(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode('.emoji-mart,.emoji-mart *{box-sizing:border-box;line-height:1.15}.emoji-mart{font-family:-apple-system,BlinkMacSystemFont,Helvetica Neue,sans-serif;font-size:16px;display:inline-block;color:#222427;border:1px solid #d9d9d9;border-radius:5px;background:#fff}.emoji-mart .emoji-mart-emoji{padding:6px}.emoji-mart-bar{border:0 solid #d9d9d9}.emoji-mart-bar:first-child{border-bottom-width:1px;border-top-left-radius:5px;border-top-right-radius:5px}.emoji-mart-bar:last-child{border-top-width:1px;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.emoji-mart-anchors{display:flex;flex-direction:row;justify-content:space-between;padding:0 6px;line-height:0}.emoji-mart-anchor{position:relative;display:block;flex:1 1 auto;color:#858585;text-align:center;padding:12px 4px;overflow:hidden;transition:color .1s ease-out;margin:0;box-shadow:none;background:none;border:none}.emoji-mart-anchor:focus{outline:0}.emoji-mart-anchor:hover,.emoji-mart-anchor:focus,.emoji-mart-anchor-selected{color:#464646}.emoji-mart-anchor-selected .emoji-mart-anchor-bar{bottom:0}.emoji-mart-anchor-bar{position:absolute;bottom:-3px;left:0;width:100%;height:3px;background-color:#464646}.emoji-mart-anchors i{display:inline-block;width:100%;max-width:22px}.emoji-mart-anchors svg,.emoji-mart-anchors img{fill:currentColor;height:18px;width:18px}.emoji-mart-scroll{overflow-y:scroll;overflow-x:hidden;height:270px;padding:0 6px 6px;will-change:transform}.emoji-mart-search{margin-top:6px;padding:0 6px;position:relative}.emoji-mart-search input{font-size:16px;display:block;width:100%;padding:5px 25px 6px 10px;border-radius:5px;border:1px solid #d9d9d9;outline:0}.emoji-mart-search input,.emoji-mart-search input::-webkit-search-decoration,.emoji-mart-search input::-webkit-search-cancel-button,.emoji-mart-search input::-webkit-search-results-button,.emoji-mart-search input::-webkit-search-results-decoration{-webkit-appearance:none}.emoji-mart-search-icon{position:absolute;top:7px;right:11px;z-index:2;padding:2px 5px 1px;border:none;background:none}.emoji-mart-category .emoji-mart-emoji span{z-index:1;position:relative;text-align:center;cursor:default}.emoji-mart-category .emoji-mart-emoji:hover:before{z-index:0;content:"";position:absolute;top:0;left:0;width:100%;height:100%;background-color:#f4f4f4;border-radius:100%}.emoji-mart-category-label{z-index:2;position:relative;position:-webkit-sticky;position:sticky;top:0}.emoji-mart-category-label span{display:block;width:100%;font-weight:500;padding:5px 6px;background-color:#fff;background-color:#fffffff2}.emoji-mart-category-list{margin:0;padding:0}.emoji-mart-category-list li{list-style:none;margin:0;padding:0;display:inline-block}.emoji-mart-emoji{position:relative;display:inline-block;font-size:0;margin:0;padding:0;border:none;background:none;box-shadow:none}.emoji-mart-emoji-native{font-family:"Segoe UI Emoji",Segoe UI Symbol,Segoe UI,"Apple Color Emoji",Twemoji Mozilla,"Noto Color Emoji","Android Emoji"}.emoji-mart-no-results{font-size:14px;text-align:center;padding-top:70px;color:#858585}.emoji-mart-no-results-img{display:block;margin-left:auto;margin-right:auto;width:50%}.emoji-mart-no-results .emoji-mart-category-label{display:none}.emoji-mart-no-results .emoji-mart-no-results-label{margin-top:.2em}.emoji-mart-no-results .emoji-mart-emoji:hover:before{content:none}.emoji-mart-preview{position:relative;height:70px}.emoji-mart-preview-emoji,.emoji-mart-preview-data,.emoji-mart-preview-skins{position:absolute;top:50%;transform:translateY(-50%)}.emoji-mart-preview-emoji{left:12px}.emoji-mart-preview-data{left:68px;right:12px;word-break:break-all}.emoji-mart-preview-skins{right:30px;text-align:right}.emoji-mart-preview-skins.custom{right:10px;text-align:right}.emoji-mart-preview-name{font-size:14px}.emoji-mart-preview-shortname{font-size:12px;color:#888}.emoji-mart-preview-shortname+.emoji-mart-preview-shortname,.emoji-mart-preview-shortname+.emoji-mart-preview-emoticon,.emoji-mart-preview-emoticon+.emoji-mart-preview-emoticon{margin-left:.5em}.emoji-mart-preview-emoticon{font-size:11px;color:#bbb}.emoji-mart-title span{display:inline-block;vertical-align:middle}.emoji-mart-title .emoji-mart-emoji{padding:0}.emoji-mart-title-label{color:#999a9c;font-size:26px;font-weight:300}.emoji-mart-skin-swatches{font-size:0;padding:2px 0;border:1px solid #d9d9d9;border-radius:12px;background-color:#fff}.emoji-mart-skin-swatches.custom{font-size:0;border:none;background-color:#fff}.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch{width:16px;padding:0 2px}.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after{opacity:.75}.emoji-mart-skin-swatch{display:inline-block;width:0;vertical-align:middle;transition-property:width,padding;transition-duration:.125s;transition-timing-function:ease-out}.emoji-mart-skin-swatch:nth-child(1){transition-delay:0s}.emoji-mart-skin-swatch:nth-child(2){transition-delay:.03s}.emoji-mart-skin-swatch:nth-child(3){transition-delay:.06s}.emoji-mart-skin-swatch:nth-child(4){transition-delay:.09s}.emoji-mart-skin-swatch:nth-child(5){transition-delay:.12s}.emoji-mart-skin-swatch:nth-child(6){transition-delay:.15s}.emoji-mart-skin-swatch.selected{position:relative;width:16px;padding:0 2px}.emoji-mart-skin-swatch.selected:after{content:"";position:absolute;top:50%;left:50%;width:4px;height:4px;margin:-2px 0 0 -2px;background-color:#fff;border-radius:100%;pointer-events:none;opacity:0;transition:opacity .2s ease-out}.emoji-mart-skin-swatch.custom{display:inline-block;width:0;height:38px;overflow:hidden;vertical-align:middle;transition-property:width,height;transition-duration:.125s;transition-timing-function:ease-out;cursor:default}.emoji-mart-skin-swatch.custom.selected{position:relative;width:36px;height:38px;padding:0 2px 0 0}.emoji-mart-skin-swatch.custom.selected:after{content:"";width:0;height:0}.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover{background-color:#f4f4f4;border-radius:10%}.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom{width:36px;height:38px;padding:0 2px 0 0}.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after{opacity:.75}.emoji-mart-skin-text.opened{display:inline-block;vertical-align:middle;text-align:left;color:#888;font-size:11px;padding:5px 2px;width:95px;height:40px;border-radius:10%;background-color:#fff}.emoji-mart-skin{display:inline-block;width:100%;padding-top:100%;max-width:12px;border-radius:100%}.emoji-mart-skin-tone-1{background-color:#ffc93a}.emoji-mart-skin-tone-2{background-color:#fadcbc}.emoji-mart-skin-tone-3{background-color:#e0bb95}.emoji-mart-skin-tone-4{background-color:#bf8f68}.emoji-mart-skin-tone-5{background-color:#9b643d}.emoji-mart-skin-tone-6{background-color:#594539}.emoji-mart-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.emoji-mart-dark{color:#fff;border-color:#555453;background-color:#222}.emoji-mart-dark .emoji-mart-bar{border-color:#555453}.emoji-mart-dark .emoji-mart-search input{color:#fff;border-color:#555453;background-color:#2f2f2f}.emoji-mart-dark .emoji-mart-search-icon svg{fill:#fff}.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before{background-color:#444}.emoji-mart-dark .emoji-mart-category-label span{background-color:#222;color:#fff}.emoji-mart-dark .emoji-mart-skin-swatches{border-color:#555453;background-color:#222}.emoji-mart-dark .emoji-mart-anchor:hover,.emoji-mart-dark .emoji-mart-anchor:focus,.emoji-mart-dark .emoji-mart-anchor-selected{color:#bfbfbf}')),document.head.appendChild(o)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
var __defProp = Object.defineProperty;
var __defNormalProp = (obj2, key, value) => key in obj2 ? __defProp(obj2, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj2[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
var __publicField = (obj2, key, value) => (__defNormalProp(obj2, typeof key != "symbol" ? key + "" : key, value), value);
import * as React from "react";
import React__default, { useState, useContext, useRef, useCallback, useMemo, useEffect, memo as memo$1, useLayoutEffect, Fragment as Fragment$1, forwardRef, createContext, useInsertionEffect, createElement, useId, cloneElement, Children, isValidElement, useReducer, useImperativeHandle, Component, PureComponent } from "react";
import { ArrowDownFilled, ArrowUpFilled, PlusCircleFilled, ClockFilled, CloseCircleFilled, TickCircleFilled, HangUpFilled, CallbackFilled, CallFilled, RingingOutlined, RingingFilled, PeopleFilled, KeypadFilled, VoicemailOutlined, OutboundOutlined, InboundOutlined, ChevronUpOutlined, ChevronDownOutlined, SpinnerOutlined, TickOutlined, CopyOutlined, SearchOutlined, CloseOutlined, LockedFilled, LoadingRedoUndoOutlined, CloseCircleOutlined, MenuVerticalFilled, CheckedCircleOutlined, PlayFilled, ControlStopFilled, ChevronLeftOutlined, ExternalOutlined, HistoryOutlined, MinusOutlined, QuestionFilled, InformationOutlined, UserOutlined, VirtualAgentFilled } from "@aircall/icons";
import { Flex, Typography, getSpace as getSpace$1, IconButton, Button as Button$1, Spacer, ThemeProvider, Icon, Select as Select$1, OrderDirection, defaultTheme, Avatar as Avatar$1, AvatarImg, AvatarText, Box, Tooltip as Tooltip$1, ModalDialog, ModalBody, Banner, BannerIcon, BannerHeading, ModalFooter, FlagIcon, ComboBoxItem, MenuItemPrefix, MenuItemLabel, MenuItemSuffix, MenuItemDescription, Skeleton, getColor as getColor$2, useComboBox, ComboBoxTrigger, ComboBoxContent, ComboBoxMenu, ComboBox, TextInput, usePopoverPlacement, DatePicker, useDropdownContext, Dropdown, Grid, toasts, Divider, getRadii, noop as noop$6, Form as Form$1, FormItem, ActionMenu, List as List$1, ListView, ListItem as ListItem$1, Popover, Menu, MenuItem, useAudio, PlayButton, MotionBox as MotionBox$2, AudioCurrentTime, AudioDuration, AudioBar, AudioManager, Audio, PasswordInput, Link as Link$2, isScrollAtBottom, isScrollAtTop, Pagination, useTheme, Table, useColor, ModalHeader, ModalTitle, Tag, TagLabel, TagDeleteIcon, TabContainer, TabContent, TabMenu, TabMenuItem, TabItem, RadioGroup, Radio, RadioLabel, RadioDescription, useSelect, DropdownButton } from "@aircall/tractor-v2";
import styled$1, { createGlobalStyle as createGlobalStyle$1, css as css$1 } from "styled-components";
import { matchPath, UNSAFE_NavigationContext, useLocation, useNavigate, Outlet, useSearchParams, Link as Link$1 } from "react-router-dom";
import { useControllableState } from "@aircall/hooks";
import { Form, useField, useForm, Field, version as version$2 } from "react-final-form";
import { createPortal } from "react-dom";
import { useNavigate as useNavigate$1, useLocation as useLocation$1 } from "react-router";
import { fieldSubscriptionItems, version as version$1, ARRAY_ERROR } from "final-form";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(x3) {
  return x3 && x3.__esModule && Object.prototype.hasOwnProperty.call(x3, "default") ? x3.default : x3;
}
__name(getDefaultExportFromCjs, "getDefaultExportFromCjs");
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var f = n.default;
  if (typeof f == "function") {
    var a4 = /* @__PURE__ */ __name(function a5() {
      return this instanceof a5 ? Reflect.construct(f, arguments, this.constructor) : f.apply(this, arguments);
    }, "a");
    a4.prototype = f.prototype;
  } else
    a4 = {};
  return Object.defineProperty(a4, "__esModule", { value: !0 }), Object.keys(n).forEach(function(k3) {
    var d3 = Object.getOwnPropertyDescriptor(n, k3);
    Object.defineProperty(a4, k3, d3.get ? d3 : {
      enumerable: !0,
      get: function() {
        return n[k3];
      }
    });
  }), a4;
}
__name(getAugmentedNamespace, "getAugmentedNamespace");
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default, k3 = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m3 = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: !0, ref: !0, __self: !0, __source: !0 };
  function q2(c3, a4, g) {
    var b2, d3 = {}, e3 = null, h3 = null;
    g !== void 0 && (e3 = "" + g), a4.key !== void 0 && (e3 = "" + a4.key), a4.ref !== void 0 && (h3 = a4.ref);
    for (b2 in a4)
      m3.call(a4, b2) && !p.hasOwnProperty(b2) && (d3[b2] = a4[b2]);
    if (c3 && c3.defaultProps)
      for (b2 in a4 = c3.defaultProps, a4)
        d3[b2] === void 0 && (d3[b2] = a4[b2]);
    return { $$typeof: k3, type: c3, key: e3, ref: h3, props: d3, _owner: n.current };
  }
  return __name(q2, "q"), reactJsxRuntime_production_min.Fragment = l, reactJsxRuntime_production_min.jsx = q2, reactJsxRuntime_production_min.jsxs = q2, reactJsxRuntime_production_min;
}
__name(requireReactJsxRuntime_production_min, "requireReactJsxRuntime_production_min");
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var React2 = React__default, REACT_ELEMENT_TYPE = Symbol.for("react.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      if (maybeIterable === null || typeof maybeIterable != "object")
        return null;
      var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
      return typeof maybeIterator == "function" ? maybeIterator : null;
    }
    __name(getIteratorFn, "getIteratorFn");
    var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format2) {
      {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)
          args[_key2 - 1] = arguments[_key2];
        printWarning("error", format2, args);
      }
    }
    __name(error, "error");
    function printWarning(level, format2, args) {
      {
        var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame, stack = ReactDebugCurrentFrame2.getStackAddendum();
        stack !== "" && (format2 += "%s", args = args.concat([stack]));
        var argsWithFormat = args.map(function(item) {
          return String(item);
        });
        argsWithFormat.unshift("Warning: " + format2), Function.prototype.apply.call(console[level], console, argsWithFormat);
      }
    }
    __name(printWarning, "printWarning");
    var enableScopeAPI = !1, enableCacheElement = !1, enableTransitionTracing = !1, enableLegacyHidden = !1, enableDebugTracing = !1, REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
      return !!(typeof type == "string" || typeof type == "function" || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing || typeof type == "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0));
    }
    __name(isValidElementType, "isValidElementType");
    function getWrappedName(outerType, innerType, wrapperName) {
      var displayName = outerType.displayName;
      if (displayName)
        return displayName;
      var functionName = innerType.displayName || innerType.name || "";
      return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    }
    __name(getWrappedName, "getWrappedName");
    function getContextName(type) {
      return type.displayName || "Context";
    }
    __name(getContextName, "getContextName");
    function getComponentNameFromType(type) {
      if (type == null)
        return null;
      if (typeof type.tag == "number" && error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof type == "function")
        return type.displayName || type.name || null;
      if (typeof type == "string")
        return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PORTAL_TYPE:
          return "Portal";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
      }
      if (typeof type == "object")
        switch (type.$$typeof) {
          case REACT_CONTEXT_TYPE:
            var context = type;
            return getContextName(context) + ".Consumer";
          case REACT_PROVIDER_TYPE:
            var provider = type;
            return getContextName(provider._context) + ".Provider";
          case REACT_FORWARD_REF_TYPE:
            return getWrappedName(type, type.render, "ForwardRef");
          case REACT_MEMO_TYPE:
            var outerName = type.displayName || null;
            return outerName !== null ? outerName : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE: {
            var lazyComponent = type, payload = lazyComponent._payload, init2 = lazyComponent._init;
            try {
              return getComponentNameFromType(init2(payload));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    __name(getComponentNameFromType, "getComponentNameFromType");
    var assign2 = Object.assign, disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    function disabledLog() {
    }
    __name(disabledLog, "disabledLog"), disabledLog.__reactDisabledLog = !0;
    function disableLogs() {
      {
        if (disabledDepth === 0) {
          prevLog = console.log, prevInfo = console.info, prevWarn = console.warn, prevError = console.error, prevGroup = console.group, prevGroupCollapsed = console.groupCollapsed, prevGroupEnd = console.groupEnd;
          var props = {
            configurable: !0,
            enumerable: !0,
            value: disabledLog,
            writable: !0
          };
          Object.defineProperties(console, {
            info: props,
            log: props,
            warn: props,
            error: props,
            group: props,
            groupCollapsed: props,
            groupEnd: props
          });
        }
        disabledDepth++;
      }
    }
    __name(disableLogs, "disableLogs");
    function reenableLogs() {
      {
        if (disabledDepth--, disabledDepth === 0) {
          var props = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: assign2({}, props, {
              value: prevLog
            }),
            info: assign2({}, props, {
              value: prevInfo
            }),
            warn: assign2({}, props, {
              value: prevWarn
            }),
            error: assign2({}, props, {
              value: prevError
            }),
            group: assign2({}, props, {
              value: prevGroup
            }),
            groupCollapsed: assign2({}, props, {
              value: prevGroupCollapsed
            }),
            groupEnd: assign2({}, props, {
              value: prevGroupEnd
            })
          });
        }
        disabledDepth < 0 && error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    __name(reenableLogs, "reenableLogs");
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher, prefix2;
    function describeBuiltInComponentFrame(name2, source, ownerFn) {
      {
        if (prefix2 === void 0)
          try {
            throw Error();
          } catch (x3) {
            var match2 = x3.stack.trim().match(/\n( *(at )?)/);
            prefix2 = match2 && match2[1] || "";
          }
        return `
` + prefix2 + name2;
      }
    }
    __name(describeBuiltInComponentFrame, "describeBuiltInComponentFrame");
    var reentry = !1, componentFrameCache;
    {
      var PossiblyWeakMap = typeof WeakMap == "function" ? WeakMap : Map;
      componentFrameCache = new PossiblyWeakMap();
    }
    function describeNativeComponentFrame(fn, construct) {
      if (!fn || reentry)
        return "";
      {
        var frame2 = componentFrameCache.get(fn);
        if (frame2 !== void 0)
          return frame2;
      }
      var control;
      reentry = !0;
      var previousPrepareStackTrace = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var previousDispatcher;
      previousDispatcher = ReactCurrentDispatcher.current, ReactCurrentDispatcher.current = null, disableLogs();
      try {
        if (construct) {
          var Fake = /* @__PURE__ */ __name(function() {
            throw Error();
          }, "Fake");
          if (Object.defineProperty(Fake.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Fake, []);
            } catch (x3) {
              control = x3;
            }
            Reflect.construct(fn, [], Fake);
          } else {
            try {
              Fake.call();
            } catch (x3) {
              control = x3;
            }
            fn.call(Fake.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (x3) {
            control = x3;
          }
          fn();
        }
      } catch (sample) {
        if (sample && control && typeof sample.stack == "string") {
          for (var sampleLines = sample.stack.split(`
`), controlLines = control.stack.split(`
`), s4 = sampleLines.length - 1, c3 = controlLines.length - 1; s4 >= 1 && c3 >= 0 && sampleLines[s4] !== controlLines[c3]; )
            c3--;
          for (; s4 >= 1 && c3 >= 0; s4--, c3--)
            if (sampleLines[s4] !== controlLines[c3]) {
              if (s4 !== 1 || c3 !== 1)
                do
                  if (s4--, c3--, c3 < 0 || sampleLines[s4] !== controlLines[c3]) {
                    var _frame = `
` + sampleLines[s4].replace(" at new ", " at ");
                    return fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName)), typeof fn == "function" && componentFrameCache.set(fn, _frame), _frame;
                  }
                while (s4 >= 1 && c3 >= 0);
              break;
            }
        }
      } finally {
        reentry = !1, ReactCurrentDispatcher.current = previousDispatcher, reenableLogs(), Error.prepareStackTrace = previousPrepareStackTrace;
      }
      var name2 = fn ? fn.displayName || fn.name : "", syntheticFrame = name2 ? describeBuiltInComponentFrame(name2) : "";
      return typeof fn == "function" && componentFrameCache.set(fn, syntheticFrame), syntheticFrame;
    }
    __name(describeNativeComponentFrame, "describeNativeComponentFrame");
    function describeFunctionComponentFrame(fn, source, ownerFn) {
      return describeNativeComponentFrame(fn, !1);
    }
    __name(describeFunctionComponentFrame, "describeFunctionComponentFrame");
    function shouldConstruct(Component2) {
      var prototype2 = Component2.prototype;
      return !!(prototype2 && prototype2.isReactComponent);
    }
    __name(shouldConstruct, "shouldConstruct");
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
      if (type == null)
        return "";
      if (typeof type == "function")
        return describeNativeComponentFrame(type, shouldConstruct(type));
      if (typeof type == "string")
        return describeBuiltInComponentFrame(type);
      switch (type) {
        case REACT_SUSPENSE_TYPE:
          return describeBuiltInComponentFrame("Suspense");
        case REACT_SUSPENSE_LIST_TYPE:
          return describeBuiltInComponentFrame("SuspenseList");
      }
      if (typeof type == "object")
        switch (type.$$typeof) {
          case REACT_FORWARD_REF_TYPE:
            return describeFunctionComponentFrame(type.render);
          case REACT_MEMO_TYPE:
            return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
          case REACT_LAZY_TYPE: {
            var lazyComponent = type, payload = lazyComponent._payload, init2 = lazyComponent._init;
            try {
              return describeUnknownElementTypeFrameInDEV(init2(payload), source, ownerFn);
            } catch {
            }
          }
        }
      return "";
    }
    __name(describeUnknownElementTypeFrameInDEV, "describeUnknownElementTypeFrameInDEV");
    var hasOwnProperty2 = Object.prototype.hasOwnProperty, loggedTypeFailures = {}, ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element2) {
      if (element2) {
        var owner = element2._owner, stack = describeUnknownElementTypeFrameInDEV(element2.type, element2._source, owner ? owner.type : null);
        ReactDebugCurrentFrame.setExtraStackFrame(stack);
      } else
        ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    __name(setCurrentlyValidatingElement, "setCurrentlyValidatingElement");
    function checkPropTypes(typeSpecs, values, location, componentName, element2) {
      {
        var has2 = Function.call.bind(hasOwnProperty2);
        for (var typeSpecName in typeSpecs)
          if (has2(typeSpecs, typeSpecName)) {
            var error$1 = void 0;
            try {
              if (typeof typeSpecs[typeSpecName] != "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw err.name = "Invariant Violation", err;
              }
              error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
              error$1 = ex;
            }
            error$1 && !(error$1 instanceof Error) && (setCurrentlyValidatingElement(element2), error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1), setCurrentlyValidatingElement(null)), error$1 instanceof Error && !(error$1.message in loggedTypeFailures) && (loggedTypeFailures[error$1.message] = !0, setCurrentlyValidatingElement(element2), error("Failed %s type: %s", location, error$1.message), setCurrentlyValidatingElement(null));
          }
      }
    }
    __name(checkPropTypes, "checkPropTypes");
    var isArrayImpl = Array.isArray;
    function isArray3(a4) {
      return isArrayImpl(a4);
    }
    __name(isArray3, "isArray");
    function typeName(value) {
      {
        var hasToStringTag = typeof Symbol == "function" && Symbol.toStringTag, type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
      }
    }
    __name(typeName, "typeName");
    function willCoercionThrow(value) {
      try {
        return testStringCoercion(value), !1;
      } catch {
        return !0;
      }
    }
    __name(willCoercionThrow, "willCoercionThrow");
    function testStringCoercion(value) {
      return "" + value;
    }
    __name(testStringCoercion, "testStringCoercion");
    function checkKeyStringCoercion(value) {
      if (willCoercionThrow(value))
        return error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value)), testStringCoercion(value);
    }
    __name(checkKeyStringCoercion, "checkKeyStringCoercion");
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner, RESERVED_PROPS = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config2) {
      if (hasOwnProperty2.call(config2, "ref")) {
        var getter2 = Object.getOwnPropertyDescriptor(config2, "ref").get;
        if (getter2 && getter2.isReactWarning)
          return !1;
      }
      return config2.ref !== void 0;
    }
    __name(hasValidRef, "hasValidRef");
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter2 = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter2 && getter2.isReactWarning)
          return !1;
      }
      return config2.key !== void 0;
    }
    __name(hasValidKey, "hasValidKey");
    function warnIfStringRefCannotBeAutoConverted(config2, self2) {
      if (typeof config2.ref == "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
        var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
        didWarnAboutStringRefs[componentName] || (error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config2.ref), didWarnAboutStringRefs[componentName] = !0);
      }
    }
    __name(warnIfStringRefCannotBeAutoConverted, "warnIfStringRefCannotBeAutoConverted");
    function defineKeyPropWarningGetter(props, displayName) {
      {
        var warnAboutAccessingKey = /* @__PURE__ */ __name(function() {
          specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName));
        }, "warnAboutAccessingKey");
        warnAboutAccessingKey.isReactWarning = !0, Object.defineProperty(props, "key", {
          get: warnAboutAccessingKey,
          configurable: !0
        });
      }
    }
    __name(defineKeyPropWarningGetter, "defineKeyPropWarningGetter");
    function defineRefPropWarningGetter(props, displayName) {
      {
        var warnAboutAccessingRef = /* @__PURE__ */ __name(function() {
          specialPropRefWarningShown || (specialPropRefWarningShown = !0, error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName));
        }, "warnAboutAccessingRef");
        warnAboutAccessingRef.isReactWarning = !0, Object.defineProperty(props, "ref", {
          get: warnAboutAccessingRef,
          configurable: !0
        });
      }
    }
    __name(defineRefPropWarningGetter, "defineRefPropWarningGetter");
    var ReactElement = /* @__PURE__ */ __name(function(type, key, ref, self2, source, owner, props) {
      var element2 = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: REACT_ELEMENT_TYPE,
        // Built-in properties that belong on the element
        type,
        key,
        ref,
        props,
        // Record the component responsible for creating this element.
        _owner: owner
      };
      return element2._store = {}, Object.defineProperty(element2._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(element2, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: self2
      }), Object.defineProperty(element2, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: source
      }), Object.freeze && (Object.freeze(element2.props), Object.freeze(element2)), element2;
    }, "ReactElement");
    function jsxDEV(type, config2, maybeKey, source, self2) {
      {
        var propName, props = {}, key = null, ref = null;
        maybeKey !== void 0 && (checkKeyStringCoercion(maybeKey), key = "" + maybeKey), hasValidKey(config2) && (checkKeyStringCoercion(config2.key), key = "" + config2.key), hasValidRef(config2) && (ref = config2.ref, warnIfStringRefCannotBeAutoConverted(config2, self2));
        for (propName in config2)
          hasOwnProperty2.call(config2, propName) && !RESERVED_PROPS.hasOwnProperty(propName) && (props[propName] = config2[propName]);
        if (type && type.defaultProps) {
          var defaultProps2 = type.defaultProps;
          for (propName in defaultProps2)
            props[propName] === void 0 && (props[propName] = defaultProps2[propName]);
        }
        if (key || ref) {
          var displayName = typeof type == "function" ? type.displayName || type.name || "Unknown" : type;
          key && defineKeyPropWarningGetter(props, displayName), ref && defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
      }
    }
    __name(jsxDEV, "jsxDEV");
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner, ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element2) {
      if (element2) {
        var owner = element2._owner, stack = describeUnknownElementTypeFrameInDEV(element2.type, element2._source, owner ? owner.type : null);
        ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
      } else
        ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    __name(setCurrentlyValidatingElement$1, "setCurrentlyValidatingElement$1");
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = !1;
    function isValidElement2(object2) {
      return typeof object2 == "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    __name(isValidElement2, "isValidElement");
    function getDeclarationErrorAddendum() {
      {
        if (ReactCurrentOwner$1.current) {
          var name2 = getComponentNameFromType(ReactCurrentOwner$1.current.type);
          if (name2)
            return `

Check the render method of \`` + name2 + "`.";
        }
        return "";
      }
    }
    __name(getDeclarationErrorAddendum, "getDeclarationErrorAddendum");
    function getSourceInfoErrorAddendum(source) {
      {
        if (source !== void 0) {
          var fileName = source.fileName.replace(/^.*[\\\/]/, ""), lineNumber = source.lineNumber;
          return `

Check your code at ` + fileName + ":" + lineNumber + ".";
        }
        return "";
      }
    }
    __name(getSourceInfoErrorAddendum, "getSourceInfoErrorAddendum");
    var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
      {
        var info = getDeclarationErrorAddendum();
        if (!info) {
          var parentName = typeof parentType == "string" ? parentType : parentType.displayName || parentType.name;
          parentName && (info = `

Check the top-level render call using <` + parentName + ">.");
        }
        return info;
      }
    }
    __name(getCurrentComponentErrorInfo, "getCurrentComponentErrorInfo");
    function validateExplicitKey(element2, parentType) {
      {
        if (!element2._store || element2._store.validated || element2.key != null)
          return;
        element2._store.validated = !0;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo])
          return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = !0;
        var childOwner = "";
        element2 && element2._owner && element2._owner !== ReactCurrentOwner$1.current && (childOwner = " It was passed a child from " + getComponentNameFromType(element2._owner.type) + "."), setCurrentlyValidatingElement$1(element2), error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner), setCurrentlyValidatingElement$1(null);
      }
    }
    __name(validateExplicitKey, "validateExplicitKey");
    function validateChildKeys(node2, parentType) {
      {
        if (typeof node2 != "object")
          return;
        if (isArray3(node2))
          for (var i2 = 0; i2 < node2.length; i2++) {
            var child = node2[i2];
            isValidElement2(child) && validateExplicitKey(child, parentType);
          }
        else if (isValidElement2(node2))
          node2._store && (node2._store.validated = !0);
        else if (node2) {
          var iteratorFn = getIteratorFn(node2);
          if (typeof iteratorFn == "function" && iteratorFn !== node2.entries)
            for (var iterator = iteratorFn.call(node2), step; !(step = iterator.next()).done; )
              isValidElement2(step.value) && validateExplicitKey(step.value, parentType);
        }
      }
    }
    __name(validateChildKeys, "validateChildKeys");
    function validatePropTypes(element2) {
      {
        var type = element2.type;
        if (type == null || typeof type == "string")
          return;
        var propTypes2;
        if (typeof type == "function")
          propTypes2 = type.propTypes;
        else if (typeof type == "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE))
          propTypes2 = type.propTypes;
        else
          return;
        if (propTypes2) {
          var name2 = getComponentNameFromType(type);
          checkPropTypes(propTypes2, element2.props, "prop", name2, element2);
        } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
          propTypesMisspellWarningShown = !0;
          var _name = getComponentNameFromType(type);
          error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        typeof type.getDefaultProps == "function" && !type.getDefaultProps.isReactClassApproved && error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    __name(validatePropTypes, "validatePropTypes");
    function validateFragmentProps(fragment) {
      {
        for (var keys2 = Object.keys(fragment.props), i2 = 0; i2 < keys2.length; i2++) {
          var key = keys2[i2];
          if (key !== "children" && key !== "key") {
            setCurrentlyValidatingElement$1(fragment), error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key), setCurrentlyValidatingElement$1(null);
            break;
          }
        }
        fragment.ref !== null && (setCurrentlyValidatingElement$1(fragment), error("Invalid attribute `ref` supplied to `React.Fragment`."), setCurrentlyValidatingElement$1(null));
      }
    }
    __name(validateFragmentProps, "validateFragmentProps");
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
      {
        var validType = isValidElementType(type);
        if (!validType) {
          var info = "";
          (type === void 0 || typeof type == "object" && type !== null && Object.keys(type).length === 0) && (info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var sourceInfo = getSourceInfoErrorAddendum(source);
          sourceInfo ? info += sourceInfo : info += getDeclarationErrorAddendum();
          var typeString;
          type === null ? typeString = "null" : isArray3(type) ? typeString = "array" : type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE ? (typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", info = " Did you accidentally export a JSX literal instead of a component?") : typeString = typeof type, error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element2 = jsxDEV(type, props, key, source, self2);
        if (element2 == null)
          return element2;
        if (validType) {
          var children = props.children;
          if (children !== void 0)
            if (isStaticChildren)
              if (isArray3(children)) {
                for (var i2 = 0; i2 < children.length; i2++)
                  validateChildKeys(children[i2], type);
                Object.freeze && Object.freeze(children);
              } else
                error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              validateChildKeys(children, type);
        }
        if (hasOwnProperty2.call(props, "key")) {
          var componentName = getComponentNameFromType(type), keys2 = Object.keys(props).filter(function(k3) {
            return k3 !== "key";
          }), beforeExample = keys2.length > 0 ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!didWarnAboutKeySpread[componentName + beforeExample]) {
            var afterExample = keys2.length > 0 ? "{" + keys2.join(": ..., ") + ": ...}" : "{}";
            error(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, beforeExample, componentName, afterExample, componentName), didWarnAboutKeySpread[componentName + beforeExample] = !0;
          }
        }
        return type === REACT_FRAGMENT_TYPE ? validateFragmentProps(element2) : validatePropTypes(element2), element2;
      }
    }
    __name(jsxWithValidation, "jsxWithValidation");
    function jsxWithValidationStatic(type, props, key) {
      return jsxWithValidation(type, props, key, !0);
    }
    __name(jsxWithValidationStatic, "jsxWithValidationStatic");
    function jsxWithValidationDynamic(type, props, key) {
      return jsxWithValidation(type, props, key, !1);
    }
    __name(jsxWithValidationDynamic, "jsxWithValidationDynamic");
    var jsx2 = jsxWithValidationDynamic, jsxs2 = jsxWithValidationStatic;
    reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE, reactJsxRuntime_development.jsx = jsx2, reactJsxRuntime_development.jsxs = jsxs2;
  }()), reactJsxRuntime_development;
}
__name(requireReactJsxRuntime_development, "requireReactJsxRuntime_development");
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
const Fragment = jsxRuntimeExports.Fragment, jsx = jsxRuntimeExports.jsx, jsxs = jsxRuntimeExports.jsxs, boxSizes = {
  small: "16px",
  regular: "24px"
}, typographyVariants = {
  small: "supportingRegularXS",
  regular: "supportingMediumS"
};
function Count({
  "data-test": dataTest = "count",
  backgroundColor: backgroundColor2 = "graphic-inverted",
  color: color2 = "text-inverted",
  size = "regular",
  value
}) {
  return /* @__PURE__ */ jsx(
    Flex,
    {
      backgroundColor: backgroundColor2,
      borderRadius: "full",
      display: "flex",
      justifyContent: "center",
      minH: boxSizes[size],
      minWidth: boxSizes[size],
      px: "xxs",
      py: "xxxs",
      children: /* @__PURE__ */ jsx(
        Typography,
        {
          alignSelf: "center",
          color: color2,
          "data-test": dataTest,
          variant: typographyVariants[size],
          children: value
        }
      )
    }
  );
}
__name(Count, "Count");
const DEV$1 = process.env.NODE_ENV !== "production", specialProperties = ["__proto__", "constructor", "prototype"], is = /* @__PURE__ */ __name((n) => n != null, "is"), num = /* @__PURE__ */ __name((n) => typeof n == "number" && !Number.isNaN(n), "num"), string$3 = /* @__PURE__ */ __name((n) => typeof n == "string" && n !== "", "string$3"), obj = /* @__PURE__ */ __name((n) => typeof n == "object" && n !== null, "obj"), func = /* @__PURE__ */ __name((n) => typeof n == "function", "func"), negative = /* @__PURE__ */ __name((n) => num(n) && n < 0, "negative"), get$6 = /* @__PURE__ */ __name((from, path) => {
  const paths = String(path).split("."), pathsLength = paths.length;
  let result2 = from;
  for (let i2 = 0; i2 < pathsLength; i2 += 1) {
    if (!is(result2))
      return result2;
    const path2 = paths[i2];
    result2 = is(result2[path2]) ? result2[path2] : void 0;
  }
  return result2;
}, "get$6"), assign$1 = /* @__PURE__ */ __name((target, source) => {
  if (!is(source))
    return target;
  for (const key in source)
    specialProperties.indexOf(key) === -1 && (target[key] = source[key]);
  return target;
}, "assign$1"), merge$1 = /* @__PURE__ */ __name((target, source) => {
  if (!is(source))
    return target;
  for (const key in source)
    specialProperties.indexOf(key) === -1 && (obj(target[key]) ? target[key] = merge$1(assign$1({}, target[key]), source[key]) : target[key] = source[key]);
  return target;
}, "merge$1"), warn$2 = /* @__PURE__ */ __name((condition, message) => {
  DEV$1 && !condition && console.error && console.error(message);
}, "warn$2");
function cascade(value, arg) {
  return typeof value == "function" ? cascade(value(arg), arg) : value;
}
__name(cascade, "cascade");
const getThemeValue = /* @__PURE__ */ __name((props, path, initial = props.theme) => cascade(get$6(initial, path), props), "getThemeValue");
function flattenStrings(array2) {
  return array2.reduce((flattenedArray, value) => {
    const lastIndex = flattenedArray.length - 1, last2 = flattenedArray[lastIndex];
    return typeof last2 == "string" && typeof value == "string" ? flattenedArray[lastIndex] = last2 + value : flattenedArray.push(value), flattenedArray;
  }, []);
}
__name(flattenStrings, "flattenStrings");
var __pow = Math.pow;
const round$1 = /* @__PURE__ */ __name((value) => Math.round(value * __pow(10, 4)) / __pow(10, 4), "round$1"), unit$1 = /* @__PURE__ */ __name((unit2) => (value) => num(value) && value !== 0 ? `${value}${unit2}` : value, "unit$1"), ms = unit$1("ms"), px$1 = unit$1("px"), deg = unit$1("deg"), pxToRem = /* @__PURE__ */ __name((value, { rootFontSize = 16 } = {}) => round$1(value / rootFontSize), "pxToRem"), rpx = /* @__PURE__ */ __name((value, options) => {
  if (!string$3(value) || value.length < 4 || value.slice(-3) !== "rpx")
    return value;
  const n = Number(value.slice(0, value.length - 3));
  return n === 0 ? 0 : `${pxToRem(n, options)}rem`;
}, "rpx"), percent$1 = /* @__PURE__ */ __name((n) => num(n) && n !== 0 && n >= -1 && n <= 1 ? `${round$1(n * 100)}%` : n, "percent$1"), transformNegative = /* @__PURE__ */ __name((_, { rawValue, variants, props }) => {
  if (string$3(rawValue)) {
    const neg = rawValue.startsWith("-"), abs = neg ? rawValue.substr(1) : rawValue, varVal = getThemeValue(props, abs, variants), value = string$3(varVal) || num(varVal) ? varVal : abs;
    return neg ? `-${value}` : value;
  }
  if (num(rawValue)) {
    const neg = negative(rawValue), abs = Math.abs(rawValue), varVal = variants ? variants[abs] : void 0;
    if (string$3(varVal))
      return neg ? `-${varVal}` : varVal;
    const value = num(varVal) ? varVal : abs;
    return neg ? value * -1 : value;
  }
}, "transformNegative"), mediaMinWidth = /* @__PURE__ */ __name((value) => value ? `@media (min-width: ${value})` : null, "mediaMinWidth"), getBreakpointMin = /* @__PURE__ */ __name((screens, key) => {
  const value = screens[key];
  return value === 0 ? null : px$1(value);
}, "getBreakpointMin"), getBreakpointMax = /* @__PURE__ */ __name((screens, key) => {
  const value = screens[key];
  return value === 0 ? null : px$1(value - 0.02);
}, "getBreakpointMax");
var __defProp$6 = Object.defineProperty, __getOwnPropSymbols$6 = Object.getOwnPropertySymbols, __hasOwnProp$6 = Object.prototype.hasOwnProperty, __propIsEnum$6 = Object.prototype.propertyIsEnumerable, __defNormalProp$6 = /* @__PURE__ */ __name((obj2, key, value) => key in obj2 ? __defProp$6(obj2, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj2[key] = value, "__defNormalProp$6"), __spreadValues$6 = /* @__PURE__ */ __name((a4, b2) => {
  for (var prop in b2 || (b2 = {}))
    __hasOwnProp$6.call(b2, prop) && __defNormalProp$6(a4, prop, b2[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b2))
      __propIsEnum$6.call(b2, prop) && __defNormalProp$6(a4, prop, b2[prop]);
  return a4;
}, "__spreadValues$6");
const getScreens = /* @__PURE__ */ __name((props) => props.theme && props.theme.screens ? props.theme.screens : {}, "getScreens"), getStates = /* @__PURE__ */ __name((props) => props.theme && props.theme.states ? props.theme.states : {}, "getStates"), getVariants = /* @__PURE__ */ __name((props) => {
  const screens = getScreens(props), states = getStates(props), medias = {};
  for (const value in screens)
    medias[value] = mediaMinWidth(getBreakpointMin(screens, value));
  const variants = __spreadValues$6(__spreadValues$6({}, medias), states);
  for (const [value, selector] of Object.entries(variants))
    selector && selector.startsWith("@") && (delete variants[value], variants[value] = selector);
  return variants;
}, "getVariants"), getCachedVariants = /* @__PURE__ */ __name((props, cache2) => {
  if (cache2.has("_variants"))
    return cache2.get("_variants");
  const states = getVariants(props);
  return cache2.set("_variants", states), states;
}, "getCachedVariants"), cacheSupported = typeof Map < "u" && typeof WeakMap < "u", caches = cacheSupported ? /* @__PURE__ */ new WeakMap() : null, isCacheDisabled = /* @__PURE__ */ __name((theme) => {
  var _a3;
  return ((_a3 = theme == null ? void 0 : theme.xstyled) == null ? void 0 : _a3.cache) === !1;
}, "isCacheDisabled"), getThemeCache = /* @__PURE__ */ __name((theme) => {
  if (isCacheDisabled(theme) || caches === null)
    return null;
  if (caches.has(theme))
    return caches.get(theme) || null;
  const cache2 = {};
  return caches.set(theme, cache2), cache2;
}, "getThemeCache"), noopCache = {
  has: () => !1,
  set: () => {
  },
  get: () => {
  }
}, getCache = /* @__PURE__ */ __name((theme, namespace) => {
  if (!theme)
    return noopCache;
  const cache2 = getThemeCache(theme);
  return !cache2 || !theme ? noopCache : (cache2[namespace] = cache2[namespace] || /* @__PURE__ */ new Map(), cache2[namespace]);
}, "getCache");
var __defProp$5 = Object.defineProperty, __getOwnPropSymbols$5 = Object.getOwnPropertySymbols, __hasOwnProp$5 = Object.prototype.hasOwnProperty, __propIsEnum$5 = Object.prototype.propertyIsEnumerable, __defNormalProp$5 = /* @__PURE__ */ __name((obj2, key, value) => key in obj2 ? __defProp$5(obj2, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj2[key] = value, "__defNormalProp$5"), __spreadValues$5 = /* @__PURE__ */ __name((a4, b2) => {
  for (var prop in b2 || (b2 = {}))
    __hasOwnProp$5.call(b2, prop) && __defNormalProp$5(a4, prop, b2[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b2))
      __propIsEnum$5.call(b2, prop) && __defNormalProp$5(a4, prop, b2[prop]);
  return a4;
}, "__spreadValues$5");
let themeGetterId = 0;
const SPLITTERS = {
  shorthand: [/\s+/, " "],
  multiple: [/\s*,\s*/, ","]
}, splitValue = /* @__PURE__ */ __name((splitter, transform2) => (value) => value.split(splitter[0]).map(transform2).join(splitter[1]), "splitValue"), themeGetter = /* @__PURE__ */ __name(({
  name: name2,
  transform: defaultTransform,
  key,
  compose: compose22,
  shorthand,
  multiple
}) => {
  const id2 = themeGetterId++, getter2 = /* @__PURE__ */ __name((value, defaultValue) => (props) => {
    let res = value;
    if (!string$3(value) && !num(value) && value !== !0)
      return res;
    const cacheKey = `${typeof value}-${value}-${defaultValue}`, cache2 = getCache(props.theme, `__themeGetter${id2}`);
    if (cache2.has(cacheKey))
      return cache2.get(cacheKey);
    const getValue2 = /* @__PURE__ */ __name((value2) => {
      const localDefaultValue = is(defaultValue) ? defaultValue : value2;
      let res2 = value2;
      const variants = is(key) ? getThemeValue(props, key) : null;
      if (is(variants)) {
        const path = value2 === !0 ? "default" : string$3(value2) || num(value2) ? value2 : null;
        if (is(path)) {
          const fromTheme = getThemeValue(props, path, variants);
          res2 = Array.isArray(fromTheme) ? fromTheme.join(",") : fromTheme;
        }
      }
      let rawValue = value2;
      is(res2) || (rawValue = localDefaultValue, res2 = localDefaultValue);
      const transform2 = (name2 && props.theme && props.theme.transformers ? props.theme.transformers[name2] : null) || defaultTransform;
      return transform2 && (res2 = transform2(res2, {
        rawValue,
        variants,
        props
      })), compose22 ? compose22(res2)(props) : res2;
    }, "getValue");
    if ((shorthand || multiple) && string$3(value)) {
      let transform2 = getValue2;
      shorthand && (transform2 = splitValue(SPLITTERS.shorthand, transform2)), multiple && (transform2 = splitValue(SPLITTERS.multiple, transform2)), res = transform2(value);
    } else
      res = getValue2(value);
    return cache2.set(cacheKey, res), res;
  }, "getter");
  return getter2.meta = { name: name2, transform: defaultTransform }, getter2;
}, "themeGetter"), createStyleGenerator = /* @__PURE__ */ __name(({
  getStyle,
  props,
  cssGetters = {},
  generators
}) => {
  const generator = getStyle;
  return generator.meta = {
    props,
    cssGetters,
    getStyle: generator,
    generators
  }, generator.apply = (values) => ({ theme }) => generator(__spreadValues$5({ theme }, values)), generator;
}, "createStyleGenerator"), reduceVariants = /* @__PURE__ */ __name((props, values, getStyle) => {
  const cache2 = getCache(props.theme, "__variants"), variants = getCachedVariants(props, cache2);
  let styles = {};
  for (const value in values) {
    const style2 = getStyle(values[value]);
    if (style2 === null)
      continue;
    const state = value in variants ? variants[value] : value;
    state !== void 0 && (state === null ? styles = merge$1(styles, style2) : styles[state] = styles[state] ? assign$1(styles[state], style2) : style2);
  }
  return styles;
}, "reduceVariants"), getStyleFactory = /* @__PURE__ */ __name((prop, mixin, themeGet) => (props) => {
  const fromValue = /* @__PURE__ */ __name((value2) => is(value2) ? obj(value2) ? reduceVariants(props, value2, fromValue) : cascade(mixin(themeGet ? themeGet(value2)(props) : value2), props) : null, "fromValue"), value = props[prop];
  if (!is(value))
    return null;
  const cache2 = getCache(props.theme, prop), key = obj(value) ? JSON.stringify(value) : value;
  if (cache2.has(key))
    return cache2.get(key);
  const style2 = fromValue(value);
  return cache2.set(key, style2), style2;
}, "getStyleFactory"), indexGeneratorsByProp = /* @__PURE__ */ __name((generators) => {
  const index2 = {};
  for (let i2 = 0; i2 < generators.length; i2++) {
    const style2 = generators[i2];
    if (style2 && style2.meta)
      for (let j = 0; j < style2.meta.props.length; j++) {
        const prop = style2.meta.props[j];
        index2[prop] = style2;
      }
  }
  return index2;
}, "indexGeneratorsByProp"), sortStyles = /* @__PURE__ */ __name((styles, variants) => {
  for (const key in variants) {
    const variant = variants[key], style2 = styles[variant];
    style2 && (delete styles[variant], styles[variant] = style2);
  }
  return styles;
}, "sortStyles");
function compose$1(...generators) {
  let flatGenerators = [];
  generators.forEach((gen) => {
    warn$2(!!gen, 'Undefined generator in "compose" method'), gen && (gen.meta.generators ? flatGenerators = [...flatGenerators, ...gen.meta.generators] : flatGenerators.push(gen));
  });
  const generatorsByProp = indexGeneratorsByProp(flatGenerators), getStyle = /* @__PURE__ */ __name((props2, sort = !0) => {
    const styles = {};
    let merged;
    for (const key in props2) {
      const generator = generatorsByProp[key];
      if (generator) {
        const style2 = generator.meta.getStyle(props2, !1);
        merge$1(styles, style2), merged = !0;
      }
    }
    if (!merged || !sort)
      return styles;
    const medias = getCachedVariants(props2, getCache(props2.theme, "__states"));
    return sortStyles(styles, medias);
  }, "getStyle"), props = [], cssGetters = {};
  for (let i2 = 0; i2 < flatGenerators.length; i2++) {
    const generator = flatGenerators[i2];
    props.push(...generator.meta.props), Object.assign(cssGetters, generator.meta.cssGetters);
  }
  return createStyleGenerator({ getStyle, props, cssGetters, generators });
}
__name(compose$1, "compose$1");
const getMixinFromCSSProperties = /* @__PURE__ */ __name((properties) => (value) => {
  if (string$3(properties))
    return { [properties]: value };
  const style2 = {};
  for (const key in properties)
    style2[properties[key]] = value;
  return style2;
}, "getMixinFromCSSProperties"), getMixinFromCSSOption = /* @__PURE__ */ __name((css2) => func(css2) ? css2 : getMixinFromCSSProperties(css2), "getMixinFromCSSOption"), dasherize = /* @__PURE__ */ __name((key) => key.replace(/[A-Z]/g, "-$&").toLowerCase(), "dasherize"), style = /* @__PURE__ */ __name(({
  prop,
  css: css2,
  themeGet,
  key,
  transform: transform2,
  cssProps: cssPropsOption
}) => {
  const getter2 = themeGet || (key || transform2 ? themeGetter({ key, transform: transform2 }) : void 0), cssProps = cssPropsOption || (string$3(css2) ? [css2] : Array.isArray(css2) ? css2 : string$3(prop) ? [prop] : Array.isArray(prop) ? prop : []);
  if (Array.isArray(prop)) {
    const mixin2 = css2 && getMixinFromCSSOption(css2), generators2 = prop.map(
      (prop2) => style({ prop: prop2, css: mixin2, cssProps, themeGet: getter2 })
    );
    return compose$1(...generators2);
  }
  const props = [prop], mixin = getMixinFromCSSOption(css2 || props), generators = [], getStyle = getStyleFactory(prop, mixin, getter2), cssGetters = getter2 ? cssProps.reduce((getters, cssProp) => (getters[dasherize(cssProp)] = getter2, getters), {}) : {}, generator = createStyleGenerator({ getStyle, props, cssGetters });
  return generators.push(generator), compose$1(...generators);
}, "style"), getPx = themeGetter({
  name: "px",
  transform: (value, { props }) => {
    var _a3, _b, _c;
    const rootFontSize = (_c = (_b = (_a3 = props == null ? void 0 : props.theme) == null ? void 0 : _a3.settings) == null ? void 0 : _b.rootFontSize) != null ? _c : void 0, num2 = Number(value);
    return px$1(rpx(Number.isNaN(num2) ? value : num2, { rootFontSize }));
  }
}), getDuration = themeGetter({
  name: "duration",
  key: "durations",
  transform: (value) => {
    const num2 = Number(value);
    return ms(Number.isNaN(num2) ? value : num2);
  }
}), getAngle = themeGetter({
  name: "angle",
  transform: (value) => {
    const num2 = Number(value);
    return deg(Number.isNaN(num2) ? value : num2);
  }
}), getPercent = themeGetter({
  name: "percent",
  compose: getPx,
  transform: percent$1
}), getTransition = themeGetter({
  name: "transition",
  key: "transitions"
}), getTransitionProperty = themeGetter({
  name: "transitionProperty",
  key: "transitionProperties"
}), getTimingFunction = themeGetter({
  name: "timingFunction",
  key: "timingFunctions"
}), transition = style({
  prop: "transition",
  themeGet: getTransition
}), transitionProperty = style({
  prop: "transitionProperty",
  themeGet: getTransitionProperty
}), transitionDuration = style({
  prop: "transitionDuration",
  themeGet: getDuration
}), transitionTimingFunction = style({
  prop: "transitionTimingFunction",
  themeGet: getTimingFunction
}), transitionDelay = style({
  prop: "transitionDelay",
  themeGet: getDuration
}), transitions$1 = compose$1(
  transition,
  transitionProperty,
  transitionDuration,
  transitionTimingFunction,
  transitionDelay
), getAnimation = themeGetter({
  name: "animation",
  key: "animations"
}), animation = style({
  prop: "animation",
  themeGet: getAnimation
}), animationDuration = style({
  prop: "animationDuration",
  themeGet: getDuration
}), animationTimingFunction = style({
  prop: "animationTimingFunction",
  themeGet: getTimingFunction
}), animations$1 = compose$1(
  animation,
  animationDuration,
  animationTimingFunction
), getColor$1 = themeGetter({
  name: "color",
  key: "colors"
}), gradientBackgrounds = {
  "gradient-to-t": "linear-gradient(to top, var(--x-gradient-stops))",
  "gradient-to-tr": "linear-gradient(to top right, var(--x-gradient-stops))",
  "gradient-to-r": "linear-gradient(to right, var(--x-gradient-stops))",
  "gradient-to-br": "linear-gradient(to bottom right, var(--x-gradient-stops))",
  "gradient-to-b": "linear-gradient(to bottom, var(--x-gradient-stops))",
  "gradient-to-bl": "linear-gradient(to bottom left, var(--x-gradient-stops))",
  "gradient-to-l": "linear-gradient(to left, var(--x-gradient-stops))",
  "gradient-to-tl": "linear-gradient(to top left, var(--x-gradient-stops))"
}, background = style({
  prop: "background",
  css: (value) => ({
    background: gradientBackgrounds[value] || value
  })
}), backgroundColor = style({
  prop: ["backgroundColor", "bg"],
  css: "backgroundColor",
  themeGet: getColor$1
}), backgroundImage = style({
  prop: "backgroundImage",
  css: (value) => ({
    backgroundImage: gradientBackgrounds[value] || value
  })
}), backgroundSize = style({
  prop: "backgroundSize"
}), backgroundPosition = style({
  prop: "backgroundPosition"
}), backgroundRepeat = style({
  prop: "backgroundRepeat"
}), backgroundAttachment = style({
  prop: "backgroundAttachment"
}), backgroundClip = style({
  prop: "backgroundClip",
  css: ["backgroundClip", "-webkitBackgroundClip"]
}), gradientFrom = style({
  prop: "gradientFrom",
  themeGet: getColor$1,
  css: (value) => ({
    "--x-gradient-from": value,
    "--x-gradient-stops": "var(--x-gradient-from), var(--x-gradient-to, transparent)"
  })
}), gradientVia = style({
  prop: "gradientVia",
  themeGet: getColor$1,
  css: (value) => ({
    "--x-gradient-stops": `var(--x-gradient-from), ${value}, var(--x-gradient-to, transparent)`
  })
}), gradientTo = style({
  prop: "gradientTo",
  themeGet: getColor$1,
  css: "--x-gradient-to"
}), backgrounds = compose$1(
  background,
  backgroundColor,
  backgroundImage,
  backgroundSize,
  backgroundPosition,
  backgroundRepeat,
  backgroundAttachment,
  backgroundClip,
  gradientFrom,
  gradientVia,
  gradientTo
), getBorder = themeGetter({
  name: "border",
  key: "borders",
  transform: (value) => {
    const num2 = Number(value);
    return num2 > 0 ? `${px$1(num2)} solid` : value;
  }
}), getBorderWidth = themeGetter({
  name: "borderWidth",
  key: "borderWidths",
  compose: getPx,
  shorthand: !0
}), getBorderColor = themeGetter({
  name: "borderColor",
  compose: getColor$1,
  shorthand: !0
}), getBorderStyle = themeGetter({
  name: "borderStyle",
  key: "borderStyles"
}), border = style({
  prop: "border",
  themeGet: getBorder
}), borderTop = style({
  prop: "borderTop",
  themeGet: getBorder
}), borderRight = style({
  prop: "borderRight",
  themeGet: getBorder
}), borderBottom = style({
  prop: "borderBottom",
  themeGet: getBorder
}), borderLeft = style({
  prop: "borderLeft",
  themeGet: getBorder
}), borderColor = style({
  prop: "borderColor",
  themeGet: getBorderColor
}), borderTopColor = style({
  prop: "borderTopColor",
  themeGet: getColor$1
}), borderRightColor = style({
  prop: "borderRightColor",
  themeGet: getColor$1
}), borderBottomColor = style({
  prop: "borderBottomColor",
  themeGet: getColor$1
}), borderLeftColor = style({
  prop: "borderLeftColor",
  themeGet: getColor$1
}), borderWidth = style({
  prop: "borderWidth",
  themeGet: getBorderWidth
}), borderTopWidth = style({
  prop: "borderTopWidth",
  themeGet: getBorderWidth
}), borderRightWidth = style({
  prop: "borderRightWidth",
  themeGet: getBorderWidth
}), borderBottomWidth = style({
  prop: "borderBottomWidth",
  themeGet: getBorderWidth
}), borderLeftWidth = style({
  prop: "borderLeftWidth",
  themeGet: getBorderWidth
}), borderStyle = style({
  prop: "borderStyle",
  themeGet: getBorderStyle,
  cssProps: [
    "borderStyle",
    "borderTopStyle",
    "borderRightStyle",
    "borderBottomStyle",
    "borderLeftStyle"
  ]
}), borderTopStyle = style({
  prop: "borderTopStyle",
  themeGet: getBorderStyle
}), borderRightStyle = style({
  prop: "borderRightStyle",
  themeGet: getBorderStyle
}), borderBottomStyle = style({
  prop: "borderBottomStyle",
  themeGet: getBorderStyle
}), borderLeftStyle = style({
  prop: "borderLeftStyle",
  themeGet: getBorderStyle
}), outline = style({
  prop: "outline",
  themeGet: getBorder
}), outlineColor = style({
  prop: "outlineColor",
  themeGet: getColor$1
}), outlineWidth = style({
  prop: "outlineWidth",
  themeGet: getBorderWidth
}), outlineStyle = style({
  prop: "outlineStyle",
  themeGet: getBorderStyle
}), outlineOffset = style({
  prop: "outlineOffset",
  themeGet: getBorderWidth
}), getRadius$1 = themeGetter({
  name: "radius",
  key: "radii",
  compose: getPx,
  shorthand: !0
}), borderRadius = style({
  prop: "borderRadius",
  themeGet: getRadius$1,
  cssProps: [
    "borderRadius",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius"
  ]
}), divideSelector = "& > :not([hidden]) ~ :not([hidden])", divideY = style({
  prop: "divideY",
  themeGet: getBorderWidth,
  css: (value) => {
    const v = value === !0 ? 1 : value;
    return {
      [divideSelector]: {
        "--x-divide-y-reverse": 0,
        borderTopWidth: `calc(${v} * calc(1 - var(--x-divide-y-reverse)))`,
        borderBottomWidth: `calc(${v} * var(--x-divide-y-reverse))`
      }
    };
  }
}), divideX = style({
  prop: "divideX",
  themeGet: getBorderWidth,
  css: (value) => {
    const v = value === !0 ? 1 : value;
    return {
      [divideSelector]: {
        "--x-divide-x-reverse": 0,
        borderRightWidth: `calc(${v} * var(--x-divide-x-reverse))`,
        borderLeftWidth: `calc(${v} * calc(1 - var(--x-divide-x-reverse)))`
      }
    };
  }
}), divideXReverse = style({
  prop: "divideXReverse",
  css: () => ({
    [divideSelector]: {
      "--x-divide-x-reverse": "1"
    }
  })
}), divideYReverse = style({
  prop: "divideYReverse",
  css: () => ({
    [divideSelector]: {
      "--x-divide-y-reverse": "1"
    }
  })
}), divideColor = style({
  prop: "divideColor",
  themeGet: getColor$1,
  css: (value) => ({
    [divideSelector]: {
      borderColor: value
    }
  })
}), divideStyle = style({
  prop: "divideStyle",
  themeGet: getBorderStyle,
  css: (value) => ({
    [divideSelector]: {
      borderStyle: value
    }
  })
}), getRingWidth = themeGetter({
  name: "ringWidth",
  key: "ringWidths",
  compose: getPx
}), ring = style({
  prop: "ring",
  themeGet: getRingWidth,
  css: (value) => ({
    "--x-ring-shadow": `var(--x-ring-inset, /*!*/ /*!*/) 0 0 0 ${value} var(--x-ring-color)`,
    boxShadow: "var(--x-ring-shadow, 0 0 #0000), var(--x-shadow, 0 0 #0000)"
  })
}), ringInset = style({
  prop: "ringInset",
  css: () => ({ "--x-ring-inset": "inset" })
}), ringColor = style({
  prop: "ringColor",
  themeGet: getColor$1,
  css: (value) => ({ "--x-ring-color": value })
}), borders$1 = compose$1(
  border,
  borderTop,
  borderRight,
  borderBottom,
  borderLeft,
  borderColor,
  borderTopColor,
  borderRightColor,
  borderBottomColor,
  borderLeftColor,
  borderWidth,
  borderTopWidth,
  borderRightWidth,
  borderBottomWidth,
  borderLeftWidth,
  borderStyle,
  borderTopStyle,
  borderRightStyle,
  borderBottomStyle,
  borderLeftStyle,
  borderRadius,
  outline,
  outlineColor,
  outlineWidth,
  outlineStyle,
  outlineOffset,
  divideX,
  divideY,
  divideXReverse,
  divideYReverse,
  divideColor,
  divideStyle,
  ring,
  ringInset,
  ringColor
), getShadow = themeGetter({
  name: "shadow",
  key: "shadows",
  multiple: !0
}), opacity = style({
  prop: "opacity"
}), boxShadow = style({
  prop: "boxShadow",
  themeGet: getShadow,
  css: (value) => ({
    "--x-shadow": value,
    boxShadow: "var(--x-ring-shadow, 0 0 #0000), var(--x-shadow)"
  })
}), textShadow = style({
  prop: "textShadow",
  themeGet: getShadow
}), effects = compose$1(opacity, boxShadow, textShadow);
var __defProp$4 = Object.defineProperty, __getOwnPropSymbols$4 = Object.getOwnPropertySymbols, __hasOwnProp$4 = Object.prototype.hasOwnProperty, __propIsEnum$4 = Object.prototype.propertyIsEnumerable, __defNormalProp$4 = /* @__PURE__ */ __name((obj2, key, value) => key in obj2 ? __defProp$4(obj2, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj2[key] = value, "__defNormalProp$4"), __spreadValues$4 = /* @__PURE__ */ __name((a4, b2) => {
  for (var prop in b2 || (b2 = {}))
    __hasOwnProp$4.call(b2, prop) && __defNormalProp$4(a4, prop, b2[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b2))
      __propIsEnum$4.call(b2, prop) && __defNormalProp$4(a4, prop, b2[prop]);
  return a4;
}, "__spreadValues$4");
const row = style({
  prop: "row",
  css: () => ({
    boxSizing: "border-box",
    flexGrow: 1,
    flexWrap: "wrap",
    display: "flex"
  })
}), getColStyle = /* @__PURE__ */ __name((props, size) => {
  if (!is(size))
    return null;
  if (size === !0)
    return {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    };
  if (size === "auto")
    return {
      flex: "0 0 auto",
      maxWidth: "none",
      width: "auto"
    };
  const sizeWidth = getPercent(size)(props);
  return {
    flex: `0 0 ${sizeWidth}`,
    maxWidth: sizeWidth
  };
}, "getColStyle"), col = createStyleGenerator({
  getStyle: (props) => {
    const value = props.col, common = {
      boxSizing: "border-box",
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    };
    if (obj(value)) {
      const breakpointsStyle = reduceVariants(
        props,
        value,
        (v) => getColStyle(props, v)
      );
      return __spreadValues$4(__spreadValues$4({}, common), breakpointsStyle);
    }
    return __spreadValues$4(__spreadValues$4({}, common), getColStyle(props, value));
  },
  props: ["col"]
}), flexboxGrids = compose$1(row, col);
var __defProp$3 = Object.defineProperty, __getOwnPropSymbols$3 = Object.getOwnPropertySymbols, __hasOwnProp$3 = Object.prototype.hasOwnProperty, __propIsEnum$3 = Object.prototype.propertyIsEnumerable, __defNormalProp$3 = /* @__PURE__ */ __name((obj2, key, value) => key in obj2 ? __defProp$3(obj2, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj2[key] = value, "__defNormalProp$3"), __spreadValues$3 = /* @__PURE__ */ __name((a4, b2) => {
  for (var prop in b2 || (b2 = {}))
    __hasOwnProp$3.call(b2, prop) && __defNormalProp$3(a4, prop, b2[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b2))
      __propIsEnum$3.call(b2, prop) && __defNormalProp$3(a4, prop, b2[prop]);
  return a4;
}, "__spreadValues$3");
const display = style({
  prop: "display"
}), float = style({
  prop: "float"
}), boxSizing = style({
  prop: "boxSizing"
}), container = createStyleGenerator({
  getStyle: (props) => {
    if (!props.container)
      return null;
    const breakpoints = getScreens(props);
    let styles = reduceVariants(
      props,
      breakpoints,
      (v) => v !== 0 ? { maxWidth: v } : {}
    );
    return obj(props.container) && (styles = reduceVariants(props, props.container, () => styles)), __spreadValues$3({
      width: "100%"
    }, styles);
  },
  props: ["container"]
}), overflow = style({
  prop: "overflow"
}), overflowX = style({
  prop: "overflowX"
}), overflowY = style({
  prop: "overflowY"
}), getZIndex = themeGetter({
  name: "zIndex",
  key: "zIndices"
}), zIndex = style({
  prop: "zIndex",
  themeGet: getZIndex
}), position$2 = style({
  prop: "position"
}), getInset = themeGetter({
  name: "inset",
  key: "inset",
  compose: getPx,
  transform: transformNegative
}), top = style({
  prop: "top",
  themeGet: getInset
}), right = style({
  prop: "right",
  themeGet: getInset
}), bottom = style({
  prop: "bottom",
  themeGet: getInset
}), left = style({
  prop: "left",
  themeGet: getInset
}), visibility = style({
  prop: "visibility"
}), overscrollBehavior = style({
  prop: "overscrollBehavior"
}), objectFit = style({
  prop: "objectFit"
}), layout$1 = compose$1(
  boxSizing,
  display,
  float,
  container,
  overflow,
  overflowX,
  overflowY,
  position$2,
  zIndex,
  top,
  right,
  bottom,
  left,
  visibility,
  overscrollBehavior,
  objectFit
), alignItems = style({
  prop: "alignItems"
}), alignContent = style({
  prop: "alignContent"
}), justifyContent = style({
  prop: "justifyContent"
}), justifyItems = style({
  prop: "justifyItems"
}), flexWrap = style({
  prop: "flexWrap"
}), flexGrow = style({
  prop: "flexGrow"
}), flexShrink = style({
  prop: "flexShrink"
}), flexBasis = style({
  prop: "flexBasis",
  themeGet: getPercent
}), flexDirection = style({
  prop: "flexDirection"
}), flex = style({
  prop: "flex"
}), justifySelf = style({
  prop: "justifySelf"
}), alignSelf = style({
  prop: "alignSelf"
}), order$1 = style({
  prop: "order"
}), flexboxes = compose$1(
  display,
  alignItems,
  alignContent,
  justifyContent,
  justifyItems,
  flexWrap,
  flexBasis,
  flexShrink,
  flexGrow,
  flexDirection,
  flex,
  justifySelf,
  alignSelf,
  order$1
), getSpace = themeGetter({
  name: "space",
  key: "space",
  compose: getPx,
  shorthand: !0,
  transform: transformNegative
}), margin = style({
  prop: ["margin", "m"],
  themeGet: getSpace,
  css: "margin"
}), marginTop = style({
  prop: ["marginTop", "mt"],
  themeGet: getSpace,
  css: "marginTop"
}), marginRight = style({
  prop: ["marginRight", "mr"],
  themeGet: getSpace,
  css: "marginRight"
}), marginBottom = style({
  prop: ["marginBottom", "mb"],
  themeGet: getSpace,
  css: "marginBottom"
}), marginLeft = style({
  prop: ["marginLeft", "ml"],
  themeGet: getSpace,
  css: "marginLeft"
}), mx = style({
  prop: "mx",
  themeGet: getSpace,
  css: ["marginRight", "marginLeft"]
}), my = style({
  prop: "my",
  themeGet: getSpace,
  css: ["marginTop", "marginBottom"]
}), padding = style({
  prop: ["padding", "p"],
  themeGet: getSpace,
  css: "padding"
}), paddingTop = style({
  prop: ["paddingTop", "pt"],
  themeGet: getSpace,
  css: "paddingTop"
}), paddingRight = style({
  prop: ["paddingRight", "pr"],
  themeGet: getSpace,
  css: "paddingRight"
}), paddingBottom = style({
  prop: ["paddingBottom", "pb"],
  themeGet: getSpace,
  css: "paddingBottom"
}), paddingLeft = style({
  prop: ["paddingLeft", "pl"],
  themeGet: getSpace,
  css: "paddingLeft"
}), px$2 = style({
  prop: "px",
  themeGet: getSpace,
  css: ["paddingRight", "paddingLeft"]
}), py = style({
  prop: "py",
  themeGet: getSpace,
  css: ["paddingTop", "paddingBottom"]
}), spaceY = style({
  prop: "spaceY",
  themeGet: getSpace,
  css: (value) => ({
    "& > :not([hidden]) ~ :not([hidden])": {
      "--x-space-y-reverse": 0,
      marginTop: `calc(${value} * calc(1 - var(--x-space-y-reverse)))`,
      marginBottom: `calc(${value} * var(--x-space-y-reverse))`
    }
  })
}), spaceX = style({
  prop: "spaceX",
  themeGet: getSpace,
  css: (value) => ({
    "& > :not([hidden]) ~ :not([hidden])": {
      "--x-space-x-reverse": 0,
      marginRight: `calc(${value} * var(--x-space-x-reverse))`,
      marginLeft: `calc(${value} * calc(1 - var(--x-space-x-reverse)))`
    }
  })
}), spaceXReverse = style({
  prop: "spaceXReverse",
  css: () => ({
    "& > :not([hidden]) ~ :not([hidden])": {
      "--x-space-x-reverse": "1"
    }
  })
}), spaceYReverse = style({
  prop: "spaceYReverse",
  css: () => ({
    "& > :not([hidden]) ~ :not([hidden])": {
      "--x-space-y-reverse": "1"
    }
  })
}), space$1 = compose$1(
  margin,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  mx,
  my,
  padding,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  px$2,
  py,
  spaceX,
  spaceY,
  spaceXReverse,
  spaceYReverse
), gap = style({
  prop: "gap",
  themeGet: getSpace
}), columnGap = style({
  prop: "columnGap",
  themeGet: getSpace
}), rowGap = style({
  prop: "rowGap",
  themeGet: getSpace
}), gridColumn = style({
  prop: "gridColumn"
}), gridRow = style({
  prop: "gridRow"
}), gridAutoFlow = style({
  prop: "gridAutoFlow"
}), gridAutoColumns = style({
  prop: "gridAutoColumns"
}), gridAutoRows = style({
  prop: "gridAutoRows"
}), gridTemplateColumns = style({
  prop: "gridTemplateColumns",
  key: "gridTemplateColumns"
}), gridTemplateRows = style({
  prop: "gridTemplateRows",
  key: "gridTemplateRows"
}), gridTemplateAreas = style({
  prop: "gridTemplateAreas"
}), gridArea = style({
  prop: "gridArea"
}), grids = compose$1(
  gap,
  columnGap,
  rowGap,
  gridColumn,
  gridRow,
  gridAutoFlow,
  gridAutoColumns,
  gridAutoRows,
  gridTemplateColumns,
  gridTemplateRows,
  gridTemplateAreas,
  gridArea
), appearance = style({
  prop: "appearance"
}), cursor = style({
  prop: "cursor"
}), pointerEvents = style({
  prop: "pointerEvents"
}), resize = style({
  prop: "resize"
}), userSelect = style({
  prop: "userSelect"
}), interactivity = compose$1(
  appearance,
  cursor,
  pointerEvents,
  resize,
  userSelect
), getSize = themeGetter({
  name: "size",
  key: "sizes",
  compose: getPercent
}), width = style({
  prop: "w",
  themeGet: getSize,
  css: "width"
}), height = style({
  prop: "h",
  themeGet: getSize,
  css: "height"
}), maxWidth = style({
  prop: ["maxWidth", "maxW"],
  themeGet: getSize,
  css: "maxWidth"
}), maxHeight = style({
  prop: ["maxHeight", "maxH"],
  themeGet: getSize,
  css: "maxHeight"
}), minWidth = style({
  prop: ["minWidth", "minW"],
  themeGet: getSize,
  css: "minWidth"
}), minHeight = style({
  prop: ["minHeight", "minH"],
  themeGet: getSize,
  css: "minHeight"
}), maskSize = style({
  prop: "maskSize",
  themeGet: themeGetter({
    name: "size",
    key: "sizes",
    compose: getPercent,
    multiple: !0,
    shorthand: !0
  })
}), sizing = compose$1(
  width,
  height,
  maxWidth,
  maxHeight,
  minWidth,
  minHeight,
  maskSize
), fill = style({
  prop: "fill",
  themeGet: getColor$1
}), stroke = style({
  prop: "stroke",
  themeGet: getColor$1
}), svg$2 = compose$1(fill, stroke), borderCollapse = style({
  prop: "borderCollapse"
}), tableLayout = style({
  prop: "tableLayout"
}), tables = compose$1(borderCollapse, tableLayout), getTransform = themeGetter({
  name: "transform",
  key: "transforms"
}), transform = style({
  prop: "transform",
  themeGet: getTransform,
  css: (value) => value === !0 ? {
    "--x-translate-x": 0,
    "--x-translate-y": 0,
    "--x-rotate": 0,
    "--x-skew-x": 0,
    "--x-skew-y": 0,
    "--x-scale-x": "1",
    "--x-scale-y": "1",
    transform: "translate3d(var(--x-translate-x), var(--x-translate-y), 0) rotate(var(--x-rotate)) skewX(var(--x-skew-x)) skewY(var(--x-skew-y)) scaleX(var(--x-scale-x)) scaleY(var(--x-scale-y))"
  } : { transform: value }
}), transformOrigin = style({
  prop: "transformOrigin"
}), translateX = style({
  prop: "translateX",
  themeGet: getSpace,
  css: "--x-translate-x"
}), translateY = style({
  prop: "translateY",
  themeGet: getSpace,
  css: "--x-translate-y"
}), rotate = style({
  prop: "rotate",
  themeGet: getAngle,
  css: "--x-rotate"
}), skewX = style({
  prop: "skewX",
  themeGet: getAngle,
  css: "--x-skew-x"
}), skewY = style({
  prop: "skewY",
  themeGet: getAngle,
  css: "--x-skew-y"
}), scale$1 = style({
  prop: "scale",
  transform: (v) => String(v),
  css: ["--x-scale-x", "--x-scale-y"]
}), scaleX = style({
  prop: "scaleX",
  transform: (v) => String(v),
  css: "--x-scale-x"
}), scaleY = style({
  prop: "scaleY",
  transform: (v) => String(v),
  css: "--x-scale-y"
}), transforms = compose$1(
  transform,
  transformOrigin,
  translateX,
  translateY,
  rotate,
  skewX,
  skewY,
  scale$1,
  scaleX,
  scaleY
);
var __defProp$2 = Object.defineProperty, __defProps$1 = Object.defineProperties, __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors, __getOwnPropSymbols$2 = Object.getOwnPropertySymbols, __hasOwnProp$2 = Object.prototype.hasOwnProperty, __propIsEnum$2 = Object.prototype.propertyIsEnumerable, __defNormalProp$2 = /* @__PURE__ */ __name((obj2, key, value) => key in obj2 ? __defProp$2(obj2, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj2[key] = value, "__defNormalProp$2"), __spreadValues$2 = /* @__PURE__ */ __name((a4, b2) => {
  for (var prop in b2 || (b2 = {}))
    __hasOwnProp$2.call(b2, prop) && __defNormalProp$2(a4, prop, b2[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b2))
      __propIsEnum$2.call(b2, prop) && __defNormalProp$2(a4, prop, b2[prop]);
  return a4;
}, "__spreadValues$2"), __spreadProps$1 = /* @__PURE__ */ __name((a4, b2) => __defProps$1(a4, __getOwnPropDescs$1(b2)), "__spreadProps$1");
const getFont = themeGetter({ name: "font", key: "fonts" }), getLineHeight = themeGetter({
  name: "lineHeight",
  key: "lineHeights",
  transform: (value, { props }) => {
    var _a3, _b, _c;
    const rootFontSize = (_c = (_b = (_a3 = props == null ? void 0 : props.theme) == null ? void 0 : _a3.settings) == null ? void 0 : _b.rootFontSize) != null ? _c : void 0;
    return rpx(value, { rootFontSize });
  }
}), getFontWeight = themeGetter({
  name: "fontWeight",
  key: "fontWeights"
}), getLetterSpacing = themeGetter({
  name: "letterSpacing",
  key: "letterSpacings",
  compose: getPx
}), getFontSize = themeGetter({
  name: "fontSize",
  key: "fontSizes",
  compose: getPx
}), fontFamily = style({
  prop: "fontFamily",
  themeGet: getFont
}), fontSize = style({
  prop: "fontSize",
  themeGet: getFontSize
}), fontVariant = style({
  prop: "fontVariant"
}), lineHeight = style({
  prop: "lineHeight",
  themeGet: getLineHeight
}), fontWeight = style({
  prop: "fontWeight",
  themeGet: getFontWeight
}), fontStyle = style({
  prop: "fontStyle"
}), letterSpacing = style({
  prop: "letterSpacing",
  themeGet: getLetterSpacing
}), color$4 = style({
  prop: "color",
  themeGet: getColor$1
}), textTransform = style({
  prop: "textTransform"
}), textDecoration = style({
  prop: "textDecoration"
}), textAlign = style({
  prop: "textAlign"
}), verticalAlign = style({
  prop: "verticalAlign"
}), whiteSpace = style({
  prop: "whiteSpace"
}), textOverflow = style({
  prop: "textOverflow"
}), listStyleType = style({
  prop: "listStyleType"
}), listStylePosition = style({
  prop: "listStylePosition"
}), all$2 = compose$1(
  space$1,
  fontFamily,
  fontSize,
  fontStyle,
  fontVariant,
  lineHeight,
  fontWeight,
  textAlign,
  letterSpacing,
  color$4,
  textTransform,
  textDecoration,
  verticalAlign,
  whiteSpace,
  textOverflow,
  listStyleType,
  listStylePosition
), text$4 = style({
  prop: "text",
  key: "texts",
  css: (value) => ({ theme }) => all$2(__spreadProps$1(__spreadValues$2({}, value), { theme }))
}), typography = compose$1(all$2, text$4), system = compose$1(
  animations$1,
  backgrounds,
  borders$1,
  effects,
  flexboxGrids,
  flexboxes,
  grids,
  interactivity,
  layout$1,
  sizing,
  space$1,
  svg$2,
  tables,
  transforms,
  transitions$1,
  typography
), th = /* @__PURE__ */ __name((path, defaultValue) => (props) => {
  const value = getThemeValue(props, path);
  return is(value) ? value : is(defaultValue) ? defaultValue : path;
}, "th");
[
  getAngle,
  getAnimation,
  getBorder,
  getBorderColor,
  getBorderStyle,
  getBorderWidth,
  getColor$1,
  getDuration,
  getFont,
  getFontSize,
  getFontWeight,
  getInset,
  getLetterSpacing,
  getLineHeight,
  getPercent,
  getPx,
  getRadius$1,
  getRingWidth,
  getShadow,
  getSize,
  getSpace,
  getTimingFunction,
  getTransform,
  getTransition,
  getTransitionProperty,
  getZIndex
].forEach((themeGetter2) => {
  th[themeGetter2.meta.name] = themeGetter2;
});
var __defProp$1 = Object.defineProperty, __getOwnPropSymbols$1 = Object.getOwnPropertySymbols, __hasOwnProp$1 = Object.prototype.hasOwnProperty, __propIsEnum$1 = Object.prototype.propertyIsEnumerable, __defNormalProp$1 = /* @__PURE__ */ __name((obj2, key, value) => key in obj2 ? __defProp$1(obj2, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj2[key] = value, "__defNormalProp$1"), __spreadValues$1 = /* @__PURE__ */ __name((a4, b2) => {
  for (var prop in b2 || (b2 = {}))
    __hasOwnProp$1.call(b2, prop) && __defNormalProp$1(a4, prop, b2[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b2))
      __propIsEnum$1.call(b2, prop) && __defNormalProp$1(a4, prop, b2[prop]);
  return a4;
}, "__spreadValues$1");
const defaultAlphaVariants = [
  0,
  5,
  10,
  20,
  25,
  30,
  40,
  50,
  60,
  70,
  75,
  80,
  90,
  95,
  100
], generateHexAlphaVariants = /* @__PURE__ */ __name((colors2, variants = defaultAlphaVariants) => {
  const transform2 = /* @__PURE__ */ __name((value, variant) => `${value}${Math.round(variant / 100 * 255).toString(16).padStart(2, "0")}`, "transform"), alphaColors = Object.keys(colors2).reduce((obj2, key) => (variants.forEach((variant) => {
    const value = colors2[key], variantKey = `${key}-a${variant}`;
    obj2[variantKey] = string$3(value) ? transform2(value, variant) : generateHexAlphaVariants(value, variants);
  }), obj2), {});
  return __spreadValues$1(__spreadValues$1({}, colors2), alphaColors);
}, "generateHexAlphaVariants");
var __defProp$7 = Object.defineProperty, __defProps$2 = Object.defineProperties, __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors, __getOwnPropSymbols$7 = Object.getOwnPropertySymbols, __hasOwnProp$7 = Object.prototype.hasOwnProperty, __propIsEnum$7 = Object.prototype.propertyIsEnumerable, __defNormalProp$7 = /* @__PURE__ */ __name((obj2, key, value) => key in obj2 ? __defProp$7(obj2, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj2[key] = value, "__defNormalProp$7"), __spreadValues$7 = /* @__PURE__ */ __name((a4, b2) => {
  for (var prop in b2 || (b2 = {}))
    __hasOwnProp$7.call(b2, prop) && __defNormalProp$7(a4, prop, b2[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b2))
      __propIsEnum$7.call(b2, prop) && __defNormalProp$7(a4, prop, b2[prop]);
  return a4;
}, "__spreadValues$7"), __spreadProps$2 = /* @__PURE__ */ __name((a4, b2) => __defProps$2(a4, __getOwnPropDescs$2(b2)), "__spreadProps$2");
const space$2 = {
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  11: "2.75rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, timingFunctions = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, transitionProperties = {
  default: [
    "background-color",
    "border-color",
    "color",
    "fill",
    "stroke",
    "opacity",
    "box-shadow",
    "transform"
  ],
  colors: ["background-color", "border-color", "color", "fill", "stroke"],
  opacity: ["opacity"],
  shadow: ["box-shadow"],
  transform: ["transform"]
}, transitions = Object.keys(
  transitionProperties
).reduce((obj2, key) => (obj2[key] = transitionProperties[key].map((property2) => `${property2} ${timingFunctions["ease-in-out"]} 150ms`).join(","), obj2), {}), colors = {
  black: "#000000",
  white: "#ffffff",
  "blue-gray-50": "#f8fafc",
  "blue-gray-100": "#f1f5f9",
  "blue-gray-200": "#e2e8f0",
  "blue-gray-300": "#cbd5e1",
  "blue-gray-400": "#94a3b8",
  "blue-gray-500": "#64748b",
  "blue-gray-600": "#475569",
  "blue-gray-700": "#334155",
  "blue-gray-800": "#1e293b",
  "blue-gray-900": "#0f172a",
  "cool-gray-50": "#f9fafb",
  "cool-gray-100": "#f3f4f6",
  "cool-gray-200": "#e5e7eb",
  "cool-gray-300": "#d1d5db",
  "cool-gray-400": "#9ca3af",
  "cool-gray-500": "#6b7280",
  "cool-gray-600": "#4b5563",
  "cool-gray-700": "#374151",
  "cool-gray-800": "#1f2937",
  "cool-gray-900": "#111827",
  "gray-50": "#fafafa",
  "gray-100": "#f4f4f5",
  "gray-200": "#e4e4e7",
  "gray-300": "#d4d4d8",
  "gray-400": "#a1a1aa",
  "gray-500": "#71717a",
  "gray-600": "#52525b",
  "gray-700": "#3f3f46",
  "gray-800": "#27272a",
  "gray-900": "#18181b",
  "true-gray-50": "#fafafa",
  "true-gray-100": "#f5f5f5",
  "true-gray-200": "#e5e5e5",
  "true-gray-300": "#d4d4d4",
  "true-gray-400": "#a3a3a3",
  "true-gray-500": "#737373",
  "true-gray-600": "#525252",
  "true-gray-700": "#404040",
  "true-gray-800": "#262626",
  "true-gray-900": "#171717",
  "warm-gray-50": "#fafaf9",
  "warm-gray-100": "#f5f5f4",
  "warm-gray-200": "#e7e5e4",
  "warm-gray-300": "#d6d3d1",
  "warm-gray-400": "#a8a29e",
  "warm-gray-500": "#78716c",
  "warm-gray-600": "#57534e",
  "warm-gray-700": "#44403c",
  "warm-gray-800": "#292524",
  "warm-gray-900": "#1c1917",
  "red-50": "#fef2f2",
  "red-100": "#fee2e2",
  "red-200": "#fecaca",
  "red-300": "#fca5a5",
  "red-400": "#f87171",
  "red-500": "#ef4444",
  "red-600": "#dc2626",
  "red-700": "#b91c1c",
  "red-800": "#991b1b",
  "red-900": "#7f1d1d",
  "orange-50": "#fff7ed",
  "orange-100": "#ffedd5",
  "orange-200": "#fed7aa",
  "orange-300": "#fdba74",
  "orange-400": "#fb923c",
  "orange-500": "#f97316",
  "orange-600": "#ea580c",
  "orange-700": "#c2410c",
  "orange-800": "#9a3412",
  "orange-900": "#7c2d12",
  "amber-50": "#fffbeb",
  "amber-100": "#fef3c7",
  "amber-200": "#fde68a",
  "amber-300": "#fcd34d",
  "amber-400": "#fbbf24",
  "amber-500": "#f59e0b",
  "amber-600": "#d97706",
  "amber-700": "#b45309",
  "amber-800": "#92400e",
  "amber-900": "#78350f",
  "yellow-50": "#fefce8",
  "yellow-100": "#fef9c3",
  "yellow-200": "#fef08a",
  "yellow-300": "#fde047",
  "yellow-400": "#facc15",
  "yellow-500": "#eab308",
  "yellow-600": "#ca8a04",
  "yellow-700": "#a16207",
  "yellow-800": "#854d0e",
  "yellow-900": "#713f12",
  "lime-50": "#f7fee7",
  "lime-100": "#ecfccb",
  "lime-200": "#d9f99d",
  "lime-300": "#bef264",
  "lime-400": "#a3e635",
  "lime-500": "#84cc16",
  "lime-600": "#65a30d",
  "lime-700": "#4d7c0f",
  "lime-800": "#3f6212",
  "lime-900": "#365314",
  "green-50": "#f0fdf4",
  "green-100": "#dcfce7",
  "green-200": "#bbf7d0",
  "green-300": "#86efac",
  "green-400": "#4ade80",
  "green-500": "#22c55e",
  "green-600": "#16a34a",
  "green-700": "#15803d",
  "green-800": "#166534",
  "green-900": "#14532d",
  "emerald-50": "#ecfdf5",
  "emerald-100": "#d1fae5",
  "emerald-200": "#a7f3d0",
  "emerald-300": "#6ee7b7",
  "emerald-400": "#34d399",
  "emerald-500": "#10b981",
  "emerald-600": "#059669",
  "emerald-700": "#047857",
  "emerald-800": "#065f46",
  "emerald-900": "#064e3b",
  "teal-50": "#f0fdfa",
  "teal-100": "#ccfbf1",
  "teal-200": "#99f6e4",
  "teal-300": "#5eead4",
  "teal-400": "#2dd4bf",
  "teal-500": "#14b8a6",
  "teal-600": "#0d9488",
  "teal-700": "#0f766e",
  "teal-800": "#115e59",
  "teal-900": "#134e4a",
  "cyan-50": "#ecfeff",
  "cyan-100": "#cffafe",
  "cyan-200": "#a5f3fc",
  "cyan-300": "#67e8f9",
  "cyan-400": "#22d3ee",
  "cyan-500": "#06b6d4",
  "cyan-600": "#0891b2",
  "cyan-700": "#0e7490",
  "cyan-800": "#155e75",
  "cyan-900": "#164e63",
  "light-blue-50": "#f0f9ff",
  "light-blue-100": "#e0f2fe",
  "light-blue-200": "#bae6fd",
  "light-blue-300": "#7dd3fc",
  "light-blue-400": "#38bdf8",
  "light-blue-500": "#0ea5e9",
  "light-blue-600": "#0284c7",
  "light-blue-700": "#0369a1",
  "light-blue-800": "#075985",
  "light-blue-900": "#0c4a6e",
  "blue-50": "#eff6ff",
  "blue-100": "#dbeafe",
  "blue-200": "#bfdbfe",
  "blue-300": "#93c5fd",
  "blue-400": "#60a5fa",
  "blue-500": "#3b82f6",
  "blue-600": "#2563eb",
  "blue-700": "#1d4ed8",
  "blue-800": "#1e40af",
  "blue-900": "#1e3a8a",
  "indigo-50": "#eef2ff",
  "indigo-100": "#e0e7ff",
  "indigo-200": "#c7d2fe",
  "indigo-300": "#a5b4fc",
  "indigo-400": "#818cf8",
  "indigo-500": "#6366f1",
  "indigo-600": "#4f46e5",
  "indigo-700": "#4338ca",
  "indigo-800": "#3730a3",
  "indigo-900": "#312e81",
  "violet-50": "#f5f3ff",
  "violet-100": "#ede9fe",
  "violet-200": "#ddd6fe",
  "violet-300": "#c4b5fd",
  "violet-400": "#a78bfa",
  "violet-500": "#8b5cf6",
  "violet-600": "#7c3aed",
  "violet-700": "#6d28d9",
  "violet-800": "#5b21b6",
  "violet-900": "#4c1d95",
  "purple-50": "#faf5ff",
  "purple-100": "#f3e8ff",
  "purple-200": "#e9d5ff",
  "purple-300": "#d8b4fe",
  "purple-400": "#c084fc",
  "purple-500": "#a855f7",
  "purple-600": "#9333ea",
  "purple-700": "#7e22ce",
  "purple-800": "#6b21a8",
  "purple-900": "#581c87",
  "fuchsia-50": "#fdf4ff",
  "fuchsia-100": "#fae8ff",
  "fuchsia-200": "#f5d0fe",
  "fuchsia-300": "#f0abfc",
  "fuchsia-400": "#e879f9",
  "fuchsia-500": "#d946ef",
  "fuchsia-600": "#c026d3",
  "fuchsia-700": "#a21caf",
  "fuchsia-800": "#86198f",
  "fuchsia-900": "#701a75",
  "pink-50": "#fdf2f8",
  "pink-100": "#fce7f3",
  "pink-200": "#fbcfe8",
  "pink-300": "#f9a8d4",
  "pink-400": "#f472b6",
  "pink-500": "#ec4899",
  "pink-600": "#db2777",
  "pink-700": "#be185d",
  "pink-800": "#9d174d",
  "pink-900": "#831843",
  "rose-50": "#fff1f2",
  "rose-100": "#ffe4e6",
  "rose-200": "#fecdd3",
  "rose-300": "#fda4af",
  "rose-400": "#fb7185",
  "rose-500": "#f43f5e",
  "rose-600": "#e11d48",
  "rose-700": "#be123c",
  "rose-800": "#9f1239",
  "rose-900": "#881337"
}, fontSizes = {
  xs: "0.75rem",
  sm: "0.875rem",
  default: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "3.75rem",
  "7xl": "4.5rem",
  "8xl": "6rem",
  "9xl": "8rem"
}, texts = Object.keys(fontSizes).reduce(
  (texts2, key) => (texts2[key] = { fontSize: key, lineHeight: key }, texts2),
  {}
);
generateHexAlphaVariants(colors), __spreadProps$2(__spreadValues$7({}, space$2), {
  0.5: void 0,
  1: void 0,
  "0.5s": space$2[0.5],
  "1s": space$2[1],
  full: "100%",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem"
});
const getPreflightStyles = /* @__PURE__ */ __name((theme) => `
/*! modern-normalize v1.0.0 | MIT License | https://github.com/sindresorhus/modern-normalize */
*,::after,::before{box-sizing:border-box}:root{-moz-tab-size:4;tab-size:4}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}body{font-family:system-ui,-apple-system,'Segoe UI',Roboto,Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji'}hr{height:0;color:inherit}abbr[title]{text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:ui-monospace,SFMono-Regular,Consolas,'Liberation Mono',Menlo,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}::-moz-focus-inner{border-style:none;padding:0}:-moz-focusring{outline:1px dotted ButtonText}:-moz-ui-invalid{box-shadow:none}legend{padding:0}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}

/* Role button pointer */
[role=button], button {
  cursor: pointer;
}

/* Remove default margins */
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

/* Remove headings styles */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/* Unstyle lists */
ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Image are block-level */
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  vertical-align: middle;
}

/* Reset border styles */
*,
::before,
::after {
  border-width: 0;
  border-style: solid;
  border-color: ${th.color("default-border-color", "currentColor")({ theme })};
}

* {
  --x-ring-color: ${th.color(
  "default-ring-color",
  "rgba(59,130,246,0.5)"
)({ theme })};
}

/* Default outline on buttons */
button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

// Animations
@keyframes x-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes x-ping {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes x-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
}

@keyframes x-bounce {
  0%, 100% {
    transform: translateY(-25%);
    animationTimingFunction: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animationTimingFunction: cubic-bezier(0, 0, 0.2, 1);
  }
}
`, "getPreflightStyles"), join$1 = /* @__PURE__ */ __name((...args) => args.filter(Boolean).join("."), "join$1"), toVarName = /* @__PURE__ */ __name((key) => `--${key.replace(/\./g, "-")}`, "toVarName"), toProp = /* @__PURE__ */ __name((key, value) => `${key}: ${value};`, "toProp");
function toCustomPropertiesDeclarations(values, theme, keys2 = Object.keys(values), parent2, state = { value: "" }) {
  for (const i2 in keys2) {
    const key = keys2[i2], value = values[key], name2 = join$1(parent2, key);
    if (obj(value)) {
      toCustomPropertiesDeclarations(
        value,
        theme,
        Object.keys(value),
        name2,
        state
      );
      continue;
    }
    if (string$3(value)) {
      state.value += toProp(toVarName(name2), value);
      continue;
    }
    if (func(value)) {
      state.value += toProp(toVarName(name2), cascade(value, { theme }));
      continue;
    }
  }
  return state.value;
}
__name(toCustomPropertiesDeclarations, "toCustomPropertiesDeclarations");
var __defProp2 = Object.defineProperty, __defProps = Object.defineProperties, __getOwnPropDescs = Object.getOwnPropertyDescriptors, __getOwnPropSymbols = Object.getOwnPropertySymbols, __hasOwnProp = Object.prototype.hasOwnProperty, __propIsEnum = Object.prototype.propertyIsEnumerable, __defNormalProp2 = /* @__PURE__ */ __name((obj2, key, value) => key in obj2 ? __defProp2(obj2, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj2[key] = value, "__defNormalProp"), __spreadValues = /* @__PURE__ */ __name((a4, b2) => {
  for (var prop in b2 || (b2 = {}))
    __hasOwnProp.call(b2, prop) && __defNormalProp2(a4, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2))
      __propIsEnum.call(b2, prop) && __defNormalProp2(a4, prop, b2[prop]);
  return a4;
}, "__spreadValues"), __spreadProps = /* @__PURE__ */ __name((a4, b2) => __defProps(a4, __getOwnPropDescs(b2)), "__spreadProps"), __objRest = /* @__PURE__ */ __name((source, exclude) => {
  var target = {};
  for (var prop in source)
    __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source))
      exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
}, "__objRest");
typeof window < "u" && (() => {
  try {
    const key = "xstyled-test-key";
    return window.localStorage.setItem(key, key), window.localStorage.removeItem(key), !0;
  } catch {
    return !1;
  }
})();
const COLOR_MODE_CLASS_PREFIX = "xstyled-color-mode-", getColorModeClassName = /* @__PURE__ */ __name((mode) => `${COLOR_MODE_CLASS_PREFIX}${mode}`, "getColorModeClassName"), XSTYLED_COLORS_PREFIX = "xstyled-colors", SYSTEM_MODES = ["light", "dark"];
function getModeTheme(theme, mode) {
  return __spreadProps(__spreadValues({}, theme), {
    colors: __spreadValues(__spreadValues({}, theme.colors), theme.colors.modes[mode])
  });
}
__name(getModeTheme, "getModeTheme");
const getMediaQuery = /* @__PURE__ */ __name((query) => `@media ${query}`, "getMediaQuery"), getColorModeQuery = /* @__PURE__ */ __name((mode) => `(prefers-color-scheme: ${mode})`, "getColorModeQuery");
function checkHasColorModes(theme) {
  return !!(theme && theme.colors && theme.colors.modes);
}
__name(checkHasColorModes, "checkHasColorModes");
function getInitialColorModeName(theme) {
  return theme.initialColorModeName || "default";
}
__name(getInitialColorModeName, "getInitialColorModeName");
function getUsedColorKeys(modes) {
  let keys2 = [];
  for (const key in modes)
    keys2 = [...keys2, ...Object.keys(modes[key])];
  return keys2;
}
__name(getUsedColorKeys, "getUsedColorKeys");
function createColorStyles(theme, { targetSelector = "body" } = {}) {
  if (!checkHasColorModes(theme))
    return null;
  const _a3 = theme.colors, { modes } = _a3, colors2 = __objRest(_a3, ["modes"]), colorKeys = getUsedColorKeys(modes);
  let styles = toCustomPropertiesDeclarations(
    colors2,
    theme,
    colorKeys,
    XSTYLED_COLORS_PREFIX
  );
  function getModePropertiesDeclarations(mode) {
    const modeTheme = getModeTheme(theme, mode), _a22 = modeTheme.colors, { modes: modes2 } = _a22, colors22 = __objRest(_a22, ["modes"]);
    return toCustomPropertiesDeclarations(
      __spreadValues(__spreadValues({}, colors22), modes2[mode]),
      modeTheme,
      colorKeys,
      XSTYLED_COLORS_PREFIX
    );
  }
  return __name(getModePropertiesDeclarations, "getModePropertiesDeclarations"), theme.useColorSchemeMediaQuery !== !1 && SYSTEM_MODES.forEach((mode) => {
    if (modes[mode]) {
      const mediaQuery = getMediaQuery(getColorModeQuery(mode));
      styles += `${mediaQuery}{${getModePropertiesDeclarations(mode)}}`;
    }
  }), [getInitialColorModeName(theme), ...Object.keys(modes)].forEach((mode) => {
    const key = `&.${getColorModeClassName(mode)}`;
    styles += `${key}{${getModePropertiesDeclarations(mode)}}`;
  }), `${targetSelector}{${styles}}`;
}
__name(createColorStyles, "createColorStyles");
React.createContext(null);
system.meta;
const getMediaWidth = /* @__PURE__ */ __name((getBreakpointBound) => (value) => (props) => {
  const v = getBreakpointBound(getScreens(props), value);
  return v === null ? "0" : v || value;
}, "getMediaWidth"), mediaGetters = {
  "min-width": getMediaWidth(getBreakpointMin),
  "max-width": getMediaWidth(getBreakpointMax)
}, PROP_CHAR = "[-\\w]", VALUE_CHAR = "(?:\\\\[\\s\\S]|[^\\\\;{}])", PROP_PATT = `(${PROP_CHAR}+)(\\s*:\\s*)(?=\\S)(${VALUE_CHAR}*?)(\\s*!important)?(\\s*;)`, MEDIA_CHAR = "[^{]", MEDIA_PATT = `(@media\\b\\s*)(?=\\S)(${MEDIA_CHAR}+?)(\\s*\\{)`, MATCH_REGEXP = new RegExp(`(?:${PROP_PATT}|${MEDIA_PATT})`, "g"), QUERY_REGEXP = new RegExp(
  `(\\(\\s*)(${PROP_CHAR}+)(\\s*:\\s*)([^\\)]*?)(\\s*\\))`,
  "g"
), mediaTransform = /* @__PURE__ */ __name((rawValue) => {
  let matches2, lastIndex = 0;
  const values = [];
  for (; matches2 = QUERY_REGEXP.exec(rawValue); ) {
    const [, open, prop, colon, value, close] = matches2, getter2 = mediaGetters[prop];
    getter2 && (values.push(rawValue.slice(lastIndex, matches2.index)), values.push(
      (p) => `${open}${prop}${colon}${getter2(value)(p)}${close}`
    ), lastIndex = matches2.index + matches2[0].length);
  }
  return values.push(rawValue.slice(lastIndex, rawValue.length)), values;
}, "mediaTransform"), createTransform = /* @__PURE__ */ __name((generator) => (rawValue) => {
  if (typeof rawValue != "string")
    return rawValue;
  let matches2, lastIndex = 0;
  const values = [];
  for (; matches2 = MATCH_REGEXP.exec(rawValue); ) {
    const [, prop, colon, value, imp, semi, media, query, brace] = matches2;
    if (media)
      values.push(rawValue.slice(lastIndex, matches2.index)), values.push(media), mediaTransform(query).forEach((v) => values.push(v)), values.push(brace), lastIndex = matches2.index + matches2[0].length;
    else {
      const getter2 = generator.meta.cssGetters[prop];
      getter2 && (values.push(rawValue.slice(lastIndex, matches2.index)), values.push(
        (p) => `${prop}${colon}${getter2(value)(p)}${imp || ""}${semi}`
      ), lastIndex = matches2.index + matches2[0].length);
    }
  }
  return values.push(rawValue.slice(lastIndex, rawValue.length)), values;
}, "createTransform");
createGlobalStyle$1`${(p) => createColorStyles(p.theme, { targetSelector: p.targetSelector })}`;
createGlobalStyle$1(({ theme }) => getPreflightStyles(theme));
const createCssFunction = /* @__PURE__ */ __name((generator) => {
  const transform2 = createTransform(generator);
  return (...args) => {
    const scCssArgs = css$1(...args);
    return flattenStrings(scCssArgs).map(transform2);
  };
}, "createCssFunction"), scStyled = typeof styled$1 == "function" ? styled$1 : styled$1.default, getCreateStyle = /* @__PURE__ */ __name((baseCreateStyle, css2, generator) => {
  const createStyle = /* @__PURE__ */ __name((...args) => baseCreateStyle`${css2(...args)}${generator}`, "createStyle");
  return createStyle.attrs = (attrs) => getCreateStyle(baseCreateStyle.attrs(attrs), css2, generator), createStyle.withConfig = (config2) => getCreateStyle(baseCreateStyle.withConfig(config2), css2, generator), createStyle;
}, "getCreateStyle"), createShouldForwardProp = /* @__PURE__ */ __name((generator) => {
  const propSet = new Set(generator.meta.props);
  return (prop, defaultValidatorFn, elementToBeCreated) => string$3(prop) && propSet.has(prop) ? !1 : typeof elementToBeCreated == "string" ? defaultValidatorFn(prop) : !0;
}, "createShouldForwardProp"), createBaseStyled = /* @__PURE__ */ __name((css2, generator) => {
  const config2 = generator ? {
    shouldForwardProp: createShouldForwardProp(generator)
  } : {};
  return (component) => {
    const baseStyled = scStyled(component);
    return getCreateStyle(config2 ? baseStyled.withConfig(config2) : baseStyled, css2, generator);
  };
}, "createBaseStyled"), createStyled = /* @__PURE__ */ __name((generator) => {
  const css2 = createCssFunction(generator), styled2 = createBaseStyled(css2), xstyled = createBaseStyled(css2, generator);
  return styled2.box = xstyled("div"), Object.keys(scStyled).forEach((key) => {
    styled2[key] = styled2(key), styled2[`${key}Box`] = xstyled(key);
  }), styled2;
}, "createStyled"), createX = /* @__PURE__ */ __name((generator) => {
  const xstyled = createBaseStyled(createCssFunction(generator), generator), x3 = {};
  return Object.keys(scStyled).forEach((tag) => {
    x3[tag] = xstyled(tag)``;
  }), x3;
}, "createX"), createCreateGlobalStyle = /* @__PURE__ */ __name((generator) => {
  const css2 = createCssFunction(generator);
  return (...args) => createGlobalStyle$1([
    css2(...args)
  ]);
}, "createCreateGlobalStyle"), createCss = /* @__PURE__ */ __name((generator) => ({
  css: createCssFunction(generator),
  x: createX(generator),
  styled: createStyled(generator),
  createGlobalStyle: createCreateGlobalStyle(generator)
}), "createCss"), { css, styled, x: x$1, createGlobalStyle } = createCss(system), GapContainer = styled(Flex)`
  gap: ${({ gap: gap2 }) => getSpace$1(gap2)};
  ${({ columnGap: columnGap2 }) => columnGap2 && css`
      column-gap: ${getSpace$1(columnGap2)};
    `}
  ${({ rowGap: rowGap2 }) => rowGap2 && css`
      row-gap: ${getSpace$1(rowGap2)};
    `}
`;
function Gap({
  children,
  gap: gap2,
  space: space2,
  "data-test": dataTest,
  ...otherProps
}) {
  return /* @__PURE__ */ jsx(GapContainer, { "data-test": dataTest, gap: gap2 ?? space2 ?? "s", ...otherProps, children });
}
__name(Gap, "Gap");
function AccordionSection({
  title,
  count,
  countProps,
  minimizable = !0,
  children,
  ...flexProps
}) {
  const [minimized, setMinimized] = useState(!1), toggleMinimized = /* @__PURE__ */ __name(() => {
    setMinimized((m3) => !m3);
  }, "toggleMinimized");
  return /* @__PURE__ */ jsx(
    Flex,
    {
      backgroundColor: "neutral-100",
      padding: "m",
      borderRadius: "default",
      w: "100%",
      ...flexProps,
      children: /* @__PURE__ */ jsxs(Gap, { flexDirection: "column", w: "100%", children: [
        /* @__PURE__ */ jsxs(Flex, { alignItems: "center", justifyContent: "space-between", children: [
          /* @__PURE__ */ jsxs(Gap, { alignItems: "center", gap: "xxs", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "bodySemiboldM", children: title }),
            count !== void 0 && /* @__PURE__ */ jsx(Count, { value: count, ...countProps })
          ] }),
          minimizable && /* @__PURE__ */ jsx(
            IconButton,
            {
              "data-test": "toggle-minimized",
              component: minimized ? ArrowDownFilled : ArrowUpFilled,
              size: 16,
              color: "neutral-1000",
              onClick: toggleMinimized
            }
          )
        ] }),
        !minimized && /* @__PURE__ */ jsx(Flex, { children })
      ] })
    }
  );
}
__name(AccordionSection, "AccordionSection");
function AddButton({
  isLarge = !1,
  children,
  ...props
}) {
  const icon = isLarge ? /* @__PURE__ */ jsx(PlusCircleFilled, {}) : null, formattedButtonText = isLarge ? children : `+ ${children}`;
  return /* @__PURE__ */ jsxs(Button$1, { size: isLarge ? "regular" : "xSmall", ...props, mode: isLarge ? "outline" : "link", children: [
    icon,
    formattedButtonText
  ] });
}
__name(AddButton, "AddButton");
const StyledSpacer = styled(Spacer)`
  background: linear-gradient(95.08deg, #c2ffec 1.17%, #f5fffb 100%);
`;
function AiPromotionalBanner({
  actionButtonHref,
  buttonTexts,
  icon,
  onClose,
  title,
  alignItems: alignItems2 = "center",
  border: border2 = "1px solid #c2ffec",
  borderRadius: borderRadius2 = 16,
  direction = "horizontal",
  fluid = !0,
  justifyContent: justifyContent2 = "space-between",
  px: px2 = "m",
  py: py2 = "s",
  space: space2 = "s",
  "data-test": dataTest = "ai-promotional-banner",
  ...spacerProps
}) {
  return /* @__PURE__ */ jsx(ThemeProvider, { children: /* @__PURE__ */ jsxs(
    StyledSpacer,
    {
      direction,
      alignItems: alignItems2,
      fluid,
      justifyContent: justifyContent2,
      py: py2,
      px: px2,
      space: space2,
      border: border2,
      borderRadius: borderRadius2,
      "data-test": dataTest,
      ...spacerProps,
      children: [
        /* @__PURE__ */ jsxs(Spacer, { space: "s", pr: "xs", alignItems: "center", children: [
          /* @__PURE__ */ jsx(Icon, { component: icon, color: "icon-interactive-secondary", size: 24 }),
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "bodySemiboldM",
              color: "text-base",
              "data-test": `${dataTest}-title`,
              children: title
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(Spacer, { space: "s", alignItems: "center", children: [
          onClose && /* @__PURE__ */ jsx(
            Button$1,
            {
              variant: "secondary",
              onClick: onClose,
              mode: "link",
              size: "xSmall",
              "data-test": `${dataTest}-close-button`,
              children: buttonTexts.close
            }
          ),
          /* @__PURE__ */ jsx(
            Button$1,
            {
              as: "a",
              href: actionButtonHref,
              target: "_blank",
              size: "small",
              "data-test": `${dataTest}-action-button`,
              children: buttonTexts.action
            }
          )
        ] })
      ]
    }
  ) });
}
__name(AiPromotionalBanner, "AiPromotionalBanner");
var Availability = /* @__PURE__ */ ((Availability2) => (Availability2.ALWAYS_CLOSED = "ALWAYS_CLOSED", Availability2.ALWAYS_OPENED = "ALWAYS_OPENED", Availability2.CUSTOM = "CUSTOM", Availability2))(Availability || {});
function AvailabilitySelect({
  texts: texts2,
  ...selectProps
}) {
  const options = [
    {
      label: texts2.always,
      description: texts2.alwaysDescription,
      value: Availability.ALWAYS_OPENED
    },
    {
      label: texts2.never,
      description: texts2.neverDescription,
      value: Availability.ALWAYS_CLOSED
    },
    {
      label: texts2.scheduled,
      value: Availability.CUSTOM
    }
  ], renderIcon2 = /* @__PURE__ */ __name((option) => {
    switch (option.value) {
      case Availability.ALWAYS_OPENED:
        return /* @__PURE__ */ jsx(Icon, { size: 24, component: TickCircleFilled, color: "primary-500" });
      case Availability.ALWAYS_CLOSED:
        return /* @__PURE__ */ jsx(Icon, { size: 24, component: CloseCircleFilled, color: "critical-500" });
      case Availability.CUSTOM:
        return /* @__PURE__ */ jsx(Icon, { size: 24, component: ClockFilled, color: "informative-500" });
      default:
        return null;
    }
  }, "renderIcon");
  return /* @__PURE__ */ jsx(
    Select$1,
    {
      "data-test": "availability-select",
      renderOption: /* @__PURE__ */ __name((option) => /* @__PURE__ */ jsxs(Gap, { alignItems: "center", gap: "xxs", children: [
        renderIcon2(option),
        /* @__PURE__ */ jsxs(Flex, { flexDirection: "column", gap: "2px", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children: option.label }),
          /* @__PURE__ */ jsx(Typography, { variant: "supportingRegularXS", color: "text-secondary", children: option.description })
        ] })
      ] }), "renderOption"),
      selectionMode: "single",
      ...selectProps,
      options
    }
  );
}
__name(AvailabilitySelect, "AvailabilitySelect");
function removeDuplicatesByProperties(array2, propertiesNames) {
  const mapKeysAndValues = array2.map((item) => [JSON.stringify(
    propertiesNames.map((propertyName) => item[propertyName])
  ), item]);
  return [...new Map(mapKeysAndValues).values()];
}
__name(removeDuplicatesByProperties, "removeDuplicatesByProperties");
var extendStatics = /* @__PURE__ */ __name(function(d3, b2) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d4, b3) {
    d4.__proto__ = b3;
  } || function(d4, b3) {
    for (var p in b3)
      Object.prototype.hasOwnProperty.call(b3, p) && (d4[p] = b3[p]);
  }, extendStatics(d3, b2);
}, "extendStatics");
function __extends(d3, b2) {
  if (typeof b2 != "function" && b2 !== null)
    throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
  extendStatics(d3, b2);
  function __2() {
    this.constructor = d3;
  }
  __name(__2, "__"), d3.prototype = b2 === null ? Object.create(b2) : (__2.prototype = b2.prototype, new __2());
}
__name(__extends, "__extends");
var __assign = /* @__PURE__ */ __name(function() {
  return __assign = Object.assign || /* @__PURE__ */ __name(function(t3) {
    for (var s4, i2 = 1, n = arguments.length; i2 < n; i2++) {
      s4 = arguments[i2];
      for (var p in s4)
        Object.prototype.hasOwnProperty.call(s4, p) && (t3[p] = s4[p]);
    }
    return t3;
  }, "__assign"), __assign.apply(this, arguments);
}, "__assign");
function __rest(s4, e3) {
  var t3 = {};
  for (var p in s4)
    Object.prototype.hasOwnProperty.call(s4, p) && e3.indexOf(p) < 0 && (t3[p] = s4[p]);
  if (s4 != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s4); i2 < p.length; i2++)
      e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s4, p[i2]) && (t3[p[i2]] = s4[p[i2]]);
  return t3;
}
__name(__rest, "__rest");
function __awaiter(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return __name(adopt, "adopt"), new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e3) {
        reject(e3);
      }
    }
    __name(fulfilled, "fulfilled");
    function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e3) {
        reject(e3);
      }
    }
    __name(rejected, "rejected");
    function step(result2) {
      result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    __name(step, "step"), step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
__name(__awaiter, "__awaiter");
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t3[0] & 1)
      throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f, y4, t3, g = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g.throw = verb(1), g.return = verb(2), typeof Symbol == "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    for (; g && (g = 0, op[0] && (_ = 0)), _; )
      try {
        if (f = 1, y4 && (t3 = op[0] & 2 ? y4.return : op[0] ? y4.throw || ((t3 = y4.return) && t3.call(y4), 0) : y4.next) && !(t3 = t3.call(y4, op[1])).done)
          return t3;
        switch (y4 = 0, t3 && (op = [op[0] & 2, t3.value]), op[0]) {
          case 0:
          case 1:
            t3 = op;
            break;
          case 4:
            return _.label++, { value: op[1], done: !1 };
          case 5:
            _.label++, y4 = op[1], op = [0];
            continue;
          case 7:
            op = _.ops.pop(), _.trys.pop();
            continue;
          default:
            if (t3 = _.trys, !(t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t3[1]) {
              _.label = t3[1], t3 = op;
              break;
            }
            if (t3 && _.label < t3[2]) {
              _.label = t3[2], _.ops.push(op);
              break;
            }
            t3[2] && _.ops.pop(), _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e3) {
        op = [6, e3], y4 = 0;
      } finally {
        f = t3 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: !0 };
  }
}
__name(__generator, "__generator");
function __read(o, n) {
  var m3 = typeof Symbol == "function" && o[Symbol.iterator];
  if (!m3)
    return o;
  var i2 = m3.call(o), r2, ar = [], e3;
  try {
    for (; (n === void 0 || n-- > 0) && !(r2 = i2.next()).done; )
      ar.push(r2.value);
  } catch (error) {
    e3 = { error };
  } finally {
    try {
      r2 && !r2.done && (m3 = i2.return) && m3.call(i2);
    } finally {
      if (e3)
        throw e3.error;
    }
  }
  return ar;
}
__name(__read, "__read");
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l = from.length, ar; i2 < l; i2++)
      (ar || !(i2 in from)) && (ar || (ar = Array.prototype.slice.call(from, 0, i2)), ar[i2] = from[i2]);
  return to.concat(ar || Array.prototype.slice.call(from));
}
__name(__spreadArray, "__spreadArray");
var genericMessage = "Invariant Violation", _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function(obj2, proto) {
  return obj2.__proto__ = proto, obj2;
} : _a, InvariantError = (
  /** @class */
  function(_super) {
    __extends(InvariantError2, _super);
    function InvariantError2(message) {
      message === void 0 && (message = genericMessage);
      var _this = _super.call(this, typeof message == "number" ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
      return _this.framesToPop = 1, _this.name = genericMessage, setPrototypeOf(_this, InvariantError2.prototype), _this;
    }
    return __name(InvariantError2, "InvariantError"), InvariantError2;
  }(Error)
);
function invariant$2(condition, message) {
  if (!condition)
    throw new InvariantError(message);
}
__name(invariant$2, "invariant$2");
var verbosityLevels = ["debug", "log", "warn", "error", "silent"], verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name2) {
  return function() {
    if (verbosityLevels.indexOf(name2) >= verbosityLevel) {
      var method = console[name2] || console.log;
      return method.apply(console, arguments);
    }
  };
}
__name(wrapConsoleMethod, "wrapConsoleMethod");
(function(invariant2) {
  invariant2.debug = wrapConsoleMethod("debug"), invariant2.log = wrapConsoleMethod("log"), invariant2.warn = wrapConsoleMethod("warn"), invariant2.error = wrapConsoleMethod("error");
})(invariant$2 || (invariant$2 = {}));
function maybe$1(thunk) {
  try {
    return thunk();
  } catch {
  }
}
__name(maybe$1, "maybe$1");
const global$1 = maybe$1(function() {
  return globalThis;
}) || maybe$1(function() {
  return window;
}) || maybe$1(function() {
  return self;
}) || maybe$1(function() {
  return global;
}) || maybe$1(function() {
  return maybe$1.constructor("return this")();
});
var __ = "__", GLOBAL_KEY = [__, __].join("DEV");
function getDEV() {
  try {
    return !!__DEV__;
  } catch {
    return Object.defineProperty(global$1, GLOBAL_KEY, {
      value: maybe$1(function() {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), global$1[GLOBAL_KEY];
  }
}
__name(getDEV, "getDEV");
const DEV = getDEV();
function maybe(thunk) {
  try {
    return thunk();
  } catch {
  }
}
__name(maybe, "maybe");
var safeGlobal = maybe(function() {
  return globalThis;
}) || maybe(function() {
  return window;
}) || maybe(function() {
  return self;
}) || maybe(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
maybe(function() {
  return maybe.constructor("return this")();
}), needToRemove = !1;
function install() {
  safeGlobal && !maybe(function() {
    return process.env.NODE_ENV;
  }) && !maybe(function() {
    return process;
  }) && (Object.defineProperty(safeGlobal, "process", {
    value: {
      env: {
        // This default needs to be "production" instead of "development", to
        // avoid the problem https://github.com/graphql/graphql-js/pull/2894
        // will eventually solve, once merged and released.
        NODE_ENV: "production"
      }
    },
    // Let anyone else change global.process as they see fit, but hide it from
    // Object.keys(global) enumeration.
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), needToRemove = !0);
}
__name(install, "install");
install();
function remove$1() {
  needToRemove && (delete safeGlobal.process, needToRemove = !1);
}
__name(remove$1, "remove$1");
function devAssert(condition, message) {
  if (!!!condition)
    throw new Error(message);
}
__name(devAssert, "devAssert");
const MAX_ARRAY_LENGTH = 10, MAX_RECURSIVE_DEPTH = 2;
function inspect(value) {
  return formatValue(value, []);
}
__name(inspect, "inspect");
function formatValue(value, seenValues) {
  switch (typeof value) {
    case "string":
      return JSON.stringify(value);
    case "function":
      return value.name ? `[function ${value.name}]` : "[function]";
    case "object":
      return formatObjectValue(value, seenValues);
    default:
      return String(value);
  }
}
__name(formatValue, "formatValue");
function formatObjectValue(value, previouslySeenValues) {
  if (value === null)
    return "null";
  if (previouslySeenValues.includes(value))
    return "[Circular]";
  const seenValues = [...previouslySeenValues, value];
  if (isJSONable(value)) {
    const jsonValue = value.toJSON();
    if (jsonValue !== value)
      return typeof jsonValue == "string" ? jsonValue : formatValue(jsonValue, seenValues);
  } else if (Array.isArray(value))
    return formatArray(value, seenValues);
  return formatObject(value, seenValues);
}
__name(formatObjectValue, "formatObjectValue");
function isJSONable(value) {
  return typeof value.toJSON == "function";
}
__name(isJSONable, "isJSONable");
function formatObject(object2, seenValues) {
  const entries = Object.entries(object2);
  return entries.length === 0 ? "{}" : seenValues.length > MAX_RECURSIVE_DEPTH ? "[" + getObjectTag(object2) + "]" : "{ " + entries.map(
    ([key, value]) => key + ": " + formatValue(value, seenValues)
  ).join(", ") + " }";
}
__name(formatObject, "formatObject");
function formatArray(array2, seenValues) {
  if (array2.length === 0)
    return "[]";
  if (seenValues.length > MAX_RECURSIVE_DEPTH)
    return "[Array]";
  const len = Math.min(MAX_ARRAY_LENGTH, array2.length), remaining = array2.length - len, items = [];
  for (let i2 = 0; i2 < len; ++i2)
    items.push(formatValue(array2[i2], seenValues));
  return remaining === 1 ? items.push("... 1 more item") : remaining > 1 && items.push(`... ${remaining} more items`), "[" + items.join(", ") + "]";
}
__name(formatArray, "formatArray");
function getObjectTag(object2) {
  const tag = Object.prototype.toString.call(object2).replace(/^\[object /, "").replace(/]$/, "");
  if (tag === "Object" && typeof object2.constructor == "function") {
    const name2 = object2.constructor.name;
    if (typeof name2 == "string" && name2 !== "")
      return name2;
  }
  return tag;
}
__name(getObjectTag, "getObjectTag");
const _Source = class _Source {
  constructor(body, name2 = "GraphQL request", locationOffset = {
    line: 1,
    column: 1
  }) {
    typeof body == "string" || devAssert(!1, `Body must be a string. Received: ${inspect(body)}.`), this.body = body, this.name = name2, this.locationOffset = locationOffset, this.locationOffset.line > 0 || devAssert(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || devAssert(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
};
__name(_Source, "Source");
let Source = _Source;
function removeTemporaryGlobals() {
  return remove$1();
}
__name(removeTemporaryGlobals, "removeTemporaryGlobals");
function checkDEV() {
  __DEV__ ? invariant$2(typeof DEV == "boolean", DEV) : invariant$2(typeof DEV == "boolean", 36);
}
__name(checkDEV, "checkDEV");
removeTemporaryGlobals();
checkDEV();
function isNonNullObject(obj2) {
  return obj2 !== null && typeof obj2 == "object";
}
__name(isNonNullObject, "isNonNullObject");
function getOperationName(doc) {
  return doc.definitions.filter(function(definition2) {
    return definition2.kind === "OperationDefinition" && definition2.name;
  }).map(function(x3) {
    return x3.name.value;
  })[0] || null;
}
__name(getOperationName, "getOperationName");
function _createForOfIteratorHelperLoose$9(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$z(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose$9, "_createForOfIteratorHelperLoose$9");
function _unsupportedIterableToArray$z(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$z(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$z(o, minLen);
  }
}
__name(_unsupportedIterableToArray$z, "_unsupportedIterableToArray$z");
function _arrayLikeToArray$z(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$z, "_arrayLikeToArray$z");
function _defineProperties$n(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$n, "_defineProperties$n");
function _createClass$n(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$n(Constructor.prototype, protoProps), staticProps && _defineProperties$n(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$n, "_createClass$n");
var hasSymbols = /* @__PURE__ */ __name(function() {
  return typeof Symbol == "function";
}, "hasSymbols"), hasSymbol = /* @__PURE__ */ __name(function(name2) {
  return hasSymbols() && !!Symbol[name2];
}, "hasSymbol"), getSymbol = /* @__PURE__ */ __name(function(name2) {
  return hasSymbol(name2) ? Symbol[name2] : "@@" + name2;
}, "getSymbol");
hasSymbols() && !hasSymbol("observable") && (Symbol.observable = Symbol("observable"));
var SymbolIterator = getSymbol("iterator"), SymbolObservable = getSymbol("observable"), SymbolSpecies = getSymbol("species");
function getMethod(obj2, key) {
  var value = obj2[key];
  if (value != null) {
    if (typeof value != "function")
      throw new TypeError(value + " is not a function");
    return value;
  }
}
__name(getMethod, "getMethod");
function getSpecies(obj2) {
  var ctor = obj2.constructor;
  return ctor !== void 0 && (ctor = ctor[SymbolSpecies], ctor === null && (ctor = void 0)), ctor !== void 0 ? ctor : Observable;
}
__name(getSpecies, "getSpecies");
function isObservable(x3) {
  return x3 instanceof Observable;
}
__name(isObservable, "isObservable");
function hostReportError(e3) {
  hostReportError.log ? hostReportError.log(e3) : setTimeout(function() {
    throw e3;
  });
}
__name(hostReportError, "hostReportError");
function enqueue(fn) {
  Promise.resolve().then(function() {
    try {
      fn();
    } catch (e3) {
      hostReportError(e3);
    }
  });
}
__name(enqueue, "enqueue");
function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup !== void 0 && (subscription._cleanup = void 0, !!cleanup))
    try {
      if (typeof cleanup == "function")
        cleanup();
      else {
        var unsubscribe = getMethod(cleanup, "unsubscribe");
        unsubscribe && unsubscribe.call(cleanup);
      }
    } catch (e3) {
      hostReportError(e3);
    }
}
__name(cleanupSubscription, "cleanupSubscription");
function closeSubscription(subscription) {
  subscription._observer = void 0, subscription._queue = void 0, subscription._state = "closed";
}
__name(closeSubscription, "closeSubscription");
function flushSubscription(subscription) {
  var queue = subscription._queue;
  if (queue) {
    subscription._queue = void 0, subscription._state = "ready";
    for (var i2 = 0; i2 < queue.length && (notifySubscription(subscription, queue[i2].type, queue[i2].value), subscription._state !== "closed"); ++i2)
      ;
  }
}
__name(flushSubscription, "flushSubscription");
function notifySubscription(subscription, type, value) {
  subscription._state = "running";
  var observer = subscription._observer;
  try {
    var m3 = getMethod(observer, type);
    switch (type) {
      case "next":
        m3 && m3.call(observer, value);
        break;
      case "error":
        if (closeSubscription(subscription), m3)
          m3.call(observer, value);
        else
          throw value;
        break;
      case "complete":
        closeSubscription(subscription), m3 && m3.call(observer);
        break;
    }
  } catch (e3) {
    hostReportError(e3);
  }
  subscription._state === "closed" ? cleanupSubscription(subscription) : subscription._state === "running" && (subscription._state = "ready");
}
__name(notifySubscription, "notifySubscription");
function onNotify(subscription, type, value) {
  if (subscription._state !== "closed") {
    if (subscription._state === "buffering") {
      subscription._queue.push({
        type,
        value
      });
      return;
    }
    if (subscription._state !== "ready") {
      subscription._state = "buffering", subscription._queue = [{
        type,
        value
      }], enqueue(function() {
        return flushSubscription(subscription);
      });
      return;
    }
    notifySubscription(subscription, type, value);
  }
}
__name(onNotify, "onNotify");
var Subscription = /* @__PURE__ */ function() {
  function Subscription2(observer, subscriber) {
    this._cleanup = void 0, this._observer = observer, this._queue = void 0, this._state = "initializing";
    var subscriptionObserver = new SubscriptionObserver(this);
    try {
      this._cleanup = subscriber.call(void 0, subscriptionObserver);
    } catch (e3) {
      subscriptionObserver.error(e3);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  __name(Subscription2, "Subscription");
  var _proto = Subscription2.prototype;
  return _proto.unsubscribe = /* @__PURE__ */ __name(function() {
    this._state !== "closed" && (closeSubscription(this), cleanupSubscription(this));
  }, "unsubscribe"), _createClass$n(Subscription2, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), Subscription2;
}(), SubscriptionObserver = /* @__PURE__ */ function() {
  function SubscriptionObserver2(subscription) {
    this._subscription = subscription;
  }
  __name(SubscriptionObserver2, "SubscriptionObserver");
  var _proto2 = SubscriptionObserver2.prototype;
  return _proto2.next = /* @__PURE__ */ __name(function(value) {
    onNotify(this._subscription, "next", value);
  }, "next"), _proto2.error = /* @__PURE__ */ __name(function(value) {
    onNotify(this._subscription, "error", value);
  }, "error"), _proto2.complete = /* @__PURE__ */ __name(function() {
    onNotify(this._subscription, "complete");
  }, "complete"), _createClass$n(SubscriptionObserver2, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), SubscriptionObserver2;
}(), Observable = /* @__PURE__ */ function() {
  function Observable2(subscriber) {
    if (!(this instanceof Observable2))
      throw new TypeError("Observable cannot be called as a function");
    if (typeof subscriber != "function")
      throw new TypeError("Observable initializer must be a function");
    this._subscriber = subscriber;
  }
  __name(Observable2, "Observable");
  var _proto3 = Observable2.prototype;
  return _proto3.subscribe = /* @__PURE__ */ __name(function(observer) {
    return (typeof observer != "object" || observer === null) && (observer = {
      next: observer,
      error: arguments[1],
      complete: arguments[2]
    }), new Subscription(observer, this._subscriber);
  }, "subscribe"), _proto3.forEach = /* @__PURE__ */ __name(function(fn) {
    var _this = this;
    return new Promise(function(resolve, reject) {
      if (typeof fn != "function") {
        reject(new TypeError(fn + " is not a function"));
        return;
      }
      function done() {
        subscription.unsubscribe(), resolve();
      }
      __name(done, "done");
      var subscription = _this.subscribe({
        next: function(value) {
          try {
            fn(value, done);
          } catch (e3) {
            reject(e3), subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }, "forEach"), _proto3.map = /* @__PURE__ */ __name(function(fn) {
    var _this2 = this;
    if (typeof fn != "function")
      throw new TypeError(fn + " is not a function");
    var C = getSpecies(this);
    return new C(function(observer) {
      return _this2.subscribe({
        next: function(value) {
          try {
            value = fn(value);
          } catch (e3) {
            return observer.error(e3);
          }
          observer.next(value);
        },
        error: function(e3) {
          observer.error(e3);
        },
        complete: function() {
          observer.complete();
        }
      });
    });
  }, "map"), _proto3.filter = /* @__PURE__ */ __name(function(fn) {
    var _this3 = this;
    if (typeof fn != "function")
      throw new TypeError(fn + " is not a function");
    var C = getSpecies(this);
    return new C(function(observer) {
      return _this3.subscribe({
        next: function(value) {
          try {
            if (!fn(value))
              return;
          } catch (e3) {
            return observer.error(e3);
          }
          observer.next(value);
        },
        error: function(e3) {
          observer.error(e3);
        },
        complete: function() {
          observer.complete();
        }
      });
    });
  }, "filter"), _proto3.reduce = /* @__PURE__ */ __name(function(fn) {
    var _this4 = this;
    if (typeof fn != "function")
      throw new TypeError(fn + " is not a function");
    var C = getSpecies(this), hasSeed = arguments.length > 1, hasValue = !1, seed = arguments[1], acc = seed;
    return new C(function(observer) {
      return _this4.subscribe({
        next: function(value) {
          var first = !hasValue;
          if (hasValue = !0, !first || hasSeed)
            try {
              acc = fn(acc, value);
            } catch (e3) {
              return observer.error(e3);
            }
          else
            acc = value;
        },
        error: function(e3) {
          observer.error(e3);
        },
        complete: function() {
          if (!hasValue && !hasSeed)
            return observer.error(new TypeError("Cannot reduce an empty sequence"));
          observer.next(acc), observer.complete();
        }
      });
    });
  }, "reduce"), _proto3.concat = /* @__PURE__ */ __name(function() {
    for (var _this5 = this, _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)
      sources[_key] = arguments[_key];
    var C = getSpecies(this);
    return new C(function(observer) {
      var subscription, index2 = 0;
      function startNext(next) {
        subscription = next.subscribe({
          next: function(v) {
            observer.next(v);
          },
          error: function(e3) {
            observer.error(e3);
          },
          complete: function() {
            index2 === sources.length ? (subscription = void 0, observer.complete()) : startNext(C.from(sources[index2++]));
          }
        });
      }
      return __name(startNext, "startNext"), startNext(_this5), function() {
        subscription && (subscription.unsubscribe(), subscription = void 0);
      };
    });
  }, "concat"), _proto3.flatMap = /* @__PURE__ */ __name(function(fn) {
    var _this6 = this;
    if (typeof fn != "function")
      throw new TypeError(fn + " is not a function");
    var C = getSpecies(this);
    return new C(function(observer) {
      var subscriptions = [], outer = _this6.subscribe({
        next: function(value) {
          if (fn)
            try {
              value = fn(value);
            } catch (e3) {
              return observer.error(e3);
            }
          var inner = C.from(value).subscribe({
            next: function(value2) {
              observer.next(value2);
            },
            error: function(e3) {
              observer.error(e3);
            },
            complete: function() {
              var i2 = subscriptions.indexOf(inner);
              i2 >= 0 && subscriptions.splice(i2, 1), completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function(e3) {
          observer.error(e3);
        },
        complete: function() {
          completeIfDone();
        }
      });
      function completeIfDone() {
        outer.closed && subscriptions.length === 0 && observer.complete();
      }
      return __name(completeIfDone, "completeIfDone"), function() {
        subscriptions.forEach(function(s4) {
          return s4.unsubscribe();
        }), outer.unsubscribe();
      };
    });
  }, "flatMap"), _proto3[SymbolObservable] = function() {
    return this;
  }, Observable2.from = /* @__PURE__ */ __name(function(x3) {
    var C = typeof this == "function" ? this : Observable2;
    if (x3 == null)
      throw new TypeError(x3 + " is not an object");
    var method = getMethod(x3, SymbolObservable);
    if (method) {
      var observable = method.call(x3);
      if (Object(observable) !== observable)
        throw new TypeError(observable + " is not an object");
      return isObservable(observable) && observable.constructor === C ? observable : new C(function(observer) {
        return observable.subscribe(observer);
      });
    }
    if (hasSymbol("iterator") && (method = getMethod(x3, SymbolIterator), method))
      return new C(function(observer) {
        enqueue(function() {
          if (!observer.closed) {
            for (var _iterator = _createForOfIteratorHelperLoose$9(method.call(x3)), _step; !(_step = _iterator()).done; ) {
              var item = _step.value;
              if (observer.next(item), observer.closed)
                return;
            }
            observer.complete();
          }
        });
      });
    if (Array.isArray(x3))
      return new C(function(observer) {
        enqueue(function() {
          if (!observer.closed) {
            for (var i2 = 0; i2 < x3.length; ++i2)
              if (observer.next(x3[i2]), observer.closed)
                return;
            observer.complete();
          }
        });
      });
    throw new TypeError(x3 + " is not observable");
  }, "from"), Observable2.of = /* @__PURE__ */ __name(function() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)
      items[_key2] = arguments[_key2];
    var C = typeof this == "function" ? this : Observable2;
    return new C(function(observer) {
      enqueue(function() {
        if (!observer.closed) {
          for (var i2 = 0; i2 < items.length; ++i2)
            if (observer.next(items[i2]), observer.closed)
              return;
          observer.complete();
        }
      });
    });
  }, "of"), _createClass$n(Observable2, null, [{
    key: SymbolSpecies,
    get: function() {
      return this;
    }
  }]), Observable2;
}();
hasSymbols() && Object.defineProperty(Observable, Symbol("extensions"), {
  value: {
    symbol: SymbolObservable,
    hostReportError
  },
  configurable: !0
});
function symbolObservablePonyfill(root2) {
  var result2, Symbol2 = root2.Symbol;
  if (typeof Symbol2 == "function")
    if (Symbol2.observable)
      result2 = Symbol2.observable;
    else {
      typeof Symbol2.for == "function" ? result2 = Symbol2.for("https://github.com/benlesh/symbol-observable") : result2 = Symbol2("https://github.com/benlesh/symbol-observable");
      try {
        Symbol2.observable = result2;
      } catch {
      }
    }
  else
    result2 = "@@observable";
  return result2;
}
__name(symbolObservablePonyfill, "symbolObservablePonyfill");
var root$e;
typeof self < "u" ? root$e = self : typeof window < "u" ? root$e = window : typeof global < "u" ? root$e = global : typeof module < "u" ? root$e = module : root$e = Function("return this")();
symbolObservablePonyfill(root$e);
var prototype = Observable.prototype, fakeObsSymbol = "@@observable";
prototype[fakeObsSymbol] || (prototype[fakeObsSymbol] = function() {
  return this;
});
function deepFreeze(value) {
  var workSet = /* @__PURE__ */ new Set([value]);
  return workSet.forEach(function(obj2) {
    isNonNullObject(obj2) && shallowFreeze(obj2) === obj2 && Object.getOwnPropertyNames(obj2).forEach(function(name2) {
      isNonNullObject(obj2[name2]) && workSet.add(obj2[name2]);
    });
  }), value;
}
__name(deepFreeze, "deepFreeze");
function shallowFreeze(obj2) {
  if (__DEV__ && !Object.isFrozen(obj2))
    try {
      Object.freeze(obj2);
    } catch (e3) {
      if (e3 instanceof TypeError)
        return null;
      throw e3;
    }
  return obj2;
}
__name(shallowFreeze, "shallowFreeze");
function maybeDeepFreeze(obj2) {
  return __DEV__ && deepFreeze(obj2), obj2;
}
__name(maybeDeepFreeze, "maybeDeepFreeze");
var canUseWeakMap = typeof WeakMap == "function" && maybe$1(function() {
  return navigator.product;
}) !== "ReactNative", canUseWeakSet = typeof WeakSet == "function", canUseSymbol = typeof Symbol == "function" && typeof Symbol.for == "function", canUseDOM = typeof maybe$1(function() {
  return window.document.createElement;
}) == "function", usingJSDOM = maybe$1(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
}) || !1, canUseLayoutEffect = canUseDOM && !usingJSDOM;
function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
}
__name(isNonEmptyArray, "isNonEmptyArray");
function compact() {
  for (var objects2 = [], _i = 0; _i < arguments.length; _i++)
    objects2[_i] = arguments[_i];
  var result2 = /* @__PURE__ */ Object.create(null);
  return objects2.forEach(function(obj2) {
    obj2 && Object.keys(obj2).forEach(function(key) {
      var value = obj2[key];
      value !== void 0 && (result2[key] = value);
    });
  }), result2;
}
__name(compact, "compact");
function mergeOptions(defaults2, options) {
  return compact(defaults2, options, options.variables && {
    variables: __assign(__assign({}, defaults2 && defaults2.variables), options.variables)
  });
}
__name(mergeOptions, "mergeOptions");
function validateOperation(operation) {
  for (var OPERATION_FIELDS = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], _i = 0, _a3 = Object.keys(operation); _i < _a3.length; _i++) {
    var key = _a3[_i];
    if (OPERATION_FIELDS.indexOf(key) < 0)
      throw __DEV__ ? new InvariantError("illegal argument: ".concat(key)) : new InvariantError(24);
  }
  return operation;
}
__name(validateOperation, "validateOperation");
function createOperation(starting, operation) {
  var context = __assign({}, starting), setContext = /* @__PURE__ */ __name(function(next) {
    typeof next == "function" ? context = __assign(__assign({}, context), next(context)) : context = __assign(__assign({}, context), next);
  }, "setContext"), getContext = /* @__PURE__ */ __name(function() {
    return __assign({}, context);
  }, "getContext");
  return Object.defineProperty(operation, "setContext", {
    enumerable: !1,
    value: setContext
  }), Object.defineProperty(operation, "getContext", {
    enumerable: !1,
    value: getContext
  }), operation;
}
__name(createOperation, "createOperation");
function transformOperation(operation) {
  var transformedOperation = {
    variables: operation.variables || {},
    extensions: operation.extensions || {},
    operationName: operation.operationName,
    query: operation.query
  };
  return transformedOperation.operationName || (transformedOperation.operationName = typeof transformedOperation.query != "string" ? getOperationName(transformedOperation.query) || void 0 : ""), transformedOperation;
}
__name(transformOperation, "transformOperation");
function passthrough(op, forward) {
  return forward ? forward(op) : Observable.of();
}
__name(passthrough, "passthrough");
function toLink(handler) {
  return typeof handler == "function" ? new ApolloLink(handler) : handler;
}
__name(toLink, "toLink");
function isTerminating(link2) {
  return link2.request.length <= 1;
}
__name(isTerminating, "isTerminating");
var LinkError = function(_super) {
  __extends(LinkError2, _super);
  function LinkError2(message, link2) {
    var _this = _super.call(this, message) || this;
    return _this.link = link2, _this;
  }
  return __name(LinkError2, "LinkError"), LinkError2;
}(Error), ApolloLink = function() {
  function ApolloLink2(request) {
    request && (this.request = request);
  }
  return __name(ApolloLink2, "ApolloLink"), ApolloLink2.empty = function() {
    return new ApolloLink2(function() {
      return Observable.of();
    });
  }, ApolloLink2.from = function(links) {
    return links.length === 0 ? ApolloLink2.empty() : links.map(toLink).reduce(function(x3, y4) {
      return x3.concat(y4);
    });
  }, ApolloLink2.split = function(test2, left2, right2) {
    var leftLink = toLink(left2), rightLink = toLink(right2 || new ApolloLink2(passthrough));
    return isTerminating(leftLink) && isTerminating(rightLink) ? new ApolloLink2(function(operation) {
      return test2(operation) ? leftLink.request(operation) || Observable.of() : rightLink.request(operation) || Observable.of();
    }) : new ApolloLink2(function(operation, forward) {
      return test2(operation) ? leftLink.request(operation, forward) || Observable.of() : rightLink.request(operation, forward) || Observable.of();
    });
  }, ApolloLink2.execute = function(link2, operation) {
    return link2.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || Observable.of();
  }, ApolloLink2.concat = function(first, second2) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink))
      return __DEV__ && invariant$2.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink)), firstLink;
    var nextLink = toLink(second2);
    return isTerminating(nextLink) ? new ApolloLink2(function(operation) {
      return firstLink.request(operation, function(op) {
        return nextLink.request(op) || Observable.of();
      }) || Observable.of();
    }) : new ApolloLink2(function(operation, forward) {
      return firstLink.request(operation, function(op) {
        return nextLink.request(op, forward) || Observable.of();
      }) || Observable.of();
    });
  }, ApolloLink2.prototype.split = function(test2, left2, right2) {
    return this.concat(ApolloLink2.split(test2, left2, right2 || new ApolloLink2(passthrough)));
  }, ApolloLink2.prototype.concat = function(next) {
    return ApolloLink2.concat(this, next);
  }, ApolloLink2.prototype.request = function(operation, forward) {
    throw __DEV__ ? new InvariantError("request is not implemented") : new InvariantError(19);
  }, ApolloLink2.prototype.onError = function(error, observer) {
    if (observer && observer.error)
      return observer.error(error), !1;
    throw error;
  }, ApolloLink2.prototype.setOnError = function(fn) {
    return this.onError = fn, this;
  }, ApolloLink2;
}();
const { toString: toString$7, hasOwnProperty: hasOwnProperty$q } = Object.prototype, fnToStr = Function.prototype.toString, previousComparisons = /* @__PURE__ */ new Map();
function equal(a4, b2) {
  try {
    return check(a4, b2);
  } finally {
    previousComparisons.clear();
  }
}
__name(equal, "equal");
function check(a4, b2) {
  if (a4 === b2)
    return !0;
  const aTag = toString$7.call(a4), bTag = toString$7.call(b2);
  if (aTag !== bTag)
    return !1;
  switch (aTag) {
    case "[object Array]":
      if (a4.length !== b2.length)
        return !1;
    case "[object Object]": {
      if (previouslyCompared(a4, b2))
        return !0;
      const aKeys = definedKeys(a4), bKeys = definedKeys(b2), keyCount = aKeys.length;
      if (keyCount !== bKeys.length)
        return !1;
      for (let k3 = 0; k3 < keyCount; ++k3)
        if (!hasOwnProperty$q.call(b2, aKeys[k3]))
          return !1;
      for (let k3 = 0; k3 < keyCount; ++k3) {
        const key = aKeys[k3];
        if (!check(a4[key], b2[key]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return a4.name === b2.name && a4.message === b2.message;
    case "[object Number]":
      if (a4 !== a4)
        return b2 !== b2;
    case "[object Boolean]":
    case "[object Date]":
      return +a4 == +b2;
    case "[object RegExp]":
    case "[object String]":
      return a4 == `${b2}`;
    case "[object Map]":
    case "[object Set]": {
      if (a4.size !== b2.size)
        return !1;
      if (previouslyCompared(a4, b2))
        return !0;
      const aIterator = a4.entries(), isMap2 = aTag === "[object Map]";
      for (; ; ) {
        const info = aIterator.next();
        if (info.done)
          break;
        const [aKey, aValue] = info.value;
        if (!b2.has(aKey) || isMap2 && !check(aValue, b2.get(aKey)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      a4 = new Uint8Array(a4), b2 = new Uint8Array(b2);
    case "[object DataView]": {
      let len = a4.byteLength;
      if (len === b2.byteLength)
        for (; len-- && a4[len] === b2[len]; )
          ;
      return len === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const aCode = fnToStr.call(a4);
      return aCode !== fnToStr.call(b2) ? !1 : !endsWith(aCode, nativeCodeSuffix);
    }
  }
  return !1;
}
__name(check, "check");
function definedKeys(obj2) {
  return Object.keys(obj2).filter(isDefinedKey, obj2);
}
__name(definedKeys, "definedKeys");
function isDefinedKey(key) {
  return this[key] !== void 0;
}
__name(isDefinedKey, "isDefinedKey");
const nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
  const fromIndex = full.length - suffix.length;
  return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
__name(endsWith, "endsWith");
function previouslyCompared(a4, b2) {
  let bSet = previousComparisons.get(a4);
  if (bSet) {
    if (bSet.has(b2))
      return !0;
  } else
    previousComparisons.set(a4, bSet = /* @__PURE__ */ new Set());
  return bSet.add(b2), !1;
}
__name(previouslyCompared, "previouslyCompared");
function isApolloError(err) {
  return err.hasOwnProperty("graphQLErrors");
}
__name(isApolloError, "isApolloError");
var generateErrorMessage = /* @__PURE__ */ __name(function(err) {
  var message = "";
  if (isNonEmptyArray(err.graphQLErrors) || isNonEmptyArray(err.clientErrors)) {
    var errors = (err.graphQLErrors || []).concat(err.clientErrors || []);
    errors.forEach(function(error) {
      var errorMessage = error ? error.message : "Error message not found.";
      message += "".concat(errorMessage, `
`);
    });
  }
  return err.networkError && (message += "".concat(err.networkError.message, `
`)), message = message.replace(/\n$/, ""), message;
}, "generateErrorMessage"), ApolloError = function(_super) {
  __extends(ApolloError2, _super);
  function ApolloError2(_a3) {
    var graphQLErrors = _a3.graphQLErrors, clientErrors = _a3.clientErrors, networkError = _a3.networkError, errorMessage = _a3.errorMessage, extraInfo = _a3.extraInfo, _this = _super.call(this, errorMessage) || this;
    return _this.graphQLErrors = graphQLErrors || [], _this.clientErrors = clientErrors || [], _this.networkError = networkError || null, _this.message = errorMessage || generateErrorMessage(_this), _this.extraInfo = extraInfo, _this.__proto__ = ApolloError2.prototype, _this;
  }
  return __name(ApolloError2, "ApolloError"), ApolloError2;
}(Error), NetworkStatus;
(function(NetworkStatus2) {
  NetworkStatus2[NetworkStatus2.loading = 1] = "loading", NetworkStatus2[NetworkStatus2.setVariables = 2] = "setVariables", NetworkStatus2[NetworkStatus2.fetchMore = 3] = "fetchMore", NetworkStatus2[NetworkStatus2.refetch = 4] = "refetch", NetworkStatus2[NetworkStatus2.poll = 6] = "poll", NetworkStatus2[NetworkStatus2.ready = 7] = "ready", NetworkStatus2[NetworkStatus2.error = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
var contextKey = canUseSymbol ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function getApolloContext() {
  var context = React.createContext[contextKey];
  return context || (Object.defineProperty(React.createContext, contextKey, {
    value: context = React.createContext({}),
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), context.displayName = "ApolloContext"), context;
}
__name(getApolloContext, "getApolloContext");
function useApolloClient(override) {
  var context = useContext(getApolloContext()), client = override || context.client;
  return __DEV__ ? invariant$2(!!client, 'Could not find "client" in the context or passed in as an option. Wrap the root component in an <ApolloProvider>, or pass an ApolloClient instance in via options.') : invariant$2(!!client, 29), client;
}
__name(useApolloClient, "useApolloClient");
var didWarnUncachedGetSnapshot = !1, uSESKey = "useSyncExternalStore", realHook = React[uSESKey], useSyncExternalStore = realHook || function(subscribe, getSnapshot, getServerSnapshot) {
  var value = getSnapshot();
  __DEV__ && !didWarnUncachedGetSnapshot && value !== getSnapshot() && (didWarnUncachedGetSnapshot = !0, __DEV__ && invariant$2.error("The result of getSnapshot should be cached to avoid an infinite loop"));
  var _a3 = React.useState({ inst: { value, getSnapshot } }), inst = _a3[0].inst, forceUpdate = _a3[1];
  return canUseLayoutEffect ? React.useLayoutEffect(function() {
    Object.assign(inst, { value, getSnapshot }), checkIfSnapshotChanged(inst) && forceUpdate({ inst });
  }, [subscribe, value, getSnapshot]) : Object.assign(inst, { value, getSnapshot }), React.useEffect(function() {
    return checkIfSnapshotChanged(inst) && forceUpdate({ inst }), subscribe(/* @__PURE__ */ __name(function() {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst });
    }, "handleStoreChange"));
  }, [subscribe]), value;
};
function checkIfSnapshotChanged(_a3) {
  var value = _a3.value, getSnapshot = _a3.getSnapshot;
  try {
    return value !== getSnapshot();
  } catch {
    return !0;
  }
}
__name(checkIfSnapshotChanged, "checkIfSnapshotChanged");
var DocumentType;
(function(DocumentType2) {
  DocumentType2[DocumentType2.Query = 0] = "Query", DocumentType2[DocumentType2.Mutation = 1] = "Mutation", DocumentType2[DocumentType2.Subscription = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache$1 = /* @__PURE__ */ new Map();
function operationName(type) {
  var name2;
  switch (type) {
    case DocumentType.Query:
      name2 = "Query";
      break;
    case DocumentType.Mutation:
      name2 = "Mutation";
      break;
    case DocumentType.Subscription:
      name2 = "Subscription";
      break;
  }
  return name2;
}
__name(operationName, "operationName");
function parser(document2) {
  var cached = cache$1.get(document2);
  if (cached)
    return cached;
  var variables, type, name2;
  __DEV__ ? invariant$2(!!document2 && !!document2.kind, "Argument of ".concat(document2, " passed to parser was not a valid GraphQL ") + "DocumentNode. You may need to use 'graphql-tag' or another method to convert your operation into a document") : invariant$2(!!document2 && !!document2.kind, 30);
  for (var fragments = [], queries = [], mutations = [], subscriptions = [], _i = 0, _a3 = document2.definitions; _i < _a3.length; _i++) {
    var x3 = _a3[_i];
    if (x3.kind === "FragmentDefinition") {
      fragments.push(x3);
      continue;
    }
    if (x3.kind === "OperationDefinition")
      switch (x3.operation) {
        case "query":
          queries.push(x3);
          break;
        case "mutation":
          mutations.push(x3);
          break;
        case "subscription":
          subscriptions.push(x3);
          break;
      }
  }
  __DEV__ ? invariant$2(!fragments.length || queries.length || mutations.length || subscriptions.length, "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well") : invariant$2(!fragments.length || queries.length || mutations.length || subscriptions.length, 31), __DEV__ ? invariant$2(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " + "".concat(document2, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") + "subscriptions and ".concat(mutations.length, " mutations. ") + "You can use 'compose' to join multiple operation types to a component") : invariant$2(queries.length + mutations.length + subscriptions.length <= 1, 32), type = queries.length ? DocumentType.Query : DocumentType.Mutation, !queries.length && !mutations.length && (type = DocumentType.Subscription);
  var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
  __DEV__ ? invariant$2(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document2, " had ") + "".concat(definitions.length, " definitions. ") + "You can use 'compose' to join multiple operation types to a component") : invariant$2(definitions.length === 1, 33);
  var definition2 = definitions[0];
  variables = definition2.variableDefinitions || [], definition2.name && definition2.name.kind === "Name" ? name2 = definition2.name.value : name2 = "data";
  var payload = { name: name2, type, variables };
  return cache$1.set(document2, payload), payload;
}
__name(parser, "parser");
function verifyDocumentType(document2, type) {
  var operation = parser(document2), requiredOperationName = operationName(type), usedOperationName = operationName(operation.type);
  __DEV__ ? invariant$2(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") + "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : invariant$2(operation.type === type, 34);
}
__name(verifyDocumentType, "verifyDocumentType");
var hasOwnProperty$p = Object.prototype.hasOwnProperty;
function useQuery(query, options) {
  return options === void 0 && (options = /* @__PURE__ */ Object.create(null)), useInternalState(useApolloClient(options.client), query).useQuery(options);
}
__name(useQuery, "useQuery");
function useInternalState(client, query) {
  var stateRef = useRef();
  (!stateRef.current || client !== stateRef.current.client || query !== stateRef.current.query) && (stateRef.current = new InternalState(client, query, stateRef.current));
  var state = stateRef.current, _a3 = useState(0);
  _a3[0];
  var setTick = _a3[1];
  return state.forceUpdate = function() {
    setTick(function(tick) {
      return tick + 1;
    });
  }, state;
}
__name(useInternalState, "useInternalState");
var InternalState = function() {
  function InternalState2(client, query, previous2) {
    this.client = client, this.query = query, this.asyncResolveFns = /* @__PURE__ */ new Set(), this.optionsToIgnoreOnce = new (canUseWeakSet ? WeakSet : Set)(), this.ssrDisabledResult = maybeDeepFreeze({
      loading: !0,
      data: void 0,
      error: void 0,
      networkStatus: NetworkStatus.loading
    }), this.skipStandbyResult = maybeDeepFreeze({
      loading: !1,
      data: void 0,
      error: void 0,
      networkStatus: NetworkStatus.ready
    }), this.toQueryResultCache = new (canUseWeakMap ? WeakMap : Map)(), verifyDocumentType(query, DocumentType.Query);
    var previousResult = previous2 && previous2.result, previousData = previousResult && previousResult.data;
    previousData && (this.previousData = previousData);
  }
  return __name(InternalState2, "InternalState"), InternalState2.prototype.forceUpdate = function() {
    __DEV__ && invariant$2.warn("Calling default no-op implementation of InternalState#forceUpdate");
  }, InternalState2.prototype.asyncUpdate = function() {
    var _this = this;
    return new Promise(function(resolve) {
      _this.asyncResolveFns.add(resolve), _this.optionsToIgnoreOnce.add(_this.watchQueryOptions), _this.forceUpdate();
    });
  }, InternalState2.prototype.useQuery = function(options) {
    var _this = this;
    this.renderPromises = useContext(getApolloContext()).renderPromises, this.useOptions(options);
    var obsQuery = this.useObservableQuery(), result2 = useSyncExternalStore(useCallback(function() {
      if (_this.renderPromises)
        return function() {
        };
      var onNext = /* @__PURE__ */ __name(function() {
        var previousResult = _this.result, result3 = obsQuery.getCurrentResult();
        previousResult && previousResult.loading === result3.loading && previousResult.networkStatus === result3.networkStatus && equal(previousResult.data, result3.data) || _this.setResult(result3);
      }, "onNext"), onError = /* @__PURE__ */ __name(function(error) {
        var last2 = obsQuery.last;
        subscription.unsubscribe();
        try {
          obsQuery.resetLastResults(), subscription = obsQuery.subscribe(onNext, onError);
        } finally {
          obsQuery.last = last2;
        }
        if (!hasOwnProperty$p.call(error, "graphQLErrors"))
          throw error;
        var previousResult = _this.result;
        (!previousResult || previousResult && previousResult.loading || !equal(error, previousResult.error)) && _this.setResult({
          data: previousResult && previousResult.data,
          error,
          loading: !1,
          networkStatus: NetworkStatus.error
        });
      }, "onError"), subscription = obsQuery.subscribe(onNext, onError);
      return function() {
        return subscription.unsubscribe();
      };
    }, [
      obsQuery,
      this.renderPromises,
      this.client.disableNetworkFetches
    ]), function() {
      return _this.getCurrentResult();
    }, function() {
      return _this.getCurrentResult();
    });
    this.unsafeHandlePartialRefetch(result2);
    var queryResult = this.toQueryResult(result2);
    return !queryResult.loading && this.asyncResolveFns.size && (this.asyncResolveFns.forEach(function(resolve) {
      return resolve(queryResult);
    }), this.asyncResolveFns.clear()), queryResult;
  }, InternalState2.prototype.useOptions = function(options) {
    var _a3, watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options), currentWatchQueryOptions = this.watchQueryOptions;
    (this.optionsToIgnoreOnce.has(currentWatchQueryOptions) || !equal(watchQueryOptions, currentWatchQueryOptions)) && (this.watchQueryOptions = watchQueryOptions, currentWatchQueryOptions && this.observable && (this.optionsToIgnoreOnce.delete(currentWatchQueryOptions), this.observable.reobserve(this.getObsQueryOptions()), this.previousData = ((_a3 = this.result) === null || _a3 === void 0 ? void 0 : _a3.data) || this.previousData, this.result = void 0)), this.onCompleted = options.onCompleted || InternalState2.prototype.onCompleted, this.onError = options.onError || InternalState2.prototype.onError, (this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === !1 && !this.queryHookOptions.skip ? this.result = this.ssrDisabledResult : this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby" ? this.result = this.skipStandbyResult : (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) && (this.result = void 0);
  }, InternalState2.prototype.getObsQueryOptions = function() {
    var toMerge = [], globalDefaults = this.client.defaultOptions.watchQuery;
    return globalDefaults && toMerge.push(globalDefaults), this.queryHookOptions.defaultOptions && toMerge.push(this.queryHookOptions.defaultOptions), toMerge.push(compact(this.observable && this.observable.options, this.watchQueryOptions)), toMerge.reduce(mergeOptions);
  }, InternalState2.prototype.createWatchQueryOptions = function(_a3) {
    var _b;
    _a3 === void 0 && (_a3 = {});
    var skip = _a3.skip;
    _a3.ssr, _a3.onCompleted, _a3.onError, _a3.displayName, _a3.defaultOptions;
    var otherOptions = __rest(_a3, ["skip", "ssr", "onCompleted", "onError", "displayName", "defaultOptions"]), watchQueryOptions = Object.assign(otherOptions, { query: this.query });
    if (this.renderPromises && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network") && (watchQueryOptions.fetchPolicy = "cache-first"), watchQueryOptions.variables || (watchQueryOptions.variables = {}), skip) {
      var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
      Object.assign(watchQueryOptions, {
        initialFetchPolicy,
        fetchPolicy: "standby"
      });
    } else
      watchQueryOptions.fetchPolicy || (watchQueryOptions.fetchPolicy = ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) || this.getDefaultFetchPolicy());
    return watchQueryOptions;
  }, InternalState2.prototype.getDefaultFetchPolicy = function() {
    var _a3, _b;
    return ((_a3 = this.queryHookOptions.defaultOptions) === null || _a3 === void 0 ? void 0 : _a3.fetchPolicy) || ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "cache-first";
  }, InternalState2.prototype.onCompleted = function(data2) {
  }, InternalState2.prototype.onError = function(error) {
  }, InternalState2.prototype.useObservableQuery = function() {
    var obsQuery = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || this.client.watchQuery(this.getObsQueryOptions());
    this.obsQueryFields = useMemo(function() {
      return {
        refetch: obsQuery.refetch.bind(obsQuery),
        reobserve: obsQuery.reobserve.bind(obsQuery),
        fetchMore: obsQuery.fetchMore.bind(obsQuery),
        updateQuery: obsQuery.updateQuery.bind(obsQuery),
        startPolling: obsQuery.startPolling.bind(obsQuery),
        stopPolling: obsQuery.stopPolling.bind(obsQuery),
        subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
      };
    }, [obsQuery]);
    var ssrAllowed = !(this.queryHookOptions.ssr === !1 || this.queryHookOptions.skip);
    return this.renderPromises && ssrAllowed && (this.renderPromises.registerSSRObservable(obsQuery), obsQuery.getCurrentResult().loading && this.renderPromises.addObservableQueryPromise(obsQuery)), obsQuery;
  }, InternalState2.prototype.setResult = function(nextResult) {
    var previousResult = this.result;
    previousResult && previousResult.data && (this.previousData = previousResult.data), this.result = nextResult, this.forceUpdate(), this.handleErrorOrCompleted(nextResult);
  }, InternalState2.prototype.handleErrorOrCompleted = function(result2) {
    result2.loading || (result2.error ? this.onError(result2.error) : result2.data && this.onCompleted(result2.data));
  }, InternalState2.prototype.getCurrentResult = function() {
    return this.result || this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult()), this.result;
  }, InternalState2.prototype.toQueryResult = function(result2) {
    var queryResult = this.toQueryResultCache.get(result2);
    if (queryResult)
      return queryResult;
    var data2 = result2.data;
    result2.partial;
    var resultWithoutPartial = __rest(result2, ["data", "partial"]);
    return this.toQueryResultCache.set(result2, queryResult = __assign(__assign(__assign({ data: data2 }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData })), !queryResult.error && isNonEmptyArray(result2.errors) && (queryResult.error = new ApolloError({ graphQLErrors: result2.errors })), queryResult;
  }, InternalState2.prototype.unsafeHandlePartialRefetch = function(result2) {
    result2.partial && this.queryHookOptions.partialRefetch && !result2.loading && (!result2.data || Object.keys(result2.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only" && (Object.assign(result2, {
      loading: !0,
      networkStatus: NetworkStatus.refetch
    }), this.observable.refetch());
  }, InternalState2;
}(), EAGER_METHODS = [
  "refetch",
  "reobserve",
  "fetchMore",
  "updateQuery",
  "startPolling",
  "subscribeToMore"
];
function useLazyQuery(query, options) {
  var internalState = useInternalState(useApolloClient(options && options.client), query), execOptionsRef = useRef(), merged = execOptionsRef.current ? mergeOptions(options, execOptionsRef.current) : options, useQueryResult = internalState.useQuery(__assign(__assign({}, merged), { skip: !execOptionsRef.current })), initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy || internalState.getDefaultFetchPolicy(), result2 = Object.assign(useQueryResult, {
    called: !!execOptionsRef.current
  }), eagerMethods = useMemo(function() {
    for (var eagerMethods2 = {}, _loop_1 = /* @__PURE__ */ __name(function(key2) {
      var method = result2[key2];
      eagerMethods2[key2] = function() {
        return execOptionsRef.current || (execOptionsRef.current = /* @__PURE__ */ Object.create(null), internalState.forceUpdate()), method.apply(this, arguments);
      };
    }, "_loop_1"), _i = 0, EAGER_METHODS_1 = EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++) {
      var key = EAGER_METHODS_1[_i];
      _loop_1(key);
    }
    return eagerMethods2;
  }, []);
  Object.assign(result2, eagerMethods);
  var execute = useCallback(function(executeOptions) {
    execOptionsRef.current = executeOptions ? __assign(__assign({}, executeOptions), { fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy }) : {
      fetchPolicy: initialFetchPolicy
    };
    var promise = internalState.asyncUpdate().then(function(queryResult) {
      return Object.assign(queryResult, eagerMethods);
    });
    return promise.catch(function() {
    }), promise;
  }, []);
  return [execute, result2];
}
__name(useLazyQuery, "useLazyQuery");
function useMutation(mutation, options) {
  var client = useApolloClient(options == null ? void 0 : options.client);
  verifyDocumentType(mutation, DocumentType.Mutation);
  var _a3 = useState({
    called: !1,
    loading: !1,
    client
  }), result2 = _a3[0], setResult = _a3[1], ref = useRef({
    result: result2,
    mutationId: 0,
    isMounted: !0,
    client,
    mutation,
    options
  });
  Object.assign(ref.current, { client, options, mutation });
  var execute = useCallback(function(executeOptions) {
    executeOptions === void 0 && (executeOptions = {});
    var _a4 = ref.current, client2 = _a4.client, options2 = _a4.options, mutation2 = _a4.mutation, baseOptions = __assign(__assign({}, options2), { mutation: mutation2 });
    !ref.current.result.loading && !baseOptions.ignoreResults && setResult(ref.current.result = {
      loading: !0,
      error: void 0,
      data: void 0,
      called: !0,
      client: client2
    });
    var mutationId = ++ref.current.mutationId, clientOptions = mergeOptions(baseOptions, executeOptions);
    return client2.mutate(clientOptions).then(function(response) {
      var _a5, _b, _c, data2 = response.data, errors = response.errors, error = errors && errors.length > 0 ? new ApolloError({ graphQLErrors: errors }) : void 0;
      if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
        var result_1 = {
          called: !0,
          loading: !1,
          data: data2,
          error,
          client: client2
        };
        ref.current.isMounted && !equal(ref.current.result, result_1) && setResult(ref.current.result = result_1);
      }
      return (_b = (_a5 = ref.current.options) === null || _a5 === void 0 ? void 0 : _a5.onCompleted) === null || _b === void 0 || _b.call(_a5, response.data), (_c = executeOptions.onCompleted) === null || _c === void 0 || _c.call(executeOptions, response.data), response;
    }).catch(function(error) {
      var _a5, _b, _c, _d;
      if (mutationId === ref.current.mutationId && ref.current.isMounted) {
        var result_2 = {
          loading: !1,
          error,
          data: void 0,
          called: !0,
          client: client2
        };
        equal(ref.current.result, result_2) || setResult(ref.current.result = result_2);
      }
      if (!((_a5 = ref.current.options) === null || _a5 === void 0) && _a5.onError || clientOptions.onError)
        return (_c = (_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onError) === null || _c === void 0 || _c.call(_b, error), (_d = executeOptions.onError) === null || _d === void 0 || _d.call(executeOptions, error), { data: void 0, errors: error };
      throw error;
    });
  }, []), reset = useCallback(function() {
    setResult({ called: !1, loading: !1, client });
  }, []);
  return useEffect(function() {
    return ref.current.isMounted = !0, function() {
      ref.current.isMounted = !1;
    };
  }, []), [execute, __assign({ reset }, result2)];
}
__name(useMutation, "useMutation");
var LOGGING_STATUS = /* @__PURE__ */ ((LOGGING_STATUS2) => (LOGGING_STATUS2.SUCCESS = "SUCCESS", LOGGING_STATUS2.FAILED = "FAILED", LOGGING_STATUS2.INITIATED = "INITIATED", LOGGING_STATUS2))(LOGGING_STATUS || {});
const createApolloLog = /* @__PURE__ */ __name((logger, operation, status, data2) => {
  const { operationName: operationName2, query, variables } = operation, message = `${query.definitions[0].operation} | ${status} | ${operationName2} `;
  status === LOGGING_STATUS.FAILED ? logger.error(message, { operationName: operationName2, variables, error: data2 }) : logger.info(message, { operationName: operationName2, variables });
}, "createApolloLog"), loggingLink = /* @__PURE__ */ __name((logger) => new ApolloLink(
  (operation, forward) => new Observable((observer) => {
    const sub = forward(operation).subscribe({
      next: (result2) => {
        createApolloLog(logger, operation, LOGGING_STATUS.SUCCESS, result2), observer.next(result2);
      },
      error: (networkError) => {
        createApolloLog(
          logger,
          operation,
          LOGGING_STATUS.FAILED,
          networkError
        ), observer.error(networkError);
      },
      complete: () => {
        observer.complete();
      }
    });
    return () => {
      sub.unsubscribe();
    };
  })
), "loggingLink");
var AUTH_STRATEGY = /* @__PURE__ */ ((AUTH_STRATEGY2) => (AUTH_STRATEGY2.PASSWORD = "password", AUTH_STRATEGY2.GOOGLE = "google", AUTH_STRATEGY2.SAML = "saml", AUTH_STRATEGY2))(AUTH_STRATEGY || {}), IDENTITY_PROVIDERS = /* @__PURE__ */ ((IDENTITY_PROVIDERS2) => (IDENTITY_PROVIDERS2.OKTA = "Okta", IDENTITY_PROVIDERS2.MS_AZURE_AD = "Microsoft Entra ID", IDENTITY_PROVIDERS2.OAUTH = "OAuth", IDENTITY_PROVIDERS2.PIDC = "PIDC", IDENTITY_PROVIDERS2.JUMP_CLOUD = "JumpCloud", IDENTITY_PROVIDERS2.ONE_LOGIN = "OneLogin", IDENTITY_PROVIDERS2.GOOGLE_WORKSPACE = "Google Workspace", IDENTITY_PROVIDERS2))(IDENTITY_PROVIDERS || {}), platform$1 = { exports: {} };
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
platform$1.exports;
(function(module2, exports2) {
  (function() {
    var objectTypes = {
      function: !0,
      object: !0
    }, root2 = objectTypes[typeof window] && window || this, freeExports2 = exports2, freeModule2 = module2 && !module2.nodeType && module2, freeGlobal2 = freeExports2 && freeModule2 && typeof commonjsGlobal == "object" && commonjsGlobal;
    freeGlobal2 && (freeGlobal2.global === freeGlobal2 || freeGlobal2.window === freeGlobal2 || freeGlobal2.self === freeGlobal2) && (root2 = freeGlobal2);
    var maxSafeInteger = Math.pow(2, 53) - 1, reOpera = /\bOpera/, objectProto2 = Object.prototype, hasOwnProperty2 = objectProto2.hasOwnProperty, toString2 = objectProto2.toString;
    function capitalize2(string2) {
      return string2 = String(string2), string2.charAt(0).toUpperCase() + string2.slice(1);
    }
    __name(capitalize2, "capitalize");
    function cleanupOS(os, pattern, label) {
      var data2 = {
        "10.0": "10",
        "6.4": "10 Technical Preview",
        "6.3": "8.1",
        "6.2": "8",
        "6.1": "Server 2008 R2 / 7",
        "6.0": "Server 2008 / Vista",
        "5.2": "Server 2003 / XP 64-bit",
        "5.1": "XP",
        "5.01": "2000 SP1",
        "5.0": "2000",
        "4.0": "NT",
        "4.90": "ME"
      };
      return pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data2 = data2[/[\d.]+$/.exec(os)]) && (os = "Windows " + data2), os = String(os), pattern && label && (os = os.replace(RegExp(pattern, "i"), label)), os = format2(
        os.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]
      ), os;
    }
    __name(cleanupOS, "cleanupOS");
    function each(object2, callback) {
      var index2 = -1, length = object2 ? object2.length : 0;
      if (typeof length == "number" && length > -1 && length <= maxSafeInteger)
        for (; ++index2 < length; )
          callback(object2[index2], index2, object2);
      else
        forOwn(object2, callback);
    }
    __name(each, "each");
    function format2(string2) {
      return string2 = trim2(string2), /^(?:webOS|i(?:OS|P))/.test(string2) ? string2 : capitalize2(string2);
    }
    __name(format2, "format");
    function forOwn(object2, callback) {
      for (var key in object2)
        hasOwnProperty2.call(object2, key) && callback(object2[key], key, object2);
    }
    __name(forOwn, "forOwn");
    function getClassOf(value) {
      return value == null ? capitalize2(value) : toString2.call(value).slice(8, -1);
    }
    __name(getClassOf, "getClassOf");
    function isHostType(object2, property2) {
      var type = object2 != null ? typeof object2[property2] : "number";
      return !/^(?:boolean|number|string|undefined)$/.test(type) && (type == "object" ? !!object2[property2] : !0);
    }
    __name(isHostType, "isHostType");
    function qualify(string2) {
      return String(string2).replace(/([ -])(?!$)/g, "$1?");
    }
    __name(qualify, "qualify");
    function reduce(array2, callback) {
      var accumulator = null;
      return each(array2, function(value, index2) {
        accumulator = callback(accumulator, value, index2, array2);
      }), accumulator;
    }
    __name(reduce, "reduce");
    function trim2(string2) {
      return String(string2).replace(/^ +| +$/g, "");
    }
    __name(trim2, "trim");
    function parse2(ua) {
      var context = root2, isCustomContext = ua && typeof ua == "object" && getClassOf(ua) != "String";
      isCustomContext && (context = ua, ua = null);
      var nav = context.navigator || {}, userAgent = nav.userAgent || "";
      ua || (ua = userAgent);
      var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString2.toString()), objectClass = "Object", airRuntimeClass = isCustomContext ? objectClass : "ScriptBridgingProxyObject", enviroClass = isCustomContext ? objectClass : "Environment", javaClass = isCustomContext && context.java ? "JavaPackage" : getClassOf(context.java), phantomClass = isCustomContext ? objectClass : "RuntimeObject", java = /\bJava/.test(javaClass) && context.java, rhino = java && getClassOf(context.environment) == enviroClass, alpha3 = java ? "a" : "α", beta = java ? "b" : "β", doc = context.document || {}, opera = context.operamini || context.opera, operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera["[[Class]]"] : getClassOf(opera)) ? operaClass : opera = null, data2, arch = ua, description = [], prerelease = null, useFeatures = ua == userAgent, version2 = useFeatures && opera && typeof opera.version == "function" && opera.version(), isSpecialCasedOS, layout2 = getLayout([
        { label: "EdgeHTML", pattern: "Edge" },
        "Trident",
        { label: "WebKit", pattern: "AppleWebKit" },
        "iCab",
        "Presto",
        "NetFront",
        "Tasman",
        "KHTML",
        "Gecko"
      ]), name2 = getName([
        "Adobe AIR",
        "Arora",
        "Avant Browser",
        "Breach",
        "Camino",
        "Electron",
        "Epiphany",
        "Fennec",
        "Flock",
        "Galeon",
        "GreenBrowser",
        "iCab",
        "Iceweasel",
        "K-Meleon",
        "Konqueror",
        "Lunascape",
        "Maxthon",
        { label: "Microsoft Edge", pattern: "(?:Edge|Edg|EdgA|EdgiOS)" },
        "Midori",
        "Nook Browser",
        "PaleMoon",
        "PhantomJS",
        "Raven",
        "Rekonq",
        "RockMelt",
        { label: "Samsung Internet", pattern: "SamsungBrowser" },
        "SeaMonkey",
        { label: "Silk", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Sleipnir",
        "SlimBrowser",
        { label: "SRWare Iron", pattern: "Iron" },
        "Sunrise",
        "Swiftfox",
        "Vivaldi",
        "Waterfox",
        "WebPositive",
        { label: "Yandex Browser", pattern: "YaBrowser" },
        { label: "UC Browser", pattern: "UCBrowser" },
        "Opera Mini",
        { label: "Opera Mini", pattern: "OPiOS" },
        "Opera",
        { label: "Opera", pattern: "OPR" },
        "Chromium",
        "Chrome",
        { label: "Chrome", pattern: "(?:HeadlessChrome)" },
        { label: "Chrome Mobile", pattern: "(?:CriOS|CrMo)" },
        { label: "Firefox", pattern: "(?:Firefox|Minefield)" },
        { label: "Firefox for iOS", pattern: "FxiOS" },
        { label: "IE", pattern: "IEMobile" },
        { label: "IE", pattern: "MSIE" },
        "Safari"
      ]), product = getProduct([
        { label: "BlackBerry", pattern: "BB10" },
        "BlackBerry",
        { label: "Galaxy S", pattern: "GT-I9000" },
        { label: "Galaxy S2", pattern: "GT-I9100" },
        { label: "Galaxy S3", pattern: "GT-I9300" },
        { label: "Galaxy S4", pattern: "GT-I9500" },
        { label: "Galaxy S5", pattern: "SM-G900" },
        { label: "Galaxy S6", pattern: "SM-G920" },
        { label: "Galaxy S6 Edge", pattern: "SM-G925" },
        { label: "Galaxy S7", pattern: "SM-G930" },
        { label: "Galaxy S7 Edge", pattern: "SM-G935" },
        "Google TV",
        "Lumia",
        "iPad",
        "iPod",
        "iPhone",
        "Kindle",
        { label: "Kindle Fire", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Nexus",
        "Nook",
        "PlayBook",
        "PlayStation Vita",
        "PlayStation",
        "TouchPad",
        "Transformer",
        { label: "Wii U", pattern: "WiiU" },
        "Wii",
        "Xbox One",
        { label: "Xbox 360", pattern: "Xbox" },
        "Xoom"
      ]), manufacturer = getManufacturer({
        Apple: { iPad: 1, iPhone: 1, iPod: 1 },
        Alcatel: {},
        Archos: {},
        Amazon: { Kindle: 1, "Kindle Fire": 1 },
        Asus: { Transformer: 1 },
        "Barnes & Noble": { Nook: 1 },
        BlackBerry: { PlayBook: 1 },
        Google: { "Google TV": 1, Nexus: 1 },
        HP: { TouchPad: 1 },
        HTC: {},
        Huawei: {},
        Lenovo: {},
        LG: {},
        Microsoft: { Xbox: 1, "Xbox One": 1 },
        Motorola: { Xoom: 1 },
        Nintendo: { "Wii U": 1, Wii: 1 },
        Nokia: { Lumia: 1 },
        Oppo: {},
        Samsung: { "Galaxy S": 1, "Galaxy S2": 1, "Galaxy S3": 1, "Galaxy S4": 1 },
        Sony: { PlayStation: 1, "PlayStation Vita": 1 },
        Xiaomi: { Mi: 1, Redmi: 1 }
      }), os = getOS([
        "Windows Phone",
        "KaiOS",
        "Android",
        "CentOS",
        { label: "Chrome OS", pattern: "CrOS" },
        "Debian",
        { label: "DragonFly BSD", pattern: "DragonFly" },
        "Fedora",
        "FreeBSD",
        "Gentoo",
        "Haiku",
        "Kubuntu",
        "Linux Mint",
        "OpenBSD",
        "Red Hat",
        "SuSE",
        "Ubuntu",
        "Xubuntu",
        "Cygwin",
        "Symbian OS",
        "hpwOS",
        "webOS ",
        "webOS",
        "Tablet OS",
        "Tizen",
        "Linux",
        "Mac OS X",
        "Macintosh",
        "Mac",
        "Windows 98;",
        "Windows "
      ]);
      function getLayout(guesses) {
        return reduce(guesses, function(result2, guess) {
          return result2 || RegExp("\\b" + (guess.pattern || qualify(guess)) + "\\b", "i").exec(ua) && (guess.label || guess);
        });
      }
      __name(getLayout, "getLayout");
      function getManufacturer(guesses) {
        return reduce(guesses, function(result2, value, key) {
          return result2 || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp("\\b" + qualify(key) + "(?:\\b|\\w*\\d)", "i").exec(ua)) && key;
        });
      }
      __name(getManufacturer, "getManufacturer");
      function getName(guesses) {
        return reduce(guesses, function(result2, guess) {
          return result2 || RegExp("\\b" + (guess.pattern || qualify(guess)) + "\\b", "i").exec(ua) && (guess.label || guess);
        });
      }
      __name(getName, "getName");
      function getOS(guesses) {
        return reduce(guesses, function(result2, guess) {
          var pattern = guess.pattern || qualify(guess);
          return !result2 && (result2 = RegExp("\\b" + pattern + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(ua)) && (result2 = cleanupOS(result2, pattern, guess.label || guess)), result2;
        });
      }
      __name(getOS, "getOS");
      function getProduct(guesses) {
        return reduce(guesses, function(result2, guess) {
          var pattern = guess.pattern || qualify(guess);
          return !result2 && (result2 = RegExp("\\b" + pattern + " *\\d+[.\\w_]*", "i").exec(ua) || RegExp("\\b" + pattern + " *\\w+-[\\w]*", "i").exec(ua) || RegExp("\\b" + pattern + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(ua)) && ((result2 = String(guess.label && !RegExp(pattern, "i").test(guess.label) ? guess.label : result2).split("/"))[1] && !/[\d.]+/.test(result2[0]) && (result2[0] += " " + result2[1]), guess = guess.label || guess, result2 = format2(result2[0].replace(RegExp(pattern, "i"), guess).replace(RegExp("; *(?:" + guess + "[_-])?", "i"), " ").replace(RegExp("(" + guess + ")[-_.]?(\\w)", "i"), "$1 $2"))), result2;
        });
      }
      __name(getProduct, "getProduct");
      function getVersion(patterns2) {
        return reduce(patterns2, function(result2, pattern) {
          return result2 || (RegExp(pattern + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(ua) || 0)[1] || null;
        });
      }
      __name(getVersion, "getVersion");
      function toStringPlatform() {
        return this.description || "";
      }
      if (__name(toStringPlatform, "toStringPlatform"), layout2 && (layout2 = [layout2]), /\bAndroid\b/.test(os) && !product && (data2 = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua)) && (product = trim2(data2[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), manufacturer && !product ? product = getProduct([manufacturer]) : manufacturer && product && (product = product.replace(RegExp("^(" + qualify(manufacturer) + ")[-_.\\s]", "i"), manufacturer + " ").replace(RegExp("^(" + qualify(manufacturer) + ")[-_.]?(\\w)", "i"), manufacturer + " $2")), (data2 = /\bGoogle TV\b/.exec(product)) && (product = data2[0]), /\bSimulator\b/i.test(ua) && (product = (product ? product + " " : "") + "Simulator"), name2 == "Opera Mini" && /\bOPiOS\b/.test(ua) && description.push("running in Turbo/Uncompressed mode"), name2 == "IE" && /\blike iPhone OS\b/.test(ua) ? (data2 = parse2(ua.replace(/like iPhone OS/, "")), manufacturer = data2.manufacturer, product = data2.product) : /^iP/.test(product) ? (name2 || (name2 = "Safari"), os = "iOS" + ((data2 = / OS ([\d_]+)/i.exec(ua)) ? " " + data2[1].replace(/_/g, ".") : "")) : name2 == "Konqueror" && /^Linux\b/i.test(os) ? os = "Kubuntu" : manufacturer && manufacturer != "Google" && (/Chrome/.test(name2) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name2) && /\bVersion\//i.test(ua) ? (name2 = "Android Browser", os = /\bAndroid\b/.test(os) ? os : "Android") : name2 == "Silk" ? (/\bMobi/i.test(ua) || (os = "Android", description.unshift("desktop mode")), /Accelerated *= *true/i.test(ua) && description.unshift("accelerated")) : name2 == "UC Browser" && /\bUCWEB\b/.test(ua) ? description.push("speed mode") : name2 == "PaleMoon" && (data2 = /\bFirefox\/([\d.]+)\b/.exec(ua)) ? description.push("identifying as Firefox " + data2[1]) : name2 == "Firefox" && (data2 = /\b(Mobile|Tablet|TV)\b/i.exec(ua)) ? (os || (os = "Firefox OS"), product || (product = data2[1])) : !name2 || (data2 = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name2)) ? (name2 && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data2 + "/") + 8)) && (name2 = null), (data2 = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os)) && (name2 = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data2) + " Browser")) : name2 == "Electron" && (data2 = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1]) && description.push("Chromium " + data2), version2 || (version2 = getVersion([
        "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
        "Version",
        qualify(name2),
        "(?:Firefox|Minefield|NetFront)"
      ])), (data2 = layout2 == "iCab" && parseFloat(version2) > 3 && "WebKit" || /\bOpera\b/.test(name2) && (/\bOPR\b/.test(ua) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout2) && "WebKit" || !layout2 && /\bMSIE\b/i.test(ua) && (os == "Mac OS" ? "Tasman" : "Trident") || layout2 == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(name2) && "NetFront") && (layout2 = [data2]), name2 == "IE" && (data2 = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1]) ? (name2 += " Mobile", os = "Windows Phone " + (/\+$/.test(data2) ? data2 : data2 + ".x"), description.unshift("desktop mode")) : /\bWPDesktop\b/i.test(ua) ? (name2 = "IE Mobile", os = "Windows Phone 8.x", description.unshift("desktop mode"), version2 || (version2 = (/\brv:([\d.]+)/.exec(ua) || 0)[1])) : name2 != "IE" && layout2 == "Trident" && (data2 = /\brv:([\d.]+)/.exec(ua)) && (name2 && description.push("identifying as " + name2 + (version2 ? " " + version2 : "")), name2 = "IE", version2 = data2[1]), useFeatures) {
        if (isHostType(context, "global"))
          if (java && (data2 = java.lang.System, arch = data2.getProperty("os.arch"), os = os || data2.getProperty("os.name") + " " + data2.getProperty("os.version")), rhino) {
            try {
              version2 = context.require("ringo/engine").version.join("."), name2 = "RingoJS";
            } catch {
              (data2 = context.system) && data2.global.system == context.system && (name2 = "Narwhal", os || (os = data2[0].os || null));
            }
            name2 || (name2 = "Rhino");
          } else
            typeof context.process == "object" && !context.process.browser && (data2 = context.process) && (typeof data2.versions == "object" && (typeof data2.versions.electron == "string" ? (description.push("Node " + data2.versions.node), name2 = "Electron", version2 = data2.versions.electron) : typeof data2.versions.nw == "string" && (description.push("Chromium " + version2, "Node " + data2.versions.node), name2 = "NW.js", version2 = data2.versions.nw)), name2 || (name2 = "Node.js", arch = data2.arch, os = data2.platform, version2 = /[\d.]+/.exec(data2.version), version2 = version2 ? version2[0] : null));
        else
          getClassOf(data2 = context.runtime) == airRuntimeClass ? (name2 = "Adobe AIR", os = data2.flash.system.Capabilities.os) : getClassOf(data2 = context.phantom) == phantomClass ? (name2 = "PhantomJS", version2 = (data2 = data2.version || null) && data2.major + "." + data2.minor + "." + data2.patch) : typeof doc.documentMode == "number" && (data2 = /\bTrident\/(\d+)/i.exec(ua)) ? (version2 = [version2, doc.documentMode], (data2 = +data2[1] + 4) != version2[1] && (description.push("IE " + version2[1] + " mode"), layout2 && (layout2[1] = ""), version2[1] = data2), version2 = name2 == "IE" ? String(version2[1].toFixed(1)) : version2[0]) : typeof doc.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(name2) && (description.push("masking as " + name2 + " " + version2), name2 = "IE", version2 = "11.0", layout2 = ["Trident"], os = "Windows");
        os = os && format2(os);
      }
      if (version2 && (data2 = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version2) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ";" + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && "a") && (prerelease = /b/i.test(data2) ? "beta" : "alpha", version2 = version2.replace(RegExp(data2 + "\\+?$"), "") + (prerelease == "beta" ? beta : alpha3) + (/\d+\+?/.exec(data2) || "")), name2 == "Fennec" || name2 == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os))
        name2 = "Firefox Mobile";
      else if (name2 == "Maxthon" && version2)
        version2 = version2.replace(/\.[\d.]+/, ".x");
      else if (/\bXbox\b/i.test(product))
        product == "Xbox 360" && (os = null), product == "Xbox 360" && /\bIEMobile\b/.test(ua) && description.unshift("mobile mode");
      else if ((/^(?:Chrome|IE|Opera)$/.test(name2) || name2 && !product && !/Browser|Mobi/.test(name2)) && (os == "Windows CE" || /Mobi/i.test(ua)))
        name2 += " Mobile";
      else if (name2 == "IE" && useFeatures)
        try {
          context.external === null && description.unshift("platform preview");
        } catch {
          description.unshift("embedded");
        }
      else
        (/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data2 = (RegExp(product.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(ua) || 0)[1] || version2) ? (data2 = [data2, /BB10/.test(ua)], os = (data2[1] ? (product = null, manufacturer = "BlackBerry") : "Device Software") + " " + data2[0], version2 = null) : this != forOwn && product != "Wii" && (useFeatures && opera || /Opera/.test(name2) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name2 == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(os) || name2 == "IE" && (os && !/^Win/.test(os) && version2 > 5.5 || /\bWindows XP\b/.test(os) && version2 > 8 || version2 == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data2 = parse2.call(forOwn, ua.replace(reOpera, "") + ";")) && data2.name && (data2 = "ing as " + data2.name + ((data2 = data2.version) ? " " + data2 : ""), reOpera.test(name2) ? (/\bIE\b/.test(data2) && os == "Mac OS" && (os = null), data2 = "identify" + data2) : (data2 = "mask" + data2, operaClass ? name2 = format2(operaClass.replace(/([a-z])([A-Z])/g, "$1 $2")) : name2 = "Opera", /\bIE\b/.test(data2) && (os = null), useFeatures || (version2 = null)), layout2 = ["Presto"], description.push(data2));
      (data2 = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) && (data2 = [parseFloat(data2.replace(/\.(\d)$/, ".0$1")), data2], name2 == "Safari" && data2[1].slice(-1) == "+" ? (name2 = "WebKit Nightly", prerelease = "alpha", version2 = data2[1].slice(0, -1)) : (version2 == data2[1] || version2 == (data2[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) && (version2 = null), data2[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1], data2[0] == 537.36 && data2[2] == 537.36 && parseFloat(data2[1]) >= 28 && layout2 == "WebKit" && (layout2 = ["Blink"]), !useFeatures || !likeChrome && !data2[1] ? (layout2 && (layout2[1] = "like Safari"), data2 = (data2 = data2[0], data2 < 400 ? 1 : data2 < 500 ? 2 : data2 < 526 ? 3 : data2 < 533 ? 4 : data2 < 534 ? "4+" : data2 < 535 ? 5 : data2 < 537 ? 6 : data2 < 538 ? 7 : data2 < 601 ? 8 : data2 < 602 ? 9 : data2 < 604 ? 10 : data2 < 606 ? 11 : data2 < 608 ? 12 : "12")) : (layout2 && (layout2[1] = "like Chrome"), data2 = data2[1] || (data2 = data2[0], data2 < 530 ? 1 : data2 < 532 ? 2 : data2 < 532.05 ? 3 : data2 < 533 ? 4 : data2 < 534.03 ? 5 : data2 < 534.07 ? 6 : data2 < 534.1 ? 7 : data2 < 534.13 ? 8 : data2 < 534.16 ? 9 : data2 < 534.24 ? 10 : data2 < 534.3 ? 11 : data2 < 535.01 ? 12 : data2 < 535.02 ? "13+" : data2 < 535.07 ? 15 : data2 < 535.11 ? 16 : data2 < 535.19 ? 17 : data2 < 536.05 ? 18 : data2 < 536.1 ? 19 : data2 < 537.01 ? 20 : data2 < 537.11 ? "21+" : data2 < 537.13 ? 23 : data2 < 537.18 ? 24 : data2 < 537.24 ? 25 : data2 < 537.36 ? 26 : layout2 != "Blink" ? "27" : "28")), layout2 && (layout2[1] += " " + (data2 += typeof data2 == "number" ? ".x" : /[.+]/.test(data2) ? "" : "+")), name2 == "Safari" && (!version2 || parseInt(version2) > 45) ? version2 = data2 : name2 == "Chrome" && /\bHeadlessChrome/i.test(ua) && description.unshift("headless")), name2 == "Opera" && (data2 = /\bzbov|zvav$/.exec(os)) ? (name2 += " ", description.unshift("desktop mode"), data2 == "zvav" ? (name2 += "Mini", version2 = null) : name2 += "Mobile", os = os.replace(RegExp(" *" + data2 + "$"), "")) : name2 == "Safari" && /\bChrome\b/.exec(layout2 && layout2[1]) ? (description.unshift("desktop mode"), name2 = "Chrome Mobile", version2 = null, /\bOS X\b/.test(os) ? (manufacturer = "Apple", os = "iOS 4.3+") : os = null) : /\bSRWare Iron\b/.test(name2) && !version2 && (version2 = getVersion("Chrome")), version2 && version2.indexOf(data2 = /[\d.]+$/.exec(os)) == 0 && ua.indexOf("/" + data2 + "-") > -1 && (os = trim2(os.replace(data2, ""))), os && os.indexOf(name2) != -1 && !RegExp(name2 + " OS").test(os) && (os = os.replace(RegExp(" *" + qualify(name2) + " *"), "")), layout2 && !/\b(?:Avant|Nook)\b/.test(name2) && (/Browser|Lunascape|Maxthon/.test(name2) || name2 != "Safari" && /^iOS/.test(os) && /\bSafari\b/.test(layout2[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name2) && layout2[1]) && (data2 = layout2[layout2.length - 1]) && description.push(data2), description.length && (description = ["(" + description.join("; ") + ")"]), manufacturer && product && product.indexOf(manufacturer) < 0 && description.push("on " + manufacturer), product && description.push((/^on /.test(description[description.length - 1]) ? "" : "on ") + product), os && (data2 = / ([\d.+]+)$/.exec(os), isSpecialCasedOS = data2 && os.charAt(os.length - data2[0].length - 1) == "/", os = {
        architecture: 32,
        family: data2 && !isSpecialCasedOS ? os.replace(data2[0], "") : os,
        version: data2 ? data2[1] : null,
        toString: function() {
          var version3 = this.version;
          return this.family + (version3 && !isSpecialCasedOS ? " " + version3 : "") + (this.architecture == 64 ? " 64-bit" : "");
        }
      }), (data2 = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch) ? (os && (os.architecture = 64, os.family = os.family.replace(RegExp(" *" + data2), "")), name2 && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)) && description.unshift("32-bit")) : os && /^OS X/.test(os.family) && name2 == "Chrome" && parseFloat(version2) >= 39 && (os.architecture = 64), ua || (ua = null);
      var platform3 = {};
      return platform3.description = ua, platform3.layout = layout2 && layout2[0], platform3.manufacturer = manufacturer, platform3.name = name2, platform3.prerelease = prerelease, platform3.product = product, platform3.ua = ua, platform3.version = name2 && version2, platform3.os = os || {
        /**
         * The CPU architecture the OS is built for.
         *
         * @memberOf platform.os
         * @type number|null
         */
        architecture: null,
        /**
         * The family of the OS.
         *
         * Common values include:
         * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
         * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
         * "SuSE", "Android", "iOS" and "Windows Phone"
         *
         * @memberOf platform.os
         * @type string|null
         */
        family: null,
        /**
         * The version of the OS.
         *
         * @memberOf platform.os
         * @type string|null
         */
        version: null,
        /**
         * Returns the OS string.
         *
         * @memberOf platform.os
         * @returns {string} The OS string.
         */
        toString: function() {
          return "null";
        }
      }, platform3.parse = parse2, platform3.toString = toStringPlatform, platform3.version && description.unshift(version2), platform3.name && description.unshift(name2), os && name2 && !(os == String(os).split(" ")[0] && (os == name2.split(" ")[0] || product)) && description.push(product ? "(" + os + ")" : "on " + os), description.length && (platform3.description = description.join(" ")), platform3;
    }
    __name(parse2, "parse");
    var platform2 = parse2();
    freeExports2 && freeModule2 ? forOwn(platform2, function(value, key) {
      freeExports2[key] = value;
    }) : root2.platform = platform2;
  }).call(commonjsGlobal);
})(platform$1, platform$1.exports);
var platformExports = platform$1.exports;
const platform = /* @__PURE__ */ getDefaultExportFromCjs(platformExports), debug$1 = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...args) => console.error("SEMVER", ...args) : () => {
};
var debug_1 = debug$1;
const SEMVER_SPEC_VERSION = "2.0.0", MAX_LENGTH$1 = 256, MAX_SAFE_INTEGER$6 = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, MAX_SAFE_COMPONENT_LENGTH = 16, MAX_SAFE_BUILD_LENGTH = MAX_LENGTH$1 - 6, RELEASE_TYPES = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants$1 = {
  MAX_LENGTH: MAX_LENGTH$1,
  MAX_SAFE_COMPONENT_LENGTH,
  MAX_SAFE_BUILD_LENGTH,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$6,
  RELEASE_TYPES,
  SEMVER_SPEC_VERSION,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
}, re$4 = { exports: {} };
(function(module2, exports2) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: MAX_SAFE_COMPONENT_LENGTH2,
    MAX_SAFE_BUILD_LENGTH: MAX_SAFE_BUILD_LENGTH2,
    MAX_LENGTH: MAX_LENGTH2
  } = constants$1, debug2 = debug_1;
  exports2 = module2.exports = {};
  const re2 = exports2.re = [], safeRe = exports2.safeRe = [], src = exports2.src = [], safeSrc = exports2.safeSrc = [], t3 = exports2.t = {};
  let R2 = 0;
  const LETTERDASHNUMBER = "[a-zA-Z0-9-]", safeRegexReplacements = [
    ["\\s", 1],
    ["\\d", MAX_LENGTH2],
    [LETTERDASHNUMBER, MAX_SAFE_BUILD_LENGTH2]
  ], makeSafeRegex = /* @__PURE__ */ __name((value) => {
    for (const [token, max2] of safeRegexReplacements)
      value = value.split(`${token}*`).join(`${token}{0,${max2}}`).split(`${token}+`).join(`${token}{1,${max2}}`);
    return value;
  }, "makeSafeRegex"), createToken = /* @__PURE__ */ __name((name2, value, isGlobal) => {
    const safe = makeSafeRegex(value), index2 = R2++;
    debug2(name2, index2, value), t3[name2] = index2, src[index2] = value, safeSrc[index2] = safe, re2[index2] = new RegExp(value, isGlobal ? "g" : void 0), safeRe[index2] = new RegExp(safe, isGlobal ? "g" : void 0);
  }, "createToken");
  createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*"), createToken("NUMERICIDENTIFIERLOOSE", "\\d+"), createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`), createToken("MAINVERSION", `(${src[t3.NUMERICIDENTIFIER]})\\.(${src[t3.NUMERICIDENTIFIER]})\\.(${src[t3.NUMERICIDENTIFIER]})`), createToken("MAINVERSIONLOOSE", `(${src[t3.NUMERICIDENTIFIERLOOSE]})\\.(${src[t3.NUMERICIDENTIFIERLOOSE]})\\.(${src[t3.NUMERICIDENTIFIERLOOSE]})`), createToken("PRERELEASEIDENTIFIER", `(?:${src[t3.NONNUMERICIDENTIFIER]}|${src[t3.NUMERICIDENTIFIER]})`), createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t3.NONNUMERICIDENTIFIER]}|${src[t3.NUMERICIDENTIFIERLOOSE]})`), createToken("PRERELEASE", `(?:-(${src[t3.PRERELEASEIDENTIFIER]}(?:\\.${src[t3.PRERELEASEIDENTIFIER]})*))`), createToken("PRERELEASELOOSE", `(?:-?(${src[t3.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t3.PRERELEASEIDENTIFIERLOOSE]})*))`), createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`), createToken("BUILD", `(?:\\+(${src[t3.BUILDIDENTIFIER]}(?:\\.${src[t3.BUILDIDENTIFIER]})*))`), createToken("FULLPLAIN", `v?${src[t3.MAINVERSION]}${src[t3.PRERELEASE]}?${src[t3.BUILD]}?`), createToken("FULL", `^${src[t3.FULLPLAIN]}$`), createToken("LOOSEPLAIN", `[v=\\s]*${src[t3.MAINVERSIONLOOSE]}${src[t3.PRERELEASELOOSE]}?${src[t3.BUILD]}?`), createToken("LOOSE", `^${src[t3.LOOSEPLAIN]}$`), createToken("GTLT", "((?:<|>)?=?)"), createToken("XRANGEIDENTIFIERLOOSE", `${src[t3.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), createToken("XRANGEIDENTIFIER", `${src[t3.NUMERICIDENTIFIER]}|x|X|\\*`), createToken("XRANGEPLAIN", `[v=\\s]*(${src[t3.XRANGEIDENTIFIER]})(?:\\.(${src[t3.XRANGEIDENTIFIER]})(?:\\.(${src[t3.XRANGEIDENTIFIER]})(?:${src[t3.PRERELEASE]})?${src[t3.BUILD]}?)?)?`), createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:${src[t3.PRERELEASELOOSE]})?${src[t3.BUILD]}?)?)?`), createToken("XRANGE", `^${src[t3.GTLT]}\\s*${src[t3.XRANGEPLAIN]}$`), createToken("XRANGELOOSE", `^${src[t3.GTLT]}\\s*${src[t3.XRANGEPLAINLOOSE]}$`), createToken("COERCEPLAIN", `(^|[^\\d])(\\d{1,${MAX_SAFE_COMPONENT_LENGTH2}})(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH2}}))?(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH2}}))?`), createToken("COERCE", `${src[t3.COERCEPLAIN]}(?:$|[^\\d])`), createToken("COERCEFULL", src[t3.COERCEPLAIN] + `(?:${src[t3.PRERELEASE]})?(?:${src[t3.BUILD]})?(?:$|[^\\d])`), createToken("COERCERTL", src[t3.COERCE], !0), createToken("COERCERTLFULL", src[t3.COERCEFULL], !0), createToken("LONETILDE", "(?:~>?)"), createToken("TILDETRIM", `(\\s*)${src[t3.LONETILDE]}\\s+`, !0), exports2.tildeTrimReplace = "$1~", createToken("TILDE", `^${src[t3.LONETILDE]}${src[t3.XRANGEPLAIN]}$`), createToken("TILDELOOSE", `^${src[t3.LONETILDE]}${src[t3.XRANGEPLAINLOOSE]}$`), createToken("LONECARET", "(?:\\^)"), createToken("CARETTRIM", `(\\s*)${src[t3.LONECARET]}\\s+`, !0), exports2.caretTrimReplace = "$1^", createToken("CARET", `^${src[t3.LONECARET]}${src[t3.XRANGEPLAIN]}$`), createToken("CARETLOOSE", `^${src[t3.LONECARET]}${src[t3.XRANGEPLAINLOOSE]}$`), createToken("COMPARATORLOOSE", `^${src[t3.GTLT]}\\s*(${src[t3.LOOSEPLAIN]})$|^$`), createToken("COMPARATOR", `^${src[t3.GTLT]}\\s*(${src[t3.FULLPLAIN]})$|^$`), createToken("COMPARATORTRIM", `(\\s*)${src[t3.GTLT]}\\s*(${src[t3.LOOSEPLAIN]}|${src[t3.XRANGEPLAIN]})`, !0), exports2.comparatorTrimReplace = "$1$2$3", createToken("HYPHENRANGE", `^\\s*(${src[t3.XRANGEPLAIN]})\\s+-\\s+(${src[t3.XRANGEPLAIN]})\\s*$`), createToken("HYPHENRANGELOOSE", `^\\s*(${src[t3.XRANGEPLAINLOOSE]})\\s+-\\s+(${src[t3.XRANGEPLAINLOOSE]})\\s*$`), createToken("STAR", "(<|>)?=?\\s*\\*"), createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$4, re$4.exports);
var reExports = re$4.exports;
const looseOption = Object.freeze({ loose: !0 }), emptyOpts = Object.freeze({}), parseOptions$1 = /* @__PURE__ */ __name((options) => options ? typeof options != "object" ? looseOption : options : emptyOpts, "parseOptions$1");
var parseOptions_1 = parseOptions$1;
const numeric = /^[0-9]+$/, compareIdentifiers$1 = /* @__PURE__ */ __name((a4, b2) => {
  const anum = numeric.test(a4), bnum = numeric.test(b2);
  return anum && bnum && (a4 = +a4, b2 = +b2), a4 === b2 ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a4 < b2 ? -1 : 1;
}, "compareIdentifiers$1"), rcompareIdentifiers = /* @__PURE__ */ __name((a4, b2) => compareIdentifiers$1(b2, a4), "rcompareIdentifiers");
var identifiers = {
  compareIdentifiers: compareIdentifiers$1,
  rcompareIdentifiers
};
const debug = debug_1, { MAX_LENGTH, MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$5 } = constants$1, { safeRe: re$3, t: t$1 } = reExports, parseOptions = parseOptions_1, { compareIdentifiers } = identifiers;
var _a2;
let SemVer$3 = (_a2 = class {
  constructor(version2, options) {
    if (options = parseOptions(options), version2 instanceof _a2) {
      if (version2.loose === !!options.loose && version2.includePrerelease === !!options.includePrerelease)
        return version2;
      version2 = version2.version;
    } else if (typeof version2 != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version2}".`);
    if (version2.length > MAX_LENGTH)
      throw new TypeError(
        `version is longer than ${MAX_LENGTH} characters`
      );
    debug("SemVer", version2, options), this.options = options, this.loose = !!options.loose, this.includePrerelease = !!options.includePrerelease;
    const m3 = version2.trim().match(options.loose ? re$3[t$1.LOOSE] : re$3[t$1.FULL]);
    if (!m3)
      throw new TypeError(`Invalid Version: ${version2}`);
    if (this.raw = version2, this.major = +m3[1], this.minor = +m3[2], this.patch = +m3[3], this.major > MAX_SAFE_INTEGER$5 || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER$5 || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER$5 || this.patch < 0)
      throw new TypeError("Invalid patch version");
    m3[4] ? this.prerelease = m3[4].split(".").map((id2) => {
      if (/^[0-9]+$/.test(id2)) {
        const num2 = +id2;
        if (num2 >= 0 && num2 < MAX_SAFE_INTEGER$5)
          return num2;
      }
      return id2;
    }) : this.prerelease = [], this.build = m3[5] ? m3[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(other) {
    if (debug("SemVer.compare", this.version, this.options, other), !(other instanceof _a2)) {
      if (typeof other == "string" && other === this.version)
        return 0;
      other = new _a2(other, this.options);
    }
    return other.version === this.version ? 0 : this.compareMain(other) || this.comparePre(other);
  }
  compareMain(other) {
    return other instanceof _a2 || (other = new _a2(other, this.options)), compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
  }
  comparePre(other) {
    if (other instanceof _a2 || (other = new _a2(other, this.options)), this.prerelease.length && !other.prerelease.length)
      return -1;
    if (!this.prerelease.length && other.prerelease.length)
      return 1;
    if (!this.prerelease.length && !other.prerelease.length)
      return 0;
    let i2 = 0;
    do {
      const a4 = this.prerelease[i2], b2 = other.prerelease[i2];
      if (debug("prerelease compare", i2, a4, b2), a4 === void 0 && b2 === void 0)
        return 0;
      if (b2 === void 0)
        return 1;
      if (a4 === void 0)
        return -1;
      if (a4 === b2)
        continue;
      return compareIdentifiers(a4, b2);
    } while (++i2);
  }
  compareBuild(other) {
    other instanceof _a2 || (other = new _a2(other, this.options));
    let i2 = 0;
    do {
      const a4 = this.build[i2], b2 = other.build[i2];
      if (debug("build compare", i2, a4, b2), a4 === void 0 && b2 === void 0)
        return 0;
      if (b2 === void 0)
        return 1;
      if (a4 === void 0)
        return -1;
      if (a4 === b2)
        continue;
      return compareIdentifiers(a4, b2);
    } while (++i2);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(release, identifier, identifierBase) {
    if (release.startsWith("pre")) {
      if (!identifier && identifierBase === !1)
        throw new Error("invalid increment argument: identifier is empty");
      if (identifier) {
        const match2 = `-${identifier}`.match(this.options.loose ? re$3[t$1.PRERELEASELOOSE] : re$3[t$1.PRERELEASE]);
        if (!match2 || match2[1] !== identifier)
          throw new Error(`invalid identifier: ${identifier}`);
      }
    }
    switch (release) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", identifier, identifierBase);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", identifier, identifierBase);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", identifier, identifierBase), this.inc("pre", identifier, identifierBase);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", identifier, identifierBase), this.inc("pre", identifier, identifierBase);
        break;
      case "release":
        if (this.prerelease.length === 0)
          throw new Error(`version ${this.raw} is not a prerelease`);
        this.prerelease.length = 0;
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const base = Number(identifierBase) ? 1 : 0;
        if (this.prerelease.length === 0)
          this.prerelease = [base];
        else {
          let i2 = this.prerelease.length;
          for (; --i2 >= 0; )
            typeof this.prerelease[i2] == "number" && (this.prerelease[i2]++, i2 = -2);
          if (i2 === -1) {
            if (identifier === this.prerelease.join(".") && identifierBase === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(base);
          }
        }
        if (identifier) {
          let prerelease = [identifier, base];
          identifierBase === !1 && (prerelease = [identifier]), compareIdentifiers(this.prerelease[0], identifier) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = prerelease) : this.prerelease = prerelease;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${release}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
}, __name(_a2, "SemVer"), _a2);
var semver = SemVer$3;
const SemVer$2 = semver, parse$4 = /* @__PURE__ */ __name((version2, options, throwErrors = !1) => {
  if (version2 instanceof SemVer$2)
    return version2;
  try {
    return new SemVer$2(version2, options);
  } catch (er) {
    if (!throwErrors)
      return null;
    throw er;
  }
}, "parse$4");
var parse_1 = parse$4;
const SemVer$1 = semver, parse$3 = parse_1, { safeRe: re$2, t } = reExports, coerce = /* @__PURE__ */ __name((version2, options) => {
  if (version2 instanceof SemVer$1)
    return version2;
  if (typeof version2 == "number" && (version2 = String(version2)), typeof version2 != "string")
    return null;
  options = options || {};
  let match2 = null;
  if (!options.rtl)
    match2 = version2.match(options.includePrerelease ? re$2[t.COERCEFULL] : re$2[t.COERCE]);
  else {
    const coerceRtlRegex = options.includePrerelease ? re$2[t.COERCERTLFULL] : re$2[t.COERCERTL];
    let next;
    for (; (next = coerceRtlRegex.exec(version2)) && (!match2 || match2.index + match2[0].length !== version2.length); )
      (!match2 || next.index + next[0].length !== match2.index + match2[0].length) && (match2 = next), coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
    coerceRtlRegex.lastIndex = -1;
  }
  if (match2 === null)
    return null;
  const major = match2[2], minor = match2[3] || "0", patch2 = match2[4] || "0", prerelease = options.includePrerelease && match2[5] ? `-${match2[5]}` : "", build = options.includePrerelease && match2[6] ? `+${match2[6]}` : "";
  return parse$3(`${major}.${minor}.${patch2}${prerelease}${build}`, options);
}, "coerce");
var coerce_1 = coerce;
const coerce$1 = /* @__PURE__ */ getDefaultExportFromCjs(coerce_1), _LRUCache = class _LRUCache {
  constructor() {
    this.max = 1e3, this.map = /* @__PURE__ */ new Map();
  }
  get(key) {
    const value = this.map.get(key);
    if (value !== void 0)
      return this.map.delete(key), this.map.set(key, value), value;
  }
  delete(key) {
    return this.map.delete(key);
  }
  set(key, value) {
    if (!this.delete(key) && value !== void 0) {
      if (this.map.size >= this.max) {
        const firstKey = this.map.keys().next().value;
        this.delete(firstKey);
      }
      this.map.set(key, value);
    }
    return this;
  }
};
__name(_LRUCache, "LRUCache");
let LRUCache = _LRUCache;
var lrucache = LRUCache;
const SemVer = semver, compare$7 = /* @__PURE__ */ __name((a4, b2, loose) => new SemVer(a4, loose).compare(new SemVer(b2, loose)), "compare$7");
var compare_1 = compare$7;
const compare$6 = compare_1, eq$6 = /* @__PURE__ */ __name((a4, b2, loose) => compare$6(a4, b2, loose) === 0, "eq$6");
var eq_1$1 = eq$6;
const compare$5 = compare_1, neq$1 = /* @__PURE__ */ __name((a4, b2, loose) => compare$5(a4, b2, loose) !== 0, "neq$1");
var neq_1 = neq$1;
const compare$4 = compare_1, gt$1 = /* @__PURE__ */ __name((a4, b2, loose) => compare$4(a4, b2, loose) > 0, "gt$1");
var gt_1 = gt$1;
const compare$3 = compare_1, gte$1 = /* @__PURE__ */ __name((a4, b2, loose) => compare$3(a4, b2, loose) >= 0, "gte$1");
var gte_1 = gte$1;
const compare$2 = compare_1, lt$1 = /* @__PURE__ */ __name((a4, b2, loose) => compare$2(a4, b2, loose) < 0, "lt$1");
var lt_1 = lt$1;
const compare$1 = compare_1, lte$1 = /* @__PURE__ */ __name((a4, b2, loose) => compare$1(a4, b2, loose) <= 0, "lte$1");
var lte_1 = lte$1;
const eq$5 = eq_1$1, neq = neq_1, gt = gt_1, gte = gte_1, lt = lt_1, lte = lte_1, cmp = /* @__PURE__ */ __name((a4, op, b2, loose) => {
  switch (op) {
    case "===":
      return typeof a4 == "object" && (a4 = a4.version), typeof b2 == "object" && (b2 = b2.version), a4 === b2;
    case "!==":
      return typeof a4 == "object" && (a4 = a4.version), typeof b2 == "object" && (b2 = b2.version), a4 !== b2;
    case "":
    case "=":
    case "==":
      return eq$5(a4, b2, loose);
    case "!=":
      return neq(a4, b2, loose);
    case ">":
      return gt(a4, b2, loose);
    case ">=":
      return gte(a4, b2, loose);
    case "<":
      return lt(a4, b2, loose);
    case "<=":
      return lte(a4, b2, loose);
    default:
      throw new TypeError(`Invalid operator: ${op}`);
  }
}, "cmp");
var cmp_1 = cmp, comparator, hasRequiredComparator;
function requireComparator() {
  if (hasRequiredComparator)
    return comparator;
  hasRequiredComparator = 1;
  const ANY = Symbol("SemVer ANY"), _Comparator = class _Comparator {
    static get ANY() {
      return ANY;
    }
    constructor(comp, options) {
      if (options = parseOptions2(options), comp instanceof _Comparator) {
        if (comp.loose === !!options.loose)
          return comp;
        comp = comp.value;
      }
      comp = comp.trim().split(/\s+/).join(" "), debug2("comparator", comp, options), this.options = options, this.loose = !!options.loose, this.parse(comp), this.semver === ANY ? this.value = "" : this.value = this.operator + this.semver.version, debug2("comp", this);
    }
    parse(comp) {
      const r2 = this.options.loose ? re2[t3.COMPARATORLOOSE] : re2[t3.COMPARATOR], m3 = comp.match(r2);
      if (!m3)
        throw new TypeError(`Invalid comparator: ${comp}`);
      this.operator = m3[1] !== void 0 ? m3[1] : "", this.operator === "=" && (this.operator = ""), m3[2] ? this.semver = new SemVer2(m3[2], this.options.loose) : this.semver = ANY;
    }
    toString() {
      return this.value;
    }
    test(version2) {
      if (debug2("Comparator.test", version2, this.options.loose), this.semver === ANY || version2 === ANY)
        return !0;
      if (typeof version2 == "string")
        try {
          version2 = new SemVer2(version2, this.options);
        } catch {
          return !1;
        }
      return cmp2(version2, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
      if (!(comp instanceof _Comparator))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new Range2(comp.value, options).test(this.value) : comp.operator === "" ? comp.value === "" ? !0 : new Range2(this.value, options).test(comp.semver) : (options = parseOptions2(options), options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0") || !options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && comp.operator.startsWith(">") || this.operator.startsWith("<") && comp.operator.startsWith("<") || this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=") || cmp2(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<") || cmp2(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")));
    }
  };
  __name(_Comparator, "Comparator");
  let Comparator = _Comparator;
  comparator = Comparator;
  const parseOptions2 = parseOptions_1, { safeRe: re2, t: t3 } = reExports, cmp2 = cmp_1, debug2 = debug_1, SemVer2 = semver, Range2 = requireRange();
  return comparator;
}
__name(requireComparator, "requireComparator");
var range$4, hasRequiredRange;
function requireRange() {
  if (hasRequiredRange)
    return range$4;
  hasRequiredRange = 1;
  const SPACE_CHARACTERS = /\s+/g, _Range = class _Range {
    constructor(range3, options) {
      if (options = parseOptions2(options), range3 instanceof _Range)
        return range3.loose === !!options.loose && range3.includePrerelease === !!options.includePrerelease ? range3 : new _Range(range3.raw, options);
      if (range3 instanceof Comparator)
        return this.raw = range3.value, this.set = [[range3]], this.formatted = void 0, this;
      if (this.options = options, this.loose = !!options.loose, this.includePrerelease = !!options.includePrerelease, this.raw = range3.trim().replace(SPACE_CHARACTERS, " "), this.set = this.raw.split("||").map((r2) => this.parseRange(r2.trim())).filter((c3) => c3.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const first = this.set[0];
        if (this.set = this.set.filter((c3) => !isNullSet(c3[0])), this.set.length === 0)
          this.set = [first];
        else if (this.set.length > 1) {
          for (const c3 of this.set)
            if (c3.length === 1 && isAny(c3[0])) {
              this.set = [c3];
              break;
            }
        }
      }
      this.formatted = void 0;
    }
    get range() {
      if (this.formatted === void 0) {
        this.formatted = "";
        for (let i2 = 0; i2 < this.set.length; i2++) {
          i2 > 0 && (this.formatted += "||");
          const comps = this.set[i2];
          for (let k3 = 0; k3 < comps.length; k3++)
            k3 > 0 && (this.formatted += " "), this.formatted += comps[k3].toString().trim();
        }
      }
      return this.formatted;
    }
    format() {
      return this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(range3) {
      const memoKey = ((this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE)) + ":" + range3, cached = cache2.get(memoKey);
      if (cached)
        return cached;
      const loose = this.options.loose, hr = loose ? re2[t3.HYPHENRANGELOOSE] : re2[t3.HYPHENRANGE];
      range3 = range3.replace(hr, hyphenReplace(this.options.includePrerelease)), debug2("hyphen replace", range3), range3 = range3.replace(re2[t3.COMPARATORTRIM], comparatorTrimReplace), debug2("comparator trim", range3), range3 = range3.replace(re2[t3.TILDETRIM], tildeTrimReplace), debug2("tilde trim", range3), range3 = range3.replace(re2[t3.CARETTRIM], caretTrimReplace), debug2("caret trim", range3);
      let rangeList = range3.split(" ").map((comp) => parseComparator(comp, this.options)).join(" ").split(/\s+/).map((comp) => replaceGTE0(comp, this.options));
      loose && (rangeList = rangeList.filter((comp) => (debug2("loose invalid filter", comp, this.options), !!comp.match(re2[t3.COMPARATORLOOSE])))), debug2("range list", rangeList);
      const rangeMap = /* @__PURE__ */ new Map(), comparators = rangeList.map((comp) => new Comparator(comp, this.options));
      for (const comp of comparators) {
        if (isNullSet(comp))
          return [comp];
        rangeMap.set(comp.value, comp);
      }
      rangeMap.size > 1 && rangeMap.has("") && rangeMap.delete("");
      const result2 = [...rangeMap.values()];
      return cache2.set(memoKey, result2), result2;
    }
    intersects(range3, options) {
      if (!(range3 instanceof _Range))
        throw new TypeError("a Range is required");
      return this.set.some((thisComparators) => isSatisfiable(thisComparators, options) && range3.set.some((rangeComparators) => isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator) => rangeComparators.every((rangeComparator) => thisComparator.intersects(rangeComparator, options)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version2) {
      if (!version2)
        return !1;
      if (typeof version2 == "string")
        try {
          version2 = new SemVer2(version2, this.options);
        } catch {
          return !1;
        }
      for (let i2 = 0; i2 < this.set.length; i2++)
        if (testSet(this.set[i2], version2, this.options))
          return !0;
      return !1;
    }
  };
  __name(_Range, "Range");
  let Range2 = _Range;
  range$4 = Range2;
  const LRU = lrucache, cache2 = new LRU(), parseOptions2 = parseOptions_1, Comparator = requireComparator(), debug2 = debug_1, SemVer2 = semver, {
    safeRe: re2,
    t: t3,
    comparatorTrimReplace,
    tildeTrimReplace,
    caretTrimReplace
  } = reExports, { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = constants$1, isNullSet = /* @__PURE__ */ __name((c3) => c3.value === "<0.0.0-0", "isNullSet"), isAny = /* @__PURE__ */ __name((c3) => c3.value === "", "isAny"), isSatisfiable = /* @__PURE__ */ __name((comparators, options) => {
    let result2 = !0;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    for (; result2 && remainingComparators.length; )
      result2 = remainingComparators.every((otherComparator) => testComparator.intersects(otherComparator, options)), testComparator = remainingComparators.pop();
    return result2;
  }, "isSatisfiable"), parseComparator = /* @__PURE__ */ __name((comp, options) => (debug2("comp", comp, options), comp = replaceCarets(comp, options), debug2("caret", comp), comp = replaceTildes(comp, options), debug2("tildes", comp), comp = replaceXRanges(comp, options), debug2("xrange", comp), comp = replaceStars(comp, options), debug2("stars", comp), comp), "parseComparator"), isX = /* @__PURE__ */ __name((id2) => !id2 || id2.toLowerCase() === "x" || id2 === "*", "isX"), replaceTildes = /* @__PURE__ */ __name((comp, options) => comp.trim().split(/\s+/).map((c3) => replaceTilde(c3, options)).join(" "), "replaceTildes"), replaceTilde = /* @__PURE__ */ __name((comp, options) => {
    const r2 = options.loose ? re2[t3.TILDELOOSE] : re2[t3.TILDE];
    return comp.replace(r2, (_, M3, m3, p, pr) => {
      debug2("tilde", comp, _, M3, m3, p, pr);
      let ret;
      return isX(M3) ? ret = "" : isX(m3) ? ret = `>=${M3}.0.0 <${+M3 + 1}.0.0-0` : isX(p) ? ret = `>=${M3}.${m3}.0 <${M3}.${+m3 + 1}.0-0` : pr ? (debug2("replaceTilde pr", pr), ret = `>=${M3}.${m3}.${p}-${pr} <${M3}.${+m3 + 1}.0-0`) : ret = `>=${M3}.${m3}.${p} <${M3}.${+m3 + 1}.0-0`, debug2("tilde return", ret), ret;
    });
  }, "replaceTilde"), replaceCarets = /* @__PURE__ */ __name((comp, options) => comp.trim().split(/\s+/).map((c3) => replaceCaret(c3, options)).join(" "), "replaceCarets"), replaceCaret = /* @__PURE__ */ __name((comp, options) => {
    debug2("caret", comp, options);
    const r2 = options.loose ? re2[t3.CARETLOOSE] : re2[t3.CARET], z2 = options.includePrerelease ? "-0" : "";
    return comp.replace(r2, (_, M3, m3, p, pr) => {
      debug2("caret", comp, _, M3, m3, p, pr);
      let ret;
      return isX(M3) ? ret = "" : isX(m3) ? ret = `>=${M3}.0.0${z2} <${+M3 + 1}.0.0-0` : isX(p) ? M3 === "0" ? ret = `>=${M3}.${m3}.0${z2} <${M3}.${+m3 + 1}.0-0` : ret = `>=${M3}.${m3}.0${z2} <${+M3 + 1}.0.0-0` : pr ? (debug2("replaceCaret pr", pr), M3 === "0" ? m3 === "0" ? ret = `>=${M3}.${m3}.${p}-${pr} <${M3}.${m3}.${+p + 1}-0` : ret = `>=${M3}.${m3}.${p}-${pr} <${M3}.${+m3 + 1}.0-0` : ret = `>=${M3}.${m3}.${p}-${pr} <${+M3 + 1}.0.0-0`) : (debug2("no pr"), M3 === "0" ? m3 === "0" ? ret = `>=${M3}.${m3}.${p}${z2} <${M3}.${m3}.${+p + 1}-0` : ret = `>=${M3}.${m3}.${p}${z2} <${M3}.${+m3 + 1}.0-0` : ret = `>=${M3}.${m3}.${p} <${+M3 + 1}.0.0-0`), debug2("caret return", ret), ret;
    });
  }, "replaceCaret"), replaceXRanges = /* @__PURE__ */ __name((comp, options) => (debug2("replaceXRanges", comp, options), comp.split(/\s+/).map((c3) => replaceXRange(c3, options)).join(" ")), "replaceXRanges"), replaceXRange = /* @__PURE__ */ __name((comp, options) => {
    comp = comp.trim();
    const r2 = options.loose ? re2[t3.XRANGELOOSE] : re2[t3.XRANGE];
    return comp.replace(r2, (ret, gtlt, M3, m3, p, pr) => {
      debug2("xRange", comp, ret, gtlt, M3, m3, p, pr);
      const xM = isX(M3), xm = xM || isX(m3), xp = xm || isX(p), anyX = xp;
      return gtlt === "=" && anyX && (gtlt = ""), pr = options.includePrerelease ? "-0" : "", xM ? gtlt === ">" || gtlt === "<" ? ret = "<0.0.0-0" : ret = "*" : gtlt && anyX ? (xm && (m3 = 0), p = 0, gtlt === ">" ? (gtlt = ">=", xm ? (M3 = +M3 + 1, m3 = 0, p = 0) : (m3 = +m3 + 1, p = 0)) : gtlt === "<=" && (gtlt = "<", xm ? M3 = +M3 + 1 : m3 = +m3 + 1), gtlt === "<" && (pr = "-0"), ret = `${gtlt + M3}.${m3}.${p}${pr}`) : xm ? ret = `>=${M3}.0.0${pr} <${+M3 + 1}.0.0-0` : xp && (ret = `>=${M3}.${m3}.0${pr} <${M3}.${+m3 + 1}.0-0`), debug2("xRange return", ret), ret;
    });
  }, "replaceXRange"), replaceStars = /* @__PURE__ */ __name((comp, options) => (debug2("replaceStars", comp, options), comp.trim().replace(re2[t3.STAR], "")), "replaceStars"), replaceGTE0 = /* @__PURE__ */ __name((comp, options) => (debug2("replaceGTE0", comp, options), comp.trim().replace(re2[options.includePrerelease ? t3.GTE0PRE : t3.GTE0], "")), "replaceGTE0"), hyphenReplace = /* @__PURE__ */ __name((incPr) => ($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr) => (isX(fM) ? from = "" : isX(fm) ? from = `>=${fM}.0.0${incPr ? "-0" : ""}` : isX(fp) ? from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}` : fpr ? from = `>=${from}` : from = `>=${from}${incPr ? "-0" : ""}`, isX(tM) ? to = "" : isX(tm) ? to = `<${+tM + 1}.0.0-0` : isX(tp) ? to = `<${tM}.${+tm + 1}.0-0` : tpr ? to = `<=${tM}.${tm}.${tp}-${tpr}` : incPr ? to = `<${tM}.${tm}.${+tp + 1}-0` : to = `<=${to}`, `${from} ${to}`.trim()), "hyphenReplace"), testSet = /* @__PURE__ */ __name((set3, version2, options) => {
    for (let i2 = 0; i2 < set3.length; i2++)
      if (!set3[i2].test(version2))
        return !1;
    if (version2.prerelease.length && !options.includePrerelease) {
      for (let i2 = 0; i2 < set3.length; i2++)
        if (debug2(set3[i2].semver), set3[i2].semver !== Comparator.ANY && set3[i2].semver.prerelease.length > 0) {
          const allowed = set3[i2].semver;
          if (allowed.major === version2.major && allowed.minor === version2.minor && allowed.patch === version2.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  }, "testSet");
  return range$4;
}
__name(requireRange, "requireRange");
const Range = requireRange(), satisfies = /* @__PURE__ */ __name((version2, range3, options) => {
  try {
    range3 = new Range(range3, options);
  } catch {
    return !1;
  }
  return range3.test(version2);
}, "satisfies");
var satisfies_1 = satisfies;
const satisfies$1 = /* @__PURE__ */ getDefaultExportFromCjs(satisfies_1), parse$2 = parse_1, valid$1 = /* @__PURE__ */ __name((version2, options) => {
  const v = parse$2(version2, options);
  return v ? v.version : null;
}, "valid$1");
var valid_1 = valid$1;
const valid$2 = /* @__PURE__ */ getDefaultExportFromCjs(valid_1), BROWSER_CHROME_ALLOWED_VERSIONS = "", BROWSER_FIREFOX_ALLOWED_VERSIONS = "", BROWSER_SAFARI_ALLOWED_VERSIONS = ">=14.x.x", BROWSER_OPERA_ALLOWED_VERSIONS = "", BROWSER_EDGE_ALLOWED_VERSIONS = "", BROWSER_IE_ALLOWED_VERSIONS = "<=0.0.0", browserMapper = {
  chrome: (version2) => satisfies$1(version2, BROWSER_CHROME_ALLOWED_VERSIONS),
  firefox: (version2) => satisfies$1(version2, BROWSER_FIREFOX_ALLOWED_VERSIONS),
  safari: (version2) => satisfies$1(version2, BROWSER_SAFARI_ALLOWED_VERSIONS),
  opera: (version2) => satisfies$1(version2, BROWSER_OPERA_ALLOWED_VERSIONS),
  edge: (version2) => satisfies$1(version2, BROWSER_EDGE_ALLOWED_VERSIONS),
  ie: (version2) => satisfies$1(version2, BROWSER_IE_ALLOWED_VERSIONS)
};
function determineBrowserSupport(mapper) {
  return ({ version: version2, name: name2 }) => !version2 || !name2 ? !1 : Object.keys(mapper).includes(name2) ? mapper[name2](version2) : !0;
}
__name(determineBrowserSupport, "determineBrowserSupport");
function isBrowserAccepted() {
  var _a3;
  return determineBrowserSupport(browserMapper)({
    name: ((_a3 = platform.name) == null ? void 0 : _a3.toLocaleLowerCase()) || "",
    version: valid$2(coerce$1(platform.version)) || ""
  });
}
__name(isBrowserAccepted, "isBrowserAccepted");
function getOperatingSystem() {
  var _a3, _b;
  const userAgent = platformExports.parse(window.navigator.userAgent), osFamily = (_a3 = userAgent.os) == null ? void 0 : _a3.family, currentOS = osFamily != null && osFamily.startsWith("Win") ? "windows" : "mac", osVersion = ((_b = userAgent.os) == null ? void 0 : _b.toString()) ?? "n/a";
  return {
    currentOS,
    osVersion
  };
}
__name(getOperatingSystem, "getOperatingSystem");
function getNextOS(currentOS) {
  return currentOS === "mac" ? "windows" : "mac";
}
__name(getNextOS, "getNextOS");
function getBrowser() {
  const userAgent = platformExports.parse(window.navigator.userAgent);
  return `Browser: ${userAgent.name} ${userAgent.version}`;
}
__name(getBrowser, "getBrowser");
const hexColorRegex = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
function hexToRgb(hex2) {
  if (!hexColorRegex.test(hex2))
    return [0, 0, 0];
  const formatted = hex2.replace("#", "");
  return [
    formatted.slice(0, 2),
    formatted.slice(2, 4),
    formatted.slice(4, 6)
  ].map((part) => parseInt(part, 16));
}
__name(hexToRgb, "hexToRgb");
function calcColorDistance(hexColorLeft, hexColorRight) {
  const [redLeft, greenLeft, blueLeft] = hexToRgb(hexColorLeft), [redRight, greenRight, blueRight] = hexToRgb(hexColorRight);
  return Math.sqrt(
    (redRight - redLeft) ** 2 + (greenRight - greenLeft) ** 2 + (blueRight - blueLeft) ** 2
  );
}
__name(calcColorDistance, "calcColorDistance");
function getClosestColor(customColor, list2) {
  return list2.map((hex2) => [
    hex2,
    calcColorDistance(hex2, customColor)
  ]).reduce(
    (acc, [hex2, distance2]) => distance2 < acc.distance ? { color: hex2, distance: distance2 } : acc,
    {
      color: "",
      distance: 1 / 0
    }
  );
}
__name(getClosestColor, "getClosestColor");
const countryISOMapping = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AN: "ANT",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BA: "BIH",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "XKX",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
}, getCountryISO3 = /* @__PURE__ */ __name((countryCode, defaultISO = "USA") => countryISOMapping[countryCode] || defaultISO, "getCountryISO3"), getFlagName = /* @__PURE__ */ __name((countryCode) => {
  const ISO3 = getCountryISO3(countryCode);
  return `Flag${ISO3.charAt(0).toUpperCase()}${ISO3.slice(1).toLowerCase()}`;
}, "getFlagName"), countriesPrefix = [
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL",
    region: "EMEA"
  },
  {
    name: "Afghanistan",
    dial_code: "+93",
    code: "AF",
    region: "EMEA"
  },
  {
    name: "Albania",
    dial_code: "+355",
    code: "AL",
    region: "EMEA"
  },
  {
    name: "Algeria",
    dial_code: "+213",
    code: "DZ",
    region: "EMEA"
  },
  {
    name: "AmericanSamoa",
    dial_code: "+1 684",
    code: "AS",
    region: "NA"
  },
  {
    name: "Andorra",
    dial_code: "+376",
    code: "AD",
    region: "EMEA"
  },
  {
    name: "Angola",
    dial_code: "+244",
    code: "AO",
    region: "EMEA"
  },
  {
    name: "Anguilla",
    dial_code: "+1 264",
    code: "AI",
    region: "EMEA"
  },
  {
    name: "Antigua and Barbuda",
    dial_code: "+1268",
    code: "AG",
    region: "EMEA"
  },
  {
    name: "Argentina",
    dial_code: "+54",
    code: "AR",
    region: "EMEA"
  },
  {
    name: "Armenia",
    dial_code: "+374",
    code: "AM",
    region: "EMEA"
  },
  {
    name: "Aruba",
    dial_code: "+297",
    code: "AW",
    region: "EMEA"
  },
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU",
    region: "APAC"
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT",
    region: "EMEA"
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ",
    region: "EMEA"
  },
  {
    name: "Bahamas",
    dial_code: "+1 242",
    code: "BS",
    region: "EMEA"
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    region: "EMEA"
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD",
    region: "APAC"
  },
  {
    name: "Barbados",
    dial_code: "+1 246",
    code: "BB",
    region: "EMEA"
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY",
    region: "EMEA"
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE",
    region: "EMEA"
  },
  {
    name: "Belize",
    dial_code: "+501",
    code: "BZ",
    region: "EMEA"
  },
  {
    name: "Benin",
    dial_code: "+229",
    code: "BJ",
    region: "EMEA"
  },
  {
    name: "Bermuda",
    dial_code: "+1 441",
    code: "BM",
    region: "EMEA"
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT",
    region: "APAC"
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    code: "BA",
    region: "EMEA"
  },
  {
    name: "Botswana",
    dial_code: "+267",
    code: "BW",
    region: "EMEA"
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR",
    region: "EMEA"
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    code: "IO",
    region: "EMEA"
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG",
    region: "EMEA"
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    code: "BF",
    region: "EMEA"
  },
  {
    name: "Burundi",
    dial_code: "+257",
    code: "BI",
    region: "EMEA"
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH",
    region: "APAC"
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    code: "CM",
    region: "EMEA"
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA",
    region: "NA"
  },
  {
    name: "Cape Verde",
    dial_code: "+238",
    code: "CV",
    region: "EMEA"
  },
  {
    name: "Cayman Islands",
    dial_code: "+ 345",
    code: "KY",
    region: "EMEA"
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    code: "CF",
    region: "EMEA"
  },
  {
    name: "Chad",
    dial_code: "+235",
    code: "TD",
    region: "EMEA"
  },
  {
    name: "Chile",
    dial_code: "+56",
    code: "CL",
    region: "EMEA"
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN",
    region: "APAC"
  },
  {
    name: "Christmas Island",
    dial_code: "+61",
    code: "CX",
    region: "APAC"
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO",
    region: "EMEA"
  },
  {
    name: "Comoros",
    dial_code: "+269",
    code: "KM",
    region: "EMEA"
  },
  {
    name: "Congo",
    dial_code: "+242",
    code: "CG",
    region: "EMEA"
  },
  {
    name: "Cook Islands",
    dial_code: "+682",
    code: "CK",
    region: "APAC"
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    code: "CR",
    region: "EMEA"
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR",
    region: "EMEA"
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU",
    region: "EMEA"
  },
  {
    name: "Cyprus",
    dial_code: "+357",
    code: "CY",
    region: "EMEA"
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    code: "CZ",
    region: "EMEA"
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK",
    region: "EMEA"
  },
  {
    name: "Djibouti",
    dial_code: "+253",
    code: "DJ",
    region: "EMEA"
  },
  {
    name: "Dominica",
    dial_code: "+1 767",
    code: "DM",
    region: "EMEA"
  },
  {
    name: "Dominican Republic",
    dial_code: "+1 849",
    code: "DO",
    region: "EMEA"
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC",
    region: "EMEA"
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG",
    region: "EMEA"
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV",
    region: "EMEA"
  },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    code: "GQ",
    region: "EMEA"
  },
  {
    name: "Eritrea",
    dial_code: "+291",
    code: "ER",
    region: "EMEA"
  },
  {
    name: "Estonia",
    dial_code: "+372",
    code: "EE",
    region: "EMEA"
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET",
    region: "EMEA"
  },
  {
    name: "Faroe Islands",
    dial_code: "+298",
    code: "FO",
    region: "EMEA"
  },
  {
    name: "Fiji",
    dial_code: "+679",
    code: "FJ",
    region: "APAC"
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI",
    region: "EMEA"
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR",
    region: "EMEA"
  },
  {
    name: "French Guiana",
    dial_code: "+594",
    code: "GF",
    region: "EMEA"
  },
  {
    name: "French Polynesia",
    dial_code: "+689",
    code: "PF",
    region: "EMEA"
  },
  {
    name: "Gabon",
    dial_code: "+241",
    code: "GA",
    region: "EMEA"
  },
  {
    name: "Gambia",
    dial_code: "+220",
    code: "GM",
    region: "EMEA"
  },
  {
    name: "Georgia",
    dial_code: "+995",
    code: "GE",
    region: "EMEA"
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
    region: "EMEA"
  },
  {
    name: "Ghana",
    dial_code: "+233",
    code: "GH",
    region: "EMEA"
  },
  {
    name: "Gibraltar",
    dial_code: "+350",
    code: "GI",
    region: "EMEA"
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR",
    region: "EMEA"
  },
  {
    name: "Greenland",
    dial_code: "+299",
    code: "GL",
    region: "EMEA"
  },
  {
    name: "Grenada",
    dial_code: "+1 473",
    code: "GD",
    region: "EMEA"
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    code: "GP",
    region: "EMEA"
  },
  {
    name: "Guam",
    dial_code: "+1 671",
    code: "GU",
    region: "APAC"
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT",
    region: "EMEA"
  },
  {
    name: "Guinea",
    dial_code: "+224",
    code: "GN",
    region: "EMEA"
  },
  {
    name: "Guinea-Bissau",
    dial_code: "+245",
    code: "GW",
    region: "EMEA"
  },
  {
    name: "Guyana",
    dial_code: "+595",
    code: "GY",
    region: "EMEA"
  },
  {
    name: "Haiti",
    dial_code: "+509",
    code: "HT",
    region: "EMEA"
  },
  {
    name: "Heard and McDonald Islands",
    dial_code: "+672",
    code: "HM",
    region: "EMEA"
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
    region: "EMEA"
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU",
    region: "EMEA"
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS",
    region: "EMEA"
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
    region: "APAC"
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID",
    region: "APAC"
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ",
    region: "EMEA"
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE",
    region: "EMEA"
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT",
    region: "EMEA"
  },
  {
    name: "Jamaica",
    dial_code: "+1 876",
    code: "JM",
    region: "EMEA"
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP",
    region: "APAC"
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO",
    region: "EMEA"
  },
  {
    name: "Kosovo",
    dial_code: "+383",
    code: "XK",
    region: "EMEA"
  },
  {
    name: "Kazakhstan",
    dial_code: "+7 7",
    code: "KZ",
    region: "EMEA"
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE",
    region: "EMEA"
  },
  {
    name: "Kiribati",
    dial_code: "+686",
    code: "KI",
    region: "APAC"
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    region: "EMEA"
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG",
    region: "EMEA"
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV",
    region: "EMEA"
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB",
    region: "EMEA"
  },
  {
    name: "Lesotho",
    dial_code: "+266",
    code: "LS",
    region: "EMEA"
  },
  {
    name: "Liberia",
    dial_code: "+231",
    code: "LR",
    region: "EMEA"
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
    region: "EMEA"
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT",
    region: "EMEA"
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU",
    region: "EMEA"
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    code: "MG",
    region: "EMEA"
  },
  {
    name: "Malawi",
    dial_code: "+265",
    code: "MW",
    region: "EMEA"
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
    region: "APAC"
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV",
    region: "APAC"
  },
  {
    name: "Mali",
    dial_code: "+223",
    code: "ML",
    region: "EMEA"
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT",
    region: "EMEA"
  },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    code: "MH",
    region: "NA"
  },
  {
    name: "Martinique",
    dial_code: "+596",
    code: "MQ",
    region: "EMEA"
  },
  {
    name: "Mauritania",
    dial_code: "+222",
    code: "MR",
    region: "EMEA"
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    code: "MU",
    region: "EMEA"
  },
  {
    name: "Mayotte",
    dial_code: "+262",
    code: "YT",
    region: "EMEA"
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX",
    region: "EMEA"
  },
  {
    name: "Monaco",
    dial_code: "+377",
    code: "MC",
    region: "EMEA"
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN",
    region: "APAC"
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME",
    region: "EMEA"
  },
  {
    name: "Montserrat",
    dial_code: "+1664",
    code: "MS",
    region: "EMEA"
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA",
    region: "EMEA"
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM",
    region: "APAC"
  },
  {
    name: "Namibia",
    dial_code: "+264",
    code: "NA",
    region: "EMEA"
  },
  {
    name: "Nauru",
    dial_code: "+674",
    code: "NR",
    region: "APAC"
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP",
    region: "APAC"
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL",
    region: "EMEA"
  },
  {
    name: "Netherlands Antilles",
    dial_code: "+599",
    code: "AN",
    region: "EMEA"
  },
  {
    name: "New Caledonia",
    dial_code: "+687",
    code: "NC",
    region: "EMEA"
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ",
    region: "APAC"
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI",
    region: "EMEA"
  },
  {
    name: "Niger",
    dial_code: "+227",
    code: "NE",
    region: "EMEA"
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG",
    region: "EMEA"
  },
  {
    name: "Niue",
    dial_code: "+683",
    code: "NU",
    region: "APAC"
  },
  {
    name: "Norfolk Island",
    dial_code: "+672",
    code: "NF",
    region: "APAC"
  },
  {
    name: "Northern Mariana Islands",
    dial_code: "+1 670",
    code: "MP",
    region: "APAC"
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO",
    region: "EMEA"
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    region: "EMEA"
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    region: "APAC"
  },
  {
    name: "Palau",
    dial_code: "+680",
    code: "PW",
    region: "APAC"
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA",
    region: "EMEA"
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG",
    region: "APAC"
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
    region: "EMEA"
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE",
    region: "EMEA"
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH",
    region: "APAC"
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL",
    region: "EMEA"
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT",
    region: "EMEA"
  },
  {
    name: "Puerto Rico",
    dial_code: "+1 939",
    code: "PR",
    region: "NA"
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    region: "EMEA"
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO",
    region: "EMEA"
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW",
    region: "EMEA"
  },
  {
    name: "Samoa",
    dial_code: "+685",
    code: "WS",
    region: "APAC"
  },
  {
    name: "San Marino",
    dial_code: "+378",
    code: "SM",
    region: "EMEA"
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    region: "EMEA"
  },
  {
    name: "Senegal",
    dial_code: "+221",
    code: "SN",
    region: "EMEA"
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS",
    region: "EMEA"
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    code: "SC",
    region: "EMEA"
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL",
    region: "EMEA"
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
    region: "APAC"
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    code: "SK",
    region: "EMEA"
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI",
    region: "EMEA"
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB",
    region: "APAC"
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA",
    region: "EMEA"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dial_code: "+500",
    code: "GS",
    region: "EMEA"
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES",
    region: "EMEA"
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
    region: "APAC"
  },
  {
    name: "Sudan",
    dial_code: "+249",
    code: "SD",
    region: "EMEA"
  },
  {
    name: "Suriname",
    dial_code: "+597",
    code: "SR",
    region: "EMEA"
  },
  {
    name: "Swaziland",
    dial_code: "+268",
    code: "SZ",
    region: "EMEA"
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE",
    region: "EMEA"
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH",
    region: "EMEA"
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ",
    region: "EMEA"
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH",
    region: "APAC"
  },
  {
    name: "Togo",
    dial_code: "+228",
    code: "TG",
    region: "EMEA"
  },
  {
    name: "Tokelau",
    dial_code: "+690",
    code: "TK",
    region: "APAC"
  },
  {
    name: "Tonga",
    dial_code: "+676",
    code: "TO",
    region: "APAC"
  },
  {
    name: "Trinidad and Tobago",
    dial_code: "+1 868",
    code: "TT",
    region: "EMEA"
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN",
    region: "EMEA"
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
    region: "EMEA"
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM",
    region: "EMEA"
  },
  {
    name: "Turks and Caicos Islands",
    dial_code: "+1 649",
    code: "TC",
    region: "EMEA"
  },
  {
    name: "Tuvalu",
    dial_code: "+688",
    code: "TV",
    region: "APAC"
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG",
    region: "EMEA"
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA",
    region: "EMEA"
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
    region: "EMEA"
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    code: "GB",
    region: "EMEA"
  },
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
    region: "NA"
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY",
    region: "EMEA"
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ",
    region: "EMEA"
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    code: "VU",
    region: "EMEA"
  },
  {
    name: "Wallis and Futuna",
    dial_code: "+681",
    code: "WF",
    region: "EMEA"
  },
  {
    name: "Yemen",
    dial_code: "+967",
    code: "YE",
    region: "EMEA"
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM",
    region: "EMEA"
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW",
    region: "EMEA"
  },
  {
    name: "Antarctica",
    dial_code: null,
    code: "AQ",
    region: "EMEA"
  },
  {
    name: "Bolivia, Plurinational State of",
    dial_code: "+591",
    code: "BO",
    region: "EMEA"
  },
  {
    name: "Brunei Darussalam",
    dial_code: "+673",
    code: "BN",
    region: "APAC"
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "+61",
    code: "CC",
    region: "APAC"
  },
  {
    name: "Congo, The Democratic Republic of the",
    dial_code: "+243",
    code: "CD",
    region: "EMEA"
  },
  {
    name: "Cote d'Ivoire",
    dial_code: "+225",
    code: "CI",
    region: "EMEA"
  },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "+500",
    code: "FK",
    region: "EMEA"
  },
  {
    name: "Guernsey",
    dial_code: "+44",
    code: "GG",
    region: "EMEA"
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "+379",
    code: "VA",
    region: "EMEA"
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK",
    region: "APAC"
  },
  {
    name: "Iran, Islamic Republic of",
    dial_code: "+98",
    code: "IR",
    region: "EMEA"
  },
  {
    name: "Isle of Man",
    dial_code: "+44",
    code: "IM",
    region: "EMEA"
  },
  {
    name: "Jersey",
    dial_code: "+44",
    code: "JE",
    region: "EMEA"
  },
  {
    name: "Korea, Democratic People's Republic of",
    dial_code: "+850",
    code: "KP",
    region: "APAC"
  },
  {
    name: "Korea, Republic of",
    dial_code: "+82",
    code: "KR",
    region: "APAC"
  },
  {
    name: "Lao People's Democratic Republic",
    dial_code: "+856",
    code: "LA",
    region: "APAC"
  },
  {
    name: "Libyan Arab Jamahiriya",
    dial_code: "+218",
    code: "LY",
    region: "EMEA"
  },
  {
    name: "Macao",
    dial_code: "+853",
    code: "MO",
    region: "EMEA"
  },
  {
    name: "Macedonia, The Former Yugoslav Republic of",
    dial_code: "+389",
    code: "MK",
    region: "EMEA"
  },
  {
    name: "Micronesia, Federated States of",
    dial_code: "+691",
    code: "FM",
    region: "APAC"
  },
  {
    name: "Moldova, Republic of",
    dial_code: "+373",
    code: "MD",
    region: "EMEA"
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    code: "MZ",
    region: "EMEA"
  },
  {
    name: "Palestinian Territory, Occupied",
    dial_code: "+970",
    code: "PS",
    region: "EMEA"
  },
  {
    name: "Pitcairn",
    dial_code: "+872",
    code: "PN",
    region: "APAC"
  },
  {
    name: "Réunion",
    dial_code: "+262",
    code: "RE",
    region: "EMEA"
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU",
    region: "EMEA"
  },
  {
    name: "Saint Barthélemy",
    dial_code: "+590",
    code: "BL",
    region: "EMEA"
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "+290",
    code: "SH",
    region: "EMEA"
  },
  {
    name: "Saint Kitts and Nevis",
    dial_code: "+1 869",
    code: "KN",
    region: "EMEA"
  },
  {
    name: "Saint Lucia",
    dial_code: "+1 758",
    code: "LC",
    region: "EMEA"
  },
  {
    name: "Saint Martin",
    dial_code: "+590",
    code: "MF",
    region: "EMEA"
  },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "+508",
    code: "PM",
    region: "EMEA"
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "+1 784",
    code: "VC",
    region: "EMEA"
  },
  {
    name: "Sao Tome and Principe",
    dial_code: "+239",
    code: "ST",
    region: "EMEA"
  },
  {
    name: "Somalia",
    dial_code: "+252",
    code: "SO",
    region: "EMEA"
  },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "+47",
    code: "SJ",
    region: "EMEA"
  },
  {
    name: "Syrian Arab Republic",
    dial_code: "+963",
    code: "SY",
    region: "EMEA"
  },
  {
    name: "Taiwan, Province of China",
    dial_code: "+886",
    code: "TW",
    region: "APAC"
  },
  {
    name: "Tanzania, United Republic of",
    dial_code: "+255",
    code: "TZ",
    region: "EMEA"
  },
  {
    name: "Timor-Leste",
    dial_code: "+670",
    code: "TL",
    region: "EMEA"
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    dial_code: "+58",
    code: "VE",
    region: "EMEA"
  },
  {
    name: "Viet Nam",
    dial_code: "+84",
    code: "VN",
    region: "APAC"
  },
  {
    name: "Virgin Islands, British",
    dial_code: "+1 284",
    code: "VG",
    region: "EMEA"
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "+1 340",
    code: "VI",
    region: "NA"
  }
], US = [
  {
    name: "Alabama",
    code: "AL"
  },
  {
    name: "Alaska",
    code: "AK"
  },
  {
    name: "Arizona",
    code: "AZ"
  },
  {
    name: "Arkansas",
    code: "AR"
  },
  {
    name: "California",
    code: "CA"
  },
  {
    name: "Colorado",
    code: "CO"
  },
  {
    name: "Connecticut",
    code: "CT"
  },
  {
    name: "Delaware",
    code: "DE"
  },
  {
    name: "District of Columbia",
    code: "DC"
  },
  {
    name: "Florida",
    code: "FL"
  },
  {
    name: "Georgia",
    code: "GA"
  },
  {
    name: "Hawaii",
    code: "HI"
  },
  {
    name: "Idaho",
    code: "ID"
  },
  {
    name: "Illinois",
    code: "IL"
  },
  {
    name: "Indiana",
    code: "IN"
  },
  {
    name: "Iowa",
    code: "IA"
  },
  {
    name: "Kansas",
    code: "KS"
  },
  {
    name: "Kentucky",
    code: "KY"
  },
  {
    name: "Louisiana",
    code: "LA"
  },
  {
    name: "Maine",
    code: "ME"
  },
  {
    name: "Maryland",
    code: "MD"
  },
  {
    name: "Massachusetts",
    code: "MA"
  },
  {
    name: "Michigan",
    code: "MI"
  },
  {
    name: "Minnesota",
    code: "MN"
  },
  {
    name: "Mississippi",
    code: "MS"
  },
  {
    name: "Missouri",
    code: "MO"
  },
  {
    name: "Montana",
    code: "MT"
  },
  {
    name: "Nebraska",
    code: "NE"
  },
  {
    name: "Nevada",
    code: "NV"
  },
  {
    name: "New Hampshire",
    code: "NH"
  },
  {
    name: "New Jersey",
    code: "NJ"
  },
  {
    name: "New Mexico",
    code: "NM"
  },
  {
    name: "New York",
    code: "NY"
  },
  {
    name: "North Carolina",
    code: "NC"
  },
  {
    name: "North Dakota",
    code: "ND"
  },
  {
    name: "Ohio",
    code: "OH"
  },
  {
    name: "Oklahoma",
    code: "OK"
  },
  {
    name: "Oregon",
    code: "OR"
  },
  {
    name: "Pennsylvania",
    code: "PA"
  },
  {
    name: "Rhode Island",
    code: "RI"
  },
  {
    name: "South Carolina",
    code: "SC"
  },
  {
    name: "South Dakota",
    code: "SD"
  },
  {
    name: "Tennessee",
    code: "TN"
  },
  {
    name: "Texas",
    code: "TX"
  },
  {
    name: "Utah",
    code: "UT"
  },
  {
    name: "Vermont",
    code: "VT"
  },
  {
    name: "Virginia",
    code: "VA"
  },
  {
    name: "Washington",
    code: "WA"
  },
  {
    name: "West Virginia",
    code: "WV"
  },
  {
    name: "Wisconsin",
    code: "WI"
  },
  {
    name: "Wyoming",
    code: "WY"
  }
], AU = [
  {
    name: "New South Wales",
    code: "NSW"
  },
  {
    name: "Queensland",
    code: "QLD"
  },
  {
    name: "South Australia",
    code: "SA"
  },
  {
    name: "Tasmania",
    code: "TAS"
  },
  {
    name: "Victoria",
    code: "VIC"
  },
  {
    name: "Western Australia",
    code: "WA"
  }
], countriesStates = {
  US,
  AU
}, TRIAL_PLANS = ["trial", "trial_transition"];
function checkIsCompanyInTrial(company) {
  return !!company.isTrial && TRIAL_PLANS.includes(company.plan);
}
__name(checkIsCompanyInTrial, "checkIsCompanyInTrial");
var CURRENCIES = /* @__PURE__ */ ((CURRENCIES2) => (CURRENCIES2.EUR = "EUR", CURRENCIES2.USD = "USD", CURRENCIES2.AUD = "AUD", CURRENCIES2.GBP = "GBP", CURRENCIES2))(CURRENCIES || {});
const CURRENCIES_SYMBOLS = {
  EUR: "€",
  USD: "$",
  AUD: "$",
  GBP: "£"
}, countriesCurrenciesMapping = [
  {
    country: "Afghanistan",
    prefixCode: "93",
    countryCode: "AF",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Albania",
    prefixCode: "355",
    countryCode: "AL",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Algeria",
    prefixCode: "213",
    countryCode: "DZ",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "AmericanSamoa",
    prefixCode: "+1 684",
    countryCode: "AS",
    currency: CURRENCIES.USD
  },
  {
    country: "Andorra",
    prefixCode: "376",
    countryCode: "AD",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Angola",
    prefixCode: "244",
    countryCode: "AO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Anguilla",
    prefixCode: "+1 264",
    countryCode: "AI",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Antarctica",
    prefixCode: "null",
    countryCode: "AQ",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Antigua and Barbuda",
    prefixCode: "1268",
    countryCode: "AG",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Argentina",
    prefixCode: "54",
    countryCode: "AR",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Armenia",
    prefixCode: "374",
    countryCode: "AM",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Aruba",
    prefixCode: "297",
    countryCode: "AW",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Australia",
    prefixCode: "61",
    countryCode: "AU",
    currency: CURRENCIES.AUD
  },
  {
    country: "Austria",
    prefixCode: "43",
    countryCode: "AT",
    currency: CURRENCIES.EUR
  },
  {
    country: "Azerbaijan",
    prefixCode: "994",
    countryCode: "AZ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Bahamas",
    prefixCode: "+1 242",
    countryCode: "BS",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Bahrain",
    prefixCode: "973",
    countryCode: "BH",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Bangladesh",
    prefixCode: "880",
    countryCode: "BD",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Barbados",
    prefixCode: "+1 246",
    countryCode: "BB",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Belarus",
    prefixCode: "375",
    countryCode: "BY",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Belgium",
    prefixCode: "32",
    countryCode: "BE",
    currency: CURRENCIES.EUR
  },
  {
    country: "Belize",
    prefixCode: "501",
    countryCode: "BZ",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Benin",
    prefixCode: "229",
    countryCode: "BJ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Bermuda",
    prefixCode: "+1 441",
    countryCode: "BM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Bhutan",
    prefixCode: "975",
    countryCode: "BT",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Bolivia, Plurinational State of",
    prefixCode: "591",
    countryCode: "BO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Bosnia and Herzegovina",
    prefixCode: "387",
    countryCode: "BA",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Botswana",
    prefixCode: "267",
    countryCode: "BW",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Brazil",
    prefixCode: "55",
    countryCode: "BR",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "British Indian Ocean Territory",
    prefixCode: "246",
    countryCode: "IO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Brunei Darussalam",
    prefixCode: "673",
    countryCode: "BN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Bulgaria",
    prefixCode: "359",
    countryCode: "BG",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Burkina Faso",
    prefixCode: "226",
    countryCode: "BF",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Burundi",
    prefixCode: "257",
    countryCode: "BI",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Cambodia",
    prefixCode: "855",
    countryCode: "KH",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Cameroon",
    prefixCode: "237",
    countryCode: "CM",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Canada",
    prefixCode: "1",
    countryCode: "CA",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Cape Verde",
    prefixCode: "238",
    countryCode: "CV",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Cayman Islands",
    prefixCode: "345",
    countryCode: "KY",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Central African Republic",
    prefixCode: "236",
    countryCode: "CF",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Chad",
    prefixCode: "235",
    countryCode: "TD",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Chile",
    prefixCode: "56",
    countryCode: "CL",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "China",
    prefixCode: "86",
    countryCode: "CN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Christmas Island",
    prefixCode: "61",
    countryCode: "CX",
    currency: CURRENCIES.AUD
  },
  {
    country: "Cocos (Keeling) Islands",
    prefixCode: "61",
    countryCode: "CC",
    currency: CURRENCIES.AUD
  },
  {
    country: "Colombia",
    prefixCode: "57",
    countryCode: "CO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Comoros",
    prefixCode: "269",
    countryCode: "KM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Congo",
    prefixCode: "242",
    countryCode: "CG",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Congo, The Democratic Republic of the",
    prefixCode: "243",
    countryCode: "CD",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Cook Islands",
    prefixCode: "682",
    countryCode: "CK",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Costa Rica",
    prefixCode: "506",
    countryCode: "CR",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Cote d'Ivoire",
    prefixCode: "225",
    countryCode: "CI",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Croatia",
    prefixCode: "385",
    countryCode: "HR",
    currency: CURRENCIES.EUR
  },
  {
    country: "Cuba",
    prefixCode: "53",
    countryCode: "CU",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Cyprus",
    prefixCode: "357",
    countryCode: "CY",
    currency: CURRENCIES.EUR
  },
  {
    country: "Czech Republic",
    prefixCode: "420",
    countryCode: "CZ",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Denmark",
    prefixCode: "45",
    countryCode: "DK",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Djibouti",
    prefixCode: "253",
    countryCode: "DJ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Dominica",
    prefixCode: "+1 767",
    countryCode: "DM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Dominican Republic",
    prefixCode: "+1 849",
    countryCode: "DO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Ecuador",
    prefixCode: "593",
    countryCode: "EC",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Egypt",
    prefixCode: "20",
    countryCode: "EG",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "El Salvador",
    prefixCode: "503",
    countryCode: "SV",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Equatorial Guinea",
    prefixCode: "240",
    countryCode: "GQ",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Eritrea",
    prefixCode: "291",
    countryCode: "ER",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Estonia",
    prefixCode: "372",
    countryCode: "EE",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Ethiopia",
    prefixCode: "251",
    countryCode: "ET",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Falkland Islands (Malvinas)",
    prefixCode: "500",
    countryCode: "FK",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Faroe Islands",
    prefixCode: "298",
    countryCode: "FO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Fiji",
    prefixCode: "679",
    countryCode: "FJ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Finland",
    prefixCode: "358",
    countryCode: "FI",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "France",
    prefixCode: "33",
    countryCode: "FR",
    currency: CURRENCIES.EUR
  },
  {
    country: "French Guiana",
    prefixCode: "594",
    countryCode: "GF",
    currency: CURRENCIES.EUR
  },
  {
    country: "French Polynesia",
    prefixCode: "689",
    countryCode: "PF",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Gabon",
    prefixCode: "241",
    countryCode: "GA",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Gambia",
    prefixCode: "220",
    countryCode: "GM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Georgia",
    prefixCode: "995",
    countryCode: "GE",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Germany",
    prefixCode: "49",
    countryCode: "DE",
    currency: CURRENCIES.EUR
  },
  {
    country: "Ghana",
    prefixCode: "233",
    countryCode: "GH",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Gibraltar",
    prefixCode: "350",
    countryCode: "GI",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Greece",
    prefixCode: "30",
    countryCode: "GR",
    currency: CURRENCIES.EUR
  },
  {
    country: "Greenland",
    prefixCode: "299",
    countryCode: "GL",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Grenada",
    prefixCode: "+1 473",
    countryCode: "GD",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Guadeloupe",
    prefixCode: "590",
    countryCode: "GP",
    currency: CURRENCIES.EUR
  },
  {
    country: "Guam",
    prefixCode: "+1 671",
    countryCode: "GU",
    currency: CURRENCIES.USD
  },
  {
    country: "Guatemala",
    prefixCode: "502",
    countryCode: "GT",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Guernsey",
    prefixCode: "44",
    countryCode: "GG",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Guinea",
    prefixCode: "224",
    countryCode: "GN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Guinea-Bissau",
    prefixCode: "245",
    countryCode: "GW",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Guyana",
    prefixCode: "595",
    countryCode: "GY",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Haiti",
    prefixCode: "509",
    countryCode: "HT",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Heard and McDonald Islands",
    prefixCode: "672",
    countryCode: "HM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Holy See (Vatican City State)",
    prefixCode: "379",
    countryCode: "VA",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Honduras",
    prefixCode: "504",
    countryCode: "HN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Hong Kong",
    prefixCode: "852",
    countryCode: "HK",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Hungary",
    prefixCode: "36",
    countryCode: "HU",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Iceland",
    prefixCode: "354",
    countryCode: "IS",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "India",
    prefixCode: "91",
    countryCode: "IN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Indonesia",
    prefixCode: "62",
    countryCode: "ID",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Iran, Islamic Republic of",
    prefixCode: "98",
    countryCode: "IR",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Iraq",
    prefixCode: "964",
    countryCode: "IQ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Ireland",
    prefixCode: "353",
    countryCode: "IE",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Isle of Man",
    prefixCode: "44",
    countryCode: "IM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Israel",
    prefixCode: "972",
    countryCode: "IL",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Italy",
    prefixCode: "39",
    countryCode: "IT",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Jamaica",
    prefixCode: "+1 876",
    countryCode: "JM",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Japan",
    prefixCode: "81",
    countryCode: "JP",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Jersey",
    prefixCode: "44",
    countryCode: "JE",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Jordan",
    prefixCode: "962",
    countryCode: "JO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Kazakhstan",
    prefixCode: "+7 7",
    countryCode: "KZ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Kenya",
    prefixCode: "254",
    countryCode: "KE",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Kiribati",
    prefixCode: "686",
    countryCode: "KI",
    currency: CURRENCIES.AUD,
    currency2: CURRENCIES.USD
  },
  {
    country: "Korea, Democratic People's Republic of",
    prefixCode: "850",
    countryCode: "KP",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Korea, Republic of",
    prefixCode: "82",
    countryCode: "KR",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Kosovo",
    prefixCode: "383",
    countryCode: "XK",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Kuwait",
    prefixCode: "965",
    countryCode: "KW",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Kyrgyzstan",
    prefixCode: "996",
    countryCode: "KG",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Lao People's Democratic Republic",
    prefixCode: "856",
    countryCode: "LA",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Latvia",
    prefixCode: "371",
    countryCode: "LV",
    currency: CURRENCIES.EUR
  },
  {
    country: "Lebanon",
    prefixCode: "961",
    countryCode: "LB",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Lesotho",
    prefixCode: "266",
    countryCode: "LS",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Liberia",
    prefixCode: "231",
    countryCode: "LR",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Libyan Arab Jamahiriya",
    prefixCode: "218",
    countryCode: "LY",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Liechtenstein",
    prefixCode: "423",
    countryCode: "LI",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Lithuania",
    prefixCode: "370",
    countryCode: "LT",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Luxembourg",
    prefixCode: "352",
    countryCode: "LU",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Macao",
    prefixCode: "853",
    countryCode: "MO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Macedonia, The Former Yugoslav Republic of",
    prefixCode: "389",
    countryCode: "MK",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Madagascar",
    prefixCode: "261",
    countryCode: "MG",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Malawi",
    prefixCode: "265",
    countryCode: "MW",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Malaysia",
    prefixCode: "60",
    countryCode: "MY",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Maldives",
    prefixCode: "960",
    countryCode: "MV",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Mali",
    prefixCode: "223",
    countryCode: "ML",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Malta",
    prefixCode: "356",
    countryCode: "MT",
    currency: CURRENCIES.EUR
  },
  {
    country: "Marshall Islands",
    prefixCode: "692",
    countryCode: "MH",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Martinique",
    prefixCode: "596",
    countryCode: "MQ",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Mauritania",
    prefixCode: "222",
    countryCode: "MR",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Mauritius",
    prefixCode: "230",
    countryCode: "MU",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Mayotte",
    prefixCode: "262",
    countryCode: "YT",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Mexico",
    prefixCode: "52",
    countryCode: "MX",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Micronesia, Federated States of",
    prefixCode: "691",
    countryCode: "FM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Moldova, Republic of",
    prefixCode: "373",
    countryCode: "MD",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Monaco",
    prefixCode: "377",
    countryCode: "MC",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Mongolia",
    prefixCode: "976",
    countryCode: "MN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Montenegro",
    prefixCode: "382",
    countryCode: "ME",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Montserrat",
    prefixCode: "1664",
    countryCode: "MS",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Morocco",
    prefixCode: "212",
    countryCode: "MA",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Mozambique",
    prefixCode: "258",
    countryCode: "MZ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Myanmar",
    prefixCode: "95",
    countryCode: "MM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Namibia",
    prefixCode: "264",
    countryCode: "NA",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Nauru",
    prefixCode: "674",
    countryCode: "NR",
    currency: CURRENCIES.AUD,
    currency2: CURRENCIES.USD
  },
  {
    country: "Nepal",
    prefixCode: "977",
    countryCode: "NP",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Netherlands",
    prefixCode: "31",
    countryCode: "NL",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Netherlands Antilles",
    prefixCode: "599",
    countryCode: "AN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.USD
  },
  {
    country: "New Caledonia",
    prefixCode: "687",
    countryCode: "NC",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "New Zealand",
    prefixCode: "64",
    countryCode: "NZ",
    currency: CURRENCIES.AUD,
    currency2: CURRENCIES.USD
  },
  {
    country: "Nicaragua",
    prefixCode: "505",
    countryCode: "NI",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Niger",
    prefixCode: "227",
    countryCode: "NE",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Nigeria",
    prefixCode: "234",
    countryCode: "NG",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Niue",
    prefixCode: "683",
    countryCode: "NU",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Norfolk Island",
    prefixCode: "672",
    countryCode: "NF",
    currency: CURRENCIES.AUD
  },
  {
    country: "Northern Mariana Islands",
    prefixCode: "+1 670",
    countryCode: "MP",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Norway",
    prefixCode: "47",
    countryCode: "NO",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Oman",
    prefixCode: "968",
    countryCode: "OM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Pakistan",
    prefixCode: "92",
    countryCode: "PK",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Palau",
    prefixCode: "680",
    countryCode: "PW",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Palestinian Territory, Occupied",
    prefixCode: "970",
    countryCode: "PS",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Panama",
    prefixCode: "507",
    countryCode: "PA",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Papua New Guinea",
    prefixCode: "675",
    countryCode: "PG",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Paraguay",
    prefixCode: "595",
    countryCode: "PY",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Peru",
    prefixCode: "51",
    countryCode: "PE",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Philippines",
    prefixCode: "63",
    countryCode: "PH",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Pitcairn",
    prefixCode: "872",
    countryCode: "PN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Poland",
    prefixCode: "48",
    countryCode: "PL",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Portugal",
    prefixCode: "351",
    countryCode: "PT",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Puerto Rico",
    prefixCode: "+1 939",
    countryCode: "PR",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.USD
  },
  {
    country: "Qatar",
    prefixCode: "974",
    countryCode: "QA",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Reunion",
    prefixCode: "262",
    countryCode: "RE",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Romania",
    prefixCode: "40",
    countryCode: "RO",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Russia",
    prefixCode: "7",
    countryCode: "RU",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Rwanda",
    prefixCode: "250",
    countryCode: "RW",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Saint Barth√©lemy",
    prefixCode: "590",
    countryCode: "BL",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Saint Helena, Ascension and Tristan Da Cunha",
    prefixCode: "290",
    countryCode: "SH",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Saint Kitts and Nevis",
    prefixCode: "+1 869",
    countryCode: "KN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Saint Lucia",
    prefixCode: "+1 758",
    countryCode: "LC",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Saint Martin",
    prefixCode: "590",
    countryCode: "MF",
    currency: CURRENCIES.EUR
  },
  {
    country: "Saint Pierre and Miquelon",
    prefixCode: "508",
    countryCode: "PM",
    currency: CURRENCIES.EUR
  },
  {
    country: "Saint Vincent and the Grenadines",
    prefixCode: "+1 784",
    countryCode: "VC",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Samoa",
    prefixCode: "685",
    countryCode: "WS",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "San Marino",
    prefixCode: "378",
    countryCode: "SM",
    currency: CURRENCIES.EUR
  },
  {
    country: "Sao Tome and Principe",
    prefixCode: "239",
    countryCode: "ST",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Saudi Arabia",
    prefixCode: "966",
    countryCode: "SA",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Senegal",
    prefixCode: "221",
    countryCode: "SN",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Serbia",
    prefixCode: "381",
    countryCode: "RS",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Seychelles",
    prefixCode: "248",
    countryCode: "SC",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Sierra Leone",
    prefixCode: "232",
    countryCode: "SL",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Singapore",
    prefixCode: "65",
    countryCode: "SG",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Slovakia",
    prefixCode: "421",
    countryCode: "SK",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Slovenia",
    prefixCode: "386",
    countryCode: "SI",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Solomon Islands",
    prefixCode: "677",
    countryCode: "SB",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Somalia",
    prefixCode: "252",
    countryCode: "SO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "South Africa",
    prefixCode: "27",
    countryCode: "ZA",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "South Georgia and the South Sandwich Islands",
    prefixCode: "500",
    countryCode: "GS",
    currency: CURRENCIES.GBP
  },
  {
    country: "Spain",
    prefixCode: "34",
    countryCode: "ES",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Sri Lanka",
    prefixCode: "94",
    countryCode: "LK",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Sudan",
    prefixCode: "249",
    countryCode: "SD",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Suriname",
    prefixCode: "597",
    countryCode: "SR",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Svalbard and Jan Mayen",
    prefixCode: "47",
    countryCode: "SJ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Swaziland",
    prefixCode: "268",
    countryCode: "SZ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Sweden",
    prefixCode: "46",
    countryCode: "SE",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Switzerland",
    prefixCode: "41",
    countryCode: "CH",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Syrian Arab Republic",
    prefixCode: "963",
    countryCode: "SY",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Taiwan, Province of China",
    prefixCode: "886",
    countryCode: "TW",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Tajikistan",
    prefixCode: "992",
    countryCode: "TJ",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Tanzania, United Republic of",
    prefixCode: "255",
    countryCode: "TZ",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Thailand",
    prefixCode: "66",
    countryCode: "TH",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Timor-Leste",
    prefixCode: "670",
    countryCode: "TL",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Togo",
    prefixCode: "228",
    countryCode: "TG",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Tokelau",
    prefixCode: "690",
    countryCode: "TK",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Tonga",
    prefixCode: "676",
    countryCode: "TO",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Trinidad and Tobago",
    prefixCode: "+1 868",
    countryCode: "TT",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Tunisia",
    prefixCode: "216",
    countryCode: "TN",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Turkey",
    prefixCode: "90",
    countryCode: "TR",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Turkmenistan",
    prefixCode: "993",
    countryCode: "TM",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Turks and Caicos Islands",
    prefixCode: "+1 649",
    countryCode: "TC",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Tuvalu",
    prefixCode: "688",
    countryCode: "TV",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Uganda",
    prefixCode: "256",
    countryCode: "UG",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Ukraine",
    prefixCode: "380",
    countryCode: "UA",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "United Arab Emirates",
    prefixCode: "971",
    countryCode: "AE",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "United Kingdom",
    prefixCode: "44",
    countryCode: "GB",
    currency: CURRENCIES.GBP,
    currency2: CURRENCIES.USD
  },
  {
    country: "United States",
    prefixCode: "1",
    countryCode: "US",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Uruguay",
    prefixCode: "598",
    countryCode: "UY",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Uzbekistan",
    prefixCode: "998",
    countryCode: "UZ",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Vanuatu",
    prefixCode: "678",
    countryCode: "VU",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Venezuela, Bolivarian Republic of",
    prefixCode: "58",
    countryCode: "VE",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Viet Nam",
    prefixCode: "84",
    countryCode: "VN",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Virgin Islands (British)",
    prefixCode: "+1",
    countryCode: "VG",
    currency: CURRENCIES.USD
  },
  {
    country: "Virgin Islands (U.S.)",
    prefixCode: "+1 340",
    countryCode: "VI",
    currency: CURRENCIES.USD
  },
  {
    country: "Wallis and Futuna",
    prefixCode: "681",
    countryCode: "WF",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Yemen",
    prefixCode: "967",
    countryCode: "YE",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  },
  {
    country: "Zambia",
    prefixCode: "260",
    countryCode: "ZM",
    currency: CURRENCIES.EUR,
    currency2: CURRENCIES.USD
  },
  {
    country: "Zimbabwe",
    prefixCode: "263",
    countryCode: "ZW",
    currency: CURRENCIES.USD,
    currency2: CURRENCIES.EUR
  }
], DEFAULT_CURRENCY = CURRENCIES.USD;
function getCurrencyByCountryCode(countryCode) {
  var _a3;
  return countryCode && ((_a3 = countriesCurrenciesMapping.find(
    (countryCurrency) => countryCurrency.countryCode === countryCode
  )) == null ? void 0 : _a3.currency) || DEFAULT_CURRENCY;
}
__name(getCurrencyByCountryCode, "getCurrencyByCountryCode");
const formatLocalizedCurrency = /* @__PURE__ */ __name((number2, currency = CURRENCIES.EUR, language = "en-US") => new Intl.NumberFormat(language, {
  style: "currency",
  currency,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
}).format(number2), "formatLocalizedCurrency");
function getCurrencySymbol(currency) {
  return CURRENCIES_SYMBOLS[currency];
}
__name(getCurrencySymbol, "getCurrencySymbol");
function currencyValueWithSymbol(value, currency) {
  return currency === CURRENCIES.EUR ? `${value}${getCurrencySymbol(currency)}` : `${getCurrencySymbol(currency)}${value}`;
}
__name(currencyValueWithSymbol, "currencyValueWithSymbol");
function _typeof$F(o) {
  "@babel/helpers - typeof";
  return _typeof$F = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$F(o);
}
__name(_typeof$F, "_typeof$F");
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === !0 || dirtyNumber === !1)
    return NaN;
  var number2 = Number(dirtyNumber);
  return isNaN(number2) ? number2 : number2 < 0 ? Math.ceil(number2) : Math.floor(number2);
}
__name(toInteger, "toInteger");
function requiredArgs(required, args) {
  if (args.length < required)
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}
__name(requiredArgs, "requiredArgs");
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  return argument instanceof Date || _typeof$F(argument) === "object" && argStr === "[object Date]" ? new Date(argument.getTime()) : typeof argument == "number" || argStr === "[object Number]" ? new Date(argument) : ((typeof argument == "string" || argStr === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
__name(toDate, "toDate");
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate), amount = toInteger(dirtyAmount);
  return isNaN(amount) ? /* @__PURE__ */ new Date(NaN) : (amount && date2.setDate(date2.getDate() + amount), date2);
}
__name(addDays, "addDays");
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate), amount = toInteger(dirtyAmount);
  if (isNaN(amount))
    return /* @__PURE__ */ new Date(NaN);
  if (!amount)
    return date2;
  var dayOfMonth = date2.getDate(), endOfDesiredMonth = new Date(date2.getTime());
  endOfDesiredMonth.setMonth(date2.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  return dayOfMonth >= daysInMonth ? endOfDesiredMonth : (date2.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth), date2);
}
__name(addMonths, "addMonths");
function add$2(dirtyDate, duration) {
  if (requiredArgs(2, arguments), !duration || _typeof$F(duration) !== "object")
    return /* @__PURE__ */ new Date(NaN);
  var years = duration.years ? toInteger(duration.years) : 0, months = duration.months ? toInteger(duration.months) : 0, weeks = duration.weeks ? toInteger(duration.weeks) : 0, days = duration.days ? toInteger(duration.days) : 0, hours = duration.hours ? toInteger(duration.hours) : 0, minutes = duration.minutes ? toInteger(duration.minutes) : 0, seconds = duration.seconds ? toInteger(duration.seconds) : 0, date2 = toDate(dirtyDate), dateWithMonths = months || years ? addMonths(date2, months + years * 12) : date2, dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths, minutesToAdd = minutes + hours * 60, secondsToAdd = seconds + minutesToAdd * 60, msToAdd = secondsToAdd * 1e3, finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}
__name(add$2, "add$2");
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime(), amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
__name(addMilliseconds, "addMilliseconds");
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
__name(getDefaultOptions, "getDefaultOptions");
function getTimezoneOffsetInMilliseconds(date2) {
  var utcDate2 = new Date(Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate(), date2.getHours(), date2.getMinutes(), date2.getSeconds(), date2.getMilliseconds()));
  return utcDate2.setUTCFullYear(date2.getFullYear()), date2.getTime() - utcDate2.getTime();
}
__name(getTimezoneOffsetInMilliseconds, "getTimezoneOffsetInMilliseconds");
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  return date2.setHours(0, 0, 0, 0), date2;
}
__name(startOfDay, "startOfDay");
var MILLISECONDS_IN_DAY$1 = 864e5;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft), startOfDayRight = startOfDay(dirtyDateRight), timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft), timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}
__name(differenceInCalendarDays, "differenceInCalendarDays");
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft), dateRight = toDate(dirtyDateRight), diff = dateLeft.getTime() - dateRight.getTime();
  return diff < 0 ? -1 : diff > 0 ? 1 : diff;
}
__name(compareAsc, "compareAsc");
var millisecondsInMinute = 6e4, millisecondsInHour = 36e5;
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft), dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
__name(isSameDay, "isSameDay");
function isDate(value) {
  return requiredArgs(1, arguments), value instanceof Date || _typeof$F(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
__name(isDate, "isDate");
function isValid(dirtyDate) {
  if (requiredArgs(1, arguments), !isDate(dirtyDate) && typeof dirtyDate != "number")
    return !1;
  var date2 = toDate(dirtyDate);
  return !isNaN(Number(date2));
}
__name(isValid, "isValid");
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft), dateRight = toDate(dirtyDateRight), yearDiff = dateLeft.getFullYear() - dateRight.getFullYear(), monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
__name(differenceInCalendarMonths, "differenceInCalendarMonths");
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft), dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
__name(differenceInCalendarYears, "differenceInCalendarYears");
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  return diff < 0 ? -1 : diff > 0 ? 1 : diff;
}
__name(compareLocalAsc, "compareLocalAsc");
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft), dateRight = toDate(dirtyDateRight), sign2 = compareLocalAsc(dateLeft, dateRight), difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign2 * difference);
  var isLastDayNotFull = +(compareLocalAsc(dateLeft, dateRight) === -sign2), result2 = sign2 * (difference - isLastDayNotFull);
  return result2 === 0 ? 0 : result2;
}
__name(differenceInDays, "differenceInDays");
function differenceInMilliseconds(dateLeft, dateRight) {
  return requiredArgs(2, arguments), toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
__name(differenceInMilliseconds, "differenceInMilliseconds");
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: /* @__PURE__ */ __name(function(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  }, "trunc")
  // Math.trunc is not supported by IE
}, defaultRoundingMethod = "trunc";
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
__name(getRoundingMethod, "getRoundingMethod");
function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(options == null ? void 0 : options.roundingMethod)(diff);
}
__name(differenceInHours, "differenceInHours");
function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options == null ? void 0 : options.roundingMethod)(diff);
}
__name(differenceInMinutes, "differenceInMinutes");
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  return date2.setHours(23, 59, 59, 999), date2;
}
__name(endOfDay, "endOfDay");
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate), month = date2.getMonth();
  return date2.setFullYear(date2.getFullYear(), month + 1, 0), date2.setHours(23, 59, 59, 999), date2;
}
__name(endOfMonth, "endOfMonth");
function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  return endOfDay(date2).getTime() === endOfMonth(date2).getTime();
}
__name(isLastDayOfMonth, "isLastDayOfMonth");
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft), dateRight = toDate(dirtyDateRight), sign2 = compareAsc(dateLeft, dateRight), difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight)), result2;
  if (difference < 1)
    result2 = 0;
  else {
    dateLeft.getMonth() === 1 && dateLeft.getDate() > 27 && dateLeft.setDate(30), dateLeft.setMonth(dateLeft.getMonth() - sign2 * difference);
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign2;
    isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1 && (isLastMonthNotFull = !1), result2 = sign2 * (difference - Number(isLastMonthNotFull));
  }
  return result2 === 0 ? 0 : result2;
}
__name(differenceInMonths, "differenceInMonths");
function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1e3;
  return getRoundingMethod(options == null ? void 0 : options.roundingMethod)(diff);
}
__name(differenceInSeconds, "differenceInSeconds");
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft), dateRight = toDate(dirtyDateRight), sign2 = compareAsc(dateLeft, dateRight), difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
  dateLeft.setFullYear(1584), dateRight.setFullYear(1584);
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign2, result2 = sign2 * (difference - Number(isLastYearNotFull));
  return result2 === 0 ? 0 : result2;
}
__name(differenceInYears, "differenceInYears");
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
__name(subMilliseconds, "subMilliseconds");
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate), timestamp = date2.getTime();
  date2.setUTCMonth(0, 1), date2.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date2.getTime(), difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
__name(getUTCDayOfYear, "getUTCDayOfYear");
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1, date2 = toDate(dirtyDate), day = date2.getUTCDay(), diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  return date2.setUTCDate(date2.getUTCDate() - diff), date2.setUTCHours(0, 0, 0, 0), date2;
}
__name(startOfUTCISOWeek, "startOfUTCISOWeek");
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate), year = date2.getUTCFullYear(), fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4), fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear), fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4), fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  return date2.getTime() >= startOfNextYear.getTime() ? year + 1 : date2.getTime() >= startOfThisYear.getTime() ? year : year - 1;
}
__name(getUTCISOWeekYear, "getUTCISOWeekYear");
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate), fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4), fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date2 = startOfUTCISOWeek(fourthOfJanuary);
  return date2;
}
__name(startOfUTCISOWeekYear, "startOfUTCISOWeekYear");
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate), diff = startOfUTCISOWeek(date2).getTime() - startOfUTCISOWeekYear(date2).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
__name(getUTCISOWeek, "getUTCISOWeek");
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions(), weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options == null ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options == null || (_options$locale = options.locale) === null || _options$locale === void 0 || (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 || (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var date2 = toDate(dirtyDate), day = date2.getUTCDay(), diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  return date2.setUTCDate(date2.getUTCDate() - diff), date2.setUTCHours(0, 0, 0, 0), date2;
}
__name(startOfUTCWeek, "startOfUTCWeek");
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate), year = date2.getUTCFullYear(), defaultOptions2 = getDefaultOptions(), firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options == null ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options == null || (_options$locale = options.locale) === null || _options$locale === void 0 || (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 || (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate), firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options), firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate), firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  return date2.getTime() >= startOfNextYear.getTime() ? year + 1 : date2.getTime() >= startOfThisYear.getTime() ? year : year - 1;
}
__name(getUTCWeekYear, "getUTCWeekYear");
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions(), firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options == null ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options == null || (_options$locale = options.locale) === null || _options$locale === void 0 || (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 || (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1), year = getUTCWeekYear(dirtyDate, options), firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate), firstWeek.setUTCHours(0, 0, 0, 0);
  var date2 = startOfUTCWeek(firstWeek, options);
  return date2;
}
__name(startOfUTCWeekYear, "startOfUTCWeekYear");
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate), diff = startOfUTCWeek(date2, options).getTime() - startOfUTCWeekYear(date2, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
__name(getUTCWeek, "getUTCWeek");
function addLeadingZeros(number2, targetLength) {
  for (var sign2 = number2 < 0 ? "-" : "", output = Math.abs(number2).toString(); output.length < targetLength; )
    output = "0" + output;
  return sign2 + output;
}
__name(addLeadingZeros, "addLeadingZeros");
var formatters$2 = {
  // Year
  y: /* @__PURE__ */ __name(function(date2, token) {
    var signedYear = date2.getUTCFullYear(), year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  }, "y"),
  // Month
  M: /* @__PURE__ */ __name(function(date2, token) {
    var month = date2.getUTCMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  }, "M"),
  // Day of the month
  d: /* @__PURE__ */ __name(function(date2, token) {
    return addLeadingZeros(date2.getUTCDate(), token.length);
  }, "d"),
  // AM or PM
  a: /* @__PURE__ */ __name(function(date2, token) {
    var dayPeriodEnumValue = date2.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  }, "a"),
  // Hour [1-12]
  h: /* @__PURE__ */ __name(function(date2, token) {
    return addLeadingZeros(date2.getUTCHours() % 12 || 12, token.length);
  }, "h"),
  // Hour [0-23]
  H: /* @__PURE__ */ __name(function(date2, token) {
    return addLeadingZeros(date2.getUTCHours(), token.length);
  }, "H"),
  // Minute
  m: /* @__PURE__ */ __name(function(date2, token) {
    return addLeadingZeros(date2.getUTCMinutes(), token.length);
  }, "m"),
  // Second
  s: /* @__PURE__ */ __name(function(date2, token) {
    return addLeadingZeros(date2.getUTCSeconds(), token.length);
  }, "s"),
  // Fraction of second
  S: /* @__PURE__ */ __name(function(date2, token) {
    var numberOfDigits = token.length, milliseconds = date2.getUTCMilliseconds(), fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }, "S")
};
const formatters$3 = formatters$2;
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, formatters = {
  // Era
  G: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var era = date2.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  }, "G"),
  // Year
  y: /* @__PURE__ */ __name(function(date2, token, localize2) {
    if (token === "yo") {
      var signedYear = date2.getUTCFullYear(), year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$3.y(date2, token);
  }, "y"),
  // Local week-numbering year
  Y: /* @__PURE__ */ __name(function(date2, token, localize2, options) {
    var signedWeekYear = getUTCWeekYear(date2, options), weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    return token === "Yo" ? localize2.ordinalNumber(weekYear, {
      unit: "year"
    }) : addLeadingZeros(weekYear, token.length);
  }, "Y"),
  // ISO week-numbering year
  R: /* @__PURE__ */ __name(function(date2, token) {
    var isoWeekYear = getUTCISOWeekYear(date2);
    return addLeadingZeros(isoWeekYear, token.length);
  }, "R"),
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: /* @__PURE__ */ __name(function(date2, token) {
    var year = date2.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  }, "u"),
  // Quarter
  Q: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  }, "Q"),
  // Stand-alone quarter
  q: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  }, "q"),
  // Month
  M: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var month = date2.getUTCMonth();
    switch (token) {
      case "M":
      case "MM":
        return formatters$3.M(date2, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  }, "M"),
  // Stand-alone month
  L: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var month = date2.getUTCMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  }, "L"),
  // Local week of year
  w: /* @__PURE__ */ __name(function(date2, token, localize2, options) {
    var week = getUTCWeek(date2, options);
    return token === "wo" ? localize2.ordinalNumber(week, {
      unit: "week"
    }) : addLeadingZeros(week, token.length);
  }, "w"),
  // ISO week of year
  I: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var isoWeek = getUTCISOWeek(date2);
    return token === "Io" ? localize2.ordinalNumber(isoWeek, {
      unit: "week"
    }) : addLeadingZeros(isoWeek, token.length);
  }, "I"),
  // Day of the month
  d: /* @__PURE__ */ __name(function(date2, token, localize2) {
    return token === "do" ? localize2.ordinalNumber(date2.getUTCDate(), {
      unit: "date"
    }) : formatters$3.d(date2, token);
  }, "d"),
  // Day of year
  D: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var dayOfYear = getUTCDayOfYear(date2);
    return token === "Do" ? localize2.ordinalNumber(dayOfYear, {
      unit: "dayOfYear"
    }) : addLeadingZeros(dayOfYear, token.length);
  }, "D"),
  // Day of week
  E: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var dayOfWeek = date2.getUTCDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  }, "E"),
  // Local day of week
  e: /* @__PURE__ */ __name(function(date2, token, localize2, options) {
    var dayOfWeek = date2.getUTCDay(), localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  }, "e"),
  // Stand-alone local day of week
  c: /* @__PURE__ */ __name(function(date2, token, localize2, options) {
    var dayOfWeek = date2.getUTCDay(), localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  }, "c"),
  // ISO day of week
  i: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var dayOfWeek = date2.getUTCDay(), isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  }, "i"),
  // AM or PM
  a: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var hours = date2.getUTCHours(), dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  }, "a"),
  // AM, PM, midnight, noon
  b: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var hours = date2.getUTCHours(), dayPeriodEnumValue;
    switch (hours === 12 ? dayPeriodEnumValue = dayPeriodEnum.noon : hours === 0 ? dayPeriodEnumValue = dayPeriodEnum.midnight : dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am", token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  }, "b"),
  // in the morning, in the afternoon, in the evening, at night
  B: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var hours = date2.getUTCHours(), dayPeriodEnumValue;
    switch (hours >= 17 ? dayPeriodEnumValue = dayPeriodEnum.evening : hours >= 12 ? dayPeriodEnumValue = dayPeriodEnum.afternoon : hours >= 4 ? dayPeriodEnumValue = dayPeriodEnum.morning : dayPeriodEnumValue = dayPeriodEnum.night, token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  }, "B"),
  // Hour [1-12]
  h: /* @__PURE__ */ __name(function(date2, token, localize2) {
    if (token === "ho") {
      var hours = date2.getUTCHours() % 12;
      return hours === 0 && (hours = 12), localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$3.h(date2, token);
  }, "h"),
  // Hour [0-23]
  H: /* @__PURE__ */ __name(function(date2, token, localize2) {
    return token === "Ho" ? localize2.ordinalNumber(date2.getUTCHours(), {
      unit: "hour"
    }) : formatters$3.H(date2, token);
  }, "H"),
  // Hour [0-11]
  K: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var hours = date2.getUTCHours() % 12;
    return token === "Ko" ? localize2.ordinalNumber(hours, {
      unit: "hour"
    }) : addLeadingZeros(hours, token.length);
  }, "K"),
  // Hour [1-24]
  k: /* @__PURE__ */ __name(function(date2, token, localize2) {
    var hours = date2.getUTCHours();
    return hours === 0 && (hours = 24), token === "ko" ? localize2.ordinalNumber(hours, {
      unit: "hour"
    }) : addLeadingZeros(hours, token.length);
  }, "k"),
  // Minute
  m: /* @__PURE__ */ __name(function(date2, token, localize2) {
    return token === "mo" ? localize2.ordinalNumber(date2.getUTCMinutes(), {
      unit: "minute"
    }) : formatters$3.m(date2, token);
  }, "m"),
  // Second
  s: /* @__PURE__ */ __name(function(date2, token, localize2) {
    return token === "so" ? localize2.ordinalNumber(date2.getUTCSeconds(), {
      unit: "second"
    }) : formatters$3.s(date2, token);
  }, "s"),
  // Fraction of second
  S: /* @__PURE__ */ __name(function(date2, token) {
    return formatters$3.S(date2, token);
  }, "S"),
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: /* @__PURE__ */ __name(function(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2, timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0)
      return "Z";
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  }, "X"),
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: /* @__PURE__ */ __name(function(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2, timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  }, "x"),
  // Timezone (GMT)
  O: /* @__PURE__ */ __name(function(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2, timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  }, "O"),
  // Timezone (specific non-location)
  z: /* @__PURE__ */ __name(function(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2, timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  }, "z"),
  // Seconds timestamp
  t: /* @__PURE__ */ __name(function(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2, timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  }, "t"),
  // Milliseconds timestamp
  T: /* @__PURE__ */ __name(function(date2, token, _localize, options) {
    var originalDate = options._originalDate || date2, timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }, "T")
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign2 = offset > 0 ? "-" : "+", absOffset = Math.abs(offset), hours = Math.floor(absOffset / 60), minutes = absOffset % 60;
  if (minutes === 0)
    return sign2 + String(hours);
  var delimiter = dirtyDelimiter || "";
  return sign2 + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
__name(formatTimezoneShort, "formatTimezoneShort");
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign2 = offset > 0 ? "-" : "+";
    return sign2 + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
__name(formatTimezoneWithOptionalMinutes, "formatTimezoneWithOptionalMinutes");
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "", sign2 = offset > 0 ? "-" : "+", absOffset = Math.abs(offset), hours = addLeadingZeros(Math.floor(absOffset / 60), 2), minutes = addLeadingZeros(absOffset % 60, 2);
  return sign2 + hours + delimiter + minutes;
}
__name(formatTimezone, "formatTimezone");
const formatters$1 = formatters;
var dateLongFormatter = /* @__PURE__ */ __name(function(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
}, "dateLongFormatter"), timeLongFormatter = /* @__PURE__ */ __name(function(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
}, "timeLongFormatter"), dateTimeLongFormatter = /* @__PURE__ */ __name(function(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [], datePattern = matchResult[1], timePattern = matchResult[2];
  if (!timePattern)
    return dateLongFormatter(pattern, formatLong2);
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
}, "dateTimeLongFormatter"), longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const longFormatters$1 = longFormatters;
var protectedDayOfYearTokens = ["D", "DD"], protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
__name(isProtectedDayOfYearToken, "isProtectedDayOfYearToken");
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
__name(isProtectedWeekYearToken, "isProtectedWeekYearToken");
function throwProtectedError(token, format2, input) {
  if (token === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (token === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (token === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (token === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
__name(throwProtectedError, "throwProtectedError");
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, formatDistance = /* @__PURE__ */ __name(function(token, count, options) {
  var result2, tokenValue = formatDistanceLocale[token];
  return typeof tokenValue == "string" ? result2 = tokenValue : count === 1 ? result2 = tokenValue.one : result2 = tokenValue.other.replace("{{count}}", count.toString()), options != null && options.addSuffix ? options.comparison && options.comparison > 0 ? "in " + result2 : result2 + " ago" : result2;
}, "formatDistance");
const formatDistance$1 = formatDistance;
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, width2 = options.width ? String(options.width) : args.defaultWidth, format2 = args.formats[width2] || args.formats[args.defaultWidth];
    return format2;
  };
}
__name(buildFormatLongFn, "buildFormatLongFn");
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, formatRelative = /* @__PURE__ */ __name(function(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}, "formatRelative");
const formatRelative$1 = formatRelative;
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options != null && options.context ? String(options.context) : "standalone", valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth, width2 = options != null && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width2] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth, _width = options != null && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
__name(buildLocalizeFn, "buildLocalizeFn");
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ordinalNumber = /* @__PURE__ */ __name(function(dirtyNumber, _options) {
  var number2 = Number(dirtyNumber), rem100 = number2 % 100;
  if (rem100 > 20 || rem100 < 10)
    switch (rem100 % 10) {
      case 1:
        return number2 + "st";
      case 2:
        return number2 + "nd";
      case 3:
        return number2 + "rd";
    }
  return number2 + "th";
}, "ordinalNumber"), localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: /* @__PURE__ */ __name(function(quarter) {
      return quarter - 1;
    }, "argumentCallback")
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const localize$1 = localize;
function buildMatchFn(args) {
  return function(string2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, width2 = options.width, matchPattern = width2 && args.matchPatterns[width2] || args.matchPatterns[args.defaultMatchWidth], matchResult = string2.match(matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0], parsePatterns = width2 && args.parsePatterns[width2] || args.parsePatterns[args.defaultParseWidth], key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }), value;
    value = args.valueCallback ? args.valueCallback(key) : key, value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string2.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
__name(buildMatchFn, "buildMatchFn");
function findKey(object2, predicate) {
  for (var key in object2)
    if (object2.hasOwnProperty(key) && predicate(object2[key]))
      return key;
}
__name(findKey, "findKey");
function findIndex(array2, predicate) {
  for (var key = 0; key < array2.length; key++)
    if (predicate(array2[key]))
      return key;
}
__name(findIndex, "findIndex");
function buildMatchPatternFn(args) {
  return function(string2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, matchResult = string2.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0], parseResult = string2.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string2.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
__name(buildMatchPatternFn, "buildMatchPatternFn");
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i, parseOrdinalNumberPattern = /\d+/i, matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
}, matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: /* @__PURE__ */ __name(function(value) {
      return parseInt(value, 10);
    }, "valueCallback")
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: /* @__PURE__ */ __name(function(index2) {
      return index2 + 1;
    }, "valueCallback")
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const match$1 = match;
var locale$2 = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const defaultLocale$2 = locale$2;
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, escapedStringRegExp = /^'([^]*?)'?$/, doubleQuoteRegExp = /''/g, unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format$1(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr), defaultOptions2 = getDefaultOptions(), locale2 = (_ref = (_options$locale = options == null ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale$2, firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options == null ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options == null || (_options$locale2 = options.locale) === null || _options$locale2 === void 0 || (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 || (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options == null ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options == null || (_options$locale3 = options.locale) === null || _options$locale3 === void 0 || (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 || (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!locale2.localize)
    throw new RangeError("locale must contain localize property");
  if (!locale2.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate))
    throw new RangeError("Invalid time value");
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate), utcDate2 = subMilliseconds(originalDate, timezoneOffset), formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  }, result2 = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(function(substring) {
    if (substring === "''")
      return "'";
    var firstCharacter = substring[0];
    if (firstCharacter === "'")
      return cleanEscapedString(substring);
    var formatter = formatters$1[firstCharacter];
    if (formatter)
      return !(options != null && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring) && throwProtectedError(substring, dirtyFormatStr, String(dirtyDate)), !(options != null && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring) && throwProtectedError(substring, dirtyFormatStr, String(dirtyDate)), formatter(utcDate2, substring, locale2.localize, formatterOptions);
    if (firstCharacter.match(unescapedLatinCharacterRegExp))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    return substring;
  }).join("");
  return result2;
}
__name(format$1, "format$1");
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  return matched ? matched[1].replace(doubleQuoteRegExp, "'") : input;
}
__name(cleanEscapedString, "cleanEscapedString");
function getYear(dirtyDate) {
  return requiredArgs(1, arguments), toDate(dirtyDate).getFullYear();
}
__name(getYear, "getYear");
function intervalToDuration(interval) {
  requiredArgs(1, arguments);
  var start = toDate(interval.start), end = toDate(interval.end);
  if (isNaN(start.getTime()))
    throw new RangeError("Start Date is invalid");
  if (isNaN(end.getTime()))
    throw new RangeError("End Date is invalid");
  var duration = {};
  duration.years = Math.abs(differenceInYears(end, start));
  var sign2 = compareAsc(end, start), remainingMonths = add$2(start, {
    years: sign2 * duration.years
  });
  duration.months = Math.abs(differenceInMonths(end, remainingMonths));
  var remainingDays = add$2(remainingMonths, {
    months: sign2 * duration.months
  });
  duration.days = Math.abs(differenceInDays(end, remainingDays));
  var remainingHours = add$2(remainingDays, {
    days: sign2 * duration.days
  });
  duration.hours = Math.abs(differenceInHours(end, remainingHours));
  var remainingMinutes = add$2(remainingHours, {
    hours: sign2 * duration.hours
  });
  duration.minutes = Math.abs(differenceInMinutes(end, remainingMinutes));
  var remainingSeconds = add$2(remainingMinutes, {
    minutes: sign2 * duration.minutes
  });
  return duration.seconds = Math.abs(differenceInSeconds(end, remainingSeconds)), duration;
}
__name(intervalToDuration, "intervalToDuration");
function intlFormat(date2, formatOrLocale, localeOptions) {
  var _localeOptions;
  requiredArgs(1, arguments);
  var formatOptions;
  return isFormatOptions(formatOrLocale) ? formatOptions = formatOrLocale : localeOptions = formatOrLocale, new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date2);
}
__name(intlFormat, "intlFormat");
function isFormatOptions(opts) {
  return opts !== void 0 && !("locale" in opts);
}
__name(isFormatOptions, "isFormatOptions");
function _assertThisInitialized$b(e3) {
  if (e3 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e3;
}
__name(_assertThisInitialized$b, "_assertThisInitialized$b");
function _setPrototypeOf$b(t3, e3) {
  return _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e4) {
    return t4.__proto__ = e4, t4;
  }, _setPrototypeOf$b(t3, e3);
}
__name(_setPrototypeOf$b, "_setPrototypeOf$b");
function _inherits$b(t3, e3) {
  if (typeof e3 != "function" && e3 !== null)
    throw new TypeError("Super expression must either be null or a function");
  t3.prototype = Object.create(e3 && e3.prototype, {
    constructor: {
      value: t3,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t3, "prototype", {
    writable: !1
  }), e3 && _setPrototypeOf$b(t3, e3);
}
__name(_inherits$b, "_inherits$b");
function _getPrototypeOf$b(t3) {
  return _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$b(t3);
}
__name(_getPrototypeOf$b, "_getPrototypeOf$b");
function _possibleConstructorReturn$b(t3, e3) {
  if (e3 && (_typeof$F(e3) == "object" || typeof e3 == "function"))
    return e3;
  if (e3 !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$b(t3);
}
__name(_possibleConstructorReturn$b, "_possibleConstructorReturn$b");
function _classCallCheck$m(a4, n) {
  if (!(a4 instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$m, "_classCallCheck$m");
function toPrimitive(t3, r2) {
  if (_typeof$F(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$F(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(toPrimitive, "toPrimitive");
function toPropertyKey(t3) {
  var i2 = toPrimitive(t3, "string");
  return _typeof$F(i2) == "symbol" ? i2 : i2 + "";
}
__name(toPropertyKey, "toPropertyKey");
function _defineProperties$m(e3, r2) {
  for (var t3 = 0; t3 < r2.length; t3++) {
    var o = r2[t3];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e3, toPropertyKey(o.key), o);
  }
}
__name(_defineProperties$m, "_defineProperties$m");
function _createClass$m(e3, r2, t3) {
  return r2 && _defineProperties$m(e3.prototype, r2), t3 && _defineProperties$m(e3, t3), Object.defineProperty(e3, "prototype", {
    writable: !1
  }), e3;
}
__name(_createClass$m, "_createClass$m");
function _defineProperty$I(e3, r2, t3) {
  return (r2 = toPropertyKey(r2)) in e3 ? Object.defineProperty(e3, r2, {
    value: t3,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e3[r2] = t3, e3;
}
__name(_defineProperty$I, "_defineProperty$I");
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft), dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
__name(isSameMonth, "isSameMonth");
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft), dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
__name(isSameYear, "isSameYear");
function isThisYear(dirtyDate) {
  return requiredArgs(1, arguments), isSameYear(dirtyDate, Date.now());
}
__name(isThisYear, "isThisYear");
function isToday(dirtyDate) {
  return requiredArgs(1, arguments), isSameDay(dirtyDate, Date.now());
}
__name(isToday, "isToday");
const TOAST_DEFAULT_DISMISS_IN_MILLISECONDS = 4e3;
var LiveMonitoringCallDirection = /* @__PURE__ */ ((LiveMonitoringCallDirection2) => (LiveMonitoringCallDirection2.INBOUND = "INBOUND", LiveMonitoringCallDirection2.OUTBOUND = "OUTBOUND", LiveMonitoringCallDirection2))(LiveMonitoringCallDirection || {}), LiveMonitoringCallStatus = /* @__PURE__ */ ((LiveMonitoringCallStatus2) => (LiveMonitoringCallStatus2.ANSWERED = "ANSWERED", LiveMonitoringCallStatus2.IN_CALL = "IN_CALL", LiveMonitoringCallStatus2.IN_CALL_AI_VOICE_AGENT = "IN_CALL_AI_VOICE_AGENT", LiveMonitoringCallStatus2.IN_IVR = "IN_IVR", LiveMonitoringCallStatus2.IN_QUEUE = "IN_QUEUE", LiveMonitoringCallStatus2.RINGING = "RINGING", LiveMonitoringCallStatus2.UNANSWERED = "UNANSWERED", LiveMonitoringCallStatus2.UNANSWERED_ABANDONED_BEFORE_10_SECONDS = "UNANSWERED_ABANDONED_BEFORE_10_SECONDS", LiveMonitoringCallStatus2.UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE = "UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE", LiveMonitoringCallStatus2.UNANSWERED_ABANDONED_IN_IVR = "UNANSWERED_ABANDONED_IN_IVR", LiveMonitoringCallStatus2.UNANSWERED_ALL_AGENTS_UNAVAILABLE = "UNANSWERED_ALL_AGENTS_UNAVAILABLE", LiveMonitoringCallStatus2.UNANSWERED_CALLBACK_REQUEST = "UNANSWERED_CALLBACK_REQUEST", LiveMonitoringCallStatus2.UNANSWERED_OUTSIDE_BUSINESS_HOURS = "UNANSWERED_OUTSIDE_BUSINESS_HOURS", LiveMonitoringCallStatus2.UNANSWERED_USERS_DID_NOT_ANSWER = "UNANSWERED_USERS_DID_NOT_ANSWER", LiveMonitoringCallStatus2))(LiveMonitoringCallStatus || {}), CustomCallStatus = /* @__PURE__ */ ((CustomCallStatus2) => (CustomCallStatus2.CALLBACK_PENDING = "CALLBACK_PENDING", CustomCallStatus2))(CustomCallStatus || {});
const AUTHORIZATION_ERROR_CODES = [403, 401], NOT_FOUND_ERROR_CODES = [404], VALIDATION_ERROR_CODES = [400, 409, 422], LIMITATION_ERROR_CODES = [429], GATEWAY_TIMEOUT_ERROR_CODES = [504], GRAPHQL_ERROR_NON_EXISTENT_RESOURCE = "Nonexistent resource", GRAPHQL_ERROR_INTERNAL_API_NOT_FOUND = "Request failed with status code 404", GRAPHQL_ERROR_INVALID_DATA = "Request failed with status code 422", BACKEND_VALIDATION_KEY_MAPPER = {
  INVALID_VALUE: "is_invalid",
  HAS_ALREADY_BEEN_TAKEN: "has already been taken",
  // Billing details related keys
  WRONG_VAT_PATTERN: "VAT country code does not match with the country",
  // Password related keys
  PASSWORD_EQUAL_TO_CURRENT_PASSWORD: "equal_to_current_password",
  PASSWORD_WRONG_FORMAT: "password_format",
  PASSWORD_TOO_SHORT: "too_short",
  PASSWORD_TAKEN_IN_PAST: "taken_in_past",
  EMAIL_ALREADY_EXISTS: "email already exists",
  RESET_PASSWORD_TOKEN_IS_INVALID: "invalid_code",
  TOO_MANY_REQUEST: "too_many_requests",
  TEAM_NAME_ALREADY_USED_BY_THE_COMPANY: "is already used by the company",
  MAX_NUMBER_OF_TEAMS_REACHED: "number of teams allowed has been reached",
  INVALID_PASSWORD: "Invalid password.",
  // Critical actions related keys
  UPDATE_EMAIL_BAD_REQUEST: "email/bad-request",
  UPDATE_EMAIL_ALREADY_IN_USE: "email/already-in-use",
  UPDATE_EMAIL_UNKNOWN: "email/unknown",
  ADD_PAYMENT_CARD_UNKNOWN: "card/unknown"
}, BACKEND_VALIDATION_ERRORS_TRANSLATION_KEYS = {
  [BACKEND_VALIDATION_KEY_MAPPER.INVALID_VALUE]: "generic_errors.backend_validation.is_invalid",
  [BACKEND_VALIDATION_KEY_MAPPER.HAS_ALREADY_BEEN_TAKEN]: "generic_errors.backend_validation.has_already_been_taken",
  [BACKEND_VALIDATION_KEY_MAPPER.WRONG_VAT_PATTERN]: "generic_errors.frontend_validation.wrong_vat_pattern",
  [BACKEND_VALIDATION_KEY_MAPPER.PASSWORD_EQUAL_TO_CURRENT_PASSWORD]: "generic_errors.backend_validation.password_equal_to_current_password",
  [BACKEND_VALIDATION_KEY_MAPPER.PASSWORD_WRONG_FORMAT]: "generic_errors.backend_validation.password_strength",
  [BACKEND_VALIDATION_KEY_MAPPER.TOO_MANY_REQUEST]: "generic_errors.backend_validation.too_many_requests",
  [BACKEND_VALIDATION_KEY_MAPPER.INVALID_PASSWORD]: "generic_errors.backend_validation.password_strength",
  [BACKEND_VALIDATION_KEY_MAPPER.RESET_PASSWORD_TOKEN_IS_INVALID]: "generic_errors.backend_validation.token_invalid",
  [BACKEND_VALIDATION_KEY_MAPPER.MAX_NUMBER_OF_TEAMS_REACHED]: "generic_errors.backend_validation.max_number_of_teams_reached",
  [BACKEND_VALIDATION_KEY_MAPPER.PASSWORD_TOO_SHORT]: "generic_errors.backend_validation.password_length",
  [BACKEND_VALIDATION_KEY_MAPPER.PASSWORD_TAKEN_IN_PAST]: "generic_errors.backend_validation.password_taken_in_past",
  [BACKEND_VALIDATION_KEY_MAPPER.EMAIL_ALREADY_EXISTS]: "generic_errors.backend_validation.email_already_exists",
  [BACKEND_VALIDATION_KEY_MAPPER.TEAM_NAME_ALREADY_USED_BY_THE_COMPANY]: "generic_errors.backend_validation.has_already_been_taken",
  [BACKEND_VALIDATION_KEY_MAPPER.UPDATE_EMAIL_BAD_REQUEST]: "generic_errors.frontend_validation.invalid_email",
  [BACKEND_VALIDATION_KEY_MAPPER.UPDATE_EMAIL_ALREADY_IN_USE]: "generic_errors.backend_validation.email_already_exists",
  [BACKEND_VALIDATION_KEY_MAPPER.UPDATE_EMAIL_UNKNOWN]: "generic_errors.other.unknown_error",
  [BACKEND_VALIDATION_KEY_MAPPER.ADD_PAYMENT_CARD_UNKNOWN]: "credit_card.card_unknown_error"
}, BACKEND_ERRORS_TRANSLATION_KEYS = {
  INVALID_DATA_ERROR: "generic_errors.backend_validation.is_invalid",
  UNKNOWN_ERROR: "generic_errors.other.unknown_error",
  NETWORK_ERROR: "generic_errors.other.network_error",
  GATEWAY_TIMEOUT_ERROR: "generic_errors.other.gateway_timeout_error",
  WRONG_ERROR: "generic_errors.other.wrong_error",
  TOO_MANY_REQUESTS: "generic_errors.other.too_many_requests",
  REQUEST_TOO_EARLY: "generic_errors.other.request_too_early",
  CREDENTIALS_ERROR: "login.errors.credential",
  MFA_CREDENTIALS_ERROR: "login.mfa.invalid_code",
  MFA_SESSION_EXPIRED: "login.message.session_expired"
}, FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS = {
  WRONG_FORMAT: "generic_errors.frontend_validation.wrong_format",
  INVALID_VALUE: "generic_errors.frontend_validation.invalid_value",
  PASSWORD_STRENGTH: "generic_errors.frontend_validation.password_strength",
  PASSWORD_LENGTH: "generic_errors.frontend_validation.password_length",
  PASSWORD_NOT_MATCH: "generic_errors.frontend_validation.password_not_match",
  INVALID_EMAIL: "generic_errors.frontend_validation.invalid_email",
  REQUIRED_FIELD: "generic_errors.frontend_validation.required",
  MAX_LENGTH: "generic_errors.frontend_validation.max_length",
  ALREADY_EXISTS: "generic_errors.frontend_validation.already_exists",
  WRONG_PICTURE_FORMAT: "generic_errors.frontend_validation.wrong_picture_format",
  PICTURE_SIZE_TOO_LARGE: "generic_errors.frontend_validation.picture_size_too_large",
  TOO_SHORT: "generic_errors.frontend_validation.too_short",
  NO_CREDIT_CARD: "generic_errors.frontend_validation.no_credit_card",
  NO_ADDRESS: "generic_errors.frontend_validation.no_address",
  INVALID_NUMBER_NAME: "generic_errors.frontend_validation.invalid_number_name"
}, FRONTEND_VALIDATION_ERRORS_MAPPER_OF_DESCRIPTIVE_ERROR_TO_KEY_NAME = {
  "email already exists": "email",
  "email/bad-request": "email",
  "email/already-in-use": "email",
  "email/unknown": "email",
  "card/unknown": "card",
  "VAT country code does not match with the country": "VATWrongFormat"
}, FF_FORM_ERROR = "FINAL_FORM/form-error", SUCCESS_FEEDBACK_MESSAGES = {
  DELETION_SUCCESS: "success_feedback_messages.deletion_success",
  UPDATE_SUCCESS: "success_feedback_messages.update_success",
  CREATION_SUCCESS: "success_feedback_messages.creation_success",
  ADD_SUCCESS: "success_feedback_messages.add_success"
}, MAX_UPLOD_IMAGE_SIZE = 46e5;
var FORM_ACTIONS = /* @__PURE__ */ ((FORM_ACTIONS2) => (FORM_ACTIONS2.CANCEL = "cancel", FORM_ACTIONS2.UNDO = "undo", FORM_ACTIONS2.SAVED = "saved", FORM_ACTIONS2.SUBMIT = "submit", FORM_ACTIONS2.UNSAVED = "unsaved", FORM_ACTIONS2))(FORM_ACTIONS || {});
const VALIDATE_EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, VALIDATE_PASSWORD_LENGTH_REGEX = /(?=.{8,})/, VALIDATE_PASSWORD_STRENGTH_REGEX = /^(?!\s)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()+?\-"!@#%&/,><':;|_~`\\"'])[\^$*.[\]{}()+?\-"!@#%&/,><':;|_~`\u0020a-zA-Z0-9\\"']{8,99}[^-\s]$/, VALIDATE_URL_FORMAT_REGEX = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w~:/?#[\]@!$&'()*+,;=.]+$/, VALIDATE_NUMBERS_ONLY_REGEX = /^\d*$/, VALIDATE_PERCENTAGE_ONLY_REGEX = /^\d*%$/, MATCH_NON_DIGITS_REGEX = /\D+/g, STRIP_COUNTRY_FROM_LANGUAGE = /[-_][a-z]+$/i, MATCH_HTML_ELEMENTS = /<\/?[a-z][\s\S]*>/i, HTTPS_URL_PREFIX = /^https?:\/\/?/, translations = {
  en: {
    Admin: "Admin",
    Agent: "Agent",
    cancel: "Cancel",
    Owner: "Owner",
    saved: "Saved",
    submit: "Confirm",
    Supervisor: "Supervisor",
    undo: "Undo",
    unsaved: "Save changes"
  },
  de: {
    Admin: "Admin",
    Agent: "Agent",
    cancel: "Abbrechen",
    Owner: "Eigentümer",
    saved: "Gespeichert",
    submit: "Bestätigen",
    Supervisor: "Supervisor",
    undo: "Rückgängig",
    unsaved: "Änderungen speichern"
  },
  es: {
    Admin: "Administrador",
    Agent: "Agente",
    cancel: "Cancelar",
    Owner: "Propietario",
    saved: "Guardado",
    submit: "Confirmar",
    Supervisor: "Supervisor",
    undo: "Deshacer",
    unsaved: "Guardar cambios"
  },
  fr: {
    Admin: "Admin",
    Agent: "Agent",
    cancel: "Annuler",
    Owner: "Propriétaire",
    saved: "Enregistré",
    submit: "Confirmer",
    Supervisor: "Superviseur",
    undo: "Annuler",
    unsaved: "Enregistrer les modifications"
  },
  it: {
    Admin: "Admin",
    Agent: "Agente",
    cancel: "Annulla",
    Owner: "Proprietario",
    saved: "Salvato",
    submit: "Conferma",
    Supervisor: "Supervisore",
    undo: "Annulla",
    unsaved: "Salva modifiche"
  },
  nb: {
    Admin: "Admin",
    Agent: "Agent",
    cancel: "Avbryte",
    Owner: "Owner",
    saved: "Lagret",
    submit: "Bekreft",
    Supervisor: "Supervisor",
    undo: "Kansellere",
    unsaved: "Lagre endringene"
  },
  pt: {
    Admin: "Admin",
    Agent: "Agente",
    cancel: "Cancelar",
    Owner: "Proprietário",
    saved: "Salvo",
    submit: "Confirmar",
    Supervisor: "Supervisor",
    undo: "Desfazer",
    unsaved: "Salvar alterações"
  }
};
var LiveMonitoringUserStatus = /* @__PURE__ */ ((LiveMonitoringUserStatus2) => (LiveMonitoringUserStatus2.AFTER_CALL_WORK = "AFTER_CALL_WORK", LiveMonitoringUserStatus2.AVAILABLE = "AVAILABLE", LiveMonitoringUserStatus2.BUSY = "BUSY", LiveMonitoringUserStatus2.DOING_BACK_OFFICE = "DOING_BACK_OFFICE", LiveMonitoringUserStatus2.DO_NOT_DISTURB = "DO_NOT_DISTURB", LiveMonitoringUserStatus2.IN_CALL = "IN_CALL", LiveMonitoringUserStatus2.IN_MANDATORY_TAGGING = "IN_MANDATORY_TAGGING", LiveMonitoringUserStatus2.IN_TRAINING = "IN_TRAINING", LiveMonitoringUserStatus2.OFFLINE = "OFFLINE", LiveMonitoringUserStatus2.ON_A_BREAK = "ON_A_BREAK", LiveMonitoringUserStatus2.ON_MOBILE = "ON_MOBILE", LiveMonitoringUserStatus2.OTHER = "OTHER", LiveMonitoringUserStatus2.OUT_FOR_LUNCH = "OUT_FOR_LUNCH", LiveMonitoringUserStatus2.RINGING = "RINGING", LiveMonitoringUserStatus2.UNAVAILABLE = "UNAVAILABLE", LiveMonitoringUserStatus2))(LiveMonitoringUserStatus || {});
function getInitials(firstName, lastName = "") {
  return (firstName.trim().charAt(0) + lastName.trim().charAt(0)).toUpperCase();
}
__name(getInitials, "getInitials");
function capitalizeFirstLetter(string2) {
  return string2.charAt(0).toUpperCase() + string2.slice(1);
}
__name(capitalizeFirstLetter, "capitalizeFirstLetter");
function getFullName(...args) {
  return args.map(capitalizeFirstLetter).join(" ").trim();
}
__name(getFullName, "getFullName");
function stringContainsHtmlTags(string2) {
  return MATCH_HTML_ELEMENTS.test(string2);
}
__name(stringContainsHtmlTags, "stringContainsHtmlTags");
function replace$1({
  regex,
  replacement
}) {
  return (value) => value.replace(regex, replacement);
}
__name(replace$1, "replace$1");
function toBoolean(value) {
  return value === "true";
}
__name(toBoolean, "toBoolean");
function toLower(value) {
  return value.toLowerCase();
}
__name(toLower, "toLower");
function toNumber$4(value) {
  return parseInt(value);
}
__name(toNumber$4, "toNumber$4");
function toStringArray(value) {
  return value.split(",");
}
__name(toStringArray, "toStringArray");
function toUpper(value) {
  return value.toUpperCase();
}
__name(toUpper, "toUpper");
function toUpperStringArray(value) {
  return toStringArray(value).map(toUpper);
}
__name(toUpperStringArray, "toUpperStringArray");
const trimWhiteSpaces = /* @__PURE__ */ __name((value) => value == null ? void 0 : value.trim(), "trimWhiteSpaces");
function getTranslatedCountryName(countryCode, language = "en") {
  try {
    const parsedLanguage = language.replace(STRIP_COUNTRY_FROM_LANGUAGE, "");
    return new Intl.DisplayNames([parsedLanguage], {
      type: "region"
    }).of(countryCode);
  } catch {
    return countryCode;
  }
}
__name(getTranslatedCountryName, "getTranslatedCountryName");
function trimWithEllipsis(str, threshold2) {
  return str.length <= threshold2 ? str : `${str.slice(0, threshold2)}...`;
}
__name(trimWithEllipsis, "trimWithEllipsis");
function matchPartialText(fullText, partialText) {
  function removeAccentCharacters(text2) {
    return text2.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
  }
  return __name(removeAccentCharacters, "removeAccentCharacters"), removeAccentCharacters(fullText).includes(
    removeAccentCharacters(partialText)
  );
}
__name(matchPartialText, "matchPartialText");
function getSplittedText(text2) {
  const matches2 = text2.match(/(\d*)([\s\S]*)/);
  if (text2 !== "" && matches2) {
    const [, ...splittedText] = matches2;
    return splittedText;
  }
  return null;
}
__name(getSplittedText, "getSplittedText");
const monthFormat = /* @__PURE__ */ __name((date2, locale2 = "en-US") => new Intl.DateTimeFormat(locale2, { month: "long" }).format(date2), "monthFormat"), monthYearFormat = /* @__PURE__ */ __name((date2) => format$1(date2, "MM/yy"), "monthYearFormat"), longDate = /* @__PURE__ */ __name((date2) => format$1(date2, "PPP"), "longDate"), getDaysDifference = /* @__PURE__ */ __name((a4, b2) => differenceInDays(a4, b2), "getDaysDifference"), getMinutesDifference = /* @__PURE__ */ __name((a4, b2) => differenceInMinutes(a4, b2), "getMinutesDifference"), getPeriodOfDay = /* @__PURE__ */ __name((date2) => {
  const hours = date2.getHours();
  return hours >= 6 && hours < 12 ? "morning" : hours >= 12 && hours < 18 ? "afternoon" : (hours >= 18 && hours < 24, "evening");
}, "getPeriodOfDay");
function longFormat(language = "en-US") {
  return (date2) => intlFormat(
    new Date(date2),
    { weekday: "long", year: "numeric", month: "long", day: "numeric" },
    { locale: language }
  );
}
__name(longFormat, "longFormat");
function classicFormat(language = "en-US") {
  return (date2) => intlFormat(
    new Date(date2),
    { year: "numeric", month: "long", day: "numeric" },
    { locale: language }
  );
}
__name(classicFormat, "classicFormat");
const dayOfMonthFormat = /* @__PURE__ */ __name((date2, locale2 = "en-US") => new Intl.DateTimeFormat(locale2, { day: "numeric" }).format(date2), "dayOfMonthFormat"), shortMonthFormat = /* @__PURE__ */ __name((date2, locale2 = "en-US") => new Intl.DateTimeFormat(locale2, { month: "short" }).format(date2), "shortMonthFormat"), shortDate = /* @__PURE__ */ __name((date2, locale2 = "en-US") => new Intl.DateTimeFormat(locale2, {
  day: "numeric",
  month: "short",
  year: "numeric"
}).format(date2), "shortDate"), formatSecondsToDuration = /* @__PURE__ */ __name((totalSeconds, extended = !0) => {
  const {
    years = 0,
    months = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = intervalToDuration({
    start: 0,
    end: totalSeconds * 1e3
  });
  return years || months ? extended ? `${years * 365 + months * 30 + days}d ${hours}h ${minutes}min ${seconds}s` : `${years * 365 + months * 30 + days}d` : days ? extended ? `${days}d ${hours}h ${minutes}min ${seconds}s` : days >= 7 ? `${days}d` : `${days}d ${hours}h` : hours ? hours >= 10 && !extended ? `${hours}h` : `${hours}h ${minutes}min ${seconds}s` : minutes ? `${minutes}min ${seconds}s` : `${seconds}s`;
}, "formatSecondsToDuration"), getLocalizedTime = /* @__PURE__ */ __name((date2, locale2 = "en-US") => date2.toLocaleTimeString(locale2, {
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit"
}), "getLocalizedTime"), getMidnightDate = /* @__PURE__ */ __name((date2 = /* @__PURE__ */ new Date()) => {
  const newDate2 = new Date(date2.getTime());
  return newDate2.setHours(0, 0, 0, 0), newDate2;
}, "getMidnightDate"), localizedRTFMap = /* @__PURE__ */ new Map(), getRtf = /* @__PURE__ */ __name((locale2) => {
  let formatter = localizedRTFMap.get(locale2);
  return formatter || (formatter = new Intl.RelativeTimeFormat(locale2, { numeric: "auto" }), localizedRTFMap.set(locale2, formatter)), formatter;
}, "getRtf"), DAY_IN_MILLISECONDS = 1e3 * 3600 * 24, DAYS_IN_WEEK = 7, getRelativeDate = /* @__PURE__ */ __name((date2, locale2 = "en-US") => {
  const rtf = getRtf(locale2), d3 = getMidnightDate(date2), currentTime = getMidnightDate(), deltaDays = (d3.getTime() - currentTime.getTime()) / DAY_IN_MILLISECONDS;
  return deltaDays === 0 || Math.abs(deltaDays) <= DAYS_IN_WEEK ? capitalizeFirstLetter(rtf.format(Math.round(deltaDays), "days")) : d3.getFullYear() === currentTime.getFullYear() ? d3.toLocaleDateString(locale2, { month: "short", day: "numeric" }) : d3.toLocaleDateString(locale2);
}, "getRelativeDate"), compressed = !0, categories$1 = [
  {
    id: "people",
    name: "Smileys & People",
    emojis: [
      "grinning",
      "smiley",
      "smile",
      "grin",
      "laughing",
      "sweat_smile",
      "rolling_on_the_floor_laughing",
      "joy",
      "slightly_smiling_face",
      "upside_down_face",
      "wink",
      "blush",
      "innocent",
      "smiling_face_with_3_hearts",
      "heart_eyes",
      "star-struck",
      "kissing_heart",
      "kissing",
      "relaxed",
      "kissing_closed_eyes",
      "kissing_smiling_eyes",
      "yum",
      "stuck_out_tongue",
      "stuck_out_tongue_winking_eye",
      "zany_face",
      "stuck_out_tongue_closed_eyes",
      "money_mouth_face",
      "hugging_face",
      "face_with_hand_over_mouth",
      "shushing_face",
      "thinking_face",
      "zipper_mouth_face",
      "face_with_raised_eyebrow",
      "neutral_face",
      "expressionless",
      "no_mouth",
      "smirk",
      "unamused",
      "face_with_rolling_eyes",
      "grimacing",
      "lying_face",
      "relieved",
      "pensive",
      "sleepy",
      "drooling_face",
      "sleeping",
      "mask",
      "face_with_thermometer",
      "face_with_head_bandage",
      "nauseated_face",
      "face_vomiting",
      "sneezing_face",
      "hot_face",
      "cold_face",
      "woozy_face",
      "dizzy_face",
      "exploding_head",
      "face_with_cowboy_hat",
      "partying_face",
      "sunglasses",
      "nerd_face",
      "face_with_monocle",
      "confused",
      "worried",
      "slightly_frowning_face",
      "white_frowning_face",
      "open_mouth",
      "hushed",
      "astonished",
      "flushed",
      "pleading_face",
      "frowning",
      "anguished",
      "fearful",
      "cold_sweat",
      "disappointed_relieved",
      "cry",
      "sob",
      "scream",
      "confounded",
      "persevere",
      "disappointed",
      "sweat",
      "weary",
      "tired_face",
      "yawning_face",
      "triumph",
      "rage",
      "angry",
      "face_with_symbols_on_mouth",
      "smiling_imp",
      "imp",
      "skull",
      "skull_and_crossbones",
      "hankey",
      "clown_face",
      "japanese_ogre",
      "japanese_goblin",
      "ghost",
      "alien",
      "space_invader",
      "robot_face",
      "smiley_cat",
      "smile_cat",
      "joy_cat",
      "heart_eyes_cat",
      "smirk_cat",
      "kissing_cat",
      "scream_cat",
      "crying_cat_face",
      "pouting_cat",
      "see_no_evil",
      "hear_no_evil",
      "speak_no_evil",
      "wave",
      "raised_back_of_hand",
      "raised_hand_with_fingers_splayed",
      "hand",
      "spock-hand",
      "ok_hand",
      "pinching_hand",
      "v",
      "crossed_fingers",
      "i_love_you_hand_sign",
      "the_horns",
      "call_me_hand",
      "point_left",
      "point_right",
      "point_up_2",
      "middle_finger",
      "point_down",
      "point_up",
      "+1",
      "-1",
      "fist",
      "facepunch",
      "left-facing_fist",
      "right-facing_fist",
      "clap",
      "raised_hands",
      "open_hands",
      "palms_up_together",
      "handshake",
      "pray",
      "writing_hand",
      "nail_care",
      "selfie",
      "muscle",
      "mechanical_arm",
      "mechanical_leg",
      "leg",
      "foot",
      "ear",
      "ear_with_hearing_aid",
      "nose",
      "brain",
      "tooth",
      "bone",
      "eyes",
      "eye",
      "tongue",
      "lips",
      "baby",
      "child",
      "boy",
      "girl",
      "adult",
      "person_with_blond_hair",
      "man",
      "bearded_person",
      "red_haired_man",
      "curly_haired_man",
      "white_haired_man",
      "bald_man",
      "woman",
      "red_haired_woman",
      "red_haired_person",
      "curly_haired_woman",
      "curly_haired_person",
      "white_haired_woman",
      "white_haired_person",
      "bald_woman",
      "bald_person",
      "blond-haired-woman",
      "blond-haired-man",
      "older_adult",
      "older_man",
      "older_woman",
      "person_frowning",
      "man-frowning",
      "woman-frowning",
      "person_with_pouting_face",
      "man-pouting",
      "woman-pouting",
      "no_good",
      "man-gesturing-no",
      "woman-gesturing-no",
      "ok_woman",
      "man-gesturing-ok",
      "woman-gesturing-ok",
      "information_desk_person",
      "man-tipping-hand",
      "woman-tipping-hand",
      "raising_hand",
      "man-raising-hand",
      "woman-raising-hand",
      "deaf_person",
      "deaf_man",
      "deaf_woman",
      "bow",
      "man-bowing",
      "woman-bowing",
      "face_palm",
      "man-facepalming",
      "woman-facepalming",
      "shrug",
      "man-shrugging",
      "woman-shrugging",
      "health_worker",
      "male-doctor",
      "female-doctor",
      "student",
      "male-student",
      "female-student",
      "teacher",
      "male-teacher",
      "female-teacher",
      "judge",
      "male-judge",
      "female-judge",
      "farmer",
      "male-farmer",
      "female-farmer",
      "cook",
      "male-cook",
      "female-cook",
      "mechanic",
      "male-mechanic",
      "female-mechanic",
      "factory_worker",
      "male-factory-worker",
      "female-factory-worker",
      "office_worker",
      "male-office-worker",
      "female-office-worker",
      "scientist",
      "male-scientist",
      "female-scientist",
      "technologist",
      "male-technologist",
      "female-technologist",
      "singer",
      "male-singer",
      "female-singer",
      "artist",
      "male-artist",
      "female-artist",
      "pilot",
      "male-pilot",
      "female-pilot",
      "astronaut",
      "male-astronaut",
      "female-astronaut",
      "firefighter",
      "male-firefighter",
      "female-firefighter",
      "cop",
      "male-police-officer",
      "female-police-officer",
      "sleuth_or_spy",
      "male-detective",
      "female-detective",
      "guardsman",
      "male-guard",
      "female-guard",
      "construction_worker",
      "male-construction-worker",
      "female-construction-worker",
      "prince",
      "princess",
      "man_with_turban",
      "man-wearing-turban",
      "woman-wearing-turban",
      "man_with_gua_pi_mao",
      "person_with_headscarf",
      "man_in_tuxedo",
      "bride_with_veil",
      "pregnant_woman",
      "breast-feeding",
      "angel",
      "santa",
      "mrs_claus",
      "superhero",
      "male_superhero",
      "female_superhero",
      "supervillain",
      "male_supervillain",
      "female_supervillain",
      "mage",
      "male_mage",
      "female_mage",
      "fairy",
      "male_fairy",
      "female_fairy",
      "vampire",
      "male_vampire",
      "female_vampire",
      "merperson",
      "merman",
      "mermaid",
      "elf",
      "male_elf",
      "female_elf",
      "genie",
      "male_genie",
      "female_genie",
      "zombie",
      "male_zombie",
      "female_zombie",
      "massage",
      "man-getting-massage",
      "woman-getting-massage",
      "haircut",
      "man-getting-haircut",
      "woman-getting-haircut",
      "walking",
      "man-walking",
      "woman-walking",
      "standing_person",
      "man_standing",
      "woman_standing",
      "kneeling_person",
      "man_kneeling",
      "woman_kneeling",
      "person_with_probing_cane",
      "man_with_probing_cane",
      "woman_with_probing_cane",
      "person_in_motorized_wheelchair",
      "man_in_motorized_wheelchair",
      "woman_in_motorized_wheelchair",
      "person_in_manual_wheelchair",
      "man_in_manual_wheelchair",
      "woman_in_manual_wheelchair",
      "runner",
      "man-running",
      "woman-running",
      "dancer",
      "man_dancing",
      "man_in_business_suit_levitating",
      "dancers",
      "man-with-bunny-ears-partying",
      "woman-with-bunny-ears-partying",
      "person_in_steamy_room",
      "man_in_steamy_room",
      "woman_in_steamy_room",
      "person_climbing",
      "man_climbing",
      "woman_climbing",
      "fencer",
      "horse_racing",
      "skier",
      "snowboarder",
      "golfer",
      "man-golfing",
      "woman-golfing",
      "surfer",
      "man-surfing",
      "woman-surfing",
      "rowboat",
      "man-rowing-boat",
      "woman-rowing-boat",
      "swimmer",
      "man-swimming",
      "woman-swimming",
      "person_with_ball",
      "man-bouncing-ball",
      "woman-bouncing-ball",
      "weight_lifter",
      "man-lifting-weights",
      "woman-lifting-weights",
      "bicyclist",
      "man-biking",
      "woman-biking",
      "mountain_bicyclist",
      "man-mountain-biking",
      "woman-mountain-biking",
      "person_doing_cartwheel",
      "man-cartwheeling",
      "woman-cartwheeling",
      "wrestlers",
      "man-wrestling",
      "woman-wrestling",
      "water_polo",
      "man-playing-water-polo",
      "woman-playing-water-polo",
      "handball",
      "man-playing-handball",
      "woman-playing-handball",
      "juggling",
      "man-juggling",
      "woman-juggling",
      "person_in_lotus_position",
      "man_in_lotus_position",
      "woman_in_lotus_position",
      "bath",
      "sleeping_accommodation",
      "people_holding_hands",
      "two_women_holding_hands",
      "couple",
      "two_men_holding_hands",
      "couplekiss",
      "woman-kiss-man",
      "man-kiss-man",
      "woman-kiss-woman",
      "couple_with_heart",
      "woman-heart-man",
      "man-heart-man",
      "woman-heart-woman",
      "family",
      "man-woman-boy",
      "man-woman-girl",
      "man-woman-girl-boy",
      "man-woman-boy-boy",
      "man-woman-girl-girl",
      "man-man-boy",
      "man-man-girl",
      "man-man-girl-boy",
      "man-man-boy-boy",
      "man-man-girl-girl",
      "woman-woman-boy",
      "woman-woman-girl",
      "woman-woman-girl-boy",
      "woman-woman-boy-boy",
      "woman-woman-girl-girl",
      "man-boy",
      "man-boy-boy",
      "man-girl",
      "man-girl-boy",
      "man-girl-girl",
      "woman-boy",
      "woman-boy-boy",
      "woman-girl",
      "woman-girl-boy",
      "woman-girl-girl",
      "speaking_head_in_silhouette",
      "bust_in_silhouette",
      "busts_in_silhouette",
      "footprints",
      "kiss",
      "love_letter",
      "cupid",
      "gift_heart",
      "sparkling_heart",
      "heartpulse",
      "heartbeat",
      "revolving_hearts",
      "two_hearts",
      "heart_decoration",
      "heavy_heart_exclamation_mark_ornament",
      "broken_heart",
      "heart",
      "orange_heart",
      "yellow_heart",
      "green_heart",
      "blue_heart",
      "purple_heart",
      "brown_heart",
      "black_heart",
      "white_heart",
      "100",
      "anger",
      "boom",
      "dizzy",
      "sweat_drops",
      "dash",
      "hole",
      "bomb",
      "speech_balloon",
      "eye-in-speech-bubble",
      "left_speech_bubble",
      "right_anger_bubble",
      "thought_balloon",
      "zzz"
    ]
  },
  {
    id: "nature",
    name: "Animals & Nature",
    emojis: [
      "monkey_face",
      "monkey",
      "gorilla",
      "orangutan",
      "dog",
      "dog2",
      "guide_dog",
      "service_dog",
      "poodle",
      "wolf",
      "fox_face",
      "raccoon",
      "cat",
      "cat2",
      "lion_face",
      "tiger",
      "tiger2",
      "leopard",
      "horse",
      "racehorse",
      "unicorn_face",
      "zebra_face",
      "deer",
      "cow",
      "ox",
      "water_buffalo",
      "cow2",
      "pig",
      "pig2",
      "boar",
      "pig_nose",
      "ram",
      "sheep",
      "goat",
      "dromedary_camel",
      "camel",
      "llama",
      "giraffe_face",
      "elephant",
      "rhinoceros",
      "hippopotamus",
      "mouse",
      "mouse2",
      "rat",
      "hamster",
      "rabbit",
      "rabbit2",
      "chipmunk",
      "hedgehog",
      "bat",
      "bear",
      "koala",
      "panda_face",
      "sloth",
      "otter",
      "skunk",
      "kangaroo",
      "badger",
      "feet",
      "turkey",
      "chicken",
      "rooster",
      "hatching_chick",
      "baby_chick",
      "hatched_chick",
      "bird",
      "penguin",
      "dove_of_peace",
      "eagle",
      "duck",
      "swan",
      "owl",
      "flamingo",
      "peacock",
      "parrot",
      "frog",
      "crocodile",
      "turtle",
      "lizard",
      "snake",
      "dragon_face",
      "dragon",
      "sauropod",
      "t-rex",
      "whale",
      "whale2",
      "dolphin",
      "fish",
      "tropical_fish",
      "blowfish",
      "shark",
      "octopus",
      "shell",
      "snail",
      "butterfly",
      "bug",
      "ant",
      "bee",
      "beetle",
      "cricket",
      "spider",
      "spider_web",
      "scorpion",
      "mosquito",
      "microbe",
      "bouquet",
      "cherry_blossom",
      "white_flower",
      "rosette",
      "rose",
      "wilted_flower",
      "hibiscus",
      "sunflower",
      "blossom",
      "tulip",
      "seedling",
      "evergreen_tree",
      "deciduous_tree",
      "palm_tree",
      "cactus",
      "ear_of_rice",
      "herb",
      "shamrock",
      "four_leaf_clover",
      "maple_leaf",
      "fallen_leaf",
      "leaves"
    ]
  },
  {
    id: "foods",
    name: "Food & Drink",
    emojis: [
      "grapes",
      "melon",
      "watermelon",
      "tangerine",
      "lemon",
      "banana",
      "pineapple",
      "mango",
      "apple",
      "green_apple",
      "pear",
      "peach",
      "cherries",
      "strawberry",
      "kiwifruit",
      "tomato",
      "coconut",
      "avocado",
      "eggplant",
      "potato",
      "carrot",
      "corn",
      "hot_pepper",
      "cucumber",
      "leafy_green",
      "broccoli",
      "garlic",
      "onion",
      "mushroom",
      "peanuts",
      "chestnut",
      "bread",
      "croissant",
      "baguette_bread",
      "pretzel",
      "bagel",
      "pancakes",
      "waffle",
      "cheese_wedge",
      "meat_on_bone",
      "poultry_leg",
      "cut_of_meat",
      "bacon",
      "hamburger",
      "fries",
      "pizza",
      "hotdog",
      "sandwich",
      "taco",
      "burrito",
      "stuffed_flatbread",
      "falafel",
      "egg",
      "fried_egg",
      "shallow_pan_of_food",
      "stew",
      "bowl_with_spoon",
      "green_salad",
      "popcorn",
      "butter",
      "salt",
      "canned_food",
      "bento",
      "rice_cracker",
      "rice_ball",
      "rice",
      "curry",
      "ramen",
      "spaghetti",
      "sweet_potato",
      "oden",
      "sushi",
      "fried_shrimp",
      "fish_cake",
      "moon_cake",
      "dango",
      "dumpling",
      "fortune_cookie",
      "takeout_box",
      "crab",
      "lobster",
      "shrimp",
      "squid",
      "oyster",
      "icecream",
      "shaved_ice",
      "ice_cream",
      "doughnut",
      "cookie",
      "birthday",
      "cake",
      "cupcake",
      "pie",
      "chocolate_bar",
      "candy",
      "lollipop",
      "custard",
      "honey_pot",
      "baby_bottle",
      "glass_of_milk",
      "coffee",
      "tea",
      "sake",
      "champagne",
      "wine_glass",
      "cocktail",
      "tropical_drink",
      "beer",
      "beers",
      "clinking_glasses",
      "tumbler_glass",
      "cup_with_straw",
      "beverage_box",
      "mate_drink",
      "ice_cube",
      "chopsticks",
      "knife_fork_plate",
      "fork_and_knife",
      "spoon",
      "hocho",
      "amphora"
    ]
  },
  {
    id: "activity",
    name: "Activities",
    emojis: [
      "jack_o_lantern",
      "christmas_tree",
      "fireworks",
      "sparkler",
      "firecracker",
      "sparkles",
      "balloon",
      "tada",
      "confetti_ball",
      "tanabata_tree",
      "bamboo",
      "dolls",
      "flags",
      "wind_chime",
      "rice_scene",
      "red_envelope",
      "ribbon",
      "gift",
      "reminder_ribbon",
      "admission_tickets",
      "ticket",
      "medal",
      "trophy",
      "sports_medal",
      "first_place_medal",
      "second_place_medal",
      "third_place_medal",
      "soccer",
      "baseball",
      "softball",
      "basketball",
      "volleyball",
      "football",
      "rugby_football",
      "tennis",
      "flying_disc",
      "bowling",
      "cricket_bat_and_ball",
      "field_hockey_stick_and_ball",
      "ice_hockey_stick_and_puck",
      "lacrosse",
      "table_tennis_paddle_and_ball",
      "badminton_racquet_and_shuttlecock",
      "boxing_glove",
      "martial_arts_uniform",
      "goal_net",
      "golf",
      "ice_skate",
      "fishing_pole_and_fish",
      "diving_mask",
      "running_shirt_with_sash",
      "ski",
      "sled",
      "curling_stone",
      "dart",
      "yo-yo",
      "kite",
      "8ball",
      "crystal_ball",
      "nazar_amulet",
      "video_game",
      "joystick",
      "slot_machine",
      "game_die",
      "jigsaw",
      "teddy_bear",
      "spades",
      "hearts",
      "diamonds",
      "clubs",
      "chess_pawn",
      "black_joker",
      "mahjong",
      "flower_playing_cards",
      "performing_arts",
      "frame_with_picture",
      "art",
      "thread",
      "yarn"
    ]
  },
  {
    id: "places",
    name: "Travel & Places",
    emojis: [
      "earth_africa",
      "earth_americas",
      "earth_asia",
      "globe_with_meridians",
      "world_map",
      "japan",
      "compass",
      "snow_capped_mountain",
      "mountain",
      "volcano",
      "mount_fuji",
      "camping",
      "beach_with_umbrella",
      "desert",
      "desert_island",
      "national_park",
      "stadium",
      "classical_building",
      "building_construction",
      "bricks",
      "house_buildings",
      "derelict_house_building",
      "house",
      "house_with_garden",
      "office",
      "post_office",
      "european_post_office",
      "hospital",
      "bank",
      "hotel",
      "love_hotel",
      "convenience_store",
      "school",
      "department_store",
      "factory",
      "japanese_castle",
      "european_castle",
      "wedding",
      "tokyo_tower",
      "statue_of_liberty",
      "church",
      "mosque",
      "hindu_temple",
      "synagogue",
      "shinto_shrine",
      "kaaba",
      "fountain",
      "tent",
      "foggy",
      "night_with_stars",
      "cityscape",
      "sunrise_over_mountains",
      "sunrise",
      "city_sunset",
      "city_sunrise",
      "bridge_at_night",
      "hotsprings",
      "carousel_horse",
      "ferris_wheel",
      "roller_coaster",
      "barber",
      "circus_tent",
      "steam_locomotive",
      "railway_car",
      "bullettrain_side",
      "bullettrain_front",
      "train2",
      "metro",
      "light_rail",
      "station",
      "tram",
      "monorail",
      "mountain_railway",
      "train",
      "bus",
      "oncoming_bus",
      "trolleybus",
      "minibus",
      "ambulance",
      "fire_engine",
      "police_car",
      "oncoming_police_car",
      "taxi",
      "oncoming_taxi",
      "car",
      "oncoming_automobile",
      "blue_car",
      "truck",
      "articulated_lorry",
      "tractor",
      "racing_car",
      "racing_motorcycle",
      "motor_scooter",
      "manual_wheelchair",
      "motorized_wheelchair",
      "auto_rickshaw",
      "bike",
      "scooter",
      "skateboard",
      "busstop",
      "motorway",
      "railway_track",
      "oil_drum",
      "fuelpump",
      "rotating_light",
      "traffic_light",
      "vertical_traffic_light",
      "octagonal_sign",
      "construction",
      "anchor",
      "boat",
      "canoe",
      "speedboat",
      "passenger_ship",
      "ferry",
      "motor_boat",
      "ship",
      "airplane",
      "small_airplane",
      "airplane_departure",
      "airplane_arriving",
      "parachute",
      "seat",
      "helicopter",
      "suspension_railway",
      "mountain_cableway",
      "aerial_tramway",
      "satellite",
      "rocket",
      "flying_saucer",
      "bellhop_bell",
      "luggage",
      "hourglass",
      "hourglass_flowing_sand",
      "watch",
      "alarm_clock",
      "stopwatch",
      "timer_clock",
      "mantelpiece_clock",
      "clock12",
      "clock1230",
      "clock1",
      "clock130",
      "clock2",
      "clock230",
      "clock3",
      "clock330",
      "clock4",
      "clock430",
      "clock5",
      "clock530",
      "clock6",
      "clock630",
      "clock7",
      "clock730",
      "clock8",
      "clock830",
      "clock9",
      "clock930",
      "clock10",
      "clock1030",
      "clock11",
      "clock1130",
      "new_moon",
      "waxing_crescent_moon",
      "first_quarter_moon",
      "moon",
      "full_moon",
      "waning_gibbous_moon",
      "last_quarter_moon",
      "waning_crescent_moon",
      "crescent_moon",
      "new_moon_with_face",
      "first_quarter_moon_with_face",
      "last_quarter_moon_with_face",
      "thermometer",
      "sunny",
      "full_moon_with_face",
      "sun_with_face",
      "ringed_planet",
      "star",
      "star2",
      "stars",
      "milky_way",
      "cloud",
      "partly_sunny",
      "thunder_cloud_and_rain",
      "mostly_sunny",
      "barely_sunny",
      "partly_sunny_rain",
      "rain_cloud",
      "snow_cloud",
      "lightning",
      "tornado",
      "fog",
      "wind_blowing_face",
      "cyclone",
      "rainbow",
      "closed_umbrella",
      "umbrella",
      "umbrella_with_rain_drops",
      "umbrella_on_ground",
      "zap",
      "snowflake",
      "snowman",
      "snowman_without_snow",
      "comet",
      "fire",
      "droplet",
      "ocean"
    ]
  },
  {
    id: "objects",
    name: "Objects",
    emojis: [
      "eyeglasses",
      "dark_sunglasses",
      "goggles",
      "lab_coat",
      "safety_vest",
      "necktie",
      "shirt",
      "jeans",
      "scarf",
      "gloves",
      "coat",
      "socks",
      "dress",
      "kimono",
      "sari",
      "one-piece_swimsuit",
      "briefs",
      "shorts",
      "bikini",
      "womans_clothes",
      "purse",
      "handbag",
      "pouch",
      "shopping_bags",
      "school_satchel",
      "mans_shoe",
      "athletic_shoe",
      "hiking_boot",
      "womans_flat_shoe",
      "high_heel",
      "sandal",
      "ballet_shoes",
      "boot",
      "crown",
      "womans_hat",
      "tophat",
      "mortar_board",
      "billed_cap",
      "helmet_with_white_cross",
      "prayer_beads",
      "lipstick",
      "ring",
      "gem",
      "mute",
      "speaker",
      "sound",
      "loud_sound",
      "loudspeaker",
      "mega",
      "postal_horn",
      "bell",
      "no_bell",
      "musical_score",
      "musical_note",
      "notes",
      "studio_microphone",
      "level_slider",
      "control_knobs",
      "microphone",
      "headphones",
      "radio",
      "saxophone",
      "guitar",
      "musical_keyboard",
      "trumpet",
      "violin",
      "banjo",
      "drum_with_drumsticks",
      "iphone",
      "calling",
      "phone",
      "telephone_receiver",
      "pager",
      "fax",
      "battery",
      "electric_plug",
      "computer",
      "desktop_computer",
      "printer",
      "keyboard",
      "three_button_mouse",
      "trackball",
      "minidisc",
      "floppy_disk",
      "cd",
      "dvd",
      "abacus",
      "movie_camera",
      "film_frames",
      "film_projector",
      "clapper",
      "tv",
      "camera",
      "camera_with_flash",
      "video_camera",
      "vhs",
      "mag",
      "mag_right",
      "candle",
      "bulb",
      "flashlight",
      "izakaya_lantern",
      "diya_lamp",
      "notebook_with_decorative_cover",
      "closed_book",
      "book",
      "green_book",
      "blue_book",
      "orange_book",
      "books",
      "notebook",
      "ledger",
      "page_with_curl",
      "scroll",
      "page_facing_up",
      "newspaper",
      "rolled_up_newspaper",
      "bookmark_tabs",
      "bookmark",
      "label",
      "moneybag",
      "yen",
      "dollar",
      "euro",
      "pound",
      "money_with_wings",
      "credit_card",
      "receipt",
      "chart",
      "currency_exchange",
      "heavy_dollar_sign",
      "email",
      "e-mail",
      "incoming_envelope",
      "envelope_with_arrow",
      "outbox_tray",
      "inbox_tray",
      "package",
      "mailbox",
      "mailbox_closed",
      "mailbox_with_mail",
      "mailbox_with_no_mail",
      "postbox",
      "ballot_box_with_ballot",
      "pencil2",
      "black_nib",
      "lower_left_fountain_pen",
      "lower_left_ballpoint_pen",
      "lower_left_paintbrush",
      "lower_left_crayon",
      "memo",
      "briefcase",
      "file_folder",
      "open_file_folder",
      "card_index_dividers",
      "date",
      "calendar",
      "spiral_note_pad",
      "spiral_calendar_pad",
      "card_index",
      "chart_with_upwards_trend",
      "chart_with_downwards_trend",
      "bar_chart",
      "clipboard",
      "pushpin",
      "round_pushpin",
      "paperclip",
      "linked_paperclips",
      "straight_ruler",
      "triangular_ruler",
      "scissors",
      "card_file_box",
      "file_cabinet",
      "wastebasket",
      "lock",
      "unlock",
      "lock_with_ink_pen",
      "closed_lock_with_key",
      "key",
      "old_key",
      "hammer",
      "axe",
      "pick",
      "hammer_and_pick",
      "hammer_and_wrench",
      "dagger_knife",
      "crossed_swords",
      "gun",
      "bow_and_arrow",
      "shield",
      "wrench",
      "nut_and_bolt",
      "gear",
      "compression",
      "scales",
      "probing_cane",
      "link",
      "chains",
      "toolbox",
      "magnet",
      "alembic",
      "test_tube",
      "petri_dish",
      "dna",
      "microscope",
      "telescope",
      "satellite_antenna",
      "syringe",
      "drop_of_blood",
      "pill",
      "adhesive_bandage",
      "stethoscope",
      "door",
      "bed",
      "couch_and_lamp",
      "chair",
      "toilet",
      "shower",
      "bathtub",
      "razor",
      "lotion_bottle",
      "safety_pin",
      "broom",
      "basket",
      "roll_of_paper",
      "soap",
      "sponge",
      "fire_extinguisher",
      "shopping_trolley",
      "smoking",
      "coffin",
      "funeral_urn",
      "moyai"
    ]
  },
  {
    id: "symbols",
    name: "Symbols",
    emojis: [
      "atm",
      "put_litter_in_its_place",
      "potable_water",
      "wheelchair",
      "mens",
      "womens",
      "restroom",
      "baby_symbol",
      "wc",
      "passport_control",
      "customs",
      "baggage_claim",
      "left_luggage",
      "warning",
      "children_crossing",
      "no_entry",
      "no_entry_sign",
      "no_bicycles",
      "no_smoking",
      "do_not_litter",
      "non-potable_water",
      "no_pedestrians",
      "no_mobile_phones",
      "underage",
      "radioactive_sign",
      "biohazard_sign",
      "arrow_up",
      "arrow_upper_right",
      "arrow_right",
      "arrow_lower_right",
      "arrow_down",
      "arrow_lower_left",
      "arrow_left",
      "arrow_upper_left",
      "arrow_up_down",
      "left_right_arrow",
      "leftwards_arrow_with_hook",
      "arrow_right_hook",
      "arrow_heading_up",
      "arrow_heading_down",
      "arrows_clockwise",
      "arrows_counterclockwise",
      "back",
      "end",
      "on",
      "soon",
      "top",
      "place_of_worship",
      "atom_symbol",
      "om_symbol",
      "star_of_david",
      "wheel_of_dharma",
      "yin_yang",
      "latin_cross",
      "orthodox_cross",
      "star_and_crescent",
      "peace_symbol",
      "menorah_with_nine_branches",
      "six_pointed_star",
      "aries",
      "taurus",
      "gemini",
      "cancer",
      "leo",
      "virgo",
      "libra",
      "scorpius",
      "sagittarius",
      "capricorn",
      "aquarius",
      "pisces",
      "ophiuchus",
      "twisted_rightwards_arrows",
      "repeat",
      "repeat_one",
      "arrow_forward",
      "fast_forward",
      "black_right_pointing_double_triangle_with_vertical_bar",
      "black_right_pointing_triangle_with_double_vertical_bar",
      "arrow_backward",
      "rewind",
      "black_left_pointing_double_triangle_with_vertical_bar",
      "arrow_up_small",
      "arrow_double_up",
      "arrow_down_small",
      "arrow_double_down",
      "double_vertical_bar",
      "black_square_for_stop",
      "black_circle_for_record",
      "eject",
      "cinema",
      "low_brightness",
      "high_brightness",
      "signal_strength",
      "vibration_mode",
      "mobile_phone_off",
      "female_sign",
      "male_sign",
      "medical_symbol",
      "infinity",
      "recycle",
      "fleur_de_lis",
      "trident",
      "name_badge",
      "beginner",
      "o",
      "white_check_mark",
      "ballot_box_with_check",
      "heavy_check_mark",
      "heavy_multiplication_x",
      "x",
      "negative_squared_cross_mark",
      "heavy_plus_sign",
      "heavy_minus_sign",
      "heavy_division_sign",
      "curly_loop",
      "loop",
      "part_alternation_mark",
      "eight_spoked_asterisk",
      "eight_pointed_black_star",
      "sparkle",
      "bangbang",
      "interrobang",
      "question",
      "grey_question",
      "grey_exclamation",
      "exclamation",
      "wavy_dash",
      "copyright",
      "registered",
      "tm",
      "hash",
      "keycap_star",
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "keycap_ten",
      "capital_abcd",
      "abcd",
      "1234",
      "symbols",
      "abc",
      "a",
      "ab",
      "b",
      "cl",
      "cool",
      "free",
      "information_source",
      "id",
      "m",
      "new",
      "ng",
      "o2",
      "ok",
      "parking",
      "sos",
      "up",
      "vs",
      "koko",
      "sa",
      "u6708",
      "u6709",
      "u6307",
      "ideograph_advantage",
      "u5272",
      "u7121",
      "u7981",
      "accept",
      "u7533",
      "u5408",
      "u7a7a",
      "congratulations",
      "secret",
      "u55b6",
      "u6e80",
      "red_circle",
      "large_orange_circle",
      "large_yellow_circle",
      "large_green_circle",
      "large_blue_circle",
      "large_purple_circle",
      "large_brown_circle",
      "black_circle",
      "white_circle",
      "large_red_square",
      "large_orange_square",
      "large_yellow_square",
      "large_green_square",
      "large_blue_square",
      "large_purple_square",
      "large_brown_square",
      "black_large_square",
      "white_large_square",
      "black_medium_square",
      "white_medium_square",
      "black_medium_small_square",
      "white_medium_small_square",
      "black_small_square",
      "white_small_square",
      "large_orange_diamond",
      "large_blue_diamond",
      "small_orange_diamond",
      "small_blue_diamond",
      "small_red_triangle",
      "small_red_triangle_down",
      "diamond_shape_with_a_dot_inside",
      "radio_button",
      "white_square_button",
      "black_square_button"
    ]
  },
  {
    id: "flags",
    name: "Flags",
    emojis: [
      "checkered_flag",
      "cn",
      "crossed_flags",
      "de",
      "es",
      "flag-ac",
      "flag-ad",
      "flag-ae",
      "flag-af",
      "flag-ag",
      "flag-ai",
      "flag-al",
      "flag-am",
      "flag-ao",
      "flag-aq",
      "flag-ar",
      "flag-as",
      "flag-at",
      "flag-au",
      "flag-aw",
      "flag-ax",
      "flag-az",
      "flag-ba",
      "flag-bb",
      "flag-bd",
      "flag-be",
      "flag-bf",
      "flag-bg",
      "flag-bh",
      "flag-bi",
      "flag-bj",
      "flag-bl",
      "flag-bm",
      "flag-bn",
      "flag-bo",
      "flag-bq",
      "flag-br",
      "flag-bs",
      "flag-bt",
      "flag-bv",
      "flag-bw",
      "flag-by",
      "flag-bz",
      "flag-ca",
      "flag-cc",
      "flag-cd",
      "flag-cf",
      "flag-cg",
      "flag-ch",
      "flag-ci",
      "flag-ck",
      "flag-cl",
      "flag-cm",
      "flag-co",
      "flag-cp",
      "flag-cr",
      "flag-cu",
      "flag-cv",
      "flag-cw",
      "flag-cx",
      "flag-cy",
      "flag-cz",
      "flag-dg",
      "flag-dj",
      "flag-dk",
      "flag-dm",
      "flag-do",
      "flag-dz",
      "flag-ea",
      "flag-ec",
      "flag-ee",
      "flag-eg",
      "flag-eh",
      "flag-england",
      "flag-er",
      "flag-et",
      "flag-eu",
      "flag-fi",
      "flag-fj",
      "flag-fk",
      "flag-fm",
      "flag-fo",
      "flag-ga",
      "flag-gd",
      "flag-ge",
      "flag-gf",
      "flag-gg",
      "flag-gh",
      "flag-gi",
      "flag-gl",
      "flag-gm",
      "flag-gn",
      "flag-gp",
      "flag-gq",
      "flag-gr",
      "flag-gs",
      "flag-gt",
      "flag-gu",
      "flag-gw",
      "flag-gy",
      "flag-hk",
      "flag-hm",
      "flag-hn",
      "flag-hr",
      "flag-ht",
      "flag-hu",
      "flag-ic",
      "flag-id",
      "flag-ie",
      "flag-il",
      "flag-im",
      "flag-in",
      "flag-io",
      "flag-iq",
      "flag-ir",
      "flag-is",
      "flag-je",
      "flag-jm",
      "flag-jo",
      "flag-ke",
      "flag-kg",
      "flag-kh",
      "flag-ki",
      "flag-km",
      "flag-kn",
      "flag-kp",
      "flag-kw",
      "flag-ky",
      "flag-kz",
      "flag-la",
      "flag-lb",
      "flag-lc",
      "flag-li",
      "flag-lk",
      "flag-lr",
      "flag-ls",
      "flag-lt",
      "flag-lu",
      "flag-lv",
      "flag-ly",
      "flag-ma",
      "flag-mc",
      "flag-md",
      "flag-me",
      "flag-mf",
      "flag-mg",
      "flag-mh",
      "flag-mk",
      "flag-ml",
      "flag-mm",
      "flag-mn",
      "flag-mo",
      "flag-mp",
      "flag-mq",
      "flag-mr",
      "flag-ms",
      "flag-mt",
      "flag-mu",
      "flag-mv",
      "flag-mw",
      "flag-mx",
      "flag-my",
      "flag-mz",
      "flag-na",
      "flag-nc",
      "flag-ne",
      "flag-nf",
      "flag-ng",
      "flag-ni",
      "flag-nl",
      "flag-no",
      "flag-np",
      "flag-nr",
      "flag-nu",
      "flag-nz",
      "flag-om",
      "flag-pa",
      "flag-pe",
      "flag-pf",
      "flag-pg",
      "flag-ph",
      "flag-pk",
      "flag-pl",
      "flag-pm",
      "flag-pn",
      "flag-pr",
      "flag-ps",
      "flag-pt",
      "flag-pw",
      "flag-py",
      "flag-qa",
      "flag-re",
      "flag-ro",
      "flag-rs",
      "flag-rw",
      "flag-sa",
      "flag-sb",
      "flag-sc",
      "flag-scotland",
      "flag-sd",
      "flag-se",
      "flag-sg",
      "flag-sh",
      "flag-si",
      "flag-sj",
      "flag-sk",
      "flag-sl",
      "flag-sm",
      "flag-sn",
      "flag-so",
      "flag-sr",
      "flag-ss",
      "flag-st",
      "flag-sv",
      "flag-sx",
      "flag-sy",
      "flag-sz",
      "flag-ta",
      "flag-tc",
      "flag-td",
      "flag-tf",
      "flag-tg",
      "flag-th",
      "flag-tj",
      "flag-tk",
      "flag-tl",
      "flag-tm",
      "flag-tn",
      "flag-to",
      "flag-tr",
      "flag-tt",
      "flag-tv",
      "flag-tw",
      "flag-tz",
      "flag-ua",
      "flag-ug",
      "flag-um",
      "flag-uy",
      "flag-uz",
      "flag-va",
      "flag-vc",
      "flag-ve",
      "flag-vg",
      "flag-vi",
      "flag-vn",
      "flag-vu",
      "flag-wales",
      "flag-wf",
      "flag-ws",
      "flag-xk",
      "flag-ye",
      "flag-yt",
      "flag-za",
      "flag-zm",
      "flag-zw",
      "fr",
      "gb",
      "it",
      "jp",
      "kr",
      "pirate_flag",
      "rainbow-flag",
      "ru",
      "triangular_flag_on_post",
      "us",
      "waving_black_flag",
      "waving_white_flag"
    ]
  }
], emojis$1 = {
  100: {
    a: "Hundred Points Symbol",
    b: "1F4AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "score",
      "perfect",
      "numbers",
      "century",
      "exam",
      "quiz",
      "test",
      "pass",
      "hundred"
    ],
    k: [
      26,
      5
    ],
    o: 2
  },
  1234: {
    a: "Input Symbol for Numbers",
    b: "1F522",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "numbers",
      "blue-square"
    ],
    k: [
      28,
      5
    ],
    o: 2
  },
  grinning: {
    a: "Grinning Face",
    b: "1F600",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "smile",
      "happy",
      "joy",
      ":D",
      "grin"
    ],
    k: [
      30,
      35
    ],
    m: ":D",
    o: 2
  },
  monkey_face: {
    a: "Monkey Face",
    b: "1F435",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "circus"
    ],
    k: [
      12,
      25
    ],
    l: [
      ":o)"
    ],
    o: 2
  },
  grapes: {
    a: "Grapes",
    b: "1F347",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "wine"
    ],
    k: [
      6,
      31
    ],
    o: 2
  },
  eyeglasses: {
    a: "Eyeglasses",
    b: "1F453",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "accessories",
      "eyesight",
      "nerdy",
      "dork",
      "geek"
    ],
    k: [
      14,
      7
    ],
    o: 2
  },
  checkered_flag: {
    a: "Chequered Flag",
    b: "1F3C1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "contest",
      "finishline",
      "race",
      "gokart"
    ],
    k: [
      8,
      39
    ],
    o: 2
  },
  jack_o_lantern: {
    a: "Jack-O-Lantern",
    b: "1F383",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "halloween",
      "light",
      "pumpkin",
      "creepy",
      "fall"
    ],
    k: [
      7,
      34
    ],
    o: 2
  },
  wave: {
    skin_variations: {
      "1F3FB": {
        unified: "1F44B-1F3FB",
        non_qualified: null,
        image: "1f44b-1f3fb.png",
        sheet_x: 13,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44B-1F3FC",
        non_qualified: null,
        image: "1f44b-1f3fc.png",
        sheet_x: 13,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44B-1F3FD",
        non_qualified: null,
        image: "1f44b-1f3fd.png",
        sheet_x: 13,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44B-1F3FE",
        non_qualified: null,
        image: "1f44b-1f3fe.png",
        sheet_x: 13,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44B-1F3FF",
        non_qualified: null,
        image: "1f44b-1f3ff.png",
        sheet_x: 13,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Waving Hand Sign",
    b: "1F44B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hands",
      "gesture",
      "goodbye",
      "solong",
      "farewell",
      "hello",
      "hi",
      "palm"
    ],
    k: [
      13,
      26
    ],
    o: 2
  },
  earth_africa: {
    a: "Earth Globe Europe-Africa",
    b: "1F30D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "globe",
      "world",
      "international"
    ],
    k: [
      5,
      32
    ],
    o: 2
  },
  atm: {
    a: "Automated Teller Machine",
    b: "1F3E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "cash",
      "blue-square",
      "payment",
      "bank"
    ],
    k: [
      11,
      1
    ],
    o: 2
  },
  melon: {
    a: "Melon",
    b: "1F348",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature",
      "food"
    ],
    k: [
      6,
      32
    ],
    o: 2
  },
  triangular_flag_on_post: {
    a: "Triangular Flag on Post",
    b: "1F6A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mark",
      "milestone",
      "place"
    ],
    k: [
      35,
      0
    ],
    o: 2
  },
  put_litter_in_its_place: {
    a: "Put Litter in Its Place Symbol",
    b: "1F6AE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "sign",
      "human",
      "info"
    ],
    k: [
      35,
      5
    ],
    o: 2
  },
  christmas_tree: {
    a: "Christmas Tree",
    b: "1F384",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "festival",
      "vacation",
      "december",
      "xmas",
      "celebration"
    ],
    k: [
      7,
      35
    ],
    o: 2
  },
  monkey: {
    a: "Monkey",
    b: "1F412",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "banana",
      "circus"
    ],
    k: [
      11,
      46
    ],
    o: 2
  },
  earth_americas: {
    a: "Earth Globe Americas",
    b: "1F30E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "globe",
      "world",
      "USA",
      "international"
    ],
    k: [
      5,
      33
    ],
    o: 2
  },
  dark_sunglasses: {
    a: "Dark Sunglasses",
    b: "1F576-FE0F",
    c: "1F576",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "cool",
      "accessories"
    ],
    k: [
      29,
      33
    ],
    o: 2
  },
  raised_back_of_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F91A-1F3FB",
        non_qualified: null,
        image: "1f91a-1f3fb.png",
        sheet_x: 37,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91A-1F3FC",
        non_qualified: null,
        image: "1f91a-1f3fc.png",
        sheet_x: 37,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91A-1F3FD",
        non_qualified: null,
        image: "1f91a-1f3fd.png",
        sheet_x: 37,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91A-1F3FE",
        non_qualified: null,
        image: "1f91a-1f3fe.png",
        sheet_x: 37,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91A-1F3FF",
        non_qualified: null,
        image: "1f91a-1f3ff.png",
        sheet_x: 37,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Back of Hand",
    b: "1F91A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "raised",
      "backhand"
    ],
    k: [
      37,
      43
    ],
    o: 4
  },
  smiley: {
    a: "Smiling Face with Open Mouth",
    b: "1F603",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "happy",
      "joy",
      "haha",
      ":D",
      ":)",
      "smile",
      "funny"
    ],
    k: [
      30,
      38
    ],
    l: [
      "=)",
      "=-)"
    ],
    m: ":)",
    o: 2
  },
  earth_asia: {
    a: "Earth Globe Asia-Australia",
    b: "1F30F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "globe",
      "world",
      "east",
      "international"
    ],
    k: [
      5,
      34
    ],
    o: 2
  },
  crossed_flags: {
    a: "Crossed Flags",
    b: "1F38C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "nation",
      "country",
      "border"
    ],
    k: [
      7,
      48
    ],
    o: 2
  },
  watermelon: {
    a: "Watermelon",
    b: "1F349",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "picnic",
      "summer"
    ],
    k: [
      6,
      33
    ],
    o: 2
  },
  goggles: {
    a: "Goggles",
    b: "1F97D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      15
    ],
    o: 11
  },
  raised_hand_with_fingers_splayed: {
    skin_variations: {
      "1F3FB": {
        unified: "1F590-1F3FB",
        non_qualified: null,
        image: "1f590-1f3fb.png",
        sheet_x: 29,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F590-1F3FC",
        non_qualified: null,
        image: "1f590-1f3fc.png",
        sheet_x: 29,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F590-1F3FD",
        non_qualified: null,
        image: "1f590-1f3fd.png",
        sheet_x: 29,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F590-1F3FE",
        non_qualified: null,
        image: "1f590-1f3fe.png",
        sheet_x: 29,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F590-1F3FF",
        non_qualified: null,
        image: "1f590-1f3ff.png",
        sheet_x: 29,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Hand with Fingers Splayed",
    b: "1F590-FE0F",
    c: "1F590",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hand",
      "fingers",
      "palm"
    ],
    k: [
      29,
      48
    ],
    o: 2
  },
  smile: {
    a: "Smiling Face with Open Mouth and Smiling Eyes",
    b: "1F604",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "happy",
      "joy",
      "funny",
      "haha",
      "laugh",
      "like",
      ":D",
      ":)"
    ],
    k: [
      30,
      39
    ],
    l: [
      "C:",
      "c:",
      ":D",
      ":-D"
    ],
    m: ":)",
    o: 2
  },
  potable_water: {
    a: "Potable Water Symbol",
    b: "1F6B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "liquid",
      "restroom",
      "cleaning",
      "faucet"
    ],
    k: [
      35,
      7
    ],
    o: 2
  },
  fireworks: {
    a: "Fireworks",
    b: "1F386",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "festival",
      "carnival",
      "congratulations"
    ],
    k: [
      7,
      42
    ],
    o: 2
  },
  gorilla: {
    a: "Gorilla",
    b: "1F98D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "circus"
    ],
    k: [
      42,
      31
    ],
    o: 4
  },
  lab_coat: {
    a: "Lab Coat",
    b: "1F97C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      14
    ],
    o: 11
  },
  tangerine: {
    a: "Tangerine",
    b: "1F34A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "fruit",
      "nature",
      "orange"
    ],
    k: [
      6,
      34
    ],
    o: 2
  },
  wheelchair: {
    a: "Wheelchair Symbol",
    b: "267F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "disabled",
      "a11y",
      "accessibility"
    ],
    k: [
      53,
      40
    ],
    o: 2
  },
  waving_black_flag: {
    a: "Waving Black Flag",
    b: "1F3F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      17
    ],
    o: 2
  },
  orangutan: {
    a: "Orangutan",
    b: "1F9A7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      55
    ],
    o: 12
  },
  sparkler: {
    a: "Firework Sparkler",
    b: "1F387",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stars",
      "night",
      "shine"
    ],
    k: [
      7,
      43
    ],
    o: 2
  },
  globe_with_meridians: {
    a: "Globe with Meridians",
    b: "1F310",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "earth",
      "international",
      "world",
      "internet",
      "interweb",
      "i18n"
    ],
    k: [
      5,
      35
    ],
    o: 2
  },
  grin: {
    a: "Grinning Face with Smiling Eyes",
    b: "1F601",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "happy",
      "smile",
      "joy",
      "kawaii"
    ],
    k: [
      30,
      36
    ],
    o: 2
  },
  hand: {
    skin_variations: {
      "1F3FB": {
        unified: "270B-1F3FB",
        non_qualified: null,
        image: "270b-1f3fb.png",
        sheet_x: 54,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "270B-1F3FC",
        non_qualified: null,
        image: "270b-1f3fc.png",
        sheet_x: 54,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "270B-1F3FD",
        non_qualified: null,
        image: "270b-1f3fd.png",
        sheet_x: 54,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "270B-1F3FE",
        non_qualified: null,
        image: "270b-1f3fe.png",
        sheet_x: 54,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "270B-1F3FF",
        non_qualified: null,
        image: "270b-1f3ff.png",
        sheet_x: 54,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Hand",
    b: "270B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      49
    ],
    n: [
      "raised_hand"
    ],
    o: 2
  },
  firecracker: {
    a: "Firecracker",
    b: "1F9E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      27
    ],
    o: 11
  },
  lemon: {
    a: "Lemon",
    b: "1F34B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature"
    ],
    k: [
      6,
      35
    ],
    o: 2
  },
  dog: {
    a: "Dog Face",
    b: "1F436",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "friend",
      "nature",
      "woof",
      "puppy",
      "pet",
      "faithful"
    ],
    k: [
      12,
      26
    ],
    o: 2
  },
  mens: {
    a: "Mens Symbol",
    b: "1F6B9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "toilet",
      "restroom",
      "wc",
      "blue-square",
      "gender",
      "male"
    ],
    k: [
      36,
      10
    ],
    o: 2
  },
  "spock-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F596-1F3FB",
        non_qualified: null,
        image: "1f596-1f3fb.png",
        sheet_x: 30,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F596-1F3FC",
        non_qualified: null,
        image: "1f596-1f3fc.png",
        sheet_x: 30,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F596-1F3FD",
        non_qualified: null,
        image: "1f596-1f3fd.png",
        sheet_x: 30,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F596-1F3FE",
        non_qualified: null,
        image: "1f596-1f3fe.png",
        sheet_x: 30,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F596-1F3FF",
        non_qualified: null,
        image: "1f596-1f3ff.png",
        sheet_x: 30,
        sheet_y: 8,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Hand with Part Between Middle and Ring Fingers",
    b: "1F596",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      3
    ],
    o: 2
  },
  world_map: {
    a: "World Map",
    b: "1F5FA-FE0F",
    c: "1F5FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "location",
      "direction"
    ],
    k: [
      30,
      29
    ],
    o: 2
  },
  laughing: {
    a: "Smiling Face with Open Mouth and Tightly-Closed Eyes",
    b: "1F606",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "happy",
      "joy",
      "lol",
      "satisfied",
      "haha",
      "face",
      "glad",
      "XD",
      "laugh"
    ],
    k: [
      30,
      41
    ],
    l: [
      ":>",
      ":->"
    ],
    n: [
      "satisfied"
    ],
    o: 2
  },
  waving_white_flag: {
    a: "Waving White Flag",
    b: "1F3F3-FE0F",
    c: "1F3F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      12
    ],
    o: 2
  },
  safety_vest: {
    a: "Safety Vest",
    b: "1F9BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      54
    ],
    o: 12
  },
  sweat_smile: {
    a: "Smiling Face with Open Mouth and Cold Sweat",
    b: "1F605",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "hot",
      "happy",
      "laugh",
      "sweat",
      "smile",
      "relief"
    ],
    k: [
      30,
      40
    ],
    o: 2
  },
  sparkles: {
    a: "Sparkles",
    b: "2728",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stars",
      "shine",
      "shiny",
      "cool",
      "awesome",
      "good",
      "magic"
    ],
    k: [
      55,
      16
    ],
    o: 2
  },
  banana: {
    a: "Banana",
    b: "1F34C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "monkey"
    ],
    k: [
      6,
      36
    ],
    o: 2
  },
  "rainbow-flag": {
    a: "Rainbow Flag",
    b: "1F3F3-FE0F-200D-1F308",
    c: "1F3F3-200D-1F308",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      11
    ],
    o: 4
  },
  ok_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F44C-1F3FB",
        non_qualified: null,
        image: "1f44c-1f3fb.png",
        sheet_x: 13,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44C-1F3FC",
        non_qualified: null,
        image: "1f44c-1f3fc.png",
        sheet_x: 13,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44C-1F3FD",
        non_qualified: null,
        image: "1f44c-1f3fd.png",
        sheet_x: 13,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44C-1F3FE",
        non_qualified: null,
        image: "1f44c-1f3fe.png",
        sheet_x: 13,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44C-1F3FF",
        non_qualified: null,
        image: "1f44c-1f3ff.png",
        sheet_x: 13,
        sheet_y: 37,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Ok Hand Sign",
    b: "1F44C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "limbs",
      "perfect",
      "ok",
      "okay"
    ],
    k: [
      13,
      32
    ],
    o: 2
  },
  japan: {
    a: "Silhouette of Japan",
    b: "1F5FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nation",
      "country",
      "japanese",
      "asia"
    ],
    k: [
      30,
      33
    ],
    o: 2
  },
  dog2: {
    a: "Dog",
    b: "1F415",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "friend",
      "doge",
      "pet",
      "faithful"
    ],
    k: [
      11,
      50
    ],
    o: 2
  },
  womens: {
    a: "Womens Symbol",
    b: "1F6BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "woman",
      "female",
      "toilet",
      "loo",
      "restroom",
      "gender"
    ],
    k: [
      36,
      11
    ],
    o: 2
  },
  necktie: {
    a: "Necktie",
    b: "1F454",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shirt",
      "suitup",
      "formal",
      "fashion",
      "cloth",
      "business"
    ],
    k: [
      14,
      8
    ],
    o: 2
  },
  pirate_flag: {
    a: "Pirate Flag",
    b: "1F3F4-200D-2620-FE0F",
    c: "1F3F4-200D-2620",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      13
    ],
    o: 11
  },
  guide_dog: {
    a: "Guide Dog",
    b: "1F9AE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      2
    ],
    o: 12
  },
  restroom: {
    a: "Restroom",
    b: "1F6BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "toilet",
      "refresh",
      "wc",
      "gender"
    ],
    k: [
      36,
      12
    ],
    o: 2
  },
  compass: {
    a: "Compass",
    b: "1F9ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      32
    ],
    o: 11
  },
  rolling_on_the_floor_laughing: {
    a: "Rolling on the Floor Laughing",
    b: "1F923",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      20
    ],
    o: 4
  },
  balloon: {
    a: "Balloon",
    b: "1F388",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "party",
      "celebration",
      "birthday",
      "circus"
    ],
    k: [
      7,
      44
    ],
    o: 2
  },
  pinching_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F90F-1F3FB",
        non_qualified: null,
        image: "1f90f-1f3fb.png",
        sheet_x: 37,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F90F-1F3FC",
        non_qualified: null,
        image: "1f90f-1f3fc.png",
        sheet_x: 37,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F90F-1F3FD",
        non_qualified: null,
        image: "1f90f-1f3fd.png",
        sheet_x: 37,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F90F-1F3FE",
        non_qualified: null,
        image: "1f90f-1f3fe.png",
        sheet_x: 37,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F90F-1F3FF",
        non_qualified: null,
        image: "1f90f-1f3ff.png",
        sheet_x: 37,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Pinching Hand",
    b: "1F90F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      17
    ],
    o: 12
  },
  pineapple: {
    a: "Pineapple",
    b: "1F34D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature",
      "food"
    ],
    k: [
      6,
      37
    ],
    o: 2
  },
  shirt: {
    a: "T-Shirt",
    b: "1F455",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      9
    ],
    n: [
      "tshirt"
    ],
    o: 2
  },
  service_dog: {
    a: "Service Dog",
    b: "1F415-200D-1F9BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      49
    ],
    o: 12
  },
  baby_symbol: {
    a: "Baby Symbol",
    b: "1F6BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "orange-square",
      "child"
    ],
    k: [
      36,
      13
    ],
    o: 2
  },
  joy: {
    a: "Face with Tears of Joy",
    b: "1F602",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "cry",
      "tears",
      "weep",
      "happy",
      "happytears",
      "haha"
    ],
    k: [
      30,
      37
    ],
    o: 2
  },
  tada: {
    a: "Party Popper",
    b: "1F389",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "party",
      "congratulations",
      "birthday",
      "magic",
      "circus",
      "celebration"
    ],
    k: [
      7,
      45
    ],
    o: 2
  },
  mango: {
    a: "Mango",
    b: "1F96D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      3
    ],
    o: 11
  },
  v: {
    skin_variations: {
      "1F3FB": {
        unified: "270C-1F3FB",
        non_qualified: null,
        image: "270c-1f3fb.png",
        sheet_x: 54,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "270C-1F3FC",
        non_qualified: null,
        image: "270c-1f3fc.png",
        sheet_x: 55,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "270C-1F3FD",
        non_qualified: null,
        image: "270c-1f3fd.png",
        sheet_x: 55,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "270C-1F3FE",
        non_qualified: null,
        image: "270c-1f3fe.png",
        sheet_x: 55,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "270C-1F3FF",
        non_qualified: null,
        image: "270c-1f3ff.png",
        sheet_x: 55,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Victory Hand",
    b: "270C-FE0F",
    c: "270C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "ohyeah",
      "hand",
      "peace",
      "victory",
      "two"
    ],
    k: [
      54,
      55
    ],
    o: 2
  },
  snow_capped_mountain: {
    a: "Snow Capped Mountain",
    b: "1F3D4-FE0F",
    c: "1F3D4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      39
    ],
    o: 2
  },
  "flag-ac": {
    a: "Ascension Island Flag",
    b: "1F1E6-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      31
    ],
    o: 2
  },
  jeans: {
    a: "Jeans",
    b: "1F456",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "shopping"
    ],
    k: [
      14,
      10
    ],
    o: 2
  },
  poodle: {
    a: "Poodle",
    b: "1F429",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dog",
      "animal",
      "101",
      "nature",
      "pet"
    ],
    k: [
      12,
      13
    ],
    o: 2
  },
  crossed_fingers: {
    skin_variations: {
      "1F3FB": {
        unified: "1F91E-1F3FB",
        non_qualified: null,
        image: "1f91e-1f3fb.png",
        sheet_x: 38,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91E-1F3FC",
        non_qualified: null,
        image: "1f91e-1f3fc.png",
        sheet_x: 38,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91E-1F3FD",
        non_qualified: null,
        image: "1f91e-1f3fd.png",
        sheet_x: 38,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91E-1F3FE",
        non_qualified: null,
        image: "1f91e-1f3fe.png",
        sheet_x: 38,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91E-1F3FF",
        non_qualified: null,
        image: "1f91e-1f3ff.png",
        sheet_x: 38,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Hand with Index and Middle Fingers Crossed",
    b: "1F91E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "good",
      "lucky"
    ],
    k: [
      38,
      5
    ],
    n: [
      "hand_with_index_and_middle_fingers_crossed"
    ],
    o: 4
  },
  "flag-ad": {
    a: "Andorra Flag",
    b: "1F1E6-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      32
    ],
    o: 2
  },
  slightly_smiling_face: {
    a: "Slightly Smiling Face",
    b: "1F642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "smile"
    ],
    k: [
      31,
      44
    ],
    l: [
      ":)",
      "(:",
      ":-)"
    ],
    o: 2
  },
  apple: {
    a: "Red Apple",
    b: "1F34E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "mac",
      "school"
    ],
    k: [
      6,
      38
    ],
    o: 2
  },
  wc: {
    a: "Water Closet",
    b: "1F6BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "toilet",
      "restroom",
      "blue-square"
    ],
    k: [
      36,
      15
    ],
    o: 2
  },
  scarf: {
    a: "Scarf",
    b: "1F9E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      22
    ],
    o: 5
  },
  mountain: {
    a: "Mountain",
    b: "26F0-FE0F",
    c: "26F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "nature",
      "environment"
    ],
    k: [
      54,
      11
    ],
    o: 2
  },
  confetti_ball: {
    a: "Confetti Ball",
    b: "1F38A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "festival",
      "party",
      "birthday",
      "circus"
    ],
    k: [
      7,
      46
    ],
    o: 2
  },
  i_love_you_hand_sign: {
    skin_variations: {
      "1F3FB": {
        unified: "1F91F-1F3FB",
        non_qualified: null,
        image: "1f91f-1f3fb.png",
        sheet_x: 38,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91F-1F3FC",
        non_qualified: null,
        image: "1f91f-1f3fc.png",
        sheet_x: 38,
        sheet_y: 13,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91F-1F3FD",
        non_qualified: null,
        image: "1f91f-1f3fd.png",
        sheet_x: 38,
        sheet_y: 14,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91F-1F3FE",
        non_qualified: null,
        image: "1f91f-1f3fe.png",
        sheet_x: 38,
        sheet_y: 15,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91F-1F3FF",
        non_qualified: null,
        image: "1f91f-1f3ff.png",
        sheet_x: 38,
        sheet_y: 16,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "I Love You Hand Sign",
    b: "1F91F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      11
    ],
    o: 5
  },
  wolf: {
    a: "Wolf Face",
    b: "1F43A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "wild"
    ],
    k: [
      12,
      30
    ],
    o: 2
  },
  gloves: {
    a: "Gloves",
    b: "1F9E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      23
    ],
    o: 5
  },
  "flag-ae": {
    a: "United Arab Emirates Flag",
    b: "1F1E6-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      33
    ],
    o: 2
  },
  upside_down_face: {
    a: "Upside-Down Face",
    b: "1F643",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "flipped",
      "silly",
      "smile"
    ],
    k: [
      31,
      45
    ],
    o: 2
  },
  green_apple: {
    a: "Green Apple",
    b: "1F34F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature"
    ],
    k: [
      6,
      39
    ],
    o: 2
  },
  passport_control: {
    a: "Passport Control",
    b: "1F6C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "custom",
      "blue-square"
    ],
    k: [
      36,
      24
    ],
    o: 2
  },
  volcano: {
    a: "Volcano",
    b: "1F30B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "nature",
      "disaster"
    ],
    k: [
      5,
      30
    ],
    o: 2
  },
  tanabata_tree: {
    a: "Tanabata Tree",
    b: "1F38B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature",
      "branch",
      "summer"
    ],
    k: [
      7,
      47
    ],
    o: 2
  },
  customs: {
    a: "Customs",
    b: "1F6C3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "passport",
      "border",
      "blue-square"
    ],
    k: [
      36,
      25
    ],
    o: 2
  },
  coat: {
    a: "Coat",
    b: "1F9E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      24
    ],
    o: 5
  },
  wink: {
    a: "Winking Face",
    b: "1F609",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "happy",
      "mischievous",
      "secret",
      ";)",
      "smile",
      "eye"
    ],
    k: [
      30,
      44
    ],
    l: [
      ";)",
      ";-)"
    ],
    m: ";)",
    o: 2
  },
  bamboo: {
    a: "Pine Decoration",
    b: "1F38D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature",
      "vegetable",
      "panda",
      "pine_decoration"
    ],
    k: [
      7,
      49
    ],
    o: 2
  },
  "flag-af": {
    a: "Afghanistan Flag",
    b: "1F1E6-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      34
    ],
    o: 2
  },
  fox_face: {
    a: "Fox Face",
    b: "1F98A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "face"
    ],
    k: [
      42,
      28
    ],
    o: 4
  },
  pear: {
    a: "Pear",
    b: "1F350",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature",
      "food"
    ],
    k: [
      6,
      40
    ],
    o: 2
  },
  mount_fuji: {
    a: "Mount Fuji",
    b: "1F5FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "mountain",
      "nature",
      "japanese"
    ],
    k: [
      30,
      30
    ],
    o: 2
  },
  the_horns: {
    skin_variations: {
      "1F3FB": {
        unified: "1F918-1F3FB",
        non_qualified: null,
        image: "1f918-1f3fb.png",
        sheet_x: 37,
        sheet_y: 32,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F918-1F3FC",
        non_qualified: null,
        image: "1f918-1f3fc.png",
        sheet_x: 37,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F918-1F3FD",
        non_qualified: null,
        image: "1f918-1f3fd.png",
        sheet_x: 37,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F918-1F3FE",
        non_qualified: null,
        image: "1f918-1f3fe.png",
        sheet_x: 37,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F918-1F3FF",
        non_qualified: null,
        image: "1f918-1f3ff.png",
        sheet_x: 37,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Sign of the Horns",
    b: "1F918",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      31
    ],
    n: [
      "sign_of_the_horns"
    ],
    o: 2
  },
  call_me_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F919-1F3FB",
        non_qualified: null,
        image: "1f919-1f3fb.png",
        sheet_x: 37,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F919-1F3FC",
        non_qualified: null,
        image: "1f919-1f3fc.png",
        sheet_x: 37,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F919-1F3FD",
        non_qualified: null,
        image: "1f919-1f3fd.png",
        sheet_x: 37,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F919-1F3FE",
        non_qualified: null,
        image: "1f919-1f3fe.png",
        sheet_x: 37,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F919-1F3FF",
        non_qualified: null,
        image: "1f919-1f3ff.png",
        sheet_x: 37,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Call Me Hand",
    b: "1F919",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hands",
      "gesture"
    ],
    k: [
      37,
      37
    ],
    o: 4
  },
  "flag-ag": {
    a: "Antigua & Barbuda Flag",
    b: "1F1E6-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      35
    ],
    o: 2
  },
  raccoon: {
    a: "Raccoon",
    b: "1F99D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      47
    ],
    o: 11
  },
  dolls: {
    a: "Japanese Dolls",
    b: "1F38E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "toy",
      "kimono"
    ],
    k: [
      7,
      50
    ],
    o: 2
  },
  blush: {
    a: "Smiling Face with Smiling Eyes",
    b: "1F60A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "smile",
      "happy",
      "flushed",
      "crush",
      "embarrassed",
      "shy",
      "joy"
    ],
    k: [
      30,
      45
    ],
    m: ":)",
    o: 2
  },
  peach: {
    a: "Peach",
    b: "1F351",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature",
      "food"
    ],
    k: [
      6,
      41
    ],
    o: 2
  },
  baggage_claim: {
    a: "Baggage Claim",
    b: "1F6C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "airport",
      "transport"
    ],
    k: [
      36,
      26
    ],
    o: 2
  },
  socks: {
    a: "Socks",
    b: "1F9E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      25
    ],
    o: 5
  },
  camping: {
    a: "Camping",
    b: "1F3D5-FE0F",
    c: "1F3D5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "outdoors",
      "tent"
    ],
    k: [
      10,
      40
    ],
    o: 2
  },
  dress: {
    a: "Dress",
    b: "1F457",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "clothes",
      "fashion",
      "shopping"
    ],
    k: [
      14,
      11
    ],
    o: 2
  },
  beach_with_umbrella: {
    a: "Beach with Umbrella",
    b: "1F3D6-FE0F",
    c: "1F3D6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      41
    ],
    o: 2
  },
  cherries: {
    a: "Cherries",
    b: "1F352",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "fruit"
    ],
    k: [
      6,
      42
    ],
    o: 2
  },
  cat: {
    a: "Cat Face",
    b: "1F431",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "meow",
      "nature",
      "pet",
      "kitten"
    ],
    k: [
      12,
      21
    ],
    o: 2
  },
  point_left: {
    skin_variations: {
      "1F3FB": {
        unified: "1F448-1F3FB",
        non_qualified: null,
        image: "1f448-1f3fb.png",
        sheet_x: 13,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F448-1F3FC",
        non_qualified: null,
        image: "1f448-1f3fc.png",
        sheet_x: 13,
        sheet_y: 10,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F448-1F3FD",
        non_qualified: null,
        image: "1f448-1f3fd.png",
        sheet_x: 13,
        sheet_y: 11,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F448-1F3FE",
        non_qualified: null,
        image: "1f448-1f3fe.png",
        sheet_x: 13,
        sheet_y: 12,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F448-1F3FF",
        non_qualified: null,
        image: "1f448-1f3ff.png",
        sheet_x: 13,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Left Pointing Backhand Index",
    b: "1F448",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "direction",
      "fingers",
      "hand",
      "left"
    ],
    k: [
      13,
      8
    ],
    o: 2
  },
  left_luggage: {
    a: "Left Luggage",
    b: "1F6C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "travel"
    ],
    k: [
      36,
      27
    ],
    o: 2
  },
  "flag-ai": {
    a: "Anguilla Flag",
    b: "1F1E6-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      36
    ],
    o: 2
  },
  innocent: {
    a: "Smiling Face with Halo",
    b: "1F607",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "angel",
      "heaven",
      "halo"
    ],
    k: [
      30,
      42
    ],
    o: 2
  },
  flags: {
    a: "Carp Streamer",
    b: "1F38F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fish",
      "japanese",
      "koinobori",
      "carp",
      "banner"
    ],
    k: [
      7,
      51
    ],
    o: 2
  },
  warning: {
    a: "Warning Sign",
    b: "26A0-FE0F",
    c: "26A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "exclamation",
      "wip",
      "alert",
      "error",
      "problem",
      "issue"
    ],
    k: [
      53,
      50
    ],
    o: 2
  },
  strawberry: {
    a: "Strawberry",
    b: "1F353",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "nature"
    ],
    k: [
      6,
      43
    ],
    o: 2
  },
  point_right: {
    skin_variations: {
      "1F3FB": {
        unified: "1F449-1F3FB",
        non_qualified: null,
        image: "1f449-1f3fb.png",
        sheet_x: 13,
        sheet_y: 15,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F449-1F3FC",
        non_qualified: null,
        image: "1f449-1f3fc.png",
        sheet_x: 13,
        sheet_y: 16,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F449-1F3FD",
        non_qualified: null,
        image: "1f449-1f3fd.png",
        sheet_x: 13,
        sheet_y: 17,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F449-1F3FE",
        non_qualified: null,
        image: "1f449-1f3fe.png",
        sheet_x: 13,
        sheet_y: 18,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F449-1F3FF",
        non_qualified: null,
        image: "1f449-1f3ff.png",
        sheet_x: 13,
        sheet_y: 19,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Right Pointing Backhand Index",
    b: "1F449",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "hand",
      "direction",
      "right"
    ],
    k: [
      13,
      14
    ],
    o: 2
  },
  desert: {
    a: "Desert",
    b: "1F3DC-FE0F",
    c: "1F3DC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "warm",
      "saharah"
    ],
    k: [
      10,
      47
    ],
    o: 2
  },
  kimono: {
    a: "Kimono",
    b: "1F458",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dress",
      "fashion",
      "women",
      "female",
      "japanese"
    ],
    k: [
      14,
      12
    ],
    o: 2
  },
  "flag-al": {
    a: "Albania Flag",
    b: "1F1E6-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      37
    ],
    o: 2
  },
  wind_chime: {
    a: "Wind Chime",
    b: "1F390",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "ding",
      "spring",
      "bell"
    ],
    k: [
      7,
      52
    ],
    o: 2
  },
  smiling_face_with_3_hearts: {
    a: "Smiling Face with Smiling Eyes and Three Hearts",
    b: "1F970",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      6
    ],
    o: 11
  },
  cat2: {
    a: "Cat",
    b: "1F408",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "meow",
      "pet",
      "cats"
    ],
    k: [
      11,
      36
    ],
    o: 2
  },
  rice_scene: {
    a: "Moon Viewing Ceremony",
    b: "1F391",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "japan",
      "asia",
      "tsukimi"
    ],
    k: [
      7,
      53
    ],
    o: 2
  },
  heart_eyes: {
    a: "Smiling Face with Heart-Shaped Eyes",
    b: "1F60D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush",
      "heart"
    ],
    k: [
      30,
      48
    ],
    o: 2
  },
  sari: {
    a: "Sari",
    b: "1F97B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      13
    ],
    o: 12
  },
  "flag-am": {
    a: "Armenia Flag",
    b: "1F1E6-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      38
    ],
    o: 2
  },
  lion_face: {
    a: "Lion Face",
    b: "1F981",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      19
    ],
    o: 2
  },
  desert_island: {
    a: "Desert Island",
    b: "1F3DD-FE0F",
    c: "1F3DD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "tropical",
      "mojito"
    ],
    k: [
      10,
      48
    ],
    o: 2
  },
  point_up_2: {
    skin_variations: {
      "1F3FB": {
        unified: "1F446-1F3FB",
        non_qualified: null,
        image: "1f446-1f3fb.png",
        sheet_x: 12,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F446-1F3FC",
        non_qualified: null,
        image: "1f446-1f3fc.png",
        sheet_x: 12,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F446-1F3FD",
        non_qualified: null,
        image: "1f446-1f3fd.png",
        sheet_x: 12,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F446-1F3FE",
        non_qualified: null,
        image: "1f446-1f3fe.png",
        sheet_x: 13,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F446-1F3FF",
        non_qualified: null,
        image: "1f446-1f3ff.png",
        sheet_x: 13,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Up Pointing Backhand Index",
    b: "1F446",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "hand",
      "direction",
      "up"
    ],
    k: [
      12,
      53
    ],
    o: 2
  },
  kiwifruit: {
    a: "Kiwifruit",
    b: "1F95D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      44
    ],
    o: 4
  },
  children_crossing: {
    a: "Children Crossing",
    b: "1F6B8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "school",
      "warning",
      "danger",
      "sign",
      "driving",
      "yellow-diamond"
    ],
    k: [
      36,
      9
    ],
    o: 2
  },
  national_park: {
    a: "National Park",
    b: "1F3DE-FE0F",
    c: "1F3DE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "environment",
      "nature"
    ],
    k: [
      10,
      49
    ],
    o: 2
  },
  no_entry: {
    a: "No Entry",
    b: "26D4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "limit",
      "security",
      "privacy",
      "bad",
      "denied",
      "stop",
      "circle"
    ],
    k: [
      54,
      8
    ],
    o: 2
  },
  "one-piece_swimsuit": {
    a: "One-Piece Swimsuit",
    b: "1FA71",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      52
    ],
    o: 12
  },
  tiger: {
    a: "Tiger Face",
    b: "1F42F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cat",
      "danger",
      "wild",
      "nature",
      "roar"
    ],
    k: [
      12,
      19
    ],
    o: 2
  },
  red_envelope: {
    a: "Red Gift Envelope",
    b: "1F9E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      26
    ],
    o: 11
  },
  "star-struck": {
    a: "Grinning Face with Star Eyes",
    b: "1F929",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      43
    ],
    n: [
      "grinning_face_with_star_eyes"
    ],
    o: 5
  },
  middle_finger: {
    skin_variations: {
      "1F3FB": {
        unified: "1F595-1F3FB",
        non_qualified: null,
        image: "1f595-1f3fb.png",
        sheet_x: 29,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F595-1F3FC",
        non_qualified: null,
        image: "1f595-1f3fc.png",
        sheet_x: 29,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F595-1F3FD",
        non_qualified: null,
        image: "1f595-1f3fd.png",
        sheet_x: 30,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F595-1F3FE",
        non_qualified: null,
        image: "1f595-1f3fe.png",
        sheet_x: 30,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F595-1F3FF",
        non_qualified: null,
        image: "1f595-1f3ff.png",
        sheet_x: 30,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Reversed Hand with Middle Finger Extended",
    b: "1F595",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      54
    ],
    n: [
      "reversed_hand_with_middle_finger_extended"
    ],
    o: 2
  },
  "flag-ao": {
    a: "Angola Flag",
    b: "1F1E6-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      39
    ],
    o: 2
  },
  tomato: {
    a: "Tomato",
    b: "1F345",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "vegetable",
      "nature",
      "food"
    ],
    k: [
      6,
      29
    ],
    o: 2
  },
  coconut: {
    a: "Coconut",
    b: "1F965",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      52
    ],
    o: 5
  },
  ribbon: {
    a: "Ribbon",
    b: "1F380",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "decoration",
      "pink",
      "girl",
      "bowtie"
    ],
    k: [
      7,
      31
    ],
    o: 2
  },
  no_entry_sign: {
    a: "No Entry Sign",
    b: "1F6AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "forbid",
      "stop",
      "limit",
      "denied",
      "disallow",
      "circle"
    ],
    k: [
      35,
      2
    ],
    o: 2
  },
  point_down: {
    skin_variations: {
      "1F3FB": {
        unified: "1F447-1F3FB",
        non_qualified: null,
        image: "1f447-1f3fb.png",
        sheet_x: 13,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F447-1F3FC",
        non_qualified: null,
        image: "1f447-1f3fc.png",
        sheet_x: 13,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F447-1F3FD",
        non_qualified: null,
        image: "1f447-1f3fd.png",
        sheet_x: 13,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F447-1F3FE",
        non_qualified: null,
        image: "1f447-1f3fe.png",
        sheet_x: 13,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F447-1F3FF",
        non_qualified: null,
        image: "1f447-1f3ff.png",
        sheet_x: 13,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Down Pointing Backhand Index",
    b: "1F447",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "hand",
      "direction",
      "down"
    ],
    k: [
      13,
      2
    ],
    o: 2
  },
  "flag-aq": {
    a: "Antarctica Flag",
    b: "1F1E6-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      40
    ],
    o: 2
  },
  briefs: {
    a: "Briefs",
    b: "1FA72",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      53
    ],
    o: 12
  },
  kissing_heart: {
    a: "Face Throwing a Kiss",
    b: "1F618",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    k: [
      31,
      2
    ],
    l: [
      ":*",
      ":-*"
    ],
    o: 2
  },
  tiger2: {
    a: "Tiger",
    b: "1F405",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "roar"
    ],
    k: [
      11,
      33
    ],
    o: 2
  },
  stadium: {
    a: "Stadium",
    b: "1F3DF-FE0F",
    c: "1F3DF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "place",
      "sports",
      "concert",
      "venue"
    ],
    k: [
      10,
      50
    ],
    o: 2
  },
  leopard: {
    a: "Leopard",
    b: "1F406",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      11,
      34
    ],
    o: 2
  },
  no_bicycles: {
    a: "No Bicycles",
    b: "1F6B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cyclist",
      "prohibited",
      "circle"
    ],
    k: [
      35,
      10
    ],
    o: 2
  },
  kissing: {
    a: "Kissing Face",
    b: "1F617",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "face",
      "3",
      "valentines",
      "infatuation",
      "kiss"
    ],
    k: [
      31,
      1
    ],
    o: 2
  },
  "flag-ar": {
    a: "Argentina Flag",
    b: "1F1E6-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      41
    ],
    o: 2
  },
  avocado: {
    a: "Avocado",
    b: "1F951",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food"
    ],
    k: [
      41,
      32
    ],
    o: 4
  },
  point_up: {
    skin_variations: {
      "1F3FB": {
        unified: "261D-1F3FB",
        non_qualified: null,
        image: "261d-1f3fb.png",
        sheet_x: 53,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "261D-1F3FC",
        non_qualified: null,
        image: "261d-1f3fc.png",
        sheet_x: 53,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "261D-1F3FD",
        non_qualified: null,
        image: "261d-1f3fd.png",
        sheet_x: 53,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "261D-1F3FE",
        non_qualified: null,
        image: "261d-1f3fe.png",
        sheet_x: 53,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "261D-1F3FF",
        non_qualified: null,
        image: "261d-1f3ff.png",
        sheet_x: 53,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Up Pointing Index",
    b: "261D-FE0F",
    c: "261D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hand",
      "fingers",
      "direction",
      "up"
    ],
    k: [
      53,
      2
    ],
    o: 2
  },
  gift: {
    a: "Wrapped Present",
    b: "1F381",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "present",
      "birthday",
      "christmas",
      "xmas"
    ],
    k: [
      7,
      32
    ],
    o: 2
  },
  classical_building: {
    a: "Classical Building",
    b: "1F3DB-FE0F",
    c: "1F3DB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "art",
      "culture",
      "history"
    ],
    k: [
      10,
      46
    ],
    o: 2
  },
  shorts: {
    a: "Shorts",
    b: "1FA73",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      54
    ],
    o: 12
  },
  "+1": {
    skin_variations: {
      "1F3FB": {
        unified: "1F44D-1F3FB",
        non_qualified: null,
        image: "1f44d-1f3fb.png",
        sheet_x: 13,
        sheet_y: 39,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44D-1F3FC",
        non_qualified: null,
        image: "1f44d-1f3fc.png",
        sheet_x: 13,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44D-1F3FD",
        non_qualified: null,
        image: "1f44d-1f3fd.png",
        sheet_x: 13,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44D-1F3FE",
        non_qualified: null,
        image: "1f44d-1f3fe.png",
        sheet_x: 13,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44D-1F3FF",
        non_qualified: null,
        image: "1f44d-1f3ff.png",
        sheet_x: 13,
        sheet_y: 43,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Thumbs Up Sign",
    b: "1F44D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "thumbsup",
      "yes",
      "awesome",
      "good",
      "agree",
      "accept",
      "cool",
      "hand",
      "like"
    ],
    k: [
      13,
      38
    ],
    n: [
      "thumbsup"
    ],
    o: 2
  },
  horse: {
    a: "Horse Face",
    b: "1F434",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "brown",
      "nature"
    ],
    k: [
      12,
      24
    ],
    o: 2
  },
  bikini: {
    a: "Bikini",
    b: "1F459",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "swimming",
      "female",
      "woman",
      "girl",
      "fashion",
      "beach",
      "summer"
    ],
    k: [
      14,
      13
    ],
    o: 2
  },
  no_smoking: {
    a: "No Smoking Symbol",
    b: "1F6AD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cigarette",
      "blue-square",
      "smell",
      "smoke"
    ],
    k: [
      35,
      4
    ],
    o: 2
  },
  eggplant: {
    a: "Aubergine",
    b: "1F346",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "nature",
      "food",
      "aubergine"
    ],
    k: [
      6,
      30
    ],
    o: 2
  },
  "flag-as": {
    a: "American Samoa Flag",
    b: "1F1E6-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      42
    ],
    o: 2
  },
  reminder_ribbon: {
    a: "Reminder Ribbon",
    b: "1F397-FE0F",
    c: "1F397",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "cause",
      "support",
      "awareness"
    ],
    k: [
      8,
      0
    ],
    o: 2
  },
  building_construction: {
    a: "Building Construction",
    b: "1F3D7-FE0F",
    c: "1F3D7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wip",
      "working",
      "progress"
    ],
    k: [
      10,
      42
    ],
    o: 2
  },
  relaxed: {
    a: "White Smiling Face",
    b: "263A-FE0F",
    c: "263A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "blush",
      "massage",
      "happiness"
    ],
    k: [
      53,
      17
    ],
    o: 2
  },
  kissing_closed_eyes: {
    a: "Kissing Face with Closed Eyes",
    b: "1F61A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    k: [
      31,
      4
    ],
    o: 2
  },
  "-1": {
    skin_variations: {
      "1F3FB": {
        unified: "1F44E-1F3FB",
        non_qualified: null,
        image: "1f44e-1f3fb.png",
        sheet_x: 13,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44E-1F3FC",
        non_qualified: null,
        image: "1f44e-1f3fc.png",
        sheet_x: 13,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44E-1F3FD",
        non_qualified: null,
        image: "1f44e-1f3fd.png",
        sheet_x: 13,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44E-1F3FE",
        non_qualified: null,
        image: "1f44e-1f3fe.png",
        sheet_x: 13,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44E-1F3FF",
        non_qualified: null,
        image: "1f44e-1f3ff.png",
        sheet_x: 13,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Thumbs Down Sign",
    b: "1F44E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "thumbsdown",
      "no",
      "dislike",
      "hand"
    ],
    k: [
      13,
      44
    ],
    n: [
      "thumbsdown"
    ],
    o: 2
  },
  admission_tickets: {
    a: "Admission Tickets",
    b: "1F39F-FE0F",
    c: "1F39F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      8,
      5
    ],
    o: 2
  },
  "flag-at": {
    a: "Austria Flag",
    b: "1F1E6-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      43
    ],
    o: 2
  },
  womans_clothes: {
    a: "Womans Clothes",
    b: "1F45A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "shopping_bags",
      "female"
    ],
    k: [
      14,
      14
    ],
    o: 2
  },
  do_not_litter: {
    a: "Do Not Litter Symbol",
    b: "1F6AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "trash",
      "bin",
      "garbage",
      "circle"
    ],
    k: [
      35,
      6
    ],
    o: 2
  },
  potato: {
    a: "Potato",
    b: "1F954",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "tuber",
      "vegatable",
      "starch"
    ],
    k: [
      41,
      35
    ],
    o: 4
  },
  racehorse: {
    a: "Horse",
    b: "1F40E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "gamble",
      "luck"
    ],
    k: [
      11,
      42
    ],
    o: 2
  },
  bricks: {
    a: "Brick",
    b: "1F9F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      36
    ],
    o: 11
  },
  fist: {
    skin_variations: {
      "1F3FB": {
        unified: "270A-1F3FB",
        non_qualified: null,
        image: "270a-1f3fb.png",
        sheet_x: 54,
        sheet_y: 44,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "270A-1F3FC",
        non_qualified: null,
        image: "270a-1f3fc.png",
        sheet_x: 54,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "270A-1F3FD",
        non_qualified: null,
        image: "270a-1f3fd.png",
        sheet_x: 54,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "270A-1F3FE",
        non_qualified: null,
        image: "270a-1f3fe.png",
        sheet_x: 54,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "270A-1F3FF",
        non_qualified: null,
        image: "270a-1f3ff.png",
        sheet_x: 54,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Fist",
    b: "270A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "hand",
      "grasp"
    ],
    k: [
      54,
      43
    ],
    o: 2
  },
  house_buildings: {
    a: "House Buildings",
    b: "1F3D8-FE0F",
    c: "1F3D8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      43
    ],
    o: 2
  },
  carrot: {
    a: "Carrot",
    b: "1F955",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "food",
      "orange"
    ],
    k: [
      41,
      36
    ],
    o: 4
  },
  ticket: {
    a: "Ticket",
    b: "1F3AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "event",
      "concert",
      "pass"
    ],
    k: [
      8,
      17
    ],
    o: 2
  },
  "flag-au": {
    a: "Australia Flag",
    b: "1F1E6-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      44
    ],
    o: 2
  },
  "non-potable_water": {
    a: "Non-Potable Water Symbol",
    b: "1F6B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "faucet",
      "tap",
      "circle"
    ],
    k: [
      35,
      8
    ],
    o: 2
  },
  purse: {
    a: "Purse",
    b: "1F45B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "accessories",
      "money",
      "sales",
      "shopping"
    ],
    k: [
      14,
      15
    ],
    o: 2
  },
  unicorn_face: {
    a: "Unicorn Face",
    b: "1F984",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      22
    ],
    o: 2
  },
  kissing_smiling_eyes: {
    a: "Kissing Face with Smiling Eyes",
    b: "1F619",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    k: [
      31,
      3
    ],
    o: 2
  },
  facepunch: {
    skin_variations: {
      "1F3FB": {
        unified: "1F44A-1F3FB",
        non_qualified: null,
        image: "1f44a-1f3fb.png",
        sheet_x: 13,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44A-1F3FC",
        non_qualified: null,
        image: "1f44a-1f3fc.png",
        sheet_x: 13,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44A-1F3FD",
        non_qualified: null,
        image: "1f44a-1f3fd.png",
        sheet_x: 13,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44A-1F3FE",
        non_qualified: null,
        image: "1f44a-1f3fe.png",
        sheet_x: 13,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44A-1F3FF",
        non_qualified: null,
        image: "1f44a-1f3ff.png",
        sheet_x: 13,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Fisted Hand Sign",
    b: "1F44A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "angry",
      "violence",
      "fist",
      "hit",
      "attack",
      "hand"
    ],
    k: [
      13,
      20
    ],
    n: [
      "punch"
    ],
    o: 2
  },
  medal: {
    a: "Medal",
    b: "1F396-FE0F",
    c: "1F396",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      7,
      56
    ],
    o: 2
  },
  zebra_face: {
    a: "Zebra Face",
    b: "1F993",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      37
    ],
    o: 5
  },
  handbag: {
    a: "Handbag",
    b: "1F45C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "accessory",
      "accessories",
      "shopping"
    ],
    k: [
      14,
      16
    ],
    o: 2
  },
  derelict_house_building: {
    a: "Derelict House Building",
    b: "1F3DA-FE0F",
    c: "1F3DA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      45
    ],
    o: 2
  },
  yum: {
    a: "Face Savouring Delicious Food",
    b: "1F60B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "happy",
      "joy",
      "tongue",
      "smile",
      "face",
      "silly",
      "yummy",
      "nom",
      "delicious",
      "savouring"
    ],
    k: [
      30,
      46
    ],
    o: 2
  },
  corn: {
    a: "Ear of Maize",
    b: "1F33D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "vegetable",
      "plant"
    ],
    k: [
      6,
      21
    ],
    o: 2
  },
  "flag-aw": {
    a: "Aruba Flag",
    b: "1F1E6-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      45
    ],
    o: 2
  },
  no_pedestrians: {
    a: "No Pedestrians",
    b: "1F6B7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "rules",
      "crossing",
      "walking",
      "circle"
    ],
    k: [
      36,
      8
    ],
    o: 2
  },
  house: {
    a: "House Building",
    b: "1F3E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "home"
    ],
    k: [
      10,
      51
    ],
    o: 2
  },
  hot_pepper: {
    a: "Hot Pepper",
    b: "1F336-FE0F",
    c: "1F336",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "spicy",
      "chilli",
      "chili"
    ],
    k: [
      6,
      14
    ],
    o: 2
  },
  "flag-ax": {
    a: "Åland Islands Flag",
    b: "1F1E6-1F1FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      46
    ],
    o: 2
  },
  trophy: {
    a: "Trophy",
    b: "1F3C6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "win",
      "award",
      "contest",
      "place",
      "ftw",
      "ceremony"
    ],
    k: [
      9,
      26
    ],
    o: 2
  },
  deer: {
    a: "Deer",
    b: "1F98C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "horns",
      "venison"
    ],
    k: [
      42,
      30
    ],
    o: 4
  },
  "left-facing_fist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F91B-1F3FB",
        non_qualified: null,
        image: "1f91b-1f3fb.png",
        sheet_x: 37,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91B-1F3FC",
        non_qualified: null,
        image: "1f91b-1f3fc.png",
        sheet_x: 37,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91B-1F3FD",
        non_qualified: null,
        image: "1f91b-1f3fd.png",
        sheet_x: 37,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91B-1F3FE",
        non_qualified: null,
        image: "1f91b-1f3fe.png",
        sheet_x: 37,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91B-1F3FF",
        non_qualified: null,
        image: "1f91b-1f3ff.png",
        sheet_x: 37,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Left-Facing Fist",
    b: "1F91B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      49
    ],
    o: 4
  },
  stuck_out_tongue: {
    a: "Face with Stuck-out Tongue",
    b: "1F61B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile",
      "tongue"
    ],
    k: [
      31,
      5
    ],
    l: [
      ":p",
      ":-p",
      ":P",
      ":-P",
      ":b",
      ":-b"
    ],
    m: ":p",
    o: 2
  },
  pouch: {
    a: "Pouch",
    b: "1F45D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bag",
      "accessories",
      "shopping"
    ],
    k: [
      14,
      17
    ],
    o: 2
  },
  no_mobile_phones: {
    a: "No Mobile Phones",
    b: "1F4F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "iphone",
      "mute",
      "circle"
    ],
    k: [
      27,
      18
    ],
    o: 2
  },
  stuck_out_tongue_winking_eye: {
    a: "Face with Stuck-out Tongue and Winking Eye",
    b: "1F61C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile",
      "wink",
      "tongue"
    ],
    k: [
      31,
      6
    ],
    l: [
      ";p",
      ";-p",
      ";b",
      ";-b",
      ";P",
      ";-P"
    ],
    m: ";p",
    o: 2
  },
  sports_medal: {
    a: "Sports Medal",
    b: "1F3C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      25
    ],
    o: 2
  },
  cucumber: {
    a: "Cucumber",
    b: "1F952",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "pickle"
    ],
    k: [
      41,
      33
    ],
    o: 4
  },
  cow: {
    a: "Cow Face",
    b: "1F42E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    k: [
      12,
      18
    ],
    o: 2
  },
  underage: {
    a: "No One Under Eighteen Symbol",
    b: "1F51E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "18",
      "drink",
      "pub",
      "night",
      "minor",
      "circle"
    ],
    k: [
      28,
      1
    ],
    o: 2
  },
  "flag-az": {
    a: "Azerbaijan Flag",
    b: "1F1E6-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      47
    ],
    o: 2
  },
  shopping_bags: {
    a: "Shopping Bags",
    b: "1F6CD-FE0F",
    c: "1F6CD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      35
    ],
    o: 2
  },
  "right-facing_fist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F91C-1F3FB",
        non_qualified: null,
        image: "1f91c-1f3fb.png",
        sheet_x: 37,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91C-1F3FC",
        non_qualified: null,
        image: "1f91c-1f3fc.png",
        sheet_x: 38,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91C-1F3FD",
        non_qualified: null,
        image: "1f91c-1f3fd.png",
        sheet_x: 38,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91C-1F3FE",
        non_qualified: null,
        image: "1f91c-1f3fe.png",
        sheet_x: 38,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91C-1F3FF",
        non_qualified: null,
        image: "1f91c-1f3ff.png",
        sheet_x: 38,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Right-Facing Fist",
    b: "1F91C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      55
    ],
    o: 4
  },
  house_with_garden: {
    a: "House with Garden",
    b: "1F3E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "home",
      "plant",
      "nature"
    ],
    k: [
      10,
      52
    ],
    o: 2
  },
  clap: {
    skin_variations: {
      "1F3FB": {
        unified: "1F44F-1F3FB",
        non_qualified: null,
        image: "1f44f-1f3fb.png",
        sheet_x: 13,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44F-1F3FC",
        non_qualified: null,
        image: "1f44f-1f3fc.png",
        sheet_x: 13,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44F-1F3FD",
        non_qualified: null,
        image: "1f44f-1f3fd.png",
        sheet_x: 13,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44F-1F3FE",
        non_qualified: null,
        image: "1f44f-1f3fe.png",
        sheet_x: 13,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44F-1F3FF",
        non_qualified: null,
        image: "1f44f-1f3ff.png",
        sheet_x: 13,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Clapping Hands Sign",
    b: "1F44F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hands",
      "praise",
      "applause",
      "congrats",
      "yay"
    ],
    k: [
      13,
      50
    ],
    o: 2
  },
  leafy_green: {
    a: "Leafy Green",
    b: "1F96C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      2
    ],
    o: 11
  },
  office: {
    a: "Office Building",
    b: "1F3E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "bureau",
      "work"
    ],
    k: [
      10,
      53
    ],
    o: 2
  },
  "flag-ba": {
    a: "Bosnia & Herzegovina Flag",
    b: "1F1E7-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      48
    ],
    o: 2
  },
  zany_face: {
    a: "Grinning Face with One Large and One Small Eye",
    b: "1F92A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      44
    ],
    n: [
      "grinning_face_with_one_large_and_one_small_eye"
    ],
    o: 5
  },
  first_place_medal: {
    a: "First Place Medal",
    b: "1F947",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      22
    ],
    o: 4
  },
  ox: {
    a: "Ox",
    b: "1F402",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cow",
      "beef"
    ],
    k: [
      11,
      30
    ],
    o: 2
  },
  school_satchel: {
    a: "School Satchel",
    b: "1F392",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "student",
      "education",
      "bag",
      "backpack"
    ],
    k: [
      7,
      54
    ],
    o: 2
  },
  radioactive_sign: {
    a: "Radioactive Sign",
    b: "2622-FE0F",
    c: "2622",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      9
    ],
    o: 2
  },
  second_place_medal: {
    a: "Second Place Medal",
    b: "1F948",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      23
    ],
    o: 4
  },
  stuck_out_tongue_closed_eyes: {
    a: "Face with Stuck-out Tongue and Tightly-Closed Eyes",
    b: "1F61D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "prank",
      "playful",
      "mischievous",
      "smile",
      "tongue"
    ],
    k: [
      31,
      7
    ],
    o: 2
  },
  broccoli: {
    a: "Broccoli",
    b: "1F966",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      53
    ],
    o: 5
  },
  biohazard_sign: {
    a: "Biohazard Sign",
    b: "2623-FE0F",
    c: "2623",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      10
    ],
    o: 2
  },
  mans_shoe: {
    a: "Mans Shoe",
    b: "1F45E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "male"
    ],
    k: [
      14,
      18
    ],
    n: [
      "shoe"
    ],
    o: 2
  },
  raised_hands: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64C-1F3FB",
        non_qualified: null,
        image: "1f64c-1f3fb.png",
        sheet_x: 33,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64C-1F3FC",
        non_qualified: null,
        image: "1f64c-1f3fc.png",
        sheet_x: 33,
        sheet_y: 10,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64C-1F3FD",
        non_qualified: null,
        image: "1f64c-1f3fd.png",
        sheet_x: 33,
        sheet_y: 11,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64C-1F3FE",
        non_qualified: null,
        image: "1f64c-1f3fe.png",
        sheet_x: 33,
        sheet_y: 12,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64C-1F3FF",
        non_qualified: null,
        image: "1f64c-1f3ff.png",
        sheet_x: 33,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Person Raising Both Hands in Celebration",
    b: "1F64C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "gesture",
      "hooray",
      "yea",
      "celebration",
      "hands"
    ],
    k: [
      33,
      8
    ],
    o: 2
  },
  post_office: {
    a: "Japanese Post Office",
    b: "1F3E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "envelope",
      "communication"
    ],
    k: [
      10,
      54
    ],
    o: 2
  },
  "flag-bb": {
    a: "Barbados Flag",
    b: "1F1E7-1F1E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      49
    ],
    o: 2
  },
  water_buffalo: {
    a: "Water Buffalo",
    b: "1F403",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "ox",
      "cow"
    ],
    k: [
      11,
      31
    ],
    o: 2
  },
  third_place_medal: {
    a: "Third Place Medal",
    b: "1F949",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      24
    ],
    o: 4
  },
  european_post_office: {
    a: "European Post Office",
    b: "1F3E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "email"
    ],
    k: [
      10,
      55
    ],
    o: 2
  },
  athletic_shoe: {
    a: "Athletic Shoe",
    b: "1F45F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shoes",
      "sports",
      "sneakers"
    ],
    k: [
      14,
      19
    ],
    o: 2
  },
  arrow_up: {
    a: "Upwards Black Arrow",
    b: "2B06-FE0F",
    c: "2B06",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "continue",
      "top",
      "direction"
    ],
    k: [
      55,
      38
    ],
    o: 2
  },
  cow2: {
    a: "Cow",
    b: "1F404",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    k: [
      11,
      32
    ],
    o: 2
  },
  open_hands: {
    skin_variations: {
      "1F3FB": {
        unified: "1F450-1F3FB",
        non_qualified: null,
        image: "1f450-1f3fb.png",
        sheet_x: 14,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F450-1F3FC",
        non_qualified: null,
        image: "1f450-1f3fc.png",
        sheet_x: 14,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F450-1F3FD",
        non_qualified: null,
        image: "1f450-1f3fd.png",
        sheet_x: 14,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F450-1F3FE",
        non_qualified: null,
        image: "1f450-1f3fe.png",
        sheet_x: 14,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F450-1F3FF",
        non_qualified: null,
        image: "1f450-1f3ff.png",
        sheet_x: 14,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Open Hands Sign",
    b: "1F450",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "butterfly",
      "hands",
      "open"
    ],
    k: [
      13,
      56
    ],
    o: 2
  },
  garlic: {
    a: "Garlic",
    b: "1F9C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      12
    ],
    o: 12
  },
  money_mouth_face: {
    a: "Money-Mouth Face",
    b: "1F911",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "rich",
      "dollar",
      "money"
    ],
    k: [
      37,
      24
    ],
    o: 2
  },
  "flag-bd": {
    a: "Bangladesh Flag",
    b: "1F1E7-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      50
    ],
    o: 2
  },
  soccer: {
    a: "Soccer Ball",
    b: "26BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "football"
    ],
    k: [
      53,
      56
    ],
    o: 2
  },
  hugging_face: {
    a: "Hugging Face",
    b: "1F917",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      30
    ],
    o: 2
  },
  onion: {
    a: "Onion",
    b: "1F9C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      13
    ],
    o: 12
  },
  arrow_upper_right: {
    a: "North East Arrow",
    b: "2197-FE0F",
    c: "2197",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "point",
      "direction",
      "diagonal",
      "northeast"
    ],
    k: [
      52,
      17
    ],
    o: 2
  },
  palms_up_together: {
    skin_variations: {
      "1F3FB": {
        unified: "1F932-1F3FB",
        non_qualified: null,
        image: "1f932-1f3fb.png",
        sheet_x: 39,
        sheet_y: 6,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F932-1F3FC",
        non_qualified: null,
        image: "1f932-1f3fc.png",
        sheet_x: 39,
        sheet_y: 7,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F932-1F3FD",
        non_qualified: null,
        image: "1f932-1f3fd.png",
        sheet_x: 39,
        sheet_y: 8,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F932-1F3FE",
        non_qualified: null,
        image: "1f932-1f3fe.png",
        sheet_x: 39,
        sheet_y: 9,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F932-1F3FF",
        non_qualified: null,
        image: "1f932-1f3ff.png",
        sheet_x: 39,
        sheet_y: 10,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Palms Up Together",
    b: "1F932",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      39,
      5
    ],
    o: 5
  },
  pig: {
    a: "Pig Face",
    b: "1F437",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "oink",
      "nature"
    ],
    k: [
      12,
      27
    ],
    o: 2
  },
  hospital: {
    a: "Hospital",
    b: "1F3E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "health",
      "surgery",
      "doctor"
    ],
    k: [
      10,
      56
    ],
    o: 2
  },
  hiking_boot: {
    a: "Hiking Boot",
    b: "1F97E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      16
    ],
    o: 11
  },
  "flag-be": {
    a: "Belgium Flag",
    b: "1F1E7-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      51
    ],
    o: 2
  },
  "flag-bf": {
    a: "Burkina Faso Flag",
    b: "1F1E7-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      52
    ],
    o: 2
  },
  mushroom: {
    a: "Mushroom",
    b: "1F344",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "vegetable"
    ],
    k: [
      6,
      28
    ],
    o: 2
  },
  pig2: {
    a: "Pig",
    b: "1F416",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      11,
      51
    ],
    o: 2
  },
  baseball: {
    a: "Baseball",
    b: "26BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls"
    ],
    k: [
      54,
      0
    ],
    o: 2
  },
  face_with_hand_over_mouth: {
    a: "Smiling Face with Smiling Eyes and Hand Covering Mouth",
    b: "1F92D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      47
    ],
    n: [
      "smiling_face_with_smiling_eyes_and_hand_covering_mouth"
    ],
    o: 5
  },
  handshake: {
    a: "Handshake",
    b: "1F91D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "agreement",
      "shake"
    ],
    k: [
      38,
      4
    ],
    o: 4
  },
  womans_flat_shoe: {
    a: "Flat Shoe",
    b: "1F97F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      17
    ],
    o: 11
  },
  bank: {
    a: "Bank",
    b: "1F3E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "money",
      "sales",
      "cash",
      "business",
      "enterprise"
    ],
    k: [
      11,
      0
    ],
    o: 2
  },
  arrow_right: {
    a: "Black Rightwards Arrow",
    b: "27A1-FE0F",
    c: "27A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "next"
    ],
    k: [
      55,
      32
    ],
    o: 2
  },
  peanuts: {
    a: "Peanuts",
    b: "1F95C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "nut"
    ],
    k: [
      41,
      43
    ],
    o: 4
  },
  shushing_face: {
    a: "Face with Finger Covering Closed Lips",
    b: "1F92B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      45
    ],
    n: [
      "face_with_finger_covering_closed_lips"
    ],
    o: 5
  },
  pray: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64F-1F3FB",
        non_qualified: null,
        image: "1f64f-1f3fb.png",
        sheet_x: 33,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64F-1F3FC",
        non_qualified: null,
        image: "1f64f-1f3fc.png",
        sheet_x: 33,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64F-1F3FD",
        non_qualified: null,
        image: "1f64f-1f3fd.png",
        sheet_x: 33,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64F-1F3FE",
        non_qualified: null,
        image: "1f64f-1f3fe.png",
        sheet_x: 33,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64F-1F3FF",
        non_qualified: null,
        image: "1f64f-1f3ff.png",
        sheet_x: 33,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Person with Folded Hands",
    b: "1F64F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "please",
      "hope",
      "wish",
      "namaste",
      "highfive"
    ],
    k: [
      33,
      50
    ],
    o: 2
  },
  softball: {
    a: "Softball",
    b: "1F94E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      29
    ],
    o: 11
  },
  high_heel: {
    a: "High-Heeled Shoe",
    b: "1F460",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "shoes",
      "female",
      "pumps",
      "stiletto"
    ],
    k: [
      14,
      20
    ],
    o: 2
  },
  "flag-bg": {
    a: "Bulgaria Flag",
    b: "1F1E7-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      53
    ],
    o: 2
  },
  arrow_lower_right: {
    a: "South East Arrow",
    b: "2198-FE0F",
    c: "2198",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "diagonal",
      "southeast"
    ],
    k: [
      52,
      18
    ],
    o: 2
  },
  hotel: {
    a: "Hotel",
    b: "1F3E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "accomodation",
      "checkin"
    ],
    k: [
      11,
      2
    ],
    o: 2
  },
  boar: {
    a: "Boar",
    b: "1F417",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      11,
      52
    ],
    o: 2
  },
  sandal: {
    a: "Womans Sandal",
    b: "1F461",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shoes",
      "fashion",
      "flip flops"
    ],
    k: [
      14,
      21
    ],
    o: 2
  },
  "flag-bh": {
    a: "Bahrain Flag",
    b: "1F1E7-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      54
    ],
    o: 2
  },
  arrow_down: {
    a: "Downwards Black Arrow",
    b: "2B07-FE0F",
    c: "2B07",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "bottom"
    ],
    k: [
      55,
      39
    ],
    o: 2
  },
  thinking_face: {
    a: "Thinking Face",
    b: "1F914",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      27
    ],
    o: 2
  },
  writing_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "270D-1F3FB",
        non_qualified: null,
        image: "270d-1f3fb.png",
        sheet_x: 55,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "270D-1F3FC",
        non_qualified: null,
        image: "270d-1f3fc.png",
        sheet_x: 55,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "270D-1F3FD",
        non_qualified: null,
        image: "270d-1f3fd.png",
        sheet_x: 55,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "270D-1F3FE",
        non_qualified: null,
        image: "270d-1f3fe.png",
        sheet_x: 55,
        sheet_y: 8,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "270D-1F3FF",
        non_qualified: null,
        image: "270d-1f3ff.png",
        sheet_x: 55,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Writing Hand",
    b: "270D-FE0F",
    c: "270D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "lower_left_ballpoint_pen",
      "stationery",
      "write",
      "compose"
    ],
    k: [
      55,
      4
    ],
    o: 2
  },
  chestnut: {
    a: "Chestnut",
    b: "1F330",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "squirrel"
    ],
    k: [
      6,
      8
    ],
    o: 2
  },
  basketball: {
    a: "Basketball and Hoop",
    b: "1F3C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls",
      "NBA"
    ],
    k: [
      8,
      38
    ],
    o: 2
  },
  pig_nose: {
    a: "Pig Nose",
    b: "1F43D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "oink"
    ],
    k: [
      12,
      33
    ],
    o: 2
  },
  love_hotel: {
    a: "Love Hotel",
    b: "1F3E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "like",
      "affection",
      "dating"
    ],
    k: [
      11,
      3
    ],
    o: 2
  },
  nail_care: {
    skin_variations: {
      "1F3FB": {
        unified: "1F485-1F3FB",
        non_qualified: null,
        image: "1f485-1f3fb.png",
        sheet_x: 24,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F485-1F3FC",
        non_qualified: null,
        image: "1f485-1f3fc.png",
        sheet_x: 24,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F485-1F3FD",
        non_qualified: null,
        image: "1f485-1f3fd.png",
        sheet_x: 24,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F485-1F3FE",
        non_qualified: null,
        image: "1f485-1f3fe.png",
        sheet_x: 24,
        sheet_y: 37,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F485-1F3FF",
        non_qualified: null,
        image: "1f485-1f3ff.png",
        sheet_x: 24,
        sheet_y: 38,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Nail Polish",
    b: "1F485",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beauty",
      "manicure",
      "finger",
      "fashion",
      "nail"
    ],
    k: [
      24,
      33
    ],
    o: 2
  },
  volleyball: {
    a: "Volleyball",
    b: "1F3D0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls"
    ],
    k: [
      10,
      35
    ],
    o: 2
  },
  "flag-bi": {
    a: "Burundi Flag",
    b: "1F1E7-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      55
    ],
    o: 2
  },
  arrow_lower_left: {
    a: "South West Arrow",
    b: "2199-FE0F",
    c: "2199",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "diagonal",
      "southwest"
    ],
    k: [
      52,
      19
    ],
    o: 2
  },
  ram: {
    a: "Ram",
    b: "1F40F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "sheep",
      "nature"
    ],
    k: [
      11,
      43
    ],
    o: 2
  },
  ballet_shoes: {
    a: "Ballet Shoes",
    b: "1FA70",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      51
    ],
    o: 12
  },
  zipper_mouth_face: {
    a: "Zipper-Mouth Face",
    b: "1F910",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sealed",
      "zipper",
      "secret"
    ],
    k: [
      37,
      23
    ],
    o: 2
  },
  bread: {
    a: "Bread",
    b: "1F35E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "wheat",
      "breakfast",
      "toast"
    ],
    k: [
      6,
      54
    ],
    o: 2
  },
  convenience_store: {
    a: "Convenience Store",
    b: "1F3EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "shopping",
      "groceries"
    ],
    k: [
      11,
      4
    ],
    o: 2
  },
  boot: {
    a: "Womans Boots",
    b: "1F462",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shoes",
      "fashion"
    ],
    k: [
      14,
      22
    ],
    o: 2
  },
  sheep: {
    a: "Sheep",
    b: "1F411",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "wool",
      "shipit"
    ],
    k: [
      11,
      45
    ],
    o: 2
  },
  face_with_raised_eyebrow: {
    a: "Face with One Eyebrow Raised",
    b: "1F928",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      42
    ],
    n: [
      "face_with_one_eyebrow_raised"
    ],
    o: 5
  },
  "flag-bj": {
    a: "Benin Flag",
    b: "1F1E7-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      56
    ],
    o: 2
  },
  arrow_left: {
    a: "Leftwards Black Arrow",
    b: "2B05-FE0F",
    c: "2B05",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "previous",
      "back"
    ],
    k: [
      55,
      37
    ],
    o: 2
  },
  selfie: {
    skin_variations: {
      "1F3FB": {
        unified: "1F933-1F3FB",
        non_qualified: null,
        image: "1f933-1f3fb.png",
        sheet_x: 39,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F933-1F3FC",
        non_qualified: null,
        image: "1f933-1f3fc.png",
        sheet_x: 39,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F933-1F3FD",
        non_qualified: null,
        image: "1f933-1f3fd.png",
        sheet_x: 39,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F933-1F3FE",
        non_qualified: null,
        image: "1f933-1f3fe.png",
        sheet_x: 39,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F933-1F3FF",
        non_qualified: null,
        image: "1f933-1f3ff.png",
        sheet_x: 39,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Selfie",
    b: "1F933",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "camera",
      "phone"
    ],
    k: [
      39,
      11
    ],
    o: 4
  },
  croissant: {
    a: "Croissant",
    b: "1F950",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "bread",
      "french"
    ],
    k: [
      41,
      31
    ],
    o: 4
  },
  school: {
    a: "School",
    b: "1F3EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "student",
      "education",
      "learn",
      "teach"
    ],
    k: [
      11,
      5
    ],
    o: 2
  },
  football: {
    a: "American Football",
    b: "1F3C8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls",
      "NFL"
    ],
    k: [
      9,
      33
    ],
    o: 2
  },
  goat: {
    a: "Goat",
    b: "1F410",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      11,
      44
    ],
    o: 2
  },
  department_store: {
    a: "Department Store",
    b: "1F3EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "shopping",
      "mall"
    ],
    k: [
      11,
      6
    ],
    o: 2
  },
  "flag-bl": {
    a: "St. Barthélemy Flag",
    b: "1F1E7-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      0
    ],
    o: 2
  },
  crown: {
    a: "Crown",
    b: "1F451",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "king",
      "kod",
      "leader",
      "royalty",
      "lord"
    ],
    k: [
      14,
      5
    ],
    o: 2
  },
  arrow_upper_left: {
    a: "North West Arrow",
    b: "2196-FE0F",
    c: "2196",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "point",
      "direction",
      "diagonal",
      "northwest"
    ],
    k: [
      52,
      16
    ],
    o: 2
  },
  neutral_face: {
    a: "Neutral Face",
    b: "1F610",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "indifference",
      "meh",
      ":|",
      "neutral"
    ],
    k: [
      30,
      51
    ],
    l: [
      ":|",
      ":-|"
    ],
    o: 2
  },
  rugby_football: {
    a: "Rugby Football",
    b: "1F3C9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "team"
    ],
    k: [
      9,
      34
    ],
    o: 2
  },
  muscle: {
    skin_variations: {
      "1F3FB": {
        unified: "1F4AA-1F3FB",
        non_qualified: null,
        image: "1f4aa-1f3fb.png",
        sheet_x: 25,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F4AA-1F3FC",
        non_qualified: null,
        image: "1f4aa-1f3fc.png",
        sheet_x: 25,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F4AA-1F3FD",
        non_qualified: null,
        image: "1f4aa-1f3fd.png",
        sheet_x: 25,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F4AA-1F3FE",
        non_qualified: null,
        image: "1f4aa-1f3fe.png",
        sheet_x: 25,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F4AA-1F3FF",
        non_qualified: null,
        image: "1f4aa-1f3ff.png",
        sheet_x: 26,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Flexed Biceps",
    b: "1F4AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arm",
      "flex",
      "hand",
      "summer",
      "strong",
      "biceps"
    ],
    k: [
      25,
      52
    ],
    o: 2
  },
  baguette_bread: {
    a: "Baguette Bread",
    b: "1F956",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "bread",
      "french"
    ],
    k: [
      41,
      37
    ],
    o: 4
  },
  expressionless: {
    a: "Expressionless Face",
    b: "1F611",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "indifferent",
      "-_-",
      "meh",
      "deadpan"
    ],
    k: [
      30,
      52
    ],
    o: 2
  },
  womans_hat: {
    a: "Womans Hat",
    b: "1F452",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "accessories",
      "female",
      "lady",
      "spring"
    ],
    k: [
      14,
      6
    ],
    o: 2
  },
  pretzel: {
    a: "Pretzel",
    b: "1F968",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      55
    ],
    o: 5
  },
  mechanical_arm: {
    a: "Mechanical Arm",
    b: "1F9BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      6
    ],
    o: 12
  },
  arrow_up_down: {
    a: "Up Down Arrow",
    b: "2195-FE0F",
    c: "2195",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "way",
      "vertical"
    ],
    k: [
      52,
      15
    ],
    o: 2
  },
  dromedary_camel: {
    a: "Dromedary Camel",
    b: "1F42A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "hot",
      "desert",
      "hump"
    ],
    k: [
      12,
      14
    ],
    o: 2
  },
  tennis: {
    a: "Tennis Racquet and Ball",
    b: "1F3BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls",
      "green"
    ],
    k: [
      8,
      36
    ],
    o: 2
  },
  "flag-bm": {
    a: "Bermuda Flag",
    b: "1F1E7-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      1
    ],
    o: 2
  },
  factory: {
    a: "Factory",
    b: "1F3ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "industry",
      "pollution",
      "smoke"
    ],
    k: [
      11,
      7
    ],
    o: 2
  },
  japanese_castle: {
    a: "Japanese Castle",
    b: "1F3EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "building"
    ],
    k: [
      11,
      9
    ],
    o: 2
  },
  no_mouth: {
    a: "Face Without Mouth",
    b: "1F636",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "hellokitty"
    ],
    k: [
      31,
      32
    ],
    o: 2
  },
  mechanical_leg: {
    a: "Mechanical Leg",
    b: "1F9BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      7
    ],
    o: 12
  },
  bagel: {
    a: "Bagel",
    b: "1F96F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      5
    ],
    o: 11
  },
  camel: {
    a: "Bactrian Camel",
    b: "1F42B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "hot",
      "desert",
      "hump"
    ],
    k: [
      12,
      15
    ],
    o: 2
  },
  tophat: {
    a: "Top Hat",
    b: "1F3A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "magic",
      "gentleman",
      "classy",
      "circus"
    ],
    k: [
      8,
      15
    ],
    o: 2
  },
  left_right_arrow: {
    a: "Left Right Arrow",
    b: "2194-FE0F",
    c: "2194",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "direction",
      "horizontal",
      "sideways"
    ],
    k: [
      52,
      14
    ],
    o: 2
  },
  "flag-bn": {
    a: "Brunei Flag",
    b: "1F1E7-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      2
    ],
    o: 2
  },
  flying_disc: {
    a: "Flying Disc",
    b: "1F94F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      30
    ],
    o: 11
  },
  smirk: {
    a: "Smirking Face",
    b: "1F60F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "smile",
      "mean",
      "prank",
      "smug",
      "sarcasm"
    ],
    k: [
      30,
      50
    ],
    o: 2
  },
  mortar_board: {
    a: "Graduation Cap",
    b: "1F393",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "school",
      "college",
      "degree",
      "university",
      "graduation",
      "cap",
      "hat",
      "legal",
      "learn",
      "education"
    ],
    k: [
      7,
      55
    ],
    o: 2
  },
  european_castle: {
    a: "European Castle",
    b: "1F3F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "royalty",
      "history"
    ],
    k: [
      11,
      10
    ],
    o: 2
  },
  leg: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B5-1F3FB",
        non_qualified: null,
        image: "1f9b5-1f3fb.png",
        sheet_x: 43,
        sheet_y: 6,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B5-1F3FC",
        non_qualified: null,
        image: "1f9b5-1f3fc.png",
        sheet_x: 43,
        sheet_y: 7,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B5-1F3FD",
        non_qualified: null,
        image: "1f9b5-1f3fd.png",
        sheet_x: 43,
        sheet_y: 8,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B5-1F3FE",
        non_qualified: null,
        image: "1f9b5-1f3fe.png",
        sheet_x: 43,
        sheet_y: 9,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B5-1F3FF",
        non_qualified: null,
        image: "1f9b5-1f3ff.png",
        sheet_x: 43,
        sheet_y: 10,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Leg",
    b: "1F9B5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      5
    ],
    o: 11
  },
  pancakes: {
    a: "Pancakes",
    b: "1F95E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "breakfast",
      "flapjacks",
      "hotcakes"
    ],
    k: [
      41,
      45
    ],
    o: 4
  },
  leftwards_arrow_with_hook: {
    a: "Leftwards Arrow with Hook",
    b: "21A9-FE0F",
    c: "21A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "back",
      "return",
      "blue-square",
      "undo",
      "enter"
    ],
    k: [
      52,
      20
    ],
    o: 2
  },
  "flag-bo": {
    a: "Bolivia Flag",
    b: "1F1E7-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      3
    ],
    o: 2
  },
  bowling: {
    a: "Bowling",
    b: "1F3B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "fun",
      "play"
    ],
    k: [
      8,
      25
    ],
    o: 2
  },
  llama: {
    a: "Llama",
    b: "1F999",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      43
    ],
    o: 11
  },
  arrow_right_hook: {
    a: "Rightwards Arrow with Hook",
    b: "21AA-FE0F",
    c: "21AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "return",
      "rotate",
      "direction"
    ],
    k: [
      52,
      21
    ],
    o: 2
  },
  wedding: {
    a: "Wedding",
    b: "1F492",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "couple",
      "marriage",
      "bride",
      "groom"
    ],
    k: [
      25,
      28
    ],
    o: 2
  },
  "flag-bq": {
    a: "Caribbean Netherlands Flag",
    b: "1F1E7-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      4
    ],
    o: 2
  },
  foot: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B6-1F3FB",
        non_qualified: null,
        image: "1f9b6-1f3fb.png",
        sheet_x: 43,
        sheet_y: 12,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B6-1F3FC",
        non_qualified: null,
        image: "1f9b6-1f3fc.png",
        sheet_x: 43,
        sheet_y: 13,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B6-1F3FD",
        non_qualified: null,
        image: "1f9b6-1f3fd.png",
        sheet_x: 43,
        sheet_y: 14,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B6-1F3FE",
        non_qualified: null,
        image: "1f9b6-1f3fe.png",
        sheet_x: 43,
        sheet_y: 15,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B6-1F3FF",
        non_qualified: null,
        image: "1f9b6-1f3ff.png",
        sheet_x: 43,
        sheet_y: 16,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Foot",
    b: "1F9B6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      11
    ],
    o: 11
  },
  giraffe_face: {
    a: "Giraffe Face",
    b: "1F992",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      36
    ],
    o: 5
  },
  unamused: {
    a: "Unamused Face",
    b: "1F612",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "indifference",
      "bored",
      "straight face",
      "serious",
      "sarcasm"
    ],
    k: [
      30,
      53
    ],
    m: ":(",
    o: 2
  },
  billed_cap: {
    a: "Billed Cap",
    b: "1F9E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      21
    ],
    o: 5
  },
  waffle: {
    a: "Waffle",
    b: "1F9C7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      15
    ],
    o: 12
  },
  cricket_bat_and_ball: {
    a: "Cricket Bat and Ball",
    b: "1F3CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      34
    ],
    o: 2
  },
  helmet_with_white_cross: {
    a: "Helmet with White Cross",
    b: "26D1-FE0F",
    c: "26D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      6
    ],
    o: 2
  },
  ear: {
    skin_variations: {
      "1F3FB": {
        unified: "1F442-1F3FB",
        non_qualified: null,
        image: "1f442-1f3fb.png",
        sheet_x: 12,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F442-1F3FC",
        non_qualified: null,
        image: "1f442-1f3fc.png",
        sheet_x: 12,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F442-1F3FD",
        non_qualified: null,
        image: "1f442-1f3fd.png",
        sheet_x: 12,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F442-1F3FE",
        non_qualified: null,
        image: "1f442-1f3fe.png",
        sheet_x: 12,
        sheet_y: 43,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F442-1F3FF",
        non_qualified: null,
        image: "1f442-1f3ff.png",
        sheet_x: 12,
        sheet_y: 44,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Ear",
    b: "1F442",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "hear",
      "sound",
      "listen"
    ],
    k: [
      12,
      39
    ],
    o: 2
  },
  elephant: {
    a: "Elephant",
    b: "1F418",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "nose",
      "th",
      "circus"
    ],
    k: [
      11,
      53
    ],
    o: 2
  },
  cheese_wedge: {
    a: "Cheese Wedge",
    b: "1F9C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      8
    ],
    o: 2
  },
  tokyo_tower: {
    a: "Tokyo Tower",
    b: "1F5FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "japanese"
    ],
    k: [
      30,
      31
    ],
    o: 2
  },
  arrow_heading_up: {
    a: "Arrow Pointing Rightwards Then Curving Upwards",
    b: "2934-FE0F",
    c: "2934",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "top"
    ],
    k: [
      55,
      35
    ],
    o: 2
  },
  field_hockey_stick_and_ball: {
    a: "Field Hockey Stick and Ball",
    b: "1F3D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      36
    ],
    o: 2
  },
  "flag-br": {
    a: "Brazil Flag",
    b: "1F1E7-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      5
    ],
    o: 2
  },
  face_with_rolling_eyes: {
    a: "Face with Rolling Eyes",
    b: "1F644",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      31,
      46
    ],
    o: 2
  },
  ear_with_hearing_aid: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9BB-1F3FB",
        non_qualified: null,
        image: "1f9bb-1f3fb.png",
        sheet_x: 43,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9BB-1F3FC",
        non_qualified: null,
        image: "1f9bb-1f3fc.png",
        sheet_x: 44,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9BB-1F3FD",
        non_qualified: null,
        image: "1f9bb-1f3fd.png",
        sheet_x: 44,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9BB-1F3FE",
        non_qualified: null,
        image: "1f9bb-1f3fe.png",
        sheet_x: 44,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9BB-1F3FF",
        non_qualified: null,
        image: "1f9bb-1f3ff.png",
        sheet_x: 44,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Ear with Hearing Aid",
    b: "1F9BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      55
    ],
    o: 12
  },
  arrow_heading_down: {
    a: "Arrow Pointing Rightwards Then Curving Downwards",
    b: "2935-FE0F",
    c: "2935",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "bottom"
    ],
    k: [
      55,
      36
    ],
    o: 2
  },
  ice_hockey_stick_and_puck: {
    a: "Ice Hockey Stick and Puck",
    b: "1F3D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      37
    ],
    o: 2
  },
  meat_on_bone: {
    a: "Meat on Bone",
    b: "1F356",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "good",
      "food",
      "drumstick"
    ],
    k: [
      6,
      46
    ],
    o: 2
  },
  prayer_beads: {
    a: "Prayer Beads",
    b: "1F4FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dhikr",
      "religious"
    ],
    k: [
      27,
      27
    ],
    o: 2
  },
  statue_of_liberty: {
    a: "Statue of Liberty",
    b: "1F5FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "american",
      "newyork"
    ],
    k: [
      30,
      32
    ],
    o: 2
  },
  grimacing: {
    a: "Grimacing Face",
    b: "1F62C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "grimace",
      "teeth"
    ],
    k: [
      31,
      22
    ],
    o: 2
  },
  "flag-bs": {
    a: "Bahamas Flag",
    b: "1F1E7-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      6
    ],
    o: 2
  },
  rhinoceros: {
    a: "Rhinoceros",
    b: "1F98F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "horn"
    ],
    k: [
      42,
      33
    ],
    o: 4
  },
  lacrosse: {
    a: "Lacrosse Stick and Ball",
    b: "1F94D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      28
    ],
    o: 11
  },
  poultry_leg: {
    a: "Poultry Leg",
    b: "1F357",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "meat",
      "drumstick",
      "bird",
      "chicken",
      "turkey"
    ],
    k: [
      6,
      47
    ],
    o: 2
  },
  hippopotamus: {
    a: "Hippopotamus",
    b: "1F99B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      45
    ],
    o: 11
  },
  nose: {
    skin_variations: {
      "1F3FB": {
        unified: "1F443-1F3FB",
        non_qualified: null,
        image: "1f443-1f3fb.png",
        sheet_x: 12,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F443-1F3FC",
        non_qualified: null,
        image: "1f443-1f3fc.png",
        sheet_x: 12,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F443-1F3FD",
        non_qualified: null,
        image: "1f443-1f3fd.png",
        sheet_x: 12,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F443-1F3FE",
        non_qualified: null,
        image: "1f443-1f3fe.png",
        sheet_x: 12,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F443-1F3FF",
        non_qualified: null,
        image: "1f443-1f3ff.png",
        sheet_x: 12,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Nose",
    b: "1F443",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "smell",
      "sniff"
    ],
    k: [
      12,
      45
    ],
    o: 2
  },
  arrows_clockwise: {
    a: "Clockwise Downwards and Upwards Open Circle Arrows",
    b: "1F503",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sync",
      "cycle",
      "round",
      "repeat"
    ],
    k: [
      27,
      31
    ],
    o: 2
  },
  "flag-bt": {
    a: "Bhutan Flag",
    b: "1F1E7-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      7
    ],
    o: 2
  },
  church: {
    a: "Church",
    b: "26EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "religion",
      "christ"
    ],
    k: [
      54,
      10
    ],
    o: 2
  },
  lipstick: {
    a: "Lipstick",
    b: "1F484",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "female",
      "girl",
      "fashion",
      "woman"
    ],
    k: [
      24,
      32
    ],
    o: 2
  },
  lying_face: {
    a: "Lying Face",
    b: "1F925",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "lie",
      "pinocchio"
    ],
    k: [
      38,
      22
    ],
    o: 4
  },
  arrows_counterclockwise: {
    a: "Anticlockwise Downwards and Upwards Open Circle Arrows",
    b: "1F504",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "sync",
      "cycle"
    ],
    k: [
      27,
      32
    ],
    o: 2
  },
  "flag-bv": {
    a: "Bouvet Island Flag",
    b: "1F1E7-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      8
    ],
    o: 2
  },
  cut_of_meat: {
    a: "Cut of Meat",
    b: "1F969",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      56
    ],
    o: 5
  },
  mosque: {
    a: "Mosque",
    b: "1F54C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "islam",
      "worship",
      "minaret"
    ],
    k: [
      28,
      36
    ],
    o: 2
  },
  ring: {
    a: "Ring",
    b: "1F48D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wedding",
      "propose",
      "marriage",
      "valentines",
      "diamond",
      "fashion",
      "jewelry",
      "gem",
      "engagement"
    ],
    k: [
      25,
      23
    ],
    o: 2
  },
  brain: {
    a: "Brain",
    b: "1F9E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      19
    ],
    o: 5
  },
  table_tennis_paddle_and_ball: {
    a: "Table Tennis Paddle and Ball",
    b: "1F3D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      38
    ],
    o: 2
  },
  relieved: {
    a: "Relieved Face",
    b: "1F60C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "relaxed",
      "phew",
      "massage",
      "happiness"
    ],
    k: [
      30,
      47
    ],
    o: 2
  },
  mouse: {
    a: "Mouse Face",
    b: "1F42D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "cheese_wedge",
      "rodent"
    ],
    k: [
      12,
      17
    ],
    o: 2
  },
  hindu_temple: {
    a: "Hindu Temple",
    b: "1F6D5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      41
    ],
    o: 12
  },
  back: {
    a: "Back with Leftwards Arrow Above",
    b: "1F519",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arrow",
      "words",
      "return"
    ],
    k: [
      27,
      53
    ],
    o: 2
  },
  gem: {
    a: "Gem Stone",
    b: "1F48E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue",
      "ruby",
      "diamond",
      "jewelry"
    ],
    k: [
      25,
      24
    ],
    o: 2
  },
  pensive: {
    a: "Pensive Face",
    b: "1F614",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sad",
      "depressed",
      "upset"
    ],
    k: [
      30,
      55
    ],
    o: 2
  },
  "flag-bw": {
    a: "Botswana Flag",
    b: "1F1E7-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      9
    ],
    o: 2
  },
  mouse2: {
    a: "Mouse",
    b: "1F401",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "rodent"
    ],
    k: [
      11,
      29
    ],
    o: 2
  },
  bacon: {
    a: "Bacon",
    b: "1F953",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "breakfast",
      "pork",
      "pig",
      "meat"
    ],
    k: [
      41,
      34
    ],
    o: 4
  },
  tooth: {
    a: "Tooth",
    b: "1F9B7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      17
    ],
    o: 11
  },
  badminton_racquet_and_shuttlecock: {
    a: "Badminton Racquet and Shuttlecock",
    b: "1F3F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      20
    ],
    o: 2
  },
  rat: {
    a: "Rat",
    b: "1F400",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "mouse",
      "rodent"
    ],
    k: [
      11,
      28
    ],
    o: 2
  },
  synagogue: {
    a: "Synagogue",
    b: "1F54D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "judaism",
      "worship",
      "temple",
      "jewish"
    ],
    k: [
      28,
      37
    ],
    o: 2
  },
  end: {
    a: "End with Leftwards Arrow Above",
    b: "1F51A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "arrow"
    ],
    k: [
      27,
      54
    ],
    o: 2
  },
  bone: {
    a: "Bone",
    b: "1F9B4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      4
    ],
    o: 11
  },
  boxing_glove: {
    a: "Boxing Glove",
    b: "1F94A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "fighting"
    ],
    k: [
      41,
      25
    ],
    o: 4
  },
  mute: {
    a: "Speaker with Cancellation Stroke",
    b: "1F507",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "volume",
      "silence",
      "quiet"
    ],
    k: [
      27,
      35
    ],
    o: 2
  },
  hamburger: {
    a: "Hamburger",
    b: "1F354",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "meat",
      "fast food",
      "beef",
      "cheeseburger",
      "mcdonalds",
      "burger king"
    ],
    k: [
      6,
      44
    ],
    o: 2
  },
  "flag-by": {
    a: "Belarus Flag",
    b: "1F1E7-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      10
    ],
    o: 2
  },
  sleepy: {
    a: "Sleepy Face",
    b: "1F62A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "tired",
      "rest",
      "nap"
    ],
    k: [
      31,
      20
    ],
    o: 2
  },
  on: {
    a: "On with Exclamation Mark with Left Right Arrow Above",
    b: "1F51B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arrow",
      "words"
    ],
    k: [
      27,
      55
    ],
    o: 2
  },
  martial_arts_uniform: {
    a: "Martial Arts Uniform",
    b: "1F94B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "judo",
      "karate",
      "taekwondo"
    ],
    k: [
      41,
      26
    ],
    o: 4
  },
  speaker: {
    a: "Speaker",
    b: "1F508",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "volume",
      "silence",
      "broadcast"
    ],
    k: [
      27,
      36
    ],
    o: 2
  },
  drooling_face: {
    a: "Drooling Face",
    b: "1F924",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face"
    ],
    k: [
      38,
      21
    ],
    o: 4
  },
  eyes: {
    a: "Eyes",
    b: "1F440",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "look",
      "watch",
      "stalk",
      "peek",
      "see"
    ],
    k: [
      12,
      36
    ],
    o: 2
  },
  "flag-bz": {
    a: "Belize Flag",
    b: "1F1E7-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      11
    ],
    o: 2
  },
  hamster: {
    a: "Hamster Face",
    b: "1F439",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      12,
      29
    ],
    o: 2
  },
  shinto_shrine: {
    a: "Shinto Shrine",
    b: "26E9-FE0F",
    c: "26E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "temple",
      "japan",
      "kyoto"
    ],
    k: [
      54,
      9
    ],
    o: 2
  },
  fries: {
    a: "French Fries",
    b: "1F35F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chips",
      "snack",
      "fast food"
    ],
    k: [
      6,
      55
    ],
    o: 2
  },
  goal_net: {
    a: "Goal Net",
    b: "1F945",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports"
    ],
    k: [
      41,
      21
    ],
    o: 4
  },
  kaaba: {
    a: "Kaaba",
    b: "1F54B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mecca",
      "mosque",
      "islam"
    ],
    k: [
      28,
      35
    ],
    o: 2
  },
  soon: {
    a: "Soon with Rightwards Arrow Above",
    b: "1F51C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arrow",
      "words"
    ],
    k: [
      27,
      56
    ],
    o: 2
  },
  "flag-ca": {
    a: "Canada Flag",
    b: "1F1E8-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      12
    ],
    o: 2
  },
  rabbit: {
    a: "Rabbit Face",
    b: "1F430",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "pet",
      "spring",
      "magic",
      "bunny"
    ],
    k: [
      12,
      20
    ],
    o: 2
  },
  eye: {
    a: "Eye",
    b: "1F441-FE0F",
    c: "1F441",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "look",
      "see",
      "watch",
      "stare"
    ],
    k: [
      12,
      38
    ],
    o: 2
  },
  sleeping: {
    a: "Sleeping Face",
    b: "1F634",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "tired",
      "sleepy",
      "night",
      "zzz"
    ],
    k: [
      31,
      30
    ],
    o: 2
  },
  pizza: {
    a: "Slice of Pizza",
    b: "1F355",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "party"
    ],
    k: [
      6,
      45
    ],
    o: 2
  },
  sound: {
    a: "Speaker with One Sound Wave",
    b: "1F509",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "volume",
      "speaker",
      "broadcast"
    ],
    k: [
      27,
      37
    ],
    o: 2
  },
  rabbit2: {
    a: "Rabbit",
    b: "1F407",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "pet",
      "magic",
      "spring"
    ],
    k: [
      11,
      35
    ],
    o: 2
  },
  fountain: {
    a: "Fountain",
    b: "26F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "summer",
      "water",
      "fresh"
    ],
    k: [
      54,
      13
    ],
    o: 2
  },
  golf: {
    a: "Flag in Hole",
    b: "26F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "business",
      "flag",
      "hole",
      "summer"
    ],
    k: [
      54,
      14
    ],
    o: 2
  },
  top: {
    a: "Top with Upwards Arrow Above",
    b: "1F51D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "blue-square"
    ],
    k: [
      28,
      0
    ],
    o: 2
  },
  mask: {
    a: "Face with Medical Mask",
    b: "1F637",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sick",
      "ill",
      "disease"
    ],
    k: [
      31,
      33
    ],
    o: 2
  },
  "flag-cc": {
    a: "Cocos (keeling) Islands Flag",
    b: "1F1E8-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      13
    ],
    o: 2
  },
  hotdog: {
    a: "Hot Dog",
    b: "1F32D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "frankfurter"
    ],
    k: [
      6,
      5
    ],
    o: 2
  },
  loud_sound: {
    a: "Speaker with Three Sound Waves",
    b: "1F50A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "volume",
      "noise",
      "noisy",
      "speaker",
      "broadcast"
    ],
    k: [
      27,
      38
    ],
    o: 2
  },
  tongue: {
    a: "Tongue",
    b: "1F445",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mouth",
      "playful"
    ],
    k: [
      12,
      52
    ],
    o: 2
  },
  place_of_worship: {
    a: "Place of Worship",
    b: "1F6D0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "religion",
      "church",
      "temple",
      "prayer"
    ],
    k: [
      36,
      38
    ],
    o: 2
  },
  ice_skate: {
    a: "Ice Skate",
    b: "26F8-FE0F",
    c: "26F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports"
    ],
    k: [
      54,
      18
    ],
    o: 2
  },
  sandwich: {
    a: "Sandwich",
    b: "1F96A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      0
    ],
    o: 5
  },
  chipmunk: {
    a: "Chipmunk",
    b: "1F43F-FE0F",
    c: "1F43F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "rodent",
      "squirrel"
    ],
    k: [
      12,
      35
    ],
    o: 2
  },
  loudspeaker: {
    a: "Public Address Loudspeaker",
    b: "1F4E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "volume",
      "sound"
    ],
    k: [
      26,
      56
    ],
    o: 2
  },
  lips: {
    a: "Mouth",
    b: "1F444",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mouth",
      "kiss"
    ],
    k: [
      12,
      51
    ],
    o: 2
  },
  "flag-cd": {
    a: "Congo - Kinshasa Flag",
    b: "1F1E8-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      14
    ],
    o: 2
  },
  tent: {
    a: "Tent",
    b: "26FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "camping",
      "outdoors"
    ],
    k: [
      54,
      37
    ],
    o: 2
  },
  face_with_thermometer: {
    a: "Face with Thermometer",
    b: "1F912",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sick",
      "temperature",
      "thermometer",
      "cold",
      "fever"
    ],
    k: [
      37,
      25
    ],
    o: 2
  },
  taco: {
    a: "Taco",
    b: "1F32E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "mexican"
    ],
    k: [
      6,
      6
    ],
    o: 2
  },
  foggy: {
    a: "Foggy",
    b: "1F301",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "mountain"
    ],
    k: [
      5,
      20
    ],
    o: 2
  },
  "flag-cf": {
    a: "Central African Republic Flag",
    b: "1F1E8-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      15
    ],
    o: 2
  },
  baby: {
    skin_variations: {
      "1F3FB": {
        unified: "1F476-1F3FB",
        non_qualified: null,
        image: "1f476-1f3fb.png",
        sheet_x: 23,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F476-1F3FC",
        non_qualified: null,
        image: "1f476-1f3fc.png",
        sheet_x: 23,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F476-1F3FD",
        non_qualified: null,
        image: "1f476-1f3fd.png",
        sheet_x: 23,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F476-1F3FE",
        non_qualified: null,
        image: "1f476-1f3fe.png",
        sheet_x: 23,
        sheet_y: 8,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F476-1F3FF",
        non_qualified: null,
        image: "1f476-1f3ff.png",
        sheet_x: 23,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Baby",
    b: "1F476",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "child",
      "boy",
      "girl",
      "toddler"
    ],
    k: [
      23,
      4
    ],
    o: 2
  },
  atom_symbol: {
    a: "Atom Symbol",
    b: "269B-FE0F",
    c: "269B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "science",
      "physics",
      "chemistry"
    ],
    k: [
      53,
      48
    ],
    o: 2
  },
  fishing_pole_and_fish: {
    a: "Fishing Pole and Fish",
    b: "1F3A3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "hobby",
      "summer"
    ],
    k: [
      8,
      9
    ],
    o: 2
  },
  hedgehog: {
    a: "Hedgehog",
    b: "1F994",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      38
    ],
    o: 5
  },
  face_with_head_bandage: {
    a: "Face with Head-Bandage",
    b: "1F915",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "injured",
      "clumsy",
      "bandage",
      "hurt"
    ],
    k: [
      37,
      28
    ],
    o: 2
  },
  mega: {
    a: "Cheering Megaphone",
    b: "1F4E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "speaker",
      "volume"
    ],
    k: [
      27,
      0
    ],
    o: 2
  },
  nauseated_face: {
    a: "Nauseated Face",
    b: "1F922",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "vomit",
      "gross",
      "green",
      "sick",
      "throw up",
      "ill"
    ],
    k: [
      38,
      19
    ],
    o: 4
  },
  child: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D2-1F3FB",
        non_qualified: null,
        image: "1f9d2-1f3fb.png",
        sheet_x: 48,
        sheet_y: 17,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D2-1F3FC",
        non_qualified: null,
        image: "1f9d2-1f3fc.png",
        sheet_x: 48,
        sheet_y: 18,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D2-1F3FD",
        non_qualified: null,
        image: "1f9d2-1f3fd.png",
        sheet_x: 48,
        sheet_y: 19,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D2-1F3FE",
        non_qualified: null,
        image: "1f9d2-1f3fe.png",
        sheet_x: 48,
        sheet_y: 20,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D2-1F3FF",
        non_qualified: null,
        image: "1f9d2-1f3ff.png",
        sheet_x: 48,
        sheet_y: 21,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Child",
    b: "1F9D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      16
    ],
    o: 5
  },
  "flag-cg": {
    a: "Congo - Brazzaville Flag",
    b: "1F1E8-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      16
    ],
    o: 2
  },
  bat: {
    a: "Bat",
    b: "1F987",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "blind",
      "vampire"
    ],
    k: [
      42,
      25
    ],
    o: 4
  },
  diving_mask: {
    a: "Diving Mask",
    b: "1F93F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      15
    ],
    o: 12
  },
  burrito: {
    a: "Burrito",
    b: "1F32F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "mexican"
    ],
    k: [
      6,
      7
    ],
    o: 2
  },
  postal_horn: {
    a: "Postal Horn",
    b: "1F4EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "instrument",
      "music"
    ],
    k: [
      27,
      12
    ],
    o: 2
  },
  night_with_stars: {
    a: "Night with Stars",
    b: "1F303",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "evening",
      "city",
      "downtown"
    ],
    k: [
      5,
      22
    ],
    o: 2
  },
  om_symbol: {
    a: "Om Symbol",
    b: "1F549-FE0F",
    c: "1F549",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      28,
      33
    ],
    o: 2
  },
  star_of_david: {
    a: "Star of David",
    b: "2721-FE0F",
    c: "2721",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "judaism"
    ],
    k: [
      55,
      15
    ],
    o: 2
  },
  boy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F466-1F3FB",
        non_qualified: null,
        image: "1f466-1f3fb.png",
        sheet_x: 14,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F466-1F3FC",
        non_qualified: null,
        image: "1f466-1f3fc.png",
        sheet_x: 14,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F466-1F3FD",
        non_qualified: null,
        image: "1f466-1f3fd.png",
        sheet_x: 14,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F466-1F3FE",
        non_qualified: null,
        image: "1f466-1f3fe.png",
        sheet_x: 14,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F466-1F3FF",
        non_qualified: null,
        image: "1f466-1f3ff.png",
        sheet_x: 14,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Boy",
    b: "1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "man",
      "male",
      "guy",
      "teenager"
    ],
    k: [
      14,
      26
    ],
    o: 2
  },
  bell: {
    a: "Bell",
    b: "1F514",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "notification",
      "christmas",
      "xmas",
      "chime"
    ],
    k: [
      27,
      48
    ],
    o: 2
  },
  "flag-ch": {
    a: "Switzerland Flag",
    b: "1F1E8-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      17
    ],
    o: 2
  },
  running_shirt_with_sash: {
    a: "Running Shirt with Sash",
    b: "1F3BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "play",
      "pageant"
    ],
    k: [
      8,
      35
    ],
    o: 2
  },
  stuffed_flatbread: {
    a: "Stuffed Flatbread",
    b: "1F959",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "flatbread",
      "stuffed",
      "gyro"
    ],
    k: [
      41,
      40
    ],
    o: 4
  },
  bear: {
    a: "Bear Face",
    b: "1F43B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "wild"
    ],
    k: [
      12,
      31
    ],
    o: 2
  },
  cityscape: {
    a: "Cityscape",
    b: "1F3D9-FE0F",
    c: "1F3D9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "night life",
      "urban"
    ],
    k: [
      10,
      44
    ],
    o: 2
  },
  face_vomiting: {
    a: "Face with Open Mouth Vomiting",
    b: "1F92E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      48
    ],
    n: [
      "face_with_open_mouth_vomiting"
    ],
    o: 5
  },
  wheel_of_dharma: {
    a: "Wheel of Dharma",
    b: "2638-FE0F",
    c: "2638",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    k: [
      53,
      15
    ],
    o: 2
  },
  ski: {
    a: "Ski and Ski Boot",
    b: "1F3BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "winter",
      "cold",
      "snow"
    ],
    k: [
      8,
      37
    ],
    o: 2
  },
  girl: {
    skin_variations: {
      "1F3FB": {
        unified: "1F467-1F3FB",
        non_qualified: null,
        image: "1f467-1f3fb.png",
        sheet_x: 14,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F467-1F3FC",
        non_qualified: null,
        image: "1f467-1f3fc.png",
        sheet_x: 14,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F467-1F3FD",
        non_qualified: null,
        image: "1f467-1f3fd.png",
        sheet_x: 14,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F467-1F3FE",
        non_qualified: null,
        image: "1f467-1f3fe.png",
        sheet_x: 14,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F467-1F3FF",
        non_qualified: null,
        image: "1f467-1f3ff.png",
        sheet_x: 14,
        sheet_y: 37,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Girl",
    b: "1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "female",
      "woman",
      "teenager"
    ],
    k: [
      14,
      32
    ],
    o: 2
  },
  falafel: {
    a: "Falafel",
    b: "1F9C6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      14
    ],
    o: 12
  },
  sneezing_face: {
    a: "Sneezing Face",
    b: "1F927",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "gesundheit",
      "sneeze",
      "sick",
      "allergy"
    ],
    k: [
      38,
      41
    ],
    o: 4
  },
  no_bell: {
    a: "Bell with Cancellation Stroke",
    b: "1F515",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "volume",
      "mute",
      "quiet",
      "silent"
    ],
    k: [
      27,
      49
    ],
    o: 2
  },
  koala: {
    a: "Koala",
    b: "1F428",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      12,
      12
    ],
    o: 2
  },
  sunrise_over_mountains: {
    a: "Sunrise over Mountains",
    b: "1F304",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "view",
      "vacation",
      "photo"
    ],
    k: [
      5,
      23
    ],
    o: 2
  },
  "flag-ci": {
    a: "Côte D’ivoire Flag",
    b: "1F1E8-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      18
    ],
    o: 2
  },
  sunrise: {
    a: "Sunrise",
    b: "1F305",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "morning",
      "view",
      "vacation",
      "photo"
    ],
    k: [
      5,
      24
    ],
    o: 2
  },
  yin_yang: {
    a: "Yin Yang",
    b: "262F-FE0F",
    c: "262F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "balance"
    ],
    k: [
      53,
      14
    ],
    o: 2
  },
  adult: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fb.png",
        sheet_x: 48,
        sheet_y: 11,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fc.png",
        sheet_x: 48,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fd.png",
        sheet_x: 48,
        sheet_y: 13,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fe.png",
        sheet_x: 48,
        sheet_y: 14,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3ff.png",
        sheet_x: 48,
        sheet_y: 15,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Adult",
    b: "1F9D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      10
    ],
    o: 5
  },
  hot_face: {
    a: "Overheated Face",
    b: "1F975",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      10
    ],
    o: 11
  },
  musical_score: {
    a: "Musical Score",
    b: "1F3BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "treble",
      "clef",
      "compose"
    ],
    k: [
      8,
      34
    ],
    o: 2
  },
  sled: {
    a: "Sled",
    b: "1F6F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      56
    ],
    o: 5
  },
  egg: {
    a: "Egg",
    b: "1F95A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "chicken",
      "breakfast"
    ],
    k: [
      41,
      41
    ],
    o: 4
  },
  panda_face: {
    a: "Panda Face",
    b: "1F43C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "panda"
    ],
    k: [
      12,
      32
    ],
    o: 2
  },
  "flag-ck": {
    a: "Cook Islands Flag",
    b: "1F1E8-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      19
    ],
    o: 2
  },
  "flag-cl": {
    a: "Chile Flag",
    b: "1F1E8-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      20
    ],
    o: 2
  },
  person_with_blond_hair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F471-1F3FB",
        non_qualified: null,
        image: "1f471-1f3fb.png",
        sheet_x: 22,
        sheet_y: 20,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F471-1F3FC",
        non_qualified: null,
        image: "1f471-1f3fc.png",
        sheet_x: 22,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F471-1F3FD",
        non_qualified: null,
        image: "1f471-1f3fd.png",
        sheet_x: 22,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F471-1F3FE",
        non_qualified: null,
        image: "1f471-1f3fe.png",
        sheet_x: 22,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F471-1F3FF",
        non_qualified: null,
        image: "1f471-1f3ff.png",
        sheet_x: 22,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F471-200D-2642-FE0F",
    a: "Person with Blond Hair",
    b: "1F471",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      22,
      19
    ],
    o: 2
  },
  sloth: {
    a: "Sloth",
    b: "1F9A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      53
    ],
    o: 12
  },
  latin_cross: {
    a: "Latin Cross",
    b: "271D-FE0F",
    c: "271D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "christianity"
    ],
    k: [
      55,
      14
    ],
    o: 2
  },
  curling_stone: {
    a: "Curling Stone",
    b: "1F94C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      27
    ],
    o: 5
  },
  cold_face: {
    a: "Freezing Face",
    b: "1F976",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      11
    ],
    o: 11
  },
  fried_egg: {
    a: "Cooking",
    b: "1F373",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "breakfast",
      "kitchen",
      "egg"
    ],
    k: [
      7,
      18
    ],
    n: [
      "cooking"
    ],
    o: 2
  },
  city_sunset: {
    a: "Cityscape at Dusk",
    b: "1F306",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "evening",
      "sky",
      "buildings"
    ],
    k: [
      5,
      25
    ],
    o: 2
  },
  musical_note: {
    a: "Musical Note",
    b: "1F3B5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "score",
      "tone",
      "sound"
    ],
    k: [
      8,
      27
    ],
    o: 2
  },
  "flag-cm": {
    a: "Cameroon Flag",
    b: "1F1E8-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      21
    ],
    o: 2
  },
  notes: {
    a: "Multiple Musical Notes",
    b: "1F3B6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "score"
    ],
    k: [
      8,
      28
    ],
    o: 2
  },
  woozy_face: {
    a: "Face with Uneven Eyes and Wavy Mouth",
    b: "1F974",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      9
    ],
    o: 11
  },
  dart: {
    a: "Direct Hit",
    b: "1F3AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "play",
      "bar"
    ],
    k: [
      8,
      21
    ],
    o: 2
  },
  orthodox_cross: {
    a: "Orthodox Cross",
    b: "2626-FE0F",
    c: "2626",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "suppedaneum",
      "religion"
    ],
    k: [
      53,
      11
    ],
    o: 2
  },
  shallow_pan_of_food: {
    a: "Shallow Pan of Food",
    b: "1F958",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "cooking",
      "casserole",
      "paella"
    ],
    k: [
      41,
      39
    ],
    o: 4
  },
  otter: {
    a: "Otter",
    b: "1F9A6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      54
    ],
    o: 12
  },
  man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3fb.png",
        sheet_x: 17,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3fc.png",
        sheet_x: 17,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3fd.png",
        sheet_x: 17,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3fe.png",
        sheet_x: 17,
        sheet_y: 26,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3ff.png",
        sheet_x: 17,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man",
    b: "1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mustache",
      "father",
      "dad",
      "guy",
      "classy",
      "sir",
      "moustache"
    ],
    k: [
      17,
      22
    ],
    o: 2
  },
  city_sunrise: {
    a: "Sunset over Buildings",
    b: "1F307",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "good morning",
      "dawn"
    ],
    k: [
      5,
      26
    ],
    o: 2
  },
  bearded_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D4-1F3FB",
        non_qualified: null,
        image: "1f9d4-1f3fb.png",
        sheet_x: 48,
        sheet_y: 29,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D4-1F3FC",
        non_qualified: null,
        image: "1f9d4-1f3fc.png",
        sheet_x: 48,
        sheet_y: 30,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D4-1F3FD",
        non_qualified: null,
        image: "1f9d4-1f3fd.png",
        sheet_x: 48,
        sheet_y: 31,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D4-1F3FE",
        non_qualified: null,
        image: "1f9d4-1f3fe.png",
        sheet_x: 48,
        sheet_y: 32,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D4-1F3FF",
        non_qualified: null,
        image: "1f9d4-1f3ff.png",
        sheet_x: 48,
        sheet_y: 33,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bearded Person",
    b: "1F9D4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      28
    ],
    o: 5
  },
  skunk: {
    a: "Skunk",
    b: "1F9A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      56
    ],
    o: 12
  },
  stew: {
    a: "Pot of Food",
    b: "1F372",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "meat",
      "soup"
    ],
    k: [
      7,
      17
    ],
    o: 2
  },
  cn: {
    a: "China Flag",
    b: "1F1E8-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "china",
      "chinese",
      "prc",
      "flag",
      "country",
      "nation",
      "banner"
    ],
    k: [
      1,
      22
    ],
    n: [
      "flag-cn"
    ],
    o: 2
  },
  studio_microphone: {
    a: "Studio Microphone",
    b: "1F399-FE0F",
    c: "1F399",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sing",
      "recording",
      "artist",
      "talkshow"
    ],
    k: [
      8,
      1
    ],
    o: 2
  },
  star_and_crescent: {
    a: "Star and Crescent",
    b: "262A-FE0F",
    c: "262A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "islam"
    ],
    k: [
      53,
      12
    ],
    o: 2
  },
  "yo-yo": {
    a: "Yo-Yo",
    b: "1FA80",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      1
    ],
    o: 12
  },
  bridge_at_night: {
    a: "Bridge at Night",
    b: "1F309",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "sanfrancisco"
    ],
    k: [
      5,
      28
    ],
    o: 2
  },
  dizzy_face: {
    a: "Dizzy Face",
    b: "1F635",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "spent",
      "unconscious",
      "xox",
      "dizzy"
    ],
    k: [
      31,
      31
    ],
    o: 2
  },
  red_haired_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 24,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 25,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 26,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 27,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 28,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Red Haired Man",
    b: "1F468-200D-1F9B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      23
    ],
    o: 11
  },
  kite: {
    a: "Kite",
    b: "1FA81",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      2
    ],
    o: 12
  },
  bowl_with_spoon: {
    a: "Bowl with Spoon",
    b: "1F963",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      50
    ],
    o: 5
  },
  "flag-co": {
    a: "Colombia Flag",
    b: "1F1E8-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      23
    ],
    o: 2
  },
  peace_symbol: {
    a: "Peace Symbol",
    b: "262E-FE0F",
    c: "262E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hippie"
    ],
    k: [
      53,
      13
    ],
    o: 2
  },
  kangaroo: {
    a: "Kangaroo",
    b: "1F998",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      42
    ],
    o: 11
  },
  hotsprings: {
    a: "Hot Springs",
    b: "2668-FE0F",
    c: "2668",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bath",
      "warm",
      "relax"
    ],
    k: [
      53,
      37
    ],
    o: 2
  },
  exploding_head: {
    a: "Shocked Face with Exploding Head",
    b: "1F92F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      49
    ],
    n: [
      "shocked_face_with_exploding_head"
    ],
    o: 5
  },
  level_slider: {
    a: "Level Slider",
    b: "1F39A-FE0F",
    c: "1F39A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "scale"
    ],
    k: [
      8,
      2
    ],
    o: 2
  },
  badger: {
    a: "Badger",
    b: "1F9A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      51
    ],
    o: 11
  },
  "8ball": {
    a: "Billiards",
    b: "1F3B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pool",
      "hobby",
      "game",
      "luck",
      "magic"
    ],
    k: [
      8,
      23
    ],
    o: 2
  },
  curly_haired_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 30,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 31,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 32,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 33,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 34,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Curly Haired Man",
    b: "1F468-200D-1F9B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      29
    ],
    o: 11
  },
  "flag-cp": {
    a: "Clipperton Island Flag",
    b: "1F1E8-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      24
    ],
    o: 2
  },
  carousel_horse: {
    a: "Carousel Horse",
    b: "1F3A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "carnival"
    ],
    k: [
      8,
      6
    ],
    o: 2
  },
  face_with_cowboy_hat: {
    a: "Face with Cowboy Hat",
    b: "1F920",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      17
    ],
    o: 4
  },
  menorah_with_nine_branches: {
    a: "Menorah with Nine Branches",
    b: "1F54E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      28,
      38
    ],
    o: 2
  },
  green_salad: {
    a: "Green Salad",
    b: "1F957",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "healthy",
      "lettuce"
    ],
    k: [
      41,
      38
    ],
    o: 4
  },
  control_knobs: {
    a: "Control Knobs",
    b: "1F39B-FE0F",
    c: "1F39B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dial"
    ],
    k: [
      8,
      3
    ],
    o: 2
  },
  popcorn: {
    a: "Popcorn",
    b: "1F37F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "movie theater",
      "films",
      "snack"
    ],
    k: [
      7,
      30
    ],
    o: 2
  },
  six_pointed_star: {
    a: "Six Pointed Star with Middle Dot",
    b: "1F52F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "religion",
      "jewish",
      "hexagram"
    ],
    k: [
      28,
      18
    ],
    o: 2
  },
  feet: {
    a: "Paw Prints",
    b: "1F43E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      12,
      34
    ],
    n: [
      "paw_prints"
    ],
    o: 2
  },
  ferris_wheel: {
    a: "Ferris Wheel",
    b: "1F3A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "carnival",
      "londoneye"
    ],
    k: [
      8,
      7
    ],
    o: 2
  },
  microphone: {
    a: "Microphone",
    b: "1F3A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "music",
      "PA",
      "sing",
      "talkshow"
    ],
    k: [
      8,
      10
    ],
    o: 2
  },
  crystal_ball: {
    a: "Crystal Ball",
    b: "1F52E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "disco",
      "party",
      "magic",
      "circus",
      "fortune_teller"
    ],
    k: [
      28,
      17
    ],
    o: 2
  },
  partying_face: {
    a: "Face with Party Horn and Party Hat",
    b: "1F973",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      8
    ],
    o: 11
  },
  "flag-cr": {
    a: "Costa Rica Flag",
    b: "1F1E8-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      25
    ],
    o: 2
  },
  white_haired_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 42,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 43,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 44,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 45,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 46,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Haired Man",
    b: "1F468-200D-1F9B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      41
    ],
    o: 11
  },
  headphones: {
    a: "Headphone",
    b: "1F3A7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "score",
      "gadgets"
    ],
    k: [
      8,
      13
    ],
    o: 2
  },
  bald_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 36,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 37,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 38,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 39,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 40,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bald Man",
    b: "1F468-200D-1F9B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      35
    ],
    o: 11
  },
  sunglasses: {
    a: "Smiling Face with Sunglasses",
    b: "1F60E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "cool",
      "smile",
      "summer",
      "beach",
      "sunglass"
    ],
    k: [
      30,
      49
    ],
    l: [
      "8)"
    ],
    o: 2
  },
  butter: {
    a: "Butter",
    b: "1F9C8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      16
    ],
    o: 12
  },
  roller_coaster: {
    a: "Roller Coaster",
    b: "1F3A2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "carnival",
      "playground",
      "photo",
      "fun"
    ],
    k: [
      8,
      8
    ],
    o: 2
  },
  turkey: {
    a: "Turkey",
    b: "1F983",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "bird"
    ],
    k: [
      42,
      21
    ],
    o: 2
  },
  nazar_amulet: {
    a: "Nazar Amulet",
    b: "1F9FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      50
    ],
    o: 11
  },
  "flag-cu": {
    a: "Cuba Flag",
    b: "1F1E8-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      26
    ],
    o: 2
  },
  aries: {
    a: "Aries",
    b: "2648",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      20
    ],
    o: 2
  },
  "flag-cv": {
    a: "Cape Verde Flag",
    b: "1F1E8-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      27
    ],
    o: 2
  },
  barber: {
    a: "Barber Pole",
    b: "1F488",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hair",
      "salon",
      "style"
    ],
    k: [
      25,
      18
    ],
    o: 2
  },
  taurus: {
    a: "Taurus",
    b: "2649",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "sign",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      21
    ],
    o: 2
  },
  salt: {
    a: "Salt Shaker",
    b: "1F9C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      10
    ],
    o: 11
  },
  woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fb.png",
        sheet_x: 20,
        sheet_y: 10,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fc.png",
        sheet_x: 20,
        sheet_y: 11,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fd.png",
        sheet_x: 20,
        sheet_y: 12,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fe.png",
        sheet_x: 20,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3ff.png",
        sheet_x: 20,
        sheet_y: 14,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman",
    b: "1F469",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "female",
      "girls",
      "lady"
    ],
    k: [
      20,
      9
    ],
    o: 2
  },
  video_game: {
    a: "Video Game",
    b: "1F3AE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "play",
      "console",
      "PS4",
      "controller"
    ],
    k: [
      8,
      20
    ],
    o: 2
  },
  chicken: {
    a: "Chicken",
    b: "1F414",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cluck",
      "nature",
      "bird"
    ],
    k: [
      11,
      48
    ],
    o: 2
  },
  radio: {
    a: "Radio",
    b: "1F4FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "communication",
      "music",
      "podcast",
      "program"
    ],
    k: [
      27,
      24
    ],
    o: 2
  },
  nerd_face: {
    a: "Nerd Face",
    b: "1F913",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "nerdy",
      "geek",
      "dork"
    ],
    k: [
      37,
      26
    ],
    o: 2
  },
  red_haired_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 9,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 10,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 11,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 12,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 13,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Red Haired Woman",
    b: "1F469-200D-1F9B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      8
    ],
    o: 11
  },
  circus_tent: {
    a: "Circus Tent",
    b: "1F3AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "festival",
      "carnival",
      "party"
    ],
    k: [
      8,
      16
    ],
    o: 2
  },
  face_with_monocle: {
    a: "Face with Monocle",
    b: "1F9D0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      45,
      16
    ],
    o: 5
  },
  canned_food: {
    a: "Canned Food",
    b: "1F96B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      1
    ],
    o: 5
  },
  "flag-cw": {
    a: "Curaçao Flag",
    b: "1F1E8-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      28
    ],
    o: 2
  },
  gemini: {
    a: "Gemini",
    b: "264A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      22
    ],
    o: 2
  },
  saxophone: {
    a: "Saxophone",
    b: "1F3B7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "instrument",
      "jazz",
      "blues"
    ],
    k: [
      8,
      29
    ],
    o: 2
  },
  rooster: {
    a: "Rooster",
    b: "1F413",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "chicken"
    ],
    k: [
      11,
      47
    ],
    o: 2
  },
  joystick: {
    a: "Joystick",
    b: "1F579-FE0F",
    c: "1F579",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "play"
    ],
    k: [
      29,
      36
    ],
    o: 2
  },
  guitar: {
    a: "Guitar",
    b: "1F3B8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "instrument"
    ],
    k: [
      8,
      30
    ],
    o: 2
  },
  slot_machine: {
    a: "Slot Machine",
    b: "1F3B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bet",
      "gamble",
      "vegas",
      "fruit machine",
      "luck",
      "casino"
    ],
    k: [
      8,
      22
    ],
    o: 2
  },
  bento: {
    a: "Bento Box",
    b: "1F371",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese",
      "box"
    ],
    k: [
      7,
      16
    ],
    o: 2
  },
  steam_locomotive: {
    a: "Steam Locomotive",
    b: "1F682",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "train"
    ],
    k: [
      34,
      1
    ],
    o: 2
  },
  confused: {
    a: "Confused Face",
    b: "1F615",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "indifference",
      "huh",
      "weird",
      "hmmm",
      ":/"
    ],
    k: [
      30,
      56
    ],
    l: [
      ":\\",
      ":-\\",
      ":/",
      ":-/"
    ],
    o: 2
  },
  "flag-cx": {
    a: "Christmas Island Flag",
    b: "1F1E8-1F1FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      29
    ],
    o: 2
  },
  hatching_chick: {
    a: "Hatching Chick",
    b: "1F423",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "chicken",
      "egg",
      "born",
      "baby",
      "bird"
    ],
    k: [
      12,
      7
    ],
    o: 2
  },
  cancer: {
    a: "Cancer",
    b: "264B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      23
    ],
    o: 2
  },
  red_haired_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 14,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 15,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 16,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 17,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Red Haired Person",
    b: "1F9D1-200D-1F9B0",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      13
    ],
    o: 12
  },
  "flag-cy": {
    a: "Cyprus Flag",
    b: "1F1E8-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      30
    ],
    o: 2
  },
  worried: {
    a: "Worried Face",
    b: "1F61F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "concern",
      "nervous",
      ":("
    ],
    k: [
      31,
      9
    ],
    o: 2
  },
  railway_car: {
    a: "Railway Car",
    b: "1F683",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      2
    ],
    o: 2
  },
  leo: {
    a: "Leo",
    b: "264C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      24
    ],
    o: 2
  },
  curly_haired_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 15,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 16,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 17,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 18,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 19,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Curly Haired Woman",
    b: "1F469-200D-1F9B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      14
    ],
    o: 11
  },
  baby_chick: {
    a: "Baby Chick",
    b: "1F424",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "chicken",
      "bird"
    ],
    k: [
      12,
      8
    ],
    o: 2
  },
  musical_keyboard: {
    a: "Musical Keyboard",
    b: "1F3B9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "piano",
      "instrument",
      "compose"
    ],
    k: [
      8,
      31
    ],
    o: 2
  },
  game_die: {
    a: "Game Die",
    b: "1F3B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dice",
      "random",
      "tabletop",
      "play",
      "luck"
    ],
    k: [
      8,
      24
    ],
    o: 2
  },
  rice_cracker: {
    a: "Rice Cracker",
    b: "1F358",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese"
    ],
    k: [
      6,
      48
    ],
    o: 2
  },
  virgo: {
    a: "Virgo",
    b: "264D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      25
    ],
    o: 2
  },
  "flag-cz": {
    a: "Czechia Flag",
    b: "1F1E8-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      31
    ],
    o: 2
  },
  curly_haired_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Curly Haired Person",
    b: "1F9D1-200D-1F9B1",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      19
    ],
    o: 12
  },
  rice_ball: {
    a: "Rice Ball",
    b: "1F359",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese"
    ],
    k: [
      6,
      49
    ],
    o: 2
  },
  hatched_chick: {
    a: "Front-Facing Baby Chick",
    b: "1F425",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "chicken",
      "baby",
      "bird"
    ],
    k: [
      12,
      9
    ],
    o: 2
  },
  jigsaw: {
    a: "Jigsaw Puzzle Piece",
    b: "1F9E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      28
    ],
    o: 11
  },
  trumpet: {
    a: "Trumpet",
    b: "1F3BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "brass"
    ],
    k: [
      8,
      32
    ],
    o: 2
  },
  slightly_frowning_face: {
    a: "Slightly Frowning Face",
    b: "1F641",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "frowning",
      "disappointed",
      "sad",
      "upset"
    ],
    k: [
      31,
      43
    ],
    o: 2
  },
  bullettrain_side: {
    a: "High-Speed Train",
    b: "1F684",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      3
    ],
    o: 2
  },
  libra: {
    a: "Libra",
    b: "264E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      26
    ],
    o: 2
  },
  de: {
    a: "Germany Flag",
    b: "1F1E9-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "german",
      "nation",
      "flag",
      "country",
      "banner"
    ],
    k: [
      1,
      32
    ],
    n: [
      "flag-de"
    ],
    o: 2
  },
  rice: {
    a: "Cooked Rice",
    b: "1F35A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "china",
      "asian"
    ],
    k: [
      6,
      50
    ],
    o: 2
  },
  violin: {
    a: "Violin",
    b: "1F3BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "instrument",
      "orchestra",
      "symphony"
    ],
    k: [
      8,
      33
    ],
    o: 2
  },
  white_haired_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 27,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 28,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 29,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 30,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 31,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Haired Woman",
    b: "1F469-200D-1F9B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      26
    ],
    o: 11
  },
  bird: {
    a: "Bird",
    b: "1F426",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "fly",
      "tweet",
      "spring"
    ],
    k: [
      12,
      10
    ],
    o: 2
  },
  white_frowning_face: {
    a: "White Frowning Face",
    b: "2639-FE0F",
    c: "2639",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      16
    ],
    o: 2
  },
  bullettrain_front: {
    a: "High-Speed Train with Bullet Nose",
    b: "1F685",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "speed",
      "fast",
      "public",
      "travel"
    ],
    k: [
      34,
      4
    ],
    o: 2
  },
  teddy_bear: {
    a: "Teddy Bear",
    b: "1F9F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      43
    ],
    o: 11
  },
  white_haired_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "White Haired Person",
    b: "1F9D1-200D-1F9B3",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      31
    ],
    o: 12
  },
  spades: {
    a: "Black Spade Suit",
    b: "2660-FE0F",
    c: "2660",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "suits",
      "magic"
    ],
    k: [
      53,
      33
    ],
    o: 2
  },
  banjo: {
    a: "Banjo",
    b: "1FA95",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      9
    ],
    o: 12
  },
  train2: {
    a: "Train",
    b: "1F686",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      5
    ],
    o: 2
  },
  scorpius: {
    a: "Scorpius",
    b: "264F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology",
      "scorpio"
    ],
    k: [
      53,
      27
    ],
    o: 2
  },
  curry: {
    a: "Curry and Rice",
    b: "1F35B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "spicy",
      "hot",
      "indian"
    ],
    k: [
      6,
      51
    ],
    o: 2
  },
  open_mouth: {
    a: "Face with Open Mouth",
    b: "1F62E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "surprise",
      "impressed",
      "wow",
      "whoa",
      ":O"
    ],
    k: [
      31,
      24
    ],
    l: [
      ":o",
      ":-o",
      ":O",
      ":-O"
    ],
    o: 2
  },
  "flag-dg": {
    a: "Diego Garcia Flag",
    b: "1F1E9-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      33
    ],
    o: 2
  },
  penguin: {
    a: "Penguin",
    b: "1F427",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      12,
      11
    ],
    o: 2
  },
  hearts: {
    a: "Black Heart Suit",
    b: "2665-FE0F",
    c: "2665",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    k: [
      53,
      35
    ],
    o: 2
  },
  ramen: {
    a: "Steaming Bowl",
    b: "1F35C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese",
      "noodle",
      "chopsticks"
    ],
    k: [
      6,
      52
    ],
    o: 2
  },
  sagittarius: {
    a: "Sagittarius",
    b: "2650",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      28
    ],
    o: 2
  },
  bald_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 21,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 22,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 23,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 24,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 25,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bald Woman",
    b: "1F469-200D-1F9B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      20
    ],
    o: 11
  },
  dove_of_peace: {
    a: "Dove of Peace",
    b: "1F54A-FE0F",
    c: "1F54A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      28,
      34
    ],
    o: 2
  },
  hushed: {
    a: "Hushed Face",
    b: "1F62F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "woo",
      "shh"
    ],
    k: [
      31,
      25
    ],
    o: 2
  },
  metro: {
    a: "Metro",
    b: "1F687",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "blue-square",
      "mrt",
      "underground",
      "tube"
    ],
    k: [
      34,
      6
    ],
    o: 2
  },
  "flag-dj": {
    a: "Djibouti Flag",
    b: "1F1E9-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      34
    ],
    o: 2
  },
  drum_with_drumsticks: {
    a: "Drum with Drumsticks",
    b: "1F941",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      17
    ],
    o: 4
  },
  spaghetti: {
    a: "Spaghetti",
    b: "1F35D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "italian",
      "noodle"
    ],
    k: [
      6,
      53
    ],
    o: 2
  },
  eagle: {
    a: "Eagle",
    b: "1F985",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "bird"
    ],
    k: [
      42,
      23
    ],
    o: 4
  },
  astonished: {
    a: "Astonished Face",
    b: "1F632",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "xox",
      "surprised",
      "poisoned"
    ],
    k: [
      31,
      28
    ],
    o: 2
  },
  capricorn: {
    a: "Capricorn",
    b: "2651",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      29
    ],
    o: 2
  },
  light_rail: {
    a: "Light Rail",
    b: "1F688",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      7
    ],
    o: 2
  },
  "flag-dk": {
    a: "Denmark Flag",
    b: "1F1E9-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      35
    ],
    o: 2
  },
  iphone: {
    a: "Mobile Phone",
    b: "1F4F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "apple",
      "gadgets",
      "dial"
    ],
    k: [
      27,
      14
    ],
    o: 2
  },
  bald_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Bald Person",
    b: "1F9D1-200D-1F9B2",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      25
    ],
    o: 12
  },
  diamonds: {
    a: "Black Diamond Suit",
    b: "2666-FE0F",
    c: "2666",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    k: [
      53,
      36
    ],
    o: 2
  },
  clubs: {
    a: "Black Club Suit",
    b: "2663-FE0F",
    c: "2663",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    k: [
      53,
      34
    ],
    o: 2
  },
  aquarius: {
    a: "Aquarius",
    b: "2652",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      30
    ],
    o: 2
  },
  sweet_potato: {
    a: "Roasted Sweet Potato",
    b: "1F360",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "nature"
    ],
    k: [
      6,
      56
    ],
    o: 2
  },
  "flag-dm": {
    a: "Dominica Flag",
    b: "1F1E9-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      36
    ],
    o: 2
  },
  duck: {
    a: "Duck",
    b: "1F986",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "bird",
      "mallard"
    ],
    k: [
      42,
      24
    ],
    o: 4
  },
  calling: {
    a: "Mobile Phone with Rightwards Arrow at Left",
    b: "1F4F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "iphone",
      "incoming"
    ],
    k: [
      27,
      15
    ],
    o: 2
  },
  station: {
    a: "Station",
    b: "1F689",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "public"
    ],
    k: [
      34,
      8
    ],
    o: 2
  },
  "blond-haired-woman": {
    skin_variations: {
      "1F3FB": {
        unified: "1F471-1F3FB-200D-2640-FE0F",
        non_qualified: "1F471-1F3FB-200D-2640",
        image: "1f471-1f3fb-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F471-1F3FC-200D-2640-FE0F",
        non_qualified: "1F471-1F3FC-200D-2640",
        image: "1f471-1f3fc-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F471-1F3FD-200D-2640-FE0F",
        non_qualified: "1F471-1F3FD-200D-2640",
        image: "1f471-1f3fd-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F471-1F3FE-200D-2640-FE0F",
        non_qualified: "1F471-1F3FE-200D-2640",
        image: "1f471-1f3fe-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F471-1F3FF-200D-2640-FE0F",
        non_qualified: "1F471-1F3FF-200D-2640",
        image: "1f471-1f3ff-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Blond Haired Woman",
    b: "1F471-200D-2640-FE0F",
    c: "1F471-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      7
    ],
    o: 4
  },
  flushed: {
    a: "Flushed Face",
    b: "1F633",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "blush",
      "shy",
      "flattered"
    ],
    k: [
      31,
      29
    ],
    o: 2
  },
  pisces: {
    a: "Pisces",
    b: "2653",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "sign",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      31
    ],
    o: 2
  },
  chess_pawn: {
    a: "Chess Pawn",
    b: "265F-FE0F",
    c: "265F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      32
    ],
    o: 11
  },
  "blond-haired-man": {
    skin_variations: {
      "1F3FB": {
        unified: "1F471-1F3FB-200D-2642-FE0F",
        non_qualified: "1F471-1F3FB-200D-2642",
        image: "1f471-1f3fb-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F471-1F3FC-200D-2642-FE0F",
        non_qualified: "1F471-1F3FC-200D-2642",
        image: "1f471-1f3fc-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F471-1F3FD-200D-2642-FE0F",
        non_qualified: "1F471-1F3FD-200D-2642",
        image: "1f471-1f3fd-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F471-1F3FE-200D-2642-FE0F",
        non_qualified: "1F471-1F3FE-200D-2642",
        image: "1f471-1f3fe-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F471-1F3FF-200D-2642-FE0F",
        non_qualified: "1F471-1F3FF-200D-2642",
        image: "1f471-1f3ff-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F471",
    a: "Blond Haired Man",
    b: "1F471-200D-2642-FE0F",
    c: "1F471-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      13
    ],
    o: 4
  },
  phone: {
    a: "Black Telephone",
    b: "260E-FE0F",
    c: "260E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "communication",
      "dial",
      "telephone"
    ],
    k: [
      52,
      54
    ],
    n: [
      "telephone"
    ],
    o: 2
  },
  oden: {
    a: "Oden",
    b: "1F362",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese"
    ],
    k: [
      7,
      1
    ],
    o: 2
  },
  "flag-do": {
    a: "Dominican Republic Flag",
    b: "1F1E9-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      37
    ],
    o: 2
  },
  tram: {
    a: "Tram",
    b: "1F68A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      9
    ],
    o: 2
  },
  swan: {
    a: "Swan",
    b: "1F9A2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      52
    ],
    o: 11
  },
  pleading_face: {
    a: "Face with Pleading Eyes",
    b: "1F97A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      12
    ],
    o: 11
  },
  "flag-dz": {
    a: "Algeria Flag",
    b: "1F1E9-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      38
    ],
    o: 2
  },
  monorail: {
    a: "Monorail",
    b: "1F69D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      28
    ],
    o: 2
  },
  owl: {
    a: "Owl",
    b: "1F989",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "bird",
      "hoot"
    ],
    k: [
      42,
      27
    ],
    o: 4
  },
  sushi: {
    a: "Sushi",
    b: "1F363",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "fish",
      "japanese",
      "rice"
    ],
    k: [
      7,
      2
    ],
    o: 2
  },
  telephone_receiver: {
    a: "Telephone Receiver",
    b: "1F4DE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "communication",
      "dial"
    ],
    k: [
      26,
      52
    ],
    o: 2
  },
  black_joker: {
    a: "Playing Card Black Joker",
    b: "1F0CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "game",
      "play",
      "magic"
    ],
    k: [
      0,
      15
    ],
    o: 2
  },
  ophiuchus: {
    a: "Ophiuchus",
    b: "26CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "constellation",
      "astrology"
    ],
    k: [
      54,
      4
    ],
    o: 2
  },
  frowning: {
    a: "Frowning Face with Open Mouth",
    b: "1F626",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "aw",
      "what"
    ],
    k: [
      31,
      16
    ],
    o: 2
  },
  older_adult: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D3-1F3FB",
        non_qualified: null,
        image: "1f9d3-1f3fb.png",
        sheet_x: 48,
        sheet_y: 23,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D3-1F3FC",
        non_qualified: null,
        image: "1f9d3-1f3fc.png",
        sheet_x: 48,
        sheet_y: 24,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D3-1F3FD",
        non_qualified: null,
        image: "1f9d3-1f3fd.png",
        sheet_x: 48,
        sheet_y: 25,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D3-1F3FE",
        non_qualified: null,
        image: "1f9d3-1f3fe.png",
        sheet_x: 48,
        sheet_y: 26,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D3-1F3FF",
        non_qualified: null,
        image: "1f9d3-1f3ff.png",
        sheet_x: 48,
        sheet_y: 27,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Older Adult",
    b: "1F9D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      22
    ],
    o: 5
  },
  "flag-ea": {
    a: "Ceuta & Melilla Flag",
    b: "1F1EA-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      39
    ],
    o: 2
  },
  flamingo: {
    a: "Flamingo",
    b: "1F9A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      0
    ],
    o: 12
  },
  pager: {
    a: "Pager",
    b: "1F4DF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bbcall",
      "oldschool",
      "90s"
    ],
    k: [
      26,
      53
    ],
    o: 2
  },
  mountain_railway: {
    a: "Mountain Railway",
    b: "1F69E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      29
    ],
    o: 2
  },
  mahjong: {
    a: "Mahjong Tile Red Dragon",
    b: "1F004",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "play",
      "chinese",
      "kanji"
    ],
    k: [
      0,
      14
    ],
    o: 2
  },
  older_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F474-1F3FB",
        non_qualified: null,
        image: "1f474-1f3fb.png",
        sheet_x: 22,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F474-1F3FC",
        non_qualified: null,
        image: "1f474-1f3fc.png",
        sheet_x: 22,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F474-1F3FD",
        non_qualified: null,
        image: "1f474-1f3fd.png",
        sheet_x: 22,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F474-1F3FE",
        non_qualified: null,
        image: "1f474-1f3fe.png",
        sheet_x: 22,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F474-1F3FF",
        non_qualified: null,
        image: "1f474-1f3ff.png",
        sheet_x: 22,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Older Man",
    b: "1F474",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "human",
      "male",
      "men",
      "old",
      "elder",
      "senior"
    ],
    k: [
      22,
      49
    ],
    o: 2
  },
  twisted_rightwards_arrows: {
    a: "Twisted Rightwards Arrows",
    b: "1F500",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "shuffle",
      "music",
      "random"
    ],
    k: [
      27,
      28
    ],
    o: 2
  },
  fried_shrimp: {
    a: "Fried Shrimp",
    b: "1F364",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "animal",
      "appetizer",
      "summer"
    ],
    k: [
      7,
      3
    ],
    o: 2
  },
  anguished: {
    a: "Anguished Face",
    b: "1F627",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "stunned",
      "nervous"
    ],
    k: [
      31,
      17
    ],
    l: [
      "D:"
    ],
    o: 2
  },
  repeat: {
    a: "Clockwise Rightwards and Leftwards Open Circle Arrows",
    b: "1F501",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "loop",
      "record"
    ],
    k: [
      27,
      29
    ],
    o: 2
  },
  fish_cake: {
    a: "Fish Cake with Swirl Design",
    b: "1F365",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japan",
      "sea",
      "beach",
      "narutomaki",
      "pink",
      "swirl",
      "kamaboko",
      "surimi",
      "ramen"
    ],
    k: [
      7,
      4
    ],
    o: 2
  },
  fax: {
    a: "Fax Machine",
    b: "1F4E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "communication",
      "technology"
    ],
    k: [
      26,
      54
    ],
    o: 2
  },
  older_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F475-1F3FB",
        non_qualified: null,
        image: "1f475-1f3fb.png",
        sheet_x: 22,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F475-1F3FC",
        non_qualified: null,
        image: "1f475-1f3fc.png",
        sheet_x: 23,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F475-1F3FD",
        non_qualified: null,
        image: "1f475-1f3fd.png",
        sheet_x: 23,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F475-1F3FE",
        non_qualified: null,
        image: "1f475-1f3fe.png",
        sheet_x: 23,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F475-1F3FF",
        non_qualified: null,
        image: "1f475-1f3ff.png",
        sheet_x: 23,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Older Woman",
    b: "1F475",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "human",
      "female",
      "women",
      "lady",
      "old",
      "elder",
      "senior"
    ],
    k: [
      22,
      55
    ],
    o: 2
  },
  "flag-ec": {
    a: "Ecuador Flag",
    b: "1F1EA-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      40
    ],
    o: 2
  },
  peacock: {
    a: "Peacock",
    b: "1F99A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      44
    ],
    o: 11
  },
  fearful: {
    a: "Fearful Face",
    b: "1F628",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "scared",
      "terrified",
      "nervous",
      "oops",
      "huh"
    ],
    k: [
      31,
      18
    ],
    o: 2
  },
  train: {
    a: "Tram Car",
    b: "1F68B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "carriage",
      "public",
      "travel"
    ],
    k: [
      34,
      10
    ],
    o: 2
  },
  flower_playing_cards: {
    a: "Flower Playing Cards",
    b: "1F3B4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "sunset",
      "red"
    ],
    k: [
      8,
      26
    ],
    o: 2
  },
  repeat_one: {
    a: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay",
    b: "1F502",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "loop"
    ],
    k: [
      27,
      30
    ],
    o: 2
  },
  moon_cake: {
    a: "Moon Cake",
    b: "1F96E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      4
    ],
    o: 11
  },
  performing_arts: {
    a: "Performing Arts",
    b: "1F3AD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "acting",
      "theater",
      "drama"
    ],
    k: [
      8,
      19
    ],
    o: 2
  },
  cold_sweat: {
    a: "Face with Open Mouth and Cold Sweat",
    b: "1F630",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "nervous",
      "sweat"
    ],
    k: [
      31,
      26
    ],
    o: 2
  },
  person_frowning: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64D-1F3FB",
        non_qualified: null,
        image: "1f64d-1f3fb.png",
        sheet_x: 33,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F64D-1F3FC",
        non_qualified: null,
        image: "1f64d-1f3fc.png",
        sheet_x: 33,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F64D-1F3FD",
        non_qualified: null,
        image: "1f64d-1f3fd.png",
        sheet_x: 33,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F64D-1F3FE",
        non_qualified: null,
        image: "1f64d-1f3fe.png",
        sheet_x: 33,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F64D-1F3FF",
        non_qualified: null,
        image: "1f64d-1f3ff.png",
        sheet_x: 33,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F64D-200D-2640-FE0F",
    a: "Person Frowning",
    b: "1F64D",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      33,
      26
    ],
    o: 2
  },
  "flag-ee": {
    a: "Estonia Flag",
    b: "1F1EA-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      41
    ],
    o: 2
  },
  battery: {
    a: "Battery",
    b: "1F50B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "power",
      "energy",
      "sustain"
    ],
    k: [
      27,
      39
    ],
    o: 2
  },
  parrot: {
    a: "Parrot",
    b: "1F99C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      46
    ],
    o: 11
  },
  bus: {
    a: "Bus",
    b: "1F68C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "car",
      "vehicle",
      "transportation"
    ],
    k: [
      34,
      11
    ],
    o: 2
  },
  "flag-eg": {
    a: "Egypt Flag",
    b: "1F1EA-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      42
    ],
    o: 2
  },
  arrow_forward: {
    a: "Black Right-Pointing Triangle",
    b: "25B6-FE0F",
    c: "25B6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "right",
      "direction",
      "play"
    ],
    k: [
      52,
      43
    ],
    o: 2
  },
  "man-frowning": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64D-1F3FB-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FB-200D-2642",
        image: "1f64d-1f3fb-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64D-1F3FC-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FC-200D-2642",
        image: "1f64d-1f3fc-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64D-1F3FD-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FD-200D-2642",
        image: "1f64d-1f3fd-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64D-1F3FE-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FE-200D-2642",
        image: "1f64d-1f3fe-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64D-1F3FF-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FF-200D-2642",
        image: "1f64d-1f3ff-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Frowning",
    b: "1F64D-200D-2642-FE0F",
    c: "1F64D-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      33,
      20
    ],
    o: 4
  },
  disappointed_relieved: {
    a: "Disappointed but Relieved Face",
    b: "1F625",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "phew",
      "sweat",
      "nervous"
    ],
    k: [
      31,
      15
    ],
    o: 2
  },
  electric_plug: {
    a: "Electric Plug",
    b: "1F50C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "charger",
      "power"
    ],
    k: [
      27,
      40
    ],
    o: 2
  },
  frame_with_picture: {
    a: "Frame with Picture",
    b: "1F5BC-FE0F",
    c: "1F5BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      14
    ],
    o: 2
  },
  oncoming_bus: {
    a: "Oncoming Bus",
    b: "1F68D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "transportation"
    ],
    k: [
      34,
      12
    ],
    o: 2
  },
  dango: {
    a: "Dango",
    b: "1F361",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "dessert",
      "sweet",
      "japanese",
      "barbecue",
      "meat"
    ],
    k: [
      7,
      0
    ],
    o: 2
  },
  frog: {
    a: "Frog Face",
    b: "1F438",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "croak",
      "toad"
    ],
    k: [
      12,
      28
    ],
    o: 2
  },
  computer: {
    a: "Personal Computer",
    b: "1F4BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "laptop",
      "screen",
      "display",
      "monitor"
    ],
    k: [
      26,
      17
    ],
    o: 2
  },
  art: {
    a: "Artist Palette",
    b: "1F3A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "design",
      "paint",
      "draw",
      "colors"
    ],
    k: [
      8,
      14
    ],
    o: 2
  },
  "flag-eh": {
    a: "Western Sahara Flag",
    b: "1F1EA-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      43
    ],
    o: 2
  },
  fast_forward: {
    a: "Black Right-Pointing Double Triangle",
    b: "23E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "play",
      "speed",
      "continue"
    ],
    k: [
      52,
      26
    ],
    o: 2
  },
  cry: {
    a: "Crying Face",
    b: "1F622",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "tears",
      "sad",
      "depressed",
      "upset",
      ":'("
    ],
    k: [
      31,
      12
    ],
    l: [
      ":'("
    ],
    m: ":'(",
    o: 2
  },
  "woman-frowning": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64D-1F3FB-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FB-200D-2640",
        image: "1f64d-1f3fb-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64D-1F3FC-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FC-200D-2640",
        image: "1f64d-1f3fc-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64D-1F3FD-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FD-200D-2640",
        image: "1f64d-1f3fd-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64D-1F3FE-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FE-200D-2640",
        image: "1f64d-1f3fe-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64D-1F3FF-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FF-200D-2640",
        image: "1f64d-1f3ff-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F64D",
    a: "Woman Frowning",
    b: "1F64D-200D-2640-FE0F",
    c: "1F64D-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      33,
      14
    ],
    o: 4
  },
  trolleybus: {
    a: "Trolleybus",
    b: "1F68E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bart",
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      13
    ],
    o: 2
  },
  crocodile: {
    a: "Crocodile",
    b: "1F40A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "reptile",
      "lizard",
      "alligator"
    ],
    k: [
      11,
      38
    ],
    o: 2
  },
  dumpling: {
    a: "Dumpling",
    b: "1F95F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      46
    ],
    o: 5
  },
  black_right_pointing_double_triangle_with_vertical_bar: {
    a: "Black Right Pointing Double Triangle with Vertical Bar",
    b: "23ED-FE0F",
    c: "23ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      30
    ],
    o: 2
  },
  desktop_computer: {
    a: "Desktop Computer",
    b: "1F5A5-FE0F",
    c: "1F5A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "computing",
      "screen"
    ],
    k: [
      30,
      10
    ],
    o: 2
  },
  person_with_pouting_face: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64E-1F3FB",
        non_qualified: null,
        image: "1f64e-1f3fb.png",
        sheet_x: 33,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F64E-1F3FC",
        non_qualified: null,
        image: "1f64e-1f3fc.png",
        sheet_x: 33,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F64E-1F3FD",
        non_qualified: null,
        image: "1f64e-1f3fd.png",
        sheet_x: 33,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F64E-1F3FE",
        non_qualified: null,
        image: "1f64e-1f3fe.png",
        sheet_x: 33,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F64E-1F3FF",
        non_qualified: null,
        image: "1f64e-1f3ff.png",
        sheet_x: 33,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F64E-200D-2640-FE0F",
    a: "Person with Pouting Face",
    b: "1F64E",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      33,
      44
    ],
    o: 2
  },
  turtle: {
    a: "Turtle",
    b: "1F422",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "slow",
      "nature",
      "tortoise"
    ],
    k: [
      12,
      6
    ],
    o: 2
  },
  sob: {
    a: "Loudly Crying Face",
    b: "1F62D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "cry",
      "tears",
      "sad",
      "upset",
      "depressed"
    ],
    k: [
      31,
      23
    ],
    m: ":'(",
    o: 2
  },
  "flag-er": {
    a: "Eritrea Flag",
    b: "1F1EA-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      44
    ],
    o: 2
  },
  thread: {
    a: "Spool of Thread",
    b: "1F9F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      40
    ],
    o: 11
  },
  minibus: {
    a: "Minibus",
    b: "1F690",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "car",
      "transportation"
    ],
    k: [
      34,
      15
    ],
    o: 2
  },
  fortune_cookie: {
    a: "Fortune Cookie",
    b: "1F960",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      47
    ],
    o: 5
  },
  yarn: {
    a: "Ball of Yarn",
    b: "1F9F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      41
    ],
    o: 11
  },
  takeout_box: {
    a: "Takeout Box",
    b: "1F961",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      48
    ],
    o: 5
  },
  "man-pouting": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64E-1F3FB-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FB-200D-2642",
        image: "1f64e-1f3fb-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64E-1F3FC-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FC-200D-2642",
        image: "1f64e-1f3fc-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64E-1F3FD-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FD-200D-2642",
        image: "1f64e-1f3fd-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64E-1F3FE-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FE-200D-2642",
        image: "1f64e-1f3fe-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64E-1F3FF-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FF-200D-2642",
        image: "1f64e-1f3ff-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Pouting",
    b: "1F64E-200D-2642-FE0F",
    c: "1F64E-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      33,
      38
    ],
    o: 4
  },
  printer: {
    a: "Printer",
    b: "1F5A8-FE0F",
    c: "1F5A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "paper",
      "ink"
    ],
    k: [
      30,
      11
    ],
    o: 2
  },
  scream: {
    a: "Face Screaming in Fear",
    b: "1F631",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "munch",
      "scared",
      "omg"
    ],
    k: [
      31,
      27
    ],
    o: 2
  },
  es: {
    a: "Spain Flag",
    b: "1F1EA-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "spain",
      "flag",
      "nation",
      "country",
      "banner"
    ],
    k: [
      1,
      45
    ],
    n: [
      "flag-es"
    ],
    o: 2
  },
  ambulance: {
    a: "Ambulance",
    b: "1F691",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "health",
      "911",
      "hospital"
    ],
    k: [
      34,
      16
    ],
    o: 2
  },
  black_right_pointing_triangle_with_double_vertical_bar: {
    a: "Black Right Pointing Triangle with Double Vertical Bar",
    b: "23EF-FE0F",
    c: "23EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      32
    ],
    o: 2
  },
  lizard: {
    a: "Lizard",
    b: "1F98E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "reptile"
    ],
    k: [
      42,
      32
    ],
    o: 4
  },
  "flag-et": {
    a: "Ethiopia Flag",
    b: "1F1EA-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      46
    ],
    o: 2
  },
  keyboard: {
    a: "Keyboard",
    b: "2328-FE0F",
    c: "2328",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "computer",
      "type",
      "input",
      "text"
    ],
    k: [
      52,
      24
    ],
    o: 2
  },
  crab: {
    a: "Crab",
    b: "1F980",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "crustacean"
    ],
    k: [
      42,
      18
    ],
    o: 2
  },
  confounded: {
    a: "Confounded Face",
    b: "1F616",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "confused",
      "sick",
      "unwell",
      "oops",
      ":S"
    ],
    k: [
      31,
      0
    ],
    o: 2
  },
  snake: {
    a: "Snake",
    b: "1F40D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "evil",
      "nature",
      "hiss",
      "python"
    ],
    k: [
      11,
      41
    ],
    o: 2
  },
  "woman-pouting": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64E-1F3FB-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FB-200D-2640",
        image: "1f64e-1f3fb-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64E-1F3FC-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FC-200D-2640",
        image: "1f64e-1f3fc-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64E-1F3FD-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FD-200D-2640",
        image: "1f64e-1f3fd-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64E-1F3FE-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FE-200D-2640",
        image: "1f64e-1f3fe-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64E-1F3FF-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FF-200D-2640",
        image: "1f64e-1f3ff-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F64E",
    a: "Woman Pouting",
    b: "1F64E-200D-2640-FE0F",
    c: "1F64E-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      33,
      32
    ],
    o: 4
  },
  arrow_backward: {
    a: "Black Left-Pointing Triangle",
    b: "25C0-FE0F",
    c: "25C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "left",
      "direction"
    ],
    k: [
      52,
      44
    ],
    o: 2
  },
  fire_engine: {
    a: "Fire Engine",
    b: "1F692",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "cars",
      "vehicle"
    ],
    k: [
      34,
      17
    ],
    o: 2
  },
  rewind: {
    a: "Black Left-Pointing Double Triangle",
    b: "23EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "play",
      "blue-square"
    ],
    k: [
      52,
      27
    ],
    o: 2
  },
  three_button_mouse: {
    a: "Three Button Mouse",
    b: "1F5B1-FE0F",
    c: "1F5B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      12
    ],
    o: 2
  },
  no_good: {
    skin_variations: {
      "1F3FB": {
        unified: "1F645-1F3FB",
        non_qualified: null,
        image: "1f645-1f3fb.png",
        sheet_x: 32,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F645-1F3FC",
        non_qualified: null,
        image: "1f645-1f3fc.png",
        sheet_x: 32,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F645-1F3FD",
        non_qualified: null,
        image: "1f645-1f3fd.png",
        sheet_x: 32,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F645-1F3FE",
        non_qualified: null,
        image: "1f645-1f3fe.png",
        sheet_x: 32,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F645-1F3FF",
        non_qualified: null,
        image: "1f645-1f3ff.png",
        sheet_x: 32,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F645-200D-2640-FE0F",
    a: "Face with No Good Gesture",
    b: "1F645",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      32,
      2
    ],
    o: 2
  },
  police_car: {
    a: "Police Car",
    b: "1F693",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "cars",
      "transportation",
      "law",
      "legal",
      "enforcement"
    ],
    k: [
      34,
      18
    ],
    o: 2
  },
  dragon_face: {
    a: "Dragon Face",
    b: "1F432",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    k: [
      12,
      22
    ],
    o: 2
  },
  persevere: {
    a: "Persevering Face",
    b: "1F623",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sick",
      "no",
      "upset",
      "oops"
    ],
    k: [
      31,
      13
    ],
    o: 2
  },
  lobster: {
    a: "Lobster",
    b: "1F99E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      48
    ],
    o: 11
  },
  "flag-eu": {
    a: "European Union Flag",
    b: "1F1EA-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      47
    ],
    o: 2
  },
  disappointed: {
    a: "Disappointed Face",
    b: "1F61E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sad",
      "upset",
      "depressed",
      ":("
    ],
    k: [
      31,
      8
    ],
    l: [
      "):",
      ":(",
      ":-("
    ],
    m: ":(",
    o: 2
  },
  shrimp: {
    a: "Shrimp",
    b: "1F990",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "ocean",
      "nature",
      "seafood"
    ],
    k: [
      42,
      34
    ],
    o: 4
  },
  dragon: {
    a: "Dragon",
    b: "1F409",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    k: [
      11,
      37
    ],
    o: 2
  },
  "man-gesturing-no": {
    skin_variations: {
      "1F3FB": {
        unified: "1F645-1F3FB-200D-2642-FE0F",
        non_qualified: "1F645-1F3FB-200D-2642",
        image: "1f645-1f3fb-200d-2642-fe0f.png",
        sheet_x: 31,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F645-1F3FC-200D-2642-FE0F",
        non_qualified: "1F645-1F3FC-200D-2642",
        image: "1f645-1f3fc-200d-2642-fe0f.png",
        sheet_x: 31,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F645-1F3FD-200D-2642-FE0F",
        non_qualified: "1F645-1F3FD-200D-2642",
        image: "1f645-1f3fd-200d-2642-fe0f.png",
        sheet_x: 31,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F645-1F3FE-200D-2642-FE0F",
        non_qualified: "1F645-1F3FE-200D-2642",
        image: "1f645-1f3fe-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F645-1F3FF-200D-2642-FE0F",
        non_qualified: "1F645-1F3FF-200D-2642",
        image: "1f645-1f3ff-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Gesturing No",
    b: "1F645-200D-2642-FE0F",
    c: "1F645-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      31,
      53
    ],
    o: 4
  },
  "flag-fi": {
    a: "Finland Flag",
    b: "1F1EB-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      48
    ],
    o: 2
  },
  trackball: {
    a: "Trackball",
    b: "1F5B2-FE0F",
    c: "1F5B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "trackpad"
    ],
    k: [
      30,
      13
    ],
    o: 2
  },
  black_left_pointing_double_triangle_with_vertical_bar: {
    a: "Black Left Pointing Double Triangle with Vertical Bar",
    b: "23EE-FE0F",
    c: "23EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      31
    ],
    o: 2
  },
  oncoming_police_car: {
    a: "Oncoming Police Car",
    b: "1F694",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "law",
      "legal",
      "enforcement",
      "911"
    ],
    k: [
      34,
      19
    ],
    o: 2
  },
  minidisc: {
    a: "Minidisc",
    b: "1F4BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "record",
      "data",
      "disk",
      "90s"
    ],
    k: [
      26,
      19
    ],
    o: 2
  },
  sweat: {
    a: "Face with Cold Sweat",
    b: "1F613",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "hot",
      "sad",
      "tired",
      "exercise"
    ],
    k: [
      30,
      54
    ],
    o: 2
  },
  squid: {
    a: "Squid",
    b: "1F991",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "ocean",
      "sea"
    ],
    k: [
      42,
      35
    ],
    o: 4
  },
  sauropod: {
    a: "Sauropod",
    b: "1F995",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      39
    ],
    o: 5
  },
  arrow_up_small: {
    a: "Up-Pointing Small Red Triangle",
    b: "1F53C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "triangle",
      "direction",
      "point",
      "forward",
      "top"
    ],
    k: [
      28,
      31
    ],
    o: 2
  },
  "flag-fj": {
    a: "Fiji Flag",
    b: "1F1EB-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      49
    ],
    o: 2
  },
  "woman-gesturing-no": {
    skin_variations: {
      "1F3FB": {
        unified: "1F645-1F3FB-200D-2640-FE0F",
        non_qualified: "1F645-1F3FB-200D-2640",
        image: "1f645-1f3fb-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F645-1F3FC-200D-2640-FE0F",
        non_qualified: "1F645-1F3FC-200D-2640",
        image: "1f645-1f3fc-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F645-1F3FD-200D-2640-FE0F",
        non_qualified: "1F645-1F3FD-200D-2640",
        image: "1f645-1f3fd-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F645-1F3FE-200D-2640-FE0F",
        non_qualified: "1F645-1F3FE-200D-2640",
        image: "1f645-1f3fe-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F645-1F3FF-200D-2640-FE0F",
        non_qualified: "1F645-1F3FF-200D-2640",
        image: "1f645-1f3ff-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F645",
    a: "Woman Gesturing No",
    b: "1F645-200D-2640-FE0F",
    c: "1F645-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      31,
      47
    ],
    o: 4
  },
  taxi: {
    a: "Taxi",
    b: "1F695",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "uber",
      "vehicle",
      "cars",
      "transportation"
    ],
    k: [
      34,
      20
    ],
    o: 2
  },
  "flag-fk": {
    a: "Falkland Islands Flag",
    b: "1F1EB-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      50
    ],
    o: 2
  },
  floppy_disk: {
    a: "Floppy Disk",
    b: "1F4BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "oldschool",
      "technology",
      "save",
      "90s",
      "80s"
    ],
    k: [
      26,
      20
    ],
    o: 2
  },
  "t-rex": {
    a: "T-Rex",
    b: "1F996",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      40
    ],
    o: 5
  },
  oyster: {
    a: "Oyster",
    b: "1F9AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      1
    ],
    o: 12
  },
  arrow_double_up: {
    a: "Black Up-Pointing Double Triangle",
    b: "23EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "top"
    ],
    k: [
      52,
      28
    ],
    o: 2
  },
  oncoming_taxi: {
    a: "Oncoming Taxi",
    b: "1F696",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "cars",
      "uber"
    ],
    k: [
      34,
      21
    ],
    o: 2
  },
  ok_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F646-1F3FB",
        non_qualified: null,
        image: "1f646-1f3fb.png",
        sheet_x: 32,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F646-1F3FC",
        non_qualified: null,
        image: "1f646-1f3fc.png",
        sheet_x: 32,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F646-1F3FD",
        non_qualified: null,
        image: "1f646-1f3fd.png",
        sheet_x: 32,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F646-1F3FE",
        non_qualified: null,
        image: "1f646-1f3fe.png",
        sheet_x: 32,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F646-1F3FF",
        non_qualified: null,
        image: "1f646-1f3ff.png",
        sheet_x: 32,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F646-200D-2640-FE0F",
    a: "Face with Ok Gesture",
    b: "1F646",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "women",
      "girl",
      "female",
      "pink",
      "human",
      "woman"
    ],
    k: [
      32,
      20
    ],
    o: 2
  },
  weary: {
    a: "Weary Face",
    b: "1F629",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "tired",
      "sleepy",
      "sad",
      "frustrated",
      "upset"
    ],
    k: [
      31,
      19
    ],
    o: 2
  },
  "man-gesturing-ok": {
    skin_variations: {
      "1F3FB": {
        unified: "1F646-1F3FB-200D-2642-FE0F",
        non_qualified: "1F646-1F3FB-200D-2642",
        image: "1f646-1f3fb-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F646-1F3FC-200D-2642-FE0F",
        non_qualified: "1F646-1F3FC-200D-2642",
        image: "1f646-1f3fc-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F646-1F3FD-200D-2642-FE0F",
        non_qualified: "1F646-1F3FD-200D-2642",
        image: "1f646-1f3fd-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F646-1F3FE-200D-2642-FE0F",
        non_qualified: "1F646-1F3FE-200D-2642",
        image: "1f646-1f3fe-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F646-1F3FF-200D-2642-FE0F",
        non_qualified: "1F646-1F3FF-200D-2642",
        image: "1f646-1f3ff-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Gesturing Ok",
    b: "1F646-200D-2642-FE0F",
    c: "1F646-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      14
    ],
    o: 4
  },
  arrow_down_small: {
    a: "Down-Pointing Small Red Triangle",
    b: "1F53D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "bottom"
    ],
    k: [
      28,
      32
    ],
    o: 2
  },
  tired_face: {
    a: "Tired Face",
    b: "1F62B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sick",
      "whine",
      "upset",
      "frustrated"
    ],
    k: [
      31,
      21
    ],
    o: 2
  },
  car: {
    a: "Automobile",
    b: "1F697",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      34,
      22
    ],
    n: [
      "red_car"
    ],
    o: 2
  },
  icecream: {
    a: "Soft Ice Cream",
    b: "1F366",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "hot",
      "dessert",
      "summer"
    ],
    k: [
      7,
      5
    ],
    o: 2
  },
  cd: {
    a: "Optical Disc",
    b: "1F4BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "dvd",
      "disk",
      "disc",
      "90s"
    ],
    k: [
      26,
      21
    ],
    o: 2
  },
  whale: {
    a: "Spouting Whale",
    b: "1F433",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    k: [
      12,
      23
    ],
    o: 2
  },
  "flag-fm": {
    a: "Micronesia Flag",
    b: "1F1EB-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      51
    ],
    o: 2
  },
  oncoming_automobile: {
    a: "Oncoming Automobile",
    b: "1F698",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "car",
      "vehicle",
      "transportation"
    ],
    k: [
      34,
      23
    ],
    o: 2
  },
  arrow_double_down: {
    a: "Black Down-Pointing Double Triangle",
    b: "23EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "bottom"
    ],
    k: [
      52,
      29
    ],
    o: 2
  },
  "woman-gesturing-ok": {
    skin_variations: {
      "1F3FB": {
        unified: "1F646-1F3FB-200D-2640-FE0F",
        non_qualified: "1F646-1F3FB-200D-2640",
        image: "1f646-1f3fb-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F646-1F3FC-200D-2640-FE0F",
        non_qualified: "1F646-1F3FC-200D-2640",
        image: "1f646-1f3fc-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F646-1F3FD-200D-2640-FE0F",
        non_qualified: "1F646-1F3FD-200D-2640",
        image: "1f646-1f3fd-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F646-1F3FE-200D-2640-FE0F",
        non_qualified: "1F646-1F3FE-200D-2640",
        image: "1f646-1f3fe-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F646-1F3FF-200D-2640-FE0F",
        non_qualified: "1F646-1F3FF-200D-2640",
        image: "1f646-1f3ff-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F646",
    a: "Woman Gesturing Ok",
    b: "1F646-200D-2640-FE0F",
    c: "1F646-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      8
    ],
    o: 4
  },
  yawning_face: {
    a: "Yawning Face",
    b: "1F971",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      7
    ],
    o: 12
  },
  dvd: {
    a: "Dvd",
    b: "1F4C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cd",
      "disk",
      "disc"
    ],
    k: [
      26,
      22
    ],
    o: 2
  },
  whale2: {
    a: "Whale",
    b: "1F40B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    k: [
      11,
      39
    ],
    o: 2
  },
  "flag-fo": {
    a: "Faroe Islands Flag",
    b: "1F1EB-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      52
    ],
    o: 2
  },
  shaved_ice: {
    a: "Shaved Ice",
    b: "1F367",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hot",
      "dessert",
      "summer"
    ],
    k: [
      7,
      6
    ],
    o: 2
  },
  double_vertical_bar: {
    a: "Double Vertical Bar",
    b: "23F8-FE0F",
    c: "23F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      37
    ],
    o: 2
  },
  information_desk_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F481-1F3FB",
        non_qualified: null,
        image: "1f481-1f3fb.png",
        sheet_x: 24,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F481-1F3FC",
        non_qualified: null,
        image: "1f481-1f3fc.png",
        sheet_x: 24,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F481-1F3FD",
        non_qualified: null,
        image: "1f481-1f3fd.png",
        sheet_x: 24,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F481-1F3FE",
        non_qualified: null,
        image: "1f481-1f3fe.png",
        sheet_x: 24,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F481-1F3FF",
        non_qualified: null,
        image: "1f481-1f3ff.png",
        sheet_x: 24,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F481-200D-2640-FE0F",
    a: "Information Desk Person",
    b: "1F481",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      24,
      2
    ],
    o: 2
  },
  dolphin: {
    a: "Dolphin",
    b: "1F42C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "flipper",
      "fins",
      "beach"
    ],
    k: [
      12,
      16
    ],
    n: [
      "flipper"
    ],
    o: 2
  },
  blue_car: {
    a: "Recreational Vehicle",
    b: "1F699",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      24
    ],
    o: 2
  },
  ice_cream: {
    a: "Ice Cream",
    b: "1F368",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "hot",
      "dessert"
    ],
    k: [
      7,
      7
    ],
    o: 2
  },
  fr: {
    a: "France Flag",
    b: "1F1EB-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "banner",
      "flag",
      "nation",
      "france",
      "french",
      "country"
    ],
    k: [
      1,
      53
    ],
    n: [
      "flag-fr"
    ],
    o: 2
  },
  triumph: {
    a: "Face with Look of Triumph",
    b: "1F624",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "gas",
      "phew",
      "proud",
      "pride"
    ],
    k: [
      31,
      14
    ],
    o: 2
  },
  abacus: {
    a: "Abacus",
    b: "1F9EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      33
    ],
    o: 11
  },
  "man-tipping-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F481-1F3FB-200D-2642-FE0F",
        non_qualified: "1F481-1F3FB-200D-2642",
        image: "1f481-1f3fb-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F481-1F3FC-200D-2642-FE0F",
        non_qualified: "1F481-1F3FC-200D-2642",
        image: "1f481-1f3fc-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F481-1F3FD-200D-2642-FE0F",
        non_qualified: "1F481-1F3FD-200D-2642",
        image: "1f481-1f3fd-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F481-1F3FE-200D-2642-FE0F",
        non_qualified: "1F481-1F3FE-200D-2642",
        image: "1f481-1f3fe-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F481-1F3FF-200D-2642-FE0F",
        non_qualified: "1F481-1F3FF-200D-2642",
        image: "1f481-1f3ff-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Tipping Hand",
    b: "1F481-200D-2642-FE0F",
    c: "1F481-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      23,
      53
    ],
    o: 4
  },
  doughnut: {
    a: "Doughnut",
    b: "1F369",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "dessert",
      "snack",
      "sweet",
      "donut"
    ],
    k: [
      7,
      8
    ],
    o: 2
  },
  fish: {
    a: "Fish",
    b: "1F41F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "food",
      "nature"
    ],
    k: [
      12,
      3
    ],
    o: 2
  },
  truck: {
    a: "Delivery Truck",
    b: "1F69A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cars",
      "transportation"
    ],
    k: [
      34,
      25
    ],
    o: 2
  },
  movie_camera: {
    a: "Movie Camera",
    b: "1F3A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "film",
      "record"
    ],
    k: [
      8,
      11
    ],
    o: 2
  },
  "flag-ga": {
    a: "Gabon Flag",
    b: "1F1EC-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      54
    ],
    o: 2
  },
  rage: {
    a: "Pouting Face",
    b: "1F621",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "angry",
      "mad",
      "hate",
      "despise"
    ],
    k: [
      31,
      11
    ],
    o: 2
  },
  black_square_for_stop: {
    a: "Black Square for Stop",
    b: "23F9-FE0F",
    c: "23F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      38
    ],
    o: 2
  },
  articulated_lorry: {
    a: "Articulated Lorry",
    b: "1F69B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "cars",
      "transportation",
      "express"
    ],
    k: [
      34,
      26
    ],
    o: 2
  },
  angry: {
    a: "Angry Face",
    b: "1F620",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mad",
      "face",
      "annoyed",
      "frustrated"
    ],
    k: [
      31,
      10
    ],
    l: [
      ">:(",
      ">:-("
    ],
    o: 2
  },
  cookie: {
    a: "Cookie",
    b: "1F36A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "snack",
      "oreo",
      "chocolate",
      "sweet",
      "dessert"
    ],
    k: [
      7,
      9
    ],
    o: 2
  },
  gb: {
    a: "United Kingdom Flag",
    b: "1F1EC-1F1E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      55
    ],
    n: [
      "uk",
      "flag-gb"
    ],
    o: 2
  },
  tropical_fish: {
    a: "Tropical Fish",
    b: "1F420",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "swim",
      "ocean",
      "beach",
      "nemo"
    ],
    k: [
      12,
      4
    ],
    o: 2
  },
  "woman-tipping-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F481-1F3FB-200D-2640-FE0F",
        non_qualified: "1F481-1F3FB-200D-2640",
        image: "1f481-1f3fb-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F481-1F3FC-200D-2640-FE0F",
        non_qualified: "1F481-1F3FC-200D-2640",
        image: "1f481-1f3fc-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F481-1F3FD-200D-2640-FE0F",
        non_qualified: "1F481-1F3FD-200D-2640",
        image: "1f481-1f3fd-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F481-1F3FE-200D-2640-FE0F",
        non_qualified: "1F481-1F3FE-200D-2640",
        image: "1f481-1f3fe-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F481-1F3FF-200D-2640-FE0F",
        non_qualified: "1F481-1F3FF-200D-2640",
        image: "1f481-1f3ff-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F481",
    a: "Woman Tipping Hand",
    b: "1F481-200D-2640-FE0F",
    c: "1F481-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      23,
      47
    ],
    o: 4
  },
  black_circle_for_record: {
    a: "Black Circle for Record",
    b: "23FA-FE0F",
    c: "23FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      39
    ],
    o: 2
  },
  film_frames: {
    a: "Film Frames",
    b: "1F39E-FE0F",
    c: "1F39E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      8,
      4
    ],
    o: 2
  },
  film_projector: {
    a: "Film Projector",
    b: "1F4FD-FE0F",
    c: "1F4FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "video",
      "tape",
      "record",
      "movie"
    ],
    k: [
      27,
      26
    ],
    o: 2
  },
  "flag-gd": {
    a: "Grenada Flag",
    b: "1F1EC-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      56
    ],
    o: 2
  },
  blowfish: {
    a: "Blowfish",
    b: "1F421",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "food",
      "sea",
      "ocean"
    ],
    k: [
      12,
      5
    ],
    o: 2
  },
  face_with_symbols_on_mouth: {
    a: "Serious Face with Symbols Covering Mouth",
    b: "1F92C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      46
    ],
    n: [
      "serious_face_with_symbols_covering_mouth"
    ],
    o: 5
  },
  birthday: {
    a: "Birthday Cake",
    b: "1F382",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "dessert",
      "cake"
    ],
    k: [
      7,
      33
    ],
    o: 2
  },
  eject: {
    a: "Eject",
    b: "23CF-FE0F",
    c: "23CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      25
    ],
    o: 2
  },
  raising_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64B-1F3FB",
        non_qualified: null,
        image: "1f64b-1f3fb.png",
        sheet_x: 33,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F64B-1F3FC",
        non_qualified: null,
        image: "1f64b-1f3fc.png",
        sheet_x: 33,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F64B-1F3FD",
        non_qualified: null,
        image: "1f64b-1f3fd.png",
        sheet_x: 33,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F64B-1F3FE",
        non_qualified: null,
        image: "1f64b-1f3fe.png",
        sheet_x: 33,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F64B-1F3FF",
        non_qualified: null,
        image: "1f64b-1f3ff.png",
        sheet_x: 33,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F64B-200D-2640-FE0F",
    a: "Happy Person Raising One Hand",
    b: "1F64B",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      33,
      2
    ],
    o: 2
  },
  tractor: {
    a: "Tractor",
    b: "1F69C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "car",
      "farming",
      "agriculture"
    ],
    k: [
      34,
      27
    ],
    o: 2
  },
  "flag-ge": {
    a: "Georgia Flag",
    b: "1F1EC-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      0
    ],
    o: 2
  },
  smiling_imp: {
    a: "Smiling Face with Horns",
    b: "1F608",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "devil",
      "horns"
    ],
    k: [
      30,
      43
    ],
    o: 2
  },
  racing_car: {
    a: "Racing Car",
    b: "1F3CE-FE0F",
    c: "1F3CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "race",
      "fast",
      "formula",
      "f1"
    ],
    k: [
      10,
      33
    ],
    o: 2
  },
  cinema: {
    a: "Cinema",
    b: "1F3A6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "record",
      "film",
      "movie",
      "curtain",
      "stage",
      "theater"
    ],
    k: [
      8,
      12
    ],
    o: 2
  },
  clapper: {
    a: "Clapper Board",
    b: "1F3AC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "movie",
      "film",
      "record"
    ],
    k: [
      8,
      18
    ],
    o: 2
  },
  shark: {
    a: "Shark",
    b: "1F988",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "jaws",
      "fins",
      "beach"
    ],
    k: [
      42,
      26
    ],
    o: 4
  },
  cake: {
    a: "Shortcake",
    b: "1F370",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "dessert"
    ],
    k: [
      7,
      15
    ],
    o: 2
  },
  "man-raising-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64B-1F3FB-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FB-200D-2642",
        image: "1f64b-1f3fb-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64B-1F3FC-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FC-200D-2642",
        image: "1f64b-1f3fc-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64B-1F3FD-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FD-200D-2642",
        image: "1f64b-1f3fd-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64B-1F3FE-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FE-200D-2642",
        image: "1f64b-1f3fe-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64B-1F3FF-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FF-200D-2642",
        image: "1f64b-1f3ff-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Raising Hand",
    b: "1F64B-200D-2642-FE0F",
    c: "1F64B-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      53
    ],
    o: 4
  },
  octopus: {
    a: "Octopus",
    b: "1F419",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "creature",
      "ocean",
      "sea",
      "nature",
      "beach"
    ],
    k: [
      11,
      54
    ],
    o: 2
  },
  "woman-raising-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64B-1F3FB-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FB-200D-2640",
        image: "1f64b-1f3fb-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64B-1F3FC-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FC-200D-2640",
        image: "1f64b-1f3fc-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64B-1F3FD-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FD-200D-2640",
        image: "1f64b-1f3fd-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64B-1F3FE-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FE-200D-2640",
        image: "1f64b-1f3fe-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64B-1F3FF-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FF-200D-2640",
        image: "1f64b-1f3ff-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F64B",
    a: "Woman Raising Hand",
    b: "1F64B-200D-2640-FE0F",
    c: "1F64B-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      47
    ],
    o: 4
  },
  "flag-gf": {
    a: "French Guiana Flag",
    b: "1F1EC-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      1
    ],
    o: 2
  },
  tv: {
    a: "Television",
    b: "1F4FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "program",
      "oldschool",
      "show",
      "television"
    ],
    k: [
      27,
      23
    ],
    o: 2
  },
  imp: {
    a: "Imp",
    b: "1F47F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "devil",
      "angry",
      "horns"
    ],
    k: [
      23,
      45
    ],
    o: 2
  },
  cupcake: {
    a: "Cupcake",
    b: "1F9C1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      9
    ],
    o: 11
  },
  racing_motorcycle: {
    a: "Racing Motorcycle",
    b: "1F3CD-FE0F",
    c: "1F3CD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      32
    ],
    o: 2
  },
  low_brightness: {
    a: "Low Brightness Symbol",
    b: "1F505",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sun",
      "afternoon",
      "warm",
      "summer"
    ],
    k: [
      27,
      33
    ],
    o: 2
  },
  shell: {
    a: "Spiral Shell",
    b: "1F41A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "sea",
      "beach"
    ],
    k: [
      11,
      55
    ],
    o: 2
  },
  "flag-gg": {
    a: "Guernsey Flag",
    b: "1F1EC-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      2
    ],
    o: 2
  },
  high_brightness: {
    a: "High Brightness Symbol",
    b: "1F506",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sun",
      "light"
    ],
    k: [
      27,
      34
    ],
    o: 2
  },
  deaf_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CF-1F3FB",
        non_qualified: null,
        image: "1f9cf-1f3fb.png",
        sheet_x: 45,
        sheet_y: 11,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CF-1F3FC",
        non_qualified: null,
        image: "1f9cf-1f3fc.png",
        sheet_x: 45,
        sheet_y: 12,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CF-1F3FD",
        non_qualified: null,
        image: "1f9cf-1f3fd.png",
        sheet_x: 45,
        sheet_y: 13,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CF-1F3FE",
        non_qualified: null,
        image: "1f9cf-1f3fe.png",
        sheet_x: 45,
        sheet_y: 14,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CF-1F3FF",
        non_qualified: null,
        image: "1f9cf-1f3ff.png",
        sheet_x: 45,
        sheet_y: 15,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Deaf Person",
    b: "1F9CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      45,
      10
    ],
    o: 12
  },
  skull: {
    a: "Skull",
    b: "1F480",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dead",
      "skeleton",
      "creepy",
      "death"
    ],
    k: [
      23,
      46
    ],
    o: 2
  },
  motor_scooter: {
    a: "Motor Scooter",
    b: "1F6F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "vespa",
      "sasha"
    ],
    k: [
      36,
      54
    ],
    o: 4
  },
  camera: {
    a: "Camera",
    b: "1F4F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "gadgets",
      "photography"
    ],
    k: [
      27,
      20
    ],
    o: 2
  },
  pie: {
    a: "Pie",
    b: "1F967",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      54
    ],
    o: 5
  },
  "flag-gh": {
    a: "Ghana Flag",
    b: "1F1EC-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      3
    ],
    o: 2
  },
  deaf_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CF-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FB-200D-2642",
        image: "1f9cf-1f3fb-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CF-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FC-200D-2642",
        image: "1f9cf-1f3fc-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CF-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FD-200D-2642",
        image: "1f9cf-1f3fd-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CF-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FE-200D-2642",
        image: "1f9cf-1f3fe-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 8,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CF-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FF-200D-2642",
        image: "1f9cf-1f3ff-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Deaf Man",
    b: "1F9CF-200D-2642-FE0F",
    c: "1F9CF-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      45,
      4
    ],
    o: 12
  },
  skull_and_crossbones: {
    a: "Skull and Crossbones",
    b: "2620-FE0F",
    c: "2620",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poison",
      "danger",
      "deadly",
      "scary",
      "death",
      "pirate",
      "evil"
    ],
    k: [
      53,
      8
    ],
    o: 2
  },
  camera_with_flash: {
    a: "Camera with Flash",
    b: "1F4F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      27,
      21
    ],
    o: 2
  },
  signal_strength: {
    a: "Antenna with Bars",
    b: "1F4F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "reception",
      "phone",
      "internet",
      "connection",
      "wifi",
      "bluetooth",
      "bars"
    ],
    k: [
      27,
      19
    ],
    o: 2
  },
  chocolate_bar: {
    a: "Chocolate Bar",
    b: "1F36B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "snack",
      "dessert",
      "sweet"
    ],
    k: [
      7,
      10
    ],
    o: 2
  },
  manual_wheelchair: {
    a: "Manual Wheelchair",
    b: "1F9BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      5
    ],
    o: 12
  },
  snail: {
    a: "Snail",
    b: "1F40C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "slow",
      "animal",
      "shell"
    ],
    k: [
      11,
      40
    ],
    o: 2
  },
  motorized_wheelchair: {
    a: "Motorized Wheelchair",
    b: "1F9BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      4
    ],
    o: 12
  },
  "flag-gi": {
    a: "Gibraltar Flag",
    b: "1F1EC-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      4
    ],
    o: 2
  },
  hankey: {
    a: "Pile of Poo",
    b: "1F4A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      51
    ],
    n: [
      "poop",
      "shit"
    ],
    o: 2
  },
  vibration_mode: {
    a: "Vibration Mode",
    b: "1F4F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "orange-square",
      "phone"
    ],
    k: [
      27,
      16
    ],
    o: 2
  },
  deaf_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CF-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FB-200D-2640",
        image: "1f9cf-1f3fb-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CF-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FC-200D-2640",
        image: "1f9cf-1f3fc-200d-2640-fe0f.png",
        sheet_x: 45,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CF-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FD-200D-2640",
        image: "1f9cf-1f3fd-200d-2640-fe0f.png",
        sheet_x: 45,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CF-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FE-200D-2640",
        image: "1f9cf-1f3fe-200d-2640-fe0f.png",
        sheet_x: 45,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CF-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FF-200D-2640",
        image: "1f9cf-1f3ff-200d-2640-fe0f.png",
        sheet_x: 45,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Deaf Woman",
    b: "1F9CF-200D-2640-FE0F",
    c: "1F9CF-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      55
    ],
    o: 12
  },
  butterfly: {
    a: "Butterfly",
    b: "1F98B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "nature",
      "caterpillar"
    ],
    k: [
      42,
      29
    ],
    o: 4
  },
  video_camera: {
    a: "Video Camera",
    b: "1F4F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "film",
      "record"
    ],
    k: [
      27,
      22
    ],
    o: 2
  },
  candy: {
    a: "Candy",
    b: "1F36C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "snack",
      "dessert",
      "sweet",
      "lolly"
    ],
    k: [
      7,
      11
    ],
    o: 2
  },
  auto_rickshaw: {
    a: "Auto Rickshaw",
    b: "1F6FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      2
    ],
    o: 12
  },
  bow: {
    skin_variations: {
      "1F3FB": {
        unified: "1F647-1F3FB",
        non_qualified: null,
        image: "1f647-1f3fb.png",
        sheet_x: 32,
        sheet_y: 39,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F647-1F3FC",
        non_qualified: null,
        image: "1f647-1f3fc.png",
        sheet_x: 32,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F647-1F3FD",
        non_qualified: null,
        image: "1f647-1f3fd.png",
        sheet_x: 32,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F647-1F3FE",
        non_qualified: null,
        image: "1f647-1f3fe.png",
        sheet_x: 32,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F647-1F3FF",
        non_qualified: null,
        image: "1f647-1f3ff.png",
        sheet_x: 32,
        sheet_y: 43,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F647-200D-2642-FE0F",
    a: "Person Bowing Deeply",
    b: "1F647",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      32,
      38
    ],
    o: 2
  },
  mobile_phone_off: {
    a: "Mobile Phone off",
    b: "1F4F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mute",
      "orange-square",
      "silence",
      "quiet"
    ],
    k: [
      27,
      17
    ],
    o: 2
  },
  clown_face: {
    a: "Clown Face",
    b: "1F921",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face"
    ],
    k: [
      38,
      18
    ],
    o: 4
  },
  lollipop: {
    a: "Lollipop",
    b: "1F36D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "snack",
      "candy",
      "sweet"
    ],
    k: [
      7,
      12
    ],
    o: 2
  },
  "flag-gl": {
    a: "Greenland Flag",
    b: "1F1EC-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      5
    ],
    o: 2
  },
  vhs: {
    a: "Videocassette",
    b: "1F4FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "record",
      "video",
      "oldschool",
      "90s",
      "80s"
    ],
    k: [
      27,
      25
    ],
    o: 2
  },
  bug: {
    a: "Bug",
    b: "1F41B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "nature",
      "worm"
    ],
    k: [
      11,
      56
    ],
    o: 2
  },
  bike: {
    a: "Bicycle",
    b: "1F6B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "bicycle",
      "exercise",
      "hipster"
    ],
    k: [
      35,
      9
    ],
    o: 2
  },
  "man-bowing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F647-1F3FB-200D-2642-FE0F",
        non_qualified: "1F647-1F3FB-200D-2642",
        image: "1f647-1f3fb-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F647-1F3FC-200D-2642-FE0F",
        non_qualified: "1F647-1F3FC-200D-2642",
        image: "1f647-1f3fc-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F647-1F3FD-200D-2642-FE0F",
        non_qualified: "1F647-1F3FD-200D-2642",
        image: "1f647-1f3fd-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F647-1F3FE-200D-2642-FE0F",
        non_qualified: "1F647-1F3FE-200D-2642",
        image: "1f647-1f3fe-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F647-1F3FF-200D-2642-FE0F",
        non_qualified: "1F647-1F3FF-200D-2642",
        image: "1f647-1f3ff-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F647",
    a: "Man Bowing",
    b: "1F647-200D-2642-FE0F",
    c: "1F647-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      32
    ],
    o: 4
  },
  female_sign: {
    a: "Female Sign",
    b: "2640-FE0F",
    c: "2640",
    d: !1,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      18
    ],
    o: 4
  },
  japanese_ogre: {
    a: "Japanese Ogre",
    b: "1F479",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "monster",
      "red",
      "mask",
      "halloween",
      "scary",
      "creepy",
      "devil",
      "demon",
      "japanese",
      "ogre"
    ],
    k: [
      23,
      34
    ],
    o: 2
  },
  custard: {
    a: "Custard",
    b: "1F36E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dessert",
      "food"
    ],
    k: [
      7,
      13
    ],
    o: 2
  },
  ant: {
    a: "Ant",
    b: "1F41C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "nature",
      "bug"
    ],
    k: [
      12,
      0
    ],
    o: 2
  },
  mag: {
    a: "Left-Pointing Magnifying Glass",
    b: "1F50D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "search",
      "zoom",
      "find",
      "detective"
    ],
    k: [
      27,
      41
    ],
    o: 2
  },
  "flag-gm": {
    a: "Gambia Flag",
    b: "1F1EC-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      6
    ],
    o: 2
  },
  honey_pot: {
    a: "Honey Pot",
    b: "1F36F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bees",
      "sweet",
      "kitchen"
    ],
    k: [
      7,
      14
    ],
    o: 2
  },
  "woman-bowing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F647-1F3FB-200D-2640-FE0F",
        non_qualified: "1F647-1F3FB-200D-2640",
        image: "1f647-1f3fb-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F647-1F3FC-200D-2640-FE0F",
        non_qualified: "1F647-1F3FC-200D-2640",
        image: "1f647-1f3fc-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F647-1F3FD-200D-2640-FE0F",
        non_qualified: "1F647-1F3FD-200D-2640",
        image: "1f647-1f3fd-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F647-1F3FE-200D-2640-FE0F",
        non_qualified: "1F647-1F3FE-200D-2640",
        image: "1f647-1f3fe-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F647-1F3FF-200D-2640-FE0F",
        non_qualified: "1F647-1F3FF-200D-2640",
        image: "1f647-1f3ff-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Bowing",
    b: "1F647-200D-2640-FE0F",
    c: "1F647-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      26
    ],
    o: 4
  },
  male_sign: {
    a: "Male Sign",
    b: "2642-FE0F",
    c: "2642",
    d: !1,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      19
    ],
    o: 4
  },
  mag_right: {
    a: "Right-Pointing Magnifying Glass",
    b: "1F50E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "search",
      "zoom",
      "find",
      "detective"
    ],
    k: [
      27,
      42
    ],
    o: 2
  },
  japanese_goblin: {
    a: "Japanese Goblin",
    b: "1F47A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "red",
      "evil",
      "mask",
      "monster",
      "scary",
      "creepy",
      "japanese",
      "goblin"
    ],
    k: [
      23,
      35
    ],
    o: 2
  },
  scooter: {
    a: "Scooter",
    b: "1F6F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      53
    ],
    o: 4
  },
  bee: {
    a: "Honeybee",
    b: "1F41D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      12,
      1
    ],
    n: [
      "honeybee"
    ],
    o: 2
  },
  "flag-gn": {
    a: "Guinea Flag",
    b: "1F1EC-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      7
    ],
    o: 2
  },
  candle: {
    a: "Candle",
    b: "1F56F-FE0F",
    c: "1F56F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fire",
      "wax"
    ],
    k: [
      29,
      6
    ],
    o: 2
  },
  skateboard: {
    a: "Skateboard",
    b: "1F6F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      1
    ],
    o: 11
  },
  medical_symbol: {
    a: "Medical Symbol",
    b: "2695-FE0F",
    c: "2695",
    d: !1,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      44
    ],
    n: [
      "staff_of_aesculapius"
    ],
    o: 4
  },
  ghost: {
    a: "Ghost",
    b: "1F47B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "halloween",
      "spooky",
      "scary"
    ],
    k: [
      23,
      36
    ],
    o: 2
  },
  beetle: {
    a: "Lady Beetle",
    b: "1F41E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "nature",
      "ladybug"
    ],
    k: [
      12,
      2
    ],
    o: 2
  },
  face_palm: {
    skin_variations: {
      "1F3FB": {
        unified: "1F926-1F3FB",
        non_qualified: null,
        image: "1f926-1f3fb.png",
        sheet_x: 38,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F926-1F3FC",
        non_qualified: null,
        image: "1f926-1f3fc.png",
        sheet_x: 38,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F926-1F3FD",
        non_qualified: null,
        image: "1f926-1f3fd.png",
        sheet_x: 38,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F926-1F3FE",
        non_qualified: null,
        image: "1f926-1f3fe.png",
        sheet_x: 38,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F926-1F3FF",
        non_qualified: null,
        image: "1f926-1f3ff.png",
        sheet_x: 38,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Face Palm",
    b: "1F926",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      38,
      35
    ],
    o: 4
  },
  "flag-gp": {
    a: "Guadeloupe Flag",
    b: "1F1EC-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      8
    ],
    o: 2
  },
  baby_bottle: {
    a: "Baby Bottle",
    b: "1F37C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "container",
      "milk"
    ],
    k: [
      7,
      27
    ],
    o: 2
  },
  infinity: {
    a: "Infinity",
    b: "267E-FE0F",
    c: "267E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      39
    ],
    o: 11
  },
  glass_of_milk: {
    a: "Glass of Milk",
    b: "1F95B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      42
    ],
    o: 4
  },
  "man-facepalming": {
    skin_variations: {
      "1F3FB": {
        unified: "1F926-1F3FB-200D-2642-FE0F",
        non_qualified: "1F926-1F3FB-200D-2642",
        image: "1f926-1f3fb-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F926-1F3FC-200D-2642-FE0F",
        non_qualified: "1F926-1F3FC-200D-2642",
        image: "1f926-1f3fc-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F926-1F3FD-200D-2642-FE0F",
        non_qualified: "1F926-1F3FD-200D-2642",
        image: "1f926-1f3fd-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F926-1F3FE-200D-2642-FE0F",
        non_qualified: "1F926-1F3FE-200D-2642",
        image: "1f926-1f3fe-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F926-1F3FF-200D-2642-FE0F",
        non_qualified: "1F926-1F3FF-200D-2642",
        image: "1f926-1f3ff-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Facepalming",
    b: "1F926-200D-2642-FE0F",
    c: "1F926-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      29
    ],
    o: 4
  },
  cricket: {
    a: "Cricket",
    b: "1F997",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports"
    ],
    k: [
      42,
      41
    ],
    o: 5
  },
  busstop: {
    a: "Bus Stop",
    b: "1F68F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "wait"
    ],
    k: [
      34,
      14
    ],
    o: 2
  },
  "flag-gq": {
    a: "Equatorial Guinea Flag",
    b: "1F1EC-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      9
    ],
    o: 2
  },
  alien: {
    a: "Extraterrestrial Alien",
    b: "1F47D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "UFO",
      "paul",
      "weird",
      "outer_space"
    ],
    k: [
      23,
      43
    ],
    o: 2
  },
  bulb: {
    a: "Electric Light Bulb",
    b: "1F4A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "light",
      "electricity",
      "idea"
    ],
    k: [
      25,
      43
    ],
    o: 2
  },
  "woman-facepalming": {
    skin_variations: {
      "1F3FB": {
        unified: "1F926-1F3FB-200D-2640-FE0F",
        non_qualified: "1F926-1F3FB-200D-2640",
        image: "1f926-1f3fb-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F926-1F3FC-200D-2640-FE0F",
        non_qualified: "1F926-1F3FC-200D-2640",
        image: "1f926-1f3fc-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F926-1F3FD-200D-2640-FE0F",
        non_qualified: "1F926-1F3FD-200D-2640",
        image: "1f926-1f3fd-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F926-1F3FE-200D-2640-FE0F",
        non_qualified: "1F926-1F3FE-200D-2640",
        image: "1f926-1f3fe-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F926-1F3FF-200D-2640-FE0F",
        non_qualified: "1F926-1F3FF-200D-2640",
        image: "1f926-1f3ff-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Facepalming",
    b: "1F926-200D-2640-FE0F",
    c: "1F926-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      23
    ],
    o: 4
  },
  spider: {
    a: "Spider",
    b: "1F577-FE0F",
    c: "1F577",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "arachnid"
    ],
    k: [
      29,
      34
    ],
    o: 2
  },
  space_invader: {
    a: "Alien Monster",
    b: "1F47E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "arcade",
      "play"
    ],
    k: [
      23,
      44
    ],
    o: 2
  },
  motorway: {
    a: "Motorway",
    b: "1F6E3-FE0F",
    c: "1F6E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "road",
      "cupertino",
      "interstate",
      "highway"
    ],
    k: [
      36,
      45
    ],
    o: 2
  },
  "flag-gr": {
    a: "Greece Flag",
    b: "1F1EC-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      10
    ],
    o: 2
  },
  recycle: {
    a: "Black Universal Recycling Symbol",
    b: "267B-FE0F",
    c: "267B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arrow",
      "environment",
      "garbage",
      "trash"
    ],
    k: [
      53,
      38
    ],
    o: 2
  },
  coffee: {
    a: "Hot Beverage",
    b: "2615",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beverage",
      "caffeine",
      "latte",
      "espresso"
    ],
    k: [
      53,
      0
    ],
    o: 2
  },
  flashlight: {
    a: "Electric Torch",
    b: "1F526",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dark",
      "camping",
      "sight",
      "night"
    ],
    k: [
      28,
      9
    ],
    o: 2
  },
  spider_web: {
    a: "Spider Web",
    b: "1F578-FE0F",
    c: "1F578",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "arachnid",
      "silk"
    ],
    k: [
      29,
      35
    ],
    o: 2
  },
  izakaya_lantern: {
    a: "Izakaya Lantern",
    b: "1F3EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "light",
      "paper",
      "halloween",
      "spooky"
    ],
    k: [
      11,
      8
    ],
    n: [
      "lantern"
    ],
    o: 2
  },
  "flag-gs": {
    a: "South Georgia & South Sandwich Islands Flag",
    b: "1F1EC-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      11
    ],
    o: 2
  },
  shrug: {
    skin_variations: {
      "1F3FB": {
        unified: "1F937-1F3FB",
        non_qualified: null,
        image: "1f937-1f3fb.png",
        sheet_x: 39,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F937-1F3FC",
        non_qualified: null,
        image: "1f937-1f3fc.png",
        sheet_x: 39,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F937-1F3FD",
        non_qualified: null,
        image: "1f937-1f3fd.png",
        sheet_x: 39,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F937-1F3FE",
        non_qualified: null,
        image: "1f937-1f3fe.png",
        sheet_x: 39,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F937-1F3FF",
        non_qualified: null,
        image: "1f937-1f3ff.png",
        sheet_x: 39,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Shrug",
    b: "1F937",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      39,
      47
    ],
    o: 4
  },
  fleur_de_lis: {
    a: "Fleur De Lis",
    b: "269C-FE0F",
    c: "269C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "decorative",
      "scout"
    ],
    k: [
      53,
      49
    ],
    o: 2
  },
  robot_face: {
    a: "Robot Face",
    b: "1F916",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      29
    ],
    o: 2
  },
  railway_track: {
    a: "Railway Track",
    b: "1F6E4-FE0F",
    c: "1F6E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "train",
      "transportation"
    ],
    k: [
      36,
      46
    ],
    o: 2
  },
  tea: {
    a: "Teacup Without Handle",
    b: "1F375",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "bowl",
      "breakfast",
      "green",
      "british"
    ],
    k: [
      7,
      20
    ],
    o: 2
  },
  "flag-gt": {
    a: "Guatemala Flag",
    b: "1F1EC-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      12
    ],
    o: 2
  },
  oil_drum: {
    a: "Oil Drum",
    b: "1F6E2-FE0F",
    c: "1F6E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "barrell"
    ],
    k: [
      36,
      44
    ],
    o: 2
  },
  diya_lamp: {
    a: "Diya Lamp",
    b: "1FA94",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      8
    ],
    o: 12
  },
  sake: {
    a: "Sake Bottle and Cup",
    b: "1F376",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wine",
      "drink",
      "drunk",
      "beverage",
      "japanese",
      "alcohol",
      "booze"
    ],
    k: [
      7,
      21
    ],
    o: 2
  },
  trident: {
    a: "Trident Emblem",
    b: "1F531",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weapon",
      "spear"
    ],
    k: [
      28,
      20
    ],
    o: 2
  },
  "man-shrugging": {
    skin_variations: {
      "1F3FB": {
        unified: "1F937-1F3FB-200D-2642-FE0F",
        non_qualified: "1F937-1F3FB-200D-2642",
        image: "1f937-1f3fb-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F937-1F3FC-200D-2642-FE0F",
        non_qualified: "1F937-1F3FC-200D-2642",
        image: "1f937-1f3fc-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F937-1F3FD-200D-2642-FE0F",
        non_qualified: "1F937-1F3FD-200D-2642",
        image: "1f937-1f3fd-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F937-1F3FE-200D-2642-FE0F",
        non_qualified: "1F937-1F3FE-200D-2642",
        image: "1f937-1f3fe-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F937-1F3FF-200D-2642-FE0F",
        non_qualified: "1F937-1F3FF-200D-2642",
        image: "1f937-1f3ff-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Shrugging",
    b: "1F937-200D-2642-FE0F",
    c: "1F937-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      39,
      41
    ],
    o: 4
  },
  smiley_cat: {
    a: "Smiling Cat Face with Open Mouth",
    b: "1F63A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "happy",
      "smile"
    ],
    k: [
      31,
      36
    ],
    o: 2
  },
  scorpion: {
    a: "Scorpion",
    b: "1F982",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "arachnid"
    ],
    k: [
      42,
      20
    ],
    o: 2
  },
  "woman-shrugging": {
    skin_variations: {
      "1F3FB": {
        unified: "1F937-1F3FB-200D-2640-FE0F",
        non_qualified: "1F937-1F3FB-200D-2640",
        image: "1f937-1f3fb-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F937-1F3FC-200D-2640-FE0F",
        non_qualified: "1F937-1F3FC-200D-2640",
        image: "1f937-1f3fc-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F937-1F3FD-200D-2640-FE0F",
        non_qualified: "1F937-1F3FD-200D-2640",
        image: "1f937-1f3fd-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F937-1F3FE-200D-2640-FE0F",
        non_qualified: "1F937-1F3FE-200D-2640",
        image: "1f937-1f3fe-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F937-1F3FF-200D-2640-FE0F",
        non_qualified: "1F937-1F3FF-200D-2640",
        image: "1f937-1f3ff-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Shrugging",
    b: "1F937-200D-2640-FE0F",
    c: "1F937-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      39,
      35
    ],
    o: 4
  },
  notebook_with_decorative_cover: {
    a: "Notebook with Decorative Cover",
    b: "1F4D4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "classroom",
      "notes",
      "record",
      "paper",
      "study"
    ],
    k: [
      26,
      42
    ],
    o: 2
  },
  fuelpump: {
    a: "Fuel Pump",
    b: "26FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "gas station",
      "petroleum"
    ],
    k: [
      54,
      38
    ],
    o: 2
  },
  name_badge: {
    a: "Name Badge",
    b: "1F4DB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fire",
      "forbid"
    ],
    k: [
      26,
      49
    ],
    o: 2
  },
  mosquito: {
    a: "Mosquito",
    b: "1F99F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      49
    ],
    o: 11
  },
  "flag-gu": {
    a: "Guam Flag",
    b: "1F1EC-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      13
    ],
    o: 2
  },
  smile_cat: {
    a: "Grinning Cat Face with Smiling Eyes",
    b: "1F638",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "smile"
    ],
    k: [
      31,
      34
    ],
    o: 2
  },
  champagne: {
    a: "Bottle with Popping Cork",
    b: "1F37E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "wine",
      "bottle",
      "celebration"
    ],
    k: [
      7,
      29
    ],
    o: 2
  },
  joy_cat: {
    a: "Cat Face with Tears of Joy",
    b: "1F639",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "haha",
      "happy",
      "tears"
    ],
    k: [
      31,
      35
    ],
    o: 2
  },
  closed_book: {
    a: "Closed Book",
    b: "1F4D5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "learn"
    ],
    k: [
      26,
      43
    ],
    o: 2
  },
  health_worker: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FB-200D-2695",
        image: "1f9d1-1f3fb-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FC-200D-2695",
        image: "1f9d1-1f3fc-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FD-200D-2695",
        image: "1f9d1-1f3fd-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FE-200D-2695",
        image: "1f9d1-1f3fe-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 53,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FF-200D-2695",
        image: "1f9d1-1f3ff-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Health Worker",
    b: "1F9D1-200D-2695-FE0F",
    c: "1F9D1-200D-2695",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      49
    ],
    o: 12
  },
  rotating_light: {
    a: "Police Cars Revolving Light",
    b: "1F6A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "police",
      "ambulance",
      "911",
      "emergency",
      "alert",
      "error",
      "pinged",
      "law",
      "legal"
    ],
    k: [
      34,
      56
    ],
    o: 2
  },
  microbe: {
    a: "Microbe",
    b: "1F9A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      50
    ],
    o: 11
  },
  "flag-gw": {
    a: "Guinea-Bissau Flag",
    b: "1F1EC-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      14
    ],
    o: 2
  },
  wine_glass: {
    a: "Wine Glass",
    b: "1F377",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "booze"
    ],
    k: [
      7,
      22
    ],
    o: 2
  },
  beginner: {
    a: "Japanese Symbol for Beginner",
    b: "1F530",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "badge",
      "shield"
    ],
    k: [
      28,
      19
    ],
    o: 2
  },
  bouquet: {
    a: "Bouquet",
    b: "1F490",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flowers",
      "nature",
      "spring"
    ],
    k: [
      25,
      26
    ],
    o: 2
  },
  heart_eyes_cat: {
    a: "Smiling Cat Face with Heart-Shaped Eyes",
    b: "1F63B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "love",
      "like",
      "affection",
      "cats",
      "valentines",
      "heart"
    ],
    k: [
      31,
      37
    ],
    o: 2
  },
  "male-doctor": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-2695-FE0F",
        non_qualified: "1F468-1F3FB-200D-2695",
        image: "1f468-1f3fb-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-2695-FE0F",
        non_qualified: "1F468-1F3FC-200D-2695",
        image: "1f468-1f3fc-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-2695-FE0F",
        non_qualified: "1F468-1F3FD-200D-2695",
        image: "1f468-1f3fd-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-2695-FE0F",
        non_qualified: "1F468-1F3FE-200D-2695",
        image: "1f468-1f3fe-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-2695-FE0F",
        non_qualified: "1F468-1F3FF-200D-2695",
        image: "1f468-1f3ff-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Doctor",
    b: "1F468-200D-2695-FE0F",
    c: "1F468-200D-2695",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      2
    ],
    o: 4
  },
  book: {
    a: "Open Book",
    b: "1F4D6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      26,
      44
    ],
    n: [
      "open_book"
    ],
    o: 2
  },
  traffic_light: {
    a: "Horizontal Traffic Light",
    b: "1F6A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "signal"
    ],
    k: [
      34,
      53
    ],
    o: 2
  },
  cocktail: {
    a: "Cocktail Glass",
    b: "1F378",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "drunk",
      "alcohol",
      "beverage",
      "booze",
      "mojito"
    ],
    k: [
      7,
      23
    ],
    o: 2
  },
  o: {
    a: "Heavy Large Circle",
    b: "2B55",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "circle",
      "round"
    ],
    k: [
      55,
      43
    ],
    o: 2
  },
  "flag-gy": {
    a: "Guyana Flag",
    b: "1F1EC-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      15
    ],
    o: 2
  },
  "female-doctor": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-2695-FE0F",
        non_qualified: "1F469-1F3FB-200D-2695",
        image: "1f469-1f3fb-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-2695-FE0F",
        non_qualified: "1F469-1F3FC-200D-2695",
        image: "1f469-1f3fc-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-2695-FE0F",
        non_qualified: "1F469-1F3FD-200D-2695",
        image: "1f469-1f3fd-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-2695-FE0F",
        non_qualified: "1F469-1F3FE-200D-2695",
        image: "1f469-1f3fe-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-2695-FE0F",
        non_qualified: "1F469-1F3FF-200D-2695",
        image: "1f469-1f3ff-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Doctor",
    b: "1F469-200D-2695-FE0F",
    c: "1F469-200D-2695",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      44
    ],
    o: 4
  },
  smirk_cat: {
    a: "Cat Face with Wry Smile",
    b: "1F63C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "smirk"
    ],
    k: [
      31,
      38
    ],
    o: 2
  },
  green_book: {
    a: "Green Book",
    b: "1F4D7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "library",
      "knowledge",
      "study"
    ],
    k: [
      26,
      45
    ],
    o: 2
  },
  cherry_blossom: {
    a: "Cherry Blossom",
    b: "1F338",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "spring",
      "flower"
    ],
    k: [
      6,
      16
    ],
    o: 2
  },
  "flag-hk": {
    a: "Hong Kong Sar China Flag",
    b: "1F1ED-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      16
    ],
    o: 2
  },
  vertical_traffic_light: {
    a: "Vertical Traffic Light",
    b: "1F6A6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "driving"
    ],
    k: [
      34,
      54
    ],
    o: 2
  },
  white_check_mark: {
    a: "White Heavy Check Mark",
    b: "2705",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "green-square",
      "ok",
      "agree",
      "vote",
      "election",
      "answer",
      "tick"
    ],
    k: [
      54,
      40
    ],
    o: 2
  },
  tropical_drink: {
    a: "Tropical Drink",
    b: "1F379",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beverage",
      "cocktail",
      "summer",
      "beach",
      "alcohol",
      "booze",
      "mojito"
    ],
    k: [
      7,
      24
    ],
    o: 2
  },
  kissing_cat: {
    a: "Kissing Cat Face with Closed Eyes",
    b: "1F63D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "kiss"
    ],
    k: [
      31,
      39
    ],
    o: 2
  },
  "flag-hm": {
    a: "Heard & Mcdonald Islands Flag",
    b: "1F1ED-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      17
    ],
    o: 2
  },
  octagonal_sign: {
    a: "Octagonal Sign",
    b: "1F6D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      39
    ],
    o: 4
  },
  white_flower: {
    a: "White Flower",
    b: "1F4AE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "spring"
    ],
    k: [
      26,
      4
    ],
    o: 2
  },
  ballot_box_with_check: {
    a: "Ballot Box with Check",
    b: "2611-FE0F",
    c: "2611",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ok",
      "agree",
      "confirm",
      "black-square",
      "vote",
      "election",
      "yes",
      "tick"
    ],
    k: [
      52,
      55
    ],
    o: 2
  },
  student: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 31,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Student",
    b: "1F9D1-200D-1F393",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      29
    ],
    o: 12
  },
  blue_book: {
    a: "Blue Book",
    b: "1F4D8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "library",
      "knowledge",
      "learn",
      "study"
    ],
    k: [
      26,
      46
    ],
    o: 2
  },
  beer: {
    a: "Beer Mug",
    b: "1F37A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    k: [
      7,
      25
    ],
    o: 2
  },
  construction: {
    a: "Construction Sign",
    b: "1F6A7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wip",
      "progress",
      "caution",
      "warning"
    ],
    k: [
      34,
      55
    ],
    o: 2
  },
  rosette: {
    a: "Rosette",
    b: "1F3F5-FE0F",
    c: "1F3F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flower",
      "decoration",
      "military"
    ],
    k: [
      11,
      18
    ],
    o: 2
  },
  heavy_check_mark: {
    a: "Heavy Check Mark",
    b: "2714-FE0F",
    c: "2714",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ok",
      "nike",
      "answer",
      "yes",
      "tick"
    ],
    k: [
      55,
      12
    ],
    o: 2
  },
  scream_cat: {
    a: "Weary Cat Face",
    b: "1F640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "munch",
      "scared",
      "scream"
    ],
    k: [
      31,
      42
    ],
    o: 2
  },
  orange_book: {
    a: "Orange Book",
    b: "1F4D9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "study"
    ],
    k: [
      26,
      47
    ],
    o: 2
  },
  beers: {
    a: "Clinking Beer Mugs",
    b: "1F37B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    k: [
      7,
      26
    ],
    o: 2
  },
  "male-student": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Student",
    b: "1F468-200D-1F393",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      50
    ],
    o: 4
  },
  "flag-hn": {
    a: "Honduras Flag",
    b: "1F1ED-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      18
    ],
    o: 2
  },
  crying_cat_face: {
    a: "Crying Cat Face",
    b: "1F63F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "tears",
      "weep",
      "sad",
      "cats",
      "upset",
      "cry"
    ],
    k: [
      31,
      41
    ],
    o: 2
  },
  anchor: {
    a: "Anchor",
    b: "2693",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ship",
      "ferry",
      "sea",
      "boat"
    ],
    k: [
      53,
      42
    ],
    o: 2
  },
  "flag-hr": {
    a: "Croatia Flag",
    b: "1F1ED-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      19
    ],
    o: 2
  },
  heavy_multiplication_x: {
    a: "Heavy Multiplication X",
    b: "2716-FE0F",
    c: "2716",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "math",
      "calculation"
    ],
    k: [
      55,
      13
    ],
    o: 2
  },
  "female-student": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Student",
    b: "1F469-200D-1F393",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      40
    ],
    o: 4
  },
  rose: {
    a: "Rose",
    b: "1F339",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flowers",
      "valentines",
      "love",
      "spring"
    ],
    k: [
      6,
      17
    ],
    o: 2
  },
  books: {
    a: "Books",
    b: "1F4DA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "literature",
      "library",
      "study"
    ],
    k: [
      26,
      48
    ],
    o: 2
  },
  clinking_glasses: {
    a: "Clinking Glasses",
    b: "1F942",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beverage",
      "drink",
      "party",
      "alcohol",
      "celebrate",
      "cheers"
    ],
    k: [
      41,
      18
    ],
    o: 4
  },
  teacher: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 49,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Teacher",
    b: "1F9D1-200D-1F3EB",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      47
    ],
    o: 12
  },
  x: {
    a: "Cross Mark",
    b: "274C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "no",
      "delete",
      "remove",
      "cancel"
    ],
    k: [
      55,
      21
    ],
    o: 2
  },
  pouting_cat: {
    a: "Pouting Cat Face",
    b: "1F63E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats"
    ],
    k: [
      31,
      40
    ],
    o: 2
  },
  wilted_flower: {
    a: "Wilted Flower",
    b: "1F940",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature",
      "flower"
    ],
    k: [
      41,
      16
    ],
    o: 4
  },
  boat: {
    a: "Sailboat",
    b: "26F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      16
    ],
    n: [
      "sailboat"
    ],
    o: 2
  },
  "flag-ht": {
    a: "Haiti Flag",
    b: "1F1ED-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      20
    ],
    o: 2
  },
  tumbler_glass: {
    a: "Tumbler Glass",
    b: "1F943",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "liquor",
      "booze",
      "bourbon",
      "scotch",
      "whisky",
      "glass",
      "shot"
    ],
    k: [
      41,
      19
    ],
    o: 4
  },
  notebook: {
    a: "Notebook",
    b: "1F4D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "record",
      "notes",
      "paper",
      "study"
    ],
    k: [
      26,
      41
    ],
    o: 2
  },
  "male-teacher": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Teacher",
    b: "1F468-200D-1F3EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      11
    ],
    o: 4
  },
  ledger: {
    a: "Ledger",
    b: "1F4D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "notes",
      "paper"
    ],
    k: [
      26,
      40
    ],
    o: 2
  },
  "flag-hu": {
    a: "Hungary Flag",
    b: "1F1ED-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      21
    ],
    o: 2
  },
  cup_with_straw: {
    a: "Cup with Straw",
    b: "1F964",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      51
    ],
    o: 5
  },
  hibiscus: {
    a: "Hibiscus",
    b: "1F33A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "vegetable",
      "flowers",
      "beach"
    ],
    k: [
      6,
      18
    ],
    o: 2
  },
  see_no_evil: {
    a: "See-No-Evil Monkey",
    b: "1F648",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "monkey",
      "animal",
      "nature",
      "haha"
    ],
    k: [
      32,
      44
    ],
    o: 2
  },
  canoe: {
    a: "Canoe",
    b: "1F6F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "boat",
      "paddle",
      "water",
      "ship"
    ],
    k: [
      36,
      55
    ],
    o: 4
  },
  negative_squared_cross_mark: {
    a: "Negative Squared Cross Mark",
    b: "274E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "x",
      "green-square",
      "no",
      "deny"
    ],
    k: [
      55,
      22
    ],
    o: 2
  },
  "flag-ic": {
    a: "Canary Islands Flag",
    b: "1F1EE-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      22
    ],
    o: 2
  },
  beverage_box: {
    a: "Beverage Box",
    b: "1F9C3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      11
    ],
    o: 12
  },
  speedboat: {
    a: "Speedboat",
    b: "1F6A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ship",
      "transportation",
      "vehicle",
      "summer"
    ],
    k: [
      34,
      52
    ],
    o: 2
  },
  heavy_plus_sign: {
    a: "Heavy Plus Sign",
    b: "2795",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "math",
      "calculation",
      "addition",
      "more",
      "increase"
    ],
    k: [
      55,
      29
    ],
    o: 2
  },
  sunflower: {
    a: "Sunflower",
    b: "1F33B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "fall"
    ],
    k: [
      6,
      19
    ],
    o: 2
  },
  page_with_curl: {
    a: "Page with Curl",
    b: "1F4C3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "office",
      "paper"
    ],
    k: [
      26,
      25
    ],
    o: 2
  },
  "female-teacher": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Teacher",
    b: "1F469-200D-1F3EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      1
    ],
    o: 4
  },
  hear_no_evil: {
    a: "Hear-No-Evil Monkey",
    b: "1F649",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "monkey",
      "nature"
    ],
    k: [
      32,
      45
    ],
    o: 2
  },
  mate_drink: {
    a: "Mate Drink",
    b: "1F9C9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      17
    ],
    o: 12
  },
  passenger_ship: {
    a: "Passenger Ship",
    b: "1F6F3-FE0F",
    c: "1F6F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "yacht",
      "cruise",
      "ferry"
    ],
    k: [
      36,
      52
    ],
    o: 2
  },
  judge: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FB-200D-2696",
        image: "1f9d1-1f3fb-200d-2696-fe0f.png",
        sheet_x: 47,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FC-200D-2696",
        image: "1f9d1-1f3fc-200d-2696-fe0f.png",
        sheet_x: 48,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FD-200D-2696",
        image: "1f9d1-1f3fd-200d-2696-fe0f.png",
        sheet_x: 48,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FE-200D-2696",
        image: "1f9d1-1f3fe-200d-2696-fe0f.png",
        sheet_x: 48,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FF-200D-2696",
        image: "1f9d1-1f3ff-200d-2696-fe0f.png",
        sheet_x: 48,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Judge",
    b: "1F9D1-200D-2696-FE0F",
    c: "1F9D1-200D-2696",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      55
    ],
    o: 12
  },
  scroll: {
    a: "Scroll",
    b: "1F4DC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "ancient",
      "history",
      "paper"
    ],
    k: [
      26,
      50
    ],
    o: 2
  },
  blossom: {
    a: "Blossom",
    b: "1F33C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "flowers",
      "yellow"
    ],
    k: [
      6,
      20
    ],
    o: 2
  },
  "flag-id": {
    a: "Indonesia Flag",
    b: "1F1EE-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      23
    ],
    o: 2
  },
  speak_no_evil: {
    a: "Speak-No-Evil Monkey",
    b: "1F64A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "monkey",
      "animal",
      "nature",
      "omg"
    ],
    k: [
      32,
      46
    ],
    o: 2
  },
  heavy_minus_sign: {
    a: "Heavy Minus Sign",
    b: "2796",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "math",
      "calculation",
      "subtract",
      "less"
    ],
    k: [
      55,
      30
    ],
    o: 2
  },
  "flag-ie": {
    a: "Ireland Flag",
    b: "1F1EE-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      24
    ],
    o: 2
  },
  ice_cube: {
    a: "Ice Cube",
    b: "1F9CA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      18
    ],
    o: 12
  },
  page_facing_up: {
    a: "Page Facing Up",
    b: "1F4C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "office",
      "paper",
      "information"
    ],
    k: [
      26,
      26
    ],
    o: 2
  },
  "male-judge": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-2696-FE0F",
        non_qualified: "1F468-1F3FB-200D-2696",
        image: "1f468-1f3fb-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-2696-FE0F",
        non_qualified: "1F468-1F3FC-200D-2696",
        image: "1f468-1f3fc-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-2696-FE0F",
        non_qualified: "1F468-1F3FD-200D-2696",
        image: "1f468-1f3fd-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-2696-FE0F",
        non_qualified: "1F468-1F3FE-200D-2696",
        image: "1f468-1f3fe-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-2696-FE0F",
        non_qualified: "1F468-1F3FF-200D-2696",
        image: "1f468-1f3ff-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Judge",
    b: "1F468-200D-2696-FE0F",
    c: "1F468-200D-2696",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      8
    ],
    o: 4
  },
  tulip: {
    a: "Tulip",
    b: "1F337",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flowers",
      "plant",
      "nature",
      "summer",
      "spring"
    ],
    k: [
      6,
      15
    ],
    o: 2
  },
  ferry: {
    a: "Ferry",
    b: "26F4-FE0F",
    c: "26F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "boat",
      "ship",
      "yacht"
    ],
    k: [
      54,
      15
    ],
    o: 2
  },
  kiss: {
    a: "Kiss Mark",
    b: "1F48B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "lips",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      21
    ],
    o: 2
  },
  heavy_division_sign: {
    a: "Heavy Division Sign",
    b: "2797",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "divide",
      "math",
      "calculation"
    ],
    k: [
      55,
      31
    ],
    o: 2
  },
  newspaper: {
    a: "Newspaper",
    b: "1F4F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "press",
      "headline"
    ],
    k: [
      27,
      13
    ],
    o: 2
  },
  "female-judge": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-2696-FE0F",
        non_qualified: "1F469-1F3FB-200D-2696",
        image: "1f469-1f3fb-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-2696-FE0F",
        non_qualified: "1F469-1F3FC-200D-2696",
        image: "1f469-1f3fc-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-2696-FE0F",
        non_qualified: "1F469-1F3FD-200D-2696",
        image: "1f469-1f3fd-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-2696-FE0F",
        non_qualified: "1F469-1F3FE-200D-2696",
        image: "1f469-1f3fe-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-2696-FE0F",
        non_qualified: "1F469-1F3FF-200D-2696",
        image: "1f469-1f3ff-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Judge",
    b: "1F469-200D-2696-FE0F",
    c: "1F469-200D-2696",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      50
    ],
    o: 4
  },
  seedling: {
    a: "Seedling",
    b: "1F331",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature",
      "grass",
      "lawn",
      "spring"
    ],
    k: [
      6,
      9
    ],
    o: 2
  },
  love_letter: {
    a: "Love Letter",
    b: "1F48C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "like",
      "affection",
      "envelope",
      "valentines"
    ],
    k: [
      25,
      22
    ],
    o: 2
  },
  chopsticks: {
    a: "Chopsticks",
    b: "1F962",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      49
    ],
    o: 5
  },
  motor_boat: {
    a: "Motor Boat",
    b: "1F6E5-FE0F",
    c: "1F6E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ship"
    ],
    k: [
      36,
      47
    ],
    o: 2
  },
  "flag-il": {
    a: "Israel Flag",
    b: "1F1EE-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      25
    ],
    o: 2
  },
  curly_loop: {
    a: "Curly Loop",
    b: "27B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "scribble",
      "draw",
      "shape",
      "squiggle"
    ],
    k: [
      55,
      33
    ],
    o: 2
  },
  "flag-im": {
    a: "Isle of Man Flag",
    b: "1F1EE-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      26
    ],
    o: 2
  },
  evergreen_tree: {
    a: "Evergreen Tree",
    b: "1F332",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature"
    ],
    k: [
      6,
      10
    ],
    o: 2
  },
  cupid: {
    a: "Heart with Arrow",
    b: "1F498",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "heart",
      "affection",
      "valentines"
    ],
    k: [
      25,
      34
    ],
    o: 2
  },
  loop: {
    a: "Double Curly Loop",
    b: "27BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tape",
      "cassette"
    ],
    k: [
      55,
      34
    ],
    o: 2
  },
  ship: {
    a: "Ship",
    b: "1F6A2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "titanic",
      "deploy"
    ],
    k: [
      34,
      33
    ],
    o: 2
  },
  farmer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Farmer",
    b: "1F9D1-200D-1F33E",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      17
    ],
    o: 12
  },
  rolled_up_newspaper: {
    a: "Rolled Up Newspaper",
    b: "1F5DE-FE0F",
    c: "1F5DE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      23
    ],
    o: 2
  },
  knife_fork_plate: {
    a: "Knife Fork Plate",
    b: "1F37D-FE0F",
    c: "1F37D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      7,
      28
    ],
    o: 2
  },
  fork_and_knife: {
    a: "Fork and Knife",
    b: "1F374",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cutlery",
      "kitchen"
    ],
    k: [
      7,
      19
    ],
    o: 2
  },
  "male-farmer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Farmer",
    b: "1F468-200D-1F33E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      38
    ],
    o: 4
  },
  bookmark_tabs: {
    a: "Bookmark Tabs",
    b: "1F4D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "favorite",
      "save",
      "order",
      "tidy"
    ],
    k: [
      26,
      39
    ],
    o: 2
  },
  part_alternation_mark: {
    a: "Part Alternation Mark",
    b: "303D-FE0F",
    c: "303D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "graph",
      "presentation",
      "stats",
      "business",
      "economics",
      "bad"
    ],
    k: [
      55,
      45
    ],
    o: 2
  },
  "flag-in": {
    a: "India Flag",
    b: "1F1EE-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      27
    ],
    o: 2
  },
  gift_heart: {
    a: "Heart with Ribbon",
    b: "1F49D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "valentines"
    ],
    k: [
      25,
      39
    ],
    o: 2
  },
  airplane: {
    a: "Airplane",
    b: "2708-FE0F",
    c: "2708",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "transportation",
      "flight",
      "fly"
    ],
    k: [
      54,
      41
    ],
    o: 2
  },
  deciduous_tree: {
    a: "Deciduous Tree",
    b: "1F333",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature"
    ],
    k: [
      6,
      11
    ],
    o: 2
  },
  spoon: {
    a: "Spoon",
    b: "1F944",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cutlery",
      "kitchen",
      "tableware"
    ],
    k: [
      41,
      20
    ],
    o: 4
  },
  "flag-io": {
    a: "British Indian Ocean Territory Flag",
    b: "1F1EE-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      28
    ],
    o: 2
  },
  palm_tree: {
    a: "Palm Tree",
    b: "1F334",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "vegetable",
      "nature",
      "summer",
      "beach",
      "mojito",
      "tropical"
    ],
    k: [
      6,
      12
    ],
    o: 2
  },
  sparkling_heart: {
    a: "Sparkling Heart",
    b: "1F496",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      32
    ],
    o: 2
  },
  "female-farmer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Farmer",
    b: "1F469-200D-1F33E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      28
    ],
    o: 4
  },
  eight_spoked_asterisk: {
    a: "Eight Spoked Asterisk",
    b: "2733-FE0F",
    c: "2733",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "star",
      "sparkle",
      "green-square"
    ],
    k: [
      55,
      17
    ],
    o: 2
  },
  small_airplane: {
    a: "Small Airplane",
    b: "1F6E9-FE0F",
    c: "1F6E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flight",
      "transportation",
      "fly",
      "vehicle"
    ],
    k: [
      36,
      48
    ],
    o: 2
  },
  bookmark: {
    a: "Bookmark",
    b: "1F516",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "favorite",
      "label",
      "save"
    ],
    k: [
      27,
      50
    ],
    o: 2
  },
  cook: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 25,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Cook",
    b: "1F9D1-200D-1F373",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      23
    ],
    o: 12
  },
  eight_pointed_black_star: {
    a: "Eight Pointed Black Star",
    b: "2734-FE0F",
    c: "2734",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "orange-square",
      "shape",
      "polygon"
    ],
    k: [
      55,
      18
    ],
    o: 2
  },
  heartpulse: {
    a: "Growing Heart",
    b: "1F497",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "like",
      "love",
      "affection",
      "valentines",
      "pink"
    ],
    k: [
      25,
      33
    ],
    o: 2
  },
  label: {
    a: "Label",
    b: "1F3F7-FE0F",
    c: "1F3F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sale",
      "tag"
    ],
    k: [
      11,
      19
    ],
    o: 2
  },
  "flag-iq": {
    a: "Iraq Flag",
    b: "1F1EE-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      29
    ],
    o: 2
  },
  hocho: {
    a: "Hocho",
    b: "1F52A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "knife",
      "blade",
      "cutlery",
      "kitchen",
      "weapon"
    ],
    k: [
      28,
      13
    ],
    n: [
      "knife"
    ],
    o: 2
  },
  cactus: {
    a: "Cactus",
    b: "1F335",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "plant",
      "nature"
    ],
    k: [
      6,
      13
    ],
    o: 2
  },
  airplane_departure: {
    a: "Airplane Departure",
    b: "1F6EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      49
    ],
    o: 2
  },
  airplane_arriving: {
    a: "Airplane Arriving",
    b: "1F6EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      50
    ],
    o: 2
  },
  ear_of_rice: {
    a: "Ear of Rice",
    b: "1F33E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant"
    ],
    k: [
      6,
      22
    ],
    o: 2
  },
  "flag-ir": {
    a: "Iran Flag",
    b: "1F1EE-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      30
    ],
    o: 2
  },
  moneybag: {
    a: "Money Bag",
    b: "1F4B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dollar",
      "payment",
      "coins",
      "sale"
    ],
    k: [
      26,
      6
    ],
    o: 2
  },
  "male-cook": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Cook",
    b: "1F468-200D-1F373",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      44
    ],
    o: 4
  },
  heartbeat: {
    a: "Beating Heart",
    b: "1F493",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines",
      "pink",
      "heart"
    ],
    k: [
      25,
      29
    ],
    o: 2
  },
  sparkle: {
    a: "Sparkle",
    b: "2747-FE0F",
    c: "2747",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stars",
      "green-square",
      "awesome",
      "good",
      "fireworks"
    ],
    k: [
      55,
      20
    ],
    o: 2
  },
  amphora: {
    a: "Amphora",
    b: "1F3FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vase",
      "jar"
    ],
    k: [
      11,
      22
    ],
    o: 2
  },
  yen: {
    a: "Banknote with Yen Sign",
    b: "1F4B4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "japanese",
      "dollar",
      "currency"
    ],
    k: [
      26,
      10
    ],
    o: 2
  },
  revolving_hearts: {
    a: "Revolving Hearts",
    b: "1F49E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      40
    ],
    o: 2
  },
  bangbang: {
    a: "Double Exclamation Mark",
    b: "203C-FE0F",
    c: "203C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "exclamation",
      "surprise"
    ],
    k: [
      52,
      10
    ],
    o: 2
  },
  parachute: {
    a: "Parachute",
    b: "1FA82",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      3
    ],
    o: 12
  },
  herb: {
    a: "Herb",
    b: "1F33F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "plant",
      "medicine",
      "weed",
      "grass",
      "lawn"
    ],
    k: [
      6,
      23
    ],
    o: 2
  },
  "flag-is": {
    a: "Iceland Flag",
    b: "1F1EE-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      31
    ],
    o: 2
  },
  "female-cook": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Cook",
    b: "1F469-200D-1F373",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      34
    ],
    o: 4
  },
  mechanic: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 15,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 16,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 17,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Mechanic",
    b: "1F9D1-200D-1F527",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      14
    ],
    o: 12
  },
  interrobang: {
    a: "Exclamation Question Mark",
    b: "2049-FE0F",
    c: "2049",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wat",
      "punctuation",
      "surprise"
    ],
    k: [
      52,
      11
    ],
    o: 2
  },
  seat: {
    a: "Seat",
    b: "1F4BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sit",
      "airplane",
      "transport",
      "bus",
      "flight",
      "fly"
    ],
    k: [
      26,
      16
    ],
    o: 2
  },
  dollar: {
    a: "Banknote with Dollar Sign",
    b: "1F4B5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "bill",
      "currency"
    ],
    k: [
      26,
      11
    ],
    o: 2
  },
  two_hearts: {
    a: "Two Hearts",
    b: "1F495",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines",
      "heart"
    ],
    k: [
      25,
      31
    ],
    o: 2
  },
  it: {
    a: "Italy Flag",
    b: "1F1EE-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "italy",
      "flag",
      "nation",
      "country",
      "banner"
    ],
    k: [
      2,
      32
    ],
    n: [
      "flag-it"
    ],
    o: 2
  },
  shamrock: {
    a: "Shamrock",
    b: "2618-FE0F",
    c: "2618",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "plant",
      "nature",
      "irish",
      "clover"
    ],
    k: [
      53,
      1
    ],
    o: 2
  },
  four_leaf_clover: {
    a: "Four Leaf Clover",
    b: "1F340",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "plant",
      "nature",
      "lucky",
      "irish"
    ],
    k: [
      6,
      24
    ],
    o: 2
  },
  euro: {
    a: "Banknote with Euro Sign",
    b: "1F4B6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "dollar",
      "currency"
    ],
    k: [
      26,
      12
    ],
    o: 2
  },
  question: {
    a: "Black Question Mark Ornament",
    b: "2753",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "doubt",
      "confused"
    ],
    k: [
      55,
      23
    ],
    o: 2
  },
  helicopter: {
    a: "Helicopter",
    b: "1F681",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "fly"
    ],
    k: [
      34,
      0
    ],
    o: 2
  },
  heart_decoration: {
    a: "Heart Decoration",
    b: "1F49F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "love",
      "like"
    ],
    k: [
      25,
      41
    ],
    o: 2
  },
  "flag-je": {
    a: "Jersey Flag",
    b: "1F1EF-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      33
    ],
    o: 2
  },
  "male-mechanic": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Mechanic",
    b: "1F468-200D-1F527",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      50
    ],
    o: 4
  },
  suspension_railway: {
    a: "Suspension Railway",
    b: "1F69F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "transportation"
    ],
    k: [
      34,
      30
    ],
    o: 2
  },
  heavy_heart_exclamation_mark_ornament: {
    a: "Heavy Heart Exclamation Mark Ornament",
    b: "2763-FE0F",
    c: "2763",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      55,
      27
    ],
    o: 2
  },
  "female-mechanic": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Mechanic",
    b: "1F469-200D-1F527",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      35
    ],
    o: 4
  },
  "flag-jm": {
    a: "Jamaica Flag",
    b: "1F1EF-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      34
    ],
    o: 2
  },
  grey_question: {
    a: "White Question Mark Ornament",
    b: "2754",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "doubts",
      "gray",
      "huh",
      "confused"
    ],
    k: [
      55,
      24
    ],
    o: 2
  },
  maple_leaf: {
    a: "Maple Leaf",
    b: "1F341",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "vegetable",
      "ca",
      "fall"
    ],
    k: [
      6,
      25
    ],
    o: 2
  },
  pound: {
    a: "Banknote with Pound Sign",
    b: "1F4B7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "british",
      "sterling",
      "money",
      "sales",
      "bills",
      "uk",
      "england",
      "currency"
    ],
    k: [
      26,
      13
    ],
    o: 2
  },
  money_with_wings: {
    a: "Money with Wings",
    b: "1F4B8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dollar",
      "bills",
      "payment",
      "sale"
    ],
    k: [
      26,
      14
    ],
    o: 2
  },
  "flag-jo": {
    a: "Jordan Flag",
    b: "1F1EF-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      35
    ],
    o: 2
  },
  fallen_leaf: {
    a: "Fallen Leaf",
    b: "1F342",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "vegetable",
      "leaves"
    ],
    k: [
      6,
      26
    ],
    o: 2
  },
  factory_worker: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f3ed.png",
        sheet_x: 45,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f3ed.png",
        sheet_x: 45,
        sheet_y: 55,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f3ed.png",
        sheet_x: 45,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f3ed.png",
        sheet_x: 46,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f3ed.png",
        sheet_x: 46,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Factory Worker",
    b: "1F9D1-200D-1F3ED",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      53
    ],
    o: 12
  },
  broken_heart: {
    a: "Broken Heart",
    b: "1F494",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sad",
      "sorry",
      "break",
      "heart",
      "heartbreak"
    ],
    k: [
      25,
      30
    ],
    l: [
      "</3"
    ],
    m: "</3",
    o: 2
  },
  grey_exclamation: {
    a: "White Exclamation Mark Ornament",
    b: "2755",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "surprise",
      "punctuation",
      "gray",
      "wow",
      "warning"
    ],
    k: [
      55,
      25
    ],
    o: 2
  },
  mountain_cableway: {
    a: "Mountain Cableway",
    b: "1F6A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "ski"
    ],
    k: [
      34,
      31
    ],
    o: 2
  },
  exclamation: {
    a: "Heavy Exclamation Mark Symbol",
    b: "2757",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "heavy_exclamation_mark",
      "danger",
      "surprise",
      "punctuation",
      "wow",
      "warning"
    ],
    k: [
      55,
      26
    ],
    n: [
      "heavy_exclamation_mark"
    ],
    o: 2
  },
  leaves: {
    a: "Leaf Fluttering in Wind",
    b: "1F343",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "tree",
      "vegetable",
      "grass",
      "lawn",
      "spring"
    ],
    k: [
      6,
      27
    ],
    o: 2
  },
  heart: {
    a: "Heavy Black Heart",
    b: "2764-FE0F",
    c: "2764",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "valentines"
    ],
    k: [
      55,
      28
    ],
    l: [
      "<3"
    ],
    m: "<3",
    o: 2
  },
  jp: {
    a: "Japan Flag",
    b: "1F1EF-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "nation",
      "flag",
      "country",
      "banner"
    ],
    k: [
      2,
      36
    ],
    n: [
      "flag-jp"
    ],
    o: 2
  },
  "male-factory-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Factory Worker",
    b: "1F468-200D-1F3ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      17
    ],
    o: 4
  },
  credit_card: {
    a: "Credit Card",
    b: "1F4B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "dollar",
      "bill",
      "payment",
      "shopping"
    ],
    k: [
      26,
      9
    ],
    o: 2
  },
  aerial_tramway: {
    a: "Aerial Tramway",
    b: "1F6A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "ski"
    ],
    k: [
      34,
      32
    ],
    o: 2
  },
  "female-factory-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Factory Worker",
    b: "1F469-200D-1F3ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      7
    ],
    o: 4
  },
  receipt: {
    a: "Receipt",
    b: "1F9FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      49
    ],
    o: 11
  },
  wavy_dash: {
    a: "Wavy Dash",
    b: "3030-FE0F",
    c: "3030",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "draw",
      "line",
      "moustache",
      "mustache",
      "squiggle",
      "scribble"
    ],
    k: [
      55,
      44
    ],
    o: 2
  },
  "flag-ke": {
    a: "Kenya Flag",
    b: "1F1F0-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      37
    ],
    o: 2
  },
  satellite: {
    a: "Satellite",
    b: "1F6F0-FE0F",
    c: "1F6F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "communication",
      "future",
      "radio",
      "space"
    ],
    k: [
      36,
      51
    ],
    o: 2
  },
  orange_heart: {
    a: "Orange Heart",
    b: "1F9E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      20
    ],
    o: 5
  },
  yellow_heart: {
    a: "Yellow Heart",
    b: "1F49B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      37
    ],
    m: "<3",
    o: 2
  },
  copyright: {
    a: "Copyright Sign",
    b: "00A9-FE0F",
    c: "00A9",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "ip",
      "license",
      "circle",
      "law",
      "legal"
    ],
    k: [
      0,
      12
    ],
    o: 2
  },
  rocket: {
    a: "Rocket",
    b: "1F680",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "launch",
      "ship",
      "staffmode",
      "NASA",
      "outer space",
      "outer_space",
      "fly"
    ],
    k: [
      33,
      56
    ],
    o: 2
  },
  chart: {
    a: "Chart with Upwards Trend and Yen Sign",
    b: "1F4B9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "green-square",
      "graph",
      "presentation",
      "stats"
    ],
    k: [
      26,
      15
    ],
    o: 2
  },
  "flag-kg": {
    a: "Kyrgyzstan Flag",
    b: "1F1F0-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      38
    ],
    o: 2
  },
  office_worker: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 10,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 11,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 12,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 13,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Office Worker",
    b: "1F9D1-200D-1F4BC",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      8
    ],
    o: 12
  },
  currency_exchange: {
    a: "Currency Exchange",
    b: "1F4B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "dollar",
      "travel"
    ],
    k: [
      26,
      7
    ],
    o: 2
  },
  registered: {
    a: "Registered Sign",
    b: "00AE-FE0F",
    c: "00AE",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "alphabet",
      "circle"
    ],
    k: [
      0,
      13
    ],
    o: 2
  },
  green_heart: {
    a: "Green Heart",
    b: "1F49A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      36
    ],
    m: "<3",
    o: 2
  },
  flying_saucer: {
    a: "Flying Saucer",
    b: "1F6F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      0
    ],
    o: 5
  },
  "flag-kh": {
    a: "Cambodia Flag",
    b: "1F1F0-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      39
    ],
    o: 2
  },
  "male-office-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Office Worker",
    b: "1F468-200D-1F4BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      44
    ],
    o: 4
  },
  tm: {
    a: "Trade Mark Sign",
    b: "2122-FE0F",
    c: "2122",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "trademark",
      "brand",
      "law",
      "legal"
    ],
    k: [
      52,
      12
    ],
    o: 2
  },
  bellhop_bell: {
    a: "Bellhop Bell",
    b: "1F6CE-FE0F",
    c: "1F6CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "service"
    ],
    k: [
      36,
      36
    ],
    o: 2
  },
  blue_heart: {
    a: "Blue Heart",
    b: "1F499",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      35
    ],
    m: "<3",
    o: 2
  },
  "flag-ki": {
    a: "Kiribati Flag",
    b: "1F1F0-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      40
    ],
    o: 2
  },
  heavy_dollar_sign: {
    a: "Heavy Dollar Sign",
    b: "1F4B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "payment",
      "currency",
      "buck"
    ],
    k: [
      26,
      8
    ],
    o: 2
  },
  "female-office-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Office Worker",
    b: "1F469-200D-1F4BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      29
    ],
    o: 4
  },
  purple_heart: {
    a: "Purple Heart",
    b: "1F49C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      38
    ],
    m: "<3",
    o: 2
  },
  scientist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 25,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Scientist",
    b: "1F9D1-200D-1F52C",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      20
    ],
    o: 12
  },
  luggage: {
    a: "Luggage",
    b: "1F9F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      38
    ],
    o: 11
  },
  hash: {
    a: "Hash Key",
    b: "0023-FE0F-20E3",
    c: "0023-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "symbol",
      "blue-square",
      "twitter"
    ],
    k: [
      0,
      0
    ],
    o: 0
  },
  "flag-km": {
    a: "Comoros Flag",
    b: "1F1F0-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      41
    ],
    o: 2
  },
  email: {
    a: "Envelope",
    b: "2709-FE0F",
    c: "2709",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "letter",
      "postal",
      "inbox",
      "communication"
    ],
    k: [
      54,
      42
    ],
    n: [
      "envelope"
    ],
    o: 2
  },
  "e-mail": {
    a: "E-Mail Symbol",
    b: "1F4E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "communication",
      "inbox"
    ],
    k: [
      27,
      4
    ],
    o: 2
  },
  keycap_star: {
    a: "Keycap Star",
    b: "002A-FE0F-20E3",
    c: "002A-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      0,
      1
    ],
    o: 0
  },
  "flag-kn": {
    a: "St. Kitts & Nevis Flag",
    b: "1F1F0-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      42
    ],
    o: 2
  },
  hourglass: {
    a: "Hourglass",
    b: "231B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "clock",
      "oldschool",
      "limit",
      "exam",
      "quiz",
      "test"
    ],
    k: [
      52,
      23
    ],
    o: 2
  },
  brown_heart: {
    a: "Brown Heart",
    b: "1F90E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      16
    ],
    o: 12
  },
  "male-scientist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Scientist",
    b: "1F468-200D-1F52C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      56
    ],
    o: 4
  },
  hourglass_flowing_sand: {
    a: "Hourglass with Flowing Sand",
    b: "23F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "oldschool",
      "time",
      "countdown"
    ],
    k: [
      52,
      36
    ],
    o: 2
  },
  black_heart: {
    a: "Black Heart",
    b: "1F5A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "evil"
    ],
    k: [
      30,
      9
    ],
    o: 4
  },
  zero: {
    a: "Keycap 0",
    b: "0030-FE0F-20E3",
    c: "0030-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "0",
      "numbers",
      "blue-square",
      "null"
    ],
    k: [
      0,
      2
    ],
    o: 0
  },
  incoming_envelope: {
    a: "Incoming Envelope",
    b: "1F4E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "inbox"
    ],
    k: [
      27,
      5
    ],
    o: 2
  },
  "flag-kp": {
    a: "North Korea Flag",
    b: "1F1F0-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      43
    ],
    o: 2
  },
  "female-scientist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Scientist",
    b: "1F469-200D-1F52C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      41
    ],
    o: 4
  },
  watch: {
    a: "Watch",
    b: "231A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "accessories"
    ],
    k: [
      52,
      22
    ],
    o: 2
  },
  white_heart: {
    a: "White Heart",
    b: "1F90D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      15
    ],
    o: 12
  },
  one: {
    a: "Keycap 1",
    b: "0031-FE0F-20E3",
    c: "0031-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "blue-square",
      "numbers",
      "1"
    ],
    k: [
      0,
      3
    ],
    o: 0
  },
  kr: {
    a: "South Korea Flag",
    b: "1F1F0-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "south",
      "korea",
      "nation",
      "flag",
      "country",
      "banner"
    ],
    k: [
      2,
      44
    ],
    n: [
      "flag-kr"
    ],
    o: 2
  },
  envelope_with_arrow: {
    a: "Envelope with Downwards Arrow Above",
    b: "1F4E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "communication"
    ],
    k: [
      27,
      6
    ],
    o: 2
  },
  technologist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 4,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Technologist",
    b: "1F9D1-200D-1F4BB",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      2
    ],
    o: 12
  },
  outbox_tray: {
    a: "Outbox Tray",
    b: "1F4E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "inbox",
      "email"
    ],
    k: [
      27,
      1
    ],
    o: 2
  },
  "male-technologist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Technologist",
    b: "1F468-200D-1F4BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      38
    ],
    o: 4
  },
  alarm_clock: {
    a: "Alarm Clock",
    b: "23F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "wake"
    ],
    k: [
      52,
      33
    ],
    o: 2
  },
  "flag-kw": {
    a: "Kuwait Flag",
    b: "1F1F0-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      45
    ],
    o: 2
  },
  two: {
    a: "Keycap 2",
    b: "0032-FE0F-20E3",
    c: "0032-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "numbers",
      "2",
      "prime",
      "blue-square"
    ],
    k: [
      0,
      4
    ],
    o: 0
  },
  anger: {
    a: "Anger Symbol",
    b: "1F4A2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "angry",
      "mad"
    ],
    k: [
      25,
      44
    ],
    o: 2
  },
  inbox_tray: {
    a: "Inbox Tray",
    b: "1F4E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "documents"
    ],
    k: [
      27,
      2
    ],
    o: 2
  },
  three: {
    a: "Keycap 3",
    b: "0033-FE0F-20E3",
    c: "0033-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "3",
      "numbers",
      "prime",
      "blue-square"
    ],
    k: [
      0,
      5
    ],
    o: 0
  },
  "flag-ky": {
    a: "Cayman Islands Flag",
    b: "1F1F0-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      46
    ],
    o: 2
  },
  stopwatch: {
    a: "Stopwatch",
    b: "23F1-FE0F",
    c: "23F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "deadline"
    ],
    k: [
      52,
      34
    ],
    o: 2
  },
  "female-technologist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Technologist",
    b: "1F469-200D-1F4BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      23
    ],
    o: 4
  },
  boom: {
    a: "Collision Symbol",
    b: "1F4A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bomb",
      "explode",
      "explosion",
      "collision",
      "blown"
    ],
    k: [
      25,
      47
    ],
    n: [
      "collision"
    ],
    o: 2
  },
  "flag-kz": {
    a: "Kazakhstan Flag",
    b: "1F1F0-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      47
    ],
    o: 2
  },
  four: {
    a: "Keycap 4",
    b: "0034-FE0F-20E3",
    c: "0034-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "4",
      "numbers",
      "blue-square"
    ],
    k: [
      0,
      6
    ],
    o: 0
  },
  timer_clock: {
    a: "Timer Clock",
    b: "23F2-FE0F",
    c: "23F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alarm"
    ],
    k: [
      52,
      35
    ],
    o: 2
  },
  singer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 37,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 38,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Singer",
    b: "1F9D1-200D-1F3A4",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      35
    ],
    o: 12
  },
  package: {
    a: "Package",
    b: "1F4E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mail",
      "gift",
      "cardboard",
      "box",
      "moving"
    ],
    k: [
      27,
      3
    ],
    o: 2
  },
  mailbox: {
    a: "Closed Mailbox with Raised Flag",
    b: "1F4EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "inbox",
      "communication"
    ],
    k: [
      27,
      8
    ],
    o: 2
  },
  "flag-la": {
    a: "Laos Flag",
    b: "1F1F1-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      48
    ],
    o: 2
  },
  dizzy: {
    a: "Dizzy Symbol",
    b: "1F4AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "star",
      "sparkle",
      "shoot",
      "magic"
    ],
    k: [
      26,
      1
    ],
    o: 2
  },
  five: {
    a: "Keycap 5",
    b: "0035-FE0F-20E3",
    c: "0035-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "5",
      "numbers",
      "blue-square",
      "prime"
    ],
    k: [
      0,
      7
    ],
    o: 0
  },
  "male-singer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Singer",
    b: "1F468-200D-1F3A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      56
    ],
    o: 4
  },
  mantelpiece_clock: {
    a: "Mantelpiece Clock",
    b: "1F570-FE0F",
    c: "1F570",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time"
    ],
    k: [
      29,
      7
    ],
    o: 2
  },
  "female-singer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Singer",
    b: "1F469-200D-1F3A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      46
    ],
    o: 4
  },
  "flag-lb": {
    a: "Lebanon Flag",
    b: "1F1F1-1F1E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      49
    ],
    o: 2
  },
  six: {
    a: "Keycap 6",
    b: "0036-FE0F-20E3",
    c: "0036-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "6",
      "numbers",
      "blue-square"
    ],
    k: [
      0,
      8
    ],
    o: 0
  },
  mailbox_closed: {
    a: "Closed Mailbox with Lowered Flag",
    b: "1F4EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "communication",
      "inbox"
    ],
    k: [
      27,
      7
    ],
    o: 2
  },
  sweat_drops: {
    a: "Splashing Sweat Symbol",
    b: "1F4A6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "water",
      "drip",
      "oops"
    ],
    k: [
      25,
      48
    ],
    o: 2
  },
  clock12: {
    a: "Clock Face Twelve Oclock",
    b: "1F55B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "noon",
      "midnight",
      "midday",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      50
    ],
    o: 2
  },
  seven: {
    a: "Keycap 7",
    b: "0037-FE0F-20E3",
    c: "0037-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "7",
      "numbers",
      "blue-square",
      "prime"
    ],
    k: [
      0,
      9
    ],
    o: 0
  },
  mailbox_with_mail: {
    a: "Open Mailbox with Raised Flag",
    b: "1F4EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "inbox",
      "communication"
    ],
    k: [
      27,
      9
    ],
    o: 2
  },
  clock1230: {
    a: "Clock Face Twelve-Thirty",
    b: "1F567",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      5
    ],
    o: 2
  },
  dash: {
    a: "Dash Symbol",
    b: "1F4A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wind",
      "air",
      "fast",
      "shoo",
      "fart",
      "smoke",
      "puff"
    ],
    k: [
      25,
      50
    ],
    o: 2
  },
  artist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 43,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Artist",
    b: "1F9D1-200D-1F3A8",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      41
    ],
    o: 12
  },
  "flag-lc": {
    a: "St. Lucia Flag",
    b: "1F1F1-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      50
    ],
    o: 2
  },
  hole: {
    a: "Hole",
    b: "1F573-FE0F",
    c: "1F573",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "embarrassing"
    ],
    k: [
      29,
      8
    ],
    o: 2
  },
  "male-artist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Artist",
    b: "1F468-200D-1F3A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      5
    ],
    o: 4
  },
  clock1: {
    a: "Clock Face One Oclock",
    b: "1F550",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      39
    ],
    o: 2
  },
  eight: {
    a: "Keycap 8",
    b: "0038-FE0F-20E3",
    c: "0038-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "8",
      "blue-square",
      "numbers"
    ],
    k: [
      0,
      10
    ],
    o: 0
  },
  mailbox_with_no_mail: {
    a: "Open Mailbox with Lowered Flag",
    b: "1F4ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "inbox"
    ],
    k: [
      27,
      10
    ],
    o: 2
  },
  "flag-li": {
    a: "Liechtenstein Flag",
    b: "1F1F1-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      51
    ],
    o: 2
  },
  bomb: {
    a: "Bomb",
    b: "1F4A3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "boom",
      "explode",
      "explosion",
      "terrorism"
    ],
    k: [
      25,
      45
    ],
    o: 2
  },
  nine: {
    a: "Keycap 9",
    b: "0039-FE0F-20E3",
    c: "0039-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "blue-square",
      "numbers",
      "9"
    ],
    k: [
      0,
      11
    ],
    o: 0
  },
  postbox: {
    a: "Postbox",
    b: "1F4EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "letter",
      "envelope"
    ],
    k: [
      27,
      11
    ],
    o: 2
  },
  "female-artist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f3a8.png",
        sheet_x: 17,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f3a8.png",
        sheet_x: 17,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f3a8.png",
        sheet_x: 17,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f3a8.png",
        sheet_x: 17,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f3a8.png",
        sheet_x: 18,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Artist",
    b: "1F469-200D-1F3A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      52
    ],
    o: 4
  },
  clock130: {
    a: "Clock Face One-Thirty",
    b: "1F55C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      51
    ],
    o: 2
  },
  "flag-lk": {
    a: "Sri Lanka Flag",
    b: "1F1F1-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      52
    ],
    o: 2
  },
  ballot_box_with_ballot: {
    a: "Ballot Box with Ballot",
    b: "1F5F3-FE0F",
    c: "1F5F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      28
    ],
    o: 2
  },
  pilot: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FB-200D-2708",
        image: "1f9d1-1f3fb-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FC-200D-2708",
        image: "1f9d1-1f3fc-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FD-200D-2708",
        image: "1f9d1-1f3fd-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FE-200D-2708",
        image: "1f9d1-1f3fe-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 8,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FF-200D-2708",
        image: "1f9d1-1f3ff-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Pilot",
    b: "1F9D1-200D-2708-FE0F",
    c: "1F9D1-200D-2708",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      48,
      4
    ],
    o: 12
  },
  keycap_ten: {
    a: "Keycap Ten",
    b: "1F51F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "numbers",
      "10",
      "blue-square"
    ],
    k: [
      28,
      2
    ],
    o: 2
  },
  clock2: {
    a: "Clock Face Two Oclock",
    b: "1F551",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      40
    ],
    o: 2
  },
  "flag-lr": {
    a: "Liberia Flag",
    b: "1F1F1-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      53
    ],
    o: 2
  },
  speech_balloon: {
    a: "Speech Balloon",
    b: "1F4AC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bubble",
      "words",
      "message",
      "talk",
      "chatting"
    ],
    k: [
      26,
      2
    ],
    o: 2
  },
  "eye-in-speech-bubble": {
    a: "Eye in Speech Bubble",
    b: "1F441-FE0F-200D-1F5E8-FE0F",
    d: !0,
    e: !0,
    f: !1,
    h: !1,
    k: [
      12,
      37
    ],
    o: 2
  },
  "flag-ls": {
    a: "Lesotho Flag",
    b: "1F1F1-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      54
    ],
    o: 2
  },
  clock230: {
    a: "Clock Face Two-Thirty",
    b: "1F55D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      52
    ],
    o: 2
  },
  "male-pilot": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-2708-FE0F",
        non_qualified: "1F468-1F3FB-200D-2708",
        image: "1f468-1f3fb-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-2708-FE0F",
        non_qualified: "1F468-1F3FC-200D-2708",
        image: "1f468-1f3fc-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-2708-FE0F",
        non_qualified: "1F468-1F3FD-200D-2708",
        image: "1f468-1f3fd-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-2708-FE0F",
        non_qualified: "1F468-1F3FE-200D-2708",
        image: "1f468-1f3fe-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-2708-FE0F",
        non_qualified: "1F468-1F3FF-200D-2708",
        image: "1f468-1f3ff-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Pilot",
    b: "1F468-200D-2708-FE0F",
    c: "1F468-200D-2708",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      14
    ],
    o: 4
  },
  capital_abcd: {
    a: "Input Symbol for Latin Capital Letters",
    b: "1F520",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alphabet",
      "words",
      "blue-square"
    ],
    k: [
      28,
      3
    ],
    o: 2
  },
  pencil2: {
    a: "Pencil",
    b: "270F-FE0F",
    c: "270F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "write",
      "paper",
      "writing",
      "school",
      "study"
    ],
    k: [
      55,
      10
    ],
    o: 2
  },
  "female-pilot": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-2708-FE0F",
        non_qualified: "1F469-1F3FB-200D-2708",
        image: "1f469-1f3fb-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-2708-FE0F",
        non_qualified: "1F469-1F3FC-200D-2708",
        image: "1f469-1f3fc-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-2708-FE0F",
        non_qualified: "1F469-1F3FD-200D-2708",
        image: "1f469-1f3fd-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-2708-FE0F",
        non_qualified: "1F469-1F3FE-200D-2708",
        image: "1f469-1f3fe-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-2708-FE0F",
        non_qualified: "1F469-1F3FF-200D-2708",
        image: "1f469-1f3ff-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Pilot",
    b: "1F469-200D-2708-FE0F",
    c: "1F469-200D-2708",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      56
    ],
    o: 4
  },
  black_nib: {
    a: "Black Nib",
    b: "2712-FE0F",
    c: "2712",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pen",
      "stationery",
      "writing",
      "write"
    ],
    k: [
      55,
      11
    ],
    o: 2
  },
  left_speech_bubble: {
    a: "Left Speech Bubble",
    b: "1F5E8-FE0F",
    c: "1F5E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "message",
      "talk",
      "chatting"
    ],
    k: [
      30,
      26
    ],
    o: 2
  },
  clock3: {
    a: "Clock Face Three Oclock",
    b: "1F552",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      41
    ],
    o: 2
  },
  abcd: {
    a: "Input Symbol for Latin Small Letters",
    b: "1F521",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "alphabet"
    ],
    k: [
      28,
      4
    ],
    o: 2
  },
  "flag-lt": {
    a: "Lithuania Flag",
    b: "1F1F1-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      55
    ],
    o: 2
  },
  clock330: {
    a: "Clock Face Three-Thirty",
    b: "1F55E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      53
    ],
    o: 2
  },
  astronaut: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 31,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Astronaut",
    b: "1F9D1-200D-1F680",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      26
    ],
    o: 12
  },
  "flag-lu": {
    a: "Luxembourg Flag",
    b: "1F1F1-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      56
    ],
    o: 2
  },
  right_anger_bubble: {
    a: "Right Anger Bubble",
    b: "1F5EF-FE0F",
    c: "1F5EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "caption",
      "speech",
      "thinking",
      "mad"
    ],
    k: [
      30,
      27
    ],
    o: 2
  },
  lower_left_fountain_pen: {
    a: "Lower Left Fountain Pen",
    b: "1F58B-FE0F",
    c: "1F58B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      45
    ],
    o: 2
  },
  "male-astronaut": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Astronaut",
    b: "1F468-200D-1F680",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      5
    ],
    o: 4
  },
  thought_balloon: {
    a: "Thought Balloon",
    b: "1F4AD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bubble",
      "cloud",
      "speech",
      "thinking",
      "dream"
    ],
    k: [
      26,
      3
    ],
    o: 2
  },
  symbols: {
    a: "Input Symbol for Symbols",
    b: "1F523",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "music",
      "note",
      "ampersand",
      "percent",
      "glyphs",
      "characters"
    ],
    k: [
      28,
      6
    ],
    o: 2
  },
  clock4: {
    a: "Clock Face Four Oclock",
    b: "1F553",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      42
    ],
    o: 2
  },
  "flag-lv": {
    a: "Latvia Flag",
    b: "1F1F1-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      0
    ],
    o: 2
  },
  lower_left_ballpoint_pen: {
    a: "Lower Left Ballpoint Pen",
    b: "1F58A-FE0F",
    c: "1F58A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      44
    ],
    o: 2
  },
  abc: {
    a: "Input Symbol for Latin Letters",
    b: "1F524",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "alphabet"
    ],
    k: [
      28,
      7
    ],
    o: 2
  },
  zzz: {
    a: "Sleeping Symbol",
    b: "1F4A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sleepy",
      "tired",
      "dream"
    ],
    k: [
      25,
      46
    ],
    o: 2
  },
  lower_left_paintbrush: {
    a: "Lower Left Paintbrush",
    b: "1F58C-FE0F",
    c: "1F58C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      46
    ],
    o: 2
  },
  "female-astronaut": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Astronaut",
    b: "1F469-200D-1F680",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      47
    ],
    o: 4
  },
  "flag-ly": {
    a: "Libya Flag",
    b: "1F1F1-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      1
    ],
    o: 2
  },
  clock430: {
    a: "Clock Face Four-Thirty",
    b: "1F55F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      54
    ],
    o: 2
  },
  "flag-ma": {
    a: "Morocco Flag",
    b: "1F1F2-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      2
    ],
    o: 2
  },
  a: {
    a: "Negative Squared Latin Capital Letter a",
    b: "1F170-FE0F",
    c: "1F170",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "red-square",
      "alphabet",
      "letter"
    ],
    k: [
      0,
      16
    ],
    o: 2
  },
  clock5: {
    a: "Clock Face Five Oclock",
    b: "1F554",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      43
    ],
    o: 2
  },
  lower_left_crayon: {
    a: "Lower Left Crayon",
    b: "1F58D-FE0F",
    c: "1F58D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      47
    ],
    o: 2
  },
  firefighter: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 37,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Firefighter",
    b: "1F9D1-200D-1F692",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      32
    ],
    o: 12
  },
  "male-firefighter": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Firefighter",
    b: "1F468-200D-1F692",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      11
    ],
    o: 4
  },
  memo: {
    a: "Memo",
    b: "1F4DD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "write",
      "documents",
      "stationery",
      "pencil",
      "paper",
      "writing",
      "legal",
      "exam",
      "quiz",
      "test",
      "study",
      "compose"
    ],
    k: [
      26,
      51
    ],
    n: [
      "pencil"
    ],
    o: 2
  },
  ab: {
    a: "Negative Squared Ab",
    b: "1F18E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "red-square",
      "alphabet"
    ],
    k: [
      0,
      20
    ],
    o: 2
  },
  "flag-mc": {
    a: "Monaco Flag",
    b: "1F1F2-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      3
    ],
    o: 2
  },
  clock530: {
    a: "Clock Face Five-Thirty",
    b: "1F560",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      55
    ],
    o: 2
  },
  briefcase: {
    a: "Briefcase",
    b: "1F4BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "business",
      "documents",
      "work",
      "law",
      "legal",
      "job",
      "career"
    ],
    k: [
      26,
      18
    ],
    o: 2
  },
  "female-firefighter": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f692.png",
        sheet_x: 18,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f692.png",
        sheet_x: 18,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f692.png",
        sheet_x: 18,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f692.png",
        sheet_x: 19,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f692.png",
        sheet_x: 19,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Firefighter",
    b: "1F469-200D-1F692",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      53
    ],
    o: 4
  },
  clock6: {
    a: "Clock Face Six Oclock",
    b: "1F555",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule",
      "dawn",
      "dusk"
    ],
    k: [
      28,
      44
    ],
    o: 2
  },
  b: {
    a: "Negative Squared Latin Capital Letter B",
    b: "1F171-FE0F",
    c: "1F171",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "red-square",
      "alphabet",
      "letter"
    ],
    k: [
      0,
      17
    ],
    o: 2
  },
  "flag-md": {
    a: "Moldova Flag",
    b: "1F1F2-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      4
    ],
    o: 2
  },
  clock630: {
    a: "Clock Face Six-Thirty",
    b: "1F561",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      56
    ],
    o: 2
  },
  cl: {
    a: "Squared Cl",
    b: "1F191",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alphabet",
      "words",
      "red-square"
    ],
    k: [
      0,
      21
    ],
    o: 2
  },
  "flag-me": {
    a: "Montenegro Flag",
    b: "1F1F2-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      5
    ],
    o: 2
  },
  file_folder: {
    a: "File Folder",
    b: "1F4C1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "business",
      "office"
    ],
    k: [
      26,
      23
    ],
    o: 2
  },
  cop: {
    skin_variations: {
      "1F3FB": {
        unified: "1F46E-1F3FB",
        non_qualified: null,
        image: "1f46e-1f3fb.png",
        sheet_x: 21,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F46E-1F3FC",
        non_qualified: null,
        image: "1f46e-1f3fc.png",
        sheet_x: 21,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F46E-1F3FD",
        non_qualified: null,
        image: "1f46e-1f3fd.png",
        sheet_x: 21,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F46E-1F3FE",
        non_qualified: null,
        image: "1f46e-1f3fe.png",
        sheet_x: 21,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F46E-1F3FF",
        non_qualified: null,
        image: "1f46e-1f3ff.png",
        sheet_x: 21,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F46E-200D-2642-FE0F",
    a: "Police Officer",
    b: "1F46E",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      21,
      49
    ],
    o: 2
  },
  "male-police-officer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F46E-1F3FB-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FB-200D-2642",
        image: "1f46e-1f3fb-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46E-1F3FC-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FC-200D-2642",
        image: "1f46e-1f3fc-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46E-1F3FD-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FD-200D-2642",
        image: "1f46e-1f3fd-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46E-1F3FE-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FE-200D-2642",
        image: "1f46e-1f3fe-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46E-1F3FF-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FF-200D-2642",
        image: "1f46e-1f3ff-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F46E",
    a: "Male Police Officer",
    b: "1F46E-200D-2642-FE0F",
    c: "1F46E-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      21,
      43
    ],
    o: 4
  },
  cool: {
    a: "Squared Cool",
    b: "1F192",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "blue-square"
    ],
    k: [
      0,
      22
    ],
    o: 2
  },
  clock7: {
    a: "Clock Face Seven Oclock",
    b: "1F556",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      45
    ],
    o: 2
  },
  "flag-mf": {
    a: "St. Martin Flag",
    b: "1F1F2-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      6
    ],
    o: 2
  },
  open_file_folder: {
    a: "Open File Folder",
    b: "1F4C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "load"
    ],
    k: [
      26,
      24
    ],
    o: 2
  },
  card_index_dividers: {
    a: "Card Index Dividers",
    b: "1F5C2-FE0F",
    c: "1F5C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "organizing",
      "business",
      "stationery"
    ],
    k: [
      30,
      15
    ],
    o: 2
  },
  "flag-mg": {
    a: "Madagascar Flag",
    b: "1F1F2-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      7
    ],
    o: 2
  },
  free: {
    a: "Squared Free",
    b: "1F193",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "words"
    ],
    k: [
      0,
      23
    ],
    o: 2
  },
  "female-police-officer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F46E-1F3FB-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FB-200D-2640",
        image: "1f46e-1f3fb-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46E-1F3FC-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FC-200D-2640",
        image: "1f46e-1f3fc-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46E-1F3FD-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FD-200D-2640",
        image: "1f46e-1f3fd-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46E-1F3FE-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FE-200D-2640",
        image: "1f46e-1f3fe-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46E-1F3FF-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FF-200D-2640",
        image: "1f46e-1f3ff-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Police Officer",
    b: "1F46E-200D-2640-FE0F",
    c: "1F46E-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      21,
      37
    ],
    o: 4
  },
  clock730: {
    a: "Clock Face Seven-Thirty",
    b: "1F562",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      0
    ],
    o: 2
  },
  date: {
    a: "Calendar",
    b: "1F4C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "calendar",
      "schedule"
    ],
    k: [
      26,
      27
    ],
    o: 2
  },
  clock8: {
    a: "Clock Face Eight Oclock",
    b: "1F557",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      46
    ],
    o: 2
  },
  information_source: {
    a: "Information Source",
    b: "2139-FE0F",
    c: "2139",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "alphabet",
      "letter"
    ],
    k: [
      52,
      13
    ],
    o: 2
  },
  sleuth_or_spy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F575-1F3FB",
        non_qualified: null,
        image: "1f575-1f3fb.png",
        sheet_x: 29,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F575-1F3FC",
        non_qualified: null,
        image: "1f575-1f3fc.png",
        sheet_x: 29,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F575-1F3FD",
        non_qualified: null,
        image: "1f575-1f3fd.png",
        sheet_x: 29,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F575-1F3FE",
        non_qualified: null,
        image: "1f575-1f3fe.png",
        sheet_x: 29,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F575-1F3FF",
        non_qualified: null,
        image: "1f575-1f3ff.png",
        sheet_x: 29,
        sheet_y: 32,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F575-FE0F-200D-2642-FE0F",
    a: "Sleuth or Spy",
    b: "1F575-FE0F",
    c: "1F575",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      29,
      27
    ],
    o: 2
  },
  "flag-mh": {
    a: "Marshall Islands Flag",
    b: "1F1F2-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      8
    ],
    o: 2
  },
  clock830: {
    a: "Clock Face Eight-Thirty",
    b: "1F563",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      1
    ],
    o: 2
  },
  calendar: {
    a: "Tear-off Calendar",
    b: "1F4C6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "schedule",
      "date",
      "planning"
    ],
    k: [
      26,
      28
    ],
    o: 2
  },
  "male-detective": {
    skin_variations: {
      "1F3FB": {
        unified: "1F575-1F3FB-200D-2642-FE0F",
        non_qualified: "1F575-1F3FB-200D-2642",
        image: "1f575-1f3fb-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F575-1F3FC-200D-2642-FE0F",
        non_qualified: "1F575-1F3FC-200D-2642",
        image: "1f575-1f3fc-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F575-1F3FD-200D-2642-FE0F",
        non_qualified: "1F575-1F3FD-200D-2642",
        image: "1f575-1f3fd-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F575-1F3FE-200D-2642-FE0F",
        non_qualified: "1F575-1F3FE-200D-2642",
        image: "1f575-1f3fe-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F575-1F3FF-200D-2642-FE0F",
        non_qualified: "1F575-1F3FF-200D-2642",
        image: "1f575-1f3ff-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F575-FE0F",
    a: "Male Detective",
    b: "1F575-FE0F-200D-2642-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      29,
      21
    ],
    o: 4
  },
  "flag-mk": {
    a: "North Macedonia Flag",
    b: "1F1F2-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      9
    ],
    o: 2
  },
  id: {
    a: "Squared Id",
    b: "1F194",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "words"
    ],
    k: [
      0,
      24
    ],
    o: 2
  },
  spiral_note_pad: {
    a: "Spiral Note Pad",
    b: "1F5D2-FE0F",
    c: "1F5D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      19
    ],
    o: 2
  },
  "female-detective": {
    skin_variations: {
      "1F3FB": {
        unified: "1F575-1F3FB-200D-2640-FE0F",
        non_qualified: "1F575-1F3FB-200D-2640",
        image: "1f575-1f3fb-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F575-1F3FC-200D-2640-FE0F",
        non_qualified: "1F575-1F3FC-200D-2640",
        image: "1f575-1f3fc-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F575-1F3FD-200D-2640-FE0F",
        non_qualified: "1F575-1F3FD-200D-2640",
        image: "1f575-1f3fd-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F575-1F3FE-200D-2640-FE0F",
        non_qualified: "1F575-1F3FE-200D-2640",
        image: "1f575-1f3fe-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F575-1F3FF-200D-2640-FE0F",
        non_qualified: "1F575-1F3FF-200D-2640",
        image: "1f575-1f3ff-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Detective",
    b: "1F575-FE0F-200D-2640-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      29,
      15
    ],
    o: 4
  },
  clock9: {
    a: "Clock Face Nine Oclock",
    b: "1F558",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      47
    ],
    o: 2
  },
  "flag-ml": {
    a: "Mali Flag",
    b: "1F1F2-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      10
    ],
    o: 2
  },
  m: {
    a: "Circled Latin Capital Letter M",
    b: "24C2-FE0F",
    c: "24C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alphabet",
      "blue-circle",
      "letter"
    ],
    k: [
      52,
      40
    ],
    o: 2
  },
  "flag-mm": {
    a: "Myanmar (burma) Flag",
    b: "1F1F2-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      11
    ],
    o: 2
  },
  clock930: {
    a: "Clock Face Nine-Thirty",
    b: "1F564",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      2
    ],
    o: 2
  },
  guardsman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F482-1F3FB",
        non_qualified: null,
        image: "1f482-1f3fb.png",
        sheet_x: 24,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F482-1F3FC",
        non_qualified: null,
        image: "1f482-1f3fc.png",
        sheet_x: 24,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F482-1F3FD",
        non_qualified: null,
        image: "1f482-1f3fd.png",
        sheet_x: 24,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F482-1F3FE",
        non_qualified: null,
        image: "1f482-1f3fe.png",
        sheet_x: 24,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F482-1F3FF",
        non_qualified: null,
        image: "1f482-1f3ff.png",
        sheet_x: 24,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F482-200D-2642-FE0F",
    a: "Guardsman",
    b: "1F482",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "uk",
      "gb",
      "british",
      "male",
      "guy",
      "royal"
    ],
    k: [
      24,
      20
    ],
    o: 2
  },
  new: {
    a: "Squared New",
    b: "1F195",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "words",
      "start"
    ],
    k: [
      0,
      25
    ],
    o: 2
  },
  spiral_calendar_pad: {
    a: "Spiral Calendar Pad",
    b: "1F5D3-FE0F",
    c: "1F5D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      20
    ],
    o: 2
  },
  ng: {
    a: "Squared Ng",
    b: "1F196",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "words",
      "shape",
      "icon"
    ],
    k: [
      0,
      26
    ],
    o: 2
  },
  card_index: {
    a: "Card Index",
    b: "1F4C7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "business",
      "stationery"
    ],
    k: [
      26,
      29
    ],
    o: 2
  },
  clock10: {
    a: "Clock Face Ten Oclock",
    b: "1F559",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      48
    ],
    o: 2
  },
  "flag-mn": {
    a: "Mongolia Flag",
    b: "1F1F2-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      12
    ],
    o: 2
  },
  "male-guard": {
    skin_variations: {
      "1F3FB": {
        unified: "1F482-1F3FB-200D-2642-FE0F",
        non_qualified: "1F482-1F3FB-200D-2642",
        image: "1f482-1f3fb-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F482-1F3FC-200D-2642-FE0F",
        non_qualified: "1F482-1F3FC-200D-2642",
        image: "1f482-1f3fc-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F482-1F3FD-200D-2642-FE0F",
        non_qualified: "1F482-1F3FD-200D-2642",
        image: "1f482-1f3fd-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F482-1F3FE-200D-2642-FE0F",
        non_qualified: "1F482-1F3FE-200D-2642",
        image: "1f482-1f3fe-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F482-1F3FF-200D-2642-FE0F",
        non_qualified: "1F482-1F3FF-200D-2642",
        image: "1f482-1f3ff-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F482",
    a: "Male Guard",
    b: "1F482-200D-2642-FE0F",
    c: "1F482-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      24,
      14
    ],
    o: 4
  },
  "flag-mo": {
    a: "Macao Sar China Flag",
    b: "1F1F2-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      13
    ],
    o: 2
  },
  clock1030: {
    a: "Clock Face Ten-Thirty",
    b: "1F565",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      3
    ],
    o: 2
  },
  chart_with_upwards_trend: {
    a: "Chart with Upwards Trend",
    b: "1F4C8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "graph",
      "presentation",
      "stats",
      "recovery",
      "business",
      "economics",
      "money",
      "sales",
      "good",
      "success"
    ],
    k: [
      26,
      30
    ],
    o: 2
  },
  o2: {
    a: "Negative Squared Latin Capital Letter O",
    b: "1F17E-FE0F",
    c: "1F17E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alphabet",
      "red-square",
      "letter"
    ],
    k: [
      0,
      18
    ],
    o: 2
  },
  "female-guard": {
    skin_variations: {
      "1F3FB": {
        unified: "1F482-1F3FB-200D-2640-FE0F",
        non_qualified: "1F482-1F3FB-200D-2640",
        image: "1f482-1f3fb-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F482-1F3FC-200D-2640-FE0F",
        non_qualified: "1F482-1F3FC-200D-2640",
        image: "1f482-1f3fc-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F482-1F3FD-200D-2640-FE0F",
        non_qualified: "1F482-1F3FD-200D-2640",
        image: "1f482-1f3fd-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F482-1F3FE-200D-2640-FE0F",
        non_qualified: "1F482-1F3FE-200D-2640",
        image: "1f482-1f3fe-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F482-1F3FF-200D-2640-FE0F",
        non_qualified: "1F482-1F3FF-200D-2640",
        image: "1f482-1f3ff-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Guard",
    b: "1F482-200D-2640-FE0F",
    c: "1F482-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      24,
      8
    ],
    o: 4
  },
  chart_with_downwards_trend: {
    a: "Chart with Downwards Trend",
    b: "1F4C9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "graph",
      "presentation",
      "stats",
      "recession",
      "business",
      "economics",
      "money",
      "sales",
      "bad",
      "failure"
    ],
    k: [
      26,
      31
    ],
    o: 2
  },
  "flag-mp": {
    a: "Northern Mariana Islands Flag",
    b: "1F1F2-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      14
    ],
    o: 2
  },
  ok: {
    a: "Squared Ok",
    b: "1F197",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "good",
      "agree",
      "yes",
      "blue-square"
    ],
    k: [
      0,
      27
    ],
    o: 2
  },
  clock11: {
    a: "Clock Face Eleven Oclock",
    b: "1F55A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      49
    ],
    o: 2
  },
  construction_worker: {
    skin_variations: {
      "1F3FB": {
        unified: "1F477-1F3FB",
        non_qualified: null,
        image: "1f477-1f3fb.png",
        sheet_x: 23,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F477-1F3FC",
        non_qualified: null,
        image: "1f477-1f3fc.png",
        sheet_x: 23,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F477-1F3FD",
        non_qualified: null,
        image: "1f477-1f3fd.png",
        sheet_x: 23,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F477-1F3FE",
        non_qualified: null,
        image: "1f477-1f3fe.png",
        sheet_x: 23,
        sheet_y: 26,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F477-1F3FF",
        non_qualified: null,
        image: "1f477-1f3ff.png",
        sheet_x: 23,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F477-200D-2642-FE0F",
    a: "Construction Worker",
    b: "1F477",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      23,
      22
    ],
    o: 2
  },
  "male-construction-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F477-1F3FB-200D-2642-FE0F",
        non_qualified: "1F477-1F3FB-200D-2642",
        image: "1f477-1f3fb-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F477-1F3FC-200D-2642-FE0F",
        non_qualified: "1F477-1F3FC-200D-2642",
        image: "1f477-1f3fc-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F477-1F3FD-200D-2642-FE0F",
        non_qualified: "1F477-1F3FD-200D-2642",
        image: "1f477-1f3fd-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F477-1F3FE-200D-2642-FE0F",
        non_qualified: "1F477-1F3FE-200D-2642",
        image: "1f477-1f3fe-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F477-1F3FF-200D-2642-FE0F",
        non_qualified: "1F477-1F3FF-200D-2642",
        image: "1f477-1f3ff-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F477",
    a: "Male Construction Worker",
    b: "1F477-200D-2642-FE0F",
    c: "1F477-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      23,
      16
    ],
    o: 4
  },
  clock1130: {
    a: "Clock Face Eleven-Thirty",
    b: "1F566",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      4
    ],
    o: 2
  },
  "flag-mq": {
    a: "Martinique Flag",
    b: "1F1F2-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      15
    ],
    o: 2
  },
  bar_chart: {
    a: "Bar Chart",
    b: "1F4CA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "graph",
      "presentation",
      "stats"
    ],
    k: [
      26,
      32
    ],
    o: 2
  },
  parking: {
    a: "Negative Squared Latin Capital Letter P",
    b: "1F17F-FE0F",
    c: "1F17F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cars",
      "blue-square",
      "alphabet",
      "letter"
    ],
    k: [
      0,
      19
    ],
    o: 2
  },
  new_moon: {
    a: "New Moon Symbol",
    b: "1F311",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      36
    ],
    o: 2
  },
  "female-construction-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F477-1F3FB-200D-2640-FE0F",
        non_qualified: "1F477-1F3FB-200D-2640",
        image: "1f477-1f3fb-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F477-1F3FC-200D-2640-FE0F",
        non_qualified: "1F477-1F3FC-200D-2640",
        image: "1f477-1f3fc-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F477-1F3FD-200D-2640-FE0F",
        non_qualified: "1F477-1F3FD-200D-2640",
        image: "1f477-1f3fd-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F477-1F3FE-200D-2640-FE0F",
        non_qualified: "1F477-1F3FE-200D-2640",
        image: "1f477-1f3fe-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F477-1F3FF-200D-2640-FE0F",
        non_qualified: "1F477-1F3FF-200D-2640",
        image: "1f477-1f3ff-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Construction Worker",
    b: "1F477-200D-2640-FE0F",
    c: "1F477-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      23,
      10
    ],
    o: 4
  },
  sos: {
    a: "Squared Sos",
    b: "1F198",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "help",
      "red-square",
      "words",
      "emergency",
      "911"
    ],
    k: [
      0,
      28
    ],
    o: 2
  },
  clipboard: {
    a: "Clipboard",
    b: "1F4CB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "documents"
    ],
    k: [
      26,
      33
    ],
    o: 2
  },
  "flag-mr": {
    a: "Mauritania Flag",
    b: "1F1F2-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      16
    ],
    o: 2
  },
  prince: {
    skin_variations: {
      "1F3FB": {
        unified: "1F934-1F3FB",
        non_qualified: null,
        image: "1f934-1f3fb.png",
        sheet_x: 39,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F934-1F3FC",
        non_qualified: null,
        image: "1f934-1f3fc.png",
        sheet_x: 39,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F934-1F3FD",
        non_qualified: null,
        image: "1f934-1f3fd.png",
        sheet_x: 39,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F934-1F3FE",
        non_qualified: null,
        image: "1f934-1f3fe.png",
        sheet_x: 39,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F934-1F3FF",
        non_qualified: null,
        image: "1f934-1f3ff.png",
        sheet_x: 39,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Prince",
    b: "1F934",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "boy",
      "man",
      "male",
      "crown",
      "royal",
      "king"
    ],
    k: [
      39,
      17
    ],
    o: 4
  },
  waxing_crescent_moon: {
    a: "Waxing Crescent Moon Symbol",
    b: "1F312",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      37
    ],
    o: 2
  },
  "flag-ms": {
    a: "Montserrat Flag",
    b: "1F1F2-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      17
    ],
    o: 2
  },
  pushpin: {
    a: "Pushpin",
    b: "1F4CC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "mark",
      "here"
    ],
    k: [
      26,
      34
    ],
    o: 2
  },
  up: {
    a: "Squared Up with Exclamation Mark",
    b: "1F199",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "above",
      "high"
    ],
    k: [
      0,
      29
    ],
    o: 2
  },
  "flag-mt": {
    a: "Malta Flag",
    b: "1F1F2-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      18
    ],
    o: 2
  },
  princess: {
    skin_variations: {
      "1F3FB": {
        unified: "1F478-1F3FB",
        non_qualified: null,
        image: "1f478-1f3fb.png",
        sheet_x: 23,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F478-1F3FC",
        non_qualified: null,
        image: "1f478-1f3fc.png",
        sheet_x: 23,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F478-1F3FD",
        non_qualified: null,
        image: "1f478-1f3fd.png",
        sheet_x: 23,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F478-1F3FE",
        non_qualified: null,
        image: "1f478-1f3fe.png",
        sheet_x: 23,
        sheet_y: 32,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F478-1F3FF",
        non_qualified: null,
        image: "1f478-1f3ff.png",
        sheet_x: 23,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Princess",
    b: "1F478",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "girl",
      "woman",
      "female",
      "blond",
      "crown",
      "royal",
      "queen"
    ],
    k: [
      23,
      28
    ],
    o: 2
  },
  round_pushpin: {
    a: "Round Pushpin",
    b: "1F4CD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "location",
      "map",
      "here"
    ],
    k: [
      26,
      35
    ],
    o: 2
  },
  first_quarter_moon: {
    a: "First Quarter Moon Symbol",
    b: "1F313",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      38
    ],
    o: 2
  },
  vs: {
    a: "Squared Vs",
    b: "1F19A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "orange-square"
    ],
    k: [
      0,
      30
    ],
    o: 2
  },
  "flag-mu": {
    a: "Mauritius Flag",
    b: "1F1F2-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      19
    ],
    o: 2
  },
  koko: {
    a: "Squared Katakana Koko",
    b: "1F201",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "here",
      "katakana",
      "japanese",
      "destination"
    ],
    k: [
      5,
      4
    ],
    o: 2
  },
  man_with_turban: {
    skin_variations: {
      "1F3FB": {
        unified: "1F473-1F3FB",
        non_qualified: null,
        image: "1f473-1f3fb.png",
        sheet_x: 22,
        sheet_y: 44,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F473-1F3FC",
        non_qualified: null,
        image: "1f473-1f3fc.png",
        sheet_x: 22,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F473-1F3FD",
        non_qualified: null,
        image: "1f473-1f3fd.png",
        sheet_x: 22,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F473-1F3FE",
        non_qualified: null,
        image: "1f473-1f3fe.png",
        sheet_x: 22,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F473-1F3FF",
        non_qualified: null,
        image: "1f473-1f3ff.png",
        sheet_x: 22,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F473-200D-2642-FE0F",
    a: "Man with Turban",
    b: "1F473",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "male",
      "indian",
      "hinduism",
      "arabs"
    ],
    k: [
      22,
      43
    ],
    o: 2
  },
  moon: {
    a: "Waxing Gibbous Moon Symbol",
    b: "1F314",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      39
    ],
    n: [
      "waxing_gibbous_moon"
    ],
    o: 2
  },
  paperclip: {
    a: "Paperclip",
    b: "1F4CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "stationery"
    ],
    k: [
      26,
      36
    ],
    o: 2
  },
  linked_paperclips: {
    a: "Linked Paperclips",
    b: "1F587-FE0F",
    c: "1F587",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      43
    ],
    o: 2
  },
  "man-wearing-turban": {
    skin_variations: {
      "1F3FB": {
        unified: "1F473-1F3FB-200D-2642-FE0F",
        non_qualified: "1F473-1F3FB-200D-2642",
        image: "1f473-1f3fb-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F473-1F3FC-200D-2642-FE0F",
        non_qualified: "1F473-1F3FC-200D-2642",
        image: "1f473-1f3fc-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F473-1F3FD-200D-2642-FE0F",
        non_qualified: "1F473-1F3FD-200D-2642",
        image: "1f473-1f3fd-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F473-1F3FE-200D-2642-FE0F",
        non_qualified: "1F473-1F3FE-200D-2642",
        image: "1f473-1f3fe-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F473-1F3FF-200D-2642-FE0F",
        non_qualified: "1F473-1F3FF-200D-2642",
        image: "1f473-1f3ff-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F473",
    a: "Man Wearing Turban",
    b: "1F473-200D-2642-FE0F",
    c: "1F473-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      37
    ],
    o: 4
  },
  sa: {
    a: "Squared Katakana Sa",
    b: "1F202-FE0F",
    c: "1F202",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "blue-square",
      "katakana"
    ],
    k: [
      5,
      5
    ],
    o: 2
  },
  full_moon: {
    a: "Full Moon Symbol",
    b: "1F315",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "yellow",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      40
    ],
    o: 2
  },
  "flag-mv": {
    a: "Maldives Flag",
    b: "1F1F2-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      20
    ],
    o: 2
  },
  "flag-mw": {
    a: "Malawi Flag",
    b: "1F1F2-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      21
    ],
    o: 2
  },
  waning_gibbous_moon: {
    a: "Waning Gibbous Moon Symbol",
    b: "1F316",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep",
      "waxing_gibbous_moon"
    ],
    k: [
      5,
      41
    ],
    o: 2
  },
  "woman-wearing-turban": {
    skin_variations: {
      "1F3FB": {
        unified: "1F473-1F3FB-200D-2640-FE0F",
        non_qualified: "1F473-1F3FB-200D-2640",
        image: "1f473-1f3fb-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F473-1F3FC-200D-2640-FE0F",
        non_qualified: "1F473-1F3FC-200D-2640",
        image: "1f473-1f3fc-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F473-1F3FD-200D-2640-FE0F",
        non_qualified: "1F473-1F3FD-200D-2640",
        image: "1f473-1f3fd-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F473-1F3FE-200D-2640-FE0F",
        non_qualified: "1F473-1F3FE-200D-2640",
        image: "1f473-1f3fe-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F473-1F3FF-200D-2640-FE0F",
        non_qualified: "1F473-1F3FF-200D-2640",
        image: "1f473-1f3ff-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Wearing Turban",
    b: "1F473-200D-2640-FE0F",
    c: "1F473-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      31
    ],
    o: 4
  },
  u6708: {
    a: "Squared Cjk Unified Ideograph-6708",
    b: "1F237-FE0F",
    c: "1F237",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "month",
      "moon",
      "japanese",
      "orange-square",
      "kanji"
    ],
    k: [
      5,
      13
    ],
    o: 2
  },
  straight_ruler: {
    a: "Straight Ruler",
    b: "1F4CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "calculate",
      "length",
      "math",
      "school",
      "drawing",
      "architect",
      "sketch"
    ],
    k: [
      26,
      37
    ],
    o: 2
  },
  u6709: {
    a: "Squared Cjk Unified Ideograph-6709",
    b: "1F236",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "orange-square",
      "chinese",
      "have",
      "kanji"
    ],
    k: [
      5,
      12
    ],
    o: 2
  },
  triangular_ruler: {
    a: "Triangular Ruler",
    b: "1F4D0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "math",
      "architect",
      "sketch"
    ],
    k: [
      26,
      38
    ],
    o: 2
  },
  man_with_gua_pi_mao: {
    skin_variations: {
      "1F3FB": {
        unified: "1F472-1F3FB",
        non_qualified: null,
        image: "1f472-1f3fb.png",
        sheet_x: 22,
        sheet_y: 26,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F472-1F3FC",
        non_qualified: null,
        image: "1f472-1f3fc.png",
        sheet_x: 22,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F472-1F3FD",
        non_qualified: null,
        image: "1f472-1f3fd.png",
        sheet_x: 22,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F472-1F3FE",
        non_qualified: null,
        image: "1f472-1f3fe.png",
        sheet_x: 22,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F472-1F3FF",
        non_qualified: null,
        image: "1f472-1f3ff.png",
        sheet_x: 22,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man with Gua Pi Mao",
    b: "1F472",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "male",
      "boy",
      "chinese"
    ],
    k: [
      22,
      25
    ],
    o: 2
  },
  "flag-mx": {
    a: "Mexico Flag",
    b: "1F1F2-1F1FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      22
    ],
    o: 2
  },
  last_quarter_moon: {
    a: "Last Quarter Moon Symbol",
    b: "1F317",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      42
    ],
    o: 2
  },
  person_with_headscarf: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D5-1F3FB",
        non_qualified: null,
        image: "1f9d5-1f3fb.png",
        sheet_x: 48,
        sheet_y: 35,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D5-1F3FC",
        non_qualified: null,
        image: "1f9d5-1f3fc.png",
        sheet_x: 48,
        sheet_y: 36,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D5-1F3FD",
        non_qualified: null,
        image: "1f9d5-1f3fd.png",
        sheet_x: 48,
        sheet_y: 37,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D5-1F3FE",
        non_qualified: null,
        image: "1f9d5-1f3fe.png",
        sheet_x: 48,
        sheet_y: 38,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D5-1F3FF",
        non_qualified: null,
        image: "1f9d5-1f3ff.png",
        sheet_x: 48,
        sheet_y: 39,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Person with Headscarf",
    b: "1F9D5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      34
    ],
    o: 5
  },
  waning_crescent_moon: {
    a: "Waning Crescent Moon Symbol",
    b: "1F318",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      43
    ],
    o: 2
  },
  u6307: {
    a: "Squared Cjk Unified Ideograph-6307",
    b: "1F22F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "point",
      "green-square",
      "kanji"
    ],
    k: [
      5,
      7
    ],
    o: 2
  },
  scissors: {
    a: "Black Scissors",
    b: "2702-FE0F",
    c: "2702",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "cut"
    ],
    k: [
      54,
      39
    ],
    o: 2
  },
  "flag-my": {
    a: "Malaysia Flag",
    b: "1F1F2-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      23
    ],
    o: 2
  },
  ideograph_advantage: {
    a: "Circled Ideograph Advantage",
    b: "1F250",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "kanji",
      "obtain",
      "get",
      "circle"
    ],
    k: [
      5,
      17
    ],
    o: 2
  },
  man_in_tuxedo: {
    skin_variations: {
      "1F3FB": {
        unified: "1F935-1F3FB",
        non_qualified: null,
        image: "1f935-1f3fb.png",
        sheet_x: 39,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F935-1F3FC",
        non_qualified: null,
        image: "1f935-1f3fc.png",
        sheet_x: 39,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F935-1F3FD",
        non_qualified: null,
        image: "1f935-1f3fd.png",
        sheet_x: 39,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F935-1F3FE",
        non_qualified: null,
        image: "1f935-1f3fe.png",
        sheet_x: 39,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F935-1F3FF",
        non_qualified: null,
        image: "1f935-1f3ff.png",
        sheet_x: 39,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Tuxedo",
    b: "1F935",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "couple",
      "marriage",
      "wedding",
      "groom"
    ],
    k: [
      39,
      23
    ],
    o: 4
  },
  "flag-mz": {
    a: "Mozambique Flag",
    b: "1F1F2-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      24
    ],
    o: 2
  },
  card_file_box: {
    a: "Card File Box",
    b: "1F5C3-FE0F",
    c: "1F5C3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "business",
      "stationery"
    ],
    k: [
      30,
      16
    ],
    o: 2
  },
  crescent_moon: {
    a: "Crescent Moon",
    b: "1F319",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "night",
      "sleep",
      "sky",
      "evening",
      "magic"
    ],
    k: [
      5,
      44
    ],
    o: 2
  },
  "flag-na": {
    a: "Namibia Flag",
    b: "1F1F3-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      25
    ],
    o: 2
  },
  bride_with_veil: {
    skin_variations: {
      "1F3FB": {
        unified: "1F470-1F3FB",
        non_qualified: null,
        image: "1f470-1f3fb.png",
        sheet_x: 22,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F470-1F3FC",
        non_qualified: null,
        image: "1f470-1f3fc.png",
        sheet_x: 22,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F470-1F3FD",
        non_qualified: null,
        image: "1f470-1f3fd.png",
        sheet_x: 22,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F470-1F3FE",
        non_qualified: null,
        image: "1f470-1f3fe.png",
        sheet_x: 22,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F470-1F3FF",
        non_qualified: null,
        image: "1f470-1f3ff.png",
        sheet_x: 22,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bride with Veil",
    b: "1F470",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "couple",
      "marriage",
      "wedding",
      "woman",
      "bride"
    ],
    k: [
      22,
      1
    ],
    o: 2
  },
  new_moon_with_face: {
    a: "New Moon with Face",
    b: "1F31A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      45
    ],
    o: 2
  },
  file_cabinet: {
    a: "File Cabinet",
    b: "1F5C4-FE0F",
    c: "1F5C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "filing",
      "organizing"
    ],
    k: [
      30,
      17
    ],
    o: 2
  },
  u5272: {
    a: "Squared Cjk Unified Ideograph-5272",
    b: "1F239",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cut",
      "divide",
      "chinese",
      "kanji",
      "pink-square"
    ],
    k: [
      5,
      15
    ],
    o: 2
  },
  wastebasket: {
    a: "Wastebasket",
    b: "1F5D1-FE0F",
    c: "1F5D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bin",
      "trash",
      "rubbish",
      "garbage",
      "toss"
    ],
    k: [
      30,
      18
    ],
    o: 2
  },
  pregnant_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F930-1F3FB",
        non_qualified: null,
        image: "1f930-1f3fb.png",
        sheet_x: 38,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F930-1F3FC",
        non_qualified: null,
        image: "1f930-1f3fc.png",
        sheet_x: 38,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F930-1F3FD",
        non_qualified: null,
        image: "1f930-1f3fd.png",
        sheet_x: 38,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F930-1F3FE",
        non_qualified: null,
        image: "1f930-1f3fe.png",
        sheet_x: 38,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F930-1F3FF",
        non_qualified: null,
        image: "1f930-1f3ff.png",
        sheet_x: 38,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Pregnant Woman",
    b: "1F930",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "baby"
    ],
    k: [
      38,
      50
    ],
    o: 4
  },
  first_quarter_moon_with_face: {
    a: "First Quarter Moon with Face",
    b: "1F31B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      46
    ],
    o: 2
  },
  "flag-nc": {
    a: "New Caledonia Flag",
    b: "1F1F3-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      26
    ],
    o: 2
  },
  u7121: {
    a: "Squared Cjk Unified Ideograph-7121",
    b: "1F21A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nothing",
      "chinese",
      "kanji",
      "japanese",
      "orange-square"
    ],
    k: [
      5,
      6
    ],
    o: 2
  },
  lock: {
    a: "Lock",
    b: "1F512",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "security",
      "password",
      "padlock"
    ],
    k: [
      27,
      46
    ],
    o: 2
  },
  "flag-ne": {
    a: "Niger Flag",
    b: "1F1F3-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      27
    ],
    o: 2
  },
  last_quarter_moon_with_face: {
    a: "Last Quarter Moon with Face",
    b: "1F31C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      47
    ],
    o: 2
  },
  "breast-feeding": {
    skin_variations: {
      "1F3FB": {
        unified: "1F931-1F3FB",
        non_qualified: null,
        image: "1f931-1f3fb.png",
        sheet_x: 39,
        sheet_y: 0,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F931-1F3FC",
        non_qualified: null,
        image: "1f931-1f3fc.png",
        sheet_x: 39,
        sheet_y: 1,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F931-1F3FD",
        non_qualified: null,
        image: "1f931-1f3fd.png",
        sheet_x: 39,
        sheet_y: 2,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F931-1F3FE",
        non_qualified: null,
        image: "1f931-1f3fe.png",
        sheet_x: 39,
        sheet_y: 3,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F931-1F3FF",
        non_qualified: null,
        image: "1f931-1f3ff.png",
        sheet_x: 39,
        sheet_y: 4,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Breast-Feeding",
    b: "1F931",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      56
    ],
    o: 5
  },
  u7981: {
    a: "Squared Cjk Unified Ideograph-7981",
    b: "1F232",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "kanji",
      "japanese",
      "chinese",
      "forbidden",
      "limit",
      "restricted",
      "red-square"
    ],
    k: [
      5,
      8
    ],
    o: 2
  },
  accept: {
    a: "Circled Ideograph Accept",
    b: "1F251",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ok",
      "good",
      "chinese",
      "kanji",
      "agree",
      "yes",
      "orange-circle"
    ],
    k: [
      5,
      18
    ],
    o: 2
  },
  angel: {
    skin_variations: {
      "1F3FB": {
        unified: "1F47C-1F3FB",
        non_qualified: null,
        image: "1f47c-1f3fb.png",
        sheet_x: 23,
        sheet_y: 38,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F47C-1F3FC",
        non_qualified: null,
        image: "1f47c-1f3fc.png",
        sheet_x: 23,
        sheet_y: 39,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F47C-1F3FD",
        non_qualified: null,
        image: "1f47c-1f3fd.png",
        sheet_x: 23,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F47C-1F3FE",
        non_qualified: null,
        image: "1f47c-1f3fe.png",
        sheet_x: 23,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F47C-1F3FF",
        non_qualified: null,
        image: "1f47c-1f3ff.png",
        sheet_x: 23,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Baby Angel",
    b: "1F47C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "heaven",
      "wings",
      "halo"
    ],
    k: [
      23,
      37
    ],
    o: 2
  },
  unlock: {
    a: "Open Lock",
    b: "1F513",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "privacy",
      "security"
    ],
    k: [
      27,
      47
    ],
    o: 2
  },
  "flag-nf": {
    a: "Norfolk Island Flag",
    b: "1F1F3-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      28
    ],
    o: 2
  },
  thermometer: {
    a: "Thermometer",
    b: "1F321-FE0F",
    c: "1F321",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "temperature",
      "hot",
      "cold"
    ],
    k: [
      5,
      52
    ],
    o: 2
  },
  "flag-ng": {
    a: "Nigeria Flag",
    b: "1F1F3-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      29
    ],
    o: 2
  },
  u7533: {
    a: "Squared Cjk Unified Ideograph-7533",
    b: "1F238",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "japanese",
      "kanji",
      "orange-square"
    ],
    k: [
      5,
      14
    ],
    o: 2
  },
  sunny: {
    a: "Black Sun with Rays",
    b: "2600-FE0F",
    c: "2600",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "nature",
      "brightness",
      "summer",
      "beach",
      "spring"
    ],
    k: [
      52,
      49
    ],
    o: 2
  },
  lock_with_ink_pen: {
    a: "Lock with Ink Pen",
    b: "1F50F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "security",
      "secret"
    ],
    k: [
      27,
      43
    ],
    o: 2
  },
  santa: {
    skin_variations: {
      "1F3FB": {
        unified: "1F385-1F3FB",
        non_qualified: null,
        image: "1f385-1f3fb.png",
        sheet_x: 7,
        sheet_y: 37,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F385-1F3FC",
        non_qualified: null,
        image: "1f385-1f3fc.png",
        sheet_x: 7,
        sheet_y: 38,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F385-1F3FD",
        non_qualified: null,
        image: "1f385-1f3fd.png",
        sheet_x: 7,
        sheet_y: 39,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F385-1F3FE",
        non_qualified: null,
        image: "1f385-1f3fe.png",
        sheet_x: 7,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F385-1F3FF",
        non_qualified: null,
        image: "1f385-1f3ff.png",
        sheet_x: 7,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Father Christmas",
    b: "1F385",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "festival",
      "man",
      "male",
      "xmas",
      "father christmas"
    ],
    k: [
      7,
      36
    ],
    o: 2
  },
  closed_lock_with_key: {
    a: "Closed Lock with Key",
    b: "1F510",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "security",
      "privacy"
    ],
    k: [
      27,
      44
    ],
    o: 2
  },
  u5408: {
    a: "Squared Cjk Unified Ideograph-5408",
    b: "1F234",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "chinese",
      "join",
      "kanji",
      "red-square"
    ],
    k: [
      5,
      10
    ],
    o: 2
  },
  "flag-ni": {
    a: "Nicaragua Flag",
    b: "1F1F3-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      30
    ],
    o: 2
  },
  mrs_claus: {
    skin_variations: {
      "1F3FB": {
        unified: "1F936-1F3FB",
        non_qualified: null,
        image: "1f936-1f3fb.png",
        sheet_x: 39,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F936-1F3FC",
        non_qualified: null,
        image: "1f936-1f3fc.png",
        sheet_x: 39,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F936-1F3FD",
        non_qualified: null,
        image: "1f936-1f3fd.png",
        sheet_x: 39,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F936-1F3FE",
        non_qualified: null,
        image: "1f936-1f3fe.png",
        sheet_x: 39,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F936-1F3FF",
        non_qualified: null,
        image: "1f936-1f3ff.png",
        sheet_x: 39,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Mother Christmas",
    b: "1F936",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "woman",
      "female",
      "xmas",
      "mother christmas"
    ],
    k: [
      39,
      29
    ],
    n: [
      "mother_christmas"
    ],
    o: 4
  },
  full_moon_with_face: {
    a: "Full Moon with Face",
    b: "1F31D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      48
    ],
    o: 2
  },
  key: {
    a: "Key",
    b: "1F511",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "lock",
      "door",
      "password"
    ],
    k: [
      27,
      45
    ],
    o: 2
  },
  superhero: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B8-1F3FB",
        non_qualified: null,
        image: "1f9b8-1f3fb.png",
        sheet_x: 43,
        sheet_y: 31,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B8-1F3FC",
        non_qualified: null,
        image: "1f9b8-1f3fc.png",
        sheet_x: 43,
        sheet_y: 32,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B8-1F3FD",
        non_qualified: null,
        image: "1f9b8-1f3fd.png",
        sheet_x: 43,
        sheet_y: 33,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B8-1F3FE",
        non_qualified: null,
        image: "1f9b8-1f3fe.png",
        sheet_x: 43,
        sheet_y: 34,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B8-1F3FF",
        non_qualified: null,
        image: "1f9b8-1f3ff.png",
        sheet_x: 43,
        sheet_y: 35,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Superhero",
    b: "1F9B8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      30
    ],
    o: 11
  },
  "flag-nl": {
    a: "Netherlands Flag",
    b: "1F1F3-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      31
    ],
    o: 2
  },
  u7a7a: {
    a: "Squared Cjk Unified Ideograph-7a7a",
    b: "1F233",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "kanji",
      "japanese",
      "chinese",
      "empty",
      "sky",
      "blue-square"
    ],
    k: [
      5,
      9
    ],
    o: 2
  },
  sun_with_face: {
    a: "Sun with Face",
    b: "1F31E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "morning",
      "sky"
    ],
    k: [
      5,
      49
    ],
    o: 2
  },
  male_superhero: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B8-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FB-200D-2642",
        image: "1f9b8-1f3fb-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 25,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B8-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FC-200D-2642",
        image: "1f9b8-1f3fc-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 26,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B8-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FD-200D-2642",
        image: "1f9b8-1f3fd-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 27,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B8-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FE-200D-2642",
        image: "1f9b8-1f3fe-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 28,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B8-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FF-200D-2642",
        image: "1f9b8-1f3ff-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 29,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Superhero",
    b: "1F9B8-200D-2642-FE0F",
    c: "1F9B8-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      24
    ],
    o: 11
  },
  ringed_planet: {
    a: "Ringed Planet",
    b: "1FA90",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      4
    ],
    o: 12
  },
  old_key: {
    a: "Old Key",
    b: "1F5DD-FE0F",
    c: "1F5DD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "lock",
      "door",
      "password"
    ],
    k: [
      30,
      22
    ],
    o: 2
  },
  congratulations: {
    a: "Circled Ideograph Congratulation",
    b: "3297-FE0F",
    c: "3297",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "kanji",
      "japanese",
      "red-circle"
    ],
    k: [
      55,
      46
    ],
    o: 2
  },
  "flag-no": {
    a: "Norway Flag",
    b: "1F1F3-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      32
    ],
    o: 2
  },
  star: {
    a: "White Medium Star",
    b: "2B50",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "night",
      "yellow"
    ],
    k: [
      55,
      42
    ],
    o: 2
  },
  secret: {
    a: "Circled Ideograph Secret",
    b: "3299-FE0F",
    c: "3299",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "privacy",
      "chinese",
      "sshh",
      "kanji",
      "red-circle"
    ],
    k: [
      55,
      47
    ],
    o: 2
  },
  "flag-np": {
    a: "Nepal Flag",
    b: "1F1F3-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      33
    ],
    o: 2
  },
  female_superhero: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B8-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FB-200D-2640",
        image: "1f9b8-1f3fb-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 19,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B8-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FC-200D-2640",
        image: "1f9b8-1f3fc-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 20,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B8-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FD-200D-2640",
        image: "1f9b8-1f3fd-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 21,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B8-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FE-200D-2640",
        image: "1f9b8-1f3fe-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 22,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B8-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FF-200D-2640",
        image: "1f9b8-1f3ff-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 23,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Superhero",
    b: "1F9B8-200D-2640-FE0F",
    c: "1F9B8-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      18
    ],
    o: 11
  },
  hammer: {
    a: "Hammer",
    b: "1F528",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "build",
      "create"
    ],
    k: [
      28,
      11
    ],
    o: 2
  },
  star2: {
    a: "Glowing Star",
    b: "1F31F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "night",
      "sparkle",
      "awesome",
      "good",
      "magic"
    ],
    k: [
      5,
      50
    ],
    o: 2
  },
  "flag-nr": {
    a: "Nauru Flag",
    b: "1F1F3-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      34
    ],
    o: 2
  },
  axe: {
    a: "Axe",
    b: "1FA93",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      7
    ],
    o: 12
  },
  u55b6: {
    a: "Squared Cjk Unified Ideograph-55b6",
    b: "1F23A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "opening hours",
      "orange-square"
    ],
    k: [
      5,
      16
    ],
    o: 2
  },
  supervillain: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B9-1F3FB",
        non_qualified: null,
        image: "1f9b9-1f3fb.png",
        sheet_x: 43,
        sheet_y: 49,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B9-1F3FC",
        non_qualified: null,
        image: "1f9b9-1f3fc.png",
        sheet_x: 43,
        sheet_y: 50,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B9-1F3FD",
        non_qualified: null,
        image: "1f9b9-1f3fd.png",
        sheet_x: 43,
        sheet_y: 51,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B9-1F3FE",
        non_qualified: null,
        image: "1f9b9-1f3fe.png",
        sheet_x: 43,
        sheet_y: 52,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B9-1F3FF",
        non_qualified: null,
        image: "1f9b9-1f3ff.png",
        sheet_x: 43,
        sheet_y: 53,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Supervillain",
    b: "1F9B9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      48
    ],
    o: 11
  },
  stars: {
    a: "Shooting Star",
    b: "1F320",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "night",
      "photo"
    ],
    k: [
      5,
      51
    ],
    o: 2
  },
  u6e80: {
    a: "Squared Cjk Unified Ideograph-6e80",
    b: "1F235",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "full",
      "chinese",
      "japanese",
      "red-square",
      "kanji"
    ],
    k: [
      5,
      11
    ],
    o: 2
  },
  "flag-nu": {
    a: "Niue Flag",
    b: "1F1F3-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      35
    ],
    o: 2
  },
  pick: {
    a: "Pick",
    b: "26CF-FE0F",
    c: "26CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "dig"
    ],
    k: [
      54,
      5
    ],
    o: 2
  },
  male_supervillain: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B9-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FB-200D-2642",
        image: "1f9b9-1f3fb-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 43,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B9-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FC-200D-2642",
        image: "1f9b9-1f3fc-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 44,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B9-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FD-200D-2642",
        image: "1f9b9-1f3fd-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 45,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B9-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FE-200D-2642",
        image: "1f9b9-1f3fe-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 46,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B9-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FF-200D-2642",
        image: "1f9b9-1f3ff-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 47,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Supervillain",
    b: "1F9B9-200D-2642-FE0F",
    c: "1F9B9-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      42
    ],
    o: 11
  },
  female_supervillain: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B9-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FB-200D-2640",
        image: "1f9b9-1f3fb-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 37,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B9-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FC-200D-2640",
        image: "1f9b9-1f3fc-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 38,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B9-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FD-200D-2640",
        image: "1f9b9-1f3fd-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 39,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B9-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FE-200D-2640",
        image: "1f9b9-1f3fe-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 40,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B9-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FF-200D-2640",
        image: "1f9b9-1f3ff-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 41,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Supervillain",
    b: "1F9B9-200D-2640-FE0F",
    c: "1F9B9-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      36
    ],
    o: 11
  },
  hammer_and_pick: {
    a: "Hammer and Pick",
    b: "2692-FE0F",
    c: "2692",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "build",
      "create"
    ],
    k: [
      53,
      41
    ],
    o: 2
  },
  milky_way: {
    a: "Milky Way",
    b: "1F30C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "space",
      "stars"
    ],
    k: [
      5,
      31
    ],
    o: 2
  },
  red_circle: {
    a: "Large Red Circle",
    b: "1F534",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "error",
      "danger"
    ],
    k: [
      28,
      23
    ],
    o: 2
  },
  "flag-nz": {
    a: "New Zealand Flag",
    b: "1F1F3-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      36
    ],
    o: 2
  },
  large_orange_circle: {
    a: "Large Orange Circle",
    b: "1F7E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      3
    ],
    o: 12
  },
  hammer_and_wrench: {
    a: "Hammer and Wrench",
    b: "1F6E0-FE0F",
    c: "1F6E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "build",
      "create"
    ],
    k: [
      36,
      42
    ],
    o: 2
  },
  "flag-om": {
    a: "Oman Flag",
    b: "1F1F4-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      37
    ],
    o: 2
  },
  cloud: {
    a: "Cloud",
    b: "2601-FE0F",
    c: "2601",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "sky"
    ],
    k: [
      52,
      50
    ],
    o: 2
  },
  mage: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D9-1F3FB",
        non_qualified: null,
        image: "1f9d9-1f3fb.png",
        sheet_x: 49,
        sheet_y: 50,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9D9-1F3FC",
        non_qualified: null,
        image: "1f9d9-1f3fc.png",
        sheet_x: 49,
        sheet_y: 51,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9D9-1F3FD",
        non_qualified: null,
        image: "1f9d9-1f3fd.png",
        sheet_x: 49,
        sheet_y: 52,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9D9-1F3FE",
        non_qualified: null,
        image: "1f9d9-1f3fe.png",
        sheet_x: 49,
        sheet_y: 53,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9D9-1F3FF",
        non_qualified: null,
        image: "1f9d9-1f3ff.png",
        sheet_x: 49,
        sheet_y: 54,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9D9-200D-2640-FE0F",
    a: "Mage",
    b: "1F9D9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      49
    ],
    o: 5
  },
  dagger_knife: {
    a: "Dagger Knife",
    b: "1F5E1-FE0F",
    c: "1F5E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      24
    ],
    o: 2
  },
  partly_sunny: {
    a: "Sun Behind Cloud",
    b: "26C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "nature",
      "cloudy",
      "morning",
      "fall",
      "spring"
    ],
    k: [
      54,
      2
    ],
    o: 2
  },
  large_yellow_circle: {
    a: "Large Yellow Circle",
    b: "1F7E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      4
    ],
    o: 12
  },
  male_mage: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D9-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FB-200D-2642",
        image: "1f9d9-1f3fb-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 44,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D9-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FC-200D-2642",
        image: "1f9d9-1f3fc-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 45,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D9-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FD-200D-2642",
        image: "1f9d9-1f3fd-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 46,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D9-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FE-200D-2642",
        image: "1f9d9-1f3fe-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 47,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D9-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FF-200D-2642",
        image: "1f9d9-1f3ff-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 48,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Mage",
    b: "1F9D9-200D-2642-FE0F",
    c: "1F9D9-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      43
    ],
    o: 5
  },
  "flag-pa": {
    a: "Panama Flag",
    b: "1F1F5-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      38
    ],
    o: 2
  },
  thunder_cloud_and_rain: {
    a: "Thunder Cloud and Rain",
    b: "26C8-FE0F",
    c: "26C8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      3
    ],
    o: 2
  },
  large_green_circle: {
    a: "Large Green Circle",
    b: "1F7E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      5
    ],
    o: 12
  },
  female_mage: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D9-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FB-200D-2640",
        image: "1f9d9-1f3fb-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 38,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FB"
      },
      "1F3FC": {
        unified: "1F9D9-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FC-200D-2640",
        image: "1f9d9-1f3fc-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 39,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FC"
      },
      "1F3FD": {
        unified: "1F9D9-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FD-200D-2640",
        image: "1f9d9-1f3fd-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 40,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FD"
      },
      "1F3FE": {
        unified: "1F9D9-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FE-200D-2640",
        image: "1f9d9-1f3fe-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 41,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FE"
      },
      "1F3FF": {
        unified: "1F9D9-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FF-200D-2640",
        image: "1f9d9-1f3ff-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 42,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FF"
      }
    },
    obsoletes: "1F9D9",
    a: "Female Mage",
    b: "1F9D9-200D-2640-FE0F",
    c: "1F9D9-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      37
    ],
    o: 5
  },
  crossed_swords: {
    a: "Crossed Swords",
    b: "2694-FE0F",
    c: "2694",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weapon"
    ],
    k: [
      53,
      43
    ],
    o: 2
  },
  "flag-pe": {
    a: "Peru Flag",
    b: "1F1F5-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      39
    ],
    o: 2
  },
  gun: {
    a: "Pistol",
    b: "1F52B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "violence",
      "weapon",
      "pistol",
      "revolver"
    ],
    k: [
      28,
      14
    ],
    o: 2
  },
  mostly_sunny: {
    a: "Mostly Sunny",
    b: "1F324-FE0F",
    c: "1F324",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      53
    ],
    n: [
      "sun_small_cloud"
    ],
    o: 2
  },
  fairy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DA-1F3FB",
        non_qualified: null,
        image: "1f9da-1f3fb.png",
        sheet_x: 50,
        sheet_y: 11,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9DA-1F3FC",
        non_qualified: null,
        image: "1f9da-1f3fc.png",
        sheet_x: 50,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9DA-1F3FD",
        non_qualified: null,
        image: "1f9da-1f3fd.png",
        sheet_x: 50,
        sheet_y: 13,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9DA-1F3FE",
        non_qualified: null,
        image: "1f9da-1f3fe.png",
        sheet_x: 50,
        sheet_y: 14,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9DA-1F3FF",
        non_qualified: null,
        image: "1f9da-1f3ff.png",
        sheet_x: 50,
        sheet_y: 15,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9DA-200D-2640-FE0F",
    a: "Fairy",
    b: "1F9DA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      10
    ],
    o: 5
  },
  "flag-pf": {
    a: "French Polynesia Flag",
    b: "1F1F5-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      40
    ],
    o: 2
  },
  large_blue_circle: {
    a: "Large Blue Circle",
    b: "1F535",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon",
      "button"
    ],
    k: [
      28,
      24
    ],
    o: 2
  },
  large_purple_circle: {
    a: "Large Purple Circle",
    b: "1F7E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      6
    ],
    o: 12
  },
  bow_and_arrow: {
    a: "Bow and Arrow",
    b: "1F3F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports"
    ],
    k: [
      11,
      21
    ],
    o: 2
  },
  male_fairy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DA-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FB-200D-2642",
        image: "1f9da-1f3fb-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 5,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9DA-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FC-200D-2642",
        image: "1f9da-1f3fc-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 6,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9DA-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FD-200D-2642",
        image: "1f9da-1f3fd-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 7,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9DA-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FE-200D-2642",
        image: "1f9da-1f3fe-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 8,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9DA-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FF-200D-2642",
        image: "1f9da-1f3ff-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 9,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Male Fairy",
    b: "1F9DA-200D-2642-FE0F",
    c: "1F9DA-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      4
    ],
    o: 5
  },
  barely_sunny: {
    a: "Barely Sunny",
    b: "1F325-FE0F",
    c: "1F325",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      54
    ],
    n: [
      "sun_behind_cloud"
    ],
    o: 2
  },
  "flag-pg": {
    a: "Papua New Guinea Flag",
    b: "1F1F5-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      41
    ],
    o: 2
  },
  shield: {
    a: "Shield",
    b: "1F6E1-FE0F",
    c: "1F6E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "protection",
      "security"
    ],
    k: [
      36,
      43
    ],
    o: 2
  },
  partly_sunny_rain: {
    a: "Partly Sunny Rain",
    b: "1F326-FE0F",
    c: "1F326",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      55
    ],
    n: [
      "sun_behind_rain_cloud"
    ],
    o: 2
  },
  large_brown_circle: {
    a: "Large Brown Circle",
    b: "1F7E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      7
    ],
    o: 12
  },
  female_fairy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DA-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FB-200D-2640",
        image: "1f9da-1f3fb-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 56,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FB"
      },
      "1F3FC": {
        unified: "1F9DA-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FC-200D-2640",
        image: "1f9da-1f3fc-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 0,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FC"
      },
      "1F3FD": {
        unified: "1F9DA-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FD-200D-2640",
        image: "1f9da-1f3fd-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 1,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FD"
      },
      "1F3FE": {
        unified: "1F9DA-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FE-200D-2640",
        image: "1f9da-1f3fe-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 2,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FE"
      },
      "1F3FF": {
        unified: "1F9DA-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FF-200D-2640",
        image: "1f9da-1f3ff-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 3,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FF"
      }
    },
    obsoletes: "1F9DA",
    a: "Female Fairy",
    b: "1F9DA-200D-2640-FE0F",
    c: "1F9DA-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      55
    ],
    o: 5
  },
  "flag-ph": {
    a: "Philippines Flag",
    b: "1F1F5-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      42
    ],
    o: 2
  },
  "flag-pk": {
    a: "Pakistan Flag",
    b: "1F1F5-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      43
    ],
    o: 2
  },
  black_circle: {
    a: "Medium Black Circle",
    b: "26AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "button",
      "round"
    ],
    k: [
      53,
      53
    ],
    o: 2
  },
  wrench: {
    a: "Wrench",
    b: "1F527",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "diy",
      "ikea",
      "fix",
      "maintainer"
    ],
    k: [
      28,
      10
    ],
    o: 2
  },
  vampire: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DB-1F3FB",
        non_qualified: null,
        image: "1f9db-1f3fb.png",
        sheet_x: 50,
        sheet_y: 29,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9DB-1F3FC",
        non_qualified: null,
        image: "1f9db-1f3fc.png",
        sheet_x: 50,
        sheet_y: 30,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9DB-1F3FD",
        non_qualified: null,
        image: "1f9db-1f3fd.png",
        sheet_x: 50,
        sheet_y: 31,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9DB-1F3FE",
        non_qualified: null,
        image: "1f9db-1f3fe.png",
        sheet_x: 50,
        sheet_y: 32,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9DB-1F3FF",
        non_qualified: null,
        image: "1f9db-1f3ff.png",
        sheet_x: 50,
        sheet_y: 33,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9DB-200D-2640-FE0F",
    a: "Vampire",
    b: "1F9DB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      28
    ],
    o: 5
  },
  rain_cloud: {
    a: "Rain Cloud",
    b: "1F327-FE0F",
    c: "1F327",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      56
    ],
    o: 2
  },
  snow_cloud: {
    a: "Snow Cloud",
    b: "1F328-FE0F",
    c: "1F328",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      6,
      0
    ],
    o: 2
  },
  "flag-pl": {
    a: "Poland Flag",
    b: "1F1F5-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      44
    ],
    o: 2
  },
  male_vampire: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DB-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FB-200D-2642",
        image: "1f9db-1f3fb-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 23,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9DB-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FC-200D-2642",
        image: "1f9db-1f3fc-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 24,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9DB-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FD-200D-2642",
        image: "1f9db-1f3fd-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 25,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9DB-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FE-200D-2642",
        image: "1f9db-1f3fe-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 26,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9DB-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FF-200D-2642",
        image: "1f9db-1f3ff-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 27,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Vampire",
    b: "1F9DB-200D-2642-FE0F",
    c: "1F9DB-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      22
    ],
    o: 5
  },
  nut_and_bolt: {
    a: "Nut and Bolt",
    b: "1F529",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "handy",
      "tools",
      "fix"
    ],
    k: [
      28,
      12
    ],
    o: 2
  },
  white_circle: {
    a: "Medium White Circle",
    b: "26AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "round"
    ],
    k: [
      53,
      52
    ],
    o: 2
  },
  female_vampire: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DB-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FB-200D-2640",
        image: "1f9db-1f3fb-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 17,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FB"
      },
      "1F3FC": {
        unified: "1F9DB-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FC-200D-2640",
        image: "1f9db-1f3fc-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 18,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FC"
      },
      "1F3FD": {
        unified: "1F9DB-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FD-200D-2640",
        image: "1f9db-1f3fd-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 19,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FD"
      },
      "1F3FE": {
        unified: "1F9DB-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FE-200D-2640",
        image: "1f9db-1f3fe-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 20,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FE"
      },
      "1F3FF": {
        unified: "1F9DB-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FF-200D-2640",
        image: "1f9db-1f3ff-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 21,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FF"
      }
    },
    obsoletes: "1F9DB",
    a: "Female Vampire",
    b: "1F9DB-200D-2640-FE0F",
    c: "1F9DB-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      16
    ],
    o: 5
  },
  "flag-pm": {
    a: "St. Pierre & Miquelon Flag",
    b: "1F1F5-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      45
    ],
    o: 2
  },
  large_red_square: {
    a: "Large Red Square",
    b: "1F7E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      8
    ],
    o: 12
  },
  lightning: {
    a: "Lightning",
    b: "1F329-FE0F",
    c: "1F329",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      6,
      1
    ],
    n: [
      "lightning_cloud"
    ],
    o: 2
  },
  gear: {
    a: "Gear",
    b: "2699-FE0F",
    c: "2699",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cog"
    ],
    k: [
      53,
      47
    ],
    o: 2
  },
  merperson: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DC-1F3FB",
        non_qualified: null,
        image: "1f9dc-1f3fb.png",
        sheet_x: 50,
        sheet_y: 47,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FB-200D-2642-FE0F"
      },
      "1F3FC": {
        unified: "1F9DC-1F3FC",
        non_qualified: null,
        image: "1f9dc-1f3fc.png",
        sheet_x: 50,
        sheet_y: 48,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FC-200D-2642-FE0F"
      },
      "1F3FD": {
        unified: "1F9DC-1F3FD",
        non_qualified: null,
        image: "1f9dc-1f3fd.png",
        sheet_x: 50,
        sheet_y: 49,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FD-200D-2642-FE0F"
      },
      "1F3FE": {
        unified: "1F9DC-1F3FE",
        non_qualified: null,
        image: "1f9dc-1f3fe.png",
        sheet_x: 50,
        sheet_y: 50,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FE-200D-2642-FE0F"
      },
      "1F3FF": {
        unified: "1F9DC-1F3FF",
        non_qualified: null,
        image: "1f9dc-1f3ff.png",
        sheet_x: 50,
        sheet_y: 51,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FF-200D-2642-FE0F"
      }
    },
    obsoleted_by: "1F9DC-200D-2642-FE0F",
    a: "Merperson",
    b: "1F9DC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      46
    ],
    o: 5
  },
  tornado: {
    a: "Tornado",
    b: "1F32A-FE0F",
    c: "1F32A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "cyclone",
      "twister"
    ],
    k: [
      6,
      2
    ],
    n: [
      "tornado_cloud"
    ],
    o: 2
  },
  large_orange_square: {
    a: "Large Orange Square",
    b: "1F7E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      10
    ],
    o: 12
  },
  "flag-pn": {
    a: "Pitcairn Islands Flag",
    b: "1F1F5-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      46
    ],
    o: 2
  },
  compression: {
    a: "Compression",
    b: "1F5DC-FE0F",
    c: "1F5DC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      21
    ],
    o: 2
  },
  merman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DC-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FB-200D-2642",
        image: "1f9dc-1f3fb-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 41,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FB"
      },
      "1F3FC": {
        unified: "1F9DC-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FC-200D-2642",
        image: "1f9dc-1f3fc-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 42,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FC"
      },
      "1F3FD": {
        unified: "1F9DC-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FD-200D-2642",
        image: "1f9dc-1f3fd-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 43,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FD"
      },
      "1F3FE": {
        unified: "1F9DC-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FE-200D-2642",
        image: "1f9dc-1f3fe-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 44,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FE"
      },
      "1F3FF": {
        unified: "1F9DC-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FF-200D-2642",
        image: "1f9dc-1f3ff-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 45,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FF"
      }
    },
    obsoletes: "1F9DC",
    a: "Merman",
    b: "1F9DC-200D-2642-FE0F",
    c: "1F9DC-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      40
    ],
    o: 5
  },
  large_yellow_square: {
    a: "Large Yellow Square",
    b: "1F7E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      11
    ],
    o: 12
  },
  fog: {
    a: "Fog",
    b: "1F32B-FE0F",
    c: "1F32B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather"
    ],
    k: [
      6,
      3
    ],
    o: 2
  },
  scales: {
    a: "Scales",
    b: "2696-FE0F",
    c: "2696",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      45
    ],
    o: 2
  },
  "flag-pr": {
    a: "Puerto Rico Flag",
    b: "1F1F5-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      47
    ],
    o: 2
  },
  wind_blowing_face: {
    a: "Wind Blowing Face",
    b: "1F32C-FE0F",
    c: "1F32C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      6,
      4
    ],
    o: 2
  },
  "flag-ps": {
    a: "Palestinian Territories Flag",
    b: "1F1F5-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      48
    ],
    o: 2
  },
  mermaid: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DC-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FB-200D-2640",
        image: "1f9dc-1f3fb-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 35,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9DC-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FC-200D-2640",
        image: "1f9dc-1f3fc-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 36,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9DC-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FD-200D-2640",
        image: "1f9dc-1f3fd-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 37,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9DC-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FE-200D-2640",
        image: "1f9dc-1f3fe-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 38,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9DC-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FF-200D-2640",
        image: "1f9dc-1f3ff-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 39,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Mermaid",
    b: "1F9DC-200D-2640-FE0F",
    c: "1F9DC-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      34
    ],
    o: 5
  },
  probing_cane: {
    a: "Probing Cane",
    b: "1F9AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      3
    ],
    o: 12
  },
  large_green_square: {
    a: "Large Green Square",
    b: "1F7E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      12
    ],
    o: 12
  },
  "flag-pt": {
    a: "Portugal Flag",
    b: "1F1F5-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      49
    ],
    o: 2
  },
  link: {
    a: "Link Symbol",
    b: "1F517",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "rings",
      "url"
    ],
    k: [
      27,
      51
    ],
    o: 2
  },
  large_blue_square: {
    a: "Large Blue Square",
    b: "1F7E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      9
    ],
    o: 12
  },
  elf: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DD-1F3FB",
        non_qualified: null,
        image: "1f9dd-1f3fb.png",
        sheet_x: 51,
        sheet_y: 8,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FB-200D-2642-FE0F"
      },
      "1F3FC": {
        unified: "1F9DD-1F3FC",
        non_qualified: null,
        image: "1f9dd-1f3fc.png",
        sheet_x: 51,
        sheet_y: 9,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FC-200D-2642-FE0F"
      },
      "1F3FD": {
        unified: "1F9DD-1F3FD",
        non_qualified: null,
        image: "1f9dd-1f3fd.png",
        sheet_x: 51,
        sheet_y: 10,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FD-200D-2642-FE0F"
      },
      "1F3FE": {
        unified: "1F9DD-1F3FE",
        non_qualified: null,
        image: "1f9dd-1f3fe.png",
        sheet_x: 51,
        sheet_y: 11,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FE-200D-2642-FE0F"
      },
      "1F3FF": {
        unified: "1F9DD-1F3FF",
        non_qualified: null,
        image: "1f9dd-1f3ff.png",
        sheet_x: 51,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FF-200D-2642-FE0F"
      }
    },
    obsoleted_by: "1F9DD-200D-2642-FE0F",
    a: "Elf",
    b: "1F9DD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      7
    ],
    o: 5
  },
  cyclone: {
    a: "Cyclone",
    b: "1F300",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "swirl",
      "blue",
      "cloud",
      "vortex",
      "spiral",
      "whirlpool",
      "spin",
      "tornado",
      "hurricane",
      "typhoon"
    ],
    k: [
      5,
      19
    ],
    o: 2
  },
  rainbow: {
    a: "Rainbow",
    b: "1F308",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "happy",
      "unicorn_face",
      "photo",
      "sky",
      "spring"
    ],
    k: [
      5,
      27
    ],
    o: 2
  },
  male_elf: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DD-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FB-200D-2642",
        image: "1f9dd-1f3fb-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 2,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FB"
      },
      "1F3FC": {
        unified: "1F9DD-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FC-200D-2642",
        image: "1f9dd-1f3fc-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 3,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FC"
      },
      "1F3FD": {
        unified: "1F9DD-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FD-200D-2642",
        image: "1f9dd-1f3fd-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 4,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FD"
      },
      "1F3FE": {
        unified: "1F9DD-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FE-200D-2642",
        image: "1f9dd-1f3fe-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 5,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FE"
      },
      "1F3FF": {
        unified: "1F9DD-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FF-200D-2642",
        image: "1f9dd-1f3ff-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 6,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FF"
      }
    },
    obsoletes: "1F9DD",
    a: "Male Elf",
    b: "1F9DD-200D-2642-FE0F",
    c: "1F9DD-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      1
    ],
    o: 5
  },
  "flag-pw": {
    a: "Palau Flag",
    b: "1F1F5-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      50
    ],
    o: 2
  },
  chains: {
    a: "Chains",
    b: "26D3-FE0F",
    c: "26D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "lock",
      "arrest"
    ],
    k: [
      54,
      7
    ],
    o: 2
  },
  large_purple_square: {
    a: "Large Purple Square",
    b: "1F7EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      13
    ],
    o: 12
  },
  female_elf: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DD-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FB-200D-2640",
        image: "1f9dd-1f3fb-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 53,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9DD-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FC-200D-2640",
        image: "1f9dd-1f3fc-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 54,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9DD-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FD-200D-2640",
        image: "1f9dd-1f3fd-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 55,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9DD-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FE-200D-2640",
        image: "1f9dd-1f3fe-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 56,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9DD-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FF-200D-2640",
        image: "1f9dd-1f3ff-200d-2640-fe0f.png",
        sheet_x: 51,
        sheet_y: 0,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Elf",
    b: "1F9DD-200D-2640-FE0F",
    c: "1F9DD-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      52
    ],
    o: 5
  },
  "flag-py": {
    a: "Paraguay Flag",
    b: "1F1F5-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      51
    ],
    o: 2
  },
  closed_umbrella: {
    a: "Closed Umbrella",
    b: "1F302",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "rain",
      "drizzle"
    ],
    k: [
      5,
      21
    ],
    o: 2
  },
  toolbox: {
    a: "Toolbox",
    b: "1F9F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      35
    ],
    o: 11
  },
  large_brown_square: {
    a: "Large Brown Square",
    b: "1F7EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      14
    ],
    o: 12
  },
  magnet: {
    a: "Magnet",
    b: "1F9F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      37
    ],
    o: 11
  },
  genie: {
    obsoleted_by: "1F9DE-200D-2642-FE0F",
    a: "Genie",
    b: "1F9DE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      15
    ],
    o: 5
  },
  "flag-qa": {
    a: "Qatar Flag",
    b: "1F1F6-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      52
    ],
    o: 2
  },
  umbrella: {
    a: "Umbrella",
    b: "2602-FE0F",
    c: "2602",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "rainy",
      "weather",
      "spring"
    ],
    k: [
      52,
      51
    ],
    o: 2
  },
  black_large_square: {
    a: "Black Large Square",
    b: "2B1B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon",
      "button"
    ],
    k: [
      55,
      40
    ],
    o: 2
  },
  male_genie: {
    obsoletes: "1F9DE",
    a: "Male Genie",
    b: "1F9DE-200D-2642-FE0F",
    c: "1F9DE-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      14
    ],
    o: 5
  },
  umbrella_with_rain_drops: {
    a: "Umbrella with Rain Drops",
    b: "2614",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      56
    ],
    o: 2
  },
  "flag-re": {
    a: "Réunion Flag",
    b: "1F1F7-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      53
    ],
    o: 2
  },
  white_large_square: {
    a: "White Large Square",
    b: "2B1C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon",
      "stone",
      "button"
    ],
    k: [
      55,
      41
    ],
    o: 2
  },
  alembic: {
    a: "Alembic",
    b: "2697-FE0F",
    c: "2697",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "distilling",
      "science",
      "experiment",
      "chemistry"
    ],
    k: [
      53,
      46
    ],
    o: 2
  },
  black_medium_square: {
    a: "Black Medium Square",
    b: "25FC-FE0F",
    c: "25FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "button",
      "icon"
    ],
    k: [
      52,
      46
    ],
    o: 2
  },
  test_tube: {
    a: "Test Tube",
    b: "1F9EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      29
    ],
    o: 11
  },
  "flag-ro": {
    a: "Romania Flag",
    b: "1F1F7-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      54
    ],
    o: 2
  },
  female_genie: {
    a: "Female Genie",
    b: "1F9DE-200D-2640-FE0F",
    c: "1F9DE-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      13
    ],
    o: 5
  },
  umbrella_on_ground: {
    a: "Umbrella on Ground",
    b: "26F1-FE0F",
    c: "26F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      12
    ],
    o: 2
  },
  zombie: {
    obsoleted_by: "1F9DF-200D-2642-FE0F",
    a: "Zombie",
    b: "1F9DF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      18
    ],
    o: 5
  },
  zap: {
    a: "High Voltage Sign",
    b: "26A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "thunder",
      "weather",
      "lightning bolt",
      "fast"
    ],
    k: [
      53,
      51
    ],
    o: 2
  },
  white_medium_square: {
    a: "White Medium Square",
    b: "25FB-FE0F",
    c: "25FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "stone",
      "icon"
    ],
    k: [
      52,
      45
    ],
    o: 2
  },
  "flag-rs": {
    a: "Serbia Flag",
    b: "1F1F7-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      55
    ],
    o: 2
  },
  petri_dish: {
    a: "Petri Dish",
    b: "1F9EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      30
    ],
    o: 11
  },
  snowflake: {
    a: "Snowflake",
    b: "2744-FE0F",
    c: "2744",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas"
    ],
    k: [
      55,
      19
    ],
    o: 2
  },
  dna: {
    a: "Dna Double Helix",
    b: "1F9EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      31
    ],
    o: 11
  },
  male_zombie: {
    obsoletes: "1F9DF",
    a: "Male Zombie",
    b: "1F9DF-200D-2642-FE0F",
    c: "1F9DF-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      17
    ],
    o: 5
  },
  black_medium_small_square: {
    a: "Black Medium Small Square",
    b: "25FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "icon",
      "shape",
      "button"
    ],
    k: [
      52,
      48
    ],
    o: 2
  },
  ru: {
    a: "Russia Flag",
    b: "1F1F7-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "russian",
      "federation",
      "flag",
      "nation",
      "country",
      "banner"
    ],
    k: [
      3,
      56
    ],
    n: [
      "flag-ru"
    ],
    o: 2
  },
  female_zombie: {
    a: "Female Zombie",
    b: "1F9DF-200D-2640-FE0F",
    c: "1F9DF-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      16
    ],
    o: 5
  },
  "flag-rw": {
    a: "Rwanda Flag",
    b: "1F1F7-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      0
    ],
    o: 2
  },
  snowman: {
    a: "Snowman",
    b: "2603-FE0F",
    c: "2603",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen",
      "without_snow"
    ],
    k: [
      52,
      52
    ],
    o: 2
  },
  white_medium_small_square: {
    a: "White Medium Small Square",
    b: "25FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "stone",
      "icon",
      "button"
    ],
    k: [
      52,
      47
    ],
    o: 2
  },
  microscope: {
    a: "Microscope",
    b: "1F52C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "laboratory",
      "experiment",
      "zoomin",
      "science",
      "study"
    ],
    k: [
      28,
      15
    ],
    o: 2
  },
  snowman_without_snow: {
    a: "Snowman Without Snow",
    b: "26C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      1
    ],
    o: 2
  },
  telescope: {
    a: "Telescope",
    b: "1F52D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stars",
      "space",
      "zoom",
      "science",
      "astronomy"
    ],
    k: [
      28,
      16
    ],
    o: 2
  },
  massage: {
    skin_variations: {
      "1F3FB": {
        unified: "1F486-1F3FB",
        non_qualified: null,
        image: "1f486-1f3fb.png",
        sheet_x: 24,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F486-1F3FC",
        non_qualified: null,
        image: "1f486-1f3fc.png",
        sheet_x: 24,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F486-1F3FD",
        non_qualified: null,
        image: "1f486-1f3fd.png",
        sheet_x: 24,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F486-1F3FE",
        non_qualified: null,
        image: "1f486-1f3fe.png",
        sheet_x: 24,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F486-1F3FF",
        non_qualified: null,
        image: "1f486-1f3ff.png",
        sheet_x: 24,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F486-200D-2640-FE0F",
    a: "Face Massage",
    b: "1F486",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      24,
      51
    ],
    o: 2
  },
  black_small_square: {
    a: "Black Small Square",
    b: "25AA-FE0F",
    c: "25AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon"
    ],
    k: [
      52,
      41
    ],
    o: 2
  },
  "flag-sa": {
    a: "Saudi Arabia Flag",
    b: "1F1F8-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      1
    ],
    o: 2
  },
  "man-getting-massage": {
    skin_variations: {
      "1F3FB": {
        unified: "1F486-1F3FB-200D-2642-FE0F",
        non_qualified: "1F486-1F3FB-200D-2642",
        image: "1f486-1f3fb-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F486-1F3FC-200D-2642-FE0F",
        non_qualified: "1F486-1F3FC-200D-2642",
        image: "1f486-1f3fc-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F486-1F3FD-200D-2642-FE0F",
        non_qualified: "1F486-1F3FD-200D-2642",
        image: "1f486-1f3fd-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F486-1F3FE-200D-2642-FE0F",
        non_qualified: "1F486-1F3FE-200D-2642",
        image: "1f486-1f3fe-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F486-1F3FF-200D-2642-FE0F",
        non_qualified: "1F486-1F3FF-200D-2642",
        image: "1f486-1f3ff-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Getting Massage",
    b: "1F486-200D-2642-FE0F",
    c: "1F486-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      24,
      45
    ],
    o: 4
  },
  comet: {
    a: "Comet",
    b: "2604-FE0F",
    c: "2604",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "space"
    ],
    k: [
      52,
      53
    ],
    o: 2
  },
  white_small_square: {
    a: "White Small Square",
    b: "25AB-FE0F",
    c: "25AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon"
    ],
    k: [
      52,
      42
    ],
    o: 2
  },
  "flag-sb": {
    a: "Solomon Islands Flag",
    b: "1F1F8-1F1E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      2
    ],
    o: 2
  },
  satellite_antenna: {
    a: "Satellite Antenna",
    b: "1F4E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      26,
      55
    ],
    o: 2
  },
  large_orange_diamond: {
    a: "Large Orange Diamond",
    b: "1F536",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "jewel",
      "gem"
    ],
    k: [
      28,
      25
    ],
    o: 2
  },
  "woman-getting-massage": {
    skin_variations: {
      "1F3FB": {
        unified: "1F486-1F3FB-200D-2640-FE0F",
        non_qualified: "1F486-1F3FB-200D-2640",
        image: "1f486-1f3fb-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F486-1F3FC-200D-2640-FE0F",
        non_qualified: "1F486-1F3FC-200D-2640",
        image: "1f486-1f3fc-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F486-1F3FD-200D-2640-FE0F",
        non_qualified: "1F486-1F3FD-200D-2640",
        image: "1f486-1f3fd-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F486-1F3FE-200D-2640-FE0F",
        non_qualified: "1F486-1F3FE-200D-2640",
        image: "1f486-1f3fe-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F486-1F3FF-200D-2640-FE0F",
        non_qualified: "1F486-1F3FF-200D-2640",
        image: "1f486-1f3ff-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F486",
    a: "Woman Getting Massage",
    b: "1F486-200D-2640-FE0F",
    c: "1F486-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      24,
      39
    ],
    o: 4
  },
  fire: {
    a: "Fire",
    b: "1F525",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hot",
      "cook",
      "flame"
    ],
    k: [
      28,
      8
    ],
    o: 2
  },
  syringe: {
    a: "Syringe",
    b: "1F489",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "health",
      "hospital",
      "drugs",
      "blood",
      "medicine",
      "needle",
      "doctor",
      "nurse"
    ],
    k: [
      25,
      19
    ],
    o: 2
  },
  "flag-sc": {
    a: "Seychelles Flag",
    b: "1F1F8-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      3
    ],
    o: 2
  },
  large_blue_diamond: {
    a: "Large Blue Diamond",
    b: "1F537",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "jewel",
      "gem"
    ],
    k: [
      28,
      26
    ],
    o: 2
  },
  "flag-sd": {
    a: "Sudan Flag",
    b: "1F1F8-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      4
    ],
    o: 2
  },
  droplet: {
    a: "Droplet",
    b: "1F4A7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "water",
      "drip",
      "faucet",
      "spring"
    ],
    k: [
      25,
      49
    ],
    o: 2
  },
  drop_of_blood: {
    a: "Drop of Blood",
    b: "1FA78",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      55
    ],
    o: 12
  },
  haircut: {
    skin_variations: {
      "1F3FB": {
        unified: "1F487-1F3FB",
        non_qualified: null,
        image: "1f487-1f3fb.png",
        sheet_x: 25,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F487-1F3FC",
        non_qualified: null,
        image: "1f487-1f3fc.png",
        sheet_x: 25,
        sheet_y: 14,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F487-1F3FD",
        non_qualified: null,
        image: "1f487-1f3fd.png",
        sheet_x: 25,
        sheet_y: 15,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F487-1F3FE",
        non_qualified: null,
        image: "1f487-1f3fe.png",
        sheet_x: 25,
        sheet_y: 16,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F487-1F3FF",
        non_qualified: null,
        image: "1f487-1f3ff.png",
        sheet_x: 25,
        sheet_y: 17,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F487-200D-2640-FE0F",
    a: "Haircut",
    b: "1F487",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      25,
      12
    ],
    o: 2
  },
  ocean: {
    a: "Water Wave",
    b: "1F30A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sea",
      "water",
      "wave",
      "nature",
      "tsunami",
      "disaster"
    ],
    k: [
      5,
      29
    ],
    o: 2
  },
  "flag-se": {
    a: "Sweden Flag",
    b: "1F1F8-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      5
    ],
    o: 2
  },
  "man-getting-haircut": {
    skin_variations: {
      "1F3FB": {
        unified: "1F487-1F3FB-200D-2642-FE0F",
        non_qualified: "1F487-1F3FB-200D-2642",
        image: "1f487-1f3fb-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F487-1F3FC-200D-2642-FE0F",
        non_qualified: "1F487-1F3FC-200D-2642",
        image: "1f487-1f3fc-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F487-1F3FD-200D-2642-FE0F",
        non_qualified: "1F487-1F3FD-200D-2642",
        image: "1f487-1f3fd-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F487-1F3FE-200D-2642-FE0F",
        non_qualified: "1F487-1F3FE-200D-2642",
        image: "1f487-1f3fe-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F487-1F3FF-200D-2642-FE0F",
        non_qualified: "1F487-1F3FF-200D-2642",
        image: "1f487-1f3ff-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Getting Haircut",
    b: "1F487-200D-2642-FE0F",
    c: "1F487-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      6
    ],
    o: 4
  },
  small_orange_diamond: {
    a: "Small Orange Diamond",
    b: "1F538",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "jewel",
      "gem"
    ],
    k: [
      28,
      27
    ],
    o: 2
  },
  pill: {
    a: "Pill",
    b: "1F48A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "health",
      "medicine",
      "doctor",
      "pharmacy",
      "drug"
    ],
    k: [
      25,
      20
    ],
    o: 2
  },
  "woman-getting-haircut": {
    skin_variations: {
      "1F3FB": {
        unified: "1F487-1F3FB-200D-2640-FE0F",
        non_qualified: "1F487-1F3FB-200D-2640",
        image: "1f487-1f3fb-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F487-1F3FC-200D-2640-FE0F",
        non_qualified: "1F487-1F3FC-200D-2640",
        image: "1f487-1f3fc-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F487-1F3FD-200D-2640-FE0F",
        non_qualified: "1F487-1F3FD-200D-2640",
        image: "1f487-1f3fd-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F487-1F3FE-200D-2640-FE0F",
        non_qualified: "1F487-1F3FE-200D-2640",
        image: "1f487-1f3fe-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F487-1F3FF-200D-2640-FE0F",
        non_qualified: "1F487-1F3FF-200D-2640",
        image: "1f487-1f3ff-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F487",
    a: "Woman Getting Haircut",
    b: "1F487-200D-2640-FE0F",
    c: "1F487-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      0
    ],
    o: 4
  },
  small_blue_diamond: {
    a: "Small Blue Diamond",
    b: "1F539",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "jewel",
      "gem"
    ],
    k: [
      28,
      28
    ],
    o: 2
  },
  "flag-sg": {
    a: "Singapore Flag",
    b: "1F1F8-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      6
    ],
    o: 2
  },
  adhesive_bandage: {
    a: "Adhesive Bandage",
    b: "1FA79",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      56
    ],
    o: 12
  },
  walking: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B6-1F3FB",
        non_qualified: null,
        image: "1f6b6-1f3fb.png",
        sheet_x: 36,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F6B6-1F3FC",
        non_qualified: null,
        image: "1f6b6-1f3fc.png",
        sheet_x: 36,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F6B6-1F3FD",
        non_qualified: null,
        image: "1f6b6-1f3fd.png",
        sheet_x: 36,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F6B6-1F3FE",
        non_qualified: null,
        image: "1f6b6-1f3fe.png",
        sheet_x: 36,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F6B6-1F3FF",
        non_qualified: null,
        image: "1f6b6-1f3ff.png",
        sheet_x: 36,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F6B6-200D-2642-FE0F",
    a: "Pedestrian",
    b: "1F6B6",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      36,
      2
    ],
    o: 2
  },
  small_red_triangle: {
    a: "Up-Pointing Red Triangle",
    b: "1F53A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "direction",
      "up",
      "top"
    ],
    k: [
      28,
      29
    ],
    o: 2
  },
  "flag-sh": {
    a: "St. Helena Flag",
    b: "1F1F8-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      7
    ],
    o: 2
  },
  stethoscope: {
    a: "Stethoscope",
    b: "1FA7A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      0
    ],
    o: 12
  },
  "man-walking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B6-1F3FB-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FB-200D-2642",
        image: "1f6b6-1f3fb-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B6-1F3FC-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FC-200D-2642",
        image: "1f6b6-1f3fc-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B6-1F3FD-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FD-200D-2642",
        image: "1f6b6-1f3fd-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B6-1F3FE-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FE-200D-2642",
        image: "1f6b6-1f3fe-200d-2642-fe0f.png",
        sheet_x: 36,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B6-1F3FF-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FF-200D-2642",
        image: "1f6b6-1f3ff-200d-2642-fe0f.png",
        sheet_x: 36,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F6B6",
    a: "Man Walking",
    b: "1F6B6-200D-2642-FE0F",
    c: "1F6B6-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      53
    ],
    o: 4
  },
  "flag-si": {
    a: "Slovenia Flag",
    b: "1F1F8-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      8
    ],
    o: 2
  },
  door: {
    a: "Door",
    b: "1F6AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "house",
      "entry",
      "exit"
    ],
    k: [
      35,
      1
    ],
    o: 2
  },
  small_red_triangle_down: {
    a: "Down-Pointing Red Triangle",
    b: "1F53B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "direction",
      "bottom"
    ],
    k: [
      28,
      30
    ],
    o: 2
  },
  "flag-sj": {
    a: "Svalbard & Jan Mayen Flag",
    b: "1F1F8-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      9
    ],
    o: 2
  },
  diamond_shape_with_a_dot_inside: {
    a: "Diamond Shape with a Dot Inside",
    b: "1F4A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "jewel",
      "blue",
      "gem",
      "crystal",
      "fancy"
    ],
    k: [
      25,
      42
    ],
    o: 2
  },
  "woman-walking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B6-1F3FB-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FB-200D-2640",
        image: "1f6b6-1f3fb-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B6-1F3FC-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FC-200D-2640",
        image: "1f6b6-1f3fc-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B6-1F3FD-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FD-200D-2640",
        image: "1f6b6-1f3fd-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B6-1F3FE-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FE-200D-2640",
        image: "1f6b6-1f3fe-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B6-1F3FF-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FF-200D-2640",
        image: "1f6b6-1f3ff-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Walking",
    b: "1F6B6-200D-2640-FE0F",
    c: "1F6B6-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      47
    ],
    o: 4
  },
  bed: {
    a: "Bed",
    b: "1F6CF-FE0F",
    c: "1F6CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sleep",
      "rest"
    ],
    k: [
      36,
      37
    ],
    o: 2
  },
  radio_button: {
    a: "Radio Button",
    b: "1F518",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "input",
      "old",
      "music",
      "circle"
    ],
    k: [
      27,
      52
    ],
    o: 2
  },
  "flag-sk": {
    a: "Slovakia Flag",
    b: "1F1F8-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      10
    ],
    o: 2
  },
  standing_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CD-1F3FB",
        non_qualified: null,
        image: "1f9cd-1f3fb.png",
        sheet_x: 44,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CD-1F3FC",
        non_qualified: null,
        image: "1f9cd-1f3fc.png",
        sheet_x: 44,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CD-1F3FD",
        non_qualified: null,
        image: "1f9cd-1f3fd.png",
        sheet_x: 44,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CD-1F3FE",
        non_qualified: null,
        image: "1f9cd-1f3fe.png",
        sheet_x: 44,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CD-1F3FF",
        non_qualified: null,
        image: "1f9cd-1f3ff.png",
        sheet_x: 44,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Standing Person",
    b: "1F9CD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      31
    ],
    o: 12
  },
  couch_and_lamp: {
    a: "Couch and Lamp",
    b: "1F6CB-FE0F",
    c: "1F6CB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "chill"
    ],
    k: [
      36,
      28
    ],
    o: 2
  },
  man_standing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CD-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FB-200D-2642",
        image: "1f9cd-1f3fb-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CD-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FC-200D-2642",
        image: "1f9cd-1f3fc-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CD-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FD-200D-2642",
        image: "1f9cd-1f3fd-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CD-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FE-200D-2642",
        image: "1f9cd-1f3fe-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CD-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FF-200D-2642",
        image: "1f9cd-1f3ff-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Standing",
    b: "1F9CD-200D-2642-FE0F",
    c: "1F9CD-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      25
    ],
    o: 12
  },
  white_square_button: {
    a: "White Square Button",
    b: "1F533",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "input"
    ],
    k: [
      28,
      22
    ],
    o: 2
  },
  "flag-sl": {
    a: "Sierra Leone Flag",
    b: "1F1F8-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      11
    ],
    o: 2
  },
  chair: {
    a: "Chair",
    b: "1FA91",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      5
    ],
    o: 12
  },
  toilet: {
    a: "Toilet",
    b: "1F6BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "restroom",
      "wc",
      "washroom",
      "bathroom",
      "potty"
    ],
    k: [
      36,
      14
    ],
    o: 2
  },
  black_square_button: {
    a: "Black Square Button",
    b: "1F532",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "input",
      "frame"
    ],
    k: [
      28,
      21
    ],
    o: 2
  },
  "flag-sm": {
    a: "San Marino Flag",
    b: "1F1F8-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      12
    ],
    o: 2
  },
  woman_standing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CD-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FB-200D-2640",
        image: "1f9cd-1f3fb-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CD-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FC-200D-2640",
        image: "1f9cd-1f3fc-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CD-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FD-200D-2640",
        image: "1f9cd-1f3fd-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CD-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FE-200D-2640",
        image: "1f9cd-1f3fe-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CD-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FF-200D-2640",
        image: "1f9cd-1f3ff-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Standing",
    b: "1F9CD-200D-2640-FE0F",
    c: "1F9CD-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      19
    ],
    o: 12
  },
  kneeling_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CE-1F3FB",
        non_qualified: null,
        image: "1f9ce-1f3fb.png",
        sheet_x: 44,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CE-1F3FC",
        non_qualified: null,
        image: "1f9ce-1f3fc.png",
        sheet_x: 44,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CE-1F3FD",
        non_qualified: null,
        image: "1f9ce-1f3fd.png",
        sheet_x: 44,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CE-1F3FE",
        non_qualified: null,
        image: "1f9ce-1f3fe.png",
        sheet_x: 44,
        sheet_y: 53,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CE-1F3FF",
        non_qualified: null,
        image: "1f9ce-1f3ff.png",
        sheet_x: 44,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Kneeling Person",
    b: "1F9CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      49
    ],
    o: 12
  },
  shower: {
    a: "Shower",
    b: "1F6BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "clean",
      "water",
      "bathroom"
    ],
    k: [
      36,
      16
    ],
    o: 2
  },
  "flag-sn": {
    a: "Senegal Flag",
    b: "1F1F8-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      13
    ],
    o: 2
  },
  bathtub: {
    a: "Bathtub",
    b: "1F6C1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "clean",
      "shower",
      "bathroom"
    ],
    k: [
      36,
      23
    ],
    o: 2
  },
  "flag-so": {
    a: "Somalia Flag",
    b: "1F1F8-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      14
    ],
    o: 2
  },
  man_kneeling: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CE-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FB-200D-2642",
        image: "1f9ce-1f3fb-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CE-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FC-200D-2642",
        image: "1f9ce-1f3fc-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CE-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FD-200D-2642",
        image: "1f9ce-1f3fd-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CE-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FE-200D-2642",
        image: "1f9ce-1f3fe-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 47,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CE-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FF-200D-2642",
        image: "1f9ce-1f3ff-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Kneeling",
    b: "1F9CE-200D-2642-FE0F",
    c: "1F9CE-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      43
    ],
    o: 12
  },
  "flag-sr": {
    a: "Suriname Flag",
    b: "1F1F8-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      15
    ],
    o: 2
  },
  woman_kneeling: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CE-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FB-200D-2640",
        image: "1f9ce-1f3fb-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 38,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CE-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FC-200D-2640",
        image: "1f9ce-1f3fc-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CE-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FD-200D-2640",
        image: "1f9ce-1f3fd-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CE-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FE-200D-2640",
        image: "1f9ce-1f3fe-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CE-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FF-200D-2640",
        image: "1f9ce-1f3ff-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Kneeling",
    b: "1F9CE-200D-2640-FE0F",
    c: "1F9CE-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      37
    ],
    o: 12
  },
  razor: {
    a: "Razor",
    b: "1FA92",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      6
    ],
    o: 12
  },
  person_with_probing_cane: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 8,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 10,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 11,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 12,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Person with Probing Cane",
    b: "1F9D1-200D-1F9AF",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      7
    ],
    o: 12
  },
  "flag-ss": {
    a: "South Sudan Flag",
    b: "1F1F8-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      16
    ],
    o: 2
  },
  lotion_bottle: {
    a: "Lotion Bottle",
    b: "1F9F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      39
    ],
    o: 11
  },
  "flag-st": {
    a: "São Tomé & Príncipe Flag",
    b: "1F1F8-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      17
    ],
    o: 2
  },
  safety_pin: {
    a: "Safety Pin",
    b: "1F9F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      42
    ],
    o: 11
  },
  man_with_probing_cane: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man with Probing Cane",
    b: "1F468-200D-1F9AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      17
    ],
    o: 12
  },
  broom: {
    a: "Broom",
    b: "1F9F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      44
    ],
    o: 11
  },
  woman_with_probing_cane: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 4,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman with Probing Cane",
    b: "1F469-200D-1F9AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      2
    ],
    o: 12
  },
  "flag-sv": {
    a: "El Salvador Flag",
    b: "1F1F8-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      18
    ],
    o: 2
  },
  "flag-sx": {
    a: "Sint Maarten Flag",
    b: "1F1F8-1F1FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      19
    ],
    o: 2
  },
  basket: {
    a: "Basket",
    b: "1F9FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      45
    ],
    o: 11
  },
  person_in_motorized_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 38,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Person in Motorized Wheelchair",
    b: "1F9D1-200D-1F9BC",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      37
    ],
    o: 12
  },
  man_in_motorized_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 49,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Motorized Wheelchair",
    b: "1F468-200D-1F9BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      47
    ],
    o: 12
  },
  "flag-sy": {
    a: "Syria Flag",
    b: "1F1F8-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      20
    ],
    o: 2
  },
  roll_of_paper: {
    a: "Roll of Paper",
    b: "1F9FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      46
    ],
    o: 11
  },
  woman_in_motorized_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 37,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman in Motorized Wheelchair",
    b: "1F469-200D-1F9BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      32
    ],
    o: 12
  },
  "flag-sz": {
    a: "Eswatini Flag",
    b: "1F1F8-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      21
    ],
    o: 2
  },
  soap: {
    a: "Bar of Soap",
    b: "1F9FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      47
    ],
    o: 11
  },
  "flag-ta": {
    a: "Tristan Da Cunha Flag",
    b: "1F1F9-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      22
    ],
    o: 2
  },
  sponge: {
    a: "Sponge",
    b: "1F9FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      48
    ],
    o: 11
  },
  person_in_manual_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 47,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Person in Manual Wheelchair",
    b: "1F9D1-200D-1F9BD",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      43
    ],
    o: 12
  },
  fire_extinguisher: {
    a: "Fire Extinguisher",
    b: "1F9EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      34
    ],
    o: 11
  },
  man_in_manual_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9bd.png",
        sheet_x: 16,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9bd.png",
        sheet_x: 16,
        sheet_y: 55,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9bd.png",
        sheet_x: 16,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9bd.png",
        sheet_x: 17,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9bd.png",
        sheet_x: 17,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Manual Wheelchair",
    b: "1F468-200D-1F9BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      53
    ],
    o: 12
  },
  "flag-tc": {
    a: "Turks & Caicos Islands Flag",
    b: "1F1F9-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      23
    ],
    o: 2
  },
  woman_in_manual_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 43,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman in Manual Wheelchair",
    b: "1F469-200D-1F9BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      38
    ],
    o: 12
  },
  "flag-td": {
    a: "Chad Flag",
    b: "1F1F9-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      24
    ],
    o: 2
  },
  shopping_trolley: {
    a: "Shopping Trolley",
    b: "1F6D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      40
    ],
    o: 4
  },
  runner: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C3-1F3FB",
        non_qualified: null,
        image: "1f3c3-1f3fb.png",
        sheet_x: 9,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3C3-1F3FC",
        non_qualified: null,
        image: "1f3c3-1f3fc.png",
        sheet_x: 9,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3C3-1F3FD",
        non_qualified: null,
        image: "1f3c3-1f3fd.png",
        sheet_x: 9,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3C3-1F3FE",
        non_qualified: null,
        image: "1f3c3-1f3fe.png",
        sheet_x: 9,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3C3-1F3FF",
        non_qualified: null,
        image: "1f3c3-1f3ff.png",
        sheet_x: 9,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3C3-200D-2642-FE0F",
    a: "Runner",
    b: "1F3C3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      9,
      1
    ],
    n: [
      "running"
    ],
    o: 2
  },
  "flag-tf": {
    a: "French Southern Territories Flag",
    b: "1F1F9-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      25
    ],
    o: 2
  },
  smoking: {
    a: "Smoking Symbol",
    b: "1F6AC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "kills",
      "tobacco",
      "cigarette",
      "joint",
      "smoke"
    ],
    k: [
      35,
      3
    ],
    o: 2
  },
  coffin: {
    a: "Coffin",
    b: "26B0-FE0F",
    c: "26B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vampire",
      "dead",
      "die",
      "death",
      "rip",
      "graveyard",
      "cemetery",
      "casket",
      "funeral",
      "box"
    ],
    k: [
      53,
      54
    ],
    o: 2
  },
  "man-running": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C3-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FB-200D-2642",
        image: "1f3c3-1f3fb-200d-2642-fe0f.png",
        sheet_x: 8,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C3-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FC-200D-2642",
        image: "1f3c3-1f3fc-200d-2642-fe0f.png",
        sheet_x: 8,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C3-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FD-200D-2642",
        image: "1f3c3-1f3fd-200d-2642-fe0f.png",
        sheet_x: 8,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C3-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FE-200D-2642",
        image: "1f3c3-1f3fe-200d-2642-fe0f.png",
        sheet_x: 8,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C3-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FF-200D-2642",
        image: "1f3c3-1f3ff-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3C3",
    a: "Man Running",
    b: "1F3C3-200D-2642-FE0F",
    c: "1F3C3-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      8,
      52
    ],
    o: 4
  },
  "flag-tg": {
    a: "Togo Flag",
    b: "1F1F9-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      26
    ],
    o: 2
  },
  "woman-running": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C3-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FB-200D-2640",
        image: "1f3c3-1f3fb-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C3-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FC-200D-2640",
        image: "1f3c3-1f3fc-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C3-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FD-200D-2640",
        image: "1f3c3-1f3fd-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C3-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FE-200D-2640",
        image: "1f3c3-1f3fe-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C3-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FF-200D-2640",
        image: "1f3c3-1f3ff-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Running",
    b: "1F3C3-200D-2640-FE0F",
    c: "1F3C3-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      8,
      46
    ],
    o: 4
  },
  funeral_urn: {
    a: "Funeral Urn",
    b: "26B1-FE0F",
    c: "26B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dead",
      "die",
      "death",
      "rip",
      "ashes"
    ],
    k: [
      53,
      55
    ],
    o: 2
  },
  "flag-th": {
    a: "Thailand Flag",
    b: "1F1F9-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      27
    ],
    o: 2
  },
  moyai: {
    a: "Moyai",
    b: "1F5FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "rock",
      "easter island",
      "moai"
    ],
    k: [
      30,
      34
    ],
    o: 2
  },
  "flag-tj": {
    a: "Tajikistan Flag",
    b: "1F1F9-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      28
    ],
    o: 2
  },
  dancer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F483-1F3FB",
        non_qualified: null,
        image: "1f483-1f3fb.png",
        sheet_x: 24,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F483-1F3FC",
        non_qualified: null,
        image: "1f483-1f3fc.png",
        sheet_x: 24,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F483-1F3FD",
        non_qualified: null,
        image: "1f483-1f3fd.png",
        sheet_x: 24,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F483-1F3FE",
        non_qualified: null,
        image: "1f483-1f3fe.png",
        sheet_x: 24,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F483-1F3FF",
        non_qualified: null,
        image: "1f483-1f3ff.png",
        sheet_x: 24,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Dancer",
    b: "1F483",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "female",
      "girl",
      "woman",
      "fun"
    ],
    k: [
      24,
      26
    ],
    o: 2
  },
  "flag-tk": {
    a: "Tokelau Flag",
    b: "1F1F9-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      29
    ],
    o: 2
  },
  man_dancing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F57A-1F3FB",
        non_qualified: null,
        image: "1f57a-1f3fb.png",
        sheet_x: 29,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F57A-1F3FC",
        non_qualified: null,
        image: "1f57a-1f3fc.png",
        sheet_x: 29,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F57A-1F3FD",
        non_qualified: null,
        image: "1f57a-1f3fd.png",
        sheet_x: 29,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F57A-1F3FE",
        non_qualified: null,
        image: "1f57a-1f3fe.png",
        sheet_x: 29,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F57A-1F3FF",
        non_qualified: null,
        image: "1f57a-1f3ff.png",
        sheet_x: 29,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Dancing",
    b: "1F57A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "male",
      "boy",
      "fun",
      "dancer"
    ],
    k: [
      29,
      37
    ],
    o: 4
  },
  "flag-tl": {
    a: "Timor-Leste Flag",
    b: "1F1F9-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      30
    ],
    o: 2
  },
  man_in_business_suit_levitating: {
    skin_variations: {
      "1F3FB": {
        unified: "1F574-1F3FB",
        non_qualified: null,
        image: "1f574-1f3fb.png",
        sheet_x: 29,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F574-1F3FC",
        non_qualified: null,
        image: "1f574-1f3fc.png",
        sheet_x: 29,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F574-1F3FD",
        non_qualified: null,
        image: "1f574-1f3fd.png",
        sheet_x: 29,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F574-1F3FE",
        non_qualified: null,
        image: "1f574-1f3fe.png",
        sheet_x: 29,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F574-1F3FF",
        non_qualified: null,
        image: "1f574-1f3ff.png",
        sheet_x: 29,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Business Suit Levitating",
    b: "1F574-FE0F",
    c: "1F574",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      9
    ],
    o: 2
  },
  "flag-tm": {
    a: "Turkmenistan Flag",
    b: "1F1F9-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      31
    ],
    o: 2
  },
  dancers: {
    obsoleted_by: "1F46F-200D-2640-FE0F",
    a: "Woman with Bunny Ears",
    b: "1F46F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      0
    ],
    o: 2
  },
  "man-with-bunny-ears-partying": {
    a: "Man with Bunny Ears Partying",
    b: "1F46F-200D-2642-FE0F",
    c: "1F46F-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      21,
      56
    ],
    o: 4
  },
  "flag-tn": {
    a: "Tunisia Flag",
    b: "1F1F9-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      32
    ],
    o: 2
  },
  "flag-to": {
    a: "Tonga Flag",
    b: "1F1F9-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      33
    ],
    o: 2
  },
  "woman-with-bunny-ears-partying": {
    obsoletes: "1F46F",
    a: "Woman with Bunny Ears Partying",
    b: "1F46F-200D-2640-FE0F",
    c: "1F46F-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      21,
      55
    ],
    o: 4
  },
  "flag-tr": {
    a: "Turkey Flag",
    b: "1F1F9-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      34
    ],
    o: 2
  },
  person_in_steamy_room: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D6-1F3FB",
        non_qualified: null,
        image: "1f9d6-1f3fb.png",
        sheet_x: 48,
        sheet_y: 53,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FB-200D-2642-FE0F"
      },
      "1F3FC": {
        unified: "1F9D6-1F3FC",
        non_qualified: null,
        image: "1f9d6-1f3fc.png",
        sheet_x: 48,
        sheet_y: 54,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FC-200D-2642-FE0F"
      },
      "1F3FD": {
        unified: "1F9D6-1F3FD",
        non_qualified: null,
        image: "1f9d6-1f3fd.png",
        sheet_x: 48,
        sheet_y: 55,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FD-200D-2642-FE0F"
      },
      "1F3FE": {
        unified: "1F9D6-1F3FE",
        non_qualified: null,
        image: "1f9d6-1f3fe.png",
        sheet_x: 48,
        sheet_y: 56,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FE-200D-2642-FE0F"
      },
      "1F3FF": {
        unified: "1F9D6-1F3FF",
        non_qualified: null,
        image: "1f9d6-1f3ff.png",
        sheet_x: 49,
        sheet_y: 0,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FF-200D-2642-FE0F"
      }
    },
    obsoleted_by: "1F9D6-200D-2642-FE0F",
    a: "Person in Steamy Room",
    b: "1F9D6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      52
    ],
    o: 5
  },
  man_in_steamy_room: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D6-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FB-200D-2642",
        image: "1f9d6-1f3fb-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 47,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FB"
      },
      "1F3FC": {
        unified: "1F9D6-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FC-200D-2642",
        image: "1f9d6-1f3fc-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 48,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FC"
      },
      "1F3FD": {
        unified: "1F9D6-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FD-200D-2642",
        image: "1f9d6-1f3fd-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 49,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FD"
      },
      "1F3FE": {
        unified: "1F9D6-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FE-200D-2642",
        image: "1f9d6-1f3fe-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 50,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FE"
      },
      "1F3FF": {
        unified: "1F9D6-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FF-200D-2642",
        image: "1f9d6-1f3ff-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 51,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FF"
      }
    },
    obsoletes: "1F9D6",
    a: "Man in Steamy Room",
    b: "1F9D6-200D-2642-FE0F",
    c: "1F9D6-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      46
    ],
    o: 5
  },
  "flag-tt": {
    a: "Trinidad & Tobago Flag",
    b: "1F1F9-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      35
    ],
    o: 2
  },
  woman_in_steamy_room: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D6-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FB-200D-2640",
        image: "1f9d6-1f3fb-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 41,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D6-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FC-200D-2640",
        image: "1f9d6-1f3fc-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 42,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D6-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FD-200D-2640",
        image: "1f9d6-1f3fd-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 43,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D6-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FE-200D-2640",
        image: "1f9d6-1f3fe-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 44,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D6-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FF-200D-2640",
        image: "1f9d6-1f3ff-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 45,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman in Steamy Room",
    b: "1F9D6-200D-2640-FE0F",
    c: "1F9D6-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      40
    ],
    o: 5
  },
  "flag-tv": {
    a: "Tuvalu Flag",
    b: "1F1F9-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      36
    ],
    o: 2
  },
  "flag-tw": {
    a: "Taiwan Flag",
    b: "1F1F9-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      37
    ],
    o: 2
  },
  person_climbing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D7-1F3FB",
        non_qualified: null,
        image: "1f9d7-1f3fb.png",
        sheet_x: 49,
        sheet_y: 14,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9D7-1F3FC",
        non_qualified: null,
        image: "1f9d7-1f3fc.png",
        sheet_x: 49,
        sheet_y: 15,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9D7-1F3FD",
        non_qualified: null,
        image: "1f9d7-1f3fd.png",
        sheet_x: 49,
        sheet_y: 16,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9D7-1F3FE",
        non_qualified: null,
        image: "1f9d7-1f3fe.png",
        sheet_x: 49,
        sheet_y: 17,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9D7-1F3FF",
        non_qualified: null,
        image: "1f9d7-1f3ff.png",
        sheet_x: 49,
        sheet_y: 18,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9D7-200D-2640-FE0F",
    a: "Person Climbing",
    b: "1F9D7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      13
    ],
    o: 5
  },
  man_climbing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D7-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FB-200D-2642",
        image: "1f9d7-1f3fb-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 8,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D7-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FC-200D-2642",
        image: "1f9d7-1f3fc-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 9,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D7-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FD-200D-2642",
        image: "1f9d7-1f3fd-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 10,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D7-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FE-200D-2642",
        image: "1f9d7-1f3fe-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 11,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D7-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FF-200D-2642",
        image: "1f9d7-1f3ff-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Climbing",
    b: "1F9D7-200D-2642-FE0F",
    c: "1F9D7-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      7
    ],
    o: 5
  },
  "flag-tz": {
    a: "Tanzania Flag",
    b: "1F1F9-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      38
    ],
    o: 2
  },
  "flag-ua": {
    a: "Ukraine Flag",
    b: "1F1FA-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      39
    ],
    o: 2
  },
  woman_climbing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D7-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FB-200D-2640",
        image: "1f9d7-1f3fb-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 2,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FB"
      },
      "1F3FC": {
        unified: "1F9D7-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FC-200D-2640",
        image: "1f9d7-1f3fc-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 3,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FC"
      },
      "1F3FD": {
        unified: "1F9D7-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FD-200D-2640",
        image: "1f9d7-1f3fd-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 4,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FD"
      },
      "1F3FE": {
        unified: "1F9D7-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FE-200D-2640",
        image: "1f9d7-1f3fe-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 5,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FE"
      },
      "1F3FF": {
        unified: "1F9D7-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FF-200D-2640",
        image: "1f9d7-1f3ff-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 6,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FF"
      }
    },
    obsoletes: "1F9D7",
    a: "Woman Climbing",
    b: "1F9D7-200D-2640-FE0F",
    c: "1F9D7-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      1
    ],
    o: 5
  },
  "flag-ug": {
    a: "Uganda Flag",
    b: "1F1FA-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      40
    ],
    o: 2
  },
  fencer: {
    a: "Fencer",
    b: "1F93A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      32
    ],
    o: 4
  },
  "flag-um": {
    a: "U.s. Outlying Islands Flag",
    b: "1F1FA-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      41
    ],
    o: 2
  },
  horse_racing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C7-1F3FB",
        non_qualified: null,
        image: "1f3c7-1f3fb.png",
        sheet_x: 9,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C7-1F3FC",
        non_qualified: null,
        image: "1f3c7-1f3fc.png",
        sheet_x: 9,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C7-1F3FD",
        non_qualified: null,
        image: "1f3c7-1f3fd.png",
        sheet_x: 9,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C7-1F3FE",
        non_qualified: null,
        image: "1f3c7-1f3fe.png",
        sheet_x: 9,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C7-1F3FF",
        non_qualified: null,
        image: "1f3c7-1f3ff.png",
        sheet_x: 9,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Horse Racing",
    b: "1F3C7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "betting",
      "competition",
      "gambling",
      "luck"
    ],
    k: [
      9,
      27
    ],
    o: 2
  },
  skier: {
    a: "Skier",
    b: "26F7-FE0F",
    c: "26F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "winter",
      "snow"
    ],
    k: [
      54,
      17
    ],
    o: 2
  },
  "flag-un": {
    a: "United Nations Flag",
    b: "1F1FA-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      42
    ],
    o: 4
  },
  us: {
    a: "United States Flag",
    b: "1F1FA-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "united",
      "states",
      "america",
      "flag",
      "nation",
      "country",
      "banner"
    ],
    k: [
      4,
      43
    ],
    n: [
      "flag-us"
    ],
    o: 2
  },
  snowboarder: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C2-1F3FB",
        non_qualified: null,
        image: "1f3c2-1f3fb.png",
        sheet_x: 8,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C2-1F3FC",
        non_qualified: null,
        image: "1f3c2-1f3fc.png",
        sheet_x: 8,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C2-1F3FD",
        non_qualified: null,
        image: "1f3c2-1f3fd.png",
        sheet_x: 8,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C2-1F3FE",
        non_qualified: null,
        image: "1f3c2-1f3fe.png",
        sheet_x: 8,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C2-1F3FF",
        non_qualified: null,
        image: "1f3c2-1f3ff.png",
        sheet_x: 8,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Snowboarder",
    b: "1F3C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "winter"
    ],
    k: [
      8,
      40
    ],
    o: 2
  },
  golfer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CC-1F3FB",
        non_qualified: null,
        image: "1f3cc-1f3fb.png",
        sheet_x: 10,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3CC-1F3FC",
        non_qualified: null,
        image: "1f3cc-1f3fc.png",
        sheet_x: 10,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3CC-1F3FD",
        non_qualified: null,
        image: "1f3cc-1f3fd.png",
        sheet_x: 10,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3CC-1F3FE",
        non_qualified: null,
        image: "1f3cc-1f3fe.png",
        sheet_x: 10,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3CC-1F3FF",
        non_qualified: null,
        image: "1f3cc-1f3ff.png",
        sheet_x: 10,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3CC-FE0F-200D-2642-FE0F",
    a: "Golfer",
    b: "1F3CC-FE0F",
    c: "1F3CC",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      26
    ],
    o: 2
  },
  "flag-uy": {
    a: "Uruguay Flag",
    b: "1F1FA-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      44
    ],
    o: 2
  },
  "flag-uz": {
    a: "Uzbekistan Flag",
    b: "1F1FA-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      45
    ],
    o: 2
  },
  "man-golfing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CC-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FB-200D-2642",
        image: "1f3cc-1f3fb-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CC-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FC-200D-2642",
        image: "1f3cc-1f3fc-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CC-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FD-200D-2642",
        image: "1f3cc-1f3fd-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CC-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FE-200D-2642",
        image: "1f3cc-1f3fe-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CC-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FF-200D-2642",
        image: "1f3cc-1f3ff-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3CC-FE0F",
    a: "Man Golfing",
    b: "1F3CC-FE0F-200D-2642-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      20
    ],
    o: 4
  },
  "flag-va": {
    a: "Vatican City Flag",
    b: "1F1FB-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      46
    ],
    o: 2
  },
  "woman-golfing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CC-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FB-200D-2640",
        image: "1f3cc-1f3fb-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CC-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FC-200D-2640",
        image: "1f3cc-1f3fc-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CC-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FD-200D-2640",
        image: "1f3cc-1f3fd-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CC-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FE-200D-2640",
        image: "1f3cc-1f3fe-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CC-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FF-200D-2640",
        image: "1f3cc-1f3ff-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Golfing",
    b: "1F3CC-FE0F-200D-2640-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      14
    ],
    o: 4
  },
  "flag-vc": {
    a: "St. Vincent & Grenadines Flag",
    b: "1F1FB-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      47
    ],
    o: 2
  },
  surfer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C4-1F3FB",
        non_qualified: null,
        image: "1f3c4-1f3fb.png",
        sheet_x: 9,
        sheet_y: 20,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3C4-1F3FC",
        non_qualified: null,
        image: "1f3c4-1f3fc.png",
        sheet_x: 9,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3C4-1F3FD",
        non_qualified: null,
        image: "1f3c4-1f3fd.png",
        sheet_x: 9,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3C4-1F3FE",
        non_qualified: null,
        image: "1f3c4-1f3fe.png",
        sheet_x: 9,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3C4-1F3FF",
        non_qualified: null,
        image: "1f3c4-1f3ff.png",
        sheet_x: 9,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3C4-200D-2642-FE0F",
    a: "Surfer",
    b: "1F3C4",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      9,
      19
    ],
    o: 2
  },
  "man-surfing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C4-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FB-200D-2642",
        image: "1f3c4-1f3fb-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C4-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FC-200D-2642",
        image: "1f3c4-1f3fc-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C4-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FD-200D-2642",
        image: "1f3c4-1f3fd-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C4-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FE-200D-2642",
        image: "1f3c4-1f3fe-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C4-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FF-200D-2642",
        image: "1f3c4-1f3ff-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3C4",
    a: "Man Surfing",
    b: "1F3C4-200D-2642-FE0F",
    c: "1F3C4-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      13
    ],
    o: 4
  },
  "flag-ve": {
    a: "Venezuela Flag",
    b: "1F1FB-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      48
    ],
    o: 2
  },
  "flag-vg": {
    a: "British Virgin Islands Flag",
    b: "1F1FB-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      49
    ],
    o: 2
  },
  "woman-surfing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C4-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FB-200D-2640",
        image: "1f3c4-1f3fb-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C4-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FC-200D-2640",
        image: "1f3c4-1f3fc-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C4-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FD-200D-2640",
        image: "1f3c4-1f3fd-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C4-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FE-200D-2640",
        image: "1f3c4-1f3fe-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C4-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FF-200D-2640",
        image: "1f3c4-1f3ff-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Surfing",
    b: "1F3C4-200D-2640-FE0F",
    c: "1F3C4-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      7
    ],
    o: 4
  },
  rowboat: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6A3-1F3FB",
        non_qualified: null,
        image: "1f6a3-1f3fb.png",
        sheet_x: 34,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F6A3-1F3FC",
        non_qualified: null,
        image: "1f6a3-1f3fc.png",
        sheet_x: 34,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F6A3-1F3FD",
        non_qualified: null,
        image: "1f6a3-1f3fd.png",
        sheet_x: 34,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F6A3-1F3FE",
        non_qualified: null,
        image: "1f6a3-1f3fe.png",
        sheet_x: 34,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F6A3-1F3FF",
        non_qualified: null,
        image: "1f6a3-1f3ff.png",
        sheet_x: 34,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F6A3-200D-2642-FE0F",
    a: "Rowboat",
    b: "1F6A3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      34,
      46
    ],
    o: 2
  },
  "flag-vi": {
    a: "U.s. Virgin Islands Flag",
    b: "1F1FB-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      50
    ],
    o: 2
  },
  "man-rowing-boat": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6A3-1F3FB-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FB-200D-2642",
        image: "1f6a3-1f3fb-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6A3-1F3FC-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FC-200D-2642",
        image: "1f6a3-1f3fc-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6A3-1F3FD-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FD-200D-2642",
        image: "1f6a3-1f3fd-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6A3-1F3FE-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FE-200D-2642",
        image: "1f6a3-1f3fe-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6A3-1F3FF-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FF-200D-2642",
        image: "1f6a3-1f3ff-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F6A3",
    a: "Man Rowing Boat",
    b: "1F6A3-200D-2642-FE0F",
    c: "1F6A3-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      34,
      40
    ],
    o: 4
  },
  "flag-vn": {
    a: "Vietnam Flag",
    b: "1F1FB-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      51
    ],
    o: 2
  },
  "flag-vu": {
    a: "Vanuatu Flag",
    b: "1F1FB-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      52
    ],
    o: 2
  },
  "woman-rowing-boat": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6A3-1F3FB-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FB-200D-2640",
        image: "1f6a3-1f3fb-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6A3-1F3FC-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FC-200D-2640",
        image: "1f6a3-1f3fc-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6A3-1F3FD-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FD-200D-2640",
        image: "1f6a3-1f3fd-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6A3-1F3FE-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FE-200D-2640",
        image: "1f6a3-1f3fe-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6A3-1F3FF-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FF-200D-2640",
        image: "1f6a3-1f3ff-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Rowing Boat",
    b: "1F6A3-200D-2640-FE0F",
    c: "1F6A3-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      34,
      34
    ],
    o: 4
  },
  swimmer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CA-1F3FB",
        non_qualified: null,
        image: "1f3ca-1f3fb.png",
        sheet_x: 9,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3CA-1F3FC",
        non_qualified: null,
        image: "1f3ca-1f3fc.png",
        sheet_x: 9,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3CA-1F3FD",
        non_qualified: null,
        image: "1f3ca-1f3fd.png",
        sheet_x: 9,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3CA-1F3FE",
        non_qualified: null,
        image: "1f3ca-1f3fe.png",
        sheet_x: 9,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3CA-1F3FF",
        non_qualified: null,
        image: "1f3ca-1f3ff.png",
        sheet_x: 9,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3CA-200D-2642-FE0F",
    a: "Swimmer",
    b: "1F3CA",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      9,
      47
    ],
    o: 2
  },
  "flag-wf": {
    a: "Wallis & Futuna Flag",
    b: "1F1FC-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      53
    ],
    o: 2
  },
  "man-swimming": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CA-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FB-200D-2642",
        image: "1f3ca-1f3fb-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CA-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FC-200D-2642",
        image: "1f3ca-1f3fc-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CA-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FD-200D-2642",
        image: "1f3ca-1f3fd-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CA-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FE-200D-2642",
        image: "1f3ca-1f3fe-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CA-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FF-200D-2642",
        image: "1f3ca-1f3ff-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3CA",
    a: "Man Swimming",
    b: "1F3CA-200D-2642-FE0F",
    c: "1F3CA-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      41
    ],
    o: 4
  },
  "flag-ws": {
    a: "Samoa Flag",
    b: "1F1FC-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      54
    ],
    o: 2
  },
  "woman-swimming": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CA-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FB-200D-2640",
        image: "1f3ca-1f3fb-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CA-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FC-200D-2640",
        image: "1f3ca-1f3fc-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CA-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FD-200D-2640",
        image: "1f3ca-1f3fd-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CA-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FE-200D-2640",
        image: "1f3ca-1f3fe-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CA-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FF-200D-2640",
        image: "1f3ca-1f3ff-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Swimming",
    b: "1F3CA-200D-2640-FE0F",
    c: "1F3CA-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      35
    ],
    o: 4
  },
  "flag-xk": {
    a: "Kosovo Flag",
    b: "1F1FD-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      55
    ],
    o: 2
  },
  person_with_ball: {
    skin_variations: {
      "1F3FB": {
        unified: "26F9-1F3FB",
        non_qualified: null,
        image: "26f9-1f3fb.png",
        sheet_x: 54,
        sheet_y: 32,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "26F9-1F3FC",
        non_qualified: null,
        image: "26f9-1f3fc.png",
        sheet_x: 54,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "26F9-1F3FD",
        non_qualified: null,
        image: "26f9-1f3fd.png",
        sheet_x: 54,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "26F9-1F3FE",
        non_qualified: null,
        image: "26f9-1f3fe.png",
        sheet_x: 54,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "26F9-1F3FF",
        non_qualified: null,
        image: "26f9-1f3ff.png",
        sheet_x: 54,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "26F9-FE0F-200D-2642-FE0F",
    a: "Person with Ball",
    b: "26F9-FE0F",
    c: "26F9",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      54,
      31
    ],
    o: 2
  },
  "flag-ye": {
    a: "Yemen Flag",
    b: "1F1FE-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      56
    ],
    o: 2
  },
  "man-bouncing-ball": {
    skin_variations: {
      "1F3FB": {
        unified: "26F9-1F3FB-200D-2642-FE0F",
        non_qualified: "26F9-1F3FB-200D-2642",
        image: "26f9-1f3fb-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "26F9-1F3FC-200D-2642-FE0F",
        non_qualified: "26F9-1F3FC-200D-2642",
        image: "26f9-1f3fc-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "26F9-1F3FD-200D-2642-FE0F",
        non_qualified: "26F9-1F3FD-200D-2642",
        image: "26f9-1f3fd-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "26F9-1F3FE-200D-2642-FE0F",
        non_qualified: "26F9-1F3FE-200D-2642",
        image: "26f9-1f3fe-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "26F9-1F3FF-200D-2642-FE0F",
        non_qualified: "26F9-1F3FF-200D-2642",
        image: "26f9-1f3ff-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "26F9-FE0F",
    a: "Man Bouncing Ball",
    b: "26F9-FE0F-200D-2642-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      54,
      25
    ],
    o: 4
  },
  "flag-yt": {
    a: "Mayotte Flag",
    b: "1F1FE-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      0
    ],
    o: 2
  },
  "woman-bouncing-ball": {
    skin_variations: {
      "1F3FB": {
        unified: "26F9-1F3FB-200D-2640-FE0F",
        non_qualified: "26F9-1F3FB-200D-2640",
        image: "26f9-1f3fb-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "26F9-1F3FC-200D-2640-FE0F",
        non_qualified: "26F9-1F3FC-200D-2640",
        image: "26f9-1f3fc-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "26F9-1F3FD-200D-2640-FE0F",
        non_qualified: "26F9-1F3FD-200D-2640",
        image: "26f9-1f3fd-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "26F9-1F3FE-200D-2640-FE0F",
        non_qualified: "26F9-1F3FE-200D-2640",
        image: "26f9-1f3fe-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "26F9-1F3FF-200D-2640-FE0F",
        non_qualified: "26F9-1F3FF-200D-2640",
        image: "26f9-1f3ff-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Bouncing Ball",
    b: "26F9-FE0F-200D-2640-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      54,
      19
    ],
    o: 4
  },
  "flag-za": {
    a: "South Africa Flag",
    b: "1F1FF-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      1
    ],
    o: 2
  },
  "flag-zm": {
    a: "Zambia Flag",
    b: "1F1FF-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      2
    ],
    o: 2
  },
  weight_lifter: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CB-1F3FB",
        non_qualified: null,
        image: "1f3cb-1f3fb.png",
        sheet_x: 10,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3CB-1F3FC",
        non_qualified: null,
        image: "1f3cb-1f3fc.png",
        sheet_x: 10,
        sheet_y: 10,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3CB-1F3FD",
        non_qualified: null,
        image: "1f3cb-1f3fd.png",
        sheet_x: 10,
        sheet_y: 11,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3CB-1F3FE",
        non_qualified: null,
        image: "1f3cb-1f3fe.png",
        sheet_x: 10,
        sheet_y: 12,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3CB-1F3FF",
        non_qualified: null,
        image: "1f3cb-1f3ff.png",
        sheet_x: 10,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3CB-FE0F-200D-2642-FE0F",
    a: "Weight Lifter",
    b: "1F3CB-FE0F",
    c: "1F3CB",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      8
    ],
    o: 2
  },
  "man-lifting-weights": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CB-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FB-200D-2642",
        image: "1f3cb-1f3fb-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CB-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FC-200D-2642",
        image: "1f3cb-1f3fc-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CB-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FD-200D-2642",
        image: "1f3cb-1f3fd-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CB-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FE-200D-2642",
        image: "1f3cb-1f3fe-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CB-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FF-200D-2642",
        image: "1f3cb-1f3ff-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3CB-FE0F",
    a: "Man Lifting Weights",
    b: "1F3CB-FE0F-200D-2642-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      2
    ],
    o: 4
  },
  "flag-zw": {
    a: "Zimbabwe Flag",
    b: "1F1FF-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      3
    ],
    o: 2
  },
  "woman-lifting-weights": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CB-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FB-200D-2640",
        image: "1f3cb-1f3fb-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CB-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FC-200D-2640",
        image: "1f3cb-1f3fc-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CB-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FD-200D-2640",
        image: "1f3cb-1f3fd-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CB-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FE-200D-2640",
        image: "1f3cb-1f3fe-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CB-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FF-200D-2640",
        image: "1f3cb-1f3ff-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Lifting Weights",
    b: "1F3CB-FE0F-200D-2640-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      9,
      53
    ],
    o: 4
  },
  "flag-england": {
    a: "England Flag",
    b: "1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      14
    ],
    o: 5
  },
  bicyclist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B4-1F3FB",
        non_qualified: null,
        image: "1f6b4-1f3fb.png",
        sheet_x: 35,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F6B4-1F3FC",
        non_qualified: null,
        image: "1f6b4-1f3fc.png",
        sheet_x: 35,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F6B4-1F3FD",
        non_qualified: null,
        image: "1f6b4-1f3fd.png",
        sheet_x: 35,
        sheet_y: 26,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F6B4-1F3FE",
        non_qualified: null,
        image: "1f6b4-1f3fe.png",
        sheet_x: 35,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F6B4-1F3FF",
        non_qualified: null,
        image: "1f6b4-1f3ff.png",
        sheet_x: 35,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F6B4-200D-2642-FE0F",
    a: "Bicyclist",
    b: "1F6B4",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      35,
      23
    ],
    o: 2
  },
  "flag-scotland": {
    a: "Scotland Flag",
    b: "1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      15
    ],
    o: 5
  },
  "flag-wales": {
    a: "Wales Flag",
    b: "1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      16
    ],
    o: 5
  },
  "man-biking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B4-1F3FB-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FB-200D-2642",
        image: "1f6b4-1f3fb-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B4-1F3FC-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FC-200D-2642",
        image: "1f6b4-1f3fc-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B4-1F3FD-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FD-200D-2642",
        image: "1f6b4-1f3fd-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B4-1F3FE-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FE-200D-2642",
        image: "1f6b4-1f3fe-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B4-1F3FF-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FF-200D-2642",
        image: "1f6b4-1f3ff-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F6B4",
    a: "Man Biking",
    b: "1F6B4-200D-2642-FE0F",
    c: "1F6B4-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      17
    ],
    o: 4
  },
  "woman-biking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B4-1F3FB-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FB-200D-2640",
        image: "1f6b4-1f3fb-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B4-1F3FC-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FC-200D-2640",
        image: "1f6b4-1f3fc-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B4-1F3FD-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FD-200D-2640",
        image: "1f6b4-1f3fd-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B4-1F3FE-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FE-200D-2640",
        image: "1f6b4-1f3fe-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B4-1F3FF-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FF-200D-2640",
        image: "1f6b4-1f3ff-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Biking",
    b: "1F6B4-200D-2640-FE0F",
    c: "1F6B4-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      11
    ],
    o: 4
  },
  mountain_bicyclist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B5-1F3FB",
        non_qualified: null,
        image: "1f6b5-1f3fb.png",
        sheet_x: 35,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F6B5-1F3FC",
        non_qualified: null,
        image: "1f6b5-1f3fc.png",
        sheet_x: 35,
        sheet_y: 43,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F6B5-1F3FD",
        non_qualified: null,
        image: "1f6b5-1f3fd.png",
        sheet_x: 35,
        sheet_y: 44,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F6B5-1F3FE",
        non_qualified: null,
        image: "1f6b5-1f3fe.png",
        sheet_x: 35,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F6B5-1F3FF",
        non_qualified: null,
        image: "1f6b5-1f3ff.png",
        sheet_x: 35,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F6B5-200D-2642-FE0F",
    a: "Mountain Bicyclist",
    b: "1F6B5",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      35,
      41
    ],
    o: 2
  },
  "man-mountain-biking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B5-1F3FB-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FB-200D-2642",
        image: "1f6b5-1f3fb-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B5-1F3FC-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FC-200D-2642",
        image: "1f6b5-1f3fc-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B5-1F3FD-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FD-200D-2642",
        image: "1f6b5-1f3fd-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B5-1F3FE-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FE-200D-2642",
        image: "1f6b5-1f3fe-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B5-1F3FF-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FF-200D-2642",
        image: "1f6b5-1f3ff-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F6B5",
    a: "Man Mountain Biking",
    b: "1F6B5-200D-2642-FE0F",
    c: "1F6B5-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      35
    ],
    o: 4
  },
  "woman-mountain-biking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B5-1F3FB-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FB-200D-2640",
        image: "1f6b5-1f3fb-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B5-1F3FC-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FC-200D-2640",
        image: "1f6b5-1f3fc-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B5-1F3FD-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FD-200D-2640",
        image: "1f6b5-1f3fd-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B5-1F3FE-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FE-200D-2640",
        image: "1f6b5-1f3fe-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B5-1F3FF-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FF-200D-2640",
        image: "1f6b5-1f3ff-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Mountain Biking",
    b: "1F6B5-200D-2640-FE0F",
    c: "1F6B5-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      29
    ],
    o: 4
  },
  person_doing_cartwheel: {
    skin_variations: {
      "1F3FB": {
        unified: "1F938-1F3FB",
        non_qualified: null,
        image: "1f938-1f3fb.png",
        sheet_x: 40,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F938-1F3FC",
        non_qualified: null,
        image: "1f938-1f3fc.png",
        sheet_x: 40,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F938-1F3FD",
        non_qualified: null,
        image: "1f938-1f3fd.png",
        sheet_x: 40,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F938-1F3FE",
        non_qualified: null,
        image: "1f938-1f3fe.png",
        sheet_x: 40,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F938-1F3FF",
        non_qualified: null,
        image: "1f938-1f3ff.png",
        sheet_x: 40,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Person Doing Cartwheel",
    b: "1F938",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      40,
      8
    ],
    o: 4
  },
  "man-cartwheeling": {
    skin_variations: {
      "1F3FB": {
        unified: "1F938-1F3FB-200D-2642-FE0F",
        non_qualified: "1F938-1F3FB-200D-2642",
        image: "1f938-1f3fb-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F938-1F3FC-200D-2642-FE0F",
        non_qualified: "1F938-1F3FC-200D-2642",
        image: "1f938-1f3fc-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F938-1F3FD-200D-2642-FE0F",
        non_qualified: "1F938-1F3FD-200D-2642",
        image: "1f938-1f3fd-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F938-1F3FE-200D-2642-FE0F",
        non_qualified: "1F938-1F3FE-200D-2642",
        image: "1f938-1f3fe-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F938-1F3FF-200D-2642-FE0F",
        non_qualified: "1F938-1F3FF-200D-2642",
        image: "1f938-1f3ff-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Cartwheeling",
    b: "1F938-200D-2642-FE0F",
    c: "1F938-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      2
    ],
    o: 4
  },
  "woman-cartwheeling": {
    skin_variations: {
      "1F3FB": {
        unified: "1F938-1F3FB-200D-2640-FE0F",
        non_qualified: "1F938-1F3FB-200D-2640",
        image: "1f938-1f3fb-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F938-1F3FC-200D-2640-FE0F",
        non_qualified: "1F938-1F3FC-200D-2640",
        image: "1f938-1f3fc-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F938-1F3FD-200D-2640-FE0F",
        non_qualified: "1F938-1F3FD-200D-2640",
        image: "1f938-1f3fd-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F938-1F3FE-200D-2640-FE0F",
        non_qualified: "1F938-1F3FE-200D-2640",
        image: "1f938-1f3fe-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F938-1F3FF-200D-2640-FE0F",
        non_qualified: "1F938-1F3FF-200D-2640",
        image: "1f938-1f3ff-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Cartwheeling",
    b: "1F938-200D-2640-FE0F",
    c: "1F938-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      39,
      53
    ],
    o: 4
  },
  wrestlers: {
    a: "Wrestlers",
    b: "1F93C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      35
    ],
    o: 4
  },
  "man-wrestling": {
    a: "Man Wrestling",
    b: "1F93C-200D-2642-FE0F",
    c: "1F93C-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      34
    ],
    o: 4
  },
  "woman-wrestling": {
    a: "Woman Wrestling",
    b: "1F93C-200D-2640-FE0F",
    c: "1F93C-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      33
    ],
    o: 4
  },
  water_polo: {
    skin_variations: {
      "1F3FB": {
        unified: "1F93D-1F3FB",
        non_qualified: null,
        image: "1f93d-1f3fb.png",
        sheet_x: 40,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F93D-1F3FC",
        non_qualified: null,
        image: "1f93d-1f3fc.png",
        sheet_x: 40,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F93D-1F3FD",
        non_qualified: null,
        image: "1f93d-1f3fd.png",
        sheet_x: 40,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F93D-1F3FE",
        non_qualified: null,
        image: "1f93d-1f3fe.png",
        sheet_x: 40,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F93D-1F3FF",
        non_qualified: null,
        image: "1f93d-1f3ff.png",
        sheet_x: 40,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Water Polo",
    b: "1F93D",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      40,
      48
    ],
    o: 4
  },
  "man-playing-water-polo": {
    skin_variations: {
      "1F3FB": {
        unified: "1F93D-1F3FB-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FB-200D-2642",
        image: "1f93d-1f3fb-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F93D-1F3FC-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FC-200D-2642",
        image: "1f93d-1f3fc-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F93D-1F3FD-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FD-200D-2642",
        image: "1f93d-1f3fd-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F93D-1F3FE-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FE-200D-2642",
        image: "1f93d-1f3fe-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F93D-1F3FF-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FF-200D-2642",
        image: "1f93d-1f3ff-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Playing Water Polo",
    b: "1F93D-200D-2642-FE0F",
    c: "1F93D-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      42
    ],
    o: 4
  },
  "woman-playing-water-polo": {
    skin_variations: {
      "1F3FB": {
        unified: "1F93D-1F3FB-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FB-200D-2640",
        image: "1f93d-1f3fb-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F93D-1F3FC-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FC-200D-2640",
        image: "1f93d-1f3fc-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F93D-1F3FD-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FD-200D-2640",
        image: "1f93d-1f3fd-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F93D-1F3FE-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FE-200D-2640",
        image: "1f93d-1f3fe-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F93D-1F3FF-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FF-200D-2640",
        image: "1f93d-1f3ff-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Playing Water Polo",
    b: "1F93D-200D-2640-FE0F",
    c: "1F93D-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      36
    ],
    o: 4
  },
  handball: {
    skin_variations: {
      "1F3FB": {
        unified: "1F93E-1F3FB",
        non_qualified: null,
        image: "1f93e-1f3fb.png",
        sheet_x: 41,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F93E-1F3FC",
        non_qualified: null,
        image: "1f93e-1f3fc.png",
        sheet_x: 41,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F93E-1F3FD",
        non_qualified: null,
        image: "1f93e-1f3fd.png",
        sheet_x: 41,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F93E-1F3FE",
        non_qualified: null,
        image: "1f93e-1f3fe.png",
        sheet_x: 41,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F93E-1F3FF",
        non_qualified: null,
        image: "1f93e-1f3ff.png",
        sheet_x: 41,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Handball",
    b: "1F93E",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      41,
      9
    ],
    o: 4
  },
  "man-playing-handball": {
    skin_variations: {
      "1F3FB": {
        unified: "1F93E-1F3FB-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FB-200D-2642",
        image: "1f93e-1f3fb-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F93E-1F3FC-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FC-200D-2642",
        image: "1f93e-1f3fc-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F93E-1F3FD-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FD-200D-2642",
        image: "1f93e-1f3fd-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F93E-1F3FE-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FE-200D-2642",
        image: "1f93e-1f3fe-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F93E-1F3FF-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FF-200D-2642",
        image: "1f93e-1f3ff-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Playing Handball",
    b: "1F93E-200D-2642-FE0F",
    c: "1F93E-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      3
    ],
    o: 4
  },
  "woman-playing-handball": {
    skin_variations: {
      "1F3FB": {
        unified: "1F93E-1F3FB-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FB-200D-2640",
        image: "1f93e-1f3fb-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F93E-1F3FC-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FC-200D-2640",
        image: "1f93e-1f3fc-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F93E-1F3FD-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FD-200D-2640",
        image: "1f93e-1f3fd-200d-2640-fe0f.png",
        sheet_x: 41,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F93E-1F3FE-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FE-200D-2640",
        image: "1f93e-1f3fe-200d-2640-fe0f.png",
        sheet_x: 41,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F93E-1F3FF-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FF-200D-2640",
        image: "1f93e-1f3ff-200d-2640-fe0f.png",
        sheet_x: 41,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Playing Handball",
    b: "1F93E-200D-2640-FE0F",
    c: "1F93E-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      54
    ],
    o: 4
  },
  juggling: {
    skin_variations: {
      "1F3FB": {
        unified: "1F939-1F3FB",
        non_qualified: null,
        image: "1f939-1f3fb.png",
        sheet_x: 40,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F939-1F3FC",
        non_qualified: null,
        image: "1f939-1f3fc.png",
        sheet_x: 40,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F939-1F3FD",
        non_qualified: null,
        image: "1f939-1f3fd.png",
        sheet_x: 40,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F939-1F3FE",
        non_qualified: null,
        image: "1f939-1f3fe.png",
        sheet_x: 40,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F939-1F3FF",
        non_qualified: null,
        image: "1f939-1f3ff.png",
        sheet_x: 40,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Juggling",
    b: "1F939",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      26
    ],
    o: 4
  },
  "man-juggling": {
    skin_variations: {
      "1F3FB": {
        unified: "1F939-1F3FB-200D-2642-FE0F",
        non_qualified: "1F939-1F3FB-200D-2642",
        image: "1f939-1f3fb-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F939-1F3FC-200D-2642-FE0F",
        non_qualified: "1F939-1F3FC-200D-2642",
        image: "1f939-1f3fc-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F939-1F3FD-200D-2642-FE0F",
        non_qualified: "1F939-1F3FD-200D-2642",
        image: "1f939-1f3fd-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F939-1F3FE-200D-2642-FE0F",
        non_qualified: "1F939-1F3FE-200D-2642",
        image: "1f939-1f3fe-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F939-1F3FF-200D-2642-FE0F",
        non_qualified: "1F939-1F3FF-200D-2642",
        image: "1f939-1f3ff-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Juggling",
    b: "1F939-200D-2642-FE0F",
    c: "1F939-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      20
    ],
    o: 4
  },
  "woman-juggling": {
    skin_variations: {
      "1F3FB": {
        unified: "1F939-1F3FB-200D-2640-FE0F",
        non_qualified: "1F939-1F3FB-200D-2640",
        image: "1f939-1f3fb-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F939-1F3FC-200D-2640-FE0F",
        non_qualified: "1F939-1F3FC-200D-2640",
        image: "1f939-1f3fc-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F939-1F3FD-200D-2640-FE0F",
        non_qualified: "1F939-1F3FD-200D-2640",
        image: "1f939-1f3fd-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F939-1F3FE-200D-2640-FE0F",
        non_qualified: "1F939-1F3FE-200D-2640",
        image: "1f939-1f3fe-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F939-1F3FF-200D-2640-FE0F",
        non_qualified: "1F939-1F3FF-200D-2640",
        image: "1f939-1f3ff-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Juggling",
    b: "1F939-200D-2640-FE0F",
    c: "1F939-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      14
    ],
    o: 4
  },
  person_in_lotus_position: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D8-1F3FB",
        non_qualified: null,
        image: "1f9d8-1f3fb.png",
        sheet_x: 49,
        sheet_y: 32,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9D8-1F3FC",
        non_qualified: null,
        image: "1f9d8-1f3fc.png",
        sheet_x: 49,
        sheet_y: 33,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9D8-1F3FD",
        non_qualified: null,
        image: "1f9d8-1f3fd.png",
        sheet_x: 49,
        sheet_y: 34,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9D8-1F3FE",
        non_qualified: null,
        image: "1f9d8-1f3fe.png",
        sheet_x: 49,
        sheet_y: 35,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9D8-1F3FF",
        non_qualified: null,
        image: "1f9d8-1f3ff.png",
        sheet_x: 49,
        sheet_y: 36,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9D8-200D-2640-FE0F",
    a: "Person in Lotus Position",
    b: "1F9D8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      31
    ],
    o: 5
  },
  man_in_lotus_position: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D8-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FB-200D-2642",
        image: "1f9d8-1f3fb-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 26,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D8-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FC-200D-2642",
        image: "1f9d8-1f3fc-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 27,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D8-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FD-200D-2642",
        image: "1f9d8-1f3fd-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 28,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D8-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FE-200D-2642",
        image: "1f9d8-1f3fe-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 29,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D8-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FF-200D-2642",
        image: "1f9d8-1f3ff-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 30,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Lotus Position",
    b: "1F9D8-200D-2642-FE0F",
    c: "1F9D8-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      25
    ],
    o: 5
  },
  woman_in_lotus_position: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D8-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FB-200D-2640",
        image: "1f9d8-1f3fb-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 20,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FB"
      },
      "1F3FC": {
        unified: "1F9D8-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FC-200D-2640",
        image: "1f9d8-1f3fc-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 21,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FC"
      },
      "1F3FD": {
        unified: "1F9D8-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FD-200D-2640",
        image: "1f9d8-1f3fd-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 22,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FD"
      },
      "1F3FE": {
        unified: "1F9D8-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FE-200D-2640",
        image: "1f9d8-1f3fe-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 23,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FE"
      },
      "1F3FF": {
        unified: "1F9D8-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FF-200D-2640",
        image: "1f9d8-1f3ff-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 24,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FF"
      }
    },
    obsoletes: "1F9D8",
    a: "Woman in Lotus Position",
    b: "1F9D8-200D-2640-FE0F",
    c: "1F9D8-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      19
    ],
    o: 5
  },
  bath: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6C0-1F3FB",
        non_qualified: null,
        image: "1f6c0-1f3fb.png",
        sheet_x: 36,
        sheet_y: 18,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6C0-1F3FC",
        non_qualified: null,
        image: "1f6c0-1f3fc.png",
        sheet_x: 36,
        sheet_y: 19,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6C0-1F3FD",
        non_qualified: null,
        image: "1f6c0-1f3fd.png",
        sheet_x: 36,
        sheet_y: 20,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6C0-1F3FE",
        non_qualified: null,
        image: "1f6c0-1f3fe.png",
        sheet_x: 36,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6C0-1F3FF",
        non_qualified: null,
        image: "1f6c0-1f3ff.png",
        sheet_x: 36,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bath",
    b: "1F6C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "clean",
      "shower",
      "bathroom"
    ],
    k: [
      36,
      17
    ],
    o: 2
  },
  sleeping_accommodation: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6CC-1F3FB",
        non_qualified: null,
        image: "1f6cc-1f3fb.png",
        sheet_x: 36,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6CC-1F3FC",
        non_qualified: null,
        image: "1f6cc-1f3fc.png",
        sheet_x: 36,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6CC-1F3FD",
        non_qualified: null,
        image: "1f6cc-1f3fd.png",
        sheet_x: 36,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6CC-1F3FE",
        non_qualified: null,
        image: "1f6cc-1f3fe.png",
        sheet_x: 36,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6CC-1F3FF",
        non_qualified: null,
        image: "1f6cc-1f3ff.png",
        sheet_x: 36,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Sleeping Accommodation",
    b: "1F6CC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      29
    ],
    o: 2
  },
  people_holding_hands: {
    skin_variations: {
      "1F3FB-1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 46,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FC": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 46,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FD": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 46,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FE": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 46,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FF": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 46,
        sheet_y: 43,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FB": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 46,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 46,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FD": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 46,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FE": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 46,
        sheet_y: 47,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FF": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 46,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FB": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 46,
        sheet_y: 49,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FC": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 46,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 46,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FE": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 46,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FF": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 46,
        sheet_y: 53,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE-1F3FB": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 46,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FC": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 46,
        sheet_y: 55,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FD": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 46,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 47,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FF": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 47,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF-1F3FB": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 47,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FC": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 47,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FD": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 47,
        sheet_y: 4,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FE": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 47,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 47,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "People Holding Hands",
    b: "1F9D1-200D-1F91D-200D-1F9D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      46,
      38
    ],
    o: 12
  },
  two_women_holding_hands: {
    skin_variations: {
      "1F3FB": {
        unified: "1F46D-1F3FB",
        non_qualified: null,
        image: "1f46d-1f3fb.png",
        sheet_x: 21,
        sheet_y: 12,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46D-1F3FC",
        non_qualified: null,
        image: "1f46d-1f3fc.png",
        sheet_x: 21,
        sheet_y: 13,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46D-1F3FD",
        non_qualified: null,
        image: "1f46d-1f3fd.png",
        sheet_x: 21,
        sheet_y: 14,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46D-1F3FE",
        non_qualified: null,
        image: "1f46d-1f3fe.png",
        sheet_x: 21,
        sheet_y: 15,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46D-1F3FF",
        non_qualified: null,
        image: "1f46d-1f3ff.png",
        sheet_x: 21,
        sheet_y: 16,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FC": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc.png",
        sheet_x: 21,
        sheet_y: 17,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FD": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd.png",
        sheet_x: 21,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FE": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe.png",
        sheet_x: 21,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FF": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff.png",
        sheet_x: 21,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FB": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb.png",
        sheet_x: 21,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FD": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd.png",
        sheet_x: 21,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FE": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe.png",
        sheet_x: 21,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FF": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff.png",
        sheet_x: 21,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FB": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb.png",
        sheet_x: 21,
        sheet_y: 25,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FC": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc.png",
        sheet_x: 21,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FE": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe.png",
        sheet_x: 21,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FF": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff.png",
        sheet_x: 21,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE-1F3FB": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb.png",
        sheet_x: 21,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FC": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc.png",
        sheet_x: 21,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FD": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd.png",
        sheet_x: 21,
        sheet_y: 31,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FF": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff.png",
        sheet_x: 21,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF-1F3FB": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb.png",
        sheet_x: 21,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FC": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc.png",
        sheet_x: 21,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FD": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd.png",
        sheet_x: 21,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FE": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe.png",
        sheet_x: 21,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Two Women Holding Hands",
    b: "1F46D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pair",
      "friendship",
      "couple",
      "love",
      "like",
      "female",
      "people",
      "human"
    ],
    k: [
      21,
      11
    ],
    n: [
      "women_holding_hands"
    ],
    o: 2
  },
  couple: {
    skin_variations: {
      "1F3FB": {
        unified: "1F46B-1F3FB",
        non_qualified: null,
        image: "1f46b-1f3fb.png",
        sheet_x: 20,
        sheet_y: 17,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46B-1F3FC",
        non_qualified: null,
        image: "1f46b-1f3fc.png",
        sheet_x: 20,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46B-1F3FD",
        non_qualified: null,
        image: "1f46b-1f3fd.png",
        sheet_x: 20,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46B-1F3FE",
        non_qualified: null,
        image: "1f46b-1f3fe.png",
        sheet_x: 20,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46B-1F3FF",
        non_qualified: null,
        image: "1f46b-1f3ff.png",
        sheet_x: 20,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FC": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FD": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FE": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FF": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 25,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FB": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FD": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FE": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FF": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FB": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FC": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 31,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FE": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FF": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FB": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FC": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FD": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FF": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 37,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FB": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 38,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FC": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FD": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FE": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man and Woman Holding Hands",
    b: "1F46B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pair",
      "people",
      "human",
      "love",
      "date",
      "dating",
      "like",
      "affection",
      "valentines",
      "marriage"
    ],
    k: [
      20,
      16
    ],
    n: [
      "man_and_woman_holding_hands",
      "woman_and_man_holding_hands"
    ],
    o: 2
  },
  two_men_holding_hands: {
    skin_variations: {
      "1F3FB": {
        unified: "1F46C-1F3FB",
        non_qualified: null,
        image: "1f46c-1f3fb.png",
        sheet_x: 20,
        sheet_y: 43,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46C-1F3FC",
        non_qualified: null,
        image: "1f46c-1f3fc.png",
        sheet_x: 20,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46C-1F3FD",
        non_qualified: null,
        image: "1f46c-1f3fd.png",
        sheet_x: 20,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46C-1F3FE",
        non_qualified: null,
        image: "1f46c-1f3fe.png",
        sheet_x: 20,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46C-1F3FF",
        non_qualified: null,
        image: "1f46c-1f3ff.png",
        sheet_x: 20,
        sheet_y: 47,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FC": {
        unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FD": {
        unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 49,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FE": {
        unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FF": {
        unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FB": {
        unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FD": {
        unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 53,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FE": {
        unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FF": {
        unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 55,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FB": {
        unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FC": {
        unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 21,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FE": {
        unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 21,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FF": {
        unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 21,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE-1F3FB": {
        unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 21,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FC": {
        unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 21,
        sheet_y: 4,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FD": {
        unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 21,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FF": {
        unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 21,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF-1F3FB": {
        unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 21,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FC": {
        unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 21,
        sheet_y: 8,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FD": {
        unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 21,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FE": {
        unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 21,
        sheet_y: 10,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Two Men Holding Hands",
    b: "1F46C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pair",
      "couple",
      "love",
      "like",
      "bromance",
      "friendship",
      "people",
      "human"
    ],
    k: [
      20,
      42
    ],
    n: [
      "men_holding_hands"
    ],
    o: 2
  },
  couplekiss: {
    obsoleted_by: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
    a: "Kiss",
    b: "1F48F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      25
    ],
    o: 2
  },
  "woman-kiss-man": {
    obsoletes: "1F48F",
    a: "Woman Kiss Man",
    b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
    c: "1F469-200D-2764-200D-1F48B-200D-1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      7
    ],
    o: 2
  },
  "man-kiss-man": {
    a: "Man Kiss Man",
    b: "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
    c: "1F468-200D-2764-200D-1F48B-200D-1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      21
    ],
    o: 2
  },
  "woman-kiss-woman": {
    a: "Woman Kiss Woman",
    b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
    c: "1F469-200D-2764-200D-1F48B-200D-1F469",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      8
    ],
    o: 2
  },
  couple_with_heart: {
    obsoleted_by: "1F469-200D-2764-FE0F-200D-1F468",
    a: "Couple with Heart",
    b: "1F491",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      27
    ],
    o: 2
  },
  "woman-heart-man": {
    obsoletes: "1F491",
    a: "Woman Heart Man",
    b: "1F469-200D-2764-FE0F-200D-1F468",
    c: "1F469-200D-2764-200D-1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      5
    ],
    o: 2
  },
  "man-heart-man": {
    a: "Man Heart Man",
    b: "1F468-200D-2764-FE0F-200D-1F468",
    c: "1F468-200D-2764-200D-1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      20
    ],
    o: 2
  },
  "woman-heart-woman": {
    a: "Woman Heart Woman",
    b: "1F469-200D-2764-FE0F-200D-1F469",
    c: "1F469-200D-2764-200D-1F469",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      6
    ],
    o: 2
  },
  family: {
    obsoleted_by: "1F468-200D-1F469-200D-1F466",
    a: "Family",
    b: "1F46A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      15
    ],
    n: [
      "man-woman-boy"
    ],
    o: 2
  },
  "man-woman-boy": {
    obsoletes: "1F46A",
    a: "Man Woman Boy",
    b: "1F468-200D-1F469-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      33
    ],
    n: [
      "family"
    ],
    o: 2
  },
  "man-woman-girl": {
    a: "Man Woman Girl",
    b: "1F468-200D-1F469-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      35
    ],
    o: 2
  },
  "man-woman-girl-boy": {
    a: "Man Woman Girl Boy",
    b: "1F468-200D-1F469-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      36
    ],
    o: 2
  },
  "man-woman-boy-boy": {
    a: "Man Woman Boy Boy",
    b: "1F468-200D-1F469-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      34
    ],
    o: 2
  },
  "man-woman-girl-girl": {
    a: "Man Woman Girl Girl",
    b: "1F468-200D-1F469-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      37
    ],
    o: 2
  },
  "man-man-boy": {
    a: "Man Man Boy",
    b: "1F468-200D-1F468-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      28
    ],
    o: 2
  },
  "man-man-girl": {
    a: "Man Man Girl",
    b: "1F468-200D-1F468-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      30
    ],
    o: 2
  },
  "man-man-girl-boy": {
    a: "Man Man Girl Boy",
    b: "1F468-200D-1F468-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      31
    ],
    o: 2
  },
  "man-man-boy-boy": {
    a: "Man Man Boy Boy",
    b: "1F468-200D-1F468-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      29
    ],
    o: 2
  },
  "man-man-girl-girl": {
    a: "Man Man Girl Girl",
    b: "1F468-200D-1F468-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      32
    ],
    o: 2
  },
  "woman-woman-boy": {
    a: "Woman Woman Boy",
    b: "1F469-200D-1F469-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      18
    ],
    o: 2
  },
  "woman-woman-girl": {
    a: "Woman Woman Girl",
    b: "1F469-200D-1F469-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      20
    ],
    o: 2
  },
  "woman-woman-girl-boy": {
    a: "Woman Woman Girl Boy",
    b: "1F469-200D-1F469-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      21
    ],
    o: 2
  },
  "woman-woman-boy-boy": {
    a: "Woman Woman Boy Boy",
    b: "1F469-200D-1F469-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      19
    ],
    o: 2
  },
  "woman-woman-girl-girl": {
    a: "Woman Woman Girl Girl",
    b: "1F469-200D-1F469-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      22
    ],
    o: 2
  },
  "man-boy": {
    a: "Man Boy",
    b: "1F468-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      24
    ],
    o: 4
  },
  "man-boy-boy": {
    a: "Man Boy Boy",
    b: "1F468-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      23
    ],
    o: 4
  },
  "man-girl": {
    a: "Man Girl",
    b: "1F468-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      27
    ],
    o: 4
  },
  "man-girl-boy": {
    a: "Man Girl Boy",
    b: "1F468-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      25
    ],
    o: 4
  },
  "man-girl-girl": {
    a: "Man Girl Girl",
    b: "1F468-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      26
    ],
    o: 4
  },
  "woman-boy": {
    a: "Woman Boy",
    b: "1F469-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      14
    ],
    o: 4
  },
  "woman-boy-boy": {
    a: "Woman Boy Boy",
    b: "1F469-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      13
    ],
    o: 4
  },
  "woman-girl": {
    a: "Woman Girl",
    b: "1F469-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      17
    ],
    o: 4
  },
  "woman-girl-boy": {
    a: "Woman Girl Boy",
    b: "1F469-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      15
    ],
    o: 4
  },
  "woman-girl-girl": {
    a: "Woman Girl Girl",
    b: "1F469-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      16
    ],
    o: 4
  },
  speaking_head_in_silhouette: {
    a: "Speaking Head in Silhouette",
    b: "1F5E3-FE0F",
    c: "1F5E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      25
    ],
    o: 2
  },
  bust_in_silhouette: {
    a: "Bust in Silhouette",
    b: "1F464",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "user",
      "person",
      "human"
    ],
    k: [
      14,
      24
    ],
    o: 2
  },
  busts_in_silhouette: {
    a: "Busts in Silhouette",
    b: "1F465",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "user",
      "person",
      "human",
      "group",
      "team"
    ],
    k: [
      14,
      25
    ],
    o: 2
  },
  footprints: {
    a: "Footprints",
    b: "1F463",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "feet",
      "tracking",
      "walking",
      "beach"
    ],
    k: [
      14,
      23
    ],
    o: 2
  }
}, aliases = {
  raised_hand: "hand",
  satisfied: "laughing",
  tshirt: "shirt",
  hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
  sign_of_the_horns: "the_horns",
  grinning_face_with_star_eyes: "star-struck",
  reversed_hand_with_middle_finger_extended: "middle_finger",
  thumbsup: "+1",
  thumbsdown: "-1",
  punch: "facepunch",
  grinning_face_with_one_large_and_one_small_eye: "zany_face",
  shoe: "mans_shoe",
  smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
  face_with_finger_covering_closed_lips: "shushing_face",
  face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
  face_with_open_mouth_vomiting: "face_vomiting",
  cooking: "fried_egg",
  "flag-cn": "cn",
  shocked_face_with_exploding_head: "exploding_head",
  paw_prints: "feet",
  "flag-de": "de",
  telephone: "phone",
  "flag-es": "es",
  red_car: "car",
  flipper: "dolphin",
  "flag-fr": "fr",
  uk: "gb",
  "flag-gb": "gb",
  serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
  poop: "hankey",
  shit: "hankey",
  honeybee: "bee",
  staff_of_aesculapius: "medical_symbol",
  lantern: "izakaya_lantern",
  open_book: "book",
  sailboat: "boat",
  knife: "hocho",
  "flag-it": "it",
  heavy_exclamation_mark: "exclamation",
  "flag-jp": "jp",
  envelope: "email",
  "flag-kr": "kr",
  collision: "boom",
  pencil: "memo",
  waxing_gibbous_moon: "moon",
  mother_christmas: "mrs_claus",
  sun_small_cloud: "mostly_sunny",
  sun_behind_cloud: "barely_sunny",
  sun_behind_rain_cloud: "partly_sunny_rain",
  lightning_cloud: "lightning",
  tornado_cloud: "tornado",
  "flag-ru": "ru",
  running: "runner",
  "flag-us": "us",
  women_holding_hands: "two_women_holding_hands",
  man_and_woman_holding_hands: "couple",
  woman_and_man_holding_hands: "couple",
  men_holding_hands: "two_men_holding_hands",
  "man-woman-boy": "family",
  family: "man-woman-boy"
}, data = {
  compressed,
  categories: categories$1,
  emojis: emojis$1,
  aliases
};
var mapping = {
  name: "a",
  unified: "b",
  non_qualified: "c",
  has_img_apple: "d",
  has_img_google: "e",
  has_img_twitter: "f",
  has_img_facebook: "h",
  keywords: "j",
  sheet: "k",
  emoticons: "l",
  text: "m",
  short_names: "n",
  added_in: "o"
}, buildSearch = /* @__PURE__ */ __name(function(emoji) {
  var search3 = [], addToSearch = /* @__PURE__ */ __name(function(strings, split) {
    strings && (Array.isArray(strings) ? strings : [strings]).forEach(function(string2) {
      (split ? string2.split(/[-|_|\s]+/) : [string2]).forEach(function(s4) {
        s4 = s4.toLowerCase(), search3.indexOf(s4) == -1 && search3.push(s4);
      });
    });
  }, "addToSearch");
  return addToSearch(emoji.short_names, !0), addToSearch(emoji.name, !0), addToSearch(emoji.keywords, !1), addToSearch(emoji.emoticons, !1), search3.join(",");
}, "buildSearch"), uncompress = /* @__PURE__ */ __name(function(data2) {
  data2.compressed = !1;
  for (var id2 in data2.emojis) {
    var emoji = data2.emojis[id2];
    for (var key in mapping)
      emoji[key] = emoji[mapping[key]], delete emoji[mapping[key]];
    emoji.short_names || (emoji.short_names = []), emoji.short_names.unshift(id2), emoji.sheet_x = emoji.sheet[0], emoji.sheet_y = emoji.sheet[1], delete emoji.sheet, emoji.text || (emoji.text = ""), emoji.added_in || (emoji.added_in = 6), emoji.added_in = emoji.added_in.toFixed(1), emoji.search = buildSearch(emoji);
  }
}, "uncompress"), _String = String;
const stringFromCodePoint = _String.fromCodePoint || /* @__PURE__ */ __name(function() {
  var MAX_SIZE = 16384, codeUnits = [], highSurrogate, lowSurrogate, index2 = -1, length = arguments.length;
  if (!length)
    return "";
  for (var result2 = ""; ++index2 < length; ) {
    var codePoint = Number(arguments[index2]);
    if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
    codePoint < 0 || // not a valid Unicode code point
    codePoint > 1114111 || // not a valid Unicode code point
    Math.floor(codePoint) != codePoint)
      throw RangeError("Invalid code point: " + codePoint);
    codePoint <= 65535 ? codeUnits.push(codePoint) : (codePoint -= 65536, highSurrogate = (codePoint >> 10) + 55296, lowSurrogate = codePoint % 1024 + 56320, codeUnits.push(highSurrogate, lowSurrogate)), (index2 + 1 === length || codeUnits.length > MAX_SIZE) && (result2 += String.fromCharCode.apply(null, codeUnits), codeUnits.length = 0);
  }
  return result2;
}, "stringFromCodePoint");
var COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/, SKINS = ["1F3FA", "1F3FB", "1F3FC", "1F3FD", "1F3FE", "1F3FF"];
function unifiedToNative(unified2) {
  var unicodes = unified2.split("-"), codePoints = unicodes.map(function(u2) {
    return "0x".concat(u2);
  });
  return stringFromCodePoint.apply(null, codePoints);
}
__name(unifiedToNative, "unifiedToNative");
function sanitize$1(emoji) {
  var name2 = emoji.name, short_names = emoji.short_names, skin_tone = emoji.skin_tone, skin_variations = emoji.skin_variations, emoticons2 = emoji.emoticons, unified2 = emoji.unified, custom2 = emoji.custom, customCategory = emoji.customCategory, imageUrl = emoji.imageUrl, id2 = emoji.id || short_names[0], colons = ":".concat(id2, ":");
  return custom2 ? {
    id: id2,
    name: name2,
    short_names,
    colons,
    emoticons: emoticons2,
    custom: custom2,
    customCategory,
    imageUrl
  } : (skin_tone && (colons += ":skin-tone-".concat(skin_tone, ":")), {
    id: id2,
    name: name2,
    short_names,
    colons,
    emoticons: emoticons2,
    unified: unified2.toLowerCase(),
    skin: skin_tone || (skin_variations ? 1 : null),
    native: unifiedToNative(unified2)
  });
}
__name(sanitize$1, "sanitize$1");
function getSanitizedData() {
  return sanitize$1(getData.apply(void 0, arguments));
}
__name(getSanitizedData, "getSanitizedData");
function getData(emoji, skin, set3, data2) {
  var emojiData = {};
  if (typeof emoji == "string") {
    var matches2 = emoji.match(COLONS_REGEX);
    if (matches2 && (emoji = matches2[1], matches2[2] && (skin = parseInt(matches2[2], 10))), data2.aliases.hasOwnProperty(emoji) && (emoji = data2.aliases[emoji]), data2.emojis.hasOwnProperty(emoji))
      emojiData = data2.emojis[emoji];
    else
      return null;
  } else
    emoji.id && (data2.aliases.hasOwnProperty(emoji.id) && (emoji.id = data2.aliases[emoji.id]), data2.emojis.hasOwnProperty(emoji.id) && (emojiData = data2.emojis[emoji.id], skin || (skin = emoji.skin)));
  if (Object.keys(emojiData).length || (emojiData = emoji, emojiData.custom = !0, emojiData.search || (emojiData.search = buildSearch(emoji))), emojiData.emoticons || (emojiData.emoticons = []), emojiData.variations || (emojiData.variations = []), emojiData.skin_variations && skin > 1) {
    emojiData = JSON.parse(JSON.stringify(emojiData));
    var skinKey = SKINS[skin - 1], variationData = emojiData.skin_variations[skinKey];
    if (variationData && (!variationData.variations && emojiData.variations && delete emojiData.variations, set3 && (variationData["has_img_".concat(set3)] == null || variationData["has_img_".concat(set3)]) || !set3)) {
      emojiData.skin_tone = skin;
      for (var k3 in variationData) {
        var v = variationData[k3];
        emojiData[k3] = v;
      }
    }
  }
  return emojiData.variations && emojiData.variations.length && (emojiData = JSON.parse(JSON.stringify(emojiData)), emojiData.unified = emojiData.variations.shift()), emojiData;
}
__name(getData, "getData");
function uniq(arr) {
  return arr.reduce(function(acc, item) {
    return acc.indexOf(item) === -1 && acc.push(item), acc;
  }, []);
}
__name(uniq, "uniq");
function intersect(a4, b2) {
  var uniqA = uniq(a4), uniqB = uniq(b2);
  return uniqA.filter(function(item) {
    return uniqB.indexOf(item) >= 0;
  });
}
__name(intersect, "intersect");
function deepMerge(a4, b2) {
  var o = {};
  for (var key in a4) {
    var originalValue = a4[key], value = originalValue;
    b2.hasOwnProperty(key) && (value = b2[key]), _typeof$F(value) === "object" && (value = deepMerge(originalValue, value)), o[key] = value;
  }
  return o;
}
__name(deepMerge, "deepMerge");
function measureScrollbar() {
  if (typeof document > "u")
    return 0;
  var div = document.createElement("div");
  div.style.width = "100px", div.style.height = "100px", div.style.overflow = "scroll", div.style.position = "absolute", div.style.top = "-9999px", document.body.appendChild(div);
  var scrollbarWidth = div.offsetWidth - div.clientWidth;
  return document.body.removeChild(div), scrollbarWidth;
}
__name(measureScrollbar, "measureScrollbar");
function throttleIdleTask(func2) {
  var doIdleTask = typeof requestIdleCallback == "function" ? requestIdleCallback : setTimeout, running = !1;
  return /* @__PURE__ */ __name(function() {
    running || (running = !0, doIdleTask(function() {
      running = !1, func2();
    }));
  }, "throttled");
}
__name(throttleIdleTask, "throttleIdleTask");
var NAMESPACE = "emoji-mart", isLocalStorageSupported = typeof window < "u" && "localStorage" in window, getter, setter;
function setHandlers(handlers2) {
  handlers2 || (handlers2 = {}), getter = handlers2.getter, setter = handlers2.setter;
}
__name(setHandlers, "setHandlers");
function setNamespace(namespace) {
  NAMESPACE = namespace;
}
__name(setNamespace, "setNamespace");
function update$1(state) {
  for (var key in state) {
    var value = state[key];
    set(key, value);
  }
}
__name(update$1, "update$1");
function set(key, value) {
  if (setter)
    setter(key, value);
  else {
    if (!isLocalStorageSupported)
      return;
    try {
      window.localStorage["".concat(NAMESPACE, ".").concat(key)] = JSON.stringify(value);
    } catch {
    }
  }
}
__name(set, "set");
function get$5(key) {
  if (getter)
    return getter(key);
  if (!isLocalStorageSupported)
    return;
  try {
    var value = window.localStorage["".concat(NAMESPACE, ".").concat(key)];
    if (value)
      return JSON.parse(value);
  } catch {
    return;
  }
}
__name(get$5, "get$5");
const store = {
  update: update$1,
  set,
  get: get$5,
  setNamespace,
  setHandlers
};
var NimbleEmojiIndex = /* @__PURE__ */ function() {
  function NimbleEmojiIndex2(data2, set3) {
    _classCallCheck$m(this, NimbleEmojiIndex2), data2.compressed && uncompress(data2), this.data = data2 || {}, this.set = set3 || null, this.originalPool = {}, this.index = {}, this.emojis = {}, this.emoticons = {}, this.customEmojisList = [], this.buildIndex();
  }
  return __name(NimbleEmojiIndex2, "NimbleEmojiIndex"), _createClass$m(NimbleEmojiIndex2, [{
    key: "buildIndex",
    value: /* @__PURE__ */ __name(function() {
      var _this = this, _loop = /* @__PURE__ */ __name(function(emoji2) {
        var emojiData = _this.data.emojis[emoji2], short_names = emojiData.short_names, emoticons2 = emojiData.emoticons, skin_variations = emojiData.skin_variations, id2 = short_names[0];
        if (emoticons2 && emoticons2.forEach(function(emoticon) {
          _this.emoticons[emoticon] || (_this.emoticons[emoticon] = id2);
        }), skin_variations) {
          _this.emojis[id2] = {};
          for (var skinTone = 1; skinTone <= 6; skinTone++)
            _this.emojis[id2][skinTone] = getSanitizedData({
              id: id2,
              skin: skinTone
            }, skinTone, _this.set, _this.data);
        } else
          _this.emojis[id2] = getSanitizedData(id2, null, _this.set, _this.data);
        _this.originalPool[id2] = emojiData;
      }, "_loop");
      for (var emoji in this.data.emojis)
        _loop(emoji);
    }, "buildIndex")
  }, {
    key: "clearCustomEmojis",
    value: /* @__PURE__ */ __name(function(pool) {
      var _this2 = this;
      this.customEmojisList.forEach(function(emoji) {
        var emojiId = emoji.id || emoji.short_names[0];
        delete pool[emojiId], delete _this2.emojis[emojiId];
      });
    }, "clearCustomEmojis")
  }, {
    key: "addCustomToPool",
    value: /* @__PURE__ */ __name(function(custom2, pool) {
      var _this3 = this;
      this.customEmojisList.length && this.clearCustomEmojis(pool), custom2.forEach(function(emoji) {
        var emojiId = emoji.id || emoji.short_names[0];
        emojiId && !pool[emojiId] && (pool[emojiId] = getData(emoji, null, null, _this3.data), _this3.emojis[emojiId] = getSanitizedData(emoji, null, null, _this3.data));
      }), this.customEmojisList = custom2, this.index = {};
    }, "addCustomToPool")
  }, {
    key: "search",
    value: /* @__PURE__ */ __name(function(value) {
      var _this4 = this, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, emojisToShowFilter = _ref.emojisToShowFilter, maxResults = _ref.maxResults, include = _ref.include, exclude = _ref.exclude, _ref$custom = _ref.custom, custom2 = _ref$custom === void 0 ? [] : _ref$custom;
      this.customEmojisList != custom2 && this.addCustomToPool(custom2, this.originalPool);
      var skinTone = store.get("skin") || 1;
      maxResults || (maxResults = 75), include || (include = []), exclude || (exclude = []);
      var results = null, pool = this.originalPool;
      if (value.length) {
        if (value == "-" || value == "-1")
          return [this.emojis[-1][skinTone]];
        var values = value.toLowerCase().split(/[\s|,|\-|_]+/), allResults = [];
        if (values.length > 2 && (values = [values[0], values[1]]), (include.length || exclude.length) && (pool = {}, this.data.categories.forEach(function(category) {
          var isIncluded = include && include.length ? include.indexOf(category.id) > -1 : !0, isExcluded = exclude && exclude.length ? exclude.indexOf(category.id) > -1 : !1;
          !isIncluded || isExcluded || category.emojis.forEach(function(emojiId) {
            return pool[emojiId] = _this4.data.emojis[emojiId];
          });
        }), custom2.length)) {
          var customIsIncluded = include && include.length ? include.indexOf("custom") > -1 : !0, customIsExcluded = exclude && exclude.length ? exclude.indexOf("custom") > -1 : !1;
          customIsIncluded && !customIsExcluded && this.addCustomToPool(custom2, pool);
        }
        allResults = values.map(function(value2) {
          for (var aPool = pool, aIndex = _this4.index, length = 0, charIndex = 0; charIndex < value2.length; charIndex++) {
            var _char = value2[charIndex];
            length++, aIndex[_char] || (aIndex[_char] = {}), aIndex = aIndex[_char], aIndex.results || function() {
              var scores = {};
              aIndex.results = [], aIndex.pool = {};
              for (var id2 in aPool) {
                var emoji = aPool[id2], search4 = emoji.search, sub = value2.substr(0, length), subIndex = search4.indexOf(sub);
                if (subIndex != -1) {
                  var score = subIndex + 1;
                  sub == id2 && (score = 0), _this4.emojis[id2] && _this4.emojis[id2][skinTone] ? aIndex.results.push(_this4.emojis[id2][skinTone]) : aIndex.results.push(_this4.emojis[id2]), aIndex.pool[id2] = emoji, scores[id2] = score;
                }
              }
              aIndex.results.sort(function(a4, b2) {
                var aScore = scores[a4.id], bScore = scores[b2.id];
                return aScore == bScore ? a4.id.localeCompare(b2.id) : aScore - bScore;
              });
            }(), aPool = aIndex.pool;
          }
          return aIndex.results;
        }).filter(function(a4) {
          return a4;
        }), allResults.length > 1 ? results = intersect.apply(null, allResults) : allResults.length ? results = allResults[0] : results = [];
      }
      return results && (emojisToShowFilter && (results = results.filter(function(result2) {
        return emojisToShowFilter(pool[result2.id]);
      })), results && results.length > maxResults && (results = results.slice(0, maxResults))), results;
    }, "search")
  }]), NimbleEmojiIndex2;
}(), emojiIndex = new NimbleEmojiIndex(data), emojis = emojiIndex.emojis, emoticons = emojiIndex.emoticons;
function search$2() {
  return emojiIndex.search.apply(emojiIndex, arguments);
}
__name(search$2, "search$2");
const emojiIndex$1 = {
  search: search$2,
  emojis,
  emoticons
};
var DEFAULTS = ["+1", "grinning", "kissing_heart", "heart_eyes", "laughing", "stuck_out_tongue_winking_eye", "sweat_smile", "joy", "scream", "disappointed", "unamused", "weary", "sob", "sunglasses", "heart", "poop"], frequently, initialized, defaults$1 = {};
function init() {
  initialized = !0, frequently = store.get("frequently");
}
__name(init, "init");
function add$1(emoji) {
  initialized || init();
  var id2 = emoji.id;
  frequently || (frequently = defaults$1), frequently[id2] || (frequently[id2] = 0), frequently[id2] += 1, store.set("last", id2), store.set("frequently", frequently);
}
__name(add$1, "add$1");
function get$4(perLine) {
  if (initialized || init(), !frequently) {
    defaults$1 = {};
    for (var result2 = [], i2 = 0; i2 < perLine; i2++)
      defaults$1[DEFAULTS[i2]] = perLine - i2, result2.push(DEFAULTS[i2]);
    return result2;
  }
  var quantity = perLine * 4, frequentlyKeys = [];
  for (var key in frequently)
    frequently.hasOwnProperty(key) && frequentlyKeys.push(key);
  var sorted = frequentlyKeys.sort(function(a4, b2) {
    return frequently[a4] - frequently[b2];
  }).reverse(), sliced = sorted.slice(0, quantity), last2 = store.get("last");
  return last2 && sliced.indexOf(last2) == -1 && (sliced.pop(), sliced.push(last2)), sliced;
}
__name(get$4, "get$4");
const frequently$1 = {
  add: add$1,
  get: get$4
};
function _extends$p() {
  return _extends$p = Object.assign ? Object.assign.bind() : function(n) {
    for (var e3 = 1; e3 < arguments.length; e3++) {
      var t3 = arguments[e3];
      for (var r2 in t3)
        ({}).hasOwnProperty.call(t3, r2) && (n[r2] = t3[r2]);
    }
    return n;
  }, _extends$p.apply(null, arguments);
}
__name(_extends$p, "_extends$p");
var propTypes = { exports: {} }, reactIs = { exports: {} }, reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b2 = typeof Symbol == "function" && Symbol.for, c3 = b2 ? Symbol.for("react.element") : 60103, d3 = b2 ? Symbol.for("react.portal") : 60106, e3 = b2 ? Symbol.for("react.fragment") : 60107, f = b2 ? Symbol.for("react.strict_mode") : 60108, g = b2 ? Symbol.for("react.profiler") : 60114, h3 = b2 ? Symbol.for("react.provider") : 60109, k3 = b2 ? Symbol.for("react.context") : 60110, l = b2 ? Symbol.for("react.async_mode") : 60111, m3 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n = b2 ? Symbol.for("react.forward_ref") : 60112, p = b2 ? Symbol.for("react.suspense") : 60113, q2 = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t3 = b2 ? Symbol.for("react.lazy") : 60116, v = b2 ? Symbol.for("react.block") : 60121, w2 = b2 ? Symbol.for("react.fundamental") : 60117, x3 = b2 ? Symbol.for("react.responder") : 60118, y4 = b2 ? Symbol.for("react.scope") : 60119;
  function z2(a4) {
    if (typeof a4 == "object" && a4 !== null) {
      var u2 = a4.$$typeof;
      switch (u2) {
        case c3:
          switch (a4 = a4.type, a4) {
            case l:
            case m3:
            case e3:
            case g:
            case f:
            case p:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case k3:
                case n:
                case t3:
                case r2:
                case h3:
                  return a4;
                default:
                  return u2;
              }
          }
        case d3:
          return u2;
      }
    }
  }
  __name(z2, "z");
  function A(a4) {
    return z2(a4) === m3;
  }
  return __name(A, "A"), reactIs_production_min.AsyncMode = l, reactIs_production_min.ConcurrentMode = m3, reactIs_production_min.ContextConsumer = k3, reactIs_production_min.ContextProvider = h3, reactIs_production_min.Element = c3, reactIs_production_min.ForwardRef = n, reactIs_production_min.Fragment = e3, reactIs_production_min.Lazy = t3, reactIs_production_min.Memo = r2, reactIs_production_min.Portal = d3, reactIs_production_min.Profiler = g, reactIs_production_min.StrictMode = f, reactIs_production_min.Suspense = p, reactIs_production_min.isAsyncMode = function(a4) {
    return A(a4) || z2(a4) === l;
  }, reactIs_production_min.isConcurrentMode = A, reactIs_production_min.isContextConsumer = function(a4) {
    return z2(a4) === k3;
  }, reactIs_production_min.isContextProvider = function(a4) {
    return z2(a4) === h3;
  }, reactIs_production_min.isElement = function(a4) {
    return typeof a4 == "object" && a4 !== null && a4.$$typeof === c3;
  }, reactIs_production_min.isForwardRef = function(a4) {
    return z2(a4) === n;
  }, reactIs_production_min.isFragment = function(a4) {
    return z2(a4) === e3;
  }, reactIs_production_min.isLazy = function(a4) {
    return z2(a4) === t3;
  }, reactIs_production_min.isMemo = function(a4) {
    return z2(a4) === r2;
  }, reactIs_production_min.isPortal = function(a4) {
    return z2(a4) === d3;
  }, reactIs_production_min.isProfiler = function(a4) {
    return z2(a4) === g;
  }, reactIs_production_min.isStrictMode = function(a4) {
    return z2(a4) === f;
  }, reactIs_production_min.isSuspense = function(a4) {
    return z2(a4) === p;
  }, reactIs_production_min.isValidElementType = function(a4) {
    return typeof a4 == "string" || typeof a4 == "function" || a4 === e3 || a4 === m3 || a4 === g || a4 === f || a4 === p || a4 === q2 || typeof a4 == "object" && a4 !== null && (a4.$$typeof === t3 || a4.$$typeof === r2 || a4.$$typeof === h3 || a4.$$typeof === k3 || a4.$$typeof === n || a4.$$typeof === w2 || a4.$$typeof === x3 || a4.$$typeof === y4 || a4.$$typeof === v);
  }, reactIs_production_min.typeOf = z2, reactIs_production_min;
}
__name(requireReactIs_production_min, "requireReactIs_production_min");
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var hasSymbol2 = typeof Symbol == "function" && Symbol.for, REACT_ELEMENT_TYPE = hasSymbol2 ? Symbol.for("react.element") : 60103, REACT_PORTAL_TYPE = hasSymbol2 ? Symbol.for("react.portal") : 60106, REACT_FRAGMENT_TYPE = hasSymbol2 ? Symbol.for("react.fragment") : 60107, REACT_STRICT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.strict_mode") : 60108, REACT_PROFILER_TYPE = hasSymbol2 ? Symbol.for("react.profiler") : 60114, REACT_PROVIDER_TYPE = hasSymbol2 ? Symbol.for("react.provider") : 60109, REACT_CONTEXT_TYPE = hasSymbol2 ? Symbol.for("react.context") : 60110, REACT_ASYNC_MODE_TYPE = hasSymbol2 ? Symbol.for("react.async_mode") : 60111, REACT_CONCURRENT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.concurrent_mode") : 60111, REACT_FORWARD_REF_TYPE = hasSymbol2 ? Symbol.for("react.forward_ref") : 60112, REACT_SUSPENSE_TYPE = hasSymbol2 ? Symbol.for("react.suspense") : 60113, REACT_SUSPENSE_LIST_TYPE = hasSymbol2 ? Symbol.for("react.suspense_list") : 60120, REACT_MEMO_TYPE = hasSymbol2 ? Symbol.for("react.memo") : 60115, REACT_LAZY_TYPE = hasSymbol2 ? Symbol.for("react.lazy") : 60116, REACT_BLOCK_TYPE = hasSymbol2 ? Symbol.for("react.block") : 60121, REACT_FUNDAMENTAL_TYPE = hasSymbol2 ? Symbol.for("react.fundamental") : 60117, REACT_RESPONDER_TYPE = hasSymbol2 ? Symbol.for("react.responder") : 60118, REACT_SCOPE_TYPE = hasSymbol2 ? Symbol.for("react.scope") : 60119;
    function isValidElementType(type) {
      return typeof type == "string" || typeof type == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type == "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    __name(isValidElementType, "isValidElementType");
    function typeOf3(object2) {
      if (typeof object2 == "object" && object2 !== null) {
        var $$typeof = object2.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object2.type;
            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;
              default:
                var $$typeofType = type && type.$$typeof;
                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    __name(typeOf3, "typeOf");
    var AsyncMode = REACT_ASYNC_MODE_TYPE, ConcurrentMode = REACT_CONCURRENT_MODE_TYPE, ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element2 = REACT_ELEMENT_TYPE, ForwardRef = REACT_FORWARD_REF_TYPE, Fragment2 = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = !1;
    function isAsyncMode(object2) {
      return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), isConcurrentMode(object2) || typeOf3(object2) === REACT_ASYNC_MODE_TYPE;
    }
    __name(isAsyncMode, "isAsyncMode");
    function isConcurrentMode(object2) {
      return typeOf3(object2) === REACT_CONCURRENT_MODE_TYPE;
    }
    __name(isConcurrentMode, "isConcurrentMode");
    function isContextConsumer(object2) {
      return typeOf3(object2) === REACT_CONTEXT_TYPE;
    }
    __name(isContextConsumer, "isContextConsumer");
    function isContextProvider(object2) {
      return typeOf3(object2) === REACT_PROVIDER_TYPE;
    }
    __name(isContextProvider, "isContextProvider");
    function isElement(object2) {
      return typeof object2 == "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    __name(isElement, "isElement");
    function isForwardRef(object2) {
      return typeOf3(object2) === REACT_FORWARD_REF_TYPE;
    }
    __name(isForwardRef, "isForwardRef");
    function isFragment(object2) {
      return typeOf3(object2) === REACT_FRAGMENT_TYPE;
    }
    __name(isFragment, "isFragment");
    function isLazy(object2) {
      return typeOf3(object2) === REACT_LAZY_TYPE;
    }
    __name(isLazy, "isLazy");
    function isMemo(object2) {
      return typeOf3(object2) === REACT_MEMO_TYPE;
    }
    __name(isMemo, "isMemo");
    function isPortal(object2) {
      return typeOf3(object2) === REACT_PORTAL_TYPE;
    }
    __name(isPortal, "isPortal");
    function isProfiler(object2) {
      return typeOf3(object2) === REACT_PROFILER_TYPE;
    }
    __name(isProfiler, "isProfiler");
    function isStrictMode(object2) {
      return typeOf3(object2) === REACT_STRICT_MODE_TYPE;
    }
    __name(isStrictMode, "isStrictMode");
    function isSuspense(object2) {
      return typeOf3(object2) === REACT_SUSPENSE_TYPE;
    }
    __name(isSuspense, "isSuspense"), reactIs_development.AsyncMode = AsyncMode, reactIs_development.ConcurrentMode = ConcurrentMode, reactIs_development.ContextConsumer = ContextConsumer, reactIs_development.ContextProvider = ContextProvider, reactIs_development.Element = Element2, reactIs_development.ForwardRef = ForwardRef, reactIs_development.Fragment = Fragment2, reactIs_development.Lazy = Lazy, reactIs_development.Memo = Memo, reactIs_development.Portal = Portal, reactIs_development.Profiler = Profiler, reactIs_development.StrictMode = StrictMode, reactIs_development.Suspense = Suspense, reactIs_development.isAsyncMode = isAsyncMode, reactIs_development.isConcurrentMode = isConcurrentMode, reactIs_development.isContextConsumer = isContextConsumer, reactIs_development.isContextProvider = isContextProvider, reactIs_development.isElement = isElement, reactIs_development.isForwardRef = isForwardRef, reactIs_development.isFragment = isFragment, reactIs_development.isLazy = isLazy, reactIs_development.isMemo = isMemo, reactIs_development.isPortal = isPortal, reactIs_development.isProfiler = isProfiler, reactIs_development.isStrictMode = isStrictMode, reactIs_development.isSuspense = isSuspense, reactIs_development.isValidElementType = isValidElementType, reactIs_development.typeOf = typeOf3;
  }()), reactIs_development;
}
__name(requireReactIs_development, "requireReactIs_development");
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
__name(requireReactIs, "requireReactIs");
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols2 = Object.getOwnPropertySymbols, hasOwnProperty2 = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
  }
  __name(toObject, "toObject");
  function shouldUseNative() {
    try {
      if (!Object.assign)
        return !1;
      var test1 = new String("abc");
      if (test1[5] = "de", Object.getOwnPropertyNames(test1)[0] === "5")
        return !1;
      for (var test2 = {}, i2 = 0; i2 < 10; i2++)
        test2["_" + String.fromCharCode(i2)] = i2;
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789")
        return !1;
      var test3 = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      }), Object.keys(Object.assign({}, test3)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return __name(shouldUseNative, "shouldUseNative"), objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    for (var from, to = toObject(target), symbols2, s4 = 1; s4 < arguments.length; s4++) {
      from = Object(arguments[s4]);
      for (var key in from)
        hasOwnProperty2.call(from, key) && (to[key] = from[key]);
      if (getOwnPropertySymbols2) {
        symbols2 = getOwnPropertySymbols2(from);
        for (var i2 = 0; i2 < symbols2.length; i2++)
          propIsEnumerable.call(from, symbols2[i2]) && (to[symbols2[i2]] = from[symbols2[i2]]);
      }
    }
    return to;
  }, objectAssign;
}
__name(requireObjectAssign, "requireObjectAssign");
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = ReactPropTypesSecret, ReactPropTypesSecret_1;
}
__name(requireReactPropTypesSecret, "requireReactPropTypesSecret");
var has$1, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has$1 = Function.call.bind(Object.prototype.hasOwnProperty)), has$1;
}
__name(requireHas, "requireHas");
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = /* @__PURE__ */ __name(function() {
  }, "printWarning");
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret(), loggedTypeFailures = {}, has2 = requireHas();
    printWarning = /* @__PURE__ */ __name(function(text2) {
      var message = "Warning: " + text2;
      typeof console < "u" && console.error(message);
      try {
        throw new Error(message);
      } catch {
      }
    }, "printWarning");
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs)
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] != "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw err.name = "Invariant Violation", err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error) && printWarning(
            (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = !0;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack ?? "")
            );
          }
        }
    }
  }
  return __name(checkPropTypes, "checkPropTypes"), checkPropTypes.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (loggedTypeFailures = {});
  }, checkPropTypes_1 = checkPropTypes, checkPropTypes_1;
}
__name(requireCheckPropTypes, "requireCheckPropTypes");
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs(), assign2 = requireObjectAssign(), ReactPropTypesSecret = requireReactPropTypesSecret(), has2 = requireHas(), checkPropTypes = requireCheckPropTypes(), printWarning = /* @__PURE__ */ __name(function() {
  }, "printWarning");
  process.env.NODE_ENV !== "production" && (printWarning = /* @__PURE__ */ __name(function(text2) {
    var message = "Warning: " + text2;
    typeof console < "u" && console.error(message);
    try {
      throw new Error(message);
    } catch {
    }
  }, "printWarning"));
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  return __name(emptyFunctionThatReturnsNull, "emptyFunctionThatReturnsNull"), factoryWithTypeCheckers = /* @__PURE__ */ __name(function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol == "function" && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn == "function")
        return iteratorFn;
    }
    __name(getIteratorFn, "getIteratorFn");
    var ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is2(x3, y4) {
      return x3 === y4 ? x3 !== 0 || 1 / x3 === 1 / y4 : x3 !== x3 && y4 !== y4;
    }
    __name(is2, "is");
    function PropTypeError(message, data2) {
      this.message = message, this.data = data2 && typeof data2 == "object" ? data2 : {}, this.stack = "";
    }
    __name(PropTypeError, "PropTypeError"), PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production")
        var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0;
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw err.name = "Invariant Violation", err;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var cacheKey = componentName + ":" + propName;
            !manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3 && (printWarning(
              "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
          }
        }
        return props[propName] == null ? isRequired ? props[propName] === null ? new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`.")) : new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`.")) : null : validate(props, propName, componentName, location, propFullName);
      }
      __name(checkType, "checkType");
      var chainedCheckType = checkType.bind(null, !1);
      return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
    }
    __name(createChainableTypeChecker, "createChainableTypeChecker");
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName], propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createPrimitiveTypeChecker, "createPrimitiveTypeChecker");
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    __name(createAnyTypeChecker, "createAnyTypeChecker");
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker != "function")
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i2 = 0; i2 < propValue.length; i2++) {
          var error = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
          if (error instanceof Error)
            return error;
        }
        return null;
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createArrayOfTypeChecker, "createArrayOfTypeChecker");
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createElementTypeChecker, "createElementTypeChecker");
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createElementTypeTypeChecker, "createElementTypeTypeChecker");
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS, actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createInstanceTypeChecker, "createInstanceTypeChecker");
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? printWarning(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : printWarning("Invalid argument supplied to oneOf, expected an array.")), emptyFunctionThatReturnsNull;
      function validate(props, propName, componentName, location, propFullName) {
        for (var propValue = props[propName], i2 = 0; i2 < expectedValues.length; i2++)
          if (is2(propValue, expectedValues[i2]))
            return null;
        var valuesString = JSON.stringify(expectedValues, /* @__PURE__ */ __name(function(key, value) {
          var type = getPreciseType(value);
          return type === "symbol" ? String(value) : value;
        }, "replacer"));
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createEnumTypeChecker, "createEnumTypeChecker");
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker != "function")
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        var propValue = props[propName], propType = getPropType(propValue);
        if (propType !== "object")
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        for (var key in propValue)
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error)
              return error;
          }
        return null;
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createObjectOfTypeChecker, "createObjectOfTypeChecker");
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers))
        return process.env.NODE_ENV !== "production" && printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;
      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
        var checker = arrayOfTypeCheckers[i2];
        if (typeof checker != "function")
          return printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."
          ), emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        for (var expectedTypes = [], i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
          var checker2 = arrayOfTypeCheckers[i3], checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null)
            return null;
          checkerResult.data && has2(checkerResult.data, "expectedType") && expectedTypes.push(checkerResult.data.expectedType);
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createUnionTypeChecker, "createUnionTypeChecker");
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createNodeChecker, "createNodeChecker");
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    __name(invalidValidatorError, "invalidValidatorError");
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName], propType = getPropType(propValue);
        if (propType !== "object")
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker != "function")
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error)
            return error;
        }
        return null;
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createShapeTypeChecker, "createShapeTypeChecker");
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName], propType = getPropType(propValue);
        if (propType !== "object")
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker != "function")
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          if (!checker)
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error)
            return error;
        }
        return null;
      }
      return __name(validate, "validate"), createChainableTypeChecker(validate);
    }
    __name(createStrictShapeTypeChecker, "createStrictShapeTypeChecker");
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue))
            return propValue.every(isNode);
          if (propValue === null || isValidElement2(propValue))
            return !0;
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue), step;
            if (iteratorFn !== propValue.entries) {
              for (; !(step = iterator.next()).done; )
                if (!isNode(step.value))
                  return !1;
            } else
              for (; !(step = iterator.next()).done; ) {
                var entry = step.value;
                if (entry && !isNode(entry[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    __name(isNode, "isNode");
    function isSymbol2(propType, propValue) {
      return propType === "symbol" ? !0 : propValue ? propValue["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && propValue instanceof Symbol : !1;
    }
    __name(isSymbol2, "isSymbol");
    function getPropType(propValue) {
      var propType = typeof propValue;
      return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol2(propType, propValue) ? "symbol" : propType;
    }
    __name(getPropType, "getPropType");
    function getPreciseType(propValue) {
      if (typeof propValue > "u" || propValue === null)
        return "" + propValue;
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date)
          return "date";
        if (propValue instanceof RegExp)
          return "regexp";
      }
      return propType;
    }
    __name(getPreciseType, "getPreciseType");
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    __name(getPostfixForTypeWarning, "getPostfixForTypeWarning");
    function getClassName(propValue) {
      return !propValue.constructor || !propValue.constructor.name ? ANONYMOUS : propValue.constructor.name;
    }
    return __name(getClassName, "getClassName"), ReactPropTypes.checkPropTypes = checkPropTypes, ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
  }, "factoryWithTypeCheckers"), factoryWithTypeCheckers;
}
__name(requireFactoryWithTypeCheckers, "requireFactoryWithTypeCheckers");
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  __name(emptyFunction, "emptyFunction");
  function emptyFunctionWithReset() {
  }
  return __name(emptyFunctionWithReset, "emptyFunctionWithReset"), emptyFunctionWithReset.resetWarningCache = emptyFunction, factoryWithThrowingShims = /* @__PURE__ */ __name(function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret !== ReactPropTypesSecret) {
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw err.name = "Invariant Violation", err;
      }
    }
    __name(shim, "shim"), shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    __name(getShim, "getShim");
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    return ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
  }, "factoryWithThrowingShims"), factoryWithThrowingShims;
}
__name(requireFactoryWithThrowingShims, "requireFactoryWithThrowingShims");
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var categories = {
  activity: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
    }));
  }, "activity"),
  custom: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("g", {
      transform: "translate(2.000000, 1.000000)"
    }, React__default.createElement("rect", {
      id: "Rectangle",
      x: "8",
      y: "0",
      width: "3",
      height: "21",
      rx: "1.5"
    }), React__default.createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    }), React__default.createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    })));
  }, "custom"),
  flags: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
    }));
  }, "flags"),
  foods: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
    }));
  }, "foods"),
  nature: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
    }), React__default.createElement("path", {
      d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
    }));
  }, "nature"),
  objects: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
    }), React__default.createElement("path", {
      d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
    }));
  }, "objects"),
  people: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }), React__default.createElement("path", {
      d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
    }));
  }, "people"),
  places: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
    }), React__default.createElement("path", {
      d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
    }));
  }, "places"),
  recent: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
    }), React__default.createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }));
  }, "recent"),
  symbols: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, React__default.createElement("path", {
      d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
    }));
  }, "symbols")
}, search$1 = {
  search: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, React__default.createElement("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    }));
  }, "search"),
  delete: /* @__PURE__ */ __name(function() {
    return React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, React__default.createElement("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    }));
  }, "_delete")
};
const icons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  categories,
  search: search$1
}, Symbol.toStringTag, { value: "Module" }));
var EmojiPropTypes = {
  data: PropTypes.object.isRequired,
  onOver: PropTypes.func,
  onLeave: PropTypes.func,
  onClick: PropTypes.func,
  fallback: PropTypes.func,
  backgroundImageFn: PropTypes.func,
  native: PropTypes.bool,
  forceSize: PropTypes.bool,
  tooltip: PropTypes.bool,
  useButton: PropTypes.bool,
  skin: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  sheetSize: PropTypes.oneOf([16, 20, 32, 64]),
  sheetColumns: PropTypes.number,
  sheetRows: PropTypes.number,
  set: PropTypes.oneOf(["apple", "google", "twitter", "facebook"]),
  size: PropTypes.number.isRequired,
  emoji: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
}, PickerPropTypes = {
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  onSkinChange: PropTypes.func,
  perLine: PropTypes.number,
  emojiSize: PropTypes.number,
  i18n: PropTypes.object,
  style: PropTypes.object,
  title: PropTypes.string,
  emoji: PropTypes.string,
  color: PropTypes.string,
  set: EmojiPropTypes.set,
  skin: EmojiPropTypes.skin,
  native: PropTypes.bool,
  backgroundImageFn: EmojiPropTypes.backgroundImageFn,
  sheetSize: EmojiPropTypes.sheetSize,
  emojisToShowFilter: PropTypes.func,
  showPreview: PropTypes.bool,
  showSkinTones: PropTypes.bool,
  emojiTooltip: EmojiPropTypes.tooltip,
  useButton: EmojiPropTypes.useButton,
  theme: PropTypes.oneOf(["auto", "light", "dark"]),
  include: PropTypes.arrayOf(PropTypes.string),
  exclude: PropTypes.arrayOf(PropTypes.string),
  recent: PropTypes.arrayOf(PropTypes.string),
  autoFocus: PropTypes.bool,
  enableFrequentEmojiSort: PropTypes.bool,
  custom: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    short_names: PropTypes.arrayOf(PropTypes.string).isRequired,
    emoticons: PropTypes.arrayOf(PropTypes.string),
    keywords: PropTypes.arrayOf(PropTypes.string),
    imageUrl: PropTypes.string,
    spriteUrl: PropTypes.string,
    sheet_x: PropTypes.number,
    sheet_y: PropTypes.number,
    size: PropTypes.number,
    sheetColumns: PropTypes.number,
    sheetRows: PropTypes.number
  })),
  skinEmoji: PropTypes.string,
  notFound: PropTypes.func,
  notFoundEmoji: PropTypes.string,
  icons: PropTypes.object
}, Anchors = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$b(Anchors2, _React$PureComponent);
  function Anchors2(props) {
    var _this;
    _classCallCheck$m(this, Anchors2), _this = _possibleConstructorReturn$b(this, _getPrototypeOf$b(Anchors2).call(this, props));
    var defaultCategory = props.categories.filter(function(category) {
      return category.first;
    })[0];
    return _this.state = {
      selected: defaultCategory.name
    }, _this.handleClick = _this.handleClick.bind(_assertThisInitialized$b(_this)), _this;
  }
  return __name(Anchors2, "Anchors"), _createClass$m(Anchors2, [{
    key: "handleClick",
    value: /* @__PURE__ */ __name(function(e3) {
      var index2 = e3.currentTarget.getAttribute("data-index"), _this$props = this.props, categories2 = _this$props.categories, onAnchorClick2 = _this$props.onAnchorClick;
      onAnchorClick2(categories2[index2], index2);
    }, "handleClick")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this2 = this, _this$props2 = this.props, categories2 = _this$props2.categories, color2 = _this$props2.color, i18n = _this$props2.i18n, icons2 = _this$props2.icons, selected = this.state.selected;
      return React__default.createElement("nav", {
        className: "emoji-mart-anchors",
        "aria-label": i18n.categorieslabel
      }, categories2.map(function(category, i2) {
        var id2 = category.id, name2 = category.name, anchor = category.anchor, isSelected = name2 == selected;
        if (anchor === !1)
          return null;
        var iconId = id2.startsWith("custom-") ? "custom" : id2;
        return React__default.createElement("button", {
          key: id2,
          "aria-label": i18n.categories[iconId],
          title: i18n.categories[iconId],
          "data-index": i2,
          type: "button",
          onClick: _this2.handleClick,
          className: "emoji-mart-anchor ".concat(isSelected ? "emoji-mart-anchor-selected" : ""),
          style: {
            color: isSelected ? color2 : null
          }
        }, React__default.createElement("div", {
          className: "emoji-mart-anchor-icon"
        }, icons2.categories[iconId]()), React__default.createElement("span", {
          className: "emoji-mart-anchor-bar",
          style: {
            backgroundColor: color2
          }
        }));
      }));
    }, "render")
  }]), Anchors2;
}(React__default.PureComponent);
Anchors.propTypes = {
  categories: PropTypes.array,
  onAnchorClick: PropTypes.func,
  icons: PropTypes.object
};
Anchors.defaultProps = {
  categories: [],
  onAnchorClick: /* @__PURE__ */ __name(function() {
  }, "onAnchorClick"),
  icons: {}
};
var EmojiDefaultProps = {
  skin: 1,
  set: "apple",
  sheetSize: 64,
  sheetColumns: 57,
  sheetRows: 57,
  native: !1,
  forceSize: !1,
  tooltip: !1,
  useButton: !0,
  backgroundImageFn: /* @__PURE__ */ __name(function(set3, sheetSize) {
    return "https://unpkg.com/emoji-datasource-".concat(set3, "@").concat("5.0.1", "/img/").concat(set3, "/sheets-256/").concat(sheetSize, ".png");
  }, "backgroundImageFn")
}, PickerDefaultProps = {
  onClick: /* @__PURE__ */ __name(function() {
  }, "onClick"),
  onSelect: /* @__PURE__ */ __name(function() {
  }, "onSelect"),
  onSkinChange: /* @__PURE__ */ __name(function() {
  }, "onSkinChange"),
  emojiSize: 24,
  perLine: 9,
  i18n: {},
  style: {},
  title: "Emoji Mart™",
  emoji: "department_store",
  color: "#ae65c5",
  set: EmojiDefaultProps.set,
  theme: "light",
  skin: null,
  defaultSkin: EmojiDefaultProps.skin,
  native: EmojiDefaultProps.native,
  sheetSize: EmojiDefaultProps.sheetSize,
  backgroundImageFn: EmojiDefaultProps.backgroundImageFn,
  emojisToShowFilter: null,
  showPreview: !0,
  showSkinTones: !0,
  emojiTooltip: EmojiDefaultProps.tooltip,
  useButton: EmojiDefaultProps.useButton,
  autoFocus: !1,
  enableFrequentEmojiSort: !1,
  custom: [],
  skinEmoji: "",
  notFound: /* @__PURE__ */ __name(function() {
  }, "notFound"),
  notFoundEmoji: "sleuth_or_spy",
  icons: {}
};
function ownKeys$K(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$K, "ownKeys$K");
function _objectSpread$K(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$K(Object(source), !0).forEach(function(key) {
      _defineProperty$I(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$K(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$K, "_objectSpread$K");
var _getData = /* @__PURE__ */ __name(function(props) {
  var emoji = props.emoji, skin = props.skin, set3 = props.set, data2 = props.data;
  return getData(emoji, skin, set3, data2);
}, "_getData"), _getPosition = /* @__PURE__ */ __name(function(props) {
  var _getData22 = _getData(props), sheet_x = _getData22.sheet_x, sheet_y = _getData22.sheet_y, multiplyX = 100 / (props.sheetColumns - 1), multiplyY = 100 / (props.sheetRows - 1);
  return "".concat(multiplyX * sheet_x, "% ").concat(multiplyY * sheet_y, "%");
}, "_getPosition"), _getSanitizedData = /* @__PURE__ */ __name(function(props) {
  var emoji = props.emoji, skin = props.skin, set3 = props.set, data2 = props.data;
  return getSanitizedData(emoji, skin, set3, data2);
}, "_getSanitizedData"), _handleClick = /* @__PURE__ */ __name(function(e3, props) {
  if (props.onClick) {
    var onClick2 = props.onClick, emoji = _getSanitizedData(props);
    onClick2(emoji, e3);
  }
}, "_handleClick"), _handleOver = /* @__PURE__ */ __name(function(e3, props) {
  if (props.onOver) {
    var onOver = props.onOver, emoji = _getSanitizedData(props);
    onOver(emoji, e3);
  }
}, "_handleOver"), _handleLeave = /* @__PURE__ */ __name(function(e3, props) {
  if (props.onLeave) {
    var onLeave = props.onLeave, emoji = _getSanitizedData(props);
    onLeave(emoji, e3);
  }
}, "_handleLeave"), _isNumeric = /* @__PURE__ */ __name(function(value) {
  return !isNaN(value - parseFloat(value));
}, "_isNumeric"), _convertStyleToCSS = /* @__PURE__ */ __name(function(style2) {
  var div = document.createElement("div");
  for (var key in style2) {
    var value = style2[key];
    _isNumeric(value) && (value += "px"), div.style[key] = value;
  }
  return div.getAttribute("style");
}, "_convertStyleToCSS"), NimbleEmoji = /* @__PURE__ */ __name(function NimbleEmoji2(props) {
  props.data.compressed && uncompress(props.data);
  for (var k3 in NimbleEmoji2.defaultProps)
    props[k3] == null && NimbleEmoji2.defaultProps[k3] != null && (props[k3] = NimbleEmoji2.defaultProps[k3]);
  var data2 = _getData(props);
  if (!data2)
    return props.fallback ? props.fallback(null, props) : null;
  var unified2 = data2.unified, custom2 = data2.custom, short_names = data2.short_names, imageUrl = data2.imageUrl, style2 = {}, children = props.children, className = "emoji-mart-emoji", nativeEmoji = unified2 && unifiedToNative(unified2), label = [nativeEmoji].concat(short_names).filter(Boolean).join(", "), title = null;
  if (!unified2 && !custom2)
    return props.fallback ? props.fallback(data2, props) : null;
  if (props.tooltip && (title = short_names[0]), props.native && unified2)
    className += " emoji-mart-emoji-native", style2 = {
      fontSize: props.size
    }, children = nativeEmoji, props.forceSize && (style2.display = "inline-block", style2.width = props.size, style2.height = props.size, style2.wordBreak = "keep-all");
  else if (custom2)
    className += " emoji-mart-emoji-custom", style2 = {
      width: props.size,
      height: props.size,
      display: "inline-block"
    }, data2.spriteUrl ? style2 = _objectSpread$K({}, style2, {
      backgroundImage: "url(".concat(data2.spriteUrl, ")"),
      backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
      backgroundPosition: _getPosition(props)
    }) : style2 = _objectSpread$K({}, style2, {
      backgroundImage: "url(".concat(imageUrl, ")"),
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center"
    });
  else {
    var setHasEmoji = data2["has_img_".concat(props.set)] == null || data2["has_img_".concat(props.set)];
    if (setHasEmoji)
      style2 = {
        width: props.size,
        height: props.size,
        display: "inline-block",
        backgroundImage: "url(".concat(props.backgroundImageFn(props.set, props.sheetSize), ")"),
        backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
        backgroundPosition: _getPosition(props)
      };
    else
      return props.fallback ? props.fallback(data2, props) : null;
  }
  var Tag2 = {
    name: "span",
    props: {}
  };
  return props.onClick && props.useButton && (Tag2.name = "button", Tag2.props = {
    type: "button"
  }), props.html ? (style2 = _convertStyleToCSS(style2), "<".concat(Tag2.name, " style='").concat(style2, "' aria-label='").concat(label, "' ").concat(title ? "title='".concat(title, "'") : "", " class='").concat(className, "'>").concat(children || "", "</").concat(Tag2.name, ">")) : React__default.createElement(Tag2.name, _extends$p({
    onClick: /* @__PURE__ */ __name(function(e3) {
      return _handleClick(e3, props);
    }, "onClick"),
    onMouseEnter: /* @__PURE__ */ __name(function(e3) {
      return _handleOver(e3, props);
    }, "onMouseEnter"),
    onMouseLeave: /* @__PURE__ */ __name(function(e3) {
      return _handleLeave(e3, props);
    }, "onMouseLeave"),
    "aria-label": label,
    title,
    className
  }, Tag2.props), React__default.createElement("span", {
    style: style2
  }, children));
}, "NimbleEmoji");
NimbleEmoji.propTypes = _objectSpread$K({}, EmojiPropTypes, {
  data: PropTypes.object.isRequired
});
NimbleEmoji.defaultProps = EmojiDefaultProps;
function ownKeys$J(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$J, "ownKeys$J");
function _objectSpread$J(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$J(Object(source), !0).forEach(function(key) {
      _defineProperty$I(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$J(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$J, "_objectSpread$J");
var NotFound = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$b(NotFound2, _React$PureComponent);
  function NotFound2() {
    return _classCallCheck$m(this, NotFound2), _possibleConstructorReturn$b(this, _getPrototypeOf$b(NotFound2).apply(this, arguments));
  }
  return __name(NotFound2, "NotFound"), _createClass$m(NotFound2, [{
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this$props = this.props, data2 = _this$props.data, emojiProps = _this$props.emojiProps, i18n = _this$props.i18n, notFound2 = _this$props.notFound, notFoundEmoji = _this$props.notFoundEmoji, component = notFound2 && notFound2() || React__default.createElement("div", {
        className: "emoji-mart-no-results"
      }, NimbleEmoji(_objectSpread$J({
        data: data2
      }, emojiProps, {
        size: 38,
        emoji: notFoundEmoji,
        onOver: null,
        onLeave: null,
        onClick: null
      })), React__default.createElement("div", {
        className: "emoji-mart-no-results-label"
      }, i18n.notfound));
      return component;
    }, "render")
  }]), NotFound2;
}(React__default.PureComponent);
NotFound.propTypes = {
  notFound: PropTypes.func.isRequired,
  emojiProps: PropTypes.object.isRequired
};
function ownKeys$I(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$I, "ownKeys$I");
function _objectSpread$I(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$I(Object(source), !0).forEach(function(key) {
      _defineProperty$I(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$I(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$I, "_objectSpread$I");
var Category = /* @__PURE__ */ function(_React$Component) {
  _inherits$b(Category2, _React$Component);
  function Category2(props) {
    var _this;
    return _classCallCheck$m(this, Category2), _this = _possibleConstructorReturn$b(this, _getPrototypeOf$b(Category2).call(this, props)), _this.data = props.data, _this.setContainerRef = _this.setContainerRef.bind(_assertThisInitialized$b(_this)), _this.setLabelRef = _this.setLabelRef.bind(_assertThisInitialized$b(_this)), _this;
  }
  return __name(Category2, "Category"), _createClass$m(Category2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function() {
      this.margin = 0, this.minMargin = 0, this.memoizeSize();
    }, "componentDidMount")
  }, {
    key: "shouldComponentUpdate",
    value: /* @__PURE__ */ __name(function(nextProps, nextState) {
      var _this$props = this.props, name2 = _this$props.name, perLine = _this$props.perLine, _native = _this$props.native, hasStickyPosition = _this$props.hasStickyPosition, emojis2 = _this$props.emojis, emojiProps = _this$props.emojiProps, skin = emojiProps.skin, size = emojiProps.size, set3 = emojiProps.set, nextPerLine = nextProps.perLine, nextNative = nextProps.native, nextHasStickyPosition = nextProps.hasStickyPosition, nextEmojis = nextProps.emojis, nextEmojiProps = nextProps.emojiProps, nextSkin = nextEmojiProps.skin, nextSize = nextEmojiProps.size, nextSet = nextEmojiProps.set, shouldUpdate = !1;
      return name2 == "Recent" && perLine != nextPerLine && (shouldUpdate = !0), name2 == "Search" && (shouldUpdate = emojis2 != nextEmojis), (skin != nextSkin || size != nextSize || _native != nextNative || set3 != nextSet || hasStickyPosition != nextHasStickyPosition) && (shouldUpdate = !0), shouldUpdate;
    }, "shouldComponentUpdate")
  }, {
    key: "memoizeSize",
    value: /* @__PURE__ */ __name(function() {
      if (!this.container) {
        this.top = 0, this.maxMargin = 0;
        return;
      }
      var parent2 = this.container.parentElement, _this$container$getBo = this.container.getBoundingClientRect(), top2 = _this$container$getBo.top, height2 = _this$container$getBo.height, _parent$getBoundingCl = parent2.getBoundingClientRect(), parentTop = _parent$getBoundingCl.top, _this$label$getBoundi = this.label.getBoundingClientRect(), labelHeight = _this$label$getBoundi.height;
      this.top = top2 - parentTop + parent2.scrollTop, height2 == 0 ? this.maxMargin = 0 : this.maxMargin = height2 - labelHeight;
    }, "memoizeSize")
  }, {
    key: "handleScroll",
    value: /* @__PURE__ */ __name(function(scrollTop) {
      var margin2 = scrollTop - this.top;
      if (margin2 = margin2 < this.minMargin ? this.minMargin : margin2, margin2 = margin2 > this.maxMargin ? this.maxMargin : margin2, margin2 != this.margin)
        return this.props.hasStickyPosition || (this.label.style.top = "".concat(margin2, "px")), this.margin = margin2, !0;
    }, "handleScroll")
  }, {
    key: "getEmojis",
    value: /* @__PURE__ */ __name(function() {
      var _this2 = this, _this$props2 = this.props, name2 = _this$props2.name, emojis2 = _this$props2.emojis, recent2 = _this$props2.recent, perLine = _this$props2.perLine;
      if (name2 == "Recent") {
        var custom2 = this.props.custom, frequentlyUsed = recent2 || frequently$1.get(perLine);
        if (frequentlyUsed.length && (emojis2 = frequentlyUsed.map(function(id2) {
          var emoji = custom2.filter(function(e3) {
            return e3.id === id2;
          })[0];
          return emoji || id2;
        }).filter(function(id2) {
          return !!getData(id2, null, null, _this2.data);
        })), emojis2.length === 0 && frequentlyUsed.length > 0)
          return null;
      }
      return emojis2 && (emojis2 = emojis2.slice(0)), emojis2;
    }, "getEmojis")
  }, {
    key: "updateDisplay",
    value: /* @__PURE__ */ __name(function(display2) {
      var emojis2 = this.getEmojis();
      !emojis2 || !this.container || (this.container.style.display = display2);
    }, "updateDisplay")
  }, {
    key: "setContainerRef",
    value: /* @__PURE__ */ __name(function(c3) {
      this.container = c3;
    }, "setContainerRef")
  }, {
    key: "setLabelRef",
    value: /* @__PURE__ */ __name(function(c3) {
      this.label = c3;
    }, "setLabelRef")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this3 = this, _this$props3 = this.props, id2 = _this$props3.id, name2 = _this$props3.name, hasStickyPosition = _this$props3.hasStickyPosition, emojiProps = _this$props3.emojiProps, i18n = _this$props3.i18n, notFound2 = _this$props3.notFound, notFoundEmoji = _this$props3.notFoundEmoji, emojis2 = this.getEmojis(), labelStyles = {}, labelSpanStyles = {}, containerStyles = {};
      emojis2 || (containerStyles = {
        display: "none"
      }), hasStickyPosition || (labelStyles = {
        height: 28
      }, labelSpanStyles = {
        position: "absolute"
      });
      var label = i18n.categories[id2] || name2;
      return React__default.createElement("section", {
        ref: this.setContainerRef,
        className: "emoji-mart-category",
        "aria-label": label,
        style: containerStyles
      }, React__default.createElement("div", {
        style: labelStyles,
        "data-name": name2,
        className: "emoji-mart-category-label"
      }, React__default.createElement("span", {
        style: labelSpanStyles,
        ref: this.setLabelRef,
        "aria-hidden": !0
        /* already labeled by the section aria-label */
      }, label)), React__default.createElement("ul", {
        className: "emoji-mart-category-list"
      }, emojis2 && emojis2.map(function(emoji) {
        return React__default.createElement("li", {
          key: emoji.short_names && emoji.short_names.join("_") || emoji
        }, NimbleEmoji(_objectSpread$I({
          emoji,
          data: _this3.data
        }, emojiProps)));
      })), emojis2 && !emojis2.length && React__default.createElement(NotFound, {
        i18n,
        notFound: notFound2,
        notFoundEmoji,
        data: this.data,
        emojiProps
      }));
    }, "render")
  }]), Category2;
}(React__default.Component);
Category.propTypes = {
  emojis: PropTypes.array,
  hasStickyPosition: PropTypes.bool,
  name: PropTypes.string.isRequired,
  native: PropTypes.bool.isRequired,
  perLine: PropTypes.number.isRequired,
  emojiProps: PropTypes.object.isRequired,
  recent: PropTypes.arrayOf(PropTypes.string),
  notFound: PropTypes.func,
  notFoundEmoji: PropTypes.string.isRequired
};
Category.defaultProps = {
  emojis: [],
  hasStickyPosition: !0
};
var Skins = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$b(Skins2, _React$PureComponent);
  function Skins2(props) {
    var _this;
    return _classCallCheck$m(this, Skins2), _this = _possibleConstructorReturn$b(this, _getPrototypeOf$b(Skins2).call(this, props)), _this.state = {
      opened: !1
    }, _this;
  }
  return __name(Skins2, "Skins"), _createClass$m(Skins2, [{
    key: "handleClick",
    value: /* @__PURE__ */ __name(function(e3) {
      var skin = parseInt(e3.currentTarget.getAttribute("data-skin")), onChange5 = this.props.onChange;
      this.state.opened ? (this.setState({
        opened: !1
      }), skin != this.props.skin && onChange5(skin)) : this.setState({
        opened: !0
      });
    }, "handleClick")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      return null;
    }, "render")
  }]), Skins2;
}(React__default.PureComponent);
Skins.propTypes = {
  onChange: PropTypes.func,
  skin: PropTypes.number.isRequired
};
Skins.defaultProps = {
  onChange: /* @__PURE__ */ __name(function() {
  }, "onChange")
};
var SkinsEmoji = /* @__PURE__ */ function(_Skins) {
  _inherits$b(SkinsEmoji2, _Skins);
  function SkinsEmoji2(props) {
    var _this;
    return _classCallCheck$m(this, SkinsEmoji2), _this = _possibleConstructorReturn$b(this, _getPrototypeOf$b(SkinsEmoji2).call(this, props)), _this.handleClick = _this.handleClick.bind(_assertThisInitialized$b(_this)), _this;
  }
  return __name(SkinsEmoji2, "SkinsEmoji"), _createClass$m(SkinsEmoji2, [{
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      for (var _this$props = this.props, skin = _this$props.skin, emojiProps = _this$props.emojiProps, data2 = _this$props.data, skinEmoji = _this$props.skinEmoji, i18n = _this$props.i18n, opened = this.state.opened, skinToneNodes = [], skinTone = 1; skinTone <= 6; skinTone++) {
        var selected = skinTone === skin;
        skinToneNodes.push(React__default.createElement("span", {
          key: "skin-tone-".concat(skinTone),
          className: "emoji-mart-skin-swatch custom".concat(selected ? " selected" : "")
        }, React__default.createElement("span", {
          onClick: this.handleClick,
          "data-skin": skinTone,
          className: "emoji-mart-skin-tone-".concat(skinTone)
        }, NimbleEmoji({
          emoji: skinEmoji,
          data: data2,
          skin: skinTone,
          backgroundImageFn: emojiProps.backgroundImageFn,
          native: emojiProps.native,
          set: emojiProps.set,
          sheetSize: emojiProps.sheetSize,
          size: 23
        }))));
      }
      return React__default.createElement("div", {
        className: "emoji-mart-skin-swatches custom".concat(opened ? " opened" : "")
      }, React__default.createElement("div", {
        className: "emoji-mart-skin-text".concat(opened ? " opened" : "")
      }, i18n.skintext), skinToneNodes);
    }, "render")
  }]), SkinsEmoji2;
}(Skins);
SkinsEmoji.propTypes = {
  onChange: PropTypes.func,
  skin: PropTypes.number.isRequired,
  emojiProps: PropTypes.object.isRequired,
  skinTone: PropTypes.number,
  skinEmoji: PropTypes.string.isRequired,
  i18n: PropTypes.object
};
SkinsEmoji.defaultProps = {
  onChange: /* @__PURE__ */ __name(function() {
  }, "onChange"),
  skinTone: null
};
var SkinsDot = /* @__PURE__ */ function(_Skins) {
  _inherits$b(SkinsDot2, _Skins);
  function SkinsDot2(props) {
    var _this;
    return _classCallCheck$m(this, SkinsDot2), _this = _possibleConstructorReturn$b(this, _getPrototypeOf$b(SkinsDot2).call(this, props)), _this.handleClick = _this.handleClick.bind(_assertThisInitialized$b(_this)), _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized$b(_this)), _this;
  }
  return __name(SkinsDot2, "SkinsDot"), _createClass$m(SkinsDot2, [{
    key: "handleKeyDown",
    value: /* @__PURE__ */ __name(function(event) {
      (event.keyCode === 13 || event.keyCode === 32) && (event.preventDefault(), this.handleClick(event));
    }, "handleKeyDown")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      for (var _this$props = this.props, skin = _this$props.skin, i18n = _this$props.i18n, opened = this.state.opened, skinToneNodes = [], skinTone = 1; skinTone <= 6; skinTone++) {
        var selected = skinTone === skin, visible = opened || selected;
        skinToneNodes.push(React__default.createElement("span", _extends$p({
          key: "skin-tone-".concat(skinTone),
          className: "emoji-mart-skin-swatch".concat(selected ? " selected" : ""),
          "aria-label": i18n.skintones[skinTone],
          "aria-hidden": !visible
        }, opened ? {
          role: "menuitem"
        } : {}), React__default.createElement("span", _extends$p({
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          role: "button"
        }, selected ? {
          "aria-haspopup": !0,
          "aria-expanded": !!opened
        } : {}, opened ? {
          "aria-pressed": !!selected
        } : {}, {
          tabIndex: visible ? "0" : "",
          "aria-label": i18n.skintones[skinTone],
          title: i18n.skintones[skinTone],
          "data-skin": skinTone,
          className: "emoji-mart-skin emoji-mart-skin-tone-".concat(skinTone)
        }))));
      }
      return React__default.createElement("section", {
        className: "emoji-mart-skin-swatches".concat(opened ? " opened" : ""),
        "aria-label": i18n.skintext
      }, React__default.createElement("div", opened ? {
        role: "menubar"
      } : {}, skinToneNodes));
    }, "render")
  }]), SkinsDot2;
}(Skins);
SkinsDot.propTypes = {
  onChange: PropTypes.func,
  skin: PropTypes.number.isRequired,
  i18n: PropTypes.object
};
SkinsDot.defaultProps = {
  onChange: /* @__PURE__ */ __name(function() {
  }, "onChange")
};
function ownKeys$H(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$H, "ownKeys$H");
function _objectSpread$H(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$H(Object(source), !0).forEach(function(key) {
      _defineProperty$I(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$H(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$H, "_objectSpread$H");
var Preview = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$b(Preview2, _React$PureComponent);
  function Preview2(props) {
    var _this;
    return _classCallCheck$m(this, Preview2), _this = _possibleConstructorReturn$b(this, _getPrototypeOf$b(Preview2).call(this, props)), _this.data = props.data, _this.state = {
      emoji: null
    }, _this;
  }
  return __name(Preview2, "Preview"), _createClass$m(Preview2, [{
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var emoji = this.state.emoji, _this$props = this.props, emojiProps = _this$props.emojiProps, skinsProps = _this$props.skinsProps, showSkinTones = _this$props.showSkinTones, title = _this$props.title, idleEmoji = _this$props.emoji, i18n = _this$props.i18n, showPreview = _this$props.showPreview;
      if (emoji && showPreview) {
        var emojiData = getData(emoji, null, null, this.data), _emojiData$emoticons = emojiData.emoticons, emoticons2 = _emojiData$emoticons === void 0 ? [] : _emojiData$emoticons, knownEmoticons = [], listedEmoticons = [];
        return emoticons2.forEach(function(emoticon) {
          knownEmoticons.indexOf(emoticon.toLowerCase()) >= 0 || (knownEmoticons.push(emoticon.toLowerCase()), listedEmoticons.push(emoticon));
        }), React__default.createElement("div", {
          className: "emoji-mart-preview"
        }, React__default.createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, NimbleEmoji(_objectSpread$H({
          key: emoji.id,
          emoji,
          data: this.data
        }, emojiProps))), React__default.createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, React__default.createElement("div", {
          className: "emoji-mart-preview-name"
        }, emoji.name), React__default.createElement("div", {
          className: "emoji-mart-preview-shortnames"
        }, emojiData.short_names.map(function(short_name) {
          return React__default.createElement("span", {
            key: short_name,
            className: "emoji-mart-preview-shortname"
          }, ":", short_name, ":");
        })), React__default.createElement("div", {
          className: "emoji-mart-preview-emoticons"
        }, listedEmoticons.map(function(emoticon) {
          return React__default.createElement("span", {
            key: emoticon,
            className: "emoji-mart-preview-emoticon"
          }, emoticon);
        }))));
      } else
        return React__default.createElement("div", {
          className: "emoji-mart-preview"
        }, React__default.createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, idleEmoji && idleEmoji.length && NimbleEmoji(_objectSpread$H({
          emoji: idleEmoji,
          data: this.data
        }, emojiProps))), React__default.createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, React__default.createElement("span", {
          className: "emoji-mart-title-label"
        }, title)), showSkinTones && React__default.createElement("div", {
          className: "emoji-mart-preview-skins".concat(skinsProps.skinEmoji ? " custom" : "")
        }, skinsProps.skinEmoji ? React__default.createElement(SkinsEmoji, {
          skin: skinsProps.skin,
          emojiProps,
          data: this.data,
          skinEmoji: skinsProps.skinEmoji,
          i18n,
          onChange: skinsProps.onChange
        }) : React__default.createElement(SkinsDot, {
          skin: skinsProps.skin,
          i18n,
          onChange: skinsProps.onChange
        })));
    }, "render")
  }]), Preview2;
}(React__default.PureComponent);
Preview.propTypes = {
  showSkinTones: PropTypes.bool,
  title: PropTypes.string.isRequired,
  emoji: PropTypes.string.isRequired,
  emojiProps: PropTypes.object.isRequired,
  skinsProps: PropTypes.object.isRequired
};
Preview.defaultProps = {
  showSkinTones: !0,
  onChange: /* @__PURE__ */ __name(function() {
  }, "onChange")
};
var id$2 = 0, Search = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$b(Search2, _React$PureComponent);
  function Search2(props) {
    var _this;
    return _classCallCheck$m(this, Search2), _this = _possibleConstructorReturn$b(this, _getPrototypeOf$b(Search2).call(this, props)), _this.state = {
      icon: search$1.search,
      isSearching: !1,
      id: ++id$2
    }, _this.data = props.data, _this.emojiIndex = new NimbleEmojiIndex(_this.data), _this.setRef = _this.setRef.bind(_assertThisInitialized$b(_this)), _this.clear = _this.clear.bind(_assertThisInitialized$b(_this)), _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized$b(_this)), _this.handleChange = throttleIdleTask(_this.handleChange.bind(_assertThisInitialized$b(_this))), _this;
  }
  return __name(Search2, "Search"), _createClass$m(Search2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function() {
      this.input && this.input.value && this.search(this.input.value);
    }, "componentDidMount")
  }, {
    key: "search",
    value: /* @__PURE__ */ __name(function(value) {
      value == "" ? this.setState({
        icon: search$1.search,
        isSearching: !1
      }) : this.setState({
        icon: search$1.delete,
        isSearching: !0
      }), this.props.onSearch(this.emojiIndex.search(value, {
        emojisToShowFilter: this.props.emojisToShowFilter,
        maxResults: this.props.maxResults,
        include: this.props.include,
        exclude: this.props.exclude,
        custom: this.props.custom
      }));
    }, "search")
  }, {
    key: "clear",
    value: /* @__PURE__ */ __name(function() {
      this.input.value != "" && (this.input.value = "", this.input.focus(), this.search(""));
    }, "clear")
  }, {
    key: "handleChange",
    value: /* @__PURE__ */ __name(function() {
      this.input && this.search(this.input.value);
    }, "handleChange")
  }, {
    key: "handleKeyUp",
    value: /* @__PURE__ */ __name(function(e3) {
      e3.keyCode === 13 && this.clear();
    }, "handleKeyUp")
  }, {
    key: "setRef",
    value: /* @__PURE__ */ __name(function(c3) {
      this.input = c3;
    }, "setRef")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this$props = this.props, i18n = _this$props.i18n, autoFocus = _this$props.autoFocus, _this$state = this.state, icon = _this$state.icon, isSearching = _this$state.isSearching, id2 = _this$state.id, inputId = "emoji-mart-search-".concat(id2);
      return React__default.createElement("section", {
        className: "emoji-mart-search",
        "aria-label": i18n.search
      }, React__default.createElement("input", {
        id: inputId,
        ref: this.setRef,
        type: "search",
        onChange: this.handleChange,
        placeholder: i18n.search,
        autoFocus
      }), React__default.createElement("label", {
        className: "emoji-mart-sr-only",
        htmlFor: inputId
      }, i18n.search), React__default.createElement("button", {
        className: "emoji-mart-search-icon",
        onClick: this.clear,
        onKeyUp: this.handleKeyUp,
        "aria-label": i18n.clear,
        disabled: !isSearching
      }, icon()));
    }, "render")
  }]), Search2;
}(React__default.PureComponent);
Search.propTypes = {
  onSearch: PropTypes.func,
  maxResults: PropTypes.number,
  emojisToShowFilter: PropTypes.func,
  autoFocus: PropTypes.bool
};
Search.defaultProps = {
  onSearch: /* @__PURE__ */ __name(function() {
  }, "onSearch"),
  maxResults: 75,
  emojisToShowFilter: null,
  autoFocus: !1
};
function ownKeys$G(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$G, "ownKeys$G");
function _objectSpread$G(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$G(Object(source), !0).forEach(function(key) {
      _defineProperty$I(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$G(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$G, "_objectSpread$G");
var I18N = {
  search: "Search",
  clear: "Clear",
  // Accessible label on "clear" button
  notfound: "No Emoji Found",
  skintext: "Choose your default skin tone",
  categories: {
    search: "Search Results",
    recent: "Frequently Used",
    people: "Smileys & People",
    nature: "Animals & Nature",
    foods: "Food & Drink",
    activity: "Activity",
    places: "Travel & Places",
    objects: "Objects",
    symbols: "Symbols",
    flags: "Flags",
    custom: "Custom"
  },
  categorieslabel: "Emoji categories",
  // Accessible title for the list of categories
  skintones: {
    1: "Default Skin Tone",
    2: "Light Skin Tone",
    3: "Medium-Light Skin Tone",
    4: "Medium Skin Tone",
    5: "Medium-Dark Skin Tone",
    6: "Dark Skin Tone"
  }
}, NimblePicker = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$b(NimblePicker2, _React$PureComponent);
  function NimblePicker2(props) {
    var _this;
    _classCallCheck$m(this, NimblePicker2), _this = _possibleConstructorReturn$b(this, _getPrototypeOf$b(NimblePicker2).call(this, props)), _this.CUSTOM = [], _this.RECENT_CATEGORY = {
      id: "recent",
      name: "Recent",
      emojis: null
    }, _this.SEARCH_CATEGORY = {
      id: "search",
      name: "Search",
      emojis: null,
      anchor: !1
    }, props.data.compressed && uncompress(props.data), _this.data = props.data, _this.i18n = deepMerge(I18N, props.i18n), _this.icons = deepMerge(icons, props.icons), _this.state = {
      firstRender: !0
    }, _this.categories = [];
    var allCategories = [].concat(_this.data.categories);
    if (props.custom.length > 0) {
      var customCategories = {}, customCategoriesCreated = 0;
      props.custom.forEach(function(emoji2) {
        customCategories[emoji2.customCategory] || (customCategories[emoji2.customCategory] = {
          id: emoji2.customCategory ? "custom-".concat(emoji2.customCategory) : "custom",
          name: emoji2.customCategory || "Custom",
          emojis: [],
          anchor: customCategoriesCreated === 0
        }, customCategoriesCreated++);
        var category2 = customCategories[emoji2.customCategory], customEmoji = _objectSpread$G({}, emoji2, {
          // `<Category />` expects emoji to have an `id`.
          id: emoji2.short_names[0],
          custom: !0
        });
        category2.emojis.push(customEmoji), _this.CUSTOM.push(customEmoji);
      }), allCategories = allCategories.concat(Object.keys(customCategories).map(function(key) {
        return customCategories[key];
      }));
    }
    _this.hideRecent = !0, props.include != null && allCategories.sort(function(a4, b2) {
      return props.include.indexOf(a4.id) > props.include.indexOf(b2.id) ? 1 : -1;
    });
    for (var categoryIndex = 0; categoryIndex < allCategories.length; categoryIndex++) {
      var category = allCategories[categoryIndex], isIncluded = props.include && props.include.length ? props.include.indexOf(category.id) > -1 : !0, isExcluded = props.exclude && props.exclude.length ? props.exclude.indexOf(category.id) > -1 : !1;
      if (!(!isIncluded || isExcluded))
        if (props.emojisToShowFilter) {
          for (var newEmojis = [], emojis2 = category.emojis, emojiIndex2 = 0; emojiIndex2 < emojis2.length; emojiIndex2++) {
            var emoji = emojis2[emojiIndex2];
            props.emojisToShowFilter(_this.data.emojis[emoji] || emoji) && newEmojis.push(emoji);
          }
          if (newEmojis.length) {
            var newCategory = {
              emojis: newEmojis,
              name: category.name,
              id: category.id
            };
            _this.categories.push(newCategory);
          }
        } else
          _this.categories.push(category);
    }
    var includeRecent = props.include && props.include.length ? props.include.indexOf(_this.RECENT_CATEGORY.id) > -1 : !0, excludeRecent = props.exclude && props.exclude.length ? props.exclude.indexOf(_this.RECENT_CATEGORY.id) > -1 : !1;
    return includeRecent && !excludeRecent && (_this.hideRecent = !1, _this.categories.unshift(_this.RECENT_CATEGORY)), _this.categories[0] && (_this.categories[0].first = !0), _this.categories.unshift(_this.SEARCH_CATEGORY), _this.setAnchorsRef = _this.setAnchorsRef.bind(_assertThisInitialized$b(_this)), _this.handleAnchorClick = _this.handleAnchorClick.bind(_assertThisInitialized$b(_this)), _this.setSearchRef = _this.setSearchRef.bind(_assertThisInitialized$b(_this)), _this.handleSearch = _this.handleSearch.bind(_assertThisInitialized$b(_this)), _this.setScrollRef = _this.setScrollRef.bind(_assertThisInitialized$b(_this)), _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized$b(_this)), _this.handleScrollPaint = _this.handleScrollPaint.bind(_assertThisInitialized$b(_this)), _this.handleEmojiOver = _this.handleEmojiOver.bind(_assertThisInitialized$b(_this)), _this.handleEmojiLeave = _this.handleEmojiLeave.bind(_assertThisInitialized$b(_this)), _this.handleEmojiClick = _this.handleEmojiClick.bind(_assertThisInitialized$b(_this)), _this.handleEmojiSelect = _this.handleEmojiSelect.bind(_assertThisInitialized$b(_this)), _this.setPreviewRef = _this.setPreviewRef.bind(_assertThisInitialized$b(_this)), _this.handleSkinChange = _this.handleSkinChange.bind(_assertThisInitialized$b(_this)), _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized$b(_this)), _this.handleDarkMatchMediaChange = _this.handleDarkMatchMediaChange.bind(_assertThisInitialized$b(_this)), _this;
  }
  return __name(NimblePicker2, "NimblePicker"), _createClass$m(NimblePicker2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function() {
      var _this2 = this;
      this.state.firstRender && (this.testStickyPosition(), this.firstRenderTimeout = setTimeout(function() {
        _this2.setState({
          firstRender: !1
        });
      }, 60));
    }, "componentDidMount")
  }, {
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function() {
      this.updateCategoriesSize(), this.handleScroll();
    }, "componentDidUpdate")
  }, {
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function() {
      this.SEARCH_CATEGORY.emojis = null, clearTimeout(this.leaveTimeout), clearTimeout(this.firstRenderTimeout), this.darkMatchMedia && this.darkMatchMedia.removeListener(this.handleDarkMatchMediaChange);
    }, "componentWillUnmount")
  }, {
    key: "testStickyPosition",
    value: /* @__PURE__ */ __name(function() {
      var stickyTestElement = document.createElement("div"), prefixes2 = ["", "-webkit-", "-ms-", "-moz-", "-o-"];
      prefixes2.forEach(function(prefix2) {
        return stickyTestElement.style.position = "".concat(prefix2, "sticky");
      }), this.hasStickyPosition = !!stickyTestElement.style.position.length;
    }, "testStickyPosition")
  }, {
    key: "getPreferredTheme",
    value: /* @__PURE__ */ __name(function() {
      return this.props.theme != "auto" ? this.props.theme : this.state.theme ? this.state.theme : typeof matchMedia != "function" || (this.darkMatchMedia || (this.darkMatchMedia = matchMedia("(prefers-color-scheme: dark)"), this.darkMatchMedia.addListener(this.handleDarkMatchMediaChange)), this.darkMatchMedia.media.match(/^not/)) ? PickerDefaultProps.theme : this.darkMatchMedia.matches ? "dark" : "light";
    }, "getPreferredTheme")
  }, {
    key: "handleDarkMatchMediaChange",
    value: /* @__PURE__ */ __name(function() {
      this.setState({
        theme: this.darkMatchMedia.matches ? "dark" : "light"
      });
    }, "handleDarkMatchMediaChange")
  }, {
    key: "handleEmojiOver",
    value: /* @__PURE__ */ __name(function(emoji) {
      var preview = this.preview;
      if (preview) {
        var emojiData = this.CUSTOM.filter(function(customEmoji) {
          return customEmoji.id === emoji.id;
        })[0];
        for (var key in emojiData)
          emojiData.hasOwnProperty(key) && (emoji[key] = emojiData[key]);
        preview.setState({
          emoji
        }), clearTimeout(this.leaveTimeout);
      }
    }, "handleEmojiOver")
  }, {
    key: "handleEmojiLeave",
    value: /* @__PURE__ */ __name(function(emoji) {
      var preview = this.preview;
      preview && (this.leaveTimeout = setTimeout(function() {
        preview.setState({
          emoji: null
        });
      }, 16));
    }, "handleEmojiLeave")
  }, {
    key: "handleEmojiClick",
    value: /* @__PURE__ */ __name(function(emoji, e3) {
      this.props.onClick(emoji, e3), this.handleEmojiSelect(emoji);
    }, "handleEmojiClick")
  }, {
    key: "handleEmojiSelect",
    value: /* @__PURE__ */ __name(function(emoji) {
      var _this3 = this;
      this.props.onSelect(emoji), !this.hideRecent && !this.props.recent && frequently$1.add(emoji);
      var component = this.categoryRefs["category-1"];
      if (component) {
        var maxMargin = component.maxMargin;
        this.props.enableFrequentEmojiSort && component.forceUpdate(), requestAnimationFrame(function() {
          _this3.scroll && (component.memoizeSize(), maxMargin != component.maxMargin && (_this3.updateCategoriesSize(), _this3.handleScrollPaint(), _this3.SEARCH_CATEGORY.emojis && component.updateDisplay("none")));
        });
      }
    }, "handleEmojiSelect")
  }, {
    key: "handleScroll",
    value: /* @__PURE__ */ __name(function() {
      this.waitingForPaint || (this.waitingForPaint = !0, requestAnimationFrame(this.handleScrollPaint));
    }, "handleScroll")
  }, {
    key: "handleScrollPaint",
    value: /* @__PURE__ */ __name(function() {
      if (this.waitingForPaint = !1, !!this.scroll) {
        var activeCategory = null;
        if (this.SEARCH_CATEGORY.emojis)
          activeCategory = this.SEARCH_CATEGORY;
        else {
          for (var target = this.scroll, scrollTop = target.scrollTop, scrollingDown = scrollTop > (this.scrollTop || 0), minTop = 0, i2 = 0, l = this.categories.length; i2 < l; i2++) {
            var ii = scrollingDown ? this.categories.length - 1 - i2 : i2, category = this.categories[ii], component = this.categoryRefs["category-".concat(ii)];
            if (component) {
              var active = component.handleScroll(scrollTop);
              (!minTop || component.top < minTop) && component.top > 0 && (minTop = component.top), active && !activeCategory && (activeCategory = category);
            }
          }
          scrollTop < minTop ? activeCategory = this.categories.filter(function(category2) {
            return category2.anchor !== !1;
          })[0] : scrollTop + this.clientHeight >= this.scrollHeight && (activeCategory = this.categories[this.categories.length - 1]);
        }
        if (activeCategory) {
          var anchors = this.anchors, _activeCategory = activeCategory, categoryName = _activeCategory.name;
          anchors.state.selected != categoryName && anchors.setState({
            selected: categoryName
          });
        }
        this.scrollTop = scrollTop;
      }
    }, "handleScrollPaint")
  }, {
    key: "handleSearch",
    value: /* @__PURE__ */ __name(function(emojis2) {
      this.SEARCH_CATEGORY.emojis = emojis2;
      for (var i2 = 0, l = this.categories.length; i2 < l; i2++) {
        var component = this.categoryRefs["category-".concat(i2)];
        if (component && component.props.name != "Search") {
          var display2 = emojis2 ? "none" : "inherit";
          component.updateDisplay(display2);
        }
      }
      this.forceUpdate(), this.scroll && (this.scroll.scrollTop = 0), this.handleScroll();
    }, "handleSearch")
  }, {
    key: "handleAnchorClick",
    value: /* @__PURE__ */ __name(function(category, i2) {
      var component = this.categoryRefs["category-".concat(i2)], scroll = this.scroll;
      this.anchors;
      var scrollToComponent = null;
      scrollToComponent = /* @__PURE__ */ __name(function() {
        if (component) {
          var top2 = component.top;
          category.first ? top2 = 0 : top2 += 1, scroll.scrollTop = top2;
        }
      }, "scrollToComponent"), this.SEARCH_CATEGORY.emojis ? (this.handleSearch(null), this.search.clear(), requestAnimationFrame(scrollToComponent)) : scrollToComponent();
    }, "handleAnchorClick")
  }, {
    key: "handleSkinChange",
    value: /* @__PURE__ */ __name(function(skin) {
      var newState = {
        skin
      }, onSkinChange2 = this.props.onSkinChange;
      this.setState(newState), store.update(newState), onSkinChange2(skin);
    }, "handleSkinChange")
  }, {
    key: "handleKeyDown",
    value: /* @__PURE__ */ __name(function(e3) {
      var handled = !1;
      switch (e3.keyCode) {
        case 13:
          var emoji;
          this.SEARCH_CATEGORY.emojis && this.SEARCH_CATEGORY.emojis.length && (emoji = getSanitizedData(this.SEARCH_CATEGORY.emojis[0], this.state.skin, this.props.set, this.props.data)) && (this.handleEmojiSelect(emoji), handled = !0);
          break;
      }
      handled && e3.preventDefault();
    }, "handleKeyDown")
  }, {
    key: "updateCategoriesSize",
    value: /* @__PURE__ */ __name(function() {
      for (var i2 = 0, l = this.categories.length; i2 < l; i2++) {
        var component = this.categoryRefs["category-".concat(i2)];
        component && component.memoizeSize();
      }
      if (this.scroll) {
        var target = this.scroll;
        this.scrollHeight = target.scrollHeight, this.clientHeight = target.clientHeight;
      }
    }, "updateCategoriesSize")
  }, {
    key: "getCategories",
    value: /* @__PURE__ */ __name(function() {
      return this.state.firstRender ? this.categories.slice(0, 3) : this.categories;
    }, "getCategories")
  }, {
    key: "setAnchorsRef",
    value: /* @__PURE__ */ __name(function(c3) {
      this.anchors = c3;
    }, "setAnchorsRef")
  }, {
    key: "setSearchRef",
    value: /* @__PURE__ */ __name(function(c3) {
      this.search = c3;
    }, "setSearchRef")
  }, {
    key: "setPreviewRef",
    value: /* @__PURE__ */ __name(function(c3) {
      this.preview = c3;
    }, "setPreviewRef")
  }, {
    key: "setScrollRef",
    value: /* @__PURE__ */ __name(function(c3) {
      this.scroll = c3;
    }, "setScrollRef")
  }, {
    key: "setCategoryRef",
    value: /* @__PURE__ */ __name(function(name2, c3) {
      this.categoryRefs || (this.categoryRefs = {}), this.categoryRefs[name2] = c3;
    }, "setCategoryRef")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this4 = this, _this$props = this.props, perLine = _this$props.perLine, emojiSize = _this$props.emojiSize, set3 = _this$props.set, sheetSize = _this$props.sheetSize, sheetColumns = _this$props.sheetColumns, sheetRows = _this$props.sheetRows, style2 = _this$props.style, title = _this$props.title, emoji = _this$props.emoji, color2 = _this$props.color, _native = _this$props.native, backgroundImageFn2 = _this$props.backgroundImageFn, emojisToShowFilter = _this$props.emojisToShowFilter, showPreview = _this$props.showPreview, showSkinTones = _this$props.showSkinTones, emojiTooltip = _this$props.emojiTooltip, useButton = _this$props.useButton, include = _this$props.include, exclude = _this$props.exclude, recent2 = _this$props.recent, autoFocus = _this$props.autoFocus, skinEmoji = _this$props.skinEmoji, notFound2 = _this$props.notFound, notFoundEmoji = _this$props.notFoundEmoji, width2 = perLine * (emojiSize + 12) + 12 + 2 + measureScrollbar(), theme = this.getPreferredTheme(), skin = this.props.skin || this.state.skin || store.get("skin") || this.props.defaultSkin;
      return React__default.createElement("section", {
        style: _objectSpread$G({
          width: width2
        }, style2),
        className: "emoji-mart emoji-mart-".concat(theme),
        "aria-label": title,
        onKeyDown: this.handleKeyDown
      }, React__default.createElement("div", {
        className: "emoji-mart-bar"
      }, React__default.createElement(Anchors, {
        ref: this.setAnchorsRef,
        data: this.data,
        i18n: this.i18n,
        color: color2,
        categories: this.categories,
        onAnchorClick: this.handleAnchorClick,
        icons: this.icons
      })), React__default.createElement(Search, {
        ref: this.setSearchRef,
        onSearch: this.handleSearch,
        data: this.data,
        i18n: this.i18n,
        emojisToShowFilter,
        include,
        exclude,
        custom: this.CUSTOM,
        autoFocus
      }), React__default.createElement("div", {
        ref: this.setScrollRef,
        className: "emoji-mart-scroll",
        onScroll: this.handleScroll
      }, this.getCategories().map(function(category, i2) {
        return React__default.createElement(Category, {
          ref: _this4.setCategoryRef.bind(_this4, "category-".concat(i2)),
          key: category.name,
          id: category.id,
          name: category.name,
          emojis: category.emojis,
          perLine,
          native: _native,
          hasStickyPosition: _this4.hasStickyPosition,
          data: _this4.data,
          i18n: _this4.i18n,
          recent: category.id == _this4.RECENT_CATEGORY.id ? recent2 : void 0,
          custom: category.id == _this4.RECENT_CATEGORY.id ? _this4.CUSTOM : void 0,
          emojiProps: {
            native: _native,
            skin,
            size: emojiSize,
            set: set3,
            sheetSize,
            sheetColumns,
            sheetRows,
            forceSize: _native,
            tooltip: emojiTooltip,
            backgroundImageFn: backgroundImageFn2,
            useButton,
            onOver: _this4.handleEmojiOver,
            onLeave: _this4.handleEmojiLeave,
            onClick: _this4.handleEmojiClick
          },
          notFound: notFound2,
          notFoundEmoji
        });
      })), (showPreview || showSkinTones) && React__default.createElement("div", {
        className: "emoji-mart-bar"
      }, React__default.createElement(Preview, {
        ref: this.setPreviewRef,
        data: this.data,
        title,
        emoji,
        showSkinTones,
        showPreview,
        emojiProps: {
          native: _native,
          size: 38,
          skin,
          set: set3,
          sheetSize,
          sheetColumns,
          sheetRows,
          backgroundImageFn: backgroundImageFn2
        },
        skinsProps: {
          skin,
          onChange: this.handleSkinChange,
          skinEmoji
        },
        i18n: this.i18n
      })));
    }, "render")
  }]), NimblePicker2;
}(React__default.PureComponent);
NimblePicker.propTypes = _objectSpread$G({}, PickerPropTypes, {
  data: PropTypes.object.isRequired
});
NimblePicker.defaultProps = _objectSpread$G({}, PickerDefaultProps);
function ownKeys$F(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$F, "ownKeys$F");
function _objectSpread$F(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$F(Object(source), !0).forEach(function(key) {
      _defineProperty$I(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$F(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$F, "_objectSpread$F");
var Picker = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits$b(Picker2, _React$PureComponent);
  function Picker2() {
    return _classCallCheck$m(this, Picker2), _possibleConstructorReturn$b(this, _getPrototypeOf$b(Picker2).apply(this, arguments));
  }
  return __name(Picker2, "Picker"), _createClass$m(Picker2, [{
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      return React__default.createElement(NimblePicker, _extends$p({}, this.props, this.state));
    }, "render")
  }]), Picker2;
}(React__default.PureComponent);
Picker.propTypes = PickerPropTypes;
Picker.defaultProps = _objectSpread$F({}, PickerDefaultProps, {
  data
});
function ownKeys$E(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$E, "ownKeys$E");
function _objectSpread$E(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$E(Object(source), !0).forEach(function(key) {
      _defineProperty$I(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$E(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$E, "_objectSpread$E");
var Emoji$1 = /* @__PURE__ */ __name(function Emoji(props) {
  for (var k3 in Emoji.defaultProps)
    props[k3] == null && Emoji.defaultProps[k3] != null && (props[k3] = Emoji.defaultProps[k3]);
  return NimbleEmoji(_objectSpread$E({}, props));
}, "Emoji");
Emoji$1.propTypes = EmojiPropTypes;
Emoji$1.defaultProps = _objectSpread$E({}, EmojiDefaultProps, {
  data
});
const legacyEmojisJson = [
  {
    emoji: "🙂",
    category: "People",
    code: "smile",
    actual: "slightly_smiling_face"
  },
  {
    emoji: "🤓",
    category: "People",
    code: "nerd_face",
    actual: "nerd_face"
  },
  {
    emoji: "😎",
    category: "People",
    code: "sunglasses",
    actual: "sunglasses"
  },
  {
    emoji: "😍",
    category: "People",
    code: "heart_eyes",
    actual: "heart_eyes"
  },
  {
    emoji: "😡",
    category: "People",
    code: "rage",
    actual: "rage"
  },
  {
    emoji: "💩",
    category: "People",
    code: "hankey",
    actual: "hankey"
  },
  {
    emoji: "💪",
    category: "People",
    code: "muscle",
    actual: "muscle"
  },
  {
    emoji: "👋",
    category: "People",
    code: "wave",
    actual: "wave"
  },
  {
    emoji: "🤑",
    category: "People",
    code: "money_mouth_face",
    actual: "money_mouth_face"
  },
  {
    emoji: "🚲",
    category: "Places",
    code: "bike",
    actual: "bike"
  },
  {
    emoji: "🚜",
    category: "Places",
    code: "tractor",
    actual: "tractor"
  },
  {
    emoji: "🚖",
    category: "Places",
    code: "oncoming_taxi",
    actual: "oncoming_taxi"
  },
  {
    emoji: "🌈",
    category: "Nature",
    code: "rainbow",
    actual: "rainbow"
  },
  {
    emoji: "🚀",
    category: "Places",
    code: "rocket",
    actual: "rocket"
  },
  {
    emoji: "🐵",
    category: "Nature",
    code: "monkey_face",
    actual: "monkey_face"
  },
  {
    emoji: "🦄",
    category: "Nature",
    code: "unicorn",
    actual: "unicorn_face"
  },
  {
    emoji: "🐷",
    category: "Nature",
    code: "pig",
    actual: "pig"
  },
  {
    emoji: "🐸",
    category: "Nature",
    code: "frog",
    actual: "frog"
  },
  {
    emoji: "🐳",
    category: "Nature",
    code: "whale",
    actual: "whale"
  },
  {
    emoji: "🌵",
    category: "Nature",
    code: "cactus",
    actual: "cactus"
  },
  {
    emoji: "🍀",
    category: "Nature",
    code: "four_leaf_clover",
    actual: "four_leaf_clover"
  },
  {
    emoji: "⚡️",
    category: "Nature",
    code: "zap",
    actual: "zap"
  },
  {
    emoji: "🔥",
    category: "Nature",
    code: "fire",
    actual: "fire"
  },
  {
    emoji: "💥",
    category: "Nature",
    code: "boom",
    actual: "boom"
  },
  {
    emoji: "☀️",
    category: "Nature",
    code: "sunny",
    actual: "sunny"
  },
  {
    emoji: "🚑",
    category: "Places",
    code: "ambulance",
    actual: "ambulance"
  },
  {
    emoji: "❤️",
    category: "Symbols",
    code: "heart",
    actual: "heart"
  },
  {
    emoji: "💘",
    category: "Symbols",
    code: "cupid",
    actual: "cupid"
  },
  {
    emoji: "🎁",
    category: "Objects",
    code: "gift",
    actual: "gift"
  },
  {
    emoji: "🍾",
    category: "Foods",
    code: "champagne",
    actual: "champagne"
  },
  {
    emoji: "💯",
    category: "Symbols",
    code: "100",
    actual: "100"
  },
  {
    emoji: "⛔️",
    category: "Symbols",
    code: "no_entry",
    actual: "no_entry"
  },
  {
    emoji: "📫",
    category: "Objects",
    code: "mailbox",
    actual: "mailbox"
  },
  {
    emoji: "📈",
    category: "Objects",
    code: "chart_with_upwards_trend",
    actual: "chart_with_upwards_trend"
  },
  {
    emoji: "♻️",
    category: "Symbols",
    code: "recycle",
    actual: "recycle"
  },
  {
    emoji: "🔒",
    category: "Objects",
    code: "lock",
    actual: "lock"
  },
  {
    emoji: "☎️",
    category: "Objects",
    code: "phone",
    actual: "phone"
  },
  {
    emoji: "💸",
    category: "Objects",
    code: "money_with_wings",
    actual: "money_with_wings"
  },
  {
    emoji: "💳",
    category: "Objects",
    code: "credit_card",
    actual: "credit_card"
  },
  {
    emoji: "💣",
    category: "Objects",
    code: "bomb",
    actual: "bomb"
  },
  {
    emoji: "😇",
    category: "People",
    code: "innocent",
    actual: "innocent"
  },
  {
    emoji: "😀",
    category: "People",
    code: "grinning",
    actual: "grinning"
  },
  {
    emoji: "😱",
    category: "People",
    code: "scream",
    actual: "scream"
  },
  {
    emoji: "😜",
    category: "People",
    code: "stuck_out_tongue_winking_eye",
    actual: "stuck_out_tongue_winking_eye"
  },
  {
    emoji: "🌊",
    category: "Nature",
    code: "ocean",
    actual: "ocean"
  },
  {
    emoji: "🎉",
    category: "Objects",
    code: "tada",
    actual: "tada"
  },
  {
    emoji: "✨",
    category: "Activities",
    code: "sparkles",
    actual: "sparkles"
  },
  {
    emoji: "🇫🇷",
    category: "Flags",
    code: "fr",
    actual: "fr"
  },
  {
    emoji: "🇺🇸",
    category: "Flags",
    code: "us",
    actual: "us"
  },
  {
    emoji: "🇬🇧",
    category: "Flags",
    code: "gb",
    actual: "gb"
  },
  {
    emoji: "🇪🇸",
    category: "Flags",
    code: "es",
    actual: "es"
  },
  {
    emoji: "🇩🇪",
    category: "Flags",
    code: "de",
    actual: "de"
  },
  {
    emoji: "🇧🇷",
    category: "Flags",
    code: "brazil",
    actual: "flag-br"
  },
  {
    emoji: "🇨🇦",
    category: "Flags",
    code: "canada",
    actual: "flag-ca"
  },
  {
    emoji: "🇮🇹",
    category: "Flags",
    code: "italy",
    actual: "it"
  }
], legacyEmojis = legacyEmojisJson, getEmoji = /* @__PURE__ */ __name((id2) => {
  const legacyEmoji = legacyEmojis.find((emoji) => emoji.code === id2), correctId = (legacyEmoji == null ? void 0 : legacyEmoji.actual) || id2, foundEmojis = emojiIndex$1.search(correctId);
  if (!(foundEmojis != null && foundEmojis.length))
    return null;
  const foundEmoji = foundEmojis.find(
    (emoji) => emoji.colons === correctId || emoji.id === correctId
  );
  return foundEmoji || null;
}, "getEmoji");
function getDerivedEmoji(defaultValue, value) {
  return getEmoji(value || defaultValue || "") || emojiIndex$1.emojis.slightly_smiling_face;
}
__name(getDerivedEmoji, "getDerivedEmoji");
const _ClientException = class _ClientException extends Error {
  constructor(error, innerError) {
    super(error.message);
    __publicField(this, "trace");
    this.error = error, this.trace = innerError, Object.setPrototypeOf(this, _ClientException.prototype);
  }
};
__name(_ClientException, "ClientException");
let ClientException = _ClientException;
var camelcase$2 = { exports: {} };
const UPPERCASE$1 = /[\p{Lu}]/u, LOWERCASE$1 = /[\p{Ll}]/u, LEADING_CAPITAL$1 = /^[\p{Lu}](?![\p{Lu}])/gu, IDENTIFIER$1 = /([\p{Alpha}\p{N}_]|$)/u, SEPARATORS$1 = /[_.\- ]+/, LEADING_SEPARATORS$1 = new RegExp("^" + SEPARATORS$1.source), SEPARATORS_AND_IDENTIFIER$1 = new RegExp(SEPARATORS$1.source + IDENTIFIER$1.source, "gu"), NUMBERS_AND_IDENTIFIER$1 = new RegExp("\\d+" + IDENTIFIER$1.source, "gu"), preserveCamelCase$1 = /* @__PURE__ */ __name((string2, toLowerCase, toUpperCase) => {
  let isLastCharLower = !1, isLastCharUpper = !1, isLastLastCharUpper = !1;
  for (let i2 = 0; i2 < string2.length; i2++) {
    const character = string2[i2];
    isLastCharLower && UPPERCASE$1.test(character) ? (string2 = string2.slice(0, i2) + "-" + string2.slice(i2), isLastCharLower = !1, isLastLastCharUpper = isLastCharUpper, isLastCharUpper = !0, i2++) : isLastCharUpper && isLastLastCharUpper && LOWERCASE$1.test(character) ? (string2 = string2.slice(0, i2 - 1) + "-" + string2.slice(i2 - 1), isLastLastCharUpper = isLastCharUpper, isLastCharUpper = !1, isLastCharLower = !0) : (isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character, isLastLastCharUpper = isLastCharUpper, isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character);
  }
  return string2;
}, "preserveCamelCase$1"), preserveConsecutiveUppercase$1 = /* @__PURE__ */ __name((input, toLowerCase) => (LEADING_CAPITAL$1.lastIndex = 0, input.replace(LEADING_CAPITAL$1, (m1) => toLowerCase(m1))), "preserveConsecutiveUppercase$1"), postProcess$1 = /* @__PURE__ */ __name((input, toUpperCase) => (SEPARATORS_AND_IDENTIFIER$1.lastIndex = 0, NUMBERS_AND_IDENTIFIER$1.lastIndex = 0, input.replace(SEPARATORS_AND_IDENTIFIER$1, (_, identifier) => toUpperCase(identifier)).replace(NUMBERS_AND_IDENTIFIER$1, (m3) => toUpperCase(m3))), "postProcess$1"), camelCase$2 = /* @__PURE__ */ __name((input, options) => {
  if (!(typeof input == "string" || Array.isArray(input)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (options = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...options
  }, Array.isArray(input) ? input = input.map((x3) => x3.trim()).filter((x3) => x3.length).join("-") : input = input.trim(), input.length === 0)
    return "";
  const toLowerCase = options.locale === !1 ? (string2) => string2.toLowerCase() : (string2) => string2.toLocaleLowerCase(options.locale), toUpperCase = options.locale === !1 ? (string2) => string2.toUpperCase() : (string2) => string2.toLocaleUpperCase(options.locale);
  return input.length === 1 ? options.pascalCase ? toUpperCase(input) : toLowerCase(input) : (input !== toLowerCase(input) && (input = preserveCamelCase$1(input, toLowerCase, toUpperCase)), input = input.replace(LEADING_SEPARATORS$1, ""), options.preserveConsecutiveUppercase ? input = preserveConsecutiveUppercase$1(input, toLowerCase) : input = toLowerCase(input), options.pascalCase && (input = toUpperCase(input.charAt(0)) + input.slice(1)), postProcess$1(input, toUpperCase));
}, "camelCase$2");
camelcase$2.exports = camelCase$2;
camelcase$2.exports.default = camelCase$2;
var camelcaseExports = camelcase$2.exports;
const camelcase$1 = /* @__PURE__ */ getDefaultExportFromCjs(camelcaseExports);
var freeGlobal$3 = typeof global == "object" && global && global.Object === Object && global;
const freeGlobal$4 = freeGlobal$3;
var freeSelf$2 = typeof self == "object" && self && self.Object === Object && self, root$c = freeGlobal$4 || freeSelf$2 || Function("return this")();
const root$d = root$c;
var Symbol$8 = root$d.Symbol;
const Symbol$9 = Symbol$8;
var objectProto$s = Object.prototype, hasOwnProperty$o = objectProto$s.hasOwnProperty, nativeObjectToString$3 = objectProto$s.toString, symToStringTag$3 = Symbol$9 ? Symbol$9.toStringTag : void 0;
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$o.call(value, symToStringTag$3), tag = value[symToStringTag$3];
  try {
    value[symToStringTag$3] = void 0;
    var unmasked = !0;
  } catch {
  }
  var result2 = nativeObjectToString$3.call(value);
  return unmasked && (isOwn ? value[symToStringTag$3] = tag : delete value[symToStringTag$3]), result2;
}
__name(getRawTag$2, "getRawTag$2");
var objectProto$r = Object.prototype, nativeObjectToString$2 = objectProto$r.toString;
function objectToString$2(value) {
  return nativeObjectToString$2.call(value);
}
__name(objectToString$2, "objectToString$2");
var nullTag$1 = "[object Null]", undefinedTag$1 = "[object Undefined]", symToStringTag$2 = Symbol$9 ? Symbol$9.toStringTag : void 0;
function baseGetTag$a(value) {
  return value == null ? value === void 0 ? undefinedTag$1 : nullTag$1 : symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$2(value) : objectToString$2(value);
}
__name(baseGetTag$a, "baseGetTag$a");
function isObjectLike$a(value) {
  return value != null && typeof value == "object";
}
__name(isObjectLike$a, "isObjectLike$a");
var symbolTag$5 = "[object Symbol]";
function isSymbol$7(value) {
  return typeof value == "symbol" || isObjectLike$a(value) && baseGetTag$a(value) == symbolTag$5;
}
__name(isSymbol$7, "isSymbol$7");
function arrayMap$4(array2, iteratee) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length, result2 = Array(length); ++index2 < length; )
    result2[index2] = iteratee(array2[index2], index2, array2);
  return result2;
}
__name(arrayMap$4, "arrayMap$4");
var isArray$h = Array.isArray;
const isArray$i = isArray$h;
var INFINITY$6 = 1 / 0, symbolProto$4 = Symbol$9 ? Symbol$9.prototype : void 0, symbolToString$1 = symbolProto$4 ? symbolProto$4.toString : void 0;
function baseToString$2(value) {
  if (typeof value == "string")
    return value;
  if (isArray$i(value))
    return arrayMap$4(value, baseToString$2) + "";
  if (isSymbol$7(value))
    return symbolToString$1 ? symbolToString$1.call(value) : "";
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY$6 ? "-0" : result2;
}
__name(baseToString$2, "baseToString$2");
var reWhitespace$1 = /\s/;
function trimmedEndIndex$2(string2) {
  for (var index2 = string2.length; index2-- && reWhitespace$1.test(string2.charAt(index2)); )
    ;
  return index2;
}
__name(trimmedEndIndex$2, "trimmedEndIndex$2");
var reTrimStart$1 = /^\s+/;
function baseTrim$2(string2) {
  return string2 && string2.slice(0, trimmedEndIndex$2(string2) + 1).replace(reTrimStart$1, "");
}
__name(baseTrim$2, "baseTrim$2");
function isObject$f(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
__name(isObject$f, "isObject$f");
var NAN$1 = 0 / 0, reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i, reIsBinary$1 = /^0b[01]+$/i, reIsOctal$1 = /^0o[0-7]+$/i, freeParseInt$1 = parseInt;
function toNumber$3(value) {
  if (typeof value == "number")
    return value;
  if (isSymbol$7(value))
    return NAN$1;
  if (isObject$f(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$f(other) ? other + "" : other;
  }
  if (typeof value != "string")
    return value === 0 ? value : +value;
  value = baseTrim$2(value);
  var isBinary = reIsBinary$1.test(value);
  return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}
__name(toNumber$3, "toNumber$3");
function identity$c(value) {
  return value;
}
__name(identity$c, "identity$c");
var asyncTag$1 = "[object AsyncFunction]", funcTag$4 = "[object Function]", genTag$2 = "[object GeneratorFunction]", proxyTag$1 = "[object Proxy]";
function isFunction$4(value) {
  if (!isObject$f(value))
    return !1;
  var tag = baseGetTag$a(value);
  return tag == funcTag$4 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
}
__name(isFunction$4, "isFunction$4");
var coreJsData$2 = root$d["__core-js_shared__"];
const coreJsData$3 = coreJsData$2;
var maskSrcKey$1 = function() {
  var uid = /[^.]+$/.exec(coreJsData$3 && coreJsData$3.keys && coreJsData$3.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$2(func2) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func2;
}
__name(isMasked$2, "isMasked$2");
var funcProto$5 = Function.prototype, funcToString$5 = funcProto$5.toString;
function toSource$3(func2) {
  if (func2 != null) {
    try {
      return funcToString$5.call(func2);
    } catch {
    }
    try {
      return func2 + "";
    } catch {
    }
  }
  return "";
}
__name(toSource$3, "toSource$3");
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor$1 = /^\[object .+?Constructor\]$/, funcProto$4 = Function.prototype, objectProto$q = Object.prototype, funcToString$4 = funcProto$4.toString, hasOwnProperty$n = objectProto$q.hasOwnProperty, reIsNative$1 = RegExp(
  "^" + funcToString$4.call(hasOwnProperty$n).replace(reRegExpChar$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$2(value) {
  if (!isObject$f(value) || isMasked$2(value))
    return !1;
  var pattern = isFunction$4(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$3(value));
}
__name(baseIsNative$2, "baseIsNative$2");
function getValue$2(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
__name(getValue$2, "getValue$2");
function getNative$8(object2, key) {
  var value = getValue$2(object2, key);
  return baseIsNative$2(value) ? value : void 0;
}
__name(getNative$8, "getNative$8");
var WeakMap$3 = getNative$8(root$d, "WeakMap");
const WeakMap$4 = WeakMap$3;
var objectCreate = Object.create, baseCreate = function() {
  function object2() {
  }
  return __name(object2, "object"), function(proto) {
    if (!isObject$f(proto))
      return {};
    if (objectCreate)
      return objectCreate(proto);
    object2.prototype = proto;
    var result2 = new object2();
    return object2.prototype = void 0, result2;
  };
}();
const baseCreate$1 = baseCreate;
function apply$2(func2, thisArg, args) {
  switch (args.length) {
    case 0:
      return func2.call(thisArg);
    case 1:
      return func2.call(thisArg, args[0]);
    case 2:
      return func2.call(thisArg, args[0], args[1]);
    case 3:
      return func2.call(thisArg, args[0], args[1], args[2]);
  }
  return func2.apply(thisArg, args);
}
__name(apply$2, "apply$2");
function noop$5() {
}
__name(noop$5, "noop$5");
function copyArray(source, array2) {
  var index2 = -1, length = source.length;
  for (array2 || (array2 = Array(length)); ++index2 < length; )
    array2[index2] = source[index2];
  return array2;
}
__name(copyArray, "copyArray");
var HOT_COUNT$1 = 800, HOT_SPAN$1 = 16, nativeNow$1 = Date.now;
function shortOut$2(func2) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow$1(), remaining = HOT_SPAN$1 - (stamp - lastCalled);
    if (lastCalled = stamp, remaining > 0) {
      if (++count >= HOT_COUNT$1)
        return arguments[0];
    } else
      count = 0;
    return func2.apply(void 0, arguments);
  };
}
__name(shortOut$2, "shortOut$2");
function constant$4(value) {
  return function() {
    return value;
  };
}
__name(constant$4, "constant$4");
var defineProperty$4 = function() {
  try {
    var func2 = getNative$8(Object, "defineProperty");
    return func2({}, "", {}), func2;
  } catch {
  }
}();
const defineProperty$5 = defineProperty$4;
var baseSetToString$2 = defineProperty$5 ? function(func2, string2) {
  return defineProperty$5(func2, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant$4(string2),
    writable: !0
  });
} : identity$c;
const baseSetToString$3 = baseSetToString$2;
var setToString$2 = shortOut$2(baseSetToString$3);
const setToString$3 = setToString$2;
function arrayEach(array2, iteratee) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length; ++index2 < length && iteratee(array2[index2], index2, array2) !== !1; )
    ;
  return array2;
}
__name(arrayEach, "arrayEach");
function baseFindIndex$2(array2, predicate, fromIndex, fromRight) {
  for (var length = array2.length, index2 = fromIndex + (fromRight ? 1 : -1); fromRight ? index2-- : ++index2 < length; )
    if (predicate(array2[index2], index2, array2))
      return index2;
  return -1;
}
__name(baseFindIndex$2, "baseFindIndex$2");
function baseIsNaN$2(value) {
  return value !== value;
}
__name(baseIsNaN$2, "baseIsNaN$2");
function strictIndexOf$2(array2, value, fromIndex) {
  for (var index2 = fromIndex - 1, length = array2.length; ++index2 < length; )
    if (array2[index2] === value)
      return index2;
  return -1;
}
__name(strictIndexOf$2, "strictIndexOf$2");
function baseIndexOf$2(array2, value, fromIndex) {
  return value === value ? strictIndexOf$2(array2, value, fromIndex) : baseFindIndex$2(array2, baseIsNaN$2, fromIndex);
}
__name(baseIndexOf$2, "baseIndexOf$2");
function arrayIncludes$2(array2, value) {
  var length = array2 == null ? 0 : array2.length;
  return !!length && baseIndexOf$2(array2, value, 0) > -1;
}
__name(arrayIncludes$2, "arrayIncludes$2");
var MAX_SAFE_INTEGER$4 = 9007199254740991, reIsUint$1 = /^(?:0|[1-9]\d*)$/;
function isIndex$4(value, length) {
  var type = typeof value;
  return length = length ?? MAX_SAFE_INTEGER$4, !!length && (type == "number" || type != "symbol" && reIsUint$1.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
__name(isIndex$4, "isIndex$4");
function baseAssignValue$2(object2, key, value) {
  key == "__proto__" && defineProperty$5 ? defineProperty$5(object2, key, {
    configurable: !0,
    enumerable: !0,
    value,
    writable: !0
  }) : object2[key] = value;
}
__name(baseAssignValue$2, "baseAssignValue$2");
function eq$4(value, other) {
  return value === other || value !== value && other !== other;
}
__name(eq$4, "eq$4");
var objectProto$p = Object.prototype, hasOwnProperty$m = objectProto$p.hasOwnProperty;
function assignValue(object2, key, value) {
  var objValue = object2[key];
  (!(hasOwnProperty$m.call(object2, key) && eq$4(objValue, value)) || value === void 0 && !(key in object2)) && baseAssignValue$2(object2, key, value);
}
__name(assignValue, "assignValue");
function copyObject(source, props, object2, customizer) {
  var isNew = !object2;
  object2 || (object2 = {});
  for (var index2 = -1, length = props.length; ++index2 < length; ) {
    var key = props[index2], newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : void 0;
    newValue === void 0 && (newValue = source[key]), isNew ? baseAssignValue$2(object2, key, newValue) : assignValue(object2, key, newValue);
  }
  return object2;
}
__name(copyObject, "copyObject");
var nativeMax$4 = Math.max;
function overRest$2(func2, start, transform2) {
  return start = nativeMax$4(start === void 0 ? func2.length - 1 : start, 0), function() {
    for (var args = arguments, index2 = -1, length = nativeMax$4(args.length - start, 0), array2 = Array(length); ++index2 < length; )
      array2[index2] = args[start + index2];
    index2 = -1;
    for (var otherArgs = Array(start + 1); ++index2 < start; )
      otherArgs[index2] = args[index2];
    return otherArgs[start] = transform2(array2), apply$2(func2, this, otherArgs);
  };
}
__name(overRest$2, "overRest$2");
function baseRest$2(func2, start) {
  return setToString$3(overRest$2(func2, start, identity$c), func2 + "");
}
__name(baseRest$2, "baseRest$2");
var MAX_SAFE_INTEGER$3 = 9007199254740991;
function isLength$4(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
}
__name(isLength$4, "isLength$4");
function isArrayLike$5(value) {
  return value != null && isLength$4(value.length) && !isFunction$4(value);
}
__name(isArrayLike$5, "isArrayLike$5");
var objectProto$o = Object.prototype;
function isPrototype$2(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$o;
  return value === proto;
}
__name(isPrototype$2, "isPrototype$2");
function baseTimes$2(n, iteratee) {
  for (var index2 = -1, result2 = Array(n); ++index2 < n; )
    result2[index2] = iteratee(index2);
  return result2;
}
__name(baseTimes$2, "baseTimes$2");
var argsTag$6 = "[object Arguments]";
function baseIsArguments$2(value) {
  return isObjectLike$a(value) && baseGetTag$a(value) == argsTag$6;
}
__name(baseIsArguments$2, "baseIsArguments$2");
var objectProto$n = Object.prototype, hasOwnProperty$l = objectProto$n.hasOwnProperty, propertyIsEnumerable$3 = objectProto$n.propertyIsEnumerable, isArguments$4 = baseIsArguments$2(function() {
  return arguments;
}()) ? baseIsArguments$2 : function(value) {
  return isObjectLike$a(value) && hasOwnProperty$l.call(value, "callee") && !propertyIsEnumerable$3.call(value, "callee");
};
const isArguments$5 = isArguments$4;
function stubFalse$1() {
  return !1;
}
__name(stubFalse$1, "stubFalse$1");
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$1 = moduleExports$2 ? root$d.Buffer : void 0, nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0, isBuffer$3 = nativeIsBuffer || stubFalse$1;
const isBuffer$4 = isBuffer$3;
var argsTag$5 = "[object Arguments]", arrayTag$4 = "[object Array]", boolTag$6 = "[object Boolean]", dateTag$5 = "[object Date]", errorTag$4 = "[object Error]", funcTag$3 = "[object Function]", mapTag$8 = "[object Map]", numberTag$6 = "[object Number]", objectTag$8 = "[object Object]", regexpTag$5 = "[object RegExp]", setTag$8 = "[object Set]", stringTag$6 = "[object String]", weakMapTag$4 = "[object WeakMap]", arrayBufferTag$5 = "[object ArrayBuffer]", dataViewTag$7 = "[object DataView]", float32Tag$3 = "[object Float32Array]", float64Tag$3 = "[object Float64Array]", int8Tag$3 = "[object Int8Array]", int16Tag$3 = "[object Int16Array]", int32Tag$3 = "[object Int32Array]", uint8Tag$3 = "[object Uint8Array]", uint8ClampedTag$3 = "[object Uint8ClampedArray]", uint16Tag$3 = "[object Uint16Array]", uint32Tag$3 = "[object Uint32Array]", typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] = typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] = typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] = typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] = typedArrayTags$1[uint32Tag$3] = !0;
typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$4] = typedArrayTags$1[arrayBufferTag$5] = typedArrayTags$1[boolTag$6] = typedArrayTags$1[dataViewTag$7] = typedArrayTags$1[dateTag$5] = typedArrayTags$1[errorTag$4] = typedArrayTags$1[funcTag$3] = typedArrayTags$1[mapTag$8] = typedArrayTags$1[numberTag$6] = typedArrayTags$1[objectTag$8] = typedArrayTags$1[regexpTag$5] = typedArrayTags$1[setTag$8] = typedArrayTags$1[stringTag$6] = typedArrayTags$1[weakMapTag$4] = !1;
function baseIsTypedArray$2(value) {
  return isObjectLike$a(value) && isLength$4(value.length) && !!typedArrayTags$1[baseGetTag$a(value)];
}
__name(baseIsTypedArray$2, "baseIsTypedArray$2");
function baseUnary$3(func2) {
  return function(value) {
    return func2(value);
  };
}
__name(baseUnary$3, "baseUnary$3");
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, freeProcess = moduleExports$1 && freeGlobal$4.process, nodeUtil$1 = function() {
  try {
    var types2 = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    return types2 || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch {
  }
}();
const nodeUtil$2 = nodeUtil$1;
var nodeIsTypedArray$1 = nodeUtil$2 && nodeUtil$2.isTypedArray, isTypedArray$4 = nodeIsTypedArray$1 ? baseUnary$3(nodeIsTypedArray$1) : baseIsTypedArray$2;
const isTypedArray$5 = isTypedArray$4;
var objectProto$m = Object.prototype, hasOwnProperty$k = objectProto$m.hasOwnProperty;
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$i(value), isArg = !isArr && isArguments$5(value), isBuff = !isArr && !isArg && isBuffer$4(value), isType = !isArr && !isArg && !isBuff && isTypedArray$5(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes$2(value.length, String) : [], length = result2.length;
  for (var key in value)
    (inherited || hasOwnProperty$k.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$4(key, length))) && result2.push(key);
  return result2;
}
__name(arrayLikeKeys$2, "arrayLikeKeys$2");
function overArg$3(func2, transform2) {
  return function(arg) {
    return func2(transform2(arg));
  };
}
__name(overArg$3, "overArg$3");
var nativeKeys$2 = overArg$3(Object.keys, Object);
const nativeKeys$3 = nativeKeys$2;
var objectProto$l = Object.prototype, hasOwnProperty$j = objectProto$l.hasOwnProperty;
function baseKeys$2(object2) {
  if (!isPrototype$2(object2))
    return nativeKeys$3(object2);
  var result2 = [];
  for (var key in Object(object2))
    hasOwnProperty$j.call(object2, key) && key != "constructor" && result2.push(key);
  return result2;
}
__name(baseKeys$2, "baseKeys$2");
function keys$6(object2) {
  return isArrayLike$5(object2) ? arrayLikeKeys$2(object2) : baseKeys$2(object2);
}
__name(keys$6, "keys$6");
function nativeKeysIn(object2) {
  var result2 = [];
  if (object2 != null)
    for (var key in Object(object2))
      result2.push(key);
  return result2;
}
__name(nativeKeysIn, "nativeKeysIn");
var objectProto$k = Object.prototype, hasOwnProperty$i = objectProto$k.hasOwnProperty;
function baseKeysIn(object2) {
  if (!isObject$f(object2))
    return nativeKeysIn(object2);
  var isProto = isPrototype$2(object2), result2 = [];
  for (var key in object2)
    key == "constructor" && (isProto || !hasOwnProperty$i.call(object2, key)) || result2.push(key);
  return result2;
}
__name(baseKeysIn, "baseKeysIn");
function keysIn(object2) {
  return isArrayLike$5(object2) ? arrayLikeKeys$2(object2, !0) : baseKeysIn(object2);
}
__name(keysIn, "keysIn");
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp$1 = /^\w*$/;
function isKey$4(value, object2) {
  if (isArray$i(value))
    return !1;
  var type = typeof value;
  return type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$7(value) ? !0 : reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) || object2 != null && value in Object(object2);
}
__name(isKey$4, "isKey$4");
var nativeCreate$5 = getNative$8(Object, "create");
const nativeCreate$6 = nativeCreate$5;
function hashClear$2() {
  this.__data__ = nativeCreate$6 ? nativeCreate$6(null) : {}, this.size = 0;
}
__name(hashClear$2, "hashClear$2");
function hashDelete$2(key) {
  var result2 = this.has(key) && delete this.__data__[key];
  return this.size -= result2 ? 1 : 0, result2;
}
__name(hashDelete$2, "hashDelete$2");
var HASH_UNDEFINED$5 = "__lodash_hash_undefined__", objectProto$j = Object.prototype, hasOwnProperty$h = objectProto$j.hasOwnProperty;
function hashGet$2(key) {
  var data2 = this.__data__;
  if (nativeCreate$6) {
    var result2 = data2[key];
    return result2 === HASH_UNDEFINED$5 ? void 0 : result2;
  }
  return hasOwnProperty$h.call(data2, key) ? data2[key] : void 0;
}
__name(hashGet$2, "hashGet$2");
var objectProto$i = Object.prototype, hasOwnProperty$g = objectProto$i.hasOwnProperty;
function hashHas$2(key) {
  var data2 = this.__data__;
  return nativeCreate$6 ? data2[key] !== void 0 : hasOwnProperty$g.call(data2, key);
}
__name(hashHas$2, "hashHas$2");
var HASH_UNDEFINED$4 = "__lodash_hash_undefined__";
function hashSet$2(key, value) {
  var data2 = this.__data__;
  return this.size += this.has(key) ? 0 : 1, data2[key] = nativeCreate$6 && value === void 0 ? HASH_UNDEFINED$4 : value, this;
}
__name(hashSet$2, "hashSet$2");
function Hash$2(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index2 < length; ) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
__name(Hash$2, "Hash$2");
Hash$2.prototype.clear = hashClear$2;
Hash$2.prototype.delete = hashDelete$2;
Hash$2.prototype.get = hashGet$2;
Hash$2.prototype.has = hashHas$2;
Hash$2.prototype.set = hashSet$2;
function listCacheClear$2() {
  this.__data__ = [], this.size = 0;
}
__name(listCacheClear$2, "listCacheClear$2");
function assocIndexOf$5(array2, key) {
  for (var length = array2.length; length--; )
    if (eq$4(array2[length][0], key))
      return length;
  return -1;
}
__name(assocIndexOf$5, "assocIndexOf$5");
var arrayProto$1 = Array.prototype, splice$2 = arrayProto$1.splice;
function listCacheDelete$2(key) {
  var data2 = this.__data__, index2 = assocIndexOf$5(data2, key);
  if (index2 < 0)
    return !1;
  var lastIndex = data2.length - 1;
  return index2 == lastIndex ? data2.pop() : splice$2.call(data2, index2, 1), --this.size, !0;
}
__name(listCacheDelete$2, "listCacheDelete$2");
function listCacheGet$2(key) {
  var data2 = this.__data__, index2 = assocIndexOf$5(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
__name(listCacheGet$2, "listCacheGet$2");
function listCacheHas$2(key) {
  return assocIndexOf$5(this.__data__, key) > -1;
}
__name(listCacheHas$2, "listCacheHas$2");
function listCacheSet$2(key, value) {
  var data2 = this.__data__, index2 = assocIndexOf$5(data2, key);
  return index2 < 0 ? (++this.size, data2.push([key, value])) : data2[index2][1] = value, this;
}
__name(listCacheSet$2, "listCacheSet$2");
function ListCache$5(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index2 < length; ) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
__name(ListCache$5, "ListCache$5");
ListCache$5.prototype.clear = listCacheClear$2;
ListCache$5.prototype.delete = listCacheDelete$2;
ListCache$5.prototype.get = listCacheGet$2;
ListCache$5.prototype.has = listCacheHas$2;
ListCache$5.prototype.set = listCacheSet$2;
var Map$5 = getNative$8(root$d, "Map");
const Map$6 = Map$5;
function mapCacheClear$2() {
  this.size = 0, this.__data__ = {
    hash: new Hash$2(),
    map: new (Map$6 || ListCache$5)(),
    string: new Hash$2()
  };
}
__name(mapCacheClear$2, "mapCacheClear$2");
function isKeyable$2(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
__name(isKeyable$2, "isKeyable$2");
function getMapData$5(map2, key) {
  var data2 = map2.__data__;
  return isKeyable$2(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
__name(getMapData$5, "getMapData$5");
function mapCacheDelete$2(key) {
  var result2 = getMapData$5(this, key).delete(key);
  return this.size -= result2 ? 1 : 0, result2;
}
__name(mapCacheDelete$2, "mapCacheDelete$2");
function mapCacheGet$2(key) {
  return getMapData$5(this, key).get(key);
}
__name(mapCacheGet$2, "mapCacheGet$2");
function mapCacheHas$2(key) {
  return getMapData$5(this, key).has(key);
}
__name(mapCacheHas$2, "mapCacheHas$2");
function mapCacheSet$2(key, value) {
  var data2 = getMapData$5(this, key), size = data2.size;
  return data2.set(key, value), this.size += data2.size == size ? 0 : 1, this;
}
__name(mapCacheSet$2, "mapCacheSet$2");
function MapCache$4(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index2 < length; ) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
__name(MapCache$4, "MapCache$4");
MapCache$4.prototype.clear = mapCacheClear$2;
MapCache$4.prototype.delete = mapCacheDelete$2;
MapCache$4.prototype.get = mapCacheGet$2;
MapCache$4.prototype.has = mapCacheHas$2;
MapCache$4.prototype.set = mapCacheSet$2;
var FUNC_ERROR_TEXT$4 = "Expected a function";
function memoize$4(func2, resolver2) {
  if (typeof func2 != "function" || resolver2 != null && typeof resolver2 != "function")
    throw new TypeError(FUNC_ERROR_TEXT$4);
  var memoized = /* @__PURE__ */ __name(function() {
    var args = arguments, key = resolver2 ? resolver2.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key))
      return cache2.get(key);
    var result2 = func2.apply(this, args);
    return memoized.cache = cache2.set(key, result2) || cache2, result2;
  }, "memoized");
  return memoized.cache = new (memoize$4.Cache || MapCache$4)(), memoized;
}
__name(memoize$4, "memoize$4");
memoize$4.Cache = MapCache$4;
var MAX_MEMOIZE_SIZE$1 = 500;
function memoizeCapped$2(func2) {
  var result2 = memoize$4(func2, function(key) {
    return cache2.size === MAX_MEMOIZE_SIZE$1 && cache2.clear(), key;
  }), cache2 = result2.cache;
  return result2;
}
__name(memoizeCapped$2, "memoizeCapped$2");
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar$1 = /\\(\\)?/g, stringToPath$2 = memoizeCapped$2(function(string2) {
  var result2 = [];
  return string2.charCodeAt(0) === 46 && result2.push(""), string2.replace(rePropName$1, function(match2, number2, quote, subString) {
    result2.push(quote ? subString.replace(reEscapeChar$1, "$1") : number2 || match2);
  }), result2;
});
const stringToPath$3 = stringToPath$2;
function toString$6(value) {
  return value == null ? "" : baseToString$2(value);
}
__name(toString$6, "toString$6");
function castPath$3(value, object2) {
  return isArray$i(value) ? value : isKey$4(value, object2) ? [value] : stringToPath$3(toString$6(value));
}
__name(castPath$3, "castPath$3");
var INFINITY$5 = 1 / 0;
function toKey$5(value) {
  if (typeof value == "string" || isSymbol$7(value))
    return value;
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY$5 ? "-0" : result2;
}
__name(toKey$5, "toKey$5");
function baseGet$4(object2, path) {
  path = castPath$3(path, object2);
  for (var index2 = 0, length = path.length; object2 != null && index2 < length; )
    object2 = object2[toKey$5(path[index2++])];
  return index2 && index2 == length ? object2 : void 0;
}
__name(baseGet$4, "baseGet$4");
function get$3(object2, path, defaultValue) {
  var result2 = object2 == null ? void 0 : baseGet$4(object2, path);
  return result2 === void 0 ? defaultValue : result2;
}
__name(get$3, "get$3");
function arrayPush$3(array2, values) {
  for (var index2 = -1, length = values.length, offset = array2.length; ++index2 < length; )
    array2[offset + index2] = values[index2];
  return array2;
}
__name(arrayPush$3, "arrayPush$3");
var spreadableSymbol$1 = Symbol$9 ? Symbol$9.isConcatSpreadable : void 0;
function isFlattenable$2(value) {
  return isArray$i(value) || isArguments$5(value) || !!(spreadableSymbol$1 && value && value[spreadableSymbol$1]);
}
__name(isFlattenable$2, "isFlattenable$2");
function baseFlatten$3(array2, depth, predicate, isStrict, result2) {
  var index2 = -1, length = array2.length;
  for (predicate || (predicate = isFlattenable$2), result2 || (result2 = []); ++index2 < length; ) {
    var value = array2[index2];
    depth > 0 && predicate(value) ? depth > 1 ? baseFlatten$3(value, depth - 1, predicate, isStrict, result2) : arrayPush$3(result2, value) : isStrict || (result2[result2.length] = value);
  }
  return result2;
}
__name(baseFlatten$3, "baseFlatten$3");
function flatten$1(array2) {
  var length = array2 == null ? 0 : array2.length;
  return length ? baseFlatten$3(array2, 1) : [];
}
__name(flatten$1, "flatten$1");
function flatRest(func2) {
  return setToString$3(overRest$2(func2, void 0, flatten$1), func2 + "");
}
__name(flatRest, "flatRest");
var getPrototype$2 = overArg$3(Object.getPrototypeOf, Object);
const getPrototype$3 = getPrototype$2;
var objectTag$7 = "[object Object]", funcProto$3 = Function.prototype, objectProto$h = Object.prototype, funcToString$3 = funcProto$3.toString, hasOwnProperty$f = objectProto$h.hasOwnProperty, objectCtorString$1 = funcToString$3.call(Object);
function isPlainObject$4(value) {
  if (!isObjectLike$a(value) || baseGetTag$a(value) != objectTag$7)
    return !1;
  var proto = getPrototype$3(value);
  if (proto === null)
    return !0;
  var Ctor = hasOwnProperty$f.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$3.call(Ctor) == objectCtorString$1;
}
__name(isPlainObject$4, "isPlainObject$4");
function baseSlice$2(array2, start, end) {
  var index2 = -1, length = array2.length;
  start < 0 && (start = -start > length ? 0 : length + start), end = end > length ? length : end, end < 0 && (end += length), length = start > end ? 0 : end - start >>> 0, start >>>= 0;
  for (var result2 = Array(length); ++index2 < length; )
    result2[index2] = array2[index2 + start];
  return result2;
}
__name(baseSlice$2, "baseSlice$2");
function stackClear$2() {
  this.__data__ = new ListCache$5(), this.size = 0;
}
__name(stackClear$2, "stackClear$2");
function stackDelete$2(key) {
  var data2 = this.__data__, result2 = data2.delete(key);
  return this.size = data2.size, result2;
}
__name(stackDelete$2, "stackDelete$2");
function stackGet$2(key) {
  return this.__data__.get(key);
}
__name(stackGet$2, "stackGet$2");
function stackHas$2(key) {
  return this.__data__.has(key);
}
__name(stackHas$2, "stackHas$2");
var LARGE_ARRAY_SIZE$3 = 200;
function stackSet$2(key, value) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache$5) {
    var pairs = data2.__data__;
    if (!Map$6 || pairs.length < LARGE_ARRAY_SIZE$3 - 1)
      return pairs.push([key, value]), this.size = ++data2.size, this;
    data2 = this.__data__ = new MapCache$4(pairs);
  }
  return data2.set(key, value), this.size = data2.size, this;
}
__name(stackSet$2, "stackSet$2");
function Stack$3(entries) {
  var data2 = this.__data__ = new ListCache$5(entries);
  this.size = data2.size;
}
__name(Stack$3, "Stack$3");
Stack$3.prototype.clear = stackClear$2;
Stack$3.prototype.delete = stackDelete$2;
Stack$3.prototype.get = stackGet$2;
Stack$3.prototype.has = stackHas$2;
Stack$3.prototype.set = stackSet$2;
function baseAssign(object2, source) {
  return object2 && copyObject(source, keys$6(source), object2);
}
__name(baseAssign, "baseAssign");
function baseAssignIn(object2, source) {
  return object2 && copyObject(source, keysIn(source), object2);
}
__name(baseAssignIn, "baseAssignIn");
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer2 = moduleExports ? root$d.Buffer : void 0, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
function cloneBuffer(buffer, isDeep) {
  if (isDeep)
    return buffer.slice();
  var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  return buffer.copy(result2), result2;
}
__name(cloneBuffer, "cloneBuffer");
function arrayFilter$2(array2, predicate) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result2 = []; ++index2 < length; ) {
    var value = array2[index2];
    predicate(value, index2, array2) && (result2[resIndex++] = value);
  }
  return result2;
}
__name(arrayFilter$2, "arrayFilter$2");
function stubArray$2() {
  return [];
}
__name(stubArray$2, "stubArray$2");
var objectProto$g = Object.prototype, propertyIsEnumerable$2 = objectProto$g.propertyIsEnumerable, nativeGetSymbols$2 = Object.getOwnPropertySymbols, getSymbols$2 = nativeGetSymbols$2 ? function(object2) {
  return object2 == null ? [] : (object2 = Object(object2), arrayFilter$2(nativeGetSymbols$2(object2), function(symbol) {
    return propertyIsEnumerable$2.call(object2, symbol);
  }));
} : stubArray$2;
const getSymbols$3 = getSymbols$2;
function copySymbols(source, object2) {
  return copyObject(source, getSymbols$3(source), object2);
}
__name(copySymbols, "copySymbols");
var nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbolsIn = nativeGetSymbols$1 ? function(object2) {
  for (var result2 = []; object2; )
    arrayPush$3(result2, getSymbols$3(object2)), object2 = getPrototype$3(object2);
  return result2;
} : stubArray$2;
const getSymbolsIn$1 = getSymbolsIn;
function copySymbolsIn(source, object2) {
  return copyObject(source, getSymbolsIn$1(source), object2);
}
__name(copySymbolsIn, "copySymbolsIn");
function baseGetAllKeys$2(object2, keysFunc, symbolsFunc) {
  var result2 = keysFunc(object2);
  return isArray$i(object2) ? result2 : arrayPush$3(result2, symbolsFunc(object2));
}
__name(baseGetAllKeys$2, "baseGetAllKeys$2");
function getAllKeys$2(object2) {
  return baseGetAllKeys$2(object2, keys$6, getSymbols$3);
}
__name(getAllKeys$2, "getAllKeys$2");
function getAllKeysIn(object2) {
  return baseGetAllKeys$2(object2, keysIn, getSymbolsIn$1);
}
__name(getAllKeysIn, "getAllKeysIn");
var DataView$3 = getNative$8(root$d, "DataView");
const DataView$4 = DataView$3;
var Promise$3 = getNative$8(root$d, "Promise");
const Promise$4 = Promise$3;
var Set$4 = getNative$8(root$d, "Set");
const Set$5 = Set$4;
var mapTag$7 = "[object Map]", objectTag$6 = "[object Object]", promiseTag$1 = "[object Promise]", setTag$7 = "[object Set]", weakMapTag$3 = "[object WeakMap]", dataViewTag$6 = "[object DataView]", dataViewCtorString$1 = toSource$3(DataView$4), mapCtorString$1 = toSource$3(Map$6), promiseCtorString$1 = toSource$3(Promise$4), setCtorString$1 = toSource$3(Set$5), weakMapCtorString$1 = toSource$3(WeakMap$4), getTag$3 = baseGetTag$a;
(DataView$4 && getTag$3(new DataView$4(new ArrayBuffer(1))) != dataViewTag$6 || Map$6 && getTag$3(new Map$6()) != mapTag$7 || Promise$4 && getTag$3(Promise$4.resolve()) != promiseTag$1 || Set$5 && getTag$3(new Set$5()) != setTag$7 || WeakMap$4 && getTag$3(new WeakMap$4()) != weakMapTag$3) && (getTag$3 = /* @__PURE__ */ __name(function(value) {
  var result2 = baseGetTag$a(value), Ctor = result2 == objectTag$6 ? value.constructor : void 0, ctorString = Ctor ? toSource$3(Ctor) : "";
  if (ctorString)
    switch (ctorString) {
      case dataViewCtorString$1:
        return dataViewTag$6;
      case mapCtorString$1:
        return mapTag$7;
      case promiseCtorString$1:
        return promiseTag$1;
      case setCtorString$1:
        return setTag$7;
      case weakMapCtorString$1:
        return weakMapTag$3;
    }
  return result2;
}, "getTag$3"));
const getTag$4 = getTag$3;
var objectProto$f = Object.prototype, hasOwnProperty$e = objectProto$f.hasOwnProperty;
function initCloneArray(array2) {
  var length = array2.length, result2 = new array2.constructor(length);
  return length && typeof array2[0] == "string" && hasOwnProperty$e.call(array2, "index") && (result2.index = array2.index, result2.input = array2.input), result2;
}
__name(initCloneArray, "initCloneArray");
var Uint8Array$3 = root$d.Uint8Array;
const Uint8Array$4 = Uint8Array$3;
function cloneArrayBuffer(arrayBuffer) {
  var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
  return new Uint8Array$4(result2).set(new Uint8Array$4(arrayBuffer)), result2;
}
__name(cloneArrayBuffer, "cloneArrayBuffer");
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
__name(cloneDataView, "cloneDataView");
var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  return result2.lastIndex = regexp.lastIndex, result2;
}
__name(cloneRegExp, "cloneRegExp");
var symbolProto$3 = Symbol$9 ? Symbol$9.prototype : void 0, symbolValueOf$2 = symbolProto$3 ? symbolProto$3.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf$2 ? Object(symbolValueOf$2.call(symbol)) : {};
}
__name(cloneSymbol, "cloneSymbol");
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
__name(cloneTypedArray, "cloneTypedArray");
var boolTag$5 = "[object Boolean]", dateTag$4 = "[object Date]", mapTag$6 = "[object Map]", numberTag$5 = "[object Number]", regexpTag$4 = "[object RegExp]", setTag$6 = "[object Set]", stringTag$5 = "[object String]", symbolTag$4 = "[object Symbol]", arrayBufferTag$4 = "[object ArrayBuffer]", dataViewTag$5 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
function initCloneByTag(object2, tag, isDeep) {
  var Ctor = object2.constructor;
  switch (tag) {
    case arrayBufferTag$4:
      return cloneArrayBuffer(object2);
    case boolTag$5:
    case dateTag$4:
      return new Ctor(+object2);
    case dataViewTag$5:
      return cloneDataView(object2, isDeep);
    case float32Tag$2:
    case float64Tag$2:
    case int8Tag$2:
    case int16Tag$2:
    case int32Tag$2:
    case uint8Tag$2:
    case uint8ClampedTag$2:
    case uint16Tag$2:
    case uint32Tag$2:
      return cloneTypedArray(object2, isDeep);
    case mapTag$6:
      return new Ctor();
    case numberTag$5:
    case stringTag$5:
      return new Ctor(object2);
    case regexpTag$4:
      return cloneRegExp(object2);
    case setTag$6:
      return new Ctor();
    case symbolTag$4:
      return cloneSymbol(object2);
  }
}
__name(initCloneByTag, "initCloneByTag");
function initCloneObject(object2) {
  return typeof object2.constructor == "function" && !isPrototype$2(object2) ? baseCreate$1(getPrototype$3(object2)) : {};
}
__name(initCloneObject, "initCloneObject");
var mapTag$5 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike$a(value) && getTag$4(value) == mapTag$5;
}
__name(baseIsMap, "baseIsMap");
var nodeIsMap = nodeUtil$2 && nodeUtil$2.isMap, isMap = nodeIsMap ? baseUnary$3(nodeIsMap) : baseIsMap;
const isMap$1 = isMap;
var setTag$5 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike$a(value) && getTag$4(value) == setTag$5;
}
__name(baseIsSet, "baseIsSet");
var nodeIsSet = nodeUtil$2 && nodeUtil$2.isSet, isSet = nodeIsSet ? baseUnary$3(nodeIsSet) : baseIsSet;
const isSet$1 = isSet;
var CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$2 = 4, argsTag$4 = "[object Arguments]", arrayTag$3 = "[object Array]", boolTag$4 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$3 = "[object Error]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", mapTag$4 = "[object Map]", numberTag$4 = "[object Number]", objectTag$5 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$4 = "[object Set]", stringTag$4 = "[object String]", symbolTag$3 = "[object Symbol]", weakMapTag$2 = "[object WeakMap]", arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag$4] = cloneableTags[arrayTag$3] = cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] = cloneableTags[boolTag$4] = cloneableTags[dateTag$3] = cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] = cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] = cloneableTags[int32Tag$1] = cloneableTags[mapTag$4] = cloneableTags[numberTag$4] = cloneableTags[objectTag$5] = cloneableTags[regexpTag$3] = cloneableTags[setTag$4] = cloneableTags[stringTag$4] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] = cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = !0;
cloneableTags[errorTag$3] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = !1;
function baseClone(value, bitmask, customizer, key, object2, stack) {
  var result2, isDeep = bitmask & CLONE_DEEP_FLAG$2, isFlat = bitmask & CLONE_FLAT_FLAG$1, isFull = bitmask & CLONE_SYMBOLS_FLAG$2;
  if (customizer && (result2 = object2 ? customizer(value, key, object2, stack) : customizer(value)), result2 !== void 0)
    return result2;
  if (!isObject$f(value))
    return value;
  var isArr = isArray$i(value);
  if (isArr) {
    if (result2 = initCloneArray(value), !isDeep)
      return copyArray(value, result2);
  } else {
    var tag = getTag$4(value), isFunc = tag == funcTag$2 || tag == genTag$1;
    if (isBuffer$4(value))
      return cloneBuffer(value, isDeep);
    if (tag == objectTag$5 || tag == argsTag$4 || isFunc && !object2) {
      if (result2 = isFlat || isFunc ? {} : initCloneObject(value), !isDeep)
        return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
    } else {
      if (!cloneableTags[tag])
        return object2 ? value : {};
      result2 = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack$3());
  var stacked = stack.get(value);
  if (stacked)
    return stacked;
  stack.set(value, result2), isSet$1(value) ? value.forEach(function(subValue) {
    result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
  }) : isMap$1(value) && value.forEach(function(subValue, key2) {
    result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
  });
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys$2 : isFlat ? keysIn : keys$6, props = isArr ? void 0 : keysFunc(value);
  return arrayEach(props || value, function(subValue, key2) {
    props && (key2 = subValue, subValue = value[key2]), assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
  }), result2;
}
__name(baseClone, "baseClone");
var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}
__name(cloneDeep, "cloneDeep");
var HASH_UNDEFINED$3 = "__lodash_hash_undefined__";
function setCacheAdd$2(value) {
  return this.__data__.set(value, HASH_UNDEFINED$3), this;
}
__name(setCacheAdd$2, "setCacheAdd$2");
function setCacheHas$2(value) {
  return this.__data__.has(value);
}
__name(setCacheHas$2, "setCacheHas$2");
function SetCache$3(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  for (this.__data__ = new MapCache$4(); ++index2 < length; )
    this.add(values[index2]);
}
__name(SetCache$3, "SetCache$3");
SetCache$3.prototype.add = SetCache$3.prototype.push = setCacheAdd$2;
SetCache$3.prototype.has = setCacheHas$2;
function arraySome$3(array2, predicate) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length; ++index2 < length; )
    if (predicate(array2[index2], index2, array2))
      return !0;
  return !1;
}
__name(arraySome$3, "arraySome$3");
function cacheHas$3(cache2, key) {
  return cache2.has(key);
}
__name(cacheHas$3, "cacheHas$3");
var COMPARE_PARTIAL_FLAG$b = 1, COMPARE_UNORDERED_FLAG$7 = 2;
function equalArrays$3(array2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$b, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength))
    return !1;
  var arrStacked = stack.get(array2), othStacked = stack.get(other);
  if (arrStacked && othStacked)
    return arrStacked == other && othStacked == array2;
  var index2 = -1, result2 = !0, seen = bitmask & COMPARE_UNORDERED_FLAG$7 ? new SetCache$3() : void 0;
  for (stack.set(array2, other), stack.set(other, array2); ++index2 < arrLength; ) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer)
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
    if (compared !== void 0) {
      if (compared)
        continue;
      result2 = !1;
      break;
    }
    if (seen) {
      if (!arraySome$3(other, function(othValue2, othIndex) {
        if (!cacheHas$3(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack)))
          return seen.push(othIndex);
      })) {
        result2 = !1;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result2 = !1;
      break;
    }
  }
  return stack.delete(array2), stack.delete(other), result2;
}
__name(equalArrays$3, "equalArrays$3");
function mapToArray$2(map2) {
  var index2 = -1, result2 = Array(map2.size);
  return map2.forEach(function(value, key) {
    result2[++index2] = [key, value];
  }), result2;
}
__name(mapToArray$2, "mapToArray$2");
function setToArray$4(set3) {
  var index2 = -1, result2 = Array(set3.size);
  return set3.forEach(function(value) {
    result2[++index2] = value;
  }), result2;
}
__name(setToArray$4, "setToArray$4");
var COMPARE_PARTIAL_FLAG$a = 1, COMPARE_UNORDERED_FLAG$6 = 2, boolTag$3 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$2 = "[object Error]", mapTag$3 = "[object Map]", numberTag$3 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$3 = "[object String]", symbolTag$2 = "[object Symbol]", arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]", symbolProto$2 = Symbol$9 ? Symbol$9.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function equalByTag$2(object2, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$3:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset)
        return !1;
      object2 = object2.buffer, other = other.buffer;
    case arrayBufferTag$2:
      return !(object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$4(object2), new Uint8Array$4(other)));
    case boolTag$3:
    case dateTag$2:
    case numberTag$3:
      return eq$4(+object2, +other);
    case errorTag$2:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag$2:
    case stringTag$3:
      return object2 == other + "";
    case mapTag$3:
      var convert2 = mapToArray$2;
    case setTag$3:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$a;
      if (convert2 || (convert2 = setToArray$4), object2.size != other.size && !isPartial)
        return !1;
      var stacked = stack.get(object2);
      if (stacked)
        return stacked == other;
      bitmask |= COMPARE_UNORDERED_FLAG$6, stack.set(object2, other);
      var result2 = equalArrays$3(convert2(object2), convert2(other), bitmask, customizer, equalFunc, stack);
      return stack.delete(object2), result2;
    case symbolTag$2:
      if (symbolValueOf$1)
        return symbolValueOf$1.call(object2) == symbolValueOf$1.call(other);
  }
  return !1;
}
__name(equalByTag$2, "equalByTag$2");
var COMPARE_PARTIAL_FLAG$9 = 1, objectProto$e = Object.prototype, hasOwnProperty$d = objectProto$e.hasOwnProperty;
function equalObjects$2(object2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$9, objProps = getAllKeys$2(object2), objLength = objProps.length, othProps = getAllKeys$2(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial)
    return !1;
  for (var index2 = objLength; index2--; ) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$d.call(other, key)))
      return !1;
  }
  var objStacked = stack.get(object2), othStacked = stack.get(other);
  if (objStacked && othStacked)
    return objStacked == other && othStacked == object2;
  var result2 = !0;
  stack.set(object2, other), stack.set(other, object2);
  for (var skipCtor = isPartial; ++index2 < objLength; ) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer)
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result2 = !1;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result2 && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    objCtor != othCtor && "constructor" in object2 && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor) && (result2 = !1);
  }
  return stack.delete(object2), stack.delete(other), result2;
}
__name(equalObjects$2, "equalObjects$2");
var COMPARE_PARTIAL_FLAG$8 = 1, argsTag$3 = "[object Arguments]", arrayTag$2 = "[object Array]", objectTag$4 = "[object Object]", objectProto$d = Object.prototype, hasOwnProperty$c = objectProto$d.hasOwnProperty;
function baseIsEqualDeep$2(object2, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$i(object2), othIsArr = isArray$i(other), objTag = objIsArr ? arrayTag$2 : getTag$4(object2), othTag = othIsArr ? arrayTag$2 : getTag$4(other);
  objTag = objTag == argsTag$3 ? objectTag$4 : objTag, othTag = othTag == argsTag$3 ? objectTag$4 : othTag;
  var objIsObj = objTag == objectTag$4, othIsObj = othTag == objectTag$4, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$4(object2)) {
    if (!isBuffer$4(other))
      return !1;
    objIsArr = !0, objIsObj = !1;
  }
  if (isSameTag && !objIsObj)
    return stack || (stack = new Stack$3()), objIsArr || isTypedArray$5(object2) ? equalArrays$3(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag$2(object2, other, objTag, bitmask, customizer, equalFunc, stack);
  if (!(bitmask & COMPARE_PARTIAL_FLAG$8)) {
    var objIsWrapped = objIsObj && hasOwnProperty$c.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$c.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      return stack || (stack = new Stack$3()), equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  return isSameTag ? (stack || (stack = new Stack$3()), equalObjects$2(object2, other, bitmask, customizer, equalFunc, stack)) : !1;
}
__name(baseIsEqualDeep$2, "baseIsEqualDeep$2");
function baseIsEqual$4(value, other, bitmask, customizer, stack) {
  return value === other ? !0 : value == null || other == null || !isObjectLike$a(value) && !isObjectLike$a(other) ? value !== value && other !== other : baseIsEqualDeep$2(value, other, bitmask, customizer, baseIsEqual$4, stack);
}
__name(baseIsEqual$4, "baseIsEqual$4");
var COMPARE_PARTIAL_FLAG$7 = 1, COMPARE_UNORDERED_FLAG$5 = 2;
function baseIsMatch$2(object2, source, matchData, customizer) {
  var index2 = matchData.length, length = index2, noCustomizer = !customizer;
  if (object2 == null)
    return !length;
  for (object2 = Object(object2); index2--; ) {
    var data2 = matchData[index2];
    if (noCustomizer && data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2))
      return !1;
  }
  for (; ++index2 < length; ) {
    data2 = matchData[index2];
    var key = data2[0], objValue = object2[key], srcValue = data2[1];
    if (noCustomizer && data2[2]) {
      if (objValue === void 0 && !(key in object2))
        return !1;
    } else {
      var stack = new Stack$3();
      if (customizer)
        var result2 = customizer(objValue, srcValue, key, object2, source, stack);
      if (!(result2 === void 0 ? baseIsEqual$4(srcValue, objValue, COMPARE_PARTIAL_FLAG$7 | COMPARE_UNORDERED_FLAG$5, customizer, stack) : result2))
        return !1;
    }
  }
  return !0;
}
__name(baseIsMatch$2, "baseIsMatch$2");
function isStrictComparable$3(value) {
  return value === value && !isObject$f(value);
}
__name(isStrictComparable$3, "isStrictComparable$3");
function getMatchData$2(object2) {
  for (var result2 = keys$6(object2), length = result2.length; length--; ) {
    var key = result2[length], value = object2[key];
    result2[length] = [key, value, isStrictComparable$3(value)];
  }
  return result2;
}
__name(getMatchData$2, "getMatchData$2");
function matchesStrictComparable$3(key, srcValue) {
  return function(object2) {
    return object2 == null ? !1 : object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
__name(matchesStrictComparable$3, "matchesStrictComparable$3");
function baseMatches$2(source) {
  var matchData = getMatchData$2(source);
  return matchData.length == 1 && matchData[0][2] ? matchesStrictComparable$3(matchData[0][0], matchData[0][1]) : function(object2) {
    return object2 === source || baseIsMatch$2(object2, source, matchData);
  };
}
__name(baseMatches$2, "baseMatches$2");
function baseHasIn$2(object2, key) {
  return object2 != null && key in Object(object2);
}
__name(baseHasIn$2, "baseHasIn$2");
function hasPath$2(object2, path, hasFunc) {
  path = castPath$3(path, object2);
  for (var index2 = -1, length = path.length, result2 = !1; ++index2 < length; ) {
    var key = toKey$5(path[index2]);
    if (!(result2 = object2 != null && hasFunc(object2, key)))
      break;
    object2 = object2[key];
  }
  return result2 || ++index2 != length ? result2 : (length = object2 == null ? 0 : object2.length, !!length && isLength$4(length) && isIndex$4(key, length) && (isArray$i(object2) || isArguments$5(object2)));
}
__name(hasPath$2, "hasPath$2");
function hasIn$2(object2, path) {
  return object2 != null && hasPath$2(object2, path, baseHasIn$2);
}
__name(hasIn$2, "hasIn$2");
var COMPARE_PARTIAL_FLAG$6 = 1, COMPARE_UNORDERED_FLAG$4 = 2;
function baseMatchesProperty$2(path, srcValue) {
  return isKey$4(path) && isStrictComparable$3(srcValue) ? matchesStrictComparable$3(toKey$5(path), srcValue) : function(object2) {
    var objValue = get$3(object2, path);
    return objValue === void 0 && objValue === srcValue ? hasIn$2(object2, path) : baseIsEqual$4(srcValue, objValue, COMPARE_PARTIAL_FLAG$6 | COMPARE_UNORDERED_FLAG$4);
  };
}
__name(baseMatchesProperty$2, "baseMatchesProperty$2");
function baseProperty$2(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
__name(baseProperty$2, "baseProperty$2");
function basePropertyDeep$2(path) {
  return function(object2) {
    return baseGet$4(object2, path);
  };
}
__name(basePropertyDeep$2, "basePropertyDeep$2");
function property$2(path) {
  return isKey$4(path) ? baseProperty$2(toKey$5(path)) : basePropertyDeep$2(path);
}
__name(property$2, "property$2");
function baseIteratee$9(value) {
  return typeof value == "function" ? value : value == null ? identity$c : typeof value == "object" ? isArray$i(value) ? baseMatchesProperty$2(value[0], value[1]) : baseMatches$2(value) : property$2(value);
}
__name(baseIteratee$9, "baseIteratee$9");
var now$2 = /* @__PURE__ */ __name(function() {
  return root$d.Date.now();
}, "now$2");
const now$3 = now$2;
var FUNC_ERROR_TEXT$3 = "Expected a function", nativeMax$3 = Math.max, nativeMin$1 = Math.min;
function debounce$2(func2, wait, options) {
  var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = !1, maxing = !1, trailing = !0;
  if (typeof func2 != "function")
    throw new TypeError(FUNC_ERROR_TEXT$3);
  wait = toNumber$3(wait) || 0, isObject$f(options) && (leading = !!options.leading, maxing = "maxWait" in options, maxWait = maxing ? nativeMax$3(toNumber$3(options.maxWait) || 0, wait) : maxWait, trailing = "trailing" in options ? !!options.trailing : trailing);
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    return lastArgs = lastThis = void 0, lastInvokeTime = time2, result2 = func2.apply(thisArg, args), result2;
  }
  __name(invokeFunc, "invokeFunc");
  function leadingEdge(time2) {
    return lastInvokeTime = time2, timerId = setTimeout(timerExpired, wait), leading ? invokeFunc(time2) : result2;
  }
  __name(leadingEdge, "leadingEdge");
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin$1(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  __name(remainingWait, "remainingWait");
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  __name(shouldInvoke, "shouldInvoke");
  function timerExpired() {
    var time2 = now$3();
    if (shouldInvoke(time2))
      return trailingEdge(time2);
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  __name(timerExpired, "timerExpired");
  function trailingEdge(time2) {
    return timerId = void 0, trailing && lastArgs ? invokeFunc(time2) : (lastArgs = lastThis = void 0, result2);
  }
  __name(trailingEdge, "trailingEdge");
  function cancel() {
    timerId !== void 0 && clearTimeout(timerId), lastInvokeTime = 0, lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  __name(cancel, "cancel");
  function flush() {
    return timerId === void 0 ? result2 : trailingEdge(now$3());
  }
  __name(flush, "flush");
  function debounced() {
    var time2 = now$3(), isInvoking = shouldInvoke(time2);
    if (lastArgs = arguments, lastThis = this, lastCallTime = time2, isInvoking) {
      if (timerId === void 0)
        return leadingEdge(lastCallTime);
      if (maxing)
        return clearTimeout(timerId), timerId = setTimeout(timerExpired, wait), invokeFunc(lastCallTime);
    }
    return timerId === void 0 && (timerId = setTimeout(timerExpired, wait)), result2;
  }
  return __name(debounced, "debounced"), debounced.cancel = cancel, debounced.flush = flush, debounced;
}
__name(debounce$2, "debounce$2");
function isArrayLikeObject(value) {
  return isObjectLike$a(value) && isArrayLike$5(value);
}
__name(isArrayLikeObject, "isArrayLikeObject");
function arrayIncludesWith$2(array2, value, comparator2) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length; ++index2 < length; )
    if (comparator2(value, array2[index2]))
      return !0;
  return !1;
}
__name(arrayIncludesWith$2, "arrayIncludesWith$2");
function last$2(array2) {
  var length = array2 == null ? 0 : array2.length;
  return length ? array2[length - 1] : void 0;
}
__name(last$2, "last$2");
function parent(object2, path) {
  return path.length < 2 ? object2 : baseGet$4(object2, baseSlice$2(path, 0, -1));
}
__name(parent, "parent");
function baseUnset(object2, path) {
  return path = castPath$3(path, object2), object2 = parent(object2, path), object2 == null || delete object2[toKey$5(last$2(path))];
}
__name(baseUnset, "baseUnset");
function customOmitClone(value) {
  return isPlainObject$4(value) ? void 0 : value;
}
__name(customOmitClone, "customOmitClone");
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4, omit = flatRest(function(object2, paths) {
  var result2 = {};
  if (object2 == null)
    return result2;
  var isDeep = !1;
  paths = arrayMap$4(paths, function(path) {
    return path = castPath$3(path, object2), isDeep || (isDeep = path.length > 1), path;
  }), copyObject(object2, getAllKeysIn(object2), result2), isDeep && (result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone));
  for (var length = paths.length; length--; )
    baseUnset(result2, paths[length]);
  return result2;
});
const omit$1 = omit;
var INFINITY$4 = 1 / 0, createSet$2 = Set$5 && 1 / setToArray$4(new Set$5([, -0]))[1] == INFINITY$4 ? function(values) {
  return new Set$5(values);
} : noop$5;
const createSet$3 = createSet$2;
var LARGE_ARRAY_SIZE$2 = 200;
function baseUniq$2(array2, iteratee, comparator2) {
  var index2 = -1, includes = arrayIncludes$2, length = array2.length, isCommon = !0, result2 = [], seen = result2;
  if (comparator2)
    isCommon = !1, includes = arrayIncludesWith$2;
  else if (length >= LARGE_ARRAY_SIZE$2) {
    var set3 = iteratee ? null : createSet$3(array2);
    if (set3)
      return setToArray$4(set3);
    isCommon = !1, includes = cacheHas$3, seen = new SetCache$3();
  } else
    seen = iteratee ? [] : result2;
  outer:
    for (; ++index2 < length; ) {
      var value = array2[index2], computed = iteratee ? iteratee(value) : value;
      if (value = comparator2 || value !== 0 ? value : 0, isCommon && computed === computed) {
        for (var seenIndex = seen.length; seenIndex--; )
          if (seen[seenIndex] === computed)
            continue outer;
        iteratee && seen.push(computed), result2.push(value);
      } else
        includes(seen, computed, comparator2) || (seen !== result2 && seen.push(computed), result2.push(value));
    }
  return result2;
}
__name(baseUniq$2, "baseUniq$2");
var unionBy = baseRest$2(function(arrays) {
  var iteratee = last$2(arrays);
  return isArrayLikeObject(iteratee) && (iteratee = void 0), baseUniq$2(baseFlatten$3(arrays, 1, isArrayLikeObject, !0), baseIteratee$9(iteratee));
});
const unionBy$1 = unionBy, typedMemo = memo$1, isAnyFieldDifferent = /* @__PURE__ */ __name((first, second2, fields) => fields.some((item) => first[item] !== second2[item]), "isAnyFieldDifferent");
function getKeysWithDifferentValues(first, second2) {
  return [.../* @__PURE__ */ new Set([...Object.keys(first), ...Object.keys(second2)])].filter((item) => first[item] !== second2[item]);
}
__name(getKeysWithDifferentValues, "getKeysWithDifferentValues");
function getKeysWithSameValues(first, second2) {
  return [.../* @__PURE__ */ new Set([...Object.keys(first), ...Object.keys(second2)])].filter((item) => first[item] === second2[item]);
}
__name(getKeysWithSameValues, "getKeysWithSameValues");
const sortAscending = /* @__PURE__ */ __name((a4, b2) => a4 < b2 ? -1 : a4 > b2 ? 1 : 0, "sortAscending"), sortAscendingBy = /* @__PURE__ */ __name((pickValueFrom) => (a4, b2) => sortAscending(
  pickValueFrom(a4).toLowerCase(),
  pickValueFrom(b2).toLowerCase()
), "sortAscendingBy"), isObject$e = /* @__PURE__ */ __name((o) => o instanceof Object && o.constructor === Object, "isObject$e"), generateEmptyArray = /* @__PURE__ */ __name((numberOfElements) => Array(numberOfElements).fill(void 0), "generateEmptyArray"), removeFieldsFromObjectRecursively = /* @__PURE__ */ __name((object2, fieldNames) => {
  const result2 = cloneDeep(object2), removeFields = /* @__PURE__ */ __name((obj2) => (isObject$e(obj2) && Object.keys(obj2).forEach((key) => {
    if (fieldNames.includes(key))
      delete obj2[key];
    else {
      const value = obj2[key];
      Array.isArray(value) ? value.forEach(removeFields) : removeFields(value);
    }
  }), obj2), "removeFields");
  return removeFields(result2), result2;
}, "removeFieldsFromObjectRecursively"), delay$1 = /* @__PURE__ */ __name((time2) => new Promise((resolve) => {
  setTimeout(() => {
    resolve();
  }, time2);
}), "delay$1");
function generateUniqId() {
  return Math.random().toString(16).slice(2);
}
__name(generateUniqId, "generateUniqId");
function generateRandomUUID() {
  return crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    (char) => {
      const r2 = Math.random() * 16 | 0;
      return (char === "x" ? r2 : r2 & 3 | 8).toString(16);
    }
  );
}
__name(generateRandomUUID, "generateRandomUUID");
var ERROR_TYPES = /* @__PURE__ */ ((ERROR_TYPES2) => (ERROR_TYPES2.UNKNOWN = "UNKNOWN", ERROR_TYPES2.NOT_FOUND = "NOT_FOUND", ERROR_TYPES2.INVALID_DATA = "INVALID_DATA", ERROR_TYPES2.VALIDATION = "VALIDATION", ERROR_TYPES2.NETWORK = "NETWORK", ERROR_TYPES2.UNAUTHORIZED = "UNAUTHORIZED", ERROR_TYPES2.TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", ERROR_TYPES2.GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT", ERROR_TYPES2))(ERROR_TYPES || {});
const isNetworkError = /* @__PURE__ */ __name((error) => isApolloError(error) && error.networkError ? !error.networkError.statusCode : !1, "isNetworkError"), hasErrorCode = /* @__PURE__ */ __name((codes) => (error) => error.networkError && "statusCode" in error.networkError ? codes.includes(error.networkError.statusCode) : !1, "hasErrorCode"), isGraphQLError = /* @__PURE__ */ __name((error) => isApolloError(error) && !!error.graphQLErrors.length, "isGraphQLError"), graphqlErrorHasErrorMessage = /* @__PURE__ */ __name((message) => (error) => isGraphQLError(error) ? error.graphQLErrors[0].message ? error.graphQLErrors[0].message.includes(message) : error.graphQLErrors.includes(message) : !1, "graphqlErrorHasErrorMessage"), formatValidationValue = /* @__PURE__ */ __name((value) => Array.isArray(value) && value.length ? value[0] : typeof value == "string" ? value : isObject$e(value) ? Object.values(value)[0] : "", "formatValidationValue"), getValidationErrors = /* @__PURE__ */ __name((validationErrors) => {
  if (!validationErrors)
    return null;
  let objectToBeFormatted = validationErrors;
  return validationErrors.errors ? objectToBeFormatted = validationErrors.errors : typeof validationErrors.error == "string" ? objectToBeFormatted = validationErrors : validationErrors.error && (objectToBeFormatted = validationErrors.error), Object.keys(objectToBeFormatted).reduce((acc, key) => {
    const value = objectToBeFormatted[key];
    return { ...acc, [camelcase$1(key)]: formatValidationValue(value) };
  }, {});
}, "getValidationErrors"), getErrorKey = /* @__PURE__ */ __name((errorMessage) => {
  const errorKey = FRONTEND_VALIDATION_ERRORS_MAPPER_OF_DESCRIPTIVE_ERROR_TO_KEY_NAME[errorMessage];
  return errorKey || null;
}, "getErrorKey");
function getErrorTranslation(error) {
  return BACKEND_VALIDATION_ERRORS_TRANSLATION_KEYS[error] || null;
}
__name(getErrorTranslation, "getErrorTranslation");
const getValidationErrorsTranslations = /* @__PURE__ */ __name((errors, options) => !errors || !Object.keys(errors).length ? null : Object.entries(errors).reduce((acc, [key, value]) => {
  var _a3, _b, _c;
  if (((_a3 = options == null ? void 0 : options.keyMapper) == null ? void 0 : _a3[key]) === "")
    return acc;
  const newKey = ((_b = options == null ? void 0 : options.keyMapper) == null ? void 0 : _b[key]) || key, newValue = getErrorTranslation(value) || ((_c = options == null ? void 0 : options.valueMapper) == null ? void 0 : _c[newKey]) || value;
  return {
    ...acc,
    [newKey]: newValue
  };
}, {}), "getValidationErrorsTranslations"), handleApolloError = /* @__PURE__ */ __name((error) => {
  var _a3;
  if (isGraphQLError(error)) {
    const graphQlErrors = error.graphQLErrors;
    if (graphqlErrorHasErrorMessage(GRAPHQL_ERROR_NON_EXISTENT_RESOURCE)(error))
      return {
        type: ERROR_TYPES.NOT_FOUND,
        message: GRAPHQL_ERROR_NON_EXISTENT_RESOURCE,
        errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.UNKNOWN_ERROR,
        graphQlErrors
      };
    if (graphqlErrorHasErrorMessage(GRAPHQL_ERROR_INTERNAL_API_NOT_FOUND)(error))
      return {
        type: ERROR_TYPES.NOT_FOUND,
        message: GRAPHQL_ERROR_INTERNAL_API_NOT_FOUND,
        graphQlErrors,
        errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.UNKNOWN_ERROR
      };
    if (graphqlErrorHasErrorMessage(GRAPHQL_ERROR_INVALID_DATA)(error))
      return {
        type: ERROR_TYPES.INVALID_DATA,
        message: GRAPHQL_ERROR_INVALID_DATA,
        graphQlErrors,
        errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.INVALID_DATA_ERROR
      };
    if (graphQlErrors[0].status === 404)
      return {
        type: ERROR_TYPES.NOT_FOUND,
        message: GRAPHQL_ERROR_INTERNAL_API_NOT_FOUND,
        graphQlErrors,
        errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.UNKNOWN_ERROR
      };
    const message = (_a3 = graphQlErrors[0]) == null ? void 0 : _a3.message;
    if (message) {
      const validationErrors = getErrorKey(message) ? getValidationErrors(
        graphQlErrors.reduce((acc, item) => {
          const key = getErrorKey(item.message);
          return key ? {
            ...acc,
            [key]: item.message
          } : acc;
        }, {})
      ) : null, validationErrorsI18nKeys = getValidationErrorsTranslations(validationErrors), errorI18nKey = validationErrorsI18nKeys ? Object.values(validationErrorsI18nKeys)[0] : getErrorTranslation(message) || BACKEND_ERRORS_TRANSLATION_KEYS.UNKNOWN_ERROR;
      return {
        type: ERROR_TYPES.VALIDATION,
        validationErrors,
        message,
        errorI18nKey,
        validationErrorsI18nKeys,
        graphQlErrors
      };
    }
    return {
      type: ERROR_TYPES.UNKNOWN,
      message: error.message,
      graphQlErrors,
      errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.UNKNOWN_ERROR
    };
  }
  if (isNetworkError(error))
    return {
      type: ERROR_TYPES.NETWORK,
      message: error.message,
      errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.NETWORK_ERROR
    };
  if (hasErrorCode(GATEWAY_TIMEOUT_ERROR_CODES)(error))
    return {
      type: ERROR_TYPES.GATEWAY_TIMEOUT,
      message: error.message,
      errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.GATEWAY_TIMEOUT_ERROR
    };
  if (hasErrorCode(AUTHORIZATION_ERROR_CODES)(error))
    return {
      type: ERROR_TYPES.UNAUTHORIZED,
      message: error.message,
      errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.UNKNOWN_ERROR
    };
  if (hasErrorCode(NOT_FOUND_ERROR_CODES)(error))
    return {
      type: ERROR_TYPES.NOT_FOUND,
      message: error.message,
      errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.UNKNOWN_ERROR
    };
  if (hasErrorCode(LIMITATION_ERROR_CODES)(error))
    return {
      type: ERROR_TYPES.TOO_MANY_REQUESTS,
      message: error.message,
      errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.TOO_MANY_REQUESTS
    };
  if (hasErrorCode(VALIDATION_ERROR_CODES)(error)) {
    const serverError = error.networkError, validationErrors = getValidationErrors(serverError.result), validationErrorsI18nKeys = getValidationErrorsTranslations(validationErrors);
    return {
      type: ERROR_TYPES.VALIDATION,
      message: error.message,
      validationErrors,
      errorI18nKey: validationErrorsI18nKeys ? Object.values(validationErrorsI18nKeys)[0] : BACKEND_ERRORS_TRANSLATION_KEYS.UNKNOWN_ERROR,
      validationErrorsI18nKeys
    };
  }
  return {
    type: ERROR_TYPES.UNKNOWN,
    message: error.message,
    errorI18nKey: BACKEND_ERRORS_TRANSLATION_KEYS.UNKNOWN_ERROR
  };
}, "handleApolloError"), _HttpError = class _HttpError extends Error {
  constructor(response, body) {
    super(response.statusText), this.response = response, this.body = body, Object.setPrototypeOf(this, _HttpError.prototype);
  }
};
__name(_HttpError, "HttpError");
let HttpError = _HttpError;
const _AtomicError = class _AtomicError extends Error {
  constructor(message, extraInfo) {
    super(message);
    __publicField(this, "name");
    __publicField(this, "extraInfo");
    this.extraInfo = extraInfo, this.name = new.target.name, Object.setPrototypeOf(this, new.target.prototype), Error.captureStackTrace && Error.captureStackTrace(this, new.target);
  }
  setMessage(message) {
    this.message = message;
  }
  setExtraInfo(info) {
    this.extraInfo = info;
  }
};
__name(_AtomicError, "AtomicError");
let AtomicError = _AtomicError;
const ERROR_TYPES_DEFAULT_MESSAGES = {
  [ERROR_TYPES.UNKNOWN]: "An unknown error occurred",
  [ERROR_TYPES.NOT_FOUND]: "The requested resource was not found",
  [ERROR_TYPES.INVALID_DATA]: "The provided data is invalid",
  [ERROR_TYPES.VALIDATION]: "Validation error occurred",
  [ERROR_TYPES.NETWORK]: "A network error occurred",
  [ERROR_TYPES.UNAUTHORIZED]: "You are not authorized to perform this action",
  [ERROR_TYPES.TOO_MANY_REQUESTS]: "Too many requests. Please try again later",
  [ERROR_TYPES.GATEWAY_TIMEOUT]: "Request timed out. Please try again"
}, _NotFoundError = class _NotFoundError extends AtomicError {
};
__name(_NotFoundError, "NotFoundError");
let NotFoundError = _NotFoundError;
const _InvalidError = class _InvalidError extends AtomicError {
};
__name(_InvalidError, "InvalidError");
let InvalidError = _InvalidError;
const _ValidationError = class _ValidationError extends AtomicError {
};
__name(_ValidationError, "ValidationError");
let ValidationError = _ValidationError;
const _NetworkError = class _NetworkError extends AtomicError {
};
__name(_NetworkError, "NetworkError");
let NetworkError = _NetworkError;
const _UnauthorizedError = class _UnauthorizedError extends AtomicError {
};
__name(_UnauthorizedError, "UnauthorizedError");
let UnauthorizedError = _UnauthorizedError;
const _TooManyRequestsError = class _TooManyRequestsError extends AtomicError {
};
__name(_TooManyRequestsError, "TooManyRequestsError");
let TooManyRequestsError = _TooManyRequestsError;
const _GatewayTimeoutError = class _GatewayTimeoutError extends AtomicError {
};
__name(_GatewayTimeoutError, "GatewayTimeoutError");
let GatewayTimeoutError = _GatewayTimeoutError;
const _UnknownError = class _UnknownError extends AtomicError {
};
__name(_UnknownError, "UnknownError");
let UnknownError = _UnknownError;
const MAX_PICTURE_SIZE = 4e6, validatePictureFormat = /* @__PURE__ */ __name((type) => {
  if (["image/jpeg", "image/png"].indexOf(type) === -1)
    return FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.WRONG_PICTURE_FORMAT;
}, "validatePictureFormat"), validatePictureSize = /* @__PURE__ */ __name((size) => {
  if (size > MAX_PICTURE_SIZE)
    return FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.PICTURE_SIZE_TOO_LARGE;
}, "validatePictureSize");
async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file), reader.onload = () => {
      resolve(reader.result);
    }, reader.onerror = reject;
  });
}
__name(fileToBase64, "fileToBase64");
const SCROLL_ENABLING_OVERFLOW_VALUES = ["scroll", "auto"];
function isScrollable(ele) {
  const hasScrollableContent = ele.scrollHeight > ele.clientHeight, overflowYStyle = window.getComputedStyle(ele).overflowY, isScrollCapable = SCROLL_ENABLING_OVERFLOW_VALUES.includes(overflowYStyle);
  return hasScrollableContent && isScrollCapable;
}
__name(isScrollable, "isScrollable");
function getScrollableParent(el) {
  return !el || el === document.body ? document.body : isScrollable(el) ? el : getScrollableParent(el.parentNode);
}
__name(getScrollableParent, "getScrollableParent");
var mapObj$1 = { exports: {} };
const isObject$d = /* @__PURE__ */ __name((value) => typeof value == "object" && value !== null, "isObject$d"), mapObjectSkip$1 = Symbol("skip"), isObjectCustom$1 = /* @__PURE__ */ __name((value) => isObject$d(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date), "isObjectCustom$1"), mapObject$2 = /* @__PURE__ */ __name((object2, mapper, options, isSeen = /* @__PURE__ */ new WeakMap()) => {
  if (options = {
    deep: !1,
    target: {},
    ...options
  }, isSeen.has(object2))
    return isSeen.get(object2);
  isSeen.set(object2, options.target);
  const { target } = options;
  delete options.target;
  const mapArray = /* @__PURE__ */ __name((array2) => array2.map((element2) => isObjectCustom$1(element2) ? mapObject$2(element2, mapper, options, isSeen) : element2), "mapArray");
  if (Array.isArray(object2))
    return mapArray(object2);
  for (const [key, value] of Object.entries(object2)) {
    const mapResult = mapper(key, value, object2);
    if (mapResult === mapObjectSkip$1)
      continue;
    let [newKey, newValue, { shouldRecurse = !0 } = {}] = mapResult;
    newKey !== "__proto__" && (options.deep && shouldRecurse && isObjectCustom$1(newValue) && (newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject$2(newValue, mapper, options, isSeen)), target[newKey] = newValue);
  }
  return target;
}, "mapObject$2");
mapObj$1.exports = (object2, mapper, options) => {
  if (!isObject$d(object2))
    throw new TypeError(`Expected an object, got \`${object2}\` (${typeof object2})`);
  return mapObject$2(object2, mapper, options);
};
mapObj$1.exports.mapObjectSkip = mapObjectSkip$1;
var mapObjExports$1 = mapObj$1.exports;
const mapObject$3 = /* @__PURE__ */ getDefaultExportFromCjs(mapObjExports$1), UPPERCASE = /[\p{Lu}]/u, LOWERCASE = /[\p{Ll}]/u, LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu, IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u, SEPARATORS = /[_.\- ]+/, LEADING_SEPARATORS = new RegExp("^" + SEPARATORS.source), SEPARATORS_AND_IDENTIFIER = new RegExp(SEPARATORS.source + IDENTIFIER.source, "gu"), NUMBERS_AND_IDENTIFIER = new RegExp("\\d+" + IDENTIFIER.source, "gu"), preserveCamelCase = /* @__PURE__ */ __name((string2, toLowerCase, toUpperCase, preserveConsecutiveUppercase2) => {
  let isLastCharLower = !1, isLastCharUpper = !1, isLastLastCharUpper = !1, isLastLastCharPreserved = !1;
  for (let index2 = 0; index2 < string2.length; index2++) {
    const character = string2[index2];
    isLastLastCharPreserved = index2 > 2 ? string2[index2 - 3] === "-" : !0, isLastCharLower && UPPERCASE.test(character) ? (string2 = string2.slice(0, index2) + "-" + string2.slice(index2), isLastCharLower = !1, isLastLastCharUpper = isLastCharUpper, isLastCharUpper = !0, index2++) : isLastCharUpper && isLastLastCharUpper && LOWERCASE.test(character) && (!isLastLastCharPreserved || preserveConsecutiveUppercase2) ? (string2 = string2.slice(0, index2 - 1) + "-" + string2.slice(index2 - 1), isLastLastCharUpper = isLastCharUpper, isLastCharUpper = !1, isLastCharLower = !0) : (isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character, isLastLastCharUpper = isLastCharUpper, isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character);
  }
  return string2;
}, "preserveCamelCase"), preserveConsecutiveUppercase = /* @__PURE__ */ __name((input, toLowerCase) => (LEADING_CAPITAL.lastIndex = 0, input.replace(LEADING_CAPITAL, (m1) => toLowerCase(m1))), "preserveConsecutiveUppercase"), postProcess = /* @__PURE__ */ __name((input, toUpperCase) => (SEPARATORS_AND_IDENTIFIER.lastIndex = 0, NUMBERS_AND_IDENTIFIER.lastIndex = 0, input.replace(SEPARATORS_AND_IDENTIFIER, (_, identifier) => toUpperCase(identifier)).replace(NUMBERS_AND_IDENTIFIER, (m3) => toUpperCase(m3))), "postProcess");
function camelCase$1(input, options) {
  if (!(typeof input == "string" || Array.isArray(input)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (options = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...options
  }, Array.isArray(input) ? input = input.map((x3) => x3.trim()).filter((x3) => x3.length).join("-") : input = input.trim(), input.length === 0)
    return "";
  const toLowerCase = options.locale === !1 ? (string2) => string2.toLowerCase() : (string2) => string2.toLocaleLowerCase(options.locale), toUpperCase = options.locale === !1 ? (string2) => string2.toUpperCase() : (string2) => string2.toLocaleUpperCase(options.locale);
  return input.length === 1 ? SEPARATORS.test(input) ? "" : options.pascalCase ? toUpperCase(input) : toLowerCase(input) : (input !== toLowerCase(input) && (input = preserveCamelCase(input, toLowerCase, toUpperCase, options.preserveConsecutiveUppercase)), input = input.replace(LEADING_SEPARATORS, ""), input = options.preserveConsecutiveUppercase ? preserveConsecutiveUppercase(input, toLowerCase) : toLowerCase(input), options.pascalCase && (input = toUpperCase(input.charAt(0)) + input.slice(1)), postProcess(input, toUpperCase));
}
__name(camelCase$1, "camelCase$1");
const _QuickLRU = class _QuickLRU extends Map {
  constructor(options = {}) {
    if (super(), !(options.maxSize && options.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof options.maxAge == "number" && options.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.maxSize = options.maxSize, this.maxAge = options.maxAge || Number.POSITIVE_INFINITY, this.onEviction = options.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
  }
  // TODO: Use private class methods when targeting Node.js 16.
  _emitEvictions(cache2) {
    if (typeof this.onEviction == "function")
      for (const [key, item] of cache2)
        this.onEviction(key, item.value);
  }
  _deleteIfExpired(key, item) {
    return typeof item.expiry == "number" && item.expiry <= Date.now() ? (typeof this.onEviction == "function" && this.onEviction(key, item.value), this.delete(key)) : !1;
  }
  _getOrDeleteIfExpired(key, item) {
    if (this._deleteIfExpired(key, item) === !1)
      return item.value;
  }
  _getItemValue(key, item) {
    return item.expiry ? this._getOrDeleteIfExpired(key, item) : item.value;
  }
  _peek(key, cache2) {
    const item = cache2.get(key);
    return this._getItemValue(key, item);
  }
  _set(key, value) {
    this.cache.set(key, value), this._size++, this._size >= this.maxSize && (this._size = 0, this._emitEvictions(this.oldCache), this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map());
  }
  _moveToRecent(key, item) {
    this.oldCache.delete(key), this._set(key, item);
  }
  *_entriesAscending() {
    for (const item of this.oldCache) {
      const [key, value] = item;
      this.cache.has(key) || this._deleteIfExpired(key, value) === !1 && (yield item);
    }
    for (const item of this.cache) {
      const [key, value] = item;
      this._deleteIfExpired(key, value) === !1 && (yield item);
    }
  }
  get(key) {
    if (this.cache.has(key)) {
      const item = this.cache.get(key);
      return this._getItemValue(key, item);
    }
    if (this.oldCache.has(key)) {
      const item = this.oldCache.get(key);
      if (this._deleteIfExpired(key, item) === !1)
        return this._moveToRecent(key, item), item.value;
    }
  }
  set(key, value, { maxAge = this.maxAge } = {}) {
    const expiry = typeof maxAge == "number" && maxAge !== Number.POSITIVE_INFINITY ? Date.now() + maxAge : void 0;
    return this.cache.has(key) ? this.cache.set(key, {
      value,
      expiry
    }) : this._set(key, { value, expiry }), this;
  }
  has(key) {
    return this.cache.has(key) ? !this._deleteIfExpired(key, this.cache.get(key)) : this.oldCache.has(key) ? !this._deleteIfExpired(key, this.oldCache.get(key)) : !1;
  }
  peek(key) {
    if (this.cache.has(key))
      return this._peek(key, this.cache);
    if (this.oldCache.has(key))
      return this._peek(key, this.oldCache);
  }
  delete(key) {
    const deleted = this.cache.delete(key);
    return deleted && this._size--, this.oldCache.delete(key) || deleted;
  }
  clear() {
    this.cache.clear(), this.oldCache.clear(), this._size = 0;
  }
  resize(newSize) {
    if (!(newSize && newSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const items = [...this._entriesAscending()], removeCount = items.length - newSize;
    removeCount < 0 ? (this.cache = new Map(items), this.oldCache = /* @__PURE__ */ new Map(), this._size = items.length) : (removeCount > 0 && this._emitEvictions(items.slice(0, removeCount)), this.oldCache = new Map(items.slice(removeCount)), this.cache = /* @__PURE__ */ new Map(), this._size = 0), this.maxSize = newSize;
  }
  *keys() {
    for (const [key] of this)
      yield key;
  }
  *values() {
    for (const [, value] of this)
      yield value;
  }
  *[Symbol.iterator]() {
    for (const item of this.cache) {
      const [key, value] = item;
      this._deleteIfExpired(key, value) === !1 && (yield [key, value.value]);
    }
    for (const item of this.oldCache) {
      const [key, value] = item;
      this.cache.has(key) || this._deleteIfExpired(key, value) === !1 && (yield [key, value.value]);
    }
  }
  *entriesDescending() {
    let items = [...this.cache];
    for (let i2 = items.length - 1; i2 >= 0; --i2) {
      const item = items[i2], [key, value] = item;
      this._deleteIfExpired(key, value) === !1 && (yield [key, value.value]);
    }
    items = [...this.oldCache];
    for (let i2 = items.length - 1; i2 >= 0; --i2) {
      const item = items[i2], [key, value] = item;
      this.cache.has(key) || this._deleteIfExpired(key, value) === !1 && (yield [key, value.value]);
    }
  }
  *entriesAscending() {
    for (const [key, value] of this._entriesAscending())
      yield [key, value.value];
  }
  get size() {
    if (!this._size)
      return this.oldCache.size;
    let oldCacheSize = 0;
    for (const key of this.oldCache.keys())
      this.cache.has(key) || oldCacheSize++;
    return Math.min(this._size + oldCacheSize, this.maxSize);
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(callbackFunction, thisArgument = this) {
    for (const [key, value] of this.entriesAscending())
      callbackFunction.call(thisArgument, value, key, this);
  }
  get [Symbol.toStringTag]() {
    return JSON.stringify([...this.entriesAscending()]);
  }
};
__name(_QuickLRU, "QuickLRU");
let QuickLRU = _QuickLRU;
const has = /* @__PURE__ */ __name((array2, key) => array2.some((element2) => typeof element2 == "string" ? element2 === key : (element2.lastIndex = 0, element2.test(key))), "has"), cache = new QuickLRU({ maxSize: 1e5 }), isObject$c = /* @__PURE__ */ __name((value) => typeof value == "object" && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date), "isObject$c"), camelCaseConvert = /* @__PURE__ */ __name((input, options) => {
  if (!isObject$c(input))
    return input;
  options = {
    deep: !1,
    pascalCase: !1,
    ...options
  };
  const { exclude, pascalCase, stopPaths, deep } = options, stopPathsSet = new Set(stopPaths), makeMapper = /* @__PURE__ */ __name((parentPath) => (key, value) => {
    if (deep && isObject$c(value)) {
      const path = parentPath === void 0 ? key : `${parentPath}.${key}`;
      stopPathsSet.has(path) || (value = mapObject$3(value, makeMapper(path)));
    }
    if (!(exclude && has(exclude, key))) {
      const cacheKey = pascalCase ? `${key}_` : key;
      if (cache.has(cacheKey))
        key = cache.get(cacheKey);
      else {
        const returnValue = camelCase$1(key, { pascalCase, locale: !1 });
        key.length < 100 && cache.set(cacheKey, returnValue), key = returnValue;
      }
    }
    return [key, value];
  }, "makeMapper");
  return mapObject$3(input, makeMapper(void 0));
}, "camelCaseConvert");
function camelcaseKeys(input, options) {
  return Array.isArray(input) ? Object.keys(input).map((key) => camelCaseConvert(input[key], options)) : camelCaseConvert(input, options);
}
__name(camelcaseKeys, "camelcaseKeys");
var mapObj = { exports: {} };
const isObject$b = /* @__PURE__ */ __name((value) => typeof value == "object" && value !== null, "isObject$b"), mapObjectSkip = Symbol("skip"), isObjectCustom = /* @__PURE__ */ __name((value) => isObject$b(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date), "isObjectCustom"), mapObject$1 = /* @__PURE__ */ __name((object2, mapper, options, isSeen = /* @__PURE__ */ new WeakMap()) => {
  if (options = {
    deep: !1,
    target: {},
    ...options
  }, isSeen.has(object2))
    return isSeen.get(object2);
  isSeen.set(object2, options.target);
  const { target } = options;
  delete options.target;
  const mapArray = /* @__PURE__ */ __name((array2) => array2.map((element2) => isObjectCustom(element2) ? mapObject$1(element2, mapper, options, isSeen) : element2), "mapArray");
  if (Array.isArray(object2))
    return mapArray(object2);
  for (const [key, value] of Object.entries(object2)) {
    const mapResult = mapper(key, value, object2);
    if (mapResult === mapObjectSkip)
      continue;
    let [newKey, newValue, { shouldRecurse = !0 } = {}] = mapResult;
    newKey !== "__proto__" && (options.deep && shouldRecurse && isObjectCustom(newValue) && (newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject$1(newValue, mapper, options, isSeen)), target[newKey] = newValue);
  }
  return target;
}, "mapObject$1");
mapObj.exports = (object2, mapper, options) => {
  if (!isObject$b(object2))
    throw new TypeError(`Expected an object, got \`${object2}\` (${typeof object2})`);
  return mapObject$1(object2, mapper, options);
};
mapObj.exports.mapObjectSkip = mapObjectSkip;
var mapObjExports = mapObj.exports;
function lowerCase(str) {
  return str.toLowerCase();
}
__name(lowerCase, "lowerCase");
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function noCase(input, options) {
  options === void 0 && (options = {});
  for (var _a3 = options.splitRegexp, splitRegexp = _a3 === void 0 ? DEFAULT_SPLIT_REGEXP : _a3, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform2 = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d, result2 = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0"), start = 0, end = result2.length; result2.charAt(start) === "\0"; )
    start++;
  for (; result2.charAt(end - 1) === "\0"; )
    end--;
  return result2.slice(start, end).split("\0").map(transform2).join(delimiter);
}
__name(noCase, "noCase");
function replace(input, re2, value) {
  return re2 instanceof RegExp ? input.replace(re2, value) : re2.reduce(function(input2, re3) {
    return input2.replace(re3, value);
  }, input);
}
__name(replace, "replace");
function dotCase(input, options) {
  return options === void 0 && (options = {}), noCase(input, __assign({ delimiter: "." }, options));
}
__name(dotCase, "dotCase");
function snakeCase$1(input, options) {
  return options === void 0 && (options = {}), dotCase(input, __assign({ delimiter: "_" }, options));
}
__name(snakeCase$1, "snakeCase$1");
const dist_es2015 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  snakeCase: snakeCase$1
}, Symbol.toStringTag, { value: "Module" })), require$$1 = /* @__PURE__ */ getAugmentedNamespace(dist_es2015), map$4 = mapObjExports, { snakeCase } = require$$1;
var snakecaseKeys = /* @__PURE__ */ __name(function(obj2, options) {
  return options = Object.assign({ deep: !0, exclude: [], parsingOptions: {} }, options), map$4(obj2, function(key, val) {
    return [
      matches(options.exclude, key) ? key : snakeCase(key, options.parsingOptions),
      val
    ];
  }, options);
}, "snakecaseKeys");
function matches(patterns2, value) {
  return patterns2.some(function(pattern) {
    return typeof pattern == "string" ? pattern === value : pattern.test(value);
  });
}
__name(matches, "matches");
const snakecaseKeys$1 = /* @__PURE__ */ getDefaultExportFromCjs(snakecaseKeys), removeDuplicateForwardSlashesFromUrl = /* @__PURE__ */ __name((url) => url.replace(/([^:]\/)\/+/g, "$1"), "removeDuplicateForwardSlashesFromUrl"), mergeBaseUrlWithEndpoints = /* @__PURE__ */ __name((baseUrl, endpoints) => Object.keys(endpoints).reduce(
  (acc, item) => ({
    ...acc,
    [item]: removeDuplicateForwardSlashesFromUrl(baseUrl + endpoints[item])
  }),
  {}
), "mergeBaseUrlWithEndpoints"), routeReplacer = /* @__PURE__ */ __name((route, variables) => variables ? Object.keys(variables).reduce(
  (str, item) => str.replace(`:${item}`, variables[item].toString()),
  route
) : route, "routeReplacer");
function isValidUrl(url) {
  try {
    new URL(url);
  } catch {
    return !1;
  }
  return !0;
}
__name(isValidUrl, "isValidUrl");
const NETWORK_ERROR_MSGS = [
  "Timeout",
  "Failed to fetch",
  "Network request failed"
];
async function parseResponse(res) {
  const clone2 = res.clone();
  let response;
  try {
    response = await res.json();
  } catch {
    response = await clone2.text();
  }
  return response;
}
__name(parseResponse, "parseResponse");
async function doRequest(url, requestConfig, token) {
  const builtUrl = typeof url == "string" ? url : routeReplacer(url.route, url.routeParams), headers = {};
  token && (headers.authorization = `Bearer ${token}`);
  const config2 = {
    ...requestConfig,
    headers: {
      ...headers,
      ...requestConfig.headers
    }
  };
  try {
    const response = await fetch(builtUrl, config2), data2 = await parseResponse(response);
    if (!response.ok)
      throw new HttpError(response, data2);
    return data2;
  } catch (e3) {
    throw e3 instanceof TypeError && NETWORK_ERROR_MSGS.includes(e3.message) ? new NetworkError(e3.message) : e3;
  }
}
__name(doRequest, "doRequest");
function downloadPdfFile({ base64, fileName }) {
  const a4 = document.createElement("a");
  a4.href = `data:application/pdf;base64,${base64}`, a4.download = fileName.toLowerCase().endsWith(".pdf") ? fileName : `${fileName}.pdf`, a4.click(), a4.remove();
}
__name(downloadPdfFile, "downloadPdfFile");
async function getFile(url, fileName, headers = {}) {
  try {
    const res = await fetch(url, {
      headers,
      mode: "cors"
    }), body = await res.blob(), file = window.URL.createObjectURL(body), a4 = document.createElement("a");
    if (a4.href = file, a4.setAttribute("download", fileName), a4.click(), window.URL.revokeObjectURL(file), a4.remove(), !res.ok)
      throw new HttpError(res, body);
    return body;
  } catch (e3) {
    throw e3 instanceof TypeError && NETWORK_ERROR_MSGS.includes(e3.message) ? new NetworkError(e3.message) : e3;
  }
}
__name(getFile, "getFile");
async function getResource(url, headers, token) {
  return doRequest(
    url,
    {
      method: "GET",
      headers: { "content-type": "application/json", ...headers }
    },
    token
  );
}
__name(getResource, "getResource");
async function deleteResource(url, headers, token) {
  return doRequest(
    url,
    {
      method: "DELETE",
      headers: { "content-type": "application/json", ...headers }
    },
    token
  );
}
__name(deleteResource, "deleteResource");
function postResource(url, body, headers, token) {
  return doRequest(
    url,
    {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "content-type": "application/json", ...headers }
    },
    token
  );
}
__name(postResource, "postResource");
async function postNormalizedResource(url, body, headers, token) {
  const response = await postResource(
    url,
    snakecaseKeys$1(body, { deep: !0 }),
    headers,
    token
  );
  return await camelcaseKeys(response, {
    deep: !0
  });
}
__name(postNormalizedResource, "postNormalizedResource");
function postFormData(url, body, token) {
  return doRequest(
    url,
    {
      body,
      method: "POST"
    },
    token
  );
}
__name(postFormData, "postFormData");
const LIVE_MONITORING_ENTERPRISE_PLANS = [
  "enterprise",
  "professional",
  "custom_july_2018",
  "friend",
  "partner"
];
function checkIsLiveMonitoringEnterprisePlan(plan) {
  return LIVE_MONITORING_ENTERPRISE_PLANS.includes(plan);
}
__name(checkIsLiveMonitoringEnterprisePlan, "checkIsLiveMonitoringEnterprisePlan");
function checkIsLiveMonitoringEnabled(featureFlags, company) {
  const { featuresAllowed, plan } = company;
  return featureFlags.showLookerInAnalytics ? !1 : featuresAllowed.isAdvancedAnalyticsAllowed && (featuresAllowed.isLiveFeedAllowed || checkIsCompanyInTrial(company) || checkIsLiveMonitoringEnterprisePlan(plan)) ? !0 : !featuresAllowed.isAdvancedAnalyticsAllowed && featureFlags.showProLiveMonitoringForEssentials;
}
__name(checkIsLiveMonitoringEnabled, "checkIsLiveMonitoringEnabled");
function checkIsLiveMonitoringPlusEnabled(featureFlags) {
  return featureFlags.showLookerInAnalytics;
}
__name(checkIsLiveMonitoringPlusEnabled, "checkIsLiveMonitoringPlusEnabled");
function convertToSeconds(minutes = 0, seconds = 0) {
  return minutes * 60 + seconds;
}
__name(convertToSeconds, "convertToSeconds");
function convertSecondsToMinSecNotation(seconds) {
  return {
    minutes: Math.floor(seconds / 60),
    seconds: seconds % 60
  };
}
__name(convertSecondsToMinSecNotation, "convertSecondsToMinSecNotation");
const metadata$1 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["64[0-2]\\d{5}|(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], 0, 0, 0, 0, 0, 0, [["2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}"], ["(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}", [8]], 0, ["857[58]\\d{4}", [8]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]], 0, 0, 0, 0, 0, ["50\\d{6}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370|864))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", [9]], ["(?:6[89]|7[235-9])\\d{7}", [9]], ["800\\d{6}", [9]], ["90[016]\\d{6}", [9]], ["878\\d{6}", [9]], ["860\\d{9}", [12]], ["5[18]\\d{7}", [9]], ["74[0248]\\d{6}", [9]], 0, ["84[0248]\\d{6}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}", [8, 10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["(?:19(?:0[01]|4[78])|901)\\d{7}", [10, 11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", [9]], ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[0-2]|[2379]\\d\\d))\\d{5}", [9]], ["800\\d{6}", [9]], ["9(?:0[05689]|76)\\d{6}", [9]], ["70[01]\\d{6}", [9]], ["9(?:3\\d{9}|6\\d{7,10})"], ["9(?:5\\d|7[2-4])\\d{6}", [9]], 0, ["9[17]0\\d{6}", [9]], ["8[134]\\d{7}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["1(?:(?:5(?:[0-25-9]\\d\\d|310)|76\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], ["1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", [12, 13]], ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}"], ["(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[024]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|4[015]|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["(?:510|6\\d\\d|7(?:[0-5]\\d|6[01]))\\d{4}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-35-9]|6(?:1[0-79]|4[0-57-9]|6[0-4])|7(?:[26][0-5]|4[0-28]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3]|78[0-5])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[015])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}"], ["6[01459]\\d{6}|6[01]\\d{5}", [7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], ["88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", [10]], ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, ["151\\d{8,9}", [11, 12]], ["1599\\d{6}", [10]], 0, ["7(?:38(?:[05]\\d|8[08])|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, ["(?:689|8(?:7[18]|80)|95[48])\\d{4}", [7]], ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}", [9, 10]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-6]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["787\\d{4}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[1-3]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, ["697(?:42|56|[78]\\d)\\d{4}", [9]], ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[5-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}"], ["(?:69[67]\\d\\d|7091[0-3])\\d{4}"], ["80[0-5]\\d{6}"], ["8[129]\\d{7}"], 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-8])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-6]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, ["219\\d{4}", [7]], ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:[579]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}", [10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}"], 0, 0, 0, ["700\\d{7,11}"]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-38])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}"], ["(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"], ["80[0-5]\\d{6}", [9]], ["8[129]\\d{7}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], ["600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}"], ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|8988)\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[136]\\d{5}", [7]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], ["85\\d{5}"], 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], ["(?:25[245]|67[3-68])\\d{9}", [12]], ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["897[01]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-6])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[1-9])\\d{5}", [7]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["9[1-9]\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[0-29]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], ["868619\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-8]|9[089])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}", [6, 7, 8, 9, 10, 11]], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[246])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]], 0, 0, ["[48]0\\d{4}", [6]], 0, 0, ["9[23]\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:[59][5-8]|7[5-9])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument$1(func2, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  return args.push(metadata$1), func2.apply(this, args);
}
__name(withMetadataArgument$1, "withMetadataArgument$1");
function compare(a4, b2) {
  a4 = a4.split("-"), b2 = b2.split("-");
  for (var pa = a4[0].split("."), pb = b2[0].split("."), i2 = 0; i2 < 3; i2++) {
    var na = Number(pa[i2]), nb = Number(pb[i2]);
    if (na > nb)
      return 1;
    if (nb > na)
      return -1;
    if (!isNaN(na) && isNaN(nb))
      return 1;
    if (isNaN(na) && !isNaN(nb))
      return -1;
  }
  return a4[1] && b2[1] ? a4[1] > b2[1] ? 1 : a4[1] < b2[1] ? -1 : 0 : !a4[1] && b2[1] ? 1 : a4[1] && !b2[1] ? -1 : 0;
}
__name(compare, "compare");
var objectConstructor = {}.constructor;
function isObject$a(object2) {
  return object2 != null && object2.constructor === objectConstructor;
}
__name(isObject$a, "isObject$a");
function _typeof$E(obj2) {
  "@babel/helpers - typeof";
  return _typeof$E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj3) {
    return typeof obj3;
  } : function(obj3) {
    return obj3 && typeof Symbol == "function" && obj3.constructor === Symbol && obj3 !== Symbol.prototype ? "symbol" : typeof obj3;
  }, _typeof$E(obj2);
}
__name(_typeof$E, "_typeof$E");
function _classCallCheck$l(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$l, "_classCallCheck$l");
function _defineProperties$l(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$l, "_defineProperties$l");
function _createClass$l(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$l(Constructor.prototype, protoProps), staticProps && _defineProperties$l(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$l, "_createClass$l");
var V3 = "1.2.0", V4 = "1.7.35", DEFAULT_EXT_PREFIX = " ext. ", CALLING_CODE_REG_EXP = /^\d+$/, Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata2) {
    _classCallCheck$l(this, Metadata2), validateMetadata(metadata2), this.metadata = metadata2, setVersion.call(this, metadata2);
  }
  return __name(Metadata2, "Metadata"), _createClass$l(Metadata2, [{
    key: "getCountries",
    value: /* @__PURE__ */ __name(function() {
      return Object.keys(this.metadata.countries).filter(function(_) {
        return _ !== "001";
      });
    }, "getCountries")
  }, {
    key: "getCountryMetadata",
    value: /* @__PURE__ */ __name(function(countryCode) {
      return this.metadata.countries[countryCode];
    }, "getCountryMetadata")
  }, {
    key: "nonGeographic",
    value: /* @__PURE__ */ __name(function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }, "nonGeographic")
  }, {
    key: "hasCountry",
    value: /* @__PURE__ */ __name(function(country) {
      return this.getCountryMetadata(country) !== void 0;
    }, "hasCountry")
  }, {
    key: "hasCallingCode",
    value: /* @__PURE__ */ __name(function(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode])
          return !0;
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001")
          return !0;
      }
    }, "hasCallingCode")
  }, {
    key: "isNonGeographicCallingCode",
    value: /* @__PURE__ */ __name(function(callingCode) {
      return this.nonGeographic() ? !!this.nonGeographic()[callingCode] : !this.getCountryCodesForCallingCode(callingCode);
    }, "isNonGeographicCallingCode")
    // Deprecated.
  }, {
    key: "country",
    value: /* @__PURE__ */ __name(function(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }, "country")
  }, {
    key: "selectNumberingPlan",
    value: /* @__PURE__ */ __name(function(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode) && (callingCode = countryCode, countryCode = null), countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode))
          throw new Error("Unknown country: ".concat(countryCode));
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode))
          throw new Error("Unknown calling code: ".concat(callingCode));
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }, "selectNumberingPlan")
  }, {
    key: "getCountryCodesForCallingCode",
    value: /* @__PURE__ */ __name(function(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes)
        return countryCodes.length === 1 && countryCodes[0].length === 3 ? void 0 : countryCodes;
    }, "getCountryCodesForCallingCode")
  }, {
    key: "getCountryCodeForCallingCode",
    value: /* @__PURE__ */ __name(function(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes)
        return countryCodes[0];
    }, "getCountryCodeForCallingCode")
  }, {
    key: "getNumberingPlanMetadata",
    value: /* @__PURE__ */ __name(function(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode)
        return this.getCountryMetadata(countryCode);
      if (this.nonGeographic()) {
        var metadata2 = this.nonGeographic()[callingCode];
        if (metadata2)
          return metadata2;
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001")
          return this.metadata.countries["001"];
      }
    }, "getNumberingPlanMetadata")
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.callingCode();
    }, "countryCallingCode")
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.IDDPrefix();
    }, "IDDPrefix")
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.defaultIDDPrefix();
    }, "defaultIDDPrefix")
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.nationalNumberPattern();
    }, "nationalNumberPattern")
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.possibleLengths();
    }, "possibleLengths")
    // Deprecated.
  }, {
    key: "formats",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.formats();
    }, "formats")
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }, "nationalPrefixForParsing")
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }, "nationalPrefixTransformRule")
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.leadingDigits();
    }, "leadingDigits")
    // Deprecated.
  }, {
    key: "hasTypes",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.hasTypes();
    }, "hasTypes")
    // Deprecated.
  }, {
    key: "type",
    value: /* @__PURE__ */ __name(function(_type) {
      return this.numberingPlan.type(_type);
    }, "type")
    // Deprecated.
  }, {
    key: "ext",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan.ext();
    }, "ext")
  }, {
    key: "countryCallingCodes",
    value: /* @__PURE__ */ __name(function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }, "countryCallingCodes")
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: /* @__PURE__ */ __name(function(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }, "chooseCountryByCountryCallingCode")
  }, {
    key: "hasSelectedNumberingPlan",
    value: /* @__PURE__ */ __name(function() {
      return this.numberingPlan !== void 0;
    }, "hasSelectedNumberingPlan")
  }]), Metadata2;
}(), NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata2, globalMetadataObject) {
    _classCallCheck$l(this, NumberingPlan2), this.globalMetadataObject = globalMetadataObject, this.metadata = metadata2, setVersion.call(this, globalMetadataObject.metadata);
  }
  return __name(NumberingPlan2, "NumberingPlan"), _createClass$l(NumberingPlan2, [{
    key: "callingCode",
    value: /* @__PURE__ */ __name(function() {
      return this.metadata[0];
    }, "callingCode")
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: /* @__PURE__ */ __name(function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }, "getDefaultCountryMetadataForRegion")
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: /* @__PURE__ */ __name(function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }, "IDDPrefix")
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: /* @__PURE__ */ __name(function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }, "defaultIDDPrefix")
  }, {
    key: "nationalNumberPattern",
    value: /* @__PURE__ */ __name(function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }, "nationalNumberPattern")
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: /* @__PURE__ */ __name(function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }, "possibleLengths")
  }, {
    key: "_getFormats",
    value: /* @__PURE__ */ __name(function(metadata2) {
      return metadata2[this.v1 ? 2 : this.v2 ? 3 : 4];
    }, "_getFormats")
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: /* @__PURE__ */ __name(function() {
      var _this = this, formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_) {
        return new Format(_, _this);
      });
    }, "formats")
  }, {
    key: "nationalPrefix",
    value: /* @__PURE__ */ __name(function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }, "nationalPrefix")
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: /* @__PURE__ */ __name(function(metadata2) {
      return metadata2[this.v1 ? 4 : this.v2 ? 5 : 6];
    }, "_getNationalPrefixFormattingRule")
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: /* @__PURE__ */ __name(function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }, "nationalPrefixFormattingRule")
  }, {
    key: "_nationalPrefixForParsing",
    value: /* @__PURE__ */ __name(function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }, "_nationalPrefixForParsing")
  }, {
    key: "nationalPrefixForParsing",
    value: /* @__PURE__ */ __name(function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }, "nationalPrefixForParsing")
  }, {
    key: "nationalPrefixTransformRule",
    value: /* @__PURE__ */ __name(function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }, "nationalPrefixTransformRule")
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: /* @__PURE__ */ __name(function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }, "_getNationalPrefixIsOptionalWhenFormatting")
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: /* @__PURE__ */ __name(function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }, "nationalPrefixIsOptionalWhenFormattingInNationalFormat")
  }, {
    key: "leadingDigits",
    value: /* @__PURE__ */ __name(function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }, "leadingDigits")
  }, {
    key: "types",
    value: /* @__PURE__ */ __name(function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }, "types")
  }, {
    key: "hasTypes",
    value: /* @__PURE__ */ __name(function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }, "hasTypes")
  }, {
    key: "type",
    value: /* @__PURE__ */ __name(function(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2))
        return new Type(getType(this.types(), _type2), this);
    }, "type")
  }, {
    key: "ext",
    value: /* @__PURE__ */ __name(function() {
      return this.v1 || this.v2 ? DEFAULT_EXT_PREFIX : this.metadata[13] || DEFAULT_EXT_PREFIX;
    }, "ext")
  }]), NumberingPlan2;
}(), Format = /* @__PURE__ */ function() {
  function Format2(format2, metadata2) {
    _classCallCheck$l(this, Format2), this._format = format2, this.metadata = metadata2;
  }
  return __name(Format2, "Format"), _createClass$l(Format2, [{
    key: "pattern",
    value: /* @__PURE__ */ __name(function() {
      return this._format[0];
    }, "pattern")
  }, {
    key: "format",
    value: /* @__PURE__ */ __name(function() {
      return this._format[1];
    }, "format")
  }, {
    key: "leadingDigitsPatterns",
    value: /* @__PURE__ */ __name(function() {
      return this._format[2] || [];
    }, "leadingDigitsPatterns")
  }, {
    key: "nationalPrefixFormattingRule",
    value: /* @__PURE__ */ __name(function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }, "nationalPrefixFormattingRule")
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: /* @__PURE__ */ __name(function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }, "nationalPrefixIsOptionalWhenFormattingInNationalFormat")
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: /* @__PURE__ */ __name(function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }, "nationalPrefixIsMandatoryWhenFormattingInNationalFormat")
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: /* @__PURE__ */ __name(function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()));
    }, "usesNationalPrefix")
  }, {
    key: "internationalFormat",
    value: /* @__PURE__ */ __name(function() {
      return this._format[5] || this.format();
    }, "internationalFormat")
  }]), Format2;
}(), FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/, Type = /* @__PURE__ */ function() {
  function Type2(type, metadata2) {
    _classCallCheck$l(this, Type2), this.type = type, this.metadata = metadata2;
  }
  return __name(Type2, "Type"), _createClass$l(Type2, [{
    key: "pattern",
    value: /* @__PURE__ */ __name(function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }, "pattern")
  }, {
    key: "possibleLengths",
    value: /* @__PURE__ */ __name(function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }, "possibleLengths")
  }]), Type2;
}();
function getType(types2, type) {
  switch (type) {
    case "FIXED_LINE":
      return types2[0];
    case "MOBILE":
      return types2[1];
    case "TOLL_FREE":
      return types2[2];
    case "PREMIUM_RATE":
      return types2[3];
    case "PERSONAL_NUMBER":
      return types2[4];
    case "VOICEMAIL":
      return types2[5];
    case "UAN":
      return types2[6];
    case "PAGER":
      return types2[7];
    case "VOIP":
      return types2[8];
    case "SHARED_COST":
      return types2[9];
  }
}
__name(getType, "getType");
function validateMetadata(metadata2) {
  if (!metadata2)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!isObject$a(metadata2) || !isObject$a(metadata2.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject$a(metadata2) ? "an object of shape: { " + Object.keys(metadata2).join(", ") + " }" : "a " + typeOf$1(metadata2) + ": " + metadata2, "."));
}
__name(validateMetadata, "validateMetadata");
var typeOf$1 = /* @__PURE__ */ __name(function(_) {
  return _typeof$E(_);
}, "typeOf");
function getCountryCallingCode(country, metadata2) {
  if (metadata2 = new Metadata(metadata2), metadata2.hasCountry(country))
    return metadata2.country(country).countryCallingCode();
  throw new Error("Unknown country: ".concat(country));
}
__name(getCountryCallingCode, "getCountryCallingCode");
function isSupportedCountry(country, metadata2) {
  return metadata2.countries.hasOwnProperty(country);
}
__name(isSupportedCountry, "isSupportedCountry");
function setVersion(metadata2) {
  var version2 = metadata2.version;
  typeof version2 == "number" ? (this.v1 = version2 === 1, this.v2 = version2 === 2, this.v3 = version2 === 3, this.v4 = version2 === 4) : version2 ? compare(version2, V3) === -1 ? this.v2 = !0 : compare(version2, V4) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
__name(setVersion, "setVersion");
function _createForOfIteratorHelperLoose$8(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$y(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose$8, "_createForOfIteratorHelperLoose$8");
function _unsupportedIterableToArray$y(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$y(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$y(o, minLen);
  }
}
__name(_unsupportedIterableToArray$y, "_unsupportedIterableToArray$y");
function _arrayLikeToArray$y(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$y, "_arrayLikeToArray$y");
function mergeArrays(a4, b2) {
  for (var merged = a4.slice(), _iterator = _createForOfIteratorHelperLoose$8(b2), _step; !(_step = _iterator()).done; ) {
    var element2 = _step.value;
    a4.indexOf(element2) < 0 && merged.push(element2);
  }
  return merged.sort(function(a5, b3) {
    return a5 - b3;
  });
}
__name(mergeArrays, "mergeArrays");
function checkNumberLength(nationalNumber, metadata2) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata2);
}
__name(checkNumberLength, "checkNumberLength");
function checkNumberLengthForType(nationalNumber, type, metadata2) {
  var type_info = metadata2.type(type), possible_lengths = type_info && type_info.possibleLengths() || metadata2.possibleLengths();
  if (!possible_lengths)
    return "IS_POSSIBLE";
  if (type === "FIXED_LINE_OR_MOBILE") {
    if (!metadata2.type("FIXED_LINE"))
      return checkNumberLengthForType(nationalNumber, "MOBILE", metadata2);
    var mobile_type = metadata2.type("MOBILE");
    mobile_type && (possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()));
  } else if (type && !type_info)
    return "INVALID_LENGTH";
  var actual_length = nationalNumber.length, minimum_length = possible_lengths[0];
  return minimum_length === actual_length ? "IS_POSSIBLE" : minimum_length > actual_length ? "TOO_SHORT" : possible_lengths[possible_lengths.length - 1] < actual_length ? "TOO_LONG" : possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
__name(checkNumberLengthForType, "checkNumberLengthForType");
function isPossiblePhoneNumber(input, options, metadata2) {
  if (options === void 0 && (options = {}), metadata2 = new Metadata(metadata2), options.v2) {
    if (!input.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone)
      return !1;
    if (input.country) {
      if (!metadata2.hasCountry(input.country))
        throw new Error("Unknown country: ".concat(input.country));
      metadata2.country(input.country);
    } else {
      if (!input.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      metadata2.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata2.possibleLengths())
    return isPossibleNumber(input.phone || input.nationalNumber, metadata2);
  if (input.countryCallingCode && metadata2.isNonGeographicCallingCode(input.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
__name(isPossiblePhoneNumber, "isPossiblePhoneNumber");
function isPossibleNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
__name(isPossibleNumber, "isPossibleNumber");
function matchesEntirely(text2, regular_expression) {
  return text2 = text2 || "", new RegExp("^(?:" + regular_expression + ")$").test(text2);
}
__name(matchesEntirely, "matchesEntirely");
function _createForOfIteratorHelperLoose$7(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$x(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose$7, "_createForOfIteratorHelperLoose$7");
function _unsupportedIterableToArray$x(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$x(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$x(o, minLen);
  }
}
__name(_unsupportedIterableToArray$x, "_unsupportedIterableToArray$x");
function _arrayLikeToArray$x(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$x, "_arrayLikeToArray$x");
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata2) {
  if (options = options || {}, !(!input.country && !input.countryCallingCode)) {
    metadata2 = new Metadata(metadata2), metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    if (matchesEntirely(nationalNumber, metadata2.nationalNumberPattern())) {
      if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata2))
        return metadata2.type("MOBILE") && metadata2.type("MOBILE").pattern() === "" || !metadata2.type("MOBILE") || isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata2) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var _iterator = _createForOfIteratorHelperLoose$7(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
        var type = _step.value;
        if (isNumberTypeEqualTo(nationalNumber, type, metadata2))
          return type;
      }
    }
  }
}
__name(getNumberType, "getNumberType");
function isNumberTypeEqualTo(nationalNumber, type, metadata2) {
  return type = metadata2.type(type), !type || !type.pattern() || type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0 ? !1 : matchesEntirely(nationalNumber, type.pattern());
}
__name(isNumberTypeEqualTo, "isNumberTypeEqualTo");
function isValidNumber(input, options, metadata2) {
  if (options = options || {}, metadata2 = new Metadata(metadata2), metadata2.selectNumberingPlan(input.country, input.countryCallingCode), metadata2.hasTypes())
    return getNumberType(input, options, metadata2.metadata) !== void 0;
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata2.nationalNumberPattern());
}
__name(isValidNumber, "isValidNumber");
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata2) {
  var _metadata = new Metadata(metadata2), possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  return possibleCountries ? possibleCountries.filter(function(country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata2);
  }) : [];
}
__name(getPossibleCountriesForNumber, "getPossibleCountriesForNumber");
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata2) {
  var _metadata = new Metadata(metadata2);
  return _metadata.selectNumberingPlan(country), _metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0;
}
__name(couldNationalNumberBelongToCountry, "couldNationalNumberBelongToCountry");
var MIN_LENGTH_FOR_NSN = 2, MAX_LENGTH_FOR_NSN = 17, MAX_LENGTH_COUNTRY_CODE = 3, VALID_DIGITS = "0-9０-９٠-٩۰-۹", DASHES = "-‐-―−ー－", SLASHES = "／/", DOTS = "．.", WHITESPACE = "  ­​⁠　", BRACKETS = "()（）［］\\[\\]", TILDES = "~⁓∼～", VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES), PLUS_CHARS = "+＋", CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number2, country, callingCode, metadata2) {
  if (country) {
    var countryMetadata = new Metadata(metadata2);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number2.search(IDDPrefixPattern) === 0) {
      number2 = number2.slice(number2.match(IDDPrefixPattern)[0].length);
      var matchedGroups = number2.match(CAPTURING_DIGIT_PATTERN);
      if (!(matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0 && matchedGroups[1] === "0"))
        return number2;
    }
  }
}
__name(stripIddPrefix, "stripIddPrefix");
function extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2) {
  if (number2 && metadata2.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata2.numberingPlan.nationalPrefixForParsing() + ")"), prefixMatch = prefixPattern.exec(number2);
    if (prefixMatch) {
      var nationalNumber, carrierCode, capturedGroupsCount = prefixMatch.length - 1, hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata2.nationalPrefixTransformRule() && hasCapturedGroups)
        nationalNumber = number2.replace(prefixPattern, metadata2.nationalPrefixTransformRule()), capturedGroupsCount > 1 && (carrierCode = prefixMatch[1]);
      else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number2.slice(prefixBeforeNationalNumber.length), hasCapturedGroups && (carrierCode = prefixMatch[1]);
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number2.indexOf(prefixMatch[1]), possibleNationalPrefix = number2.slice(0, possiblePositionOfTheFirstCapturedGroup);
        possibleNationalPrefix === metadata2.numberingPlan.nationalPrefix() && (nationalPrefix = metadata2.numberingPlan.nationalPrefix());
      } else
        nationalPrefix = prefixMatch[0];
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number2
  };
}
__name(extractNationalNumberFromPossiblyIncompleteNumber, "extractNationalNumberFromPossiblyIncompleteNumber");
function extractNationalNumber(number2, metadata2) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number2) {
    if (!shouldHaveExtractedNationalPrefix(number2, nationalNumber, metadata2))
      return {
        nationalNumber: number2
      };
    if (metadata2.possibleLengths() && !isPossibleIncompleteNationalNumber(nationalNumber, metadata2))
      return {
        nationalNumber: number2
      };
  }
  return {
    nationalNumber,
    carrierCode
  };
}
__name(extractNationalNumber, "extractNationalNumber");
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata2) {
  return !(matchesEntirely(nationalNumberBefore, metadata2.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata2.nationalNumberPattern()));
}
__name(shouldHaveExtractedNationalPrefix, "shouldHaveExtractedNationalPrefix");
function isPossibleIncompleteNationalNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
__name(isPossibleIncompleteNationalNumber, "isPossibleIncompleteNationalNumber");
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata2) : callingCode;
  if (number2.indexOf(countryCallingCode) === 0) {
    metadata2 = new Metadata(metadata2), metadata2.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number2.slice(countryCallingCode.length), _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata2), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber, _extractNationalNumbe2 = extractNationalNumber(number2, metadata2), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata2.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata2) === "TOO_LONG")
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
  }
  return {
    number: number2
  };
}
__name(extractCountryCallingCodeFromInternationalNumberWithoutPlusSign, "extractCountryCallingCodeFromInternationalNumberWithoutPlusSign");
function extractCountryCallingCode(number2, country, callingCode, metadata2) {
  if (!number2)
    return {};
  var isNumberWithIddPrefix;
  if (number2[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number2, country, callingCode, metadata2);
    if (numberWithoutIDD && numberWithoutIDD !== number2)
      isNumberWithIddPrefix = !0, number2 = "+" + numberWithoutIDD;
    else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode,
            number: shorterNumber
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number2
      };
    }
  }
  if (number2[1] === "0")
    return {};
  metadata2 = new Metadata(metadata2);
  for (var i2 = 2; i2 - 1 <= MAX_LENGTH_COUNTRY_CODE && i2 <= number2.length; ) {
    var _countryCallingCode = number2.slice(1, i2);
    if (metadata2.hasCallingCode(_countryCallingCode))
      return metadata2.selectNumberingPlan(_countryCallingCode), {
        countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: _countryCallingCode,
        number: number2.slice(i2)
      };
    i2++;
  }
  return {};
}
__name(extractCountryCallingCode, "extractCountryCallingCode");
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
__name(applyInternationalSeparatorStyle, "applyInternationalSeparatorStyle");
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number2, format2, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix;
  _ref.carrierCode, _ref.metadata;
  var formattedNumber = number2.replace(new RegExp(format2.pattern()), useInternationalFormat ? format2.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format2.nationalPrefixFormattingRule() ? format2.format().replace(FIRST_GROUP_PATTERN, format2.nationalPrefixFormattingRule()) : format2.format()
  ));
  return useInternationalFormat ? applyInternationalSeparatorStyle(formattedNumber) : formattedNumber;
}
__name(formatNationalNumberUsingFormat, "formatNationalNumberUsingFormat");
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata2) {
  var countryMetadata = new Metadata(metadata2);
  if (countryMetadata.selectNumberingPlan(country, callingCode), countryMetadata.defaultIDDPrefix())
    return countryMetadata.defaultIDDPrefix();
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix()))
    return countryMetadata.IDDPrefix();
}
__name(getIddPrefix, "getIddPrefix");
var RFC3966_EXTN_PREFIX = ";ext=", getExtensionDigitsPattern = /* @__PURE__ */ __name(function(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
}, "getExtensionDigitsPattern");
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20", extLimitAfterLikelyLabel = "15", extLimitAfterAmbiguousChar = "9", extLimitWhenNotSure = "6", possibleSeparatorsBetweenNumberAndExtLabel = "[  \\t,]*", possibleCharsAfterExtLabel = "[:\\.．]?[  \\t,-]*", optionalExtnSuffix = "#?", explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)", ambiguousSeparator = "[- ]+", possibleSeparatorsNumberExtLabelNoComma = "[  \\t]*", autoDiallingAndExtLabelsFound = "(?:,{2}|;)", rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel), explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix, ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix, americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#", autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix, onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
__name(createExtensionPattern, "createExtensionPattern");
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}", VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*", VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i"), VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
"(?:" + createExtensionPattern() + ")?", VALID_PHONE_NUMBER_PATTERN = new RegExp(
  // Either a short two-digit-only phone number
  "^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$",
  "i"
);
function isViablePhoneNumber(number2) {
  return number2.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number2);
}
__name(isViablePhoneNumber, "isViablePhoneNumber");
function isViablePhoneNumberStart(number2) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number2);
}
__name(isViablePhoneNumberStart, "isViablePhoneNumberStart");
function formatRFC3966(_ref) {
  var number2 = _ref.number, ext = _ref.ext;
  if (!number2)
    return "";
  if (number2[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(number2).concat(ext ? ";ext=" + ext : "");
}
__name(formatRFC3966, "formatRFC3966");
function _createForOfIteratorHelperLoose$6(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$w(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose$6, "_createForOfIteratorHelperLoose$6");
function _unsupportedIterableToArray$w(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$w(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$w(o, minLen);
  }
}
__name(_unsupportedIterableToArray$w, "_unsupportedIterableToArray$w");
function _arrayLikeToArray$w(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$w, "_arrayLikeToArray$w");
function ownKeys$D(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$D, "ownKeys$D");
function _objectSpread$D(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$D(Object(source), !0).forEach(function(key) {
      _defineProperty$H(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$D(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$D, "_objectSpread$D");
function _defineProperty$H(obj2, key, value) {
  return key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$H, "_defineProperty$H");
var DEFAULT_OPTIONS = {
  formatExtension: /* @__PURE__ */ __name(function(formattedNumber, extension2, metadata2) {
    return "".concat(formattedNumber).concat(metadata2.ext()).concat(extension2);
  }, "formatExtension")
};
function formatNumber(input, format2, options, metadata2) {
  if (options ? options = _objectSpread$D(_objectSpread$D({}, DEFAULT_OPTIONS), options) : options = DEFAULT_OPTIONS, metadata2 = new Metadata(metadata2), input.country && input.country !== "001") {
    if (!metadata2.hasCountry(input.country))
      throw new Error("Unknown country: ".concat(input.country));
    metadata2.country(input.country);
  } else if (input.countryCallingCode)
    metadata2.selectNumberingPlan(input.countryCallingCode);
  else
    return input.phone || "";
  var countryCallingCode = metadata2.countryCallingCode(), nationalNumber = options.v2 ? input.nationalNumber : input.phone, number2;
  switch (format2) {
    case "NATIONAL":
      return nationalNumber ? (number2 = formatNationalNumber$1(nationalNumber, input.carrierCode, "NATIONAL", metadata2, options), addExtension(number2, input.ext, metadata2, options.formatExtension)) : "";
    case "INTERNATIONAL":
      return nationalNumber ? (number2 = formatNationalNumber$1(nationalNumber, null, "INTERNATIONAL", metadata2, options), number2 = "+".concat(countryCallingCode, " ").concat(number2), addExtension(number2, input.ext, metadata2, options.formatExtension)) : "+".concat(countryCallingCode);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    case "IDD":
      if (!options.fromCountry)
        return;
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata2);
      return addExtension(formattedNumber, input.ext, metadata2, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format2, '"'));
  }
}
__name(formatNumber, "formatNumber");
function formatNationalNumber$1(number2, carrierCode, formatAs, metadata2, options) {
  var format2 = chooseFormatForNumber(metadata2.formats(), number2);
  return format2 ? formatNationalNumberUsingFormat(number2, format2, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: !(format2.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === !1),
    carrierCode,
    metadata: metadata2
  }) : number2;
}
__name(formatNationalNumber$1, "formatNationalNumber$1");
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$6(availableFormats), _step; !(_step = _iterator()).done; ) {
    var format2 = _step.value;
    if (format2.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format2.leadingDigitsPatterns()[format2.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0)
        continue;
    }
    if (matchesEntirely(nationalNnumber, format2.pattern()))
      return format2;
  }
}
__name(chooseFormatForNumber, "chooseFormatForNumber");
function addExtension(formattedNumber, ext, metadata2, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata2) : formattedNumber;
}
__name(addExtension, "addExtension");
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata2) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata2.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber$1(nationalNumber, carrierCode, "NATIONAL", metadata2);
    return countryCallingCode === "1" ? countryCallingCode + " " + formattedNumber : formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata2.metadata);
  if (iddPrefix)
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber$1(nationalNumber, null, "INTERNATIONAL", metadata2));
}
__name(formatIDD, "formatIDD");
function ownKeys$C(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$C, "ownKeys$C");
function _objectSpread$C(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$C(Object(source), !0).forEach(function(key) {
      _defineProperty$G(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$C(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$C, "_objectSpread$C");
function _defineProperty$G(obj2, key, value) {
  return key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$G, "_defineProperty$G");
function _classCallCheck$k(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$k, "_classCallCheck$k");
function _defineProperties$k(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$k, "_defineProperties$k");
function _createClass$k(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$k(Constructor.prototype, protoProps), staticProps && _defineProperties$k(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$k, "_createClass$k");
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryOrCountryCallingCode, nationalNumber, metadata2) {
    if (_classCallCheck$k(this, PhoneNumber2), !countryOrCountryCallingCode)
      throw new TypeError("First argument is required");
    if (typeof countryOrCountryCallingCode != "string")
      throw new TypeError("First argument must be a string");
    if (typeof countryOrCountryCallingCode == "string") {
      if (countryOrCountryCallingCode[0] === "+" && !nationalNumber)
        throw new TypeError("`metadata` argument not passed");
      if (isObject$a(nationalNumber) && isObject$a(nationalNumber.countries)) {
        metadata2 = nationalNumber;
        var e164Number = countryOrCountryCallingCode;
        if (!E164_NUMBER_REGEXP.test(e164Number))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var _extractCountryCallin = extractCountryCallingCode(e164Number, void 0, void 0, metadata2), _countryCallingCode = _extractCountryCallin.countryCallingCode, number2 = _extractCountryCallin.number;
        if (nationalNumber = number2, countryOrCountryCallingCode = _countryCallingCode, !nationalNumber)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!nationalNumber)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof nationalNumber != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    validateMetadata(metadata2);
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata2), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country, this.countryCallingCode = countryCallingCode, this.nationalNumber = nationalNumber, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return metadata2;
    };
  }
  return __name(PhoneNumber2, "PhoneNumber"), _createClass$k(PhoneNumber2, [{
    key: "setExt",
    value: /* @__PURE__ */ __name(function(ext) {
      this.ext = ext;
    }, "setExt")
  }, {
    key: "getPossibleCountries",
    value: /* @__PURE__ */ __name(function() {
      return this.country ? [this.country] : getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }, "getPossibleCountries")
  }, {
    key: "isPossible",
    value: /* @__PURE__ */ __name(function() {
      return isPossiblePhoneNumber(this, {
        v2: !0
      }, this.getMetadata());
    }, "isPossible")
  }, {
    key: "isValid",
    value: /* @__PURE__ */ __name(function() {
      return isValidNumber(this, {
        v2: !0
      }, this.getMetadata());
    }, "isValid")
  }, {
    key: "isNonGeographic",
    value: /* @__PURE__ */ __name(function() {
      var metadata2 = new Metadata(this.getMetadata());
      return metadata2.isNonGeographicCallingCode(this.countryCallingCode);
    }, "isNonGeographic")
  }, {
    key: "isEqual",
    value: /* @__PURE__ */ __name(function(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }, "isEqual")
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: /* @__PURE__ */ __name(function() {
      return getNumberType(this, {
        v2: !0
      }, this.getMetadata());
    }, "getType")
  }, {
    key: "format",
    value: /* @__PURE__ */ __name(function(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$C(_objectSpread$C({}, options), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }, "format")
  }, {
    key: "formatNational",
    value: /* @__PURE__ */ __name(function(options) {
      return this.format("NATIONAL", options);
    }, "formatNational")
  }, {
    key: "formatInternational",
    value: /* @__PURE__ */ __name(function(options) {
      return this.format("INTERNATIONAL", options);
    }, "formatInternational")
  }, {
    key: "getURI",
    value: /* @__PURE__ */ __name(function(options) {
      return this.format("RFC3966", options);
    }, "getURI")
  }]), PhoneNumber2;
}(), isCountryCode = /* @__PURE__ */ __name(function(value) {
  return /^[A-Z]{2}$/.test(value);
}, "isCountryCode");
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country, countryCallingCode, metadata2 = new Metadata(metadataJson);
  return isCountryCode(countryOrCountryCallingCode) ? (country = countryOrCountryCallingCode, metadata2.selectNumberingPlan(country), countryCallingCode = metadata2.countryCallingCode()) : countryCallingCode = countryOrCountryCallingCode, {
    country,
    countryCallingCode
  };
}
__name(getCountryAndCountryCallingCode, "getCountryAndCountryCallingCode");
var E164_NUMBER_REGEXP = /^\+\d+$/;
function _typeof$D(obj2) {
  "@babel/helpers - typeof";
  return _typeof$D = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj3) {
    return typeof obj3;
  } : function(obj3) {
    return obj3 && typeof Symbol == "function" && obj3.constructor === Symbol && obj3 !== Symbol.prototype ? "symbol" : typeof obj3;
  }, _typeof$D(obj2);
}
__name(_typeof$D, "_typeof$D");
function _defineProperties$j(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$j, "_defineProperties$j");
function _createClass$j(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$j(Constructor.prototype, protoProps), staticProps && _defineProperties$j(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$j, "_createClass$j");
function _classCallCheck$j(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$j, "_classCallCheck$j");
function _inherits$a(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$a(subClass, superClass);
}
__name(_inherits$a, "_inherits$a");
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$a();
  return /* @__PURE__ */ __name(function() {
    var Super = _getPrototypeOf$a(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$a(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else
      result2 = Super.apply(this, arguments);
    return _possibleConstructorReturn$a(this, result2);
  }, "_createSuperInternal");
}
__name(_createSuper$1, "_createSuper$1");
function _possibleConstructorReturn$a(self2, call) {
  if (call && (_typeof$D(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$a(self2);
}
__name(_possibleConstructorReturn$a, "_possibleConstructorReturn$a");
function _assertThisInitialized$a(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$a, "_assertThisInitialized$a");
function _wrapNativeSuper(Class) {
  var _cache = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = /* @__PURE__ */ __name(function(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof _cache < "u") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper2);
    }
    function Wrapper2() {
      return _construct(Class2, arguments, _getPrototypeOf$a(this).constructor);
    }
    return __name(Wrapper2, "Wrapper"), Wrapper2.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper2, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf$a(Wrapper2, Class2);
  }, "_wrapNativeSuper"), _wrapNativeSuper(Class);
}
__name(_wrapNativeSuper, "_wrapNativeSuper");
function _construct(Parent, args, Class) {
  return _isNativeReflectConstruct$a() ? _construct = Reflect.construct : _construct = /* @__PURE__ */ __name(function(Parent2, args2, Class2) {
    var a4 = [null];
    a4.push.apply(a4, args2);
    var Constructor = Function.bind.apply(Parent2, a4), instance = new Constructor();
    return Class2 && _setPrototypeOf$a(instance, Class2.prototype), instance;
  }, "_construct"), _construct.apply(null, arguments);
}
__name(_construct, "_construct");
function _isNativeReflectConstruct$a() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
__name(_isNativeReflectConstruct$a, "_isNativeReflectConstruct$a");
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
__name(_isNativeFunction, "_isNativeFunction");
function _setPrototypeOf$a(o, p) {
  return _setPrototypeOf$a = Object.setPrototypeOf || /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$a(o, p);
}
__name(_setPrototypeOf$a, "_setPrototypeOf$a");
function _getPrototypeOf$a(o) {
  return _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$a(o);
}
__name(_getPrototypeOf$a, "_getPrototypeOf$a");
var ParseError = /* @__PURE__ */ function(_Error) {
  _inherits$a(ParseError2, _Error);
  var _super = _createSuper$1(ParseError2);
  function ParseError2(code2) {
    var _this;
    return _classCallCheck$j(this, ParseError2), _this = _super.call(this, code2), Object.setPrototypeOf(_assertThisInitialized$a(_this), ParseError2.prototype), _this.name = _this.constructor.name, _this;
  }
  return __name(ParseError2, "ParseError"), _createClass$j(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error)), EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number2) {
  var start = number2.search(EXTN_PATTERN);
  if (start < 0)
    return {};
  for (var numberWithoutExtension = number2.slice(0, start), matches2 = number2.match(EXTN_PATTERN), i2 = 1; i2 < matches2.length; ) {
    if (matches2[i2])
      return {
        number: numberWithoutExtension,
        ext: matches2[i2]
      };
    i2++;
  }
}
__name(extractExtension, "extractExtension");
function _createForOfIteratorHelperLoose$5(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$v(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose$5, "_createForOfIteratorHelperLoose$5");
function _unsupportedIterableToArray$v(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$v(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$v(o, minLen);
  }
}
__name(_unsupportedIterableToArray$v, "_unsupportedIterableToArray$v");
function _arrayLikeToArray$v(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$v, "_arrayLikeToArray$v");
var DIGITS = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function parseDigit(character) {
  return DIGITS[character];
}
__name(parseDigit, "parseDigit");
function parseDigits(string2) {
  for (var result2 = "", _iterator = _createForOfIteratorHelperLoose$5(string2.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value, digit = parseDigit(character);
    digit && (result2 += digit);
  }
  return result2;
}
__name(parseDigits, "parseDigits");
function _createForOfIteratorHelperLoose$4(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$u(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose$4, "_createForOfIteratorHelperLoose$4");
function _unsupportedIterableToArray$u(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$u(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$u(o, minLen);
  }
}
__name(_unsupportedIterableToArray$u, "_unsupportedIterableToArray$u");
function _arrayLikeToArray$u(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$u, "_arrayLikeToArray$u");
function parseIncompletePhoneNumber(string2) {
  for (var result2 = "", _iterator = _createForOfIteratorHelperLoose$4(string2.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
__name(parseIncompletePhoneNumber, "parseIncompletePhoneNumber");
function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  if (character === "+") {
    if (prevParsedCharacters) {
      typeof emitEvent == "function" && emitEvent("end");
      return;
    }
    return "+";
  }
  return parseDigit(character);
}
__name(parsePhoneNumberCharacter, "parsePhoneNumberCharacter");
function _createForOfIteratorHelperLoose$3(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$t(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose$3, "_createForOfIteratorHelperLoose$3");
function _unsupportedIterableToArray$t(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$t(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$t(o, minLen);
  }
}
__name(_unsupportedIterableToArray$t, "_unsupportedIterableToArray$t");
function _arrayLikeToArray$t(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$t, "_arrayLikeToArray$t");
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries;
  _ref.defaultCountry;
  var metadata2 = _ref.metadata;
  metadata2 = new Metadata(metadata2);
  for (var _iterator = _createForOfIteratorHelperLoose$3(countries), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    if (metadata2.country(country), metadata2.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata2.leadingDigits()) === 0)
        return country;
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata2.metadata))
      return country;
  }
}
__name(getCountryByNationalNumber, "getCountryByNationalNumber");
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = !1;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata2 = _ref.metadata;
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE && metadata2.isNonGeographicCallingCode(callingCode))
    return "001";
  var possibleCountries = metadata2.getCountryCodesForCallingCode(callingCode);
  if (possibleCountries)
    return possibleCountries.length === 1 ? possibleCountries[0] : getCountryByNationalNumber(nationalPhoneNumber, {
      countries: possibleCountries,
      defaultCountry,
      metadata: metadata2.metadata
    });
}
__name(getCountryByCallingCode, "getCountryByCallingCode");
var PLUS_SIGN = "+", RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?", RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")", RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$", RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g"), ALPHANUM_ = VALID_DIGITS, RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*", VALID_ALPHA_ = "a-zA-Z", RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*", RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$", RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g"), RFC3966_PREFIX_ = "tel:", RFC3966_PHONE_CONTEXT_ = ";phone-context=", RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0)
    return null;
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length)
    return "";
  var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
  return phoneContextEnd >= 0 ? numberToExtractFrom.substring(phoneContextStart, phoneContextEnd) : numberToExtractFrom.substring(phoneContextStart);
}
__name(extractPhoneContext, "extractPhoneContext");
function isPhoneContextValid(phoneContext) {
  return phoneContext === null ? !0 : phoneContext.length === 0 ? !1 : RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
__name(isPhoneContextValid, "isPhoneContextValid");
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber2 = _ref.extractFormattedPhoneNumber, phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext))
    throw new ParseError("NOT_A_NUMBER");
  var phoneNumberString;
  if (phoneContext === null)
    phoneNumberString = extractFormattedPhoneNumber2(numberToParse) || "";
  else {
    phoneNumberString = "", phoneContext.charAt(0) === PLUS_SIGN && (phoneNumberString += phoneContext);
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_), indexOfNationalNumber;
    indexOfRfc3966Prefix >= 0 ? indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length : indexOfNationalNumber = 0;
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0 && (phoneNumberString = phoneNumberString.substring(0, indexOfIsdn)), phoneNumberString !== "")
    return phoneNumberString;
}
__name(extractFormattedPhoneNumberFromPossibleRfc3966NumberUri, "extractFormattedPhoneNumberFromPossibleRfc3966NumberUri");
var MAX_INPUT_STRING_LENGTH = 250, PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]"), AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse$1(text2, options, metadata2) {
  if (options = options || {}, metadata2 = new Metadata(metadata2), options.defaultCountry && !metadata2.hasCountry(options.defaultCountry))
    throw options.v2 ? new ParseError("INVALID_COUNTRY") : new Error("Unknown country: ".concat(options.defaultCountry));
  var _parseInput = parseInput(text2, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2)
      throw error === "TOO_SHORT" ? new ParseError("TOO_SHORT") : new ParseError("NOT_A_NUMBER");
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber$1(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata2), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata2.hasSelectedNumberingPlan()) {
    if (options.v2)
      throw new ParseError("INVALID_COUNTRY");
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2)
      throw new ParseError("TOO_SHORT");
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2)
      throw new ParseError("TOO_LONG");
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata2.metadata);
    return country && (phoneNumber.country = country), carrierCode && (phoneNumber.carrierCode = carrierCode), ext && (phoneNumber.ext = ext), phoneNumber.__countryCallingCodeSource = countryCallingCodeSource, phoneNumber;
  }
  var valid2 = (options.extended ? metadata2.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) : !1;
  return options.extended ? {
    country,
    countryCallingCode,
    carrierCode,
    valid: valid2,
    possible: valid2 ? !0 : !!(options.extended === !0 && metadata2.possibleLengths() && isPossibleNumber(nationalNumber, metadata2)),
    phone: nationalNumber,
    ext
  } : valid2 ? result(country, nationalNumber, ext) : {};
}
__name(parse$1, "parse$1");
function _extractFormattedPhoneNumber(text2, extract, throwOnError) {
  if (text2) {
    if (text2.length > MAX_INPUT_STRING_LENGTH) {
      if (throwOnError)
        throw new ParseError("TOO_LONG");
      return;
    }
    if (extract === !1)
      return text2;
    var startsAt = text2.search(PHONE_NUMBER_START_PATTERN);
    if (!(startsAt < 0))
      return text2.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
  }
}
__name(_extractFormattedPhoneNumber, "_extractFormattedPhoneNumber");
function parseInput(text2, v2, extract) {
  var number2 = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text2, {
    extractFormattedPhoneNumber: /* @__PURE__ */ __name(function(text3) {
      return _extractFormattedPhoneNumber(text3, extract, v2);
    }, "extractFormattedPhoneNumber")
  });
  if (!number2)
    return {};
  if (!isViablePhoneNumber(number2))
    return isViablePhoneNumberStart(number2) ? {
      error: "TOO_SHORT"
    } : {};
  var withExtensionStripped = extractExtension(number2);
  return withExtensionStripped.ext ? withExtensionStripped : {
    number: number2
  };
}
__name(parseInput, "parseInput");
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  return ext && (result2.ext = ext), result2;
}
__name(result, "result");
function parsePhoneNumber$1(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata2) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata2.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number2 = _extractCountryCallin.number, country;
  if (countryCallingCode)
    metadata2.selectNumberingPlan(countryCallingCode);
  else if (number2 && (defaultCountry || defaultCallingCode))
    metadata2.selectNumberingPlan(defaultCountry, defaultCallingCode), defaultCountry && (country = defaultCountry), countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata2.metadata);
  else
    return {};
  if (!number2)
    return {
      countryCallingCodeSource,
      countryCallingCode
    };
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number2), metadata2), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode, exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber,
    defaultCountry,
    metadata: metadata2
  });
  return exactCountry && (country = exactCountry, exactCountry === "001" || metadata2.country(country)), {
    country,
    countryCallingCode,
    countryCallingCodeSource,
    nationalNumber,
    carrierCode
  };
}
__name(parsePhoneNumber$1, "parsePhoneNumber$1");
function ownKeys$B(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$B, "ownKeys$B");
function _objectSpread$B(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$B(Object(source), !0).forEach(function(key) {
      _defineProperty$F(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$B(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$B, "_objectSpread$B");
function _defineProperty$F(obj2, key, value) {
  return key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$F, "_defineProperty$F");
function parsePhoneNumberWithError$3(text2, options, metadata2) {
  return parse$1(text2, _objectSpread$B(_objectSpread$B({}, options), {}, {
    v2: !0
  }), metadata2);
}
__name(parsePhoneNumberWithError$3, "parsePhoneNumberWithError$3");
function ownKeys$A(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$A, "ownKeys$A");
function _objectSpread$A(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$A(Object(source), !0).forEach(function(key) {
      _defineProperty$E(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$A(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$A, "_objectSpread$A");
function _defineProperty$E(obj2, key, value) {
  return key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$E, "_defineProperty$E");
function _slicedToArray$h(arr, i2) {
  return _arrayWithHoles$i(arr) || _iterableToArrayLimit$h(arr, i2) || _unsupportedIterableToArray$s(arr, i2) || _nonIterableRest$i();
}
__name(_slicedToArray$h, "_slicedToArray$h");
function _nonIterableRest$i() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$i, "_nonIterableRest$i");
function _unsupportedIterableToArray$s(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$s(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$s(o, minLen);
  }
}
__name(_unsupportedIterableToArray$s, "_unsupportedIterableToArray$s");
function _arrayLikeToArray$s(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$s, "_arrayLikeToArray$s");
function _iterableToArrayLimit$h(arr, i2) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _arr = [], _n = !0, _d = !1, _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i2 && _arr.length === i2)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
__name(_iterableToArrayLimit$h, "_iterableToArrayLimit$h");
function _arrayWithHoles$i(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$i, "_arrayWithHoles$i");
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray$h(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3], text2, options, metadata2;
  if (typeof arg_1 == "string")
    text2 = arg_1;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 == "string")
    arg_4 ? (options = arg_3, metadata2 = arg_4) : (options = void 0, metadata2 = arg_3), arg_2 && (options = _objectSpread$A({
      defaultCountry: arg_2
    }, options));
  else if (isObject$a(arg_2))
    arg_3 ? (options = arg_2, metadata2 = arg_3) : metadata2 = arg_2;
  else
    throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text: text2,
    options,
    metadata: metadata2
  };
}
__name(normalizeArguments, "normalizeArguments");
function parsePhoneNumberWithError$2() {
  var _normalizeArguments = normalizeArguments(arguments), text2 = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  return parsePhoneNumberWithError$3(text2, options, metadata2);
}
__name(parsePhoneNumberWithError$2, "parsePhoneNumberWithError$2");
function ownKeys$z(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$z, "ownKeys$z");
function _objectSpread$z(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$z(Object(source), !0).forEach(function(key) {
      _defineProperty$D(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$z(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$z, "_objectSpread$z");
function _defineProperty$D(obj2, key, value) {
  return key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$D, "_defineProperty$D");
function parsePhoneNumber(text2, options, metadata2) {
  options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata2) && (options = _objectSpread$z(_objectSpread$z({}, options), {}, {
    defaultCountry: void 0
  }));
  try {
    return parsePhoneNumberWithError$3(text2, options, metadata2);
  } catch (error) {
    if (!(error instanceof ParseError))
      throw error;
  }
}
__name(parsePhoneNumber, "parsePhoneNumber");
function ownKeys$y(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$y, "ownKeys$y");
function _objectSpread$y(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$y(Object(source), !0).forEach(function(key) {
      _defineProperty$C(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$y(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$y, "_objectSpread$y");
function _defineProperty$C(obj2, key, value) {
  return key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$C, "_defineProperty$C");
function isValidPhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments), text2 = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  options = _objectSpread$y(_objectSpread$y({}, options), {}, {
    extract: !1
  });
  var phoneNumber = parsePhoneNumber(text2, options, metadata2);
  return phoneNumber && phoneNumber.isValid() || !1;
}
__name(isValidPhoneNumber$1, "isValidPhoneNumber$1");
function _classCallCheck$i(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$i, "_classCallCheck$i");
function _defineProperties$i(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$i, "_defineProperties$i");
function _createClass$i(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$i(Constructor.prototype, protoProps), staticProps && _defineProperties$i(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$i, "_createClass$i");
var AsYouTypeState = /* @__PURE__ */ function() {
  function AsYouTypeState2(_ref) {
    var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
    _classCallCheck$i(this, AsYouTypeState2), this.onCountryChange = onCountryChange, this.onCallingCodeChange = onCallingCodeChange;
  }
  return __name(AsYouTypeState2, "AsYouTypeState"), _createClass$i(AsYouTypeState2, [{
    key: "reset",
    value: /* @__PURE__ */ __name(function(_ref2) {
      var country = _ref2.country, callingCode = _ref2.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(country, callingCode);
    }, "reset")
  }, {
    key: "resetNationalSignificantNumber",
    value: /* @__PURE__ */ __name(function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }, "resetNationalSignificantNumber")
  }, {
    key: "update",
    value: /* @__PURE__ */ __name(function(properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this[key] = properties[key];
      }
    }, "update")
  }, {
    key: "initCountryAndCallingCode",
    value: /* @__PURE__ */ __name(function(country, callingCode) {
      this.setCountry(country), this.setCallingCode(callingCode);
    }, "initCountryAndCallingCode")
  }, {
    key: "setCountry",
    value: /* @__PURE__ */ __name(function(country) {
      this.country = country, this.onCountryChange(country);
    }, "setCountry")
  }, {
    key: "setCallingCode",
    value: /* @__PURE__ */ __name(function(callingCode) {
      this.callingCode = callingCode, this.onCallingCodeChange(callingCode, this.country);
    }, "setCallingCode")
  }, {
    key: "startInternationalNumber",
    value: /* @__PURE__ */ __name(function(country, callingCode) {
      this.international = !0, this.initCountryAndCallingCode(country, callingCode);
    }, "startInternationalNumber")
  }, {
    key: "appendDigits",
    value: /* @__PURE__ */ __name(function(nextDigits) {
      this.digits += nextDigits;
    }, "appendDigits")
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: /* @__PURE__ */ __name(function(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }, "appendNationalSignificantNumberDigits")
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: /* @__PURE__ */ __name(function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }, "getNationalDigits")
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: /* @__PURE__ */ __name(function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }, "getDigitsWithoutInternationalPrefix")
  }]), AsYouTypeState2;
}();
function _createForOfIteratorHelperLoose$2(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$r(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose$2, "_createForOfIteratorHelperLoose$2");
function _unsupportedIterableToArray$r(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$r(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$r(o, minLen);
  }
}
__name(_unsupportedIterableToArray$r, "_unsupportedIterableToArray$r");
function _arrayLikeToArray$r(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$r, "_arrayLikeToArray$r");
var DIGIT_PLACEHOLDER = "x", DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
function repeat(string2, times) {
  if (times < 1)
    return "";
  for (var result2 = ""; times > 1; )
    times & 1 && (result2 += string2), times >>= 1, string2 += string2;
  return result2 + string2;
}
__name(repeat, "repeat");
function cutAndStripNonPairedParens(string2, cutBeforeIndex) {
  return string2[cutBeforeIndex] === ")" && cutBeforeIndex++, stripNonPairedParens(string2.slice(0, cutBeforeIndex));
}
__name(cutAndStripNonPairedParens, "cutAndStripNonPairedParens");
function stripNonPairedParens(string2) {
  for (var dangling_braces = [], i2 = 0; i2 < string2.length; )
    string2[i2] === "(" ? dangling_braces.push(i2) : string2[i2] === ")" && dangling_braces.pop(), i2++;
  var start = 0, cleared_string = "";
  dangling_braces.push(string2.length);
  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
    var index2 = _dangling_braces[_i];
    cleared_string += string2.slice(start, index2), start = index2 + 1;
  }
  return cleared_string;
}
__name(stripNonPairedParens, "stripNonPairedParens");
function populateTemplateWithDigits(template, position2, digits) {
  for (var _iterator2 = _createForOfIteratorHelperLoose$2(digits.split("")), _step2; !(_step2 = _iterator2()).done; ) {
    var digit = _step2.value;
    if (template.slice(position2 + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0)
      return;
    position2 = template.search(DIGIT_PLACEHOLDER_MATCHER), template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }
  return [template, position2];
}
__name(populateTemplateWithDigits, "populateTemplateWithDigits");
function formatCompleteNumber(state, format2, _ref) {
  var metadata2 = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix, matcher = new RegExp("^(?:".concat(format2.pattern(), ")$"));
  if (matcher.test(state.nationalSignificantNumber))
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format2, {
      metadata: metadata2,
      shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix
    });
}
__name(formatCompleteNumber, "formatCompleteNumber");
function canFormatCompleteNumber(nationalSignificantNumber, metadata2) {
  return checkNumberLength(nationalSignificantNumber, metadata2) === "IS_POSSIBLE";
}
__name(canFormatCompleteNumber, "canFormatCompleteNumber");
function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format2, _ref2) {
  var metadata2 = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  if (state.nationalSignificantNumber, state.international, state.nationalPrefix, state.carrierCode, shouldTryNationalPrefixFormattingRule(format2)) {
    var formattedNumber = formatNationalNumber(state, format2, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix,
      metadata: metadata2
    });
    if (formattedNumber)
      return formattedNumber;
  }
  return formatNationalNumber(state, format2, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix,
    metadata: metadata2
  });
}
__name(formatNationalNumberWithAndWithoutNationalPrefixFormattingRule, "formatNationalNumberWithAndWithoutNationalPrefixFormattingRule");
function formatNationalNumber(state, format2, _ref3) {
  var metadata2 = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix, formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format2, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata2
  });
  if (useNationalPrefixFormattingRule || (state.nationalPrefix ? formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format2) + formattedNationalNumber : state.complexPrefixBeforeNationalSignificantNumber && (formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + " " + formattedNationalNumber)), isValidFormattedNationalNumber(formattedNationalNumber, state))
    return formattedNationalNumber;
}
__name(formatNationalNumber, "formatNationalNumber");
function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}
__name(isValidFormattedNationalNumber, "isValidFormattedNationalNumber");
function _classCallCheck$h(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$h, "_classCallCheck$h");
function _defineProperties$h(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$h, "_defineProperties$h");
function _createClass$h(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$h(Constructor.prototype, protoProps), staticProps && _defineProperties$h(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$h, "_createClass$h");
var PatternParser = /* @__PURE__ */ function() {
  function PatternParser2() {
    _classCallCheck$h(this, PatternParser2);
  }
  return __name(PatternParser2, "PatternParser"), _createClass$h(PatternParser2, [{
    key: "parse",
    value: /* @__PURE__ */ __name(function(pattern) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(pattern), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
      if (branches)
        return {
          op: "|",
          args: branches.concat([expandSingleElementArray(instructions)])
        };
      if (instructions.length === 0)
        throw new Error("Pattern is required");
      return instructions.length === 1 ? instructions[0] : instructions;
    }, "parse")
  }, {
    key: "startContext",
    value: /* @__PURE__ */ __name(function(context) {
      this.context.push(context);
    }, "startContext")
  }, {
    key: "endContext",
    value: /* @__PURE__ */ __name(function() {
      this.context.pop();
    }, "endContext")
  }, {
    key: "getContext",
    value: /* @__PURE__ */ __name(function() {
      return this.context[this.context.length - 1];
    }, "getContext")
  }, {
    key: "parsePattern",
    value: /* @__PURE__ */ __name(function(pattern) {
      if (!pattern)
        throw new Error("Pattern is required");
      var match2 = pattern.match(OPERATOR);
      if (!match2) {
        if (ILLEGAL_CHARACTER_REGEXP.test(pattern))
          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(""));
        return;
      }
      var operator = match2[1], before = pattern.slice(0, match2.index), rightPart = pattern.slice(match2.index + operator.length);
      switch (operator) {
        case "(?:":
          before && this.parsePattern(before), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (before && this.parsePattern(before), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var _this$getContext = this.getContext(), branches = _this$getContext.branches;
          branches.push(expandSingleElementArray(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: branches
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (before && this.parsePattern(before), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          before && this.parsePattern(before), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: parseOneOfSet(before)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(operator));
      }
      rightPart && this.parsePattern(rightPart);
    }, "parsePattern")
  }]), PatternParser2;
}();
function parseOneOfSet(pattern) {
  for (var values = [], i2 = 0; i2 < pattern.length; ) {
    if (pattern[i2] === "-") {
      if (i2 === 0 || i2 === pattern.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
      for (var prevValue = pattern[i2 - 1].charCodeAt(0) + 1, nextValue = pattern[i2 + 1].charCodeAt(0) - 1, value = prevValue; value <= nextValue; )
        values.push(String.fromCharCode(value)), value++;
    } else
      values.push(pattern[i2]);
    i2++;
  }
  return values;
}
__name(parseOneOfSet, "parseOneOfSet");
var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/, OPERATOR = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function expandSingleElementArray(array2) {
  return array2.length === 1 ? array2[0] : array2;
}
__name(expandSingleElementArray, "expandSingleElementArray");
function _createForOfIteratorHelperLoose$1(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$q(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose$1, "_createForOfIteratorHelperLoose$1");
function _unsupportedIterableToArray$q(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$q(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$q(o, minLen);
  }
}
__name(_unsupportedIterableToArray$q, "_unsupportedIterableToArray$q");
function _arrayLikeToArray$q(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$q, "_arrayLikeToArray$q");
function _classCallCheck$g(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$g, "_classCallCheck$g");
function _defineProperties$g(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$g, "_defineProperties$g");
function _createClass$g(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$g(Constructor.prototype, protoProps), staticProps && _defineProperties$g(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$g, "_createClass$g");
var PatternMatcher = /* @__PURE__ */ function() {
  function PatternMatcher2(pattern) {
    _classCallCheck$g(this, PatternMatcher2), this.matchTree = new PatternParser().parse(pattern);
  }
  return __name(PatternMatcher2, "PatternMatcher"), _createClass$g(PatternMatcher2, [{
    key: "match",
    value: /* @__PURE__ */ __name(function(string2) {
      var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
      if (!string2)
        throw new Error("String is required");
      var result2 = _match(string2.split(""), this.matchTree, !0);
      if (result2 && result2.match && delete result2.matchedChars, !(result2 && result2.overflow && !allowOverflow))
        return result2;
    }, "match")
  }]), PatternMatcher2;
}();
function _match(characters, tree, last2) {
  if (typeof tree == "string") {
    var characterString = characters.join("");
    return tree.indexOf(characterString) === 0 ? characters.length === tree.length ? {
      match: !0,
      matchedChars: characters
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : characterString.indexOf(tree) === 0 ? last2 && characters.length > tree.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: characters.slice(0, tree.length)
    } : void 0;
  }
  if (Array.isArray(tree)) {
    for (var restCharacters = characters.slice(), i2 = 0; i2 < tree.length; ) {
      var subtree = tree[i2], result2 = _match(restCharacters, subtree, last2 && i2 === tree.length - 1);
      if (result2) {
        if (result2.overflow)
          return result2;
        if (result2.match) {
          if (restCharacters = restCharacters.slice(result2.matchedChars.length), restCharacters.length === 0)
            return i2 === tree.length - 1 ? {
              match: !0,
              matchedChars: characters
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (result2.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(result2, null, 2)));
        }
      } else
        return;
      i2++;
    }
    return last2 ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: characters.slice(0, characters.length - restCharacters.length)
    };
  }
  switch (tree.op) {
    case "|":
      for (var partialMatch, _iterator = _createForOfIteratorHelperLoose$1(tree.args), _step; !(_step = _iterator()).done; ) {
        var branch = _step.value, _result = _match(characters, branch, last2);
        if (_result) {
          if (_result.overflow)
            return _result;
          if (_result.match)
            return {
              match: !0,
              matchedChars: _result.matchedChars
            };
          if (_result.partialMatch)
            partialMatch = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(_result, null, 2)));
        }
      }
      return partialMatch ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var _iterator2 = _createForOfIteratorHelperLoose$1(tree.args), _step2; !(_step2 = _iterator2()).done; ) {
        var _char = _step2.value;
        if (characters[0] === _char)
          return characters.length === 1 ? {
            match: !0,
            matchedChars: characters
          } : last2 ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [_char]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(tree));
  }
}
__name(_match, "_match");
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray$p(o)) || allowArrayLike && o && typeof o.length == "number") {
    it && (o = it);
    var i2 = 0;
    return function() {
      return i2 >= o.length ? { done: !0 } : { done: !1, value: o[i2++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_createForOfIteratorHelperLoose, "_createForOfIteratorHelperLoose");
function _unsupportedIterableToArray$p(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$p(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$p(o, minLen);
  }
}
__name(_unsupportedIterableToArray$p, "_unsupportedIterableToArray$p");
function _arrayLikeToArray$p(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$p, "_arrayLikeToArray$p");
function _classCallCheck$f(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$f, "_classCallCheck$f");
function _defineProperties$f(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$f, "_defineProperties$f");
function _createClass$f(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$f(Constructor.prototype, protoProps), staticProps && _defineProperties$f(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$f, "_createClass$f");
var DUMMY_DIGIT = "9", LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15, LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH), NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/, CREATE_CHARACTER_CLASS_PATTERN = /* @__PURE__ */ __name(function() {
  return /\[([^\[\]])*\]/g;
}, "CREATE_CHARACTER_CLASS_PATTERN"), CREATE_STANDALONE_DIGIT_PATTERN = /* @__PURE__ */ __name(function() {
  return /\d(?=[^,}][^,}])/g;
}, "CREATE_STANDALONE_DIGIT_PATTERN"), NON_ALTERING_FORMAT_REG_EXP = new RegExp("[" + VALID_PUNCTUATION + "]*\\$1[" + VALID_PUNCTUATION + "]*(\\$\\d[" + VALID_PUNCTUATION + "]*)*$"), MIN_LEADING_DIGITS_LENGTH = 3, AsYouTypeFormatter = /* @__PURE__ */ function() {
  function AsYouTypeFormatter2(_ref) {
    _ref.state;
    var metadata2 = _ref.metadata;
    _classCallCheck$f(this, AsYouTypeFormatter2), this.metadata = metadata2, this.resetFormat();
  }
  return __name(AsYouTypeFormatter2, "AsYouTypeFormatter"), _createClass$f(AsYouTypeFormatter2, [{
    key: "resetFormat",
    value: /* @__PURE__ */ __name(function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }, "resetFormat")
  }, {
    key: "reset",
    value: /* @__PURE__ */ __name(function(numberingPlan, state) {
      this.resetFormat(), numberingPlan ? (this.isNANP = numberingPlan.callingCode() === "1", this.matchingFormats = numberingPlan.formats(), state.nationalSignificantNumber && this.narrowDownMatchingFormats(state)) : (this.isNANP = void 0, this.matchingFormats = []);
    }, "reset")
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: /* @__PURE__ */ __name(function(nextDigits, state) {
      var _this = this;
      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata))
        for (var _iterator = _createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done; ) {
          var format3 = _step.value, formattedCompleteNumber = formatCompleteNumber(state, format3, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: /* @__PURE__ */ __name(function(format4) {
              return _this.shouldTryNationalPrefixFormattingRule(format4, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            }, "shouldTryNationalPrefixFormattingRule"),
            getSeparatorAfterNationalPrefix: /* @__PURE__ */ __name(function(format4) {
              return _this.getSeparatorAfterNationalPrefix(format4);
            }, "getSeparatorAfterNationalPrefix")
          });
          if (formattedCompleteNumber)
            return this.resetFormat(), this.chosenFormat = format3, this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state), this.populatedNationalNumberTemplate = formattedCompleteNumber, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER), formattedCompleteNumber;
        }
      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    }, "format")
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: /* @__PURE__ */ __name(function(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat, newlyChosenFormat = this.chooseFormat(state);
      if (newlyChosenFormat)
        return newlyChosenFormat === previouslyChosenFormat ? this.formatNextNationalNumberDigits(nextDigits) : this.formatNextNationalNumberDigits(state.getNationalDigits());
    }, "formatNationalNumberWithNextDigits")
  }, {
    key: "narrowDownMatchingFormats",
    value: /* @__PURE__ */ __name(function(_ref2) {
      var _this2 = this, nationalSignificantNumber = _ref2.nationalSignificantNumber, nationalPrefix = _ref2.nationalPrefix, international = _ref2.international, leadingDigits = nationalSignificantNumber, leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;
      leadingDigitsPatternIndex < 0 && (leadingDigitsPatternIndex = 0), this.matchingFormats = this.matchingFormats.filter(function(format2) {
        return _this2.formatSuits(format2, international, nationalPrefix) && _this2.formatMatches(format2, leadingDigits, leadingDigitsPatternIndex);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }, "narrowDownMatchingFormats")
  }, {
    key: "formatSuits",
    value: /* @__PURE__ */ __name(function(format2, international, nationalPrefix) {
      return !(nationalPrefix && !format2.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format2.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !international && !nationalPrefix && format2.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }, "formatSuits")
  }, {
    key: "formatMatches",
    value: /* @__PURE__ */ __name(function(format2, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format2.leadingDigitsPatterns().length;
      if (leadingDigitsPatternsCount === 0)
        return !0;
      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format2.leadingDigitsPatterns()[leadingDigitsPatternIndex];
      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH)
        try {
          return new PatternMatcher(leadingDigitsPattern).match(leadingDigits, {
            allowOverflow: !0
          }) !== void 0;
        } catch (error) {
          return console.error(error), !0;
        }
      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }, "formatMatches")
  }, {
    key: "getFormatFormat",
    value: /* @__PURE__ */ __name(function(format2, international) {
      return international ? format2.internationalFormat() : format2.format();
    }, "getFormatFormat")
  }, {
    key: "chooseFormat",
    value: /* @__PURE__ */ __name(function(state) {
      for (var _this3 = this, _loop = /* @__PURE__ */ __name(function() {
        var format2 = _step2.value;
        return _this3.chosenFormat === format2 ? "break" : NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format2, state.international)) ? _this3.createTemplateForFormat(format2, state) ? (_this3.chosenFormat = format2, "break") : (_this3.matchingFormats = _this3.matchingFormats.filter(function(_) {
          return _ !== format2;
        }), "continue") : "continue";
      }, "_loop"), _iterator2 = _createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done; ) {
        var _ret = _loop();
        if (_ret === "break")
          break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }, "chooseFormat")
  }, {
    key: "createTemplateForFormat",
    value: /* @__PURE__ */ __name(function(format2, state) {
      if (!(format2.pattern().indexOf("|") >= 0)) {
        var template = this.getTemplateForFormat(format2, state);
        if (template)
          return this.setNationalNumberTemplate(template, state), !0;
      }
    }, "createTemplateForFormat")
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: /* @__PURE__ */ __name(function(format2) {
      return this.isNANP || format2 && format2.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format2.nationalPrefixFormattingRule()) ? " " : "";
    }, "getSeparatorAfterNationalPrefix")
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: /* @__PURE__ */ __name(function(_ref3, options) {
      var IDDPrefix = _ref3.IDDPrefix, missingPlus = _ref3.missingPlus;
      return IDDPrefix ? options && options.spacing === !1 ? IDDPrefix : IDDPrefix + " " : missingPlus ? "" : "+";
    }, "getInternationalPrefixBeforeCountryCallingCode")
  }, {
    key: "getTemplate",
    value: /* @__PURE__ */ __name(function(state) {
      if (this.template) {
        for (var index2 = -1, i2 = 0, internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
          spacing: !1
        }) : ""; i2 < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length; )
          index2 = this.template.indexOf(DIGIT_PLACEHOLDER, index2 + 1), i2++;
        return cutAndStripNonPairedParens(this.template, index2 + 1);
      }
    }, "getTemplate")
  }, {
    key: "setNationalNumberTemplate",
    value: /* @__PURE__ */ __name(function(template, state) {
      this.nationalNumberTemplate = template, this.populatedNationalNumberTemplate = template, this.populatedNationalNumberTemplatePosition = -1, state.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + " " + template : this.template = template;
    }, "setNationalNumberTemplate")
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: /* @__PURE__ */ __name(function(format2, _ref4) {
      var nationalSignificantNumber = _ref4.nationalSignificantNumber, international = _ref4.international, nationalPrefix = _ref4.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber, pattern = format2.pattern();
      pattern = pattern.replace(CREATE_CHARACTER_CLASS_PATTERN(), "\\d").replace(CREATE_STANDALONE_DIGIT_PATTERN(), "\\d");
      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0];
      if (!(nationalSignificantNumber.length > digits.length)) {
        var strictPattern = new RegExp("^" + pattern + "$"), nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT);
        strictPattern.test(nationalNumberDummyDigits) && (digits = nationalNumberDummyDigits);
        var numberFormat = this.getFormatFormat(format2, international), nationalPrefixIncludedInTemplate;
        if (this.shouldTryNationalPrefixFormattingRule(format2, {
          international,
          nationalPrefix
        })) {
          var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format2.nationalPrefixFormattingRule());
          if (parseDigits(format2.nationalPrefixFormattingRule()) === (nationalPrefix || "") + parseDigits("$1") && (numberFormat = numberFormatWithNationalPrefix, nationalPrefixIncludedInTemplate = !0, nationalPrefix))
            for (var i2 = nationalPrefix.length; i2 > 0; )
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER), i2--;
        }
        var template = digits.replace(new RegExp(pattern), numberFormat).replace(new RegExp(DUMMY_DIGIT, "g"), DIGIT_PLACEHOLDER);
        return nationalPrefixIncludedInTemplate || (complexPrefixBeforeNationalSignificantNumber ? template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + " " + template : nationalPrefix && (template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format2) + template)), international && (template = applyInternationalSeparatorStyle(template)), template;
      }
    }, "getTemplateForFormat")
  }, {
    key: "formatNextNationalNumberDigits",
    value: /* @__PURE__ */ __name(function(digits) {
      var result2 = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
      if (!result2) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = result2[0], this.populatedNationalNumberTemplatePosition = result2[1], cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }, "formatNextNationalNumberDigits")
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: /* @__PURE__ */ __name(function(format2, _ref5) {
      var international = _ref5.international, nationalPrefix = _ref5.nationalPrefix;
      if (format2.nationalPrefixFormattingRule()) {
        var usesNationalPrefix = format2.usesNationalPrefix();
        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international)
          return !0;
      }
    }, "shouldTryNationalPrefixFormattingRule")
  }]), AsYouTypeFormatter2;
}();
function _slicedToArray$g(arr, i2) {
  return _arrayWithHoles$h(arr) || _iterableToArrayLimit$g(arr, i2) || _unsupportedIterableToArray$o(arr, i2) || _nonIterableRest$h();
}
__name(_slicedToArray$g, "_slicedToArray$g");
function _nonIterableRest$h() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$h, "_nonIterableRest$h");
function _unsupportedIterableToArray$o(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$o(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$o(o, minLen);
  }
}
__name(_unsupportedIterableToArray$o, "_unsupportedIterableToArray$o");
function _arrayLikeToArray$o(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$o, "_arrayLikeToArray$o");
function _iterableToArrayLimit$g(arr, i2) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _arr = [], _n = !0, _d = !1, _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i2 && _arr.length === i2)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
__name(_iterableToArrayLimit$g, "_iterableToArrayLimit$g");
function _arrayWithHoles$h(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$h, "_arrayWithHoles$h");
function _classCallCheck$e(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$e, "_classCallCheck$e");
function _defineProperties$e(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$e, "_defineProperties$e");
function _createClass$e(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$e(Constructor.prototype, protoProps), staticProps && _defineProperties$e(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$e, "_createClass$e");
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = "[" + VALID_PUNCTUATION + VALID_DIGITS + "]+", VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp("^" + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + "$", "i"), VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + PLUS_CHARS + "][" + VALID_PUNCTUATION + VALID_DIGITS + "]*|[" + VALID_PUNCTUATION + VALID_DIGITS + "]+)", AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp("[^" + VALID_PUNCTUATION + VALID_DIGITS + "]+.*$"), COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/, AsYouTypeParser = /* @__PURE__ */ function() {
  function AsYouTypeParser2(_ref) {
    var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata2 = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
    _classCallCheck$e(this, AsYouTypeParser2), this.defaultCountry = defaultCountry, this.defaultCallingCode = defaultCallingCode, this.metadata = metadata2, this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }
  return __name(AsYouTypeParser2, "AsYouTypeParser"), _createClass$e(AsYouTypeParser2, [{
    key: "input",
    value: /* @__PURE__ */ __name(function(text2, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text2), _extractFormattedDigi2 = _slicedToArray$g(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1], digits = parseDigits(formattedDigits), justLeadingPlus;
      return hasPlus && (state.digits || (state.startInternationalNumber(), digits || (justLeadingPlus = !0))), digits && this.inputDigits(digits, state), {
        digits,
        justLeadingPlus
      };
    }, "input")
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: /* @__PURE__ */ __name(function(nextDigits, state) {
      var digits = state.digits, hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3;
      if (state.appendDigits(nextDigits), hasReceivedThreeLeadingDigits && this.extractIddPrefix(state), this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state))
          return;
      } else
        state.appendNationalSignificantNumberDigits(nextDigits);
      state.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
        return state.update(stateUpdate);
      });
    }, "inputDigits")
  }, {
    key: "isWaitingForCountryCallingCode",
    value: /* @__PURE__ */ __name(function(_ref2) {
      var international = _ref2.international, callingCode = _ref2.callingCode;
      return international && !callingCode;
    }, "isWaitingForCountryCallingCode")
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: /* @__PURE__ */ __name(function(state) {
      var _extractCountryCallin = extractCountryCallingCode("+" + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number2 = _extractCountryCallin.number;
      if (countryCallingCode)
        return state.setCallingCode(countryCallingCode), state.update({
          nationalSignificantNumber: number2
        }), !0;
    }, "extractCountryCallingCode$1")
  }, {
    key: "reset",
    value: /* @__PURE__ */ __name(function(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = !0;
        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }, "reset")
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: /* @__PURE__ */ __name(function(nationalDigits, setState) {
      if (this.hasSelectedNumberingPlan) {
        var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
        if (nationalNumber !== nationalDigits)
          return this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState), !0;
      }
    }, "extractNationalSignificantNumber")
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: /* @__PURE__ */ __name(function(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode;
        if (nationalNumber !== prevNationalSignificantNumber)
          return this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState), !0;
      }
    }, "extractAnotherNationalSignificantNumber")
  }, {
    key: "onExtractedNationalNumber",
    value: /* @__PURE__ */ __name(function(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber, nationalSignificantNumberMatchesInput, nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber);
      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = !0;
        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex);
        prefixBeforeNationalNumber !== nationalPrefix && (complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber);
      }
      setState({
        nationalPrefix,
        carrierCode,
        nationalSignificantNumber,
        nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }, "onExtractedNationalNumber")
  }, {
    key: "reExtractNationalSignificantNumber",
    value: /* @__PURE__ */ __name(function(state) {
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
        return state.update(stateUpdate);
      }))
        return !0;
      if (this.extractIddPrefix(state))
        return this.extractCallingCodeAndNationalSignificantNumber(state), !0;
      if (this.fixMissingPlus(state))
        return this.extractCallingCodeAndNationalSignificantNumber(state), !0;
    }, "reExtractNationalSignificantNumber")
  }, {
    key: "extractIddPrefix",
    value: /* @__PURE__ */ __name(function(state) {
      var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits;
      if (state.nationalSignificantNumber, !(international || IDDPrefix)) {
        var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (numberWithoutIDD !== void 0 && numberWithoutIDD !== digits)
          return state.update({
            IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
          }), this.startInternationalNumber(state, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }, "extractIddPrefix")
  }, {
    key: "fixMissingPlus",
    value: /* @__PURE__ */ __name(function(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode;
        if (_extractCountryCallin2.number, newCallingCode)
          return state.update({
            missingPlus: !0
          }), this.startInternationalNumber(state, {
            country: state.country,
            callingCode: newCallingCode
          }), !0;
      }
    }, "fixMissingPlus")
  }, {
    key: "startInternationalNumber",
    value: /* @__PURE__ */ __name(function(state, _ref3) {
      var country = _ref3.country, callingCode = _ref3.callingCode;
      state.startInternationalNumber(country, callingCode), state.nationalSignificantNumber && (state.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }, "startInternationalNumber")
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: /* @__PURE__ */ __name(function(state) {
      this.extractCountryCallingCode(state) && this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
        return state.update(stateUpdate);
      });
    }, "extractCallingCodeAndNationalSignificantNumber")
  }]), AsYouTypeParser2;
}();
function extractFormattedPhoneNumber(text2) {
  var startsAt = text2.search(VALID_FORMATTED_PHONE_NUMBER_PART);
  if (!(startsAt < 0)) {
    text2 = text2.slice(startsAt);
    var hasPlus;
    return text2[0] === "+" && (hasPlus = !0, text2 = text2.slice(1)), text2 = text2.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ""), hasPlus && (text2 = "+" + text2), text2;
  }
}
__name(extractFormattedPhoneNumber, "extractFormattedPhoneNumber");
function _extractFormattedDigitsAndPlus(text2) {
  var extractedNumber = extractFormattedPhoneNumber(text2) || "";
  return extractedNumber[0] === "+" ? [extractedNumber.slice(1), !0] : [extractedNumber];
}
__name(_extractFormattedDigitsAndPlus, "_extractFormattedDigitsAndPlus");
function extractFormattedDigitsAndPlus(text2) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text2), _extractFormattedDigi4 = _slicedToArray$g(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1];
  return VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits) || (formattedDigits = ""), [formattedDigits, hasPlus];
}
__name(extractFormattedDigitsAndPlus, "extractFormattedDigitsAndPlus");
function _slicedToArray$f(arr, i2) {
  return _arrayWithHoles$g(arr) || _iterableToArrayLimit$f(arr, i2) || _unsupportedIterableToArray$n(arr, i2) || _nonIterableRest$g();
}
__name(_slicedToArray$f, "_slicedToArray$f");
function _nonIterableRest$g() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$g, "_nonIterableRest$g");
function _unsupportedIterableToArray$n(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$n(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$n(o, minLen);
  }
}
__name(_unsupportedIterableToArray$n, "_unsupportedIterableToArray$n");
function _arrayLikeToArray$n(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$n, "_arrayLikeToArray$n");
function _iterableToArrayLimit$f(arr, i2) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _arr = [], _n = !0, _d = !1, _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i2 && _arr.length === i2)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
__name(_iterableToArrayLimit$f, "_iterableToArrayLimit$f");
function _arrayWithHoles$g(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$g, "_arrayWithHoles$g");
function _classCallCheck$d(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$d, "_classCallCheck$d");
function _defineProperties$d(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
__name(_defineProperties$d, "_defineProperties$d");
function _createClass$d(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$d(Constructor.prototype, protoProps), staticProps && _defineProperties$d(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$d, "_createClass$d");
var AsYouType$1 = /* @__PURE__ */ function() {
  function AsYouType2(optionsOrDefaultCountry, metadata2) {
    _classCallCheck$d(this, AsYouType2), this.metadata = new Metadata(metadata2);
    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = _slicedToArray$f(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1];
    this.defaultCountry = defaultCountry, this.defaultCallingCode = defaultCallingCode, this.reset();
  }
  return __name(AsYouType2, "AsYouType"), _createClass$d(AsYouType2, [{
    key: "getCountryAndCallingCode",
    value: /* @__PURE__ */ __name(function(optionsOrDefaultCountry) {
      var defaultCountry, defaultCallingCode;
      return optionsOrDefaultCountry && (isObject$a(optionsOrDefaultCountry) ? (defaultCountry = optionsOrDefaultCountry.defaultCountry, defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode) : defaultCountry = optionsOrDefaultCountry), defaultCountry && !this.metadata.hasCountry(defaultCountry) && (defaultCountry = void 0), [defaultCountry, defaultCallingCode];
    }, "getCountryAndCallingCode")
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: /* @__PURE__ */ __name(function(text2) {
      var _this$parser$input = this.parser.input(text2, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
      if (justLeadingPlus)
        this.formattedOutput = "+";
      else if (digits) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var formattedNationalNumber;
        if (this.metadata.hasSelectedNumberingPlan() && (formattedNationalNumber = this.formatter.format(digits, this.state)), formattedNationalNumber === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var nationalDigits = this.state.getNationalDigits();
          nationalDigits && (formattedNationalNumber = this.formatter.format(nationalDigits, this.state));
        }
        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }, "input")
  }, {
    key: "reset",
    value: /* @__PURE__ */ __name(function() {
      var _this = this;
      return this.state = new AsYouTypeState({
        onCountryChange: /* @__PURE__ */ __name(function(country) {
          _this.country = country;
        }, "onCountryChange"),
        onCallingCodeChange: /* @__PURE__ */ __name(function(callingCode, country) {
          _this.metadata.selectNumberingPlan(country, callingCode), _this.formatter.reset(_this.metadata.numberingPlan, _this.state), _this.parser.reset(_this.metadata.numberingPlan);
        }, "onCallingCodeChange")
      }), this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: /* @__PURE__ */ __name(function() {
          _this.determineTheCountryIfNeeded(), _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }, "onNationalSignificantNumberChange")
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }, "reset")
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: /* @__PURE__ */ __name(function() {
      return this.state.international;
    }, "isInternational")
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: /* @__PURE__ */ __name(function() {
      if (this.isInternational())
        return this.state.callingCode;
    }, "getCallingCode")
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: /* @__PURE__ */ __name(function() {
      return this.getCallingCode();
    }, "getCountryCallingCode")
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: /* @__PURE__ */ __name(function() {
      var digits = this.state.digits;
      if (digits)
        return this._getCountry();
    }, "getCountry")
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: /* @__PURE__ */ __name(function() {
      var country = this.state.country;
      return country;
    }, "_getCountry")
  }, {
    key: "determineTheCountryIfNeeded",
    value: /* @__PURE__ */ __name(function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }, "determineTheCountryIfNeeded")
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: /* @__PURE__ */ __name(function(formattedNationalNumber) {
      var _this2 = this;
      if (this.isInternational()) {
        var prefix2 = /* @__PURE__ */ __name(function(text2) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: !!text2
          }) + text2;
        }, "prefix"), callingCode = this.state.callingCode;
        return prefix2(callingCode ? formattedNationalNumber ? "".concat(callingCode, " ").concat(formattedNationalNumber) : callingCode : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return formattedNationalNumber;
    }, "getFullNumber")
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: /* @__PURE__ */ __name(function() {
      var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix, number2 = nationalSignificantNumber, prefix2 = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
      return prefix2 && (number2 = prefix2 + number2), number2;
    }, "getNonFormattedNationalNumberWithPrefix")
  }, {
    key: "getNonFormattedNumber",
    value: /* @__PURE__ */ __name(function() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }, "getNonFormattedNumber")
  }, {
    key: "getNonFormattedTemplate",
    value: /* @__PURE__ */ __name(function() {
      var number2 = this.getNonFormattedNumber();
      if (number2)
        return number2.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
    }, "getNonFormattedTemplate")
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: /* @__PURE__ */ __name(function() {
      var callingCode = this.state.callingCode, countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    }, "isCountryCallingCodeAmbiguous")
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: /* @__PURE__ */ __name(function() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }, "determineTheCountry")
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: /* @__PURE__ */ __name(function() {
      var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber;
      if (digits) {
        if (this.isInternational())
          return callingCode ? "+" + callingCode + nationalSignificantNumber : "+" + digits;
        if (country || callingCode) {
          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
          return "+" + callingCode_ + nationalSignificantNumber;
        }
      }
    }, "getNumberValue")
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: /* @__PURE__ */ __name(function() {
      var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode, country = this._getCountry();
      if (nationalSignificantNumber && !(!country && !callingCode)) {
        if (country && country === this.defaultCountry) {
          var metadata2 = new Metadata(this.metadata.metadata);
          metadata2.selectNumberingPlan(country);
          var _callingCode = metadata2.numberingPlan.callingCode(), ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);
          if (ambiguousCountries.length > 1) {
            var exactCountry = getCountryByNationalNumber(nationalSignificantNumber, {
              countries: ambiguousCountries,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            exactCountry && (country = exactCountry);
          }
        }
        var phoneNumber = new PhoneNumber(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
        return carrierCode && (phoneNumber.carrierCode = carrierCode), phoneNumber;
      }
    }, "getNumber")
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: /* @__PURE__ */ __name(function() {
      var phoneNumber = this.getNumber();
      return phoneNumber ? phoneNumber.isPossible() : !1;
    }, "isPossible")
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: /* @__PURE__ */ __name(function() {
      var phoneNumber = this.getNumber();
      return phoneNumber ? phoneNumber.isValid() : !1;
    }, "isValid")
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: /* @__PURE__ */ __name(function() {
      return this.state.nationalSignificantNumber;
    }, "getNationalNumber")
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: /* @__PURE__ */ __name(function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }, "getChars")
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: /* @__PURE__ */ __name(function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }, "getTemplate")
  }]), AsYouType2;
}();
function parsePhoneNumberWithError$1() {
  return withMetadataArgument$1(parsePhoneNumberWithError$2, arguments);
}
__name(parsePhoneNumberWithError$1, "parsePhoneNumberWithError$1");
function normalizeNumber(number2, prefix2 = "") {
  return number2.startsWith("+") || number2 === "anonymous" ? number2 : `+${prefix2}${number2}`;
}
__name(normalizeNumber, "normalizeNumber");
function formatInternationalNumber(number2, countryCode) {
  try {
    return countryCode ? parsePhoneNumberWithError$1(number2, countryCode).formatInternational() : parsePhoneNumberWithError$1(normalizeNumber(number2)).formatInternational();
  } catch {
    return number2;
  }
}
__name(formatInternationalNumber, "formatInternationalNumber");
function formatLocalizedNumber(number2, locale2 = "en-US") {
  return new Intl.NumberFormat(locale2, {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  }).format(number2);
}
__name(formatLocalizedNumber, "formatLocalizedNumber");
function formatToE164(number2) {
  try {
    return parsePhoneNumberWithError$1(number2).number;
  } catch {
    return number2;
  }
}
__name(formatToE164, "formatToE164");
function toFixedNumber(num2, digits, base = 10) {
  const pow2 = base ** digits;
  return Math.round(num2 * pow2) / pow2;
}
__name(toFixedNumber, "toFixedNumber");
const HOME_ROUTE = "/", COMPANY_ROUTE = "/company", ONBOARDING_ROUTE = "/onboarding", DOWNLOAD_APP_ROUTE = "/download", ANALYTICS_ROUTE = "/analytics", ANALYTICS_ROUTE_TAB = "/analytics/:tab", NUMBERS_ROUTE = "/numbers", NUMBERS_ROUTE_TAB_ACTIVE = "/numbers/active", NUMBERS_ROUTE_TAB_UNVERIFIED = "/numbers/unverified", NUMBER_DETAIL_ROUTE = "/numbers/:numberId", NUMBER_DETAIL_ROUTE_TAB = "/numbers/:numberId/:tab", NUMBER_PURCHASE_ROUTE = "/numbers/purchase", NUMBER_PURCHASE_ROUTE_AT_IVR_CREATION = "/numbers/purchase/:numberId/:key", NUMBER_PURCHASE_ROUTE_AT_IVR_EDITION = "/numbers/purchase/:numberId/:key/:settingId", NUMBER_PROOF_OF_ID_ROUTE = "/numbers/:number/proof_of_id", TEAMS_ROUTE = "/teams", TEAM_DETAIL_ROUTE = "/teams/:teamId", USERS_ROUTE = "/users", USER_DETAIL_ROUTE = "/users/:userId", USER_DETAIL_ROUTE_TAB = "/users/:userId/:tab", CALLS_ROUTE = "/calls", CALLS_CHILD_ROUTE = {
  TAGS: "/calls/tags",
  BLOCKED_NUMBERS: "/calls/blocked_numbers",
  CALL_ASSET: "/calls/:callId/:callType"
}, INTEGRATIONS_ROUTE = "/integrations", INTEGRATIONS_ROUTE_TAB = "/integrations/:tab", CHECK_HEALTH = "/check-health", STATS_ROUTE = "/stats", STATS_ROUTE_TAB = "/stats/:tab", STATS_CHILD_ROUTE = {
  OVERVIEW: "/stats/overview",
  OVERVIEW_BETA: "/stats/overview_beta",
  ANALYTICS: "/stats/analytics",
  ANALYTICS_PLUS: "/stats/analytics_plus",
  MONITORING: "/stats/monitoring",
  INBOUND: "/stats/inbound",
  AVAILABILITIES: "/stats/availabilities",
  CALL_HISTORY: "/stats/call_history"
}, ACTIVITY_FEED_ROUTE = "/activity_feed", INTEGRATION_CHILD_ROUTES = {
  /** Integration settings page */
  INTEGRATION_SETTINGS: "/:applicationType/:integrationName/:integrationId",
  INTEGRATION_SETTINGS_TAB: "/:applicationType/:integrationName/:integrationId/:tab",
  /** Application page */
  APPLICATION: "/app/:applicationType/:applicationName/:applicationId",
  /** Flow installation pages */
  FLOW_INSTALL: "/flow/install/:applicationType/:applicationName/:applicationId",
  FLOW_CREATE: "/flow/create/:applicationType/:applicationName/:applicationId",
  FLOW_COMPLETE: "/flow/complete/:applicationType/:applicationName/:applicationId"
}, INTEGRATION_FULL_ROUTES = Object.keys(
  INTEGRATION_CHILD_ROUTES
).reduce(
  (acc, routeName) => {
    const childRouteName = routeName;
    return acc[childRouteName] = `${INTEGRATIONS_ROUTE}${acc[childRouteName]}`, acc;
  },
  { ...INTEGRATION_CHILD_ROUTES }
), INTEGRATION_AUTHORIZE = "/oauth/authorize", INTEGRATION_AUTHORIZE_SUCCESS = "/oauth/success", ZENDESK_SSO = "/sso/zendesk", SANDBOX_SSO = "/sso/sandbox", LOGIN_SUB_PASSWORD_ROUTE = "/", LOGIN_SUB_SSO_ROUTE = "/sso", LOGIN_ROUTE = "/login", LOGIN_SSO_ROUTE = `${LOGIN_ROUTE}${LOGIN_SUB_SSO_ROUTE}`, FORGOT_PASSWORD_ROUTE = "/forgot_password", RESET_PASSWORD_ROUTE = "/reset_password", CONFIRM_INVITATION_ROUTE = "/confirm_invitation", CONFIRM_USER_CREATION_ROUTE = "/users/confirmation", TEST_ROUTE = "/test", PUBLIC_ROUTES = [
  LOGIN_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  CONFIRM_INVITATION_ROUTE,
  CONFIRM_USER_CREATION_ROUTE,
  DOWNLOAD_APP_ROUTE
], ACCOUNT_ROUTE = "/account", ADDONS_DETAIL_ROUTE = "/addons/:addonName", ACCOUNT_PLAN_PURCHASE_ROUTE = "/account/plan/purchase", ACCOUNT_PLAN_CANCEL_ROUTE = "/account/plan/cancel", ACCOUNT_ROUTE_TAB = "/account/:tab";
var ACCOUNT_TABS = /* @__PURE__ */ ((ACCOUNT_TABS2) => (ACCOUNT_TABS2.GENERAL = "general", ACCOUNT_TABS2.YOUR_PLAN = "plan", ACCOUNT_TABS2.BILLING = "billing", ACCOUNT_TABS2.SECURITY = "security", ACCOUNT_TABS2.PERMISSIONS = "permissions", ACCOUNT_TABS2))(ACCOUNT_TABS || {});
const UNAUTHORIZED_ROUTE = "/unauthorized", ROUTES = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACCOUNT_PLAN_CANCEL_ROUTE,
  ACCOUNT_PLAN_PURCHASE_ROUTE,
  ACCOUNT_ROUTE,
  ACCOUNT_ROUTE_TAB,
  ACCOUNT_TABS,
  ACTIVITY_FEED_ROUTE,
  ADDONS_DETAIL_ROUTE,
  ANALYTICS_ROUTE,
  ANALYTICS_ROUTE_TAB,
  CALLS_CHILD_ROUTE,
  CALLS_ROUTE,
  CHECK_HEALTH,
  COMPANY_ROUTE,
  CONFIRM_INVITATION_ROUTE,
  CONFIRM_USER_CREATION_ROUTE,
  DOWNLOAD_APP_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  HOME_ROUTE,
  INTEGRATIONS_ROUTE,
  INTEGRATIONS_ROUTE_TAB,
  INTEGRATION_AUTHORIZE,
  INTEGRATION_AUTHORIZE_SUCCESS,
  INTEGRATION_CHILD_ROUTES,
  INTEGRATION_FULL_ROUTES,
  LOGIN_ROUTE,
  LOGIN_SSO_ROUTE,
  LOGIN_SUB_PASSWORD_ROUTE,
  LOGIN_SUB_SSO_ROUTE,
  NUMBERS_ROUTE,
  NUMBERS_ROUTE_TAB_ACTIVE,
  NUMBERS_ROUTE_TAB_UNVERIFIED,
  NUMBER_DETAIL_ROUTE,
  NUMBER_DETAIL_ROUTE_TAB,
  NUMBER_PROOF_OF_ID_ROUTE,
  NUMBER_PURCHASE_ROUTE,
  NUMBER_PURCHASE_ROUTE_AT_IVR_CREATION,
  NUMBER_PURCHASE_ROUTE_AT_IVR_EDITION,
  ONBOARDING_ROUTE,
  PUBLIC_ROUTES,
  RESET_PASSWORD_ROUTE,
  SANDBOX_SSO,
  STATS_CHILD_ROUTE,
  STATS_ROUTE,
  STATS_ROUTE_TAB,
  TEAMS_ROUTE,
  TEAM_DETAIL_ROUTE,
  TEST_ROUTE,
  UNAUTHORIZED_ROUTE,
  USERS_ROUTE,
  USER_DETAIL_ROUTE,
  USER_DETAIL_ROUTE_TAB,
  ZENDESK_SSO
}, Symbol.toStringTag, { value: "Module" })), allRoutes = Object.keys(ROUTES).flatMap((key) => {
  const val = ROUTES[key];
  return key === "INTEGRATION_CHILD_ROUTES" ? [] : isObject$f(val) ? Object.values(val) : val;
});
function getRouteFromPath(path) {
  return allRoutes.find((routePath) => matchPath(routePath, path));
}
__name(getRouteFromPath, "getRouteFromPath");
var RESOURCE = /* @__PURE__ */ ((RESOURCE2) => (RESOURCE2.NUMBERS = "NUMBERS", RESOURCE2.TEAMS = "TEAMS", RESOURCE2.USERS = "USERS", RESOURCE2.STATS = "STATS", RESOURCE2.ACTIVITY_FEED = "ACTIVITY_FEED", RESOURCE2.CALL_SETTINGS = "CALL_SETTINGS", RESOURCE2.INTEGRATIONS = "INTEGRATIONS", RESOURCE2.COMPANY_GENERAL = "COMPANY_GENERAL", RESOURCE2.COMPANY_PLAN = "COMPANY_PLAN", RESOURCE2.COMPANY_BILLING = "COMPANY_BILLING", RESOURCE2.COMPANY_SECURITY = "COMPANY_SECURITY", RESOURCE2.COMPANY_ROLES = "COMPANY_ROLES", RESOURCE2.ASSET = "ASSET", RESOURCE2.DASHBOARD_V2 = "DASHBOARD_V2", RESOURCE2.ROLE_MANAGEMENT = "ROLE_MANAGEMENT", RESOURCE2.CONVERSATIONS_CENTER = "CONVERSATIONS_CENTER", RESOURCE2.CONTACTS = "CONTACTS", RESOURCE2))(RESOURCE || {}), PERMISSIONS_ACTIONS = /* @__PURE__ */ ((PERMISSIONS_ACTIONS2) => (PERMISSIONS_ACTIONS2.CREATE = "c", PERMISSIONS_ACTIONS2.READ = "r", PERMISSIONS_ACTIONS2.UPDATE = "u", PERMISSIONS_ACTIONS2.DELETE = "d", PERMISSIONS_ACTIONS2))(PERMISSIONS_ACTIONS || {});
const ROLE_NAME = {
  OWNER: "Owner",
  ADMIN: "Admin",
  SUPERVISOR: "Supervisor",
  AGENT: "Agent"
}, ROLE_ORDER = {
  [ROLE_NAME.OWNER]: 1,
  [ROLE_NAME.ADMIN]: 2,
  [ROLE_NAME.SUPERVISOR]: 3,
  [ROLE_NAME.AGENT]: 4
}, PERMISSIONS_MODAL_LS_KEY = "permissions_modal";
function getResourceFromPath(path, routesResourcesMapping) {
  if (path in routesResourcesMapping)
    return routesResourcesMapping[path];
  const route = getRouteFromPath(path);
  return route && route in routesResourcesMapping ? routesResourcesMapping[route] : null;
}
__name(getResourceFromPath, "getResourceFromPath");
function hasRole(roles, roleName) {
  return roles.some((r2) => r2.name === roleName);
}
__name(hasRole, "hasRole");
function isOnlyAgent(roles) {
  return roles.length === 1 && roles[0] === ROLE_NAME.AGENT;
}
__name(isOnlyAgent, "isOnlyAgent");
function canDeleteUser(userId, userRoles, userToDeleteId, userToDeleteRoles) {
  return userId === userToDeleteId ? !1 : hasRole(userRoles, ROLE_NAME.ADMIN) && hasRole(userRoles, ROLE_NAME.OWNER) ? !0 : hasRole(userRoles, ROLE_NAME.OWNER) ? hasRole(userToDeleteRoles, ROLE_NAME.OWNER) : hasRole(userRoles, ROLE_NAME.ADMIN) ? !hasRole(userToDeleteRoles, ROLE_NAME.OWNER) : !1;
}
__name(canDeleteUser, "canDeleteUser");
const forwardRefWithGenericType = React__default.forwardRef;
function reverseOrderDirection(orderDirection) {
  return orderDirection === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc;
}
__name(reverseOrderDirection, "reverseOrderDirection");
function computeThemeVariantFromInitials(initials, variants = ["default", "blue", "green", "yellow"]) {
  return variants[(initials.charCodeAt(0) + (initials.charCodeAt(1) || 0)) % variants.length];
}
__name(computeThemeVariantFromInitials, "computeThemeVariantFromInitials");
const defaultColors = defaultTheme.colors, dashboardTheme = {
  ...defaultTheme,
  colors: {
    // Customize colors here
    ...defaultColors
  }
}, _InvalidTokenError = class _InvalidTokenError extends Error {
};
__name(_InvalidTokenError, "InvalidTokenError");
let InvalidTokenError = _InvalidTokenError;
InvalidTokenError.prototype.name = "InvalidTokenError";
function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, (m3, p) => {
    let code2 = p.charCodeAt(0).toString(16).toUpperCase();
    return code2.length < 2 && (code2 = "0" + code2), "%" + code2;
  }));
}
__name(b64DecodeUnicode, "b64DecodeUnicode");
function base64UrlDecode(str) {
  let output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return b64DecodeUnicode(output);
  } catch {
    return atob(output);
  }
}
__name(base64UrlDecode, "base64UrlDecode");
function jwtDecode(token, options) {
  if (typeof token != "string")
    throw new InvalidTokenError("Invalid token specified: must be a string");
  options || (options = {});
  const pos = options.header === !0 ? 0 : 1, part = token.split(".")[pos];
  if (typeof part != "string")
    throw new InvalidTokenError(`Invalid token specified: missing part #${pos + 1}`);
  let decoded;
  try {
    decoded = base64UrlDecode(part);
  } catch (e3) {
    throw new InvalidTokenError(`Invalid token specified: invalid base64 for part #${pos + 1} (${e3.message})`);
  }
  try {
    return JSON.parse(decoded);
  } catch (e3) {
    throw new InvalidTokenError(`Invalid token specified: invalid json for part #${pos + 1} (${e3.message})`);
  }
}
__name(jwtDecode, "jwtDecode");
function safeJSONParse(data2, replacer) {
  try {
    return JSON.parse(data2, replacer);
  } catch (error) {
    return console.error("JSON parsing failed", {
      rawData: data2,
      error
    }), null;
  }
}
__name(safeJSONParse, "safeJSONParse");
function mapActions(action) {
  const char = action.toLowerCase().charAt(0);
  return !char || !Object.values(PERMISSIONS_ACTIONS).includes(char) ? null : char;
}
__name(mapActions, "mapActions");
function parsePermissions(permissionsStr) {
  const customPermissionsJson = safeJSONParse(permissionsStr);
  return customPermissionsJson ? Object.entries(customPermissionsJson).reduce(
    (acc, [resource, actions]) => {
      const mappedActions = actions.map(mapActions).filter(isTruthy);
      return { ...acc, [resource]: mappedActions };
    },
    {}
  ) : {};
}
__name(parsePermissions, "parsePermissions");
function parseRoles(rolesStr) {
  const rolesJson = safeJSONParse(rolesStr);
  return rolesJson ? rolesJson.map((role) => role) : [];
}
__name(parseRoles, "parseRoles");
function parseToken(decodedToken) {
  const rolesKey = "custom:roles", rolesStr = decodedToken[rolesKey] || "[]", customRoles = parseRoles(rolesStr), permissionsKey = "custom:permissions", permissionsStr = decodedToken[permissionsKey] || "{}", customPermissions = parsePermissions(permissionsStr);
  return {
    ...decodedToken,
    [permissionsKey]: customPermissions,
    [rolesKey]: customRoles
  };
}
__name(parseToken, "parseToken");
function decodeToken(t3) {
  const decodedToken = jwtDecode(t3);
  return parseToken(decodedToken);
}
__name(decodeToken, "decodeToken");
const getCommonPayload = /* @__PURE__ */ __name(({
  platform: platform2 = "dashboard",
  release
}) => ({
  platform: platform2,
  release,
  screen_size: `${window.screen.width}x${window.screen.height}`,
  window_size: `${window.outerWidth}x${window.outerHeight}`,
  os_version: getOperatingSystem().osVersion
}), "getCommonPayload"), getTrackSettingsProperties = /* @__PURE__ */ __name(({
  event,
  settingsSection,
  setting,
  field,
  action,
  isOwnUser
}) => ({
  event,
  payload: {
    ...isOwnUser !== void 0 && {
      target_user: isOwnUser ? "self" : "other_user"
    },
    settings_section: settingsSection,
    setting,
    action: `${snakeCase$1(field)}_${action || "updated"}`
  }
}), "getTrackSettingsProperties");
function isDefined$1(value) {
  return typeof value < "u";
}
__name(isDefined$1, "isDefined$1");
function isTruthy(value) {
  return !!value;
}
__name(isTruthy, "isTruthy");
const metadata = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument(func2, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  return args.push(metadata), func2.apply(this, args);
}
__name(withMetadataArgument, "withMetadataArgument");
function parsePhoneNumberWithError() {
  return withMetadataArgument(parsePhoneNumberWithError$2, arguments);
}
__name(parsePhoneNumberWithError, "parsePhoneNumberWithError");
function isValidPhoneNumber() {
  return withMetadataArgument(isValidPhoneNumber$1, arguments);
}
__name(isValidPhoneNumber, "isValidPhoneNumber");
function AsYouType(country) {
  return AsYouType$1.call(this, country, metadata);
}
__name(AsYouType, "AsYouType");
AsYouType.prototype = Object.create(AsYouType$1.prototype, {});
AsYouType.prototype.constructor = AsYouType;
const validateRequired = /* @__PURE__ */ __name((value) => value ? void 0 : FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.REQUIRED_FIELD, "validateRequired"), validateEmail = /* @__PURE__ */ __name((email) => {
  const isEmpty = validateRequired(email);
  return isEmpty || (VALIDATE_EMAIL_REGEX.test(email) ? void 0 : FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.INVALID_EMAIL);
}, "validateEmail"), validateAlreadyExists = /* @__PURE__ */ __name((values) => (value) => {
  if (values.includes(value))
    return FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.ALREADY_EXISTS;
}, "validateAlreadyExists"), validateConfirmedPassword = /* @__PURE__ */ __name((passwordKey) => (value, allValues) => {
  const isEmpty = validateRequired(value);
  return isEmpty || (value === allValues[passwordKey] ? void 0 : FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.PASSWORD_NOT_MATCH);
}, "validateConfirmedPassword"), validatePasswordLength = /* @__PURE__ */ __name((password) => VALIDATE_PASSWORD_LENGTH_REGEX.test(password) ? void 0 : FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.PASSWORD_LENGTH, "validatePasswordLength"), validatePasswordStrength = /* @__PURE__ */ __name((password) => VALIDATE_PASSWORD_STRENGTH_REGEX.test(password) ? void 0 : FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.PASSWORD_STRENGTH, "validatePasswordStrength"), validateMaxLength = /* @__PURE__ */ __name((max2) => (value = "") => value.length > max2 ? FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.MAX_LENGTH : void 0, "validateMaxLength"), validateUrlFormat = /* @__PURE__ */ __name((urlFormatRegex) => (value) => (urlFormatRegex || VALIDATE_URL_FORMAT_REGEX).test(value) ? void 0 : FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.WRONG_FORMAT, "validateUrlFormat"), pipeValidators = /* @__PURE__ */ __name((...validators) => (value) => validators.reduce(
  (error, validator) => error || validator(value, {}),
  void 0
), "pipeValidators"), validateMinValue = /* @__PURE__ */ __name((min2) => (value) => {
  if (!value)
    return;
  const number2 = parseInt(value);
  if (Number.isNaN(number2) || number2 < min2)
    return FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.INVALID_VALUE;
}, "validateMinValue"), validateMaxValue = /* @__PURE__ */ __name((max2) => (value) => {
  if (!value)
    return;
  const number2 = parseInt(value);
  if (Number.isNaN(number2) || number2 > max2)
    return FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.INVALID_VALUE;
}, "validateMaxValue"), validateNumberOnly = /* @__PURE__ */ __name((value) => value ? !VALIDATE_NUMBERS_ONLY_REGEX.test(value) && FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.WRONG_FORMAT : !1, "validateNumberOnly"), validatePercentage = /* @__PURE__ */ __name((value) => !value || VALIDATE_NUMBERS_ONLY_REGEX.test(value) || VALIDATE_PERCENTAGE_ONLY_REGEX.test(value) ? !1 : FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.WRONG_FORMAT, "validatePercentage"), validateUniquePhoneNumber = /* @__PURE__ */ __name((numbersList) => (number2) => {
  if (!number2)
    return;
  const getRawNumber = /* @__PURE__ */ __name((formattedNumber) => formattedNumber.replace(MATCH_NON_DIGITS_REGEX, ""), "getRawNumber");
  return numbersList.some(
    (numberFromList) => getRawNumber(numberFromList) === getRawNumber(number2)
  ) ? FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.ALREADY_EXISTS : void 0;
}, "validateUniquePhoneNumber"), validatePhoneNumberFormat = /* @__PURE__ */ __name((number2) => {
  if (!number2 || number2.length < 6)
    return FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.TOO_SHORT;
  try {
    const { country, number: parsedPhoneNumber } = parsePhoneNumberWithError(number2);
    return isValidPhoneNumber(parsedPhoneNumber.toString(), country) ? void 0 : FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.WRONG_FORMAT;
  } catch {
    return FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.INVALID_VALUE;
  }
}, "validatePhoneNumberFormat"), validateNumberName = /* @__PURE__ */ __name((value) => {
  if (/[,%_^"]/.test(value))
    return FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS.INVALID_NUMBER_NAME;
}, "validateNumberName");
function tzTokenizeDate(date2, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date2) : hackyOffset(dtf, date2);
}
__name(tzTokenizeDate, "tzTokenizeDate");
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function partsOffset(dtf, date2) {
  try {
    for (var formatted = dtf.formatToParts(date2), filled = [], i2 = 0; i2 < formatted.length; i2++) {
      var pos = typeToPos[formatted[i2].type];
      pos >= 0 && (filled[pos] = parseInt(formatted[i2].value, 10));
    }
    return filled;
  } catch (error) {
    if (error instanceof RangeError)
      return [NaN];
    throw error;
  }
}
__name(partsOffset, "partsOffset");
function hackyOffset(dtf, date2) {
  var formatted = dtf.format(date2).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
}
__name(hackyOffset, "hackyOffset");
var dtfCache = {};
function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    var testDateFormatted = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return dtfCache[timeZone];
}
__name(getDateTimeFormat, "getDateTimeFormat");
function newDateUTC(fullYear, month, day, hour, minute, second2, millisecond2) {
  var utcDate2 = /* @__PURE__ */ new Date(0);
  return utcDate2.setUTCFullYear(fullYear, month, day), utcDate2.setUTCHours(hour, minute, second2, millisecond2), utcDate2;
}
__name(newDateUTC, "newDateUTC");
var MILLISECONDS_IN_HOUR = 36e5, MILLISECONDS_IN_MINUTE = 6e4, patterns = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function tzParseTimezone(timezoneString, date2, isUtcDate) {
  var token, absoluteOffset;
  if (!timezoneString || (token = patterns.timezoneZ.exec(timezoneString), token))
    return 0;
  var hours;
  if (token = patterns.timezoneHH.exec(timezoneString), token)
    return hours = parseInt(token[1], 10), validateTimezone(hours) ? -(hours * MILLISECONDS_IN_HOUR) : NaN;
  if (token = patterns.timezoneHHMM.exec(timezoneString), token) {
    hours = parseInt(token[1], 10);
    var minutes = parseInt(token[2], 10);
    return validateTimezone(hours, minutes) ? (absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE, hours > 0 ? -absoluteOffset : absoluteOffset) : NaN;
  }
  if (isValidTimezoneIANAString(timezoneString)) {
    date2 = new Date(date2 || Date.now());
    var utcDate2 = isUtcDate ? date2 : toUtcDate(date2), offset = calcOffset(utcDate2, timezoneString), fixedOffset = isUtcDate ? offset : fixOffset(date2, offset, timezoneString);
    return -fixedOffset;
  }
  return NaN;
}
__name(tzParseTimezone, "tzParseTimezone");
function toUtcDate(date2) {
  return newDateUTC(
    date2.getFullYear(),
    date2.getMonth(),
    date2.getDate(),
    date2.getHours(),
    date2.getMinutes(),
    date2.getSeconds(),
    date2.getMilliseconds()
  );
}
__name(toUtcDate, "toUtcDate");
function calcOffset(date2, timezoneString) {
  var tokens = tzTokenizeDate(date2, timezoneString), asUTC = newDateUTC(
    tokens[0],
    tokens[1] - 1,
    tokens[2],
    tokens[3] % 24,
    tokens[4],
    tokens[5],
    0
  ).getTime(), asTS = date2.getTime(), over = asTS % 1e3;
  return asTS -= over >= 0 ? over : 1e3 + over, asUTC - asTS;
}
__name(calcOffset, "calcOffset");
function fixOffset(date2, offset, timezoneString) {
  var localTS = date2.getTime(), utcGuess = localTS - offset, o2 = calcOffset(new Date(utcGuess), timezoneString);
  if (offset === o2)
    return offset;
  utcGuess -= o2 - offset;
  var o3 = calcOffset(new Date(utcGuess), timezoneString);
  return o2 === o3 ? o2 : Math.max(o2, o3);
}
__name(fixOffset, "fixOffset");
function validateTimezone(hours, minutes) {
  return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
__name(validateTimezone, "validateTimezone");
var validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: timeZoneString }), validIANATimezoneCache[timeZoneString] = !0, !0;
  } catch {
    return !1;
  }
}
__name(isValidTimezoneIANAString, "isValidTimezoneIANAString");
function getTimezoneOffset(timeZone, date2) {
  return -tzParseTimezone(timeZone, date2);
}
__name(getTimezoneOffset, "getTimezoneOffset");
const browserTimezones = Intl.supportedValuesOf(
  "timeZone"
), LEGACY_TIMEZONES = [
  {
    value: "Etc/GMT+12",
    name: "International Date Line West"
  },
  {
    value: "Pacific/Pago_Pago",
    name: "American Samoa"
  },
  {
    value: "Pacific/Midway",
    name: "Midway Island"
  },
  {
    value: "Pacific/Honolulu",
    name: "Hawaii"
  },
  {
    value: "America/Juneau",
    name: "Alaska"
  },
  {
    value: "America/Los_Angeles",
    name: "Pacific Time (US & Canada)"
  },
  {
    value: "America/Tijuana",
    name: "Tijuana"
  },
  {
    value: "America/Phoenix",
    name: "Arizona"
  },
  {
    value: "America/Chihuahua",
    name: "Chihuahua"
  },
  {
    value: "America/Mazatlan",
    name: "Mazatlan"
  },
  {
    value: "America/Denver",
    name: "Mountain Time (US & Canada)"
  },
  {
    value: "America/Guatemala",
    name: "Central America"
  },
  {
    value: "America/Chicago",
    name: "Central Time (US & Canada)"
  },
  {
    value: "America/Mexico_City",
    name: "Mexico City"
  },
  {
    value: "America/Monterrey",
    name: "Monterrey"
  },
  {
    value: "America/Regina",
    name: "Saskatchewan"
  },
  {
    value: "America/Bogota",
    name: "Bogota"
  },
  {
    value: "America/New_York",
    name: "Eastern Time (US & Canada)"
  },
  {
    value: "America/Indiana/Indianapolis",
    name: "Indiana (East)"
  },
  {
    value: "America/Lima",
    name: "Lima"
  },
  {
    value: "America/Halifax",
    name: "Atlantic Time (Canada)"
  },
  {
    value: "America/Caracas",
    name: "Caracas"
  },
  {
    value: "America/Guyana",
    name: "Georgetown"
  },
  {
    value: "America/La_Paz",
    name: "La Paz"
  },
  {
    value: "America/Puerto_Rico",
    name: "Puerto Rico"
  },
  {
    value: "America/Santiago",
    name: "Santiago"
  },
  {
    value: "America/St_Johns",
    name: "Newfoundland"
  },
  {
    value: "America/Sao_Paulo",
    name: "Brasilia"
  },
  {
    value: "America/Argentina/Buenos_Aires",
    name: "Buenos Aires"
  },
  {
    value: "America/Godthab",
    name: "Greenland"
  },
  {
    value: "America/Montevideo",
    name: "Montevideo"
  },
  {
    value: "Atlantic/South_Georgia",
    name: "Mid-Atlantic"
  },
  {
    value: "Atlantic/Azores",
    name: "Azores"
  },
  {
    value: "Atlantic/Cape_Verde",
    name: "Cape Verde Is."
  },
  {
    value: "Africa/Casablanca",
    name: "Casablanca"
  },
  {
    value: "Europe/Dublin",
    name: "Dublin"
  },
  {
    value: "Europe/Lisbon",
    name: "Lisbon"
  },
  {
    value: "Europe/London",
    name: "London"
  },
  {
    value: "Africa/Monrovia",
    name: "Monrovia"
  },
  {
    value: "Etc/UTC",
    name: "UTC"
  },
  {
    value: "Europe/Amsterdam",
    name: "Amsterdam"
  },
  {
    value: "Europe/Belgrade",
    name: "Belgrade"
  },
  {
    value: "Europe/Berlin",
    name: "Berlin"
  },
  {
    value: "Europe/Bratislava",
    name: "Bratislava"
  },
  {
    value: "Europe/Brussels",
    name: "Brussels"
  },
  {
    value: "Europe/Budapest",
    name: "Budapest"
  },
  {
    value: "Europe/Copenhagen",
    name: "Copenhagen"
  },
  {
    value: "Europe/Ljubljana",
    name: "Ljubljana"
  },
  {
    value: "Europe/Madrid",
    name: "Madrid"
  },
  {
    value: "Europe/Paris",
    name: "Paris"
  },
  {
    value: "Europe/Prague",
    name: "Prague"
  },
  {
    value: "Europe/Rome",
    name: "Rome"
  },
  {
    value: "Europe/Sarajevo",
    name: "Sarajevo"
  },
  {
    value: "Europe/Skopje",
    name: "Skopje"
  },
  {
    value: "Europe/Stockholm",
    name: "Stockholm"
  },
  {
    value: "Europe/Vienna",
    name: "Vienna"
  },
  {
    value: "Europe/Warsaw",
    name: "Warsaw"
  },
  {
    value: "Africa/Algiers",
    name: "West Central Africa"
  },
  {
    value: "Europe/Zagreb",
    name: "Zagreb"
  },
  {
    value: "Europe/Zurich",
    name: "Zurich"
  },
  {
    value: "Europe/Athens",
    name: "Athens"
  },
  {
    value: "Europe/Bucharest",
    name: "Bucharest"
  },
  {
    value: "Africa/Cairo",
    name: "Cairo"
  },
  {
    value: "Africa/Harare",
    name: "Harare"
  },
  {
    value: "Europe/Helsinki",
    name: "Helsinki"
  },
  {
    value: "Asia/Jerusalem",
    name: "Jerusalem"
  },
  {
    value: "Europe/Kaliningrad",
    name: "Kaliningrad"
  },
  {
    value: "Europe/Kiev",
    name: "Kyiv"
  },
  {
    value: "Africa/Johannesburg",
    name: "Pretoria"
  },
  {
    value: "Europe/Riga",
    name: "Riga"
  },
  {
    value: "Europe/Sofia",
    name: "Sofia"
  },
  {
    value: "Europe/Tallinn",
    name: "Tallinn"
  },
  {
    value: "Europe/Vilnius",
    name: "Vilnius"
  },
  {
    value: "Asia/Baghdad",
    name: "Baghdad"
  },
  {
    value: "Europe/Istanbul",
    name: "Istanbul"
  },
  {
    value: "Asia/Kuwait",
    name: "Kuwait"
  },
  {
    value: "Europe/Minsk",
    name: "Minsk"
  },
  {
    value: "Europe/Moscow",
    name: "Moscow"
  },
  {
    value: "Africa/Nairobi",
    name: "Nairobi"
  },
  {
    value: "Asia/Riyadh",
    name: "Riyadh"
  },
  {
    value: "Asia/Tehran",
    name: "Tehran"
  },
  {
    value: "Asia/Baku",
    name: "Baku"
  },
  {
    value: "Asia/Muscat",
    name: "Muscat"
  },
  {
    value: "Europe/Samara",
    name: "Samara"
  },
  {
    value: "Asia/Tbilisi",
    name: "Tbilisi"
  },
  {
    value: "Europe/Volgograd",
    name: "Volgograd"
  },
  {
    value: "Asia/Yerevan",
    name: "Yerevan"
  },
  {
    value: "Asia/Kabul",
    name: "Kabul"
  },
  {
    value: "Asia/Yekaterinburg",
    name: "Ekaterinburg"
  },
  {
    value: "Asia/Karachi",
    name: "Karachi"
  },
  {
    value: "Asia/Tashkent",
    name: "Tashkent"
  },
  {
    value: "Asia/Kolkata",
    name: "Kolkata"
  },
  {
    value: "Asia/Colombo",
    name: "Sri Jayawardenepura"
  },
  {
    value: "Asia/Kathmandu",
    name: "Kathmandu"
  },
  {
    value: "Asia/Almaty",
    name: "Almaty"
  },
  {
    value: "Asia/Dhaka",
    name: "Dhaka"
  },
  {
    value: "Asia/Urumqi",
    name: "Urumqi"
  },
  {
    value: "Asia/Rangoon",
    name: "Rangoon"
  },
  {
    value: "Asia/Bangkok",
    name: "Bangkok"
  },
  {
    value: "Asia/Jakarta",
    name: "Jakarta"
  },
  {
    value: "Asia/Krasnoyarsk",
    name: "Krasnoyarsk"
  },
  {
    value: "Asia/Novosibirsk",
    name: "Novosibirsk"
  },
  {
    value: "Asia/Shanghai",
    name: "Beijing"
  },
  {
    value: "Asia/Chongqing",
    name: "Chongqing"
  },
  {
    value: "Asia/Hong_Kong",
    name: "Hong Kong"
  },
  {
    value: "Asia/Irkutsk",
    name: "Irkutsk"
  },
  {
    value: "Asia/Kuala_Lumpur",
    name: "Kuala Lumpur"
  },
  {
    value: "Australia/Perth",
    name: "Perth"
  },
  {
    value: "Asia/Singapore",
    name: "Singapore"
  },
  {
    value: "Asia/Taipei",
    name: "Taipei"
  },
  {
    value: "Asia/Ulaanbaatar",
    name: "Ulaanbaatar"
  },
  {
    value: "Asia/Seoul",
    name: "Seoul"
  },
  {
    value: "Asia/Tokyo",
    name: "Tokyo"
  },
  {
    value: "Asia/Yakutsk",
    name: "Yakutsk"
  },
  {
    value: "Australia/Adelaide",
    name: "Adelaide"
  },
  {
    value: "Australia/Darwin",
    name: "Darwin"
  },
  {
    value: "Australia/Brisbane",
    name: "Brisbane"
  },
  {
    value: "Pacific/Guam",
    name: "Guam"
  },
  {
    value: "Australia/Hobart",
    name: "Hobart"
  },
  {
    value: "Australia/Melbourne",
    name: "Melbourne"
  },
  {
    value: "Pacific/Port_Moresby",
    name: "Port Moresby"
  },
  {
    value: "Australia/Sydney",
    name: "Sydney"
  },
  {
    value: "Asia/Vladivostok",
    name: "Vladivostok"
  },
  {
    value: "Asia/Magadan",
    name: "Magadan"
  },
  {
    value: "Pacific/Noumea",
    name: "New Caledonia"
  },
  {
    value: "Pacific/Guadalcanal",
    name: "Solomon Is."
  },
  {
    value: "Asia/Srednekolymsk",
    name: "Srednekolymsk"
  },
  {
    value: "Pacific/Auckland",
    name: "Auckland"
  },
  {
    value: "Pacific/Fiji",
    name: "Fiji"
  },
  {
    value: "Asia/Kamchatka",
    name: "Kamchatka"
  },
  {
    value: "Pacific/Majuro",
    name: "Marshall Is."
  },
  {
    value: "Pacific/Chatham",
    name: "Chatham Is."
  },
  {
    value: "Pacific/Tongatapu",
    name: "Nuku'alofa"
  },
  {
    value: "Pacific/Apia",
    name: "Samoa"
  },
  {
    value: "Pacific/Fakaofo",
    name: "Tokelau Is."
  }
], prettifyTimezoneName = /* @__PURE__ */ __name((input) => input.replace(/\//g, " - ").replace(/_/g, " "), "prettifyTimezoneName"), TIMEZONES = unionBy$1(
  browserTimezones.map((tz) => ({
    name: prettifyTimezoneName(tz),
    value: tz
  })),
  LEGACY_TIMEZONES,
  "value"
);
function getFormattedTimezoneOffset(timezoneValue) {
  const offsetMs = getTimezoneOffset(timezoneValue), sign2 = offsetMs >= 0 ? "+" : "-";
  let hours = Math.abs(Math.floor(offsetMs / 36e5));
  timezoneValue === "America/St_Johns" && (hours -= 1);
  const formattedHours = sign2 + hours.toString().padStart(2, "0"), formattedMinutes = (Math.abs(offsetMs) % 36e5 / 6e4).toString().padStart(2, "0");
  return `${formattedHours}:${formattedMinutes}`;
}
__name(getFormattedTimezoneOffset, "getFormattedTimezoneOffset");
function getTimezones(timezones = TIMEZONES) {
  function includeUtcOffset(tz) {
    const formattedOffset = getFormattedTimezoneOffset(tz.value);
    return {
      ...tz,
      formattedOffset,
      formattedUtcOffset: `UTC${formattedOffset}`,
      utcOffset: parseInt(formattedOffset.replace(":", ""), 10)
    };
  }
  __name(includeUtcOffset, "includeUtcOffset");
  function sortByUtcOffset(a4, b2) {
    return a4.utcOffset !== b2.utcOffset ? a4.utcOffset > b2.utcOffset ? 1 : -1 : a4.name > b2.name ? 1 : -1;
  }
  return __name(sortByUtcOffset, "sortByUtcOffset"), timezones.map(includeUtcOffset).sort(sortByUtcOffset);
}
__name(getTimezones, "getTimezones");
const LANGUAGES = [
  {
    label: "English",
    languageCode: "EN",
    countryCode: "GB"
  },
  {
    label: "Français",
    languageCode: "FR",
    countryCode: "FR"
  },
  {
    label: "Español",
    languageCode: "ES",
    countryCode: "ES"
  },
  {
    label: "Deutsch",
    languageCode: "DE",
    countryCode: "DE"
  },
  {
    label: "Italiano",
    languageCode: "IT",
    countryCode: "IT"
  },
  {
    label: "Norsk Bokmål",
    languageCode: "NB",
    countryCode: "NO"
  },
  {
    label: "Nederlands",
    languageCode: "NL",
    countryCode: "NL"
  }
];
function getCountryCodeFromLanguage(lang) {
  var _a3;
  return (_a3 = LANGUAGES.find((l) => l.languageCode === lang)) == null ? void 0 : _a3.countryCode;
}
__name(getCountryCodeFromLanguage, "getCountryCodeFromLanguage");
function getLabelFromLanguage(lang) {
  var _a3;
  return (_a3 = LANGUAGES.find((l) => l.languageCode === lang)) == null ? void 0 : _a3.label;
}
__name(getLabelFromLanguage, "getLabelFromLanguage");
var LICENSE_NAME = /* @__PURE__ */ ((LICENSE_NAME2) => (LICENSE_NAME2.AI_ASSIST_PRO = "ai_assist_pro", LICENSE_NAME2.ANALYTICS_PLUS = "analytics_plus", LICENSE_NAME2.AIRCALL_AI = "aircall_ai", LICENSE_NAME2.WHATSAPP_MESSAGING = "whatsapp_messaging", LICENSE_NAME2.SALESFORCE_SERVICE_CLOUD_VOICE = "salesforce_service_cloud_voice", LICENSE_NAME2))(LICENSE_NAME || {});
function checkUserHasLicense(licenseName, userLicenses) {
  return userLicenses.some((l) => l.name === licenseName && l.active);
}
__name(checkUserHasLicense, "checkUserHasLicense");
function checkLicenseExpression(expression, userLicenses) {
  return expression === null ? !0 : typeof expression == "string" ? checkUserHasLicense(expression, userLicenses) : "and" in expression ? expression.and.every(
    (expr) => checkLicenseExpression(expr, userLicenses)
  ) : "or" in expression ? expression.or.some(
    (expr) => checkLicenseExpression(expr, userLicenses)
  ) : !1;
}
__name(checkLicenseExpression, "checkLicenseExpression");
const Avatar = React__default.memo(
  ({
    initials,
    "data-test": dataTest = "dashboard-avatar",
    src,
    variant,
    ...avatarProps
  }) => {
    const _variant = variant || computeThemeVariantFromInitials(initials);
    return /* @__PURE__ */ jsx(Avatar$1, { "data-test": dataTest, variant: _variant, ...avatarProps, children: src ? /* @__PURE__ */ jsx(AvatarImg, { src }) : /* @__PURE__ */ jsx(AvatarText, { initials }) });
  }
);
function CallStatusTooltipContent({
  status,
  tooltipDurations,
  texts: texts2
}) {
  let content2 = null;
  switch (status) {
    case LiveMonitoringCallStatus.IN_IVR: {
      content2 = /* @__PURE__ */ jsx(Typography, { children: texts2.tooltip });
      break;
    }
    case LiveMonitoringCallStatus.RINGING:
    case LiveMonitoringCallStatus.IN_CALL:
    case LiveMonitoringCallStatus.IN_CALL_AI_VOICE_AGENT:
    case LiveMonitoringCallStatus.IN_QUEUE:
    case CustomCallStatus.CALLBACK_PENDING: {
      content2 = /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Typography, { children: texts2.tooltip }) });
      break;
    }
    case LiveMonitoringCallStatus.UNANSWERED:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_BEFORE_10_SECONDS:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_IN_IVR:
    case LiveMonitoringCallStatus.UNANSWERED_ALL_AGENTS_UNAVAILABLE:
    case LiveMonitoringCallStatus.UNANSWERED_CALLBACK_REQUEST:
    case LiveMonitoringCallStatus.UNANSWERED_OUTSIDE_BUSINESS_HOURS:
    case LiveMonitoringCallStatus.UNANSWERED_USERS_DID_NOT_ANSWER:
    case LiveMonitoringCallStatus.ANSWERED: {
      content2 = /* @__PURE__ */ jsx(
        TooltipContent$2,
        {
          rows: tooltipDurations.map((d3, index2) => {
            var _a3;
            return [
              // eslint-disable-next-line react/no-array-index-key
              /* @__PURE__ */ jsx(Duration, { display: "inline", seconds: d3 }, index2),
              (_a3 = texts2.tooltipDurations) == null ? void 0 : _a3[index2]
            ];
          })
        }
      );
      break;
    }
  }
  return /* @__PURE__ */ jsx(Box, { "data-test": "call-status-tooltip-content", children: content2 });
}
__name(CallStatusTooltipContent, "CallStatusTooltipContent");
function CallStatusText({
  duration,
  status,
  texts: texts2
}) {
  let color2 = "text-base", node2 = null;
  switch (status) {
    case LiveMonitoringCallStatus.IN_IVR:
    case LiveMonitoringCallStatus.IN_QUEUE:
    case LiveMonitoringCallStatus.RINGING:
    case LiveMonitoringCallStatus.IN_CALL:
    case LiveMonitoringCallStatus.IN_CALL_AI_VOICE_AGENT:
    case CustomCallStatus.CALLBACK_PENDING:
      node2 = /* @__PURE__ */ jsx(Typography, { color: color2, ellipsis: !0, variant: "bodyMediumS", children: texts2.title });
      break;
    case LiveMonitoringCallStatus.ANSWERED:
      node2 = /* @__PURE__ */ jsx(
        Duration,
        {
          color: color2,
          ellipsis: !0,
          variant: "bodyMediumS",
          seconds: duration,
          children: (formattedDuration) => texts2.duration(formattedDuration)
        }
      );
      break;
    case LiveMonitoringCallStatus.UNANSWERED:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_BEFORE_10_SECONDS:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_IN_IVR:
    case LiveMonitoringCallStatus.UNANSWERED_ALL_AGENTS_UNAVAILABLE:
    case LiveMonitoringCallStatus.UNANSWERED_CALLBACK_REQUEST:
    case LiveMonitoringCallStatus.UNANSWERED_OUTSIDE_BUSINESS_HOURS:
    case LiveMonitoringCallStatus.UNANSWERED_USERS_DID_NOT_ANSWER:
      color2 = "text-placeholder", node2 = /* @__PURE__ */ jsx(Typography, { color: color2, ellipsis: !0, variant: "bodyMediumS", children: "0s" });
      break;
  }
  return node2;
}
__name(CallStatusText, "CallStatusText");
function CallStatusDuration({
  status,
  duration,
  texts: texts2
}) {
  let node2 = null;
  switch (status) {
    case LiveMonitoringCallStatus.IN_IVR:
    case LiveMonitoringCallStatus.IN_QUEUE:
    case LiveMonitoringCallStatus.RINGING:
    case LiveMonitoringCallStatus.IN_CALL:
    case LiveMonitoringCallStatus.IN_CALL_AI_VOICE_AGENT:
    case CustomCallStatus.CALLBACK_PENDING:
      node2 = /* @__PURE__ */ jsx(
        LiveDuration,
        {
          color: "neutral-400",
          ellipsis: !0,
          variant: "supportingMediumS",
          seconds: duration,
          children: (d3) => texts2.duration(d3)
        }
      );
      break;
    case LiveMonitoringCallStatus.ANSWERED:
    case LiveMonitoringCallStatus.UNANSWERED:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_BEFORE_10_SECONDS:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_IN_IVR:
    case LiveMonitoringCallStatus.UNANSWERED_ALL_AGENTS_UNAVAILABLE:
    case LiveMonitoringCallStatus.UNANSWERED_CALLBACK_REQUEST:
    case LiveMonitoringCallStatus.UNANSWERED_OUTSIDE_BUSINESS_HOURS:
    case LiveMonitoringCallStatus.UNANSWERED_USERS_DID_NOT_ANSWER:
      break;
    default:
      node2 = /* @__PURE__ */ jsx(Typography, { color: "neutral-400", ellipsis: !0, variant: "supportingMediumS" });
      break;
  }
  return node2;
}
__name(CallStatusDuration, "CallStatusDuration");
function CallStatusIcon({
  status,
  size,
  "data-test": dataTest = "call-status-icon",
  ...iconProps
}) {
  let color2 = "secondary-700", icon = null;
  switch (status) {
    case LiveMonitoringCallStatus.IN_IVR:
      icon = KeypadFilled;
      break;
    case LiveMonitoringCallStatus.IN_QUEUE:
      icon = PeopleFilled;
      break;
    case LiveMonitoringCallStatus.RINGING:
      icon = RingingFilled;
      break;
    case LiveMonitoringCallStatus.IN_CALL:
    case LiveMonitoringCallStatus.IN_CALL_AI_VOICE_AGENT:
      icon = RingingOutlined, color2 = "primary-500";
      break;
    case LiveMonitoringCallStatus.ANSWERED:
      icon = CallFilled;
      break;
    case CustomCallStatus.CALLBACK_PENDING:
      icon = CallbackFilled, color2 = "critical-500";
      break;
    default:
      icon = HangUpFilled, color2 = "critical-500";
      break;
  }
  return /* @__PURE__ */ jsx(
    Icon,
    {
      "data-test": `${dataTest}-${status}`,
      size,
      color: color2,
      ...iconProps,
      component: icon
    }
  );
}
__name(CallStatusIcon, "CallStatusIcon");
function CallStatus({
  status,
  iconSize: iconSize2 = 24,
  duration = 0,
  tooltipDurations = [],
  texts: texts2,
  "data-test": dataTest = "call-status"
}) {
  const shouldDisplayIcon = [
    LiveMonitoringCallStatus.IN_IVR,
    LiveMonitoringCallStatus.IN_QUEUE,
    LiveMonitoringCallStatus.RINGING,
    LiveMonitoringCallStatus.IN_CALL,
    LiveMonitoringCallStatus.IN_CALL_AI_VOICE_AGENT,
    CustomCallStatus.CALLBACK_PENDING
  ].includes(status);
  return /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      content: /* @__PURE__ */ jsx(
        CallStatusTooltipContent,
        {
          status,
          duration,
          tooltipDurations,
          texts: texts2
        }
      ),
      sideOffset: 2,
      children: /* @__PURE__ */ jsxs(Flex, { gap: "xxs", alignItems: "center", "data-test": dataTest, w: "100%", children: [
        shouldDisplayIcon ? /* @__PURE__ */ jsx(
          CallStatusIcon,
          {
            status,
            size: iconSize2,
            "data-test": `${dataTest}-icon`
          }
        ) : /* @__PURE__ */ jsx(Box, { w: iconSize2, h: iconSize2 }),
        /* @__PURE__ */ jsxs(Flex, { flexDirection: "column", overflow: "hidden", children: [
          /* @__PURE__ */ jsx(CallStatusText, { status, duration, texts: texts2 }),
          /* @__PURE__ */ jsx(
            CallStatusDuration,
            {
              status,
              duration,
              texts: texts2
            }
          )
        ] })
      ] })
    }
  );
}
__name(CallStatus, "CallStatus");
function ConditionalTooltip({
  children,
  visible,
  "data-test": dataTest = "conditional-tooltip",
  ...tooltipProps
}) {
  return visible ? /* @__PURE__ */ jsx(Tooltip$1, { ...tooltipProps, "data-test": dataTest, children }) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment -- required for valid return type
    /* @__PURE__ */ jsx(Fragment, { children })
  );
}
__name(ConditionalTooltip, "ConditionalTooltip");
function TooltipContent$2({ rows }) {
  return /* @__PURE__ */ jsx(Typography, { display: "inline", "data-test": "tooltip-content", children: rows.map(([primary, secondary], index2) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ jsxs(Box, { children: [
      primary,
      secondary && /* @__PURE__ */ jsxs(Typography, { display: "inline", color: "text-placeholder", children: [
        " - ",
        secondary
      ] })
    ] }, index2)
  )) });
}
__name(TooltipContent$2, "TooltipContent$2");
function getColor(direction, status, withVoicemail) {
  if (withVoicemail)
    return "warning-500";
  switch (status) {
    case LiveMonitoringCallStatus.IN_CALL:
    case LiveMonitoringCallStatus.IN_CALL_AI_VOICE_AGENT:
    case LiveMonitoringCallStatus.ANSWERED:
      return direction === LiveMonitoringCallDirection.INBOUND ? "primary-500" : "informative-500";
    case LiveMonitoringCallStatus.UNANSWERED:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_BEFORE_10_SECONDS:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE:
    case LiveMonitoringCallStatus.UNANSWERED_ABANDONED_IN_IVR:
    case LiveMonitoringCallStatus.UNANSWERED_ALL_AGENTS_UNAVAILABLE:
    case LiveMonitoringCallStatus.UNANSWERED_CALLBACK_REQUEST:
    case LiveMonitoringCallStatus.UNANSWERED_OUTSIDE_BUSINESS_HOURS:
    case LiveMonitoringCallStatus.UNANSWERED_USERS_DID_NOT_ANSWER:
      return "critical-500";
    case LiveMonitoringCallStatus.IN_IVR:
    case LiveMonitoringCallStatus.IN_QUEUE:
    case LiveMonitoringCallStatus.RINGING:
    default:
      return "neutral-400";
  }
}
__name(getColor, "getColor");
function getIcon(direction, withVoicemail) {
  if (withVoicemail)
    return VoicemailOutlined;
  switch (direction) {
    case LiveMonitoringCallDirection.INBOUND:
      return InboundOutlined;
    case LiveMonitoringCallDirection.OUTBOUND:
      return OutboundOutlined;
    default:
      return VoicemailOutlined;
  }
}
__name(getIcon, "getIcon");
function CallDirection({
  direction,
  status,
  texts: texts2,
  withVoicemail = !1,
  ...restProps
}) {
  var _a3;
  const color2 = getColor(direction, status, withVoicemail), icon = getIcon(direction, withVoicemail);
  return /* @__PURE__ */ jsx(
    ConditionalTooltip,
    {
      visible: !!((_a3 = texts2 == null ? void 0 : texts2.tooltip) != null && _a3.length),
      content: /* @__PURE__ */ jsx(TooltipContent$2, { rows: (texts2 == null ? void 0 : texts2.tooltip) || [] }),
      align: "center",
      side: "top",
      sideOffset: -2,
      mouseEnterDelay: 0,
      mouseLeaveDelay: 100,
      "data-test": "call-type-icon-tooltip",
      children: /* @__PURE__ */ jsx(Icon, { ...restProps, color: color2, component: icon })
    }
  );
}
__name(CallDirection, "CallDirection");
const CustomIcon = styled(Icon)`
  display: flex;
  width: max-content;
  align-items: center;
  justify-content: center;
  padding: 0 ${getSpace$1("s")} 0 ${getSpace$1("xxs")};
  cursor: ${({ cursor: cursor2 }) => cursor2 ?? "default"};
`;
function Chevron({ direction, ...props }) {
  return /* @__PURE__ */ jsx(
    CustomIcon,
    {
      "data-test": "chevron",
      ...props,
      component: direction === "up" ? ChevronUpOutlined : ChevronDownOutlined
    }
  );
}
__name(Chevron, "Chevron");
function ConfirmationModal({
  children,
  show,
  onConfirm,
  onCancel,
  disabled,
  loading = !1,
  "data-test": dataTest = "confirmation-modal",
  texts: texts2
}) {
  return /* @__PURE__ */ jsxs(
    ModalDialog,
    {
      show,
      onHide: onCancel,
      size: "small",
      "data-test": dataTest,
      children: [
        /* @__PURE__ */ jsx(ModalBody, { children: /* @__PURE__ */ jsxs(Spacer, { direction: "vertical", space: "m", fluid: !0, children: [
          /* @__PURE__ */ jsxs(
            Spacer,
            {
              alignItems: "center",
              justifyContent: "center",
              direction: "vertical",
              space: "m",
              fluid: !0,
              children: [
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "bodySemiboldM",
                    textAlign: "center",
                    whiteSpace: "break-spaces",
                    children: texts2.confirmation
                  }
                ),
                children
              ]
            }
          ),
          texts2.error || texts2.banner ? /* @__PURE__ */ jsxs(Spacer, { space: "xxs", direction: "vertical", fluid: !0, children: [
            texts2.banner && /* @__PURE__ */ jsxs(Banner, { variant: "warning", inline: !0, children: [
              /* @__PURE__ */ jsx(BannerIcon, {}),
              /* @__PURE__ */ jsx(BannerHeading, { children: texts2.banner })
            ] }),
            texts2.error && /* @__PURE__ */ jsxs(Banner, { variant: "critical", inline: !0, children: [
              /* @__PURE__ */ jsx(BannerIcon, {}),
              /* @__PURE__ */ jsx(BannerHeading, { children: texts2.error })
            ] })
          ] }) : null
        ] }) }),
        /* @__PURE__ */ jsx(ModalFooter, { children: /* @__PURE__ */ jsxs(Spacer, { space: "xxs", alignItems: "center", children: [
          /* @__PURE__ */ jsx(
            Button$1,
            {
              mode: "ghost",
              variant: "secondary",
              onClick: onCancel,
              "data-test": `${dataTest}-cancel`,
              children: texts2.cancel
            }
          ),
          loading ? /* @__PURE__ */ jsx(Button$1, { disabled: !0, "data-test": `${dataTest}-loading`, children: /* @__PURE__ */ jsx(Icon, { component: SpinnerOutlined, spin: !0 }) }) : /* @__PURE__ */ jsx(
            Button$1,
            {
              disabled,
              onClick: onConfirm,
              "data-test": `${dataTest}-confirm`,
              children: texts2.confirm
            }
          )
        ] }) })
      ]
    }
  );
}
__name(ConfirmationModal, "ConfirmationModal");
function useCopyToClipboard$1() {
  return (content2) => {
    const tempInput = document.createElement("textarea");
    tempInput.value = content2, document.body.appendChild(tempInput), tempInput.select(), document.execCommand("copy"), document.body.removeChild(tempInput);
  };
}
__name(useCopyToClipboard$1, "useCopyToClipboard$1");
const RESET_TIMEOUT = 1e3;
function CopyToClipboardButton({
  content: content2,
  texts: texts2 = {
    copy: "Copy",
    copied: "Copied"
  },
  ...buttonProps
}) {
  const copyFn = useCopyToClipboard$1(), [hasCopied, setHasCopied] = useState(!1), timeout = useRef(0), handleClick = useCallback(() => {
    hasCopied || (copyFn(content2), setHasCopied(!0), timeout.current = window.setTimeout(() => {
      setHasCopied(!1);
    }, RESET_TIMEOUT));
  }, [hasCopied, copyFn, content2]);
  return useEffect(() => () => clearTimeout(timeout.current), []), /* @__PURE__ */ jsxs(Button$1, { ...buttonProps, onClick: handleClick, children: [
    /* @__PURE__ */ jsx(Box, { display: "inline", position: "relative", children: hasCopied ? /* @__PURE__ */ jsx(TickOutlined, {}) : /* @__PURE__ */ jsx(CopyOutlined, {}) }),
    hasCopied ? texts2.copied : texts2.copy
  ] });
}
__name(CopyToClipboardButton, "CopyToClipboardButton");
var freeGlobal$2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
freeGlobal$2 || freeSelf$1 || Function("return this")();
var useIsomorphicLayoutEffect$1 = typeof window < "u" ? useLayoutEffect : useEffect;
function useEventListener(eventName, handler, element2, options) {
  const savedHandler = useRef(handler);
  useIsomorphicLayoutEffect$1(() => {
    savedHandler.current = handler;
  }, [handler]), useEffect(() => {
    const targetElement = (element2 == null ? void 0 : element2.current) ?? window;
    if (!(targetElement && targetElement.addEventListener))
      return;
    const listener = /* @__PURE__ */ __name((event) => {
      savedHandler.current(event);
    }, "listener");
    return targetElement.addEventListener(eventName, listener, options), () => {
      targetElement.removeEventListener(eventName, listener, options);
    };
  }, [eventName, element2, options]);
}
__name(useEventListener, "useEventListener");
function useCopyToClipboard() {
  const [copiedText, setCopiedText] = useState(null), copy2 = useCallback(async (text2) => {
    if (!(navigator != null && navigator.clipboard))
      return console.warn("Clipboard not supported"), !1;
    try {
      return await navigator.clipboard.writeText(text2), setCopiedText(text2), !0;
    } catch (error) {
      return console.warn("Copy failed", error), setCopiedText(null), !1;
    }
  }, []);
  return [copiedText, copy2];
}
__name(useCopyToClipboard, "useCopyToClipboard");
function useEventCallback(fn) {
  const ref = useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return useIsomorphicLayoutEffect$1(() => {
    ref.current = fn;
  }, [fn]), useCallback((...args) => {
    var _a3;
    return (_a3 = ref.current) == null ? void 0 : _a3.call(ref, ...args);
  }, [ref]);
}
__name(useEventCallback, "useEventCallback");
var IS_SERVER = typeof window > "u";
function useLocalStorage(key, initialValue, options = {}) {
  const { initializeWithValue = !0 } = options, serializer2 = useCallback(
    (value) => options.serializer ? options.serializer(value) : JSON.stringify(value),
    [options]
  ), deserializer2 = useCallback(
    (value) => {
      if (options.deserializer)
        return options.deserializer(value);
      if (value === "undefined")
        return;
      const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
      let parsed;
      try {
        parsed = JSON.parse(value);
      } catch (error) {
        return console.error("Error parsing JSON:", error), defaultValue;
      }
      return parsed;
    },
    [options, initialValue]
  ), readValue = useCallback(() => {
    const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
    if (IS_SERVER)
      return initialValueToUse;
    try {
      const raw = window.localStorage.getItem(key);
      return raw ? deserializer2(raw) : initialValueToUse;
    } catch (error) {
      return console.warn(`Error reading localStorage key “${key}”:`, error), initialValueToUse;
    }
  }, [initialValue, key, deserializer2]), [storedValue, setStoredValue] = useState(() => initializeWithValue ? readValue() : initialValue instanceof Function ? initialValue() : initialValue), setValue = useEventCallback((value) => {
    IS_SERVER && console.warn(
      `Tried setting localStorage key “${key}” even though environment is not a client`
    );
    try {
      const newValue = value instanceof Function ? value(readValue()) : value;
      window.localStorage.setItem(key, serializer2(newValue)), setStoredValue(newValue), window.dispatchEvent(new StorageEvent("local-storage", { key }));
    } catch (error) {
      console.warn(`Error setting localStorage key “${key}”:`, error);
    }
  }), removeValue = useEventCallback(() => {
    IS_SERVER && console.warn(
      `Tried removing localStorage key “${key}” even though environment is not a client`
    );
    const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
    window.localStorage.removeItem(key), setStoredValue(defaultValue), window.dispatchEvent(new StorageEvent("local-storage", { key }));
  });
  useEffect(() => {
    setStoredValue(readValue());
  }, [key]);
  const handleStorageChange = useCallback(
    (event) => {
      event.key && event.key !== key || setStoredValue(readValue());
    },
    [key, readValue]
  );
  return useEventListener("storage", handleStorageChange), useEventListener("local-storage", handleStorageChange), [storedValue, setValue, removeValue];
}
__name(useLocalStorage, "useLocalStorage");
function useHover(elementRef) {
  const [value, setValue] = useState(!1), handleMouseEnter = /* @__PURE__ */ __name(() => {
    setValue(!0);
  }, "handleMouseEnter"), handleMouseLeave = /* @__PURE__ */ __name(() => {
    setValue(!1);
  }, "handleMouseLeave");
  return useEventListener("mouseenter", handleMouseEnter, elementRef), useEventListener("mouseleave", handleMouseLeave, elementRef), value;
}
__name(useHover, "useHover");
function CopyToClipboardText({
  children,
  timeoutDuration = 1e3,
  tooltipTexts
}) {
  const [, copy2] = useCopyToClipboard(), [hasCopied, setHasCopied] = useState(!1), timeout = useRef(0), handleClick = useCallback(() => {
    hasCopied || (copy2(children), setHasCopied(!0), timeout.current = window.setTimeout(() => {
      setHasCopied(!1);
    }, timeoutDuration));
  }, [hasCopied, copy2, children, timeoutDuration]);
  useEffect(() => () => clearTimeout(timeout.current), []);
  const iconOnClick = hasCopied ? void 0 : handleClick, iconComponent = hasCopied ? TickOutlined : CopyOutlined, color2 = hasCopied ? "primary-500" : "neutral-400";
  return /* @__PURE__ */ jsxs(Gap, { alignItems: "center", gap: "xxs", children: [
    /* @__PURE__ */ jsx(Typography, { color: color2, children }),
    /* @__PURE__ */ jsx(
      ConditionalTooltip,
      {
        visible: !!tooltipTexts,
        title: hasCopied ? tooltipTexts == null ? void 0 : tooltipTexts.copied : tooltipTexts == null ? void 0 : tooltipTexts.copy,
        align: "center",
        side: "top",
        mouseEnterDelay: 0,
        mouseLeaveDelay: 100,
        children: /* @__PURE__ */ jsx(
          IconButton,
          {
            "data-test": hasCopied ? "copied-icon" : "copy-icon",
            size: 24,
            onClick: iconOnClick,
            component: iconComponent,
            color: color2
          }
        )
      }
    )
  ] });
}
__name(CopyToClipboardText, "CopyToClipboardText");
function Country({
  size = 20,
  countryCode,
  children,
  gap: gap2 = 2,
  ...typographyProps
}) {
  return /* @__PURE__ */ jsxs(Flex, { alignItems: "center", gap: gap2, children: [
    /* @__PURE__ */ jsx(FlagIcon, { size, countryCode }),
    /* @__PURE__ */ jsx(Typography, { ...typographyProps, children })
  ] });
}
__name(Country, "Country");
const MultiSelectItemInner = /* @__PURE__ */ __name(function({
  option,
  render,
  renderPrefix,
  renderSuffix,
  renderDescription
}) {
  const { value, label } = option, prefix2 = renderPrefix == null ? void 0 : renderPrefix(option), suffix = renderSuffix == null ? void 0 : renderSuffix(option), description = renderDescription == null ? void 0 : renderDescription(option);
  return /* @__PURE__ */ jsx(ComboBoxItem, { itemKey: value, style: { borderBottom: "none" }, children: render ? render(option) : /* @__PURE__ */ jsxs(Fragment, { children: [
    prefix2 && /* @__PURE__ */ jsx(MenuItemPrefix, { pl: "4px", children: prefix2 }),
    /* @__PURE__ */ jsx(MenuItemLabel, { children: /* @__PURE__ */ jsx(Typography, { ellipsis: 2, variant: "bodyRegularS", children: label }) }),
    suffix && /* @__PURE__ */ jsx(MenuItemSuffix, { pl: "4px", children: suffix }),
    description && /* @__PURE__ */ jsx(MenuItemDescription, { children: description })
  ] }) }, value);
}, "MultiSelectItem2"), MultiSelectItem = memo$1(
  MultiSelectItemInner
);
function RenderMultiple({
  children,
  quantity,
  ...spaceProps
}) {
  return /* @__PURE__ */ jsx(Spacer, { ...spaceProps, children: Array(quantity).fill(void 0).map((_, index2) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ jsx(Fragment$1, { children: children(index2) }, index2)
  )) });
}
__name(RenderMultiple, "RenderMultiple");
function MultiSelectLoader({
  count = 3,
  "data-test": dataTest = "multi-select-loader"
}) {
  return /* @__PURE__ */ jsx(
    RenderMultiple,
    {
      gap: "s",
      direction: "vertical",
      quantity: count,
      px: "s",
      py: "m",
      "data-test": dataTest,
      children: (index2) => /* @__PURE__ */ jsxs(Flex, { gap: "s", alignItems: "center", children: [
        /* @__PURE__ */ jsx(Skeleton, { h: 16, w: 16, shape: "squircle" }),
        /* @__PURE__ */ jsx(Skeleton, { h: 12, flex: "1" })
      ] }, index2)
    }
  );
}
__name(MultiSelectLoader, "MultiSelectLoader");
const Separator = styled(Flex)`
  height: 1px;
  background: ${getColor$2("neutral-200")};
`;
function MultiSelectContent({
  allowRemove,
  children,
  className,
  options,
  loading,
  renderItem,
  renderItemPrefix,
  renderItemSuffix,
  renderTriggerLabel,
  renderTriggerPrefix,
  renderTriggerSuffix,
  w: w2,
  minWidth: minWidth2,
  maxW,
  menuMaxWidth,
  menuMinWidth = "max-content",
  showSelectedOnTop = !1,
  texts: textsProp,
  loadingSkeletonsCount,
  "data-test": dataTest = "multi-select",
  disabled = !1,
  triggerStyle = "filter"
}) {
  const { selectedKeys } = useComboBox(), texts2 = {
    placeholder: "Select",
    item: "item",
    items: "items",
    result: "result",
    results: "results",
    ...textsProp || {}
  }, [optionsCache, setOptionsCache] = useState(/* @__PURE__ */ new Map());
  useEffect(() => {
    setOptionsCache((cache2) => (selectedKeys.forEach((key) => {
      if (!cache2.has(key)) {
        const option = options.find((o) => o.value === key);
        option && cache2.set(key, option);
      }
    }), cache2));
  }, [selectedKeys, options, optionsCache]);
  const selectedOptions = selectedKeys.reduce((acc, key) => {
    const option = options.find((o) => o.value === key) || optionsCache.get(key);
    return [...acc, ...option ? [option] : []];
  }, []), items = options.filter(
    (o) => showSelectedOnTop ? !selectedOptions.find((so) => o.value === so.value) : !0
  ).map((option) => /* @__PURE__ */ jsx(
    MultiSelectItem,
    {
      option,
      render: renderItem,
      renderPrefix: renderItemPrefix,
      renderSuffix: renderItemSuffix
    },
    option.value
  )), topItems = showSelectedOnTop ? selectedOptions.map((option) => /* @__PURE__ */ jsx(
    MultiSelectItem,
    {
      option,
      render: renderItem,
      renderPrefix: renderItemPrefix,
      renderSuffix: renderItemSuffix
    },
    option.value
  )) : [];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ComboBoxTrigger, { children: (/* @__PURE__ */ __name(() => {
      const triggerProps = {
        allowRemove,
        className,
        "data-test": `${dataTest}-trigger`,
        selectedOptions,
        placeholder: texts2.placeholder,
        texts: texts2,
        minWidth: minWidth2,
        maxW,
        w: w2,
        disabled
      };
      return triggerStyle === "select" ? /* @__PURE__ */ jsx(
        SelectTrigger,
        {
          renderTriggerLabel,
          renderTriggerPrefix,
          renderTriggerSuffix,
          ...triggerProps
        }
      ) : /* @__PURE__ */ jsx(FilterTrigger, { ...triggerProps });
    }, "renderTrigger"))() }),
    /* @__PURE__ */ jsxs(
      ComboBoxContent,
      {
        takeTriggerWidth: !0,
        maxW: menuMaxWidth,
        minWidth: menuMinWidth,
        "data-test": `${dataTest}-content`,
        children: [
          children,
          loading ? /* @__PURE__ */ jsx(
            MultiSelectLoader,
            {
              count: loadingSkeletonsCount,
              "data-test": `${dataTest}-loader`
            }
          ) : /* @__PURE__ */ jsxs(ComboBoxMenu, { maxH: "314px", p: "xxs", pt: children ? "0" : "xs", children: [
            topItems,
            topItems.length && items.length ? /* @__PURE__ */ jsx(Separator, { "data-test": `${dataTest}-separator` }) : null,
            items
          ] })
        ]
      }
    )
  ] });
}
__name(MultiSelectContent, "MultiSelectContent");
function MultiSelect(props) {
  const { onSelect: onSelect2, ...restProps } = props, handleSelectionChange = useCallback(
    (selectedKeys) => {
      onSelect2(selectedKeys);
    },
    [onSelect2]
  );
  return /* @__PURE__ */ jsx(
    ComboBox,
    {
      selectionMode: "multiple",
      ...restProps,
      onSelectionChange: handleSelectionChange,
      children: /* @__PURE__ */ jsx(MultiSelectContent, { ...props })
    }
  );
}
__name(MultiSelect, "MultiSelect");
function MultiSelectInput({
  onChange: onChange5,
  value,
  onClear,
  "data-test": dataTest = "multi-select-input"
}) {
  const handleChange = useCallback(
    (event) => {
      onChange5(event.target.value);
    },
    [onChange5]
  );
  return /* @__PURE__ */ jsx(
    TextInput,
    {
      "data-test": dataTest,
      icon: SearchOutlined,
      autoFocus: !0,
      value,
      onChange: handleChange,
      onClear: value.length ? onClear : void 0
    }
  );
}
__name(MultiSelectInput, "MultiSelectInput");
function MultiSelectResults({
  count,
  texts: texts2 = {
    result: "result",
    results: "results"
  }
}) {
  const { side } = usePopoverPlacement();
  return /* @__PURE__ */ jsx(Flex, { h: "40px", alignItems: "center", children: /* @__PURE__ */ jsxs(
    Typography,
    {
      variant: "bodyRegularS",
      color: "text-secondary",
      order: side === "top" ? 1 : void 0,
      px: "s",
      children: [
        count,
        " ",
        count === 1 ? texts2.result : texts2.results
      ]
    }
  ) });
}
__name(MultiSelectResults, "MultiSelectResults");
function MultiSearchSelect({
  options,
  onSearch: onSearch2,
  debounceDuration = 400,
  loading,
  showSelectedOnTop = !0,
  resetSearchOnSelect = !1,
  isSearch = !1,
  onSelect: onSelect2,
  resultsCount,
  selectionMode = "multiple",
  "data-test": dataTest = "multi-search-select",
  ...restProps
}) {
  const [query, setQuery] = useState(""), onSearchDebounced = useRef(debounce$2(onSearch2, debounceDuration)), texts2 = {
    placeholder: "Select",
    item: "item",
    items: "items",
    result: "result",
    results: "results",
    ...restProps.texts || {}
  }, handleQuery = useCallback(
    (q2, immediate = !1) => {
      setQuery(q2), immediate || !debounceDuration ? onSearch2 == null || onSearch2(q2) : onSearchDebounced.current(q2);
    },
    [debounceDuration, onSearch2]
  ), handleSelect = useCallback(
    (keys2) => {
      resetSearchOnSelect && isSearch && handleQuery("", !0), onSelect2(keys2);
    },
    [handleQuery, isSearch, onSelect2, resetSearchOnSelect]
  );
  return /* @__PURE__ */ jsx(
    MultiSelect,
    {
      texts: texts2,
      options,
      loading,
      showSelectedOnTop: isSearch ? !1 : showSelectedOnTop,
      "data-test": dataTest,
      ...restProps,
      selectionMode,
      onSelect: handleSelect,
      children: /* @__PURE__ */ jsxs(Flex, { margin: "xxs", marginBottom: "0", flexDirection: "column", children: [
        /* @__PURE__ */ jsx(
          MultiSelectInput,
          {
            onChange: handleQuery,
            onClear: () => handleQuery("", !0),
            value: query,
            "data-test": `${dataTest}-input`
          }
        ),
        !loading && /* @__PURE__ */ jsx(
          MultiSelectResults,
          {
            texts: { result: texts2.result, results: texts2.results },
            count: resultsCount ?? options.length
          }
        )
      ] })
    }
  );
}
__name(MultiSearchSelect, "MultiSearchSelect");
function calculateLabel$1(selectedOptions, selectedKeys, texts2) {
  return selectedKeys.length > selectedOptions.length ? `${selectedKeys.length} ${selectedKeys.length === 1 ? texts2.item : texts2.items}` : selectedOptions.length > 0 ? selectedOptions.map(({ label }) => label).join(", ") : null;
}
__name(calculateLabel$1, "calculateLabel$1");
function flexTriggerStyle$1({ disabled }) {
  return disabled ? css`
      background-color: ${getColor$1("surface-disabled")};
      border: 1px solid;
      border-color: ${getColor$1("graphic-disabled")};
      cursor: not-allowed;
    ` : css`
    background-color: ${getColor$1("surface-default")};
    border: 1px solid;
    border-color: ${getColor$1("graphic-interactive-default")};

    &:hover {
      border-color: ${getColor$1("graphic-interactive-default-hover")};
    }

    &:active {
      border-color: ${getColor$1("graphic-interactive-default-active")};
    }
  `;
}
__name(flexTriggerStyle$1, "flexTriggerStyle$1");
const FlexTrigger = styled(Flex)`
  ${flexTriggerStyle$1};

  height: 48px;

  transition:
    300ms background-color,
    300ms border-color;
`;
function SelectTriggerBase({
  className,
  placeholder,
  texts: texts2,
  selectedOptions,
  "data-test": dataTest = "multi-select-trigger",
  renderTriggerLabel,
  renderTriggerPrefix,
  renderTriggerSuffix,
  disabled,
  allowRemove = !1,
  ...flexProps
}, ref) {
  const { selectedKeys, open, removeAll } = useComboBox(), hasSelectedKeys = selectedKeys.length > 0, label = (renderTriggerLabel == null ? void 0 : renderTriggerLabel(selectedOptions)) || calculateLabel$1(selectedOptions, selectedKeys, texts2), handleRemove = useCallback(
    (e3) => {
      e3.stopPropagation(), removeAll();
    },
    [removeAll]
  ), renderIcon2 = /* @__PURE__ */ __name(() => hasSelectedKeys && allowRemove ? /* @__PURE__ */ jsx(
    IconButton,
    {
      "data-test": "multi-select-trigger-remove",
      "aria-label": "remove selection",
      disabled,
      color: disabled ? "icon-disabled" : "icon-default",
      size: "24px",
      ml: "auto",
      component: CloseOutlined,
      onClick: disabled ? void 0 : handleRemove
    }
  ) : /* @__PURE__ */ jsx(
    Icon,
    {
      "data-test": open ? "multi-select-trigger-arrow-up" : "multi-select-trigger-arrow-down",
      color: disabled ? "icon-disabled" : "icon-default",
      ml: "auto",
      size: "24px",
      component: open ? ChevronUpOutlined : ChevronDownOutlined
    }
  ), "renderIcon");
  return /* @__PURE__ */ jsxs(
    FlexTrigger,
    {
      "data-test": dataTest,
      borderRadius: "sm",
      className,
      color: disabled ? "text-disabled" : "text-base",
      cursor: "pointer",
      px: "xs",
      alignItems: "center",
      userSelect: "none",
      ref,
      disabled,
      gap: "xxs",
      ...flexProps,
      children: [
        selectedOptions.length === 1 ? renderTriggerPrefix == null ? void 0 : renderTriggerPrefix(selectedOptions[0]) : null,
        /* @__PURE__ */ jsx(
          Typography,
          {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            variant: disabled ? "bodyMediumS" : "bodyRegularS",
            title: typeof label == "string" ? label : "",
            children: label ?? placeholder
          }
        ),
        selectedOptions.length === 1 ? renderTriggerSuffix == null ? void 0 : renderTriggerSuffix(selectedOptions[0]) : null,
        renderIcon2()
      ]
    }
  );
}
__name(SelectTriggerBase, "SelectTriggerBase");
const SelectTrigger = forwardRef(SelectTriggerBase);
function calculateTextColor$1(selectedKeysLength, disabled) {
  return !disabled && selectedKeysLength > 0 ? "text-inverted" : disabled ? "text-disabled" : "text-base";
}
__name(calculateTextColor$1, "calculateTextColor$1");
function calculateLabel(selectedOptions, selectedKeys, texts2) {
  const countKeys = selectedKeys.length, [firstOption] = selectedOptions;
  return countKeys === 1 && (firstOption == null ? void 0 : firstOption.value) === selectedKeys[0] ? firstOption.label : countKeys >= 1 ? `${countKeys} ${countKeys === 1 ? texts2.item : texts2.items}` : null;
}
__name(calculateLabel, "calculateLabel");
function flexTriggerStyle({
  disabled,
  hasSelectedKeys
}) {
  return disabled ? css`
      background-color: ${getColor$1(hasSelectedKeys ? "surface-interactive-disabled" : "surface-default")};
      border: 1px solid;
      border-color: ${getColor$1("graphic-disabled")};
      cursor: not-allowed;
    ` : hasSelectedKeys ? css`
      background-color: ${getColor$1("surface-interactive-secondary")};
      border: 1px solid;
      border-color: ${getColor$1("graphic-interactive-primary-ghost")};

      &:hover {
        background-color: ${getColor$1("surface-interactive-secondary-hover")};
      }

      &:active {
        background-color: ${getColor$1("surface-interactive-secondary-active")};
      }
    ` : css`
    background-color: ${getColor$1("surface-default")};
    border: 1px solid;
    border-color: ${getColor$1("graphic-interactive-default")};

    &:hover {
      border-color: ${getColor$1("graphic-interactive-default-hover")};
    }

    &:active {
      border-color: ${getColor$1("graphic-interactive-default-active")};
    }
  `;
}
__name(flexTriggerStyle, "flexTriggerStyle");
const StyledFlexTrigger = styled(Flex)`
  ${flexTriggerStyle};

  height: 40px;

  transition:
    300ms background-color,
    300ms border-color;
`;
function FilterTriggerBase({
  allowRemove = !0,
  className,
  placeholder,
  texts: texts2,
  selectedOptions,
  "data-test": dataTest = "multi-select-trigger",
  disabled,
  ...flexProps
}, ref) {
  const { selectedKeys, removeAll, open } = useComboBox(), selectedKeysLength = selectedKeys.length, hasSelectedKeys = selectedKeysLength > 0, handleRemove = useCallback(
    (e3) => {
      e3.stopPropagation(), removeAll();
    },
    [removeAll]
  );
  function renderIcon2() {
    return hasSelectedKeys ? allowRemove ? /* @__PURE__ */ jsx(
      IconButton,
      {
        "data-test": "multi-select-trigger-remove",
        "aria-label": "remove selection",
        color: disabled ? "icon-disabled" : "icon-inverted",
        discColor: "icon-interactive-secondary",
        disabled,
        size: "24px",
        ml: "auto",
        component: CloseCircleFilled,
        onClick: disabled ? void 0 : handleRemove
      }
    ) : null : /* @__PURE__ */ jsx(
      Icon,
      {
        "data-test": open ? "multi-select-trigger-arrow-up" : "multi-select-trigger-arrow-down",
        color: disabled ? "icon-disabled" : "icon-default",
        ml: "auto",
        size: "16px",
        component: open ? ArrowUpFilled : ArrowDownFilled
      }
    );
  }
  __name(renderIcon2, "renderIcon");
  const color2 = calculateTextColor$1(selectedKeysLength, disabled), label = calculateLabel(selectedOptions, selectedKeys, texts2);
  return /* @__PURE__ */ jsxs(
    StyledFlexTrigger,
    {
      className,
      "data-test": dataTest,
      borderRadius: "sm",
      color: color2,
      cursor: "pointer",
      px: "xs",
      alignItems: "center",
      userSelect: "none",
      hasSelectedKeys,
      ref,
      disabled,
      gap: "xxs",
      ...flexProps,
      children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            variant: "bodyMediumS",
            title: label ?? "",
            children: label ?? placeholder
          }
        ),
        renderIcon2()
      ]
    }
  );
}
__name(FilterTriggerBase, "FilterTriggerBase");
const FilterTrigger = forwardRef(FilterTriggerBase);
function CountryMultiSearchSelect({
  language,
  showDialCode = !1,
  w: w2 = "200px",
  maxW = "200px",
  disabled,
  triggerStyle,
  countries,
  ...props
}) {
  const [searchOptions, setSearchOptions] = useState(void 0), options = useMemo(() => countriesPrefix.filter(
    (country) => countries ? countries.includes(country.code) : !0
  ).map((country) => ({
    ...country,
    name: getTranslatedCountryName(country.code, language)
  })).sort((a4, b2) => sortAscending(a4.name, b2.name)).map((country) => ({
    label: country.name,
    value: country.code,
    dialCode: country.dial_code
  })), [countries, language]), renderTriggerPrefix = useCallback(
    (option) => /* @__PURE__ */ jsx(FlagIcon, { countryCode: option.value, size: 24, mr: "xxs" }),
    []
  ), renderTriggerSuffix = useCallback(
    (option) => showDialCode ? /* @__PURE__ */ jsxs(
      Typography,
      {
        color: disabled ? "text-disabled" : "text-base",
        variant: "bodyRegularS",
        flexShrink: 0,
        children: [
          " (",
          option.dialCode,
          ")"
        ]
      }
    ) : null,
    [showDialCode, disabled]
  ), renderItemPrefix = useCallback(
    (option) => /* @__PURE__ */ jsx(FlagIcon, { countryCode: option.value }),
    []
  ), renderItemSuffix = useCallback(
    (option) => showDialCode ? /* @__PURE__ */ jsx(Typography, { color: "text-base", variant: "bodyRegularS", children: option.dialCode }) : null,
    [showDialCode]
  ), handleSearch = useCallback(
    (query) => {
      if (query === "") {
        setSearchOptions(void 0);
        return;
      }
      const results = options.filter(
        (option) => matchPartialText(option.label, query)
      );
      setSearchOptions(results);
    },
    [options]
  ), { texts: texts2 } = props;
  return /* @__PURE__ */ jsx(
    MultiSearchSelect,
    {
      ...props,
      options: searchOptions || options,
      isSearch: !!searchOptions,
      renderItemPrefix,
      renderItemSuffix,
      renderTriggerPrefix,
      renderTriggerSuffix,
      triggerStyle,
      texts: texts2 || {
        item: "country",
        items: "countries",
        result: "result",
        results: "results"
      },
      w: w2,
      maxW,
      disabled,
      onSearch: handleSearch,
      debounceDuration: 0
    }
  );
}
__name(CountryMultiSearchSelect, "CountryMultiSearchSelect");
function CountryPrefixSearchSelect({
  language,
  w: w2 = "200px",
  maxW = "200px",
  disabled,
  showCountryName = !0,
  ...props
}) {
  const [searchOptions, setSearchOptions] = useState(void 0), options = useMemo(() => countriesPrefix.map((country) => ({
    ...country,
    name: getTranslatedCountryName(country.code, language)
  })).sort((a4, b2) => sortAscending(a4.name, b2.name)).map((country) => {
    const { name: name2, dial_code } = country;
    return {
      label: `${dial_code} ${name2}`,
      value: country.code,
      countryName: name2,
      dialCode: dial_code
    };
  }), [language]), handleSearch = useCallback(
    (query) => {
      if (query === "") {
        setSearchOptions(void 0);
        return;
      }
      const results = options.filter(
        (option) => matchPartialText(option.label, query)
      );
      setSearchOptions(results);
    },
    [options]
  ), renderItemPrefix = useCallback(
    (option) => /* @__PURE__ */ jsx(FlagIcon, { countryCode: option.value }),
    []
  ), renderTriggerPrefix = useCallback(
    (option) => /* @__PURE__ */ jsx(FlagIcon, { countryCode: option.value, size: 24, mr: "xxs" }),
    []
  ), renderTriggerLabel = useCallback(
    (selectedOptions) => {
      const selectedOption = selectedOptions[0];
      if (!selectedOption)
        return "";
      const { countryName, dialCode } = selectedOption;
      return showCountryName ? `${dialCode} ${countryName}` : `${dialCode}`;
    },
    [showCountryName]
  ), { texts: texts2 } = props;
  return /* @__PURE__ */ jsx(
    MultiSearchSelect,
    {
      ...props,
      selectionMode: "single",
      triggerStyle: "select",
      options: searchOptions || options,
      isSearch: !!searchOptions,
      renderItemPrefix,
      renderTriggerLabel,
      renderTriggerPrefix,
      texts: texts2 || {
        item: "country",
        items: "countries",
        result: "result",
        results: "results"
      },
      w: w2,
      maxW,
      disabled,
      onSearch: handleSearch,
      debounceDuration: 0
    }
  );
}
__name(CountryPrefixSearchSelect, "CountryPrefixSearchSelect");
function getRangeDatesLabel(startDate, endDate, locale2 = "en-US") {
  if (!endDate)
    return `${shortDate(startDate, locale2)} -`;
  if (!isSameYear(startDate, endDate))
    return `${shortDate(startDate, locale2)} - ${shortDate(endDate, locale2)}`;
  if (isSameDay(startDate, endDate))
    return isThisYear(startDate) ? `${shortMonthFormat(startDate, locale2)} ${dayOfMonthFormat(
      startDate,
      locale2
    )}` : `${shortDate(startDate, locale2)}`;
  const months = [
    shortMonthFormat(startDate, locale2),
    shortMonthFormat(endDate, locale2)
  ], days = [
    dayOfMonthFormat(startDate, locale2),
    dayOfMonthFormat(endDate, locale2)
  ], sameMonth = isSameMonth(startDate, endDate) ? "" : `${months[1]} `, thisYear = isThisYear(startDate) ? "" : `, ${getYear(startDate)}`, start = `${months[0]} ${days[0]}`, end = `${sameMonth}${days[1]}`;
  return `${start} - ${end}${thisYear}`;
}
__name(getRangeDatesLabel, "getRangeDatesLabel");
function matchPredefinedOption(startDate, endDate, ranges = []) {
  if (startDate && endDate)
    return ranges.find(
      ({ startDate: predefinedOptionStart, endDate: predefinedOptionEnd }) => isSameDay(predefinedOptionStart, startDate) && isSameDay(predefinedOptionEnd, endDate)
    );
}
__name(matchPredefinedOption, "matchPredefinedOption");
function getDisplayLabel(dates, ranges = [], locale2 = "en-US") {
  const { startDate, endDate } = dates;
  if (ranges.length > 0) {
    const matchedPredefinedOption = matchPredefinedOption(
      startDate,
      endDate,
      ranges
    );
    if (matchedPredefinedOption)
      return matchedPredefinedOption.label;
  }
  return startDate ? getRangeDatesLabel(startDate, endDate, locale2) : null;
}
__name(getDisplayLabel, "getDisplayLabel");
function calculateTextColor(hasValue, disabled) {
  return !disabled && hasValue ? "text-inverted" : disabled ? "text-disabled" : "text-base";
}
__name(calculateTextColor, "calculateTextColor");
function DateSelectInputBase({
  allowRemove = !0,
  className,
  "data-test": dataTest = "date-select-input",
  value,
  placeholder,
  onClear,
  icon = ArrowDownFilled,
  disabled = !1,
  ...rest
}, ref) {
  const onIconClick = useCallback(
    (event) => {
      value && (event.stopPropagation(), onClear());
    },
    [value, onClear]
  );
  function renderIcon2() {
    return value ? allowRemove ? /* @__PURE__ */ jsx(
      IconButton,
      {
        color: disabled ? "icon-disabled" : "icon-inverted",
        discColor: "icon-interactive-secondary",
        disabled,
        ml: "auto",
        size: "24px",
        "data-test": "clear-button-icon-circle",
        component: CloseCircleFilled,
        onClick: disabled ? void 0 : onIconClick
      }
    ) : null : /* @__PURE__ */ jsx(
      Icon,
      {
        color: disabled ? "icon-disabled" : "icon-default",
        ml: "auto",
        size: "16px",
        "data-test": "clear-button-icon-arrow",
        component: icon,
        onClick: onIconClick
      }
    );
  }
  __name(renderIcon2, "renderIcon");
  const color2 = calculateTextColor(!!value, disabled);
  return /* @__PURE__ */ jsxs(
    StyledFlexTrigger,
    {
      className,
      "data-test": dataTest,
      borderRadius: "sm",
      color: color2,
      cursor: "pointer",
      px: "xs",
      hasSelectedKeys: !!value,
      alignItems: "center",
      userSelect: "none",
      ref,
      disabled,
      gap: "xxs",
      ...rest,
      children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            variant: "bodyMediumS",
            title: value ?? "",
            children: value ?? placeholder
          }
        ),
        renderIcon2()
      ]
    }
  );
}
__name(DateSelectInputBase, "DateSelectInputBase");
const DateSelectInput = forwardRef(DateSelectInputBase), Button = styled(Button$1).attrs({
  mode: "link",
  size: "xSmall",
  justifyContent: "start",
  my: "xxxs",
  selected: !1
})`
  border-radius: 4px;

  color: text-base;
  &:hover {
    background-color: ${getColor$1("surface-interactive-default-active")};
    text-decoration: none;
    color: ${getColor$1("text-interactive-primary")};
  }

  &:disabled {
    background-color: ${getColor$1("surface-interactive-default-active")};
    color: ${getColor$1("text-interactive-primary")};
  }
`;
function PredefinedDatesPicker({
  "data-test": dataTest = "predefined-dates-picker",
  onClick: onClick2,
  ranges
}) {
  return /* @__PURE__ */ jsx(Flex, { "data-test": dataTest, flexDirection: "column", justifyContent: "center", children: ranges.map((range3) => {
    const { label, rangeValue, startDate, endDate } = range3;
    return /* @__PURE__ */ jsx(
      Button,
      {
        tabIndex: -1,
        onClick: () => onClick2({ rangeValue, startDate, endDate }),
        "data-test": label,
        type: "button",
        children: /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularM", p: "0.5 xxxs", children: label })
      },
      label
    );
  }) });
}
__name(PredefinedDatesPicker, "PredefinedDatesPicker");
function DateSelectMenu({
  value,
  onChange: onChange5,
  ranges,
  "data-test": dataTest = "date-select-menu",
  footer: footer2,
  ...rest
}) {
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      flexDirection: "column",
      gap: "xxxs",
      "data-test": dataTest,
      w: "min-content",
      children: [
        ranges ? /* @__PURE__ */ jsxs(Flex, { alignItems: "center", flexDirection: "row", px: 2, children: [
          /* @__PURE__ */ jsx(PredefinedDatesPicker, { ranges, onClick: onChange5 }),
          /* @__PURE__ */ jsx(
            DatePicker,
            {
              value,
              onChange: onChange5,
              initialDate: (value == null ? void 0 : value.startDate) ?? void 0,
              ...rest
            }
          )
        ] }) : /* @__PURE__ */ jsx(
          DatePicker,
          {
            value,
            onChange: onChange5,
            initialDate: (value == null ? void 0 : value.startDate) ?? void 0,
            ...rest
          }
        ),
        footer2
      ]
    }
  );
}
__name(DateSelectMenu, "DateSelectMenu");
function DateSelectMenuContainer({
  onChange: onChange5,
  ...rest
}) {
  const { setOpen } = useDropdownContext(), closeMenu = useCallback(() => {
    setOpen(!1);
  }, [setOpen]), handleOnChange = useCallback(
    (newValue) => {
      newValue.endDate && closeMenu(), onChange5(newValue);
    },
    [onChange5, closeMenu]
  );
  return /* @__PURE__ */ jsx(DateSelectMenu, { onChange: handleOnChange, ...rest });
}
__name(DateSelectMenuContainer, "DateSelectMenuContainer");
function DateSelect({
  allowRemove,
  className,
  placeholder = "Select date range",
  onClear,
  value,
  defaultValue,
  onChange: onChange5,
  ranges = [],
  onClose,
  onOpen,
  locale: locale2 = "en-US",
  maxW = "200px",
  w: w2 = "200px",
  ...rest
}) {
  const [datesValue, setDatesValue] = useControllableState({
    prop: value,
    defaultProp: defaultValue,
    onChange: onChange5
  }), displayLabel = useMemo(
    () => datesValue ? getDisplayLabel(datesValue, ranges, locale2) : void 0,
    [datesValue, locale2, ranges]
  );
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      closeOnInsideClick: !1,
      onVisibilityChange: /* @__PURE__ */ __name((visibility2) => {
        visibility2 ? onOpen == null || onOpen() : onClose == null || onClose();
      }, "handleVisibilityChange"),
      trigger: /* @__PURE__ */ jsx(
        DateSelectInput,
        {
          allowRemove,
          className,
          value: displayLabel,
          onClear: /* @__PURE__ */ __name(() => {
            setDatesValue({
              rangeValue: void 0,
              startDate: null,
              endDate: null
            }), onClear == null || onClear();
          }, "handleOnClear"),
          placeholder,
          maxW,
          w: w2
        }
      ),
      maxWidth: "unset",
      align: "start",
      children: /* @__PURE__ */ jsx(
        DateSelectMenuContainer,
        {
          locale: locale2,
          value: datesValue,
          onChange: setDatesValue,
          ranges,
          ...rest
        }
      )
    }
  );
}
__name(DateSelect, "DateSelect");
function _extends$o() {
  return _extends$o = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$o.apply(this, arguments);
}
__name(_extends$o, "_extends$o");
function moveFieldState(state, source, destKey, oldState) {
  oldState === void 0 && (oldState = state), delete state.fields[source.name], state.fields[destKey] = _extends$o({}, source, {
    name: destKey,
    // prevent functions from being overwritten
    // if the state.fields[destKey] does not exist, it will be created
    // when that field gets registered, with its own change/blur/focus callbacks
    change: oldState.fields[destKey] && oldState.fields[destKey].change,
    blur: oldState.fields[destKey] && oldState.fields[destKey].blur,
    focus: oldState.fields[destKey] && oldState.fields[destKey].focus,
    lastFieldState: void 0
    // clearing lastFieldState forces renotification
  }), state.fields[destKey].change || delete state.fields[destKey].change, state.fields[destKey].blur || delete state.fields[destKey].blur, state.fields[destKey].focus || delete state.fields[destKey].focus;
}
__name(moveFieldState, "moveFieldState");
var escapeRegexTokens = /* @__PURE__ */ __name(function(string2) {
  return string2.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}, "escapeRegexTokens"), insert = /* @__PURE__ */ __name(function(_ref, state, _ref2) {
  var name2 = _ref[0], index2 = _ref[1], value = _ref[2], changeValue = _ref2.changeValue;
  _ref2.resetFieldState, changeValue(state, name2, function(array2) {
    var copy2 = [].concat(array2 || []);
    return copy2.splice(index2, 0, value), copy2;
  });
  var backup = _extends$o({}, state.fields), pattern = new RegExp("^" + escapeRegexTokens(name2) + "\\[(\\d+)\\](.*)");
  Object.keys(state.fields).sort().reverse().forEach(function(key) {
    var tokens = pattern.exec(key);
    if (tokens) {
      var fieldIndex = Number(tokens[1]);
      if (fieldIndex >= index2) {
        var incrementedKey = name2 + "[" + (fieldIndex + 1) + "]" + tokens[2];
        moveFieldState(state, backup[key], incrementedKey);
      }
    }
  });
}, "insert"), concat = /* @__PURE__ */ __name(function(_ref, state, _ref2) {
  var name2 = _ref[0], value = _ref[1], changeValue = _ref2.changeValue;
  changeValue(state, name2, function(array2) {
    return array2 ? [].concat(array2, value) : value;
  });
}, "concat");
function moveFields(name2, matchPrefix, destIndex, state) {
  Object.keys(state.fields).forEach(function(key) {
    if (key.substring(0, matchPrefix.length) === matchPrefix) {
      var suffix = key.substring(matchPrefix.length), destKey = name2 + "[" + destIndex + "]" + suffix;
      moveFieldState(state, state.fields[key], destKey);
    }
  });
}
__name(moveFields, "moveFields");
function restoreFunctions(state, backupState) {
  Object.keys(state.fields).forEach(function(key) {
    state.fields[key] = _extends$o({}, state.fields[key], {
      change: state.fields[key].change || backupState.fields[key] && backupState.fields[key].change,
      blur: state.fields[key].blur || backupState.fields[key] && backupState.fields[key].blur,
      focus: state.fields[key].focus || backupState.fields[key] && backupState.fields[key].focus
    }), state.fields[key].change || delete state.fields[key].change, state.fields[key].blur || delete state.fields[key].blur, state.fields[key].focus || delete state.fields[key].focus;
  });
}
__name(restoreFunctions, "restoreFunctions");
var TMP = "tmp", move = /* @__PURE__ */ __name(function(_ref, state, _ref2) {
  var name2 = _ref[0], from = _ref[1], to = _ref[2], changeValue = _ref2.changeValue;
  if (from !== to) {
    changeValue(state, name2, function(array2) {
      var copy2 = [].concat(array2 || []), value = copy2[from];
      return copy2.splice(from, 1), copy2.splice(to, 0, value), copy2;
    });
    var backupState = _extends$o({}, state, {
      fields: _extends$o({}, state.fields)
      // move this row to tmp index
    }), fromPrefix = name2 + "[" + from + "]";
    if (moveFields(name2, fromPrefix, TMP, state), from < to)
      for (var i2 = from + 1; i2 <= to; i2++) {
        var innerFromPrefix = name2 + "[" + i2 + "]";
        moveFields(name2, innerFromPrefix, "" + (i2 - 1), state);
      }
    else
      for (var _i = from - 1; _i >= to; _i--) {
        var _innerFromPrefix = name2 + "[" + _i + "]";
        moveFields(name2, _innerFromPrefix, "" + (_i + 1), state);
      }
    var tmpPrefix = name2 + "[" + TMP + "]";
    moveFields(name2, tmpPrefix, to, state), restoreFunctions(state, backupState);
  }
}, "move"), pop = /* @__PURE__ */ __name(function(_ref, state, _ref2) {
  var name2 = _ref[0], changeValue = _ref2.changeValue, result2, removedIndex;
  if (changeValue(state, name2, function(array2) {
    if (array2)
      return array2.length ? (removedIndex = array2.length - 1, result2 = array2[removedIndex], array2.slice(0, removedIndex)) : [];
  }), removedIndex !== void 0) {
    var pattern = new RegExp("^" + escapeRegexTokens(name2) + "\\[" + removedIndex + "].*");
    Object.keys(state.fields).forEach(function(key) {
      pattern.test(key) && delete state.fields[key];
    });
  }
  return result2;
}, "pop"), push$1 = /* @__PURE__ */ __name(function(_ref, state, _ref2) {
  var name2 = _ref[0], value = _ref[1], changeValue = _ref2.changeValue;
  changeValue(state, name2, function(array2) {
    return array2 ? [].concat(array2, [value]) : [value];
  });
}, "push"), remove = /* @__PURE__ */ __name(function(_ref, state, _ref2) {
  var name2 = _ref[0], index2 = _ref[1], changeValue = _ref2.changeValue, renameField = _ref2.renameField, returnValue;
  changeValue(state, name2, function(array2) {
    var copy2 = [].concat(array2 || []);
    return returnValue = copy2[index2], copy2.splice(index2, 1), copy2;
  });
  var pattern = new RegExp("^" + escapeRegexTokens(name2) + "\\[(\\d+)\\](.*)"), backup = _extends$o({}, state, {
    fields: _extends$o({}, state.fields)
  });
  return Object.keys(state.fields).forEach(function(key) {
    var tokens = pattern.exec(key);
    if (tokens) {
      var fieldIndex = Number(tokens[1]);
      if (fieldIndex === index2)
        delete state.fields[key];
      else if (fieldIndex > index2) {
        delete state.fields[key];
        var decrementedKey = name2 + "[" + (fieldIndex - 1) + "]" + tokens[2];
        backup.fields[decrementedKey] ? moveFieldState(state, backup.fields[key], decrementedKey, backup) : renameField(state, key, decrementedKey);
      }
    }
  }), returnValue;
}, "remove"), countBelow = /* @__PURE__ */ __name(function(array2, value) {
  return array2.reduce(function(count, item) {
    return item < value ? count + 1 : count;
  }, 0);
}, "countBelow"), removeBatch = /* @__PURE__ */ __name(function(_ref, state, _ref2) {
  var name2 = _ref[0], indexes = _ref[1], changeValue = _ref2.changeValue, sortedIndexes = [].concat(indexes);
  sortedIndexes.sort();
  for (var i2 = 0; i2 < sortedIndexes.length; i2++)
    i2 > 0 && sortedIndexes[i2] === sortedIndexes[i2 - 1] && sortedIndexes.splice(i2--, 1);
  var returnValue = [];
  changeValue(state, name2, function(array2) {
    if (returnValue = indexes.map(function(index2) {
      return array2 && array2[index2];
    }), !array2 || !sortedIndexes.length)
      return array2;
    var copy2 = [].concat(array2), removed = [];
    return sortedIndexes.forEach(function(index2) {
      copy2.splice(index2 - removed.length, 1), removed.push(array2 && array2[index2]);
    }), copy2;
  });
  var pattern = new RegExp("^" + escapeRegexTokens(name2) + "\\[(\\d+)\\](.*)"), newState = _extends$o({}, state, {
    fields: {}
  });
  return Object.keys(state.fields).forEach(function(key) {
    var tokens = pattern.exec(key);
    if (tokens) {
      var fieldIndex = Number(tokens[1]);
      if (!~sortedIndexes.indexOf(fieldIndex)) {
        var decrementedKey = name2 + "[" + (fieldIndex - countBelow(sortedIndexes, fieldIndex)) + "]" + tokens[2];
        moveFieldState(newState, state.fields[key], decrementedKey, state);
      }
    } else
      newState.fields[key] = state.fields[key];
  }), state.fields = newState.fields, returnValue;
}, "removeBatch"), shift = /* @__PURE__ */ __name(function(_ref, state, tools) {
  var name2 = _ref[0];
  return remove([name2, 0], state, tools);
}, "shift"), TMP$1 = "tmp", swap$1 = /* @__PURE__ */ __name(function(_ref, state, _ref2) {
  var name2 = _ref[0], indexA = _ref[1], indexB = _ref[2], changeValue = _ref2.changeValue;
  if (indexA !== indexB) {
    changeValue(state, name2, function(array2) {
      var copy2 = [].concat(array2 || []), a4 = copy2[indexA];
      return copy2[indexA] = copy2[indexB], copy2[indexB] = a4, copy2;
    });
    var backupState = _extends$o({}, state, {
      fields: _extends$o({}, state.fields)
      // swap all field state that begin with "name[indexA]" with that under "name[indexB]"
    }), aPrefix = name2 + "[" + indexA + "]", bPrefix = name2 + "[" + indexB + "]", tmpPrefix = name2 + "[" + TMP$1 + "]";
    moveFields(name2, aPrefix, TMP$1, state), moveFields(name2, bPrefix, indexA, state), moveFields(name2, tmpPrefix, indexB, state), restoreFunctions(state, backupState);
  }
}, "swap"), unshift = /* @__PURE__ */ __name(function(_ref, state, tools) {
  var name2 = _ref[0], value = _ref[1];
  return insert([name2, 0, value], state, tools);
}, "unshift"), update = /* @__PURE__ */ __name(function(_ref, state, _ref2) {
  var name2 = _ref[0], index2 = _ref[1], value = _ref[2], changeValue = _ref2.changeValue;
  changeValue(state, name2, function(array2) {
    var copy2 = [].concat(array2 || []);
    return copy2.splice(index2, 1, value), copy2;
  });
}, "update"), mutators = {
  insert,
  concat,
  move,
  pop,
  push: push$1,
  remove,
  removeBatch,
  shift,
  swap: swap$1,
  unshift,
  update
};
const DEFAULT_GUTTER = {
  _: 16,
  lg: 24
};
function GridLayout({ children, ...rest }) {
  return /* @__PURE__ */ jsx(
    Grid,
    {
      gridTemplateColumns: "repeat(12, 1fr)",
      columnGap: DEFAULT_GUTTER,
      rowGap: "s",
      gridAutoFlow: "row",
      ...rest,
      children
    }
  );
}
__name(GridLayout, "GridLayout");
function GridItem({
  xs,
  sm,
  md,
  lg,
  xl,
  children,
  ...boxProps
}) {
  const gridColumns = {
    _: `span ${xs}`,
    sm: sm ? `span ${sm}` : void 0,
    md: md ? `span ${md}` : void 0,
    lg: lg ? `span ${lg}` : void 0,
    xl: xl ? `span ${xl}` : void 0
  };
  return /* @__PURE__ */ jsx(Box, { gridColumn: gridColumns, ...boxProps, children });
}
__name(GridItem, "GridItem");
const MotionConfigContext = createContext({
  transformPagePoint: (p) => p,
  isStatic: !1,
  reducedMotion: "never"
}), MotionContext = createContext({}), PresenceContext = createContext(null), isBrowser = typeof document < "u", useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect, LazyContext = createContext({ strict: !1 }), camelToDash = /* @__PURE__ */ __name((str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), "camelToDash"), optimizedAppearDataId = "framerAppearId", optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);
function useVisualElement(Component2, visualState, props, createVisualElement) {
  const { visualElement: parent2 } = useContext(MotionContext), lazyContext = useContext(LazyContext), presenceContext = useContext(PresenceContext), reducedMotionConfig = useContext(MotionConfigContext).reducedMotion, visualElementRef = useRef();
  createVisualElement = createVisualElement || lazyContext.renderer, !visualElementRef.current && createVisualElement && (visualElementRef.current = createVisualElement(Component2, {
    visualState,
    parent: parent2,
    props,
    presenceContext,
    blockInitialAnimation: presenceContext ? presenceContext.initial === !1 : !1,
    reducedMotionConfig
  }));
  const visualElement = visualElementRef.current;
  useInsertionEffect(() => {
    visualElement && visualElement.update(props, presenceContext);
  });
  const wantsHandoff = useRef(!!(props[optimizedAppearDataAttribute] && !window.HandoffComplete));
  return useIsomorphicLayoutEffect(() => {
    visualElement && (visualElement.render(), wantsHandoff.current && visualElement.animationState && visualElement.animationState.animateChanges());
  }), useEffect(() => {
    visualElement && (visualElement.updateFeatures(), !wantsHandoff.current && visualElement.animationState && visualElement.animationState.animateChanges(), wantsHandoff.current && (wantsHandoff.current = !1, window.HandoffComplete = !0));
  }), visualElement;
}
__name(useVisualElement, "useVisualElement");
function isRefObject(ref) {
  return ref && typeof ref == "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}
__name(isRefObject, "isRefObject");
function useMotionRef(visualState, visualElement, externalRef) {
  return useCallback(
    (instance) => {
      instance && visualState.mount && visualState.mount(instance), visualElement && (instance ? visualElement.mount(instance) : visualElement.unmount()), externalRef && (typeof externalRef == "function" ? externalRef(instance) : isRefObject(externalRef) && (externalRef.current = instance));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]
  );
}
__name(useMotionRef, "useMotionRef");
function isVariantLabel(v) {
  return typeof v == "string" || Array.isArray(v);
}
__name(isVariantLabel, "isVariantLabel");
function isAnimationControls(v) {
  return v !== null && typeof v == "object" && typeof v.start == "function";
}
__name(isAnimationControls, "isAnimationControls");
const variantPriorityOrder = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], variantProps = ["initial", ...variantPriorityOrder];
function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some((name2) => isVariantLabel(props[name2]));
}
__name(isControllingVariants, "isControllingVariants");
function isVariantNode(props) {
  return !!(isControllingVariants(props) || props.variants);
}
__name(isVariantNode, "isVariantNode");
function getCurrentTreeVariants(props, context) {
  if (isControllingVariants(props)) {
    const { initial, animate } = props;
    return {
      initial: initial === !1 || isVariantLabel(initial) ? initial : void 0,
      animate: isVariantLabel(animate) ? animate : void 0
    };
  }
  return props.inherit !== !1 ? context : {};
}
__name(getCurrentTreeVariants, "getCurrentTreeVariants");
function useCreateMotionContext(props) {
  const { initial, animate } = getCurrentTreeVariants(props, useContext(MotionContext));
  return useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
__name(useCreateMotionContext, "useCreateMotionContext");
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}
__name(variantLabelsAsDependency, "variantLabelsAsDependency");
const featureProps = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, featureDefinitions = {};
for (const key in featureProps)
  featureDefinitions[key] = {
    isEnabled: (props) => featureProps[key].some((name2) => !!props[name2])
  };
function loadFeatures(features) {
  for (const key in features)
    featureDefinitions[key] = {
      ...featureDefinitions[key],
      ...features[key]
    };
}
__name(loadFeatures, "loadFeatures");
const LayoutGroupContext = createContext({}), SwitchLayoutGroupContext = createContext({}), motionComponentSymbol = Symbol.for("motionComponentSymbol");
function createMotionComponent({ preloadedFeatures: preloadedFeatures2, createVisualElement, useRender, useVisualState, Component: Component2 }) {
  preloadedFeatures2 && loadFeatures(preloadedFeatures2);
  function MotionComponent(props, externalRef) {
    let MeasureLayout2;
    const configAndProps = {
      ...useContext(MotionConfigContext),
      ...props,
      layoutId: useLayoutId(props)
    }, { isStatic } = configAndProps, context = useCreateMotionContext(props), visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser) {
      context.visualElement = useVisualElement(Component2, visualState, configAndProps, createVisualElement);
      const initialLayoutGroupConfig = useContext(SwitchLayoutGroupContext), isStrict = useContext(LazyContext).strict;
      context.visualElement && (MeasureLayout2 = context.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        configAndProps,
        isStrict,
        preloadedFeatures2,
        initialLayoutGroupConfig
      ));
    }
    return React.createElement(
      MotionContext.Provider,
      { value: context },
      MeasureLayout2 && context.visualElement ? React.createElement(MeasureLayout2, { visualElement: context.visualElement, ...configAndProps }) : null,
      useRender(Component2, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
    );
  }
  __name(MotionComponent, "MotionComponent");
  const ForwardRefComponent = forwardRef(MotionComponent);
  return ForwardRefComponent[motionComponentSymbol] = Component2, ForwardRefComponent;
}
__name(createMotionComponent, "createMotionComponent");
function useLayoutId({ layoutId }) {
  const layoutGroupId = useContext(LayoutGroupContext).id;
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}
__name(useLayoutId, "useLayoutId");
function createMotionProxy(createConfig) {
  function custom2(Component2, customMotionComponentConfig = {}) {
    return createMotionComponent(createConfig(Component2, customMotionComponentConfig));
  }
  if (__name(custom2, "custom"), typeof Proxy > "u")
    return custom2;
  const componentCache = /* @__PURE__ */ new Map();
  return new Proxy(custom2, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (_target, key) => (componentCache.has(key) || componentCache.set(key, custom2(key)), componentCache.get(key))
  });
}
__name(createMotionProxy, "createMotionProxy");
const lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(Component2) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component2 != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Component2.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(lowercaseSVGElements.indexOf(Component2) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(Component2))
    )
  );
}
__name(isSVGComponent, "isSVGComponent");
const scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}
__name(addScaleCorrector, "addScaleCorrector");
const transformPropOrder = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], transformProps = new Set(transformPropOrder);
function isForcedMotionValue(key, { layout: layout2, layoutId }) {
  return transformProps.has(key) || key.startsWith("origin") || (layout2 || layoutId !== void 0) && (!!scaleCorrectors[key] || key === "opacity");
}
__name(isForcedMotionValue, "isForcedMotionValue");
const isMotionValue = /* @__PURE__ */ __name((value) => !!(value && value.getVelocity), "isMotionValue"), translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, numTransforms = transformPropOrder.length;
function buildTransform(transform2, { enableHardwareAcceleration = !0, allowTransformNone = !0 }, transformIsDefault, transformTemplate) {
  let transformString = "";
  for (let i2 = 0; i2 < numTransforms; i2++) {
    const key = transformPropOrder[i2];
    if (transform2[key] !== void 0) {
      const transformName = translateAlias[key] || key;
      transformString += `${transformName}(${transform2[key]}) `;
    }
  }
  return enableHardwareAcceleration && !transform2.z && (transformString += "translateZ(0)"), transformString = transformString.trim(), transformTemplate ? transformString = transformTemplate(transform2, transformIsDefault ? "" : transformString) : allowTransformNone && transformIsDefault && (transformString = "none"), transformString;
}
__name(buildTransform, "buildTransform");
const checkStringStartsWith = /* @__PURE__ */ __name((token) => (key) => typeof key == "string" && key.startsWith(token), "checkStringStartsWith"), isCSSVariableName = checkStringStartsWith("--"), isCSSVariableToken = checkStringStartsWith("var(--"), cssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, getValueAsType = /* @__PURE__ */ __name((value, type) => type && typeof value == "number" ? type.transform(value) : value, "getValueAsType"), clamp = /* @__PURE__ */ __name((min2, max2, v) => Math.min(Math.max(v, min2), max2), "clamp"), number$4 = {
  test: (v) => typeof v == "number",
  parse: parseFloat,
  transform: (v) => v
}, alpha$1 = {
  ...number$4,
  transform: (v) => clamp(0, 1, v)
}, scale = {
  ...number$4,
  default: 1
}, sanitize = /* @__PURE__ */ __name((v) => Math.round(v * 1e5) / 1e5, "sanitize"), floatRegex = /(-)?([\d]*\.?[\d])+/g, colorRegex = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, singleColorRegex = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString$2(v) {
  return typeof v == "string";
}
__name(isString$2, "isString$2");
const createUnitType = /* @__PURE__ */ __name((unit2) => ({
  test: (v) => isString$2(v) && v.endsWith(unit2) && v.split(" ").length === 1,
  parse: parseFloat,
  transform: (v) => `${v}${unit2}`
}), "createUnitType"), degrees = createUnitType("deg"), percent = createUnitType("%"), px = createUnitType("px"), vh = createUnitType("vh"), vw = createUnitType("vw"), progressPercentage = {
  ...percent,
  parse: (v) => percent.parse(v) / 100,
  transform: (v) => percent.transform(v * 100)
}, int = {
  ...number$4,
  transform: Math.round
}, numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha$1,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  // SVG
  fillOpacity: alpha$1,
  strokeOpacity: alpha$1,
  numOctaves: int
};
function buildHTMLStyles(state, latestValues, options, transformTemplate) {
  const { style: style2, vars, transform: transform2, transformOrigin: transformOrigin2 } = state;
  let hasTransform2 = !1, hasTransformOrigin = !1, transformIsNone = !0;
  for (const key in latestValues) {
    const value = latestValues[key];
    if (isCSSVariableName(key)) {
      vars[key] = value;
      continue;
    }
    const valueType = numberValueTypes[key], valueAsType = getValueAsType(value, valueType);
    if (transformProps.has(key)) {
      if (hasTransform2 = !0, transform2[key] = valueAsType, !transformIsNone)
        continue;
      value !== (valueType.default || 0) && (transformIsNone = !1);
    } else
      key.startsWith("origin") ? (hasTransformOrigin = !0, transformOrigin2[key] = valueAsType) : style2[key] = valueAsType;
  }
  if (latestValues.transform || (hasTransform2 || transformTemplate ? style2.transform = buildTransform(state.transform, options, transformIsNone, transformTemplate) : style2.transform && (style2.transform = "none")), hasTransformOrigin) {
    const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin2;
    style2.transformOrigin = `${originX} ${originY} ${originZ}`;
  }
}
__name(buildHTMLStyles, "buildHTMLStyles");
const createHtmlRenderState = /* @__PURE__ */ __name(() => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), "createHtmlRenderState");
function copyRawValuesOnly(target, source, props) {
  for (const key in source)
    !isMotionValue(source[key]) && !isForcedMotionValue(key, props) && (target[key] = source[key]);
}
__name(copyRawValuesOnly, "copyRawValuesOnly");
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
  return useMemo(() => {
    const state = createHtmlRenderState();
    return buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate), Object.assign({}, state.vars, state.style);
  }, [visualState]);
}
__name(useInitialMotionValues, "useInitialMotionValues");
function useStyle(props, visualState, isStatic) {
  const styleProp = props.style || {}, style2 = {};
  return copyRawValuesOnly(style2, styleProp, props), Object.assign(style2, useInitialMotionValues(props, visualState, isStatic)), props.transformValues ? props.transformValues(style2) : style2;
}
__name(useStyle, "useStyle");
function useHTMLProps(props, visualState, isStatic) {
  const htmlProps = {}, style2 = useStyle(props, visualState, isStatic);
  return props.drag && props.dragListener !== !1 && (htmlProps.draggable = !1, style2.userSelect = style2.WebkitUserSelect = style2.WebkitTouchCallout = "none", style2.touchAction = props.drag === !0 ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`), props.tabIndex === void 0 && (props.onTap || props.onTapStart || props.whileTap) && (htmlProps.tabIndex = 0), htmlProps.style = style2, htmlProps;
}
__name(useHTMLProps, "useHTMLProps");
const validMotionProps = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function isValidMotionProp(key) {
  return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}
__name(isValidMotionProp, "isValidMotionProp");
let shouldForward = /* @__PURE__ */ __name((key) => !isValidMotionProp(key), "shouldForward");
function loadExternalIsValidProp(isValidProp) {
  isValidProp && (shouldForward = /* @__PURE__ */ __name((key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key), "shouldForward"));
}
__name(loadExternalIsValidProp, "loadExternalIsValidProp");
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch {
}
function filterProps$1(props, isDom, forwardMotionProps) {
  const filteredProps = {};
  for (const key in props)
    key === "values" && typeof props.values == "object" || (shouldForward(key) || forwardMotionProps === !0 && isValidMotionProp(key) || !isDom && !isValidMotionProp(key) || // If trying to use native HTML drag events, forward drag listeners
    props.draggable && key.startsWith("onDrag")) && (filteredProps[key] = props[key]);
  return filteredProps;
}
__name(filterProps$1, "filterProps$1");
function calcOrigin$1(origin, offset, size) {
  return typeof origin == "string" ? origin : px.transform(offset + size * origin);
}
__name(calcOrigin$1, "calcOrigin$1");
function calcSVGTransformOrigin(dimensions, originX, originY) {
  const pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width), pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
  return `${pxOriginX} ${pxOriginY}`;
}
__name(calcSVGTransformOrigin, "calcSVGTransformOrigin");
const dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = !0) {
  attrs.pathLength = 1;
  const keys2 = useDashCase ? dashKeys : camelKeys;
  attrs[keys2.offset] = px.transform(-offset);
  const pathLength = px.transform(length), pathSpacing = px.transform(spacing);
  attrs[keys2.array] = `${pathLength} ${pathSpacing}`;
}
__name(buildSVGPath, "buildSVGPath");
function buildSVGAttrs(state, {
  attrX,
  attrY,
  attrScale,
  originX,
  originY,
  pathLength,
  pathSpacing = 1,
  pathOffset = 0,
  // This is object creation, which we try to avoid per-frame.
  ...latest
}, options, isSVGTag2, transformTemplate) {
  if (buildHTMLStyles(state, latest, options, transformTemplate), isSVGTag2) {
    state.style.viewBox && (state.attrs.viewBox = state.style.viewBox);
    return;
  }
  state.attrs = state.style, state.style = {};
  const { attrs, style: style2, dimensions } = state;
  attrs.transform && (dimensions && (style2.transform = attrs.transform), delete attrs.transform), dimensions && (originX !== void 0 || originY !== void 0 || style2.transform) && (style2.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== void 0 ? originX : 0.5, originY !== void 0 ? originY : 0.5)), attrX !== void 0 && (attrs.x = attrX), attrY !== void 0 && (attrs.y = attrY), attrScale !== void 0 && (attrs.scale = attrScale), pathLength !== void 0 && buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, !1);
}
__name(buildSVGAttrs, "buildSVGAttrs");
const createSvgRenderState = /* @__PURE__ */ __name(() => ({
  ...createHtmlRenderState(),
  attrs: {}
}), "createSvgRenderState"), isSVGTag = /* @__PURE__ */ __name((tag) => typeof tag == "string" && tag.toLowerCase() === "svg", "isSVGTag");
function useSVGProps(props, visualState, _isStatic, Component2) {
  const visualProps = useMemo(() => {
    const state = createSvgRenderState();
    return buildSVGAttrs(state, visualState, { enableHardwareAcceleration: !1 }, isSVGTag(Component2), props.transformTemplate), {
      ...state.attrs,
      style: { ...state.style }
    };
  }, [visualState]);
  if (props.style) {
    const rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props), visualProps.style = { ...rawStyles, ...visualProps.style };
  }
  return visualProps;
}
__name(useSVGProps, "useSVGProps");
function createUseRender(forwardMotionProps = !1) {
  return /* @__PURE__ */ __name((Component2, props, ref, { latestValues }, isStatic) => {
    const visualProps = (isSVGComponent(Component2) ? useSVGProps : useHTMLProps)(props, latestValues, isStatic, Component2), elementProps = {
      ...filterProps$1(props, typeof Component2 == "string", forwardMotionProps),
      ...visualProps,
      ref
    }, { children } = props, renderedChildren = useMemo(() => isMotionValue(children) ? children.get() : children, [children]);
    return createElement(Component2, {
      ...elementProps,
      children: renderedChildren
    });
  }, "useRender");
}
__name(createUseRender, "createUseRender");
function renderHTML(element2, { style: style2, vars }, styleProp, projection) {
  Object.assign(element2.style, style2, projection && projection.getProjectionStyles(styleProp));
  for (const key in vars)
    element2.style.setProperty(key, vars[key]);
}
__name(renderHTML, "renderHTML");
const camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function renderSVG(element2, renderState, _styleProp, projection) {
  renderHTML(element2, renderState, void 0, projection);
  for (const key in renderState.attrs)
    element2.setAttribute(camelCaseAttributes.has(key) ? key : camelToDash(key), renderState.attrs[key]);
}
__name(renderSVG, "renderSVG");
function scrapeMotionValuesFromProps$1(props, prevProps) {
  const { style: style2 } = props, newValues = {};
  for (const key in style2)
    (isMotionValue(style2[key]) || prevProps.style && isMotionValue(prevProps.style[key]) || isForcedMotionValue(key, props)) && (newValues[key] = style2[key]);
  return newValues;
}
__name(scrapeMotionValuesFromProps$1, "scrapeMotionValuesFromProps$1");
function scrapeMotionValuesFromProps(props, prevProps) {
  const newValues = scrapeMotionValuesFromProps$1(props, prevProps);
  for (const key in props)
    if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
      const targetKey = transformPropOrder.indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
      newValues[targetKey] = props[key];
    }
  return newValues;
}
__name(scrapeMotionValuesFromProps, "scrapeMotionValuesFromProps");
function resolveVariantFromProps(props, definition2, custom2, currentValues = {}, currentVelocity = {}) {
  return typeof definition2 == "function" && (definition2 = definition2(custom2 !== void 0 ? custom2 : props.custom, currentValues, currentVelocity)), typeof definition2 == "string" && (definition2 = props.variants && props.variants[definition2]), typeof definition2 == "function" && (definition2 = definition2(custom2 !== void 0 ? custom2 : props.custom, currentValues, currentVelocity)), definition2;
}
__name(resolveVariantFromProps, "resolveVariantFromProps");
function useConstant$1(init2) {
  const ref = useRef(null);
  return ref.current === null && (ref.current = init2()), ref.current;
}
__name(useConstant$1, "useConstant$1");
const isKeyframesTarget = /* @__PURE__ */ __name((v) => Array.isArray(v), "isKeyframesTarget"), isCustomValue = /* @__PURE__ */ __name((v) => !!(v && typeof v == "object" && v.mix && v.toValue), "isCustomValue"), resolveFinalValueInKeyframes = /* @__PURE__ */ __name((v) => isKeyframesTarget(v) ? v[v.length - 1] || 0 : v, "resolveFinalValueInKeyframes");
function resolveMotionValue(value) {
  const unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}
__name(resolveMotionValue, "resolveMotionValue");
function makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps2, createRenderState, onMount }, props, context, presenceContext) {
  const state = {
    latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps2),
    renderState: createRenderState()
  };
  return onMount && (state.mount = (instance) => onMount(props, instance, state)), state;
}
__name(makeState, "makeState");
const makeUseVisualState = /* @__PURE__ */ __name((config2) => (props, isStatic) => {
  const context = useContext(MotionContext), presenceContext = useContext(PresenceContext), make = /* @__PURE__ */ __name(() => makeState(config2, props, context, presenceContext), "make");
  return isStatic ? make() : useConstant$1(make);
}, "makeUseVisualState");
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
  const values = {}, motionValues = scrapeMotionValues(props, {});
  for (const key in motionValues)
    values[key] = resolveMotionValue(motionValues[key]);
  let { initial, animate } = props;
  const isControllingVariants$1 = isControllingVariants(props), isVariantNode$1 = isVariantNode(props);
  context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== !1 && (initial === void 0 && (initial = context.initial), animate === void 0 && (animate = context.animate));
  let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === !1 : !1;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === !1;
  const variantToSet = isInitialAnimationBlocked ? animate : initial;
  return variantToSet && typeof variantToSet != "boolean" && !isAnimationControls(variantToSet) && (Array.isArray(variantToSet) ? variantToSet : [variantToSet]).forEach((definition2) => {
    const resolved = resolveVariantFromProps(props, definition2);
    if (!resolved)
      return;
    const { transitionEnd, transition: transition2, ...target } = resolved;
    for (const key in target) {
      let valueTarget = target[key];
      if (Array.isArray(valueTarget)) {
        const index2 = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
        valueTarget = valueTarget[index2];
      }
      valueTarget !== null && (values[key] = valueTarget);
    }
    for (const key in transitionEnd)
      values[key] = transitionEnd[key];
  }), values;
}
__name(makeLatestValues, "makeLatestValues");
const noop$4 = /* @__PURE__ */ __name((any) => any, "noop$4"), _Queue = class _Queue {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(process2) {
    if (!this.scheduled.has(process2))
      return this.scheduled.add(process2), this.order.push(process2), !0;
  }
  remove(process2) {
    const index2 = this.order.indexOf(process2);
    index2 !== -1 && (this.order.splice(index2, 1), this.scheduled.delete(process2));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
};
__name(_Queue, "Queue");
let Queue = _Queue;
function createRenderStep(runNextFrame) {
  let thisFrame = new Queue(), nextFrame = new Queue(), numToRun = 0, isProcessing = !1, flushNextFrame = !1;
  const toKeepAlive = /* @__PURE__ */ new WeakSet(), step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (callback, keepAlive = !1, immediate = !1) => {
      const addToCurrentFrame = immediate && isProcessing, queue = addToCurrentFrame ? thisFrame : nextFrame;
      return keepAlive && toKeepAlive.add(callback), queue.add(callback) && addToCurrentFrame && isProcessing && (numToRun = thisFrame.order.length), callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (callback) => {
      nextFrame.remove(callback), toKeepAlive.delete(callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (frameData2) => {
      if (isProcessing) {
        flushNextFrame = !0;
        return;
      }
      if (isProcessing = !0, [thisFrame, nextFrame] = [nextFrame, thisFrame], nextFrame.clear(), numToRun = thisFrame.order.length, numToRun)
        for (let i2 = 0; i2 < numToRun; i2++) {
          const callback = thisFrame.order[i2];
          callback(frameData2), toKeepAlive.has(callback) && (step.schedule(callback), runNextFrame());
        }
      isProcessing = !1, flushNextFrame && (flushNextFrame = !1, step.process(frameData2));
    }
  };
  return step;
}
__name(createRenderStep, "createRenderStep");
const stepsOrder = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  let runNextFrame = !1, useDefaultElapsed = !0;
  const state = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, steps2 = stepsOrder.reduce((acc, key) => (acc[key] = createRenderStep(() => runNextFrame = !0), acc), {}), processStep = /* @__PURE__ */ __name((stepId) => steps2[stepId].process(state), "processStep"), processBatch = /* @__PURE__ */ __name(() => {
    const timestamp = performance.now();
    runNextFrame = !1, state.delta = useDefaultElapsed ? 1e3 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1), state.timestamp = timestamp, state.isProcessing = !0, stepsOrder.forEach(processStep), state.isProcessing = !1, runNextFrame && allowKeepAlive && (useDefaultElapsed = !1, scheduleNextBatch(processBatch));
  }, "processBatch"), wake = /* @__PURE__ */ __name(() => {
    runNextFrame = !0, useDefaultElapsed = !0, state.isProcessing || scheduleNextBatch(processBatch);
  }, "wake");
  return { schedule: stepsOrder.reduce((acc, key) => {
    const step = steps2[key];
    return acc[key] = (process2, keepAlive = !1, immediate = !1) => (runNextFrame || wake(), step.schedule(process2, keepAlive, immediate)), acc;
  }, {}), cancel: /* @__PURE__ */ __name((process2) => stepsOrder.forEach((key) => steps2[key].cancel(process2)), "cancel"), state, steps: steps2 };
}
__name(createRenderBatcher, "createRenderBatcher");
const { schedule: frame, cancel: cancelFrame, state: frameData, steps } = createRenderBatcher(typeof requestAnimationFrame < "u" ? requestAnimationFrame : noop$4, !0), svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: (props, instance, { renderState, latestValues }) => {
      frame.read(() => {
        try {
          renderState.dimensions = typeof instance.getBBox == "function" ? instance.getBBox() : instance.getBoundingClientRect();
        } catch {
          renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), frame.render(() => {
        buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: !1 }, isSVGTag(instance.tagName), props.transformTemplate), renderSVG(instance, renderState);
      });
    }
  })
}, htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function createDomMotionConfig(Component2, { forwardMotionProps = !1 }, preloadedFeatures2, createVisualElement) {
  return {
    ...isSVGComponent(Component2) ? svgMotionConfig : htmlMotionConfig,
    preloadedFeatures: preloadedFeatures2,
    useRender: createUseRender(forwardMotionProps),
    createVisualElement,
    Component: Component2
  };
}
__name(createDomMotionConfig, "createDomMotionConfig");
function addDomEvent(target, eventName, handler, options = { passive: !0 }) {
  return target.addEventListener(eventName, handler, options), () => target.removeEventListener(eventName, handler);
}
__name(addDomEvent, "addDomEvent");
const isPrimaryPointer = /* @__PURE__ */ __name((event) => event.pointerType === "mouse" ? typeof event.button != "number" || event.button <= 0 : event.isPrimary !== !1, "isPrimaryPointer");
function extractEventInfo(event, pointType = "page") {
  return {
    point: {
      x: event[pointType + "X"],
      y: event[pointType + "Y"]
    }
  };
}
__name(extractEventInfo, "extractEventInfo");
const addPointerInfo = /* @__PURE__ */ __name((handler) => (event) => isPrimaryPointer(event) && handler(event, extractEventInfo(event)), "addPointerInfo");
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, eventName, addPointerInfo(handler), options);
}
__name(addPointerEvent, "addPointerEvent");
const combineFunctions = /* @__PURE__ */ __name((a4, b2) => (v) => b2(a4(v)), "combineFunctions"), pipe = /* @__PURE__ */ __name((...transformers) => transformers.reduce(combineFunctions), "pipe");
function createLock(name2) {
  let lock = null;
  return () => {
    const openLock = /* @__PURE__ */ __name(() => {
      lock = null;
    }, "openLock");
    return lock === null ? (lock = name2, openLock) : !1;
  };
}
__name(createLock, "createLock");
const globalHorizontalLock = createLock("dragHorizontal"), globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag2) {
  let lock = !1;
  if (drag2 === "y")
    lock = globalVerticalLock();
  else if (drag2 === "x")
    lock = globalHorizontalLock();
  else {
    const openHorizontal = globalHorizontalLock(), openVertical = globalVerticalLock();
    openHorizontal && openVertical ? lock = /* @__PURE__ */ __name(() => {
      openHorizontal(), openVertical();
    }, "lock") : (openHorizontal && openHorizontal(), openVertical && openVertical());
  }
  return lock;
}
__name(getGlobalLock, "getGlobalLock");
function isDragActive() {
  const openGestureLock = getGlobalLock(!0);
  return openGestureLock ? (openGestureLock(), !1) : !0;
}
__name(isDragActive, "isDragActive");
const _Feature = class _Feature {
  constructor(node2) {
    this.isMounted = !1, this.node = node2;
  }
  update() {
  }
};
__name(_Feature, "Feature");
let Feature = _Feature;
function addHoverEvent(node2, isActive) {
  const eventName = "pointer" + (isActive ? "enter" : "leave"), callbackName = "onHover" + (isActive ? "Start" : "End"), handleEvent = /* @__PURE__ */ __name((event, info) => {
    if (event.pointerType === "touch" || isDragActive())
      return;
    const props = node2.getProps();
    node2.animationState && props.whileHover && node2.animationState.setActive("whileHover", isActive), props[callbackName] && frame.update(() => props[callbackName](event, info));
  }, "handleEvent");
  return addPointerEvent(node2.current, eventName, handleEvent, {
    passive: !node2.getProps()[callbackName]
  });
}
__name(addHoverEvent, "addHoverEvent");
const _HoverGesture = class _HoverGesture extends Feature {
  mount() {
    this.unmount = pipe(addHoverEvent(this.node, !0), addHoverEvent(this.node, !1));
  }
  unmount() {
  }
};
__name(_HoverGesture, "HoverGesture");
let HoverGesture = _HoverGesture;
const _FocusGesture = class _FocusGesture extends Feature {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let isFocusVisible = !1;
    try {
      isFocusVisible = this.node.current.matches(":focus-visible");
    } catch {
      isFocusVisible = !0;
    }
    !isFocusVisible || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
};
__name(_FocusGesture, "FocusGesture");
let FocusGesture = _FocusGesture;
const isNodeOrChild = /* @__PURE__ */ __name((parent2, child) => child ? parent2 === child ? !0 : isNodeOrChild(parent2, child.parentElement) : !1, "isNodeOrChild");
function fireSyntheticPointerEvent(name2, handler) {
  if (!handler)
    return;
  const syntheticPointerEvent = new PointerEvent("pointer" + name2);
  handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
__name(fireSyntheticPointerEvent, "fireSyntheticPointerEvent");
const _PressGesture = class _PressGesture extends Feature {
  constructor() {
    super(...arguments), this.removeStartListeners = noop$4, this.removeEndListeners = noop$4, this.removeAccessibleListeners = noop$4, this.startPointerPress = (startEvent, startInfo) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const props = this.node.getProps(), removePointerUpListener = addPointerEvent(window, "pointerup", /* @__PURE__ */ __name((endEvent, endInfo) => {
        if (!this.checkPressEnd())
          return;
        const { onTap, onTapCancel, globalTapTarget } = this.node.getProps();
        frame.update(() => {
          !globalTapTarget && !isNodeOrChild(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
        });
      }, "endPointerPress"), { passive: !(props.onTap || props.onPointerUp) }), removePointerCancelListener = addPointerEvent(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), { passive: !(props.onTapCancel || props.onPointerCancel) });
      this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener), this.startPress(startEvent, startInfo);
    }, this.startAccessiblePress = () => {
      const handleKeydown = /* @__PURE__ */ __name((keydownEvent) => {
        if (keydownEvent.key !== "Enter" || this.isPressing)
          return;
        const handleKeyup = /* @__PURE__ */ __name((keyupEvent) => {
          keyupEvent.key !== "Enter" || !this.checkPressEnd() || fireSyntheticPointerEvent("up", (event, info) => {
            const { onTap } = this.node.getProps();
            onTap && frame.update(() => onTap(event, info));
          });
        }, "handleKeyup");
        this.removeEndListeners(), this.removeEndListeners = addDomEvent(this.node.current, "keyup", handleKeyup), fireSyntheticPointerEvent("down", (event, info) => {
          this.startPress(event, info);
        });
      }, "handleKeydown"), removeKeydownListener = addDomEvent(this.node.current, "keydown", handleKeydown), handleBlur = /* @__PURE__ */ __name(() => {
        this.isPressing && fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
      }, "handleBlur"), removeBlurListener = addDomEvent(this.node.current, "blur", handleBlur);
      this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
    };
  }
  startPress(event, info) {
    this.isPressing = !0;
    const { onTapStart, whileTap } = this.node.getProps();
    whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !0), onTapStart && frame.update(() => onTapStart(event, info));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !isDragActive();
  }
  cancelPress(event, info) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel } = this.node.getProps();
    onTapCancel && frame.update(() => onTapCancel(event, info));
  }
  mount() {
    const props = this.node.getProps(), removePointerListener = addPointerEvent(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(props.onTapStart || props.onPointerStart) }), removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
};
__name(_PressGesture, "PressGesture");
let PressGesture = _PressGesture;
const observerCallbacks = /* @__PURE__ */ new WeakMap(), observers = /* @__PURE__ */ new WeakMap(), fireObserverCallback = /* @__PURE__ */ __name((entry) => {
  const callback = observerCallbacks.get(entry.target);
  callback && callback(entry);
}, "fireObserverCallback"), fireAllObserverCallbacks = /* @__PURE__ */ __name((entries) => {
  entries.forEach(fireObserverCallback);
}, "fireAllObserverCallbacks");
function initIntersectionObserver({ root: root2, ...options }) {
  const lookupRoot = root2 || document;
  observers.has(lookupRoot) || observers.set(lookupRoot, {});
  const rootObservers = observers.get(lookupRoot), key = JSON.stringify(options);
  return rootObservers[key] || (rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root: root2, ...options })), rootObservers[key];
}
__name(initIntersectionObserver, "initIntersectionObserver");
function observeIntersection(element2, options, callback) {
  const rootInteresectionObserver = initIntersectionObserver(options);
  return observerCallbacks.set(element2, callback), rootInteresectionObserver.observe(element2), () => {
    observerCallbacks.delete(element2), rootInteresectionObserver.unobserve(element2);
  };
}
__name(observeIntersection, "observeIntersection");
const thresholdNames = {
  some: 0,
  all: 1
}, _InViewFeature = class _InViewFeature extends Feature {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport = {} } = this.node.getProps(), { root: root2, margin: rootMargin, amount = "some", once } = viewport, options = {
      root: root2 ? root2.current : void 0,
      rootMargin,
      threshold: typeof amount == "number" ? amount : thresholdNames[amount]
    }, onIntersectionUpdate = /* @__PURE__ */ __name((entry) => {
      const { isIntersecting } = entry;
      if (this.isInView === isIntersecting || (this.isInView = isIntersecting, once && !isIntersecting && this.hasEnteredView))
        return;
      isIntersecting && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", isIntersecting);
      const { onViewportEnter, onViewportLeave } = this.node.getProps(), callback = isIntersecting ? onViewportEnter : onViewportLeave;
      callback && callback(entry);
    }, "onIntersectionUpdate");
    return observeIntersection(this.node.current, options, onIntersectionUpdate);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props, prevProps } = this.node;
    ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps)) && this.startObserver();
  }
  unmount() {
  }
};
__name(_InViewFeature, "InViewFeature");
let InViewFeature = _InViewFeature;
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
  return (name2) => viewport[name2] !== prevViewport[name2];
}
__name(hasViewportOptionChanged, "hasViewportOptionChanged");
const gestureAnimations = {
  inView: {
    Feature: InViewFeature
  },
  tap: {
    Feature: PressGesture
  },
  focus: {
    Feature: FocusGesture
  },
  hover: {
    Feature: HoverGesture
  }
};
function shallowCompare(next, prev) {
  if (!Array.isArray(prev))
    return !1;
  const prevLength = prev.length;
  if (prevLength !== next.length)
    return !1;
  for (let i2 = 0; i2 < prevLength; i2++)
    if (prev[i2] !== next[i2])
      return !1;
  return !0;
}
__name(shallowCompare, "shallowCompare");
function getCurrent(visualElement) {
  const current = {};
  return visualElement.values.forEach((value, key) => current[key] = value.get()), current;
}
__name(getCurrent, "getCurrent");
function getVelocity$1(visualElement) {
  const velocity = {};
  return visualElement.values.forEach((value, key) => velocity[key] = value.getVelocity()), velocity;
}
__name(getVelocity$1, "getVelocity$1");
function resolveVariant(visualElement, definition2, custom2) {
  const props = visualElement.getProps();
  return resolveVariantFromProps(props, definition2, custom2 !== void 0 ? custom2 : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
}
__name(resolveVariant, "resolveVariant");
let warning = noop$4, invariant$1 = noop$4;
process.env.NODE_ENV !== "production" && (warning = /* @__PURE__ */ __name((check2, message) => {
  !check2 && typeof console < "u" && console.warn(message);
}, "warning"), invariant$1 = /* @__PURE__ */ __name((check2, message) => {
  if (!check2)
    throw new Error(message);
}, "invariant$1"));
const secondsToMilliseconds = /* @__PURE__ */ __name((seconds) => seconds * 1e3, "secondsToMilliseconds"), millisecondsToSeconds = /* @__PURE__ */ __name((milliseconds) => milliseconds / 1e3, "millisecondsToSeconds"), instantAnimationState = {
  current: !1
}, isBezierDefinition = /* @__PURE__ */ __name((easing) => Array.isArray(easing) && typeof easing[0] == "number", "isBezierDefinition");
function isWaapiSupportedEasing(easing) {
  return !!(!easing || typeof easing == "string" && supportedWaapiEasing[easing] || isBezierDefinition(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}
__name(isWaapiSupportedEasing, "isWaapiSupportedEasing");
const cubicBezierAsString = /* @__PURE__ */ __name(([a4, b2, c3, d3]) => `cubic-bezier(${a4}, ${b2}, ${c3}, ${d3})`, "cubicBezierAsString"), supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing(easing) {
  if (easing)
    return isBezierDefinition(easing) ? cubicBezierAsString(easing) : Array.isArray(easing) ? easing.map(mapEasingToNativeEasing) : supportedWaapiEasing[easing];
}
__name(mapEasingToNativeEasing, "mapEasingToNativeEasing");
function animateStyle(element2, valueName, keyframes2, { delay: delay2 = 0, duration, repeat: repeat2 = 0, repeatType = "loop", ease: ease2, times } = {}) {
  const keyframeOptions = { [valueName]: keyframes2 };
  times && (keyframeOptions.offset = times);
  const easing = mapEasingToNativeEasing(ease2);
  return Array.isArray(easing) && (keyframeOptions.easing = easing), element2.animate(keyframeOptions, {
    delay: delay2,
    duration,
    easing: Array.isArray(easing) ? "linear" : easing,
    fill: "both",
    iterations: repeat2 + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}
__name(animateStyle, "animateStyle");
function getFinalKeyframe(keyframes2, { repeat: repeat2, repeatType = "loop" }) {
  const index2 = repeat2 && repeatType !== "loop" && repeat2 % 2 === 1 ? 0 : keyframes2.length - 1;
  return keyframes2[index2];
}
__name(getFinalKeyframe, "getFinalKeyframe");
const calcBezier = /* @__PURE__ */ __name((t3, a1, a22) => (((1 - 3 * a22 + 3 * a1) * t3 + (3 * a22 - 6 * a1)) * t3 + 3 * a1) * t3, "calcBezier"), subdivisionPrecision = 1e-7, subdivisionMaxIterations = 12;
function binarySubdivide(x3, lowerBound, upperBound, mX1, mX2) {
  let currentX, currentT, i2 = 0;
  do
    currentT = lowerBound + (upperBound - lowerBound) / 2, currentX = calcBezier(currentT, mX1, mX2) - x3, currentX > 0 ? upperBound = currentT : lowerBound = currentT;
  while (Math.abs(currentX) > subdivisionPrecision && ++i2 < subdivisionMaxIterations);
  return currentT;
}
__name(binarySubdivide, "binarySubdivide");
function cubicBezier$1(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return noop$4;
  const getTForX = /* @__PURE__ */ __name((aX) => binarySubdivide(aX, 0, 1, mX1, mX2), "getTForX");
  return (t3) => t3 === 0 || t3 === 1 ? t3 : calcBezier(getTForX(t3), mY1, mY2);
}
__name(cubicBezier$1, "cubicBezier$1");
const easeIn = cubicBezier$1(0.42, 0, 1, 1), easeOut = cubicBezier$1(0, 0, 0.58, 1), easeInOut = cubicBezier$1(0.42, 0, 0.58, 1), isEasingArray = /* @__PURE__ */ __name((ease2) => Array.isArray(ease2) && typeof ease2[0] != "number", "isEasingArray"), mirrorEasing = /* @__PURE__ */ __name((easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2, "mirrorEasing"), reverseEasing = /* @__PURE__ */ __name((easing) => (p) => 1 - easing(1 - p), "reverseEasing"), circIn = /* @__PURE__ */ __name((p) => 1 - Math.sin(Math.acos(p)), "circIn"), circOut = reverseEasing(circIn), circInOut = mirrorEasing(circIn), backOut = cubicBezier$1(0.33, 1.53, 0.69, 0.99), backIn = reverseEasing(backOut), backInOut = mirrorEasing(backIn), anticipate = /* @__PURE__ */ __name((p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1))), "anticipate"), easingLookup = {
  linear: noop$4,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate
}, easingDefinitionToFunction = /* @__PURE__ */ __name((definition2) => {
  if (Array.isArray(definition2)) {
    invariant$1(definition2.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [x1, y1, x22, y22] = definition2;
    return cubicBezier$1(x1, y1, x22, y22);
  } else if (typeof definition2 == "string")
    return invariant$1(easingLookup[definition2] !== void 0, `Invalid easing type '${definition2}'`), easingLookup[definition2];
  return definition2;
}, "easingDefinitionToFunction"), isColorString = /* @__PURE__ */ __name((type, testProp) => (v) => !!(isString$2(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp)), "isColorString"), splitColor = /* @__PURE__ */ __name((aName, bName, cName) => (v) => {
  if (!isString$2(v))
    return v;
  const [a4, b2, c3, alpha3] = v.match(floatRegex);
  return {
    [aName]: parseFloat(a4),
    [bName]: parseFloat(b2),
    [cName]: parseFloat(c3),
    alpha: alpha3 !== void 0 ? parseFloat(alpha3) : 1
  };
}, "splitColor"), clampRgbUnit = /* @__PURE__ */ __name((v) => clamp(0, 255, v), "clampRgbUnit"), rgbUnit = {
  ...number$4,
  transform: (v) => Math.round(clampRgbUnit(v))
}, rgba$1 = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red, green, blue, alpha: alpha$1$1 = 1 }) => "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha$1.transform(alpha$1$1)) + ")"
};
function parseHex(v) {
  let r2 = "", g = "", b2 = "", a4 = "";
  return v.length > 5 ? (r2 = v.substring(1, 3), g = v.substring(3, 5), b2 = v.substring(5, 7), a4 = v.substring(7, 9)) : (r2 = v.substring(1, 2), g = v.substring(2, 3), b2 = v.substring(3, 4), a4 = v.substring(4, 5), r2 += r2, g += g, b2 += b2, a4 += a4), {
    red: parseInt(r2, 16),
    green: parseInt(g, 16),
    blue: parseInt(b2, 16),
    alpha: a4 ? parseInt(a4, 16) / 255 : 1
  };
}
__name(parseHex, "parseHex");
const hex$1 = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba$1.transform
}, hsla$1 = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue, saturation, lightness, alpha: alpha$1$1 = 1 }) => "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha$1.transform(alpha$1$1)) + ")"
}, color$3 = {
  test: (v) => rgba$1.test(v) || hex$1.test(v) || hsla$1.test(v),
  parse: (v) => rgba$1.test(v) ? rgba$1.parse(v) : hsla$1.test(v) ? hsla$1.parse(v) : hex$1.parse(v),
  transform: (v) => isString$2(v) ? v : v.hasOwnProperty("red") ? rgba$1.transform(v) : hsla$1.transform(v)
}, mix = /* @__PURE__ */ __name((from, to, progress2) => -progress2 * from + progress2 * to + from, "mix");
function hueToRgb(p, q2, t3) {
  return t3 < 0 && (t3 += 1), t3 > 1 && (t3 -= 1), t3 < 1 / 6 ? p + (q2 - p) * 6 * t3 : t3 < 1 / 2 ? q2 : t3 < 2 / 3 ? p + (q2 - p) * (2 / 3 - t3) * 6 : p;
}
__name(hueToRgb, "hueToRgb");
function hslaToRgba({ hue, saturation, lightness, alpha: alpha3 }) {
  hue /= 360, saturation /= 100, lightness /= 100;
  let red = 0, green = 0, blue = 0;
  if (!saturation)
    red = green = blue = lightness;
  else {
    const q2 = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation, p = 2 * lightness - q2;
    red = hueToRgb(p, q2, hue + 1 / 3), green = hueToRgb(p, q2, hue), blue = hueToRgb(p, q2, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha: alpha3
  };
}
__name(hslaToRgba, "hslaToRgba");
const mixLinearColor = /* @__PURE__ */ __name((from, to, v) => {
  const fromExpo = from * from;
  return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
}, "mixLinearColor"), colorTypes = [hex$1, rgba$1, hsla$1], getColorType = /* @__PURE__ */ __name((v) => colorTypes.find((type) => type.test(v)), "getColorType");
function asRGBA(color2) {
  const type = getColorType(color2);
  invariant$1(!!type, `'${color2}' is not an animatable color. Use the equivalent color code instead.`);
  let model = type.parse(color2);
  return type === hsla$1 && (model = hslaToRgba(model)), model;
}
__name(asRGBA, "asRGBA");
const mixColor = /* @__PURE__ */ __name((from, to) => {
  const fromRGBA = asRGBA(from), toRGBA = asRGBA(to), blended = { ...fromRGBA };
  return (v) => (blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v), blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v), blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v), blended.alpha = mix(fromRGBA.alpha, toRGBA.alpha, v), rgba$1.transform(blended));
}, "mixColor");
function test(v) {
  var _a3, _b;
  return isNaN(v) && isString$2(v) && (((_a3 = v.match(floatRegex)) === null || _a3 === void 0 ? void 0 : _a3.length) || 0) + (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
__name(test, "test");
const cssVarTokeniser = {
  regex: cssVariableRegex,
  countKey: "Vars",
  token: "${v}",
  parse: noop$4
}, colorTokeniser = {
  regex: colorRegex,
  countKey: "Colors",
  token: "${c}",
  parse: color$3.parse
}, numberTokeniser = {
  regex: floatRegex,
  countKey: "Numbers",
  token: "${n}",
  parse: number$4.parse
};
function tokenise(info, { regex, countKey, token, parse: parse2 }) {
  const matches2 = info.tokenised.match(regex);
  matches2 && (info["num" + countKey] = matches2.length, info.tokenised = info.tokenised.replace(regex, token), info.values.push(...matches2.map(parse2)));
}
__name(tokenise, "tokenise");
function analyseComplexValue(value) {
  const originalValue = value.toString(), info = {
    value: originalValue,
    tokenised: originalValue,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return info.value.includes("var(--") && tokenise(info, cssVarTokeniser), tokenise(info, colorTokeniser), tokenise(info, numberTokeniser), info;
}
__name(analyseComplexValue, "analyseComplexValue");
function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}
__name(parseComplexValue, "parseComplexValue");
function createTransformer(source) {
  const { values, numColors, numVars, tokenised } = analyseComplexValue(source), numValues = values.length;
  return (v) => {
    let output = tokenised;
    for (let i2 = 0; i2 < numValues; i2++)
      i2 < numVars ? output = output.replace(cssVarTokeniser.token, v[i2]) : i2 < numVars + numColors ? output = output.replace(colorTokeniser.token, color$3.transform(v[i2])) : output = output.replace(numberTokeniser.token, sanitize(v[i2]));
    return output;
  };
}
__name(createTransformer, "createTransformer");
const convertNumbersToZero = /* @__PURE__ */ __name((v) => typeof v == "number" ? 0 : v, "convertNumbersToZero");
function getAnimatableNone$1(v) {
  const parsed = parseComplexValue(v);
  return createTransformer(v)(parsed.map(convertNumbersToZero));
}
__name(getAnimatableNone$1, "getAnimatableNone$1");
const complex = {
  test,
  parse: parseComplexValue,
  createTransformer,
  getAnimatableNone: getAnimatableNone$1
}, mixImmediate = /* @__PURE__ */ __name((origin, target) => (p) => `${p > 0 ? target : origin}`, "mixImmediate");
function getMixer(origin, target) {
  return typeof origin == "number" ? (v) => mix(origin, target, v) : color$3.test(origin) ? mixColor(origin, target) : origin.startsWith("var(") ? mixImmediate(origin, target) : mixComplex(origin, target);
}
__name(getMixer, "getMixer");
const mixArray = /* @__PURE__ */ __name((from, to) => {
  const output = [...from], numValues = output.length, blendValue = from.map((fromThis, i2) => getMixer(fromThis, to[i2]));
  return (v) => {
    for (let i2 = 0; i2 < numValues; i2++)
      output[i2] = blendValue[i2](v);
    return output;
  };
}, "mixArray"), mixObject = /* @__PURE__ */ __name((origin, target) => {
  const output = { ...origin, ...target }, blendValue = {};
  for (const key in output)
    origin[key] !== void 0 && target[key] !== void 0 && (blendValue[key] = getMixer(origin[key], target[key]));
  return (v) => {
    for (const key in blendValue)
      output[key] = blendValue[key](v);
    return output;
  };
}, "mixObject"), mixComplex = /* @__PURE__ */ __name((origin, target) => {
  const template = complex.createTransformer(target), originStats = analyseComplexValue(origin), targetStats = analyseComplexValue(target);
  return originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers ? pipe(mixArray(originStats.values, targetStats.values), template) : (warning(!0, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), mixImmediate(origin, target));
}, "mixComplex"), progress = /* @__PURE__ */ __name((from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
}, "progress"), mixNumber = /* @__PURE__ */ __name((from, to) => (p) => mix(from, to, p), "mixNumber");
function detectMixerFactory(v) {
  return typeof v == "number" ? mixNumber : typeof v == "string" ? color$3.test(v) ? mixColor : mixComplex : Array.isArray(v) ? mixArray : typeof v == "object" ? mixObject : mixNumber;
}
__name(detectMixerFactory, "detectMixerFactory");
function createMixers(output, ease2, customMixer) {
  const mixers = [], mixerFactory = customMixer || detectMixerFactory(output[0]), numMixers = output.length - 1;
  for (let i2 = 0; i2 < numMixers; i2++) {
    let mixer = mixerFactory(output[i2], output[i2 + 1]);
    if (ease2) {
      const easingFunction = Array.isArray(ease2) ? ease2[i2] || noop$4 : ease2;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
__name(createMixers, "createMixers");
function interpolate$1(input, output, { clamp: isClamp = !0, ease: ease2, mixer } = {}) {
  const inputLength = input.length;
  if (invariant$1(inputLength === output.length, "Both input and output ranges must be the same length"), inputLength === 1)
    return () => output[0];
  input[0] > input[inputLength - 1] && (input = [...input].reverse(), output = [...output].reverse());
  const mixers = createMixers(output, ease2, mixer), numMixers = mixers.length, interpolator = /* @__PURE__ */ __name((v) => {
    let i2 = 0;
    if (numMixers > 1)
      for (; i2 < input.length - 2 && !(v < input[i2 + 1]); i2++)
        ;
    const progressInRange = progress(input[i2], input[i2 + 1], v);
    return mixers[i2](progressInRange);
  }, "interpolator");
  return isClamp ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v)) : interpolator;
}
__name(interpolate$1, "interpolate$1");
function fillOffset(offset, remaining) {
  const min2 = offset[offset.length - 1];
  for (let i2 = 1; i2 <= remaining; i2++) {
    const offsetProgress = progress(0, remaining, i2);
    offset.push(mix(min2, 1, offsetProgress));
  }
}
__name(fillOffset, "fillOffset");
function defaultOffset(arr) {
  const offset = [0];
  return fillOffset(offset, arr.length - 1), offset;
}
__name(defaultOffset, "defaultOffset");
function convertOffsetToTimes(offset, duration) {
  return offset.map((o) => o * duration);
}
__name(convertOffsetToTimes, "convertOffsetToTimes");
function defaultEasing(values, easing) {
  return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
__name(defaultEasing, "defaultEasing");
function keyframes({ duration = 300, keyframes: keyframeValues, times, ease: ease2 = "easeInOut" }) {
  const easingFunctions = isEasingArray(ease2) ? ease2.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease2), state = {
    done: !1,
    value: keyframeValues[0]
  }, absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : defaultOffset(keyframeValues),
    duration
  ), mapTimeToKeyframe = interpolate$1(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
  });
  return {
    calculatedDuration: duration,
    next: (t3) => (state.value = mapTimeToKeyframe(t3), state.done = t3 >= duration, state)
  };
}
__name(keyframes, "keyframes");
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1e3 / frameDuration) : 0;
}
__name(velocityPerSecond, "velocityPerSecond");
const velocitySampleDuration = 5;
function calcGeneratorVelocity(resolveValue, t3, current) {
  const prevT = Math.max(t3 - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t3 - prevT);
}
__name(calcGeneratorVelocity, "calcGeneratorVelocity");
const safeMin = 1e-3, minDuration = 0.01, maxDuration$1 = 10, minDamping = 0.05, maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
  let envelope, derivative;
  warning(duration <= secondsToMilliseconds(maxDuration$1), "Spring duration must be 10 seconds or less");
  let dampingRatio = 1 - bounce;
  dampingRatio = clamp(minDamping, maxDamping, dampingRatio), duration = clamp(minDuration, maxDuration$1, millisecondsToSeconds(duration)), dampingRatio < 1 ? (envelope = /* @__PURE__ */ __name((undampedFreq2) => {
    const exponentialDecay = undampedFreq2 * dampingRatio, delta = exponentialDecay * duration, a4 = exponentialDecay - velocity, b2 = calcAngularFreq(undampedFreq2, dampingRatio), c3 = Math.exp(-delta);
    return safeMin - a4 / b2 * c3;
  }, "envelope"), derivative = /* @__PURE__ */ __name((undampedFreq2) => {
    const delta = undampedFreq2 * dampingRatio * duration, d3 = delta * velocity + velocity, e3 = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration, f = Math.exp(-delta), g = calcAngularFreq(Math.pow(undampedFreq2, 2), dampingRatio);
    return (-envelope(undampedFreq2) + safeMin > 0 ? -1 : 1) * ((d3 - e3) * f) / g;
  }, "derivative")) : (envelope = /* @__PURE__ */ __name((undampedFreq2) => {
    const a4 = Math.exp(-undampedFreq2 * duration), b2 = (undampedFreq2 - velocity) * duration + 1;
    return -safeMin + a4 * b2;
  }, "envelope"), derivative = /* @__PURE__ */ __name((undampedFreq2) => {
    const a4 = Math.exp(-undampedFreq2 * duration), b2 = (velocity - undampedFreq2) * (duration * duration);
    return a4 * b2;
  }, "derivative"));
  const initialGuess = 5 / duration, undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  if (duration = secondsToMilliseconds(duration), isNaN(undampedFreq))
    return {
      stiffness: 100,
      damping: 10,
      duration
    };
  {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration
    };
  }
}
__name(findSpring, "findSpring");
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  let result2 = initialGuess;
  for (let i2 = 1; i2 < rootIterations; i2++)
    result2 = result2 - envelope(result2) / derivative(result2);
  return result2;
}
__name(approximateRoot, "approximateRoot");
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
__name(calcAngularFreq, "calcAngularFreq");
const durationKeys = ["duration", "bounce"], physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys2) {
  return keys2.some((key) => options[key] !== void 0);
}
__name(isSpringType, "isSpringType");
function getSpringOptions(options) {
  let springOptions = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...options
  };
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    const derived = findSpring(options);
    springOptions = {
      ...springOptions,
      ...derived,
      mass: 1
    }, springOptions.isResolvedFromDuration = !0;
  }
  return springOptions;
}
__name(getSpringOptions, "getSpringOptions");
function spring({ keyframes: keyframes2, restDelta, restSpeed, ...options }) {
  const origin = keyframes2[0], target = keyframes2[keyframes2.length - 1], state = { done: !1, value: origin }, { stiffness, damping, mass, duration, velocity, isResolvedFromDuration } = getSpringOptions({
    ...options,
    velocity: -millisecondsToSeconds(options.velocity || 0)
  }), initialVelocity = velocity || 0, dampingRatio = damping / (2 * Math.sqrt(stiffness * mass)), initialDelta = target - origin, undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass)), isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? 0.01 : 2), restDelta || (restDelta = isGranularScale ? 5e-3 : 0.5);
  let resolveSpring;
  if (dampingRatio < 1) {
    const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
    resolveSpring = /* @__PURE__ */ __name((t3) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t3);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t3) + initialDelta * Math.cos(angularFreq * t3));
    }, "resolveSpring");
  } else if (dampingRatio === 1)
    resolveSpring = /* @__PURE__ */ __name((t3) => target - Math.exp(-undampedAngularFreq * t3) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t3), "resolveSpring");
  else {
    const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = /* @__PURE__ */ __name((t3) => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t3), freqForT = Math.min(dampedAngularFreq * t3, 300);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
    }, "resolveSpring");
  }
  return {
    calculatedDuration: isResolvedFromDuration && duration || null,
    next: (t3) => {
      const current = resolveSpring(t3);
      if (isResolvedFromDuration)
        state.done = t3 >= duration;
      else {
        let currentVelocity = initialVelocity;
        t3 !== 0 && (dampingRatio < 1 ? currentVelocity = calcGeneratorVelocity(resolveSpring, t3, current) : currentVelocity = 0);
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed, isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      }
      return state.value = state.done ? target : current, state;
    }
  };
}
__name(spring, "spring");
function inertia({ keyframes: keyframes2, velocity = 0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min: min2, max: max2, restDelta = 0.5, restSpeed }) {
  const origin = keyframes2[0], state = {
    done: !1,
    value: origin
  }, isOutOfBounds = /* @__PURE__ */ __name((v) => min2 !== void 0 && v < min2 || max2 !== void 0 && v > max2, "isOutOfBounds"), nearestBoundary = /* @__PURE__ */ __name((v) => min2 === void 0 ? max2 : max2 === void 0 || Math.abs(min2 - v) < Math.abs(max2 - v) ? min2 : max2, "nearestBoundary");
  let amplitude = power * velocity;
  const ideal = origin + amplitude, target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
  target !== ideal && (amplitude = target - origin);
  const calcDelta = /* @__PURE__ */ __name((t3) => -amplitude * Math.exp(-t3 / timeConstant), "calcDelta"), calcLatest = /* @__PURE__ */ __name((t3) => target + calcDelta(t3), "calcLatest"), applyFriction = /* @__PURE__ */ __name((t3) => {
    const delta = calcDelta(t3), latest = calcLatest(t3);
    state.done = Math.abs(delta) <= restDelta, state.value = state.done ? target : latest;
  }, "applyFriction");
  let timeReachedBoundary, spring$1;
  const checkCatchBoundary = /* @__PURE__ */ __name((t3) => {
    isOutOfBounds(state.value) && (timeReachedBoundary = t3, spring$1 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t3, state.value),
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta,
      restSpeed
    }));
  }, "checkCatchBoundary");
  return checkCatchBoundary(0), {
    calculatedDuration: null,
    next: (t3) => {
      let hasUpdatedFrame = !1;
      return !spring$1 && timeReachedBoundary === void 0 && (hasUpdatedFrame = !0, applyFriction(t3), checkCatchBoundary(t3)), timeReachedBoundary !== void 0 && t3 > timeReachedBoundary ? spring$1.next(t3 - timeReachedBoundary) : (!hasUpdatedFrame && applyFriction(t3), state);
    }
  };
}
__name(inertia, "inertia");
const frameloopDriver = /* @__PURE__ */ __name((update3) => {
  const passTimestamp = /* @__PURE__ */ __name(({ timestamp }) => update3(timestamp), "passTimestamp");
  return {
    start: () => frame.update(passTimestamp, !0),
    stop: () => cancelFrame(passTimestamp),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => frameData.isProcessing ? frameData.timestamp : performance.now()
  };
}, "frameloopDriver"), maxGeneratorDuration = 2e4;
function calcGeneratorDuration(generator) {
  let duration = 0;
  const timeStep = 50;
  let state = generator.next(duration);
  for (; !state.done && duration < maxGeneratorDuration; )
    duration += timeStep, state = generator.next(duration);
  return duration >= maxGeneratorDuration ? 1 / 0 : duration;
}
__name(calcGeneratorDuration, "calcGeneratorDuration");
const types$1 = {
  decay: inertia,
  inertia,
  tween: keyframes,
  keyframes,
  spring
};
function animateValue({ autoplay = !0, delay: delay2 = 0, driver = frameloopDriver, keyframes: keyframes$1, type = "keyframes", repeat: repeat2 = 0, repeatDelay = 0, repeatType = "loop", onPlay, onStop, onComplete, onUpdate, ...options }) {
  let speed = 1, hasStopped = !1, resolveFinishedPromise, currentFinishedPromise;
  const updateFinishedPromise = /* @__PURE__ */ __name(() => {
    currentFinishedPromise = new Promise((resolve) => {
      resolveFinishedPromise = resolve;
    });
  }, "updateFinishedPromise");
  updateFinishedPromise();
  let animationDriver;
  const generatorFactory = types$1[type] || keyframes;
  let mapNumbersToKeyframes;
  generatorFactory !== keyframes && typeof keyframes$1[0] != "number" && (process.env.NODE_ENV !== "production" && invariant$1(keyframes$1.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${keyframes$1}`), mapNumbersToKeyframes = interpolate$1([0, 100], keyframes$1, {
    clamp: !1
  }), keyframes$1 = [0, 100]);
  const generator = generatorFactory({ ...options, keyframes: keyframes$1 });
  let mirroredGenerator;
  repeatType === "mirror" && (mirroredGenerator = generatorFactory({
    ...options,
    keyframes: [...keyframes$1].reverse(),
    velocity: -(options.velocity || 0)
  }));
  let playState = "idle", holdTime = null, startTime = null, cancelTime = null;
  generator.calculatedDuration === null && repeat2 && (generator.calculatedDuration = calcGeneratorDuration(generator));
  const { calculatedDuration } = generator;
  let resolvedDuration = 1 / 0, totalDuration = 1 / 0;
  calculatedDuration !== null && (resolvedDuration = calculatedDuration + repeatDelay, totalDuration = resolvedDuration * (repeat2 + 1) - repeatDelay);
  let currentTime = 0;
  const tick = /* @__PURE__ */ __name((timestamp) => {
    if (startTime === null)
      return;
    speed > 0 && (startTime = Math.min(startTime, timestamp)), speed < 0 && (startTime = Math.min(timestamp - totalDuration / speed, startTime)), holdTime !== null ? currentTime = holdTime : currentTime = Math.round(timestamp - startTime) * speed;
    const timeWithoutDelay = currentTime - delay2 * (speed >= 0 ? 1 : -1), isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    currentTime = Math.max(timeWithoutDelay, 0), playState === "finished" && holdTime === null && (currentTime = totalDuration);
    let elapsed = currentTime, frameGenerator = generator;
    if (repeat2) {
      const progress2 = Math.min(currentTime, totalDuration) / resolvedDuration;
      let currentIteration = Math.floor(progress2), iterationProgress = progress2 % 1;
      !iterationProgress && progress2 >= 1 && (iterationProgress = 1), iterationProgress === 1 && currentIteration--, currentIteration = Math.min(currentIteration, repeat2 + 1), !!(currentIteration % 2) && (repeatType === "reverse" ? (iterationProgress = 1 - iterationProgress, repeatDelay && (iterationProgress -= repeatDelay / resolvedDuration)) : repeatType === "mirror" && (frameGenerator = mirroredGenerator)), elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
    }
    const state = isInDelayPhase ? { done: !1, value: keyframes$1[0] } : frameGenerator.next(elapsed);
    mapNumbersToKeyframes && (state.value = mapNumbersToKeyframes(state.value));
    let { done } = state;
    !isInDelayPhase && calculatedDuration !== null && (done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0);
    const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
    return onUpdate && onUpdate(state.value), isAnimationFinished && finish(), state;
  }, "tick"), stopAnimationDriver = /* @__PURE__ */ __name(() => {
    animationDriver && animationDriver.stop(), animationDriver = void 0;
  }, "stopAnimationDriver"), cancel = /* @__PURE__ */ __name(() => {
    playState = "idle", stopAnimationDriver(), resolveFinishedPromise(), updateFinishedPromise(), startTime = cancelTime = null;
  }, "cancel"), finish = /* @__PURE__ */ __name(() => {
    playState = "finished", onComplete && onComplete(), stopAnimationDriver(), resolveFinishedPromise();
  }, "finish"), play = /* @__PURE__ */ __name(() => {
    if (hasStopped)
      return;
    animationDriver || (animationDriver = driver(tick));
    const now2 = animationDriver.now();
    onPlay && onPlay(), holdTime !== null ? startTime = now2 - holdTime : (!startTime || playState === "finished") && (startTime = now2), playState === "finished" && updateFinishedPromise(), cancelTime = startTime, holdTime = null, playState = "running", animationDriver.start();
  }, "play");
  autoplay && play();
  const controls = {
    then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    get time() {
      return millisecondsToSeconds(currentTime);
    },
    set time(newTime) {
      newTime = secondsToMilliseconds(newTime), currentTime = newTime, holdTime !== null || !animationDriver || speed === 0 ? holdTime = newTime : startTime = animationDriver.now() - newTime / speed;
    },
    get duration() {
      const duration = generator.calculatedDuration === null ? calcGeneratorDuration(generator) : generator.calculatedDuration;
      return millisecondsToSeconds(duration);
    },
    get speed() {
      return speed;
    },
    set speed(newSpeed) {
      newSpeed === speed || !animationDriver || (speed = newSpeed, controls.time = millisecondsToSeconds(currentTime));
    },
    get state() {
      return playState;
    },
    play,
    pause: () => {
      playState = "paused", holdTime = currentTime;
    },
    stop: () => {
      hasStopped = !0, playState !== "idle" && (playState = "idle", onStop && onStop(), cancel());
    },
    cancel: () => {
      cancelTime !== null && tick(cancelTime), cancel();
    },
    complete: () => {
      playState = "finished";
    },
    sample: (elapsed) => (startTime = 0, tick(elapsed))
  };
  return controls;
}
__name(animateValue, "animateValue");
function memo(callback) {
  let result2;
  return () => (result2 === void 0 && (result2 = callback()), result2);
}
__name(memo, "memo");
const supportsWaapi = memo(() => Object.hasOwnProperty.call(Element.prototype, "animate")), acceleratedValues = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), sampleDelta = 10, maxDuration = 2e4, requiresPregeneratedKeyframes = /* @__PURE__ */ __name((valueName, options) => options.type === "spring" || valueName === "backgroundColor" || !isWaapiSupportedEasing(options.ease), "requiresPregeneratedKeyframes");
function createAcceleratedAnimation(value, valueName, { onUpdate, onComplete, ...options }) {
  if (!(supportsWaapi() && acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia"))
    return !1;
  let hasStopped = !1, resolveFinishedPromise, currentFinishedPromise, pendingCancel = !1;
  const updateFinishedPromise = /* @__PURE__ */ __name(() => {
    currentFinishedPromise = new Promise((resolve) => {
      resolveFinishedPromise = resolve;
    });
  }, "updateFinishedPromise");
  updateFinishedPromise();
  let { keyframes: keyframes2, duration = 300, ease: ease2, times } = options;
  if (requiresPregeneratedKeyframes(valueName, options)) {
    const sampleAnimation = animateValue({
      ...options,
      repeat: 0,
      delay: 0
    });
    let state = { done: !1, value: keyframes2[0] };
    const pregeneratedKeyframes = [];
    let t3 = 0;
    for (; !state.done && t3 < maxDuration; )
      state = sampleAnimation.sample(t3), pregeneratedKeyframes.push(state.value), t3 += sampleDelta;
    times = void 0, keyframes2 = pregeneratedKeyframes, duration = t3 - sampleDelta, ease2 = "linear";
  }
  const animation2 = animateStyle(value.owner.current, valueName, keyframes2, {
    ...options,
    duration,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: ease2,
    times
  }), cancelAnimation = /* @__PURE__ */ __name(() => {
    pendingCancel = !1, animation2.cancel();
  }, "cancelAnimation"), safeCancel = /* @__PURE__ */ __name(() => {
    pendingCancel = !0, frame.update(cancelAnimation), resolveFinishedPromise(), updateFinishedPromise();
  }, "safeCancel");
  return animation2.onfinish = () => {
    pendingCancel || (value.set(getFinalKeyframe(keyframes2, options)), onComplete && onComplete(), safeCancel());
  }, {
    then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    attachTimeline(timeline) {
      return animation2.timeline = timeline, animation2.onfinish = null, noop$4;
    },
    get time() {
      return millisecondsToSeconds(animation2.currentTime || 0);
    },
    set time(newTime) {
      animation2.currentTime = secondsToMilliseconds(newTime);
    },
    get speed() {
      return animation2.playbackRate;
    },
    set speed(newSpeed) {
      animation2.playbackRate = newSpeed;
    },
    get duration() {
      return millisecondsToSeconds(duration);
    },
    play: () => {
      hasStopped || (animation2.play(), cancelFrame(cancelAnimation));
    },
    pause: () => animation2.pause(),
    stop: () => {
      if (hasStopped = !0, animation2.playState === "idle")
        return;
      const { currentTime } = animation2;
      if (currentTime) {
        const sampleAnimation = animateValue({
          ...options,
          autoplay: !1
        });
        value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta).value, sampleAnimation.sample(currentTime).value, sampleDelta);
      }
      safeCancel();
    },
    complete: () => {
      pendingCancel || animation2.finish();
    },
    cancel: safeCancel
  };
}
__name(createAcceleratedAnimation, "createAcceleratedAnimation");
function createInstantAnimation({ keyframes: keyframes2, delay: delay2, onUpdate, onComplete }) {
  const setValue = /* @__PURE__ */ __name(() => (onUpdate && onUpdate(keyframes2[keyframes2.length - 1]), onComplete && onComplete(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: noop$4,
    pause: noop$4,
    stop: noop$4,
    then: (resolve) => (resolve(), Promise.resolve()),
    cancel: noop$4,
    complete: noop$4
  }), "setValue");
  return delay2 ? animateValue({
    keyframes: [0, 1],
    duration: 0,
    delay: delay2,
    onComplete: setValue
  }) : setValue();
}
__name(createInstantAnimation, "createInstantAnimation");
const underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, criticallyDampedSpring = /* @__PURE__ */ __name((target) => ({
  type: "spring",
  stiffness: 550,
  damping: target === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), "criticallyDampedSpring"), keyframesTransition = {
  type: "keyframes",
  duration: 0.8
}, ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, getDefaultTransition = /* @__PURE__ */ __name((valueKey, { keyframes: keyframes2 }) => keyframes2.length > 2 ? keyframesTransition : transformProps.has(valueKey) ? valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes2[1]) : underDampedSpring : ease, "getDefaultTransition"), isAnimatable = /* @__PURE__ */ __name((key, value) => key === "zIndex" ? !1 : !!(typeof value == "number" || Array.isArray(value) || typeof value == "string" && // It's animatable if we have a string
(complex.test(value) || value === "0") && // And it contains numbers and/or colors
!value.startsWith("url(")), "isAnimatable"), maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
  const [name2, value] = v.slice(0, -1).split("(");
  if (name2 === "drop-shadow")
    return v;
  const [number2] = value.match(floatRegex) || [];
  if (!number2)
    return v;
  const unit2 = value.replace(number2, "");
  let defaultValue = maxDefaults.has(name2) ? 1 : 0;
  return number2 !== value && (defaultValue *= 100), name2 + "(" + defaultValue + unit2 + ")";
}
__name(applyDefaultFilter, "applyDefaultFilter");
const functionRegex = /([a-z-]*)\(.*?\)/g, filter = {
  ...complex,
  getAnimatableNone: (v) => {
    const functions = v.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(" ") : v;
  }
}, defaultValueTypes = {
  ...numberValueTypes,
  // Color props
  color: color$3,
  backgroundColor: color$3,
  outlineColor: color$3,
  fill: color$3,
  stroke: color$3,
  // Border props
  borderColor: color$3,
  borderTopColor: color$3,
  borderRightColor: color$3,
  borderBottomColor: color$3,
  borderLeftColor: color$3,
  filter,
  WebkitFilter: filter
}, getDefaultValueType = /* @__PURE__ */ __name((key) => defaultValueTypes[key], "getDefaultValueType");
function getAnimatableNone(key, value) {
  let defaultValueType = getDefaultValueType(key);
  return defaultValueType !== filter && (defaultValueType = complex), defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : void 0;
}
__name(getAnimatableNone, "getAnimatableNone");
const isZeroValueString = /* @__PURE__ */ __name((v) => /^0[^.\s]+$/.test(v), "isZeroValueString");
function isNone(value) {
  if (typeof value == "number")
    return value === 0;
  if (value !== null)
    return value === "none" || value === "0" || isZeroValueString(value);
}
__name(isNone, "isNone");
function getKeyframes(value, valueName, target, transition2) {
  const isTargetAnimatable = isAnimatable(valueName, target);
  let keyframes2;
  Array.isArray(target) ? keyframes2 = [...target] : keyframes2 = [null, target];
  const defaultOrigin = transition2.from !== void 0 ? transition2.from : value.get();
  let animatableTemplateValue;
  const noneKeyframeIndexes = [];
  for (let i2 = 0; i2 < keyframes2.length; i2++)
    keyframes2[i2] === null && (keyframes2[i2] = i2 === 0 ? defaultOrigin : keyframes2[i2 - 1]), isNone(keyframes2[i2]) && noneKeyframeIndexes.push(i2), typeof keyframes2[i2] == "string" && keyframes2[i2] !== "none" && keyframes2[i2] !== "0" && (animatableTemplateValue = keyframes2[i2]);
  if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue)
    for (let i2 = 0; i2 < noneKeyframeIndexes.length; i2++) {
      const index2 = noneKeyframeIndexes[i2];
      keyframes2[index2] = getAnimatableNone(valueName, animatableTemplateValue);
    }
  return keyframes2;
}
__name(getKeyframes, "getKeyframes");
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat: repeat2, repeatType, repeatDelay, from, elapsed, ...transition2 }) {
  return !!Object.keys(transition2).length;
}
__name(isTransitionDefined, "isTransitionDefined");
function getValueTransition(transition2, key) {
  return transition2[key] || transition2.default || transition2;
}
__name(getValueTransition, "getValueTransition");
const MotionGlobalConfig = {
  skipAnimations: !1
}, animateMotionValue = /* @__PURE__ */ __name((valueName, value, target, transition2 = {}) => (onComplete) => {
  const valueTransition = getValueTransition(transition2, valueName) || {}, delay2 = valueTransition.delay || transition2.delay || 0;
  let { elapsed = 0 } = transition2;
  elapsed = elapsed - secondsToMilliseconds(delay2);
  const keyframes2 = getKeyframes(value, valueName, target, valueTransition), originKeyframe = keyframes2[0], targetKeyframe = keyframes2[keyframes2.length - 1], isOriginAnimatable = isAnimatable(valueName, originKeyframe), isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
  warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
  let options = {
    keyframes: keyframes2,
    velocity: value.getVelocity(),
    ease: "easeOut",
    ...valueTransition,
    delay: -elapsed,
    onUpdate: (v) => {
      value.set(v), valueTransition.onUpdate && valueTransition.onUpdate(v);
    },
    onComplete: () => {
      onComplete(), valueTransition.onComplete && valueTransition.onComplete();
    }
  };
  if (isTransitionDefined(valueTransition) || (options = {
    ...options,
    ...getDefaultTransition(valueName, options)
  }), options.duration && (options.duration = secondsToMilliseconds(options.duration)), options.repeatDelay && (options.repeatDelay = secondsToMilliseconds(options.repeatDelay)), !isOriginAnimatable || !isTargetAnimatable || instantAnimationState.current || valueTransition.type === !1 || MotionGlobalConfig.skipAnimations)
    return createInstantAnimation(options);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !transition2.isHandoff && value.owner && value.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !value.owner.getProps().onUpdate
  ) {
    const acceleratedAnimation = createAcceleratedAnimation(value, valueName, options);
    if (acceleratedAnimation)
      return acceleratedAnimation;
  }
  return animateValue(options);
}, "animateMotionValue");
function isWillChangeMotionValue(value) {
  return !!(isMotionValue(value) && value.add);
}
__name(isWillChangeMotionValue, "isWillChangeMotionValue");
const isNumericalString = /* @__PURE__ */ __name((v) => /^\-?\d*\.?\d+$/.test(v), "isNumericalString");
function addUniqueItem(arr, item) {
  arr.indexOf(item) === -1 && arr.push(item);
}
__name(addUniqueItem, "addUniqueItem");
function removeItem(arr, item) {
  const index2 = arr.indexOf(item);
  index2 > -1 && arr.splice(index2, 1);
}
__name(removeItem, "removeItem");
const _SubscriptionManager = class _SubscriptionManager {
  constructor() {
    this.subscriptions = [];
  }
  add(handler) {
    return addUniqueItem(this.subscriptions, handler), () => removeItem(this.subscriptions, handler);
  }
  notify(a4, b2, c3) {
    const numSubscriptions = this.subscriptions.length;
    if (numSubscriptions)
      if (numSubscriptions === 1)
        this.subscriptions[0](a4, b2, c3);
      else
        for (let i2 = 0; i2 < numSubscriptions; i2++) {
          const handler = this.subscriptions[i2];
          handler && handler(a4, b2, c3);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
};
__name(_SubscriptionManager, "SubscriptionManager");
let SubscriptionManager = _SubscriptionManager;
const warned = /* @__PURE__ */ new Set();
function warnOnce(condition, message, element2) {
  condition || warned.has(message) || (console.warn(message), element2 && console.warn(element2), warned.add(message));
}
__name(warnOnce, "warnOnce");
const isFloat = /* @__PURE__ */ __name((value) => !isNaN(parseFloat(value)), "isFloat"), _MotionValue = class _MotionValue {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(init2, options = {}) {
    this.version = "10.18.0", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (v, render = !0) => {
      this.prev = this.current, this.current = v;
      const { delta, timestamp } = frameData;
      this.lastUpdated !== timestamp && (this.timeDelta = delta, this.lastUpdated = timestamp, frame.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), render && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => frame.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp }) => {
      timestamp !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = init2, this.canTrackVelocity = isFloat(this.current), this.owner = options.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(subscription) {
    return process.env.NODE_ENV !== "production" && warnOnce(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", subscription);
  }
  on(eventName, callback) {
    this.events[eventName] || (this.events[eventName] = new SubscriptionManager());
    const unsubscribe = this.events[eventName].add(callback);
    return eventName === "change" ? () => {
      unsubscribe(), frame.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : unsubscribe;
  }
  clearListeners() {
    for (const eventManagers in this.events)
      this.events[eventManagers].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(passiveEffect, stopPassiveEffect) {
    this.passiveEffect = passiveEffect, this.stopPassiveEffect = stopPassiveEffect;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(v, render = !0) {
    !render || !this.passiveEffect ? this.updateAndNotify(v, render) : this.passiveEffect(v, this.updateAndNotify);
  }
  setWithVelocity(prev, current, delta) {
    this.set(current), this.prev = prev, this.timeDelta = delta;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(v) {
    this.updateAndNotify(v), this.prev = v, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(startAnimation) {
    return this.stop(), new Promise((resolve) => {
      this.hasAnimated = !0, this.animation = startAnimation(resolve), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
};
__name(_MotionValue, "MotionValue");
let MotionValue = _MotionValue;
function motionValue(init2, options) {
  return new MotionValue(init2, options);
}
__name(motionValue, "motionValue");
const testValueType = /* @__PURE__ */ __name((v) => (type) => type.test(v), "testValueType"), auto = {
  test: (v) => v === "auto",
  parse: (v) => v
}, dimensionValueTypes = [number$4, px, percent, degrees, vw, vh, auto], findDimensionValueType = /* @__PURE__ */ __name((v) => dimensionValueTypes.find(testValueType(v)), "findDimensionValueType"), valueTypes = [...dimensionValueTypes, color$3, complex], findValueType = /* @__PURE__ */ __name((v) => valueTypes.find(testValueType(v)), "findValueType");
function setMotionValue(visualElement, key, value) {
  visualElement.hasValue(key) ? visualElement.getValue(key).set(value) : visualElement.addValue(key, motionValue(value));
}
__name(setMotionValue, "setMotionValue");
function setTarget(visualElement, definition2) {
  const resolved = resolveVariant(visualElement, definition2);
  let { transitionEnd = {}, transition: transition2 = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, !1) : {};
  target = { ...target, ...transitionEnd };
  for (const key in target) {
    const value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement, key, value);
  }
}
__name(setTarget, "setTarget");
function checkTargetForNewValues(visualElement, target, origin) {
  var _a3, _b;
  const newValueKeys = Object.keys(target).filter((key) => !visualElement.hasValue(key)), numNewValues = newValueKeys.length;
  if (numNewValues)
    for (let i2 = 0; i2 < numNewValues; i2++) {
      const key = newValueKeys[i2], targetValue = target[key];
      let value = null;
      Array.isArray(targetValue) && (value = targetValue[0]), value === null && (value = (_b = (_a3 = origin[key]) !== null && _a3 !== void 0 ? _a3 : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key]), value != null && (typeof value == "string" && (isNumericalString(value) || isZeroValueString(value)) ? value = parseFloat(value) : !findValueType(value) && complex.test(targetValue) && (value = getAnimatableNone(key, targetValue)), visualElement.addValue(key, motionValue(value, { owner: visualElement })), origin[key] === void 0 && (origin[key] = value), value !== null && visualElement.setBaseTarget(key, value));
    }
}
__name(checkTargetForNewValues, "checkTargetForNewValues");
function getOriginFromTransition(key, transition2) {
  return transition2 ? (transition2[key] || transition2.default || transition2).from : void 0;
}
__name(getOriginFromTransition, "getOriginFromTransition");
function getOrigin(target, transition2, visualElement) {
  const origin = {};
  for (const key in target) {
    const transitionOrigin = getOriginFromTransition(key, transition2);
    if (transitionOrigin !== void 0)
      origin[key] = transitionOrigin;
    else {
      const value = visualElement.getValue(key);
      value && (origin[key] = value.get());
    }
  }
  return origin;
}
__name(getOrigin, "getOrigin");
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
  const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== !0;
  return needsAnimating[key] = !1, shouldBlock;
}
__name(shouldBlockAnimation, "shouldBlockAnimation");
function hasKeyframesChanged(value, target) {
  const current = value.get();
  if (Array.isArray(target)) {
    for (let i2 = 0; i2 < target.length; i2++)
      if (target[i2] !== current)
        return !0;
  } else
    return current !== target;
}
__name(hasKeyframesChanged, "hasKeyframesChanged");
function animateTarget(visualElement, definition2, { delay: delay2 = 0, transitionOverride, type } = {}) {
  let { transition: transition2 = visualElement.getDefaultTransition(), transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition2);
  const willChange = visualElement.getValue("willChange");
  transitionOverride && (transition2 = transitionOverride);
  const animations2 = [], animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  for (const key in target) {
    const value = visualElement.getValue(key), valueTarget = target[key];
    if (!value || valueTarget === void 0 || animationTypeState && shouldBlockAnimation(animationTypeState, key))
      continue;
    const valueTransition = {
      delay: delay2,
      elapsed: 0,
      ...getValueTransition(transition2 || {}, key)
    };
    if (window.HandoffAppearAnimations) {
      const appearId = visualElement.getProps()[optimizedAppearDataAttribute];
      if (appearId) {
        const elapsed = window.HandoffAppearAnimations(appearId, key, value, frame);
        elapsed !== null && (valueTransition.elapsed = elapsed, valueTransition.isHandoff = !0);
      }
    }
    let canSkip = !valueTransition.isHandoff && !hasKeyframesChanged(value, valueTarget);
    if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity) && (canSkip = !1), value.animation && (canSkip = !1), canSkip)
      continue;
    value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key) ? { type: !1 } : valueTransition));
    const animation2 = value.animation;
    isWillChangeMotionValue(willChange) && (willChange.add(key), animation2.then(() => willChange.remove(key))), animations2.push(animation2);
  }
  return transitionEnd && Promise.all(animations2).then(() => {
    transitionEnd && setTarget(visualElement, transitionEnd);
  }), animations2;
}
__name(animateTarget, "animateTarget");
function animateVariant(visualElement, variant, options = {}) {
  const resolved = resolveVariant(visualElement, variant, options.custom);
  let { transition: transition2 = visualElement.getDefaultTransition() || {} } = resolved || {};
  options.transitionOverride && (transition2 = options.transitionOverride);
  const getAnimation2 = resolved ? () => Promise.all(animateTarget(visualElement, resolved, options)) : () => Promise.resolve(), getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0) => {
    const { delayChildren = 0, staggerChildren, staggerDirection } = transition2;
    return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : () => Promise.resolve(), { when } = transition2;
  if (when) {
    const [first, last2] = when === "beforeChildren" ? [getAnimation2, getChildAnimations] : [getChildAnimations, getAnimation2];
    return first().then(() => last2());
  } else
    return Promise.all([getAnimation2(), getChildAnimations(options.delay)]);
}
__name(animateVariant, "animateVariant");
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
  const animations2 = [], maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren, generateStaggerDuration = staggerDirection === 1 ? (i2 = 0) => i2 * staggerChildren : (i2 = 0) => maxStaggerDuration - i2 * staggerChildren;
  return Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach((child, i2) => {
    child.notify("AnimationStart", variant), animations2.push(animateVariant(child, variant, {
      ...options,
      delay: delayChildren + generateStaggerDuration(i2)
    }).then(() => child.notify("AnimationComplete", variant)));
  }), Promise.all(animations2);
}
__name(animateChildren, "animateChildren");
function sortByTreeOrder(a4, b2) {
  return a4.sortNodePosition(b2);
}
__name(sortByTreeOrder, "sortByTreeOrder");
function animateVisualElement(visualElement, definition2, options = {}) {
  visualElement.notify("AnimationStart", definition2);
  let animation2;
  if (Array.isArray(definition2)) {
    const animations2 = definition2.map((variant) => animateVariant(visualElement, variant, options));
    animation2 = Promise.all(animations2);
  } else if (typeof definition2 == "string")
    animation2 = animateVariant(visualElement, definition2, options);
  else {
    const resolvedDefinition = typeof definition2 == "function" ? resolveVariant(visualElement, definition2, options.custom) : definition2;
    animation2 = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
  }
  return animation2.then(() => visualElement.notify("AnimationComplete", definition2));
}
__name(animateVisualElement, "animateVisualElement");
const reversePriorityOrder = [...variantPriorityOrder].reverse(), numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
  return (animations2) => Promise.all(animations2.map(({ animation: animation2, options }) => animateVisualElement(visualElement, animation2, options)));
}
__name(animateList, "animateList");
function createAnimationState(visualElement) {
  let animate = animateList(visualElement);
  const state = createState$1();
  let isInitialRender = !0;
  const buildResolvedTypeValues = /* @__PURE__ */ __name((acc, definition2) => {
    const resolved = resolveVariant(visualElement, definition2);
    if (resolved) {
      const { transition: transition2, transitionEnd, ...target } = resolved;
      acc = { ...acc, ...target, ...transitionEnd };
    }
    return acc;
  }, "buildResolvedTypeValues");
  function setAnimateFunction(makeAnimator) {
    animate = makeAnimator(visualElement);
  }
  __name(setAnimateFunction, "setAnimateFunction");
  function animateChanges(options, changedActiveType) {
    const props = visualElement.getProps(), context = visualElement.getVariantContext(!0) || {}, animations2 = [], removedKeys = /* @__PURE__ */ new Set();
    let encounteredKeys = {}, removedVariantIndex = 1 / 0;
    for (let i2 = 0; i2 < numAnimationTypes; i2++) {
      const type = reversePriorityOrder[i2], typeState = state[type], prop = props[type] !== void 0 ? props[type] : context[type], propIsVariant = isVariantLabel(prop), activeDelta = type === changedActiveType ? typeState.isActive : null;
      activeDelta === !1 && (removedVariantIndex = i2);
      let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount && (isInherited = !1), typeState.protectedKeys = { ...encounteredKeys }, // If it isn't active and hasn't *just* been set as inactive
      !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
      !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
      isAnimationControls(prop) || typeof prop == "boolean")
        continue;
      let shouldAnimateType = checkVariantsDidChange(typeState.prevProp, prop) || // If we're making this variant active, we want to always make it active
      type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
      i2 > removedVariantIndex && propIsVariant, handledRemovedValues = !1;
      const definitionList = Array.isArray(prop) ? prop : [prop];
      let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
      activeDelta === !1 && (resolvedValues = {});
      const { prevResolvedValues = {} } = typeState, allKeys = {
        ...prevResolvedValues,
        ...resolvedValues
      }, markToAnimate = /* @__PURE__ */ __name((key) => {
        shouldAnimateType = !0, removedKeys.has(key) && (handledRemovedValues = !0, removedKeys.delete(key)), typeState.needsAnimating[key] = !0;
      }, "markToAnimate");
      for (const key in allKeys) {
        const next = resolvedValues[key], prev = prevResolvedValues[key];
        if (encounteredKeys.hasOwnProperty(key))
          continue;
        let valueHasChanged = !1;
        isKeyframesTarget(next) && isKeyframesTarget(prev) ? valueHasChanged = !shallowCompare(next, prev) : valueHasChanged = next !== prev, valueHasChanged ? next !== void 0 ? markToAnimate(key) : removedKeys.add(key) : next !== void 0 && removedKeys.has(key) ? markToAnimate(key) : typeState.protectedKeys[key] = !0;
      }
      typeState.prevProp = prop, typeState.prevResolvedValues = resolvedValues, typeState.isActive && (encounteredKeys = { ...encounteredKeys, ...resolvedValues }), isInitialRender && visualElement.blockInitialAnimation && (shouldAnimateType = !1), shouldAnimateType && (!isInherited || handledRemovedValues) && animations2.push(...definitionList.map((animation2) => ({
        animation: animation2,
        options: { type, ...options }
      })));
    }
    if (removedKeys.size) {
      const fallbackAnimation = {};
      removedKeys.forEach((key) => {
        const fallbackTarget = visualElement.getBaseTarget(key);
        fallbackTarget !== void 0 && (fallbackAnimation[key] = fallbackTarget);
      }), animations2.push({ animation: fallbackAnimation });
    }
    let shouldAnimate = !!animations2.length;
    return isInitialRender && (props.initial === !1 || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount && (shouldAnimate = !1), isInitialRender = !1, shouldAnimate ? animate(animations2) : Promise.resolve();
  }
  __name(animateChanges, "animateChanges");
  function setActive(type, isActive, options) {
    var _a3;
    if (state[type].isActive === isActive)
      return Promise.resolve();
    (_a3 = visualElement.variantChildren) === null || _a3 === void 0 || _a3.forEach((child) => {
      var _a4;
      return (_a4 = child.animationState) === null || _a4 === void 0 ? void 0 : _a4.setActive(type, isActive);
    }), state[type].isActive = isActive;
    const animations2 = animateChanges(options, type);
    for (const key in state)
      state[key].protectedKeys = {};
    return animations2;
  }
  return __name(setActive, "setActive"), {
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: () => state
  };
}
__name(createAnimationState, "createAnimationState");
function checkVariantsDidChange(prev, next) {
  return typeof next == "string" ? next !== prev : Array.isArray(next) ? !shallowCompare(next, prev) : !1;
}
__name(checkVariantsDidChange, "checkVariantsDidChange");
function createTypeState(isActive = !1) {
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
__name(createTypeState, "createTypeState");
function createState$1() {
  return {
    animate: createTypeState(!0),
    whileInView: createTypeState(),
    whileHover: createTypeState(),
    whileTap: createTypeState(),
    whileDrag: createTypeState(),
    whileFocus: createTypeState(),
    exit: createTypeState()
  };
}
__name(createState$1, "createState$1");
const _AnimationFeature = class _AnimationFeature extends Feature {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(node2) {
    super(node2), node2.animationState || (node2.animationState = createAnimationState(node2));
  }
  updateAnimationControlsSubscription() {
    const { animate } = this.node.getProps();
    this.unmount(), isAnimationControls(animate) && (this.unmount = animate.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate } = this.node.getProps(), { animate: prevAnimate } = this.node.prevProps || {};
    animate !== prevAnimate && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
};
__name(_AnimationFeature, "AnimationFeature");
let AnimationFeature = _AnimationFeature, id$1 = 0;
const _ExitAnimationFeature = class _ExitAnimationFeature extends Feature {
  constructor() {
    super(...arguments), this.id = id$1++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent, onExitComplete, custom: custom2 } = this.node.presenceContext, { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || isPresent === prevIsPresent)
      return;
    const exitAnimation = this.node.animationState.setActive("exit", !isPresent, { custom: custom2 ?? this.node.getProps().custom });
    onExitComplete && !isPresent && exitAnimation.then(() => onExitComplete(this.id));
  }
  mount() {
    const { register } = this.node.presenceContext || {};
    register && (this.unmount = register(this.id));
  }
  unmount() {
  }
};
__name(_ExitAnimationFeature, "ExitAnimationFeature");
let ExitAnimationFeature = _ExitAnimationFeature;
const animations = {
  animation: {
    Feature: AnimationFeature
  },
  exit: {
    Feature: ExitAnimationFeature
  }
}, distance = /* @__PURE__ */ __name((a4, b2) => Math.abs(a4 - b2), "distance");
function distance2D(a4, b2) {
  const xDelta = distance(a4.x, b2.x), yDelta = distance(a4.y, b2.y);
  return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}
__name(distance2D, "distance2D");
const _PanSession = class _PanSession {
  constructor(event, handlers2, { transformPagePoint, contextWindow, dragSnapToOrigin = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const info2 = getPanInfo(this.lastMoveEventInfo, this.history), isPanStarted = this.startEvent !== null, isDistancePastThreshold = distance2D(info2.offset, { x: 0, y: 0 }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      const { point: point3 } = info2, { timestamp: timestamp2 } = frameData;
      this.history.push({ ...point3, timestamp: timestamp2 });
      const { onStart, onMove } = this.handlers;
      isPanStarted || (onStart && onStart(this.lastMoveEvent, info2), this.startEvent = this.lastMoveEvent), onMove && onMove(this.lastMoveEvent, info2);
    }, this.handlePointerMove = (event2, info2) => {
      this.lastMoveEvent = event2, this.lastMoveEventInfo = transformPoint(info2, this.transformPagePoint), frame.update(this.updatePoint, !0);
    }, this.handlePointerUp = (event2, info2) => {
      this.end();
      const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
      if (this.dragSnapToOrigin && resumeAnimation && resumeAnimation(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const panInfo = getPanInfo(event2.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(info2, this.transformPagePoint), this.history);
      this.startEvent && onEnd && onEnd(event2, panInfo), onSessionEnd && onSessionEnd(event2, panInfo);
    }, !isPrimaryPointer(event))
      return;
    this.dragSnapToOrigin = dragSnapToOrigin, this.handlers = handlers2, this.transformPagePoint = transformPagePoint, this.contextWindow = contextWindow || window;
    const info = extractEventInfo(event), initialInfo = transformPoint(info, this.transformPagePoint), { point: point2 } = initialInfo, { timestamp } = frameData;
    this.history = [{ ...point2, timestamp }];
    const { onSessionStart } = handlers2;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history)), this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(handlers2) {
    this.handlers = handlers2;
  }
  end() {
    this.removeListeners && this.removeListeners(), cancelFrame(this.updatePoint);
  }
};
__name(_PanSession, "PanSession");
let PanSession = _PanSession;
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
__name(transformPoint, "transformPoint");
function subtractPoint(a4, b2) {
  return { x: a4.x - b2.x, y: a4.y - b2.y };
}
__name(subtractPoint, "subtractPoint");
function getPanInfo({ point: point2 }, history) {
  return {
    point: point2,
    delta: subtractPoint(point2, lastDevicePoint(history)),
    offset: subtractPoint(point2, startDevicePoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}
__name(getPanInfo, "getPanInfo");
function startDevicePoint(history) {
  return history[0];
}
__name(startDevicePoint, "startDevicePoint");
function lastDevicePoint(history) {
  return history[history.length - 1];
}
__name(lastDevicePoint, "lastDevicePoint");
function getVelocity(history, timeDelta) {
  if (history.length < 2)
    return { x: 0, y: 0 };
  let i2 = history.length - 1, timestampedPoint = null;
  const lastPoint = lastDevicePoint(history);
  for (; i2 >= 0 && (timestampedPoint = history[i2], !(lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta))); )
    i2--;
  if (!timestampedPoint)
    return { x: 0, y: 0 };
  const time2 = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
  if (time2 === 0)
    return { x: 0, y: 0 };
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time2,
    y: (lastPoint.y - timestampedPoint.y) / time2
  };
  return currentVelocity.x === 1 / 0 && (currentVelocity.x = 0), currentVelocity.y === 1 / 0 && (currentVelocity.y = 0), currentVelocity;
}
__name(getVelocity, "getVelocity");
function calcLength(axis) {
  return axis.max - axis.min;
}
__name(calcLength, "calcLength");
function isNear(value, target = 0, maxDistance = 0.01) {
  return Math.abs(value - target) <= maxDistance;
}
__name(isNear, "isNear");
function calcAxisDelta(delta, source, target, origin = 0.5) {
  delta.origin = origin, delta.originPoint = mix(source.min, source.max, delta.origin), delta.scale = calcLength(target) / calcLength(source), (isNear(delta.scale, 1, 1e-4) || isNaN(delta.scale)) && (delta.scale = 1), delta.translate = mix(target.min, target.max, delta.origin) - delta.originPoint, (isNear(delta.translate) || isNaN(delta.translate)) && (delta.translate = 0);
}
__name(calcAxisDelta, "calcAxisDelta");
function calcBoxDelta(delta, source, target, origin) {
  calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : void 0), calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : void 0);
}
__name(calcBoxDelta, "calcBoxDelta");
function calcRelativeAxis(target, relative, parent2) {
  target.min = parent2.min + relative.min, target.max = target.min + calcLength(relative);
}
__name(calcRelativeAxis, "calcRelativeAxis");
function calcRelativeBox(target, relative, parent2) {
  calcRelativeAxis(target.x, relative.x, parent2.x), calcRelativeAxis(target.y, relative.y, parent2.y);
}
__name(calcRelativeBox, "calcRelativeBox");
function calcRelativeAxisPosition(target, layout2, parent2) {
  target.min = layout2.min - parent2.min, target.max = target.min + calcLength(layout2);
}
__name(calcRelativeAxisPosition, "calcRelativeAxisPosition");
function calcRelativePosition(target, layout2, parent2) {
  calcRelativeAxisPosition(target.x, layout2.x, parent2.x), calcRelativeAxisPosition(target.y, layout2.y, parent2.y);
}
__name(calcRelativePosition, "calcRelativePosition");
function applyConstraints(point2, { min: min2, max: max2 }, elastic) {
  return min2 !== void 0 && point2 < min2 ? point2 = elastic ? mix(min2, point2, elastic.min) : Math.max(point2, min2) : max2 !== void 0 && point2 > max2 && (point2 = elastic ? mix(max2, point2, elastic.max) : Math.min(point2, max2)), point2;
}
__name(applyConstraints, "applyConstraints");
function calcRelativeAxisConstraints(axis, min2, max2) {
  return {
    min: min2 !== void 0 ? axis.min + min2 : void 0,
    max: max2 !== void 0 ? axis.max + max2 - (axis.max - axis.min) : void 0
  };
}
__name(calcRelativeAxisConstraints, "calcRelativeAxisConstraints");
function calcRelativeConstraints(layoutBox, { top: top2, left: left2, bottom: bottom2, right: right2 }) {
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left2, right2),
    y: calcRelativeAxisConstraints(layoutBox.y, top2, bottom2)
  };
}
__name(calcRelativeConstraints, "calcRelativeConstraints");
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  let min2 = constraintsAxis.min - layoutAxis.min, max2 = constraintsAxis.max - layoutAxis.max;
  return constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min && ([min2, max2] = [max2, min2]), { min: min2, max: max2 };
}
__name(calcViewportAxisConstraints, "calcViewportAxisConstraints");
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
__name(calcViewportConstraints, "calcViewportConstraints");
function calcOrigin(source, target) {
  let origin = 0.5;
  const sourceLength = calcLength(source), targetLength = calcLength(target);
  return targetLength > sourceLength ? origin = progress(target.min, target.max - sourceLength, source.min) : sourceLength > targetLength && (origin = progress(source.min, source.max - targetLength, target.min)), clamp(0, 1, origin);
}
__name(calcOrigin, "calcOrigin");
function rebaseAxisConstraints(layout2, constraints) {
  const relativeConstraints = {};
  return constraints.min !== void 0 && (relativeConstraints.min = constraints.min - layout2.min), constraints.max !== void 0 && (relativeConstraints.max = constraints.max - layout2.min), relativeConstraints;
}
__name(rebaseAxisConstraints, "rebaseAxisConstraints");
const defaultElastic = 0.35;
function resolveDragElastic(dragElastic = defaultElastic) {
  return dragElastic === !1 ? dragElastic = 0 : dragElastic === !0 && (dragElastic = defaultElastic), {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
__name(resolveDragElastic, "resolveDragElastic");
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
__name(resolveAxisElastic, "resolveAxisElastic");
function resolvePointElastic(dragElastic, label) {
  return typeof dragElastic == "number" ? dragElastic : dragElastic[label] || 0;
}
__name(resolvePointElastic, "resolvePointElastic");
const createAxisDelta = /* @__PURE__ */ __name(() => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), "createAxisDelta"), createDelta = /* @__PURE__ */ __name(() => ({
  x: createAxisDelta(),
  y: createAxisDelta()
}), "createDelta"), createAxis = /* @__PURE__ */ __name(() => ({ min: 0, max: 0 }), "createAxis"), createBox = /* @__PURE__ */ __name(() => ({
  x: createAxis(),
  y: createAxis()
}), "createBox");
function eachAxis(callback) {
  return [callback("x"), callback("y")];
}
__name(eachAxis, "eachAxis");
function convertBoundingBoxToBox({ top: top2, left: left2, right: right2, bottom: bottom2 }) {
  return {
    x: { min: left2, max: right2 },
    y: { min: top2, max: bottom2 }
  };
}
__name(convertBoundingBoxToBox, "convertBoundingBoxToBox");
function convertBoxToBoundingBox({ x: x3, y: y4 }) {
  return { top: y4.min, right: x3.max, bottom: y4.max, left: x3.min };
}
__name(convertBoxToBoundingBox, "convertBoxToBoundingBox");
function transformBoxPoints(point2, transformPoint2) {
  if (!transformPoint2)
    return point2;
  const topLeft = transformPoint2({ x: point2.left, y: point2.top }), bottomRight = transformPoint2({ x: point2.right, y: point2.bottom });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}
__name(transformBoxPoints, "transformBoxPoints");
function isIdentityScale(scale2) {
  return scale2 === void 0 || scale2 === 1;
}
__name(isIdentityScale, "isIdentityScale");
function hasScale({ scale: scale2, scaleX: scaleX2, scaleY: scaleY2 }) {
  return !isIdentityScale(scale2) || !isIdentityScale(scaleX2) || !isIdentityScale(scaleY2);
}
__name(hasScale, "hasScale");
function hasTransform(values) {
  return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
__name(hasTransform, "hasTransform");
function has2DTranslate(values) {
  return is2DTranslate(values.x) || is2DTranslate(values.y);
}
__name(has2DTranslate, "has2DTranslate");
function is2DTranslate(value) {
  return value && value !== "0%";
}
__name(is2DTranslate, "is2DTranslate");
function scalePoint(point2, scale2, originPoint) {
  const distanceFromOrigin = point2 - originPoint, scaled = scale2 * distanceFromOrigin;
  return originPoint + scaled;
}
__name(scalePoint, "scalePoint");
function applyPointDelta(point2, translate, scale2, originPoint, boxScale) {
  return boxScale !== void 0 && (point2 = scalePoint(point2, boxScale, originPoint)), scalePoint(point2, scale2, originPoint) + translate;
}
__name(applyPointDelta, "applyPointDelta");
function applyAxisDelta(axis, translate = 0, scale2 = 1, originPoint, boxScale) {
  axis.min = applyPointDelta(axis.min, translate, scale2, originPoint, boxScale), axis.max = applyPointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
__name(applyAxisDelta, "applyAxisDelta");
function applyBoxDelta(box, { x: x3, y: y4 }) {
  applyAxisDelta(box.x, x3.translate, x3.scale, x3.originPoint), applyAxisDelta(box.y, y4.translate, y4.scale, y4.originPoint);
}
__name(applyBoxDelta, "applyBoxDelta");
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = !1) {
  const treeLength = treePath.length;
  if (!treeLength)
    return;
  treeScale.x = treeScale.y = 1;
  let node2, delta;
  for (let i2 = 0; i2 < treeLength; i2++) {
    node2 = treePath[i2], delta = node2.projectionDelta;
    const instance = node2.instance;
    instance && instance.style && instance.style.display === "contents" || (isSharedTransition && node2.options.layoutScroll && node2.scroll && node2 !== node2.root && transformBox(box, {
      x: -node2.scroll.offset.x,
      y: -node2.scroll.offset.y
    }), delta && (treeScale.x *= delta.x.scale, treeScale.y *= delta.y.scale, applyBoxDelta(box, delta)), isSharedTransition && hasTransform(node2.latestValues) && transformBox(box, node2.latestValues));
  }
  treeScale.x = snapToDefault(treeScale.x), treeScale.y = snapToDefault(treeScale.y);
}
__name(applyTreeDeltas, "applyTreeDeltas");
function snapToDefault(scale2) {
  return Number.isInteger(scale2) || scale2 > 1.0000000000001 || scale2 < 0.999999999999 ? scale2 : 1;
}
__name(snapToDefault, "snapToDefault");
function translateAxis(axis, distance2) {
  axis.min = axis.min + distance2, axis.max = axis.max + distance2;
}
__name(translateAxis, "translateAxis");
function transformAxis(axis, transforms2, [key, scaleKey, originKey]) {
  const axisOrigin = transforms2[originKey] !== void 0 ? transforms2[originKey] : 0.5, originPoint = mix(axis.min, axis.max, axisOrigin);
  applyAxisDelta(axis, transforms2[key], transforms2[scaleKey], originPoint, transforms2.scale);
}
__name(transformAxis, "transformAxis");
const xKeys$1 = ["x", "scaleX", "originX"], yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(box, transform2) {
  transformAxis(box.x, transform2, xKeys$1), transformAxis(box.y, transform2, yKeys$1);
}
__name(transformBox, "transformBox");
function measureViewportBox(instance, transformPoint2) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint2));
}
__name(measureViewportBox, "measureViewportBox");
function measurePageBox(element2, rootProjectionNode2, transformPagePoint) {
  const viewportBox = measureViewportBox(element2, transformPagePoint), { scroll } = rootProjectionNode2;
  return scroll && (translateAxis(viewportBox.x, scroll.offset.x), translateAxis(viewportBox.y, scroll.offset.y)), viewportBox;
}
__name(measurePageBox, "measurePageBox");
const getContextWindow = /* @__PURE__ */ __name(({ current }) => current ? current.ownerDocument.defaultView : null, "getContextWindow"), elementDragControls = /* @__PURE__ */ new WeakMap(), _VisualElementDragControls = class _VisualElementDragControls {
  constructor(visualElement) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = createBox(), this.visualElement = visualElement;
  }
  start(originEvent, { snapToCursor = !1 } = {}) {
    const { presenceContext } = this.visualElement;
    if (presenceContext && presenceContext.isPresent === !1)
      return;
    const onSessionStart = /* @__PURE__ */ __name((event) => {
      const { dragSnapToOrigin: dragSnapToOrigin2 } = this.getProps();
      dragSnapToOrigin2 ? this.pauseAnimation() : this.stopAnimation(), snapToCursor && this.snapToCursor(extractEventInfo(event, "page").point);
    }, "onSessionStart"), onStart = /* @__PURE__ */ __name((event, info) => {
      const { drag: drag2, dragPropagation, onDragStart } = this.getProps();
      if (drag2 && !dragPropagation && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = getGlobalLock(drag2), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), eachAxis((axis) => {
        let current = this.getAxisMotionValue(axis).get() || 0;
        if (percent.test(current)) {
          const { projection } = this.visualElement;
          if (projection && projection.layout) {
            const measuredAxis = projection.layout.layoutBox[axis];
            measuredAxis && (current = calcLength(measuredAxis) * (parseFloat(current) / 100));
          }
        }
        this.originPoint[axis] = current;
      }), onDragStart && frame.update(() => onDragStart(event, info), !1, !0);
      const { animationState } = this.visualElement;
      animationState && animationState.setActive("whileDrag", !0);
    }, "onStart"), onMove = /* @__PURE__ */ __name((event, info) => {
      const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag } = this.getProps();
      if (!dragPropagation && !this.openGlobalLock)
        return;
      const { offset } = info;
      if (dragDirectionLock && this.currentDirection === null) {
        this.currentDirection = getCurrentDirection(offset), this.currentDirection !== null && onDirectionLock && onDirectionLock(this.currentDirection);
        return;
      }
      this.updateAxis("x", info.point, offset), this.updateAxis("y", info.point, offset), this.visualElement.render(), onDrag && onDrag(event, info);
    }, "onMove"), onSessionEnd = /* @__PURE__ */ __name((event, info) => this.stop(event, info), "onSessionEnd"), resumeAnimation = /* @__PURE__ */ __name(() => eachAxis((axis) => {
      var _a3;
      return this.getAnimationState(axis) === "paused" && ((_a3 = this.getAxisMotionValue(axis).animation) === null || _a3 === void 0 ? void 0 : _a3.play());
    }), "resumeAnimation"), { dragSnapToOrigin } = this.getProps();
    this.panSession = new PanSession(originEvent, {
      onSessionStart,
      onStart,
      onMove,
      onSessionEnd,
      resumeAnimation
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin,
      contextWindow: getContextWindow(this.visualElement)
    });
  }
  stop(event, info) {
    const isDragging = this.isDragging;
    if (this.cancel(), !isDragging)
      return;
    const { velocity } = info;
    this.startAnimation(velocity);
    const { onDragEnd } = this.getProps();
    onDragEnd && frame.update(() => onDragEnd(event, info));
  }
  cancel() {
    this.isDragging = !1;
    const { projection, animationState } = this.visualElement;
    projection && (projection.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation } = this.getProps();
    !dragPropagation && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), animationState && animationState.setActive("whileDrag", !1);
  }
  updateAxis(axis, _point, offset) {
    const { drag: drag2 } = this.getProps();
    if (!offset || !shouldDrag(axis, drag2, this.currentDirection))
      return;
    const axisValue = this.getAxisMotionValue(axis);
    let next = this.originPoint[axis] + offset[axis];
    this.constraints && this.constraints[axis] && (next = applyConstraints(next, this.constraints[axis], this.elastic[axis])), axisValue.set(next);
  }
  resolveConstraints() {
    var _a3;
    const { dragConstraints, dragElastic } = this.getProps(), layout2 = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (_a3 = this.visualElement.projection) === null || _a3 === void 0 ? void 0 : _a3.layout, prevConstraints = this.constraints;
    dragConstraints && isRefObject(dragConstraints) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : dragConstraints && layout2 ? this.constraints = calcRelativeConstraints(layout2.layoutBox, dragConstraints) : this.constraints = !1, this.elastic = resolveDragElastic(dragElastic), prevConstraints !== this.constraints && layout2 && this.constraints && !this.hasMutatedConstraints && eachAxis((axis) => {
      this.getAxisMotionValue(axis) && (this.constraints[axis] = rebaseAxisConstraints(layout2.layoutBox[axis], this.constraints[axis]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
    if (!constraints || !isRefObject(constraints))
      return !1;
    const constraintsElement = constraints.current;
    invariant$1(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection } = this.visualElement;
    if (!projection || !projection.layout)
      return !1;
    const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
    let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
    if (onMeasureDragConstraints) {
      const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
      this.hasMutatedConstraints = !!userConstraints, userConstraints && (measuredConstraints = convertBoundingBoxToBox(userConstraints));
    }
    return measuredConstraints;
  }
  startAnimation(velocity) {
    const { drag: drag2, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd } = this.getProps(), constraints = this.constraints || {}, momentumAnimations = eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, this.currentDirection))
        return;
      let transition2 = constraints && constraints[axis] || {};
      dragSnapToOrigin && (transition2 = { min: 0, max: 0 });
      const bounceStiffness = dragElastic ? 200 : 1e6, bounceDamping = dragElastic ? 40 : 1e7, inertia2 = {
        type: "inertia",
        velocity: dragMomentum ? velocity[axis] : 0,
        bounceStiffness,
        bounceDamping,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...dragTransition,
        ...transition2
      };
      return this.startAxisValueAnimation(axis, inertia2);
    });
    return Promise.all(momentumAnimations).then(onDragTransitionEnd);
  }
  startAxisValueAnimation(axis, transition2) {
    const axisValue = this.getAxisMotionValue(axis);
    return axisValue.start(animateMotionValue(axis, axisValue, 0, transition2));
  }
  stopAnimation() {
    eachAxis((axis) => this.getAxisMotionValue(axis).stop());
  }
  pauseAnimation() {
    eachAxis((axis) => {
      var _a3;
      return (_a3 = this.getAxisMotionValue(axis).animation) === null || _a3 === void 0 ? void 0 : _a3.pause();
    });
  }
  getAnimationState(axis) {
    var _a3;
    return (_a3 = this.getAxisMotionValue(axis).animation) === null || _a3 === void 0 ? void 0 : _a3.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(axis) {
    const dragKey = "_drag" + axis.toUpperCase(), props = this.visualElement.getProps(), externalMotionValue = props[dragKey];
    return externalMotionValue || this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : void 0) || 0);
  }
  snapToCursor(point2) {
    eachAxis((axis) => {
      const { drag: drag2 } = this.getProps();
      if (!shouldDrag(axis, drag2, this.currentDirection))
        return;
      const { projection } = this.visualElement, axisValue = this.getAxisMotionValue(axis);
      if (projection && projection.layout) {
        const { min: min2, max: max2 } = projection.layout.layoutBox[axis];
        axisValue.set(point2[axis] - mix(min2, max2, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: drag2, dragConstraints } = this.getProps(), { projection } = this.visualElement;
    if (!isRefObject(dragConstraints) || !projection || !this.constraints)
      return;
    this.stopAnimation();
    const boxProgress = { x: 0, y: 0 };
    eachAxis((axis) => {
      const axisValue = this.getAxisMotionValue(axis);
      if (axisValue) {
        const latest = axisValue.get();
        boxProgress[axis] = calcOrigin({ min: latest, max: latest }, this.constraints[axis]);
      }
    });
    const { transformTemplate } = this.visualElement.getProps();
    this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none", projection.root && projection.root.updateScroll(), projection.updateLayout(), this.resolveConstraints(), eachAxis((axis) => {
      if (!shouldDrag(axis, drag2, null))
        return;
      const axisValue = this.getAxisMotionValue(axis), { min: min2, max: max2 } = this.constraints[axis];
      axisValue.set(mix(min2, max2, boxProgress[axis]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    elementDragControls.set(this.visualElement, this);
    const element2 = this.visualElement.current, stopPointerListener = addPointerEvent(element2, "pointerdown", (event) => {
      const { drag: drag2, dragListener = !0 } = this.getProps();
      drag2 && dragListener && this.start(event);
    }), measureDragConstraints = /* @__PURE__ */ __name(() => {
      const { dragConstraints } = this.getProps();
      isRefObject(dragConstraints) && (this.constraints = this.resolveRefConstraints());
    }, "measureDragConstraints"), { projection } = this.visualElement, stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
    projection && !projection.layout && (projection.root && projection.root.updateScroll(), projection.updateLayout()), measureDragConstraints();
    const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints()), stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta, hasLayoutChanged }) => {
      this.isDragging && hasLayoutChanged && (eachAxis((axis) => {
        const motionValue2 = this.getAxisMotionValue(axis);
        motionValue2 && (this.originPoint[axis] += delta[axis].translate, motionValue2.set(motionValue2.get() + delta[axis].translate));
      }), this.visualElement.render());
    });
    return () => {
      stopResizeListener(), stopPointerListener(), stopMeasureLayoutListener(), stopLayoutUpdateListener && stopLayoutUpdateListener();
    };
  }
  getProps() {
    const props = this.visualElement.getProps(), { drag: drag2 = !1, dragDirectionLock = !1, dragPropagation = !1, dragConstraints = !1, dragElastic = defaultElastic, dragMomentum = !0 } = props;
    return {
      ...props,
      drag: drag2,
      dragDirectionLock,
      dragPropagation,
      dragConstraints,
      dragElastic,
      dragMomentum
    };
  }
};
__name(_VisualElementDragControls, "VisualElementDragControls");
let VisualElementDragControls = _VisualElementDragControls;
function shouldDrag(direction, drag2, currentDirection) {
  return (drag2 === !0 || drag2 === direction) && (currentDirection === null || currentDirection === direction);
}
__name(shouldDrag, "shouldDrag");
function getCurrentDirection(offset, lockThreshold = 10) {
  let direction = null;
  return Math.abs(offset.y) > lockThreshold ? direction = "y" : Math.abs(offset.x) > lockThreshold && (direction = "x"), direction;
}
__name(getCurrentDirection, "getCurrentDirection");
const _DragGesture = class _DragGesture extends Feature {
  constructor(node2) {
    super(node2), this.removeGroupControls = noop$4, this.removeListeners = noop$4, this.controls = new VisualElementDragControls(node2);
  }
  mount() {
    const { dragControls } = this.node.getProps();
    dragControls && (this.removeGroupControls = dragControls.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || noop$4;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
};
__name(_DragGesture, "DragGesture");
let DragGesture = _DragGesture;
const asyncHandler = /* @__PURE__ */ __name((handler) => (event, info) => {
  handler && frame.update(() => handler(event, info));
}, "asyncHandler"), _PanGesture = class _PanGesture extends Feature {
  constructor() {
    super(...arguments), this.removePointerDownListener = noop$4;
  }
  onPointerDown(pointerDownEvent) {
    this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: getContextWindow(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
    return {
      onSessionStart: asyncHandler(onPanSessionStart),
      onStart: asyncHandler(onPanStart),
      onMove: onPan,
      onEnd: (event, info) => {
        delete this.session, onPanEnd && frame.update(() => onPanEnd(event, info));
      }
    };
  }
  mount() {
    this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
};
__name(_PanGesture, "PanGesture");
let PanGesture = _PanGesture;
function usePresence() {
  const context = useContext(PresenceContext);
  if (context === null)
    return [!0, null];
  const { isPresent, onExitComplete, register } = context, id2 = useId();
  return useEffect(() => register(id2), []), !isPresent && onExitComplete ? [!1, /* @__PURE__ */ __name(() => onExitComplete && onExitComplete(id2), "safeToRemove")] : [!0];
}
__name(usePresence, "usePresence");
const globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function pixelsToPercent(pixels, axis) {
  return axis.max === axis.min ? 0 : pixels / (axis.max - axis.min) * 100;
}
__name(pixelsToPercent, "pixelsToPercent");
const correctBorderRadius = {
  correct: (latest, node2) => {
    if (!node2.target)
      return latest;
    if (typeof latest == "string")
      if (px.test(latest))
        latest = parseFloat(latest);
      else
        return latest;
    const x3 = pixelsToPercent(latest, node2.target.x), y4 = pixelsToPercent(latest, node2.target.y);
    return `${x3}% ${y4}%`;
  }
}, correctBoxShadow = {
  correct: (latest, { treeScale, projectionDelta }) => {
    const original = latest, shadow = complex.parse(latest);
    if (shadow.length > 5)
      return original;
    const template = complex.createTransformer(latest), offset = typeof shadow[0] != "number" ? 1 : 0, xScale = projectionDelta.x.scale * treeScale.x, yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale, shadow[1 + offset] /= yScale;
    const averageScale = mix(xScale, yScale, 0.5);
    return typeof shadow[2 + offset] == "number" && (shadow[2 + offset] /= averageScale), typeof shadow[3 + offset] == "number" && (shadow[3 + offset] /= averageScale), template(shadow);
  }
}, _MeasureLayoutWithContext = class _MeasureLayoutWithContext extends React__default.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props, { projection } = visualElement;
    addScaleCorrector(defaultScaleCorrectors), projection && (layoutGroup.group && layoutGroup.group.add(projection), switchLayoutGroup && switchLayoutGroup.register && layoutId && switchLayoutGroup.register(projection), projection.root.didUpdate(), projection.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), projection.setOptions({
      ...projection.options,
      onExitComplete: () => this.safeToRemove()
    })), globalProjectionState.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(prevProps) {
    const { layoutDependency, visualElement, drag: drag2, isPresent } = this.props, projection = visualElement.projection;
    return projection && (projection.isPresent = isPresent, drag2 || prevProps.layoutDependency !== layoutDependency || layoutDependency === void 0 ? projection.willUpdate() : this.safeToRemove(), prevProps.isPresent !== isPresent && (isPresent ? projection.promote() : projection.relegate() || frame.postRender(() => {
      const stack = projection.getStack();
      (!stack || !stack.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection } = this.props.visualElement;
    projection && (projection.root.didUpdate(), queueMicrotask(() => {
      !projection.currentAnimation && projection.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement, layoutGroup, switchLayoutGroup: promoteContext } = this.props, { projection } = visualElement;
    projection && (projection.scheduleCheckAfterUnmount(), layoutGroup && layoutGroup.group && layoutGroup.group.remove(projection), promoteContext && promoteContext.deregister && promoteContext.deregister(projection));
  }
  safeToRemove() {
    const { safeToRemove } = this.props;
    safeToRemove && safeToRemove();
  }
  render() {
    return null;
  }
};
__name(_MeasureLayoutWithContext, "MeasureLayoutWithContext");
let MeasureLayoutWithContext = _MeasureLayoutWithContext;
function MeasureLayout(props) {
  const [isPresent, safeToRemove] = usePresence(), layoutGroup = useContext(LayoutGroupContext);
  return React__default.createElement(MeasureLayoutWithContext, { ...props, layoutGroup, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent, safeToRemove });
}
__name(MeasureLayout, "MeasureLayout");
const defaultScaleCorrectors = {
  borderRadius: {
    ...correctBorderRadius,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
}, borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], numBorders = borders.length, asNumber = /* @__PURE__ */ __name((value) => typeof value == "string" ? parseFloat(value) : value, "asNumber"), isPx = /* @__PURE__ */ __name((value) => typeof value == "number" || px.test(value), "isPx");
function mixValues(target, follow, lead, progress2, shouldCrossfadeOpacity, isOnlyMember) {
  shouldCrossfadeOpacity ? (target.opacity = mix(
    0,
    // TODO Reinstate this if only child
    lead.opacity !== void 0 ? lead.opacity : 1,
    easeCrossfadeIn(progress2)
  ), target.opacityExit = mix(follow.opacity !== void 0 ? follow.opacity : 1, 0, easeCrossfadeOut(progress2))) : isOnlyMember && (target.opacity = mix(follow.opacity !== void 0 ? follow.opacity : 1, lead.opacity !== void 0 ? lead.opacity : 1, progress2));
  for (let i2 = 0; i2 < numBorders; i2++) {
    const borderLabel = `border${borders[i2]}Radius`;
    let followRadius = getRadius(follow, borderLabel), leadRadius = getRadius(lead, borderLabel);
    if (followRadius === void 0 && leadRadius === void 0)
      continue;
    followRadius || (followRadius = 0), leadRadius || (leadRadius = 0), followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius) ? (target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress2), 0), (percent.test(leadRadius) || percent.test(followRadius)) && (target[borderLabel] += "%")) : target[borderLabel] = leadRadius;
  }
  (follow.rotate || lead.rotate) && (target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress2));
}
__name(mixValues, "mixValues");
function getRadius(values, radiusName) {
  return values[radiusName] !== void 0 ? values[radiusName] : values.borderRadius;
}
__name(getRadius, "getRadius");
const easeCrossfadeIn = compress(0, 0.5, circOut), easeCrossfadeOut = compress(0.5, 0.95, noop$4);
function compress(min2, max2, easing) {
  return (p) => p < min2 ? 0 : p > max2 ? 1 : easing(progress(min2, max2, p));
}
__name(compress, "compress");
function copyAxisInto(axis, originAxis) {
  axis.min = originAxis.min, axis.max = originAxis.max;
}
__name(copyAxisInto, "copyAxisInto");
function copyBoxInto(box, originBox) {
  copyAxisInto(box.x, originBox.x), copyAxisInto(box.y, originBox.y);
}
__name(copyBoxInto, "copyBoxInto");
function removePointDelta(point2, translate, scale2, originPoint, boxScale) {
  return point2 -= translate, point2 = scalePoint(point2, 1 / scale2, originPoint), boxScale !== void 0 && (point2 = scalePoint(point2, 1 / boxScale, originPoint)), point2;
}
__name(removePointDelta, "removePointDelta");
function removeAxisDelta(axis, translate = 0, scale2 = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
  if (percent.test(translate) && (translate = parseFloat(translate), translate = mix(sourceAxis.min, sourceAxis.max, translate / 100) - sourceAxis.min), typeof translate != "number")
    return;
  let originPoint = mix(originAxis.min, originAxis.max, origin);
  axis === originAxis && (originPoint -= translate), axis.min = removePointDelta(axis.min, translate, scale2, originPoint, boxScale), axis.max = removePointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
__name(removeAxisDelta, "removeAxisDelta");
function removeAxisTransforms(axis, transforms2, [key, scaleKey, originKey], origin, sourceAxis) {
  removeAxisDelta(axis, transforms2[key], transforms2[scaleKey], transforms2[originKey], transforms2.scale, origin, sourceAxis);
}
__name(removeAxisTransforms, "removeAxisTransforms");
const xKeys = ["x", "scaleX", "originX"], yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(box, transforms2, originBox, sourceBox) {
  removeAxisTransforms(box.x, transforms2, xKeys, originBox ? originBox.x : void 0, sourceBox ? sourceBox.x : void 0), removeAxisTransforms(box.y, transforms2, yKeys, originBox ? originBox.y : void 0, sourceBox ? sourceBox.y : void 0);
}
__name(removeBoxTransforms, "removeBoxTransforms");
function isAxisDeltaZero(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
__name(isAxisDeltaZero, "isAxisDeltaZero");
function isDeltaZero(delta) {
  return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
__name(isDeltaZero, "isDeltaZero");
function boxEquals(a4, b2) {
  return a4.x.min === b2.x.min && a4.x.max === b2.x.max && a4.y.min === b2.y.min && a4.y.max === b2.y.max;
}
__name(boxEquals, "boxEquals");
function boxEqualsRounded(a4, b2) {
  return Math.round(a4.x.min) === Math.round(b2.x.min) && Math.round(a4.x.max) === Math.round(b2.x.max) && Math.round(a4.y.min) === Math.round(b2.y.min) && Math.round(a4.y.max) === Math.round(b2.y.max);
}
__name(boxEqualsRounded, "boxEqualsRounded");
function aspectRatio(box) {
  return calcLength(box.x) / calcLength(box.y);
}
__name(aspectRatio, "aspectRatio");
const _NodeStack = class _NodeStack {
  constructor() {
    this.members = [];
  }
  add(node2) {
    addUniqueItem(this.members, node2), node2.scheduleRender();
  }
  remove(node2) {
    if (removeItem(this.members, node2), node2 === this.prevLead && (this.prevLead = void 0), node2 === this.lead) {
      const prevLead = this.members[this.members.length - 1];
      prevLead && this.promote(prevLead);
    }
  }
  relegate(node2) {
    const indexOfNode = this.members.findIndex((member) => node2 === member);
    if (indexOfNode === 0)
      return !1;
    let prevLead;
    for (let i2 = indexOfNode; i2 >= 0; i2--) {
      const member = this.members[i2];
      if (member.isPresent !== !1) {
        prevLead = member;
        break;
      }
    }
    return prevLead ? (this.promote(prevLead), !0) : !1;
  }
  promote(node2, preserveFollowOpacity) {
    const prevLead = this.lead;
    if (node2 !== prevLead && (this.prevLead = prevLead, this.lead = node2, node2.show(), prevLead)) {
      prevLead.instance && prevLead.scheduleRender(), node2.scheduleRender(), node2.resumeFrom = prevLead, preserveFollowOpacity && (node2.resumeFrom.preserveOpacity = !0), prevLead.snapshot && (node2.snapshot = prevLead.snapshot, node2.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues), node2.root && node2.root.isUpdating && (node2.isLayoutDirty = !0);
      const { crossfade } = node2.options;
      crossfade === !1 && prevLead.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((node2) => {
      const { options, resumingFrom } = node2;
      options.onExitComplete && options.onExitComplete(), resumingFrom && resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((node2) => {
      node2.instance && node2.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
};
__name(_NodeStack, "NodeStack");
let NodeStack = _NodeStack;
function buildProjectionTransform(delta, treeScale, latestTransform) {
  let transform2 = "";
  const xTranslate = delta.x.translate / treeScale.x, yTranslate = delta.y.translate / treeScale.y;
  if ((xTranslate || yTranslate) && (transform2 = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `), (treeScale.x !== 1 || treeScale.y !== 1) && (transform2 += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `), latestTransform) {
    const { rotate: rotate2, rotateX, rotateY } = latestTransform;
    rotate2 && (transform2 += `rotate(${rotate2}deg) `), rotateX && (transform2 += `rotateX(${rotateX}deg) `), rotateY && (transform2 += `rotateY(${rotateY}deg) `);
  }
  const elementScaleX = delta.x.scale * treeScale.x, elementScaleY = delta.y.scale * treeScale.y;
  return (elementScaleX !== 1 || elementScaleY !== 1) && (transform2 += `scale(${elementScaleX}, ${elementScaleY})`), transform2 || "none";
}
__name(buildProjectionTransform, "buildProjectionTransform");
const compareByDepth = /* @__PURE__ */ __name((a4, b2) => a4.depth - b2.depth, "compareByDepth"), _FlatTree = class _FlatTree {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(child) {
    addUniqueItem(this.children, child), this.isDirty = !0;
  }
  remove(child) {
    removeItem(this.children, child), this.isDirty = !0;
  }
  forEach(callback) {
    this.isDirty && this.children.sort(compareByDepth), this.isDirty = !1, this.children.forEach(callback);
  }
};
__name(_FlatTree, "FlatTree");
let FlatTree = _FlatTree;
function delay(callback, timeout) {
  const start = performance.now(), checkElapsed = /* @__PURE__ */ __name(({ timestamp }) => {
    const elapsed = timestamp - start;
    elapsed >= timeout && (cancelFrame(checkElapsed), callback(elapsed - timeout));
  }, "checkElapsed");
  return frame.read(checkElapsed, !0), () => cancelFrame(checkElapsed);
}
__name(delay, "delay");
function record(data2) {
  window.MotionDebug && window.MotionDebug.record(data2);
}
__name(record, "record");
function isSVGElement(element2) {
  return element2 instanceof SVGElement && element2.tagName !== "svg";
}
__name(isSVGElement, "isSVGElement");
function animateSingleValue(value, keyframes2, options) {
  const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
  return motionValue$1.start(animateMotionValue("", motionValue$1, keyframes2, options)), motionValue$1.animation;
}
__name(animateSingleValue, "animateSingleValue");
const transformAxes = ["", "X", "Y", "Z"], hiddenVisibility = { visibility: "hidden" }, animationTarget = 1e3;
let id = 0;
const projectionFrameData = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform }) {
  var _a3;
  return _a3 = class {
    constructor(latestValues = {}, parent2 = defaultParent == null ? void 0 : defaultParent()) {
      this.id = id++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, projectionFrameData.totalNodes = projectionFrameData.resolvedTargetDeltas = projectionFrameData.recalculatedProjection = 0, this.nodes.forEach(propagateDirtyNodes), this.nodes.forEach(resolveTargetDelta), this.nodes.forEach(calcProjection), this.nodes.forEach(cleanDirtyNodes), record(projectionFrameData);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = latestValues, this.root = parent2 ? parent2.root || parent2 : this, this.path = parent2 ? [...parent2.path, parent2] : [], this.parent = parent2, this.depth = parent2 ? parent2.depth + 1 : 0;
      for (let i2 = 0; i2 < this.path.length; i2++)
        this.path[i2].shouldResetTransform = !0;
      this.root === this && (this.nodes = new FlatTree());
    }
    addEventListener(name2, handler) {
      return this.eventHandlers.has(name2) || this.eventHandlers.set(name2, new SubscriptionManager()), this.eventHandlers.get(name2).add(handler);
    }
    notifyListeners(name2, ...args) {
      const subscriptionManager = this.eventHandlers.get(name2);
      subscriptionManager && subscriptionManager.notify(...args);
    }
    hasListeners(name2) {
      return this.eventHandlers.has(name2);
    }
    /**
     * Lifecycles
     */
    mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = isSVGElement(instance), this.instance = instance;
      const { layoutId, layout: layout2, visualElement } = this.options;
      if (visualElement && !visualElement.current && visualElement.mount(instance), this.root.nodes.add(this), this.parent && this.parent.children.add(this), isLayoutDirty && (layout2 || layoutId) && (this.isLayoutDirty = !0), attachResizeListener) {
        let cancelDelay;
        const resizeUnblockUpdate = /* @__PURE__ */ __name(() => this.root.updateBlockedByResize = !1, "resizeUnblockUpdate");
        attachResizeListener(instance, () => {
          this.root.updateBlockedByResize = !0, cancelDelay && cancelDelay(), cancelDelay = delay(resizeUnblockUpdate, 250), globalProjectionState.hasAnimatedSinceResize && (globalProjectionState.hasAnimatedSinceResize = !1, this.nodes.forEach(finishAnimation));
        });
      }
      layoutId && this.root.registerSharedNode(layoutId, this), this.options.animate !== !1 && visualElement && (layoutId || layout2) && this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition, { onLayoutAnimationStart, onLayoutAnimationComplete } = visualElement.getProps(), targetChanged = !this.targetLayout || !boxEqualsRounded(this.targetLayout, newLayout) || hasRelativeTargetChanged, hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
          const animationOptions = {
            ...getValueTransition(layoutTransition, "layout"),
            onPlay: onLayoutAnimationStart,
            onComplete: onLayoutAnimationComplete
          };
          (visualElement.shouldReduceMotion || this.options.layoutRoot) && (animationOptions.delay = 0, animationOptions.type = !1), this.startAnimation(animationOptions);
        } else
          hasLayoutChanged || finishAnimation(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = newLayout;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const stack = this.getStack();
      stack && stack.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, cancelFrame(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(resetRotation), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement } = this.options;
      return visualElement && visualElement.getProps().transformTemplate;
    }
    willUpdate(shouldNotifyListeners = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let i2 = 0; i2 < this.path.length; i2++) {
        const node2 = this.path[i2];
        node2.shouldResetTransform = !0, node2.updateScroll("snapshot"), node2.options.layoutRoot && node2.willUpdate(!1);
      }
      const { layoutId, layout: layout2 } = this.options;
      if (layoutId === void 0 && !layout2)
        return;
      const transformTemplate = this.getTransformTemplate();
      this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0, this.updateSnapshot(), shouldNotifyListeners && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(clearMeasurements);
        return;
      }
      this.isUpdating || this.nodes.forEach(clearIsLayoutDirty), this.isUpdating = !1, this.nodes.forEach(resetTransformStyle), this.nodes.forEach(updateLayout), this.nodes.forEach(notifyLayoutUpdate), this.clearAllSnapshots();
      const now2 = performance.now();
      frameData.delta = clamp(0, 1e3 / 60, now2 - frameData.timestamp), frameData.timestamp = now2, frameData.isProcessing = !0, steps.update.process(frameData), steps.preRender.process(frameData), steps.render.process(frameData), frameData.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(clearSnapshot), this.sharedNodes.forEach(removeLeadSnapshots);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, frame.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      frame.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let i2 = 0; i2 < this.path.length; i2++)
          this.path[i2].updateScroll();
      const prevLayout = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = createBox(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement } = this.options;
      visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : void 0);
    }
    updateScroll(phase = "measure") {
      let needsMeasurement = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase && (needsMeasurement = !1), needsMeasurement && (this.scroll = {
        animationId: this.root.animationId,
        phase,
        isRoot: checkIsScrollRoot(this.instance),
        offset: measureScroll(this.instance)
      });
    }
    resetTransform() {
      if (!resetTransform)
        return;
      const isResetRequested = this.isLayoutDirty || this.shouldResetTransform, hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta), transformTemplate = this.getTransformTemplate(), transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : void 0, transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
      isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged) && (resetTransform(this.instance, transformTemplateValue), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(removeTransform = !0) {
      const pageBox = this.measurePageBox();
      let layoutBox = this.removeElementScroll(pageBox);
      return removeTransform && (layoutBox = this.removeTransform(layoutBox)), roundBox(layoutBox), {
        animationId: this.root.animationId,
        measuredBox: pageBox,
        layoutBox,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement } = this.options;
      if (!visualElement)
        return createBox();
      const box = visualElement.measureViewportBox(), { scroll } = this.root;
      return scroll && (translateAxis(box.x, scroll.offset.x), translateAxis(box.y, scroll.offset.y)), box;
    }
    removeElementScroll(box) {
      const boxWithoutScroll = createBox();
      copyBoxInto(boxWithoutScroll, box);
      for (let i2 = 0; i2 < this.path.length; i2++) {
        const node2 = this.path[i2], { scroll, options } = node2;
        if (node2 !== this.root && scroll && options.layoutScroll) {
          if (scroll.isRoot) {
            copyBoxInto(boxWithoutScroll, box);
            const { scroll: rootScroll } = this.root;
            rootScroll && (translateAxis(boxWithoutScroll.x, -rootScroll.offset.x), translateAxis(boxWithoutScroll.y, -rootScroll.offset.y));
          }
          translateAxis(boxWithoutScroll.x, scroll.offset.x), translateAxis(boxWithoutScroll.y, scroll.offset.y);
        }
      }
      return boxWithoutScroll;
    }
    applyTransform(box, transformOnly = !1) {
      const withTransforms = createBox();
      copyBoxInto(withTransforms, box);
      for (let i2 = 0; i2 < this.path.length; i2++) {
        const node2 = this.path[i2];
        !transformOnly && node2.options.layoutScroll && node2.scroll && node2 !== node2.root && transformBox(withTransforms, {
          x: -node2.scroll.offset.x,
          y: -node2.scroll.offset.y
        }), hasTransform(node2.latestValues) && transformBox(withTransforms, node2.latestValues);
      }
      return hasTransform(this.latestValues) && transformBox(withTransforms, this.latestValues), withTransforms;
    }
    removeTransform(box) {
      const boxWithoutTransform = createBox();
      copyBoxInto(boxWithoutTransform, box);
      for (let i2 = 0; i2 < this.path.length; i2++) {
        const node2 = this.path[i2];
        if (!node2.instance || !hasTransform(node2.latestValues))
          continue;
        hasScale(node2.latestValues) && node2.updateSnapshot();
        const sourceBox = createBox(), nodeBox = node2.measurePageBox();
        copyBoxInto(sourceBox, nodeBox), removeBoxTransforms(boxWithoutTransform, node2.latestValues, node2.snapshot ? node2.snapshot.layoutBox : void 0, sourceBox);
      }
      return hasTransform(this.latestValues) && removeBoxTransforms(boxWithoutTransform, this.latestValues), boxWithoutTransform;
    }
    setTargetDelta(delta) {
      this.targetDelta = delta, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(options) {
      this.options = {
        ...this.options,
        ...options,
        crossfade: options.crossfade !== void 0 ? options.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== frameData.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(forceRecalculation = !1) {
      var _a4;
      const lead = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
      const isShared = !!this.resumingFrom || this !== lead;
      if (!(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || !((_a4 = this.parent) === null || _a4 === void 0) && _a4.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: layout2, layoutId } = this.options;
      if (!(!this.layout || !(layout2 || layoutId))) {
        if (this.resolvedRelativeTargetAt = frameData.timestamp, !this.targetDelta && !this.relativeTarget) {
          const relativeParent = this.getClosestProjectingParent();
          relativeParent && relativeParent.layout && this.animationProgress !== 1 ? (this.relativeParent = relativeParent, this.forceRelativeParentToResolveTarget(), this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = createBox(), this.targetWithTransforms = createBox()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : copyBoxInto(this.target, this.layout.layoutBox), applyBoxDelta(this.target, this.targetDelta)) : copyBoxInto(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const relativeParent = this.getClosestProjectingParent();
            relativeParent && !!relativeParent.resumingFrom == !!this.resumingFrom && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1 ? (this.relativeParent = relativeParent, this.forceRelativeParentToResolveTarget(), this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          projectionFrameData.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || hasScale(this.parent.latestValues) || has2DTranslate(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var _a4;
      const lead = this.getLead(), isShared = !!this.resumingFrom || this !== lead;
      let canSkip = !0;
      if ((this.isProjectionDirty || !((_a4 = this.parent) === null || _a4 === void 0) && _a4.isProjectionDirty) && (canSkip = !1), isShared && (this.isSharedProjectionDirty || this.isTransformDirty) && (canSkip = !1), this.resolvedRelativeTargetAt === frameData.timestamp && (canSkip = !1), canSkip)
        return;
      const { layout: layout2, layoutId } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(layout2 || layoutId))
        return;
      copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
      const prevTreeScaleX = this.treeScale.x, prevTreeScaleY = this.treeScale.y;
      applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared), lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (lead.target = lead.layout.layoutBox);
      const { target } = lead;
      if (!target) {
        this.projectionTransform && (this.projectionDelta = createDelta(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = createDelta(), this.projectionDeltaWithTransform = createDelta());
      const prevProjectionTransform = this.projectionTransform;
      calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues), this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale), (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", target)), projectionFrameData.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(notifyAll = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), notifyAll) {
        const stack = this.getStack();
        stack && stack.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = !1) {
      const snapshot = this.snapshot, snapshotLatestValues = snapshot ? snapshot.latestValues : {}, mixedValues = { ...this.latestValues }, targetDelta = createDelta();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
      const relativeLayout = createBox(), snapshotSource = snapshot ? snapshot.source : void 0, layoutSource = this.layout ? this.layout.source : void 0, isSharedLayoutAnimation = snapshotSource !== layoutSource, stack = this.getStack(), isOnlyMember = !stack || stack.members.length <= 1, shouldCrossfadeOpacity = !!(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === !0 && !this.path.some(hasOpacityCrossfade));
      this.animationProgress = 0;
      let prevRelativeTarget;
      this.mixTargetDelta = (latest) => {
        const progress2 = latest / 1e3;
        mixAxisDelta(targetDelta.x, delta.x, progress2), mixAxisDelta(targetDelta.y, delta.y, progress2), this.setTargetDelta(targetDelta), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox), mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress2), prevRelativeTarget && boxEquals(this.relativeTarget, prevRelativeTarget) && (this.isProjectionDirty = !1), prevRelativeTarget || (prevRelativeTarget = createBox()), copyBoxInto(prevRelativeTarget, this.relativeTarget)), isSharedLayoutAnimation && (this.animationValues = mixedValues, mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress2, shouldCrossfadeOpacity, isOnlyMember)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = progress2;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(options) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (cancelFrame(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = frame.update(() => {
        globalProjectionState.hasAnimatedSinceResize = !0, this.currentAnimation = animateSingleValue(0, animationTarget, {
          ...options,
          onUpdate: (latest) => {
            this.mixTargetDelta(latest), options.onUpdate && options.onUpdate(latest);
          },
          onComplete: () => {
            options.onComplete && options.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const stack = this.getStack();
      stack && stack.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(animationTarget), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const lead = this.getLead();
      let { targetWithTransforms, target, layout: layout2, latestValues } = lead;
      if (!(!targetWithTransforms || !target || !layout2)) {
        if (this !== lead && this.layout && layout2 && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout2.layoutBox)) {
          target = this.target || createBox();
          const xLength = calcLength(this.layout.layoutBox.x);
          target.x.min = lead.target.x.min, target.x.max = target.x.min + xLength;
          const yLength = calcLength(this.layout.layoutBox.y);
          target.y.min = lead.target.y.min, target.y.max = target.y.min + yLength;
        }
        copyBoxInto(targetWithTransforms, target), transformBox(targetWithTransforms, latestValues), calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
      }
    }
    registerSharedNode(layoutId, node2) {
      this.sharedNodes.has(layoutId) || this.sharedNodes.set(layoutId, new NodeStack()), this.sharedNodes.get(layoutId).add(node2);
      const config2 = node2.options.initialPromotionConfig;
      node2.promote({
        transition: config2 ? config2.transition : void 0,
        preserveFollowOpacity: config2 && config2.shouldPreserveFollowOpacity ? config2.shouldPreserveFollowOpacity(node2) : void 0
      });
    }
    isLead() {
      const stack = this.getStack();
      return stack ? stack.lead === this : !0;
    }
    getLead() {
      var _a4;
      const { layoutId } = this.options;
      return layoutId ? ((_a4 = this.getStack()) === null || _a4 === void 0 ? void 0 : _a4.lead) || this : this;
    }
    getPrevLead() {
      var _a4;
      const { layoutId } = this.options;
      return layoutId ? (_a4 = this.getStack()) === null || _a4 === void 0 ? void 0 : _a4.prevLead : void 0;
    }
    getStack() {
      const { layoutId } = this.options;
      if (layoutId)
        return this.root.sharedNodes.get(layoutId);
    }
    promote({ needsReset, transition: transition2, preserveFollowOpacity } = {}) {
      const stack = this.getStack();
      stack && stack.promote(this, preserveFollowOpacity), needsReset && (this.projectionDelta = void 0, this.needsReset = !0), transition2 && this.setOptions({ transition: transition2 });
    }
    relegate() {
      const stack = this.getStack();
      return stack ? stack.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement } = this.options;
      if (!visualElement)
        return;
      let hasRotate = !1;
      const { latestValues } = visualElement;
      if ((latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) && (hasRotate = !0), !hasRotate)
        return;
      const resetValues = {};
      for (let i2 = 0; i2 < transformAxes.length; i2++) {
        const key = "rotate" + transformAxes[i2];
        latestValues[key] && (resetValues[key] = latestValues[key], visualElement.setStaticValue(key, 0));
      }
      visualElement.render();
      for (const key in resetValues)
        visualElement.setStaticValue(key, resetValues[key]);
      visualElement.scheduleRender();
    }
    getProjectionStyles(styleProp) {
      var _a4, _b;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return hiddenVisibility;
      const styles = {
        visibility: ""
      }, transformTemplate = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, styles.opacity = "", styles.pointerEvents = resolveMotionValue(styleProp == null ? void 0 : styleProp.pointerEvents) || "", styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none", styles;
      const lead = this.getLead();
      if (!this.projectionDelta || !this.layout || !lead.target) {
        const emptyStyles = {};
        return this.options.layoutId && (emptyStyles.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, emptyStyles.pointerEvents = resolveMotionValue(styleProp == null ? void 0 : styleProp.pointerEvents) || ""), this.hasProjected && !hasTransform(this.latestValues) && (emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none", this.hasProjected = !1), emptyStyles;
      }
      const valuesToRender = lead.animationValues || lead.latestValues;
      this.applyTransformsToTarget(), styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender), transformTemplate && (styles.transform = transformTemplate(valuesToRender, styles.transform));
      const { x: x3, y: y4 } = this.projectionDelta;
      styles.transformOrigin = `${x3.origin * 100}% ${y4.origin * 100}% 0`, lead.animationValues ? styles.opacity = lead === this ? (_b = (_a4 = valuesToRender.opacity) !== null && _a4 !== void 0 ? _a4 : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit : styles.opacity = lead === this ? valuesToRender.opacity !== void 0 ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== void 0 ? valuesToRender.opacityExit : 0;
      for (const key in scaleCorrectors) {
        if (valuesToRender[key] === void 0)
          continue;
        const { correct, applyTo } = scaleCorrectors[key], corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
        if (applyTo) {
          const num2 = applyTo.length;
          for (let i2 = 0; i2 < num2; i2++)
            styles[applyTo[i2]] = corrected;
        } else
          styles[key] = corrected;
      }
      return this.options.layoutId && (styles.pointerEvents = lead === this ? resolveMotionValue(styleProp == null ? void 0 : styleProp.pointerEvents) || "" : "none"), styles;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((node2) => {
        var _a4;
        return (_a4 = node2.currentAnimation) === null || _a4 === void 0 ? void 0 : _a4.stop();
      }), this.root.nodes.forEach(clearMeasurements), this.root.sharedNodes.clear();
    }
  }, __name(_a3, "ProjectionNode"), _a3;
}
__name(createProjectionNode, "createProjectionNode");
function updateLayout(node2) {
  node2.updateLayout();
}
__name(updateLayout, "updateLayout");
function notifyLayoutUpdate(node2) {
  var _a3;
  const snapshot = ((_a3 = node2.resumeFrom) === null || _a3 === void 0 ? void 0 : _a3.snapshot) || node2.snapshot;
  if (node2.isLead() && node2.layout && snapshot && node2.hasListeners("didUpdate")) {
    const { layoutBox: layout2, measuredBox: measuredLayout } = node2.layout, { animationType } = node2.options, isShared = snapshot.source !== node2.layout.source;
    animationType === "size" ? eachAxis((axis) => {
      const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis], length = calcLength(axisSnapshot);
      axisSnapshot.min = layout2[axis].min, axisSnapshot.max = axisSnapshot.min + length;
    }) : shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout2) && eachAxis((axis) => {
      const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis], length = calcLength(layout2[axis]);
      axisSnapshot.max = axisSnapshot.min + length, node2.relativeTarget && !node2.currentAnimation && (node2.isProjectionDirty = !0, node2.relativeTarget[axis].max = node2.relativeTarget[axis].min + length);
    });
    const layoutDelta = createDelta();
    calcBoxDelta(layoutDelta, layout2, snapshot.layoutBox);
    const visualDelta = createDelta();
    isShared ? calcBoxDelta(visualDelta, node2.applyTransform(measuredLayout, !0), snapshot.measuredBox) : calcBoxDelta(visualDelta, layout2, snapshot.layoutBox);
    const hasLayoutChanged = !isDeltaZero(layoutDelta);
    let hasRelativeTargetChanged = !1;
    if (!node2.resumeFrom) {
      const relativeParent = node2.getClosestProjectingParent();
      if (relativeParent && !relativeParent.resumeFrom) {
        const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
        if (parentSnapshot && parentLayout) {
          const relativeSnapshot = createBox();
          calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
          const relativeLayout = createBox();
          calcRelativePosition(relativeLayout, layout2, parentLayout.layoutBox), boxEqualsRounded(relativeSnapshot, relativeLayout) || (hasRelativeTargetChanged = !0), relativeParent.options.layoutRoot && (node2.relativeTarget = relativeLayout, node2.relativeTargetOrigin = relativeSnapshot, node2.relativeParent = relativeParent);
        }
      }
    }
    node2.notifyListeners("didUpdate", {
      layout: layout2,
      snapshot,
      delta: visualDelta,
      layoutDelta,
      hasLayoutChanged,
      hasRelativeTargetChanged
    });
  } else if (node2.isLead()) {
    const { onExitComplete } = node2.options;
    onExitComplete && onExitComplete();
  }
  node2.options.transition = void 0;
}
__name(notifyLayoutUpdate, "notifyLayoutUpdate");
function propagateDirtyNodes(node2) {
  projectionFrameData.totalNodes++, node2.parent && (node2.isProjecting() || (node2.isProjectionDirty = node2.parent.isProjectionDirty), node2.isSharedProjectionDirty || (node2.isSharedProjectionDirty = !!(node2.isProjectionDirty || node2.parent.isProjectionDirty || node2.parent.isSharedProjectionDirty)), node2.isTransformDirty || (node2.isTransformDirty = node2.parent.isTransformDirty));
}
__name(propagateDirtyNodes, "propagateDirtyNodes");
function cleanDirtyNodes(node2) {
  node2.isProjectionDirty = node2.isSharedProjectionDirty = node2.isTransformDirty = !1;
}
__name(cleanDirtyNodes, "cleanDirtyNodes");
function clearSnapshot(node2) {
  node2.clearSnapshot();
}
__name(clearSnapshot, "clearSnapshot");
function clearMeasurements(node2) {
  node2.clearMeasurements();
}
__name(clearMeasurements, "clearMeasurements");
function clearIsLayoutDirty(node2) {
  node2.isLayoutDirty = !1;
}
__name(clearIsLayoutDirty, "clearIsLayoutDirty");
function resetTransformStyle(node2) {
  const { visualElement } = node2.options;
  visualElement && visualElement.getProps().onBeforeLayoutMeasure && visualElement.notify("BeforeLayoutMeasure"), node2.resetTransform();
}
__name(resetTransformStyle, "resetTransformStyle");
function finishAnimation(node2) {
  node2.finishAnimation(), node2.targetDelta = node2.relativeTarget = node2.target = void 0, node2.isProjectionDirty = !0;
}
__name(finishAnimation, "finishAnimation");
function resolveTargetDelta(node2) {
  node2.resolveTargetDelta();
}
__name(resolveTargetDelta, "resolveTargetDelta");
function calcProjection(node2) {
  node2.calcProjection();
}
__name(calcProjection, "calcProjection");
function resetRotation(node2) {
  node2.resetRotation();
}
__name(resetRotation, "resetRotation");
function removeLeadSnapshots(stack) {
  stack.removeLeadSnapshot();
}
__name(removeLeadSnapshots, "removeLeadSnapshots");
function mixAxisDelta(output, delta, p) {
  output.translate = mix(delta.translate, 0, p), output.scale = mix(delta.scale, 1, p), output.origin = delta.origin, output.originPoint = delta.originPoint;
}
__name(mixAxisDelta, "mixAxisDelta");
function mixAxis(output, from, to, p) {
  output.min = mix(from.min, to.min, p), output.max = mix(from.max, to.max, p);
}
__name(mixAxis, "mixAxis");
function mixBox(output, from, to, p) {
  mixAxis(output.x, from.x, to.x, p), mixAxis(output.y, from.y, to.y, p);
}
__name(mixBox, "mixBox");
function hasOpacityCrossfade(node2) {
  return node2.animationValues && node2.animationValues.opacityExit !== void 0;
}
__name(hasOpacityCrossfade, "hasOpacityCrossfade");
const defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, userAgentContains = /* @__PURE__ */ __name((string2) => typeof navigator < "u" && navigator.userAgent.toLowerCase().includes(string2), "userAgentContains"), roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : noop$4;
function roundAxis(axis) {
  axis.min = roundPoint(axis.min), axis.max = roundPoint(axis.max);
}
__name(roundAxis, "roundAxis");
function roundBox(box) {
  roundAxis(box.x), roundAxis(box.y);
}
__name(roundBox, "roundBox");
function shouldAnimatePositionOnly(animationType, snapshot, layout2) {
  return animationType === "position" || animationType === "preserve-aspect" && !isNear(aspectRatio(snapshot), aspectRatio(layout2), 0.2);
}
__name(shouldAnimatePositionOnly, "shouldAnimatePositionOnly");
const DocumentProjectionNode = createProjectionNode({
  attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), rootProjectionNode = {
  current: void 0
}, HTMLProjectionNode = createProjectionNode({
  measureScroll: (instance) => ({
    x: instance.scrollLeft,
    y: instance.scrollTop
  }),
  defaultParent: () => {
    if (!rootProjectionNode.current) {
      const documentNode = new DocumentProjectionNode({});
      documentNode.mount(window), documentNode.setOptions({ layoutScroll: !0 }), rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: (instance, value) => {
    instance.style.transform = value !== void 0 ? value : "none";
  },
  checkIsScrollRoot: (instance) => window.getComputedStyle(instance).position === "fixed"
}), drag = {
  pan: {
    Feature: PanGesture
  },
  drag: {
    Feature: DragGesture,
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
}, splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
  const match2 = splitCSSVariableRegex.exec(current);
  if (!match2)
    return [,];
  const [, token, fallback] = match2;
  return [token, fallback];
}
__name(parseCSSVariable, "parseCSSVariable");
const maxDepth = 4;
function getVariableValue(current, element2, depth = 1) {
  invariant$1(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
  const [token, fallback] = parseCSSVariable(current);
  if (!token)
    return;
  const resolved = window.getComputedStyle(element2).getPropertyValue(token);
  if (resolved) {
    const trimmed = resolved.trim();
    return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
  } else
    return isCSSVariableToken(fallback) ? getVariableValue(fallback, element2, depth + 1) : fallback;
}
__name(getVariableValue, "getVariableValue");
function resolveCSSVariables(visualElement, { ...target }, transitionEnd) {
  const element2 = visualElement.current;
  if (!(element2 instanceof Element))
    return { target, transitionEnd };
  transitionEnd && (transitionEnd = { ...transitionEnd }), visualElement.values.forEach((value) => {
    const current = value.get();
    if (!isCSSVariableToken(current))
      return;
    const resolved = getVariableValue(current, element2);
    resolved && value.set(resolved);
  });
  for (const key in target) {
    const current = target[key];
    if (!isCSSVariableToken(current))
      continue;
    const resolved = getVariableValue(current, element2);
    resolved && (target[key] = resolved, transitionEnd || (transitionEnd = {}), transitionEnd[key] === void 0 && (transitionEnd[key] = current));
  }
  return { target, transitionEnd };
}
__name(resolveCSSVariables, "resolveCSSVariables");
const positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), isPositionalKey = /* @__PURE__ */ __name((key) => positionalKeys.has(key), "isPositionalKey"), hasPositionalKey = /* @__PURE__ */ __name((target) => Object.keys(target).some(isPositionalKey), "hasPositionalKey"), isNumOrPxType = /* @__PURE__ */ __name((v) => v === number$4 || v === px, "isNumOrPxType"), getPosFromMatrix = /* @__PURE__ */ __name((matrix, pos) => parseFloat(matrix.split(", ")[pos]), "getPosFromMatrix"), getTranslateFromMatrix = /* @__PURE__ */ __name((pos2, pos3) => (_bbox, { transform: transform2 }) => {
  if (transform2 === "none" || !transform2)
    return 0;
  const matrix3d = transform2.match(/^matrix3d\((.+)\)$/);
  if (matrix3d)
    return getPosFromMatrix(matrix3d[1], pos3);
  {
    const matrix = transform2.match(/^matrix\((.+)\)$/);
    return matrix ? getPosFromMatrix(matrix[1], pos2) : 0;
  }
}, "getTranslateFromMatrix"), transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]), nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
  const removedTransforms = [];
  return nonTranslationalTransformKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    value !== void 0 && (removedTransforms.push([key, value.get()]), value.set(key.startsWith("scale") ? 1 : 0));
  }), removedTransforms.length && visualElement.render(), removedTransforms;
}
__name(removeNonTranslationalTransform, "removeNonTranslationalTransform");
const positionalValues = {
  // Dimensions
  width: ({ x: x3 }, { paddingLeft: paddingLeft2 = "0", paddingRight: paddingRight2 = "0" }) => x3.max - x3.min - parseFloat(paddingLeft2) - parseFloat(paddingRight2),
  height: ({ y: y4 }, { paddingTop: paddingTop2 = "0", paddingBottom: paddingBottom2 = "0" }) => y4.max - y4.min - parseFloat(paddingTop2) - parseFloat(paddingBottom2),
  top: (_bbox, { top: top2 }) => parseFloat(top2),
  left: (_bbox, { left: left2 }) => parseFloat(left2),
  bottom: ({ y: y4 }, { top: top2 }) => parseFloat(top2) + (y4.max - y4.min),
  right: ({ x: x3 }, { left: left2 }) => parseFloat(left2) + (x3.max - x3.min),
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
const convertChangedValueTypes = /* @__PURE__ */ __name((target, visualElement, changedKeys) => {
  const originBbox = visualElement.measureViewportBox(), element2 = visualElement.current, elementComputedStyle = getComputedStyle(element2), { display: display2 } = elementComputedStyle, origin = {};
  display2 === "none" && visualElement.setStaticValue("display", target.display || "block"), changedKeys.forEach((key) => {
    origin[key] = positionalValues[key](originBbox, elementComputedStyle);
  }), visualElement.render();
  const targetBbox = visualElement.measureViewportBox();
  return changedKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    value && value.jump(origin[key]), target[key] = positionalValues[key](targetBbox, elementComputedStyle);
  }), target;
}, "convertChangedValueTypes"), checkAndConvertChangedValueTypes = /* @__PURE__ */ __name((visualElement, target, origin = {}, transitionEnd = {}) => {
  target = { ...target }, transitionEnd = { ...transitionEnd };
  const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
  let removedTransformValues = [], hasAttemptedToRemoveTransformValues = !1;
  const changedValueTypeKeys = [];
  if (targetPositionalKeys.forEach((key) => {
    const value = visualElement.getValue(key);
    if (!visualElement.hasValue(key))
      return;
    let from = origin[key], fromType = findDimensionValueType(from);
    const to = target[key];
    let toType;
    if (isKeyframesTarget(to)) {
      const numKeyframes = to.length, fromIndex = to[0] === null ? 1 : 0;
      from = to[fromIndex], fromType = findDimensionValueType(from);
      for (let i2 = fromIndex; i2 < numKeyframes && to[i2] !== null; i2++)
        toType ? invariant$1(findDimensionValueType(to[i2]) === toType, "All keyframes must be of the same type") : (toType = findDimensionValueType(to[i2]), invariant$1(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value"));
    } else
      toType = findDimensionValueType(to);
    if (fromType !== toType)
      if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
        const current = value.get();
        typeof current == "string" && value.set(parseFloat(current)), typeof to == "string" ? target[key] = parseFloat(to) : Array.isArray(to) && toType === px && (target[key] = to.map(parseFloat));
      } else
        fromType != null && fromType.transform && (toType != null && toType.transform) && (from === 0 || to === 0) ? from === 0 ? value.set(toType.transform(from)) : target[key] = fromType.transform(to) : (hasAttemptedToRemoveTransformValues || (removedTransformValues = removeNonTranslationalTransform(visualElement), hasAttemptedToRemoveTransformValues = !0), changedValueTypeKeys.push(key), transitionEnd[key] = transitionEnd[key] !== void 0 ? transitionEnd[key] : target[key], value.jump(to));
  }), changedValueTypeKeys.length) {
    const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null, convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
    return removedTransformValues.length && removedTransformValues.forEach(([key, value]) => {
      visualElement.getValue(key).set(value);
    }), visualElement.render(), isBrowser && scrollY !== null && window.scrollTo({ top: scrollY }), { target: convertedTarget, transitionEnd };
  } else
    return { target, transitionEnd };
}, "checkAndConvertChangedValueTypes");
function unitConversion(visualElement, target, origin, transitionEnd) {
  return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : { target, transitionEnd };
}
__name(unitConversion, "unitConversion");
const parseDomVariant = /* @__PURE__ */ __name((visualElement, target, origin, transitionEnd) => {
  const resolved = resolveCSSVariables(visualElement, target, transitionEnd);
  return target = resolved.target, transitionEnd = resolved.transitionEnd, unitConversion(visualElement, target, origin, transitionEnd);
}, "parseDomVariant"), prefersReducedMotion = { current: null }, hasReducedMotionListener = { current: !1 };
function initPrefersReducedMotion() {
  if (hasReducedMotionListener.current = !0, !!isBrowser)
    if (window.matchMedia) {
      const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)"), setReducedMotionPreferences = /* @__PURE__ */ __name(() => prefersReducedMotion.current = motionMediaQuery.matches, "setReducedMotionPreferences");
      motionMediaQuery.addListener(setReducedMotionPreferences), setReducedMotionPreferences();
    } else
      prefersReducedMotion.current = !1;
}
__name(initPrefersReducedMotion, "initPrefersReducedMotion");
function updateMotionValuesFromProps(element2, next, prev) {
  const { willChange } = next;
  for (const key in next) {
    const nextValue = next[key], prevValue = prev[key];
    if (isMotionValue(nextValue))
      element2.addValue(key, nextValue), isWillChangeMotionValue(willChange) && willChange.add(key), process.env.NODE_ENV === "development" && warnOnce(nextValue.version === "10.18.0", `Attempting to mix Framer Motion versions ${nextValue.version} with 10.18.0 may not work as expected.`);
    else if (isMotionValue(prevValue))
      element2.addValue(key, motionValue(nextValue, { owner: element2 })), isWillChangeMotionValue(willChange) && willChange.remove(key);
    else if (prevValue !== nextValue)
      if (element2.hasValue(key)) {
        const existingValue = element2.getValue(key);
        !existingValue.hasAnimated && existingValue.set(nextValue);
      } else {
        const latestValue = element2.getStaticValue(key);
        element2.addValue(key, motionValue(latestValue !== void 0 ? latestValue : nextValue, { owner: element2 }));
      }
  }
  for (const key in prev)
    next[key] === void 0 && element2.removeValue(key);
  return next;
}
__name(updateMotionValuesFromProps, "updateMotionValuesFromProps");
const visualElementStore = /* @__PURE__ */ new WeakMap(), featureNames = Object.keys(featureDefinitions), numFeatures = featureNames.length, propEventHandlers = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], numVariantProps = variantProps.length, _VisualElement = class _VisualElement {
  constructor({ parent: parent2, props, presenceContext, reducedMotionConfig, visualState }, options = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => frame.render(this.render, !1, !0);
    const { latestValues, renderState } = visualState;
    this.latestValues = latestValues, this.baseTarget = { ...latestValues }, this.initialValues = props.initial ? { ...latestValues } : {}, this.renderState = renderState, this.parent = parent2, this.props = props, this.presenceContext = presenceContext, this.depth = parent2 ? parent2.depth + 1 : 0, this.reducedMotionConfig = reducedMotionConfig, this.options = options, this.isControllingVariants = isControllingVariants(props), this.isVariantNode = isVariantNode(props), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(parent2 && parent2.current);
    const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
    for (const key in initialMotionValues) {
      const value = initialMotionValues[key];
      latestValues[key] !== void 0 && isMotionValue(value) && (value.set(latestValues[key], !1), isWillChangeMotionValue(willChange) && willChange.add(key));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(_props, _prevProps) {
    return {};
  }
  mount(instance) {
    this.current = instance, visualElementStore.set(instance, this), this.projection && !this.projection.instance && this.projection.mount(instance), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((value, key) => this.bindToMotionValue(key, value)), hasReducedMotionListener.current || initPrefersReducedMotion(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : prefersReducedMotion.current, process.env.NODE_ENV !== "production" && warnOnce(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    visualElementStore.delete(this.current), this.projection && this.projection.unmount(), cancelFrame(this.notifyUpdate), cancelFrame(this.render), this.valueSubscriptions.forEach((remove3) => remove3()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const key in this.events)
      this.events[key].clear();
    for (const key in this.features)
      this.features[key].unmount();
    this.current = null;
  }
  bindToMotionValue(key, value) {
    const valueIsTransform = transformProps.has(key), removeOnChange = value.on("change", (latestValue) => {
      this.latestValues[key] = latestValue, this.props.onUpdate && frame.update(this.notifyUpdate, !1, !0), valueIsTransform && this.projection && (this.projection.isTransformDirty = !0);
    }), removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(key, () => {
      removeOnChange(), removeOnRenderRequest();
    });
  }
  sortNodePosition(other) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== other.type ? 0 : this.sortInstanceNodePosition(this.current, other.current);
  }
  loadFeatures({ children, ...renderedProps }, isStrict, preloadedFeatures2, initialLayoutGroupConfig) {
    let ProjectionNodeConstructor, MeasureLayout2;
    if (process.env.NODE_ENV !== "production" && preloadedFeatures2 && isStrict) {
      const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      renderedProps.ignoreStrict ? warning(!1, strictMessage) : invariant$1(!1, strictMessage);
    }
    for (let i2 = 0; i2 < numFeatures; i2++) {
      const name2 = featureNames[i2], { isEnabled, Feature: FeatureConstructor, ProjectionNode, MeasureLayout: MeasureLayoutComponent } = featureDefinitions[name2];
      ProjectionNode && (ProjectionNodeConstructor = ProjectionNode), isEnabled(renderedProps) && (!this.features[name2] && FeatureConstructor && (this.features[name2] = new FeatureConstructor(this)), MeasureLayoutComponent && (MeasureLayout2 = MeasureLayoutComponent));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
      this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
      const { layoutId, layout: layout2, drag: drag2, dragConstraints, layoutScroll, layoutRoot } = renderedProps;
      this.projection.setOptions({
        layoutId,
        layout: layout2,
        alwaysMeasureLayout: !!drag2 || dragConstraints && isRefObject(dragConstraints),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof layout2 == "string" ? layout2 : "both",
        initialPromotionConfig: initialLayoutGroupConfig,
        layoutScroll,
        layoutRoot
      });
    }
    return MeasureLayout2;
  }
  updateFeatures() {
    for (const key in this.features) {
      const feature = this.features[key];
      feature.isMounted ? feature.update() : (feature.mount(), feature.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
  }
  getStaticValue(key) {
    return this.latestValues[key];
  }
  setStaticValue(key, value) {
    this.latestValues[key] = value;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(target, canMutate = !0) {
    return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(props, presenceContext) {
    (props.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = props, this.prevPresenceContext = this.presenceContext, this.presenceContext = presenceContext;
    for (let i2 = 0; i2 < propEventHandlers.length; i2++) {
      const key = propEventHandlers[i2];
      this.propEventSubscriptions[key] && (this.propEventSubscriptions[key](), delete this.propEventSubscriptions[key]);
      const listener = props["on" + key];
      listener && (this.propEventSubscriptions[key] = this.on(key, listener));
    }
    this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(name2) {
    return this.props.variants ? this.props.variants[name2] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(startAtParent = !1) {
    if (startAtParent)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const context2 = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (context2.initial = this.props.initial), context2;
    }
    const context = {};
    for (let i2 = 0; i2 < numVariantProps; i2++) {
      const name2 = variantProps[i2], prop = this.props[name2];
      (isVariantLabel(prop) || prop === !1) && (context[name2] = prop);
    }
    return context;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(child) {
    const closestVariantNode = this.getClosestVariantNode();
    if (closestVariantNode)
      return closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child), () => closestVariantNode.variantChildren.delete(child);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(key, value) {
    value !== this.values.get(key) && (this.removeValue(key), this.bindToMotionValue(key, value)), this.values.set(key, value), this.latestValues[key] = value.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(key) {
    this.values.delete(key);
    const unsubscribe = this.valueSubscriptions.get(key);
    unsubscribe && (unsubscribe(), this.valueSubscriptions.delete(key)), delete this.latestValues[key], this.removeValueFromRenderState(key, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(key) {
    return this.values.has(key);
  }
  getValue(key, defaultValue) {
    if (this.props.values && this.props.values[key])
      return this.props.values[key];
    let value = this.values.get(key);
    return value === void 0 && defaultValue !== void 0 && (value = motionValue(defaultValue, { owner: this }), this.addValue(key, value)), value;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(key) {
    var _a3;
    return this.latestValues[key] !== void 0 || !this.current ? this.latestValues[key] : (_a3 = this.getBaseTargetFromProps(this.props, key)) !== null && _a3 !== void 0 ? _a3 : this.readValueFromInstance(this.current, key, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(key, value) {
    this.baseTarget[key] = value;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(key) {
    var _a3;
    const { initial } = this.props, valueFromInitial = typeof initial == "string" || typeof initial == "object" ? (_a3 = resolveVariantFromProps(this.props, initial)) === null || _a3 === void 0 ? void 0 : _a3[key] : void 0;
    if (initial && valueFromInitial !== void 0)
      return valueFromInitial;
    const target = this.getBaseTargetFromProps(this.props, key);
    return target !== void 0 && !isMotionValue(target) ? target : this.initialValues[key] !== void 0 && valueFromInitial === void 0 ? void 0 : this.baseTarget[key];
  }
  on(eventName, callback) {
    return this.events[eventName] || (this.events[eventName] = new SubscriptionManager()), this.events[eventName].add(callback);
  }
  notify(eventName, ...args) {
    this.events[eventName] && this.events[eventName].notify(...args);
  }
};
__name(_VisualElement, "VisualElement");
let VisualElement = _VisualElement;
const _DOMVisualElement = class _DOMVisualElement extends VisualElement {
  sortInstanceNodePosition(a4, b2) {
    return a4.compareDocumentPosition(b2) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(props, key) {
    return props.style ? props.style[key] : void 0;
  }
  removeValueFromRenderState(key, { vars, style: style2 }) {
    delete vars[key], delete style2[key];
  }
  makeTargetAnimatableFromInstance({ transition: transition2, transitionEnd, ...target }, { transformValues }, isMounted) {
    let origin = getOrigin(target, transition2 || {}, this);
    if (transformValues && (transitionEnd && (transitionEnd = transformValues(transitionEnd)), target && (target = transformValues(target)), origin && (origin = transformValues(origin))), isMounted) {
      checkTargetForNewValues(this, target, origin);
      const parsed = parseDomVariant(this, target, origin, transitionEnd);
      transitionEnd = parsed.transitionEnd, target = parsed.target;
    }
    return {
      transition: transition2,
      transitionEnd,
      ...target
    };
  }
};
__name(_DOMVisualElement, "DOMVisualElement");
let DOMVisualElement = _DOMVisualElement;
function getComputedStyle$1(element2) {
  return window.getComputedStyle(element2);
}
__name(getComputedStyle$1, "getComputedStyle$1");
const _HTMLVisualElement = class _HTMLVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType && defaultType.default || 0;
    } else {
      const computedStyle = getComputedStyle$1(instance), value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
      return typeof value == "string" ? value.trim() : value;
    }
  }
  measureInstanceViewportBox(instance, { transformPagePoint }) {
    return measureViewportBox(instance, transformPagePoint);
  }
  build(renderState, latestValues, options, props) {
    buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
  }
  scrapeMotionValuesFromProps(props, prevProps) {
    return scrapeMotionValuesFromProps$1(props, prevProps);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children } = this.props;
    isMotionValue(children) && (this.childSubscription = children.on("change", (latest) => {
      this.current && (this.current.textContent = `${latest}`);
    }));
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderHTML(instance, renderState, styleProp, projection);
  }
};
__name(_HTMLVisualElement, "HTMLVisualElement");
let HTMLVisualElement = _HTMLVisualElement;
const _SVGVisualElement = class _SVGVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(props, key) {
    return props[key];
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType && defaultType.default || 0;
    }
    return key = camelCaseAttributes.has(key) ? key : camelToDash(key), instance.getAttribute(key);
  }
  measureInstanceViewportBox() {
    return createBox();
  }
  scrapeMotionValuesFromProps(props, prevProps) {
    return scrapeMotionValuesFromProps(props, prevProps);
  }
  build(renderState, latestValues, options, props) {
    buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderSVG(instance, renderState, styleProp, projection);
  }
  mount(instance) {
    this.isSVGTag = isSVGTag(instance.tagName), super.mount(instance);
  }
};
__name(_SVGVisualElement, "SVGVisualElement");
let SVGVisualElement = _SVGVisualElement;
const createDomVisualElement = /* @__PURE__ */ __name((Component2, options) => isSVGComponent(Component2) ? new SVGVisualElement(options, { enableHardwareAcceleration: !1 }) : new HTMLVisualElement(options, { enableHardwareAcceleration: !0 }), "createDomVisualElement"), layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
}, preloadedFeatures = {
  ...animations,
  ...gestureAnimations,
  ...drag,
  ...layout
}, motion = /* @__PURE__ */ createMotionProxy((Component2, config2) => createDomMotionConfig(Component2, config2, preloadedFeatures, createDomVisualElement));
function useIsMounted() {
  const isMounted = useRef(!1);
  return useIsomorphicLayoutEffect(() => (isMounted.current = !0, () => {
    isMounted.current = !1;
  }), []), isMounted;
}
__name(useIsMounted, "useIsMounted");
function useForceUpdate() {
  const isMounted = useIsMounted(), [forcedRenderCount, setForcedRenderCount] = useState(0), forceRender = useCallback(() => {
    isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
  }, [forcedRenderCount]);
  return [useCallback(() => frame.postRender(forceRender), [forceRender]), forcedRenderCount];
}
__name(useForceUpdate, "useForceUpdate");
const _PopChildMeasure = class _PopChildMeasure extends React.Component {
  getSnapshotBeforeUpdate(prevProps) {
    const element2 = this.props.childRef.current;
    if (element2 && prevProps.isPresent && !this.props.isPresent) {
      const size = this.props.sizeRef.current;
      size.height = element2.offsetHeight || 0, size.width = element2.offsetWidth || 0, size.top = element2.offsetTop, size.left = element2.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
};
__name(_PopChildMeasure, "PopChildMeasure");
let PopChildMeasure = _PopChildMeasure;
function PopChild({ children, isPresent }) {
  const id2 = useId(), ref = useRef(null), size = useRef({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return useInsertionEffect(() => {
    const { width: width2, height: height2, top: top2, left: left2 } = size.current;
    if (isPresent || !ref.current || !width2 || !height2)
      return;
    ref.current.dataset.motionPopId = id2;
    const style2 = document.createElement("style");
    return document.head.appendChild(style2), style2.sheet && style2.sheet.insertRule(`
          [data-motion-pop-id="${id2}"] {
            position: absolute !important;
            width: ${width2}px !important;
            height: ${height2}px !important;
            top: ${top2}px !important;
            left: ${left2}px !important;
          }
        `), () => {
      document.head.removeChild(style2);
    };
  }, [isPresent]), React.createElement(PopChildMeasure, { isPresent, childRef: ref, sizeRef: size }, React.cloneElement(children, { ref }));
}
__name(PopChild, "PopChild");
const PresenceChild = /* @__PURE__ */ __name(({ children, initial, isPresent, onExitComplete, custom: custom2, presenceAffectsLayout, mode }) => {
  const presenceChildren = useConstant$1(newChildrenMap), id2 = useId(), context = useMemo(
    () => ({
      id: id2,
      initial,
      isPresent,
      custom: custom2,
      onExitComplete: (childId) => {
        presenceChildren.set(childId, !0);
        for (const isComplete of presenceChildren.values())
          if (!isComplete)
            return;
        onExitComplete && onExitComplete();
      },
      register: (childId) => (presenceChildren.set(childId, !1), () => presenceChildren.delete(childId))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? void 0 : [isPresent]
  );
  return useMemo(() => {
    presenceChildren.forEach((_, key) => presenceChildren.set(key, !1));
  }, [isPresent]), React.useEffect(() => {
    !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
  }, [isPresent]), mode === "popLayout" && (children = React.createElement(PopChild, { isPresent }, children)), React.createElement(PresenceContext.Provider, { value: context }, children);
}, "PresenceChild");
function newChildrenMap() {
  return /* @__PURE__ */ new Map();
}
__name(newChildrenMap, "newChildrenMap");
function useUnmountEffect(callback) {
  return useEffect(() => () => callback(), []);
}
__name(useUnmountEffect, "useUnmountEffect");
const getChildKey = /* @__PURE__ */ __name((child) => child.key || "", "getChildKey");
function updateChildLookup(children, allChildren) {
  children.forEach((child) => {
    const key = getChildKey(child);
    allChildren.set(key, child);
  });
}
__name(updateChildLookup, "updateChildLookup");
function onlyElements(children) {
  const filtered = [];
  return Children.forEach(children, (child) => {
    isValidElement(child) && filtered.push(child);
  }), filtered;
}
__name(onlyElements, "onlyElements");
const AnimatePresence = /* @__PURE__ */ __name(({ children, custom: custom2, initial = !0, onExitComplete, exitBeforeEnter, presenceAffectsLayout = !0, mode = "sync" }) => {
  invariant$1(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
  const forceRender = useContext(LayoutGroupContext).forceRender || useForceUpdate()[0], isMounted = useIsMounted(), filteredChildren = onlyElements(children);
  let childrenToRender = filteredChildren;
  const exitingChildren = useRef(/* @__PURE__ */ new Map()).current, presentChildren = useRef(childrenToRender), allChildren = useRef(/* @__PURE__ */ new Map()).current, isInitialRender = useRef(!0);
  if (useIsomorphicLayoutEffect(() => {
    isInitialRender.current = !1, updateChildLookup(filteredChildren, allChildren), presentChildren.current = childrenToRender;
  }), useUnmountEffect(() => {
    isInitialRender.current = !0, allChildren.clear(), exitingChildren.clear();
  }), isInitialRender.current)
    return React.createElement(React.Fragment, null, childrenToRender.map((child) => React.createElement(PresenceChild, { key: getChildKey(child), isPresent: !0, initial: initial ? void 0 : !1, presenceAffectsLayout, mode }, child)));
  childrenToRender = [...childrenToRender];
  const presentKeys = presentChildren.current.map(getChildKey), targetKeys = filteredChildren.map(getChildKey), numPresent = presentKeys.length;
  for (let i2 = 0; i2 < numPresent; i2++) {
    const key = presentKeys[i2];
    targetKeys.indexOf(key) === -1 && !exitingChildren.has(key) && exitingChildren.set(key, void 0);
  }
  return mode === "wait" && exitingChildren.size && (childrenToRender = []), exitingChildren.forEach((component, key) => {
    if (targetKeys.indexOf(key) !== -1)
      return;
    const child = allChildren.get(key);
    if (!child)
      return;
    const insertionIndex = presentKeys.indexOf(key);
    let exitingComponent = component;
    if (!exitingComponent) {
      const onExit = /* @__PURE__ */ __name(() => {
        exitingChildren.delete(key);
        const leftOverKeys = Array.from(allChildren.keys()).filter((childKey) => !targetKeys.includes(childKey));
        if (leftOverKeys.forEach((leftOverKey) => allChildren.delete(leftOverKey)), presentChildren.current = filteredChildren.filter((presentChild) => {
          const presentChildKey = getChildKey(presentChild);
          return (
            // filter out the node exiting
            presentChildKey === key || // filter out the leftover children
            leftOverKeys.includes(presentChildKey)
          );
        }), !exitingChildren.size) {
          if (isMounted.current === !1)
            return;
          forceRender(), onExitComplete && onExitComplete();
        }
      }, "onExit");
      exitingComponent = React.createElement(PresenceChild, { key: getChildKey(child), isPresent: !1, onExitComplete: onExit, custom: custom2, presenceAffectsLayout, mode }, child), exitingChildren.set(key, exitingComponent);
    }
    childrenToRender.splice(insertionIndex, 0, exitingComponent);
  }), childrenToRender = childrenToRender.map((child) => {
    const key = child.key;
    return exitingChildren.has(key) ? child : React.createElement(PresenceChild, { key: getChildKey(child), isPresent: !0, presenceAffectsLayout, mode }, child);
  }), process.env.NODE_ENV !== "production" && mode === "wait" && childrenToRender.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), React.createElement(React.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child) => cloneElement(child)));
}, "AnimatePresence");
function Paper({
  children,
  footer: footer2,
  title,
  subtitle,
  fluid,
  disabled,
  disabledText,
  titleSide,
  ...boxProps
}) {
  return /* @__PURE__ */ jsxs(
    Box,
    {
      borderRadius: "sm",
      maxWidth: 1372,
      border: "1px solid",
      borderColor: "neutral-200",
      backgroundColor: "white",
      ...disabled && { cursor: "not-allowed" },
      ...boxProps,
      children: [
        /* @__PURE__ */ jsxs(GridLayout, { w: "100%", rowGap: "m", columnGap: { _: "m", md: "l" }, p: "m", children: [
          title && /* @__PURE__ */ jsx(GridItem, { xs: 12, gridRow: 1, children: /* @__PURE__ */ jsxs(Spacer, { alignItems: "center", space: "xs", children: [
            /* @__PURE__ */ jsxs(
              Typography,
              {
                variant: "headingBoldS",
                "data-test": "paper-title",
                mb: subtitle ? "-8px" : 0,
                display: "flex",
                color: disabled ? "neutral-300" : "neutral-1000",
                children: [
                  title,
                  disabled && disabledText ? /* @__PURE__ */ jsxs(Flex, { alignItems: "center", ml: 34, children: [
                    /* @__PURE__ */ jsx(LockedFilled, { color: "neutral-400", size: 16 }),
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        fontSize: 14,
                        ml: 10,
                        color: "neutral-400",
                        fontWeight: 500,
                        children: disabledText
                      }
                    )
                  ] }) : null
                ]
              }
            ),
            titleSide && /* @__PURE__ */ jsx(Box, { children: titleSide })
          ] }) }),
          subtitle && /* @__PURE__ */ jsx(GridItem, { xs: 12, lg: 8, gridRow: 2, children: /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "bodyMediumS",
              "data-test": "paper-subtitle",
              color: disabled ? "secondary-100" : "neutral-1000",
              children: subtitle
            }
          ) }),
          /* @__PURE__ */ jsx(GridItem, { xs: 12, lg: fluid ? 12 : 8, children })
        ] }),
        footer2
      ]
    }
  );
}
__name(Paper, "Paper");
function Loader(props) {
  return /* @__PURE__ */ jsx(
    Icon,
    {
      "data-test": "loader",
      spin: !0,
      component: LoadingRedoUndoOutlined,
      ...props
    }
  );
}
__name(Loader, "Loader");
function Loading({
  "data-test": dataTest = "loading",
  size = 40,
  color: color2 = "primary-500",
  ...flexProps
}) {
  return /* @__PURE__ */ jsx(
    Flex,
    {
      "data-test": dataTest,
      w: "100%",
      h: "100%",
      alignItems: "center",
      justifyContent: "center",
      ...flexProps,
      children: /* @__PURE__ */ jsx(Loader, { color: color2, size })
    }
  );
}
__name(Loading, "Loading");
const SaveButtonStatus = {
  UNSAVED: "unsaved",
  SAVING: "saving",
  SAVED: "saved"
}, AnimatedButton = styled(Button$1)`
  transition: 0.5s all ease-in-out;
`;
function SaveButton({
  mode = "fill",
  status,
  unsavedText = "Save changes",
  savedText = "Saved",
  "data-test": dataTest = "save-button",
  ...rest
}) {
  const buttonContent = useMemo(
    () => ({
      unsaved: unsavedText,
      saving: /* @__PURE__ */ jsx(
        Loading,
        {
          "data-test": `${dataTest}-saving-icon`,
          size: 24,
          color: mode === "fill" ? "neutral-0" : "primary-500"
        }
      ),
      saved: savedText
    }),
    [unsavedText, dataTest, mode, savedText]
  ), buttonMode = useMemo(() => mode === "fill" ? status === SaveButtonStatus.SAVED ? "outline" : "fill" : mode, [mode, status]);
  return /* @__PURE__ */ jsxs(
    AnimatedButton,
    {
      "data-test": dataTest,
      mode: buttonMode,
      readOnly: status !== SaveButtonStatus.UNSAVED,
      ...rest,
      children: [
        status === SaveButtonStatus.SAVED && /* @__PURE__ */ jsx(TickOutlined, {}),
        buttonContent[status]
      ]
    }
  );
}
__name(SaveButton, "SaveButton");
const SaveBarContainerContext = createContext({
  containerElement: null
});
function SaveBarProvider({
  portalContainerRef,
  children
}) {
  const [containerElement, setContainerElement] = useState(null), memoizedContainerElement = useMemo(
    () => ({ containerElement }),
    [containerElement]
  );
  return useEffect(() => {
    setContainerElement(portalContainerRef.current);
  }, [portalContainerRef]), /* @__PURE__ */ jsx(SaveBarContainerContext.Provider, { value: memoizedContainerElement, children });
}
__name(SaveBarProvider, "SaveBarProvider");
const useNavigationBlocker = /* @__PURE__ */ __name(() => {
  const blockerContext = useContext(NavigationBlockerContext);
  return blockerContext || (console.error(
    "useNavigationBlocker must be used within a <NavigationBlockerProvider>"
  ), {});
}, "useNavigationBlocker");
function useBlocker(when = !0) {
  const { setBlockedTransition } = useNavigationBlocker(), navigationContext = useContext(
    UNSAFE_NavigationContext
  );
  useEffect(() => {
    var _a3, _b;
    if (!when || !setBlockedTransition)
      return noop$5;
    const unblock = (_b = (_a3 = navigationContext.navigator).block) == null ? void 0 : _b.call(_a3, (tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock(), tx.retry();
        }
      };
      setBlockedTransition(autoUnblockingTx);
    });
    return unblock;
  }, [when, navigationContext, setBlockedTransition]);
}
__name(useBlocker, "useBlocker");
function customShowToast(toast) {
  toasts.showToast({
    ...toast,
    message: toast.message,
    dismissIn: toast.dismissIn ?? TOAST_DEFAULT_DISMISS_IN_MILLISECONDS,
    variant: toast.variant ?? "info",
    icon: toast.icon ?? !0
  });
}
__name(customShowToast, "customShowToast");
function useToast() {
  return useMemo(
    () => ({
      remove: toasts.removeToast,
      show: customShowToast
    }),
    []
  );
}
__name(useToast, "useToast");
function useCancellableLazyQuery(query, options) {
  const client = useApolloClient(), toast = useToast(), [loading, setLoading] = useState(!0), [data2, setData] = useState(), [error, setError] = useState(null), subscriptionRef = useRef(), cancel = useCallback(() => {
    subscriptionRef.current && (subscriptionRef.current.unsubscribe(), subscriptionRef.current = void 0, setLoading(!1));
  }, []), lazyQuery = useCallback(() => {
    const sub = client.watchQuery({
      query,
      ...options
    }).subscribe({
      next(x3) {
        cancel(), setError(null), setData(x3.data);
      },
      error(err) {
        setLoading(!1), cancel();
        const clientError = handleApolloError(err);
        setError(clientError), setData(void 0), options != null && options.showErrorToast && toast.show({
          variant: "critical",
          message: options.showErrorToast(clientError.errorI18nKey)
        });
      }
    });
    subscriptionRef.current = sub;
  }, [cancel, client, options, query, toast]);
  return useEffect(
    () => () => {
      cancel();
    },
    [cancel]
  ), {
    loading,
    data: data2,
    error,
    lazyQuery,
    cancel
  };
}
__name(useCancellableLazyQuery, "useCancellableLazyQuery");
const useCombinedRefs = /* @__PURE__ */ __name((...refs) => useCallback(
  (element2) => refs.forEach((ref) => {
    if (ref) {
      if (typeof ref == "function") {
        ref(element2);
        return;
      }
      ref.current = element2;
    }
  }),
  [refs]
), "useCombinedRefs"), Container$5 = styled(Box)`
  grid-area: header;
`, CloseButton = styled(Button$1)`
  position: absolute;
  right: ${getSpace$1("s")};
`;
function FormWizardHeaderTitle({
  "data-test": dataTest = "form-wizard-header-title",
  children,
  className
}) {
  return /* @__PURE__ */ jsx(
    Typography,
    {
      "data-test": dataTest,
      variant: "headingBoldS",
      className,
      children
    }
  );
}
__name(FormWizardHeaderTitle, "FormWizardHeaderTitle");
function FormWizardHeaderClose({
  "data-test": dataTest = "form-wizard-header-close",
  onClick: onClick2,
  children,
  className
}) {
  const { onClose } = useFormWizard();
  return /* @__PURE__ */ jsxs(
    CloseButton,
    {
      "data-test": dataTest,
      variant: "secondary",
      mode: "ghost",
      onClick: onClick2 || onClose,
      className,
      children: [
        children,
        /* @__PURE__ */ jsx(CloseCircleOutlined, {})
      ]
    }
  );
}
__name(FormWizardHeaderClose, "FormWizardHeaderClose");
function FormWizardHeader({
  "data-test": dataTest = "form-wizard-header",
  children,
  className
}) {
  return /* @__PURE__ */ jsxs(Container$5, { "data-test": dataTest, h: "72px", bg: "white", className, children: [
    /* @__PURE__ */ jsx(
      Flex,
      {
        backgroundColor: "white",
        h: "100%",
        alignItems: "center",
        justifyContent: "center",
        children
      }
    ),
    /* @__PURE__ */ jsx(
      Divider,
      {
        orientation: "horizontal",
        size: "xSmall",
        backgroundColor: "neutral-200"
      }
    )
  ] });
}
__name(FormWizardHeader, "FormWizardHeader");
const Container$4 = styled(Flex)`
  position: relative;
  flex-direction: column;
  margin: ${getSpace$1("xl")} 0 50vh;
  background: white;
  border-radius: ${getRadii("sm")};
`;
function FormWizardPage({
  children,
  "data-test": dataTest = "form-wizard-page",
  loading = !1,
  className,
  ...flexProps
}) {
  return loading ? /* @__PURE__ */ jsx(Loading, { "data-test": `${dataTest}-loading` }) : /* @__PURE__ */ jsx(Container$4, { "data-test": dataTest, className, ...flexProps, children });
}
__name(FormWizardPage, "FormWizardPage");
function FormWizardPageContent({
  "data-test": dataTest = "form-wizard-page-content",
  children,
  className
}) {
  return /* @__PURE__ */ jsx(Flex, { "data-test": dataTest, padding: "xl", className, children });
}
__name(FormWizardPageContent, "FormWizardPageContent");
function FormWizardPageFooter({
  "data-test": dataTest = "form-wizard-page-footer",
  children,
  className
}) {
  return /* @__PURE__ */ jsxs(Flex, { "data-test": dataTest, flexDirection: "column", className, children: [
    /* @__PURE__ */ jsx(
      Divider,
      {
        orientation: "horizontal",
        size: "xSmall",
        backgroundColor: "neutral-200"
      }
    ),
    /* @__PURE__ */ jsx(Flex, { gap: "s", p: "s", px: "xl", justifyContent: "flex-end", children })
  ] });
}
__name(FormWizardPageFooter, "FormWizardPageFooter");
function LoadingButton({
  children,
  loading = !1,
  loadingText = "Loading",
  "data-test": dataTest = "loading-button",
  disabled = !1,
  ...buttonProps
}) {
  return /* @__PURE__ */ jsx(
    Button$1,
    {
      "data-test": dataTest,
      ...buttonProps,
      disabled: disabled || loading,
      children: loading ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Loader, { "data-test": `${dataTest}-loader`, size: 24 }),
        loadingText
      ] }) : children
    }
  );
}
__name(LoadingButton, "LoadingButton");
function FormWizardPageFooterNext({
  "data-test": dataTest = "form-wizard-page-footer-next",
  children,
  onClick: onClick2,
  loading = !1,
  ...restProps
}) {
  return /* @__PURE__ */ jsx(
    LoadingButton,
    {
      "data-test": dataTest,
      variant: "primary",
      mode: "fill",
      onClick: onClick2,
      loading,
      ...restProps,
      children
    }
  );
}
__name(FormWizardPageFooterNext, "FormWizardPageFooterNext");
function FormWizardPageFooterPrev({
  children,
  onClick: onClick2,
  "data-test": dataTest = "form-wizard-page-footer-prev",
  className,
  ...buttonProps
}) {
  return /* @__PURE__ */ jsx(
    Button$1,
    {
      "data-test": dataTest,
      variant: "secondary",
      mode: "ghost",
      onClick: onClick2,
      className,
      ...buttonProps,
      children
    }
  );
}
__name(FormWizardPageFooterPrev, "FormWizardPageFooterPrev");
function FormWizardPageHeaderSubtitle({
  children,
  className
}) {
  return /* @__PURE__ */ jsx(
    Typography,
    {
      variant: "bodyRegularS",
      color: "neutral-400",
      className,
      children
    }
  );
}
__name(FormWizardPageHeaderSubtitle, "FormWizardPageHeaderSubtitle");
function FormWizardPageHeaderTitle({
  children,
  className
}) {
  return /* @__PURE__ */ jsx(Typography, { variant: "headingBoldM", className, children });
}
__name(FormWizardPageHeaderTitle, "FormWizardPageHeaderTitle");
function FormWizardPageHeader({
  "data-test": dataTest = "form-wizard-page-header",
  children,
  className
}) {
  return /* @__PURE__ */ jsx(
    Gap,
    {
      padding: "xl",
      pb: "0",
      "data-test": dataTest,
      flexDirection: "column",
      gap: "xxs",
      className,
      children
    }
  );
}
__name(FormWizardPageHeader, "FormWizardPageHeader");
function FormWizardSide() {
  const ref = useRef(null), { setSideRef, hasSide } = useFormWizard();
  return useEffect(() => {
    setSideRef(ref);
  }, [ref, setSideRef]), /* @__PURE__ */ jsx(Box, { ref, display: hasSide ? "block" : "none" });
}
__name(FormWizardSide, "FormWizardSide");
const Number$1 = styled(Flex)`
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: white;
  border-radius: ${getRadii("sm")};
  flex-shrink: 0;
`;
function NumberLink({ marginRight: marginRight2 }) {
  return /* @__PURE__ */ jsxs(Flex, { flexDirection: "column", gap: "3px", marginRight: marginRight2, children: [
    /* @__PURE__ */ jsx(Flex, { backgroundColor: "neutral-500", w: "1px", h: "3px", borderRadius: "1px" }),
    /* @__PURE__ */ jsx(Flex, { backgroundColor: "neutral-500", w: "1px", h: "5px", borderRadius: "1px" }),
    /* @__PURE__ */ jsx(Flex, { backgroundColor: "neutral-500", w: "1px", h: "5px", borderRadius: "1px" }),
    /* @__PURE__ */ jsx(Flex, { backgroundColor: "neutral-500", w: "1px", h: "3px", borderRadius: "1px" })
  ] });
}
__name(NumberLink, "NumberLink");
function FormWizardStepper() {
  const { pageIndex, hasStepper, stepTitles } = useFormWizard();
  if (!hasStepper)
    return null;
  const list2 = stepTitles.map((title, i2) => {
    const isActive = i2 === pageIndex, isDone = i2 < pageIndex, isNext = i2 > pageIndex;
    return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
      i2 > 0 && /* @__PURE__ */ jsx(NumberLink, { marginRight: "11px" }),
      /* @__PURE__ */ jsxs(Flex, { alignItems: "center", justifyContent: "center", gap: "xxs", children: [
        isDone && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "bodyRegularS",
              color: "primary-500",
              textAlign: "right",
              children: title
            }
          ),
          /* @__PURE__ */ jsx(
            Number$1,
            {
              backgroundColor: "white",
              border: "1px solid",
              borderColor: "primary-500",
              children: /* @__PURE__ */ jsx(TickOutlined, { color: "primary-500", size: "18px" })
            }
          )
        ] }),
        isActive && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "bodyMediumS", textAlign: "right", children: title }),
          /* @__PURE__ */ jsx(
            Number$1,
            {
              backgroundColor: "primary-500",
              border: "1px solid",
              borderColor: "primary-500",
              children: /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", color: "white", children: i2 + 1 })
            }
          )
        ] }),
        isNext && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "bodyRegularS",
              color: "neutral-400",
              textAlign: "right",
              children: title
            }
          ),
          /* @__PURE__ */ jsx(
            Number$1,
            {
              backgroundColor: "white",
              border: "1px solid",
              borderColor: "neutral-400",
              children: /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", color: "neutral-400", children: i2 + 1 })
            }
          )
        ] })
      ] })
    ] }, title);
  });
  return /* @__PURE__ */ jsx(
    Flex,
    {
      w: "200px",
      marginTop: "xl",
      flexDirection: "column",
      alignItems: "flex-end",
      userSelect: "none",
      children: list2
    }
  );
}
__name(FormWizardStepper, "FormWizardStepper");
const PreventBodyScroll = createGlobalStyle`
  body {
    overflow: hidden;
  }
`, Container$3 = styled(Flex)`
  align-items: flex-start;
  justify-content: center;
  grid-area: page;
  overflow: auto;
  gap: ${getSpace$1("m")};
`;
function FormWizardPages({
  "data-test": dataTest = "form-wizard-pages",
  children,
  className,
  ...flexProps
}) {
  const { pageIndex, setNumberOfPages, setStepTitles } = useFormWizard(), numberOfPages = Children.count(children), childrenArr = Children.toArray(children), stepTitles = useMemo(() => {
    const titles = Children.map(children, (child) => !child || !isValidElement(child) ? null : child.props.stepTitle);
    return titles ? titles.filter(isTruthy) : [];
  }, [children]);
  useEffect(() => {
    setStepTitles(stepTitles);
  }, [setStepTitles, stepTitles]), useEffect(() => {
    setNumberOfPages(numberOfPages);
  }, [numberOfPages, setNumberOfPages]);
  const page = childrenArr[pageIndex];
  return /* @__PURE__ */ jsxs(Container$3, { "data-test": dataTest, className, ...flexProps, children: [
    /* @__PURE__ */ jsx(PreventBodyScroll, {}),
    /* @__PURE__ */ jsx(FormWizardStepper, {}),
    page,
    /* @__PURE__ */ jsx(FormWizardSide, {})
  ] });
}
__name(FormWizardPages, "FormWizardPages");
function FormWizardPageSubtext({
  children,
  className
}) {
  return /* @__PURE__ */ jsx(
    Typography,
    {
      variant: "bodyRegularS",
      color: "neutral-400",
      position: "absolute",
      bottom: "-30px",
      className,
      children
    }
  );
}
__name(FormWizardPageSubtext, "FormWizardPageSubtext");
function FormWizardSideRegister({
  children
}) {
  const { sideRef, setHasSide } = useFormWizard();
  return useEffect(() => {
    setHasSide(!0);
  }, [setHasSide]), sideRef != null && sideRef.current ? createPortal(children, sideRef.current) : null;
}
__name(FormWizardSideRegister, "FormWizardSideRegister");
function FormWizardStepperRegister() {
  const { setHasStepper } = useFormWizard();
  return useEffect(() => (setHasStepper(!0), () => setHasStepper(!1)), [setHasStepper]), null;
}
__name(FormWizardStepperRegister, "FormWizardStepperRegister");
const FormWizardContext = createContext(void 0), Container$2 = styled(Flex)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: grid;
  background: ${getColor$2("neutral-100")};
  grid-template-areas:
    "header"
    "page";
  grid-template-rows: auto 1fr;
`;
function FormWizard({
  children,
  onSuccess = noop$5,
  onClose = noop$5,
  onCancel = noop$5,
  "data-test": dataTest = "form-wizard",
  initialData = {},
  currentPageIndex = 0,
  className
}) {
  const [pageIndex, setPageIndex] = useState(currentPageIndex), [data2, setData] = useState(initialData), [numberOfPages, setNumberOfPages] = useState(0), [nextDisabled, setNextDisabled] = useState(!1), [hasStepper, setHasStepper] = useState(!1), [stepTitles, setStepTitles] = useState([]), [hasSide, setHasSide] = useState(!1), [sideRef, setSideRef] = useState(null);
  useEffect(() => {
    setPageIndex(currentPageIndex);
  }, [currentPageIndex]);
  const navigateToNextPage = useCallback(() => {
    if (pageIndex === numberOfPages - 1) {
      onSuccess(data2);
      return;
    }
    setPageIndex((index2) => index2 + 1);
  }, [data2, numberOfPages, onSuccess, pageIndex]), editData = useCallback((newData) => {
    setData((prevData) => ({ ...prevData, ...newData }));
  }, []), context = useMemo(
    () => ({
      data: data2,
      pageIndex,
      numberOfPages,
      setNumberOfPages,
      hasStepper,
      setHasStepper,
      sideRef,
      setSideRef,
      hasSide,
      setHasSide,
      stepTitles,
      setStepTitles,
      setData,
      editData,
      navigateToNextPage,
      navigateToPrevPage: () => {
        setPageIndex((index2) => index2 >= 1 ? index2 - 1 : 0);
      },
      onCancel,
      onClose,
      setPageIndex,
      nextDisabled,
      setNextDisabled
    }),
    [
      data2,
      pageIndex,
      numberOfPages,
      hasStepper,
      sideRef,
      hasSide,
      stepTitles,
      editData,
      navigateToNextPage,
      onCancel,
      onClose,
      nextDisabled
    ]
  );
  return /* @__PURE__ */ jsx(FormWizardContext.Provider, { value: context, children: /* @__PURE__ */ jsx(Container$2, { "data-test": dataTest, className, children }) });
}
__name(FormWizard, "FormWizard");
FormWizard.Stepper = FormWizardStepperRegister;
FormWizard.Header = FormWizardHeader;
FormWizard.HeaderTitle = FormWizardHeaderTitle;
FormWizard.HeaderClose = FormWizardHeaderClose;
FormWizard.Pages = FormWizardPages;
FormWizard.Page = FormWizardPage;
FormWizard.PageContent = FormWizardPageContent;
FormWizard.PageFooter = FormWizardPageFooter;
FormWizard.PageFooterPrev = FormWizardPageFooterPrev;
FormWizard.PageFooterNext = FormWizardPageFooterNext;
FormWizard.PageHeader = FormWizardPageHeader;
FormWizard.PageHeaderTitle = FormWizardPageHeaderTitle;
FormWizard.PageHeaderSubtitle = FormWizardPageHeaderSubtitle;
FormWizard.PageSubText = FormWizardPageSubtext;
FormWizard.Side = FormWizardSideRegister;
function useFormWizard() {
  const context = useContext(FormWizardContext);
  if (!context)
    throw new Error(
      "useFormWizard should be used within a FormWizard provider"
    );
  return context;
}
__name(useFormWizard, "useFormWizard");
const useGraphLazyQuery = /* @__PURE__ */ __name((query, options) => {
  const [queryFunction, { error, ...queryResult }] = useLazyQuery(
    query,
    options
  );
  return [
    useCallback(
      async (opts) => {
        try {
          const { data: data2, error: _error } = await queryFunction(opts);
          if (!data2)
            throw new ApolloError({ graphQLErrors: [] });
          return { data: data2, error: void 0 };
        } catch (e3) {
          return {
            data: void 0,
            error: handleApolloError(e3).errorI18nKey
          };
        }
      },
      [queryFunction]
    ),
    {
      ...queryResult,
      error: error ? handleApolloError(error) : void 0
    }
  ];
}, "useGraphLazyQuery"), useGraphMutation = /* @__PURE__ */ __name((mutation, options) => {
  const toast = useToast(), [mutate, mutationResult] = useMutation(mutation, options), customMutate = useCallback(
    async (mutateOptions, feedbackOptions = {}) => {
      const { successMessage, getErrorMessage } = feedbackOptions;
      try {
        const { data: data2 } = await mutate(mutateOptions);
        if (!data2)
          throw new ApolloError({ graphQLErrors: [] });
        return successMessage != null && successMessage.length && toast.show({
          variant: "success",
          message: successMessage,
          dismissIn: (options == null ? void 0 : options.successMessageTimeout) || TOAST_DEFAULT_DISMISS_IN_MILLISECONDS
        }), {
          data: data2,
          error: void 0,
          validationErrors: void 0,
          clientError: void 0,
          apolloError: void 0
        };
      } catch (e3) {
        const apolloError = e3, clientError2 = handleApolloError(apolloError), validationClientError = clientError2, _getErrorMessage = getErrorMessage ?? (options == null ? void 0 : options.showErrorToast) ?? (options == null ? void 0 : options.getErrorMessage);
        return _getErrorMessage && toast.show({
          variant: "critical",
          message: _getErrorMessage(clientError2.errorI18nKey)
        }), {
          data: void 0,
          error: clientError2.errorI18nKey,
          validationErrors: validationClientError.validationErrorsI18nKeys,
          clientError: clientError2,
          apolloError
        };
      }
    },
    [mutate, options, toast]
  );
  useEffect(() => {
    mutationResult.error && console.error(mutationResult.error);
  }, [mutationResult.error]);
  const clientError = mutationResult.error ? handleApolloError(mutationResult.error) : void 0;
  return [
    customMutate,
    {
      ...mutationResult,
      clientError
    }
  ];
}, "useGraphMutation"), _AtomicErrorBuilder = class _AtomicErrorBuilder extends AtomicError {
  constructor(error) {
    super(error.message);
    __publicField(this, "actualError");
    this.actualError = error;
  }
  withMessage(message) {
    return this.message = message, this;
  }
  withInfo(info) {
    return this.extraInfo = info, this;
  }
  build() {
    return this.actualError.setMessage(this.message), this.actualError.setExtraInfo(this.extraInfo), this.actualError;
  }
};
__name(_AtomicErrorBuilder, "AtomicErrorBuilder");
let AtomicErrorBuilder = _AtomicErrorBuilder;
const _AtomicErrorFactory = class _AtomicErrorFactory {
  static create(typeOf3) {
    switch (typeOf3) {
      case ERROR_TYPES.NOT_FOUND:
        return new NotFoundError(
          ERROR_TYPES_DEFAULT_MESSAGES[ERROR_TYPES.NOT_FOUND]
        );
      case ERROR_TYPES.GATEWAY_TIMEOUT:
        return new GatewayTimeoutError(
          ERROR_TYPES_DEFAULT_MESSAGES[ERROR_TYPES.GATEWAY_TIMEOUT]
        );
      case ERROR_TYPES.TOO_MANY_REQUESTS:
        return new TooManyRequestsError(
          ERROR_TYPES_DEFAULT_MESSAGES[ERROR_TYPES.TOO_MANY_REQUESTS]
        );
      case ERROR_TYPES.UNAUTHORIZED:
        return new UnauthorizedError(
          ERROR_TYPES_DEFAULT_MESSAGES[ERROR_TYPES.UNAUTHORIZED]
        );
      case ERROR_TYPES.NETWORK:
        return new NetworkError(
          ERROR_TYPES_DEFAULT_MESSAGES[ERROR_TYPES.NETWORK]
        );
      case ERROR_TYPES.VALIDATION:
        return new ValidationError(
          ERROR_TYPES_DEFAULT_MESSAGES[ERROR_TYPES.VALIDATION]
        );
      case ERROR_TYPES.INVALID_DATA:
        return new InvalidError(
          ERROR_TYPES_DEFAULT_MESSAGES[ERROR_TYPES.INVALID_DATA]
        );
      default:
        return new UnknownError(
          ERROR_TYPES_DEFAULT_MESSAGES[ERROR_TYPES.UNKNOWN]
        );
    }
  }
};
__name(_AtomicErrorFactory, "AtomicErrorFactory");
let AtomicErrorFactory = _AtomicErrorFactory;
function useGraphQuery(query, options) {
  const toast = useToast(), { throwError = !0 } = options ?? {}, { error, data: data2, previousData, ...rest } = useQuery(query, options);
  let clientError;
  if (error && (clientError = handleApolloError(error), throwError))
    throw new AtomicErrorBuilder(
      AtomicErrorFactory.create(clientError.type)
    ).withMessage(clientError.message).withInfo({
      options,
      apolloError: error
    }).build();
  return useEffect(() => {
    clientError && (options != null && options.showErrorToast) && toast.show({
      variant: "critical",
      message: options.showErrorToast(clientError.errorI18nKey)
    });
  }, [error, toast, options == null ? void 0 : options.showErrorToast, options, clientError]), {
    error: clientError,
    data: data2,
    previousData,
    staleData: data2 ?? previousData,
    ...rest
  };
}
__name(useGraphQuery, "useGraphQuery");
function useThrottledCallback(callback, wait, deps) {
  const lastCall = useRef(null), timeout = useRef(null), clear = useCallback(() => {
    timeout.current && clearTimeout(timeout.current);
  }, []), throttledCallback = useCallback(
    (...args) => {
      clear();
      const now2 = /* @__PURE__ */ new Date(), elapsedTime = lastCall.current ? now2.getTime() - lastCall.current.getTime() : wait;
      elapsedTime >= wait ? (callback(...args), lastCall.current = now2) : timeout.current = window.setTimeout(() => {
        callback(...args), lastCall.current = /* @__PURE__ */ new Date();
      }, wait - elapsedTime);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...deps, callback, wait, clear]
  );
  return useEffect(() => () => clear(), [clear]), [throttledCallback, clear];
}
__name(useThrottledCallback, "useThrottledCallback");
function useInfiniteLoader({
  containerRef,
  threshold: threshold2,
  onLoad,
  skip
}) {
  var _a3;
  const prevScrollTop = useRef(((_a3 = containerRef == null ? void 0 : containerRef.current) == null ? void 0 : _a3.scrollTop) || 0), [scrollAtBottom, setScrollAtBottom] = useState(!1), [handleScroll] = useThrottledCallback(
    () => {
      const element2 = containerRef == null ? void 0 : containerRef.current;
      if (!element2)
        return;
      const isPastThreshold = element2.scrollHeight - element2.clientHeight - element2.scrollTop - threshold2 <= 0;
      element2.scrollTop > prevScrollTop.current && isPastThreshold && !skip ? (setScrollAtBottom(!0), onLoad()) : setScrollAtBottom(!1), prevScrollTop.current = element2.scrollTop;
    },
    500,
    [containerRef, threshold2, skip, onLoad]
  );
  return useLayoutEffect(() => {
    const element2 = containerRef == null ? void 0 : containerRef.current;
    return element2 == null || element2.addEventListener("scroll", handleScroll), () => {
      element2 == null || element2.removeEventListener("scroll", handleScroll);
    };
  }), { scrollAtBottom };
}
__name(useInfiniteLoader, "useInfiniteLoader");
function useGraphQueryPaginated({
  query,
  queryOptions,
  paginationOptions
}) {
  const {
    checkHasMore,
    onFetchMore,
    containerRef,
    threshold: threshold2 = 1500
  } = paginationOptions, variables = useMemo(
    () => queryOptions.variables,
    // We use JSON.stringify to deep compare the variables
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(queryOptions.variables)]
  );
  if (!variables)
    throw new Error("You must provide variables to useGraphQueryPaginated");
  const [loadingMore, setLoadingMore] = useState(!1), { loading, fetchMore, data: data2, ...rest } = useGraphQuery(query, {
    ...queryOptions,
    notifyOnNetworkStatusChange: !0,
    variables
  }), currentVariables = useRef(variables), hasMore = data2 ? checkHasMore(data2, currentVariables.current) : !1;
  useEffect(() => {
    variables && (currentVariables.current = variables);
  }, [variables]);
  const loadMore = useCallback(async () => {
    if (!hasMore || !data2)
      return;
    setLoadingMore(!0);
    const newVariables = onFetchMore(data2, currentVariables.current);
    currentVariables.current = {
      ...variables,
      ...newVariables
    }, await fetchMore({
      variables: newVariables
    }), setLoadingMore(!1);
  }, [data2, fetchMore, hasMore, onFetchMore, variables]), { scrollAtBottom } = useInfiniteLoader({
    containerRef,
    threshold: threshold2,
    skip: loading,
    onLoad: loadMore
  });
  return {
    data: data2,
    loading,
    loadMore,
    hasMore,
    loadingMore,
    scrollAtBottom,
    ...rest,
    variables: currentVariables.current
  };
}
__name(useGraphQueryPaginated, "useGraphQueryPaginated");
const ResourceContext = createContext(void 0);
function Resource({ name: name2, children }) {
  return /* @__PURE__ */ jsx(ResourceContext.Provider, { value: name2, children });
}
__name(Resource, "Resource");
function useResource(routesResourcesMapping = {}) {
  const location = useLocation();
  return useContext(ResourceContext) || getResourceFromPath(location.pathname, routesResourcesMapping);
}
__name(useResource, "useResource");
const PermissionsContext = createContext(
  {}
);
function PermissionsProvider({
  children,
  token
}) {
  const value = useMemo(() => {
    const decodedToken = decodeToken(token), { "custom:permissions": customPermissions } = decodedToken, dashboardResources = [
      RESOURCE.NUMBERS,
      RESOURCE.TEAMS,
      RESOURCE.USERS,
      RESOURCE.STATS,
      RESOURCE.ACTIVITY_FEED,
      RESOURCE.CALL_SETTINGS,
      RESOURCE.INTEGRATIONS,
      RESOURCE.COMPANY_GENERAL,
      RESOURCE.COMPANY_PLAN,
      RESOURCE.COMPANY_BILLING,
      RESOURCE.COMPANY_SECURITY,
      RESOURCE.COMPANY_ROLES
    ], hasDashboardAccess = Object.keys(customPermissions).some(
      (p) => dashboardResources.includes(p)
    );
    return {
      permissions: customPermissions,
      // The user has access to the dashboard if he has any of the dashboard permissions
      hasDashboardAccess,
      token
    };
  }, [token]);
  return /* @__PURE__ */ jsx(PermissionsContext.Provider, { value, children: typeof children == "function" ? children(value) : children });
}
__name(PermissionsProvider, "PermissionsProvider");
function usePermissions() {
  const permissionsContext = useContext(PermissionsContext), resource = useResource(), checkAccess = useCallback(
    (action, _resource) => {
      const actualResource = _resource || resource;
      if (!actualResource)
        throw new Error("No resource found.");
      const permissions = permissionsContext.permissions[actualResource];
      return permissions ? permissions.includes(action) : !1;
    },
    [permissionsContext.permissions, resource]
  );
  return {
    ...permissionsContext,
    resource,
    checkAccess
  };
}
__name(usePermissions, "usePermissions");
function useHasAccess(actions, _resource) {
  const { checkAccess } = usePermissions();
  return actions.map(
    (action) => checkAccess(action, _resource)
  );
}
__name(useHasAccess, "useHasAccess");
function useImperativeQuery(options) {
  const client = useApolloClient();
  return useCallback(
    async (variables) => {
      try {
        return { result: await client.query({
          ...options,
          variables
        }), error: void 0 };
      } catch (e3) {
        return { result: void 0, error: handleApolloError(e3).errorI18nKey };
      }
    },
    [client, options]
  );
}
__name(useImperativeQuery, "useImperativeQuery");
function useIntersection({
  targetRef,
  root: root2,
  margin: margin2 = 100,
  onIntersect
}) {
  const [isIntersecting, setIsIntersecting] = useState(!1);
  return useEffect(() => {
    if (!targetRef.current)
      return noop$6;
    function handleIntersection(entries) {
      entries.some((entry) => entry.isIntersecting) && (onIntersect == null || onIntersect(), setIsIntersecting(!0));
    }
    __name(handleIntersection, "handleIntersection");
    const observer = new IntersectionObserver(handleIntersection, {
      root: root2,
      rootMargin: `${margin2}px`
    });
    return observer.observe(targetRef.current), () => {
      observer.disconnect();
    };
  }, [onIntersect, root2, margin2, targetRef]), isIntersecting;
}
__name(useIntersection, "useIntersection");
const WHITE = "#ffffff", BLACK = "#000000";
function luminance(r2, g, b2) {
  const luminances = [r2, g, b2].map((v) => {
    const value = v / 255;
    return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  }), [redLuminance, greenLuminance, blueLuminance] = luminances;
  return redLuminance * 0.2126 + greenLuminance * 0.7152 + blueLuminance * 0.0722;
}
__name(luminance, "luminance");
const FALLBACK_RGB_COLOR = [0, 179, 136], FALLBACK_COLOR = "#00b388";
function useLuminance({
  color: color2,
  threshold: threshold2
}) {
  const transformedColor = useMemo(() => hexToRgb(color2), [color2]), rgbColor = useMemo(
    () => transformedColor ?? FALLBACK_RGB_COLOR,
    [transformedColor]
  ), whiteRgb = useMemo(() => hexToRgb(WHITE), []), tagLuminance = useMemo(
    () => luminance(rgbColor[0], rgbColor[1], rgbColor[2]),
    [rgbColor]
  ), whiteLuminance = useMemo(
    () => luminance(whiteRgb[0], whiteRgb[1], whiteRgb[2]),
    [whiteRgb]
  );
  return {
    textColor: useMemo(
      () => tagLuminance > whiteLuminance ? (whiteLuminance + 0.05) / (tagLuminance + 0.05) : (tagLuminance + 0.05) / (whiteLuminance + 0.05),
      [tagLuminance, whiteLuminance]
    ) < threshold2 ? WHITE : BLACK,
    bgColor: transformedColor ? color2 : FALLBACK_COLOR
  };
}
__name(useLuminance, "useLuminance");
function useLoadMore({
  query,
  queryOptions,
  getTotal
}) {
  const variables = useMemo(
    () => ({
      from: 0,
      limit: 50,
      ...queryOptions == null ? void 0 : queryOptions.variables
    }),
    [queryOptions == null ? void 0 : queryOptions.variables]
  ), innerQueryOptions = {
    ...queryOptions,
    notifyOnNetworkStatusChange: !0,
    variables
  }, currentFrom = useRef(variables.from), { loading, fetchMore, data: data2, ...rest } = useGraphQuery(query, innerQueryOptions), total = getTotal(data2), hasMore = currentFrom.current + variables.limit < total, loadMore = useCallback(async () => {
    if (!hasMore)
      return;
    const newFrom = currentFrom.current + variables.limit;
    await fetchMore({
      variables: { ...variables, from: newFrom }
    }), currentFrom.current = newFrom;
  }, [fetchMore, hasMore, variables]);
  return useEffect(() => {
    currentFrom.current = 0;
  }, [variables.filter]), {
    data: data2,
    loading,
    loadMore,
    hasMore,
    ...rest
  };
}
__name(useLoadMore, "useLoadMore");
function useMutableRef(initialValue, onSet, onGet) {
  const onSetRef = useRef(onSet), onGetRef = useRef(onGet);
  return useMemo(() => {
    let v = initialValue;
    return {
      get current() {
        return onGetRef.current === void 0 ? v : onGetRef.current(v);
      },
      set current(val) {
        v = onSetRef.current === void 0 ? val : onSetRef.current(val);
      }
    };
  }, []);
}
__name(useMutableRef, "useMutableRef");
function useMeasureElement() {
  const [element2, setElement] = useState(null), elementRef = useMutableRef(null, (v) => (setElement(v), v)), [rect, setRect] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }), observer = useMemo(
    () => new window.ResizeObserver(([entry]) => {
      entry && requestAnimationFrame(() => {
        setRect(entry.contentRect);
      });
    }),
    []
  );
  return useLayoutEffect(() => {
    if (element2)
      return observer.observe(element2), () => {
        observer.disconnect();
      };
  }, [element2, observer]), [elementRef, rect];
}
__name(useMeasureElement, "useMeasureElement");
const navigation = /* @__PURE__ */ __name((nav) => (route, params, options = {}) => nav(routeReplacer(route, params), options), "navigation");
function useNavigateWithParamsReplace() {
  const navigate = useNavigate();
  return useMemo(() => navigation(navigate), [navigate]);
}
__name(useNavigateWithParamsReplace, "useNavigateWithParamsReplace");
function useStateDelay(initialValue) {
  const timer = useRef(), [value, setValue] = useState(initialValue), _setValue = useCallback(
    (newValue, delay2, newValueAfterDelay) => {
      setValue(newValue), delay2 !== void 0 && newValueAfterDelay !== void 0 && (timer.current = window.setTimeout(() => {
        setValue(newValueAfterDelay);
      }, delay2));
    },
    []
  );
  return useEffect(() => () => clearTimeout(timer.current), []), [value, _setValue];
}
__name(useStateDelay, "useStateDelay");
function useToggle(isOpen = !1) {
  const [open, setOpenState] = useState(isOpen), toggle = useCallback(() => setOpenState((s4) => !s4), []), setOpen = useCallback(() => setOpenState(!0), []), setClose = useCallback(() => setOpenState(!1), []);
  return [open, toggle, setOpen, setClose];
}
__name(useToggle, "useToggle");
const useCloseOnScroll = /* @__PURE__ */ __name(({
  eleRef,
  innerScrollRef,
  open,
  onClose
}) => {
  const onScroll = useCallback(
    (scrollEvent) => {
      innerScrollRef != null && innerScrollRef.current && !innerScrollRef.current.contains(scrollEvent.target) && onClose();
    },
    [onClose, innerScrollRef]
  ), outerScrollableRef = useRef();
  return useEffect(() => {
    if (outerScrollableRef.current = getScrollableParent(eleRef.current), !open)
      return noop$5;
    const isBody = outerScrollableRef.current === document.body, element2 = isBody ? window : outerScrollableRef.current;
    return element2.addEventListener("scroll", onScroll), isBody || window.addEventListener("scroll", onScroll), () => {
      element2.removeEventListener("scroll", onScroll), isBody || window.removeEventListener("scroll", onScroll);
    };
  }, [eleRef, onScroll, open, outerScrollableRef]), { outerScrollableEle: outerScrollableRef.current };
}, "useCloseOnScroll");
function useFromRoute(route) {
  const { state } = useLocation();
  return (state == null ? void 0 : state.from) === route;
}
__name(useFromRoute, "useFromRoute");
const useResizeObserver = /* @__PURE__ */ __name(({
  ref,
  onResize
}) => {
  useEffect(() => {
    const element2 = ref == null ? void 0 : ref.current;
    if (!element2)
      return noop$5;
    if (typeof window.ResizeObserver > "u")
      return window.addEventListener("resize", onResize), () => {
        window.removeEventListener("resize", onResize);
      };
    const resizeObserverInstance = new window.ResizeObserver(
      (entries) => {
        entries.length && requestAnimationFrame(() => {
          onResize();
        });
      }
    );
    return resizeObserverInstance.observe(element2), () => {
      resizeObserverInstance.unobserve(element2);
    };
  }, [onResize, ref]);
}, "useResizeObserver"), useLayoutPosition = /* @__PURE__ */ __name((ref) => {
  const [boundingRect, setBoundingRect] = useState(), updateLayoutPosition = useCallback(() => {
    var _a3;
    const rect = (_a3 = ref.current) == null ? void 0 : _a3.getBoundingClientRect();
    setBoundingRect(rect);
  }, [ref]);
  useLayoutEffect(() => {
    updateLayoutPosition();
  }, [updateLayoutPosition]);
  const onResize = useCallback(
    () => window.requestAnimationFrame(updateLayoutPosition),
    [updateLayoutPosition]
  );
  return useResizeObserver({ ref, onResize }), {
    boundingRect,
    updateLayoutPosition
  };
}, "useLayoutPosition"), formatObjectToSearchParams = /* @__PURE__ */ __name((searchObject) => new URLSearchParams(searchObject), "formatObjectToSearchParams"), formatSearchParamsToObject = /* @__PURE__ */ __name((searchParams) => searchParams ? Object.fromEntries(searchParams) : {}, "formatSearchParamsToObject"), removeEmptyEntriesFromObject = /* @__PURE__ */ __name((searchObject) => {
  const newSearchObject = searchObject;
  return Object.keys(newSearchObject).forEach(
    (k3) => !newSearchObject[k3] && searchObject[k3] !== void 0 && delete newSearchObject[k3]
  ), newSearchObject;
}, "removeEmptyEntriesFromObject"), copyURLSearchParamsWithoutKeys = /* @__PURE__ */ __name((searchParams, keys2) => {
  const newSearchParams = new URLSearchParams(searchParams.toString());
  return keys2.forEach((key) => newSearchParams.delete(key)), newSearchParams;
}, "copyURLSearchParamsWithoutKeys"), areSearchParamsEqual = /* @__PURE__ */ __name((searchParamsA, searchParamsB) => searchParamsA.toString() === searchParamsB.toString(), "areSearchParamsEqual"), getSearchParamsSize = /* @__PURE__ */ __name((searchParams) => Array.from(searchParams.keys()).length, "getSearchParamsSize"), mergeSearchParams = /* @__PURE__ */ __name((a4, b2) => new URLSearchParams({
  ...Object.fromEntries(a4),
  ...Object.fromEntries(b2)
}), "mergeSearchParams");
function PersistedSearchParams({
  children
}) {
  const location = useLocation(), { persistedSearchParams } = usePersistedSearchParams(), navigate = useNavigate();
  return useEffect(
    () => {
      if (getSearchParamsSize(persistedSearchParams) && !location.search) {
        const redirectUrl = `${location.pathname}?${persistedSearchParams.toString()}`;
        navigate(redirectUrl);
      }
    },
    // On every route change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname]
  ), children || /* @__PURE__ */ jsx(Outlet, {});
}
__name(PersistedSearchParams, "PersistedSearchParams");
const PERSIST_SEARCH_PARAMS_KEY = "PERSIST_SEARCH_PARAMS";
function usePersistedSearchParams() {
  const { pathname } = useLocation(), [localStorageParams, setLocalStorageParams] = useLocalStorage(PERSIST_SEARCH_PARAMS_KEY, {}), [searchParams, setSearchParams] = useSearchParams(), localStorageSearchParams = useMemo(
    () => formatObjectToSearchParams(localStorageParams[pathname]),
    [localStorageParams, pathname]
  ), persistedSearchParams = useMemo(() => {
    const merged = new URLSearchParams(localStorageSearchParams);
    return searchParams.forEach((value, key) => {
      localStorageSearchParams.has(key) && merged.set(key, value);
    }), merged;
  }, [localStorageSearchParams, searchParams]), setPersistedSearchParams = useCallback(
    (updateFn, navigate = !0) => {
      const prevPersistedSearchParamsObj = formatSearchParamsToObject(
        persistedSearchParams
      ), newPersistedSearchParamsObj = updateFn(
        prevPersistedSearchParamsObj
      );
      if (setLocalStorageParams((prev) => ({
        ...prev,
        [pathname]: newPersistedSearchParamsObj
      })), navigate) {
        const newSearchParams = new URLSearchParams({
          ...formatSearchParamsToObject(searchParams),
          ...newPersistedSearchParamsObj
        });
        setSearchParams(newSearchParams);
      }
    },
    [
      pathname,
      persistedSearchParams,
      searchParams,
      setLocalStorageParams,
      setSearchParams
    ]
  ), deletePersistedSearchParams = useCallback(
    (keys2) => {
      const keysToDelete = Array.isArray(keys2) ? keys2 : [keys2], newLocationLocalStorageParams = omit$1(
        localStorageParams[pathname],
        keysToDelete
      );
      setLocalStorageParams({
        ...localStorageParams,
        [pathname]: newLocationLocalStorageParams
      });
      const sParams = copyURLSearchParamsWithoutKeys(
        searchParams,
        keysToDelete
      ), newSearchParams = new URLSearchParams({
        ...formatSearchParamsToObject(sParams),
        ...newLocationLocalStorageParams
      });
      setSearchParams(newSearchParams);
    },
    [
      localStorageParams,
      pathname,
      searchParams,
      setLocalStorageParams,
      setSearchParams
    ]
  ), deleteAllPersistedSearchParams = useCallback(() => {
    const keys2 = Array.from(localStorageSearchParams.keys());
    deletePersistedSearchParams(keys2);
  }, [deletePersistedSearchParams, localStorageSearchParams]);
  return {
    searchParams,
    persistedSearchParams,
    setPersistedSearchParams,
    deletePersistedSearchParams,
    deleteAllPersistedSearchParams
  };
}
__name(usePersistedSearchParams, "usePersistedSearchParams");
var LINE_TYPE_VALUES = /* @__PURE__ */ ((LINE_TYPE_VALUES2) => (LINE_TYPE_VALUES2.IVR = "IVR", LINE_TYPE_VALUES2.CLASSIC = "Classic", LINE_TYPE_VALUES2.SMARTFLOW = "Smartflow", LINE_TYPE_VALUES2.SMS = "SMS", LINE_TYPE_VALUES2.MMS = "MMS", LINE_TYPE_VALUES2.WA_MSG = "Wa_msg", LINE_TYPE_VALUES2))(LINE_TYPE_VALUES || {}), AVAILABILITY_FILTER_VALUES = /* @__PURE__ */ ((AVAILABILITY_FILTER_VALUES2) => (AVAILABILITY_FILTER_VALUES2.AVAILABLE = "Available", AVAILABILITY_FILTER_VALUES2.OFFLINE = "Offline", AVAILABILITY_FILTER_VALUES2.PENDING_VALIDATION = "Pending Validation", AVAILABILITY_FILTER_VALUES2))(AVAILABILITY_FILTER_VALUES || {}), LIST_VIEW_PARAMS = /* @__PURE__ */ ((LIST_VIEW_PARAMS2) => (LIST_VIEW_PARAMS2.TEAMS = "teams", LIST_VIEW_PARAMS2.SEARCH = "search", LIST_VIEW_PARAMS2.ROLES = "roles", LIST_VIEW_PARAMS2.OWNER = "owner", LIST_VIEW_PARAMS2.AVAILABILITY = "availability", LIST_VIEW_PARAMS2.COUNTRY = "country", LIST_VIEW_PARAMS2.LINE_TYPE = "type", LIST_VIEW_PARAMS2.LINE_STATUS = "status", LIST_VIEW_PARAMS2.SORT_DIRECTION = "direction", LIST_VIEW_PARAMS2.SORT_FIELD = "field", LIST_VIEW_PARAMS2.ASSIGNED_LICENSES = "assigned_licenses", LIST_VIEW_PARAMS2))(LIST_VIEW_PARAMS || {}), LineStatus = /* @__PURE__ */ ((LineStatus2) => (LineStatus2.ACTION_NEEDED = "ACTION_NEEDED", LineStatus2.ALWAYS_CLOSED = "ALWAYS_CLOSED", LineStatus2.ALWAYS_OPENED = "ALWAYS_OPENED", LineStatus2.CLOSED = "CLOSED", LineStatus2.OPENED = "OPENED", LineStatus2))(LineStatus || {});
function useListViewFilters({
  debounceTimeout = 500,
  onSet
} = {}) {
  const {
    searchParams,
    setPersistedSearchParams,
    deletePersistedSearchParams
  } = usePersistedSearchParams();
  function parse2(filter2, value) {
    let parsedValue = value;
    switch (filter2) {
      case LIST_VIEW_PARAMS.COUNTRY:
      case LIST_VIEW_PARAMS.TEAMS:
      case LIST_VIEW_PARAMS.ASSIGNED_LICENSES:
        parsedValue = value.split(",");
        break;
      case LIST_VIEW_PARAMS.SORT_DIRECTION:
        parsedValue = value.toUpperCase();
        break;
      case LIST_VIEW_PARAMS.LINE_STATUS:
        parsedValue = value.toUpperCase().split(",");
        break;
      case LIST_VIEW_PARAMS.ROLES:
      case LIST_VIEW_PARAMS.AVAILABILITY:
        parsedValue = value.split(",").map((role) => capitalizeFirstLetter(role));
        break;
      case LIST_VIEW_PARAMS.LINE_TYPE: {
        parsedValue = value.split(",").map((v) => [
          LINE_TYPE_VALUES.SMS.toLowerCase(),
          LINE_TYPE_VALUES.MMS.toLowerCase(),
          LINE_TYPE_VALUES.IVR.toLowerCase()
        ].includes(v) ? v.toUpperCase() : capitalizeFirstLetter(v));
        break;
      }
      default:
        parsedValue = value;
        break;
    }
    return parsedValue;
  }
  __name(parse2, "parse");
  function serialize2(filter2, value) {
    let res;
    return Array.isArray(value) ? res = value.join(",") : res = value, [LIST_VIEW_PARAMS.SEARCH, LIST_VIEW_PARAMS.SORT_FIELD].includes(filter2) ? res : res.toLowerCase();
  }
  __name(serialize2, "serialize");
  const set3 = useCallback(
    (filter2, value) => {
      const valueSerialized = serialize2(filter2, value);
      valueSerialized === "" ? deletePersistedSearchParams(filter2) : setPersistedSearchParams((prevParams) => ({
        ...prevParams,
        [filter2]: valueSerialized
      })), onSet == null || onSet(filter2, valueSerialized);
    },
    [deletePersistedSearchParams, onSet, setPersistedSearchParams]
  ), setDebounced = useMemo(
    () => debounce$2(set3, debounceTimeout),
    [debounceTimeout, set3]
  ), setMultiple = useCallback(
    (filtersValues) => {
      const newSearchParams = Object.entries(filtersValues).reduce(
        (acc, [_filter, value]) => {
          const filter2 = _filter, valueSerialized = serialize2(
            filter2,
            value
          );
          return valueSerialized === "" && deletePersistedSearchParams(filter2), onSet == null || onSet(filter2, valueSerialized), {
            ...acc,
            ...valueSerialized && { [filter2]: valueSerialized }
          };
        },
        {}
      );
      setPersistedSearchParams(() => newSearchParams);
    },
    [deletePersistedSearchParams, onSet, setPersistedSearchParams]
  ), get3 = useCallback(
    (filter2, defaultValue = null) => {
      const value = searchParams.get(filter2);
      return value ? parse2(filter2, value) : defaultValue || null;
    },
    [searchParams]
  );
  return { set: set3, setDebounced, setMultiple, get: get3 };
}
__name(useListViewFilters, "useListViewFilters");
function usePageVisibility({
  onHiddenDelay = 0,
  onVisibleDelay = 0
} = {}) {
  const [isVisible, setVisible] = useState(!0), timeoutRef = useRef(null), handleVisibilityChange = useCallback(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    const visible = document.visibilityState === "visible";
    timeoutRef.current = window.setTimeout(
      () => {
        setVisible(visible);
      },
      visible ? onVisibleDelay : onHiddenDelay
    );
  }, [onHiddenDelay, onVisibleDelay]);
  return useEffect(() => (document.addEventListener("visibilitychange", handleVisibilityChange), () => {
    timeoutRef.current && clearTimeout(timeoutRef.current), document.removeEventListener("visibilitychange", handleVisibilityChange);
  }), [handleVisibilityChange]), { isVisible };
}
__name(usePageVisibility, "usePageVisibility");
function useQueryParams() {
  const navigate = useNavigate(), { pathname, search: search3 } = useLocation(), searchParams = useMemo(() => new URLSearchParams(search3), [search3]), setSearchParams = useCallback(
    (urlParams) => {
      urlParams && urlParams.toString() !== "" ? navigate(`${pathname}?${urlParams.toString()}`, { replace: !0 }) : navigate(`${pathname}`, { replace: !0 });
    },
    [navigate, pathname]
  );
  return { searchParams, setSearchParams };
}
__name(useQueryParams, "useQueryParams");
const SAVE_DELAY_TIME = 5e3, MAX_ROWS = 5;
function useSearchHistory({
  name: name2,
  search: search3,
  maxRows = MAX_ROWS,
  saveDelayTime = SAVE_DELAY_TIME
}) {
  const timerIdRef = useRef(), localStorageField = useMemo(() => `${name2}-history`, [name2]), [recentSearches, setRencentSearches] = useLocalStorage(
    localStorageField,
    []
  ), addSearchTerm = useCallback(
    (searchStr) => {
      setRencentSearches((prevSearches) => {
        let updatedHistory = prevSearches;
        const duplicateIndex = prevSearches.indexOf(searchStr);
        return duplicateIndex >= 0 ? updatedHistory = [
          searchStr,
          ...prevSearches.slice(0, duplicateIndex),
          ...prevSearches.slice(duplicateIndex + 1, prevSearches.length)
        ] : updatedHistory.unshift(searchStr), updatedHistory.length > maxRows && updatedHistory.pop(), updatedHistory;
      });
    },
    [maxRows, setRencentSearches]
  ), addSearch = useCallback(
    (searchStr) => {
      timerIdRef.current && clearTimeout(timerIdRef.current), addSearchTerm(searchStr);
    },
    [addSearchTerm]
  ), clearAllSearch = useCallback(() => {
    setRencentSearches([]);
  }, [setRencentSearches]);
  return useEffect(() => search3 ? (timerIdRef.current && clearTimeout(timerIdRef.current), timerIdRef.current = window.setTimeout(() => {
    addSearchTerm(search3);
  }, saveDelayTime), () => {
    clearTimeout(timerIdRef.current);
  }) : noop$5, [addSearch, addSearchTerm, saveDelayTime, search3]), {
    recentSearches,
    addSearch,
    clearAllSearch
  };
}
__name(useSearchHistory, "useSearchHistory");
function manageFunnelId(sessionStorageKey, getFunnelIdSearchParam, deleteFunnelIdSearchParam) {
  function setAndReturnNewFunnelId() {
    const funnelId = generateRandomUUID();
    return sessionStorage.setItem(sessionStorageKey, funnelId), funnelId;
  }
  __name(setAndReturnNewFunnelId, "setAndReturnNewFunnelId");
  function getExistingOrNewFunnelId() {
    const existingFunnelId = sessionStorage.getItem(sessionStorageKey) ?? (getFunnelIdSearchParam == null ? void 0 : getFunnelIdSearchParam());
    return existingFunnelId || setAndReturnNewFunnelId();
  }
  __name(getExistingOrNewFunnelId, "getExistingOrNewFunnelId");
  function deleteFunnelId() {
    sessionStorage.removeItem(sessionStorageKey), deleteFunnelIdSearchParam == null || deleteFunnelIdSearchParam();
  }
  return __name(deleteFunnelId, "deleteFunnelId"), {
    setAndReturnNewFunnelId,
    getExistingOrNewFunnelId,
    deleteFunnelId
  };
}
__name(manageFunnelId, "manageFunnelId");
const FUNNEL_ID_SESSION_STORAGE$1 = "addon_subscription_funnel_id", FUNNEL_ID_SEARCH_PARAM = "id", ADD_ON_SUBSCRIPTION_FUNNEL_STARTED_EVENT = "add_on_subscription_funnel_started", ADD_ON_SUBSCRIPTION_FUNNEL_TRIAL_INITIALIZED_EVENT = "add_on_subscription_funnel_trial_initialized", ADD_ON_SUBSCRIPTION_FUNNEL_TRIAL_COMPLETED_EVENT = "add_on_subscription_funnel_trial_completed", ADD_ON_SUBSCRIPTION_FUNNEL_REQUEST_QUOTE_COMPLETED_EVENT = "add_on_subscription_funnel_request_quote_completed", ADD_ON_SUBSCRIPTION_FUNNEL_REQUEST_QUOTE_CLICKED_EVENT = "add_on_subscription_funnel_request_quote_clicked", ADD_ON_SUBSCRIPTION_FUNNEL_LEARN_MORE_CLICKED_EVENT = "add_on_subscription_funnel_learn_more_clicked", ADD_ON_SUBSCRIPTION_FUNNEL_BLOCKED_EVENT = "add_on_subscription_funnel_blocked", ADD_ON_SUBSCRIPTION_FUNNEL_UPGRADE_CLICKED_EVENT = "add_on_subscription_funnel_upgrade_clicked", SELF_ADD_ON_SUBSCRIPTION_FUNNEL_STARTED_EVENT = "self_add_on_subscription_funnel_started", SELF_ADD_ON_SUBSCRIPTION_FUNNEL_REQUEST_QUOTE_CLICKED_EVENT = "self_add_on_subscription_funnel_request_quote_clicked", SELF_ADD_ON_SUBSCRIPTION_FUNNEL_REQUEST_QUOTE_NOW_COMPLETED_EVENT = "self_add_on_subscription_funnel_request_quote_now_completed", SELF_ADD_ON_SUBSCRIPTION_FUNNEL_SUBSCRIBE_NOW_CLICKED_EVENT = "self_add_on_subscription_funnel_subscribe_now_clicked", SELF_ADD_ON_SUBSCRIPTION_REQUEST_FEATURE_CLICKED_EVENT = "self_add_on_subscription_request_feature_clicked", SELF_ADD_ON_SUBSCRIPTION_TRY_IT_FOR_FREE_CLICKED_EVENT = "self_add_on_subscription_try_it_for_free_clicked", SELF_ADD_ON_SUBSCRIPTION_MAYBE_LATER_CLICKED_EVENT = "self_add_on_subscription_maybe_later_clicked", SELF_ADD_ON_SUBSCRIPTION_LAUNCH_TRIAL_NOW_COMPLETED_EVENT = "self_add_on_subscription_launch_trial_now_completed", SELF_ADD_ON_SUBSCRIPTION_SUBSCRIBE_TO_ADD_ON_COMPLETED_EVENT = "self_add_on_subscription_subscribe_to_add_on_completed", SELF_ADD_ON_SUBSCRIPTION_START_USING_CLICKED_EVENT = "self_add_on_subscription_start_using_clicked", SELF_ADD_ON_SUBSCRIPTION_GO_TO_COURSE_CLICKED_EVENT = "self_add_on_subscription_go_to_course_clicked", SELF_ADD_ON_SUBSCRIPTION_BACK_CLICKED_EVENT = "self_add_on_subscription_back_clicked", SELF_ADD_ON_SUBSCRIPTION_FUNNEL_RETURN_TO_DASHBOARD_CLICKED_EVENT = "self_add_on_subscription_funnel_return_to_dashboard_clicked", SELF_ADD_ON_SUBSCRIPTION_FUNNEL_CLOSE_CLICKED_EVENT = "self_add_on_subscription_funnel_close_clicked", SELF_ADD_ON_SUBSCRIPTION_FUNNEL_UPGRADE_NOW_CLICKED_EVENT = "self_add_on_subscription_funnel_upgrade_now_clicked", SELF_ADD_ON_SUBSCRIPTION_FUNNEL_PLANS_CLICKED_EVENT = "self_add_on_subscription_funnel_plans_clicked", SELF_ADD_ON_SUBSCRIPTION_START_FREE_TRIAL_COMPLETED_EVENT = "self_add_on_subscription_start_free_trial_completed";
function useTrackAddonSubscriptionFunnel(track) {
  const location = useLocation(), [searchParams, setSearchParams] = useSearchParams(), getFunnelIdSearchParam = /* @__PURE__ */ __name(() => searchParams.get(FUNNEL_ID_SEARCH_PARAM), "getFunnelIdSearchParam"), deleteFunnelIdSearchParam = /* @__PURE__ */ __name(() => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete(FUNNEL_ID_SEARCH_PARAM), setSearchParams(newSearchParams);
  }, "deleteFunnelIdSearchParam"), { setAndReturnNewFunnelId, getExistingOrNewFunnelId, deleteFunnelId } = manageFunnelId(
    FUNNEL_ID_SESSION_STORAGE$1,
    getFunnelIdSearchParam,
    deleteFunnelIdSearchParam
  ), trackAddonSubscriptionFunnelStarted = useCallback(
    (payload) => {
      track(
        ADD_ON_SUBSCRIPTION_FUNNEL_STARTED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: setAndReturnNewFunnelId(),
          pagePath: location.pathname
        })
      );
    },
    [location.pathname, setAndReturnNewFunnelId, track]
  ), trackAddonTrialInitialized = useCallback(
    (payload) => {
      track(
        ADD_ON_SUBSCRIPTION_FUNNEL_TRIAL_INITIALIZED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonTrialCompleted = useCallback(
    (payload) => {
      track(
        ADD_ON_SUBSCRIPTION_FUNNEL_TRIAL_COMPLETED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      ), deleteFunnelId();
    },
    [deleteFunnelId, getExistingOrNewFunnelId, track]
  ), trackAddonRequestQuoteCompleted = useCallback(
    (payload) => {
      track(
        ADD_ON_SUBSCRIPTION_FUNNEL_REQUEST_QUOTE_COMPLETED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      ), deleteFunnelId();
    },
    [deleteFunnelId, getExistingOrNewFunnelId, track]
  ), trackAddonRequestQuoteClicked = useCallback(
    (payload) => {
      track(
        ADD_ON_SUBSCRIPTION_FUNNEL_REQUEST_QUOTE_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonUpgradeClicked = useCallback(
    (payload) => {
      track(
        ADD_ON_SUBSCRIPTION_FUNNEL_UPGRADE_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      ), deleteFunnelId();
    },
    [deleteFunnelId, getExistingOrNewFunnelId, track]
  ), trackAddonLearnMoreClicked = useCallback(
    (payload) => {
      track(
        ADD_ON_SUBSCRIPTION_FUNNEL_LEARN_MORE_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload
        })
      );
    },
    [track]
  ), trackAddonSubscriptionFunnelBlocked = useCallback(
    (payload) => {
      track(
        ADD_ON_SUBSCRIPTION_FUNNEL_BLOCKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      ), deleteFunnelId();
    },
    [deleteFunnelId, getExistingOrNewFunnelId, track]
  ), trackAddonSelfSubscriptionFunnelStarted = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_FUNNEL_STARTED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionRequestQuoteClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_FUNNEL_REQUEST_QUOTE_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionRequestQuoteNowCompleted = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_FUNNEL_REQUEST_QUOTE_NOW_COMPLETED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionSubscribeNowClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_FUNNEL_SUBSCRIBE_NOW_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionRequestFeatureClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_REQUEST_FEATURE_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionTryItForFreeClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_TRY_IT_FOR_FREE_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionMaybeLaterClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_MAYBE_LATER_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionLaunchTrialNowCompleted = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_LAUNCH_TRIAL_NOW_COMPLETED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionSubscribeToAddonCompleted = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_SUBSCRIBE_TO_ADD_ON_COMPLETED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionStartUsingClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_START_USING_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionGoToCourseClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_GO_TO_COURSE_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionBackClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_BACK_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionReturnToDashboardClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_FUNNEL_RETURN_TO_DASHBOARD_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionCloseClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_FUNNEL_CLOSE_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionUpgradeNowClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_FUNNEL_UPGRADE_NOW_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSubscriptionPlansClicked = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_FUNNEL_PLANS_CLICKED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddonSelfSubscriptionStartFreeTrialCompleted = useCallback(
    (payload) => {
      track(
        SELF_ADD_ON_SUBSCRIPTION_START_FREE_TRIAL_COMPLETED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  );
  return useMemo(
    () => ({
      trackAddonSubscriptionFunnelStarted,
      trackAddonTrialInitialized,
      trackAddonTrialCompleted,
      trackAddonRequestQuoteCompleted,
      trackAddonLearnMoreClicked,
      trackAddonSubscriptionFunnelBlocked,
      trackAddonRequestQuoteClicked,
      trackAddonUpgradeClicked,
      trackAddonSelfSubscriptionFunnelStarted,
      trackAddonSubscriptionRequestQuoteClicked,
      trackAddonSubscriptionRequestQuoteNowCompleted,
      trackAddonSubscriptionSubscribeNowClicked,
      trackAddonSubscriptionRequestFeatureClicked,
      trackAddonSubscriptionTryItForFreeClicked,
      trackAddonSubscriptionMaybeLaterClicked,
      trackAddonSubscriptionLaunchTrialNowCompleted,
      trackAddonSubscriptionSubscribeToAddonCompleted,
      trackAddonSubscriptionStartUsingClicked,
      trackAddonSubscriptionGoToCourseClicked,
      trackAddonSubscriptionBackClicked,
      trackAddonSubscriptionReturnToDashboardClicked,
      trackAddonSubscriptionCloseClicked,
      trackAddonSubscriptionUpgradeNowClicked,
      trackAddonSubscriptionPlansClicked,
      trackAddonSelfSubscriptionStartFreeTrialCompleted
    }),
    [
      trackAddonSubscriptionFunnelStarted,
      trackAddonTrialInitialized,
      trackAddonTrialCompleted,
      trackAddonRequestQuoteCompleted,
      trackAddonLearnMoreClicked,
      trackAddonSubscriptionFunnelBlocked,
      trackAddonRequestQuoteClicked,
      trackAddonUpgradeClicked,
      trackAddonSelfSubscriptionFunnelStarted,
      trackAddonSubscriptionRequestQuoteClicked,
      trackAddonSubscriptionRequestQuoteNowCompleted,
      trackAddonSubscriptionSubscribeNowClicked,
      trackAddonSubscriptionRequestFeatureClicked,
      trackAddonSubscriptionTryItForFreeClicked,
      trackAddonSubscriptionMaybeLaterClicked,
      trackAddonSubscriptionLaunchTrialNowCompleted,
      trackAddonSubscriptionSubscribeToAddonCompleted,
      trackAddonSubscriptionStartUsingClicked,
      trackAddonSubscriptionGoToCourseClicked,
      trackAddonSubscriptionBackClicked,
      trackAddonSubscriptionReturnToDashboardClicked,
      trackAddonSubscriptionCloseClicked,
      trackAddonSubscriptionUpgradeNowClicked,
      trackAddonSubscriptionPlansClicked,
      trackAddonSelfSubscriptionStartFreeTrialCompleted
    ]
  );
}
__name(useTrackAddonSubscriptionFunnel, "useTrackAddonSubscriptionFunnel");
const FUNNEL_ID_SESSION_STORAGE = "license_management_funnel_id", USER_ASSIGNED_ADD_ONS_FILTER_USED_EVENT = "user_assigned_add_ons_filter_used", USER_ADD_ON_PROVISIONING_FUNNEL_STARTED_EVENT = "user_add_on_provisioning_funnel_started", USER_ADD_ON_PROVISIONING_FUNNEL_COMPLETED_EVENT = "user_add_on_provisioning_funnel_completed", COMPANY_ADD_ON_PROVISIONING_MANAGE_LICENSES_FUNNEL_STARTED_EVENT = "company_add_on_provisioning_manage_licenses_funnel_started", COMPANY_ADD_ON_PROVISIONING_MANAGE_LICENSES_FUNNEL_COMPLETED_EVENT = "company_add_on_provisioning_manage_licenses_funnel_completed", ADD_ON_PROVISIONING_FUNNEL_COMPLETED_ERROR_DISPLAYED_EVENT = "add_on_provisioning_funnel_completed_error_displayed";
function useTrackLicenseManagementFunnel(track) {
  const location = useLocation(), { setAndReturnNewFunnelId, getExistingOrNewFunnelId } = manageFunnelId(
    FUNNEL_ID_SESSION_STORAGE
  ), trackUserAssignedAddOnsFilterUsed = useCallback(
    (payload) => {
      track(
        USER_ASSIGNED_ADD_ONS_FILTER_USED_EVENT,
        snakecaseKeys$1({
          ...payload
        })
      );
    },
    [track]
  ), trackUserAddOnProvisioningFunnelStarted = useCallback(
    (payload) => {
      track(
        USER_ADD_ON_PROVISIONING_FUNNEL_STARTED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: setAndReturnNewFunnelId(),
          pagePath: location.pathname
        })
      );
    },
    [location.pathname, setAndReturnNewFunnelId, track]
  ), trackUserAddOnProvisioningFunnelCompleted = useCallback(
    (payload) => {
      track(
        USER_ADD_ON_PROVISIONING_FUNNEL_COMPLETED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackCompanyAddOnProvisioningManageLicensesFunnelStarted = useCallback(
    (payload) => {
      track(
        COMPANY_ADD_ON_PROVISIONING_MANAGE_LICENSES_FUNNEL_STARTED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: setAndReturnNewFunnelId(),
          pagePath: location.pathname
        })
      );
    },
    [location.pathname, setAndReturnNewFunnelId, track]
  ), trackCompanyAddOnProvisioningManageLicensesFunnelCompleted = useCallback(
    (payload) => {
      track(
        COMPANY_ADD_ON_PROVISIONING_MANAGE_LICENSES_FUNNEL_COMPLETED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  ), trackAddOnProvisioningFunnelCompletedErrorDisplayed = useCallback(
    (payload) => {
      track(
        ADD_ON_PROVISIONING_FUNNEL_COMPLETED_ERROR_DISPLAYED_EVENT,
        snakecaseKeys$1({
          ...payload,
          funnelId: getExistingOrNewFunnelId()
        })
      );
    },
    [getExistingOrNewFunnelId, track]
  );
  return {
    trackUserAssignedAddOnsFilterUsed,
    trackUserAddOnProvisioningFunnelStarted,
    trackUserAddOnProvisioningFunnelCompleted,
    trackCompanyAddOnProvisioningManageLicensesFunnelStarted,
    trackCompanyAddOnProvisioningManageLicensesFunnelCompleted,
    trackAddOnProvisioningFunnelCompletedErrorDisplayed
  };
}
__name(useTrackLicenseManagementFunnel, "useTrackLicenseManagementFunnel");
function useNavigateToAddonPage(track) {
  const navigate = useNavigate$1(), location = useLocation$1(), { trackAddonSubscriptionFunnelStarted } = useTrackAddonSubscriptionFunnel(track);
  return useCallback(
    (addonName, buttonNameClicked, options) => {
      const { includeSearchParams = !1, customFromPath } = options ?? {};
      trackAddonSubscriptionFunnelStarted({ addonName, buttonNameClicked });
      const from = customFromPath ?? location.pathname, search3 = includeSearchParams ? location.search : "", url = `/addons/${addonName === "ai_assist_pro" ? "aircall_ai" : addonName}`;
      navigate(`${url}?from=${encodeURIComponent(from + search3)}`);
    },
    [
      navigate,
      trackAddonSubscriptionFunnelStarted,
      location.pathname,
      location.search
    ]
  );
}
__name(useNavigateToAddonPage, "useNavigateToAddonPage");
function useBeforeUnload(shouldBlock) {
  const beforeUnloadHandler = useCallback((event) => {
    event.preventDefault(), event.returnValue = !0;
  }, []);
  useEffect(() => (shouldBlock && window.addEventListener("beforeunload", beforeUnloadHandler), () => {
    window.removeEventListener("beforeunload", beforeUnloadHandler);
  }), [shouldBlock, beforeUnloadHandler]);
}
__name(useBeforeUnload, "useBeforeUnload");
var AVAILABLE_BROADCAST_CHANNELS = /* @__PURE__ */ ((AVAILABLE_BROADCAST_CHANNELS2) => (AVAILABLE_BROADCAST_CHANNELS2.CALENDAR_EVENTS = "CALENDAR_EVENTS", AVAILABLE_BROADCAST_CHANNELS2.USER_EVENTS = "USER_EVENTS", AVAILABLE_BROADCAST_CHANNELS2.VIRTUAL_AGENT_EVENTS = "VIRTUAL_AGENT_EVENTS", AVAILABLE_BROADCAST_CHANNELS2.TEAM_EVENTS = "TEAM_EVENTS", AVAILABLE_BROADCAST_CHANNELS2.LINE_EVENTS = "LINE_EVENTS", AVAILABLE_BROADCAST_CHANNELS2))(AVAILABLE_BROADCAST_CHANNELS || {}), LINE_BROADCAST_EVENTS = /* @__PURE__ */ ((LINE_BROADCAST_EVENTS2) => (LINE_BROADCAST_EVENTS2.CREATE_LINE = "LINE_CREATED", LINE_BROADCAST_EVENTS2.DELETE_LINE = "LINE_DELETED", LINE_BROADCAST_EVENTS2.UPDATE_LINE = "LINE_UPDATED", LINE_BROADCAST_EVENTS2))(LINE_BROADCAST_EVENTS || {}), TEAM_BROADCAST_EVENTS = /* @__PURE__ */ ((TEAM_BROADCAST_EVENTS2) => (TEAM_BROADCAST_EVENTS2.CREATE_TEAM = "TEAM_CREATED", TEAM_BROADCAST_EVENTS2.DELETE_TEAM = "TEAM_DELETED", TEAM_BROADCAST_EVENTS2.UPDATE_TEAM = "TEAM_UPDATED", TEAM_BROADCAST_EVENTS2))(TEAM_BROADCAST_EVENTS || {}), VIRTUAL_AGENT_BROADCAST_EVENTS = /* @__PURE__ */ ((VIRTUAL_AGENT_BROADCAST_EVENTS2) => (VIRTUAL_AGENT_BROADCAST_EVENTS2.CREATE_VIRTUAL_AGENT = "VIRTUAL_AGENT_CREATED", VIRTUAL_AGENT_BROADCAST_EVENTS2.DELETE_VIRTUAL_AGENT = "VIRTUAL_AGENT_DELETED", VIRTUAL_AGENT_BROADCAST_EVENTS2.UPDATE_VIRTUAL_AGENT = "VIRTUAL_AGENT_UPDATED", VIRTUAL_AGENT_BROADCAST_EVENTS2))(VIRTUAL_AGENT_BROADCAST_EVENTS || {}), CALENDAR_BROADCAST_EVENTS = /* @__PURE__ */ ((CALENDAR_BROADCAST_EVENTS2) => (CALENDAR_BROADCAST_EVENTS2.CREATE_CALENDAR = "CALENDAR_CREATED", CALENDAR_BROADCAST_EVENTS2.DELETE_CALENDAR = "CALENDAR_DELETED", CALENDAR_BROADCAST_EVENTS2.UPDATE_CALENDAR = "CALENDAR_UPDATED", CALENDAR_BROADCAST_EVENTS2))(CALENDAR_BROADCAST_EVENTS || {}), USER_BROADCAST_EVENTS = /* @__PURE__ */ ((USER_BROADCAST_EVENTS2) => (USER_BROADCAST_EVENTS2.CREATE_USERS = "USERS_CREATED", USER_BROADCAST_EVENTS2.DELETE_USER = "USER_DELETED", USER_BROADCAST_EVENTS2.UPDATE_USER = "USER_UPDATED", USER_BROADCAST_EVENTS2))(USER_BROADCAST_EVENTS || {});
const useBroadcastChannel = /* @__PURE__ */ __name((broadCastChannelName, handleReceiveMessageCb) => {
  const channelRef = useRef(null);
  return useEffect(() => {
    const channel = new BroadcastChannel(broadCastChannelName);
    return handleReceiveMessageCb && (channel.onmessage = (event) => {
      handleReceiveMessageCb(event);
    }), channelRef.current = channel, () => {
      try {
        channel.close();
      } catch (e3) {
        console.error("useBroadcastChannel closeChannel", e3);
      }
      channelRef.current === channel && (channelRef.current = null);
    };
  }, [broadCastChannelName, handleReceiveMessageCb]), { sendMessage: useCallback((message) => {
    var _a3;
    try {
      (_a3 = channelRef.current) == null || _a3.postMessage(message);
    } catch (e3) {
      console.error("useBroadcastChannel postMessage", e3);
    }
  }, []) };
}, "useBroadcastChannel");
function useElapsedTime() {
  const startTime = useRef(null), start = useCallback(() => {
    startTime.current = Date.now();
  }, []), getElapsed = useCallback(() => startTime.current ? Date.now() - startTime.current : 0, []), reset = useCallback(() => {
    startTime.current = null;
  }, []);
  return { getElapsed, reset, start };
}
__name(useElapsedTime, "useElapsedTime");
const StyledSaveBar = styled(Flex)`
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 16px;
  border-top: 1px solid ${getColor$2("neutral-200")};
  will-change: transform;
`, MotionBox$1 = motion(Box), saveAnimationVariants = {
  enter: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.35,
      ease: "easeInOut"
    }
  }
}, innerSaveAnimationVariants = {
  enter: {
    ...saveAnimationVariants.enter,
    height: 65
  },
  exit: {
    ...saveAnimationVariants.exit,
    height: 0
  }
};
function getSavingStatus({
  pristine,
  submitting,
  submitSucceeded
}) {
  return submitting ? SaveButtonStatus.SAVING : submitSucceeded && pristine ? SaveButtonStatus.SAVED : SaveButtonStatus.UNSAVED;
}
__name(getSavingStatus, "getSavingStatus");
const InnerSaveBar = typedMemo(
  ({
    formProps,
    lang,
    submitButtonText,
    successButtonText,
    undoButtonText
  }) => {
    const { hasValidationErrors: hasErrors, handleSubmit: onSubmit } = formProps, onReset = formProps.form.reset, savingStatus = getSavingStatus(formProps);
    return /* @__PURE__ */ jsx(
      MotionBox$1,
      {
        "data-test": "save-bar",
        overflow: "hidden",
        variants: innerSaveAnimationVariants,
        initial: "exit",
        animate: "enter",
        exit: "exit",
        children: /* @__PURE__ */ jsx(StyledSaveBar, { children: /* @__PURE__ */ jsxs(Spacer, { space: "xxs", alignItems: "center", children: [
          onReset && savingStatus === "unsaved" && /* @__PURE__ */ jsx(
            Button$1,
            {
              "data-test": "undo-button",
              onClick: onReset,
              variant: "secondary",
              mode: "ghost",
              children: undoButtonText || translations[lang][FORM_ACTIONS.UNDO]
            }
          ),
          /* @__PURE__ */ jsx(
            SaveButton,
            {
              status: savingStatus,
              onClick: onSubmit,
              disabled: hasErrors,
              savedText: successButtonText || translations[lang][FORM_ACTIONS.SAVED],
              unsavedText: submitButtonText || translations[lang][FORM_ACTIONS.UNSAVED]
            }
          )
        ] }) })
      }
    );
  }
), AnimatedSaveContainer = typedMemo(
  ({
    children,
    shouldBlockNavigation = !1,
    formProps
  }) => {
    const { pristine, submitSucceeded, submitFailed } = formProps, [visibleAfterSaved, setVisibleAfterSaved] = useStateDelay(!1);
    useBlocker(
      // only block the navigation if the form values are changed
      shouldBlockNavigation && !pristine
    );
    const savingStatus = getSavingStatus(formProps);
    useEffect(() => {
      savingStatus === SaveButtonStatus.SAVED && setVisibleAfterSaved(!0, 1e3, !1);
    }, [savingStatus, setVisibleAfterSaved]);
    const isSaving = savingStatus === SaveButtonStatus.SAVING;
    return /* @__PURE__ */ jsx(AnimatePresence, { children: (!pristine || isSaving || submitSucceeded && visibleAfterSaved || submitFailed) && children });
  }
), SaveBar = typedMemo(
  ({
    shouldUseContext = !0,
    formProps,
    lang = "en",
    ...restProps
  }) => {
    const { containerElement } = useContext(SaveBarContainerContext);
    return shouldUseContext && containerElement ? createPortal(
      /* @__PURE__ */ jsx(AnimatedSaveContainer, { formProps, children: /* @__PURE__ */ jsx(InnerSaveBar, { formProps, lang, ...restProps }) }),
      containerElement
    ) : /* @__PURE__ */ jsx(AnimatedSaveContainer, { formProps, ...restProps, children: /* @__PURE__ */ jsx(InnerSaveBar, { formProps, lang, ...restProps }) });
  }
);
function PaperForm({
  children,
  title,
  subtitle,
  shouldBlockNavigation,
  formProps,
  getErrorMessage,
  lang,
  submitButtonText,
  successButtonText,
  undoButtonText,
  ...paperProps
}) {
  return /* @__PURE__ */ jsx(Form, { ...formProps, children: (formRenderProps) => /* @__PURE__ */ jsx(Form$1, { onSubmit: formRenderProps.handleSubmit, children: /* @__PURE__ */ jsx(
    Paper,
    {
      ...paperProps,
      title,
      subtitle,
      footer: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(AnimatePresence, { children: getErrorMessage && formRenderProps.submitError && /* @__PURE__ */ jsxs(
          Banner,
          {
            "data-test": "paper-form-error-banner",
            variant: "critical",
            children: [
              /* @__PURE__ */ jsx(BannerIcon, {}),
              /* @__PURE__ */ jsx(BannerHeading, { children: getErrorMessage(formRenderProps.submitError) })
            ]
          }
        ) }),
        /* @__PURE__ */ jsx(
          SaveBar,
          {
            formProps: formRenderProps,
            shouldUseContext: !1,
            shouldBlockNavigation,
            lang,
            submitButtonText,
            successButtonText,
            undoButtonText
          }
        )
      ] }),
      children: children(formRenderProps)
    }
  ) }) });
}
__name(PaperForm, "PaperForm");
function SelectField({
  name: name2,
  label,
  options,
  placeholder,
  onChange: onChange5,
  validate,
  t: t3,
  children,
  ...selectProps
}) {
  const {
    input: { value, onChange: onFormChange, onBlur },
    meta: { error, touched }
  } = useField(name2, { validate }), showError = error && touched, onChangeHandler = useCallback(
    (selected) => {
      onChange5 ? onChange5(selected[0]) : onFormChange(selected[0]);
    },
    [onFormChange, onChange5]
  ), selectedKeys = value ? [value] : void 0;
  return /* @__PURE__ */ jsx(
    FormItem,
    {
      label,
      name: name2,
      gridAutoRows: "max-content",
      validationStatus: showError ? "error" : void 0,
      helpText: showError ? t3(error) : void 0,
      children: children ? children({ onChange: onChangeHandler, selectedKeys, onBlur }) : /* @__PURE__ */ jsx(
        Select$1,
        {
          placeholder,
          options,
          onSelectionChange: onChangeHandler,
          onBlur,
          selectedKeys,
          ...selectProps
        }
      )
    }
  );
}
__name(SelectField, "SelectField");
function TimeSelect({
  "data-test": dataTest = "time-select",
  value = 0,
  from = 0,
  // 00:00
  to = 1440,
  // 24:00
  onChange: onChange5
}) {
  const onTimeSelected = /* @__PURE__ */ __name((keys2) => {
    onChange5(keys2 == null ? void 0 : keys2[0]);
  }, "onTimeSelected"), options = useMemo(
    () => [...new Array(49)].reduce((acc, _, i2) => {
      const totalMinutes = from + i2 * 30;
      if (totalMinutes > to)
        return acc;
      const minutes = (totalMinutes % 60).toString().padStart(2, "0"), label = `${Math.floor(totalMinutes / 60).toString().padStart(2, "0")}:${minutes}`;
      return [...acc, { value: totalMinutes, label }];
    }, []),
    [from, to]
  );
  return /* @__PURE__ */ jsx(
    Select$1,
    {
      "data-test": dataTest,
      selectedKeys: [value],
      options,
      onSelectionChange: onTimeSelected
    }
  );
}
__name(TimeSelect, "TimeSelect");
const TimeSlotContainer = styled(GridLayout)`
  position: relative;
`;
function TimeSlotField({
  from,
  to,
  name: name2,
  hasIcon,
  onRemove,
  "data-test": dataTest,
  texts: texts2,
  ...otherProps
}) {
  const form = useForm(), handleChangeFrom = useCallback(
    (value) => {
      form.change(`${name2}.from`, value), form.change(`${name2}.to`, Math.max(value + 30, to));
    },
    [form, name2, to]
  );
  return /* @__PURE__ */ jsxs(
    TimeSlotContainer,
    {
      gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
      w: "100%",
      p: "s",
      pr: "xl",
      "data-test": dataTest,
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(GridItem, { xs: 6, children: /* @__PURE__ */ jsx(FormItem, { label: "Available on", children: /* @__PURE__ */ jsx(Field, { name: `${name2}.days`, children: ({ input: { value, onChange: onChange5 } }) => /* @__PURE__ */ jsx(
          DaysPicker,
          {
            mt: 12,
            selectedDays: value,
            onChange: onChange5,
            texts: texts2.days
          }
        ) }) }) }),
        /* @__PURE__ */ jsx(GridItem, { xs: 6, children: /* @__PURE__ */ jsxs(Spacer, { space: "s", children: [
          /* @__PURE__ */ jsx(FormItem, { label: "From", children: /* @__PURE__ */ jsx(Field, { name: `${name2}.from`, children: ({ input: { value } }) => /* @__PURE__ */ jsx(
            TimeSelect,
            {
              "data-test": `${dataTest}-from-time-select`,
              value,
              from: 0,
              to: 1410,
              onChange: handleChangeFrom
            }
          ) }) }),
          /* @__PURE__ */ jsx(FormItem, { label: "To", children: /* @__PURE__ */ jsx(Field, { name: `${name2}.to`, children: ({ input: { value, onChange: onChange5 } }) => /* @__PURE__ */ jsx(
            TimeSelect,
            {
              "data-test": `${dataTest}-to-time-select`,
              value,
              from: from + 30,
              onChange: onChange5
            }
          ) }) })
        ] }) }),
        hasIcon && /* @__PURE__ */ jsx(Box, { position: "absolute", top: "2px", right: "2px", children: /* @__PURE__ */ jsx(
          ActionMenu,
          {
            trigger: /* @__PURE__ */ jsx(
              Button$1,
              {
                mode: "ghost",
                shape: "circle",
                variant: "secondary",
                size: "xSmall",
                "data-test": `${dataTest}-action-button`,
                children: /* @__PURE__ */ jsx(MenuVerticalFilled, {})
              }
            ),
            items: [
              {
                name: texts2.remove,
                onClick: onRemove
              }
            ]
          }
        ) })
      ]
    }
  );
}
__name(TimeSlotField, "TimeSlotField");
function _objectWithoutPropertiesLoose$g(r2, e3) {
  if (r2 == null)
    return {};
  var t3 = {};
  for (var n in r2)
    if ({}.hasOwnProperty.call(r2, n)) {
      if (e3.indexOf(n) !== -1)
        continue;
      t3[n] = r2[n];
    }
  return t3;
}
__name(_objectWithoutPropertiesLoose$g, "_objectWithoutPropertiesLoose$g");
function renderComponent(props, name2) {
  var render = props.render, children = props.children, component = props.component, rest = _objectWithoutPropertiesLoose$g(props, ["render", "children", "component"]);
  if (component)
    return /* @__PURE__ */ createElement(component, _extends$p({}, rest, {
      children,
      render
    }));
  if (render)
    return render(children === void 0 ? rest : _extends$p({}, rest, {
      children
    }));
  if (typeof children != "function")
    throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name2);
  return children(rest);
}
__name(renderComponent, "renderComponent");
var defaultIsEqual = /* @__PURE__ */ __name(function(aArray, bArray) {
  return aArray === bArray || Array.isArray(aArray) && Array.isArray(bArray) && aArray.length === bArray.length && !aArray.some(function(a4, index2) {
    return a4 !== bArray[index2];
  });
}, "defaultIsEqual");
function useConstant(init2) {
  var ref = React__default.useRef();
  return ref.current || (ref.current = init2()), ref.current;
}
__name(useConstant, "useConstant");
var all$1 = fieldSubscriptionItems.reduce(function(result2, key) {
  return result2[key] = !0, result2;
}, {}), useFieldArray = /* @__PURE__ */ __name(function(name2, _temp) {
  var _ref = _temp === void 0 ? {} : _temp, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? all$1 : _ref$subscription, defaultValue = _ref.defaultValue, initialValue = _ref.initialValue, _ref$isEqual = _ref.isEqual, isEqual2 = _ref$isEqual === void 0 ? defaultIsEqual : _ref$isEqual, validateProp = _ref.validate, form = useForm("useFieldArray"), formMutators = form.mutators, hasMutators = !!(formMutators && formMutators.push && formMutators.pop);
  if (!hasMutators)
    throw new Error("Array mutators not found. You need to provide the mutators from final-form-arrays to your form");
  var mutators2 = useConstant(function() {
    return (
      // curry the field name onto all mutator calls
      Object.keys(formMutators).reduce(function(result2, key) {
        return result2[key] = function() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
            args[_key] = arguments[_key];
          return formMutators[key].apply(formMutators, [name2].concat(args));
        }, result2;
      }, {})
    );
  }), validate = useConstant(function() {
    return function(value, allValues, meta2) {
      if (validateProp) {
        var error = validateProp(value, allValues, meta2);
        if (!error || Array.isArray(error))
          return error;
        var arrayError = [];
        return arrayError[ARRAY_ERROR] = error, arrayError;
      }
    };
  }), _useField = useField(name2, {
    subscription: _extends$p({}, subscription, {
      length: !0
    }),
    defaultValue,
    initialValue,
    isEqual: isEqual2,
    validate,
    format: /* @__PURE__ */ __name(function(v) {
      return v;
    }, "format")
  }), _useField$meta = _useField.meta, length = _useField$meta.length, meta = _objectWithoutPropertiesLoose$g(_useField$meta, ["length"]), input = _useField.input, fieldState = _objectWithoutPropertiesLoose$g(_useField, ["meta", "input"]), forEach = /* @__PURE__ */ __name(function(iterator) {
    for (var len = length || 0, i2 = 0; i2 < len; i2++)
      iterator(name2 + "[" + i2 + "]", i2);
  }, "forEach"), map2 = /* @__PURE__ */ __name(function(iterator) {
    for (var len = length || 0, results = [], i2 = 0; i2 < len; i2++)
      results.push(iterator(name2 + "[" + i2 + "]", i2));
    return results;
  }, "map");
  return {
    fields: _extends$p({
      name: name2,
      forEach,
      length: length || 0,
      map: map2
    }, mutators2, fieldState, {
      value: input.value
    }),
    meta
  };
}, "useFieldArray"), version = "3.1.2", versions = {
  "final-form": version$1,
  "react-final-form": version$2,
  "react-final-form-arrays": version
}, FieldArray = /* @__PURE__ */ __name(function(_ref) {
  var name2 = _ref.name, subscription = _ref.subscription, defaultValue = _ref.defaultValue, initialValue = _ref.initialValue, isEqual2 = _ref.isEqual, validate = _ref.validate, rest = _objectWithoutPropertiesLoose$g(_ref, ["name", "subscription", "defaultValue", "initialValue", "isEqual", "validate"]), _useFieldArray = useFieldArray(name2, {
    subscription,
    defaultValue,
    initialValue,
    isEqual: isEqual2,
    validate
  }), fields = _useFieldArray.fields, meta = _useFieldArray.meta;
  return renderComponent(_extends$p({
    fields,
    meta: _extends$p({}, meta, {
      __versions: versions
    })
  }, rest), "FieldArray(" + name2 + ")");
}, "FieldArray");
function TimeSlotsField({ slots, texts: texts2 }) {
  const form = useForm(), handleAdd = useCallback(() => {
    form.mutators.push("slots", {
      __typename: "AvailabilitySlot",
      days: [
        DayOfWeek.MONDAY,
        DayOfWeek.TUESDAY,
        DayOfWeek.WEDNESDAY,
        DayOfWeek.THURSDAY,
        DayOfWeek.FRIDAY
      ],
      from: 540,
      to: 1080
    });
  }, [form]);
  function handleRemove(index2) {
    form.mutators.remove("slots", index2);
  }
  return __name(handleRemove, "handleRemove"), /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(FieldArray, { name: "slots", children: ({ fields }) => /* @__PURE__ */ jsx(FormItem, { label: texts2.timeslotLabel, children: /* @__PURE__ */ jsx(List$1, { "data-test": "timeslots", children: /* @__PURE__ */ jsx(ListView, { children: fields.map((field, i2) => /* @__PURE__ */ jsx(ListItem$1, { h: "auto", children: /* @__PURE__ */ jsx(
      TimeSlotField,
      {
        hasIcon: fields.length !== 1,
        name: field,
        ...slots[i2],
        onRemove: () => handleRemove(i2),
        "data-test": `timeslot-${i2 + 1}`,
        texts: {
          remove: texts2.remove,
          days: texts2.days
        }
      }
    ) }, field)) }) }) }) }),
    /* @__PURE__ */ jsx(
      AddButton,
      {
        "data-test": "timeslots-add-button",
        isLarge: !1,
        onClick: handleAdd,
        children: texts2.addNew
      }
    )
  ] });
}
__name(TimeSlotsField, "TimeSlotsField");
function SingleSearchSelect({
  "data-test": dataTest = "single-search-select",
  ...props
}) {
  return /* @__PURE__ */ jsx(
    MultiSearchSelect,
    {
      ...props,
      "data-test": dataTest,
      showSelectedOnTop: !1,
      selectionMode: "single",
      resetSearchOnSelect: !1
    }
  );
}
__name(SingleSearchSelect, "SingleSearchSelect");
function TimezoneSelect({
  onChange: onChange5,
  shouldGuessTimezone,
  value,
  options,
  ...props
}) {
  const timezoneOptions = useMemo(
    () => getTimezones(options).map((tz) => ({
      formattedOffset: tz.formattedOffset,
      formattedUtcOffset: tz.formattedUtcOffset,
      label: tz.name,
      value: tz.value
    })),
    [options]
  ), [filteredOptions, setOptions] = useState(timezoneOptions), onSearch2 = /* @__PURE__ */ __name((text2) => {
    const searchText = text2.trim().toLocaleLowerCase();
    setOptions(
      timezoneOptions.filter(
        (option) => {
          var _a3;
          return option.label.toLowerCase().includes(searchText) || ((_a3 = option.formattedOffset) == null ? void 0 : _a3.includes(searchText));
        }
      )
    );
  }, "onSearch"), handleSelect = /* @__PURE__ */ __name((keys2) => {
    onChange5(keys2 == null ? void 0 : keys2[0]);
  }, "handleSelect"), initialValue = useMemo(() => {
    if (value)
      return [value];
    if (shouldGuessTimezone) {
      const tzGuess = window.Intl.DateTimeFormat().resolvedOptions().timeZone;
      return filteredOptions.find((option) => option.value === tzGuess) ? [tzGuess] : [filteredOptions[0].value];
    }
    return [];
  }, [value, shouldGuessTimezone, filteredOptions]);
  return /* @__PURE__ */ jsx(
    SingleSearchSelect,
    {
      ...props,
      options: filteredOptions,
      onSearch: onSearch2,
      renderItem: (option) => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(MenuItemLabel, { children: option.label }),
        /* @__PURE__ */ jsx(MenuItemSuffix, { children: /* @__PURE__ */ jsx(Typography, { color: "neutral-400", variant: "bodyRegularS", children: option.formattedUtcOffset }) })
      ] }),
      selectedKeys: initialValue,
      onSelect: handleSelect
    }
  );
}
__name(TimezoneSelect, "TimezoneSelect");
function TimeSlotsForm({
  initialValues,
  onSubmit,
  title,
  texts: texts2,
  t: t3,
  ...otherProps
}) {
  const { addNew, timeslotLabel, remove: remove3, days } = texts2, renderTimeSlots = useCallback(
    (values) => {
      const { availability } = values;
      return availability === Availability.CUSTOM ? /* @__PURE__ */ jsx(GridItem, { xs: 12, children: /* @__PURE__ */ jsx(
        TimeSlotsField,
        {
          slots: values.slots,
          texts: {
            addNew,
            timeslotLabel,
            remove: remove3,
            days
          }
        }
      ) }) : null;
    },
    [addNew, days, remove3, timeslotLabel]
  );
  return /* @__PURE__ */ jsx(
    PaperForm,
    {
      title,
      shouldBlockNavigation: !0,
      formProps: {
        onSubmit,
        initialValues,
        mutators: { ...mutators }
      },
      fluid: !0,
      ...otherProps,
      children: ({ values }) => /* @__PURE__ */ jsxs(GridLayout, { children: [
        /* @__PURE__ */ jsx(GridItem, { xs: 6, children: /* @__PURE__ */ jsx(FormItem, { label: texts2.timezone, children: /* @__PURE__ */ jsx(Field, { name: "timezone", children: ({ input: { value, onChange: onChange5 } }) => /* @__PURE__ */ jsx(
          TimezoneSelect,
          {
            onChange: onChange5,
            triggerStyle: "select",
            value
          }
        ) }) }) }),
        /* @__PURE__ */ jsx(GridItem, { xs: 6, children: /* @__PURE__ */ jsx(
          SelectField,
          {
            label: texts2.availabilityLabel,
            name: "availability",
            size: "regular",
            "data-test": "availability-select",
            t: t3,
            children: ({ selectedKeys, onChange: onChange5, onBlur }) => /* @__PURE__ */ jsx(
              AvailabilitySelect,
              {
                onSelectionChange: onChange5,
                onBlur,
                selectedKeys,
                texts: {
                  always: texts2.always,
                  alwaysDescription: texts2.alwaysDescription,
                  never: texts2.never,
                  neverDescription: texts2.neverDescription,
                  scheduled: texts2.scheduled
                }
              }
            )
          }
        ) }),
        renderTimeSlots(values)
      ] })
    }
  );
}
__name(TimeSlotsForm, "TimeSlotsForm");
var DayOfWeek = /* @__PURE__ */ ((DayOfWeek2) => (DayOfWeek2.FRIDAY = "FRIDAY", DayOfWeek2.MONDAY = "MONDAY", DayOfWeek2.SATURDAY = "SATURDAY", DayOfWeek2.SUNDAY = "SUNDAY", DayOfWeek2.THURSDAY = "THURSDAY", DayOfWeek2.TUESDAY = "TUESDAY", DayOfWeek2.WEDNESDAY = "WEDNESDAY", DayOfWeek2))(DayOfWeek || {});
const Circle = styled(Flex)`
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  ${({ isActive }) => css`
    background-color: ${isActive ? "primary-500" : "neutral-400"};
  `};
  color: text-inverted;
  cursor: pointer;
  user-select: none;
`;
function DaysPickerDay({
  dayOfWeek,
  isActive,
  onClick: onClick2,
  texts: texts2
}) {
  return /* @__PURE__ */ jsx(
    Circle,
    {
      isActive,
      onClick: () => onClick2(dayOfWeek),
      "data-test": `day-of-week-${dayOfWeek}`,
      children: /* @__PURE__ */ jsx(Typography, { variant: "bodyMediumS", top: 2, children: texts2[dayOfWeek] })
    }
  );
}
__name(DaysPickerDay, "DaysPickerDay");
function DaysPicker({
  selectedDays,
  onChange: onChange5,
  texts: texts2,
  ...otherProps
}) {
  const handleClickDay = useCallback(
    (dayOfWeek) => {
      const newSelectedDays = selectedDays.includes(dayOfWeek) ? selectedDays.filter((d3) => d3 !== dayOfWeek) : [...selectedDays, dayOfWeek];
      onChange5 == null || onChange5(newSelectedDays);
    },
    [onChange5, selectedDays]
  ), days = [
    DayOfWeek.MONDAY,
    DayOfWeek.TUESDAY,
    DayOfWeek.WEDNESDAY,
    DayOfWeek.THURSDAY,
    DayOfWeek.FRIDAY,
    DayOfWeek.SATURDAY,
    DayOfWeek.SUNDAY
  ].map((dayOfWeek) => /* @__PURE__ */ jsx(
    DaysPickerDay,
    {
      dayOfWeek,
      onClick: handleClickDay,
      isActive: selectedDays.includes(dayOfWeek),
      texts: texts2
    },
    dayOfWeek
  ));
  return /* @__PURE__ */ jsx(Spacer, { space: "xxs", ...otherProps, children: days });
}
__name(DaysPicker, "DaysPicker");
function Day({ date: date2, locale: locale2, ...restProps }) {
  return /* @__PURE__ */ jsx(Typography, { ...restProps, children: date2.toLocaleDateString(locale2, {
    day: "numeric",
    month: "short"
  }) });
}
__name(Day, "Day");
function Time({ date: date2, locale: locale2, ...restProps }) {
  return /* @__PURE__ */ jsx(Typography, { ...restProps, children: getLocalizedTime(date2, locale2) });
}
__name(Time, "Time");
function DayTime({ date: date2, locale: locale2, ...restProps }) {
  return /* @__PURE__ */ jsxs(Typography, { ...restProps, children: [
    /* @__PURE__ */ jsx(Day, { date: date2, locale: locale2, ...restProps, display: "inline" }),
    " - ",
    /* @__PURE__ */ jsx(Time, { date: date2, locale: locale2, ...restProps, display: "inline" })
  ] });
}
__name(DayTime, "DayTime");
function DrawerSection({
  children,
  "data-test": dataTest = "drawer-section",
  ...gapProps
}) {
  return /* @__PURE__ */ jsx(Gap, { gap: "xxs", flexDirection: "column", "data-test": dataTest, ...gapProps, children });
}
__name(DrawerSection, "DrawerSection");
function DrawerSectionBody({
  children,
  "data-test": dataTest = "drawer-section-body",
  ...gapProps
}) {
  return /* @__PURE__ */ jsx(Gap, { gap: "xxs", "data-test": dataTest, ...gapProps, children });
}
__name(DrawerSectionBody, "DrawerSectionBody");
function DrawerSectionHeaderIcon({
  component,
  color: color2,
  size,
  ...iconProps
}) {
  return React__default.isValidElement(component) ? component : /* @__PURE__ */ jsx(
    Icon,
    {
      component,
      color: color2,
      size,
      ...iconProps
    }
  );
}
__name(DrawerSectionHeaderIcon, "DrawerSectionHeaderIcon");
function DrawerSectionHeader({
  icon: {
    component: iconComponent,
    color: iconColor = "icon-default",
    size: iconSize2 = 16,
    ...iconProps
  },
  title,
  typography: {
    color: typographyColor = "neutral-800",
    variant: typographyVariant2 = "bodySemiboldM",
    ...typographyProps
  } = {},
  "data-test": dataTest = "drawer-section-header",
  ...gapProps
}) {
  return /* @__PURE__ */ jsxs(Gap, { gap: "xxs", alignItems: "center", "data-test": dataTest, ...gapProps, children: [
    /* @__PURE__ */ jsx(
      DrawerSectionHeaderIcon,
      {
        component: iconComponent,
        color: iconColor,
        size: iconSize2,
        "data-test": `${dataTest}-icon`,
        ...iconProps
      }
    ),
    /* @__PURE__ */ jsx(
      Typography,
      {
        variant: typographyVariant2,
        color: typographyColor,
        "data-test": `${dataTest}-title`,
        ...typographyProps,
        children: title
      }
    )
  ] });
}
__name(DrawerSectionHeader, "DrawerSectionHeader");
var COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function toFileWithPath(file, path) {
  var f = withMimeType(file);
  if (typeof f.path != "string") {
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f, "path", {
      value: typeof path == "string" ? path : typeof webkitRelativePath == "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return f;
}
__name(toFileWithPath, "toFileWithPath");
function withMimeType(file) {
  var name2 = file.name, hasExtension = name2 && name2.lastIndexOf(".") !== -1;
  if (hasExtension && !file.type) {
    var ext = name2.split(".").pop().toLowerCase(), type = COMMON_MIME_TYPES.get(ext);
    type && Object.defineProperty(file, "type", {
      value: type,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return file;
}
__name(withMimeType, "withMimeType");
var FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a3) {
      return isObject$9(evt) && isDataTransfer(evt.dataTransfer) ? [2, getDataTransferFiles(evt.dataTransfer, evt.type)] : isChangeEvt(evt) ? [2, getInputFiles(evt)] : Array.isArray(evt) && evt.every(function(item) {
        return "getFile" in item && typeof item.getFile == "function";
      }) ? [2, getFsHandleFiles(evt)] : [2, []];
    });
  });
}
__name(fromEvent, "fromEvent");
function isDataTransfer(value) {
  return isObject$9(value);
}
__name(isDataTransfer, "isDataTransfer");
function isChangeEvt(value) {
  return isObject$9(value) && isObject$9(value.target);
}
__name(isChangeEvt, "isChangeEvt");
function isObject$9(v) {
  return typeof v == "object" && v !== null;
}
__name(isObject$9, "isObject$9");
function getInputFiles(evt) {
  return fromList(evt.target.files).map(function(file) {
    return toFileWithPath(file);
  });
}
__name(getInputFiles, "getInputFiles");
function getFsHandleFiles(handles) {
  return __awaiter(this, void 0, void 0, function() {
    var files;
    return __generator(this, function(_a3) {
      switch (_a3.label) {
        case 0:
          return [4, Promise.all(handles.map(function(h3) {
            return h3.getFile();
          }))];
        case 1:
          return files = _a3.sent(), [2, files.map(function(file) {
            return toFileWithPath(file);
          })];
      }
    });
  });
}
__name(getFsHandleFiles, "getFsHandleFiles");
function getDataTransferFiles(dt, type) {
  return __awaiter(this, void 0, void 0, function() {
    var items, files;
    return __generator(this, function(_a3) {
      switch (_a3.label) {
        case 0:
          return dt.items ? (items = fromList(dt.items).filter(function(item) {
            return item.kind === "file";
          }), type !== "drop" ? [2, items] : [4, Promise.all(items.map(toFilePromises))]) : [3, 2];
        case 1:
          return files = _a3.sent(), [2, noIgnoredFiles(flatten(files))];
        case 2:
          return [2, noIgnoredFiles(fromList(dt.files).map(function(file) {
            return toFileWithPath(file);
          }))];
      }
    });
  });
}
__name(getDataTransferFiles, "getDataTransferFiles");
function noIgnoredFiles(files) {
  return files.filter(function(file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
}
__name(noIgnoredFiles, "noIgnoredFiles");
function fromList(items) {
  if (items === null)
    return [];
  for (var files = [], i2 = 0; i2 < items.length; i2++) {
    var file = items[i2];
    files.push(file);
  }
  return files;
}
__name(fromList, "fromList");
function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry != "function")
    return fromDataTransferItem(item);
  var entry = item.webkitGetAsEntry();
  return entry && entry.isDirectory ? fromDirEntry(entry) : fromDataTransferItem(item);
}
__name(toFilePromises, "toFilePromises");
function flatten(items) {
  return items.reduce(function(acc, files) {
    return __spreadArray(__spreadArray([], __read(acc), !1), __read(Array.isArray(files) ? flatten(files) : [files]), !1);
  }, []);
}
__name(flatten, "flatten");
function fromDataTransferItem(item) {
  var file = item.getAsFile();
  if (!file)
    return Promise.reject("".concat(item, " is not a File"));
  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
}
__name(fromDataTransferItem, "fromDataTransferItem");
function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a3) {
      return [2, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
    });
  });
}
__name(fromEntry, "fromEntry");
function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function(resolve, reject) {
    var entries = [];
    function readEntries() {
      var _this = this;
      reader.readEntries(function(batch) {
        return __awaiter(_this, void 0, void 0, function() {
          var files, err_1, items;
          return __generator(this, function(_a3) {
            switch (_a3.label) {
              case 0:
                if (batch.length)
                  return [3, 5];
                _a3.label = 1;
              case 1:
                return _a3.trys.push([1, 3, , 4]), [4, Promise.all(entries)];
              case 2:
                return files = _a3.sent(), resolve(files), [3, 4];
              case 3:
                return err_1 = _a3.sent(), reject(err_1), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                items = Promise.all(batch.map(fromEntry)), entries.push(items), readEntries(), _a3.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(err) {
        reject(err);
      });
    }
    __name(readEntries, "readEntries"), readEntries();
  });
}
__name(fromDirEntry, "fromDirEntry");
function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a3) {
      return [2, new Promise(function(resolve, reject) {
        entry.file(function(file) {
          var fwp = toFileWithPath(file, entry.fullPath);
          resolve(fwp);
        }, function(err) {
          reject(err);
        });
      })];
    });
  });
}
__name(fromFileEntry, "fromFileEntry");
var _default = /* @__PURE__ */ __name(function(file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    if (acceptedFilesArray.length === 0)
      return !0;
    var fileName = file.name || "", mimeType = (file.type || "").toLowerCase(), baseMimeType = mimeType.replace(/\/.*$/, "");
    return acceptedFilesArray.some(function(type) {
      var validType = type.trim().toLowerCase();
      return validType.charAt(0) === "." ? fileName.toLowerCase().endsWith(validType) : validType.endsWith("/*") ? baseMimeType === validType.replace(/\/.*$/, "") : mimeType === validType;
    });
  }
  return !0;
}, "_default");
function _toConsumableArray$c(arr) {
  return _arrayWithoutHoles$c(arr) || _iterableToArray$d(arr) || _unsupportedIterableToArray$m(arr) || _nonIterableSpread$c();
}
__name(_toConsumableArray$c, "_toConsumableArray$c");
function _nonIterableSpread$c() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$c, "_nonIterableSpread$c");
function _iterableToArray$d(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$d, "_iterableToArray$d");
function _arrayWithoutHoles$c(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$m(arr);
}
__name(_arrayWithoutHoles$c, "_arrayWithoutHoles$c");
function _defineProperty$B(obj2, key, value) {
  return key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$B, "_defineProperty$B");
function _slicedToArray$e(arr, i2) {
  return _arrayWithHoles$f(arr) || _iterableToArrayLimit$e(arr, i2) || _unsupportedIterableToArray$m(arr, i2) || _nonIterableRest$f();
}
__name(_slicedToArray$e, "_slicedToArray$e");
function _nonIterableRest$f() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$f, "_nonIterableRest$f");
function _unsupportedIterableToArray$m(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$m(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$m(o, minLen);
  }
}
__name(_unsupportedIterableToArray$m, "_unsupportedIterableToArray$m");
function _arrayLikeToArray$m(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$m, "_arrayLikeToArray$m");
function _iterableToArrayLimit$e(arr, i2) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _arr = [], _n = !0, _d = !1, _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i2 && _arr.length === i2)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
__name(_iterableToArrayLimit$e, "_iterableToArrayLimit$e");
function _arrayWithHoles$f(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$f, "_arrayWithHoles$f");
var FILE_INVALID_TYPE = "file-invalid-type", FILE_TOO_LARGE = "file-too-large", FILE_TOO_SMALL = "file-too-small", TOO_MANY_FILES = "too-many-files", getInvalidTypeRejectionErr = /* @__PURE__ */ __name(function(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
}, "getInvalidTypeRejectionErr"), getTooLargeRejectionErr = /* @__PURE__ */ __name(function(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
}, "getTooLargeRejectionErr"), getTooSmallRejectionErr = /* @__PURE__ */ __name(function(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
}, "getTooSmallRejectionErr"), TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
__name(fileAccepted, "fileAccepted");
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size))
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize)
        return [!1, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize)
        return [!1, getTooSmallRejectionErr(minSize)];
    } else {
      if (isDefined(minSize) && file.size < minSize)
        return [!1, getTooSmallRejectionErr(minSize)];
      if (isDefined(maxSize) && file.size > maxSize)
        return [!1, getTooLargeRejectionErr(maxSize)];
    }
  return [!0, null];
}
__name(fileMatchSize, "fileMatchSize");
function isDefined(value) {
  return value != null;
}
__name(isDefined, "isDefined");
function allFilesAccepted(_ref) {
  var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
  return !multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles ? !1 : files.every(function(file) {
    var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray$e(_fileAccepted, 1), accepted = _fileAccepted2[0], _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray$e(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0], customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
}
__name(allFilesAccepted, "allFilesAccepted");
function isPropagationStopped(event) {
  return typeof event.isPropagationStopped == "function" ? event.isPropagationStopped() : typeof event.cancelBubble < "u" ? event.cancelBubble : !1;
}
__name(isPropagationStopped, "isPropagationStopped");
function isEvtWithFiles(event) {
  return event.dataTransfer ? Array.prototype.some.call(event.dataTransfer.types, function(type) {
    return type === "Files" || type === "application/x-moz-file";
  }) : !!event.target && !!event.target.files;
}
__name(isEvtWithFiles, "isEvtWithFiles");
function onDocumentDragOver(event) {
  event.preventDefault();
}
__name(onDocumentDragOver, "onDocumentDragOver");
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
__name(isIe, "isIe");
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
__name(isEdge, "isEdge");
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
__name(isIeOrEdge, "isIeOrEdge");
function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)
    fns[_key] = arguments[_key];
  return function(event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)
      args[_key2 - 1] = arguments[_key2];
    return fns.some(function(fn) {
      return !isPropagationStopped(event) && fn && fn.apply(void 0, [event].concat(args)), isPropagationStopped(event);
    });
  };
}
__name(composeEventHandlers, "composeEventHandlers");
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
__name(canUseFileSystemAccessAPI, "canUseFileSystemAccessAPI");
function pickerOptionsFromAccept(accept) {
  return isDefined(accept) ? Object.entries(accept).filter(function(_ref2) {
    var _ref3 = _slicedToArray$e(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1], ok2 = !0;
    return isMIMEType(mimeType) || (console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), ok2 = !1), (!Array.isArray(ext) || !ext.every(isExt)) && (console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.')), ok2 = !1), ok2;
  }).map(function(_ref4) {
    var _ref5 = _slicedToArray$e(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
    return {
      accept: _defineProperty$B({}, mimeType, ext)
    };
  }) : accept;
}
__name(pickerOptionsFromAccept, "pickerOptionsFromAccept");
function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept))
    return Object.entries(accept).reduce(function(a4, _ref6) {
      var _ref7 = _slicedToArray$e(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
      return [].concat(_toConsumableArray$c(a4), [mimeType], _toConsumableArray$c(ext));
    }, []).filter(function(v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
}
__name(acceptPropAsAcceptAttr, "acceptPropAsAcceptAttr");
function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
__name(isAbort, "isAbort");
function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
__name(isSecurityError, "isSecurityError");
function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
__name(isMIMEType, "isMIMEType");
function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
__name(isExt, "isExt");
var _excluded$f = ["children"], _excluded2$5 = ["open"], _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray$b(arr) {
  return _arrayWithoutHoles$b(arr) || _iterableToArray$c(arr) || _unsupportedIterableToArray$l(arr) || _nonIterableSpread$b();
}
__name(_toConsumableArray$b, "_toConsumableArray$b");
function _nonIterableSpread$b() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$b, "_nonIterableSpread$b");
function _iterableToArray$c(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$c, "_iterableToArray$c");
function _arrayWithoutHoles$b(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$l(arr);
}
__name(_arrayWithoutHoles$b, "_arrayWithoutHoles$b");
function _slicedToArray$d(arr, i2) {
  return _arrayWithHoles$e(arr) || _iterableToArrayLimit$d(arr, i2) || _unsupportedIterableToArray$l(arr, i2) || _nonIterableRest$e();
}
__name(_slicedToArray$d, "_slicedToArray$d");
function _nonIterableRest$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$e, "_nonIterableRest$e");
function _unsupportedIterableToArray$l(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$l(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$l(o, minLen);
  }
}
__name(_unsupportedIterableToArray$l, "_unsupportedIterableToArray$l");
function _arrayLikeToArray$l(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$l, "_arrayLikeToArray$l");
function _iterableToArrayLimit$d(arr, i2) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _arr = [], _n = !0, _d = !1, _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i2 && _arr.length === i2)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
__name(_iterableToArrayLimit$d, "_iterableToArrayLimit$d");
function _arrayWithHoles$e(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$e, "_arrayWithHoles$e");
function ownKeys$x(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols2 = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols2 = symbols2.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols2);
  }
  return keys2;
}
__name(ownKeys$x, "ownKeys$x");
function _objectSpread$x(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$x(Object(source), !0).forEach(function(key) {
      _defineProperty$A(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$x(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
__name(_objectSpread$x, "_objectSpread$x");
function _defineProperty$A(obj2, key, value) {
  return key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$A, "_defineProperty$A");
function _objectWithoutProperties$f(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$f(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$f, "_objectWithoutProperties$f");
function _objectWithoutPropertiesLoose$f(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$f, "_objectWithoutPropertiesLoose$f");
var Dropzone$1 = /* @__PURE__ */ forwardRef(function(_ref, ref) {
  var children = _ref.children, params = _objectWithoutProperties$f(_ref, _excluded$f), _useDropzone = useDropzone(params), open = _useDropzone.open, props = _objectWithoutProperties$f(_useDropzone, _excluded2$5);
  return useImperativeHandle(ref, function() {
    return {
      open
    };
  }, [open]), /* @__PURE__ */ React__default.createElement(Fragment$1, null, children(_objectSpread$x(_objectSpread$x({}, props), {}, {
    open
  })));
});
Dropzone$1.displayName = "Dropzone";
var defaultProps$3 = {
  disabled: !1,
  getFilesFromEvent: fromEvent,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
Dropzone$1.defaultProps = defaultProps$3;
Dropzone$1.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
var initialState = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _defaultProps$props = _objectSpread$x(_objectSpread$x({}, defaultProps$3), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator, acceptAttr = useMemo(function() {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]), pickerTypes = useMemo(function() {
    return pickerOptionsFromAccept(accept);
  }, [accept]), onFileDialogOpenCb = useMemo(function() {
    return typeof onFileDialogOpen == "function" ? onFileDialogOpen : noop$3;
  }, [onFileDialogOpen]), onFileDialogCancelCb = useMemo(function() {
    return typeof onFileDialogCancel == "function" ? onFileDialogCancel : noop$3;
  }, [onFileDialogCancel]), rootRef = useRef(null), inputRef = useRef(null), _useReducer = useReducer(reducer, initialState), _useReducer2 = _slicedToArray$d(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1], isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, fsAccessApiWorksRef = useRef(typeof window < "u" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()), onWindowFocus = /* @__PURE__ */ __name(function() {
    !fsAccessApiWorksRef.current && isFileDialogActive && setTimeout(function() {
      if (inputRef.current) {
        var files = inputRef.current.files;
        files.length || (dispatch({
          type: "closeDialog"
        }), onFileDialogCancelCb());
      }
    }, 300);
  }, "onWindowFocus");
  useEffect(function() {
    return window.addEventListener("focus", onWindowFocus, !1), function() {
      window.removeEventListener("focus", onWindowFocus, !1);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]), onDocumentDrop = /* @__PURE__ */ __name(function(event) {
    rootRef.current && rootRef.current.contains(event.target) || (event.preventDefault(), dragTargetsRef.current = []);
  }, "onDocumentDrop");
  useEffect(function() {
    return preventDropOnDocument && (document.addEventListener("dragover", onDocumentDragOver, !1), document.addEventListener("drop", onDocumentDrop, !1)), function() {
      preventDropOnDocument && (document.removeEventListener("dragover", onDocumentDragOver), document.removeEventListener("drop", onDocumentDrop));
    };
  }, [rootRef, preventDropOnDocument]), useEffect(function() {
    return !disabled && autoFocus && rootRef.current && rootRef.current.focus(), function() {
    };
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function(e3) {
    onError ? onError(e3) : console.error(e3);
  }, [onError]), onDragEnterCb = useCallback(function(event) {
    event.preventDefault(), event.persist(), stopPropagation(event), dragTargetsRef.current = [].concat(_toConsumableArray$b(dragTargetsRef.current), [event.target]), isEvtWithFiles(event) && Promise.resolve(getFilesFromEvent(event)).then(function(files) {
      if (!(isPropagationStopped(event) && !noDragEventsBubbling)) {
        var fileCount = files.length, isDragAccept = fileCount > 0 && allFilesAccepted({
          files,
          accept: acceptAttr,
          minSize,
          maxSize,
          multiple,
          maxFiles,
          validator
        }), isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept,
          isDragReject,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), onDragEnter && onDragEnter(event);
      }
    }).catch(function(e3) {
      return onErrCb(e3);
    });
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]), onDragOverCb = useCallback(function(event) {
    event.preventDefault(), event.persist(), stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer)
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return hasFiles && onDragOver && onDragOver(event), !1;
  }, [onDragOver, noDragEventsBubbling]), onDragLeaveCb = useCallback(function(event) {
    event.preventDefault(), event.persist(), stopPropagation(event);
    var targets = dragTargetsRef.current.filter(function(target) {
      return rootRef.current && rootRef.current.contains(target);
    }), targetIdx = targets.indexOf(event.target);
    targetIdx !== -1 && targets.splice(targetIdx, 1), dragTargetsRef.current = targets, !(targets.length > 0) && (dispatch({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), isEvtWithFiles(event) && onDragLeave && onDragLeave(event));
  }, [rootRef, onDragLeave, noDragEventsBubbling]), setFiles = useCallback(function(files, event) {
    var acceptedFiles = [], fileRejections = [];
    files.forEach(function(file) {
      var _fileAccepted = fileAccepted(file, acceptAttr), _fileAccepted2 = _slicedToArray$d(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1], _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray$d(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1], customErrors = validator ? validator(file) : null;
      if (accepted && sizeMatch && !customErrors)
        acceptedFiles.push(file);
      else {
        var errors = [acceptError, sizeError];
        customErrors && (errors = errors.concat(customErrors)), fileRejections.push({
          file,
          errors: errors.filter(function(e3) {
            return e3;
          })
        });
      }
    }), (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) && (acceptedFiles.forEach(function(file) {
      fileRejections.push({
        file,
        errors: [TOO_MANY_FILES_REJECTION]
      });
    }), acceptedFiles.splice(0)), dispatch({
      acceptedFiles,
      fileRejections,
      type: "setFiles"
    }), onDrop && onDrop(acceptedFiles, fileRejections, event), fileRejections.length > 0 && onDropRejected && onDropRejected(fileRejections, event), acceptedFiles.length > 0 && onDropAccepted && onDropAccepted(acceptedFiles, event);
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]), onDropCb = useCallback(function(event) {
    event.preventDefault(), event.persist(), stopPropagation(event), dragTargetsRef.current = [], isEvtWithFiles(event) && Promise.resolve(getFilesFromEvent(event)).then(function(files) {
      isPropagationStopped(event) && !noDragEventsBubbling || setFiles(files, event);
    }).catch(function(e3) {
      return onErrCb(e3);
    }), dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]), openFileDialog = useCallback(function() {
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      }), onFileDialogOpenCb();
      var opts = {
        multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function(handles) {
        return getFilesFromEvent(handles);
      }).then(function(files) {
        setFiles(files, null), dispatch({
          type: "closeDialog"
        });
      }).catch(function(e3) {
        isAbort(e3) ? (onFileDialogCancelCb(e3), dispatch({
          type: "closeDialog"
        })) : isSecurityError(e3) ? (fsAccessApiWorksRef.current = !1, inputRef.current ? (inputRef.current.value = null, inputRef.current.click()) : onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : onErrCb(e3);
      });
      return;
    }
    inputRef.current && (dispatch({
      type: "openDialog"
    }), onFileDialogOpenCb(), inputRef.current.value = null, inputRef.current.click());
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]), onKeyDownCb = useCallback(function(event) {
    !rootRef.current || !rootRef.current.isEqualNode(event.target) || (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) && (event.preventDefault(), openFileDialog());
  }, [rootRef, openFileDialog]), onFocusCb = useCallback(function() {
    dispatch({
      type: "focus"
    });
  }, []), onBlurCb = useCallback(function() {
    dispatch({
      type: "blur"
    });
  }, []), onClickCb = useCallback(function() {
    noClick || (isIeOrEdge() ? setTimeout(openFileDialog, 0) : openFileDialog());
  }, [noClick, openFileDialog]), composeHandler = /* @__PURE__ */ __name(function(fn) {
    return disabled ? null : fn;
  }, "composeHandler"), composeKeyboardHandler = /* @__PURE__ */ __name(function(fn) {
    return noKeyboard ? null : composeHandler(fn);
  }, "composeKeyboardHandler"), composeDragHandler = /* @__PURE__ */ __name(function(fn) {
    return noDrag ? null : composeHandler(fn);
  }, "composeDragHandler"), stopPropagation = /* @__PURE__ */ __name(function(event) {
    noDragEventsBubbling && event.stopPropagation();
  }, "stopPropagation"), getRootProps = useMemo(function() {
    return function() {
      var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick2 = _ref2.onClick, onDragEnter2 = _ref2.onDragEnter, onDragOver2 = _ref2.onDragOver, onDragLeave2 = _ref2.onDragLeave, onDrop2 = _ref2.onDrop, rest = _objectWithoutProperties$f(_ref2, _excluded3);
      return _objectSpread$x(_objectSpread$x(_defineProperty$A({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick2, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter2, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver2, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave2, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop2, onDropCb)),
        role: typeof role == "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]), onInputElementClick = useCallback(function(event) {
    event.stopPropagation();
  }, []), getInputProps = useMemo(function() {
    return function() {
      var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange5 = _ref3.onChange, onClick2 = _ref3.onClick, rest = _objectWithoutProperties$f(_ref3, _excluded4), inputProps = _defineProperty$A({
        accept: acceptAttr,
        multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange5, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick2, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread$x(_objectSpread$x({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread$x(_objectSpread$x({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps,
    getInputProps,
    rootRef,
    inputRef,
    open: composeHandler(openFileDialog)
  });
}
__name(useDropzone, "useDropzone");
function reducer(state, action) {
  switch (action.type) {
    case "focus":
      return _objectSpread$x(_objectSpread$x({}, state), {}, {
        isFocused: !0
      });
    case "blur":
      return _objectSpread$x(_objectSpread$x({}, state), {}, {
        isFocused: !1
      });
    case "openDialog":
      return _objectSpread$x(_objectSpread$x({}, initialState), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return _objectSpread$x(_objectSpread$x({}, state), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return _objectSpread$x(_objectSpread$x({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });
    case "setFiles":
      return _objectSpread$x(_objectSpread$x({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });
    case "reset":
      return _objectSpread$x({}, initialState);
    default:
      return state;
  }
}
__name(reducer, "reducer");
function noop$3() {
}
__name(noop$3, "noop$3");
const makeDropzoneColor = /* @__PURE__ */ __name(({
  isDragActive: isDragActive2,
  variant
}) => isDragActive2 ? css`
      border: 1px solid ${getColor$2("primary-700")};
      border-top: ${variant === "secondary" ? "none" : void 0};
      background-color: ${getColor$2("primary-100")};
    ` : css`
    border: 1px dashed ${getColor$2("neutral-600")};
    border-top: ${variant === "secondary" ? "none" : void 0};
  `, "makeDropzoneColor"), DropzoneArea = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${({ backgroundColor: backgroundColor2, bg, background: background2 }) => backgroundColor2 ?? bg ?? background2 ?? getColor$2("neutral-100")};
  cursor: pointer;
  padding: ${getSpace$1("xxl")} ${getSpace$1("xl")};

  ${makeDropzoneColor}

  ${({ disabled }) => disabled && css`
      background-color: ${getColor$2("neutral-200")};
      border: 1px solid ${getColor$2("neutral-400")};
      cursor: not-allowed;
    `}

  &:hover {
    border: 1px solid ${getColor$2("neutral-600")};
  }
`;
function DropzoneTextElement({
  children,
  ...typographyProps
}) {
  return typeof children == "string" ? /* @__PURE__ */ jsx(Typography, { ...typographyProps, children }) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ jsx(Fragment, { children })
  );
}
__name(DropzoneTextElement, "DropzoneTextElement");
function Dropzone({
  dropzoneOptions,
  children,
  errorText,
  "data-test": dataTest = "dropzone",
  disabled = !1,
  text: text2,
  subtext,
  ...otherProps
}) {
  const { getRootProps, getInputProps, isDragActive: isDragActive2, fileRejections } = useDropzone({
    ...dropzoneOptions,
    disabled
  }), error = fileRejections.length ? errorText || fileRejections[0].errors[0].message : void 0;
  return /* @__PURE__ */ jsxs(Spacer, { direction: "vertical", space: "xxs", fluid: !0, children: [
    /* @__PURE__ */ jsxs(
      DropzoneArea,
      {
        "data-test": dataTest,
        ...getRootProps({ isDragActive: isDragActive2 }),
        ...otherProps,
        disabled,
        children: [
          /* @__PURE__ */ jsx("input", { ...getInputProps(), "data-test": `${dataTest}-input` }),
          (text2 || subtext) && /* @__PURE__ */ jsxs(Spacer, { direction: "vertical", space: "xxxs", alignItems: "center", children: [
            text2 && /* @__PURE__ */ jsx(
              DropzoneTextElement,
              {
                variant: "bodyMediumM",
                color: "neutral-800",
                textAlign: "center",
                children: text2
              }
            ),
            subtext && /* @__PURE__ */ jsx(
              DropzoneTextElement,
              {
                variant: "bodyRegularM",
                color: "neutral-400",
                textAlign: "center",
                children: subtext
              }
            )
          ] }),
          children
        ]
      }
    ),
    error && /* @__PURE__ */ jsxs(
      Banner,
      {
        "data-test": `${dataTest}-error-banner`,
        variant: "critical",
        inline: !0,
        children: [
          /* @__PURE__ */ jsx(BannerIcon, {}),
          /* @__PURE__ */ jsx(BannerHeading, { children: error })
        ]
      }
    )
  ] });
}
__name(Dropzone, "Dropzone");
function LiveDuration({ seconds, ...restProps }) {
  const [liveSeconds, setLiveSeconds] = useState(seconds);
  return useEffect(() => {
    setLiveSeconds(seconds);
  }, [seconds]), useEffect(() => {
    const interval = setInterval(() => {
      setLiveSeconds((prevSeconds) => prevSeconds + 1);
    }, 1e3);
    return () => clearInterval(interval);
  }, []), /* @__PURE__ */ jsx(Duration, { seconds: liveSeconds, ...restProps });
}
__name(LiveDuration, "LiveDuration");
function Duration({
  extended = !0,
  seconds,
  children,
  isLive = !1,
  ...restProps
}) {
  if (isLive)
    return /* @__PURE__ */ jsx(LiveDuration, { seconds, ...restProps, children });
  const formattedDuration = formatSecondsToDuration(seconds, extended), text2 = children ? children(formattedDuration) : formattedDuration;
  return /* @__PURE__ */ jsx(Typography, { ...restProps, children: text2 });
}
__name(Duration, "Duration");
const editableSuccessStyles = css`
  background: none;

  &:hover {
    outline: 1px solid;
    outline-color: graphic-interactive-default-hover;
    background-color: surface-interactive-primary-ghost-hover;
  }

  &:focus {
    outline: 2px solid;
    outline-color: graphic-interactive-default-active;
    background: none;
  }

  ${({ focus }) => focus && css`
      outline: 2px solid !important;
      outline-color: graphic-interactive-default-active !important;
      background: none !important;
    `}
`, editableErrorStyles = css`
  background-color: surface-interactive-critical-ghost-hover;

  &:hover {
    outline: 1px solid;
    outline-color: graphic-interactive-critical-hover;
  }

  &:focus {
    outline: 2px solid;
    outline-color: graphic-interactive-critical;
  }

  ${({ focus }) => focus && css`
      outline: 2px solid !important;
      outline-color: graphic-interactive-critical !important;
    `}
`, editableBaseStyles = css`
  padding: xxxs;
  // We don't want the padding between the textarea and the border to be visible
  margin: -xxxs;

  border-radius: sm;
  border: 1px solid;
  border-color: transparent;
  color: text-base;
  border: none;
  outline: none;
  line-height: 1.4;
  background-color: transparent;
  white-space: pre-wrap;
  width: 100%;

  &::placeholder {
    color: text-placeholder;
  }

  ${({ validationStatus }) => validationStatus === "error" ? editableErrorStyles : editableSuccessStyles}
`, editableStylesWithVariant = /* @__PURE__ */ __name((variant) => css`
  ${editableBaseStyles}
  ${({ theme }) => ({
  fontSize: theme.typography[variant].fontSize,
  fontWeight: theme.typography[variant].fontWeight,
  lineHeight: theme.typography[variant].lineHeight
})}
`, "editableStylesWithVariant"), STextarea = styled.textarea`
  ${({ variant }) => editableStylesWithVariant(variant)}
  resize: none;
  overflow: hidden;
`;
function EditableTextarea({
  defaultValue,
  onSubmit,
  placeholder,
  "data-test": dataTest = "editable-textarea",
  validationStatus = "success",
  variant = "bodyRegularS",
  ...props
}) {
  const [value, setValue] = useState(defaultValue ?? ""), textareaRef = useRef(null);
  useEffect(() => {
    setValue(defaultValue ?? "");
  }, [defaultValue]);
  const adjustHeight = useCallback(() => {
    const textarea = textareaRef.current;
    textarea && (textarea.style.height = "auto", textarea.style.height = `${textarea.scrollHeight}px`);
  }, []);
  return useEffect(() => {
    adjustHeight();
  }, [value, adjustHeight]), /* @__PURE__ */ jsx(
    STextarea,
    {
      "data-test": dataTest,
      ref: textareaRef,
      onBlur: /* @__PURE__ */ __name(() => {
        onSubmit == null || onSubmit(value.trim());
      }, "handleSubmit"),
      onKeyDown: /* @__PURE__ */ __name((e3) => {
        var _a3;
        e3.key === "Enter" && !e3.shiftKey && (e3.preventDefault(), (_a3 = textareaRef.current) == null || _a3.blur());
      }, "handleKeyDown"),
      placeholder,
      value,
      rows: 1,
      validationStatus,
      variant,
      ...props,
      onChange: (e3) => {
        setValue(e3.target.value);
      }
    }
  );
}
__name(EditableTextarea, "EditableTextarea");
const Trigger = styled(Flex)`
  ${editableBaseStyles}
  cursor: pointer;
`;
function EditableSelect({
  options,
  defaultValue,
  placeholder,
  onChange: onChange5,
  "data-test": dataTest = "editable-select",
  validationStatus = "success",
  variant = "bodyRegularS",
  ...triggerProps
}) {
  const [value, setValue] = useState(defaultValue), [isOpen, setIsOpen] = useState(!1), selectedOption = options.find((option) => option.value === value);
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  function handleSelect(selectedValue) {
    setValue(selectedValue), onChange5(selectedValue), setIsOpen(!1);
  }
  return __name(handleSelect, "handleSelect"), /* @__PURE__ */ jsxs(
    Popover.Root,
    {
      open: isOpen,
      onOpenChange: (open) => {
        setIsOpen(open);
      },
      children: [
        /* @__PURE__ */ jsx(Popover.Trigger, { onClick: () => setIsOpen((o) => !o), children: /* @__PURE__ */ jsx(
          Trigger,
          {
            ...triggerProps,
            focus: isOpen,
            validationStatus,
            children: selectedOption ? /* @__PURE__ */ jsx(
              Typography,
              {
                "data-test": `${dataTest}-trigger`,
                variant,
                color: "text-base",
                children: selectedOption.label
              }
            ) : /* @__PURE__ */ jsx(Typography, { variant, color: "text-placeholder", children: placeholder })
          }
        ) }),
        isOpen && /* @__PURE__ */ jsx(
          Popover.Content,
          {
            bg: "white",
            boxShadow: 1,
            borderRadius: "sm",
            p: "xxs",
            takeTriggerWidth: !0,
            closeOnOutsideClick: !0,
            sideOffset: 8,
            children: /* @__PURE__ */ jsx(Menu, { selectionMode: "none", size: "regular", w: "100%", children: options.map((option) => /* @__PURE__ */ jsxs(
              MenuItem,
              {
                onClick: () => handleSelect(option.value),
                children: [
                  /* @__PURE__ */ jsx(MenuItemLabel, { children: option.label }),
                  value === option.value && /* @__PURE__ */ jsx(MenuItemSuffix, { children: /* @__PURE__ */ jsx(
                    CheckedCircleOutlined,
                    {
                      "data-test": `${dataTest}-checkmark`,
                      color: "icon-primary"
                    }
                  ) })
                ]
              },
              `${option.value}`
            )) })
          }
        )
      ]
    }
  );
}
__name(EditableSelect, "EditableSelect");
const SInput = styled.input`
  ${({ variant }) => editableStylesWithVariant(variant)}
`;
function EditableInput({
  value,
  onSubmit,
  placeholder,
  "data-test": dataTest = "editable-textarea",
  validationStatus = "success",
  variant = "bodyRegularS",
  selectAllOnFocus = !1,
  truncate: truncate2 = 0,
  onFocus,
  onBlur,
  onChange: onChange5,
  ...props
}) {
  const inputRef = useRef(null), [isFocused, setIsFocused] = useState(!1), shouldTruncate = !isFocused && truncate2 > 0;
  function truncateValue(v) {
    const str = v ?? "";
    return str.length > truncate2 ? `${str.substring(0, truncate2)}...` : str;
  }
  __name(truncateValue, "truncateValue");
  const displayValue = shouldTruncate ? truncateValue(value) : value, adjustHeight = useCallback(() => {
    const textarea = inputRef.current;
    textarea && (textarea.style.height = "auto", textarea.style.height = `${textarea.scrollHeight}px`);
  }, []);
  useEffect(() => {
    adjustHeight();
  }, [value, adjustHeight]);
  const handleBlur = /* @__PURE__ */ __name((e3) => {
    setIsFocused(!1), onSubmit == null || onSubmit((value == null ? void 0 : value.trim()) ?? ""), onBlur == null || onBlur(e3);
  }, "handleBlur"), handleChange = /* @__PURE__ */ __name((e3) => {
    onChange5 == null || onChange5(e3.target.value);
  }, "handleChange");
  function handleFocus(e3) {
    setIsFocused(!0), selectAllOnFocus && setTimeout(() => {
      var _a3;
      (_a3 = inputRef.current) == null || _a3.select();
    }, 0), onFocus == null || onFocus(e3);
  }
  return __name(handleFocus, "handleFocus"), /* @__PURE__ */ jsx(
    SInput,
    {
      "data-test": dataTest,
      ref: inputRef,
      placeholder,
      value: displayValue,
      validationStatus,
      variant,
      ...props,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      onKeyDown: /* @__PURE__ */ __name((e3) => {
        var _a3;
        (e3.key === "Enter" && !e3.shiftKey || e3.key === "Escape") && (e3.preventDefault(), (_a3 = inputRef.current) == null || _a3.blur());
      }, "handleKeyDown")
    }
  );
}
__name(EditableInput, "EditableInput");
const EMOJI_SIZES = {
  large: 28,
  regular: 18,
  small: 12
}, Wrapper = styled(Flex)`
  height: fit-content;
  & > span {
    display: inline-flex;
  }
`, Emoji2 = React__default.memo(({ name: name2, size = "large" }) => {
  var _a3;
  const sizeNum = EMOJI_SIZES[size], id2 = ((_a3 = getEmoji(name2)) == null ? void 0 : _a3.id) || name2;
  return /* @__PURE__ */ jsx(Wrapper, { "data-test": "emoji", children: /* @__PURE__ */ jsx(Emoji$1, { set: "apple", size: sizeNum, emoji: id2 }) });
}), EmojiAvatar = React__default.memo(
  ({ name: name2, size = "large" }) => /* @__PURE__ */ jsx(Avatar$1, { size, variant: "default", "data-test": "emoji-avatar", children: /* @__PURE__ */ jsx(Emoji2, { name: name2, size }) })
);
import("./emoji-mart-daf8cd6d.mjs");
const EmojiPickerText = styled(Box)`
  align-items: center;
  justify-content: center;
  gap: ${getSpace$1("xxs")};

  > .emoji-mart-emoji {
    margin-right: ${getSpace$1("xxs")};
  }

  &:hover {
    border-color: ${getColor$2("neutral-300")};
  }
`, EmojiPickerDropdown = styled(Box)`
  .emoji-mart {
    border: 1px solid ${getColor$2("neutral-200")};
    border-radius: ${getRadii("sm")};
    font-family: inherit;
    font-size: 1rem;

    &-bar {
      border: 0;
    }

    &-anchor {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: ${getSpace$1("xxs")};
      color: ${getColor$2("neutral-400")};
      cursor: pointer;

      &:hover {
        color: ${getColor$2("black")};
      }

      > span {
        display: none;
      }

      &-selected {
        > div {
          color: ${getColor$2("primary-500")} !important;
        }
      }
    }

    &-search {
      margin: 0 ${getSpace$1("xxs")} ${getSpace$1("xxs")};

      > input {
        border-radius: ${getRadii("sm")};
      }
    }

    &-scroll {
      padding: 0 ${getSpace$1("xxs")};
    }

    &-category-label > span {
      padding: ${getSpace$1("xxs")};
      background: ${getColor$2("neutral-0")};
    }

    &-category-list > li {
      margin: 1px;
      cursor: pointer;
    }

    &-category .emoji-mart-emoji {
      cursor: inherit;
      ${({ selectedEmoji }) => !!selectedEmoji && css`
          &[aria-label="${selectedEmoji}"]::before {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: ${getColor$2("primary-500")};
            border-radius: ${getRadii("sm")};
            content: "";
          }
        `}
      outline: 0;

      > span {
        cursor: inherit;
      }

      &:hover::before {
        background-color: ${getColor$2("neutral-300")};
        border-radius: ${getRadii("sm")};
      }
    }

    &-preview {
      height: max-content;

      &-skins {
        position: relative;
        top: 0;
        right: 0;
        left: 0;
        width: max-content;
        padding: ${getSpace$1("xxs")};
        transform: translate(0);
      }

      &-data,
      &-emoji {
        display: none;
      }
    }

    &-skin {
      &-swatches {
        border: 0;
        background: transparent;
      }

      &-swatch {
        > span {
          outline: 0;
        }
      }
    }
  }
`, EmojiPicker = memo$1(
  ({
    defaultValue,
    value,
    onChange: onChange5 = noop$5,
    closeOnSelect = !0,
    name: name2,
    pullRight = !1,
    autoFocus = !1,
    hideSkinSelector = !1,
    "data-test": dataTest = "emoji-picker"
  }) => {
    const [open, setOpen] = useState(autoFocus), [emoji, setEmoji] = useState(
      useMemo(() => getDerivedEmoji(defaultValue, value), [value, defaultValue])
    ), containerRef = useRef(null);
    useEffect(() => {
      !defaultValue && value && setEmoji(getDerivedEmoji(defaultValue, value));
    }, [value, defaultValue]);
    const toggleOpen = useCallback(() => {
      setOpen(!open);
    }, [setOpen, open]);
    useEffect(() => {
      const rootClose = /* @__PURE__ */ __name((e3) => {
        var _a3;
        (_a3 = containerRef.current) != null && _a3.contains(e3.target) || setOpen(!1);
      }, "rootClose"), closeOnEscape = /* @__PURE__ */ __name((e3) => {
        e3.key === "Escape" && open && setOpen(!1);
      }, "closeOnEscape");
      return document.addEventListener("click", rootClose, !0), document.addEventListener("keyup", closeOnEscape, !0), () => {
        document.removeEventListener("click", rootClose, !0), document.removeEventListener("keyup", closeOnEscape, !0);
      };
    }, [open]);
    const handleSelect = useCallback(
      (selectedEmoji) => {
        defaultValue && !value && setEmoji(selectedEmoji), onChange5(selectedEmoji), closeOnSelect && setOpen(!1);
      },
      [setEmoji, onChange5, defaultValue, value, closeOnSelect]
    );
    return /* @__PURE__ */ jsxs(Box, { ref: containerRef, "data-test": dataTest, position: "relative", children: [
      /* @__PURE__ */ jsxs(
        EmojiPickerText,
        {
          display: "inline-flex",
          h: "48px",
          p: "xs",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "neutral-200",
          borderRadius: "sm",
          background: "white",
          cursor: "pointer",
          onClick: toggleOpen,
          "data-test": `${dataTest}-text`,
          children: [
            /* @__PURE__ */ jsx(Emoji2, { name: emoji.id, size: "large" }),
            /* @__PURE__ */ jsx(
              Icon,
              {
                component: open ? ChevronUpOutlined : ChevronDownOutlined,
                size: 15,
                onClick: noop$5
              }
            ),
            /* @__PURE__ */ jsx(
              "input",
              {
                hidden: !0,
                value: emoji == null ? void 0 : emoji.id,
                readOnly: !0,
                name: name2,
                "data-test": `${dataTest}-text-input`
              }
            )
          ]
        }
      ),
      open && /* @__PURE__ */ jsx(
        EmojiPickerDropdown,
        {
          position: "absolute",
          zIndex: "1000",
          top: "calc(100% + 10px)",
          overflow: "hidden",
          ...pullRight ? { right: 0 } : { left: 0 },
          selectedEmoji: `${emoji.native}, ${emoji.id}`,
          "data-test": pullRight ? `${dataTest}-dropdown-right` : `${dataTest}-dropdown-left`,
          children: /* @__PURE__ */ jsx(
            Picker,
            {
              set: "apple",
              onSelect: handleSelect,
              autoFocus: !0,
              showPreview: !1,
              theme: "light",
              skinEmoji: "thumbsup",
              showSkinTones: !hideSkinSelector
            }
          )
        }
      )
    ] });
  }
), StyledImage = styled.img`
  border-radius: ${getRadii("default")};
`;
function EmptyStateView({
  "data-test": dataTest = "empty-state-view",
  children,
  imageSrc,
  text: text2,
  title,
  ...flexProps
}) {
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      alignItems: "center",
      "data-test": dataTest,
      flexDirection: "column",
      justifyContent: "center",
      gap: "xs",
      ...flexProps,
      children: [
        imageSrc && /* @__PURE__ */ jsx(StyledImage, { alt: "", src: imageSrc }),
        /* @__PURE__ */ jsx(Typography, { color: "text-highlight", variant: "headingBoldS", children: title }),
        text2 !== void 0 && /* @__PURE__ */ jsx(Typography, { color: "text-highlight", variant: "bodyRegularM", children: text2 }),
        children
      ]
    }
  );
}
__name(EmptyStateView, "EmptyStateView");
function isAtomicError(error) {
  return typeof error == "object" && error !== null && "extraInfo" in error;
}
__name(isAtomicError, "isAtomicError");
const _ErrorBoundary = class _ErrorBoundary extends Component {
  constructor(props) {
    super(props), this.state = { error: null, processed: !1 };
  }
  static getDerivedStateFromError(error) {
    return { error, processed: !1 };
  }
  componentDidUpdate(prevProps) {
    const { location } = this.props, { error } = this.state;
    location !== prevProps.location && error && this.setState({ error: null, processed: !1 });
  }
  componentDidCatch(error, info) {
    const { extensionInfo } = this.props, currentError = isAtomicError(error) ? error : new UnknownError(error.message);
    currentError.setExtraInfo({
      ...currentError.extraInfo,
      extensionInfo,
      info
    }), this.setState({ error: currentError, processed: !0 });
  }
  render() {
    const { error, processed } = this.state, { children } = this.props;
    if (!error)
      return children;
    if (!processed)
      return null;
    throw error;
  }
};
__name(_ErrorBoundary, "ErrorBoundary");
let ErrorBoundary = _ErrorBoundary;
const PlayerWrapper = styled(Grid)`
  flex: ${({ isExpanded }) => isExpanded ? "1" : "0"};
  grid-template-columns: ${({ isExpanded }) => isExpanded ? "auto 1fr" : "auto"};
  transition: all 0.5s ease-in-out;
`;
function Player$1({
  onPlay,
  onError,
  loading = !1,
  tooltipTexts,
  color: color2 = "default",
  "data-test": dataTest = "expandable-audio-player"
}) {
  const [hasBeenPlayedOnce, setHasBeenPlayedOnce] = useState(!1), { isPlaying, error } = useAudio();
  return useEffect(() => {
    error && (onError == null || onError(error));
  }, [error, onError]), useEffect(() => {
    !hasBeenPlayedOnce && isPlaying && (setHasBeenPlayedOnce(!0), onPlay == null || onPlay());
  }, [onPlay, hasBeenPlayedOnce, isPlaying]), /* @__PURE__ */ jsxs(PlayerWrapper, { isExpanded: hasBeenPlayedOnce, gap: "xxs", children: [
    /* @__PURE__ */ jsx(
      ConditionalTooltip,
      {
        visible: !!tooltipTexts,
        title: isPlaying ? tooltipTexts == null ? void 0 : tooltipTexts.pause : tooltipTexts == null ? void 0 : tooltipTexts.play,
        align: "center",
        side: "top",
        mouseEnterDelay: 0,
        mouseLeaveDelay: 100,
        children: /* @__PURE__ */ jsx(Box, { w: "fit-content", "data-test": `${dataTest}-play-button`, children: /* @__PURE__ */ jsx(PlayButton, { loading, color: color2 }) })
      }
    ),
    /* @__PURE__ */ jsx(AnimatePresence, { children: hasBeenPlayedOnce && /* @__PURE__ */ jsxs(
      MotionBox$2,
      {
        animate: { opacity: 1 },
        initial: { opacity: 0 },
        exit: { opacity: 0 },
        "data-test": `${dataTest}-audio-bar`,
        children: [
          /* @__PURE__ */ jsxs(Flex, { justifyContent: "space-between", pb: "xxs", children: [
            /* @__PURE__ */ jsx(AudioCurrentTime, {}),
            /* @__PURE__ */ jsx(AudioDuration, {})
          ] }),
          /* @__PURE__ */ jsx(AudioBar, { color: color2 })
        ]
      }
    ) })
  ] });
}
__name(Player$1, "Player$1");
function ExpandableAudioPlayer({
  src,
  ...playerProps
}) {
  return /* @__PURE__ */ jsx(AudioManager, { children: /* @__PURE__ */ jsx(Audio, { src, children: /* @__PURE__ */ jsx(Player$1, { ...playerProps }) }) });
}
__name(ExpandableAudioPlayer, "ExpandableAudioPlayer");
const Input$1 = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: ${getSpace$1("s")} ${getSpace$1("xs")};
  border: 1px dashed ${getColor$2("neutral-200")};
  border-radius: ${getRadii("sm")};
  background: ${getColor$2("neutral-0")};
  color: ${getColor$2("neutral-400")};
`;
function FileInput({
  file,
  onRemove,
  "data-test": dataTest
}) {
  return /* @__PURE__ */ jsxs(Input$1, { "data-test": dataTest, children: [
    file.name,
    /* @__PURE__ */ jsx(
      IconButton,
      {
        type: "button",
        "data-test": `${dataTest}-remove`,
        onClick: onRemove,
        size: 24,
        component: CloseCircleFilled,
        color: "neutral-200"
      }
    )
  ] });
}
__name(FileInput, "FileInput");
function PasswordField({
  name: name2,
  "data-test": dataTest = "password-field",
  ...passwordFieldProps
}) {
  return /* @__PURE__ */ jsx(PasswordInput, { id: name2, "data-test": dataTest, ...passwordFieldProps });
}
__name(PasswordField, "PasswordField");
const TextFieldWithEllipsis = styled(TextInput)`
  ${({ ellipsis }) => ellipsis && "text-overflow: ellipsis"};
  ${({ hasHelperText }) => hasHelperText && "border-radius: 0 8px 8px 0;"};
`;
function TextField({
  helperText,
  name: name2,
  "data-test": dataTest = "text-field",
  ...textFieldProps
}) {
  return /* @__PURE__ */ jsx(
    TextFieldWithEllipsis,
    {
      id: name2,
      hasHelperText: !!helperText,
      "data-test": dataTest,
      ...textFieldProps
    }
  );
}
__name(TextField, "TextField");
const HelperText = styled(Flex)`
  align-items: center;
  background-color: ${getColor$2("background-01")};
  border-bottom: 1px solid ${getColor$2("input-border-01")};
  border-left: 1px solid ${getColor$2("input-border-01")};
  border-radius: 8px 0 0 8px;
  border-top: 1px solid ${getColor$2("input-border-01")};
  padding: 0 16px;
  white-space: nowrap;
`, GridContainer = styled(Grid)`
  position: relative;

  ${({ hasHelperText }) => hasHelperText && "grid-template-columns: fit-content(100%) 1fr;"}
`;
function FieldInput(props) {
  const { type } = props;
  switch (type) {
    case "password":
      return /* @__PURE__ */ jsx(PasswordField, { ...props });
    case "text":
    default:
      return /* @__PURE__ */ jsx(TextField, { ...props });
  }
}
__name(FieldInput, "FieldInput");
function FormField({
  autoFocus = !1,
  clearable,
  defaultValue,
  disabled,
  ellipsis = !1,
  getErrorMessage,
  helperText,
  label,
  name: name2,
  placeholder,
  type = "text",
  validate,
  validateInitial,
  ...formFieldProps
}) {
  return /* @__PURE__ */ jsx(
    Field,
    {
      component: "input",
      type,
      name: name2,
      validate,
      initialValue: defaultValue,
      format: trimWhiteSpaces,
      formatOnBlur: !0,
      children: ({
        input: { onBlur, onChange: onChange5, value },
        meta: { error, submitError, touched }
      }) => {
        const validationError = error ?? submitError, shouldShowError = (touched || validateInitial) && validationError;
        return /* @__PURE__ */ jsx(
          FormItem,
          {
            label,
            name: name2,
            helpText: shouldShowError && getErrorMessage(validationError),
            validationStatus: shouldShowError && "error",
            gridAutoRows: "max-content",
            children: /* @__PURE__ */ jsxs(GridContainer, { hasHelperText: !!helperText, children: [
              helperText && /* @__PURE__ */ jsx(HelperText, { children: helperText }),
              /* @__PURE__ */ jsx(
                FieldInput,
                {
                  autoFocus,
                  disabled,
                  ellipsis,
                  helperText,
                  id: name2,
                  label,
                  name: name2,
                  onBlur,
                  onChange: onChange5,
                  onClear: clearable && value ? () => onChange5("") : void 0,
                  placeholder,
                  type,
                  value,
                  ...formFieldProps
                }
              )
            ] })
          }
        );
      }
    }
  );
}
__name(FormField, "FormField");
function GraphQuery({
  children,
  query,
  queryOptions,
  "data-test": dataTest = "graph-query"
}) {
  const { data: data2, loading } = useGraphQuery(query, {
    ...queryOptions,
    throwError: !0
  });
  return loading && !data2 ? /* @__PURE__ */ jsx(Loading, { "data-test": `${dataTest}-loading`, size: 30 }) : children({ data: data2 });
}
__name(GraphQuery, "GraphQuery");
function HasAccess({
  action = PERMISSIONS_ACTIONS.READ,
  children,
  shouldThrow = !1,
  resource,
  oneOf
}) {
  const { checkAccess } = usePermissions();
  if (!(oneOf ? oneOf.some((r2) => checkAccess(action, r2)) : checkAccess(action, resource))) {
    if (shouldThrow)
      throw new Error("You do not have access to this page.");
    return null;
  }
  return children;
}
__name(HasAccess, "HasAccess");
function ErrorBanner({
  error,
  onRetry,
  retryLabel
}) {
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      backgroundColor: "red-100",
      justifyContent: "space-between",
      alignItems: "center",
      h: 48,
      px: 16,
      children: [
        /* @__PURE__ */ jsx(Typography, { variant: "supportingRegularS", "data-test": "image-uploader-error", children: error }),
        /* @__PURE__ */ jsx(
          Button$1,
          {
            variant: "secondary",
            mode: "outline",
            size: "xSmall",
            onClick: onRetry,
            "data-test": "retry-button",
            children: retryLabel
          }
        )
      ]
    }
  );
}
__name(ErrorBanner, "ErrorBanner");
const Input = styled.input`
  display: none;
`;
function getSaveButtonStatus(loading, saved) {
  return loading ? SaveButtonStatus.SAVING : saved ? SaveButtonStatus.SAVED : SaveButtonStatus.UNSAVED;
}
__name(getSaveButtonStatus, "getSaveButtonStatus");
function ImageUploader({
  defaultImage,
  image: image2,
  onDelete,
  onUpload,
  "data-test": dataTest = "image-uploader",
  texts: texts2 = {
    upload: "Upload",
    uploaded: "Uploaded",
    delete: "Delete",
    deleted: "Deleted",
    retry: "Retry"
  }
}) {
  const [[isUploading, isUploaded], setUploadStatus] = useStateDelay([
    !1,
    !1
  ]), [[isDeleting, isDeleted], setDeleteStatus] = useStateDelay([
    !1,
    !1
  ]), [error, setError] = useState(null), inputEl = useRef(null), isBusy = isUploading || isDeleting, handleDelete = useCallback(async () => {
    setDeleteStatus([!0, !1]);
    const e3 = await onDelete();
    if (setDeleteStatus([!1, !1]), e3) {
      setError(e3);
      return;
    }
    setDeleteStatus([!1, !0], 2e3, [!1, !1]);
  }, [onDelete, setDeleteStatus]), handleUpload = useCallback(() => {
    var _a3;
    (_a3 = inputEl.current) == null || _a3.click();
  }, [inputEl]), onSelectedFileChange = useCallback(
    async (event) => {
      var _a3;
      setUploadStatus([!0, !1]);
      const file = (_a3 = event.target.files) == null ? void 0 : _a3[0];
      if (!file)
        return;
      const e3 = await onUpload(file);
      if (setUploadStatus([!1, !1]), inputEl.current && (inputEl.current.value = ""), e3) {
        setError(e3);
        return;
      }
      setUploadStatus([!1, !0], 2e3, [!1, !1]);
    },
    [onUpload, setUploadStatus]
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      borderRadius: 8,
      border: "1px solid",
      borderColor: "secondary-100",
      backgroundColor: "neutral-0",
      overflow: "hidden",
      maxWidth: "400px",
      children: [
        /* @__PURE__ */ jsx(Flex, { py: "l", flexDirection: "column", alignItems: "center", children: image2 ? /* @__PURE__ */ jsx(Avatar$1, { size: "xLarge", "data-test": `${dataTest}-avatar`, children: /* @__PURE__ */ jsx(AvatarImg, { src: image2 }) }) : defaultImage }),
        /* @__PURE__ */ jsx(
          Input,
          {
            type: "file",
            accept: "image/png,image/jpeg",
            onChange: onSelectedFileChange,
            ref: inputEl,
            "data-test": `${dataTest}-input`
          }
        ),
        error ? /* @__PURE__ */ jsx(
          ErrorBanner,
          {
            error,
            onRetry: () => setError(null),
            retryLabel: texts2.retry
          }
        ) : /* @__PURE__ */ jsxs(Flex, { borderTop: "1px solid", borderColor: "secondary-100", children: [
          (!!image2 || isDeleting || isDeleted) && /* @__PURE__ */ jsx(
            Flex,
            {
              flexGrow: 1,
              flexBasis: 0,
              alignItems: "center",
              borderRight: "1px solid",
              borderColor: "secondary-100",
              children: /* @__PURE__ */ jsx(
                SaveButton,
                {
                  size: "xSmall",
                  "data-test": `${dataTest}-delete-button`,
                  mode: "link",
                  type: "button",
                  block: !0,
                  onClick: handleDelete,
                  disabled: isBusy,
                  status: getSaveButtonStatus(isDeleting, isDeleted),
                  unsavedText: texts2.delete,
                  savedText: texts2.deleted
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(Box, { flexGrow: 1, flexBasis: 0, py: 10, children: /* @__PURE__ */ jsx(
            SaveButton,
            {
              size: "xSmall",
              "data-test": `${dataTest}-upload-button`,
              mode: "link",
              type: "button",
              block: !0,
              status: getSaveButtonStatus(isUploading, isUploaded),
              disabled: isBusy,
              onClick: handleUpload,
              unsavedText: texts2.upload,
              savedText: texts2.uploaded
            }
          ) })
        ] })
      ]
    }
  );
}
__name(ImageUploader, "ImageUploader");
const InfoPopupContext = createContext(null), useInfoPopup = /* @__PURE__ */ __name(() => useContext(InfoPopupContext), "useInfoPopup");
function InfoPopupRoot({
  open: openProp,
  defaultOpen,
  onOpenChange,
  children,
  align,
  side,
  mouseEnterDelay,
  mouseLeaveDelay,
  "data-test": dataTest
}) {
  const [open, setIsOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  }), handleClose = useMemo(
    () => debounce$2(() => {
      setIsOpen(!1);
    }, mouseLeaveDelay),
    [setIsOpen, mouseLeaveDelay]
  ), handleOpen = useMemo(
    () => debounce$2(() => {
      handleClose.cancel(), setIsOpen(!0);
    }, mouseEnterDelay),
    [mouseEnterDelay, handleClose, setIsOpen]
  ), value = useMemo(
    () => ({
      openPopup: handleOpen,
      closePopup: handleClose,
      cancelClose: handleClose.cancel,
      align,
      side
    }),
    [align, handleClose, handleOpen, side]
  );
  return /* @__PURE__ */ jsx(InfoPopupContext.Provider, { value, children: /* @__PURE__ */ jsx(Popover.Root, { open, "data-test": dataTest, children }) });
}
__name(InfoPopupRoot, "InfoPopupRoot");
function InfoPopup({
  children,
  align,
  side,
  mouseEnterDelay = 0,
  mouseLeaveDelay = 100,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    InfoPopupRoot,
    {
      align,
      side,
      mouseEnterDelay,
      mouseLeaveDelay,
      ...props,
      children
    }
  );
}
__name(InfoPopup, "InfoPopup");
function InfoPopupContent({
  children,
  ...props
}) {
  const { align, side, cancelClose, closePopup } = useInfoPopup();
  return /* @__PURE__ */ jsx(
    Popover.Content,
    {
      align,
      side,
      sideOffset: 8,
      onMouseEnter: cancelClose,
      onMouseLeave: closePopup,
      children: /* @__PURE__ */ jsx(
        Box,
        {
          backgroundColor: "surface-default",
          boxShadow: 1,
          borderRadius: "sm",
          p: "m",
          ...props,
          children
        }
      )
    }
  );
}
__name(InfoPopupContent, "InfoPopupContent");
function InfoPopupTrigger({
  children,
  "data-test": dataTest
}) {
  const { openPopup, closePopup } = useInfoPopup();
  return /* @__PURE__ */ jsx(
    Popover.Trigger,
    {
      onMouseEnter: openPopup,
      onMouseLeave: closePopup,
      "data-test": dataTest,
      children: Children.only(children)
    }
  );
}
__name(InfoPopupTrigger, "InfoPopupTrigger");
const CancelButtonContainer = styled(Box)`
  visibility: ${({ visible }) => visible ? "hidden" : "initial"};
`;
function InlineFormButtons({
  submitting,
  onClose,
  shouldDisableSubmit,
  handleSubmit,
  formRenderProps,
  submitButtonText,
  successButtonText,
  cancelButtonText,
  shouldBlockNavigation = !1,
  lang = "en"
}) {
  const { pristine } = formRenderProps;
  return useBlocker(
    // only block the navigation if the form values are changed
    shouldBlockNavigation && !pristine
  ), /* @__PURE__ */ jsxs(Spacer, { space: "xxs", children: [
    /* @__PURE__ */ jsx(
      CancelButtonContainer,
      {
        visible: submitting,
        "data-test": "inline-form-cancel-button-container",
        children: /* @__PURE__ */ jsx(
          Button$1,
          {
            onClick: onClose,
            type: "button",
            mode: "ghost",
            variant: "secondary",
            "data-test": "inline-form-cancel-button",
            children: cancelButtonText || translations[lang][FORM_ACTIONS.CANCEL]
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      SaveButton,
      {
        type: "submit",
        disabled: shouldDisableSubmit,
        onClick: handleSubmit,
        "data-test": "inline-form-submit-button",
        status: getSavingStatus(formRenderProps),
        savedText: successButtonText || translations[lang][FORM_ACTIONS.SAVED],
        unsavedText: submitButtonText || translations[lang][FORM_ACTIONS.SUBMIT]
      }
    )
  ] });
}
__name(InlineFormButtons, "InlineFormButtons");
const StyledInlineForm = styled(Form$1)`
  width: 100%;
  background: ${getColor$2("neutral-0")};
`;
function InlineForm({
  formProps,
  children,
  onClose,
  submitButtonText,
  successButtonText,
  cancelButtonText,
  shouldBlockNavigation,
  "data-test": dataTest = "inline-form",
  ...otherFlexProps
}) {
  const { onSubmit, ...rest } = formProps;
  return /* @__PURE__ */ jsx(
    Form,
    {
      ...rest,
      onSubmit: async (values, form, callback) => {
        await onSubmit(values, form, callback) || onClose();
      },
      children: (formRenderProps) => {
        const { handleSubmit, pristine, submitting } = formRenderProps, shouldDisableSubmit = submitting || pristine;
        return /* @__PURE__ */ jsx(StyledInlineForm, { onSubmit: handleSubmit, "data-test": dataTest, children: /* @__PURE__ */ jsxs(Flex, { p: "s", justifyContent: "space-between", ...otherFlexProps, children: [
          /* @__PURE__ */ jsx(Flex, { flex: "1", alignItems: "center", children: children(formRenderProps) }),
          /* @__PURE__ */ jsx(Box, { ml: "s", children: /* @__PURE__ */ jsx(
            InlineFormButtons,
            {
              submitting,
              onClose,
              shouldDisableSubmit,
              handleSubmit,
              formRenderProps,
              submitButtonText,
              shouldBlockNavigation,
              successButtonText,
              cancelButtonText
            }
          ) })
        ] }) });
      }
    }
  );
}
__name(InlineForm, "InlineForm");
function NumberFormatted({
  value,
  countryCode,
  ...restProps
}) {
  return /* @__PURE__ */ jsx(Typography, { ...restProps, children: formatInternationalNumber(value, countryCode) });
}
__name(NumberFormatted, "NumberFormatted");
function LineTitle({
  "data-test": dataTest = "line-title",
  ...typographyProps
}) {
  const context = useContext(LineContext), color2 = context.isClickable ? "text-interactive-secondary" : "text-base", commonProps = {
    "data-test": dataTest,
    variant: "bodySemiboldS",
    color: color2,
    ...typographyProps,
    ellipsis: !0,
    gridArea: "title"
  };
  return context.name ? /* @__PURE__ */ jsx(Typography, { ...commonProps, children: context.name }) : /* @__PURE__ */ jsx(
    NumberFormatted,
    {
      ...commonProps,
      value: context.number,
      countryCode: context.countryCode
    }
  );
}
__name(LineTitle, "LineTitle");
const LineContext = createContext({
  countryCode: null,
  name: null,
  number: null,
  isClickable: !1
}), LineGridLayout = styled(Grid)`
  grid-template-areas:
    "flag title"
    "flag subtitle";
  grid-row-gap: unset;
  grid-template-rows: 1fr auto;
  grid-template-columns: auto 1fr auto;
  align-items: center;
`;
function LineTooltipContent({
  countryCode,
  name: name2,
  number: number2
}) {
  const numberFormatted = /* @__PURE__ */ jsx(
    NumberFormatted,
    {
      display: "inline",
      value: number2,
      countryCode
    }
  );
  return number2 && !name2 ? numberFormatted : /* @__PURE__ */ jsx(TooltipContent$2, { rows: [[name2, numberFormatted]] });
}
__name(LineTooltipContent, "LineTooltipContent");
function Line({
  "data-test": dataTest = "line",
  children,
  countryCode,
  hasTooltip = !0,
  number: number2,
  name: name2,
  onClick: onClick2,
  ...gridProps
}) {
  const value = useMemo(
    () => ({ countryCode, name: name2, number: number2, isClickable: !!onClick2 }),
    [countryCode, name2, number2, onClick2]
  );
  return /* @__PURE__ */ jsx(LineContext.Provider, { value, children: /* @__PURE__ */ jsx(
    ConditionalTooltip,
    {
      visible: hasTooltip && !!number2,
      content: /* @__PURE__ */ jsx(
        LineTooltipContent,
        {
          countryCode,
          number: number2,
          name: name2
        }
      ),
      side: "top",
      sideOffset: 4,
      "data-test": `${dataTest}-tooltip`,
      children: /* @__PURE__ */ jsx(
        LineGridLayout,
        {
          gap: "xxs",
          "data-test": dataTest,
          onClick: onClick2,
          cursor: onClick2 ? "pointer" : "default",
          ...gridProps,
          children: children || /* @__PURE__ */ jsx(LineTitle, {})
        }
      )
    }
  ) });
}
__name(Line, "Line");
const LineFlagIcon = styled(FlagIcon)`
  grid-area: flag;
`;
function LineFlag({
  size = 20,
  "data-test": dataTest = "line-flag",
  ...iconProps
}) {
  const context = useContext(LineContext);
  return /* @__PURE__ */ jsx(
    LineFlagIcon,
    {
      countryCode: context.countryCode,
      size,
      "data-test": dataTest,
      ...iconProps
    }
  );
}
__name(LineFlag, "LineFlag");
function LineSubtitle({
  "data-test": dataTest = "line-subtitle",
  ...typographyProps
}) {
  const context = useContext(LineContext);
  return /* @__PURE__ */ jsx(
    NumberFormatted,
    {
      "data-test": dataTest,
      variant: "supportingMediumS",
      color: "text-secondary",
      ...typographyProps,
      gridArea: "subtitle",
      ellipsis: !0,
      value: context.number,
      countryCode: context.countryCode
    }
  );
}
__name(LineSubtitle, "LineSubtitle");
const Link = styled(Link$1)`
  color: ${({ color: color2 }) => color2 || "inherit"};
  text-decoration: none;

  &:visited,
  &:active {
    color: ${({ color: color2 }) => color2 || "inherit"};
  }
`, UnderlinedLink = styled(Link)`
  text-decoration: underline;
`, UnderlinedExternalLink = styled(Link$2)`
  text-decoration: underline;
`, ScrollContainer = styled(Box)`
  overflow: auto;
  padding: 0;
  margin: 0;
  list-style-type: none;
  ${({ hasBottomShadow, hasTopShadow }) => `box-shadow: ${[
  ...hasTopShadow ? ["inset 0 19px 20px -31px grey"] : [],
  ...hasBottomShadow ? ["inset 0 -19px 20px -31px grey"] : []
].join(",")};`}
  ${({ hasBottomBorder }) => hasBottomBorder && `border-bottom: 1px solid ${getColor$2("neutral-500")};`};
  ${({ maxHeight: maxHeight2 }) => `max-height: ${maxHeight2};`}
`;
function ShadowScrollContainerInner({
  children,
  maxHeight: maxHeight2 = "100%",
  hasBottomBorder = !1,
  forceShadow = !1,
  "data-test": dataTest = "scroll-container",
  as = "div",
  ...otherProps
}, ref) {
  const localRef = React__default.useRef(null), combinedRef = useCombinedRefs(localRef, ref), [hasBottomShadow, setBottomShadow] = useState(!1), [hasTopShadow, setTopShadow] = useState(!1), setScrollShadow = useCallback((el) => {
    const atBottom = isScrollAtBottom(el), atTop = isScrollAtTop(el);
    setBottomShadow(!atBottom), setTopShadow(!atTop);
  }, []);
  useEffect(() => {
    setScrollShadow(localRef.current);
  }, [localRef, setScrollShadow]);
  const handleScroll = useCallback(
    (e3) => {
      setScrollShadow(e3.currentTarget);
    },
    [setScrollShadow]
  );
  return /* @__PURE__ */ jsx(
    ScrollContainer,
    {
      ref: combinedRef,
      as,
      "data-test": dataTest,
      hasTopShadow,
      hasBottomShadow: forceShadow || hasBottomShadow,
      hasBottomBorder,
      onScroll: handleScroll,
      maxHeight: maxHeight2,
      ...otherProps,
      children
    }
  );
}
__name(ShadowScrollContainerInner, "ShadowScrollContainerInner");
const ShadowScrollContainer = forwardRefWithGenericType(
  ShadowScrollContainerInner
), Container$1 = styled(Box)`
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  border: 1px solid ${getColor$2("neutral-200")};
  border-radius: ${getRadii("sm")};
  background: ${getColor$2("neutral-0")};
  transition: 500ms box-shadow;
`, ItemsContainer = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;
`, Item = styled.li`
  border-bottom: 1px solid ${getColor$2("neutral-200")};

  &:last-child {
    border-bottom: none;
  }
`, CustomLoaderContainer = styled(Flex)`
  position: absolute;
  z-index: 3;
  bottom: 0;
  width: 100%;
  height: ${getSpace$1("xl")};
  padding: ${getSpace$1("m")};
  background: ${getColor$2("neutral-0")};
  border-top: 1px solid ${getColor$2("neutral-100")};
`, OverLoadingContainer = styled(Flex)`
  position: absolute;
  z-index: 10;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  background: rgb(255 255 255 / 0.8);
`, ROW_HEIGHT = 41, NUMBER_OF_ROWS_DISPLAYED = 9, List = forwardRef(
  ({
    children,
    forceShadow = !1,
    "data-test": dataTest = "list",
    hasScroll = !1,
    isLoadingMoreItems = !1,
    customLoader,
    stickyFooter,
    overLoading = !1,
    w: w2 = "100%",
    renderHeader,
    ...otherProps
  }, ref) => {
    const hasNoChildren = React__default.Children.toArray(children).filter(
      (child) => React__default.isValidElement(child)
    ).length === 0;
    if (hasNoChildren && !stickyFooter)
      return null;
    const items = React__default.Children.map(
      children,
      (child, index2) => child && /* @__PURE__ */ jsx(Item, { "data-test": `list-item-${index2}`, children: child })
    );
    return /* @__PURE__ */ jsxs(Container$1, { w: w2, ...otherProps, children: [
      overLoading && /* @__PURE__ */ jsx(OverLoadingContainer, { "data-test": "list-over-loading", children: /* @__PURE__ */ jsx(Loading, { color: "primary-500", size: 28 }) }),
      hasScroll ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          ShadowScrollContainer,
          {
            as: "ul",
            ref,
            "data-test": dataTest,
            forceShadow,
            hasBottomBorder: !!(stickyFooter && !hasNoChildren),
            maxHeight: Math.ceil(
              ROW_HEIGHT * NUMBER_OF_ROWS_DISPLAYED + ROW_HEIGHT / 2
            ),
            children: items
          }
        ),
        stickyFooter && /* @__PURE__ */ jsx(
          Flex,
          {
            borderTop: items != null && items.length ? "1px solid" : "none",
            borderColor: "neutral-200",
            children: stickyFooter
          }
        ),
        isLoadingMoreItems && customLoader && /* @__PURE__ */ jsx(
          CustomLoaderContainer,
          {
            "data-test": "list-custom-loader",
            justifyContent: "center",
            alignItems: "center",
            children: customLoader
          }
        )
      ] }) : /* @__PURE__ */ jsxs(ItemsContainer, { "data-test": dataTest, children: [
        renderHeader == null ? void 0 : renderHeader(),
        items
      ] })
    ] });
  }
), CustomPagination = styled(Pagination)`
  > div:first-child {
    ${({ hideLimit }) => hideLimit && "display: none;"}
  }
`;
function ListPaginated({
  children,
  activePage,
  onPageChange,
  onPageSizeChange,
  pageSize,
  recordsTotalCount,
  hideLimit = !1,
  ...listProps
}) {
  const { "data-test": dataTest = "list-paginated" } = listProps;
  return /* @__PURE__ */ jsxs(Spacer, { fluid: !0, direction: "vertical", space: "xs", children: [
    /* @__PURE__ */ jsx(List, { ...listProps, children }),
    /* @__PURE__ */ jsx(
      CustomPagination,
      {
        "data-test": `${dataTest}-pagination`,
        hideLimit,
        activePage,
        onPageChange,
        onPageSizeChange,
        pageSize,
        recordsTotalCount
      }
    )
  ] });
}
__name(ListPaginated, "ListPaginated");
const StyledListItem = styled(Flex)`
  position: relative;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  ${({ hasCustomHeight }) => !hasCustomHeight && css`
      &:hover {
        background-color: ${getColor$2("neutral-100")};
        transition: all 0.25s ease-in-out;
      }
    `}

  & > div:nth-child(2) {
    border-left: 1px solid ${getColor$2("neutral-200")};

    &:hover {
      & > div {
        background: ${getColor$2("neutral-200")};
      }
    }
  }
`, IconWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  padding: ${getSpace$1("xxs")};
  border-radius: 50%;
  transition: all 0.25s ease-in-out;
`, DropdownIconWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  padding: ${getSpace$1("xxxs")};
  cursor: pointer;

  &:hover {
    > ${IconWrapper} {
      background-color: ${getColor$2("neutral-300")};
    }
  }
  ${({ hasCustomHeight }) => hasCustomHeight ? css`
          position: relative;
          top: 0;
          right: 0;
        ` : css`
          border-left: 1px solid ${getColor$2("neutral-300")};
        `}
`;
function ListItem({
  avatar,
  primaryText,
  secondaryText,
  children,
  dropdownOptions,
  "data-test": dataTest = "list-item",
  ...otherProps
}) {
  const { space: space2 } = useTheme(), { h: h3 } = otherProps, hasCustomHeight = !!(h3 && h3 !== space2.xl);
  return /* @__PURE__ */ jsxs(
    StyledListItem,
    {
      minH: space2.xl,
      "data-test": dataTest,
      hasCustomHeight,
      ...otherProps,
      children: [
        primaryText && /* @__PURE__ */ jsxs(Spacer, { space: "xxs", direction: "horizontal", alignItems: "center", px: "s", children: [
          avatar,
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "bodyRegularS",
              "data-test": `${dataTest}-primary-text`,
              children: primaryText
            }
          ),
          secondaryText && /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "supportingMediumS",
              color: "neutral-400",
              ml: "xxs",
              "data-test": `${dataTest}-secondary-text`,
              children: secondaryText
            }
          )
        ] }),
        children,
        dropdownOptions && /* @__PURE__ */ jsx(
          Dropdown,
          {
            trigger: /* @__PURE__ */ jsx(DropdownIconWrapper, { hasCustomHeight, children: /* @__PURE__ */ jsx(IconWrapper, { children: /* @__PURE__ */ jsx(
              IconButton,
              {
                size: space2.s,
                component: MenuVerticalFilled,
                color: "neutral-600",
                "data-test": `${dataTest}-dropdown-trigger`,
                discColor: "transparent",
                type: "button"
              }
            ) }) }),
            side: "bottom",
            align: "start",
            children: /* @__PURE__ */ jsx(Menu, { children: dropdownOptions.map(({ title, callback }, index2) => /* @__PURE__ */ jsx(
              MenuItem,
              {
                itemKey: title,
                onClick: callback,
                "data-test": `${dataTest}-dropdown-menu-item-${index2}`,
                children: /* @__PURE__ */ jsx(MenuItemLabel, { children: title })
              },
              title
            )) })
          }
        )
      ]
    }
  );
}
__name(ListItem, "ListItem");
function ListItemActions({
  children,
  actions = []
}) {
  return /* @__PURE__ */ jsxs(ListItem$1, { background: "white", w: "100%", p: "s", position: "relative", children: [
    children,
    actions.length ? /* @__PURE__ */ jsx(Box, { position: "absolute", top: "4px", right: "4px", children: /* @__PURE__ */ jsx(
      ActionMenu,
      {
        trigger: /* @__PURE__ */ jsx(
          Button$1,
          {
            mode: "ghost",
            shape: "circle",
            variant: "secondary",
            size: "xSmall",
            "data-test": "action-button",
            children: /* @__PURE__ */ jsx(MenuVerticalFilled, {})
          }
        ),
        items: actions
      }
    ) }) : null
  ] });
}
__name(ListItemActions, "ListItemActions");
var LoadMoreStrategy = /* @__PURE__ */ ((LoadMoreStrategy2) => (LoadMoreStrategy2.Button = "button", LoadMoreStrategy2.Scroll = "scroll", LoadMoreStrategy2))(LoadMoreStrategy || {});
const LoadMoreTableFooter = forwardRef(
  ({ children, "data-test": dataTest, ...flexProps }, ref) => /* @__PURE__ */ jsx("tfoot", { "data-test": dataTest, children: /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { colSpan: 9999, style: { padding: 0 }, children: /* @__PURE__ */ jsx(
    Flex,
    {
      w: "100%",
      borderTop: "1px solid",
      borderColor: "neutral-200",
      alignItems: "center",
      justifyContent: "center",
      p: "m",
      ref,
      ...flexProps,
      children
    }
  ) }) }) })
);
function LoadMoreButton({
  onLoadMore,
  loading,
  loadingText,
  buttonText,
  hasMore,
  dataTest
}) {
  return hasMore ? /* @__PURE__ */ jsx(LoadMoreTableFooter, { "data-test": `${dataTest}-footer`, children: /* @__PURE__ */ jsx(
    LoadingButton,
    {
      onClick: onLoadMore,
      loading,
      loadingText,
      children: buttonText
    }
  ) }) : null;
}
__name(LoadMoreButton, "LoadMoreButton");
function LoadMoreScroll({
  hasMore,
  dataTest,
  containerRef,
  scrollThreshold,
  onLoadMore
}) {
  var _a3;
  const loadMoreRef = useRef(null), scrollContainer = (_a3 = containerRef.current) == null ? void 0 : _a3.querySelector(`[data-test="${dataTest}"]`);
  return useIntersection({
    targetRef: loadMoreRef,
    root: scrollContainer,
    onIntersect: onLoadMore,
    margin: scrollThreshold
  }), hasMore ? /* @__PURE__ */ jsx(
    LoadMoreTableFooter,
    {
      ref: loadMoreRef,
      "data-test": `${dataTest}-footer`,
      p: "xs",
      children: /* @__PURE__ */ jsx(
        Loading,
        {
          size: 34,
          w: "100%",
          h: "100%",
          background: "rgba(255,255,255,0.7)",
          "data-test": `${dataTest}-loading`
        }
      )
    }
  ) : null;
}
__name(LoadMoreScroll, "LoadMoreScroll");
function LoadMoreTable({
  buttonText = "Load more",
  data: data2,
  hasMore,
  loading = !1,
  loadingMore = !1,
  loadingText,
  noDataMessage,
  onLoadMore,
  "data-test": dataTest = "load-more-table",
  strategy = LoadMoreStrategy.Button,
  scrollThreshold = 100,
  ...tableProps
}) {
  const containerRef = useRef(null);
  return /* @__PURE__ */ jsxs(Flex, { flex: "1", overflow: "auto", position: "relative", ref: containerRef, children: [
    loading && /* @__PURE__ */ jsx(
      Loading,
      {
        size: 34,
        color: "neutral-300",
        position: "absolute",
        zIndex: "10",
        borderRadius: "sm",
        w: "100%",
        h: "100%",
        background: "rgba(255,255,255,0.7)",
        "data-test": `${dataTest}-loading`
      }
    ),
    /* @__PURE__ */ jsx(
      Table,
      {
        ...tableProps,
        data: data2 ?? /* istanbul ignore next */
        [],
        noDataMessage: data2 ? noDataMessage : " ",
        footer: strategy === "button" ? /* @__PURE__ */ jsx(
          LoadMoreButton,
          {
            loading: loadingMore,
            loadingText,
            buttonText,
            hasMore,
            dataTest,
            onLoadMore
          }
        ) : /* @__PURE__ */ jsx(
          LoadMoreScroll,
          {
            hasMore,
            dataTest,
            containerRef,
            scrollThreshold,
            onLoadMore
          }
        ),
        "data-test": dataTest
      }
    )
  ] });
}
__name(LoadMoreTable, "LoadMoreTable");
function stringify$1(values, options) {
  const settings = options || {};
  return (values[values.length - 1] === "" ? [...values, ""] : values).join(
    (settings.padRight ? " " : "") + "," + (settings.padLeft === !1 ? "" : " ")
  ).trim();
}
__name(stringify$1, "stringify$1");
const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, emptyOptions$2 = {};
function name(name2, options) {
  return ((options || emptyOptions$2).jsx ? nameReJsx : nameRe).test(name2);
}
__name(name, "name");
const re$1 = /[ \t\n\f\r]/g;
function whitespace(thing) {
  return typeof thing == "object" ? thing.type === "text" ? empty$2(thing.value) : !1 : empty$2(thing);
}
__name(whitespace, "whitespace");
function empty$2(value) {
  return value.replace(re$1, "") === "";
}
__name(empty$2, "empty$2");
const _Schema = class _Schema {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(property2, normal, space2) {
    this.normal = normal, this.property = property2, space2 && (this.space = space2);
  }
};
__name(_Schema, "Schema");
let Schema = _Schema;
Schema.prototype.normal = {};
Schema.prototype.property = {};
Schema.prototype.space = void 0;
function merge(definitions, space2) {
  const property2 = {}, normal = {};
  for (const definition2 of definitions)
    Object.assign(property2, definition2.property), Object.assign(normal, definition2.normal);
  return new Schema(property2, normal, space2);
}
__name(merge, "merge");
function normalize$2(value) {
  return value.toLowerCase();
}
__name(normalize$2, "normalize$2");
const _Info = class _Info {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(property2, attribute) {
    this.attribute = attribute, this.property = property2;
  }
};
__name(_Info, "Info");
let Info = _Info;
Info.prototype.attribute = "";
Info.prototype.booleanish = !1;
Info.prototype.boolean = !1;
Info.prototype.commaOrSpaceSeparated = !1;
Info.prototype.commaSeparated = !1;
Info.prototype.defined = !1;
Info.prototype.mustUseProperty = !1;
Info.prototype.number = !1;
Info.prototype.overloadedBoolean = !1;
Info.prototype.property = "";
Info.prototype.spaceSeparated = !1;
Info.prototype.space = void 0;
let powers = 0;
const boolean = increment(), booleanish = increment(), overloadedBoolean = increment(), number$3 = increment(), spaceSeparated = increment(), commaSeparated = increment(), commaOrSpaceSeparated = increment();
function increment() {
  return 2 ** ++powers;
}
__name(increment, "increment");
const types = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean,
  booleanish,
  commaOrSpaceSeparated,
  commaSeparated,
  number: number$3,
  overloadedBoolean,
  spaceSeparated
}, Symbol.toStringTag, { value: "Module" })), checks = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(types)
), _DefinedInfo = class _DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(property2, attribute, mask, space2) {
    let index2 = -1;
    if (super(property2, attribute), mark(this, "space", space2), typeof mask == "number")
      for (; ++index2 < checks.length; ) {
        const check2 = checks[index2];
        mark(this, checks[index2], (mask & types[check2]) === types[check2]);
      }
  }
};
__name(_DefinedInfo, "DefinedInfo");
let DefinedInfo = _DefinedInfo;
DefinedInfo.prototype.defined = !0;
function mark(values, key, value) {
  value && (values[key] = value);
}
__name(mark, "mark");
function create(definition2) {
  const properties = {}, normals = {};
  for (const [property2, value] of Object.entries(definition2.properties)) {
    const info = new DefinedInfo(
      property2,
      definition2.transform(definition2.attributes || {}, property2),
      value,
      definition2.space
    );
    definition2.mustUseProperty && definition2.mustUseProperty.includes(property2) && (info.mustUseProperty = !0), properties[property2] = info, normals[normalize$2(property2)] = property2, normals[normalize$2(info.attribute)] = property2;
  }
  return new Schema(properties, normals, definition2.space);
}
__name(create, "create");
const aria = create({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number$3,
    ariaColIndex: number$3,
    ariaColSpan: number$3,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number$3,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number$3,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number$3,
    ariaRowIndex: number$3,
    ariaRowSpan: number$3,
    ariaSelected: booleanish,
    ariaSetSize: number$3,
    ariaSort: null,
    ariaValueMax: number$3,
    ariaValueMin: number$3,
    ariaValueNow: number$3,
    ariaValueText: null,
    role: null
  },
  transform(_, property2) {
    return property2 === "role" ? property2 : "aria-" + property2.slice(4).toLowerCase();
  }
});
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}
__name(caseSensitiveTransform, "caseSensitiveTransform");
function caseInsensitiveTransform(attributes, property2) {
  return caseSensitiveTransform(attributes, property2.toLowerCase());
}
__name(caseInsensitiveTransform, "caseInsensitiveTransform");
const html$2 = create({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number$3,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number$3 | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number$3,
    hidden: overloadedBoolean,
    high: number$3,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number$3,
    manifest: null,
    max: null,
    maxLength: number$3,
    media: null,
    method: null,
    min: null,
    minLength: number$3,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number$3,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number$3,
    rowSpan: number$3,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootClonable: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number$3,
    sizes: null,
    slot: null,
    span: number$3,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number$3,
    step: null,
    style: null,
    tabIndex: number$3,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number$3,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number$3,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number$3,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number$3,
    // `<img>` and `<object>`
    leftMargin: number$3,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number$3,
    // `<body>`
    marginWidth: number$3,
    // `<body>`
    noResize: boolean,
    // `<frame>`
    noHref: boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number$3,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number$3,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number$3,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number$3,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: caseInsensitiveTransform
}), svg$1 = create({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number$3,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number$3,
    amplitude: number$3,
    arabicForm: null,
    ascent: number$3,
    attributeName: null,
    attributeType: null,
    azimuth: number$3,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number$3,
    by: null,
    calcMode: null,
    capHeight: number$3,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number$3,
    diffuseConstant: number$3,
    direction: null,
    display: null,
    dur: null,
    divisor: number$3,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number$3,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number$3,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number$3,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number$3,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number$3,
    horizOriginX: number$3,
    horizOriginY: number$3,
    id: null,
    ideographic: number$3,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number$3,
    k: number$3,
    k1: number$3,
    k2: number$3,
    k3: number$3,
    k4: number$3,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number$3,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number$3,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number$3,
    overlineThickness: number$3,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number$3,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number$3,
    pointsAtY: number$3,
    pointsAtZ: number$3,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number$3,
    specularExponent: number$3,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number$3,
    strikethroughThickness: number$3,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number$3,
    strokeOpacity: number$3,
    strokeWidth: null,
    style: null,
    surfaceScale: number$3,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number$3,
    tableValues: null,
    target: null,
    targetX: number$3,
    targetY: number$3,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number$3,
    underlineThickness: number$3,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number$3,
    values: null,
    vAlphabetic: number$3,
    vMathematical: number$3,
    vectorEffect: null,
    vHanging: number$3,
    vIdeographic: number$3,
    version: null,
    vertAdvY: number$3,
    vertOriginX: number$3,
    vertOriginY: number$3,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number$3,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: caseSensitiveTransform
}), xlink = create({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(_, property2) {
    return "xlink:" + property2.slice(5).toLowerCase();
  }
}), xmlns = create({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: caseInsensitiveTransform
}), xml = create({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(_, property2) {
    return "xml:" + property2.slice(3).toLowerCase();
  }
}), hastToReact = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, cap$1 = /[A-Z]/g, dash = /-[a-z]/g, valid = /^data[-\w.:]+$/i;
function find(schema, value) {
  const normal = normalize$2(value);
  let property2 = value, Type2 = Info;
  if (normal in schema.normal)
    return schema.property[schema.normal[normal]];
  if (normal.length > 4 && normal.slice(0, 4) === "data" && valid.test(value)) {
    if (value.charAt(4) === "-") {
      const rest = value.slice(5).replace(dash, camelcase);
      property2 = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      const rest = value.slice(4);
      if (!dash.test(rest)) {
        let dashes = rest.replace(cap$1, kebab);
        dashes.charAt(0) !== "-" && (dashes = "-" + dashes), value = "data" + dashes;
      }
    }
    Type2 = DefinedInfo;
  }
  return new Type2(property2, value);
}
__name(find, "find");
function kebab($0) {
  return "-" + $0.toLowerCase();
}
__name(kebab, "kebab");
function camelcase($0) {
  return $0.charAt(1).toUpperCase();
}
__name(camelcase, "camelcase");
const html$1 = merge([aria, html$2, xlink, xmlns, xml], "html"), svg = merge([aria, svg$1, xlink, xmlns, xml], "svg");
function stringify(values) {
  return values.join(" ").trim();
}
__name(stringify, "stringify");
var cjs$1 = {}, COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, NEWLINE_REGEX = /\n/g, WHITESPACE_REGEX = /^\s*/, PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, COLON_REGEX = /^:\s*/, VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, SEMICOLON_REGEX = /^[;\s]*/, TRIM_REGEX = /^\s+|\s+$/g, NEWLINE = `
`, FORWARD_SLASH = "/", ASTERISK = "*", EMPTY_STRING = "", TYPE_COMMENT = "comment", TYPE_DECLARATION = "declaration", inlineStyleParser = /* @__PURE__ */ __name(function(style2, options) {
  if (typeof style2 != "string")
    throw new TypeError("First argument must be a string");
  if (!style2)
    return [];
  options = options || {};
  var lineno = 1, column = 1;
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    lines && (lineno += lines.length);
    var i2 = str.lastIndexOf(NEWLINE);
    column = ~i2 ? str.length - i2 : column + str.length;
  }
  __name(updatePosition, "updatePosition");
  function position2() {
    var start = { line: lineno, column };
    return function(node2) {
      return node2.position = new Position(start), whitespace2(), node2;
    };
  }
  __name(position2, "position");
  function Position(start) {
    this.start = start, this.end = { line: lineno, column }, this.source = options.source;
  }
  __name(Position, "Position"), Position.prototype.content = style2;
  function error(msg) {
    var err = new Error(
      options.source + ":" + lineno + ":" + column + ": " + msg
    );
    if (err.reason = msg, err.filename = options.source, err.line = lineno, err.column = column, err.source = style2, !options.silent)
      throw err;
  }
  __name(error, "error");
  function match2(re2) {
    var m3 = re2.exec(style2);
    if (m3) {
      var str = m3[0];
      return updatePosition(str), style2 = style2.slice(str.length), m3;
    }
  }
  __name(match2, "match");
  function whitespace2() {
    match2(WHITESPACE_REGEX);
  }
  __name(whitespace2, "whitespace");
  function comments(rules) {
    var c3;
    for (rules = rules || []; c3 = comment(); )
      c3 !== !1 && rules.push(c3);
    return rules;
  }
  __name(comments, "comments");
  function comment() {
    var pos = position2();
    if (!(FORWARD_SLASH != style2.charAt(0) || ASTERISK != style2.charAt(1))) {
      for (var i2 = 2; EMPTY_STRING != style2.charAt(i2) && (ASTERISK != style2.charAt(i2) || FORWARD_SLASH != style2.charAt(i2 + 1)); )
        ++i2;
      if (i2 += 2, EMPTY_STRING === style2.charAt(i2 - 1))
        return error("End of comment missing");
      var str = style2.slice(2, i2 - 2);
      return column += 2, updatePosition(str), style2 = style2.slice(i2), column += 2, pos({
        type: TYPE_COMMENT,
        comment: str
      });
    }
  }
  __name(comment, "comment");
  function declaration() {
    var pos = position2(), prop = match2(PROPERTY_REGEX);
    if (prop) {
      if (comment(), !match2(COLON_REGEX))
        return error("property missing ':'");
      var val = match2(VALUE_REGEX), ret = pos({
        type: TYPE_DECLARATION,
        property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
        value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
      });
      return match2(SEMICOLON_REGEX), ret;
    }
  }
  __name(declaration, "declaration");
  function declarations() {
    var decls = [];
    comments(decls);
    for (var decl; decl = declaration(); )
      decl !== !1 && (decls.push(decl), comments(decls));
    return decls;
  }
  return __name(declarations, "declarations"), whitespace2(), declarations();
}, "inlineStyleParser");
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}
__name(trim, "trim");
var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { default: mod };
};
Object.defineProperty(cjs$1, "__esModule", { value: !0 });
cjs$1.default = StyleToObject;
var inline_style_parser_1 = __importDefault$1(inlineStyleParser);
function StyleToObject(style2, iterator) {
  var styleObject = null;
  if (!style2 || typeof style2 != "string")
    return styleObject;
  var declarations = (0, inline_style_parser_1.default)(style2), hasIterator = typeof iterator == "function";
  return declarations.forEach(function(declaration) {
    if (declaration.type === "declaration") {
      var property2 = declaration.property, value = declaration.value;
      hasIterator ? iterator(property2, value, declaration) : value && (styleObject = styleObject || {}, styleObject[property2] = value);
    }
  }), styleObject;
}
__name(StyleToObject, "StyleToObject");
var utilities = {};
Object.defineProperty(utilities, "__esModule", { value: !0 });
utilities.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/, HYPHEN_REGEX = /-([a-z])/g, NO_HYPHEN_REGEX = /^[^-]+$/, VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/, MS_VENDOR_PREFIX_REGEX = /^-(ms)-/, skipCamelCase = /* @__PURE__ */ __name(function(property2) {
  return !property2 || NO_HYPHEN_REGEX.test(property2) || CUSTOM_PROPERTY_REGEX.test(property2);
}, "skipCamelCase"), capitalize = /* @__PURE__ */ __name(function(match2, character) {
  return character.toUpperCase();
}, "capitalize"), trimHyphen = /* @__PURE__ */ __name(function(match2, prefix2) {
  return "".concat(prefix2, "-");
}, "trimHyphen"), camelCase = /* @__PURE__ */ __name(function(property2, options) {
  return options === void 0 && (options = {}), skipCamelCase(property2) ? property2 : (property2 = property2.toLowerCase(), options.reactCompat ? property2 = property2.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen) : property2 = property2.replace(VENDOR_PREFIX_REGEX, trimHyphen), property2.replace(HYPHEN_REGEX, capitalize));
}, "camelCase");
utilities.camelCase = camelCase;
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { default: mod };
}, style_to_object_1 = __importDefault(cjs$1), utilities_1 = utilities;
function StyleToJS(style2, options) {
  var output = {};
  return !style2 || typeof style2 != "string" || (0, style_to_object_1.default)(style2, function(property2, value) {
    property2 && value && (output[(0, utilities_1.camelCase)(property2, options)] = value);
  }), output;
}
__name(StyleToJS, "StyleToJS");
StyleToJS.default = StyleToJS;
var cjs = StyleToJS;
const styleToJs = /* @__PURE__ */ getDefaultExportFromCjs(cjs), pointStart$1 = point$6("start");
function point$6(type) {
  return point2;
  function point2(node2) {
    const point3 = node2 && node2.position && node2.position[type] || {};
    if (typeof point3.line == "number" && point3.line > 0 && typeof point3.column == "number" && point3.column > 0)
      return {
        line: point3.line,
        column: point3.column,
        offset: typeof point3.offset == "number" && point3.offset > -1 ? point3.offset : void 0
      };
  }
}
__name(point$6, "point$6");
function stringifyPosition(value) {
  return !value || typeof value != "object" ? "" : "position" in value || "type" in value ? position$1(value.position) : "start" in value || "end" in value ? position$1(value) : "line" in value || "column" in value ? point$5(value) : "";
}
__name(stringifyPosition, "stringifyPosition");
function point$5(point2) {
  return index(point2 && point2.line) + ":" + index(point2 && point2.column);
}
__name(point$5, "point$5");
function position$1(pos) {
  return point$5(pos && pos.start) + "-" + point$5(pos && pos.end);
}
__name(position$1, "position$1");
function index(value) {
  return value && typeof value == "number" ? value : 1;
}
__name(index, "index");
const _VFileMessage = class _VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin) {
    super(), typeof optionsOrParentOrPlace == "string" && (origin = optionsOrParentOrPlace, optionsOrParentOrPlace = void 0);
    let reason = "", options = {}, legacyCause = !1;
    if (optionsOrParentOrPlace && ("line" in optionsOrParentOrPlace && "column" in optionsOrParentOrPlace ? options = { place: optionsOrParentOrPlace } : "start" in optionsOrParentOrPlace && "end" in optionsOrParentOrPlace ? options = { place: optionsOrParentOrPlace } : "type" in optionsOrParentOrPlace ? options = {
      ancestors: [optionsOrParentOrPlace],
      place: optionsOrParentOrPlace.position
    } : options = { ...optionsOrParentOrPlace }), typeof causeOrReason == "string" ? reason = causeOrReason : !options.cause && causeOrReason && (legacyCause = !0, reason = causeOrReason.message, options.cause = causeOrReason), !options.ruleId && !options.source && typeof origin == "string") {
      const index2 = origin.indexOf(":");
      index2 === -1 ? options.ruleId = origin : (options.source = origin.slice(0, index2), options.ruleId = origin.slice(index2 + 1));
    }
    if (!options.place && options.ancestors && options.ancestors) {
      const parent2 = options.ancestors[options.ancestors.length - 1];
      parent2 && (options.place = parent2.position);
    }
    const start = options.place && "start" in options.place ? options.place.start : options.place;
    this.ancestors = options.ancestors || void 0, this.cause = options.cause || void 0, this.column = start ? start.column : void 0, this.fatal = void 0, this.file, this.message = reason, this.line = start ? start.line : void 0, this.name = stringifyPosition(options.place) || "1:1", this.place = options.place || void 0, this.reason = this.message, this.ruleId = options.ruleId || void 0, this.source = options.source || void 0, this.stack = legacyCause && options.cause && typeof options.cause.stack == "string" ? options.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
};
__name(_VFileMessage, "VFileMessage");
let VFileMessage = _VFileMessage;
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.column = void 0;
VFileMessage.prototype.line = void 0;
VFileMessage.prototype.ancestors = void 0;
VFileMessage.prototype.cause = void 0;
VFileMessage.prototype.fatal = void 0;
VFileMessage.prototype.place = void 0;
VFileMessage.prototype.ruleId = void 0;
VFileMessage.prototype.source = void 0;
const own$3 = {}.hasOwnProperty, emptyMap = /* @__PURE__ */ new Map(), cap = /[A-Z]/g, tableElements = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), tableCellElement = /* @__PURE__ */ new Set(["td", "th"]), docs = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function toJsxRuntime(tree, options) {
  if (!options || options.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const filePath = options.filePath || void 0;
  let create2;
  if (options.development) {
    if (typeof options.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    create2 = developmentCreate(filePath, options.jsxDEV);
  } else {
    if (typeof options.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof options.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    create2 = productionCreate(filePath, options.jsx, options.jsxs);
  }
  const state = {
    Fragment: options.Fragment,
    ancestors: [],
    components: options.components || {},
    create: create2,
    elementAttributeNameCase: options.elementAttributeNameCase || "react",
    evaluater: options.createEvaluater ? options.createEvaluater() : void 0,
    filePath,
    ignoreInvalidStyle: options.ignoreInvalidStyle || !1,
    passKeys: options.passKeys !== !1,
    passNode: options.passNode || !1,
    schema: options.space === "svg" ? svg : html$1,
    stylePropertyNameCase: options.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: options.tableCellAlignToStyle !== !1
  }, result2 = one$2(state, tree, void 0);
  return result2 && typeof result2 != "string" ? result2 : state.create(
    tree,
    state.Fragment,
    { children: result2 || void 0 },
    void 0
  );
}
__name(toJsxRuntime, "toJsxRuntime");
function one$2(state, node2, key) {
  if (node2.type === "element")
    return element$1(state, node2, key);
  if (node2.type === "mdxFlowExpression" || node2.type === "mdxTextExpression")
    return mdxExpression(state, node2);
  if (node2.type === "mdxJsxFlowElement" || node2.type === "mdxJsxTextElement")
    return mdxJsxElement(state, node2, key);
  if (node2.type === "mdxjsEsm")
    return mdxEsm(state, node2);
  if (node2.type === "root")
    return root$b(state, node2, key);
  if (node2.type === "text")
    return text$3(state, node2);
}
__name(one$2, "one$2");
function element$1(state, node2, key) {
  const parentSchema = state.schema;
  let schema = parentSchema;
  node2.tagName.toLowerCase() === "svg" && parentSchema.space === "html" && (schema = svg, state.schema = schema), state.ancestors.push(node2);
  const type = findComponentFromName(state, node2.tagName, !1), props = createElementProps(state, node2);
  let children = createChildren(state, node2);
  return tableElements.has(node2.tagName) && (children = children.filter(function(child) {
    return typeof child == "string" ? !whitespace(child) : !0;
  })), addNode(state, props, type, node2), addChildren(props, children), state.ancestors.pop(), state.schema = parentSchema, state.create(node2, type, props, key);
}
__name(element$1, "element$1");
function mdxExpression(state, node2) {
  if (node2.data && node2.data.estree && state.evaluater) {
    const expression = node2.data.estree.body[0];
    return expression.type, /** @type {Child | undefined} */
    state.evaluater.evaluateExpression(expression.expression);
  }
  crashEstree(state, node2.position);
}
__name(mdxExpression, "mdxExpression");
function mdxEsm(state, node2) {
  if (node2.data && node2.data.estree && state.evaluater)
    return (
      /** @type {Child | undefined} */
      state.evaluater.evaluateProgram(node2.data.estree)
    );
  crashEstree(state, node2.position);
}
__name(mdxEsm, "mdxEsm");
function mdxJsxElement(state, node2, key) {
  const parentSchema = state.schema;
  let schema = parentSchema;
  node2.name === "svg" && parentSchema.space === "html" && (schema = svg, state.schema = schema), state.ancestors.push(node2);
  const type = node2.name === null ? state.Fragment : findComponentFromName(state, node2.name, !0), props = createJsxElementProps(state, node2), children = createChildren(state, node2);
  return addNode(state, props, type, node2), addChildren(props, children), state.ancestors.pop(), state.schema = parentSchema, state.create(node2, type, props, key);
}
__name(mdxJsxElement, "mdxJsxElement");
function root$b(state, node2, key) {
  const props = {};
  return addChildren(props, createChildren(state, node2)), state.create(node2, state.Fragment, props, key);
}
__name(root$b, "root$b");
function text$3(_, node2) {
  return node2.value;
}
__name(text$3, "text$3");
function addNode(state, props, type, node2) {
  typeof type != "string" && type !== state.Fragment && state.passNode && (props.node = node2);
}
__name(addNode, "addNode");
function addChildren(props, children) {
  if (children.length > 0) {
    const value = children.length > 1 ? children : children[0];
    value && (props.children = value);
  }
}
__name(addChildren, "addChildren");
function productionCreate(_, jsx2, jsxs2) {
  return create2;
  function create2(_2, type, props, key) {
    const fn = Array.isArray(props.children) ? jsxs2 : jsx2;
    return key ? fn(type, props, key) : fn(type, props);
  }
}
__name(productionCreate, "productionCreate");
function developmentCreate(filePath, jsxDEV) {
  return create2;
  function create2(node2, type, props, key) {
    const isStaticChildren = Array.isArray(props.children), point2 = pointStart$1(node2);
    return jsxDEV(
      type,
      props,
      key,
      isStaticChildren,
      {
        columnNumber: point2 ? point2.column - 1 : void 0,
        fileName: filePath,
        lineNumber: point2 ? point2.line : void 0
      },
      void 0
    );
  }
}
__name(developmentCreate, "developmentCreate");
function createElementProps(state, node2) {
  const props = {};
  let alignValue, prop;
  for (prop in node2.properties)
    if (prop !== "children" && own$3.call(node2.properties, prop)) {
      const result2 = createProperty(state, prop, node2.properties[prop]);
      if (result2) {
        const [key, value] = result2;
        state.tableCellAlignToStyle && key === "align" && typeof value == "string" && tableCellElement.has(node2.tagName) ? alignValue = value : props[key] = value;
      }
    }
  if (alignValue) {
    const style2 = (
      /** @type {Style} */
      props.style || (props.style = {})
    );
    style2[state.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = alignValue;
  }
  return props;
}
__name(createElementProps, "createElementProps");
function createJsxElementProps(state, node2) {
  const props = {};
  for (const attribute of node2.attributes)
    if (attribute.type === "mdxJsxExpressionAttribute")
      if (attribute.data && attribute.data.estree && state.evaluater) {
        const expression = attribute.data.estree.body[0];
        expression.type;
        const objectExpression = expression.expression;
        objectExpression.type;
        const property2 = objectExpression.properties[0];
        property2.type, Object.assign(
          props,
          state.evaluater.evaluateExpression(property2.argument)
        );
      } else
        crashEstree(state, node2.position);
    else {
      const name2 = attribute.name;
      let value;
      if (attribute.value && typeof attribute.value == "object")
        if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
          const expression = attribute.value.data.estree.body[0];
          expression.type, value = state.evaluater.evaluateExpression(expression.expression);
        } else
          crashEstree(state, node2.position);
      else
        value = attribute.value === null ? !0 : attribute.value;
      props[name2] = /** @type {Props[keyof Props]} */
      value;
    }
  return props;
}
__name(createJsxElementProps, "createJsxElementProps");
function createChildren(state, node2) {
  const children = [];
  let index2 = -1;
  const countsByName = state.passKeys ? /* @__PURE__ */ new Map() : emptyMap;
  for (; ++index2 < node2.children.length; ) {
    const child = node2.children[index2];
    let key;
    if (state.passKeys) {
      const name2 = child.type === "element" ? child.tagName : child.type === "mdxJsxFlowElement" || child.type === "mdxJsxTextElement" ? child.name : void 0;
      if (name2) {
        const count = countsByName.get(name2) || 0;
        key = name2 + "-" + count, countsByName.set(name2, count + 1);
      }
    }
    const result2 = one$2(state, child, key);
    result2 !== void 0 && children.push(result2);
  }
  return children;
}
__name(createChildren, "createChildren");
function createProperty(state, prop, value) {
  const info = find(state.schema, prop);
  if (!(value == null || typeof value == "number" && Number.isNaN(value))) {
    if (Array.isArray(value) && (value = info.commaSeparated ? stringify$1(value) : stringify(value)), info.property === "style") {
      let styleObject = typeof value == "object" ? value : parseStyle(state, String(value));
      return state.stylePropertyNameCase === "css" && (styleObject = transformStylesToCssCasing(styleObject)), ["style", styleObject];
    }
    return [
      state.elementAttributeNameCase === "react" && info.space ? hastToReact[info.property] || info.property : info.attribute,
      value
    ];
  }
}
__name(createProperty, "createProperty");
function parseStyle(state, value) {
  try {
    return styleToJs(value, { reactCompat: !0 });
  } catch (error) {
    if (state.ignoreInvalidStyle)
      return {};
    const cause = (
      /** @type {Error} */
      error
    ), message = new VFileMessage("Cannot parse `style` attribute", {
      ancestors: state.ancestors,
      cause,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw message.file = state.filePath || void 0, message.url = docs + "#cannot-parse-style-attribute", message;
  }
}
__name(parseStyle, "parseStyle");
function findComponentFromName(state, name$1, allowExpression) {
  let result2;
  if (!allowExpression)
    result2 = { type: "Literal", value: name$1 };
  else if (name$1.includes(".")) {
    const identifiers2 = name$1.split(".");
    let index2 = -1, node2;
    for (; ++index2 < identifiers2.length; ) {
      const prop = name(identifiers2[index2]) ? { type: "Identifier", name: identifiers2[index2] } : { type: "Literal", value: identifiers2[index2] };
      node2 = node2 ? {
        type: "MemberExpression",
        object: node2,
        property: prop,
        computed: !!(index2 && prop.type === "Literal"),
        optional: !1
      } : prop;
    }
    result2 = node2;
  } else
    result2 = name(name$1) && !/^[a-z]/.test(name$1) ? { type: "Identifier", name: name$1 } : { type: "Literal", value: name$1 };
  if (result2.type === "Literal") {
    const name2 = (
      /** @type {string | number} */
      result2.value
    );
    return own$3.call(state.components, name2) ? state.components[name2] : name2;
  }
  if (state.evaluater)
    return state.evaluater.evaluateExpression(result2);
  crashEstree(state);
}
__name(findComponentFromName, "findComponentFromName");
function crashEstree(state, place) {
  const message = new VFileMessage(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: state.ancestors,
      place,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw message.file = state.filePath || void 0, message.url = docs + "#cannot-handle-mdx-estrees-without-createevaluater", message;
}
__name(crashEstree, "crashEstree");
function transformStylesToCssCasing(domCasing) {
  const cssCasing = {};
  let from;
  for (from in domCasing)
    own$3.call(domCasing, from) && (cssCasing[transformStyleToCssCasing(from)] = domCasing[from]);
  return cssCasing;
}
__name(transformStylesToCssCasing, "transformStylesToCssCasing");
function transformStyleToCssCasing(from) {
  let to = from.replace(cap, toDash);
  return to.slice(0, 3) === "ms-" && (to = "-" + to), to;
}
__name(transformStyleToCssCasing, "transformStyleToCssCasing");
function toDash($0) {
  return "-" + $0.toLowerCase();
}
__name(toDash, "toDash");
const urlAttributes = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, emptyOptions$1 = {};
function toString$5(value, options) {
  const settings = options || emptyOptions$1, includeImageAlt = typeof settings.includeImageAlt == "boolean" ? settings.includeImageAlt : !0, includeHtml = typeof settings.includeHtml == "boolean" ? settings.includeHtml : !0;
  return one$1(value, includeImageAlt, includeHtml);
}
__name(toString$5, "toString$5");
function one$1(value, includeImageAlt, includeHtml) {
  if (node(value)) {
    if ("value" in value)
      return value.type === "html" && !includeHtml ? "" : value.value;
    if (includeImageAlt && "alt" in value && value.alt)
      return value.alt;
    if ("children" in value)
      return all(value.children, includeImageAlt, includeHtml);
  }
  return Array.isArray(value) ? all(value, includeImageAlt, includeHtml) : "";
}
__name(one$1, "one$1");
function all(values, includeImageAlt, includeHtml) {
  const result2 = [];
  let index2 = -1;
  for (; ++index2 < values.length; )
    result2[index2] = one$1(values[index2], includeImageAlt, includeHtml);
  return result2.join("");
}
__name(all, "all");
function node(value) {
  return !!(value && typeof value == "object");
}
__name(node, "node");
const element = document.createElement("i");
function decodeNamedCharacterReference(value) {
  const characterReference2 = "&" + value + ";";
  element.innerHTML = characterReference2;
  const character = element.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    character.charCodeAt(character.length - 1) === 59 && value !== "semi" || character === characterReference2 ? !1 : character
  );
}
__name(decodeNamedCharacterReference, "decodeNamedCharacterReference");
function splice$1(list2, start, remove3, items) {
  const end = list2.length;
  let chunkStart = 0, parameters;
  if (start < 0 ? start = -start > end ? 0 : end + start : start = start > end ? end : start, remove3 = remove3 > 0 ? remove3 : 0, items.length < 1e4)
    parameters = Array.from(items), parameters.unshift(start, remove3), list2.splice(...parameters);
  else
    for (remove3 && list2.splice(start, remove3); chunkStart < items.length; )
      parameters = items.slice(chunkStart, chunkStart + 1e4), parameters.unshift(start, 0), list2.splice(...parameters), chunkStart += 1e4, start += 1e4;
}
__name(splice$1, "splice$1");
function push2(list2, items) {
  return list2.length > 0 ? (splice$1(list2, list2.length, 0, items), list2) : items;
}
__name(push2, "push");
const hasOwnProperty$b = {}.hasOwnProperty;
function combineExtensions(extensions) {
  const all2 = {};
  let index2 = -1;
  for (; ++index2 < extensions.length; )
    syntaxExtension(all2, extensions[index2]);
  return all2;
}
__name(combineExtensions, "combineExtensions");
function syntaxExtension(all2, extension2) {
  let hook;
  for (hook in extension2) {
    const left2 = (hasOwnProperty$b.call(all2, hook) ? all2[hook] : void 0) || (all2[hook] = {}), right2 = extension2[hook];
    let code2;
    if (right2)
      for (code2 in right2) {
        hasOwnProperty$b.call(left2, code2) || (left2[code2] = []);
        const value = right2[code2];
        constructs(
          // @ts-expect-error Looks like a list.
          left2[code2],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
  }
}
__name(syntaxExtension, "syntaxExtension");
function constructs(existing, list2) {
  let index2 = -1;
  const before = [];
  for (; ++index2 < list2.length; )
    (list2[index2].add === "after" ? existing : before).push(list2[index2]);
  splice$1(existing, 0, 0, before);
}
__name(constructs, "constructs");
function decodeNumericCharacterReference(value, base) {
  const code2 = Number.parseInt(value, base);
  return (
    // C0 except for HT, LF, FF, CR, space.
    code2 < 9 || code2 === 11 || code2 > 13 && code2 < 32 || // Control character (DEL) of C0, and C1 controls.
    code2 > 126 && code2 < 160 || // Lone high surrogates and low surrogates.
    code2 > 55295 && code2 < 57344 || // Noncharacters.
    code2 > 64975 && code2 < 65008 || /* eslint-disable no-bitwise */
    (code2 & 65535) === 65535 || (code2 & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    code2 > 1114111 ? "�" : String.fromCodePoint(code2)
  );
}
__name(decodeNumericCharacterReference, "decodeNumericCharacterReference");
function normalizeIdentifier(value) {
  return value.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
__name(normalizeIdentifier, "normalizeIdentifier");
const asciiAlpha = regexCheck(/[A-Za-z]/), asciiAlphanumeric = regexCheck(/[\dA-Za-z]/), asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(code2) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code2 !== null && (code2 < 32 || code2 === 127)
  );
}
__name(asciiControl, "asciiControl");
const asciiDigit = regexCheck(/\d/), asciiHexDigit = regexCheck(/[\dA-Fa-f]/), asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(code2) {
  return code2 !== null && code2 < -2;
}
__name(markdownLineEnding, "markdownLineEnding");
function markdownLineEndingOrSpace(code2) {
  return code2 !== null && (code2 < 0 || code2 === 32);
}
__name(markdownLineEndingOrSpace, "markdownLineEndingOrSpace");
function markdownSpace(code2) {
  return code2 === -2 || code2 === -1 || code2 === 32;
}
__name(markdownSpace, "markdownSpace");
const unicodePunctuation = regexCheck(/\p{P}|\p{S}/u), unicodeWhitespace = regexCheck(/\s/);
function regexCheck(regex) {
  return check2;
  function check2(code2) {
    return code2 !== null && code2 > -1 && regex.test(String.fromCharCode(code2));
  }
}
__name(regexCheck, "regexCheck");
function normalizeUri(value) {
  const result2 = [];
  let index2 = -1, start = 0, skip = 0;
  for (; ++index2 < value.length; ) {
    const code2 = value.charCodeAt(index2);
    let replace2 = "";
    if (code2 === 37 && asciiAlphanumeric(value.charCodeAt(index2 + 1)) && asciiAlphanumeric(value.charCodeAt(index2 + 2)))
      skip = 2;
    else if (code2 < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code2)) || (replace2 = String.fromCharCode(code2));
    else if (code2 > 55295 && code2 < 57344) {
      const next = value.charCodeAt(index2 + 1);
      code2 < 56320 && next > 56319 && next < 57344 ? (replace2 = String.fromCharCode(code2, next), skip = 1) : replace2 = "�";
    } else
      replace2 = String.fromCharCode(code2);
    replace2 && (result2.push(value.slice(start, index2), encodeURIComponent(replace2)), start = index2 + skip + 1, replace2 = ""), skip && (index2 += skip, skip = 0);
  }
  return result2.join("") + value.slice(start);
}
__name(normalizeUri, "normalizeUri");
function factorySpace(effects2, ok2, type, max2) {
  const limit = max2 ? max2 - 1 : Number.POSITIVE_INFINITY;
  let size = 0;
  return start;
  function start(code2) {
    return markdownSpace(code2) ? (effects2.enter(type), prefix2(code2)) : ok2(code2);
  }
  function prefix2(code2) {
    return markdownSpace(code2) && size++ < limit ? (effects2.consume(code2), prefix2) : (effects2.exit(type), ok2(code2));
  }
}
__name(factorySpace, "factorySpace");
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(effects2) {
  const contentStart = effects2.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
  let previous2;
  return contentStart;
  function afterContentStartConstruct(code2) {
    if (code2 === null) {
      effects2.consume(code2);
      return;
    }
    return effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), factorySpace(effects2, contentStart, "linePrefix");
  }
  function paragraphInitial(code2) {
    return effects2.enter("paragraph"), lineStart(code2);
  }
  function lineStart(code2) {
    const token = effects2.enter("chunkText", {
      contentType: "text",
      previous: previous2
    });
    return previous2 && (previous2.next = token), previous2 = token, data2(code2);
  }
  function data2(code2) {
    if (code2 === null) {
      effects2.exit("chunkText"), effects2.exit("paragraph"), effects2.consume(code2);
      return;
    }
    return markdownLineEnding(code2) ? (effects2.consume(code2), effects2.exit("chunkText"), lineStart) : (effects2.consume(code2), data2);
  }
}
__name(initializeContent, "initializeContent");
const document$2 = {
  tokenize: initializeDocument
}, containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(effects2) {
  const self2 = this, stack = [];
  let continued = 0, childFlow, childToken, lineStartOffset;
  return start;
  function start(code2) {
    if (continued < stack.length) {
      const item = stack[continued];
      return self2.containerState = item[1], effects2.attempt(item[0].continuation, documentContinue, checkNewContainers)(code2);
    }
    return checkNewContainers(code2);
  }
  function documentContinue(code2) {
    if (continued++, self2.containerState._closeFlow) {
      self2.containerState._closeFlow = void 0, childFlow && closeFlow();
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits, point2;
      for (; indexBeforeFlow--; )
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          point2 = self2.events[indexBeforeFlow][1].end;
          break;
        }
      exitContainers(continued);
      let index2 = indexBeforeExits;
      for (; index2 < self2.events.length; )
        self2.events[index2][1].end = {
          ...point2
        }, index2++;
      return splice$1(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits)), self2.events.length = index2, checkNewContainers(code2);
    }
    return start(code2);
  }
  function checkNewContainers(code2) {
    if (continued === stack.length) {
      if (!childFlow)
        return documentContinued(code2);
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete)
        return flowStart(code2);
      self2.interrupt = !!(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
    }
    return self2.containerState = {}, effects2.check(containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code2);
  }
  function thereIsANewContainer(code2) {
    return childFlow && closeFlow(), exitContainers(continued), documentContinued(code2);
  }
  function thereIsNoNewContainer(code2) {
    return self2.parser.lazy[self2.now().line] = continued !== stack.length, lineStartOffset = self2.now().offset, flowStart(code2);
  }
  function documentContinued(code2) {
    return self2.containerState = {}, effects2.attempt(containerConstruct, containerContinue, flowStart)(code2);
  }
  function containerContinue(code2) {
    return continued++, stack.push([self2.currentConstruct, self2.containerState]), documentContinued(code2);
  }
  function flowStart(code2) {
    if (code2 === null) {
      childFlow && closeFlow(), exitContainers(0), effects2.consume(code2);
      return;
    }
    return childFlow = childFlow || self2.parser.flow(self2.now()), effects2.enter("chunkFlow", {
      _tokenizer: childFlow,
      contentType: "flow",
      previous: childToken
    }), flowContinue(code2);
  }
  function flowContinue(code2) {
    if (code2 === null) {
      writeToChild(effects2.exit("chunkFlow"), !0), exitContainers(0), effects2.consume(code2);
      return;
    }
    return markdownLineEnding(code2) ? (effects2.consume(code2), writeToChild(effects2.exit("chunkFlow")), continued = 0, self2.interrupt = void 0, start) : (effects2.consume(code2), flowContinue);
  }
  function writeToChild(token, endOfFile) {
    const stream = self2.sliceStream(token);
    if (endOfFile && stream.push(null), token.previous = childToken, childToken && (childToken.next = token), childToken = token, childFlow.defineSkip(token.start), childFlow.write(stream), self2.parser.lazy[token.start.line]) {
      let index2 = childFlow.events.length;
      for (; index2--; )
        if (
          // The token starts before the line ending…
          childFlow.events[index2][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index2][1].end || // …or ends after it.
          childFlow.events[index2][1].end.offset > lineStartOffset)
        )
          return;
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits, seen, point2;
      for (; indexBeforeFlow--; )
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          if (seen) {
            point2 = self2.events[indexBeforeFlow][1].end;
            break;
          }
          seen = !0;
        }
      for (exitContainers(continued), index2 = indexBeforeExits; index2 < self2.events.length; )
        self2.events[index2][1].end = {
          ...point2
        }, index2++;
      splice$1(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits)), self2.events.length = index2;
    }
  }
  function exitContainers(size) {
    let index2 = stack.length;
    for (; index2-- > size; ) {
      const entry = stack[index2];
      self2.containerState = entry[1], entry[0].exit.call(self2, effects2);
    }
    stack.length = size;
  }
  function closeFlow() {
    childFlow.write([null]), childToken = void 0, childFlow = void 0, self2.containerState._closeFlow = void 0;
  }
}
__name(initializeDocument, "initializeDocument");
function tokenizeContainer(effects2, ok2, nok) {
  return factorySpace(effects2, effects2.attempt(this.parser.constructs.document, ok2, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
__name(tokenizeContainer, "tokenizeContainer");
function classifyCharacter(code2) {
  if (code2 === null || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2))
    return 1;
  if (unicodePunctuation(code2))
    return 2;
}
__name(classifyCharacter, "classifyCharacter");
function resolveAll(constructs2, events, context) {
  const called = [];
  let index2 = -1;
  for (; ++index2 < constructs2.length; ) {
    const resolve = constructs2[index2].resolveAll;
    resolve && !called.includes(resolve) && (events = resolve(events, context), called.push(resolve));
  }
  return events;
}
__name(resolveAll, "resolveAll");
const attention = {
  name: "attention",
  resolveAll: resolveAllAttention,
  tokenize: tokenizeAttention
};
function resolveAllAttention(events, context) {
  let index2 = -1, open, group, text2, openingSequence, closingSequence, use, nextEvents, offset;
  for (; ++index2 < events.length; )
    if (events[index2][0] === "enter" && events[index2][1].type === "attentionSequence" && events[index2][1]._close) {
      for (open = index2; open--; )
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index2][1]).charCodeAt(0)) {
          if ((events[open][1]._close || events[index2][1]._open) && (events[index2][1].end.offset - events[index2][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index2][1].end.offset - events[index2][1].start.offset) % 3))
            continue;
          use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index2][1].end.offset - events[index2][1].start.offset > 1 ? 2 : 1;
          const start = {
            ...events[open][1].end
          }, end = {
            ...events[index2][1].start
          };
          movePoint(start, -use), movePoint(end, use), openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start,
            end: {
              ...events[open][1].end
            }
          }, closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...events[index2][1].start
            },
            end
          }, text2 = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: {
              ...events[open][1].end
            },
            end: {
              ...events[index2][1].start
            }
          }, group = {
            type: use > 1 ? "strong" : "emphasis",
            start: {
              ...openingSequence.start
            },
            end: {
              ...closingSequence.end
            }
          }, events[open][1].end = {
            ...openingSequence.start
          }, events[index2][1].start = {
            ...closingSequence.end
          }, nextEvents = [], events[open][1].end.offset - events[open][1].start.offset && (nextEvents = push2(nextEvents, [["enter", events[open][1], context], ["exit", events[open][1], context]])), nextEvents = push2(nextEvents, [["enter", group, context], ["enter", openingSequence, context], ["exit", openingSequence, context], ["enter", text2, context]]), nextEvents = push2(nextEvents, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + 1, index2), context)), nextEvents = push2(nextEvents, [["exit", text2, context], ["enter", closingSequence, context], ["exit", closingSequence, context], ["exit", group, context]]), events[index2][1].end.offset - events[index2][1].start.offset ? (offset = 2, nextEvents = push2(nextEvents, [["enter", events[index2][1], context], ["exit", events[index2][1], context]])) : offset = 0, splice$1(events, open - 1, index2 - open + 3, nextEvents), index2 = open + nextEvents.length - offset - 2;
          break;
        }
    }
  for (index2 = -1; ++index2 < events.length; )
    events[index2][1].type === "attentionSequence" && (events[index2][1].type = "data");
  return events;
}
__name(resolveAllAttention, "resolveAllAttention");
function tokenizeAttention(effects2, ok2) {
  const attentionMarkers2 = this.parser.constructs.attentionMarkers.null, previous2 = this.previous, before = classifyCharacter(previous2);
  let marker;
  return start;
  function start(code2) {
    return marker = code2, effects2.enter("attentionSequence"), inside(code2);
  }
  function inside(code2) {
    if (code2 === marker)
      return effects2.consume(code2), inside;
    const token = effects2.exit("attentionSequence"), after = classifyCharacter(code2), open = !after || after === 2 && before || attentionMarkers2.includes(code2), close = !before || before === 2 && after || attentionMarkers2.includes(previous2);
    return token._open = !!(marker === 42 ? open : open && (before || !close)), token._close = !!(marker === 42 ? close : close && (after || !open)), ok2(code2);
  }
}
__name(tokenizeAttention, "tokenizeAttention");
function movePoint(point2, offset) {
  point2.column += offset, point2.offset += offset, point2._bufferIndex += offset;
}
__name(movePoint, "movePoint");
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects2, ok2, nok) {
  let size = 0;
  return start;
  function start(code2) {
    return effects2.enter("autolink"), effects2.enter("autolinkMarker"), effects2.consume(code2), effects2.exit("autolinkMarker"), effects2.enter("autolinkProtocol"), open;
  }
  function open(code2) {
    return asciiAlpha(code2) ? (effects2.consume(code2), schemeOrEmailAtext) : code2 === 64 ? nok(code2) : emailAtext(code2);
  }
  function schemeOrEmailAtext(code2) {
    return code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2) ? (size = 1, schemeInsideOrEmailAtext(code2)) : emailAtext(code2);
  }
  function schemeInsideOrEmailAtext(code2) {
    return code2 === 58 ? (effects2.consume(code2), size = 0, urlInside) : (code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2)) && size++ < 32 ? (effects2.consume(code2), schemeInsideOrEmailAtext) : (size = 0, emailAtext(code2));
  }
  function urlInside(code2) {
    return code2 === 62 ? (effects2.exit("autolinkProtocol"), effects2.enter("autolinkMarker"), effects2.consume(code2), effects2.exit("autolinkMarker"), effects2.exit("autolink"), ok2) : code2 === null || code2 === 32 || code2 === 60 || asciiControl(code2) ? nok(code2) : (effects2.consume(code2), urlInside);
  }
  function emailAtext(code2) {
    return code2 === 64 ? (effects2.consume(code2), emailAtSignOrDot) : asciiAtext(code2) ? (effects2.consume(code2), emailAtext) : nok(code2);
  }
  function emailAtSignOrDot(code2) {
    return asciiAlphanumeric(code2) ? emailLabel(code2) : nok(code2);
  }
  function emailLabel(code2) {
    return code2 === 46 ? (effects2.consume(code2), size = 0, emailAtSignOrDot) : code2 === 62 ? (effects2.exit("autolinkProtocol").type = "autolinkEmail", effects2.enter("autolinkMarker"), effects2.consume(code2), effects2.exit("autolinkMarker"), effects2.exit("autolink"), ok2) : emailValue(code2);
  }
  function emailValue(code2) {
    if ((code2 === 45 || asciiAlphanumeric(code2)) && size++ < 63) {
      const next = code2 === 45 ? emailValue : emailLabel;
      return effects2.consume(code2), next;
    }
    return nok(code2);
  }
}
__name(tokenizeAutolink, "tokenizeAutolink");
const blankLine = {
  partial: !0,
  tokenize: tokenizeBlankLine
};
function tokenizeBlankLine(effects2, ok2, nok) {
  return start;
  function start(code2) {
    return markdownSpace(code2) ? factorySpace(effects2, after, "linePrefix")(code2) : after(code2);
  }
  function after(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok2(code2) : nok(code2);
  }
}
__name(tokenizeBlankLine, "tokenizeBlankLine");
const blockQuote = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit,
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart
};
function tokenizeBlockQuoteStart(effects2, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === 62) {
      const state = self2.containerState;
      return state.open || (effects2.enter("blockQuote", {
        _container: !0
      }), state.open = !0), effects2.enter("blockQuotePrefix"), effects2.enter("blockQuoteMarker"), effects2.consume(code2), effects2.exit("blockQuoteMarker"), after;
    }
    return nok(code2);
  }
  function after(code2) {
    return markdownSpace(code2) ? (effects2.enter("blockQuotePrefixWhitespace"), effects2.consume(code2), effects2.exit("blockQuotePrefixWhitespace"), effects2.exit("blockQuotePrefix"), ok2) : (effects2.exit("blockQuotePrefix"), ok2(code2));
  }
}
__name(tokenizeBlockQuoteStart, "tokenizeBlockQuoteStart");
function tokenizeBlockQuoteContinuation(effects2, ok2, nok) {
  const self2 = this;
  return contStart;
  function contStart(code2) {
    return markdownSpace(code2) ? factorySpace(effects2, contBefore, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2) : contBefore(code2);
  }
  function contBefore(code2) {
    return effects2.attempt(blockQuote, ok2, nok)(code2);
  }
}
__name(tokenizeBlockQuoteContinuation, "tokenizeBlockQuoteContinuation");
function exit(effects2) {
  effects2.exit("blockQuote");
}
__name(exit, "exit");
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects2, ok2, nok) {
  return start;
  function start(code2) {
    return effects2.enter("characterEscape"), effects2.enter("escapeMarker"), effects2.consume(code2), effects2.exit("escapeMarker"), inside;
  }
  function inside(code2) {
    return asciiPunctuation(code2) ? (effects2.enter("characterEscapeValue"), effects2.consume(code2), effects2.exit("characterEscapeValue"), effects2.exit("characterEscape"), ok2) : nok(code2);
  }
}
__name(tokenizeCharacterEscape, "tokenizeCharacterEscape");
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects2, ok2, nok) {
  const self2 = this;
  let size = 0, max2, test2;
  return start;
  function start(code2) {
    return effects2.enter("characterReference"), effects2.enter("characterReferenceMarker"), effects2.consume(code2), effects2.exit("characterReferenceMarker"), open;
  }
  function open(code2) {
    return code2 === 35 ? (effects2.enter("characterReferenceMarkerNumeric"), effects2.consume(code2), effects2.exit("characterReferenceMarkerNumeric"), numeric2) : (effects2.enter("characterReferenceValue"), max2 = 31, test2 = asciiAlphanumeric, value(code2));
  }
  function numeric2(code2) {
    return code2 === 88 || code2 === 120 ? (effects2.enter("characterReferenceMarkerHexadecimal"), effects2.consume(code2), effects2.exit("characterReferenceMarkerHexadecimal"), effects2.enter("characterReferenceValue"), max2 = 6, test2 = asciiHexDigit, value) : (effects2.enter("characterReferenceValue"), max2 = 7, test2 = asciiDigit, value(code2));
  }
  function value(code2) {
    if (code2 === 59 && size) {
      const token = effects2.exit("characterReferenceValue");
      return test2 === asciiAlphanumeric && !decodeNamedCharacterReference(self2.sliceSerialize(token)) ? nok(code2) : (effects2.enter("characterReferenceMarker"), effects2.consume(code2), effects2.exit("characterReferenceMarker"), effects2.exit("characterReference"), ok2);
    }
    return test2(code2) && size++ < max2 ? (effects2.consume(code2), value) : nok(code2);
  }
}
__name(tokenizeCharacterReference, "tokenizeCharacterReference");
const nonLazyContinuation = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuation
}, codeFenced = {
  concrete: !0,
  name: "codeFenced",
  tokenize: tokenizeCodeFenced
};
function tokenizeCodeFenced(effects2, ok2, nok) {
  const self2 = this, closeStart = {
    partial: !0,
    tokenize: tokenizeCloseStart
  };
  let initialPrefix = 0, sizeOpen = 0, marker;
  return start;
  function start(code2) {
    return beforeSequenceOpen(code2);
  }
  function beforeSequenceOpen(code2) {
    const tail = self2.events[self2.events.length - 1];
    return initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], !0).length : 0, marker = code2, effects2.enter("codeFenced"), effects2.enter("codeFencedFence"), effects2.enter("codeFencedFenceSequence"), sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    return code2 === marker ? (sizeOpen++, effects2.consume(code2), sequenceOpen) : sizeOpen < 3 ? nok(code2) : (effects2.exit("codeFencedFenceSequence"), markdownSpace(code2) ? factorySpace(effects2, infoBefore, "whitespace")(code2) : infoBefore(code2));
  }
  function infoBefore(code2) {
    return code2 === null || markdownLineEnding(code2) ? (effects2.exit("codeFencedFence"), self2.interrupt ? ok2(code2) : effects2.check(nonLazyContinuation, atNonLazyBreak, after)(code2)) : (effects2.enter("codeFencedFenceInfo"), effects2.enter("chunkString", {
      contentType: "string"
    }), info(code2));
  }
  function info(code2) {
    return code2 === null || markdownLineEnding(code2) ? (effects2.exit("chunkString"), effects2.exit("codeFencedFenceInfo"), infoBefore(code2)) : markdownSpace(code2) ? (effects2.exit("chunkString"), effects2.exit("codeFencedFenceInfo"), factorySpace(effects2, metaBefore, "whitespace")(code2)) : code2 === 96 && code2 === marker ? nok(code2) : (effects2.consume(code2), info);
  }
  function metaBefore(code2) {
    return code2 === null || markdownLineEnding(code2) ? infoBefore(code2) : (effects2.enter("codeFencedFenceMeta"), effects2.enter("chunkString", {
      contentType: "string"
    }), meta(code2));
  }
  function meta(code2) {
    return code2 === null || markdownLineEnding(code2) ? (effects2.exit("chunkString"), effects2.exit("codeFencedFenceMeta"), infoBefore(code2)) : code2 === 96 && code2 === marker ? nok(code2) : (effects2.consume(code2), meta);
  }
  function atNonLazyBreak(code2) {
    return effects2.attempt(closeStart, after, contentBefore)(code2);
  }
  function contentBefore(code2) {
    return effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), contentStart;
  }
  function contentStart(code2) {
    return initialPrefix > 0 && markdownSpace(code2) ? factorySpace(effects2, beforeContentChunk, "linePrefix", initialPrefix + 1)(code2) : beforeContentChunk(code2);
  }
  function beforeContentChunk(code2) {
    return code2 === null || markdownLineEnding(code2) ? effects2.check(nonLazyContinuation, atNonLazyBreak, after)(code2) : (effects2.enter("codeFlowValue"), contentChunk(code2));
  }
  function contentChunk(code2) {
    return code2 === null || markdownLineEnding(code2) ? (effects2.exit("codeFlowValue"), beforeContentChunk(code2)) : (effects2.consume(code2), contentChunk);
  }
  function after(code2) {
    return effects2.exit("codeFenced"), ok2(code2);
  }
  function tokenizeCloseStart(effects3, ok3, nok2) {
    let size = 0;
    return startBefore;
    function startBefore(code2) {
      return effects3.enter("lineEnding"), effects3.consume(code2), effects3.exit("lineEnding"), start2;
    }
    function start2(code2) {
      return effects3.enter("codeFencedFence"), markdownSpace(code2) ? factorySpace(effects3, beforeSequenceClose, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2) : beforeSequenceClose(code2);
    }
    function beforeSequenceClose(code2) {
      return code2 === marker ? (effects3.enter("codeFencedFenceSequence"), sequenceClose(code2)) : nok2(code2);
    }
    function sequenceClose(code2) {
      return code2 === marker ? (size++, effects3.consume(code2), sequenceClose) : size >= sizeOpen ? (effects3.exit("codeFencedFenceSequence"), markdownSpace(code2) ? factorySpace(effects3, sequenceCloseAfter, "whitespace")(code2) : sequenceCloseAfter(code2)) : nok2(code2);
    }
    function sequenceCloseAfter(code2) {
      return code2 === null || markdownLineEnding(code2) ? (effects3.exit("codeFencedFence"), ok3(code2)) : nok2(code2);
    }
  }
}
__name(tokenizeCodeFenced, "tokenizeCodeFenced");
function tokenizeNonLazyContinuation(effects2, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    return code2 === null ? nok(code2) : (effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), lineStart);
  }
  function lineStart(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok2(code2);
  }
}
__name(tokenizeNonLazyContinuation, "tokenizeNonLazyContinuation");
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
}, furtherStart = {
  partial: !0,
  tokenize: tokenizeFurtherStart
};
function tokenizeCodeIndented(effects2, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    return effects2.enter("codeIndented"), factorySpace(effects2, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], !0).length >= 4 ? atBreak(code2) : nok(code2);
  }
  function atBreak(code2) {
    return code2 === null ? after(code2) : markdownLineEnding(code2) ? effects2.attempt(furtherStart, atBreak, after)(code2) : (effects2.enter("codeFlowValue"), inside(code2));
  }
  function inside(code2) {
    return code2 === null || markdownLineEnding(code2) ? (effects2.exit("codeFlowValue"), atBreak(code2)) : (effects2.consume(code2), inside);
  }
  function after(code2) {
    return effects2.exit("codeIndented"), ok2(code2);
  }
}
__name(tokenizeCodeIndented, "tokenizeCodeIndented");
function tokenizeFurtherStart(effects2, ok2, nok) {
  const self2 = this;
  return furtherStart2;
  function furtherStart2(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : markdownLineEnding(code2) ? (effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), furtherStart2) : factorySpace(effects2, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], !0).length >= 4 ? ok2(code2) : markdownLineEnding(code2) ? furtherStart2(code2) : nok(code2);
  }
}
__name(tokenizeFurtherStart, "tokenizeFurtherStart");
const codeText = {
  name: "codeText",
  previous,
  resolve: resolveCodeText,
  tokenize: tokenizeCodeText
};
function resolveCodeText(events) {
  let tailExitIndex = events.length - 4, headEnterIndex = 3, index2, enter;
  if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
    for (index2 = headEnterIndex; ++index2 < tailExitIndex; )
      if (events[index2][1].type === "codeTextData") {
        events[headEnterIndex][1].type = "codeTextPadding", events[tailExitIndex][1].type = "codeTextPadding", headEnterIndex += 2, tailExitIndex -= 2;
        break;
      }
  }
  for (index2 = headEnterIndex - 1, tailExitIndex++; ++index2 <= tailExitIndex; )
    enter === void 0 ? index2 !== tailExitIndex && events[index2][1].type !== "lineEnding" && (enter = index2) : (index2 === tailExitIndex || events[index2][1].type === "lineEnding") && (events[enter][1].type = "codeTextData", index2 !== enter + 2 && (events[enter][1].end = events[index2 - 1][1].end, events.splice(enter + 2, index2 - enter - 2), tailExitIndex -= index2 - enter - 2, index2 = enter + 2), enter = void 0);
  return events;
}
__name(resolveCodeText, "resolveCodeText");
function previous(code2) {
  return code2 !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
__name(previous, "previous");
function tokenizeCodeText(effects2, ok2, nok) {
  let sizeOpen = 0, size, token;
  return start;
  function start(code2) {
    return effects2.enter("codeText"), effects2.enter("codeTextSequence"), sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    return code2 === 96 ? (effects2.consume(code2), sizeOpen++, sequenceOpen) : (effects2.exit("codeTextSequence"), between(code2));
  }
  function between(code2) {
    return code2 === null ? nok(code2) : code2 === 32 ? (effects2.enter("space"), effects2.consume(code2), effects2.exit("space"), between) : code2 === 96 ? (token = effects2.enter("codeTextSequence"), size = 0, sequenceClose(code2)) : markdownLineEnding(code2) ? (effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), between) : (effects2.enter("codeTextData"), data2(code2));
  }
  function data2(code2) {
    return code2 === null || code2 === 32 || code2 === 96 || markdownLineEnding(code2) ? (effects2.exit("codeTextData"), between(code2)) : (effects2.consume(code2), data2);
  }
  function sequenceClose(code2) {
    return code2 === 96 ? (effects2.consume(code2), size++, sequenceClose) : size === sizeOpen ? (effects2.exit("codeTextSequence"), effects2.exit("codeText"), ok2(code2)) : (token.type = "codeTextData", data2(code2));
  }
}
__name(tokenizeCodeText, "tokenizeCodeText");
const _SpliceBuffer = class _SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(initial) {
    this.left = initial ? [...initial] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(index2) {
    if (index2 < 0 || index2 >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + index2 + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return index2 < this.left.length ? this.left[index2] : this.right[this.right.length - index2 + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(start, end) {
    const stop = end ?? Number.POSITIVE_INFINITY;
    return stop < this.left.length ? this.left.slice(start, stop) : start > this.left.length ? this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse() : this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(start, deleteCount, items) {
    const count = deleteCount || 0;
    this.setCursor(Math.trunc(start));
    const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
    return items && chunkedPush(this.left, items), removed.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(item) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(item);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(items) {
    this.setCursor(Number.POSITIVE_INFINITY), chunkedPush(this.left, items);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(item) {
    this.setCursor(0), this.right.push(item);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(items) {
    this.setCursor(0), chunkedPush(this.right, items.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
        chunkedPush(this.right, removed.reverse());
      } else {
        const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        chunkedPush(this.left, removed.reverse());
      }
  }
};
__name(_SpliceBuffer, "SpliceBuffer");
let SpliceBuffer = _SpliceBuffer;
function chunkedPush(list2, right2) {
  let chunkStart = 0;
  if (right2.length < 1e4)
    list2.push(...right2);
  else
    for (; chunkStart < right2.length; )
      list2.push(...right2.slice(chunkStart, chunkStart + 1e4)), chunkStart += 1e4;
}
__name(chunkedPush, "chunkedPush");
function subtokenize(eventsArray) {
  const jumps = {};
  let index2 = -1, event, lineIndex, otherIndex, otherEvent, parameters, subevents, more;
  const events = new SpliceBuffer(eventsArray);
  for (; ++index2 < events.length; ) {
    for (; index2 in jumps; )
      index2 = jumps[index2];
    if (event = events.get(index2), index2 && event[1].type === "chunkFlow" && events.get(index2 - 1)[1].type === "listItemPrefix" && (subevents = event[1]._tokenizer.events, otherIndex = 0, otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank" && (otherIndex += 2), otherIndex < subevents.length && subevents[otherIndex][1].type === "content"))
      for (; ++otherIndex < subevents.length && subevents[otherIndex][1].type !== "content"; )
        subevents[otherIndex][1].type === "chunkText" && (subevents[otherIndex][1]._isInFirstContentOfListItem = !0, otherIndex++);
    if (event[0] === "enter")
      event[1].contentType && (Object.assign(jumps, subcontent(events, index2)), index2 = jumps[index2], more = !0);
    else if (event[1]._container) {
      for (otherIndex = index2, lineIndex = void 0; otherIndex--; )
        if (otherEvent = events.get(otherIndex), otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank")
          otherEvent[0] === "enter" && (lineIndex && (events.get(lineIndex)[1].type = "lineEndingBlank"), otherEvent[1].type = "lineEnding", lineIndex = otherIndex);
        else if (!(otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent"))
          break;
      lineIndex && (event[1].end = {
        ...events.get(lineIndex)[1].start
      }, parameters = events.slice(lineIndex, index2), parameters.unshift(event), events.splice(lineIndex, index2 - lineIndex + 1, parameters));
    }
  }
  return splice$1(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0)), !more;
}
__name(subtokenize, "subtokenize");
function subcontent(events, eventIndex) {
  const token = events.get(eventIndex)[1], context = events.get(eventIndex)[2];
  let startPosition = eventIndex - 1;
  const startPositions = [];
  let tokenizer = token._tokenizer;
  tokenizer || (tokenizer = context.parser[token.contentType](token.start), token._contentTypeTextTrailing && (tokenizer._contentTypeTextTrailing = !0));
  const childEvents = tokenizer.events, jumps = [], gaps = {};
  let stream, previous2, index2 = -1, current = token, adjust = 0, start = 0;
  const breaks = [start];
  for (; current; ) {
    for (; events.get(++startPosition)[1] !== current; )
      ;
    startPositions.push(startPosition), current._tokenizer || (stream = context.sliceStream(current), current.next || stream.push(null), previous2 && tokenizer.defineSkip(current.start), current._isInFirstContentOfListItem && (tokenizer._gfmTasklistFirstContentOfListItem = !0), tokenizer.write(stream), current._isInFirstContentOfListItem && (tokenizer._gfmTasklistFirstContentOfListItem = void 0)), previous2 = current, current = current.next;
  }
  for (current = token; ++index2 < childEvents.length; )
    // Find a void token that includes a break.
    childEvents[index2][0] === "exit" && childEvents[index2 - 1][0] === "enter" && childEvents[index2][1].type === childEvents[index2 - 1][1].type && childEvents[index2][1].start.line !== childEvents[index2][1].end.line && (start = index2 + 1, breaks.push(start), current._tokenizer = void 0, current.previous = void 0, current = current.next);
  for (tokenizer.events = [], current ? (current._tokenizer = void 0, current.previous = void 0) : breaks.pop(), index2 = breaks.length; index2--; ) {
    const slice = childEvents.slice(breaks[index2], breaks[index2 + 1]), start2 = startPositions.pop();
    jumps.push([start2, start2 + slice.length - 1]), events.splice(start2, 2, slice);
  }
  for (jumps.reverse(), index2 = -1; ++index2 < jumps.length; )
    gaps[adjust + jumps[index2][0]] = adjust + jumps[index2][1], adjust += jumps[index2][1] - jumps[index2][0] - 1;
  return gaps;
}
__name(subcontent, "subcontent");
const content = {
  resolve: resolveContent,
  tokenize: tokenizeContent
}, continuationConstruct = {
  partial: !0,
  tokenize: tokenizeContinuation
};
function resolveContent(events) {
  return subtokenize(events), events;
}
__name(resolveContent, "resolveContent");
function tokenizeContent(effects2, ok2) {
  let previous2;
  return chunkStart;
  function chunkStart(code2) {
    return effects2.enter("content"), previous2 = effects2.enter("chunkContent", {
      contentType: "content"
    }), chunkInside(code2);
  }
  function chunkInside(code2) {
    return code2 === null ? contentEnd(code2) : markdownLineEnding(code2) ? effects2.check(continuationConstruct, contentContinue, contentEnd)(code2) : (effects2.consume(code2), chunkInside);
  }
  function contentEnd(code2) {
    return effects2.exit("chunkContent"), effects2.exit("content"), ok2(code2);
  }
  function contentContinue(code2) {
    return effects2.consume(code2), effects2.exit("chunkContent"), previous2.next = effects2.enter("chunkContent", {
      contentType: "content",
      previous: previous2
    }), previous2 = previous2.next, chunkInside;
  }
}
__name(tokenizeContent, "tokenizeContent");
function tokenizeContinuation(effects2, ok2, nok) {
  const self2 = this;
  return startLookahead;
  function startLookahead(code2) {
    return effects2.exit("chunkContent"), effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), factorySpace(effects2, prefixed, "linePrefix");
  }
  function prefixed(code2) {
    if (code2 === null || markdownLineEnding(code2))
      return nok(code2);
    const tail = self2.events[self2.events.length - 1];
    return !self2.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], !0).length >= 4 ? ok2(code2) : effects2.interrupt(self2.parser.constructs.flow, nok, ok2)(code2);
  }
}
__name(tokenizeContinuation, "tokenizeContinuation");
function factoryDestination(effects2, ok2, nok, type, literalType, literalMarkerType, rawType, stringType, max2) {
  const limit = max2 || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start;
  function start(code2) {
    return code2 === 60 ? (effects2.enter(type), effects2.enter(literalType), effects2.enter(literalMarkerType), effects2.consume(code2), effects2.exit(literalMarkerType), enclosedBefore) : code2 === null || code2 === 32 || code2 === 41 || asciiControl(code2) ? nok(code2) : (effects2.enter(type), effects2.enter(rawType), effects2.enter(stringType), effects2.enter("chunkString", {
      contentType: "string"
    }), raw(code2));
  }
  function enclosedBefore(code2) {
    return code2 === 62 ? (effects2.enter(literalMarkerType), effects2.consume(code2), effects2.exit(literalMarkerType), effects2.exit(literalType), effects2.exit(type), ok2) : (effects2.enter(stringType), effects2.enter("chunkString", {
      contentType: "string"
    }), enclosed(code2));
  }
  function enclosed(code2) {
    return code2 === 62 ? (effects2.exit("chunkString"), effects2.exit(stringType), enclosedBefore(code2)) : code2 === null || code2 === 60 || markdownLineEnding(code2) ? nok(code2) : (effects2.consume(code2), code2 === 92 ? enclosedEscape : enclosed);
  }
  function enclosedEscape(code2) {
    return code2 === 60 || code2 === 62 || code2 === 92 ? (effects2.consume(code2), enclosed) : enclosed(code2);
  }
  function raw(code2) {
    return !balance && (code2 === null || code2 === 41 || markdownLineEndingOrSpace(code2)) ? (effects2.exit("chunkString"), effects2.exit(stringType), effects2.exit(rawType), effects2.exit(type), ok2(code2)) : balance < limit && code2 === 40 ? (effects2.consume(code2), balance++, raw) : code2 === 41 ? (effects2.consume(code2), balance--, raw) : code2 === null || code2 === 32 || code2 === 40 || asciiControl(code2) ? nok(code2) : (effects2.consume(code2), code2 === 92 ? rawEscape : raw);
  }
  function rawEscape(code2) {
    return code2 === 40 || code2 === 41 || code2 === 92 ? (effects2.consume(code2), raw) : raw(code2);
  }
}
__name(factoryDestination, "factoryDestination");
function factoryLabel(effects2, ok2, nok, type, markerType, stringType) {
  const self2 = this;
  let size = 0, seen;
  return start;
  function start(code2) {
    return effects2.enter(type), effects2.enter(markerType), effects2.consume(code2), effects2.exit(markerType), effects2.enter(stringType), atBreak;
  }
  function atBreak(code2) {
    return size > 999 || code2 === null || code2 === 91 || code2 === 93 && !seen || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    code2 === 94 && !size && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : code2 === 93 ? (effects2.exit(stringType), effects2.enter(markerType), effects2.consume(code2), effects2.exit(markerType), effects2.exit(type), ok2) : markdownLineEnding(code2) ? (effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), atBreak) : (effects2.enter("chunkString", {
      contentType: "string"
    }), labelInside(code2));
  }
  function labelInside(code2) {
    return code2 === null || code2 === 91 || code2 === 93 || markdownLineEnding(code2) || size++ > 999 ? (effects2.exit("chunkString"), atBreak(code2)) : (effects2.consume(code2), seen || (seen = !markdownSpace(code2)), code2 === 92 ? labelEscape : labelInside);
  }
  function labelEscape(code2) {
    return code2 === 91 || code2 === 92 || code2 === 93 ? (effects2.consume(code2), size++, labelInside) : labelInside(code2);
  }
}
__name(factoryLabel, "factoryLabel");
function factoryTitle(effects2, ok2, nok, type, markerType, stringType) {
  let marker;
  return start;
  function start(code2) {
    return code2 === 34 || code2 === 39 || code2 === 40 ? (effects2.enter(type), effects2.enter(markerType), effects2.consume(code2), effects2.exit(markerType), marker = code2 === 40 ? 41 : code2, begin) : nok(code2);
  }
  function begin(code2) {
    return code2 === marker ? (effects2.enter(markerType), effects2.consume(code2), effects2.exit(markerType), effects2.exit(type), ok2) : (effects2.enter(stringType), atBreak(code2));
  }
  function atBreak(code2) {
    return code2 === marker ? (effects2.exit(stringType), begin(marker)) : code2 === null ? nok(code2) : markdownLineEnding(code2) ? (effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), factorySpace(effects2, atBreak, "linePrefix")) : (effects2.enter("chunkString", {
      contentType: "string"
    }), inside(code2));
  }
  function inside(code2) {
    return code2 === marker || code2 === null || markdownLineEnding(code2) ? (effects2.exit("chunkString"), atBreak(code2)) : (effects2.consume(code2), code2 === 92 ? escape : inside);
  }
  function escape(code2) {
    return code2 === marker || code2 === 92 ? (effects2.consume(code2), inside) : inside(code2);
  }
}
__name(factoryTitle, "factoryTitle");
function factoryWhitespace(effects2, ok2) {
  let seen;
  return start;
  function start(code2) {
    return markdownLineEnding(code2) ? (effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), seen = !0, start) : markdownSpace(code2) ? factorySpace(effects2, start, seen ? "linePrefix" : "lineSuffix")(code2) : ok2(code2);
  }
}
__name(factoryWhitespace, "factoryWhitespace");
const definition = {
  name: "definition",
  tokenize: tokenizeDefinition
}, titleBefore = {
  partial: !0,
  tokenize: tokenizeTitleBefore
};
function tokenizeDefinition(effects2, ok2, nok) {
  const self2 = this;
  let identifier;
  return start;
  function start(code2) {
    return effects2.enter("definition"), before(code2);
  }
  function before(code2) {
    return factoryLabel.call(
      self2,
      effects2,
      labelAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(code2);
  }
  function labelAfter(code2) {
    return identifier = normalizeIdentifier(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1)), code2 === 58 ? (effects2.enter("definitionMarker"), effects2.consume(code2), effects2.exit("definitionMarker"), markerAfter) : nok(code2);
  }
  function markerAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects2, destinationBefore)(code2) : destinationBefore(code2);
  }
  function destinationBefore(code2) {
    return factoryDestination(
      effects2,
      destinationAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(code2);
  }
  function destinationAfter(code2) {
    return effects2.attempt(titleBefore, after, after)(code2);
  }
  function after(code2) {
    return markdownSpace(code2) ? factorySpace(effects2, afterWhitespace, "whitespace")(code2) : afterWhitespace(code2);
  }
  function afterWhitespace(code2) {
    return code2 === null || markdownLineEnding(code2) ? (effects2.exit("definition"), self2.parser.defined.push(identifier), ok2(code2)) : nok(code2);
  }
}
__name(tokenizeDefinition, "tokenizeDefinition");
function tokenizeTitleBefore(effects2, ok2, nok) {
  return titleBefore2;
  function titleBefore2(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects2, beforeMarker)(code2) : nok(code2);
  }
  function beforeMarker(code2) {
    return factoryTitle(effects2, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code2);
  }
  function titleAfter(code2) {
    return markdownSpace(code2) ? factorySpace(effects2, titleAfterOptionalWhitespace, "whitespace")(code2) : titleAfterOptionalWhitespace(code2);
  }
  function titleAfterOptionalWhitespace(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok2(code2) : nok(code2);
  }
}
__name(tokenizeTitleBefore, "tokenizeTitleBefore");
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects2, ok2, nok) {
  return start;
  function start(code2) {
    return effects2.enter("hardBreakEscape"), effects2.consume(code2), after;
  }
  function after(code2) {
    return markdownLineEnding(code2) ? (effects2.exit("hardBreakEscape"), ok2(code2)) : nok(code2);
  }
}
__name(tokenizeHardBreakEscape, "tokenizeHardBreakEscape");
const headingAtx = {
  name: "headingAtx",
  resolve: resolveHeadingAtx,
  tokenize: tokenizeHeadingAtx
};
function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2, contentStart = 3, content2, text2;
  return events[contentStart][1].type === "whitespace" && (contentStart += 2), contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace" && (contentEnd -= 2), events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace") && (contentEnd -= contentStart + 1 === contentEnd ? 2 : 4), contentEnd > contentStart && (content2 = {
    type: "atxHeadingText",
    start: events[contentStart][1].start,
    end: events[contentEnd][1].end
  }, text2 = {
    type: "chunkText",
    start: events[contentStart][1].start,
    end: events[contentEnd][1].end,
    contentType: "text"
  }, splice$1(events, contentStart, contentEnd - contentStart + 1, [["enter", content2, context], ["enter", text2, context], ["exit", text2, context], ["exit", content2, context]])), events;
}
__name(resolveHeadingAtx, "resolveHeadingAtx");
function tokenizeHeadingAtx(effects2, ok2, nok) {
  let size = 0;
  return start;
  function start(code2) {
    return effects2.enter("atxHeading"), before(code2);
  }
  function before(code2) {
    return effects2.enter("atxHeadingSequence"), sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    return code2 === 35 && size++ < 6 ? (effects2.consume(code2), sequenceOpen) : code2 === null || markdownLineEndingOrSpace(code2) ? (effects2.exit("atxHeadingSequence"), atBreak(code2)) : nok(code2);
  }
  function atBreak(code2) {
    return code2 === 35 ? (effects2.enter("atxHeadingSequence"), sequenceFurther(code2)) : code2 === null || markdownLineEnding(code2) ? (effects2.exit("atxHeading"), ok2(code2)) : markdownSpace(code2) ? factorySpace(effects2, atBreak, "whitespace")(code2) : (effects2.enter("atxHeadingText"), data2(code2));
  }
  function sequenceFurther(code2) {
    return code2 === 35 ? (effects2.consume(code2), sequenceFurther) : (effects2.exit("atxHeadingSequence"), atBreak(code2));
  }
  function data2(code2) {
    return code2 === null || code2 === 35 || markdownLineEndingOrSpace(code2) ? (effects2.exit("atxHeadingText"), atBreak(code2)) : (effects2.consume(code2), data2);
  }
}
__name(tokenizeHeadingAtx, "tokenizeHeadingAtx");
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], htmlRawNames = ["pre", "script", "style", "textarea"], htmlFlow = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: resolveToHtmlFlow,
  tokenize: tokenizeHtmlFlow
}, blankLineBefore = {
  partial: !0,
  tokenize: tokenizeBlankLineBefore
}, nonLazyContinuationStart = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuationStart
};
function resolveToHtmlFlow(events) {
  let index2 = events.length;
  for (; index2-- && !(events[index2][0] === "enter" && events[index2][1].type === "htmlFlow"); )
    ;
  return index2 > 1 && events[index2 - 2][1].type === "linePrefix" && (events[index2][1].start = events[index2 - 2][1].start, events[index2 + 1][1].start = events[index2 - 2][1].start, events.splice(index2 - 2, 2)), events;
}
__name(resolveToHtmlFlow, "resolveToHtmlFlow");
function tokenizeHtmlFlow(effects2, ok2, nok) {
  const self2 = this;
  let marker, closingTag, buffer, index2, markerB;
  return start;
  function start(code2) {
    return before(code2);
  }
  function before(code2) {
    return effects2.enter("htmlFlow"), effects2.enter("htmlFlowData"), effects2.consume(code2), open;
  }
  function open(code2) {
    return code2 === 33 ? (effects2.consume(code2), declarationOpen) : code2 === 47 ? (effects2.consume(code2), closingTag = !0, tagCloseStart) : code2 === 63 ? (effects2.consume(code2), marker = 3, self2.interrupt ? ok2 : continuationDeclarationInside) : asciiAlpha(code2) ? (effects2.consume(code2), buffer = String.fromCharCode(code2), tagName) : nok(code2);
  }
  function declarationOpen(code2) {
    return code2 === 45 ? (effects2.consume(code2), marker = 2, commentOpenInside) : code2 === 91 ? (effects2.consume(code2), marker = 5, index2 = 0, cdataOpenInside) : asciiAlpha(code2) ? (effects2.consume(code2), marker = 4, self2.interrupt ? ok2 : continuationDeclarationInside) : nok(code2);
  }
  function commentOpenInside(code2) {
    return code2 === 45 ? (effects2.consume(code2), self2.interrupt ? ok2 : continuationDeclarationInside) : nok(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    return code2 === value.charCodeAt(index2++) ? (effects2.consume(code2), index2 === value.length ? self2.interrupt ? ok2 : continuation : cdataOpenInside) : nok(code2);
  }
  function tagCloseStart(code2) {
    return asciiAlpha(code2) ? (effects2.consume(code2), buffer = String.fromCharCode(code2), tagName) : nok(code2);
  }
  function tagName(code2) {
    if (code2 === null || code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      const slash = code2 === 47, name2 = buffer.toLowerCase();
      return !slash && !closingTag && htmlRawNames.includes(name2) ? (marker = 1, self2.interrupt ? ok2(code2) : continuation(code2)) : htmlBlockNames.includes(buffer.toLowerCase()) ? (marker = 6, slash ? (effects2.consume(code2), basicSelfClosing) : self2.interrupt ? ok2(code2) : continuation(code2)) : (marker = 7, self2.interrupt && !self2.parser.lazy[self2.now().line] ? nok(code2) : closingTag ? completeClosingTagAfter(code2) : completeAttributeNameBefore(code2));
    }
    return code2 === 45 || asciiAlphanumeric(code2) ? (effects2.consume(code2), buffer += String.fromCharCode(code2), tagName) : nok(code2);
  }
  function basicSelfClosing(code2) {
    return code2 === 62 ? (effects2.consume(code2), self2.interrupt ? ok2 : continuation) : nok(code2);
  }
  function completeClosingTagAfter(code2) {
    return markdownSpace(code2) ? (effects2.consume(code2), completeClosingTagAfter) : completeEnd(code2);
  }
  function completeAttributeNameBefore(code2) {
    return code2 === 47 ? (effects2.consume(code2), completeEnd) : code2 === 58 || code2 === 95 || asciiAlpha(code2) ? (effects2.consume(code2), completeAttributeName) : markdownSpace(code2) ? (effects2.consume(code2), completeAttributeNameBefore) : completeEnd(code2);
  }
  function completeAttributeName(code2) {
    return code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2) ? (effects2.consume(code2), completeAttributeName) : completeAttributeNameAfter(code2);
  }
  function completeAttributeNameAfter(code2) {
    return code2 === 61 ? (effects2.consume(code2), completeAttributeValueBefore) : markdownSpace(code2) ? (effects2.consume(code2), completeAttributeNameAfter) : completeAttributeNameBefore(code2);
  }
  function completeAttributeValueBefore(code2) {
    return code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96 ? nok(code2) : code2 === 34 || code2 === 39 ? (effects2.consume(code2), markerB = code2, completeAttributeValueQuoted) : markdownSpace(code2) ? (effects2.consume(code2), completeAttributeValueBefore) : completeAttributeValueUnquoted(code2);
  }
  function completeAttributeValueQuoted(code2) {
    return code2 === markerB ? (effects2.consume(code2), markerB = null, completeAttributeValueQuotedAfter) : code2 === null || markdownLineEnding(code2) ? nok(code2) : (effects2.consume(code2), completeAttributeValueQuoted);
  }
  function completeAttributeValueUnquoted(code2) {
    return code2 === null || code2 === 34 || code2 === 39 || code2 === 47 || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96 || markdownLineEndingOrSpace(code2) ? completeAttributeNameAfter(code2) : (effects2.consume(code2), completeAttributeValueUnquoted);
  }
  function completeAttributeValueQuotedAfter(code2) {
    return code2 === 47 || code2 === 62 || markdownSpace(code2) ? completeAttributeNameBefore(code2) : nok(code2);
  }
  function completeEnd(code2) {
    return code2 === 62 ? (effects2.consume(code2), completeAfter) : nok(code2);
  }
  function completeAfter(code2) {
    return code2 === null || markdownLineEnding(code2) ? continuation(code2) : markdownSpace(code2) ? (effects2.consume(code2), completeAfter) : nok(code2);
  }
  function continuation(code2) {
    return code2 === 45 && marker === 2 ? (effects2.consume(code2), continuationCommentInside) : code2 === 60 && marker === 1 ? (effects2.consume(code2), continuationRawTagOpen) : code2 === 62 && marker === 4 ? (effects2.consume(code2), continuationClose) : code2 === 63 && marker === 3 ? (effects2.consume(code2), continuationDeclarationInside) : code2 === 93 && marker === 5 ? (effects2.consume(code2), continuationCdataInside) : markdownLineEnding(code2) && (marker === 6 || marker === 7) ? (effects2.exit("htmlFlowData"), effects2.check(blankLineBefore, continuationAfter, continuationStart)(code2)) : code2 === null || markdownLineEnding(code2) ? (effects2.exit("htmlFlowData"), continuationStart(code2)) : (effects2.consume(code2), continuation);
  }
  function continuationStart(code2) {
    return effects2.check(nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code2);
  }
  function continuationStartNonLazy(code2) {
    return effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), continuationBefore;
  }
  function continuationBefore(code2) {
    return code2 === null || markdownLineEnding(code2) ? continuationStart(code2) : (effects2.enter("htmlFlowData"), continuation(code2));
  }
  function continuationCommentInside(code2) {
    return code2 === 45 ? (effects2.consume(code2), continuationDeclarationInside) : continuation(code2);
  }
  function continuationRawTagOpen(code2) {
    return code2 === 47 ? (effects2.consume(code2), buffer = "", continuationRawEndTag) : continuation(code2);
  }
  function continuationRawEndTag(code2) {
    if (code2 === 62) {
      const name2 = buffer.toLowerCase();
      return htmlRawNames.includes(name2) ? (effects2.consume(code2), continuationClose) : continuation(code2);
    }
    return asciiAlpha(code2) && buffer.length < 8 ? (effects2.consume(code2), buffer += String.fromCharCode(code2), continuationRawEndTag) : continuation(code2);
  }
  function continuationCdataInside(code2) {
    return code2 === 93 ? (effects2.consume(code2), continuationDeclarationInside) : continuation(code2);
  }
  function continuationDeclarationInside(code2) {
    return code2 === 62 ? (effects2.consume(code2), continuationClose) : code2 === 45 && marker === 2 ? (effects2.consume(code2), continuationDeclarationInside) : continuation(code2);
  }
  function continuationClose(code2) {
    return code2 === null || markdownLineEnding(code2) ? (effects2.exit("htmlFlowData"), continuationAfter(code2)) : (effects2.consume(code2), continuationClose);
  }
  function continuationAfter(code2) {
    return effects2.exit("htmlFlow"), ok2(code2);
  }
}
__name(tokenizeHtmlFlow, "tokenizeHtmlFlow");
function tokenizeNonLazyContinuationStart(effects2, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    return markdownLineEnding(code2) ? (effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), after) : nok(code2);
  }
  function after(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok2(code2);
  }
}
__name(tokenizeNonLazyContinuationStart, "tokenizeNonLazyContinuationStart");
function tokenizeBlankLineBefore(effects2, ok2, nok) {
  return start;
  function start(code2) {
    return effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), effects2.attempt(blankLine, ok2, nok);
  }
}
__name(tokenizeBlankLineBefore, "tokenizeBlankLineBefore");
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects2, ok2, nok) {
  const self2 = this;
  let marker, index2, returnState;
  return start;
  function start(code2) {
    return effects2.enter("htmlText"), effects2.enter("htmlTextData"), effects2.consume(code2), open;
  }
  function open(code2) {
    return code2 === 33 ? (effects2.consume(code2), declarationOpen) : code2 === 47 ? (effects2.consume(code2), tagCloseStart) : code2 === 63 ? (effects2.consume(code2), instruction) : asciiAlpha(code2) ? (effects2.consume(code2), tagOpen) : nok(code2);
  }
  function declarationOpen(code2) {
    return code2 === 45 ? (effects2.consume(code2), commentOpenInside) : code2 === 91 ? (effects2.consume(code2), index2 = 0, cdataOpenInside) : asciiAlpha(code2) ? (effects2.consume(code2), declaration) : nok(code2);
  }
  function commentOpenInside(code2) {
    return code2 === 45 ? (effects2.consume(code2), commentEnd) : nok(code2);
  }
  function comment(code2) {
    return code2 === null ? nok(code2) : code2 === 45 ? (effects2.consume(code2), commentClose) : markdownLineEnding(code2) ? (returnState = comment, lineEndingBefore(code2)) : (effects2.consume(code2), comment);
  }
  function commentClose(code2) {
    return code2 === 45 ? (effects2.consume(code2), commentEnd) : comment(code2);
  }
  function commentEnd(code2) {
    return code2 === 62 ? end(code2) : code2 === 45 ? commentClose(code2) : comment(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    return code2 === value.charCodeAt(index2++) ? (effects2.consume(code2), index2 === value.length ? cdata : cdataOpenInside) : nok(code2);
  }
  function cdata(code2) {
    return code2 === null ? nok(code2) : code2 === 93 ? (effects2.consume(code2), cdataClose) : markdownLineEnding(code2) ? (returnState = cdata, lineEndingBefore(code2)) : (effects2.consume(code2), cdata);
  }
  function cdataClose(code2) {
    return code2 === 93 ? (effects2.consume(code2), cdataEnd) : cdata(code2);
  }
  function cdataEnd(code2) {
    return code2 === 62 ? end(code2) : code2 === 93 ? (effects2.consume(code2), cdataEnd) : cdata(code2);
  }
  function declaration(code2) {
    return code2 === null || code2 === 62 ? end(code2) : markdownLineEnding(code2) ? (returnState = declaration, lineEndingBefore(code2)) : (effects2.consume(code2), declaration);
  }
  function instruction(code2) {
    return code2 === null ? nok(code2) : code2 === 63 ? (effects2.consume(code2), instructionClose) : markdownLineEnding(code2) ? (returnState = instruction, lineEndingBefore(code2)) : (effects2.consume(code2), instruction);
  }
  function instructionClose(code2) {
    return code2 === 62 ? end(code2) : instruction(code2);
  }
  function tagCloseStart(code2) {
    return asciiAlpha(code2) ? (effects2.consume(code2), tagClose) : nok(code2);
  }
  function tagClose(code2) {
    return code2 === 45 || asciiAlphanumeric(code2) ? (effects2.consume(code2), tagClose) : tagCloseBetween(code2);
  }
  function tagCloseBetween(code2) {
    return markdownLineEnding(code2) ? (returnState = tagCloseBetween, lineEndingBefore(code2)) : markdownSpace(code2) ? (effects2.consume(code2), tagCloseBetween) : end(code2);
  }
  function tagOpen(code2) {
    return code2 === 45 || asciiAlphanumeric(code2) ? (effects2.consume(code2), tagOpen) : code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2) ? tagOpenBetween(code2) : nok(code2);
  }
  function tagOpenBetween(code2) {
    return code2 === 47 ? (effects2.consume(code2), end) : code2 === 58 || code2 === 95 || asciiAlpha(code2) ? (effects2.consume(code2), tagOpenAttributeName) : markdownLineEnding(code2) ? (returnState = tagOpenBetween, lineEndingBefore(code2)) : markdownSpace(code2) ? (effects2.consume(code2), tagOpenBetween) : end(code2);
  }
  function tagOpenAttributeName(code2) {
    return code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2) ? (effects2.consume(code2), tagOpenAttributeName) : tagOpenAttributeNameAfter(code2);
  }
  function tagOpenAttributeNameAfter(code2) {
    return code2 === 61 ? (effects2.consume(code2), tagOpenAttributeValueBefore) : markdownLineEnding(code2) ? (returnState = tagOpenAttributeNameAfter, lineEndingBefore(code2)) : markdownSpace(code2) ? (effects2.consume(code2), tagOpenAttributeNameAfter) : tagOpenBetween(code2);
  }
  function tagOpenAttributeValueBefore(code2) {
    return code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96 ? nok(code2) : code2 === 34 || code2 === 39 ? (effects2.consume(code2), marker = code2, tagOpenAttributeValueQuoted) : markdownLineEnding(code2) ? (returnState = tagOpenAttributeValueBefore, lineEndingBefore(code2)) : markdownSpace(code2) ? (effects2.consume(code2), tagOpenAttributeValueBefore) : (effects2.consume(code2), tagOpenAttributeValueUnquoted);
  }
  function tagOpenAttributeValueQuoted(code2) {
    return code2 === marker ? (effects2.consume(code2), marker = void 0, tagOpenAttributeValueQuotedAfter) : code2 === null ? nok(code2) : markdownLineEnding(code2) ? (returnState = tagOpenAttributeValueQuoted, lineEndingBefore(code2)) : (effects2.consume(code2), tagOpenAttributeValueQuoted);
  }
  function tagOpenAttributeValueUnquoted(code2) {
    return code2 === null || code2 === 34 || code2 === 39 || code2 === 60 || code2 === 61 || code2 === 96 ? nok(code2) : code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2) ? tagOpenBetween(code2) : (effects2.consume(code2), tagOpenAttributeValueUnquoted);
  }
  function tagOpenAttributeValueQuotedAfter(code2) {
    return code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2) ? tagOpenBetween(code2) : nok(code2);
  }
  function end(code2) {
    return code2 === 62 ? (effects2.consume(code2), effects2.exit("htmlTextData"), effects2.exit("htmlText"), ok2) : nok(code2);
  }
  function lineEndingBefore(code2) {
    return effects2.exit("htmlTextData"), effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), lineEndingAfter;
  }
  function lineEndingAfter(code2) {
    return markdownSpace(code2) ? factorySpace(effects2, lineEndingAfterPrefix, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2) : lineEndingAfterPrefix(code2);
  }
  function lineEndingAfterPrefix(code2) {
    return effects2.enter("htmlTextData"), returnState(code2);
  }
}
__name(tokenizeHtmlText, "tokenizeHtmlText");
const labelEnd = {
  name: "labelEnd",
  resolveAll: resolveAllLabelEnd,
  resolveTo: resolveToLabelEnd,
  tokenize: tokenizeLabelEnd
}, resourceConstruct = {
  tokenize: tokenizeResource
}, referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
}, referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(events) {
  let index2 = -1;
  const newEvents = [];
  for (; ++index2 < events.length; ) {
    const token = events[index2][1];
    if (newEvents.push(events[index2]), token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
      const offset = token.type === "labelImage" ? 4 : 2;
      token.type = "data", index2 += offset;
    }
  }
  return events.length !== newEvents.length && splice$1(events, 0, events.length, newEvents), events;
}
__name(resolveAllLabelEnd, "resolveAllLabelEnd");
function resolveToLabelEnd(events, context) {
  let index2 = events.length, offset = 0, token, open, close, media;
  for (; index2--; )
    if (token = events[index2][1], open) {
      if (token.type === "link" || token.type === "labelLink" && token._inactive)
        break;
      events[index2][0] === "enter" && token.type === "labelLink" && (token._inactive = !0);
    } else if (close) {
      if (events[index2][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced && (open = index2, token.type !== "labelLink")) {
        offset = 2;
        break;
      }
    } else
      token.type === "labelEnd" && (close = index2);
  const group = {
    type: events[open][1].type === "labelLink" ? "link" : "image",
    start: {
      ...events[open][1].start
    },
    end: {
      ...events[events.length - 1][1].end
    }
  }, label = {
    type: "label",
    start: {
      ...events[open][1].start
    },
    end: {
      ...events[close][1].end
    }
  }, text2 = {
    type: "labelText",
    start: {
      ...events[open + offset + 2][1].end
    },
    end: {
      ...events[close - 2][1].start
    }
  };
  return media = [["enter", group, context], ["enter", label, context]], media = push2(media, events.slice(open + 1, open + offset + 3)), media = push2(media, [["enter", text2, context]]), media = push2(media, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)), media = push2(media, [["exit", text2, context], events[close - 2], events[close - 1], ["exit", label, context]]), media = push2(media, events.slice(close + 1)), media = push2(media, [["exit", group, context]]), splice$1(events, open, events.length, media), events;
}
__name(resolveToLabelEnd, "resolveToLabelEnd");
function tokenizeLabelEnd(effects2, ok2, nok) {
  const self2 = this;
  let index2 = self2.events.length, labelStart, defined3;
  for (; index2--; )
    if ((self2.events[index2][1].type === "labelImage" || self2.events[index2][1].type === "labelLink") && !self2.events[index2][1]._balanced) {
      labelStart = self2.events[index2][1];
      break;
    }
  return start;
  function start(code2) {
    return labelStart ? labelStart._inactive ? labelEndNok(code2) : (defined3 = self2.parser.defined.includes(normalizeIdentifier(self2.sliceSerialize({
      start: labelStart.end,
      end: self2.now()
    }))), effects2.enter("labelEnd"), effects2.enter("labelMarker"), effects2.consume(code2), effects2.exit("labelMarker"), effects2.exit("labelEnd"), after) : nok(code2);
  }
  function after(code2) {
    return code2 === 40 ? effects2.attempt(resourceConstruct, labelEndOk, defined3 ? labelEndOk : labelEndNok)(code2) : code2 === 91 ? effects2.attempt(referenceFullConstruct, labelEndOk, defined3 ? referenceNotFull : labelEndNok)(code2) : defined3 ? labelEndOk(code2) : labelEndNok(code2);
  }
  function referenceNotFull(code2) {
    return effects2.attempt(referenceCollapsedConstruct, labelEndOk, labelEndNok)(code2);
  }
  function labelEndOk(code2) {
    return ok2(code2);
  }
  function labelEndNok(code2) {
    return labelStart._balanced = !0, nok(code2);
  }
}
__name(tokenizeLabelEnd, "tokenizeLabelEnd");
function tokenizeResource(effects2, ok2, nok) {
  return resourceStart;
  function resourceStart(code2) {
    return effects2.enter("resource"), effects2.enter("resourceMarker"), effects2.consume(code2), effects2.exit("resourceMarker"), resourceBefore;
  }
  function resourceBefore(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects2, resourceOpen)(code2) : resourceOpen(code2);
  }
  function resourceOpen(code2) {
    return code2 === 41 ? resourceEnd(code2) : factoryDestination(effects2, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code2);
  }
  function resourceDestinationAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects2, resourceBetween)(code2) : resourceEnd(code2);
  }
  function resourceDestinationMissing(code2) {
    return nok(code2);
  }
  function resourceBetween(code2) {
    return code2 === 34 || code2 === 39 || code2 === 40 ? factoryTitle(effects2, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code2) : resourceEnd(code2);
  }
  function resourceTitleAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects2, resourceEnd)(code2) : resourceEnd(code2);
  }
  function resourceEnd(code2) {
    return code2 === 41 ? (effects2.enter("resourceMarker"), effects2.consume(code2), effects2.exit("resourceMarker"), effects2.exit("resource"), ok2) : nok(code2);
  }
}
__name(tokenizeResource, "tokenizeResource");
function tokenizeReferenceFull(effects2, ok2, nok) {
  const self2 = this;
  return referenceFull;
  function referenceFull(code2) {
    return factoryLabel.call(self2, effects2, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code2);
  }
  function referenceFullAfter(code2) {
    return self2.parser.defined.includes(normalizeIdentifier(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1))) ? ok2(code2) : nok(code2);
  }
  function referenceFullMissing(code2) {
    return nok(code2);
  }
}
__name(tokenizeReferenceFull, "tokenizeReferenceFull");
function tokenizeReferenceCollapsed(effects2, ok2, nok) {
  return referenceCollapsedStart;
  function referenceCollapsedStart(code2) {
    return effects2.enter("reference"), effects2.enter("referenceMarker"), effects2.consume(code2), effects2.exit("referenceMarker"), referenceCollapsedOpen;
  }
  function referenceCollapsedOpen(code2) {
    return code2 === 93 ? (effects2.enter("referenceMarker"), effects2.consume(code2), effects2.exit("referenceMarker"), effects2.exit("reference"), ok2) : nok(code2);
  }
}
__name(tokenizeReferenceCollapsed, "tokenizeReferenceCollapsed");
const labelStartImage = {
  name: "labelStartImage",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartImage
};
function tokenizeLabelStartImage(effects2, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    return effects2.enter("labelImage"), effects2.enter("labelImageMarker"), effects2.consume(code2), effects2.exit("labelImageMarker"), open;
  }
  function open(code2) {
    return code2 === 91 ? (effects2.enter("labelMarker"), effects2.consume(code2), effects2.exit("labelMarker"), effects2.exit("labelImage"), after) : nok(code2);
  }
  function after(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok2(code2);
  }
}
__name(tokenizeLabelStartImage, "tokenizeLabelStartImage");
const labelStartLink = {
  name: "labelStartLink",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartLink
};
function tokenizeLabelStartLink(effects2, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    return effects2.enter("labelLink"), effects2.enter("labelMarker"), effects2.consume(code2), effects2.exit("labelMarker"), effects2.exit("labelLink"), after;
  }
  function after(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok2(code2);
  }
}
__name(tokenizeLabelStartLink, "tokenizeLabelStartLink");
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects2, ok2) {
  return start;
  function start(code2) {
    return effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), factorySpace(effects2, ok2, "linePrefix");
  }
}
__name(tokenizeLineEnding, "tokenizeLineEnding");
const thematicBreak$1 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects2, ok2, nok) {
  let size = 0, marker;
  return start;
  function start(code2) {
    return effects2.enter("thematicBreak"), before(code2);
  }
  function before(code2) {
    return marker = code2, atBreak(code2);
  }
  function atBreak(code2) {
    return code2 === marker ? (effects2.enter("thematicBreakSequence"), sequence(code2)) : size >= 3 && (code2 === null || markdownLineEnding(code2)) ? (effects2.exit("thematicBreak"), ok2(code2)) : nok(code2);
  }
  function sequence(code2) {
    return code2 === marker ? (effects2.consume(code2), size++, sequence) : (effects2.exit("thematicBreakSequence"), markdownSpace(code2) ? factorySpace(effects2, atBreak, "whitespace")(code2) : atBreak(code2));
  }
}
__name(tokenizeThematicBreak, "tokenizeThematicBreak");
const list$1 = {
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd,
  name: "list",
  tokenize: tokenizeListStart
}, listItemPrefixWhitespaceConstruct = {
  partial: !0,
  tokenize: tokenizeListItemPrefixWhitespace
}, indentConstruct = {
  partial: !0,
  tokenize: tokenizeIndent
};
function tokenizeListStart(effects2, ok2, nok) {
  const self2 = this, tail = self2.events[self2.events.length - 1];
  let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], !0).length : 0, size = 0;
  return start;
  function start(code2) {
    const kind = self2.containerState.type || (code2 === 42 || code2 === 43 || code2 === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self2.containerState.marker || code2 === self2.containerState.marker : asciiDigit(code2)) {
      if (self2.containerState.type || (self2.containerState.type = kind, effects2.enter(kind, {
        _container: !0
      })), kind === "listUnordered")
        return effects2.enter("listItemPrefix"), code2 === 42 || code2 === 45 ? effects2.check(thematicBreak$1, nok, atMarker)(code2) : atMarker(code2);
      if (!self2.interrupt || code2 === 49)
        return effects2.enter("listItemPrefix"), effects2.enter("listItemValue"), inside(code2);
    }
    return nok(code2);
  }
  function inside(code2) {
    return asciiDigit(code2) && ++size < 10 ? (effects2.consume(code2), inside) : (!self2.interrupt || size < 2) && (self2.containerState.marker ? code2 === self2.containerState.marker : code2 === 41 || code2 === 46) ? (effects2.exit("listItemValue"), atMarker(code2)) : nok(code2);
  }
  function atMarker(code2) {
    return effects2.enter("listItemMarker"), effects2.consume(code2), effects2.exit("listItemMarker"), self2.containerState.marker = self2.containerState.marker || code2, effects2.check(
      blankLine,
      // Can’t be empty when interrupting.
      self2.interrupt ? nok : onBlank,
      effects2.attempt(listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix)
    );
  }
  function onBlank(code2) {
    return self2.containerState.initialBlankLine = !0, initialSize++, endOfPrefix(code2);
  }
  function otherPrefix(code2) {
    return markdownSpace(code2) ? (effects2.enter("listItemPrefixWhitespace"), effects2.consume(code2), effects2.exit("listItemPrefixWhitespace"), endOfPrefix) : nok(code2);
  }
  function endOfPrefix(code2) {
    return self2.containerState.size = initialSize + self2.sliceSerialize(effects2.exit("listItemPrefix"), !0).length, ok2(code2);
  }
}
__name(tokenizeListStart, "tokenizeListStart");
function tokenizeListContinuation(effects2, ok2, nok) {
  const self2 = this;
  return self2.containerState._closeFlow = void 0, effects2.check(blankLine, onBlank, notBlank);
  function onBlank(code2) {
    return self2.containerState.furtherBlankLines = self2.containerState.furtherBlankLines || self2.containerState.initialBlankLine, factorySpace(effects2, ok2, "listItemIndent", self2.containerState.size + 1)(code2);
  }
  __name(onBlank, "onBlank");
  function notBlank(code2) {
    return self2.containerState.furtherBlankLines || !markdownSpace(code2) ? (self2.containerState.furtherBlankLines = void 0, self2.containerState.initialBlankLine = void 0, notInCurrentItem(code2)) : (self2.containerState.furtherBlankLines = void 0, self2.containerState.initialBlankLine = void 0, effects2.attempt(indentConstruct, ok2, notInCurrentItem)(code2));
  }
  __name(notBlank, "notBlank");
  function notInCurrentItem(code2) {
    return self2.containerState._closeFlow = !0, self2.interrupt = void 0, factorySpace(effects2, effects2.attempt(list$1, ok2, nok), "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2);
  }
  __name(notInCurrentItem, "notInCurrentItem");
}
__name(tokenizeListContinuation, "tokenizeListContinuation");
function tokenizeIndent(effects2, ok2, nok) {
  const self2 = this;
  return factorySpace(effects2, afterPrefix, "listItemIndent", self2.containerState.size + 1);
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], !0).length === self2.containerState.size ? ok2(code2) : nok(code2);
  }
}
__name(tokenizeIndent, "tokenizeIndent");
function tokenizeListEnd(effects2) {
  effects2.exit(this.containerState.type);
}
__name(tokenizeListEnd, "tokenizeListEnd");
function tokenizeListItemPrefixWhitespace(effects2, ok2, nok) {
  const self2 = this;
  return factorySpace(effects2, afterPrefix, "listItemPrefixWhitespace", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1);
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return !markdownSpace(code2) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok2(code2) : nok(code2);
  }
}
__name(tokenizeListItemPrefixWhitespace, "tokenizeListItemPrefixWhitespace");
const setextUnderline = {
  name: "setextUnderline",
  resolveTo: resolveToSetextUnderline,
  tokenize: tokenizeSetextUnderline
};
function resolveToSetextUnderline(events, context) {
  let index2 = events.length, content2, text2, definition2;
  for (; index2--; )
    if (events[index2][0] === "enter") {
      if (events[index2][1].type === "content") {
        content2 = index2;
        break;
      }
      events[index2][1].type === "paragraph" && (text2 = index2);
    } else
      events[index2][1].type === "content" && events.splice(index2, 1), !definition2 && events[index2][1].type === "definition" && (definition2 = index2);
  const heading2 = {
    type: "setextHeading",
    start: {
      ...events[content2][1].start
    },
    end: {
      ...events[events.length - 1][1].end
    }
  };
  return events[text2][1].type = "setextHeadingText", definition2 ? (events.splice(text2, 0, ["enter", heading2, context]), events.splice(definition2 + 1, 0, ["exit", events[content2][1], context]), events[content2][1].end = {
    ...events[definition2][1].end
  }) : events[content2][1] = heading2, events.push(["exit", heading2, context]), events;
}
__name(resolveToSetextUnderline, "resolveToSetextUnderline");
function tokenizeSetextUnderline(effects2, ok2, nok) {
  const self2 = this;
  let marker;
  return start;
  function start(code2) {
    let index2 = self2.events.length, paragraph2;
    for (; index2--; )
      if (self2.events[index2][1].type !== "lineEnding" && self2.events[index2][1].type !== "linePrefix" && self2.events[index2][1].type !== "content") {
        paragraph2 = self2.events[index2][1].type === "paragraph";
        break;
      }
    return !self2.parser.lazy[self2.now().line] && (self2.interrupt || paragraph2) ? (effects2.enter("setextHeadingLine"), marker = code2, before(code2)) : nok(code2);
  }
  function before(code2) {
    return effects2.enter("setextHeadingLineSequence"), inside(code2);
  }
  function inside(code2) {
    return code2 === marker ? (effects2.consume(code2), inside) : (effects2.exit("setextHeadingLineSequence"), markdownSpace(code2) ? factorySpace(effects2, after, "lineSuffix")(code2) : after(code2));
  }
  function after(code2) {
    return code2 === null || markdownLineEnding(code2) ? (effects2.exit("setextHeadingLine"), ok2(code2)) : nok(code2);
  }
}
__name(tokenizeSetextUnderline, "tokenizeSetextUnderline");
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(effects2) {
  const self2 = this, initial = effects2.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects2.attempt(this.parser.constructs.flowInitial, afterConstruct, factorySpace(effects2, effects2.attempt(this.parser.constructs.flow, afterConstruct, effects2.attempt(content, afterConstruct)), "linePrefix"))
  );
  return initial;
  function atBlankEnding(code2) {
    if (code2 === null) {
      effects2.consume(code2);
      return;
    }
    return effects2.enter("lineEndingBlank"), effects2.consume(code2), effects2.exit("lineEndingBlank"), self2.currentConstruct = void 0, initial;
  }
  function afterConstruct(code2) {
    if (code2 === null) {
      effects2.consume(code2);
      return;
    }
    return effects2.enter("lineEnding"), effects2.consume(code2), effects2.exit("lineEnding"), self2.currentConstruct = void 0, initial;
  }
}
__name(initializeFlow, "initializeFlow");
const resolver = {
  resolveAll: createResolver()
}, string$2 = initializeFactory("string"), text$2 = initializeFactory("text");
function initializeFactory(field) {
  return {
    resolveAll: createResolver(field === "text" ? resolveAllLineSuffixes : void 0),
    tokenize: initializeText
  };
  function initializeText(effects2) {
    const self2 = this, constructs2 = this.parser.constructs[field], text2 = effects2.attempt(constructs2, start, notText);
    return start;
    function start(code2) {
      return atBreak(code2) ? text2(code2) : notText(code2);
    }
    function notText(code2) {
      if (code2 === null) {
        effects2.consume(code2);
        return;
      }
      return effects2.enter("data"), effects2.consume(code2), data2;
    }
    function data2(code2) {
      return atBreak(code2) ? (effects2.exit("data"), text2(code2)) : (effects2.consume(code2), data2);
    }
    function atBreak(code2) {
      if (code2 === null)
        return !0;
      const list2 = constructs2[code2];
      let index2 = -1;
      if (list2)
        for (; ++index2 < list2.length; ) {
          const item = list2[index2];
          if (!item.previous || item.previous.call(self2, self2.previous))
            return !0;
        }
      return !1;
    }
  }
}
__name(initializeFactory, "initializeFactory");
function createResolver(extraResolver) {
  return resolveAllText;
  function resolveAllText(events, context) {
    let index2 = -1, enter;
    for (; ++index2 <= events.length; )
      enter === void 0 ? events[index2] && events[index2][1].type === "data" && (enter = index2, index2++) : (!events[index2] || events[index2][1].type !== "data") && (index2 !== enter + 2 && (events[enter][1].end = events[index2 - 1][1].end, events.splice(enter + 2, index2 - enter - 2), index2 = enter + 2), enter = void 0);
    return extraResolver ? extraResolver(events, context) : events;
  }
}
__name(createResolver, "createResolver");
function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0;
  for (; ++eventIndex <= events.length; )
    if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
      const data2 = events[eventIndex - 1][1], chunks = context.sliceStream(data2);
      let index2 = chunks.length, bufferIndex = -1, size = 0, tabs;
      for (; index2--; ) {
        const chunk = chunks[index2];
        if (typeof chunk == "string") {
          for (bufferIndex = chunk.length; chunk.charCodeAt(bufferIndex - 1) === 32; )
            size++, bufferIndex--;
          if (bufferIndex)
            break;
          bufferIndex = -1;
        } else if (chunk === -2)
          tabs = !0, size++;
        else if (chunk !== -1) {
          index2++;
          break;
        }
      }
      if (context._contentTypeTextTrailing && eventIndex === events.length && (size = 0), size) {
        const token = {
          type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: index2 ? bufferIndex : data2.start._bufferIndex + bufferIndex,
            _index: data2.start._index + index2,
            line: data2.end.line,
            column: data2.end.column - size,
            offset: data2.end.offset - size
          },
          end: {
            ...data2.end
          }
        };
        data2.end = {
          ...token.start
        }, data2.start.offset === data2.end.offset ? Object.assign(data2, token) : (events.splice(eventIndex, 0, ["enter", token, context], ["exit", token, context]), eventIndex += 2);
      }
      eventIndex++;
    }
  return events;
}
__name(resolveAllLineSuffixes, "resolveAllLineSuffixes");
const document$1 = {
  42: list$1,
  43: list$1,
  45: list$1,
  48: list$1,
  49: list$1,
  50: list$1,
  51: list$1,
  52: list$1,
  53: list$1,
  54: list$1,
  55: list$1,
  56: list$1,
  57: list$1,
  62: blockQuote
}, contentInitial = {
  91: definition
}, flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  32: codeIndented
}, flow = {
  35: headingAtx,
  42: thematicBreak$1,
  45: [setextUnderline, thematicBreak$1],
  60: htmlFlow,
  61: setextUnderline,
  95: thematicBreak$1,
  96: codeFenced,
  126: codeFenced
}, string$1 = {
  38: characterReference,
  92: characterEscape
}, text$1 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  33: labelStartImage,
  38: characterReference,
  42: attention,
  60: [autolink, htmlText],
  91: labelStartLink,
  92: [hardBreakEscape, characterEscape],
  93: labelEnd,
  95: attention,
  96: codeText
}, insideSpan = {
  null: [attention, resolver]
}, attentionMarkers = {
  null: [42, 95]
}, disable = {
  null: []
}, defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$1,
  flow,
  flowInitial,
  insideSpan,
  string: string$1,
  text: text$1
}, Symbol.toStringTag, { value: "Module" }));
function createTokenizer(parser2, initialize, from) {
  let point2 = {
    _bufferIndex: -1,
    _index: 0,
    line: from && from.line || 1,
    column: from && from.column || 1,
    offset: from && from.offset || 0
  };
  const columnStart = {}, resolveAllConstructs = [];
  let chunks = [], stack = [];
  const effects2 = {
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    consume,
    enter,
    exit: exit2,
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: !0
    })
  }, context = {
    code: null,
    containerState: {},
    defineSkip,
    events: [],
    now: now2,
    parser: parser2,
    previous: null,
    sliceSerialize,
    sliceStream,
    write
  };
  let state = initialize.tokenize.call(context, effects2);
  return initialize.resolveAll && resolveAllConstructs.push(initialize), context;
  function write(slice) {
    return chunks = push2(chunks, slice), main(), chunks[chunks.length - 1] !== null ? [] : (addResult(initialize, 0), context.events = resolveAll(resolveAllConstructs, context.events, context), context.events);
  }
  __name(write, "write");
  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs);
  }
  __name(sliceSerialize, "sliceSerialize");
  function sliceStream(token) {
    return sliceChunks(chunks, token);
  }
  __name(sliceStream, "sliceStream");
  function now2() {
    const {
      _bufferIndex,
      _index,
      line,
      column,
      offset
    } = point2;
    return {
      _bufferIndex,
      _index,
      line,
      column,
      offset
    };
  }
  __name(now2, "now");
  function defineSkip(value) {
    columnStart[value.line] = value.column, accountForPotentialSkip();
  }
  __name(defineSkip, "defineSkip");
  function main() {
    let chunkIndex;
    for (; point2._index < chunks.length; ) {
      const chunk = chunks[point2._index];
      if (typeof chunk == "string")
        for (chunkIndex = point2._index, point2._bufferIndex < 0 && (point2._bufferIndex = 0); point2._index === chunkIndex && point2._bufferIndex < chunk.length; )
          go(chunk.charCodeAt(point2._bufferIndex));
      else
        go(chunk);
    }
  }
  __name(main, "main");
  function go(code2) {
    state = state(code2);
  }
  __name(go, "go");
  function consume(code2) {
    markdownLineEnding(code2) ? (point2.line++, point2.column = 1, point2.offset += code2 === -3 ? 2 : 1, accountForPotentialSkip()) : code2 !== -1 && (point2.column++, point2.offset++), point2._bufferIndex < 0 ? point2._index++ : (point2._bufferIndex++, point2._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    chunks[point2._index].length && (point2._bufferIndex = -1, point2._index++)), context.previous = code2;
  }
  __name(consume, "consume");
  function enter(type, fields) {
    const token = fields || {};
    return token.type = type, token.start = now2(), context.events.push(["enter", token, context]), stack.push(token), token;
  }
  __name(enter, "enter");
  function exit2(type) {
    const token = stack.pop();
    return token.end = now2(), context.events.push(["exit", token, context]), token;
  }
  __name(exit2, "exit");
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }
  __name(onsuccessfulconstruct, "onsuccessfulconstruct");
  function onsuccessfulcheck(_, info) {
    info.restore();
  }
  __name(onsuccessfulcheck, "onsuccessfulcheck");
  function constructFactory(onreturn, fields) {
    return hook;
    function hook(constructs2, returnState, bogusState) {
      let listOfConstructs, constructIndex, currentConstruct, info;
      return Array.isArray(constructs2) ? (
        /* c8 ignore next 1 */
        handleListOfConstructs(constructs2)
      ) : "tokenize" in constructs2 ? (
        // Looks like a construct.
        handleListOfConstructs([
          /** @type {Construct} */
          constructs2
        ])
      ) : handleMapOfConstructs(constructs2);
      function handleMapOfConstructs(map2) {
        return start;
        function start(code2) {
          const left2 = code2 !== null && map2[code2], all2 = code2 !== null && map2.null, list2 = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(left2) ? left2 : left2 ? [left2] : [],
            ...Array.isArray(all2) ? all2 : all2 ? [all2] : []
          ];
          return handleListOfConstructs(list2)(code2);
        }
      }
      function handleListOfConstructs(list2) {
        return listOfConstructs = list2, constructIndex = 0, list2.length === 0 ? bogusState : handleConstruct(list2[constructIndex]);
      }
      function handleConstruct(construct) {
        return start;
        function start(code2) {
          return info = store2(), currentConstruct = construct, construct.partial || (context.currentConstruct = construct), construct.name && context.parser.constructs.disable.null.includes(construct.name) ? nok() : construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects2,
            ok2,
            nok
          )(code2);
        }
      }
      function ok2(code2) {
        return onreturn(currentConstruct, info), returnState;
      }
      function nok(code2) {
        return info.restore(), ++constructIndex < listOfConstructs.length ? handleConstruct(listOfConstructs[constructIndex]) : bogusState;
      }
    }
  }
  __name(constructFactory, "constructFactory");
  function addResult(construct, from2) {
    construct.resolveAll && !resolveAllConstructs.includes(construct) && resolveAllConstructs.push(construct), construct.resolve && splice$1(context.events, from2, context.events.length - from2, construct.resolve(context.events.slice(from2), context)), construct.resolveTo && (context.events = construct.resolveTo(context.events, context));
  }
  __name(addResult, "addResult");
  function store2() {
    const startPoint = now2(), startPrevious = context.previous, startCurrentConstruct = context.currentConstruct, startEventsIndex = context.events.length, startStack = Array.from(stack);
    return {
      from: startEventsIndex,
      restore
    };
    function restore() {
      point2 = startPoint, context.previous = startPrevious, context.currentConstruct = startCurrentConstruct, context.events.length = startEventsIndex, stack = startStack, accountForPotentialSkip();
    }
  }
  __name(store2, "store");
  function accountForPotentialSkip() {
    point2.line in columnStart && point2.column < 2 && (point2.column = columnStart[point2.line], point2.offset += columnStart[point2.line] - 1);
  }
  __name(accountForPotentialSkip, "accountForPotentialSkip");
}
__name(createTokenizer, "createTokenizer");
function sliceChunks(chunks, token) {
  const startIndex = token.start._index, startBufferIndex = token.start._bufferIndex, endIndex = token.end._index, endBufferIndex = token.end._bufferIndex;
  let view;
  if (startIndex === endIndex)
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  else {
    if (view = chunks.slice(startIndex, endIndex), startBufferIndex > -1) {
      const head = view[0];
      typeof head == "string" ? view[0] = head.slice(startBufferIndex) : view.shift();
    }
    endBufferIndex > 0 && view.push(chunks[endIndex].slice(0, endBufferIndex));
  }
  return view;
}
__name(sliceChunks, "sliceChunks");
function serializeChunks(chunks, expandTabs) {
  let index2 = -1;
  const result2 = [];
  let atTab;
  for (; ++index2 < chunks.length; ) {
    const chunk = chunks[index2];
    let value;
    if (typeof chunk == "string")
      value = chunk;
    else
      switch (chunk) {
        case -5: {
          value = "\r";
          break;
        }
        case -4: {
          value = `
`;
          break;
        }
        case -3: {
          value = `\r
`;
          break;
        }
        case -2: {
          value = expandTabs ? " " : "	";
          break;
        }
        case -1: {
          if (!expandTabs && atTab)
            continue;
          value = " ";
          break;
        }
        default:
          value = String.fromCharCode(chunk);
      }
    atTab = chunk === -2, result2.push(value);
  }
  return result2.join("");
}
__name(serializeChunks, "serializeChunks");
function parse(options) {
  const parser2 = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      combineExtensions([defaultConstructs, ...(options || {}).extensions || []])
    ),
    content: create2(content$1),
    defined: [],
    document: create2(document$2),
    flow: create2(flow$1),
    lazy: {},
    string: create2(string$2),
    text: create2(text$2)
  };
  return parser2;
  function create2(initial) {
    return creator;
    function creator(from) {
      return createTokenizer(parser2, initial, from);
    }
  }
}
__name(parse, "parse");
function postprocess(events) {
  for (; !subtokenize(events); )
    ;
  return events;
}
__name(postprocess, "postprocess");
const search2 = /[\0\t\n\r]/g;
function preprocess() {
  let column = 1, buffer = "", start = !0, atCarriageReturn;
  return preprocessor;
  function preprocessor(value, encoding, end) {
    const chunks = [];
    let match2, next, startPosition, endPosition, code2;
    for (value = buffer + (typeof value == "string" ? value.toString() : new TextDecoder(encoding || void 0).decode(value)), startPosition = 0, buffer = "", start && (value.charCodeAt(0) === 65279 && startPosition++, start = void 0); startPosition < value.length; ) {
      if (search2.lastIndex = startPosition, match2 = search2.exec(value), endPosition = match2 && match2.index !== void 0 ? match2.index : value.length, code2 = value.charCodeAt(endPosition), !match2) {
        buffer = value.slice(startPosition);
        break;
      }
      if (code2 === 10 && startPosition === endPosition && atCarriageReturn)
        chunks.push(-3), atCarriageReturn = void 0;
      else
        switch (atCarriageReturn && (chunks.push(-5), atCarriageReturn = void 0), startPosition < endPosition && (chunks.push(value.slice(startPosition, endPosition)), column += endPosition - startPosition), code2) {
          case 0: {
            chunks.push(65533), column++;
            break;
          }
          case 9: {
            for (next = Math.ceil(column / 4) * 4, chunks.push(-2); column++ < next; )
              chunks.push(-1);
            break;
          }
          case 10: {
            chunks.push(-4), column = 1;
            break;
          }
          default:
            atCarriageReturn = !0, column = 1;
        }
      startPosition = endPosition + 1;
    }
    return end && (atCarriageReturn && chunks.push(-5), buffer && chunks.push(buffer), chunks.push(null)), chunks;
  }
}
__name(preprocess, "preprocess");
const characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode);
}
__name(decodeString, "decodeString");
function decode($0, $1, $2) {
  if ($1)
    return $1;
  if ($2.charCodeAt(0) === 35) {
    const head2 = $2.charCodeAt(1), hex2 = head2 === 120 || head2 === 88;
    return decodeNumericCharacterReference($2.slice(hex2 ? 2 : 1), hex2 ? 16 : 10);
  }
  return decodeNamedCharacterReference($2) || $0;
}
__name(decode, "decode");
const own$2 = {}.hasOwnProperty;
function fromMarkdown(value, encoding, options) {
  return typeof encoding != "string" && (options = encoding, encoding = void 0), compiler(options)(postprocess(parse(options).document().write(preprocess()(value, encoding, !0))));
}
__name(fromMarkdown, "fromMarkdown");
function compiler(options) {
  const config2 = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: opener(link2),
      autolinkProtocol: onenterdata,
      autolinkEmail: onenterdata,
      atxHeading: opener(heading2),
      blockQuote: opener(blockQuote2),
      characterEscape: onenterdata,
      characterReference: onenterdata,
      codeFenced: opener(codeFlow),
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: opener(codeFlow, buffer),
      codeText: opener(codeText2, buffer),
      codeTextData: onenterdata,
      data: onenterdata,
      codeFlowValue: onenterdata,
      definition: opener(definition2),
      definitionDestinationString: buffer,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: opener(emphasis2),
      hardBreakEscape: opener(hardBreak2),
      hardBreakTrailing: opener(hardBreak2),
      htmlFlow: opener(html2, buffer),
      htmlFlowData: onenterdata,
      htmlText: opener(html2, buffer),
      htmlTextData: onenterdata,
      image: opener(image2),
      label: buffer,
      link: opener(link2),
      listItem: opener(listItem2),
      listItemValue: onenterlistitemvalue,
      listOrdered: opener(list2, onenterlistordered),
      listUnordered: opener(list2),
      paragraph: opener(paragraph2),
      reference: onenterreference,
      referenceString: buffer,
      resourceDestinationString: buffer,
      resourceTitleString: buffer,
      setextHeading: opener(heading2),
      strong: opener(strong2),
      thematicBreak: opener(thematicBreak2)
    },
    exit: {
      atxHeading: closer(),
      atxHeadingSequence: onexitatxheadingsequence,
      autolink: closer(),
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: closer(),
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      characterReference: onexitcharacterreference,
      codeFenced: closer(onexitcodefenced),
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onexitcodefencedfencemeta,
      codeFlowValue: onexitdata,
      codeIndented: closer(onexitcodeindented),
      codeText: closer(onexitcodetext),
      codeTextData: onexitdata,
      data: onexitdata,
      definition: closer(),
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: closer(),
      hardBreakEscape: closer(onexithardbreak),
      hardBreakTrailing: closer(onexithardbreak),
      htmlFlow: closer(onexithtmlflow),
      htmlFlowData: onexitdata,
      htmlText: closer(onexithtmltext),
      htmlTextData: onexitdata,
      image: closer(onexitimage),
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: closer(onexitlink),
      listItem: closer(),
      listOrdered: closer(),
      listUnordered: closer(),
      paragraph: closer(),
      referenceString: onexitreferencestring,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      resource: onexitresource,
      setextHeading: closer(onexitsetextheading),
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: closer(),
      thematicBreak: closer()
    }
  };
  configure(config2, (options || {}).mdastExtensions || []);
  const data2 = {};
  return compile;
  function compile(events) {
    let tree = {
      type: "root",
      children: []
    };
    const context = {
      stack: [tree],
      tokenStack: [],
      config: config2,
      enter,
      exit: exit2,
      buffer,
      resume,
      data: data2
    }, listStack = [];
    let index2 = -1;
    for (; ++index2 < events.length; )
      if (events[index2][1].type === "listOrdered" || events[index2][1].type === "listUnordered")
        if (events[index2][0] === "enter")
          listStack.push(index2);
        else {
          const tail = listStack.pop();
          index2 = prepareList(events, tail, index2);
        }
    for (index2 = -1; ++index2 < events.length; ) {
      const handler = config2[events[index2][0]];
      own$2.call(handler, events[index2][1].type) && handler[events[index2][1].type].call(Object.assign({
        sliceSerialize: events[index2][2].sliceSerialize
      }, context), events[index2][1]);
    }
    if (context.tokenStack.length > 0) {
      const tail = context.tokenStack[context.tokenStack.length - 1];
      (tail[1] || defaultOnError).call(context, void 0, tail[0]);
    }
    for (tree.position = {
      start: point$4(events.length > 0 ? events[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: point$4(events.length > 0 ? events[events.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, index2 = -1; ++index2 < config2.transforms.length; )
      tree = config2.transforms[index2](tree) || tree;
    return tree;
  }
  function prepareList(events, start, length) {
    let index2 = start - 1, containerBalance = -1, listSpread = !1, listItem3, lineIndex, firstBlankLineIndex, atMarker;
    for (; ++index2 <= length; ) {
      const event = events[index2];
      switch (event[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          event[0] === "enter" ? containerBalance++ : containerBalance--, atMarker = void 0;
          break;
        }
        case "lineEndingBlank": {
          event[0] === "enter" && (listItem3 && !atMarker && !containerBalance && !firstBlankLineIndex && (firstBlankLineIndex = index2), atMarker = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          atMarker = void 0;
      }
      if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
        if (listItem3) {
          let tailIndex = index2;
          for (lineIndex = void 0; tailIndex--; ) {
            const tailEvent = events[tailIndex];
            if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
              if (tailEvent[0] === "exit")
                continue;
              lineIndex && (events[lineIndex][1].type = "lineEndingBlank", listSpread = !0), tailEvent[1].type = "lineEnding", lineIndex = tailIndex;
            } else if (!(tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent"))
              break;
          }
          firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex) && (listItem3._spread = !0), listItem3.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end), events.splice(lineIndex || index2, 0, ["exit", listItem3, event[2]]), index2++, length++;
        }
        if (event[1].type === "listItemPrefix") {
          const item = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, event[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          listItem3 = item, events.splice(index2, 0, ["enter", item, event[2]]), index2++, length++, firstBlankLineIndex = void 0, atMarker = !0;
        }
      }
    }
    return events[start][1]._spread = listSpread, length;
  }
  function opener(create2, and) {
    return open;
    function open(token) {
      enter.call(this, create2(token), token), and && and.call(this, token);
    }
  }
  function buffer() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function enter(node2, token, errorHandler) {
    this.stack[this.stack.length - 1].children.push(node2), this.stack.push(node2), this.tokenStack.push([token, errorHandler || void 0]), node2.position = {
      start: point$4(token.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function closer(and) {
    return close;
    function close(token) {
      and && and.call(this, token), exit2.call(this, token);
    }
  }
  function exit2(token, onExitError) {
    const node2 = this.stack.pop(), open = this.tokenStack.pop();
    if (open)
      open[0].type !== token.type && (onExitError ? onExitError.call(this, token, open[0]) : (open[1] || defaultOnError).call(this, token, open[0]));
    else
      throw new Error("Cannot close `" + token.type + "` (" + stringifyPosition({
        start: token.start,
        end: token.end
      }) + "): it’s not open");
    node2.position.end = point$4(token.end);
  }
  function resume() {
    return toString$5(this.stack.pop());
  }
  function onenterlistordered() {
    this.data.expectingFirstListItemValue = !0;
  }
  function onenterlistitemvalue(token) {
    if (this.data.expectingFirstListItemValue) {
      const ancestor = this.stack[this.stack.length - 2];
      ancestor.start = Number.parseInt(this.sliceSerialize(token), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function onexitcodefencedfenceinfo() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.lang = data3;
  }
  function onexitcodefencedfencemeta() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.meta = data3;
  }
  function onexitcodefencedfence() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function onexitcodefenced() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.value = data3.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function onexitcodeindented() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.value = data3.replace(/(\r?\n|\r)$/g, "");
  }
  function onexitdefinitionlabelstring(token) {
    const label = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.label = label, node2.identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
  }
  function onexitdefinitiontitlestring() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.title = data3;
  }
  function onexitdefinitiondestinationstring() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.url = data3;
  }
  function onexitatxheadingsequence(token) {
    const node2 = this.stack[this.stack.length - 1];
    if (!node2.depth) {
      const depth = this.sliceSerialize(token).length;
      node2.depth = depth;
    }
  }
  function onexitsetextheadingtext() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function onexitsetextheadinglinesequence(token) {
    const node2 = this.stack[this.stack.length - 1];
    node2.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
  }
  function onexitsetextheading() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function onenterdata(token) {
    const siblings = this.stack[this.stack.length - 1].children;
    let tail = siblings[siblings.length - 1];
    (!tail || tail.type !== "text") && (tail = text2(), tail.position = {
      start: point$4(token.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, siblings.push(tail)), this.stack.push(tail);
  }
  function onexitdata(token) {
    const tail = this.stack.pop();
    tail.value += this.sliceSerialize(token), tail.position.end = point$4(token.end);
  }
  function onexitlineending(token) {
    const context = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const tail = context.children[context.children.length - 1];
      tail.position.end = point$4(token.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && config2.canContainEols.includes(context.type) && (onenterdata.call(this, token), onexitdata.call(this, token));
  }
  function onexithardbreak() {
    this.data.atHardBreak = !0;
  }
  function onexithtmlflow() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.value = data3;
  }
  function onexithtmltext() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.value = data3;
  }
  function onexitcodetext() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.value = data3;
  }
  function onexitlink() {
    const node2 = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const referenceType = this.data.referenceType || "shortcut";
      node2.type += "Reference", node2.referenceType = referenceType, delete node2.url, delete node2.title;
    } else
      delete node2.identifier, delete node2.label;
    this.data.referenceType = void 0;
  }
  function onexitimage() {
    const node2 = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const referenceType = this.data.referenceType || "shortcut";
      node2.type += "Reference", node2.referenceType = referenceType, delete node2.url, delete node2.title;
    } else
      delete node2.identifier, delete node2.label;
    this.data.referenceType = void 0;
  }
  function onexitlabeltext(token) {
    const string2 = this.sliceSerialize(token), ancestor = this.stack[this.stack.length - 2];
    ancestor.label = decodeString(string2), ancestor.identifier = normalizeIdentifier(string2).toLowerCase();
  }
  function onexitlabel() {
    const fragment = this.stack[this.stack.length - 1], value = this.resume(), node2 = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, node2.type === "link") {
      const children = fragment.children;
      node2.children = children;
    } else
      node2.alt = value;
  }
  function onexitresourcedestinationstring() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.url = data3;
  }
  function onexitresourcetitlestring() {
    const data3 = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.title = data3;
  }
  function onexitresource() {
    this.data.inReference = void 0;
  }
  function onenterreference() {
    this.data.referenceType = "collapsed";
  }
  function onexitreferencestring(token) {
    const label = this.resume(), node2 = this.stack[this.stack.length - 1];
    node2.label = label, node2.identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase(), this.data.referenceType = "full";
  }
  function onexitcharacterreferencemarker(token) {
    this.data.characterReferenceType = token.type;
  }
  function onexitcharacterreferencevalue(token) {
    const data3 = this.sliceSerialize(token), type = this.data.characterReferenceType;
    let value;
    type ? (value = decodeNumericCharacterReference(data3, type === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : value = decodeNamedCharacterReference(data3);
    const tail = this.stack[this.stack.length - 1];
    tail.value += value;
  }
  function onexitcharacterreference(token) {
    const tail = this.stack.pop();
    tail.position.end = point$4(token.end);
  }
  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token);
    const node2 = this.stack[this.stack.length - 1];
    node2.url = this.sliceSerialize(token);
  }
  function onexitautolinkemail(token) {
    onexitdata.call(this, token);
    const node2 = this.stack[this.stack.length - 1];
    node2.url = "mailto:" + this.sliceSerialize(token);
  }
  function blockQuote2() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function codeFlow() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function codeText2() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function definition2() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function emphasis2() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function heading2() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function hardBreak2() {
    return {
      type: "break"
    };
  }
  function html2() {
    return {
      type: "html",
      value: ""
    };
  }
  function image2() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function link2() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function list2(token) {
    return {
      type: "list",
      ordered: token.type === "listOrdered",
      start: null,
      spread: token._spread,
      children: []
    };
  }
  function listItem2(token) {
    return {
      type: "listItem",
      spread: token._spread,
      checked: null,
      children: []
    };
  }
  function paragraph2() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function strong2() {
    return {
      type: "strong",
      children: []
    };
  }
  function text2() {
    return {
      type: "text",
      value: ""
    };
  }
  function thematicBreak2() {
    return {
      type: "thematicBreak"
    };
  }
}
__name(compiler, "compiler");
function point$4(d3) {
  return {
    line: d3.line,
    column: d3.column,
    offset: d3.offset
  };
}
__name(point$4, "point$4");
function configure(combined, extensions) {
  let index2 = -1;
  for (; ++index2 < extensions.length; ) {
    const value = extensions[index2];
    Array.isArray(value) ? configure(combined, value) : extension(combined, value);
  }
}
__name(configure, "configure");
function extension(combined, extension2) {
  let key;
  for (key in extension2)
    if (own$2.call(extension2, key))
      switch (key) {
        case "canContainEols": {
          const right2 = extension2[key];
          right2 && combined[key].push(...right2);
          break;
        }
        case "transforms": {
          const right2 = extension2[key];
          right2 && combined[key].push(...right2);
          break;
        }
        case "enter":
        case "exit": {
          const right2 = extension2[key];
          right2 && Object.assign(combined[key], right2);
          break;
        }
      }
}
__name(extension, "extension");
function defaultOnError(left2, right2) {
  throw left2 ? new Error("Cannot close `" + left2.type + "` (" + stringifyPosition({
    start: left2.start,
    end: left2.end
  }) + "): a different token (`" + right2.type + "`, " + stringifyPosition({
    start: right2.start,
    end: right2.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + right2.type + "`, " + stringifyPosition({
    start: right2.start,
    end: right2.end
  }) + ") is still open");
}
__name(defaultOnError, "defaultOnError");
function remarkParse(options) {
  const self2 = this;
  self2.parser = parser2;
  function parser2(doc) {
    return fromMarkdown(doc, {
      ...self2.data("settings"),
      ...options,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: self2.data("micromarkExtensions") || [],
      mdastExtensions: self2.data("fromMarkdownExtensions") || []
    });
  }
  __name(parser2, "parser");
}
__name(remarkParse, "remarkParse");
function blockquote(state, node2) {
  const result2 = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: state.wrap(state.all(node2), !0)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(blockquote, "blockquote");
function hardBreak(state, node2) {
  const result2 = { type: "element", tagName: "br", properties: {}, children: [] };
  return state.patch(node2, result2), [state.applyData(node2, result2), { type: "text", value: `
` }];
}
__name(hardBreak, "hardBreak");
function code(state, node2) {
  const value = node2.value ? node2.value + `
` : "", properties = {};
  node2.lang && (properties.className = ["language-" + node2.lang]);
  let result2 = {
    type: "element",
    tagName: "code",
    properties,
    children: [{ type: "text", value }]
  };
  return node2.meta && (result2.data = { meta: node2.meta }), state.patch(node2, result2), result2 = state.applyData(node2, result2), result2 = { type: "element", tagName: "pre", properties: {}, children: [result2] }, state.patch(node2, result2), result2;
}
__name(code, "code");
function strikethrough(state, node2) {
  const result2 = {
    type: "element",
    tagName: "del",
    properties: {},
    children: state.all(node2)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(strikethrough, "strikethrough");
function emphasis(state, node2) {
  const result2 = {
    type: "element",
    tagName: "em",
    properties: {},
    children: state.all(node2)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(emphasis, "emphasis");
function footnoteReference(state, node2) {
  const clobberPrefix = typeof state.options.clobberPrefix == "string" ? state.options.clobberPrefix : "user-content-", id2 = String(node2.identifier).toUpperCase(), safeId = normalizeUri(id2.toLowerCase()), index2 = state.footnoteOrder.indexOf(id2);
  let counter, reuseCounter = state.footnoteCounts.get(id2);
  reuseCounter === void 0 ? (reuseCounter = 0, state.footnoteOrder.push(id2), counter = state.footnoteOrder.length) : counter = index2 + 1, reuseCounter += 1, state.footnoteCounts.set(id2, reuseCounter);
  const link2 = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + clobberPrefix + "fn-" + safeId,
      id: clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(counter) }]
  };
  state.patch(node2, link2);
  const sup = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [link2]
  };
  return state.patch(node2, sup), state.applyData(node2, sup);
}
__name(footnoteReference, "footnoteReference");
function heading(state, node2) {
  const result2 = {
    type: "element",
    tagName: "h" + node2.depth,
    properties: {},
    children: state.all(node2)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(heading, "heading");
function html(state, node2) {
  if (state.options.allowDangerousHtml) {
    const result2 = { type: "raw", value: node2.value };
    return state.patch(node2, result2), state.applyData(node2, result2);
  }
}
__name(html, "html");
function revert(state, node2) {
  const subtype = node2.referenceType;
  let suffix = "]";
  if (subtype === "collapsed" ? suffix += "[]" : subtype === "full" && (suffix += "[" + (node2.label || node2.identifier) + "]"), node2.type === "imageReference")
    return [{ type: "text", value: "![" + node2.alt + suffix }];
  const contents = state.all(node2), head = contents[0];
  head && head.type === "text" ? head.value = "[" + head.value : contents.unshift({ type: "text", value: "[" });
  const tail = contents[contents.length - 1];
  return tail && tail.type === "text" ? tail.value += suffix : contents.push({ type: "text", value: suffix }), contents;
}
__name(revert, "revert");
function imageReference(state, node2) {
  const id2 = String(node2.identifier).toUpperCase(), definition2 = state.definitionById.get(id2);
  if (!definition2)
    return revert(state, node2);
  const properties = { src: normalizeUri(definition2.url || ""), alt: node2.alt };
  definition2.title !== null && definition2.title !== void 0 && (properties.title = definition2.title);
  const result2 = { type: "element", tagName: "img", properties, children: [] };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(imageReference, "imageReference");
function image(state, node2) {
  const properties = { src: normalizeUri(node2.url) };
  node2.alt !== null && node2.alt !== void 0 && (properties.alt = node2.alt), node2.title !== null && node2.title !== void 0 && (properties.title = node2.title);
  const result2 = { type: "element", tagName: "img", properties, children: [] };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(image, "image");
function inlineCode(state, node2) {
  const text2 = { type: "text", value: node2.value.replace(/\r?\n|\r/g, " ") };
  state.patch(node2, text2);
  const result2 = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [text2]
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(inlineCode, "inlineCode");
function linkReference(state, node2) {
  const id2 = String(node2.identifier).toUpperCase(), definition2 = state.definitionById.get(id2);
  if (!definition2)
    return revert(state, node2);
  const properties = { href: normalizeUri(definition2.url || "") };
  definition2.title !== null && definition2.title !== void 0 && (properties.title = definition2.title);
  const result2 = {
    type: "element",
    tagName: "a",
    properties,
    children: state.all(node2)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(linkReference, "linkReference");
function link(state, node2) {
  const properties = { href: normalizeUri(node2.url) };
  node2.title !== null && node2.title !== void 0 && (properties.title = node2.title);
  const result2 = {
    type: "element",
    tagName: "a",
    properties,
    children: state.all(node2)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(link, "link");
function listItem(state, node2, parent2) {
  const results = state.all(node2), loose = parent2 ? listLoose(parent2) : listItemLoose(node2), properties = {}, children = [];
  if (typeof node2.checked == "boolean") {
    const head = results[0];
    let paragraph2;
    head && head.type === "element" && head.tagName === "p" ? paragraph2 = head : (paragraph2 = { type: "element", tagName: "p", properties: {}, children: [] }, results.unshift(paragraph2)), paragraph2.children.length > 0 && paragraph2.children.unshift({ type: "text", value: " " }), paragraph2.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: node2.checked, disabled: !0 },
      children: []
    }), properties.className = ["task-list-item"];
  }
  let index2 = -1;
  for (; ++index2 < results.length; ) {
    const child = results[index2];
    (loose || index2 !== 0 || child.type !== "element" || child.tagName !== "p") && children.push({ type: "text", value: `
` }), child.type === "element" && child.tagName === "p" && !loose ? children.push(...child.children) : children.push(child);
  }
  const tail = results[results.length - 1];
  tail && (loose || tail.type !== "element" || tail.tagName !== "p") && children.push({ type: "text", value: `
` });
  const result2 = { type: "element", tagName: "li", properties, children };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(listItem, "listItem");
function listLoose(node2) {
  let loose = !1;
  if (node2.type === "list") {
    loose = node2.spread || !1;
    const children = node2.children;
    let index2 = -1;
    for (; !loose && ++index2 < children.length; )
      loose = listItemLoose(children[index2]);
  }
  return loose;
}
__name(listLoose, "listLoose");
function listItemLoose(node2) {
  const spread = node2.spread;
  return spread ?? node2.children.length > 1;
}
__name(listItemLoose, "listItemLoose");
function list(state, node2) {
  const properties = {}, results = state.all(node2);
  let index2 = -1;
  for (typeof node2.start == "number" && node2.start !== 1 && (properties.start = node2.start); ++index2 < results.length; ) {
    const child = results[index2];
    if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
      properties.className = ["contains-task-list"];
      break;
    }
  }
  const result2 = {
    type: "element",
    tagName: node2.ordered ? "ol" : "ul",
    properties,
    children: state.wrap(results, !0)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(list, "list");
function paragraph(state, node2) {
  const result2 = {
    type: "element",
    tagName: "p",
    properties: {},
    children: state.all(node2)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(paragraph, "paragraph");
function root$a(state, node2) {
  const result2 = { type: "root", children: state.wrap(state.all(node2)) };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(root$a, "root$a");
function strong(state, node2) {
  const result2 = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: state.all(node2)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(strong, "strong");
const pointEnd = point$3("end"), pointStart = point$3("start");
function point$3(type) {
  return point2;
  function point2(node2) {
    const point3 = node2 && node2.position && node2.position[type] || {};
    if (typeof point3.line == "number" && point3.line > 0 && typeof point3.column == "number" && point3.column > 0)
      return {
        line: point3.line,
        column: point3.column,
        offset: typeof point3.offset == "number" && point3.offset > -1 ? point3.offset : void 0
      };
  }
}
__name(point$3, "point$3");
function position(node2) {
  const start = pointStart(node2), end = pointEnd(node2);
  if (start && end)
    return { start, end };
}
__name(position, "position");
function table(state, node2) {
  const rows = state.all(node2), firstRow = rows.shift(), tableContent = [];
  if (firstRow) {
    const head = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: state.wrap([firstRow], !0)
    };
    state.patch(node2.children[0], head), tableContent.push(head);
  }
  if (rows.length > 0) {
    const body = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: state.wrap(rows, !0)
    }, start = pointStart(node2.children[1]), end = pointEnd(node2.children[node2.children.length - 1]);
    start && end && (body.position = { start, end }), tableContent.push(body);
  }
  const result2 = {
    type: "element",
    tagName: "table",
    properties: {},
    children: state.wrap(tableContent, !0)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(table, "table");
function tableRow(state, node2, parent2) {
  const siblings = parent2 ? parent2.children : void 0, tagName = (siblings ? siblings.indexOf(node2) : 1) === 0 ? "th" : "td", align = parent2 && parent2.type === "table" ? parent2.align : void 0, length = align ? align.length : node2.children.length;
  let cellIndex = -1;
  const cells = [];
  for (; ++cellIndex < length; ) {
    const cell = node2.children[cellIndex], properties = {}, alignValue = align ? align[cellIndex] : void 0;
    alignValue && (properties.align = alignValue);
    let result3 = { type: "element", tagName, properties, children: [] };
    cell && (result3.children = state.all(cell), state.patch(cell, result3), result3 = state.applyData(cell, result3)), cells.push(result3);
  }
  const result2 = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: state.wrap(cells, !0)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(tableRow, "tableRow");
function tableCell(state, node2) {
  const result2 = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: state.all(node2)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(tableCell, "tableCell");
const tab = 9, space = 32;
function trimLines(value) {
  const source = String(value), search3 = /\r?\n|\r/g;
  let match2 = search3.exec(source), last2 = 0;
  const lines = [];
  for (; match2; )
    lines.push(
      trimLine(source.slice(last2, match2.index), last2 > 0, !0),
      match2[0]
    ), last2 = match2.index + match2[0].length, match2 = search3.exec(source);
  return lines.push(trimLine(source.slice(last2), last2 > 0, !1)), lines.join("");
}
__name(trimLines, "trimLines");
function trimLine(value, start, end) {
  let startIndex = 0, endIndex = value.length;
  if (start) {
    let code2 = value.codePointAt(startIndex);
    for (; code2 === tab || code2 === space; )
      startIndex++, code2 = value.codePointAt(startIndex);
  }
  if (end) {
    let code2 = value.codePointAt(endIndex - 1);
    for (; code2 === tab || code2 === space; )
      endIndex--, code2 = value.codePointAt(endIndex - 1);
  }
  return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}
__name(trimLine, "trimLine");
function text(state, node2) {
  const result2 = { type: "text", value: trimLines(String(node2.value)) };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(text, "text");
function thematicBreak(state, node2) {
  const result2 = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(thematicBreak, "thematicBreak");
const handlers = {
  blockquote,
  break: hardBreak,
  code,
  delete: strikethrough,
  emphasis,
  footnoteReference,
  heading,
  html,
  imageReference,
  image,
  inlineCode,
  linkReference,
  link,
  listItem,
  list,
  paragraph,
  // @ts-expect-error: root is different, but hard to type.
  root: root$a,
  strong,
  table,
  tableCell,
  tableRow,
  text,
  thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};
function ignore() {
}
__name(ignore, "ignore");
const VOID = -1, PRIMITIVE = 0, ARRAY = 1, OBJECT = 2, DATE = 3, REGEXP = 4, MAP = 5, SET = 6, ERROR = 7, BIGINT = 8, env = typeof self == "object" ? self : globalThis, deserializer = /* @__PURE__ */ __name(($, _) => {
  const as = /* @__PURE__ */ __name((out, index2) => ($.set(index2, out), out), "as"), unpair = /* @__PURE__ */ __name((index2) => {
    if ($.has(index2))
      return $.get(index2);
    const [type, value] = _[index2];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index2);
      case ARRAY: {
        const arr = as([], index2);
        for (const index3 of value)
          arr.push(unpair(index3));
        return arr;
      }
      case OBJECT: {
        const object2 = as({}, index2);
        for (const [key, index3] of value)
          object2[unpair(key)] = unpair(index3);
        return object2;
      }
      case DATE:
        return as(new Date(value), index2);
      case REGEXP: {
        const { source, flags: flags2 } = value;
        return as(new RegExp(source, flags2), index2);
      }
      case MAP: {
        const map2 = as(/* @__PURE__ */ new Map(), index2);
        for (const [key, index3] of value)
          map2.set(unpair(key), unpair(index3));
        return map2;
      }
      case SET: {
        const set3 = as(/* @__PURE__ */ new Set(), index2);
        for (const index3 of value)
          set3.add(unpair(index3));
        return set3;
      }
      case ERROR: {
        const { name: name2, message } = value;
        return as(new env[name2](message), index2);
      }
      case BIGINT:
        return as(BigInt(value), index2);
      case "BigInt":
        return as(Object(BigInt(value)), index2);
      case "ArrayBuffer":
        return as(new Uint8Array(value).buffer, value);
      case "DataView": {
        const { buffer } = new Uint8Array(value);
        return as(new DataView(buffer), value);
      }
    }
    return as(new env[type](value), index2);
  }, "unpair");
  return unpair;
}, "deserializer"), deserialize = /* @__PURE__ */ __name((serialized) => deserializer(/* @__PURE__ */ new Map(), serialized)(0), "deserialize"), EMPTY = "", { toString: toString$4 } = {}, { keys: keys$5 } = Object, typeOf2 = /* @__PURE__ */ __name((value) => {
  const type = typeof value;
  if (type !== "object" || !value)
    return [PRIMITIVE, type];
  const asString = toString$4.call(value).slice(8, -1);
  switch (asString) {
    case "Array":
      return [ARRAY, EMPTY];
    case "Object":
      return [OBJECT, EMPTY];
    case "Date":
      return [DATE, EMPTY];
    case "RegExp":
      return [REGEXP, EMPTY];
    case "Map":
      return [MAP, EMPTY];
    case "Set":
      return [SET, EMPTY];
    case "DataView":
      return [ARRAY, asString];
  }
  return asString.includes("Array") ? [ARRAY, asString] : asString.includes("Error") ? [ERROR, asString] : [OBJECT, asString];
}, "typeOf"), shouldSkip = /* @__PURE__ */ __name(([TYPE, type]) => TYPE === PRIMITIVE && (type === "function" || type === "symbol"), "shouldSkip"), serializer = /* @__PURE__ */ __name((strict, json, $, _) => {
  const as = /* @__PURE__ */ __name((out, value) => {
    const index2 = _.push(out) - 1;
    return $.set(value, index2), index2;
  }, "as"), pair = /* @__PURE__ */ __name((value) => {
    if ($.has(value))
      return $.get(value);
    let [TYPE, type] = typeOf2(value);
    switch (TYPE) {
      case PRIMITIVE: {
        let entry = value;
        switch (type) {
          case "bigint":
            TYPE = BIGINT, entry = value.toString();
            break;
          case "function":
          case "symbol":
            if (strict)
              throw new TypeError("unable to serialize " + type);
            entry = null;
            break;
          case "undefined":
            return as([VOID], value);
        }
        return as([TYPE, entry], value);
      }
      case ARRAY: {
        if (type) {
          let spread = value;
          return type === "DataView" ? spread = new Uint8Array(value.buffer) : type === "ArrayBuffer" && (spread = new Uint8Array(value)), as([type, [...spread]], value);
        }
        const arr = [], index2 = as([TYPE, arr], value);
        for (const entry of value)
          arr.push(pair(entry));
        return index2;
      }
      case OBJECT: {
        if (type)
          switch (type) {
            case "BigInt":
              return as([type, value.toString()], value);
            case "Boolean":
            case "Number":
            case "String":
              return as([type, value.valueOf()], value);
          }
        if (json && "toJSON" in value)
          return pair(value.toJSON());
        const entries = [], index2 = as([TYPE, entries], value);
        for (const key of keys$5(value))
          (strict || !shouldSkip(typeOf2(value[key]))) && entries.push([pair(key), pair(value[key])]);
        return index2;
      }
      case DATE:
        return as([TYPE, value.toISOString()], value);
      case REGEXP: {
        const { source, flags: flags2 } = value;
        return as([TYPE, { source, flags: flags2 }], value);
      }
      case MAP: {
        const entries = [], index2 = as([TYPE, entries], value);
        for (const [key, entry] of value)
          (strict || !(shouldSkip(typeOf2(key)) || shouldSkip(typeOf2(entry)))) && entries.push([pair(key), pair(entry)]);
        return index2;
      }
      case SET: {
        const entries = [], index2 = as([TYPE, entries], value);
        for (const entry of value)
          (strict || !shouldSkip(typeOf2(entry))) && entries.push(pair(entry));
        return index2;
      }
    }
    const { message } = value;
    return as([TYPE, { name: type, message }], value);
  }, "pair");
  return pair;
}, "serializer"), serialize = /* @__PURE__ */ __name((value, { json, lossy } = {}) => {
  const _ = [];
  return serializer(!(json || lossy), !!json, /* @__PURE__ */ new Map(), _)(value), _;
}, "serialize"), structuredClone$1 = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (any, options) => options && ("json" in options || "lossy" in options) ? deserialize(serialize(any, options)) : structuredClone(any)
) : (any, options) => deserialize(serialize(any, options));
function defaultFootnoteBackContent(_, rereferenceIndex) {
  const result2 = [{ type: "text", value: "↩" }];
  return rereferenceIndex > 1 && result2.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(rereferenceIndex) }]
  }), result2;
}
__name(defaultFootnoteBackContent, "defaultFootnoteBackContent");
function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
  return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
__name(defaultFootnoteBackLabel, "defaultFootnoteBackLabel");
function footer(state) {
  const clobberPrefix = typeof state.options.clobberPrefix == "string" ? state.options.clobberPrefix : "user-content-", footnoteBackContent = state.options.footnoteBackContent || defaultFootnoteBackContent, footnoteBackLabel = state.options.footnoteBackLabel || defaultFootnoteBackLabel, footnoteLabel = state.options.footnoteLabel || "Footnotes", footnoteLabelTagName = state.options.footnoteLabelTagName || "h2", footnoteLabelProperties = state.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, listItems = [];
  let referenceIndex = -1;
  for (; ++referenceIndex < state.footnoteOrder.length; ) {
    const definition2 = state.footnoteById.get(
      state.footnoteOrder[referenceIndex]
    );
    if (!definition2)
      continue;
    const content2 = state.all(definition2), id2 = String(definition2.identifier).toUpperCase(), safeId = normalizeUri(id2.toLowerCase());
    let rereferenceIndex = 0;
    const backReferences = [], counts = state.footnoteCounts.get(id2);
    for (; counts !== void 0 && ++rereferenceIndex <= counts; ) {
      backReferences.length > 0 && backReferences.push({ type: "text", value: " " });
      let children = typeof footnoteBackContent == "string" ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
      typeof children == "string" && (children = { type: "text", value: children }), backReferences.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + clobberPrefix + "fnref-" + safeId + (rereferenceIndex > 1 ? "-" + rereferenceIndex : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof footnoteBackLabel == "string" ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(children) ? children : [children]
      });
    }
    const tail = content2[content2.length - 1];
    if (tail && tail.type === "element" && tail.tagName === "p") {
      const tailTail = tail.children[tail.children.length - 1];
      tailTail && tailTail.type === "text" ? tailTail.value += " " : tail.children.push({ type: "text", value: " " }), tail.children.push(...backReferences);
    } else
      content2.push(...backReferences);
    const listItem2 = {
      type: "element",
      tagName: "li",
      properties: { id: clobberPrefix + "fn-" + safeId },
      children: state.wrap(content2, !0)
    };
    state.patch(definition2, listItem2), listItems.push(listItem2);
  }
  if (listItems.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: footnoteLabelTagName,
          properties: {
            ...structuredClone$1(footnoteLabelProperties),
            id: "footnote-label"
          },
          children: [{ type: "text", value: footnoteLabel }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: state.wrap(listItems, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
__name(footer, "footer");
const convert$1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  /* @__PURE__ */ __name(function(test2) {
    if (test2 == null)
      return ok$1;
    if (typeof test2 == "function")
      return castFactory$1(test2);
    if (typeof test2 == "object")
      return Array.isArray(test2) ? anyFactory$1(test2) : propsFactory$1(test2);
    if (typeof test2 == "string")
      return typeFactory$1(test2);
    throw new Error("Expected function, string, or object as test");
  }, "convert$1")
);
function anyFactory$1(tests) {
  const checks2 = [];
  let index2 = -1;
  for (; ++index2 < tests.length; )
    checks2[index2] = convert$1(tests[index2]);
  return castFactory$1(any);
  function any(...parameters) {
    let index3 = -1;
    for (; ++index3 < checks2.length; )
      if (checks2[index3].apply(this, parameters))
        return !0;
    return !1;
  }
}
__name(anyFactory$1, "anyFactory$1");
function propsFactory$1(check2) {
  const checkAsRecord = (
    /** @type {Record<string, unknown>} */
    check2
  );
  return castFactory$1(all2);
  function all2(node2) {
    const nodeAsRecord = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      node2
    );
    let key;
    for (key in check2)
      if (nodeAsRecord[key] !== checkAsRecord[key])
        return !1;
    return !0;
  }
}
__name(propsFactory$1, "propsFactory$1");
function typeFactory$1(check2) {
  return castFactory$1(type);
  function type(node2) {
    return node2 && node2.type === check2;
  }
}
__name(typeFactory$1, "typeFactory$1");
function castFactory$1(testFunction) {
  return check2;
  function check2(value, index2, parent2) {
    return !!(looksLikeANode$1(value) && testFunction.call(
      this,
      value,
      typeof index2 == "number" ? index2 : void 0,
      parent2 || void 0
    ));
  }
}
__name(castFactory$1, "castFactory$1");
function ok$1() {
  return !0;
}
__name(ok$1, "ok$1");
function looksLikeANode$1(value) {
  return value !== null && typeof value == "object" && "type" in value;
}
__name(looksLikeANode$1, "looksLikeANode$1");
const empty$1 = [], CONTINUE$1 = !0, EXIT$1 = !1, SKIP$1 = "skip";
function visitParents$1(tree, test2, visitor, reverse3) {
  let check2;
  typeof test2 == "function" && typeof visitor != "function" ? (reverse3 = visitor, visitor = test2) : check2 = test2;
  const is2 = convert$1(check2), step = reverse3 ? -1 : 1;
  factory(tree, void 0, [])();
  function factory(node2, index2, parents) {
    const value = (
      /** @type {Record<string, unknown>} */
      node2 && typeof node2 == "object" ? node2 : {}
    );
    if (typeof value.type == "string") {
      const name2 = (
        // `hast`
        typeof value.tagName == "string" ? value.tagName : (
          // `xast`
          typeof value.name == "string" ? value.name : void 0
        )
      );
      Object.defineProperty(visit2, "name", {
        value: "node (" + (node2.type + (name2 ? "<" + name2 + ">" : "")) + ")"
      });
    }
    return visit2;
    function visit2() {
      let result2 = empty$1, subresult, offset, grandparents;
      if ((!test2 || is2(node2, index2, parents[parents.length - 1] || void 0)) && (result2 = toResult$1(visitor(node2, parents)), result2[0] === EXIT$1))
        return result2;
      if ("children" in node2 && node2.children) {
        const nodeAsParent = (
          /** @type {UnistParent} */
          node2
        );
        if (nodeAsParent.children && result2[0] !== SKIP$1)
          for (offset = (reverse3 ? nodeAsParent.children.length : -1) + step, grandparents = parents.concat(nodeAsParent); offset > -1 && offset < nodeAsParent.children.length; ) {
            const child = nodeAsParent.children[offset];
            if (subresult = factory(child, offset, grandparents)(), subresult[0] === EXIT$1)
              return subresult;
            offset = typeof subresult[1] == "number" ? subresult[1] : offset + step;
          }
      }
      return result2;
    }
  }
  __name(factory, "factory");
}
__name(visitParents$1, "visitParents$1");
function toResult$1(value) {
  return Array.isArray(value) ? value : typeof value == "number" ? [CONTINUE$1, value] : value == null ? empty$1 : [value];
}
__name(toResult$1, "toResult$1");
function visit$1(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  let reverse3, test2, visitor;
  typeof testOrVisitor == "function" && typeof visitorOrReverse != "function" ? (test2 = void 0, visitor = testOrVisitor, reverse3 = visitorOrReverse) : (test2 = testOrVisitor, visitor = visitorOrReverse, reverse3 = maybeReverse), visitParents$1(tree, test2, overload, reverse3);
  function overload(node2, parents) {
    const parent2 = parents[parents.length - 1], index2 = parent2 ? parent2.children.indexOf(node2) : void 0;
    return visitor(node2, index2, parent2);
  }
  __name(overload, "overload");
}
__name(visit$1, "visit$1");
const own$1 = {}.hasOwnProperty, emptyOptions = {};
function createState(tree, options) {
  const settings = options || emptyOptions, definitionById = /* @__PURE__ */ new Map(), footnoteById = /* @__PURE__ */ new Map(), footnoteCounts = /* @__PURE__ */ new Map(), handlers$1 = { ...handlers, ...settings.handlers }, state = {
    all: all2,
    applyData,
    definitionById,
    footnoteById,
    footnoteCounts,
    footnoteOrder: [],
    handlers: handlers$1,
    one: one2,
    options: settings,
    patch,
    wrap: wrap$1
  };
  return visit$1(tree, function(node2) {
    if (node2.type === "definition" || node2.type === "footnoteDefinition") {
      const map2 = node2.type === "definition" ? definitionById : footnoteById, id2 = String(node2.identifier).toUpperCase();
      map2.has(id2) || map2.set(id2, node2);
    }
  }), state;
  function one2(node2, parent2) {
    const type = node2.type, handle = state.handlers[type];
    if (own$1.call(state.handlers, type) && handle)
      return handle(state, node2, parent2);
    if (state.options.passThrough && state.options.passThrough.includes(type)) {
      if ("children" in node2) {
        const { children, ...shallow } = node2, result2 = structuredClone$1(shallow);
        return result2.children = state.all(node2), result2;
      }
      return structuredClone$1(node2);
    }
    return (state.options.unknownHandler || defaultUnknownHandler)(state, node2, parent2);
  }
  __name(one2, "one");
  function all2(parent2) {
    const values = [];
    if ("children" in parent2) {
      const nodes = parent2.children;
      let index2 = -1;
      for (; ++index2 < nodes.length; ) {
        const result2 = state.one(nodes[index2], parent2);
        if (result2) {
          if (index2 && nodes[index2 - 1].type === "break" && (!Array.isArray(result2) && result2.type === "text" && (result2.value = trimMarkdownSpaceStart(result2.value)), !Array.isArray(result2) && result2.type === "element")) {
            const head = result2.children[0];
            head && head.type === "text" && (head.value = trimMarkdownSpaceStart(head.value));
          }
          Array.isArray(result2) ? values.push(...result2) : values.push(result2);
        }
      }
    }
    return values;
  }
  __name(all2, "all");
}
__name(createState, "createState");
function patch(from, to) {
  from.position && (to.position = position(from));
}
__name(patch, "patch");
function applyData(from, to) {
  let result2 = to;
  if (from && from.data) {
    const hName = from.data.hName, hChildren = from.data.hChildren, hProperties = from.data.hProperties;
    if (typeof hName == "string")
      if (result2.type === "element")
        result2.tagName = hName;
      else {
        const children = "children" in result2 ? result2.children : [result2];
        result2 = { type: "element", tagName: hName, properties: {}, children };
      }
    result2.type === "element" && hProperties && Object.assign(result2.properties, structuredClone$1(hProperties)), "children" in result2 && result2.children && hChildren !== null && hChildren !== void 0 && (result2.children = hChildren);
  }
  return result2;
}
__name(applyData, "applyData");
function defaultUnknownHandler(state, node2) {
  const data2 = node2.data || {}, result2 = "value" in node2 && !(own$1.call(data2, "hProperties") || own$1.call(data2, "hChildren")) ? { type: "text", value: node2.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: state.all(node2)
  };
  return state.patch(node2, result2), state.applyData(node2, result2);
}
__name(defaultUnknownHandler, "defaultUnknownHandler");
function wrap$1(nodes, loose) {
  const result2 = [];
  let index2 = -1;
  for (loose && result2.push({ type: "text", value: `
` }); ++index2 < nodes.length; )
    index2 && result2.push({ type: "text", value: `
` }), result2.push(nodes[index2]);
  return loose && nodes.length > 0 && result2.push({ type: "text", value: `
` }), result2;
}
__name(wrap$1, "wrap$1");
function trimMarkdownSpaceStart(value) {
  let index2 = 0, code2 = value.charCodeAt(index2);
  for (; code2 === 9 || code2 === 32; )
    index2++, code2 = value.charCodeAt(index2);
  return value.slice(index2);
}
__name(trimMarkdownSpaceStart, "trimMarkdownSpaceStart");
function toHast(tree, options) {
  const state = createState(tree, options), node2 = state.one(tree, void 0), foot = footer(state), result2 = Array.isArray(node2) ? { type: "root", children: node2 } : node2 || { type: "root", children: [] };
  return foot && result2.children.push({ type: "text", value: `
` }, foot), result2;
}
__name(toHast, "toHast");
function remarkRehype(destination, options) {
  return destination && "run" in destination ? async function(tree, file) {
    const hastTree = (
      /** @type {HastRoot} */
      toHast(tree, { file, ...options })
    );
    await destination.run(hastTree, file);
  } : function(tree, file) {
    return (
      /** @type {HastRoot} */
      toHast(tree, { file, ...destination || options })
    );
  };
}
__name(remarkRehype, "remarkRehype");
function bail(error) {
  if (error)
    throw error;
}
__name(bail, "bail");
var hasOwn$1 = Object.prototype.hasOwnProperty, toStr = Object.prototype.toString, defineProperty$3 = Object.defineProperty, gOPD = Object.getOwnPropertyDescriptor, isArray$g = /* @__PURE__ */ __name(function(arr) {
  return typeof Array.isArray == "function" ? Array.isArray(arr) : toStr.call(arr) === "[object Array]";
}, "isArray"), isPlainObject$3 = /* @__PURE__ */ __name(function(obj2) {
  if (!obj2 || toStr.call(obj2) !== "[object Object]")
    return !1;
  var hasOwnConstructor = hasOwn$1.call(obj2, "constructor"), hasIsPrototypeOf = obj2.constructor && obj2.constructor.prototype && hasOwn$1.call(obj2.constructor.prototype, "isPrototypeOf");
  if (obj2.constructor && !hasOwnConstructor && !hasIsPrototypeOf)
    return !1;
  var key;
  for (key in obj2)
    ;
  return typeof key > "u" || hasOwn$1.call(obj2, key);
}, "isPlainObject"), setProperty = /* @__PURE__ */ __name(function(target, options) {
  defineProperty$3 && options.name === "__proto__" ? defineProperty$3(target, options.name, {
    enumerable: !0,
    configurable: !0,
    value: options.newValue,
    writable: !0
  }) : target[options.name] = options.newValue;
}, "setProperty"), getProperty = /* @__PURE__ */ __name(function(obj2, name2) {
  if (name2 === "__proto__")
    if (hasOwn$1.call(obj2, name2)) {
      if (gOPD)
        return gOPD(obj2, name2).value;
    } else
      return;
  return obj2[name2];
}, "getProperty"), extend$1 = /* @__PURE__ */ __name(function extend() {
  var options, name2, src, copy2, copyIsArray, clone2, target = arguments[0], i2 = 1, length = arguments.length, deep = !1;
  for (typeof target == "boolean" && (deep = target, target = arguments[1] || {}, i2 = 2), (target == null || typeof target != "object" && typeof target != "function") && (target = {}); i2 < length; ++i2)
    if (options = arguments[i2], options != null)
      for (name2 in options)
        src = getProperty(target, name2), copy2 = getProperty(options, name2), target !== copy2 && (deep && copy2 && (isPlainObject$3(copy2) || (copyIsArray = isArray$g(copy2))) ? (copyIsArray ? (copyIsArray = !1, clone2 = src && isArray$g(src) ? src : []) : clone2 = src && isPlainObject$3(src) ? src : {}, setProperty(target, { name: name2, newValue: extend(deep, clone2, copy2) })) : typeof copy2 < "u" && setProperty(target, { name: name2, newValue: copy2 }));
  return target;
}, "extend");
const extend$2 = /* @__PURE__ */ getDefaultExportFromCjs(extend$1);
function isPlainObject$2(value) {
  if (typeof value != "object" || value === null)
    return !1;
  const prototype2 = Object.getPrototypeOf(value);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}
__name(isPlainObject$2, "isPlainObject$2");
function trough() {
  const fns = [], pipeline = { run, use };
  return pipeline;
  function run(...values) {
    let middlewareIndex = -1;
    const callback = values.pop();
    if (typeof callback != "function")
      throw new TypeError("Expected function as last argument, not " + callback);
    next(null, ...values);
    function next(error, ...output) {
      const fn = fns[++middlewareIndex];
      let index2 = -1;
      if (error) {
        callback(error);
        return;
      }
      for (; ++index2 < values.length; )
        (output[index2] === null || output[index2] === void 0) && (output[index2] = values[index2]);
      values = output, fn ? wrap(fn, next)(...output) : callback(null, ...output);
    }
    __name(next, "next");
  }
  function use(middelware) {
    if (typeof middelware != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + middelware
      );
    return fns.push(middelware), pipeline;
  }
}
__name(trough, "trough");
function wrap(middleware, callback) {
  let called;
  return wrapped;
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length;
    let result2;
    fnExpectsCallback && parameters.push(done);
    try {
      result2 = middleware.apply(this, parameters);
    } catch (error) {
      const exception = (
        /** @type {Error} */
        error
      );
      if (fnExpectsCallback && called)
        throw exception;
      return done(exception);
    }
    fnExpectsCallback || (result2 && result2.then && typeof result2.then == "function" ? result2.then(then, done) : result2 instanceof Error ? done(result2) : then(result2));
  }
  function done(error, ...output) {
    called || (called = !0, callback(error, ...output));
  }
  function then(value) {
    done(null, value);
  }
}
__name(wrap, "wrap");
const minpath = { basename, dirname, extname, join, sep: "/" };
function basename(path, extname2) {
  if (extname2 !== void 0 && typeof extname2 != "string")
    throw new TypeError('"ext" argument must be a string');
  assertPath$1(path);
  let start = 0, end = -1, index2 = path.length, seenNonSlash;
  if (extname2 === void 0 || extname2.length === 0 || extname2.length > path.length) {
    for (; index2--; )
      if (path.codePointAt(index2) === 47) {
        if (seenNonSlash) {
          start = index2 + 1;
          break;
        }
      } else
        end < 0 && (seenNonSlash = !0, end = index2 + 1);
    return end < 0 ? "" : path.slice(start, end);
  }
  if (extname2 === path)
    return "";
  let firstNonSlashEnd = -1, extnameIndex = extname2.length - 1;
  for (; index2--; )
    if (path.codePointAt(index2) === 47) {
      if (seenNonSlash) {
        start = index2 + 1;
        break;
      }
    } else
      firstNonSlashEnd < 0 && (seenNonSlash = !0, firstNonSlashEnd = index2 + 1), extnameIndex > -1 && (path.codePointAt(index2) === extname2.codePointAt(extnameIndex--) ? extnameIndex < 0 && (end = index2) : (extnameIndex = -1, end = firstNonSlashEnd));
  return start === end ? end = firstNonSlashEnd : end < 0 && (end = path.length), path.slice(start, end);
}
__name(basename, "basename");
function dirname(path) {
  if (assertPath$1(path), path.length === 0)
    return ".";
  let end = -1, index2 = path.length, unmatchedSlash;
  for (; --index2; )
    if (path.codePointAt(index2) === 47) {
      if (unmatchedSlash) {
        end = index2;
        break;
      }
    } else
      unmatchedSlash || (unmatchedSlash = !0);
  return end < 0 ? path.codePointAt(0) === 47 ? "/" : "." : end === 1 && path.codePointAt(0) === 47 ? "//" : path.slice(0, end);
}
__name(dirname, "dirname");
function extname(path) {
  assertPath$1(path);
  let index2 = path.length, end = -1, startPart = 0, startDot = -1, preDotState = 0, unmatchedSlash;
  for (; index2--; ) {
    const code2 = path.codePointAt(index2);
    if (code2 === 47) {
      if (unmatchedSlash) {
        startPart = index2 + 1;
        break;
      }
      continue;
    }
    end < 0 && (unmatchedSlash = !0, end = index2 + 1), code2 === 46 ? startDot < 0 ? startDot = index2 : preDotState !== 1 && (preDotState = 1) : startDot > -1 && (preDotState = -1);
  }
  return startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
  preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1 ? "" : path.slice(startDot, end);
}
__name(extname, "extname");
function join(...segments) {
  let index2 = -1, joined;
  for (; ++index2 < segments.length; )
    assertPath$1(segments[index2]), segments[index2] && (joined = joined === void 0 ? segments[index2] : joined + "/" + segments[index2]);
  return joined === void 0 ? "." : normalize$1(joined);
}
__name(join, "join");
function normalize$1(path) {
  assertPath$1(path);
  const absolute = path.codePointAt(0) === 47;
  let value = normalizeString(path, !absolute);
  return value.length === 0 && !absolute && (value = "."), value.length > 0 && path.codePointAt(path.length - 1) === 47 && (value += "/"), absolute ? "/" + value : value;
}
__name(normalize$1, "normalize$1");
function normalizeString(path, allowAboveRoot) {
  let result2 = "", lastSegmentLength = 0, lastSlash = -1, dots = 0, index2 = -1, code2, lastSlashIndex;
  for (; ++index2 <= path.length; ) {
    if (index2 < path.length)
      code2 = path.codePointAt(index2);
    else {
      if (code2 === 47)
        break;
      code2 = 47;
    }
    if (code2 === 47) {
      if (!(lastSlash === index2 - 1 || dots === 1))
        if (lastSlash !== index2 - 1 && dots === 2) {
          if (result2.length < 2 || lastSegmentLength !== 2 || result2.codePointAt(result2.length - 1) !== 46 || result2.codePointAt(result2.length - 2) !== 46) {
            if (result2.length > 2) {
              if (lastSlashIndex = result2.lastIndexOf("/"), lastSlashIndex !== result2.length - 1) {
                lastSlashIndex < 0 ? (result2 = "", lastSegmentLength = 0) : (result2 = result2.slice(0, lastSlashIndex), lastSegmentLength = result2.length - 1 - result2.lastIndexOf("/")), lastSlash = index2, dots = 0;
                continue;
              }
            } else if (result2.length > 0) {
              result2 = "", lastSegmentLength = 0, lastSlash = index2, dots = 0;
              continue;
            }
          }
          allowAboveRoot && (result2 = result2.length > 0 ? result2 + "/.." : "..", lastSegmentLength = 2);
        } else
          result2.length > 0 ? result2 += "/" + path.slice(lastSlash + 1, index2) : result2 = path.slice(lastSlash + 1, index2), lastSegmentLength = index2 - lastSlash - 1;
      lastSlash = index2, dots = 0;
    } else
      code2 === 46 && dots > -1 ? dots++ : dots = -1;
  }
  return result2;
}
__name(normalizeString, "normalizeString");
function assertPath$1(path) {
  if (typeof path != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(path)
    );
}
__name(assertPath$1, "assertPath$1");
const minproc = { cwd };
function cwd() {
  return "/";
}
__name(cwd, "cwd");
function isUrl(fileUrlOrPath) {
  return !!(fileUrlOrPath !== null && typeof fileUrlOrPath == "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
  fileUrlOrPath.auth === void 0);
}
__name(isUrl, "isUrl");
function urlToPath(path) {
  if (typeof path == "string")
    path = new URL(path);
  else if (!isUrl(path)) {
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + path + "`"
    );
    throw error.code = "ERR_INVALID_ARG_TYPE", error;
  }
  if (path.protocol !== "file:") {
    const error = new TypeError("The URL must be of scheme file");
    throw error.code = "ERR_INVALID_URL_SCHEME", error;
  }
  return getPathFromURLPosix(path);
}
__name(urlToPath, "urlToPath");
function getPathFromURLPosix(url) {
  if (url.hostname !== "") {
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw error.code = "ERR_INVALID_FILE_URL_HOST", error;
  }
  const pathname = url.pathname;
  let index2 = -1;
  for (; ++index2 < pathname.length; )
    if (pathname.codePointAt(index2) === 37 && pathname.codePointAt(index2 + 1) === 50) {
      const third = pathname.codePointAt(index2 + 2);
      if (third === 70 || third === 102) {
        const error = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw error.code = "ERR_INVALID_FILE_URL_PATH", error;
      }
    }
  return decodeURIComponent(pathname);
}
__name(getPathFromURLPosix, "getPathFromURLPosix");
const order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
), _VFile = class _VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    let options;
    value ? isUrl(value) ? options = { path: value } : typeof value == "string" || isUint8Array$1(value) ? options = { value } : options = value : options = {}, this.cwd = "cwd" in options ? "" : minproc.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let index2 = -1;
    for (; ++index2 < order.length; ) {
      const field2 = order[index2];
      field2 in options && options[field2] !== void 0 && options[field2] !== null && (this[field2] = field2 === "history" ? [...options[field2]] : options[field2]);
    }
    let field;
    for (field in options)
      order.includes(field) || (this[field] = options[field]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? minpath.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename2) {
    assertNonEmpty(basename2, "basename"), assertPart(basename2, "basename"), this.path = minpath.join(this.dirname || "", basename2);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? minpath.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname2) {
    assertPath(this.basename, "dirname"), this.path = minpath.join(dirname2 || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? minpath.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname2) {
    if (assertPart(extname2, "extname"), assertPath(this.dirname, "extname"), extname2) {
      if (extname2.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (extname2.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = minpath.join(this.dirname, this.stem + (extname2 || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path) {
    isUrl(path) && (path = urlToPath(path)), assertNonEmpty(path, "path"), this.path !== path && this.history.push(path);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? minpath.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty(stem, "stem"), assertPart(stem, "stem"), this.path = minpath.join(this.dirname || "", stem + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    throw message.fatal = !0, message;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    return message.fatal = void 0, message;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin
    );
    return this.path && (message.name = this.path + ":" + message.name, message.file = this.path), message.fatal = !1, this.messages.push(message), message;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(encoding || void 0).decode(this.value);
  }
};
__name(_VFile, "VFile");
let VFile = _VFile;
function assertPart(part, name2) {
  if (part && part.includes(minpath.sep))
    throw new Error(
      "`" + name2 + "` cannot be a path: did not expect `" + minpath.sep + "`"
    );
}
__name(assertPart, "assertPart");
function assertNonEmpty(part, name2) {
  if (!part)
    throw new Error("`" + name2 + "` cannot be empty");
}
__name(assertNonEmpty, "assertNonEmpty");
function assertPath(path, name2) {
  if (!path)
    throw new Error("Setting `" + name2 + "` requires `path` to be set too");
}
__name(assertPath, "assertPath");
function isUint8Array$1(value) {
  return !!(value && typeof value == "object" && "byteLength" in value && "byteOffset" in value);
}
__name(isUint8Array$1, "isUint8Array$1");
const CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  /* @__PURE__ */ __name(function(property2) {
    const proto = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), value = proto[property2], apply2 = /* @__PURE__ */ __name(function() {
      return value.apply(apply2, arguments);
    }, "apply");
    return Object.setPrototypeOf(apply2, proto), apply2;
  }, "CallableInstance")
), own = {}.hasOwnProperty, _Processor = class _Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const destination = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new _Processor()
    );
    let index2 = -1;
    for (; ++index2 < this.attachers.length; ) {
      const attacher = this.attachers[index2];
      destination.use(...attacher);
    }
    return destination.data(extend$2(!0, {}, this.namespace)), destination;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key, value) {
    return typeof key == "string" ? arguments.length === 2 ? (assertUnfrozen("data", this.frozen), this.namespace[key] = value, this) : own.call(this.namespace, key) && this.namespace[key] || void 0 : key ? (assertUnfrozen("data", this.frozen), this.namespace = key, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const self2 = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [attacher, ...options] = this.attachers[this.freezeIndex];
      if (options[0] === !1)
        continue;
      options[0] === !0 && (options[0] = void 0);
      const transformer2 = attacher.call(self2, ...options);
      typeof transformer2 == "function" && this.transformers.use(transformer2);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze();
    const realFile = vfile(file), parser2 = this.parser || this.Parser;
    return assertParser("parse", parser2), parser2(String(realFile), realFile);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self2 = this;
    return this.freeze(), assertParser("process", this.parser || this.Parser), assertCompiler("process", this.compiler || this.Compiler), done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject) {
      const realFile = vfile(file), parseTree = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        self2.parse(realFile)
      );
      self2.run(parseTree, realFile, function(error, tree, file2) {
        if (error || !tree || !file2)
          return realDone(error);
        const compileTree = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          tree
        ), compileResult = self2.stringify(compileTree, file2);
        looksLikeAValue(compileResult) ? file2.value = compileResult : file2.result = compileResult, realDone(
          error,
          /** @type {VFileWithOutput<CompileResult>} */
          file2
        );
      });
      function realDone(error, file2) {
        error || !file2 ? reject(error) : resolve ? resolve(file2) : done(void 0, file2);
      }
      __name(realDone, "realDone");
    }
    __name(executor, "executor");
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    let complete = !1, result2;
    return this.freeze(), assertParser("processSync", this.parser || this.Parser), assertCompiler("processSync", this.compiler || this.Compiler), this.process(file, realDone), assertDone("processSync", "process", complete), result2;
    function realDone(error, file2) {
      complete = !0, bail(error), result2 = file2;
    }
    __name(realDone, "realDone");
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode(tree), this.freeze();
    const transformers = this.transformers;
    return !done && typeof file == "function" && (done = file, file = void 0), done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject) {
      const realFile = vfile(file);
      transformers.run(tree, realFile, realDone);
      function realDone(error, outputTree, file2) {
        const resultingTree = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          outputTree || tree
        );
        error ? reject(error) : resolve ? resolve(resultingTree) : done(void 0, resultingTree, file2);
      }
      __name(realDone, "realDone");
    }
    __name(executor, "executor");
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    let complete = !1, result2;
    return this.run(tree, file, realDone), assertDone("runSync", "run", complete), result2;
    function realDone(error, tree2) {
      bail(error), result2 = tree2, complete = !0;
    }
    __name(realDone, "realDone");
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze();
    const realFile = vfile(file), compiler2 = this.compiler || this.Compiler;
    return assertCompiler("stringify", compiler2), assertNode(tree), compiler2(tree, realFile);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers, namespace = this.namespace;
    if (assertUnfrozen("use", this.frozen), value != null)
      if (typeof value == "function")
        addPlugin(value, parameters);
      else if (typeof value == "object")
        Array.isArray(value) ? addList(value) : addPreset(value);
      else
        throw new TypeError("Expected usable value, not `" + value + "`");
    return this;
    function add2(value2) {
      if (typeof value2 == "function")
        addPlugin(value2, []);
      else if (typeof value2 == "object")
        if (Array.isArray(value2)) {
          const [plugin, ...parameters2] = (
            /** @type {PluginTuple<Array<unknown>>} */
            value2
          );
          addPlugin(plugin, parameters2);
        } else
          addPreset(value2);
      else
        throw new TypeError("Expected usable value, not `" + value2 + "`");
    }
    function addPreset(result2) {
      if (!("plugins" in result2) && !("settings" in result2))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      addList(result2.plugins), result2.settings && (namespace.settings = extend$2(!0, namespace.settings, result2.settings));
    }
    function addList(plugins) {
      let index2 = -1;
      if (plugins != null)
        if (Array.isArray(plugins))
          for (; ++index2 < plugins.length; ) {
            const thing = plugins[index2];
            add2(thing);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
    }
    function addPlugin(plugin, parameters2) {
      let index2 = -1, entryIndex = -1;
      for (; ++index2 < attachers.length; )
        if (attachers[index2][0] === plugin) {
          entryIndex = index2;
          break;
        }
      if (entryIndex === -1)
        attachers.push([plugin, ...parameters2]);
      else if (parameters2.length > 0) {
        let [primary, ...rest] = parameters2;
        const currentPrimary = attachers[entryIndex][1];
        isPlainObject$2(currentPrimary) && isPlainObject$2(primary) && (primary = extend$2(!0, currentPrimary, primary)), attachers[entryIndex] = [plugin, primary, ...rest];
      }
    }
  }
};
__name(_Processor, "Processor");
let Processor = _Processor;
const unified = new Processor().freeze();
function assertParser(name2, value) {
  if (typeof value != "function")
    throw new TypeError("Cannot `" + name2 + "` without `parser`");
}
__name(assertParser, "assertParser");
function assertCompiler(name2, value) {
  if (typeof value != "function")
    throw new TypeError("Cannot `" + name2 + "` without `compiler`");
}
__name(assertCompiler, "assertCompiler");
function assertUnfrozen(name2, frozen) {
  if (frozen)
    throw new Error(
      "Cannot call `" + name2 + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
__name(assertUnfrozen, "assertUnfrozen");
function assertNode(node2) {
  if (!isPlainObject$2(node2) || typeof node2.type != "string")
    throw new TypeError("Expected node, got `" + node2 + "`");
}
__name(assertNode, "assertNode");
function assertDone(name2, asyncName, complete) {
  if (!complete)
    throw new Error(
      "`" + name2 + "` finished async. Use `" + asyncName + "` instead"
    );
}
__name(assertDone, "assertDone");
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value);
}
__name(vfile, "vfile");
function looksLikeAVFile(value) {
  return !!(value && typeof value == "object" && "message" in value && "messages" in value);
}
__name(looksLikeAVFile, "looksLikeAVFile");
function looksLikeAValue(value) {
  return typeof value == "string" || isUint8Array(value);
}
__name(looksLikeAValue, "looksLikeAValue");
function isUint8Array(value) {
  return !!(value && typeof value == "object" && "byteLength" in value && "byteOffset" in value);
}
__name(isUint8Array, "isUint8Array");
const convert = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  /* @__PURE__ */ __name(function(test2) {
    if (test2 == null)
      return ok;
    if (typeof test2 == "function")
      return castFactory(test2);
    if (typeof test2 == "object")
      return Array.isArray(test2) ? anyFactory(test2) : propsFactory(test2);
    if (typeof test2 == "string")
      return typeFactory(test2);
    throw new Error("Expected function, string, or object as test");
  }, "convert")
);
function anyFactory(tests) {
  const checks2 = [];
  let index2 = -1;
  for (; ++index2 < tests.length; )
    checks2[index2] = convert(tests[index2]);
  return castFactory(any);
  function any(...parameters) {
    let index3 = -1;
    for (; ++index3 < checks2.length; )
      if (checks2[index3].apply(this, parameters))
        return !0;
    return !1;
  }
}
__name(anyFactory, "anyFactory");
function propsFactory(check2) {
  const checkAsRecord = (
    /** @type {Record<string, unknown>} */
    check2
  );
  return castFactory(all2);
  function all2(node2) {
    const nodeAsRecord = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      node2
    );
    let key;
    for (key in check2)
      if (nodeAsRecord[key] !== checkAsRecord[key])
        return !1;
    return !0;
  }
}
__name(propsFactory, "propsFactory");
function typeFactory(check2) {
  return castFactory(type);
  function type(node2) {
    return node2 && node2.type === check2;
  }
}
__name(typeFactory, "typeFactory");
function castFactory(testFunction) {
  return check2;
  function check2(value, index2, parent2) {
    return !!(looksLikeANode(value) && testFunction.call(
      this,
      value,
      typeof index2 == "number" ? index2 : void 0,
      parent2 || void 0
    ));
  }
}
__name(castFactory, "castFactory");
function ok() {
  return !0;
}
__name(ok, "ok");
function looksLikeANode(value) {
  return value !== null && typeof value == "object" && "type" in value;
}
__name(looksLikeANode, "looksLikeANode");
const empty = [], CONTINUE = !0, EXIT = !1, SKIP = "skip";
function visitParents(tree, test2, visitor, reverse3) {
  let check2;
  typeof test2 == "function" && typeof visitor != "function" ? (reverse3 = visitor, visitor = test2) : check2 = test2;
  const is2 = convert(check2), step = reverse3 ? -1 : 1;
  factory(tree, void 0, [])();
  function factory(node2, index2, parents) {
    const value = (
      /** @type {Record<string, unknown>} */
      node2 && typeof node2 == "object" ? node2 : {}
    );
    if (typeof value.type == "string") {
      const name2 = (
        // `hast`
        typeof value.tagName == "string" ? value.tagName : (
          // `xast`
          typeof value.name == "string" ? value.name : void 0
        )
      );
      Object.defineProperty(visit2, "name", {
        value: "node (" + (node2.type + (name2 ? "<" + name2 + ">" : "")) + ")"
      });
    }
    return visit2;
    function visit2() {
      let result2 = empty, subresult, offset, grandparents;
      if ((!test2 || is2(node2, index2, parents[parents.length - 1] || void 0)) && (result2 = toResult(visitor(node2, parents)), result2[0] === EXIT))
        return result2;
      if ("children" in node2 && node2.children) {
        const nodeAsParent = (
          /** @type {UnistParent} */
          node2
        );
        if (nodeAsParent.children && result2[0] !== SKIP)
          for (offset = (reverse3 ? nodeAsParent.children.length : -1) + step, grandparents = parents.concat(nodeAsParent); offset > -1 && offset < nodeAsParent.children.length; ) {
            const child = nodeAsParent.children[offset];
            if (subresult = factory(child, offset, grandparents)(), subresult[0] === EXIT)
              return subresult;
            offset = typeof subresult[1] == "number" ? subresult[1] : offset + step;
          }
      }
      return result2;
    }
  }
  __name(factory, "factory");
}
__name(visitParents, "visitParents");
function toResult(value) {
  return Array.isArray(value) ? value : typeof value == "number" ? [CONTINUE, value] : value == null ? empty : [value];
}
__name(toResult, "toResult");
function visit(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  let reverse3, test2, visitor;
  typeof testOrVisitor == "function" && typeof visitorOrReverse != "function" ? (test2 = void 0, visitor = testOrVisitor, reverse3 = visitorOrReverse) : (test2 = testOrVisitor, visitor = visitorOrReverse, reverse3 = maybeReverse), visitParents(tree, test2, overload, reverse3);
  function overload(node2, parents) {
    const parent2 = parents[parents.length - 1], index2 = parent2 ? parent2.children.indexOf(node2) : void 0;
    return visitor(node2, index2, parent2);
  }
  __name(overload, "overload");
}
__name(visit, "visit");
const changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", emptyPlugins = [], emptyRemarkRehypeOptions = { allowDangerousHtml: !0 }, safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i, deprecations = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Markdown(options) {
  const processor = createProcessor(options), file = createFile(options);
  return post(processor.runSync(processor.parse(file), file), options);
}
__name(Markdown, "Markdown");
function createProcessor(options) {
  const rehypePlugins = options.rehypePlugins || emptyPlugins, remarkPlugins = options.remarkPlugins || emptyPlugins, remarkRehypeOptions = options.remarkRehypeOptions ? { ...options.remarkRehypeOptions, ...emptyRemarkRehypeOptions } : emptyRemarkRehypeOptions;
  return unified().use(remarkParse).use(remarkPlugins).use(remarkRehype, remarkRehypeOptions).use(rehypePlugins);
}
__name(createProcessor, "createProcessor");
function createFile(options) {
  const children = options.children || "", file = new VFile();
  return typeof children == "string" && (file.value = children), file;
}
__name(createFile, "createFile");
function post(tree, options) {
  const allowedElements = options.allowedElements, allowElement = options.allowElement, components = options.components, disallowedElements = options.disallowedElements, skipHtml = options.skipHtml, unwrapDisallowed = options.unwrapDisallowed, urlTransform = options.urlTransform || defaultUrlTransform;
  for (const deprecation of deprecations)
    Object.hasOwn(options, deprecation.from) && ("" + deprecation.from + (deprecation.to ? "use `" + deprecation.to + "` instead" : "remove it") + changelog + deprecation.id, void 0);
  return visit(tree, transform2), toJsxRuntime(tree, {
    Fragment,
    components,
    ignoreInvalidStyle: !0,
    jsx,
    jsxs,
    passKeys: !0,
    passNode: !0
  });
  function transform2(node2, index2, parent2) {
    if (node2.type === "raw" && parent2 && typeof index2 == "number")
      return skipHtml ? parent2.children.splice(index2, 1) : parent2.children[index2] = { type: "text", value: node2.value }, index2;
    if (node2.type === "element") {
      let key;
      for (key in urlAttributes)
        if (Object.hasOwn(urlAttributes, key) && Object.hasOwn(node2.properties, key)) {
          const value = node2.properties[key], test2 = urlAttributes[key];
          (test2 === null || test2.includes(node2.tagName)) && (node2.properties[key] = urlTransform(String(value || ""), key, node2));
        }
    }
    if (node2.type === "element") {
      let remove3 = allowedElements ? !allowedElements.includes(node2.tagName) : disallowedElements ? disallowedElements.includes(node2.tagName) : !1;
      if (!remove3 && allowElement && typeof index2 == "number" && (remove3 = !allowElement(node2, index2, parent2)), remove3 && parent2 && typeof index2 == "number")
        return unwrapDisallowed && node2.children ? parent2.children.splice(index2, 1, ...node2.children) : parent2.children.splice(index2, 1), index2;
    }
  }
  __name(transform2, "transform");
}
__name(post, "post");
function defaultUrlTransform(value) {
  const colon = value.indexOf(":"), questionMark = value.indexOf("?"), numberSign = value.indexOf("#"), slash = value.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    safeProtocol.test(value.slice(0, colon)) ? value : ""
  );
}
__name(defaultUrlTransform, "defaultUrlTransform");
function MarkdownContent({
  "data-test": dataTest = "markdown-content",
  components,
  children
}) {
  return /* @__PURE__ */ jsx(Typography, { "data-test": dataTest, wordBreak: "break-word", children: /* @__PURE__ */ jsx(Markdown, { components, children }) });
}
__name(MarkdownContent, "MarkdownContent");
function Note({
  children,
  user,
  date: date2,
  locale: locale2,
  w: w2 = "100%",
  ...gapProps
}) {
  return /* @__PURE__ */ jsxs(Gap, { flexDirection: "column", space: "xxs", w: w2, ...gapProps, children: [
    /* @__PURE__ */ jsxs(Gap, { alignItems: "center", justifyContent: "space-between", children: [
      user,
      /* @__PURE__ */ jsx(
        DayTime,
        {
          date: date2,
          locale: locale2,
          variant: "bodyRegularS",
          color: "text-placeholder"
        }
      )
    ] }),
    typeof children == "string" ? /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children }) : children
  ] });
}
__name(Note, "Note");
function MarkdownBoldText({ children }) {
  return /* @__PURE__ */ jsx(Typography, { variant: "bodySemiboldS", children });
}
__name(MarkdownBoldText, "MarkdownBoldText");
function MarkdownText({ children }) {
  return /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children });
}
__name(MarkdownText, "MarkdownText");
const componentsMap = {
  h1: MarkdownBoldText,
  h2: MarkdownBoldText,
  h3: MarkdownBoldText,
  p: MarkdownText,
  em: MarkdownText
};
function MarkdownNote({
  "data-test": dataTest = "markdown-note",
  children,
  components = componentsMap,
  ...rest
}) {
  return /* @__PURE__ */ jsx(Note, { "data-test": dataTest, ...rest, children: /* @__PURE__ */ jsx(MarkdownContent, { components, children }) });
}
__name(MarkdownNote, "MarkdownNote");
function MessageScreen({
  buttonText,
  image: Image,
  onClick: onClick2,
  subtitle,
  title,
  "data-test": dataTest = "message-screen",
  w: w2 = "100%",
  h: h3 = "100%",
  backgroundColor: backgroundColor2 = "neutral-100",
  ...gapProps
}) {
  return /* @__PURE__ */ jsxs(
    Gap,
    {
      gap: "xl",
      w: w2,
      h: h3,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: backgroundColor2,
      "data-test": dataTest,
      ...gapProps,
      children: [
        Image && /* @__PURE__ */ jsx(Image, {}),
        /* @__PURE__ */ jsxs(Gap, { gap: "s", flexDirection: "column", alignItems: "center", children: [
          title && /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "headingBoldM",
              color: "text-highlight",
              "data-test": `${dataTest}-title`,
              children: title
            }
          ),
          subtitle && (typeof subtitle == "string" ? /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "bodyRegularM",
              textAlign: "center",
              "data-test": `${dataTest}-subtitle`,
              children: subtitle
            }
          ) : subtitle)
        ] }),
        onClick2 && buttonText && /* @__PURE__ */ jsx(Button$1, { "data-test": `${dataTest}-button`, onClick: onClick2, children: buttonText })
      ]
    }
  );
}
__name(MessageScreen, "MessageScreen");
const SvgAircallPlaceholder = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 60, cy: 60, r: 60, fill: "#CACCD8", fillOpacity: 0.25 }), /* @__PURE__ */ React.createElement("path", { d: "M72.0691 87.9346C71.1159 85.5825 69.0929 83.8114 66.6313 83.2759C65.1584 82.9234 62.7372 82.6935 60 82.6935C57.2629 82.6935 54.8417 82.9234 53.3688 83.2759C50.9248 83.8076 48.9131 85.5573 47.9516 87.8843C47.6181 88.6913 46.8191 89.1838 45.9738 89.1033C45.7648 89.0834 45.5842 89.0656 45.4321 89.0499C41.4933 88.6433 38.3974 88.0761 36.5987 87.4141C36.5958 87.4125 36.5922 87.4109 36.588 87.4093C35.381 86.939 34.5221 85.7312 34.5221 84.3155C34.5221 84.2803 34.5226 84.2452 34.5237 84.2103C34.5264 84.1533 34.5297 84.0951 34.5334 84.0358C34.5344 84.0225 34.5356 84.0093 34.5368 83.9961C34.5402 83.959 34.5424 83.9232 34.5432 83.8886C34.8498 79.6386 37.3394 69.6885 41.0579 58.3317C45.3088 45.3486 49.7544 34.8376 51.7591 32.7875C52.0791 32.4421 52.4483 32.1528 52.8564 31.9297C53.0157 31.8354 53.2175 31.7452 53.4571 31.6601C53.4634 31.6579 53.4697 31.6556 53.4759 31.6534C54.7931 31.1917 57.2205 30.8824 59.9976 30.8824C62.7796 30.8824 65.207 31.1917 66.5217 31.6526C66.5304 31.6556 66.5367 31.6579 66.5429 31.6601C66.7826 31.7452 66.9844 31.8354 67.1437 31.9297C67.5518 32.1528 67.921 32.4421 68.238 32.7838C68.2391 32.7849 68.2401 32.7861 68.241 32.7875C70.2456 34.8376 74.6912 45.3486 78.9422 58.3317C82.6607 69.6885 85.1502 79.6386 85.4568 83.8886C85.4577 83.9232 85.4598 83.959 85.4633 83.9961C85.4645 84.0093 85.4656 84.0225 85.4667 84.0358C85.4704 84.0951 85.4736 84.1533 85.4764 84.2103C85.4774 84.2452 85.478 84.2803 85.478 84.3155C85.478 85.7312 84.6191 86.939 83.4121 87.4093C83.4078 87.4109 83.4043 87.4125 83.4014 87.4141C81.6042 88.0755 78.5122 88.6423 74.5783 89.0488C74.4077 89.0664 74.2013 89.0867 73.9592 89.1096L73.9592 89.1096C73.1487 89.1863 72.3836 88.7107 72.0691 87.9346Z", fill: "#80939A" })), "SvgAircallPlaceholder");
function ComingSoonScreen({
  "data-test": dataTest = "coming-soon-screen",
  ...props
}) {
  return /* @__PURE__ */ jsx(MessageScreen, { image: SvgAircallPlaceholder, "data-test": dataTest, ...props });
}
__name(ComingSoonScreen, "ComingSoonScreen");
const SvgSettings = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 60, cy: 60, r: 60, fill: "#3086EE" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M90.3256 51.502H87.7711C86.7489 51.502 85.839 50.8729 85.4638 49.9226C85.3582 49.653 85.2481 49.3879 85.1336 49.1228C84.7269 48.1859 84.9246 47.0963 85.648 46.3728L87.4544 44.5665C89.8246 42.1963 89.8246 38.3523 87.4544 35.9798L84.0215 32.5469C81.6512 30.1767 77.8072 30.1767 75.4347 32.5469L73.6284 34.3532C72.905 35.0766 71.8176 35.2743 70.8785 34.8677C70.6134 34.7531 70.3483 34.643 70.0787 34.5374C69.1283 34.1622 68.4993 33.2523 68.4993 32.2301V29.6756C68.4993 26.3236 65.7808 23.6052 62.4288 23.6052H57.5737C54.2217 23.6052 51.5033 26.3236 51.5033 29.6756V32.2301C51.5033 33.2523 50.8742 34.1622 49.9239 34.5374C49.6543 34.643 49.3891 34.7531 49.124 34.8677C48.1872 35.2743 47.0976 35.0766 46.3741 34.3532L44.5678 32.5469C42.1976 30.1767 38.3535 30.1767 35.9811 32.5469L32.5482 35.9798C30.1779 38.35 30.1779 42.194 32.5482 44.5665L34.3545 46.3728C35.0779 47.0963 35.2756 48.1837 34.869 49.1228C34.7544 49.3879 34.6443 49.653 34.5387 49.9226C34.1635 50.8729 33.2536 51.502 32.2314 51.502H29.6769C26.3249 51.502 23.6064 54.2204 23.6064 57.5725V62.4275C23.6064 65.7795 26.3249 68.498 29.6769 68.498H32.2314C33.2536 68.498 34.1635 69.127 34.5387 70.0774C34.6443 70.347 34.7544 70.6121 34.869 70.8772C35.2756 71.8141 35.0779 72.9037 34.3545 73.6271L32.5482 75.4334C30.1779 77.8037 30.1779 81.6477 32.5482 84.0202L35.9811 87.4531C38.3513 89.8233 42.1953 89.8233 44.5678 87.4531L46.3741 85.6468C47.0976 84.9233 48.1849 84.7256 49.124 85.1323C49.3891 85.2468 49.6543 85.3569 49.9239 85.4625C50.8742 85.8377 51.5033 86.7476 51.5033 87.7698V90.3243C51.5033 93.6763 54.2217 96.3948 57.5737 96.3948H62.4288C65.7808 96.3948 68.4993 93.6763 68.4993 90.3243V87.7698C68.4993 86.7476 69.1283 85.8377 70.0787 85.4625C70.3483 85.3569 70.6134 85.2468 70.8785 85.1323C71.8153 84.7256 72.905 84.9233 73.6284 85.6468L75.4347 87.4531C77.8049 89.8233 81.649 89.8233 84.0215 87.4531L87.4544 84.0202C89.8246 81.6499 89.8246 77.8059 87.4544 75.4334L85.648 73.6271C84.9246 72.9037 84.7269 71.8163 85.1336 70.8772C85.2481 70.6121 85.3582 70.347 85.4638 70.0774C85.839 69.127 86.7489 68.498 87.7711 68.498H90.3256C93.6776 68.498 96.3961 65.7795 96.3961 62.4275V57.5725C96.3961 54.2204 93.6776 51.502 90.3256 51.502V51.502Z", fill: "white" }), /* @__PURE__ */ React.createElement("circle", { cx: 60, cy: 60, r: 13.6489, fill: "white" })), "SvgSettings");
function NoSupportScreen({
  "data-test": dataTest = "no-support-screen",
  ...props
}) {
  return /* @__PURE__ */ jsx(MessageScreen, { image: SvgSettings, "data-test": dataTest, ...props });
}
__name(NoSupportScreen, "NoSupportScreen");
const SvgNotFound = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement("svg", { width: 440, height: 325, viewBox: "0 0 440 325", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...props }, /* @__PURE__ */ React.createElement("g", { filter: "url(#filter0_bdd_13925_39989)" }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_13925_39989)" }, /* @__PURE__ */ React.createElement("rect", { x: 91.4678, y: 117.032, width: 218.474, height: 141.663, rx: 10.3226, fill: "#CACCD8", fillOpacity: 0.2, shapeRendering: "crispEdges" }), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter1_dd_13925_39989)" }, /* @__PURE__ */ React.createElement("rect", { width: 20.6452, height: 177.419, transform: "translate(91.4678 117.032)", fill: "#CACCD8", fillOpacity: 0.5 }), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip1_13925_39989)" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M101.79 128C103.128 128 104.311 128.109 105.031 128.275C106.467 128.578 107.597 129.711 107.898 131.151C108.065 131.873 108.173 133.06 108.173 134.402C108.173 135.744 108.065 136.93 107.898 137.652C107.597 139.092 106.467 140.226 105.031 140.528C104.311 140.695 103.128 140.803 101.79 140.803C100.452 140.803 99.2681 140.695 98.5481 140.528C97.1126 140.226 95.9821 139.092 95.6808 137.652C95.5147 136.93 95.4062 135.744 95.4062 134.402C95.4062 133.06 95.5147 131.873 95.6808 131.151C95.9821 129.711 97.1126 128.578 98.5481 128.275C99.2681 128.109 100.452 128 101.79 128ZM102.632 137.255C102.945 137.321 103.202 137.539 103.323 137.828C103.363 137.923 103.461 137.982 103.564 137.972C103.594 137.97 103.621 137.967 103.642 137.965C104.142 137.915 104.535 137.845 104.764 137.764L104.765 137.763C104.918 137.706 105.028 137.557 105.028 137.383C105.028 137.379 105.028 137.374 105.027 137.37L105.026 137.349L105.026 137.344C105.025 137.339 105.025 137.335 105.025 137.331C104.986 136.808 104.67 135.585 104.197 134.189C103.657 132.592 103.092 131.3 102.837 131.048C102.797 131.006 102.749 130.97 102.697 130.943C102.677 130.931 102.652 130.92 102.621 130.91L102.618 130.909C102.451 130.852 102.143 130.814 101.789 130.814C101.436 130.814 101.128 130.852 100.96 130.909L100.958 130.91C100.927 130.92 100.902 130.931 100.882 130.943C100.83 130.97 100.783 131.006 100.742 131.048C100.487 131.3 99.9223 132.592 99.3821 134.189C98.9095 135.585 98.5931 136.808 98.5541 137.331C98.554 137.335 98.5537 137.339 98.5533 137.344L98.5528 137.349L98.5516 137.37C98.5515 137.372 98.5515 137.375 98.5515 137.377C98.5514 137.379 98.5514 137.381 98.5514 137.383C98.5514 137.557 98.6606 137.706 98.814 137.763L98.8153 137.764C99.0439 137.845 99.4374 137.915 99.938 137.965C99.9573 137.967 99.9803 137.969 100.007 137.972C100.114 137.982 100.216 137.921 100.258 137.822C100.38 137.536 100.636 137.321 100.947 137.255C101.134 137.212 101.442 137.184 101.79 137.184C102.137 137.184 102.445 137.212 102.632 137.255Z", fill: "#F7F8FC" })), /* @__PURE__ */ React.createElement("rect", { x: 96.6289, y: 151.771, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("rect", { x: 96.6289, y: 169.836, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("rect", { x: 96.6289, y: 187.9, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("rect", { x: 96.6289, y: 205.965, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("rect", { x: 96.6289, y: 224.029, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" })), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip2_13925_39989)" }, /* @__PURE__ */ React.createElement("rect", { width: 197.829, height: 46.3624, transform: "translate(112.113 117.032)", fill: "#CACCD8", fillOpacity: 0.25 }), /* @__PURE__ */ React.createElement("rect", { x: 128.597, y: 133.517, width: 30.9082, height: 6.18165, rx: 3.09082, fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("rect", { x: 128.597, y: 143.819, width: 41.211, height: 3.09082, rx: 1.54541, fill: "#F7F8FC" }))), /* @__PURE__ */ React.createElement("rect", { x: 91.339, y: 116.904, width: 218.732, height: 141.92, rx: 10.4514, stroke: "#EAEBF0", strokeWidth: 0.257569, shapeRendering: "crispEdges" })), /* @__PURE__ */ React.createElement("mask", { id: "mask0_13925_39989", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 264, y: 82, width: 71, height: 72 }, /* @__PURE__ */ React.createElement("circle", { cx: 299.655, cy: 117.897, r: 35.17, fill: "#74B5FF" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_13925_39989)" }, /* @__PURE__ */ React.createElement("g", { filter: "url(#filter2_f_13925_39989)" }, /* @__PURE__ */ React.createElement("rect", { x: 290.178, y: 123.484, width: 103.058, height: 84.1643, fill: "#CACCD8", fillOpacity: 0.5 })), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter3_bdd_13925_39989)" }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip3_13925_39989)" }, /* @__PURE__ */ React.createElement("path", { d: "M148.243 111.001C148.243 103.874 154.02 98.0973 161.146 98.0973H306.307C313.433 98.0973 319.21 103.874 319.21 111.001V356.162H148.243V111.001Z", fill: "#CACCD8", fillOpacity: 0.2, shapeRendering: "crispEdges" }), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter4_bd_13925_39989)" }, /* @__PURE__ */ React.createElement("rect", { x: 195.017, y: 189.233, width: 77.4194, height: 77.4194, rx: 38.7097, fill: "#3086EE", shapeRendering: "crispEdges" }))), /* @__PURE__ */ React.createElement("path", { d: "M319.21 356.323H319.371V356.162V111.001C319.371 103.785 313.522 97.9363 306.307 97.9363H161.146C153.931 97.9363 148.082 103.785 148.082 111.001V356.162V356.323H148.243H319.21Z", stroke: "#EAEBF0", strokeWidth: 0.321961, shapeRendering: "crispEdges" }))), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M299.426 151.215C317.241 151.215 331.684 136.773 331.684 118.957C331.684 101.142 317.241 86.6991 299.426 86.6991C281.61 86.6991 267.167 101.142 267.167 118.957C267.167 136.773 281.61 151.215 299.426 151.215ZM299.426 172.721C329.118 172.721 353.189 148.65 353.189 118.957C353.189 89.2644 329.118 65.1937 299.426 65.1937C269.733 65.1937 245.662 89.2644 245.662 118.957C245.662 148.65 269.733 172.721 299.426 172.721Z", fill: "#FFC000" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.6, d: "M329.074 163.813C335.106 159.817 340.286 154.638 344.281 148.606L369.697 174.022C373.896 178.222 373.896 185.029 369.697 189.229C365.498 193.428 358.689 193.428 354.49 189.229L329.074 163.813Z", fill: "#FFC000" }), /* @__PURE__ */ React.createElement("path", { d: "M364.445 73.0314C369.872 73.0314 373.748 76.4998 373.748 81.3964C373.748 87.6558 368.641 88.8622 366.761 91.5769C366.042 92.6144 365.054 93.7194 363.792 93.7194C362.53 93.7194 361.46 92.6749 361.774 91.4526C363.094 86.3096 368.851 86.1128 368.851 81.8861C368.851 79.397 366.974 77.6832 364.281 77.6832C362.141 77.6832 360.473 78.7693 359.653 80.4913C359.073 81.7095 357.958 82.7961 356.615 82.6665C355.395 82.5488 354.445 81.4927 354.729 80.3006C355.76 75.9789 359.48 73.0314 364.445 73.0314Z", fill: "#FFE185" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.6, d: "M360.771 99.3094C360.771 101.023 362.158 102.411 363.912 102.411C365.708 102.411 367.054 101.023 367.054 99.3094C367.054 97.5548 365.708 96.2083 363.912 96.2083C362.158 96.2083 360.771 97.5548 360.771 99.3094Z", fill: "#FFE185" }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", { id: "filter0_bdd_13925_39989", x: 60.2422, y: 90.9683, width: 280.925, height: 214.436, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: 12.9032 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_13925_39989" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 15.4839 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 15.4839 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "effect1_backgroundBlur_13925_39989", result: "effect2_dropShadow_13925_39989" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dx: -2.58065, dy: 2.58065 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 3.87097 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "effect2_dropShadow_13925_39989", result: "effect3_dropShadow_13925_39989" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect3_dropShadow_13925_39989", result: "shape" })), /* @__PURE__ */ React.createElement("filter", { id: "filter1_dd_13925_39989", x: 88.1121, y: 115.354, width: 27.3564, height: 184.131, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 0.419464 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 0.419464 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.00392157 0 0 0 0 0.14902 0 0 0 0 0.207843 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_13925_39989" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 1.67785 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 1.67785 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.00392157 0 0 0 0 0.14902 0 0 0 0 0.207843 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "effect1_dropShadow_13925_39989", result: "effect2_dropShadow_13925_39989" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_13925_39989", result: "shape" })), /* @__PURE__ */ React.createElement("filter", { id: "filter2_f_13925_39989", x: 135.34, y: -31.3544, width: 412.736, height: 393.842, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 77.4193, result: "effect1_foregroundBlur_13925_39989" })), /* @__PURE__ */ React.createElement("filter", { id: "filter3_bdd_13925_39989", x: 109.211, y: 65.5173, width: 249.031, height: 349.031, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: 16.129 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_13925_39989" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 19.3548 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 19.3548 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "effect1_backgroundBlur_13925_39989", result: "effect2_dropShadow_13925_39989" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dx: -3.22581, dy: 3.22581 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 4.83871 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "effect2_dropShadow_13925_39989", result: "effect3_dropShadow_13925_39989" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect3_dropShadow_13925_39989", result: "shape" })), /* @__PURE__ */ React.createElement("filter", { id: "filter4_bd_13925_39989", x: 117.598, y: 124.717, width: 232.258, height: 258.065, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: 32.2581 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_13925_39989" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 38.7097 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 38.7097 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "effect1_backgroundBlur_13925_39989", result: "effect2_dropShadow_13925_39989" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_13925_39989", result: "shape" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_13925_39989" }, /* @__PURE__ */ React.createElement("rect", { x: 91.4678, y: 117.032, width: 218.474, height: 141.663, rx: 10.3226, fill: "white" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip1_13925_39989" }, /* @__PURE__ */ React.createElement("rect", { width: 12.7668, height: 12.8033, fill: "white", transform: "translate(95.4062 128)" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip2_13925_39989" }, /* @__PURE__ */ React.createElement("rect", { width: 197.829, height: 141.663, fill: "white", transform: "translate(112.113 117.032)" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip3_13925_39989" }, /* @__PURE__ */ React.createElement("path", { d: "M148.243 111.001C148.243 103.874 154.02 98.0973 161.146 98.0973H306.307C313.433 98.0973 319.21 103.874 319.21 111.001V356.162H148.243V111.001Z", fill: "white" })))), "SvgNotFound");
function NotFoundScreen({
  "data-test": dataTest = "not-found-screen",
  ...props
}) {
  return /* @__PURE__ */ jsx(MessageScreen, { image: SvgNotFound, "data-test": dataTest, ...props });
}
__name(NotFoundScreen, "NotFoundScreen");
const SvgLock = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 60, cy: 60, r: 60, fill: "#E85B79" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M27.2426 74.5588C27.2426 56.5751 31.097 52.7206 49.0808 52.7206H70.919C88.9028 52.7206 92.7573 56.5751 92.7573 74.5588C92.7573 92.5426 88.9028 96.3971 70.919 96.3971H49.0808C31.097 96.3971 27.2426 92.5426 27.2426 74.5588Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M56.3603 70.9191C56.3603 68.909 57.9898 67.2794 60 67.2794C62.0101 67.2794 63.6397 68.909 63.6397 70.9191V78.1985C63.6397 80.2087 62.0101 81.8383 60 81.8383C57.9898 81.8383 56.3603 80.2087 56.3603 78.1985V70.9191Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M60 23.603C47.9391 23.603 38.1617 33.3803 38.1617 45.4412V53.5862C40.2094 53.1384 42.6171 52.8896 45.4412 52.7833V45.4412C45.4412 37.4006 51.9594 30.8824 60 30.8824C68.0406 30.8824 74.5588 37.4006 74.5588 45.4412V52.7833C77.3829 52.8896 79.7906 53.1384 81.8382 53.5862V45.4412C81.8382 33.3803 72.0609 23.603 60 23.603Z", fill: "white" })), "SvgLock");
function RestrictedAccessScreen({
  "data-test": dataTest = "restricted-access-screen",
  ...props
}) {
  return /* @__PURE__ */ jsx(MessageScreen, { image: SvgLock, "data-test": dataTest, ...props });
}
__name(RestrictedAccessScreen, "RestrictedAccessScreen");
const SvgWarning = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement("svg", { width: 121, height: 120, viewBox: "0 0 121 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 60.5, cy: 60, r: 60, fill: "#F49C17" }), /* @__PURE__ */ React.createElement("path", { d: "M64.4637 64.76C64.4637 66.7702 62.8342 68.3997 60.824 68.3997C58.8139 68.3997 57.1843 66.7702 57.1843 64.76L57.1843 52.7203C57.1843 50.7101 58.8139 49.0806 60.824 49.0806C62.8342 49.0806 64.4637 50.7101 64.4637 52.7203V64.76Z", fill: "#F49C17" }), /* @__PURE__ */ React.createElement("path", { d: "M64.4637 76.3447C64.4637 78.3549 62.8342 79.9844 60.824 79.9844C58.8139 79.9844 57.1843 78.3549 57.1843 76.3447V75.5996C57.1843 73.5895 58.8139 71.9599 60.824 71.9599C62.8342 71.9599 64.4637 73.5895 64.4637 75.5996V76.3447Z", fill: "#F49C17" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, fillRule: "evenodd", clipRule: "evenodd", d: "M71.1357 36.918C67.1117 28.8701 55.6269 28.8701 51.6029 36.918L32.8734 74.3771C29.2433 81.6372 34.5227 90.1794 42.6397 90.1794H80.0989C88.2159 90.1794 93.4953 81.6372 89.8652 74.3771L71.1357 36.918ZM60.8242 68.3997C62.8343 68.3997 64.4639 66.7702 64.4639 64.76V52.7203C64.4639 50.7101 62.8343 49.0806 60.8242 49.0806C58.814 49.0806 57.1845 50.7101 57.1845 52.7203V64.76C57.1845 66.7702 58.814 68.3997 60.8242 68.3997ZM60.8242 79.9844C62.8343 79.9844 64.4639 78.3549 64.4639 76.3447V75.5996C64.4639 73.5894 62.8343 71.9599 60.8242 71.9599C58.814 71.9599 57.1845 73.5894 57.1845 75.5996V76.3447C57.1845 78.3549 58.814 79.9844 60.8242 79.9844Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M64.4669 64.7605C64.4669 66.7706 62.8374 68.4002 60.8272 68.4002C58.8171 68.4002 57.1875 66.7706 57.1875 64.7605L57.1875 52.7208C57.1875 50.7106 58.8171 49.0811 60.8272 49.0811C62.8374 49.0811 64.4669 50.7106 64.4669 52.7208V64.7605Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M64.4669 76.3452C64.4669 78.3553 62.8374 79.9849 60.8272 79.9849C58.8171 79.9849 57.1875 78.3553 57.1875 76.3452V75.6001C57.1875 73.5899 58.8171 71.9604 60.8272 71.9604C62.8374 71.9604 64.4669 73.5899 64.4669 75.6001V76.3452Z", fill: "white" })), "SvgWarning");
function UnknownErrorScreen({
  "data-test": dataTest = "unknown-error-screen",
  ...props
}) {
  return /* @__PURE__ */ jsx(MessageScreen, { image: SvgWarning, "data-test": dataTest, ...props });
}
__name(UnknownErrorScreen, "UnknownErrorScreen");
const SvgNoData = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement("svg", { width: 311, height: 193, viewBox: "0 0 311 193", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2_108)" }, /* @__PURE__ */ React.createElement("g", { filter: "url(#filter0_di_2_108)" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M257.216 23.8413L69.771 23.8402V70.702H267.487V34.1123C267.487 34.0901 267.487 34.068 267.487 34.0459C267.485 33.7285 267.468 33.4146 267.438 33.1047C267.399 32.6985 267.335 32.2992 267.25 31.9082C266.241 27.295 262.132 23.8414 257.216 23.8413ZM114.193 40.5305H89.543C87.841 40.5305 86.461 41.8238 86.461 43.4192C86.461 45.0146 87.841 46.3079 89.543 46.3079H114.193C115.895 46.3079 117.274 45.0146 117.274 43.4192C117.274 41.8238 115.895 40.5305 114.193 40.5305ZM126.005 50.1595H88.002C87.151 50.1595 86.461 50.878 86.461 51.7643C86.461 52.6507 87.151 53.3692 88.002 53.3692H126.005C126.855 53.3692 127.545 52.6507 127.545 51.7643C127.545 50.878 126.855 50.1595 126.005 50.1595Z", fill: "#CACCD8", fillOpacity: 0.4 }), /* @__PURE__ */ React.createElement("path", { d: "M56.4513 130.402H62.549C63.701 130.402 64.635 131.336 64.635 132.488V138.586C64.635 139.738 63.701 140.672 62.549 140.672H56.4513C55.2988 140.672 54.3645 139.738 54.3645 138.586V132.488C54.3645 131.336 55.2988 130.402 56.4513 130.402Z", fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("path", { d: "M56.4513 112.427H62.549C63.701 112.427 64.635 113.362 64.635 114.514V120.611C64.635 121.764 63.701 122.698 62.549 122.698H56.4513C55.2988 122.698 54.3645 121.764 54.3645 120.611V114.514C54.3645 113.362 55.2988 112.427 56.4513 112.427Z", fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("path", { d: "M56.4513 94.453H62.549C63.701 94.453 64.635 95.387 64.635 96.54V102.637C64.635 103.79 63.701 104.724 62.549 104.724H56.4513C55.2988 104.724 54.3645 103.79 54.3645 102.637V96.54C54.3645 95.387 55.2988 94.453 56.4513 94.453Z", fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("path", { d: "M56.4513 76.479H62.549C63.701 76.479 64.635 77.413 64.635 78.566V84.663C64.635 85.816 63.701 86.75 62.549 86.75H56.4513C55.2988 86.75 54.3645 85.816 54.3645 84.663V78.566C54.3645 77.413 55.2988 76.479 56.4513 76.479Z", fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("path", { d: "M56.4513 58.5047H62.549C63.701 58.5047 64.635 59.439 64.635 60.5916V66.689C64.635 67.841 63.701 68.776 62.549 68.776H56.4513C55.2988 68.776 54.3645 67.841 54.3645 66.689V60.5916C54.3645 59.439 55.2988 58.5047 56.4513 58.5047Z", fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M69.771 23.8402H59.5C53.8275 23.8402 49.229 28.4387 49.229 34.1112V154.795C49.229 160.468 53.8275 165.066 59.5 165.066H69.771V23.8402ZM62.549 130.402C63.701 130.402 64.635 131.336 64.635 132.488V138.586C64.635 139.738 63.701 140.672 62.549 140.672H56.4513C55.2988 140.672 54.3645 139.738 54.3645 138.586V132.488C54.3645 131.336 55.2988 130.402 56.4513 130.402H62.549ZM62.549 112.427H56.4513C55.2988 112.427 54.3645 113.362 54.3645 114.514V120.611C54.3645 121.764 55.2988 122.698 56.4513 122.698H62.549C63.701 122.698 64.635 121.764 64.635 120.611V114.514C64.635 113.362 63.701 112.427 62.549 112.427ZM56.4513 94.453H62.549C63.701 94.453 64.635 95.387 64.635 96.54V102.637C64.635 103.79 63.701 104.724 62.549 104.724H56.4513C55.2988 104.724 54.3645 103.79 54.3645 102.637V96.54C54.3645 95.387 55.2988 94.453 56.4513 94.453ZM62.549 76.479H56.4513C55.2988 76.479 54.3645 77.413 54.3645 78.566V84.663C54.3645 85.816 55.2988 86.75 56.4513 86.75H62.549C63.701 86.75 64.635 85.816 64.635 84.663V78.566C64.635 77.413 63.701 76.479 62.549 76.479ZM56.4513 58.5047H62.549C63.701 58.5047 64.635 59.439 64.635 60.5916V66.689C64.635 67.841 63.701 68.776 62.549 68.776H56.4513C55.2988 68.776 54.3645 67.841 54.3645 66.689V60.5916C54.3645 59.439 55.2988 58.5047 56.4513 58.5047ZM62.76 34.3873C62.036 34.2202 60.846 34.1112 59.5 34.1112C58.1545 34.1112 56.9642 34.2202 56.2402 34.3873C54.7966 34.6903 53.6597 35.8271 53.3567 37.2707C53.1897 37.9948 53.0806 39.185 53.0806 40.5305C53.0806 41.876 53.1897 43.0663 53.3567 43.7903C53.6597 45.2339 54.7966 46.3708 56.2402 46.6737C56.9642 46.8408 58.1545 46.9499 59.5 46.9499C60.846 46.9499 62.036 46.8408 62.76 46.6737C64.203 46.3708 65.34 45.2339 65.643 43.7903C65.81 43.0663 65.919 41.876 65.919 40.5305C65.919 39.185 65.81 37.9948 65.643 37.2707C65.34 35.8271 64.203 34.6903 62.76 34.3873ZM60.347 43.3919C60.662 43.458 60.921 43.6763 61.042 43.9663C61.083 44.062 61.18 44.1206 61.284 44.1112C61.315 44.1083 61.341 44.1058 61.363 44.1036C61.866 44.0535 62.261 43.9836 62.491 43.9021L62.492 43.9015C62.646 43.8436 62.756 43.6947 62.756 43.5202C62.756 43.5158 62.756 43.5115 62.756 43.5072L62.755 43.4856L62.754 43.4808C62.754 43.4762 62.754 43.4718 62.754 43.4675C62.714 42.9435 62.396 41.7169 61.921 40.3169C61.378 38.7163 60.809 37.4205 60.553 37.1678C60.513 37.1257 60.465 37.0895 60.413 37.062C60.393 37.0504 60.367 37.0393 60.336 37.0288L60.333 37.0279C60.165 36.9711 59.855 36.9329 59.5 36.9329C59.145 36.9329 58.8343 36.9711 58.666 37.028L58.6636 37.0288C58.633 37.0393 58.6072 37.0504 58.5868 37.062C58.5347 37.0895 58.4875 37.1252 58.4466 37.1678C58.1903 37.4205 57.6222 38.7163 57.0789 40.3169C56.6036 41.7169 56.2854 42.9435 56.2462 43.4675C56.2461 43.4718 56.2458 43.4762 56.2454 43.4808L56.245 43.4856L56.2437 43.5072L56.2436 43.5138L56.2435 43.5202C56.2435 43.6947 56.3533 43.8436 56.5076 43.9015L56.5089 43.9021C56.7389 43.9837 57.1345 44.0536 57.638 44.1038C57.6574 44.1057 57.6805 44.1079 57.7072 44.1104C57.8152 44.1203 57.9173 44.0596 57.96 43.9601C58.0828 43.6732 58.34 43.4575 58.6524 43.3919C58.8406 43.3485 59.15 43.3202 59.5 43.3202C59.85 43.3202 60.159 43.3485 60.347 43.3919Z", fill: "#CACCD8", fillOpacity: 0.6 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M59.5 34.1112C60.846 34.1112 62.036 34.2202 62.76 34.3873C64.203 34.6903 65.34 35.8271 65.643 37.2707C65.81 37.9948 65.919 39.185 65.919 40.5305C65.919 41.876 65.81 43.0663 65.643 43.7903C65.34 45.2339 64.203 46.3708 62.76 46.6737C62.036 46.8408 60.846 46.9499 59.5 46.9499C58.1545 46.9499 56.9642 46.8408 56.2402 46.6737C54.7966 46.3708 53.6597 45.2339 53.3567 43.7903C53.1897 43.0663 53.0806 41.876 53.0806 40.5305C53.0806 39.185 53.1897 37.9948 53.3567 37.2707C53.6597 35.8271 54.7966 34.6903 56.2402 34.3873C56.9642 34.2202 58.1545 34.1112 59.5 34.1112ZM61.042 43.9663C60.921 43.6763 60.662 43.458 60.347 43.3919C60.159 43.3485 59.85 43.3202 59.5 43.3202C59.15 43.3202 58.8406 43.3485 58.6524 43.3919C58.34 43.4575 58.0828 43.6732 57.96 43.9601C57.9173 44.0596 57.8152 44.1203 57.7072 44.1104C57.6805 44.1079 57.6574 44.1057 57.638 44.1038C57.1345 44.0536 56.7389 43.9837 56.5089 43.9021L56.5076 43.9015C56.3533 43.8436 56.2435 43.6947 56.2435 43.5202L56.2436 43.5138L56.2437 43.5072L56.245 43.4856L56.2454 43.4808C56.2458 43.4762 56.2461 43.4718 56.2462 43.4675C56.2854 42.9435 56.6036 41.7169 57.0789 40.3169C57.6222 38.7163 58.1903 37.4205 58.4466 37.1678C58.4875 37.1252 58.5347 37.0895 58.5868 37.062C58.6072 37.0504 58.633 37.0393 58.6636 37.0288L58.666 37.028C58.8343 36.9711 59.145 36.9329 59.5 36.9329C59.855 36.9329 60.165 36.9711 60.333 37.0279L60.336 37.0288C60.367 37.0393 60.393 37.0504 60.413 37.062C60.465 37.0895 60.513 37.1257 60.553 37.1678C60.809 37.4205 61.378 38.7163 61.921 40.3169C62.396 41.7169 62.714 42.9435 62.754 43.4675C62.754 43.4718 62.754 43.4762 62.754 43.4808L62.755 43.4856L62.756 43.5072C62.756 43.5115 62.756 43.5158 62.756 43.5202C62.756 43.6947 62.646 43.8436 62.492 43.9015L62.491 43.9021C62.261 43.9836 61.866 44.0535 61.363 44.1036C61.341 44.1058 61.315 44.1083 61.284 44.1112C61.18 44.1206 61.083 44.062 61.042 43.9663Z", fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("path", { d: "M88.002 50.1595H126.005C126.855 50.1595 127.545 50.878 127.545 51.7643C127.545 52.6507 126.855 53.3692 126.005 53.3692H88.002C87.151 53.3692 86.461 52.6507 86.461 51.7643C86.461 50.878 87.151 50.1595 88.002 50.1595Z", fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("path", { d: "M89.543 40.5305H114.193C115.895 40.5305 117.274 41.8238 117.274 43.4192C117.274 45.0146 115.895 46.3079 114.193 46.3079H89.543C87.841 46.3079 86.461 45.0146 86.461 43.4192C86.461 41.8238 87.841 40.5305 89.543 40.5305Z", fill: "#F7F8FC" }), /* @__PURE__ */ React.createElement("path", { d: "M267.487 154.795V34.1112C267.487 34.0894 267.487 34.0676 267.487 34.0459C267.487 34.068 267.487 34.0901 267.487 34.1123V70.702H69.771V23.8402V165.066H257.216C262.889 165.066 267.487 160.468 267.487 154.795Z", fill: "#F7F8FC", fillOpacity: 0.2 })), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M257.216 24.4823H59.5C54.182 24.4823 49.8709 28.7933 49.8709 34.1113V154.795C49.8709 160.113 54.182 164.424 59.5 164.424H257.216C262.534 164.424 266.845 160.113 266.845 154.795V34.1113C266.845 28.7933 262.534 24.4823 257.216 24.4823ZM59.5 23.8403C53.8275 23.8403 49.229 28.4388 49.229 34.1113V154.795C49.229 160.468 53.8275 165.066 59.5 165.066H257.216C262.889 165.066 267.487 160.468 267.487 154.795V34.1113C267.487 28.4388 262.889 23.8403 257.216 23.8403H59.5Z", fill: "url(#paint0_linear_2_108)" }), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter1_d_2_108)" }, /* @__PURE__ */ React.createElement("path", { d: "M304.704 25.792C301.495 11.9786 287.696 3.38163 273.882 6.59026C260.069 9.79889 251.472 23.598 254.681 37.4115C257.889 51.225 271.688 59.8219 285.502 56.6133C299.315 53.4047 307.912 39.6055 304.704 25.792Z", fill: "url(#paint1_linear_2_108)", fillOpacity: 0.6 }), /* @__PURE__ */ React.createElement("path", { d: "M304.217 25.9052C301.07 12.3607 287.54 3.93114 273.995 7.07729C260.451 10.2234 252.021 23.7539 255.168 37.2984C258.314 50.8429 271.844 59.2724 285.389 56.1263C298.933 52.9801 307.363 39.4497 304.217 25.9052Z", stroke: "url(#paint2_linear_2_108)", strokeOpacity: 0.5 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M279.023 34.3934C281.095 33.9121 282.384 31.8422 281.903 29.7702C281.422 27.6981 279.352 26.4086 277.28 26.8899C275.208 27.3712 273.918 29.4411 274.399 31.5131C274.881 33.5851 276.951 34.8747 279.023 34.3934ZM279.604 36.8945C283.057 36.0924 285.206 32.6426 284.404 29.1892C283.602 25.7358 280.152 23.5866 276.699 24.3887C273.245 25.1909 271.096 28.6407 271.898 32.0941C272.7 35.5474 276.15 37.6967 279.604 36.8945Z", fill: "#3086EE" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M282.811 35.0576C283.405 34.4299 283.867 33.6876 284.169 32.8781L287.812 35.1475C288.413 35.5225 288.597 36.3142 288.222 36.9161C287.847 37.5179 287.056 37.7019 286.454 37.3269L282.811 35.0576Z", fill: "#3086EE" })), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter2_d_2_108)" }, /* @__PURE__ */ React.createElement("path", { d: "M295.558 167.501C294.798 155.471 284.429 146.335 272.399 147.095C260.369 147.855 251.233 158.223 251.993 170.253C252.753 182.283 263.122 191.42 275.152 190.659C287.182 189.899 296.318 179.531 295.558 167.501Z", fill: "url(#paint3_linear_2_108)", fillOpacity: 0.6 }), /* @__PURE__ */ React.createElement("path", { d: "M295.058 167.533C294.316 155.778 284.185 146.852 272.43 147.594C260.676 148.337 251.749 158.468 252.492 170.222C253.234 181.977 263.365 190.904 275.12 190.161C286.874 189.418 295.801 179.287 295.058 167.533Z", stroke: "url(#paint4_linear_2_108)", strokeOpacity: 0.5 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M284.645 162.338C285.011 162.585 285.193 163.027 285.105 163.46L284.456 166.669C284.337 167.26 283.761 167.642 283.17 167.522L279.961 166.873C279.529 166.786 279.191 166.446 279.107 166.013C279.022 165.58 279.207 165.138 279.574 164.894L283.432 162.334C283.8 162.09 284.279 162.092 284.645 162.338ZM262.881 171.03C263.019 170.444 263.606 170.08 264.193 170.218L267.38 170.968C267.809 171.069 268.136 171.418 268.207 171.854C268.278 172.29 268.08 172.725 267.704 172.958L263.768 175.395C263.393 175.627 262.914 175.611 262.556 175.353C262.198 175.095 262.03 174.647 262.131 174.217L262.881 171.03Z", fill: "#012635" }), /* @__PURE__ */ React.createElement("g", { opacity: 0.5 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M273.084 160.173C269.186 160.419 266.02 163.472 265.314 167.482C265.209 168.076 264.643 168.472 264.05 168.368C263.456 168.263 263.06 167.697 263.164 167.103C264.026 162.211 267.936 158.311 272.946 157.995C277.956 157.678 282.326 161.054 283.796 165.8C283.975 166.376 283.653 166.987 283.077 167.165C282.501 167.344 281.89 167.022 281.712 166.446C280.506 162.557 276.981 159.927 273.084 160.173Z", fill: "#3086EE" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M264.191 170.607C264.767 170.428 265.378 170.751 265.557 171.326C266.762 175.215 270.287 177.845 274.185 177.599C278.082 177.353 281.248 174.3 281.954 170.29C282.059 169.697 282.625 169.3 283.219 169.405C283.812 169.509 284.209 170.075 284.104 170.669C283.242 175.562 279.332 179.461 274.322 179.777C269.312 180.094 264.943 176.718 263.472 171.972C263.293 171.397 263.615 170.785 264.191 170.607Z", fill: "#3086EE" }))), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter3_d_2_108)" }, /* @__PURE__ */ React.createElement("path", { d: "M45.4094 87.7479C45.8835 75.7032 36.5037 65.5547 24.459 65.0805C12.4143 64.6064 2.26571 73.9862 1.79156 86.0309C1.31742 98.0756 10.6972 108.224 22.742 108.698C34.7867 109.172 44.9352 99.7927 45.4094 87.7479Z", fill: "url(#paint5_linear_2_108)", fillOpacity: 0.6 }), /* @__PURE__ */ React.createElement("path", { d: "M44.9098 87.728C45.3731 75.9592 36.2082 66.0431 24.4394 65.5799C12.6706 65.1166 2.75453 74.2815 2.29124 86.0503C1.82796 97.8191 10.9929 107.735 22.7617 108.198C34.5305 108.662 44.4465 99.4968 44.9098 87.728Z", stroke: "url(#paint6_linear_2_108)", strokeOpacity: 0.5 }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M17.9884 92.129C17.5793 91.686 17.6065 90.996 18.0491 90.587L27.6661 81.698C28.1087 81.289 28.7991 81.317 29.2082 81.759C29.6173 82.202 29.5901 82.892 29.1475 83.301L19.5305 92.19C19.0879 92.599 18.3975 92.572 17.9884 92.129Z", fill: "#3086EE" }), /* @__PURE__ */ React.createElement("path", { d: "M28.803 92.547C29.2456 92.138 29.2727 91.447 28.8637 91.005L19.9379 81.347C19.5288 80.905 18.8384 80.878 18.3958 81.287C17.9532 81.696 17.926 82.386 18.3351 82.829L27.2608 92.486C27.6699 92.929 28.3603 92.956 28.803 92.547Z", fill: "#3086EE" }))), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", { id: "filter0_di_2_108", x: 33.229, y: 15.8402, width: 242.258, height: 173.226, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dx: -4, dy: 4 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 6 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_2_108" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_2_108", result: "shape" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 24 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 24 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: -1, k3: 1 }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect2_innerShadow_2_108" })), /* @__PURE__ */ React.createElement("filter", { id: "filter1_d_2_108", x: 206.009, y: -18.0813, width: 147.366, height: 147.366, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 24 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 24 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_2_108" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_2_108", result: "shape" })), /* @__PURE__ */ React.createElement("filter", { id: "filter2_d_2_108", x: 203.949, y: 123.051, width: 139.654, height: 139.654, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 24 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 24 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_2_108" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_2_108", result: "shape" })), /* @__PURE__ */ React.createElement("filter", { id: "filter3_d_2_108", x: -46.2256, y: 41.063, width: 139.652, height: 139.653, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 24 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 24 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_2_108" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_2_108", result: "shape" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint0_linear_2_108", x1: 267.487, y1: 23.8403, x2: 49.229, y2: 165.066, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#CACCD8", stopOpacity: 0.2 }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#CACCD8", stopOpacity: 0.5 })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint1_linear_2_108", x1: 273.882, y1: 6.59035, x2: 285.502, y2: 56.6136, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#C9C9C9", stopOpacity: 0.5 }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#EAEBF0", stopOpacity: 0.5 })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint2_linear_2_108", x1: 273.813, y1: 6.7358, x2: 285.433, y2: 56.759, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#6B6C72", stopOpacity: 0.25 })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint3_linear_2_108", x1: 272.4, y1: 147.095, x2: 275.152, y2: 190.66, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#C9C9C9", stopOpacity: 0.5 }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#EAEBF0", stopOpacity: 0.5 })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint4_linear_2_108", x1: 272.371, y1: 147.129, x2: 275.124, y2: 190.694, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#6B6C72", stopOpacity: 0.25 })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint5_linear_2_108", x1: 24.4591, y1: 65.0805, x2: 22.7421, y2: 108.698, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#C9C9C9", stopOpacity: 0.5 }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#EAEBF0", stopOpacity: 0.5 })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint6_linear_2_108", x1: 24.4799, y1: 65.062, x2: 22.7629, y2: 108.679, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#CACCD8" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#6B6C72", stopOpacity: 0.25 })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2_108" }, /* @__PURE__ */ React.createElement("rect", { width: 309.58, height: 191.255, fill: "white", transform: "translate(0.933044 0.780533)" })))), "SvgNoData");
function NoDataScreen({
  "data-test": dataTest = "no-data-screen",
  ...props
}) {
  return /* @__PURE__ */ jsx(MessageScreen, { image: SvgNoData, "data-test": dataTest, ...props });
}
__name(NoDataScreen, "NoDataScreen");
function Player({
  onPlay,
  onError,
  icons: {
    play: PlayIcon = PlayFilled,
    stop: StopIcon = ControlStopFilled
  } = {},
  "data-test": dataTest = "mini-audio-player",
  autoplay = !1,
  ...iconProps
}) {
  const { isPlaying, pause, play, seek, error } = useAudio();
  useEffect(() => {
    error && (onError == null || onError(error));
  }, [error, onError]), useEffect(() => {
    autoplay && play();
  }, [autoplay, play]);
  const togglePlay = useCallback(
    (e3) => {
      e3.stopPropagation(), isPlaying ? (onPlay == null || onPlay(), pause(), seek(0)) : play();
    },
    [isPlaying, onPlay, pause, play, seek]
  );
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      ...iconProps,
      component: isPlaying ? StopIcon : PlayIcon,
      onClick: togglePlay,
      "data-test": `${dataTest}-play-button`
    }
  );
}
__name(Player, "Player");
function MiniAudioPlayer({ src, ...playerProps }) {
  return /* @__PURE__ */ jsx(AudioManager, { children: /* @__PURE__ */ jsx(Audio, { src, children: /* @__PURE__ */ jsx(Player, { ...playerProps }) }) });
}
__name(MiniAudioPlayer, "MiniAudioPlayer");
function ModalCard({ avatar, tag, title }) {
  const borderColor2 = useColor("neutral-200");
  return /* @__PURE__ */ jsxs(
    Gap,
    {
      minWidth: 160,
      gap: "xxxs",
      p: "s",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "white",
      border: `1px solid ${borderColor2}`,
      borderRadius: "sm",
      children: [
        avatar,
        /* @__PURE__ */ jsx(Typography, { variant: "bodySemiboldM", ellipsis: !0, children: title }),
        tag
      ]
    }
  );
}
__name(ModalCard, "ModalCard");
const StyledForm = styled(Form$1)`
  display: flex;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;
`;
function ModalForm({
  show,
  formProps,
  onHide,
  onCancel = onHide,
  title,
  children,
  submitButtonText,
  size = "regular",
  allowPristineSubmit = !1,
  extraFooterContent,
  lang = "en",
  "data-test": dataTest = "modal-form",
  getErrorMessage
}) {
  return /* @__PURE__ */ jsx(ModalDialog, { show, onHide, size, children: /* @__PURE__ */ jsx(Form, { ...formProps, children: (formRenderProps) => {
    const {
      handleSubmit,
      hasValidationErrors,
      pristine,
      submitError,
      submitting
    } = formRenderProps, shouldDisableSubmit = submitting || hasValidationErrors || !allowPristineSubmit && pristine;
    return /* @__PURE__ */ jsxs(StyledForm, { onSubmit: handleSubmit, "data-test": dataTest, children: [
      /* @__PURE__ */ jsx(ModalHeader, { children: /* @__PURE__ */ jsx(ModalTitle, { children: title }) }),
      /* @__PURE__ */ jsx(ModalBody, { children: children(formRenderProps) }),
      /* @__PURE__ */ jsx(AnimatePresence, { children: submitError && /* @__PURE__ */ jsxs(
        Banner,
        {
          variant: "critical",
          "data-text": "modal-form-error-banner",
          children: [
            /* @__PURE__ */ jsx(BannerIcon, {}),
            /* @__PURE__ */ jsx(BannerHeading, { children: getErrorMessage == null ? void 0 : getErrorMessage(submitError) })
          ]
        }
      ) }),
      /* @__PURE__ */ jsx(ModalFooter, { children: /* @__PURE__ */ jsxs(
        Spacer,
        {
          space: "xxs",
          alignItems: "center",
          justifyContent: "space-between",
          children: [
            extraFooterContent && /* @__PURE__ */ jsx(Box, { children: extraFooterContent }),
            /* @__PURE__ */ jsx(
              Button$1,
              {
                onClick: onCancel,
                type: "button",
                mode: "ghost",
                variant: "secondary",
                "data-test": "modal-form-cancel-button",
                children: translations[lang][FORM_ACTIONS.CANCEL]
              }
            ),
            /* @__PURE__ */ jsx(
              SaveButton,
              {
                type: "submit",
                "data-test": "modal-form-submit-button",
                disabled: shouldDisableSubmit,
                status: getSavingStatus(formRenderProps),
                savedText: translations[lang][FORM_ACTIONS.SAVED],
                unsavedText: submitButtonText || translations[lang][FORM_ACTIONS.SUBMIT]
              }
            )
          ]
        }
      ) })
    ] });
  } }) });
}
__name(ModalForm, "ModalForm");
function MultiInlineSearchTagItemInner({ item, "data-test": dataTest }) {
  const { removeKey, disabled } = useComboBox(), trimmedValue = trimWithEllipsis(item.label, 35), onDelete = useCallback(
    (event) => {
      event.stopPropagation(), removeKey(item.value);
    },
    [item.value, removeKey]
  );
  return /* @__PURE__ */ jsxs(Tag, { variant: "grey", size: "small", "data-test": dataTest, children: [
    /* @__PURE__ */ jsx(TagLabel, { "data-test": `${dataTest}-label`, children: trimmedValue }),
    /* @__PURE__ */ jsx(
      TagDeleteIcon,
      {
        "data-test": `${dataTest}-delete-icon`,
        onClick: disabled ? void 0 : onDelete
      }
    )
  ] });
}
__name(MultiInlineSearchTagItemInner, "MultiInlineSearchTagItemInner");
const MultiInlineSearchTagItem = memo$1(
  MultiInlineSearchTagItemInner
), TAG_HEIGHT = 32, TagWrapper = styled(Flex)`
  display: flex;
  align-items: center;
  height: ${TAG_HEIGHT}px;
`;
function TagList({
  selectedOptions,
  "data-test": dataTest,
  renderItem
}) {
  return selectedOptions.length === 0 ? null : /* @__PURE__ */ jsx(Fragment, { children: selectedOptions.map((item) => /* @__PURE__ */ jsx(TagWrapper, { children: renderItem ? renderItem(item) : /* @__PURE__ */ jsx(
    MultiInlineSearchTagItem,
    {
      item,
      "data-test": `${dataTest}-${item.value}`
    }
  ) }, item.value)) });
}
__name(TagList, "TagList");
const InlineInput = styled.input`
  width: 100%;
  flex: 1;
  height: ${TAG_HEIGHT}px;
  display: flex;
  align-items: center;

  &,
  &:hover,
  &:active,
  &:focus {
    border: none;
  }
  background: transparent;
  outline: none;
`;
function MultiInlineSearchBox({
  onValueChange,
  value,
  inputRef,
  selectedOptions,
  "data-test": dataTest,
  renderTag
}) {
  const { removeKey, open, setOpen, disabled } = useComboBox();
  useEffect(() => {
    var _a3;
    open && ((_a3 = inputRef == null ? void 0 : inputRef.current) == null || _a3.focus());
  }, [inputRef, open]);
  const onChange5 = /* @__PURE__ */ __name((event) => {
    onValueChange(event.target.value);
  }, "onChange"), onKeyDown = /* @__PURE__ */ __name((e3) => {
    if (open || setOpen(!0), e3.key === "Backspace" && value === "") {
      const lastOption = selectedOptions[selectedOptions.length - 1];
      lastOption && removeKey(lastOption.value);
    }
  }, "onKeyDown");
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      w: "100%",
      flexWrap: "wrap",
      "data-test": dataTest,
      gap: "xxxs",
      onClick: disabled ? void 0 : /* @__PURE__ */ __name((e3) => {
        e3.stopPropagation(), open || setOpen(!0);
      }, "onSearchBoxClick"),
      alignSelf: "flex-start",
      children: [
        /* @__PURE__ */ jsx(
          TagList,
          {
            "data-test": `${dataTest}-tag`,
            selectedOptions,
            renderItem: renderTag
          }
        ),
        !disabled && /* @__PURE__ */ jsx(
          InlineInput,
          {
            "data-test": `${dataTest}-input`,
            value,
            onChange: onChange5,
            onKeyDown,
            ref: inputRef
          }
        )
      ]
    }
  );
}
__name(MultiInlineSearchBox, "MultiInlineSearchBox");
function MultiInlineSearchIcon({
  onClearAll,
  hideClearAll,
  "data-test": dataTest
}) {
  const { removeAll, selectedKeys, disabled } = useComboBox();
  return hideClearAll || disabled ? /* @__PURE__ */ jsx(
    Icon,
    {
      "data-test": `${dataTest}-down`,
      color: "icon-default",
      ml: "auto",
      size: "16px",
      component: ChevronDownOutlined
    }
  ) : /* @__PURE__ */ jsx(
    Icon,
    {
      "data-test": `${dataTest}-${selectedKeys.length ? "close" : "down"}`,
      color: "icon-default",
      ml: "auto",
      size: "16px",
      component: selectedKeys.length ? CloseOutlined : ChevronDownOutlined,
      onClick: () => {
        selectedKeys.length && (removeAll(), onClearAll());
      }
    }
  );
}
__name(MultiInlineSearchIcon, "MultiInlineSearchIcon");
function MultiSelectMenu({
  options,
  renderItem,
  renderItemPrefix,
  renderItemSuffix,
  renderItemDescription,
  maxMenuHeight,
  "data-test": dataTest
}) {
  return /* @__PURE__ */ jsx(ComboBoxMenu, { py: "xxs", maxHeight: maxMenuHeight, "data-test": dataTest, children: options.map((option) => /* @__PURE__ */ jsx(
    MultiSelectItem,
    {
      option,
      render: renderItem,
      renderPrefix: renderItemPrefix,
      renderSuffix: renderItemSuffix,
      renderDescription: renderItemDescription
    },
    option.value
  )) });
}
__name(MultiSelectMenu, "MultiSelectMenu");
function MultiInlineSearchSelect({
  options,
  onSelect: onSelect2,
  onSearch: onSearch2,
  onClose = noop$5,
  onClearAll = noop$5,
  open,
  defaultOpen,
  loading = !1,
  hideSelectedOptions = !0,
  hideClearAll = !1,
  defaultSelectedKeys: defaultProp,
  selectedKeys: prop,
  renderTag,
  renderItem,
  renderItemPrefix,
  renderItemSuffix,
  renderItemDescription,
  emptyLabel = "0 result",
  debounceDuration = 400,
  maxMenuHeight = "314px",
  maxSearchBoxHeight = "240px",
  "data-test": dataTest = "multi-inline-search",
  disabled = !1
}) {
  const [selectedKeys, onSelectedKeysChange] = useControllableState({
    prop,
    defaultProp,
    onChange: onSelect2
  }), [text2, setText] = useState(""), inputRef = useRef(null), onSearchDebounced = useRef(debounce$2(onSearch2, debounceDuration)), [optionsCache, setOptionsCache] = useState(/* @__PURE__ */ new Map()), onTextInputChange = /* @__PURE__ */ __name((value) => {
    setText(value), onSearchDebounced.current(value);
  }, "onTextInputChange");
  useEffect(() => {
    setOptionsCache((cache2) => (selectedKeys == null || selectedKeys.forEach((key) => {
      if (!cache2.has(key)) {
        const option = options.find((o) => o.value === key);
        option && cache2.set(key, option);
      }
    }), cache2));
  }, [selectedKeys, options, optionsCache]);
  const resetSearch = /* @__PURE__ */ __name(() => {
    setText(""), onSearchDebounced.current("");
  }, "resetSearch"), onSelectionChange = /* @__PURE__ */ __name((keys2) => {
    var _a3;
    onSelectedKeysChange(keys2), setText(""), (_a3 = inputRef.current) == null || _a3.focus();
  }, "onSelectionChange"), handleClose = /* @__PURE__ */ __name(() => {
    document.activeElement === inputRef.current || resetSearch(), onClose();
  }, "handleClose"), selectedOptions = useMemo(
    () => (selectedKeys == null ? void 0 : selectedKeys.reduce((acc, k3) => {
      const opt = options.find((o) => o.value === k3) || optionsCache.get(k3);
      return opt ? [...acc, opt] : acc;
    }, [])) || [],
    [selectedKeys, options, optionsCache]
  ), unselectedOptions = options.filter(
    (o) => !(selectedKeys != null && selectedKeys.includes(o.value))
  ), isEmpty = hideSelectedOptions ? unselectedOptions.length === 0 : options.length === 0, color2 = useMemo(
    () => disabled ? {
      borderColor: "graphic-disabled",
      backgroundColor: "surface-disabled"
    } : {
      borderColor: "graphic-interactive-default",
      backgroundColor: "surface-interactive-default"
    },
    [disabled]
  );
  return /* @__PURE__ */ jsxs(
    ComboBox,
    {
      selectionMode: "multiple",
      onSelectionChange,
      selectedKeys,
      onClose: handleClose,
      "data-test": dataTest,
      defaultOpen,
      open,
      disabled,
      children: [
        /* @__PURE__ */ jsx(ComboBoxTrigger, { "data-test": `${dataTest}-trigger`, children: /* @__PURE__ */ jsxs(
          Flex,
          {
            border: "1px solid",
            borderRadius: "sm",
            ...color2,
            w: "100%",
            minH: "48px",
            maxH: maxSearchBoxHeight,
            overflowY: "auto",
            p: "xxs",
            alignItems: "center",
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ jsx(
                MultiInlineSearchBox,
                {
                  renderTag,
                  "data-test": `${dataTest}-box`,
                  value: text2,
                  onValueChange: onTextInputChange,
                  inputRef,
                  selectedOptions
                }
              ),
              /* @__PURE__ */ jsx(
                MultiInlineSearchIcon,
                {
                  "data-test": `${dataTest}-icon`,
                  hideClearAll,
                  onClearAll
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ jsxs(
          ComboBoxContent,
          {
            closeOnInsideClick: !1,
            "data-test": `${dataTest}-content`,
            children: [
              loading && /* @__PURE__ */ jsx(MultiSelectLoader, { "data-test": `${dataTest}-loader` }),
              !loading && isEmpty && /* @__PURE__ */ jsx(Typography, { p: "s", "data-test": "multi-inline-search-empty-label", children: emptyLabel }),
              !loading && !isEmpty && /* @__PURE__ */ jsx(
                MultiSelectMenu,
                {
                  "data-test": `${dataTest}-menu`,
                  options: hideSelectedOptions ? unselectedOptions : options,
                  maxMenuHeight,
                  renderItem,
                  renderItemPrefix,
                  renderItemSuffix,
                  renderItemDescription
                }
              )
            ]
          }
        )
      ]
    }
  );
}
__name(MultiInlineSearchSelect, "MultiInlineSearchSelect");
const NavigationBlockerContext = createContext(void 0);
function NavigationBlockerProvider({
  children
}) {
  const [navPromptShown, setNavPromptShown] = useState(!1), blockedTransition = useRef(null), confirmNavigation = useCallback(() => {
    setNavPromptShown(!1), blockedTransition.current && blockedTransition.current.retry();
  }, []), cancelNavigation = useCallback(() => {
    setNavPromptShown(!1);
  }, []), setBlockedTransition = useCallback((transition2) => {
    blockedTransition.current = transition2, setNavPromptShown(!0);
  }, []), memoizedContextValue = useMemo(
    () => ({
      navPromptShown,
      setNavPromptShown,
      cancelNavigation,
      confirmNavigation,
      setBlockedTransition
    }),
    [cancelNavigation, confirmNavigation, navPromptShown, setBlockedTransition]
  );
  return /* @__PURE__ */ jsx(NavigationBlockerContext.Provider, { value: memoizedContextValue, children });
}
__name(NavigationBlockerProvider, "NavigationBlockerProvider");
function NavigationBlockerDialog({
  descriptionText = "You have unsaved changes. Are you sure you want to leave?",
  cancelText = "Cancel",
  discardText = "Discard"
}) {
  const { navPromptShown, cancelNavigation, confirmNavigation } = useNavigationBlocker();
  return /* @__PURE__ */ jsxs(ModalDialog, { size: "xSmall", show: navPromptShown, onHide: cancelNavigation, children: [
    /* @__PURE__ */ jsx(ModalBody, { p: "m", children: /* @__PURE__ */ jsx(Typography, { variant: "bodyMediumS", children: descriptionText }) }),
    /* @__PURE__ */ jsx(ModalFooter, { children: /* @__PURE__ */ jsxs(Spacer, { direction: "horizontal", space: "xxs", children: [
      /* @__PURE__ */ jsx(
        Button$1,
        {
          "data-test": "navigation-blocker-dialog-cancel",
          mode: "ghost",
          variant: "secondary",
          onClick: cancelNavigation,
          children: cancelText
        }
      ),
      /* @__PURE__ */ jsx(
        Button$1,
        {
          "data-test": "navigation-blocker-dialog-confirm",
          onClick: confirmNavigation,
          children: discardText
        }
      )
    ] }) })
  ] });
}
__name(NavigationBlockerDialog, "NavigationBlockerDialog");
const makeTextField = /* @__PURE__ */ __name(({ variant }) => {
  switch (variant) {
    case "yellow":
      return css`
        background: ${getColor$1("warning-100")};
      `;
    case "green":
      return css`
        background: ${getColor$1("primary-100")};
      `;
    default:
      return "background: none;";
  }
}, "makeTextField"), StyledAvatar$1 = styled(Avatar$1)`
  ${makeTextField}

  &::after {
    display: none;
  }
`;
function NumberBox({
  "data-test": dataTest = "number-box",
  value,
  maxValue
}) {
  return /* @__PURE__ */ jsx(
    StyledAvatar$1,
    {
      size: "xLarge",
      variant: maxValue !== void 0 && value >= maxValue ? "yellow" : "green",
      "data-test": "avatar-with-number",
      children: maxValue !== void 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "headingBoldS",
            mb: "xs",
            "data-test": `${dataTest}-count`,
            children: value
          }
        ),
        /* @__PURE__ */ jsxs(
          Typography,
          {
            variant: "bodyRegularS",
            mt: "s",
            "data-test": `${dataTest}-max-number`,
            children: [
              "/ ",
              maxValue
            ]
          }
        )
      ] }) : /* @__PURE__ */ jsx(Typography, { variant: "headingBoldS", "data-test": `${dataTest}-count`, children: value })
    }
  );
}
__name(NumberBox, "NumberBox");
const Right = styled(Flex)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  align-items: center;
  justify-content: end;
  gap: xxs;
  margin-right: xs;
  width: 60px;
`, STextInput = styled(TextInput)`
  // the width of Right element
  padding-right: 60px;
  /* Hide native number input arrows */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;
function NumberInput({
  unit: unit2,
  value,
  width: width2,
  onChange: onChange5,
  min: min2,
  max: max2,
  step = 1,
  decimalPlaces = 0,
  minWidth: minWidth2,
  ...restProps
}) {
  const [strValue, setValue] = useState(value.toString());
  useEffect(() => {
    setValue(value.toString());
  }, [value]);
  const updateValue = useCallback(
    (updater) => {
      setValue((v) => {
        const num2 = parseFloat(v);
        let newNum = updater(num2);
        min2 !== void 0 && newNum < min2 && (newNum = min2), max2 !== void 0 && newNum > max2 && (newNum = max2);
        const numberToReturn = toFixedNumber(newNum, decimalPlaces);
        return onChange5 == null || onChange5(numberToReturn), numberToReturn.toString();
      });
    },
    [decimalPlaces, max2, min2, onChange5]
  ), handleClickUp = useCallback(() => {
    updateValue((v) => v + step);
  }, [step, updateValue]), handleClickDown = useCallback(() => {
    updateValue((v) => v - step);
  }, [step, updateValue]), handleChange = useCallback(
    (e3) => {
      const origValue = e3.target.value, newNumber = parseFloat(origValue);
      if (origValue === "" || Number.isNaN(newNumber)) {
        setValue("");
        return;
      }
      updateValue(() => newNumber);
    },
    [updateValue]
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-test": "number-input",
      w: width2,
      minWidth: minWidth2,
      position: "relative",
      children: [
        /* @__PURE__ */ jsx(
          STextInput,
          {
            ...restProps,
            type: "number",
            width: "100%",
            min: min2,
            max: max2,
            step,
            value: strValue,
            onChange: handleChange,
            "data-test": "number-input-input"
          }
        ),
        /* @__PURE__ */ jsxs(Right, { children: [
          /* @__PURE__ */ jsx(Typography, { color: "text-secondary", children: unit2 }),
          /* @__PURE__ */ jsxs(Flex, { flexDirection: "column", gap: "0px", children: [
            /* @__PURE__ */ jsx(
              IconButton,
              {
                type: "button",
                component: ArrowUpFilled,
                size: 16,
                color: "icon-default",
                onClick: handleClickUp,
                "data-test": "number-input-up"
              }
            ),
            /* @__PURE__ */ jsx(
              IconButton,
              {
                type: "button",
                component: ArrowDownFilled,
                size: 16,
                color: "icon-default",
                onClick: handleClickDown,
                "data-test": "number-input-down"
              }
            )
          ] })
        ] })
      ]
    }
  );
}
__name(NumberInput, "NumberInput");
const Bar = styled(Box).attrs(({ progress: progress2 }) => ({
  style: {
    width: `${progress2 ?? "100"}%`
  }
}))`
  position: absolute;
  height: ${({ barHeight }) => barHeight}px;
  border-radius: ${({ barHeight }) => Math.round(barHeight / 2)}px;
  background-color: ${({ color: color2 }) => getColor$2(color2 ?? "neutral-200")};
  ${({ animated }) => animated && "transition: width 0.25s"}
`, ProgressBar = React__default.forwardRef(
  ({
    progress: progress2,
    disabled,
    height: height2 = 2,
    animated = !1,
    color: color2 = "success-300",
    ...rest
  }, ref) => /* @__PURE__ */ jsx(ThemeProvider, { children: /* @__PURE__ */ jsxs(
    Box,
    {
      ...rest,
      ref,
      position: "relative",
      "data-test": "progress-bar",
      borderRadius: height2 / 2,
      h: `${height2}px`,
      overflow: "hidden",
      children: [
        /* @__PURE__ */ jsx(Bar, { animated: !1, barHeight: height2 }),
        /* @__PURE__ */ jsx(
          Bar,
          {
            progress: progress2,
            color: disabled ? "neutral-400" : color2,
            "data-test": "progress-bar-gauge",
            animated,
            barHeight: height2
          }
        )
      ]
    }
  ) })
);
var PROGRESS_ACTION_TYPE = /* @__PURE__ */ ((PROGRESS_ACTION_TYPE2) => (PROGRESS_ACTION_TYPE2.INCREASE = "INCREASE", PROGRESS_ACTION_TYPE2.UPDATE = "UPDATE", PROGRESS_ACTION_TYPE2))(PROGRESS_ACTION_TYPE || {});
const PROGRESS_INCREASE_INTERVAL = 500;
function progressReducer(progress2, action) {
  const { type, value } = action;
  switch (type) {
    case PROGRESS_ACTION_TYPE.INCREASE: {
      const { capping, maxCapping, actualProgress } = action, newProgress = Math.min(progress2 + value, actualProgress + capping);
      return Math.min(newProgress, maxCapping);
    }
    case PROGRESS_ACTION_TYPE.UPDATE:
      return progress2 > value ? progress2 : value;
    default:
      return progress2;
  }
}
__name(progressReducer, "progressReducer");
function OptimisticProgressBar({
  speed,
  capping,
  maxCapping,
  progress: actualProgress,
  ...rest
}) {
  const [optimisticProgress, dispatch] = useReducer(
    progressReducer,
    actualProgress
  ), lastUpdate = useRef(Date.now());
  return useEffect(() => {
    const interval = setInterval(() => {
      const now2 = Date.now(), elapsedTime = (now2 - lastUpdate.current) / 1e3;
      dispatch({
        type: PROGRESS_ACTION_TYPE.INCREASE,
        value: elapsedTime * speed,
        actualProgress,
        capping,
        maxCapping
      }), lastUpdate.current = now2;
    }, PROGRESS_INCREASE_INTERVAL);
    return dispatch({ type: PROGRESS_ACTION_TYPE.UPDATE, value: actualProgress }), () => clearInterval(interval);
  }, [actualProgress, dispatch, capping, speed, maxCapping]), /* @__PURE__ */ jsx(
    ProgressBar,
    {
      w: "100%",
      progress: Math.round(optimisticProgress),
      animated: !0,
      ...rest
    }
  );
}
__name(OptimisticProgressBar, "OptimisticProgressBar");
const Overlay = /* @__PURE__ */ __name(({
  portalRootElement = "portal-root",
  children
}) => {
  const overlayRef = useRef(document.createElement("div"));
  return useEffect(() => {
    const portalContainer = document.getElementById(portalRootElement), { current: overlayEle } = overlayRef;
    return portalContainer == null || portalContainer.appendChild(overlayEle), () => {
      portalContainer == null || portalContainer.removeChild(overlayEle);
    };
  }, [portalRootElement]), createPortal(children, overlayRef.current);
}, "Overlay"), Tab = {
  Container: TabContainer,
  Content: TabContent,
  Menu: styled(TabMenu).attrs(() => ({
    space: "s",
    variant: "auto"
  }))`
    padding-right: ${getSpace$1("l")};
    padding-left: ${getSpace$1("l")};
  `,
  MenuItem: styled(TabMenuItem)`
    height: 100%;
    opacity: ${({ active = !0 }) => active ? 1 : 0.4};
    font-size: ${({ theme }) => theme.typography.bodySemiboldM.fontSize};
    padding: ${getSpace$1("xxs")} 0 ${getSpace$1("s")};
    margin: 0 ${getSpace$1("xxs")};
  `,
  Item: styled(TabItem)`
    padding: ${getSpace$1("xl")};
  `,
  BaseTabItem: styled(TabItem)`
    padding: 0;
  `
}, PageHeaderContainer = styled(Box)`
  border-bottom: 1px solid ${getColor$2("graphic-default")};
`;
function PageHeaderLink({ children, to, ...linkProps }) {
  return /* @__PURE__ */ jsx(Link$1, { to, ...linkProps, children: /* @__PURE__ */ jsxs(Button$1, { mode: "ghost", size: "xSmall", variant: "secondary", children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        component: ChevronLeftOutlined,
        size: 16,
        color: "text-interactive-secondary"
      }
    ),
    /* @__PURE__ */ jsx(Typography, { color: "text-interactive-secondary", variant: "bodySemiboldM", children })
  ] }) });
}
__name(PageHeaderLink, "PageHeaderLink");
const PageHeaderLinkStyled = styled(PageHeaderLink)`
  display: block;
  width: max-content;
  margin-bottom: ${getSpace$1("xxs")};
`;
function PageHeader({
  largeTitle,
  title,
  subtitle,
  "data-test": dataTest = "page-header",
  icon,
  avatarSrc,
  avatarInitials = "",
  children,
  activeTabId = "1",
  gobackLinkRoute,
  gobackLinkText,
  onTabChange = noop$5,
  renderAvatar,
  renderExtra,
  renderSubLeft,
  renderSubRight,
  renderTitleRight,
  titleProps,
  className
}) {
  const hasLargeTitle = !!largeTitle, hasAvatar = !!(avatarSrc || avatarInitials), hasGoBackLink = !!(gobackLinkRoute && gobackLinkText), childrenArray = React__default.Children.toArray(children), [tabMenu, tabContent, otherContent] = childrenArray.reduce(
    (acc, curr) => {
      switch (curr.type) {
        case Tab.Menu:
          acc[0].push(curr);
          break;
        case Tab.Content:
          acc[1].push(curr);
          break;
        default:
          acc[2].push(curr);
          break;
      }
      return acc;
    },
    [[], [], []]
  ), hasTabs = !!tabMenu.length, content2 = /* @__PURE__ */ jsxs(
    PageHeaderContainer,
    {
      backgroundColor: "neutral-0",
      w: "100%",
      "data-test": dataTest,
      hasTabs,
      className,
      children: [
        /* @__PURE__ */ jsxs(Box, { pl: "xl", pr: "s", pt: "xs", pb: "xs", children: [
          hasGoBackLink && /* @__PURE__ */ jsx(
            PageHeaderLinkStyled,
            {
              "data-test": `${dataTest}-link`,
              to: gobackLinkRoute,
              children: gobackLinkText
            }
          ),
          /* @__PURE__ */ jsxs(Flex, { alignItems: "center", fluid: !0, ...titleProps, children: [
            /* @__PURE__ */ jsxs(Spacer, { alignItems: "center", space: "s", children: [
              renderAvatar == null ? void 0 : renderAvatar(),
              !!icon && /* @__PURE__ */ jsx(Icon, { "data-test": "page-header-icon", component: icon, size: "l" }),
              hasAvatar && /* @__PURE__ */ jsx(
                Avatar,
                {
                  "data-test": "page-header-avatar",
                  src: avatarSrc,
                  initials: avatarInitials,
                  size: "regular"
                }
              ),
              /* @__PURE__ */ jsxs(Spacer, { direction: "vertical", children: [
                hasLargeTitle && /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "headingBoldM",
                    fontWeight: 700,
                    color: "neutral-1000",
                    "data-test": `${dataTest}-large-title`,
                    children: largeTitle
                  }
                ),
                !!title && /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "headingBoldS",
                    color: "neutral-1000",
                    "data-test": `${dataTest}-title`,
                    children: title
                  }
                ),
                !!(renderSubLeft || subtitle || renderSubRight) && /* @__PURE__ */ jsxs(Flex, { gap: "xxs", alignItems: "center", children: [
                  renderSubLeft == null ? void 0 : renderSubLeft(),
                  !!subtitle && /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "bodyRegularS",
                      color: "secondary-600",
                      "data-test": `${dataTest}-subtitle`,
                      children: subtitle
                    }
                  ),
                  renderSubRight == null ? void 0 : renderSubRight()
                ] })
              ] })
            ] }),
            renderTitleRight == null ? void 0 : renderTitleRight()
          ] }),
          renderExtra == null ? void 0 : renderExtra()
        ] }),
        hasTabs && /* @__PURE__ */ jsx(Box, { children: tabMenu })
      ]
    }
  );
  return hasTabs ? /* @__PURE__ */ jsxs(Tab.Container, { activeTabId, onChange: onTabChange, children: [
    content2,
    otherContent,
    tabContent
  ] }) : content2;
}
__name(PageHeader, "PageHeader");
function getPercentageTagVariant(value, thresholds, colors2) {
  return value === 0 ? colors2.zero : value >= Math.max(...thresholds) ? colors2.good : value >= Math.min(...thresholds) ? colors2.medium : colors2.bad;
}
__name(getPercentageTagVariant, "getPercentageTagVariant");
const StyledTag = styled(Tag)`
  padding-left: ${getSpace$1("xs")};
  padding-right: ${getSpace$1("xs")};
`;
function PercentageTag({
  value,
  thresholds,
  "data-test": dataTest = "percentage-tag",
  size = "large",
  disabled,
  colors: colorsOverride,
  ...tagProps
}) {
  const colors2 = {
    zero: "darkSecondary",
    bad: "red",
    medium: "yellow",
    good: "green",
    ...colorsOverride
  }, variant = disabled ? "grey" : getPercentageTagVariant(value, thresholds, colors2);
  return /* @__PURE__ */ jsx(
    StyledTag,
    {
      ...tagProps,
      variant,
      size,
      "data-test": dataTest,
      disabled,
      children: /* @__PURE__ */ jsxs(Typography, { variant: "bodyMediumS", children: [
        value,
        "%"
      ] })
    }
  );
}
__name(PercentageTag, "PercentageTag");
const Container = styled(Flex)`
  border: 1px solid ${getColor$2("neutral-200")};
  border-radius: 8px;
  background: white;

  :focus-within {
    border: 1px solid ${getColor$2("neutral-300")};
  }

  > div {
    border: none;
  }

  input {
    border: none;
    padding-left: 0px;
  }

  div:has(> input) {
    padding-left: 0;
  }
`;
function PhoneInput({
  defaultCountryPrefix = "FR",
  onChange: onChange5,
  value,
  ...inputProps
}) {
  const createInitialNumber = /* @__PURE__ */ __name(() => {
    let number22 = "";
    if (!value)
      return number22;
    try {
      const parsedPhoneNumber = parsePhoneNumberWithError(value), country = parsedPhoneNumber.country;
      number22 = new AsYouType(country).input(parsedPhoneNumber.nationalNumber);
    } catch {
    }
    return number22;
  }, "createInitialNumber"), createInitialCountry = /* @__PURE__ */ __name(() => {
    let countryPrefix2 = defaultCountryPrefix;
    if (!value)
      return countryPrefix2;
    try {
      const country = parsePhoneNumberWithError(value).country;
      country && (countryPrefix2 = country);
    } catch {
    }
    return countryPrefix2;
  }, "createInitialCountry"), [countryPrefix, setCountryPrefix] = useState(createInitialCountry), [number2, setNumber] = useState(createInitialNumber), handleSelectCountryPrefix = useCallback((values) => {
    const newCountryPrefix = values[0];
    setCountryPrefix(newCountryPrefix);
  }, []), handleChange = useCallback(
    (e3) => {
      const rawValue = e3.target.value;
      setNumber(rawValue);
      try {
        const parsedPhoneNumber = parsePhoneNumberWithError(
          rawValue,
          countryPrefix
        );
        rawValue.startsWith("+") && parsedPhoneNumber.country && setCountryPrefix(parsedPhoneNumber.country), onChange5(parsedPhoneNumber.number);
      } catch {
      }
    },
    [countryPrefix, onChange5]
  );
  return /* @__PURE__ */ jsxs(Container, { children: [
    /* @__PURE__ */ jsx(
      CountryPrefixSearchSelect,
      {
        "data-test": "phone-input-country-prefix",
        w: "140px",
        selectedKeys: [countryPrefix],
        onSelect: handleSelectCountryPrefix,
        showCountryName: !1
      }
    ),
    /* @__PURE__ */ jsx(
      TextInput,
      {
        "data-test": "phone-input-text-input",
        value: number2,
        onChange: handleChange,
        ...inputProps
      }
    )
  ] });
}
__name(PhoneInput, "PhoneInput");
function r(e3) {
  var t3, f, n = "";
  if (typeof e3 == "string" || typeof e3 == "number")
    n += e3;
  else if (typeof e3 == "object")
    if (Array.isArray(e3)) {
      var o = e3.length;
      for (t3 = 0; t3 < o; t3++)
        e3[t3] && (f = r(e3[t3])) && (n && (n += " "), n += f);
    } else
      for (f in e3)
        e3[f] && (n && (n += " "), n += f);
  return n;
}
__name(r, "r");
function clsx() {
  for (var e3, t3, f = 0, n = "", o = arguments.length; f < o; f++)
    (e3 = arguments[f]) && (t3 = r(e3)) && (n && (n += " "), n += t3);
  return n;
}
__name(clsx, "clsx");
var isArray$f = Array.isArray, isArray_1 = isArray$f, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$9 = freeGlobal || freeSelf || Function("return this")(), _root = root$9, root$8 = _root, Symbol$7 = root$8.Symbol, _Symbol = Symbol$7, Symbol$6 = _Symbol, objectProto$c = Object.prototype, hasOwnProperty$a = objectProto$c.hasOwnProperty, nativeObjectToString$1 = objectProto$c.toString, symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = !0;
  } catch {
  }
  var result2 = nativeObjectToString$1.call(value);
  return unmasked && (isOwn ? value[symToStringTag$1] = tag : delete value[symToStringTag$1]), result2;
}
__name(getRawTag$1, "getRawTag$1");
var _getRawTag = getRawTag$1, objectProto$b = Object.prototype, nativeObjectToString = objectProto$b.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
__name(objectToString$1, "objectToString$1");
var _objectToString = objectToString$1, Symbol$5 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$5 ? Symbol$5.toStringTag : void 0;
function baseGetTag$9(value) {
  return value == null ? value === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
__name(baseGetTag$9, "baseGetTag$9");
var _baseGetTag = baseGetTag$9;
function isObjectLike$9(value) {
  return value != null && typeof value == "object";
}
__name(isObjectLike$9, "isObjectLike$9");
var isObjectLike_1 = isObjectLike$9, baseGetTag$8 = _baseGetTag, isObjectLike$8 = isObjectLike_1, symbolTag$1 = "[object Symbol]";
function isSymbol$6(value) {
  return typeof value == "symbol" || isObjectLike$8(value) && baseGetTag$8(value) == symbolTag$1;
}
__name(isSymbol$6, "isSymbol$6");
var isSymbol_1 = isSymbol$6, isArray$e = isArray_1, isSymbol$5 = isSymbol_1, reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object2) {
  if (isArray$e(value))
    return !1;
  var type = typeof value;
  return type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$5(value) ? !0 : reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
}
__name(isKey$3, "isKey$3");
var _isKey = isKey$3;
function isObject$7(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
__name(isObject$7, "isObject$7");
var isObject_1 = isObject$7;
const isObject$8 = /* @__PURE__ */ getDefaultExportFromCjs(isObject_1);
var baseGetTag$7 = _baseGetTag, isObject$6 = isObject_1, asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$6(value))
    return !1;
  var tag = baseGetTag$7(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
__name(isFunction$2, "isFunction$2");
var isFunction_1 = isFunction$2;
const isFunction$3 = /* @__PURE__ */ getDefaultExportFromCjs(isFunction_1);
var root$7 = _root, coreJsData$1 = root$7["__core-js_shared__"], _coreJsData = coreJsData$1, coreJsData = _coreJsData, maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func2) {
  return !!maskSrcKey && maskSrcKey in func2;
}
__name(isMasked$1, "isMasked$1");
var _isMasked = isMasked$1, funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
function toSource$2(func2) {
  if (func2 != null) {
    try {
      return funcToString$2.call(func2);
    } catch {
    }
    try {
      return func2 + "";
    } catch {
    }
  }
  return "";
}
__name(toSource$2, "toSource$2");
var _toSource = toSource$2, isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$5 = isObject_1, toSource$1 = _toSource, reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$a = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$9 = objectProto$a.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$9).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$5(value) || isMasked(value))
    return !1;
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
__name(baseIsNative$1, "baseIsNative$1");
var _baseIsNative = baseIsNative$1;
function getValue$1(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
__name(getValue$1, "getValue$1");
var _getValue = getValue$1, baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(object2, key) {
  var value = getValue(object2, key);
  return baseIsNative(value) ? value : void 0;
}
__name(getNative$7, "getNative$7");
var _getNative = getNative$7, getNative$6 = _getNative, nativeCreate$4 = getNative$6(Object, "create"), _nativeCreate = nativeCreate$4, nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
}
__name(hashClear$1, "hashClear$1");
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result2 = this.has(key) && delete this.__data__[key];
  return this.size -= result2 ? 1 : 0, result2;
}
__name(hashDelete$1, "hashDelete$1");
var _hashDelete = hashDelete$1, nativeCreate$2 = _nativeCreate, HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$9 = Object.prototype, hasOwnProperty$8 = objectProto$9.hasOwnProperty;
function hashGet$1(key) {
  var data2 = this.__data__;
  if (nativeCreate$2) {
    var result2 = data2[key];
    return result2 === HASH_UNDEFINED$2 ? void 0 : result2;
  }
  return hasOwnProperty$8.call(data2, key) ? data2[key] : void 0;
}
__name(hashGet$1, "hashGet$1");
var _hashGet = hashGet$1, nativeCreate$1 = _nativeCreate, objectProto$8 = Object.prototype, hasOwnProperty$7 = objectProto$8.hasOwnProperty;
function hashHas$1(key) {
  var data2 = this.__data__;
  return nativeCreate$1 ? data2[key] !== void 0 : hasOwnProperty$7.call(data2, key);
}
__name(hashHas$1, "hashHas$1");
var _hashHas = hashHas$1, nativeCreate = _nativeCreate, HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data2 = this.__data__;
  return this.size += this.has(key) ? 0 : 1, data2[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value, this;
}
__name(hashSet$1, "hashSet$1");
var _hashSet = hashSet$1, hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index2 < length; ) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
__name(Hash$1, "Hash$1");
Hash$1.prototype.clear = hashClear;
Hash$1.prototype.delete = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}
__name(listCacheClear$1, "listCacheClear$1");
var _listCacheClear = listCacheClear$1;
function eq$3(value, other) {
  return value === other || value !== value && other !== other;
}
__name(eq$3, "eq$3");
var eq_1 = eq$3, eq$2 = eq_1;
function assocIndexOf$4(array2, key) {
  for (var length = array2.length; length--; )
    if (eq$2(array2[length][0], key))
      return length;
  return -1;
}
__name(assocIndexOf$4, "assocIndexOf$4");
var _assocIndexOf = assocIndexOf$4, assocIndexOf$3 = _assocIndexOf, arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data2 = this.__data__, index2 = assocIndexOf$3(data2, key);
  if (index2 < 0)
    return !1;
  var lastIndex = data2.length - 1;
  return index2 == lastIndex ? data2.pop() : splice.call(data2, index2, 1), --this.size, !0;
}
__name(listCacheDelete$1, "listCacheDelete$1");
var _listCacheDelete = listCacheDelete$1, assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data2 = this.__data__, index2 = assocIndexOf$2(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
__name(listCacheGet$1, "listCacheGet$1");
var _listCacheGet = listCacheGet$1, assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
__name(listCacheHas$1, "listCacheHas$1");
var _listCacheHas = listCacheHas$1, assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  return index2 < 0 ? (++this.size, data2.push([key, value])) : data2[index2][1] = value, this;
}
__name(listCacheSet$1, "listCacheSet$1");
var _listCacheSet = listCacheSet$1, listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index2 < length; ) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
__name(ListCache$4, "ListCache$4");
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype.delete = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4, getNative$5 = _getNative, root$6 = _root, Map$4 = getNative$5(root$6, "Map"), _Map = Map$4, Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$3 || ListCache$3)(),
    string: new Hash()
  };
}
__name(mapCacheClear$1, "mapCacheClear$1");
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
__name(isKeyable$1, "isKeyable$1");
var _isKeyable = isKeyable$1, isKeyable = _isKeyable;
function getMapData$4(map2, key) {
  var data2 = map2.__data__;
  return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
__name(getMapData$4, "getMapData$4");
var _getMapData = getMapData$4, getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result2 = getMapData$3(this, key).delete(key);
  return this.size -= result2 ? 1 : 0, result2;
}
__name(mapCacheDelete$1, "mapCacheDelete$1");
var _mapCacheDelete = mapCacheDelete$1, getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
__name(mapCacheGet$1, "mapCacheGet$1");
var _mapCacheGet = mapCacheGet$1, getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
__name(mapCacheHas$1, "mapCacheHas$1");
var _mapCacheHas = mapCacheHas$1, getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data2 = getMapData(this, key), size = data2.size;
  return data2.set(key, value), this.size += data2.size == size ? 0 : 1, this;
}
__name(mapCacheSet$1, "mapCacheSet$1");
var _mapCacheSet = mapCacheSet$1, mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index2 < length; ) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
__name(MapCache$3, "MapCache$3");
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype.delete = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3, MapCache$2 = _MapCache, FUNC_ERROR_TEXT$2 = "Expected a function";
function memoize$2(func2, resolver2) {
  if (typeof func2 != "function" || resolver2 != null && typeof resolver2 != "function")
    throw new TypeError(FUNC_ERROR_TEXT$2);
  var memoized = /* @__PURE__ */ __name(function() {
    var args = arguments, key = resolver2 ? resolver2.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key))
      return cache2.get(key);
    var result2 = func2.apply(this, args);
    return memoized.cache = cache2.set(key, result2) || cache2, result2;
  }, "memoized");
  return memoized.cache = new (memoize$2.Cache || MapCache$2)(), memoized;
}
__name(memoize$2, "memoize$2");
memoize$2.Cache = MapCache$2;
var memoize_1 = memoize$2;
const memoize$3 = /* @__PURE__ */ getDefaultExportFromCjs(memoize_1);
var memoize$1 = memoize_1, MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func2) {
  var result2 = memoize$1(func2, function(key) {
    return cache2.size === MAX_MEMOIZE_SIZE && cache2.clear(), key;
  }), cache2 = result2.cache;
  return result2;
}
__name(memoizeCapped$1, "memoizeCapped$1");
var _memoizeCapped = memoizeCapped$1, memoizeCapped = _memoizeCapped, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath$1 = memoizeCapped(function(string2) {
  var result2 = [];
  return string2.charCodeAt(0) === 46 && result2.push(""), string2.replace(rePropName, function(match2, number2, quote, subString) {
    result2.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match2);
  }), result2;
}), _stringToPath = stringToPath$1;
function arrayMap$3(array2, iteratee) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length, result2 = Array(length); ++index2 < length; )
    result2[index2] = iteratee(array2[index2], index2, array2);
  return result2;
}
__name(arrayMap$3, "arrayMap$3");
var _arrayMap = arrayMap$3, Symbol$4 = _Symbol, arrayMap$2 = _arrayMap, isArray$d = isArray_1, isSymbol$4 = isSymbol_1, INFINITY$3 = 1 / 0, symbolProto$1 = Symbol$4 ? Symbol$4.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string")
    return value;
  if (isArray$d(value))
    return arrayMap$2(value, baseToString$1) + "";
  if (isSymbol$4(value))
    return symbolToString ? symbolToString.call(value) : "";
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY$3 ? "-0" : result2;
}
__name(baseToString$1, "baseToString$1");
var _baseToString = baseToString$1, baseToString = _baseToString;
function toString$3(value) {
  return value == null ? "" : baseToString(value);
}
__name(toString$3, "toString$3");
var toString_1 = toString$3, isArray$c = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString$2 = toString_1;
function castPath$2(value, object2) {
  return isArray$c(value) ? value : isKey$2(value, object2) ? [value] : stringToPath(toString$2(value));
}
__name(castPath$2, "castPath$2");
var _castPath = castPath$2, isSymbol$3 = isSymbol_1, INFINITY$2 = 1 / 0;
function toKey$4(value) {
  if (typeof value == "string" || isSymbol$3(value))
    return value;
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY$2 ? "-0" : result2;
}
__name(toKey$4, "toKey$4");
var _toKey = toKey$4, castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$3(object2, path) {
  path = castPath$1(path, object2);
  for (var index2 = 0, length = path.length; object2 != null && index2 < length; )
    object2 = object2[toKey$3(path[index2++])];
  return index2 && index2 == length ? object2 : void 0;
}
__name(baseGet$3, "baseGet$3");
var _baseGet = baseGet$3, baseGet$2 = _baseGet;
function get$1(object2, path, defaultValue) {
  var result2 = object2 == null ? void 0 : baseGet$2(object2, path);
  return result2 === void 0 ? defaultValue : result2;
}
__name(get$1, "get$1");
var get_1 = get$1;
const get$2 = /* @__PURE__ */ getDefaultExportFromCjs(get_1);
function isNil(value) {
  return value == null;
}
__name(isNil, "isNil");
var isNil_1 = isNil;
const isNil$1 = /* @__PURE__ */ getDefaultExportFromCjs(isNil_1);
var baseGetTag$6 = _baseGetTag, isArray$b = isArray_1, isObjectLike$7 = isObjectLike_1, stringTag$2 = "[object String]";
function isString(value) {
  return typeof value == "string" || !isArray$b(value) && isObjectLike$7(value) && baseGetTag$6(value) == stringTag$2;
}
__name(isString, "isString");
var isString_1 = isString;
const isString$1 = /* @__PURE__ */ getDefaultExportFromCjs(isString_1);
var reactIsExports = requireReactIs(), baseGetTag$5 = _baseGetTag, isObjectLike$6 = isObjectLike_1, numberTag$2 = "[object Number]";
function isNumber$2(value) {
  return typeof value == "number" || isObjectLike$6(value) && baseGetTag$5(value) == numberTag$2;
}
__name(isNumber$2, "isNumber$2");
var isNumber_1 = isNumber$2;
const isNumber$3 = /* @__PURE__ */ getDefaultExportFromCjs(isNumber_1);
var isNumber$1 = isNumber_1;
function isNaN$1(value) {
  return isNumber$1(value) && value != +value;
}
__name(isNaN$1, "isNaN$1");
var _isNaN = isNaN$1;
const isNan = /* @__PURE__ */ getDefaultExportFromCjs(_isNaN);
var mathSign = /* @__PURE__ */ __name(function(value) {
  return value === 0 ? 0 : value > 0 ? 1 : -1;
}, "mathSign"), isPercent = /* @__PURE__ */ __name(function(value) {
  return isString$1(value) && value.indexOf("%") === value.length - 1;
}, "isPercent"), isNumber = /* @__PURE__ */ __name(function(value) {
  return isNumber$3(value) && !isNan(value);
}, "isNumber"), isNumOrStr = /* @__PURE__ */ __name(function(value) {
  return isNumber(value) || isString$1(value);
}, "isNumOrStr"), idCounter = 0, uniqueId = /* @__PURE__ */ __name(function(prefix2) {
  var id2 = ++idCounter;
  return "".concat(prefix2 || "").concat(id2);
}, "uniqueId"), getPercentValue = /* @__PURE__ */ __name(function(percent2, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, validate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!isNumber(percent2) && !isString$1(percent2))
    return defaultValue;
  var value;
  if (isPercent(percent2)) {
    var index2 = percent2.indexOf("%");
    value = totalValue * parseFloat(percent2.slice(0, index2)) / 100;
  } else
    value = +percent2;
  return isNan(value) && (value = defaultValue), validate && value > totalValue && (value = totalValue), value;
}, "getPercentValue"), getAnyElementOfObject = /* @__PURE__ */ __name(function(obj2) {
  if (!obj2)
    return null;
  var keys2 = Object.keys(obj2);
  return keys2 && keys2.length ? obj2[keys2[0]] : null;
}, "getAnyElementOfObject"), hasDuplicate = /* @__PURE__ */ __name(function(ary) {
  if (!Array.isArray(ary))
    return !1;
  for (var len = ary.length, cache2 = {}, i2 = 0; i2 < len; i2++)
    if (!cache2[ary[i2]])
      cache2[ary[i2]] = !0;
    else
      return !0;
  return !1;
}, "hasDuplicate"), interpolateNumber$2 = /* @__PURE__ */ __name(function(numberA, numberB) {
  return isNumber(numberA) && isNumber(numberB) ? function(t3) {
    return numberA + t3 * (numberB - numberA);
  } : function() {
    return numberB;
  };
}, "interpolateNumber");
function findEntryInArray(ary, specifiedKey, specifiedValue) {
  return !ary || !ary.length ? null : ary.find(function(entry) {
    return entry && (typeof specifiedKey == "function" ? specifiedKey(entry) : get$2(entry, specifiedKey)) === specifiedValue;
  });
}
__name(findEntryInArray, "findEntryInArray");
function shallowEqual(a4, b2) {
  for (var key in a4)
    if ({}.hasOwnProperty.call(a4, key) && (!{}.hasOwnProperty.call(b2, key) || a4[key] !== b2[key]))
      return !1;
  for (var _key in b2)
    if ({}.hasOwnProperty.call(b2, _key) && !{}.hasOwnProperty.call(a4, _key))
      return !1;
  return !0;
}
__name(shallowEqual, "shallowEqual");
function _typeof$C(o) {
  "@babel/helpers - typeof";
  return _typeof$C = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$C(o);
}
__name(_typeof$C, "_typeof$C");
var SVGContainerPropKeys = ["viewBox", "children"], SVGElementPropKeys = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], PolyElementKeys = ["points", "pathLength"], FilteredElementKeyMap = {
  svg: SVGContainerPropKeys,
  polygon: PolyElementKeys,
  polyline: PolyElementKeys
}, EventKeys = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], adaptEventHandlers = /* @__PURE__ */ __name(function(props, newHandler) {
  if (!props || typeof props == "function" || typeof props == "boolean")
    return null;
  var inputProps = props;
  if (/* @__PURE__ */ isValidElement(props) && (inputProps = props.props), !isObject$8(inputProps))
    return null;
  var out = {};
  return Object.keys(inputProps).forEach(function(key) {
    EventKeys.includes(key) && (out[key] = newHandler || function(e3) {
      return inputProps[key](inputProps, e3);
    });
  }), out;
}, "adaptEventHandlers"), getEventHandlerOfChild = /* @__PURE__ */ __name(function(originalHandler, data2, index2) {
  return function(e3) {
    return originalHandler(data2, index2, e3), null;
  };
}, "getEventHandlerOfChild"), adaptEventsOfChild = /* @__PURE__ */ __name(function(props, data2, index2) {
  if (!isObject$8(props) || _typeof$C(props) !== "object")
    return null;
  var out = null;
  return Object.keys(props).forEach(function(key) {
    var item = props[key];
    EventKeys.includes(key) && typeof item == "function" && (out || (out = {}), out[key] = getEventHandlerOfChild(item, data2, index2));
  }), out;
}, "adaptEventsOfChild"), _excluded$e = ["children"], _excluded2$4 = ["children"];
function _objectWithoutProperties$e(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$e(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$e, "_objectWithoutProperties$e");
function _objectWithoutPropertiesLoose$e(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$e, "_objectWithoutPropertiesLoose$e");
var REACT_BROWSER_EVENT_MAP = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart"
}, getDisplayName = /* @__PURE__ */ __name(function(Comp) {
  return typeof Comp == "string" ? Comp : Comp ? Comp.displayName || Comp.name || "Component" : "";
}, "getDisplayName"), lastChildren = null, lastResult = null, toArray = /* @__PURE__ */ __name(function toArray2(children) {
  if (children === lastChildren && Array.isArray(lastResult))
    return lastResult;
  var result2 = [];
  return Children.forEach(children, function(child) {
    isNil$1(child) || (reactIsExports.isFragment(child) ? result2 = result2.concat(toArray2(child.props.children)) : result2.push(child));
  }), lastResult = result2, lastChildren = children, result2;
}, "toArray");
function findAllByType(children, type) {
  var result2 = [], types2 = [];
  return Array.isArray(type) ? types2 = type.map(function(t3) {
    return getDisplayName(t3);
  }) : types2 = [getDisplayName(type)], toArray(children).forEach(function(child) {
    var childType = get$2(child, "type.displayName") || get$2(child, "type.name");
    types2.indexOf(childType) !== -1 && result2.push(child);
  }), result2;
}
__name(findAllByType, "findAllByType");
function findChildByType(children, type) {
  var result2 = findAllByType(children, type);
  return result2 && result2[0];
}
__name(findChildByType, "findChildByType");
var validateWidthHeight = /* @__PURE__ */ __name(function(el) {
  if (!el || !el.props)
    return !1;
  var _el$props = el.props, width2 = _el$props.width, height2 = _el$props.height;
  return !(!isNumber(width2) || width2 <= 0 || !isNumber(height2) || height2 <= 0);
}, "validateWidthHeight"), SVG_TAGS = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], isSvgElement = /* @__PURE__ */ __name(function(child) {
  return child && child.type && isString$1(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
}, "isSvgElement"), isValidSpreadableProp = /* @__PURE__ */ __name(function(property2, key, includeEvents, svgElementType) {
  var _FilteredElementKeyMa, matchingElementTypeKeys = (_FilteredElementKeyMa = FilteredElementKeyMap == null ? void 0 : FilteredElementKeyMap[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
  return !isFunction$3(property2) && (svgElementType && matchingElementTypeKeys.includes(key) || SVGElementPropKeys.includes(key)) || includeEvents && EventKeys.includes(key);
}, "isValidSpreadableProp"), filterProps = /* @__PURE__ */ __name(function(props, includeEvents, svgElementType) {
  if (!props || typeof props == "function" || typeof props == "boolean")
    return null;
  var inputProps = props;
  if (/* @__PURE__ */ isValidElement(props) && (inputProps = props.props), !isObject$8(inputProps))
    return null;
  var out = {};
  return Object.keys(inputProps).forEach(function(key) {
    var _inputProps;
    isValidSpreadableProp((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType) && (out[key] = inputProps[key]);
  }), out;
}, "filterProps"), isChildrenEqual = /* @__PURE__ */ __name(function isChildrenEqual2(nextChildren, prevChildren) {
  if (nextChildren === prevChildren)
    return !0;
  var count = Children.count(nextChildren);
  if (count !== Children.count(prevChildren))
    return !1;
  if (count === 0)
    return !0;
  if (count === 1)
    return isSingleChildEqual(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
  for (var i2 = 0; i2 < count; i2++) {
    var nextChild = nextChildren[i2], prevChild = prevChildren[i2];
    if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
      if (!isChildrenEqual2(nextChild, prevChild))
        return !1;
    } else if (!isSingleChildEqual(nextChild, prevChild))
      return !1;
  }
  return !0;
}, "isChildrenEqual"), isSingleChildEqual = /* @__PURE__ */ __name(function(nextChild, prevChild) {
  if (isNil$1(nextChild) && isNil$1(prevChild))
    return !0;
  if (!isNil$1(nextChild) && !isNil$1(prevChild)) {
    var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = _objectWithoutProperties$e(_ref, _excluded$e), _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = _objectWithoutProperties$e(_ref2, _excluded2$4);
    return nextChildren && prevChildren ? shallowEqual(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren) : !nextChildren && !prevChildren ? shallowEqual(nextProps, prevProps) : !1;
  }
  return !1;
}, "isSingleChildEqual"), renderByOrder = /* @__PURE__ */ __name(function(children, renderMap) {
  var elements = [], record2 = {};
  return toArray(children).forEach(function(child, index2) {
    if (isSvgElement(child))
      elements.push(child);
    else if (child) {
      var displayName = getDisplayName(child.type), _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
      if (handler && (!once || !record2[displayName])) {
        var results = handler(child, displayName, index2);
        elements.push(results), record2[displayName] = !0;
      }
    }
  }), elements;
}, "renderByOrder"), getReactEventByType = /* @__PURE__ */ __name(function(e3) {
  var type = e3 && e3.type;
  return type && REACT_BROWSER_EVENT_MAP[type] ? REACT_BROWSER_EVENT_MAP[type] : null;
}, "getReactEventByType"), parseChildIndex = /* @__PURE__ */ __name(function(child, children) {
  return toArray(children).indexOf(child);
}, "parseChildIndex"), _excluded$d = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function _extends$n() {
  return _extends$n = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$n.apply(this, arguments);
}
__name(_extends$n, "_extends$n");
function _objectWithoutProperties$d(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$d(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$d, "_objectWithoutProperties$d");
function _objectWithoutPropertiesLoose$d(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$d, "_objectWithoutPropertiesLoose$d");
function Surface(props) {
  var children = props.children, width2 = props.width, height2 = props.height, viewBox = props.viewBox, className = props.className, style2 = props.style, title = props.title, desc = props.desc, others = _objectWithoutProperties$d(props, _excluded$d), svgView = viewBox || {
    width: width2,
    height: height2,
    x: 0,
    y: 0
  }, layerClass = clsx("recharts-surface", className);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$n({}, filterProps(others, !0, "svg"), {
    className: layerClass,
    width: width2,
    height: height2,
    style: style2,
    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
  }), /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("desc", null, desc), children);
}
__name(Surface, "Surface");
var _excluded$c = ["children", "className"];
function _extends$m() {
  return _extends$m = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$m.apply(this, arguments);
}
__name(_extends$m, "_extends$m");
function _objectWithoutProperties$c(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$c(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$c, "_objectWithoutProperties$c");
function _objectWithoutPropertiesLoose$c(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$c, "_objectWithoutPropertiesLoose$c");
var Layer = /* @__PURE__ */ React__default.forwardRef(function(props, ref) {
  var children = props.children, className = props.className, others = _objectWithoutProperties$c(props, _excluded$c), layerClass = clsx("recharts-layer", className);
  return /* @__PURE__ */ React__default.createElement("g", _extends$m({
    className: layerClass
  }, filterProps(others, !0), {
    ref
  }), children);
}), isDev$1 = process.env.NODE_ENV !== "production", warn$1 = /* @__PURE__ */ __name(function(condition, format2) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)
    args[_key - 2] = arguments[_key];
  if (isDev$1 && typeof console < "u" && console.warn && (format2 === void 0 && console.warn("LogUtils requires an error message argument"), !condition))
    if (format2 === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var argIndex = 0;
      console.warn(format2.replace(/%s/g, function() {
        return args[argIndex++];
      }));
    }
}, "warn");
function baseSlice$1(array2, start, end) {
  var index2 = -1, length = array2.length;
  start < 0 && (start = -start > length ? 0 : length + start), end = end > length ? length : end, end < 0 && (end += length), length = start > end ? 0 : end - start >>> 0, start >>>= 0;
  for (var result2 = Array(length); ++index2 < length; )
    result2[index2] = array2[index2 + start];
  return result2;
}
__name(baseSlice$1, "baseSlice$1");
var _baseSlice = baseSlice$1, baseSlice = _baseSlice;
function castSlice$1(array2, start, end) {
  var length = array2.length;
  return end = end === void 0 ? length : end, !start && end >= length ? array2 : baseSlice(array2, start, end);
}
__name(castSlice$1, "castSlice$1");
var _castSlice = castSlice$1, rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1, rsVarRange$1 = "\\ufe0e\\ufe0f", rsZWJ$1 = "\\u200d", reHasUnicode = RegExp("[" + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + "]");
function hasUnicode$2(string2) {
  return reHasUnicode.test(string2);
}
__name(hasUnicode$2, "hasUnicode$2");
var _hasUnicode = hasUnicode$2;
function asciiToArray$1(string2) {
  return string2.split("");
}
__name(asciiToArray$1, "asciiToArray$1");
var _asciiToArray = asciiToArray$1, rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f", rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ = "\\u200d", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")", reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
function unicodeToArray$1(string2) {
  return string2.match(reUnicode) || [];
}
__name(unicodeToArray$1, "unicodeToArray$1");
var _unicodeToArray = unicodeToArray$1, asciiToArray = _asciiToArray, hasUnicode$1 = _hasUnicode, unicodeToArray = _unicodeToArray;
function stringToArray$1(string2) {
  return hasUnicode$1(string2) ? unicodeToArray(string2) : asciiToArray(string2);
}
__name(stringToArray$1, "stringToArray$1");
var _stringToArray = stringToArray$1, castSlice = _castSlice, hasUnicode = _hasUnicode, stringToArray = _stringToArray, toString$1 = toString_1;
function createCaseFirst$1(methodName) {
  return function(string2) {
    string2 = toString$1(string2);
    var strSymbols = hasUnicode(string2) ? stringToArray(string2) : void 0, chr = strSymbols ? strSymbols[0] : string2.charAt(0), trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
    return chr[methodName]() + trailing;
  };
}
__name(createCaseFirst$1, "createCaseFirst$1");
var _createCaseFirst = createCaseFirst$1, createCaseFirst = _createCaseFirst, upperFirst = createCaseFirst("toUpperCase"), upperFirst_1 = upperFirst;
const upperFirst$1 = /* @__PURE__ */ getDefaultExportFromCjs(upperFirst_1);
function constant$3(x3) {
  return /* @__PURE__ */ __name(function() {
    return x3;
  }, "constant");
}
__name(constant$3, "constant$3");
const cos = Math.cos, sin = Math.sin, sqrt$1 = Math.sqrt, pi$1 = Math.PI, tau$1 = 2 * pi$1, pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
  this._ += strings[0];
  for (let i2 = 1, n = strings.length; i2 < n; ++i2)
    this._ += arguments[i2] + strings[i2];
}
__name(append, "append");
function appendRound(digits) {
  let d3 = Math.floor(digits);
  if (!(d3 >= 0))
    throw new Error(`invalid digits: ${digits}`);
  if (d3 > 15)
    return append;
  const k3 = 10 ** d3;
  return function(strings) {
    this._ += strings[0];
    for (let i2 = 1, n = strings.length; i2 < n; ++i2)
      this._ += Math.round(arguments[i2] * k3) / k3 + strings[i2];
  };
}
__name(appendRound, "appendRound");
const _Path = class _Path {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x3, y4) {
    this._append`M${this._x0 = this._x1 = +x3},${this._y0 = this._y1 = +y4}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(x3, y4) {
    this._append`L${this._x1 = +x3},${this._y1 = +y4}`;
  }
  quadraticCurveTo(x1, y1, x3, y4) {
    this._append`Q${+x1},${+y1},${this._x1 = +x3},${this._y1 = +y4}`;
  }
  bezierCurveTo(x1, y1, x22, y22, x3, y4) {
    this._append`C${+x1},${+y1},${+x22},${+y22},${this._x1 = +x3},${this._y1 = +y4}`;
  }
  arcTo(x1, y1, x22, y22, r2) {
    if (x1 = +x1, y1 = +y1, x22 = +x22, y22 = +y22, r2 = +r2, r2 < 0)
      throw new Error(`negative radius: ${r2}`);
    let x0 = this._x1, y0 = this._y1, x21 = x22 - x1, y21 = y22 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null)
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    else if (l01_2 > epsilon)
      if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r2)
        this._append`L${this._x1 = x1},${this._y1 = y1}`;
      else {
        let x20 = x22 - x0, y20 = y22 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r2 * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
        Math.abs(t01 - 1) > epsilon && this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`, this._append`A${r2},${r2},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
      }
  }
  arc(x3, y4, r2, a0, a1, ccw) {
    if (x3 = +x3, y4 = +y4, r2 = +r2, ccw = !!ccw, r2 < 0)
      throw new Error(`negative radius: ${r2}`);
    let dx = r2 * Math.cos(a0), dy = r2 * Math.sin(a0), x0 = x3 + dx, y0 = y4 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    this._x1 === null ? this._append`M${x0},${y0}` : (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) && this._append`L${x0},${y0}`, r2 && (da < 0 && (da = da % tau + tau), da > tauEpsilon ? this._append`A${r2},${r2},0,1,${cw},${x3 - dx},${y4 - dy}A${r2},${r2},0,1,${cw},${this._x1 = x0},${this._y1 = y0}` : da > epsilon && this._append`A${r2},${r2},0,${+(da >= pi)},${cw},${this._x1 = x3 + r2 * Math.cos(a1)},${this._y1 = y4 + r2 * Math.sin(a1)}`);
  }
  rect(x3, y4, w2, h3) {
    this._append`M${this._x0 = this._x1 = +x3},${this._y0 = this._y1 = +y4}h${w2 = +w2}v${+h3}h${-w2}Z`;
  }
  toString() {
    return this._;
  }
};
__name(_Path, "Path");
let Path = _Path;
function withPath(shape) {
  let digits = 3;
  return shape.digits = function(_) {
    if (!arguments.length)
      return digits;
    if (_ == null)
      digits = null;
    else {
      const d3 = Math.floor(_);
      if (!(d3 >= 0))
        throw new RangeError(`invalid digits: ${_}`);
      digits = d3;
    }
    return shape;
  }, () => new Path(digits);
}
__name(withPath, "withPath");
function array(x3) {
  return typeof x3 == "object" && "length" in x3 ? x3 : Array.from(x3);
}
__name(array, "array");
function Linear(context) {
  this._context = context;
}
__name(Linear, "Linear");
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    switch (x3 = +x3, y4 = +y4, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(x3, y4);
        break;
    }
  }
};
function curveLinear(context) {
  return new Linear(context);
}
__name(curveLinear, "curveLinear");
function x2(p) {
  return p[0];
}
__name(x2, "x");
function y3(p) {
  return p[1];
}
__name(y3, "y");
function shapeLine(x$12, y$1) {
  var defined3 = constant$3(!0), context = null, curve = curveLinear, output = null, path = withPath(line);
  x$12 = typeof x$12 == "function" ? x$12 : x$12 === void 0 ? x2 : constant$3(x$12), y$1 = typeof y$1 == "function" ? y$1 : y$1 === void 0 ? y3 : constant$3(y$1);
  function line(data2) {
    var i2, n = (data2 = array(data2)).length, d3, defined0 = !1, buffer;
    for (context == null && (output = curve(buffer = path())), i2 = 0; i2 <= n; ++i2)
      !(i2 < n && defined3(d3 = data2[i2], i2, data2)) === defined0 && ((defined0 = !defined0) ? output.lineStart() : output.lineEnd()), defined0 && output.point(+x$12(d3, i2, data2), +y$1(d3, i2, data2));
    if (buffer)
      return output = null, buffer + "" || null;
  }
  return __name(line, "line"), line.x = function(_) {
    return arguments.length ? (x$12 = typeof _ == "function" ? _ : constant$3(+_), line) : x$12;
  }, line.y = function(_) {
    return arguments.length ? (y$1 = typeof _ == "function" ? _ : constant$3(+_), line) : y$1;
  }, line.defined = function(_) {
    return arguments.length ? (defined3 = typeof _ == "function" ? _ : constant$3(!!_), line) : defined3;
  }, line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  }, line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  }, line;
}
__name(shapeLine, "shapeLine");
function shapeArea(x0, y0, y1) {
  var x1 = null, defined3 = constant$3(!0), context = null, curve = curveLinear, output = null, path = withPath(area);
  x0 = typeof x0 == "function" ? x0 : x0 === void 0 ? x2 : constant$3(+x0), y0 = typeof y0 == "function" ? y0 : constant$3(y0 === void 0 ? 0 : +y0), y1 = typeof y1 == "function" ? y1 : y1 === void 0 ? y3 : constant$3(+y1);
  function area(data2) {
    var i2, j, k3, n = (data2 = array(data2)).length, d3, defined0 = !1, buffer, x0z = new Array(n), y0z = new Array(n);
    for (context == null && (output = curve(buffer = path())), i2 = 0; i2 <= n; ++i2) {
      if (!(i2 < n && defined3(d3 = data2[i2], i2, data2)) === defined0)
        if (defined0 = !defined0)
          j = i2, output.areaStart(), output.lineStart();
        else {
          for (output.lineEnd(), output.lineStart(), k3 = i2 - 1; k3 >= j; --k3)
            output.point(x0z[k3], y0z[k3]);
          output.lineEnd(), output.areaEnd();
        }
      defined0 && (x0z[i2] = +x0(d3, i2, data2), y0z[i2] = +y0(d3, i2, data2), output.point(x1 ? +x1(d3, i2, data2) : x0z[i2], y1 ? +y1(d3, i2, data2) : y0z[i2]));
    }
    if (buffer)
      return output = null, buffer + "" || null;
  }
  __name(area, "area");
  function arealine() {
    return shapeLine().defined(defined3).curve(curve).context(context);
  }
  return __name(arealine, "arealine"), area.x = function(_) {
    return arguments.length ? (x0 = typeof _ == "function" ? _ : constant$3(+_), x1 = null, area) : x0;
  }, area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ == "function" ? _ : constant$3(+_), area) : x0;
  }, area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ == "function" ? _ : constant$3(+_), area) : x1;
  }, area.y = function(_) {
    return arguments.length ? (y0 = typeof _ == "function" ? _ : constant$3(+_), y1 = null, area) : y0;
  }, area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ == "function" ? _ : constant$3(+_), area) : y0;
  }, area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ == "function" ? _ : constant$3(+_), area) : y1;
  }, area.lineX0 = area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  }, area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  }, area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  }, area.defined = function(_) {
    return arguments.length ? (defined3 = typeof _ == "function" ? _ : constant$3(!!_), area) : defined3;
  }, area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  }, area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  }, area;
}
__name(shapeArea, "shapeArea");
const _Bump = class _Bump {
  constructor(context, x3) {
    this._context = context, this._x = x3;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(x3, y4) {
    switch (x3 = +x3, y4 = +y4, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + x3) / 2, this._y0, this._x0, y4, x3, y4) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y4) / 2, x3, this._y0, x3, y4);
        break;
      }
    }
    this._x0 = x3, this._y0 = y4;
  }
};
__name(_Bump, "Bump");
let Bump = _Bump;
function bumpX(context) {
  return new Bump(context, !0);
}
__name(bumpX, "bumpX");
function bumpY(context) {
  return new Bump(context, !1);
}
__name(bumpY, "bumpY");
const symbolCircle = {
  draw(context, size) {
    const r2 = sqrt$1(size / pi$1);
    context.moveTo(r2, 0), context.arc(0, 0, r2, 0, tau$1);
  }
}, symbolCross = {
  draw(context, size) {
    const r2 = sqrt$1(size / 5) / 2;
    context.moveTo(-3 * r2, -r2), context.lineTo(-r2, -r2), context.lineTo(-r2, -3 * r2), context.lineTo(r2, -3 * r2), context.lineTo(r2, -r2), context.lineTo(3 * r2, -r2), context.lineTo(3 * r2, r2), context.lineTo(r2, r2), context.lineTo(r2, 3 * r2), context.lineTo(-r2, 3 * r2), context.lineTo(-r2, r2), context.lineTo(-3 * r2, r2), context.closePath();
  }
}, tan30 = sqrt$1(1 / 3), tan30_2 = tan30 * 2, symbolDiamond = {
  draw(context, size) {
    const y4 = sqrt$1(size / tan30_2), x3 = y4 * tan30;
    context.moveTo(0, -y4), context.lineTo(x3, 0), context.lineTo(0, y4), context.lineTo(-x3, 0), context.closePath();
  }
}, symbolSquare = {
  draw(context, size) {
    const w2 = sqrt$1(size), x3 = -w2 / 2;
    context.rect(x3, x3, w2, w2);
  }
}, ka = 0.8908130915292852, kr = sin(pi$1 / 10) / sin(7 * pi$1 / 10), kx = sin(tau$1 / 10) * kr, ky = -cos(tau$1 / 10) * kr, symbolStar = {
  draw(context, size) {
    const r2 = sqrt$1(size * ka), x3 = kx * r2, y4 = ky * r2;
    context.moveTo(0, -r2), context.lineTo(x3, y4);
    for (let i2 = 1; i2 < 5; ++i2) {
      const a4 = tau$1 * i2 / 5, c3 = cos(a4), s4 = sin(a4);
      context.lineTo(s4 * r2, -c3 * r2), context.lineTo(c3 * x3 - s4 * y4, s4 * x3 + c3 * y4);
    }
    context.closePath();
  }
}, sqrt3 = sqrt$1(3), symbolTriangle = {
  draw(context, size) {
    const y4 = -sqrt$1(size / (sqrt3 * 3));
    context.moveTo(0, y4 * 2), context.lineTo(-sqrt3 * y4, -y4), context.lineTo(sqrt3 * y4, -y4), context.closePath();
  }
}, c2 = -0.5, s3 = sqrt$1(3) / 2, k2 = 1 / sqrt$1(12), a3 = (k2 / 2 + 1) * 3, symbolWye = {
  draw(context, size) {
    const r2 = sqrt$1(size / a3), x0 = r2 / 2, y0 = r2 * k2, x1 = x0, y1 = r2 * k2 + r2, x22 = -x1, y22 = y1;
    context.moveTo(x0, y0), context.lineTo(x1, y1), context.lineTo(x22, y22), context.lineTo(c2 * x0 - s3 * y0, s3 * x0 + c2 * y0), context.lineTo(c2 * x1 - s3 * y1, s3 * x1 + c2 * y1), context.lineTo(c2 * x22 - s3 * y22, s3 * x22 + c2 * y22), context.lineTo(c2 * x0 + s3 * y0, c2 * y0 - s3 * x0), context.lineTo(c2 * x1 + s3 * y1, c2 * y1 - s3 * x1), context.lineTo(c2 * x22 + s3 * y22, c2 * y22 - s3 * x22), context.closePath();
  }
};
function Symbol$3(type, size) {
  let context = null, path = withPath(symbol);
  type = typeof type == "function" ? type : constant$3(type || symbolCircle), size = typeof size == "function" ? size : constant$3(size === void 0 ? 64 : +size);
  function symbol() {
    let buffer;
    if (context || (context = buffer = path()), type.apply(this, arguments).draw(context, +size.apply(this, arguments)), buffer)
      return context = null, buffer + "" || null;
  }
  return __name(symbol, "symbol"), symbol.type = function(_) {
    return arguments.length ? (type = typeof _ == "function" ? _ : constant$3(_), symbol) : type;
  }, symbol.size = function(_) {
    return arguments.length ? (size = typeof _ == "function" ? _ : constant$3(+_), symbol) : size;
  }, symbol.context = function(_) {
    return arguments.length ? (context = _ ?? null, symbol) : context;
  }, symbol;
}
__name(Symbol$3, "Symbol$3");
function noop$2() {
}
__name(noop$2, "noop$2");
function point$2(that, x3, y4) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x3) / 6,
    (that._y0 + 4 * that._y1 + y4) / 6
  );
}
__name(point$2, "point$2");
function Basis(context) {
  this._context = context;
}
__name(Basis, "Basis");
Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point$2(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    switch (x3 = +x3, y4 = +y4, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        point$2(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = x3, this._y0 = this._y1, this._y1 = y4;
  }
};
function curveBasis(context) {
  return new Basis(context);
}
__name(curveBasis, "curveBasis");
function BasisClosed(context) {
  this._context = context;
}
__name(BasisClosed, "BasisClosed");
BasisClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x3, y4) {
    switch (x3 = +x3, y4 = +y4, this._point) {
      case 0:
        this._point = 1, this._x2 = x3, this._y2 = y4;
        break;
      case 1:
        this._point = 2, this._x3 = x3, this._y3 = y4;
        break;
      case 2:
        this._point = 3, this._x4 = x3, this._y4 = y4, this._context.moveTo((this._x0 + 4 * this._x1 + x3) / 6, (this._y0 + 4 * this._y1 + y4) / 6);
        break;
      default:
        point$2(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = x3, this._y0 = this._y1, this._y1 = y4;
  }
};
function curveBasisClosed(context) {
  return new BasisClosed(context);
}
__name(curveBasisClosed, "curveBasisClosed");
function BasisOpen(context) {
  this._context = context;
}
__name(BasisOpen, "BasisOpen");
BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    switch (x3 = +x3, y4 = +y4, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var x0 = (this._x0 + 4 * this._x1 + x3) / 6, y0 = (this._y0 + 4 * this._y1 + y4) / 6;
        this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
        break;
      case 3:
        this._point = 4;
      default:
        point$2(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = x3, this._y0 = this._y1, this._y1 = y4;
  }
};
function curveBasisOpen(context) {
  return new BasisOpen(context);
}
__name(curveBasisOpen, "curveBasisOpen");
function LinearClosed(context) {
  this._context = context;
}
__name(LinearClosed, "LinearClosed");
LinearClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4, this._point ? this._context.lineTo(x3, y4) : (this._point = 1, this._context.moveTo(x3, y4));
  }
};
function curveLinearClosed(context) {
  return new LinearClosed(context);
}
__name(curveLinearClosed, "curveLinearClosed");
function sign(x3) {
  return x3 < 0 ? -1 : 1;
}
__name(sign, "sign");
function slope3(that, x22, y22) {
  var h0 = that._x1 - that._x0, h1 = x22 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y22 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
__name(slope3, "slope3");
function slope2(that, t3) {
  var h3 = that._x1 - that._x0;
  return h3 ? (3 * (that._y1 - that._y0) / h3 - t3) / 2 : t3;
}
__name(slope2, "slope2");
function point$1(that, t02, t12) {
  var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t02, x1 - dx, y1 - dx * t12, x1, y1);
}
__name(point$1, "point$1");
function MonotoneX(context) {
  this._context = context;
}
__name(MonotoneX, "MonotoneX");
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point$1(this, this._t0, slope2(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    var t12 = NaN;
    if (x3 = +x3, y4 = +y4, !(x3 === this._x1 && y4 === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, point$1(this, slope2(this, t12 = slope3(this, x3, y4)), t12);
          break;
        default:
          point$1(this, this._t0, t12 = slope3(this, x3, y4));
          break;
      }
      this._x0 = this._x1, this._x1 = x3, this._y0 = this._y1, this._y1 = y4, this._t0 = t12;
    }
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
__name(MonotoneY, "MonotoneY");
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x3, y4) {
  MonotoneX.prototype.point.call(this, y4, x3);
};
function ReflectContext(context) {
  this._context = context;
}
__name(ReflectContext, "ReflectContext");
ReflectContext.prototype = {
  moveTo: function(x3, y4) {
    this._context.moveTo(y4, x3);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(x3, y4) {
    this._context.lineTo(y4, x3);
  },
  bezierCurveTo: function(x1, y1, x22, y22, x3, y4) {
    this._context.bezierCurveTo(y1, x1, y22, x22, y4, x3);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
__name(monotoneX, "monotoneX");
function monotoneY(context) {
  return new MonotoneY(context);
}
__name(monotoneY, "monotoneY");
function Natural(context) {
  this._context = context;
}
__name(Natural, "Natural");
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var x3 = this._x, y4 = this._y, n = x3.length;
    if (n)
      if (this._line ? this._context.lineTo(x3[0], y4[0]) : this._context.moveTo(x3[0], y4[0]), n === 2)
        this._context.lineTo(x3[1], y4[1]);
      else
        for (var px2 = controlPoints(x3), py2 = controlPoints(y4), i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)
          this._context.bezierCurveTo(px2[0][i0], py2[0][i0], px2[1][i0], py2[1][i0], x3[i1], y4[i1]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(x3, y4) {
    this._x.push(+x3), this._y.push(+y4);
  }
};
function controlPoints(x3) {
  var i2, n = x3.length - 1, m3, a4 = new Array(n), b2 = new Array(n), r2 = new Array(n);
  for (a4[0] = 0, b2[0] = 2, r2[0] = x3[0] + 2 * x3[1], i2 = 1; i2 < n - 1; ++i2)
    a4[i2] = 1, b2[i2] = 4, r2[i2] = 4 * x3[i2] + 2 * x3[i2 + 1];
  for (a4[n - 1] = 2, b2[n - 1] = 7, r2[n - 1] = 8 * x3[n - 1] + x3[n], i2 = 1; i2 < n; ++i2)
    m3 = a4[i2] / b2[i2 - 1], b2[i2] -= m3, r2[i2] -= m3 * r2[i2 - 1];
  for (a4[n - 1] = r2[n - 1] / b2[n - 1], i2 = n - 2; i2 >= 0; --i2)
    a4[i2] = (r2[i2] - a4[i2 + 1]) / b2[i2];
  for (b2[n - 1] = (x3[n] + a4[n - 1]) / 2, i2 = 0; i2 < n - 1; ++i2)
    b2[i2] = 2 * x3[i2 + 1] - a4[i2 + 1];
  return [a4, b2];
}
__name(controlPoints, "controlPoints");
function curveNatural(context) {
  return new Natural(context);
}
__name(curveNatural, "curveNatural");
function Step(context, t3) {
  this._context = context, this._t = t3;
}
__name(Step, "Step");
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(x3, y4) {
    switch (x3 = +x3, y4 = +y4, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, y4), this._context.lineTo(x3, y4);
        else {
          var x1 = this._x * (1 - this._t) + x3 * this._t;
          this._context.lineTo(x1, this._y), this._context.lineTo(x1, y4);
        }
        break;
      }
    }
    this._x = x3, this._y = y4;
  }
};
function curveStep(context) {
  return new Step(context, 0.5);
}
__name(curveStep, "curveStep");
function stepBefore(context) {
  return new Step(context, 0);
}
__name(stepBefore, "stepBefore");
function stepAfter(context) {
  return new Step(context, 1);
}
__name(stepAfter, "stepAfter");
function stackOffsetNone(series, order2) {
  if ((n = series.length) > 1)
    for (var i2 = 1, j, s0, s1 = series[order2[0]], n, m3 = s1.length; i2 < n; ++i2)
      for (s0 = s1, s1 = series[order2[i2]], j = 0; j < m3; ++j)
        s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
}
__name(stackOffsetNone, "stackOffsetNone");
function stackOrderNone(series) {
  for (var n = series.length, o = new Array(n); --n >= 0; )
    o[n] = n;
  return o;
}
__name(stackOrderNone, "stackOrderNone");
function stackValue(d3, key) {
  return d3[key];
}
__name(stackValue, "stackValue");
function stackSeries(key) {
  const series = [];
  return series.key = key, series;
}
__name(stackSeries, "stackSeries");
function shapeStack() {
  var keys2 = constant$3([]), order2 = stackOrderNone, offset = stackOffsetNone, value = stackValue;
  function stack(data2) {
    var sz = Array.from(keys2.apply(this, arguments), stackSeries), i2, n = sz.length, j = -1, oz;
    for (const d3 of data2)
      for (i2 = 0, ++j; i2 < n; ++i2)
        (sz[i2][j] = [0, +value(d3, sz[i2].key, j, data2)]).data = d3;
    for (i2 = 0, oz = array(order2(sz)); i2 < n; ++i2)
      sz[oz[i2]].index = i2;
    return offset(sz, oz), sz;
  }
  return __name(stack, "stack"), stack.keys = function(_) {
    return arguments.length ? (keys2 = typeof _ == "function" ? _ : constant$3(Array.from(_)), stack) : keys2;
  }, stack.value = function(_) {
    return arguments.length ? (value = typeof _ == "function" ? _ : constant$3(+_), stack) : value;
  }, stack.order = function(_) {
    return arguments.length ? (order2 = _ == null ? stackOrderNone : typeof _ == "function" ? _ : constant$3(Array.from(_)), stack) : order2;
  }, stack.offset = function(_) {
    return arguments.length ? (offset = _ ?? stackOffsetNone, stack) : offset;
  }, stack;
}
__name(shapeStack, "shapeStack");
function stackOffsetExpand(series, order2) {
  if ((n = series.length) > 0) {
    for (var i2, n, j = 0, m3 = series[0].length, y4; j < m3; ++j) {
      for (y4 = i2 = 0; i2 < n; ++i2)
        y4 += series[i2][j][1] || 0;
      if (y4)
        for (i2 = 0; i2 < n; ++i2)
          series[i2][j][1] /= y4;
    }
    stackOffsetNone(series, order2);
  }
}
__name(stackOffsetExpand, "stackOffsetExpand");
function stackOffsetSilhouette(series, order2) {
  if ((n = series.length) > 0) {
    for (var j = 0, s0 = series[order2[0]], n, m3 = s0.length; j < m3; ++j) {
      for (var i2 = 0, y4 = 0; i2 < n; ++i2)
        y4 += series[i2][j][1] || 0;
      s0[j][1] += s0[j][0] = -y4 / 2;
    }
    stackOffsetNone(series, order2);
  }
}
__name(stackOffsetSilhouette, "stackOffsetSilhouette");
function stackOffsetWiggle(series, order2) {
  if (!(!((n = series.length) > 0) || !((m3 = (s0 = series[order2[0]]).length) > 0))) {
    for (var y4 = 0, j = 1, s0, m3, n; j < m3; ++j) {
      for (var i2 = 0, s1 = 0, s22 = 0; i2 < n; ++i2) {
        for (var si = series[order2[i2]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s32 = (sij0 - sij1) / 2, k3 = 0; k3 < i2; ++k3) {
          var sk = series[order2[k3]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
          s32 += skj0 - skj1;
        }
        s1 += sij0, s22 += s32 * sij0;
      }
      s0[j - 1][1] += s0[j - 1][0] = y4, s1 && (y4 -= s22 / s1);
    }
    s0[j - 1][1] += s0[j - 1][0] = y4, stackOffsetNone(series, order2);
  }
}
__name(stackOffsetWiggle, "stackOffsetWiggle");
function _typeof$B(o) {
  "@babel/helpers - typeof";
  return _typeof$B = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$B(o);
}
__name(_typeof$B, "_typeof$B");
var _excluded$b = ["type", "size", "sizeType"];
function _extends$l() {
  return _extends$l = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$l.apply(this, arguments);
}
__name(_extends$l, "_extends$l");
function ownKeys$w(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$w, "ownKeys$w");
function _objectSpread$w(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$w(Object(t3), !0).forEach(function(r3) {
      _defineProperty$z(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$w(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$w, "_objectSpread$w");
function _defineProperty$z(obj2, key, value) {
  return key = _toPropertyKey$z(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$z, "_defineProperty$z");
function _toPropertyKey$z(t3) {
  var i2 = _toPrimitive$z(t3, "string");
  return _typeof$B(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$z, "_toPropertyKey$z");
function _toPrimitive$z(t3, r2) {
  if (_typeof$B(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$B(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$z, "_toPrimitive$z");
function _objectWithoutProperties$b(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$b(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$b, "_objectWithoutProperties$b");
function _objectWithoutPropertiesLoose$b(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$b, "_objectWithoutPropertiesLoose$b");
var symbolFactories = {
  symbolCircle,
  symbolCross,
  symbolDiamond,
  symbolSquare,
  symbolStar,
  symbolTriangle,
  symbolWye
}, RADIAN$2 = Math.PI / 180, getSymbolFactory = /* @__PURE__ */ __name(function(type) {
  var name2 = "symbol".concat(upperFirst$1(type));
  return symbolFactories[name2] || symbolCircle;
}, "getSymbolFactory"), calculateAreaSize = /* @__PURE__ */ __name(function(size, sizeType, type) {
  if (sizeType === "area")
    return size;
  switch (type) {
    case "cross":
      return 5 * size * size / 9;
    case "diamond":
      return 0.5 * size * size / Math.sqrt(3);
    case "square":
      return size * size;
    case "star": {
      var angle = 18 * RADIAN$2;
      return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
    }
    case "triangle":
      return Math.sqrt(3) * size * size / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
    default:
      return Math.PI * size * size / 4;
  }
}, "calculateAreaSize"), registerSymbol = /* @__PURE__ */ __name(function(key, factory) {
  symbolFactories["symbol".concat(upperFirst$1(key))] = factory;
}, "registerSymbol"), Symbols = /* @__PURE__ */ __name(function(_ref) {
  var _ref$type = _ref.type, type = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = _objectWithoutProperties$b(_ref, _excluded$b), props = _objectSpread$w(_objectSpread$w({}, rest), {}, {
    type,
    size,
    sizeType
  }), getPath4 = /* @__PURE__ */ __name(function() {
    var symbolFactory = getSymbolFactory(type), symbol = Symbol$3().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
    return symbol();
  }, "getPath"), className = props.className, cx = props.cx, cy = props.cy, filteredProps = filterProps(props, !0);
  return cx === +cx && cy === +cy && size === +size ? /* @__PURE__ */ React__default.createElement("path", _extends$l({}, filteredProps, {
    className: clsx("recharts-symbols", className),
    transform: "translate(".concat(cx, ", ").concat(cy, ")"),
    d: getPath4()
  })) : null;
}, "Symbols");
Symbols.registerSymbol = registerSymbol;
function _typeof$A(o) {
  "@babel/helpers - typeof";
  return _typeof$A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$A(o);
}
__name(_typeof$A, "_typeof$A");
function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$k.apply(this, arguments);
}
__name(_extends$k, "_extends$k");
function ownKeys$v(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$v, "ownKeys$v");
function _objectSpread$v(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$v(Object(t3), !0).forEach(function(r3) {
      _defineProperty$y(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$v(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$v, "_objectSpread$v");
function _classCallCheck$c(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$c, "_classCallCheck$c");
function _defineProperties$c(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$y(descriptor.key), descriptor);
  }
}
__name(_defineProperties$c, "_defineProperties$c");
function _createClass$c(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$c(Constructor.prototype, protoProps), staticProps && _defineProperties$c(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$c, "_createClass$c");
function _callSuper$8(t3, o, e3) {
  return o = _getPrototypeOf$9(o), _possibleConstructorReturn$9(t3, _isNativeReflectConstruct$9() ? Reflect.construct(o, e3 || [], _getPrototypeOf$9(t3).constructor) : o.apply(t3, e3));
}
__name(_callSuper$8, "_callSuper$8");
function _possibleConstructorReturn$9(self2, call) {
  if (call && (_typeof$A(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$9(self2);
}
__name(_possibleConstructorReturn$9, "_possibleConstructorReturn$9");
function _assertThisInitialized$9(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$9, "_assertThisInitialized$9");
function _isNativeReflectConstruct$9() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$9 = /* @__PURE__ */ __name(function() {
    return !!t3;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct$9, "_isNativeReflectConstruct$9");
function _getPrototypeOf$9(o) {
  return _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$9(o);
}
__name(_getPrototypeOf$9, "_getPrototypeOf$9");
function _inherits$9(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$9(subClass, superClass);
}
__name(_inherits$9, "_inherits$9");
function _setPrototypeOf$9(o, p) {
  return _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$9(o, p);
}
__name(_setPrototypeOf$9, "_setPrototypeOf$9");
function _defineProperty$y(obj2, key, value) {
  return key = _toPropertyKey$y(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$y, "_defineProperty$y");
function _toPropertyKey$y(t3) {
  var i2 = _toPrimitive$y(t3, "string");
  return _typeof$A(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$y, "_toPropertyKey$y");
function _toPrimitive$y(t3, r2) {
  if (_typeof$A(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$A(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$y, "_toPrimitive$y");
var SIZE = 32, DefaultLegendContent = /* @__PURE__ */ function(_PureComponent) {
  _inherits$9(DefaultLegendContent2, _PureComponent);
  function DefaultLegendContent2() {
    return _classCallCheck$c(this, DefaultLegendContent2), _callSuper$8(this, DefaultLegendContent2, arguments);
  }
  return __name(DefaultLegendContent2, "DefaultLegendContent"), _createClass$c(DefaultLegendContent2, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      /* @__PURE__ */ __name(function(data2) {
        var inactiveColor = this.props.inactiveColor, halfSize = SIZE / 2, sixthSize = SIZE / 6, thirdSize = SIZE / 3, color2 = data2.inactive ? inactiveColor : data2.color;
        if (data2.type === "plainline")
          return /* @__PURE__ */ React__default.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: color2,
            strokeDasharray: data2.payload.strokeDasharray,
            x1: 0,
            y1: halfSize,
            x2: SIZE,
            y2: halfSize,
            className: "recharts-legend-icon"
          });
        if (data2.type === "line")
          return /* @__PURE__ */ React__default.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: color2,
            d: "M0,".concat(halfSize, "h").concat(thirdSize, `
            A`).concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, `
            H`).concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, `
            A`).concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
            className: "recharts-legend-icon"
          });
        if (data2.type === "rect")
          return /* @__PURE__ */ React__default.createElement("path", {
            stroke: "none",
            fill: color2,
            d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ React__default.isValidElement(data2.legendIcon)) {
          var iconProps = _objectSpread$v({}, data2);
          return delete iconProps.legendIcon, /* @__PURE__ */ React__default.cloneElement(data2.legendIcon, iconProps);
        }
        return /* @__PURE__ */ React__default.createElement(Symbols, {
          fill: color2,
          cx: halfSize,
          cy: halfSize,
          size: SIZE,
          sizeType: "diameter",
          type: data2.type
        });
      }, "renderIcon")
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: /* @__PURE__ */ __name(function() {
      var _this = this, _this$props = this.props, payload = _this$props.payload, iconSize2 = _this$props.iconSize, layout2 = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor, viewBox = {
        x: 0,
        y: 0,
        width: SIZE,
        height: SIZE
      }, itemStyle = {
        display: layout2 === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, svgStyle = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return payload.map(function(entry, i2) {
        var finalFormatter = entry.formatter || formatter, className = clsx(_defineProperty$y(_defineProperty$y({
          "recharts-legend-item": !0
        }, "legend-item-".concat(i2), !0), "inactive", entry.inactive));
        if (entry.type === "none")
          return null;
        var entryValue = isFunction$3(entry.value) ? null : entry.value;
        warn$1(
          !isFunction$3(entry.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var color2 = entry.inactive ? inactiveColor : entry.color;
        return /* @__PURE__ */ React__default.createElement("li", _extends$k({
          className,
          style: itemStyle,
          key: "legend-item-".concat(i2)
        }, adaptEventsOfChild(_this.props, entry, i2)), /* @__PURE__ */ React__default.createElement(Surface, {
          width: iconSize2,
          height: iconSize2,
          viewBox,
          style: svgStyle
        }, _this.renderIcon(entry)), /* @__PURE__ */ React__default.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: color2
          }
        }, finalFormatter ? finalFormatter(entryValue, entry, i2) : entryValue));
      });
    }, "renderItems")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this$props2 = this.props, payload = _this$props2.payload, layout2 = _this$props2.layout, align = _this$props2.align;
      if (!payload || !payload.length)
        return null;
      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout2 === "horizontal" ? align : "left"
      };
      return /* @__PURE__ */ React__default.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
      }, this.renderItems());
    }, "render")
  }]), DefaultLegendContent2;
}(PureComponent);
_defineProperty$y(DefaultLegendContent, "displayName", "Legend");
_defineProperty$y(DefaultLegendContent, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2(), this.size = 0;
}
__name(stackClear$1, "stackClear$1");
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data2 = this.__data__, result2 = data2.delete(key);
  return this.size = data2.size, result2;
}
__name(stackDelete$1, "stackDelete$1");
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
__name(stackGet$1, "stackGet$1");
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
__name(stackHas$1, "stackHas$1");
var _stackHas = stackHas$1, ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache, LARGE_ARRAY_SIZE$1 = 200;
function stackSet$1(key, value) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache$1) {
    var pairs = data2.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1)
      return pairs.push([key, value]), this.size = ++data2.size, this;
    data2 = this.__data__ = new MapCache$1(pairs);
  }
  return data2.set(key, value), this.size = data2.size, this;
}
__name(stackSet$1, "stackSet$1");
var _stackSet = stackSet$1, ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(entries) {
  var data2 = this.__data__ = new ListCache(entries);
  this.size = data2.size;
}
__name(Stack$2, "Stack$2");
Stack$2.prototype.clear = stackClear;
Stack$2.prototype.delete = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2, HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  return this.__data__.set(value, HASH_UNDEFINED), this;
}
__name(setCacheAdd$1, "setCacheAdd$1");
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
__name(setCacheHas$1, "setCacheHas$1");
var _setCacheHas = setCacheHas$1, MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$2(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  for (this.__data__ = new MapCache(); ++index2 < length; )
    this.add(values[index2]);
}
__name(SetCache$2, "SetCache$2");
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;
function arraySome$2(array2, predicate) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length; ++index2 < length; )
    if (predicate(array2[index2], index2, array2))
      return !0;
  return !1;
}
__name(arraySome$2, "arraySome$2");
var _arraySome = arraySome$2;
function cacheHas$2(cache2, key) {
  return cache2.has(key);
}
__name(cacheHas$2, "cacheHas$2");
var _cacheHas = cacheHas$2, SetCache$1 = _SetCache, arraySome$1 = _arraySome, cacheHas$1 = _cacheHas, COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength))
    return !1;
  var arrStacked = stack.get(array2), othStacked = stack.get(other);
  if (arrStacked && othStacked)
    return arrStacked == other && othStacked == array2;
  var index2 = -1, result2 = !0, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : void 0;
  for (stack.set(array2, other), stack.set(other, array2); ++index2 < arrLength; ) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer)
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
    if (compared !== void 0) {
      if (compared)
        continue;
      result2 = !1;
      break;
    }
    if (seen) {
      if (!arraySome$1(other, function(othValue2, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack)))
          return seen.push(othIndex);
      })) {
        result2 = !1;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result2 = !1;
      break;
    }
  }
  return stack.delete(array2), stack.delete(other), result2;
}
__name(equalArrays$2, "equalArrays$2");
var _equalArrays = equalArrays$2, root$5 = _root, Uint8Array$2 = root$5.Uint8Array, _Uint8Array = Uint8Array$2;
function mapToArray$1(map2) {
  var index2 = -1, result2 = Array(map2.size);
  return map2.forEach(function(value, key) {
    result2[++index2] = [key, value];
  }), result2;
}
__name(mapToArray$1, "mapToArray$1");
var _mapToArray = mapToArray$1;
function setToArray$3(set3) {
  var index2 = -1, result2 = Array(set3.size);
  return set3.forEach(function(value) {
    result2[++index2] = value;
  }), result2;
}
__name(setToArray$3, "setToArray$3");
var _setToArray = setToArray$3, Symbol$2 = _Symbol, Uint8Array$1 = _Uint8Array, eq$1 = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray$2 = _setToArray, COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag$2 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(object2, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset)
        return !1;
      object2 = object2.buffer, other = other.buffer;
    case arrayBufferTag$1:
      return !(object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object2), new Uint8Array$1(other)));
    case boolTag$2:
    case dateTag$1:
    case numberTag$1:
      return eq$1(+object2, +other);
    case errorTag$1:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object2 == other + "";
    case mapTag$2:
      var convert2 = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      if (convert2 || (convert2 = setToArray$2), object2.size != other.size && !isPartial)
        return !1;
      var stacked = stack.get(object2);
      if (stacked)
        return stacked == other;
      bitmask |= COMPARE_UNORDERED_FLAG$2, stack.set(object2, other);
      var result2 = equalArrays$1(convert2(object2), convert2(other), bitmask, customizer, equalFunc, stack);
      return stack.delete(object2), result2;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(object2) == symbolValueOf.call(other);
  }
  return !1;
}
__name(equalByTag$1, "equalByTag$1");
var _equalByTag = equalByTag$1;
function arrayPush$2(array2, values) {
  for (var index2 = -1, length = values.length, offset = array2.length; ++index2 < length; )
    array2[offset + index2] = values[index2];
  return array2;
}
__name(arrayPush$2, "arrayPush$2");
var _arrayPush = arrayPush$2, arrayPush$1 = _arrayPush, isArray$a = isArray_1;
function baseGetAllKeys$1(object2, keysFunc, symbolsFunc) {
  var result2 = keysFunc(object2);
  return isArray$a(object2) ? result2 : arrayPush$1(result2, symbolsFunc(object2));
}
__name(baseGetAllKeys$1, "baseGetAllKeys$1");
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(array2, predicate) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result2 = []; ++index2 < length; ) {
    var value = array2[index2];
    predicate(value, index2, array2) && (result2[resIndex++] = value);
  }
  return result2;
}
__name(arrayFilter$1, "arrayFilter$1");
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
__name(stubArray$1, "stubArray$1");
var stubArray_1 = stubArray$1, arrayFilter = _arrayFilter, stubArray = stubArray_1, objectProto$7 = Object.prototype, propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols$1 = nativeGetSymbols ? function(object2) {
  return object2 == null ? [] : (object2 = Object(object2), arrayFilter(nativeGetSymbols(object2), function(symbol) {
    return propertyIsEnumerable$1.call(object2, symbol);
  }));
} : stubArray, _getSymbols = getSymbols$1;
function baseTimes$1(n, iteratee) {
  for (var index2 = -1, result2 = Array(n); ++index2 < n; )
    result2[index2] = iteratee(index2);
  return result2;
}
__name(baseTimes$1, "baseTimes$1");
var _baseTimes = baseTimes$1, baseGetTag$4 = _baseGetTag, isObjectLike$5 = isObjectLike_1, argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$5(value) && baseGetTag$4(value) == argsTag$2;
}
__name(baseIsArguments$1, "baseIsArguments$1");
var _baseIsArguments = baseIsArguments$1, baseIsArguments = _baseIsArguments, isObjectLike$4 = isObjectLike_1, objectProto$6 = Object.prototype, hasOwnProperty$6 = objectProto$6.hasOwnProperty, propertyIsEnumerable = objectProto$6.propertyIsEnumerable, isArguments$3 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$4(value) && hasOwnProperty$6.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
}, isArguments_1 = isArguments$3, isBuffer$2 = { exports: {} };
function stubFalse() {
  return !1;
}
__name(stubFalse, "stubFalse");
var stubFalse_1 = stubFalse;
isBuffer$2.exports;
(function(module2, exports2) {
  var root2 = _root, stubFalse2 = stubFalse_1, freeExports2 = exports2 && !exports2.nodeType && exports2, freeModule2 = freeExports2 && !0 && module2 && !module2.nodeType && module2, moduleExports2 = freeModule2 && freeModule2.exports === freeExports2, Buffer3 = moduleExports2 ? root2.Buffer : void 0, nativeIsBuffer2 = Buffer3 ? Buffer3.isBuffer : void 0, isBuffer2 = nativeIsBuffer2 || stubFalse2;
  module2.exports = isBuffer2;
})(isBuffer$2, isBuffer$2.exports);
var isBufferExports = isBuffer$2.exports, MAX_SAFE_INTEGER$2 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$3(value, length) {
  var type = typeof value;
  return length = length ?? MAX_SAFE_INTEGER$2, !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
__name(isIndex$3, "isIndex$3");
var _isIndex = isIndex$3, MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
__name(isLength$3, "isLength$3");
var isLength_1 = isLength$3, baseGetTag$3 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$3 = isObjectLike_1, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$3 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray$1(value) {
  return isObjectLike$3(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$3(value)];
}
__name(baseIsTypedArray$1, "baseIsTypedArray$1");
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$2(func2) {
  return function(value) {
    return func2(value);
  };
}
__name(baseUnary$2, "baseUnary$2");
var _baseUnary = baseUnary$2, _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module2, exports2) {
  var freeGlobal2 = _freeGlobal, freeExports2 = exports2 && !exports2.nodeType && exports2, freeModule2 = freeExports2 && !0 && module2 && !module2.nodeType && module2, moduleExports2 = freeModule2 && freeModule2.exports === freeExports2, freeProcess2 = moduleExports2 && freeGlobal2.process, nodeUtil2 = function() {
    try {
      var types2 = freeModule2 && freeModule2.require && freeModule2.require("util").types;
      return types2 || freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
    } catch {
    }
  }();
  module2.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports, baseIsTypedArray = _baseIsTypedArray, baseUnary$1 = _baseUnary, nodeUtil = _nodeUtilExports, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray$3 = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray, isTypedArray_1 = isTypedArray$3, baseTimes = _baseTimes, isArguments$2 = isArguments_1, isArray$9 = isArray_1, isBuffer$1 = isBufferExports, isIndex$2 = _isIndex, isTypedArray$2 = isTypedArray_1, objectProto$5 = Object.prototype, hasOwnProperty$5 = objectProto$5.hasOwnProperty;
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$9(value), isArg = !isArr && isArguments$2(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$2(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String) : [], length = result2.length;
  for (var key in value)
    (inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$2(key, length))) && result2.push(key);
  return result2;
}
__name(arrayLikeKeys$1, "arrayLikeKeys$1");
var _arrayLikeKeys = arrayLikeKeys$1, objectProto$4 = Object.prototype;
function isPrototype$1(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$4;
  return value === proto;
}
__name(isPrototype$1, "isPrototype$1");
var _isPrototype = isPrototype$1;
function overArg$2(func2, transform2) {
  return function(arg) {
    return func2(transform2(arg));
  };
}
__name(overArg$2, "overArg$2");
var _overArg = overArg$2, overArg$1 = _overArg, nativeKeys$1 = overArg$1(Object.keys, Object), _nativeKeys = nativeKeys$1, isPrototype = _isPrototype, nativeKeys = _nativeKeys, objectProto$3 = Object.prototype, hasOwnProperty$4 = objectProto$3.hasOwnProperty;
function baseKeys$1(object2) {
  if (!isPrototype(object2))
    return nativeKeys(object2);
  var result2 = [];
  for (var key in Object(object2))
    hasOwnProperty$4.call(object2, key) && key != "constructor" && result2.push(key);
  return result2;
}
__name(baseKeys$1, "baseKeys$1");
var _baseKeys = baseKeys$1, isFunction = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$4(value) {
  return value != null && isLength$1(value.length) && !isFunction(value);
}
__name(isArrayLike$4, "isArrayLike$4");
var isArrayLike_1 = isArrayLike$4, arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$3 = isArrayLike_1;
function keys$4(object2) {
  return isArrayLike$3(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
__name(keys$4, "keys$4");
var keys_1 = keys$4, baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$3 = keys_1;
function getAllKeys$1(object2) {
  return baseGetAllKeys(object2, keys$3, getSymbols);
}
__name(getAllKeys$1, "getAllKeys$1");
var _getAllKeys = getAllKeys$1, getAllKeys = _getAllKeys, COMPARE_PARTIAL_FLAG$3 = 1, objectProto$2 = Object.prototype, hasOwnProperty$3 = objectProto$2.hasOwnProperty;
function equalObjects$1(object2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial)
    return !1;
  for (var index2 = objLength; index2--; ) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$3.call(other, key)))
      return !1;
  }
  var objStacked = stack.get(object2), othStacked = stack.get(other);
  if (objStacked && othStacked)
    return objStacked == other && othStacked == object2;
  var result2 = !0;
  stack.set(object2, other), stack.set(other, object2);
  for (var skipCtor = isPartial; ++index2 < objLength; ) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer)
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result2 = !1;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result2 && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    objCtor != othCtor && "constructor" in object2 && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor) && (result2 = !1);
  }
  return stack.delete(object2), stack.delete(other), result2;
}
__name(equalObjects$1, "equalObjects$1");
var _equalObjects = equalObjects$1, getNative$4 = _getNative, root$4 = _root, DataView$2 = getNative$4(root$4, "DataView"), _DataView = DataView$2, getNative$3 = _getNative, root$3 = _root, Promise$2 = getNative$3(root$3, "Promise"), _Promise = Promise$2, getNative$2 = _getNative, root$2 = _root, Set$3 = getNative$2(root$2, "Set"), _Set = Set$3, getNative$1 = _getNative, root$1 = _root, WeakMap$2 = getNative$1(root$1, "WeakMap"), _WeakMap = WeakMap$2, DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$2 = _Set, WeakMap$1 = _WeakMap, baseGetTag$2 = _baseGetTag, toSource = _toSource, mapTag = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1), getTag$2 = baseGetTag$2;
(DataView$1 && getTag$2(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$2(new Map$1()) != mapTag || Promise$1 && getTag$2(Promise$1.resolve()) != promiseTag || Set$2 && getTag$2(new Set$2()) != setTag || WeakMap$1 && getTag$2(new WeakMap$1()) != weakMapTag) && (getTag$2 = /* @__PURE__ */ __name(function(value) {
  var result2 = baseGetTag$2(value), Ctor = result2 == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
  if (ctorString)
    switch (ctorString) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return result2;
}, "getTag$2"));
var _getTag = getTag$2, Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag$1 = _getTag, isArray$8 = isArray_1, isBuffer = isBufferExports, isTypedArray$1 = isTypedArray_1, COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag$1 = "[object Object]", objectProto$1 = Object.prototype, hasOwnProperty$2 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep$1(object2, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$8(object2), othIsArr = isArray$8(other), objTag = objIsArr ? arrayTag : getTag$1(object2), othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag$1 : objTag, othTag = othTag == argsTag ? objectTag$1 : othTag;
  var objIsObj = objTag == objectTag$1, othIsObj = othTag == objectTag$1, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object2)) {
    if (!isBuffer(other))
      return !1;
    objIsArr = !0, objIsObj = !1;
  }
  if (isSameTag && !objIsObj)
    return stack || (stack = new Stack$1()), objIsArr || isTypedArray$1(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$2.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      return stack || (stack = new Stack$1()), equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  return isSameTag ? (stack || (stack = new Stack$1()), equalObjects(object2, other, bitmask, customizer, equalFunc, stack)) : !1;
}
__name(baseIsEqualDeep$1, "baseIsEqualDeep$1");
var _baseIsEqualDeep = baseIsEqualDeep$1, baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$2 = isObjectLike_1;
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  return value === other ? !0 : value == null || other == null || !isObjectLike$2(value) && !isObjectLike$2(other) ? value !== value && other !== other : baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}
__name(baseIsEqual$3, "baseIsEqual$3");
var _baseIsEqual = baseIsEqual$3, Stack = _Stack, baseIsEqual$2 = _baseIsEqual, COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object2, source, matchData, customizer) {
  var index2 = matchData.length, length = index2, noCustomizer = !customizer;
  if (object2 == null)
    return !length;
  for (object2 = Object(object2); index2--; ) {
    var data2 = matchData[index2];
    if (noCustomizer && data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2))
      return !1;
  }
  for (; ++index2 < length; ) {
    data2 = matchData[index2];
    var key = data2[0], objValue = object2[key], srcValue = data2[1];
    if (noCustomizer && data2[2]) {
      if (objValue === void 0 && !(key in object2))
        return !1;
    } else {
      var stack = new Stack();
      if (customizer)
        var result2 = customizer(objValue, srcValue, key, object2, source, stack);
      if (!(result2 === void 0 ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result2))
        return !1;
    }
  }
  return !0;
}
__name(baseIsMatch$1, "baseIsMatch$1");
var _baseIsMatch = baseIsMatch$1, isObject$4 = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject$4(value);
}
__name(isStrictComparable$2, "isStrictComparable$2");
var _isStrictComparable = isStrictComparable$2, isStrictComparable$1 = _isStrictComparable, keys$2 = keys_1;
function getMatchData$1(object2) {
  for (var result2 = keys$2(object2), length = result2.length; length--; ) {
    var key = result2[length], value = object2[key];
    result2[length] = [key, value, isStrictComparable$1(value)];
  }
  return result2;
}
__name(getMatchData$1, "getMatchData$1");
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key, srcValue) {
  return function(object2) {
    return object2 == null ? !1 : object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
__name(matchesStrictComparable$2, "matchesStrictComparable$2");
var _matchesStrictComparable = matchesStrictComparable$2, baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  return matchData.length == 1 && matchData[0][2] ? matchesStrictComparable$1(matchData[0][0], matchData[0][1]) : function(object2) {
    return object2 === source || baseIsMatch(object2, source, matchData);
  };
}
__name(baseMatches$1, "baseMatches$1");
var _baseMatches = baseMatches$1;
function baseHasIn$1(object2, key) {
  return object2 != null && key in Object(object2);
}
__name(baseHasIn$1, "baseHasIn$1");
var _baseHasIn = baseHasIn$1, castPath = _castPath, isArguments$1 = isArguments_1, isArray$7 = isArray_1, isIndex$1 = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$1(object2, path, hasFunc) {
  path = castPath(path, object2);
  for (var index2 = -1, length = path.length, result2 = !1; ++index2 < length; ) {
    var key = toKey$2(path[index2]);
    if (!(result2 = object2 != null && hasFunc(object2, key)))
      break;
    object2 = object2[key];
  }
  return result2 || ++index2 != length ? result2 : (length = object2 == null ? 0 : object2.length, !!length && isLength(length) && isIndex$1(key, length) && (isArray$7(object2) || isArguments$1(object2)));
}
__name(hasPath$1, "hasPath$1");
var _hasPath = hasPath$1, baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(object2, path) {
  return object2 != null && hasPath(object2, path, baseHasIn);
}
__name(hasIn$1, "hasIn$1");
var hasIn_1 = hasIn$1, baseIsEqual$1 = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey, COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path, srcValue) {
  return isKey$1(path) && isStrictComparable(srcValue) ? matchesStrictComparable(toKey$1(path), srcValue) : function(object2) {
    var objValue = get(object2, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
__name(baseMatchesProperty$1, "baseMatchesProperty$1");
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$b(value) {
  return value;
}
__name(identity$b, "identity$b");
var identity_1 = identity$b;
function baseProperty$1(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
__name(baseProperty$1, "baseProperty$1");
var _baseProperty = baseProperty$1, baseGet$1 = _baseGet;
function basePropertyDeep$1(path) {
  return function(object2) {
    return baseGet$1(object2, path);
  };
}
__name(basePropertyDeep$1, "basePropertyDeep$1");
var _basePropertyDeep = basePropertyDeep$1, baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
__name(property$1, "property$1");
var property_1 = property$1, baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$a = identity_1, isArray$6 = isArray_1, property = property_1;
function baseIteratee$8(value) {
  return typeof value == "function" ? value : value == null ? identity$a : typeof value == "object" ? isArray$6(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value) : property(value);
}
__name(baseIteratee$8, "baseIteratee$8");
var _baseIteratee = baseIteratee$8;
function baseFindIndex$1(array2, predicate, fromIndex, fromRight) {
  for (var length = array2.length, index2 = fromIndex + (fromRight ? 1 : -1); fromRight ? index2-- : ++index2 < length; )
    if (predicate(array2[index2], index2, array2))
      return index2;
  return -1;
}
__name(baseFindIndex$1, "baseFindIndex$1");
var _baseFindIndex = baseFindIndex$1;
function baseIsNaN$1(value) {
  return value !== value;
}
__name(baseIsNaN$1, "baseIsNaN$1");
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(array2, value, fromIndex) {
  for (var index2 = fromIndex - 1, length = array2.length; ++index2 < length; )
    if (array2[index2] === value)
      return index2;
  return -1;
}
__name(strictIndexOf$1, "strictIndexOf$1");
var _strictIndexOf = strictIndexOf$1, baseFindIndex = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$1(array2, value, fromIndex) {
  return value === value ? strictIndexOf(array2, value, fromIndex) : baseFindIndex(array2, baseIsNaN, fromIndex);
}
__name(baseIndexOf$1, "baseIndexOf$1");
var _baseIndexOf = baseIndexOf$1, baseIndexOf = _baseIndexOf;
function arrayIncludes$1(array2, value) {
  var length = array2 == null ? 0 : array2.length;
  return !!length && baseIndexOf(array2, value, 0) > -1;
}
__name(arrayIncludes$1, "arrayIncludes$1");
var _arrayIncludes = arrayIncludes$1;
function arrayIncludesWith$1(array2, value, comparator2) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length; ++index2 < length; )
    if (comparator2(value, array2[index2]))
      return !0;
  return !1;
}
__name(arrayIncludesWith$1, "arrayIncludesWith$1");
var _arrayIncludesWith = arrayIncludesWith$1;
function noop$1() {
}
__name(noop$1, "noop$1");
var noop_1 = noop$1, Set$1 = _Set, noop = noop_1, setToArray$1 = _setToArray, INFINITY$1 = 1 / 0, createSet$1 = Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY$1 ? function(values) {
  return new Set$1(values);
} : noop, _createSet = createSet$1, SetCache = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, cacheHas = _cacheHas, createSet = _createSet, setToArray = _setToArray, LARGE_ARRAY_SIZE = 200;
function baseUniq$1(array2, iteratee, comparator2) {
  var index2 = -1, includes = arrayIncludes, length = array2.length, isCommon = !0, result2 = [], seen = result2;
  if (comparator2)
    isCommon = !1, includes = arrayIncludesWith;
  else if (length >= LARGE_ARRAY_SIZE) {
    var set3 = iteratee ? null : createSet(array2);
    if (set3)
      return setToArray(set3);
    isCommon = !1, includes = cacheHas, seen = new SetCache();
  } else
    seen = iteratee ? [] : result2;
  outer:
    for (; ++index2 < length; ) {
      var value = array2[index2], computed = iteratee ? iteratee(value) : value;
      if (value = comparator2 || value !== 0 ? value : 0, isCommon && computed === computed) {
        for (var seenIndex = seen.length; seenIndex--; )
          if (seen[seenIndex] === computed)
            continue outer;
        iteratee && seen.push(computed), result2.push(value);
      } else
        includes(seen, computed, comparator2) || (seen !== result2 && seen.push(computed), result2.push(value));
    }
  return result2;
}
__name(baseUniq$1, "baseUniq$1");
var _baseUniq = baseUniq$1, baseIteratee$7 = _baseIteratee, baseUniq = _baseUniq;
function uniqBy(array2, iteratee) {
  return array2 && array2.length ? baseUniq(array2, baseIteratee$7(iteratee)) : [];
}
__name(uniqBy, "uniqBy");
var uniqBy_1 = uniqBy;
const uniqBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(uniqBy_1);
function getUniqPayload(payload, option, defaultUniqBy2) {
  return option === !0 ? uniqBy$1(payload, defaultUniqBy2) : isFunction$3(option) ? uniqBy$1(payload, option) : payload;
}
__name(getUniqPayload, "getUniqPayload");
function _typeof$z(o) {
  "@babel/helpers - typeof";
  return _typeof$z = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$z(o);
}
__name(_typeof$z, "_typeof$z");
var _excluded$a = ["ref"];
function ownKeys$u(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$u, "ownKeys$u");
function _objectSpread$u(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$u(Object(t3), !0).forEach(function(r3) {
      _defineProperty$x(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$u(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$u, "_objectSpread$u");
function _classCallCheck$b(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$b, "_classCallCheck$b");
function _defineProperties$b(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$x(descriptor.key), descriptor);
  }
}
__name(_defineProperties$b, "_defineProperties$b");
function _createClass$b(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$b(Constructor.prototype, protoProps), staticProps && _defineProperties$b(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$b, "_createClass$b");
function _callSuper$7(t3, o, e3) {
  return o = _getPrototypeOf$8(o), _possibleConstructorReturn$8(t3, _isNativeReflectConstruct$8() ? Reflect.construct(o, e3 || [], _getPrototypeOf$8(t3).constructor) : o.apply(t3, e3));
}
__name(_callSuper$7, "_callSuper$7");
function _possibleConstructorReturn$8(self2, call) {
  if (call && (_typeof$z(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$8(self2);
}
__name(_possibleConstructorReturn$8, "_possibleConstructorReturn$8");
function _isNativeReflectConstruct$8() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$8 = /* @__PURE__ */ __name(function() {
    return !!t3;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct$8, "_isNativeReflectConstruct$8");
function _getPrototypeOf$8(o) {
  return _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$8(o);
}
__name(_getPrototypeOf$8, "_getPrototypeOf$8");
function _assertThisInitialized$8(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$8, "_assertThisInitialized$8");
function _inherits$8(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$8(subClass, superClass);
}
__name(_inherits$8, "_inherits$8");
function _setPrototypeOf$8(o, p) {
  return _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$8(o, p);
}
__name(_setPrototypeOf$8, "_setPrototypeOf$8");
function _defineProperty$x(obj2, key, value) {
  return key = _toPropertyKey$x(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$x, "_defineProperty$x");
function _toPropertyKey$x(t3) {
  var i2 = _toPrimitive$x(t3, "string");
  return _typeof$z(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$x, "_toPropertyKey$x");
function _toPrimitive$x(t3, r2) {
  if (_typeof$z(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$z(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$x, "_toPrimitive$x");
function _objectWithoutProperties$a(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$a(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$a, "_objectWithoutProperties$a");
function _objectWithoutPropertiesLoose$a(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$a, "_objectWithoutPropertiesLoose$a");
function defaultUniqBy$1(entry) {
  return entry.value;
}
__name(defaultUniqBy$1, "defaultUniqBy$1");
function renderContent$1(content2, props) {
  if (/* @__PURE__ */ React__default.isValidElement(content2))
    return /* @__PURE__ */ React__default.cloneElement(content2, props);
  if (typeof content2 == "function")
    return /* @__PURE__ */ React__default.createElement(content2, props);
  props.ref;
  var otherProps = _objectWithoutProperties$a(props, _excluded$a);
  return /* @__PURE__ */ React__default.createElement(DefaultLegendContent, otherProps);
}
__name(renderContent$1, "renderContent$1");
var EPS$1 = 1, Legend = /* @__PURE__ */ function(_PureComponent) {
  _inherits$8(Legend2, _PureComponent);
  function Legend2() {
    var _this;
    _classCallCheck$b(this, Legend2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
      args[_key] = arguments[_key];
    return _this = _callSuper$7(this, Legend2, [].concat(args)), _defineProperty$x(_assertThisInitialized$8(_this), "lastBoundingBox", {
      width: -1,
      height: -1
    }), _this;
  }
  return __name(Legend2, "Legend"), _createClass$b(Legend2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function() {
      this.updateBBox();
    }, "componentDidMount")
  }, {
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function() {
      this.updateBBox();
    }, "componentDidUpdate")
  }, {
    key: "getBBox",
    value: /* @__PURE__ */ __name(function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var _box = this.wrapperNode.getBoundingClientRect();
        return _box.height = this.wrapperNode.offsetHeight, _box.width = this.wrapperNode.offsetWidth, _box;
      }
      return null;
    }, "getBBox")
  }, {
    key: "updateBBox",
    value: /* @__PURE__ */ __name(function() {
      var onBBoxUpdate = this.props.onBBoxUpdate, box = this.getBBox();
      box ? (Math.abs(box.width - this.lastBoundingBox.width) > EPS$1 || Math.abs(box.height - this.lastBoundingBox.height) > EPS$1) && (this.lastBoundingBox.width = box.width, this.lastBoundingBox.height = box.height, onBBoxUpdate && onBBoxUpdate(box)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, onBBoxUpdate && onBBoxUpdate(null));
    }, "updateBBox")
  }, {
    key: "getBBoxSnapshot",
    value: /* @__PURE__ */ __name(function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? _objectSpread$u({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }, "getBBoxSnapshot")
  }, {
    key: "getDefaultPosition",
    value: /* @__PURE__ */ __name(function(style2) {
      var _this$props = this.props, layout2 = _this$props.layout, align = _this$props.align, verticalAlign2 = _this$props.verticalAlign, margin2 = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight, hPos, vPos;
      if (!style2 || (style2.left === void 0 || style2.left === null) && (style2.right === void 0 || style2.right === null))
        if (align === "center" && layout2 === "vertical") {
          var _box2 = this.getBBoxSnapshot();
          hPos = {
            left: ((chartWidth || 0) - _box2.width) / 2
          };
        } else
          hPos = align === "right" ? {
            right: margin2 && margin2.right || 0
          } : {
            left: margin2 && margin2.left || 0
          };
      if (!style2 || (style2.top === void 0 || style2.top === null) && (style2.bottom === void 0 || style2.bottom === null))
        if (verticalAlign2 === "middle") {
          var _box3 = this.getBBoxSnapshot();
          vPos = {
            top: ((chartHeight || 0) - _box3.height) / 2
          };
        } else
          vPos = verticalAlign2 === "bottom" ? {
            bottom: margin2 && margin2.bottom || 0
          } : {
            top: margin2 && margin2.top || 0
          };
      return _objectSpread$u(_objectSpread$u({}, hPos), vPos);
    }, "getDefaultPosition")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this2 = this, _this$props2 = this.props, content2 = _this$props2.content, width2 = _this$props2.width, height2 = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload, outerStyle = _objectSpread$u(_objectSpread$u({
        position: "absolute",
        width: width2 || "auto",
        height: height2 || "auto"
      }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: /* @__PURE__ */ __name(function(node2) {
          _this2.wrapperNode = node2;
        }, "ref")
      }, renderContent$1(content2, _objectSpread$u(_objectSpread$u({}, this.props), {}, {
        payload: getUniqPayload(payload, payloadUniqBy, defaultUniqBy$1)
      })));
    }, "render")
  }], [{
    key: "getWithHeight",
    value: /* @__PURE__ */ __name(function(item, chartWidth) {
      var layout2 = item.props.layout;
      return layout2 === "vertical" && isNumber(item.props.height) ? {
        height: item.props.height
      } : layout2 === "horizontal" ? {
        width: item.props.width || chartWidth
      } : null;
    }, "getWithHeight")
  }]), Legend2;
}(PureComponent);
_defineProperty$x(Legend, "displayName", "Legend");
_defineProperty$x(Legend, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Symbol$1 = _Symbol, isArguments = isArguments_1, isArray$5 = isArray_1, spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable$1(value) {
  return isArray$5(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
__name(isFlattenable$1, "isFlattenable$1");
var _isFlattenable = isFlattenable$1, arrayPush = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$2(array2, depth, predicate, isStrict, result2) {
  var index2 = -1, length = array2.length;
  for (predicate || (predicate = isFlattenable), result2 || (result2 = []); ++index2 < length; ) {
    var value = array2[index2];
    depth > 0 && predicate(value) ? depth > 1 ? baseFlatten$2(value, depth - 1, predicate, isStrict, result2) : arrayPush(result2, value) : isStrict || (result2[result2.length] = value);
  }
  return result2;
}
__name(baseFlatten$2, "baseFlatten$2");
var _baseFlatten = baseFlatten$2;
function createBaseFor$1(fromRight) {
  return function(object2, iteratee, keysFunc) {
    for (var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length = props.length; length--; ) {
      var key = props[fromRight ? length : ++index2];
      if (iteratee(iterable[key], key, iterable) === !1)
        break;
    }
    return object2;
  };
}
__name(createBaseFor$1, "createBaseFor$1");
var _createBaseFor = createBaseFor$1, createBaseFor = _createBaseFor, baseFor$1 = createBaseFor(), _baseFor = baseFor$1, baseFor = _baseFor, keys$1 = keys_1;
function baseForOwn$2(object2, iteratee) {
  return object2 && baseFor(object2, iteratee, keys$1);
}
__name(baseForOwn$2, "baseForOwn$2");
var _baseForOwn = baseForOwn$2, isArrayLike$2 = isArrayLike_1;
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null)
      return collection;
    if (!isArrayLike$2(collection))
      return eachFunc(collection, iteratee);
    for (var length = collection.length, index2 = fromRight ? length : -1, iterable = Object(collection); (fromRight ? index2-- : ++index2 < length) && iteratee(iterable[index2], index2, iterable) !== !1; )
      ;
    return collection;
  };
}
__name(createBaseEach$1, "createBaseEach$1");
var _createBaseEach = createBaseEach$1, baseForOwn$1 = _baseForOwn, createBaseEach = _createBaseEach, baseEach$3 = createBaseEach(baseForOwn$1), _baseEach = baseEach$3, baseEach$2 = _baseEach, isArrayLike$1 = isArrayLike_1;
function baseMap$2(collection, iteratee) {
  var index2 = -1, result2 = isArrayLike$1(collection) ? Array(collection.length) : [];
  return baseEach$2(collection, function(value, key, collection2) {
    result2[++index2] = iteratee(value, key, collection2);
  }), result2;
}
__name(baseMap$2, "baseMap$2");
var _baseMap = baseMap$2;
function baseSortBy$1(array2, comparer) {
  var length = array2.length;
  for (array2.sort(comparer); length--; )
    array2[length] = array2[length].value;
  return array2;
}
__name(baseSortBy$1, "baseSortBy$1");
var _baseSortBy = baseSortBy$1, isSymbol$2 = isSymbol_1;
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol$2(value), othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol$2(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive)
      return 1;
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive)
      return -1;
  }
  return 0;
}
__name(compareAscending$1, "compareAscending$1");
var _compareAscending = compareAscending$1, compareAscending = _compareAscending;
function compareMultiple$1(object2, other, orders) {
  for (var index2 = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length; ++index2 < length; ) {
    var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
    if (result2) {
      if (index2 >= ordersLength)
        return result2;
      var order2 = orders[index2];
      return result2 * (order2 == "desc" ? -1 : 1);
    }
  }
  return object2.index - other.index;
}
__name(compareMultiple$1, "compareMultiple$1");
var _compareMultiple = compareMultiple$1, arrayMap$1 = _arrayMap, baseGet = _baseGet, baseIteratee$6 = _baseIteratee, baseMap$1 = _baseMap, baseSortBy = _baseSortBy, baseUnary = _baseUnary, compareMultiple = _compareMultiple, identity$9 = identity_1, isArray$4 = isArray_1;
function baseOrderBy$1(collection, iteratees, orders) {
  iteratees.length ? iteratees = arrayMap$1(iteratees, function(iteratee) {
    return isArray$4(iteratee) ? function(value) {
      return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
    } : iteratee;
  }) : iteratees = [identity$9];
  var index2 = -1;
  iteratees = arrayMap$1(iteratees, baseUnary(baseIteratee$6));
  var result2 = baseMap$1(collection, function(value, key, collection2) {
    var criteria = arrayMap$1(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { criteria, index: ++index2, value };
  });
  return baseSortBy(result2, function(object2, other) {
    return compareMultiple(object2, other, orders);
  });
}
__name(baseOrderBy$1, "baseOrderBy$1");
var _baseOrderBy = baseOrderBy$1;
function apply$1(func2, thisArg, args) {
  switch (args.length) {
    case 0:
      return func2.call(thisArg);
    case 1:
      return func2.call(thisArg, args[0]);
    case 2:
      return func2.call(thisArg, args[0], args[1]);
    case 3:
      return func2.call(thisArg, args[0], args[1], args[2]);
  }
  return func2.apply(thisArg, args);
}
__name(apply$1, "apply$1");
var _apply = apply$1, apply = _apply, nativeMax$2 = Math.max;
function overRest$1(func2, start, transform2) {
  return start = nativeMax$2(start === void 0 ? func2.length - 1 : start, 0), function() {
    for (var args = arguments, index2 = -1, length = nativeMax$2(args.length - start, 0), array2 = Array(length); ++index2 < length; )
      array2[index2] = args[start + index2];
    index2 = -1;
    for (var otherArgs = Array(start + 1); ++index2 < start; )
      otherArgs[index2] = args[index2];
    return otherArgs[start] = transform2(array2), apply(func2, this, otherArgs);
  };
}
__name(overRest$1, "overRest$1");
var _overRest = overRest$1;
function constant$2(value) {
  return function() {
    return value;
  };
}
__name(constant$2, "constant$2");
var constant_1 = constant$2, getNative = _getNative, defineProperty$2 = function() {
  try {
    var func2 = getNative(Object, "defineProperty");
    return func2({}, "", {}), func2;
  } catch {
  }
}(), _defineProperty$w = defineProperty$2, constant$1 = constant_1, defineProperty$1 = _defineProperty$w, identity$8 = identity_1, baseSetToString$1 = defineProperty$1 ? function(func2, string2) {
  return defineProperty$1(func2, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant$1(string2),
    writable: !0
  });
} : identity$8, _baseSetToString = baseSetToString$1, HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut$1(func2) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    if (lastCalled = stamp, remaining > 0) {
      if (++count >= HOT_COUNT)
        return arguments[0];
    } else
      count = 0;
    return func2.apply(void 0, arguments);
  };
}
__name(shortOut$1, "shortOut$1");
var _shortOut = shortOut$1, baseSetToString = _baseSetToString, shortOut = _shortOut, setToString$1 = shortOut(baseSetToString), _setToString = setToString$1, identity$7 = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$1(func2, start) {
  return setToString(overRest(func2, start, identity$7), func2 + "");
}
__name(baseRest$1, "baseRest$1");
var _baseRest = baseRest$1, eq = eq_1, isArrayLike = isArrayLike_1, isIndex = _isIndex, isObject$3 = isObject_1;
function isIterateeCall$4(value, index2, object2) {
  if (!isObject$3(object2))
    return !1;
  var type = typeof index2;
  return (type == "number" ? isArrayLike(object2) && isIndex(index2, object2.length) : type == "string" && index2 in object2) ? eq(object2[index2], value) : !1;
}
__name(isIterateeCall$4, "isIterateeCall$4");
var _isIterateeCall = isIterateeCall$4, baseFlatten$1 = _baseFlatten, baseOrderBy = _baseOrderBy, baseRest = _baseRest, isIterateeCall$3 = _isIterateeCall, sortBy = baseRest(function(collection, iteratees) {
  if (collection == null)
    return [];
  var length = iteratees.length;
  return length > 1 && isIterateeCall$3(collection, iteratees[0], iteratees[1]) ? iteratees = [] : length > 2 && isIterateeCall$3(iteratees[0], iteratees[1], iteratees[2]) && (iteratees = [iteratees[0]]), baseOrderBy(collection, baseFlatten$1(iteratees, 1), []);
}), sortBy_1 = sortBy;
const sortBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(sortBy_1);
function _typeof$y(o) {
  "@babel/helpers - typeof";
  return _typeof$y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$y(o);
}
__name(_typeof$y, "_typeof$y");
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$j.apply(this, arguments);
}
__name(_extends$j, "_extends$j");
function _slicedToArray$c(arr, i2) {
  return _arrayWithHoles$d(arr) || _iterableToArrayLimit$c(arr, i2) || _unsupportedIterableToArray$k(arr, i2) || _nonIterableRest$d();
}
__name(_slicedToArray$c, "_slicedToArray$c");
function _nonIterableRest$d() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$d, "_nonIterableRest$d");
function _unsupportedIterableToArray$k(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$k(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$k(o, minLen);
  }
}
__name(_unsupportedIterableToArray$k, "_unsupportedIterableToArray$k");
function _arrayLikeToArray$k(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$k, "_arrayLikeToArray$k");
function _iterableToArrayLimit$c(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$c, "_iterableToArrayLimit$c");
function _arrayWithHoles$d(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$d, "_arrayWithHoles$d");
function ownKeys$t(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$t, "ownKeys$t");
function _objectSpread$t(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$t(Object(t3), !0).forEach(function(r3) {
      _defineProperty$v(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$t(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$t, "_objectSpread$t");
function _defineProperty$v(obj2, key, value) {
  return key = _toPropertyKey$w(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$v, "_defineProperty$v");
function _toPropertyKey$w(t3) {
  var i2 = _toPrimitive$w(t3, "string");
  return _typeof$y(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$w, "_toPropertyKey$w");
function _toPrimitive$w(t3, r2) {
  if (_typeof$y(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$y(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$w, "_toPrimitive$w");
function defaultFormatter(value) {
  return Array.isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1]) ? value.join(" ~ ") : value;
}
__name(defaultFormatter, "defaultFormatter");
var DefaultTooltipContent = /* @__PURE__ */ __name(function(props) {
  var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? !1 : _props$accessibilityL, renderContent2 = /* @__PURE__ */ __name(function() {
    if (payload && payload.length) {
      var listStyle = {
        padding: 0,
        margin: 0
      }, items = (itemSorter ? sortBy$1(payload, itemSorter) : payload).map(function(entry, i2) {
        if (entry.type === "none")
          return null;
        var finalItemStyle = _objectSpread$t({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: entry.color || "#000"
        }, itemStyle), finalFormatter = entry.formatter || formatter || defaultFormatter, value = entry.value, name2 = entry.name, finalValue = value, finalName = name2;
        if (finalFormatter && finalValue != null && finalName != null) {
          var formatted = finalFormatter(value, name2, entry, i2, payload);
          if (Array.isArray(formatted)) {
            var _formatted = _slicedToArray$c(formatted, 2);
            finalValue = _formatted[0], finalName = _formatted[1];
          } else
            finalValue = formatted;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ React__default.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(i2),
            style: finalItemStyle
          }, isNumOrStr(finalName) ? /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, finalName) : null, isNumOrStr(finalName) ? /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, separator) : null, /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, finalValue), /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, entry.unit || ""))
        );
      });
      return /* @__PURE__ */ React__default.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: listStyle
      }, items);
    }
    return null;
  }, "renderContent"), finalStyle = _objectSpread$t({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, contentStyle), finalLabelStyle = _objectSpread$t({
    margin: 0
  }, labelStyle), hasLabel = !isNil$1(label), finalLabel = hasLabel ? label : "", wrapperCN = clsx("recharts-default-tooltip", wrapperClassName), labelCN = clsx("recharts-tooltip-label", labelClassName);
  hasLabel && labelFormatter && payload !== void 0 && payload !== null && (finalLabel = labelFormatter(label, payload));
  var accessibilityAttributes = accessibilityLayer ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ React__default.createElement("div", _extends$j({
    className: wrapperCN,
    style: finalStyle
  }, accessibilityAttributes), /* @__PURE__ */ React__default.createElement("p", {
    className: labelCN,
    style: finalLabelStyle
  }, /* @__PURE__ */ React__default.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent2());
}, "DefaultTooltipContent");
function _typeof$x(o) {
  "@babel/helpers - typeof";
  return _typeof$x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$x(o);
}
__name(_typeof$x, "_typeof$x");
function _defineProperty$u(obj2, key, value) {
  return key = _toPropertyKey$v(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$u, "_defineProperty$u");
function _toPropertyKey$v(t3) {
  var i2 = _toPrimitive$v(t3, "string");
  return _typeof$x(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$v, "_toPropertyKey$v");
function _toPrimitive$v(t3, r2) {
  if (_typeof$x(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$x(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$v, "_toPrimitive$v");
var CSS_CLASS_PREFIX = "recharts-tooltip-wrapper", TOOLTIP_HIDDEN = {
  visibility: "hidden"
};
function getTooltipCSSClassName(_ref) {
  var coordinate = _ref.coordinate, translateX2 = _ref.translateX, translateY2 = _ref.translateY;
  return clsx(CSS_CLASS_PREFIX, _defineProperty$u(_defineProperty$u(_defineProperty$u(_defineProperty$u({}, "".concat(CSS_CLASS_PREFIX, "-right"), isNumber(translateX2) && coordinate && isNumber(coordinate.x) && translateX2 >= coordinate.x), "".concat(CSS_CLASS_PREFIX, "-left"), isNumber(translateX2) && coordinate && isNumber(coordinate.x) && translateX2 < coordinate.x), "".concat(CSS_CLASS_PREFIX, "-bottom"), isNumber(translateY2) && coordinate && isNumber(coordinate.y) && translateY2 >= coordinate.y), "".concat(CSS_CLASS_PREFIX, "-top"), isNumber(translateY2) && coordinate && isNumber(coordinate.y) && translateY2 < coordinate.y));
}
__name(getTooltipCSSClassName, "getTooltipCSSClassName");
function getTooltipTranslateXY(_ref2) {
  var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position2 = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
  if (position2 && isNumber(position2[key]))
    return position2[key];
  var negative2 = coordinate[key] - tooltipDimension - offsetTopLeft, positive = coordinate[key] + offsetTopLeft;
  if (allowEscapeViewBox[key])
    return reverseDirection[key] ? negative2 : positive;
  if (reverseDirection[key]) {
    var _tooltipBoundary = negative2, _viewBoxBoundary = viewBox[key];
    return _tooltipBoundary < _viewBoxBoundary ? Math.max(positive, viewBox[key]) : Math.max(negative2, viewBox[key]);
  }
  var tooltipBoundary = positive + tooltipDimension, viewBoxBoundary = viewBox[key] + viewBoxDimension;
  return tooltipBoundary > viewBoxBoundary ? Math.max(negative2, viewBox[key]) : Math.max(positive, viewBox[key]);
}
__name(getTooltipTranslateXY, "getTooltipTranslateXY");
function getTransformStyle(_ref3) {
  var translateX2 = _ref3.translateX, translateY2 = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
  return {
    transform: useTranslate3d ? "translate3d(".concat(translateX2, "px, ").concat(translateY2, "px, 0)") : "translate(".concat(translateX2, "px, ").concat(translateY2, "px)")
  };
}
__name(getTransformStyle, "getTransformStyle");
function getTooltipTranslate(_ref4) {
  var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position2 = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox, cssProperties, translateX2, translateY2;
  return tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate ? (translateX2 = getTooltipTranslateXY({
    allowEscapeViewBox,
    coordinate,
    key: "x",
    offsetTopLeft,
    position: position2,
    reverseDirection,
    tooltipDimension: tooltipBox.width,
    viewBox,
    viewBoxDimension: viewBox.width
  }), translateY2 = getTooltipTranslateXY({
    allowEscapeViewBox,
    coordinate,
    key: "y",
    offsetTopLeft,
    position: position2,
    reverseDirection,
    tooltipDimension: tooltipBox.height,
    viewBox,
    viewBoxDimension: viewBox.height
  }), cssProperties = getTransformStyle({
    translateX: translateX2,
    translateY: translateY2,
    useTranslate3d
  })) : cssProperties = TOOLTIP_HIDDEN, {
    cssProperties,
    cssClasses: getTooltipCSSClassName({
      translateX: translateX2,
      translateY: translateY2,
      coordinate
    })
  };
}
__name(getTooltipTranslate, "getTooltipTranslate");
function _typeof$w(o) {
  "@babel/helpers - typeof";
  return _typeof$w = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$w(o);
}
__name(_typeof$w, "_typeof$w");
function ownKeys$s(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$s, "ownKeys$s");
function _objectSpread$s(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$s(Object(t3), !0).forEach(function(r3) {
      _defineProperty$t(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$s(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$s, "_objectSpread$s");
function _classCallCheck$a(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$a, "_classCallCheck$a");
function _defineProperties$a(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$u(descriptor.key), descriptor);
  }
}
__name(_defineProperties$a, "_defineProperties$a");
function _createClass$a(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$a(Constructor.prototype, protoProps), staticProps && _defineProperties$a(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$a, "_createClass$a");
function _callSuper$6(t3, o, e3) {
  return o = _getPrototypeOf$7(o), _possibleConstructorReturn$7(t3, _isNativeReflectConstruct$7() ? Reflect.construct(o, e3 || [], _getPrototypeOf$7(t3).constructor) : o.apply(t3, e3));
}
__name(_callSuper$6, "_callSuper$6");
function _possibleConstructorReturn$7(self2, call) {
  if (call && (_typeof$w(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$7(self2);
}
__name(_possibleConstructorReturn$7, "_possibleConstructorReturn$7");
function _isNativeReflectConstruct$7() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$7 = /* @__PURE__ */ __name(function() {
    return !!t3;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct$7, "_isNativeReflectConstruct$7");
function _getPrototypeOf$7(o) {
  return _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$7(o);
}
__name(_getPrototypeOf$7, "_getPrototypeOf$7");
function _assertThisInitialized$7(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$7, "_assertThisInitialized$7");
function _inherits$7(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$7(subClass, superClass);
}
__name(_inherits$7, "_inherits$7");
function _setPrototypeOf$7(o, p) {
  return _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$7(o, p);
}
__name(_setPrototypeOf$7, "_setPrototypeOf$7");
function _defineProperty$t(obj2, key, value) {
  return key = _toPropertyKey$u(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$t, "_defineProperty$t");
function _toPropertyKey$u(t3) {
  var i2 = _toPrimitive$u(t3, "string");
  return _typeof$w(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$u, "_toPropertyKey$u");
function _toPrimitive$u(t3, r2) {
  if (_typeof$w(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$w(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$u, "_toPrimitive$u");
var EPSILON = 1, TooltipBoundingBox = /* @__PURE__ */ function(_PureComponent) {
  _inherits$7(TooltipBoundingBox2, _PureComponent);
  function TooltipBoundingBox2() {
    var _this;
    _classCallCheck$a(this, TooltipBoundingBox2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
      args[_key] = arguments[_key];
    return _this = _callSuper$6(this, TooltipBoundingBox2, [].concat(args)), _defineProperty$t(_assertThisInitialized$7(_this), "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), _defineProperty$t(_assertThisInitialized$7(_this), "handleKeyDown", function(event) {
      if (event.key === "Escape") {
        var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
        _this.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
            y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
          }
        });
      }
    }), _this;
  }
  return __name(TooltipBoundingBox2, "TooltipBoundingBox"), _createClass$a(TooltipBoundingBox2, [{
    key: "updateBBox",
    value: /* @__PURE__ */ __name(function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();
        (Math.abs(box.width - this.state.lastBoundingBox.width) > EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > EPSILON) && this.setState({
          lastBoundingBox: {
            width: box.width,
            height: box.height
          }
        });
      } else
        (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
    }, "updateBBox")
  }, {
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }, "componentDidMount")
  }, {
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }, "componentWillUnmount")
  }, {
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function() {
      var _this$props$coordinat5, _this$props$coordinat6;
      this.props.active && this.updateBBox(), this.state.dismissed && (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }, "componentDidUpdate")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this2 = this, _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration2 = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position2 = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle, _getTooltipTranslate = getTooltipTranslate({
        allowEscapeViewBox,
        coordinate,
        offsetTopLeft: offset,
        position: position2,
        reverseDirection,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d,
        viewBox
      }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties, outerStyle = _objectSpread$s(_objectSpread$s({
        transition: isAnimationActive && active ? "transform ".concat(animationDuration2, "ms ").concat(animationEasing) : void 0
      }, cssProperties), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, wrapperStyle);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ React__default.createElement("div", {
          tabIndex: -1,
          className: cssClasses,
          style: outerStyle,
          ref: /* @__PURE__ */ __name(function(node2) {
            _this2.wrapperNode = node2;
          }, "ref")
        }, children)
      );
    }, "render")
  }]), TooltipBoundingBox2;
}(PureComponent), parseIsSsrByDefault = /* @__PURE__ */ __name(function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, "parseIsSsrByDefault"), Global = {
  isSsr: parseIsSsrByDefault(),
  get: /* @__PURE__ */ __name(function(key) {
    return Global[key];
  }, "get"),
  set: /* @__PURE__ */ __name(function(key, value) {
    if (typeof key == "string")
      Global[key] = value;
    else {
      var keys2 = Object.keys(key);
      keys2 && keys2.length && keys2.forEach(function(k3) {
        Global[k3] = key[k3];
      });
    }
  }, "set")
};
function _typeof$v(o) {
  "@babel/helpers - typeof";
  return _typeof$v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$v(o);
}
__name(_typeof$v, "_typeof$v");
function ownKeys$r(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$r, "ownKeys$r");
function _objectSpread$r(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$r(Object(t3), !0).forEach(function(r3) {
      _defineProperty$s(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$r(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$r, "_objectSpread$r");
function _classCallCheck$9(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$9, "_classCallCheck$9");
function _defineProperties$9(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$t(descriptor.key), descriptor);
  }
}
__name(_defineProperties$9, "_defineProperties$9");
function _createClass$9(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$9(Constructor.prototype, protoProps), staticProps && _defineProperties$9(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$9, "_createClass$9");
function _callSuper$5(t3, o, e3) {
  return o = _getPrototypeOf$6(o), _possibleConstructorReturn$6(t3, _isNativeReflectConstruct$6() ? Reflect.construct(o, e3 || [], _getPrototypeOf$6(t3).constructor) : o.apply(t3, e3));
}
__name(_callSuper$5, "_callSuper$5");
function _possibleConstructorReturn$6(self2, call) {
  if (call && (_typeof$v(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$6(self2);
}
__name(_possibleConstructorReturn$6, "_possibleConstructorReturn$6");
function _assertThisInitialized$6(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$6, "_assertThisInitialized$6");
function _isNativeReflectConstruct$6() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$6 = /* @__PURE__ */ __name(function() {
    return !!t3;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct$6, "_isNativeReflectConstruct$6");
function _getPrototypeOf$6(o) {
  return _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$6(o);
}
__name(_getPrototypeOf$6, "_getPrototypeOf$6");
function _inherits$6(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$6(subClass, superClass);
}
__name(_inherits$6, "_inherits$6");
function _setPrototypeOf$6(o, p) {
  return _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$6(o, p);
}
__name(_setPrototypeOf$6, "_setPrototypeOf$6");
function _defineProperty$s(obj2, key, value) {
  return key = _toPropertyKey$t(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$s, "_defineProperty$s");
function _toPropertyKey$t(t3) {
  var i2 = _toPrimitive$t(t3, "string");
  return _typeof$v(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$t, "_toPropertyKey$t");
function _toPrimitive$t(t3, r2) {
  if (_typeof$v(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$v(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$t, "_toPrimitive$t");
function defaultUniqBy(entry) {
  return entry.dataKey;
}
__name(defaultUniqBy, "defaultUniqBy");
function renderContent(content2, props) {
  return /* @__PURE__ */ React__default.isValidElement(content2) ? /* @__PURE__ */ React__default.cloneElement(content2, props) : typeof content2 == "function" ? /* @__PURE__ */ React__default.createElement(content2, props) : /* @__PURE__ */ React__default.createElement(DefaultTooltipContent, props);
}
__name(renderContent, "renderContent");
var Tooltip = /* @__PURE__ */ function(_PureComponent) {
  _inherits$6(Tooltip2, _PureComponent);
  function Tooltip2() {
    return _classCallCheck$9(this, Tooltip2), _callSuper$5(this, Tooltip2, arguments);
  }
  return __name(Tooltip2, "Tooltip"), _createClass$9(Tooltip2, [{
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this = this, _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration2 = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content2 = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position2 = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle, finalPayload = payload ?? [];
      filterNull && finalPayload.length && (finalPayload = getUniqPayload(payload.filter(function(entry) {
        return entry.value != null && (entry.hide !== !0 || _this.props.includeHidden);
      }), payloadUniqBy, defaultUniqBy));
      var hasPayload = finalPayload.length > 0;
      return /* @__PURE__ */ React__default.createElement(TooltipBoundingBox, {
        allowEscapeViewBox,
        animationDuration: animationDuration2,
        animationEasing,
        isAnimationActive,
        active,
        coordinate,
        hasPayload,
        offset,
        position: position2,
        reverseDirection,
        useTranslate3d,
        viewBox,
        wrapperStyle
      }, renderContent(content2, _objectSpread$r(_objectSpread$r({}, this.props), {}, {
        payload: finalPayload
      })));
    }, "render")
  }]), Tooltip2;
}(PureComponent);
_defineProperty$s(Tooltip, "displayName", "Tooltip");
_defineProperty$s(Tooltip, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Global.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var root = _root, now$1 = /* @__PURE__ */ __name(function() {
  return root.Date.now();
}, "now$1"), now_1 = now$1, reWhitespace = /\s/;
function trimmedEndIndex$1(string2) {
  for (var index2 = string2.length; index2-- && reWhitespace.test(string2.charAt(index2)); )
    ;
  return index2;
}
__name(trimmedEndIndex$1, "trimmedEndIndex$1");
var _trimmedEndIndex = trimmedEndIndex$1, trimmedEndIndex = _trimmedEndIndex, reTrimStart = /^\s+/;
function baseTrim$1(string2) {
  return string2 && string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "");
}
__name(baseTrim$1, "baseTrim$1");
var _baseTrim = baseTrim$1, baseTrim = _baseTrim, isObject$2 = isObject_1, isSymbol$1 = isSymbol_1, NAN = 0 / 0, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber$2(value) {
  if (typeof value == "number")
    return value;
  if (isSymbol$1(value))
    return NAN;
  if (isObject$2(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$2(other) ? other + "" : other;
  }
  if (typeof value != "string")
    return value === 0 ? value : +value;
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
__name(toNumber$2, "toNumber$2");
var toNumber_1 = toNumber$2, isObject$1 = isObject_1, now = now_1, toNumber$1 = toNumber_1, FUNC_ERROR_TEXT$1 = "Expected a function", nativeMax$1 = Math.max, nativeMin = Math.min;
function debounce$1(func2, wait, options) {
  var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = !1, maxing = !1, trailing = !0;
  if (typeof func2 != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  wait = toNumber$1(wait) || 0, isObject$1(options) && (leading = !!options.leading, maxing = "maxWait" in options, maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait, trailing = "trailing" in options ? !!options.trailing : trailing);
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    return lastArgs = lastThis = void 0, lastInvokeTime = time2, result2 = func2.apply(thisArg, args), result2;
  }
  __name(invokeFunc, "invokeFunc");
  function leadingEdge(time2) {
    return lastInvokeTime = time2, timerId = setTimeout(timerExpired, wait), leading ? invokeFunc(time2) : result2;
  }
  __name(leadingEdge, "leadingEdge");
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  __name(remainingWait, "remainingWait");
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  __name(shouldInvoke, "shouldInvoke");
  function timerExpired() {
    var time2 = now();
    if (shouldInvoke(time2))
      return trailingEdge(time2);
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  __name(timerExpired, "timerExpired");
  function trailingEdge(time2) {
    return timerId = void 0, trailing && lastArgs ? invokeFunc(time2) : (lastArgs = lastThis = void 0, result2);
  }
  __name(trailingEdge, "trailingEdge");
  function cancel() {
    timerId !== void 0 && clearTimeout(timerId), lastInvokeTime = 0, lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  __name(cancel, "cancel");
  function flush() {
    return timerId === void 0 ? result2 : trailingEdge(now());
  }
  __name(flush, "flush");
  function debounced() {
    var time2 = now(), isInvoking = shouldInvoke(time2);
    if (lastArgs = arguments, lastThis = this, lastCallTime = time2, isInvoking) {
      if (timerId === void 0)
        return leadingEdge(lastCallTime);
      if (maxing)
        return clearTimeout(timerId), timerId = setTimeout(timerExpired, wait), invokeFunc(lastCallTime);
    }
    return timerId === void 0 && (timerId = setTimeout(timerExpired, wait)), result2;
  }
  return __name(debounced, "debounced"), debounced.cancel = cancel, debounced.flush = flush, debounced;
}
__name(debounce$1, "debounce$1");
var debounce_1 = debounce$1, debounce = debounce_1, isObject = isObject_1, FUNC_ERROR_TEXT = "Expected a function";
function throttle(func2, wait, options) {
  var leading = !0, trailing = !0;
  if (typeof func2 != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return isObject(options) && (leading = "leading" in options ? !!options.leading : leading, trailing = "trailing" in options ? !!options.trailing : trailing), debounce(func2, wait, {
    leading,
    maxWait: wait,
    trailing
  });
}
__name(throttle, "throttle");
var throttle_1 = throttle;
const throttle$1 = /* @__PURE__ */ getDefaultExportFromCjs(throttle_1);
function _typeof$u(o) {
  "@babel/helpers - typeof";
  return _typeof$u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$u(o);
}
__name(_typeof$u, "_typeof$u");
function ownKeys$q(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$q, "ownKeys$q");
function _objectSpread$q(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$q(Object(t3), !0).forEach(function(r3) {
      _defineProperty$r(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$q(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$q, "_objectSpread$q");
function _defineProperty$r(obj2, key, value) {
  return key = _toPropertyKey$s(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$r, "_defineProperty$r");
function _toPropertyKey$s(t3) {
  var i2 = _toPrimitive$s(t3, "string");
  return _typeof$u(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$s, "_toPropertyKey$s");
function _toPrimitive$s(t3, r2) {
  if (_typeof$u(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$u(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$s, "_toPrimitive$s");
function _slicedToArray$b(arr, i2) {
  return _arrayWithHoles$c(arr) || _iterableToArrayLimit$b(arr, i2) || _unsupportedIterableToArray$j(arr, i2) || _nonIterableRest$c();
}
__name(_slicedToArray$b, "_slicedToArray$b");
function _nonIterableRest$c() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$c, "_nonIterableRest$c");
function _unsupportedIterableToArray$j(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$j(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$j(o, minLen);
  }
}
__name(_unsupportedIterableToArray$j, "_unsupportedIterableToArray$j");
function _arrayLikeToArray$j(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$j, "_arrayLikeToArray$j");
function _iterableToArrayLimit$b(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$b, "_iterableToArrayLimit$b");
function _arrayWithHoles$c(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$c, "_arrayWithHoles$c");
var ResponsiveContainer = /* @__PURE__ */ forwardRef(function(_ref, ref) {
  var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
    width: -1,
    height: -1
  } : _ref$initialDimension, _ref$width = _ref.width, width2 = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height2 = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth2 = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight2 = _ref.minHeight, maxHeight2 = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce2 = _ref$debounce === void 0 ? 0 : _ref$debounce, id2 = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style2 = _ref$style === void 0 ? {} : _ref$style, containerRef = useRef(null), onResizeRef = useRef();
  onResizeRef.current = onResize, useImperativeHandle(ref, function() {
    return Object.defineProperty(containerRef.current, "current", {
      get: /* @__PURE__ */ __name(function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), containerRef.current;
      }, "get"),
      configurable: !0
    });
  });
  var _useState = useState({
    containerWidth: initialDimension.width,
    containerHeight: initialDimension.height
  }), _useState2 = _slicedToArray$b(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1], setContainerSize = useCallback(function(newWidth, newHeight) {
    setSizes(function(prevState) {
      var roundedWidth = Math.round(newWidth), roundedHeight = Math.round(newHeight);
      return prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight ? prevState : {
        containerWidth: roundedWidth,
        containerHeight: roundedHeight
      };
    });
  }, []);
  useEffect(function() {
    var callback = /* @__PURE__ */ __name(function(entries) {
      var _onResizeRef$current, _entries$0$contentRec = entries[0].contentRect, containerWidth2 = _entries$0$contentRec.width, containerHeight2 = _entries$0$contentRec.height;
      setContainerSize(containerWidth2, containerHeight2), (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth2, containerHeight2);
    }, "callback");
    debounce2 > 0 && (callback = throttle$1(callback, debounce2, {
      trailing: !0,
      leading: !1
    }));
    var observer = new ResizeObserver(callback), _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
    return setContainerSize(containerWidth, containerHeight), observer.observe(containerRef.current), function() {
      observer.disconnect();
    };
  }, [setContainerSize, debounce2]);
  var chartContent = useMemo(function() {
    var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
    if (containerWidth < 0 || containerHeight < 0)
      return null;
    warn$1(isPercent(width2) || isPercent(height2), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, width2, height2), warn$1(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
    var calculatedWidth = isPercent(width2) ? containerWidth : width2, calculatedHeight = isPercent(height2) ? containerHeight : height2;
    aspect && aspect > 0 && (calculatedWidth ? calculatedHeight = calculatedWidth / aspect : calculatedHeight && (calculatedWidth = calculatedHeight * aspect), maxHeight2 && calculatedHeight > maxHeight2 && (calculatedHeight = maxHeight2)), warn$1(calculatedWidth > 0 || calculatedHeight > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, calculatedWidth, calculatedHeight, width2, height2, minWidth2, minHeight2, aspect);
    var isCharts = !Array.isArray(children) && reactIsExports.isElement(children) && getDisplayName(children.type).endsWith("Chart");
    return React__default.Children.map(children, function(child) {
      return reactIsExports.isElement(child) ? /* @__PURE__ */ cloneElement(child, _objectSpread$q({
        width: calculatedWidth,
        height: calculatedHeight
      }, isCharts ? {
        style: _objectSpread$q({
          height: "100%",
          width: "100%",
          maxHeight: calculatedHeight,
          maxWidth: calculatedWidth
        }, child.props.style)
      } : {})) : child;
    });
  }, [aspect, children, height2, maxHeight2, minHeight2, minWidth2, sizes, width2]);
  return /* @__PURE__ */ React__default.createElement("div", {
    id: id2 ? "".concat(id2) : void 0,
    className: clsx("recharts-responsive-container", className),
    style: _objectSpread$q(_objectSpread$q({}, style2), {}, {
      width: width2,
      height: height2,
      minWidth: minWidth2,
      minHeight: minHeight2,
      maxHeight: maxHeight2
    }),
    ref: containerRef
  }, chartContent);
}), Cell = /* @__PURE__ */ __name(function(_props) {
  return null;
}, "Cell");
Cell.displayName = "Cell";
function _typeof$t(o) {
  "@babel/helpers - typeof";
  return _typeof$t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$t(o);
}
__name(_typeof$t, "_typeof$t");
function ownKeys$p(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$p, "ownKeys$p");
function _objectSpread$p(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$p(Object(t3), !0).forEach(function(r3) {
      _defineProperty$q(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$p(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$p, "_objectSpread$p");
function _defineProperty$q(obj2, key, value) {
  return key = _toPropertyKey$r(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$q, "_defineProperty$q");
function _toPropertyKey$r(t3) {
  var i2 = _toPrimitive$r(t3, "string");
  return _typeof$t(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$r, "_toPropertyKey$r");
function _toPrimitive$r(t3, r2) {
  if (_typeof$t(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$t(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$r, "_toPrimitive$r");
var stringCache = {
  widthCache: {},
  cacheCount: 0
}, MAX_CACHE_NUM = 2e3, SPAN_STYLE = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function removeInvalidKeys(obj2) {
  var copyObj = _objectSpread$p({}, obj2);
  return Object.keys(copyObj).forEach(function(key) {
    copyObj[key] || delete copyObj[key];
  }), copyObj;
}
__name(removeInvalidKeys, "removeInvalidKeys");
var getStringSize = /* @__PURE__ */ __name(function(text2) {
  var style2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (text2 == null || Global.isSsr)
    return {
      width: 0,
      height: 0
    };
  var copyStyle = removeInvalidKeys(style2), cacheKey = JSON.stringify({
    text: text2,
    copyStyle
  });
  if (stringCache.widthCache[cacheKey])
    return stringCache.widthCache[cacheKey];
  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
    measurementSpan || (measurementSpan = document.createElement("span"), measurementSpan.setAttribute("id", MEASUREMENT_SPAN_ID), measurementSpan.setAttribute("aria-hidden", "true"), document.body.appendChild(measurementSpan));
    var measurementSpanStyle = _objectSpread$p(_objectSpread$p({}, SPAN_STYLE), copyStyle);
    Object.assign(measurementSpan.style, measurementSpanStyle), measurementSpan.textContent = "".concat(text2);
    var rect = measurementSpan.getBoundingClientRect(), result2 = {
      width: rect.width,
      height: rect.height
    };
    return stringCache.widthCache[cacheKey] = result2, ++stringCache.cacheCount > MAX_CACHE_NUM && (stringCache.cacheCount = 0, stringCache.widthCache = {}), result2;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, "getStringSize"), getOffset = /* @__PURE__ */ __name(function(rect) {
  return {
    top: rect.top + window.scrollY - document.documentElement.clientTop,
    left: rect.left + window.scrollX - document.documentElement.clientLeft
  };
}, "getOffset");
function _typeof$s(o) {
  "@babel/helpers - typeof";
  return _typeof$s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$s(o);
}
__name(_typeof$s, "_typeof$s");
function _slicedToArray$a(arr, i2) {
  return _arrayWithHoles$b(arr) || _iterableToArrayLimit$a(arr, i2) || _unsupportedIterableToArray$i(arr, i2) || _nonIterableRest$b();
}
__name(_slicedToArray$a, "_slicedToArray$a");
function _nonIterableRest$b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$b, "_nonIterableRest$b");
function _unsupportedIterableToArray$i(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$i(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$i(o, minLen);
  }
}
__name(_unsupportedIterableToArray$i, "_unsupportedIterableToArray$i");
function _arrayLikeToArray$i(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$i, "_arrayLikeToArray$i");
function _iterableToArrayLimit$a(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$a, "_iterableToArrayLimit$a");
function _arrayWithHoles$b(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$b, "_arrayWithHoles$b");
function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$8, "_classCallCheck$8");
function _defineProperties$8(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$q(descriptor.key), descriptor);
  }
}
__name(_defineProperties$8, "_defineProperties$8");
function _createClass$8(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$8(Constructor.prototype, protoProps), staticProps && _defineProperties$8(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$8, "_createClass$8");
function _toPropertyKey$q(t3) {
  var i2 = _toPrimitive$q(t3, "string");
  return _typeof$s(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$q, "_toPropertyKey$q");
function _toPrimitive$q(t3, r2) {
  if (_typeof$s(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$s(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$q, "_toPrimitive$q");
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, CONVERSION_RATES = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, FIXED_CSS_LENGTH_UNITS = Object.keys(CONVERSION_RATES), STR_NAN = "NaN";
function convertToPx(value, unit2) {
  return value * CONVERSION_RATES[unit2];
}
__name(convertToPx, "convertToPx");
var DecimalCSS = /* @__PURE__ */ function() {
  function DecimalCSS2(num2, unit2) {
    _classCallCheck$8(this, DecimalCSS2), this.num = num2, this.unit = unit2, this.num = num2, this.unit = unit2, Number.isNaN(num2) && (this.unit = ""), unit2 !== "" && !CSS_LENGTH_UNIT_REGEX.test(unit2) && (this.num = NaN, this.unit = ""), FIXED_CSS_LENGTH_UNITS.includes(unit2) && (this.num = convertToPx(num2, unit2), this.unit = "px");
  }
  return __name(DecimalCSS2, "DecimalCSS"), _createClass$8(DecimalCSS2, [{
    key: "add",
    value: /* @__PURE__ */ __name(function(other) {
      return this.unit !== other.unit ? new DecimalCSS2(NaN, "") : new DecimalCSS2(this.num + other.num, this.unit);
    }, "add")
  }, {
    key: "subtract",
    value: /* @__PURE__ */ __name(function(other) {
      return this.unit !== other.unit ? new DecimalCSS2(NaN, "") : new DecimalCSS2(this.num - other.num, this.unit);
    }, "subtract")
  }, {
    key: "multiply",
    value: /* @__PURE__ */ __name(function(other) {
      return this.unit !== "" && other.unit !== "" && this.unit !== other.unit ? new DecimalCSS2(NaN, "") : new DecimalCSS2(this.num * other.num, this.unit || other.unit);
    }, "multiply")
  }, {
    key: "divide",
    value: /* @__PURE__ */ __name(function(other) {
      return this.unit !== "" && other.unit !== "" && this.unit !== other.unit ? new DecimalCSS2(NaN, "") : new DecimalCSS2(this.num / other.num, this.unit || other.unit);
    }, "divide")
  }, {
    key: "toString",
    value: /* @__PURE__ */ __name(function() {
      return "".concat(this.num).concat(this.unit);
    }, "toString")
  }, {
    key: "isNaN",
    value: /* @__PURE__ */ __name(function() {
      return Number.isNaN(this.num);
    }, "isNaN")
  }], [{
    key: "parse",
    value: /* @__PURE__ */ __name(function(str) {
      var _NUM_SPLIT_REGEX$exec, _ref = (_NUM_SPLIT_REGEX$exec = NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = _slicedToArray$a(_ref, 3), numStr = _ref2[1], unit2 = _ref2[2];
      return new DecimalCSS2(parseFloat(numStr), unit2 ?? "");
    }, "parse")
  }]), DecimalCSS2;
}();
function calculateArithmetic(expr) {
  if (expr.includes(STR_NAN))
    return STR_NAN;
  for (var newExpr = expr; newExpr.includes("*") || newExpr.includes("/"); ) {
    var _MULTIPLY_OR_DIVIDE_R, _ref3 = (_MULTIPLY_OR_DIVIDE_R = MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = _slicedToArray$a(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3], lTs = DecimalCSS.parse(leftOperand ?? ""), rTs = DecimalCSS.parse(rightOperand ?? ""), result2 = operator === "*" ? lTs.multiply(rTs) : lTs.divide(rTs);
    if (result2.isNaN())
      return STR_NAN;
    newExpr = newExpr.replace(MULTIPLY_OR_DIVIDE_REGEX, result2.toString());
  }
  for (; newExpr.includes("+") || /.-\d+(?:\.\d+)?/.test(newExpr); ) {
    var _ADD_OR_SUBTRACT_REGE, _ref5 = (_ADD_OR_SUBTRACT_REGE = ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = _slicedToArray$a(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3], _lTs = DecimalCSS.parse(_leftOperand ?? ""), _rTs = DecimalCSS.parse(_rightOperand ?? ""), _result = _operator === "+" ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
    if (_result.isNaN())
      return STR_NAN;
    newExpr = newExpr.replace(ADD_OR_SUBTRACT_REGEX, _result.toString());
  }
  return newExpr;
}
__name(calculateArithmetic, "calculateArithmetic");
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(expr) {
  for (var newExpr = expr; newExpr.includes("("); ) {
    var _PARENTHESES_REGEX$ex = PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = _slicedToArray$a(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
    newExpr = newExpr.replace(PARENTHESES_REGEX, calculateArithmetic(parentheticalExpression));
  }
  return newExpr;
}
__name(calculateParentheses, "calculateParentheses");
function evaluateExpression(expression) {
  var newExpr = expression.replace(/\s+/g, "");
  return newExpr = calculateParentheses(newExpr), newExpr = calculateArithmetic(newExpr), newExpr;
}
__name(evaluateExpression, "evaluateExpression");
function safeEvaluateExpression(expression) {
  try {
    return evaluateExpression(expression);
  } catch {
    return STR_NAN;
  }
}
__name(safeEvaluateExpression, "safeEvaluateExpression");
function reduceCSSCalc(expression) {
  var result2 = safeEvaluateExpression(expression.slice(5, -1));
  return result2 === STR_NAN ? "" : result2;
}
__name(reduceCSSCalc, "reduceCSSCalc");
var _excluded$9 = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], _excluded2$3 = ["dx", "dy", "angle", "className", "breakAll"];
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$i.apply(this, arguments);
}
__name(_extends$i, "_extends$i");
function _objectWithoutProperties$9(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$9(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$9, "_objectWithoutProperties$9");
function _objectWithoutPropertiesLoose$9(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$9, "_objectWithoutPropertiesLoose$9");
function _slicedToArray$9(arr, i2) {
  return _arrayWithHoles$a(arr) || _iterableToArrayLimit$9(arr, i2) || _unsupportedIterableToArray$h(arr, i2) || _nonIterableRest$a();
}
__name(_slicedToArray$9, "_slicedToArray$9");
function _nonIterableRest$a() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$a, "_nonIterableRest$a");
function _unsupportedIterableToArray$h(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$h(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$h(o, minLen);
  }
}
__name(_unsupportedIterableToArray$h, "_unsupportedIterableToArray$h");
function _arrayLikeToArray$h(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$h, "_arrayLikeToArray$h");
function _iterableToArrayLimit$9(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$9, "_iterableToArrayLimit$9");
function _arrayWithHoles$a(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$a, "_arrayWithHoles$a");
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/, calculateWordWidths = /* @__PURE__ */ __name(function(_ref) {
  var children = _ref.children, breakAll = _ref.breakAll, style2 = _ref.style;
  try {
    var words = [];
    isNil$1(children) || (breakAll ? words = children.toString().split("") : words = children.toString().split(BREAKING_SPACES));
    var wordsWithComputedWidth = words.map(function(word) {
      return {
        word,
        width: getStringSize(word, style2).width
      };
    }), spaceWidth = breakAll ? 0 : getStringSize(" ", style2).width;
    return {
      wordsWithComputedWidth,
      spaceWidth
    };
  } catch {
    return null;
  }
}, "calculateWordWidths"), calculateWordsByLines = /* @__PURE__ */ __name(function(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
  var maxLines = _ref2.maxLines, children = _ref2.children, style2 = _ref2.style, breakAll = _ref2.breakAll, shouldLimitLines = isNumber(maxLines), text2 = children, calculate = /* @__PURE__ */ __name(function() {
    var words = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return words.reduce(function(result3, _ref3) {
      var word = _ref3.word, width2 = _ref3.width, currentLine = result3[result3.length - 1];
      if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width2 + spaceWidth < Number(lineWidth)))
        currentLine.words.push(word), currentLine.width += width2 + spaceWidth;
      else {
        var newLine = {
          words: [word],
          width: width2
        };
        result3.push(newLine);
      }
      return result3;
    }, []);
  }, "calculate"), originalResult = calculate(initialWordsWithComputedWith), findLongestLine = /* @__PURE__ */ __name(function(words) {
    return words.reduce(function(a4, b2) {
      return a4.width > b2.width ? a4 : b2;
    });
  }, "findLongestLine");
  if (!shouldLimitLines)
    return originalResult;
  for (var suffix = "…", checkOverflow = /* @__PURE__ */ __name(function(index2) {
    var tempText = text2.slice(0, index2), words = calculateWordWidths({
      breakAll,
      style: style2,
      children: tempText + suffix
    }).wordsWithComputedWidth, result3 = calculate(words), doesOverflow = result3.length > maxLines || findLongestLine(result3).width > Number(lineWidth);
    return [doesOverflow, result3];
  }, "checkOverflow"), start = 0, end = text2.length - 1, iterations = 0, trimmedResult; start <= end && iterations <= text2.length - 1; ) {
    var middle = Math.floor((start + end) / 2), prev = middle - 1, _checkOverflow = checkOverflow(prev), _checkOverflow2 = _slicedToArray$9(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result2 = _checkOverflow2[1], _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = _slicedToArray$9(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
    if (!doesPrevOverflow && !doesMiddleOverflow && (start = middle + 1), doesPrevOverflow && doesMiddleOverflow && (end = middle - 1), !doesPrevOverflow && doesMiddleOverflow) {
      trimmedResult = result2;
      break;
    }
    iterations++;
  }
  return trimmedResult || originalResult;
}, "calculateWordsByLines"), getWordsWithoutCalculate = /* @__PURE__ */ __name(function(children) {
  var words = isNil$1(children) ? [] : children.toString().split(BREAKING_SPACES);
  return [{
    words
  }];
}, "getWordsWithoutCalculate"), getWordsByLines = /* @__PURE__ */ __name(function(_ref4) {
  var width2 = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style2 = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
  if ((width2 || scaleToFit) && !Global.isSsr) {
    var wordsWithComputedWidth, spaceWidth, wordWidths = calculateWordWidths({
      breakAll,
      children,
      style: style2
    });
    if (wordWidths) {
      var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
      wordsWithComputedWidth = wcw, spaceWidth = sw;
    } else
      return getWordsWithoutCalculate(children);
    return calculateWordsByLines({
      breakAll,
      children,
      maxLines,
      style: style2
    }, wordsWithComputedWidth, spaceWidth, width2, scaleToFit);
  }
  return getWordsWithoutCalculate(children);
}, "getWordsByLines"), DEFAULT_FILL = "#808080", Text = /* @__PURE__ */ __name(function(_ref5) {
  var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight2 = _ref5$lineHeight === void 0 ? "1em" : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? "0.71em" : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? !1 : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? "start" : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? "end" : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill2 = _ref5$fill === void 0 ? DEFAULT_FILL : _ref5$fill, props = _objectWithoutProperties$9(_ref5, _excluded$9), wordsByLines = useMemo(function() {
    return getWordsByLines({
      breakAll: props.breakAll,
      children: props.children,
      maxLines: props.maxLines,
      scaleToFit,
      style: props.style,
      width: props.width
    });
  }, [props.breakAll, props.children, props.maxLines, scaleToFit, props.style, props.width]), dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = _objectWithoutProperties$9(props, _excluded2$3);
  if (!isNumOrStr(propsX) || !isNumOrStr(propsY))
    return null;
  var x3 = propsX + (isNumber(dx) ? dx : 0), y4 = propsY + (isNumber(dy) ? dy : 0), startDy;
  switch (verticalAnchor) {
    case "start":
      startDy = reduceCSSCalc("calc(".concat(capHeight, ")"));
      break;
    case "middle":
      startDy = reduceCSSCalc("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight2, " + (").concat(capHeight, " / 2))"));
      break;
    default:
      startDy = reduceCSSCalc("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight2, ")"));
      break;
  }
  var transforms2 = [];
  if (scaleToFit) {
    var lineWidth = wordsByLines[0].width, width2 = props.width;
    transforms2.push("scale(".concat((isNumber(width2) ? width2 / lineWidth : 1) / lineWidth, ")"));
  }
  return angle && transforms2.push("rotate(".concat(angle, ", ").concat(x3, ", ").concat(y4, ")")), transforms2.length && (textProps.transform = transforms2.join(" ")), /* @__PURE__ */ React__default.createElement("text", _extends$i({}, filterProps(textProps, !0), {
    x: x3,
    y: y4,
    className: clsx("recharts-text", className),
    textAnchor,
    fill: fill2.includes("url") ? DEFAULT_FILL : fill2
  }), wordsByLines.map(function(line, index2) {
    var words = line.words.join(breakAll ? "" : " ");
    return /* @__PURE__ */ React__default.createElement("tspan", {
      x: x3,
      dy: index2 === 0 ? startDy : lineHeight2,
      key: words
    }, words);
  }));
}, "Text");
function ascending(a4, b2) {
  return a4 == null || b2 == null ? NaN : a4 < b2 ? -1 : a4 > b2 ? 1 : a4 >= b2 ? 0 : NaN;
}
__name(ascending, "ascending");
function descending(a4, b2) {
  return a4 == null || b2 == null ? NaN : b2 < a4 ? -1 : b2 > a4 ? 1 : b2 >= a4 ? 0 : NaN;
}
__name(descending, "descending");
function bisector(f) {
  let compare1, compare2, delta;
  f.length !== 2 ? (compare1 = ascending, compare2 = /* @__PURE__ */ __name((d3, x3) => ascending(f(d3), x3), "compare2"), delta = /* @__PURE__ */ __name((d3, x3) => f(d3) - x3, "delta")) : (compare1 = f === ascending || f === descending ? f : zero$1, compare2 = f, delta = f);
  function left2(a4, x3, lo = 0, hi = a4.length) {
    if (lo < hi) {
      if (compare1(x3, x3) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        compare2(a4[mid], x3) < 0 ? lo = mid + 1 : hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  __name(left2, "left");
  function right2(a4, x3, lo = 0, hi = a4.length) {
    if (lo < hi) {
      if (compare1(x3, x3) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        compare2(a4[mid], x3) <= 0 ? lo = mid + 1 : hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  __name(right2, "right");
  function center(a4, x3, lo = 0, hi = a4.length) {
    const i2 = left2(a4, x3, lo, hi - 1);
    return i2 > lo && delta(a4[i2 - 1], x3) > -delta(a4[i2], x3) ? i2 - 1 : i2;
  }
  return __name(center, "center"), { left: left2, center, right: right2 };
}
__name(bisector, "bisector");
function zero$1() {
  return 0;
}
__name(zero$1, "zero$1");
function number$2(x3) {
  return x3 === null ? NaN : +x3;
}
__name(number$2, "number$2");
function* numbers(values, valueof) {
  if (valueof === void 0)
    for (let value of values)
      value != null && (value = +value) >= value && (yield value);
  else {
    let index2 = -1;
    for (let value of values)
      (value = valueof(value, ++index2, values)) != null && (value = +value) >= value && (yield value);
  }
}
__name(numbers, "numbers");
const ascendingBisect = bisector(ascending), bisectRight = ascendingBisect.right;
bisector(number$2).center;
const bisect = bisectRight, _InternMap = class _InternMap extends Map {
  constructor(entries, key = keyof) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } }), entries != null)
      for (const [key2, value] of entries)
        this.set(key2, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
};
__name(_InternMap, "InternMap");
let InternMap = _InternMap;
function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
__name(intern_get, "intern_get");
function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : (_intern.set(key, value), value);
}
__name(intern_set, "intern_set");
function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) && (value = _intern.get(key), _intern.delete(key)), value;
}
__name(intern_delete, "intern_delete");
function keyof(value) {
  return value !== null && typeof value == "object" ? value.valueOf() : value;
}
__name(keyof, "keyof");
function compareDefined(compare2 = ascending) {
  if (compare2 === ascending)
    return ascendingDefined;
  if (typeof compare2 != "function")
    throw new TypeError("compare is not a function");
  return (a4, b2) => {
    const x3 = compare2(a4, b2);
    return x3 || x3 === 0 ? x3 : (compare2(b2, b2) === 0) - (compare2(a4, a4) === 0);
  };
}
__name(compareDefined, "compareDefined");
function ascendingDefined(a4, b2) {
  return (a4 == null || !(a4 >= a4)) - (b2 == null || !(b2 >= b2)) || (a4 < b2 ? -1 : a4 > b2 ? 1 : 0);
}
__name(ascendingDefined, "ascendingDefined");
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
  const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  return power < 0 ? (inc = Math.pow(10, -power) / factor, i1 = Math.round(start * inc), i2 = Math.round(stop * inc), i1 / inc < start && ++i1, i2 / inc > stop && --i2, inc = -inc) : (inc = Math.pow(10, power) * factor, i1 = Math.round(start / inc), i2 = Math.round(stop / inc), i1 * inc < start && ++i1, i2 * inc > stop && --i2), i2 < i1 && 0.5 <= count && count < 2 ? tickSpec(start, stop, count * 2) : [i1, i2, inc];
}
__name(tickSpec, "tickSpec");
function ticks(start, stop, count) {
  if (stop = +stop, start = +start, count = +count, !(count > 0))
    return [];
  if (start === stop)
    return [start];
  const reverse3 = stop < start, [i1, i2, inc] = reverse3 ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
  if (!(i2 >= i1))
    return [];
  const n = i2 - i1 + 1, ticks2 = new Array(n);
  if (reverse3)
    if (inc < 0)
      for (let i3 = 0; i3 < n; ++i3)
        ticks2[i3] = (i2 - i3) / -inc;
    else
      for (let i3 = 0; i3 < n; ++i3)
        ticks2[i3] = (i2 - i3) * inc;
  else if (inc < 0)
    for (let i3 = 0; i3 < n; ++i3)
      ticks2[i3] = (i1 + i3) / -inc;
  else
    for (let i3 = 0; i3 < n; ++i3)
      ticks2[i3] = (i1 + i3) * inc;
  return ticks2;
}
__name(ticks, "ticks");
function tickIncrement(start, stop, count) {
  return stop = +stop, start = +start, count = +count, tickSpec(start, stop, count)[2];
}
__name(tickIncrement, "tickIncrement");
function tickStep(start, stop, count) {
  stop = +stop, start = +start, count = +count;
  const reverse3 = stop < start, inc = reverse3 ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
  return (reverse3 ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}
__name(tickStep, "tickStep");
function max$2(values, valueof) {
  let max2;
  if (valueof === void 0)
    for (const value of values)
      value != null && (max2 < value || max2 === void 0 && value >= value) && (max2 = value);
  else {
    let index2 = -1;
    for (let value of values)
      (value = valueof(value, ++index2, values)) != null && (max2 < value || max2 === void 0 && value >= value) && (max2 = value);
  }
  return max2;
}
__name(max$2, "max$2");
function min$2(values, valueof) {
  let min2;
  if (valueof === void 0)
    for (const value of values)
      value != null && (min2 > value || min2 === void 0 && value >= value) && (min2 = value);
  else {
    let index2 = -1;
    for (let value of values)
      (value = valueof(value, ++index2, values)) != null && (min2 > value || min2 === void 0 && value >= value) && (min2 = value);
  }
  return min2;
}
__name(min$2, "min$2");
function quickselect(array2, k3, left2 = 0, right2 = 1 / 0, compare2) {
  if (k3 = Math.floor(k3), left2 = Math.floor(Math.max(0, left2)), right2 = Math.floor(Math.min(array2.length - 1, right2)), !(left2 <= k3 && k3 <= right2))
    return array2;
  for (compare2 = compare2 === void 0 ? ascendingDefined : compareDefined(compare2); right2 > left2; ) {
    if (right2 - left2 > 600) {
      const n = right2 - left2 + 1, m3 = k3 - left2 + 1, z2 = Math.log(n), s4 = 0.5 * Math.exp(2 * z2 / 3), sd = 0.5 * Math.sqrt(z2 * s4 * (n - s4) / n) * (m3 - n / 2 < 0 ? -1 : 1), newLeft = Math.max(left2, Math.floor(k3 - m3 * s4 / n + sd)), newRight = Math.min(right2, Math.floor(k3 + (n - m3) * s4 / n + sd));
      quickselect(array2, k3, newLeft, newRight, compare2);
    }
    const t3 = array2[k3];
    let i2 = left2, j = right2;
    for (swap2(array2, left2, k3), compare2(array2[right2], t3) > 0 && swap2(array2, left2, right2); i2 < j; ) {
      for (swap2(array2, i2, j), ++i2, --j; compare2(array2[i2], t3) < 0; )
        ++i2;
      for (; compare2(array2[j], t3) > 0; )
        --j;
    }
    compare2(array2[left2], t3) === 0 ? swap2(array2, left2, j) : (++j, swap2(array2, j, right2)), j <= k3 && (left2 = j + 1), k3 <= j && (right2 = j - 1);
  }
  return array2;
}
__name(quickselect, "quickselect");
function swap2(array2, i2, j) {
  const t3 = array2[i2];
  array2[i2] = array2[j], array2[j] = t3;
}
__name(swap2, "swap");
function quantile$1(values, p, valueof) {
  if (values = Float64Array.from(numbers(values, valueof)), !(!(n = values.length) || isNaN(p = +p))) {
    if (p <= 0 || n < 2)
      return min$2(values);
    if (p >= 1)
      return max$2(values);
    var n, i2 = (n - 1) * p, i0 = Math.floor(i2), value0 = max$2(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min$2(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i2 - i0);
  }
}
__name(quantile$1, "quantile$1");
function quantileSorted(values, p, valueof = number$2) {
  if (!(!(n = values.length) || isNaN(p = +p))) {
    if (p <= 0 || n < 2)
      return +valueof(values[0], 0, values);
    if (p >= 1)
      return +valueof(values[n - 1], n - 1, values);
    var n, i2 = (n - 1) * p, i0 = Math.floor(i2), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i2 - i0);
  }
}
__name(quantileSorted, "quantileSorted");
function range$3(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
  for (var i2 = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range3 = new Array(n); ++i2 < n; )
    range3[i2] = start + i2 * step;
  return range3;
}
__name(range$3, "range$3");
function initRange(domain, range3) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range3).domain(domain);
      break;
  }
  return this;
}
__name(initRange, "initRange");
function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof domain == "function" ? this.interpolator(domain) : this.range(domain);
      break;
    }
    default: {
      this.domain(domain), typeof interpolator == "function" ? this.interpolator(interpolator) : this.range(interpolator);
      break;
    }
  }
  return this;
}
__name(initInterpolator, "initInterpolator");
const implicit = Symbol("implicit");
function ordinal() {
  var index2 = new InternMap(), domain = [], range3 = [], unknown = implicit;
  function scale2(d3) {
    let i2 = index2.get(d3);
    if (i2 === void 0) {
      if (unknown !== implicit)
        return unknown;
      index2.set(d3, i2 = domain.push(d3) - 1);
    }
    return range3[i2 % range3.length];
  }
  return __name(scale2, "scale"), scale2.domain = function(_) {
    if (!arguments.length)
      return domain.slice();
    domain = [], index2 = new InternMap();
    for (const value of _)
      index2.has(value) || index2.set(value, domain.push(value) - 1);
    return scale2;
  }, scale2.range = function(_) {
    return arguments.length ? (range3 = Array.from(_), scale2) : range3.slice();
  }, scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  }, scale2.copy = function() {
    return ordinal(domain, range3).unknown(unknown);
  }, initRange.apply(scale2, arguments), scale2;
}
__name(ordinal, "ordinal");
function band() {
  var scale2 = ordinal().unknown(void 0), domain = scale2.domain, ordinalRange = scale2.range, r0 = 0, r1 = 1, step, bandwidth, round2 = !1, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale2.unknown;
  function rescale() {
    var n = domain().length, reverse3 = r1 < r0, start = reverse3 ? r1 : r0, stop = reverse3 ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2), round2 && (step = Math.floor(step)), start += (stop - start - step * (n - paddingInner)) * align, bandwidth = step * (1 - paddingInner), round2 && (start = Math.round(start), bandwidth = Math.round(bandwidth));
    var values = range$3(n).map(function(i2) {
      return start + step * i2;
    });
    return ordinalRange(reverse3 ? values.reverse() : values);
  }
  return __name(rescale, "rescale"), scale2.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  }, scale2.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  }, scale2.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round2 = !0, rescale();
  }, scale2.bandwidth = function() {
    return bandwidth;
  }, scale2.step = function() {
    return step;
  }, scale2.round = function(_) {
    return arguments.length ? (round2 = !!_, rescale()) : round2;
  }, scale2.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  }, scale2.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  }, scale2.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  }, scale2.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  }, scale2.copy = function() {
    return band(domain(), [r0, r1]).round(round2).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  }, initRange.apply(rescale(), arguments);
}
__name(band, "band");
function pointish(scale2) {
  var copy2 = scale2.copy;
  return scale2.padding = scale2.paddingOuter, delete scale2.paddingInner, delete scale2.paddingOuter, scale2.copy = function() {
    return pointish(copy2());
  }, scale2;
}
__name(pointish, "pointish");
function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
__name(point, "point");
function define(constructor, factory, prototype2) {
  constructor.prototype = factory.prototype = prototype2, prototype2.constructor = constructor;
}
__name(define, "define");
function extend2(parent2, definition2) {
  var prototype2 = Object.create(parent2.prototype);
  for (var key in definition2)
    prototype2[key] = definition2[key];
  return prototype2;
}
__name(extend2, "extend");
function Color() {
}
__name(Color, "Color");
var darker = 0.7, brighter = 1 / darker, reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`), named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
__name(color_formatHex, "color_formatHex");
function color_formatHex8() {
  return this.rgb().formatHex8();
}
__name(color_formatHex8, "color_formatHex8");
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
__name(color_formatHsl, "color_formatHsl");
function color_formatRgb() {
  return this.rgb().formatRgb();
}
__name(color_formatRgb, "color_formatRgb");
function color(format2) {
  var m3, l;
  return format2 = (format2 + "").trim().toLowerCase(), (m3 = reHex.exec(format2)) ? (l = m3[1].length, m3 = parseInt(m3[1], 16), l === 6 ? rgbn(m3) : l === 3 ? new Rgb(m3 >> 8 & 15 | m3 >> 4 & 240, m3 >> 4 & 15 | m3 & 240, (m3 & 15) << 4 | m3 & 15, 1) : l === 8 ? rgba(m3 >> 24 & 255, m3 >> 16 & 255, m3 >> 8 & 255, (m3 & 255) / 255) : l === 4 ? rgba(m3 >> 12 & 15 | m3 >> 8 & 240, m3 >> 8 & 15 | m3 >> 4 & 240, m3 >> 4 & 15 | m3 & 240, ((m3 & 15) << 4 | m3 & 15) / 255) : null) : (m3 = reRgbInteger.exec(format2)) ? new Rgb(m3[1], m3[2], m3[3], 1) : (m3 = reRgbPercent.exec(format2)) ? new Rgb(m3[1] * 255 / 100, m3[2] * 255 / 100, m3[3] * 255 / 100, 1) : (m3 = reRgbaInteger.exec(format2)) ? rgba(m3[1], m3[2], m3[3], m3[4]) : (m3 = reRgbaPercent.exec(format2)) ? rgba(m3[1] * 255 / 100, m3[2] * 255 / 100, m3[3] * 255 / 100, m3[4]) : (m3 = reHslPercent.exec(format2)) ? hsla(m3[1], m3[2] / 100, m3[3] / 100, 1) : (m3 = reHslaPercent.exec(format2)) ? hsla(m3[1], m3[2] / 100, m3[3] / 100, m3[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
__name(color, "color");
function rgbn(n) {
  return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
__name(rgbn, "rgbn");
function rgba(r2, g, b2, a4) {
  return a4 <= 0 && (r2 = g = b2 = NaN), new Rgb(r2, g, b2, a4);
}
__name(rgba, "rgba");
function rgbConvert(o) {
  return o instanceof Color || (o = color(o)), o ? (o = o.rgb(), new Rgb(o.r, o.g, o.b, o.opacity)) : new Rgb();
}
__name(rgbConvert, "rgbConvert");
function rgb$1(r2, g, b2, opacity2) {
  return arguments.length === 1 ? rgbConvert(r2) : new Rgb(r2, g, b2, opacity2 ?? 1);
}
__name(rgb$1, "rgb$1");
function Rgb(r2, g, b2, opacity2) {
  this.r = +r2, this.g = +g, this.b = +b2, this.opacity = +opacity2;
}
__name(Rgb, "Rgb");
define(Rgb, rgb$1, extend2(Color, {
  brighter(k3) {
    return k3 = k3 == null ? brighter : Math.pow(brighter, k3), new Rgb(this.r * k3, this.g * k3, this.b * k3, this.opacity);
  },
  darker(k3) {
    return k3 = k3 == null ? darker : Math.pow(darker, k3), new Rgb(this.r * k3, this.g * k3, this.b * k3, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
__name(rgb_formatHex, "rgb_formatHex");
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
__name(rgb_formatHex8, "rgb_formatHex8");
function rgb_formatRgb() {
  const a4 = clampa(this.opacity);
  return `${a4 === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a4 === 1 ? ")" : `, ${a4})`}`;
}
__name(rgb_formatRgb, "rgb_formatRgb");
function clampa(opacity2) {
  return isNaN(opacity2) ? 1 : Math.max(0, Math.min(1, opacity2));
}
__name(clampa, "clampa");
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
__name(clampi, "clampi");
function hex(value) {
  return value = clampi(value), (value < 16 ? "0" : "") + value.toString(16);
}
__name(hex, "hex");
function hsla(h3, s4, l, a4) {
  return a4 <= 0 ? h3 = s4 = l = NaN : l <= 0 || l >= 1 ? h3 = s4 = NaN : s4 <= 0 && (h3 = NaN), new Hsl(h3, s4, l, a4);
}
__name(hsla, "hsla");
function hslConvert(o) {
  if (o instanceof Hsl)
    return new Hsl(o.h, o.s, o.l, o.opacity);
  if (o instanceof Color || (o = color(o)), !o)
    return new Hsl();
  if (o instanceof Hsl)
    return o;
  o = o.rgb();
  var r2 = o.r / 255, g = o.g / 255, b2 = o.b / 255, min2 = Math.min(r2, g, b2), max2 = Math.max(r2, g, b2), h3 = NaN, s4 = max2 - min2, l = (max2 + min2) / 2;
  return s4 ? (r2 === max2 ? h3 = (g - b2) / s4 + (g < b2) * 6 : g === max2 ? h3 = (b2 - r2) / s4 + 2 : h3 = (r2 - g) / s4 + 4, s4 /= l < 0.5 ? max2 + min2 : 2 - max2 - min2, h3 *= 60) : s4 = l > 0 && l < 1 ? 0 : h3, new Hsl(h3, s4, l, o.opacity);
}
__name(hslConvert, "hslConvert");
function hsl(h3, s4, l, opacity2) {
  return arguments.length === 1 ? hslConvert(h3) : new Hsl(h3, s4, l, opacity2 ?? 1);
}
__name(hsl, "hsl");
function Hsl(h3, s4, l, opacity2) {
  this.h = +h3, this.s = +s4, this.l = +l, this.opacity = +opacity2;
}
__name(Hsl, "Hsl");
define(Hsl, hsl, extend2(Color, {
  brighter(k3) {
    return k3 = k3 == null ? brighter : Math.pow(brighter, k3), new Hsl(this.h, this.s, this.l * k3, this.opacity);
  },
  darker(k3) {
    return k3 = k3 == null ? darker : Math.pow(darker, k3), new Hsl(this.h, this.s, this.l * k3, this.opacity);
  },
  rgb() {
    var h3 = this.h % 360 + (this.h < 0) * 360, s4 = isNaN(h3) || isNaN(this.s) ? 0 : this.s, l = this.l, m22 = l + (l < 0.5 ? l : 1 - l) * s4, m1 = 2 * l - m22;
    return new Rgb(
      hsl2rgb(h3 >= 240 ? h3 - 240 : h3 + 120, m1, m22),
      hsl2rgb(h3, m1, m22),
      hsl2rgb(h3 < 120 ? h3 + 240 : h3 - 120, m1, m22),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const a4 = clampa(this.opacity);
    return `${a4 === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a4 === 1 ? ")" : `, ${a4})`}`;
  }
}));
function clamph(value) {
  return value = (value || 0) % 360, value < 0 ? value + 360 : value;
}
__name(clamph, "clamph");
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
__name(clampt, "clampt");
function hsl2rgb(h3, m1, m22) {
  return (h3 < 60 ? m1 + (m22 - m1) * h3 / 60 : h3 < 180 ? m22 : h3 < 240 ? m1 + (m22 - m1) * (240 - h3) / 60 : m1) * 255;
}
__name(hsl2rgb, "hsl2rgb");
const constant = /* @__PURE__ */ __name((x3) => () => x3, "constant");
function linear$1(a4, d3) {
  return function(t3) {
    return a4 + t3 * d3;
  };
}
__name(linear$1, "linear$1");
function exponential(a4, b2, y4) {
  return a4 = Math.pow(a4, y4), b2 = Math.pow(b2, y4) - a4, y4 = 1 / y4, function(t3) {
    return Math.pow(a4 + t3 * b2, y4);
  };
}
__name(exponential, "exponential");
function gamma(y4) {
  return (y4 = +y4) == 1 ? nogamma : function(a4, b2) {
    return b2 - a4 ? exponential(a4, b2, y4) : constant(isNaN(a4) ? b2 : a4);
  };
}
__name(gamma, "gamma");
function nogamma(a4, b2) {
  var d3 = b2 - a4;
  return d3 ? linear$1(a4, d3) : constant(isNaN(a4) ? b2 : a4);
}
__name(nogamma, "nogamma");
const rgb = (/* @__PURE__ */ __name(function rgbGamma(y4) {
  var color2 = gamma(y4);
  function rgb2(start, end) {
    var r2 = color2((start = rgb$1(start)).r, (end = rgb$1(end)).r), g = color2(start.g, end.g), b2 = color2(start.b, end.b), opacity2 = nogamma(start.opacity, end.opacity);
    return function(t3) {
      return start.r = r2(t3), start.g = g(t3), start.b = b2(t3), start.opacity = opacity2(t3), start + "";
    };
  }
  return __name(rgb2, "rgb"), rgb2.gamma = rgbGamma, rgb2;
}, "rgbGamma"))(1);
function numberArray(a4, b2) {
  b2 || (b2 = []);
  var n = a4 ? Math.min(b2.length, a4.length) : 0, c3 = b2.slice(), i2;
  return function(t3) {
    for (i2 = 0; i2 < n; ++i2)
      c3[i2] = a4[i2] * (1 - t3) + b2[i2] * t3;
    return c3;
  };
}
__name(numberArray, "numberArray");
function isNumberArray(x3) {
  return ArrayBuffer.isView(x3) && !(x3 instanceof DataView);
}
__name(isNumberArray, "isNumberArray");
function genericArray(a4, b2) {
  var nb = b2 ? b2.length : 0, na = a4 ? Math.min(nb, a4.length) : 0, x3 = new Array(na), c3 = new Array(nb), i2;
  for (i2 = 0; i2 < na; ++i2)
    x3[i2] = interpolate(a4[i2], b2[i2]);
  for (; i2 < nb; ++i2)
    c3[i2] = b2[i2];
  return function(t3) {
    for (i2 = 0; i2 < na; ++i2)
      c3[i2] = x3[i2](t3);
    return c3;
  };
}
__name(genericArray, "genericArray");
function date$1(a4, b2) {
  var d3 = /* @__PURE__ */ new Date();
  return a4 = +a4, b2 = +b2, function(t3) {
    return d3.setTime(a4 * (1 - t3) + b2 * t3), d3;
  };
}
__name(date$1, "date$1");
function interpolateNumber$1(a4, b2) {
  return a4 = +a4, b2 = +b2, function(t3) {
    return a4 * (1 - t3) + b2 * t3;
  };
}
__name(interpolateNumber$1, "interpolateNumber$1");
function object(a4, b2) {
  var i2 = {}, c3 = {}, k3;
  (a4 === null || typeof a4 != "object") && (a4 = {}), (b2 === null || typeof b2 != "object") && (b2 = {});
  for (k3 in b2)
    k3 in a4 ? i2[k3] = interpolate(a4[k3], b2[k3]) : c3[k3] = b2[k3];
  return function(t3) {
    for (k3 in i2)
      c3[k3] = i2[k3](t3);
    return c3;
  };
}
__name(object, "object");
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b2) {
  return function() {
    return b2;
  };
}
__name(zero, "zero");
function one(b2) {
  return function(t3) {
    return b2(t3) + "";
  };
}
__name(one, "one");
function string(a4, b2) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i2 = -1, s4 = [], q2 = [];
  for (a4 = a4 + "", b2 = b2 + ""; (am = reA.exec(a4)) && (bm = reB.exec(b2)); )
    (bs = bm.index) > bi && (bs = b2.slice(bi, bs), s4[i2] ? s4[i2] += bs : s4[++i2] = bs), (am = am[0]) === (bm = bm[0]) ? s4[i2] ? s4[i2] += bm : s4[++i2] = bm : (s4[++i2] = null, q2.push({ i: i2, x: interpolateNumber$1(am, bm) })), bi = reB.lastIndex;
  return bi < b2.length && (bs = b2.slice(bi), s4[i2] ? s4[i2] += bs : s4[++i2] = bs), s4.length < 2 ? q2[0] ? one(q2[0].x) : zero(b2) : (b2 = q2.length, function(t3) {
    for (var i3 = 0, o; i3 < b2; ++i3)
      s4[(o = q2[i3]).i] = o.x(t3);
    return s4.join("");
  });
}
__name(string, "string");
function interpolate(a4, b2) {
  var t3 = typeof b2, c3;
  return b2 == null || t3 === "boolean" ? constant(b2) : (t3 === "number" ? interpolateNumber$1 : t3 === "string" ? (c3 = color(b2)) ? (b2 = c3, rgb) : string : b2 instanceof color ? rgb : b2 instanceof Date ? date$1 : isNumberArray(b2) ? numberArray : Array.isArray(b2) ? genericArray : typeof b2.valueOf != "function" && typeof b2.toString != "function" || isNaN(b2) ? object : interpolateNumber$1)(a4, b2);
}
__name(interpolate, "interpolate");
function interpolateRound(a4, b2) {
  return a4 = +a4, b2 = +b2, function(t3) {
    return Math.round(a4 * (1 - t3) + b2 * t3);
  };
}
__name(interpolateRound, "interpolateRound");
function piecewise(interpolate$12, values) {
  values === void 0 && (values = interpolate$12, interpolate$12 = interpolate);
  for (var i2 = 0, n = values.length - 1, v = values[0], I2 = new Array(n < 0 ? 0 : n); i2 < n; )
    I2[i2] = interpolate$12(v, v = values[++i2]);
  return function(t3) {
    var i3 = Math.max(0, Math.min(n - 1, Math.floor(t3 *= n)));
    return I2[i3](t3 - i3);
  };
}
__name(piecewise, "piecewise");
function constants(x3) {
  return function() {
    return x3;
  };
}
__name(constants, "constants");
function number$1(x3) {
  return +x3;
}
__name(number$1, "number$1");
var unit = [0, 1];
function identity$6(x3) {
  return x3;
}
__name(identity$6, "identity$6");
function normalize(a4, b2) {
  return (b2 -= a4 = +a4) ? function(x3) {
    return (x3 - a4) / b2;
  } : constants(isNaN(b2) ? NaN : 0.5);
}
__name(normalize, "normalize");
function clamper(a4, b2) {
  var t3;
  return a4 > b2 && (t3 = a4, a4 = b2, b2 = t3), function(x3) {
    return Math.max(a4, Math.min(b2, x3));
  };
}
__name(clamper, "clamper");
function bimap(domain, range3, interpolate2) {
  var d0 = domain[0], d1 = domain[1], r0 = range3[0], r1 = range3[1];
  return d1 < d0 ? (d0 = normalize(d1, d0), r0 = interpolate2(r1, r0)) : (d0 = normalize(d0, d1), r0 = interpolate2(r0, r1)), function(x3) {
    return r0(d0(x3));
  };
}
__name(bimap, "bimap");
function polymap(domain, range3, interpolate2) {
  var j = Math.min(domain.length, range3.length) - 1, d3 = new Array(j), r2 = new Array(j), i2 = -1;
  for (domain[j] < domain[0] && (domain = domain.slice().reverse(), range3 = range3.slice().reverse()); ++i2 < j; )
    d3[i2] = normalize(domain[i2], domain[i2 + 1]), r2[i2] = interpolate2(range3[i2], range3[i2 + 1]);
  return function(x3) {
    var i3 = bisect(domain, x3, 1, j) - 1;
    return r2[i3](d3[i3](x3));
  };
}
__name(polymap, "polymap");
function copy$1(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
__name(copy$1, "copy$1");
function transformer$2() {
  var domain = unit, range3 = unit, interpolate$12 = interpolate, transform2, untransform, unknown, clamp2 = identity$6, piecewise2, output, input;
  function rescale() {
    var n = Math.min(domain.length, range3.length);
    return clamp2 !== identity$6 && (clamp2 = clamper(domain[0], domain[n - 1])), piecewise2 = n > 2 ? polymap : bimap, output = input = null, scale2;
  }
  __name(rescale, "rescale");
  function scale2(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown : (output || (output = piecewise2(domain.map(transform2), range3, interpolate$12)))(transform2(clamp2(x3)));
  }
  return __name(scale2, "scale"), scale2.invert = function(y4) {
    return clamp2(untransform((input || (input = piecewise2(range3, domain.map(transform2), interpolateNumber$1)))(y4)));
  }, scale2.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
  }, scale2.range = function(_) {
    return arguments.length ? (range3 = Array.from(_), rescale()) : range3.slice();
  }, scale2.rangeRound = function(_) {
    return range3 = Array.from(_), interpolate$12 = interpolateRound, rescale();
  }, scale2.clamp = function(_) {
    return arguments.length ? (clamp2 = _ ? !0 : identity$6, rescale()) : clamp2 !== identity$6;
  }, scale2.interpolate = function(_) {
    return arguments.length ? (interpolate$12 = _, rescale()) : interpolate$12;
  }, scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  }, function(t3, u2) {
    return transform2 = t3, untransform = u2, rescale();
  };
}
__name(transformer$2, "transformer$2");
function continuous() {
  return transformer$2()(identity$6, identity$6);
}
__name(continuous, "continuous");
function formatDecimal(x3) {
  return Math.abs(x3 = Math.round(x3)) >= 1e21 ? x3.toLocaleString("en").replace(/,/g, "") : x3.toString(10);
}
__name(formatDecimal, "formatDecimal");
function formatDecimalParts(x3, p) {
  if ((i2 = (x3 = p ? x3.toExponential(p - 1) : x3.toExponential()).indexOf("e")) < 0)
    return null;
  var i2, coefficient = x3.slice(0, i2);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x3.slice(i2 + 1)
  ];
}
__name(formatDecimalParts, "formatDecimalParts");
function exponent(x3) {
  return x3 = formatDecimalParts(Math.abs(x3)), x3 ? x3[1] : NaN;
}
__name(exponent, "exponent");
function formatGroup(grouping, thousands) {
  return function(value, width2) {
    for (var i2 = value.length, t3 = [], j = 0, g = grouping[0], length = 0; i2 > 0 && g > 0 && (length + g + 1 > width2 && (g = Math.max(1, width2 - length)), t3.push(value.substring(i2 -= g, i2 + g)), !((length += g + 1) > width2)); )
      g = grouping[j = (j + 1) % grouping.length];
    return t3.reverse().join(thousands);
  };
}
__name(formatGroup, "formatGroup");
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i2) {
      return numerals[+i2];
    });
  };
}
__name(formatNumerals, "formatNumerals");
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match2 = re.exec(specifier)))
    throw new Error("invalid format: " + specifier);
  var match2;
  return new FormatSpecifier({
    fill: match2[1],
    align: match2[2],
    sign: match2[3],
    symbol: match2[4],
    zero: match2[5],
    width: match2[6],
    comma: match2[7],
    precision: match2[8] && match2[8].slice(1),
    trim: match2[9],
    type: match2[10]
  });
}
__name(formatSpecifier, "formatSpecifier");
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "", this.align = specifier.align === void 0 ? ">" : specifier.align + "", this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "", this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "", this.zero = !!specifier.zero, this.width = specifier.width === void 0 ? void 0 : +specifier.width, this.comma = !!specifier.comma, this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision, this.trim = !!specifier.trim, this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
__name(FormatSpecifier, "FormatSpecifier");
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s4) {
  out:
    for (var n = s4.length, i2 = 1, i0 = -1, i1; i2 < n; ++i2)
      switch (s4[i2]) {
        case ".":
          i0 = i1 = i2;
          break;
        case "0":
          i0 === 0 && (i0 = i2), i1 = i2;
          break;
        default:
          if (!+s4[i2])
            break out;
          i0 > 0 && (i0 = 0);
          break;
      }
  return i0 > 0 ? s4.slice(0, i0) + s4.slice(i1 + 1) : s4;
}
__name(formatTrim, "formatTrim");
var prefixExponent;
function formatPrefixAuto(x3, p) {
  var d3 = formatDecimalParts(x3, p);
  if (!d3)
    return x3 + "";
  var coefficient = d3[0], exponent2 = d3[1], i2 = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n = coefficient.length;
  return i2 === n ? coefficient : i2 > n ? coefficient + new Array(i2 - n + 1).join("0") : i2 > 0 ? coefficient.slice(0, i2) + "." + coefficient.slice(i2) : "0." + new Array(1 - i2).join("0") + formatDecimalParts(x3, Math.max(0, p + i2 - 1))[0];
}
__name(formatPrefixAuto, "formatPrefixAuto");
function formatRounded(x3, p) {
  var d3 = formatDecimalParts(x3, p);
  if (!d3)
    return x3 + "";
  var coefficient = d3[0], exponent2 = d3[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
__name(formatRounded, "formatRounded");
const formatTypes = {
  "%": (x3, p) => (x3 * 100).toFixed(p),
  b: (x3) => Math.round(x3).toString(2),
  c: (x3) => x3 + "",
  d: formatDecimal,
  e: (x3, p) => x3.toExponential(p),
  f: (x3, p) => x3.toFixed(p),
  g: (x3, p) => x3.toPrecision(p),
  o: (x3) => Math.round(x3).toString(8),
  p: (x3, p) => formatRounded(x3 * 100, p),
  r: formatRounded,
  s: formatPrefixAuto,
  X: (x3) => Math.round(x3).toString(16).toUpperCase(),
  x: (x3) => Math.round(x3).toString(16)
};
function identity$5(x3) {
  return x3;
}
__name(identity$5, "identity$5");
var map$3 = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(locale2) {
  var group = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$5 : formatGroup(map$3.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$5 : formatNumerals(map$3.call(locale2.numerals, String)), percent2 = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "−" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill2 = specifier.fill, align = specifier.align, sign2 = specifier.sign, symbol = specifier.symbol, zero2 = specifier.zero, width2 = specifier.width, comma = specifier.comma, precision = specifier.precision, trim2 = specifier.trim, type = specifier.type;
    type === "n" ? (comma = !0, type = "g") : formatTypes[type] || (precision === void 0 && (precision = 12), trim2 = !0, type = "g"), (zero2 || fill2 === "0" && align === "=") && (zero2 = !0, fill2 = "0", align = "=");
    var prefix2 = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent2 : "", formatType = formatTypes[type], maybeSuffix = /[defgprs%]/.test(type);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix2, valueSuffix = suffix, i2, n, c3;
      if (type === "c")
        valueSuffix = formatType(value) + valueSuffix, value = "";
      else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        if (value = isNaN(value) ? nan : formatType(Math.abs(value), precision), trim2 && (value = formatTrim(value)), valueNegative && +value == 0 && sign2 !== "+" && (valueNegative = !1), valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix, valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : ""), maybeSuffix) {
          for (i2 = -1, n = value.length; ++i2 < n; )
            if (c3 = value.charCodeAt(i2), 48 > c3 || c3 > 57) {
              valueSuffix = (c3 === 46 ? decimal + value.slice(i2 + 1) : value.slice(i2)) + valueSuffix, value = value.slice(0, i2);
              break;
            }
        }
      }
      comma && !zero2 && (value = group(value, 1 / 0));
      var length = valuePrefix.length + value.length + valueSuffix.length, padding2 = length < width2 ? new Array(width2 - length + 1).join(fill2) : "";
      switch (comma && zero2 && (value = group(padding2 + value, padding2.length ? width2 - valueSuffix.length : 1 / 0), padding2 = ""), align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding2;
          break;
        case "=":
          value = valuePrefix + padding2 + value + valueSuffix;
          break;
        case "^":
          value = padding2.slice(0, length = padding2.length >> 1) + valuePrefix + value + valueSuffix + padding2.slice(length);
          break;
        default:
          value = padding2 + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    return __name(format2, "format"), format2.toString = function() {
      return specifier + "";
    }, format2;
  }
  __name(newFormat, "newFormat");
  function formatPrefix2(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e3 = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k3 = Math.pow(10, -e3), prefix2 = prefixes[8 + e3 / 3];
    return function(value2) {
      return f(k3 * value2) + prefix2;
    };
  }
  return __name(formatPrefix2, "formatPrefix"), {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
__name(formatLocale$1, "formatLocale$1");
var locale$1, format, formatPrefix;
defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$1(definition2) {
  return locale$1 = formatLocale$1(definition2), format = locale$1.format, formatPrefix = locale$1.formatPrefix, locale$1;
}
__name(defaultLocale$1, "defaultLocale$1");
function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}
__name(precisionFixed, "precisionFixed");
function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}
__name(precisionPrefix, "precisionPrefix");
function precisionRound(step, max2) {
  return step = Math.abs(step), max2 = Math.abs(max2) - step, Math.max(0, exponent(max2) - exponent(step)) + 1;
}
__name(precisionRound, "precisionRound");
function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count), precision;
  switch (specifier = formatSpecifier(specifier ?? ",f"), specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      return specifier.precision == null && !isNaN(precision = precisionPrefix(step, value)) && (specifier.precision = precision), formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop)))) && (specifier.precision = precision - (specifier.type === "e"));
      break;
    }
    case "f":
    case "%": {
      specifier.precision == null && !isNaN(precision = precisionFixed(step)) && (specifier.precision = precision - (specifier.type === "%") * 2);
      break;
    }
  }
  return format(specifier);
}
__name(tickFormat, "tickFormat");
function linearish(scale2) {
  var domain = scale2.domain;
  return scale2.ticks = function(count) {
    var d3 = domain();
    return ticks(d3[0], d3[d3.length - 1], count ?? 10);
  }, scale2.tickFormat = function(count, specifier) {
    var d3 = domain();
    return tickFormat(d3[0], d3[d3.length - 1], count ?? 10, specifier);
  }, scale2.nice = function(count) {
    count == null && (count = 10);
    var d3 = domain(), i0 = 0, i1 = d3.length - 1, start = d3[i0], stop = d3[i1], prestep, step, maxIter = 10;
    for (stop < start && (step = start, start = stop, stop = step, step = i0, i0 = i1, i1 = step); maxIter-- > 0; ) {
      if (step = tickIncrement(start, stop, count), step === prestep)
        return d3[i0] = start, d3[i1] = stop, domain(d3);
      if (step > 0)
        start = Math.floor(start / step) * step, stop = Math.ceil(stop / step) * step;
      else if (step < 0)
        start = Math.ceil(start * step) / step, stop = Math.floor(stop * step) / step;
      else
        break;
      prestep = step;
    }
    return scale2;
  }, scale2;
}
__name(linearish, "linearish");
function linear() {
  var scale2 = continuous();
  return scale2.copy = function() {
    return copy$1(scale2, linear());
  }, initRange.apply(scale2, arguments), linearish(scale2);
}
__name(linear, "linear");
function identity$4(domain) {
  var unknown;
  function scale2(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown : x3;
  }
  return __name(scale2, "scale"), scale2.invert = scale2, scale2.domain = scale2.range = function(_) {
    return arguments.length ? (domain = Array.from(_, number$1), scale2) : domain.slice();
  }, scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  }, scale2.copy = function() {
    return identity$4(domain).unknown(unknown);
  }, domain = arguments.length ? Array.from(domain, number$1) : [0, 1], linearish(scale2);
}
__name(identity$4, "identity$4");
function nice(domain, interval) {
  domain = domain.slice();
  var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t3;
  return x1 < x0 && (t3 = i0, i0 = i1, i1 = t3, t3 = x0, x0 = x1, x1 = t3), domain[i0] = interval.floor(x0), domain[i1] = interval.ceil(x1), domain;
}
__name(nice, "nice");
function transformLog(x3) {
  return Math.log(x3);
}
__name(transformLog, "transformLog");
function transformExp(x3) {
  return Math.exp(x3);
}
__name(transformExp, "transformExp");
function transformLogn(x3) {
  return -Math.log(-x3);
}
__name(transformLogn, "transformLogn");
function transformExpn(x3) {
  return -Math.exp(-x3);
}
__name(transformExpn, "transformExpn");
function pow10(x3) {
  return isFinite(x3) ? +("1e" + x3) : x3 < 0 ? 0 : x3;
}
__name(pow10, "pow10");
function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : (x3) => Math.pow(base, x3);
}
__name(powp, "powp");
function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x3) => Math.log(x3) / base);
}
__name(logp, "logp");
function reflect(f) {
  return (x3, k3) => -f(-x3, k3);
}
__name(reflect, "reflect");
function loggish(transform2) {
  const scale2 = transform2(transformLog, transformExp), domain = scale2.domain;
  let base = 10, logs, pows;
  function rescale() {
    return logs = logp(base), pows = powp(base), domain()[0] < 0 ? (logs = reflect(logs), pows = reflect(pows), transform2(transformLogn, transformExpn)) : transform2(transformLog, transformExp), scale2;
  }
  return __name(rescale, "rescale"), scale2.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  }, scale2.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  }, scale2.ticks = (count) => {
    const d3 = domain();
    let u2 = d3[0], v = d3[d3.length - 1];
    const r2 = v < u2;
    r2 && ([u2, v] = [v, u2]);
    let i2 = logs(u2), j = logs(v), k3, t3;
    const n = count == null ? 10 : +count;
    let z2 = [];
    if (!(base % 1) && j - i2 < n) {
      if (i2 = Math.floor(i2), j = Math.ceil(j), u2 > 0) {
        for (; i2 <= j; ++i2)
          for (k3 = 1; k3 < base; ++k3)
            if (t3 = i2 < 0 ? k3 / pows(-i2) : k3 * pows(i2), !(t3 < u2)) {
              if (t3 > v)
                break;
              z2.push(t3);
            }
      } else
        for (; i2 <= j; ++i2)
          for (k3 = base - 1; k3 >= 1; --k3)
            if (t3 = i2 > 0 ? k3 / pows(-i2) : k3 * pows(i2), !(t3 < u2)) {
              if (t3 > v)
                break;
              z2.push(t3);
            }
      z2.length * 2 < n && (z2 = ticks(u2, v, n));
    } else
      z2 = ticks(i2, j, Math.min(j - i2, n)).map(pows);
    return r2 ? z2.reverse() : z2;
  }, scale2.tickFormat = (count, specifier) => {
    if (count == null && (count = 10), specifier == null && (specifier = base === 10 ? "s" : ","), typeof specifier != "function" && (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null && (specifier.trim = !0), specifier = format(specifier)), count === 1 / 0)
      return specifier;
    const k3 = Math.max(1, base * count / scale2.ticks().length);
    return (d3) => {
      let i2 = d3 / pows(Math.round(logs(d3)));
      return i2 * base < base - 0.5 && (i2 *= base), i2 <= k3 ? specifier(d3) : "";
    };
  }, scale2.nice = () => domain(nice(domain(), {
    floor: (x3) => pows(Math.floor(logs(x3))),
    ceil: (x3) => pows(Math.ceil(logs(x3)))
  })), scale2;
}
__name(loggish, "loggish");
function log() {
  const scale2 = loggish(transformer$2()).domain([1, 10]);
  return scale2.copy = () => copy$1(scale2, log()).base(scale2.base()), initRange.apply(scale2, arguments), scale2;
}
__name(log, "log");
function transformSymlog(c3) {
  return function(x3) {
    return Math.sign(x3) * Math.log1p(Math.abs(x3 / c3));
  };
}
__name(transformSymlog, "transformSymlog");
function transformSymexp(c3) {
  return function(x3) {
    return Math.sign(x3) * Math.expm1(Math.abs(x3)) * c3;
  };
}
__name(transformSymexp, "transformSymexp");
function symlogish(transform2) {
  var c3 = 1, scale2 = transform2(transformSymlog(c3), transformSymexp(c3));
  return scale2.constant = function(_) {
    return arguments.length ? transform2(transformSymlog(c3 = +_), transformSymexp(c3)) : c3;
  }, linearish(scale2);
}
__name(symlogish, "symlogish");
function symlog() {
  var scale2 = symlogish(transformer$2());
  return scale2.copy = function() {
    return copy$1(scale2, symlog()).constant(scale2.constant());
  }, initRange.apply(scale2, arguments);
}
__name(symlog, "symlog");
function transformPow(exponent2) {
  return function(x3) {
    return x3 < 0 ? -Math.pow(-x3, exponent2) : Math.pow(x3, exponent2);
  };
}
__name(transformPow, "transformPow");
function transformSqrt(x3) {
  return x3 < 0 ? -Math.sqrt(-x3) : Math.sqrt(x3);
}
__name(transformSqrt, "transformSqrt");
function transformSquare(x3) {
  return x3 < 0 ? -x3 * x3 : x3 * x3;
}
__name(transformSquare, "transformSquare");
function powish(transform2) {
  var scale2 = transform2(identity$6, identity$6), exponent2 = 1;
  function rescale() {
    return exponent2 === 1 ? transform2(identity$6, identity$6) : exponent2 === 0.5 ? transform2(transformSqrt, transformSquare) : transform2(transformPow(exponent2), transformPow(1 / exponent2));
  }
  return __name(rescale, "rescale"), scale2.exponent = function(_) {
    return arguments.length ? (exponent2 = +_, rescale()) : exponent2;
  }, linearish(scale2);
}
__name(powish, "powish");
function pow() {
  var scale2 = powish(transformer$2());
  return scale2.copy = function() {
    return copy$1(scale2, pow()).exponent(scale2.exponent());
  }, initRange.apply(scale2, arguments), scale2;
}
__name(pow, "pow");
function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}
__name(sqrt, "sqrt");
function square(x3) {
  return Math.sign(x3) * x3 * x3;
}
__name(square, "square");
function unsquare(x3) {
  return Math.sign(x3) * Math.sqrt(Math.abs(x3));
}
__name(unsquare, "unsquare");
function radial() {
  var squared = continuous(), range3 = [0, 1], round2 = !1, unknown;
  function scale2(x3) {
    var y4 = unsquare(squared(x3));
    return isNaN(y4) ? unknown : round2 ? Math.round(y4) : y4;
  }
  return __name(scale2, "scale"), scale2.invert = function(y4) {
    return squared.invert(square(y4));
  }, scale2.domain = function(_) {
    return arguments.length ? (squared.domain(_), scale2) : squared.domain();
  }, scale2.range = function(_) {
    return arguments.length ? (squared.range((range3 = Array.from(_, number$1)).map(square)), scale2) : range3.slice();
  }, scale2.rangeRound = function(_) {
    return scale2.range(_).round(!0);
  }, scale2.round = function(_) {
    return arguments.length ? (round2 = !!_, scale2) : round2;
  }, scale2.clamp = function(_) {
    return arguments.length ? (squared.clamp(_), scale2) : squared.clamp();
  }, scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  }, scale2.copy = function() {
    return radial(squared.domain(), range3).round(round2).clamp(squared.clamp()).unknown(unknown);
  }, initRange.apply(scale2, arguments), linearish(scale2);
}
__name(radial, "radial");
function quantile() {
  var domain = [], range3 = [], thresholds = [], unknown;
  function rescale() {
    var i2 = 0, n = Math.max(1, range3.length);
    for (thresholds = new Array(n - 1); ++i2 < n; )
      thresholds[i2 - 1] = quantileSorted(domain, i2 / n);
    return scale2;
  }
  __name(rescale, "rescale");
  function scale2(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown : range3[bisect(thresholds, x3)];
  }
  return __name(scale2, "scale"), scale2.invertExtent = function(y4) {
    var i2 = range3.indexOf(y4);
    return i2 < 0 ? [NaN, NaN] : [
      i2 > 0 ? thresholds[i2 - 1] : domain[0],
      i2 < thresholds.length ? thresholds[i2] : domain[domain.length - 1]
    ];
  }, scale2.domain = function(_) {
    if (!arguments.length)
      return domain.slice();
    domain = [];
    for (let d3 of _)
      d3 != null && !isNaN(d3 = +d3) && domain.push(d3);
    return domain.sort(ascending), rescale();
  }, scale2.range = function(_) {
    return arguments.length ? (range3 = Array.from(_), rescale()) : range3.slice();
  }, scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  }, scale2.quantiles = function() {
    return thresholds.slice();
  }, scale2.copy = function() {
    return quantile().domain(domain).range(range3).unknown(unknown);
  }, initRange.apply(scale2, arguments);
}
__name(quantile, "quantile");
function quantize() {
  var x0 = 0, x1 = 1, n = 1, domain = [0.5], range3 = [0, 1], unknown;
  function scale2(x3) {
    return x3 != null && x3 <= x3 ? range3[bisect(domain, x3, 0, n)] : unknown;
  }
  __name(scale2, "scale");
  function rescale() {
    var i2 = -1;
    for (domain = new Array(n); ++i2 < n; )
      domain[i2] = ((i2 + 1) * x1 - (i2 - n) * x0) / (n + 1);
    return scale2;
  }
  return __name(rescale, "rescale"), scale2.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
  }, scale2.range = function(_) {
    return arguments.length ? (n = (range3 = Array.from(_)).length - 1, rescale()) : range3.slice();
  }, scale2.invertExtent = function(y4) {
    var i2 = range3.indexOf(y4);
    return i2 < 0 ? [NaN, NaN] : i2 < 1 ? [x0, domain[0]] : i2 >= n ? [domain[n - 1], x1] : [domain[i2 - 1], domain[i2]];
  }, scale2.unknown = function(_) {
    return arguments.length && (unknown = _), scale2;
  }, scale2.thresholds = function() {
    return domain.slice();
  }, scale2.copy = function() {
    return quantize().domain([x0, x1]).range(range3).unknown(unknown);
  }, initRange.apply(linearish(scale2), arguments);
}
__name(quantize, "quantize");
function threshold() {
  var domain = [0.5], range3 = [0, 1], unknown, n = 1;
  function scale2(x3) {
    return x3 != null && x3 <= x3 ? range3[bisect(domain, x3, 0, n)] : unknown;
  }
  return __name(scale2, "scale"), scale2.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range3.length - 1), scale2) : domain.slice();
  }, scale2.range = function(_) {
    return arguments.length ? (range3 = Array.from(_), n = Math.min(domain.length, range3.length - 1), scale2) : range3.slice();
  }, scale2.invertExtent = function(y4) {
    var i2 = range3.indexOf(y4);
    return [domain[i2 - 1], domain[i2]];
  }, scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  }, scale2.copy = function() {
    return threshold().domain(domain).range(range3).unknown(unknown);
  }, initRange.apply(scale2, arguments);
}
__name(threshold, "threshold");
const t0 = /* @__PURE__ */ new Date(), t1 = /* @__PURE__ */ new Date();
function timeInterval(floori, offseti, count, field) {
  function interval(date2) {
    return floori(date2 = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date2)), date2;
  }
  return __name(interval, "interval"), interval.floor = (date2) => (floori(date2 = /* @__PURE__ */ new Date(+date2)), date2), interval.ceil = (date2) => (floori(date2 = new Date(date2 - 1)), offseti(date2, 1), floori(date2), date2), interval.round = (date2) => {
    const d0 = interval(date2), d1 = interval.ceil(date2);
    return date2 - d0 < d1 - date2 ? d0 : d1;
  }, interval.offset = (date2, step) => (offseti(date2 = /* @__PURE__ */ new Date(+date2), step == null ? 1 : Math.floor(step)), date2), interval.range = (start, stop, step) => {
    const range3 = [];
    if (start = interval.ceil(start), step = step == null ? 1 : Math.floor(step), !(start < stop) || !(step > 0))
      return range3;
    let previous2;
    do
      range3.push(previous2 = /* @__PURE__ */ new Date(+start)), offseti(start, step), floori(start);
    while (previous2 < start && start < stop);
    return range3;
  }, interval.filter = (test2) => timeInterval((date2) => {
    if (date2 >= date2)
      for (; floori(date2), !test2(date2); )
        date2.setTime(date2 - 1);
  }, (date2, step) => {
    if (date2 >= date2)
      if (step < 0)
        for (; ++step <= 0; )
          for (; offseti(date2, -1), !test2(date2); )
            ;
      else
        for (; --step >= 0; )
          for (; offseti(date2, 1), !test2(date2); )
            ;
  }), count && (interval.count = (start, end) => (t0.setTime(+start), t1.setTime(+end), floori(t0), floori(t1), Math.floor(count(t0, t1))), interval.every = (step) => (step = Math.floor(step), !isFinite(step) || !(step > 0) ? null : step > 1 ? interval.filter(field ? (d3) => field(d3) % step === 0 : (d3) => interval.count(0, d3) % step === 0) : interval)), interval;
}
__name(timeInterval, "timeInterval");
const millisecond = timeInterval(() => {
}, (date2, step) => {
  date2.setTime(+date2 + step);
}, (start, end) => end - start);
millisecond.every = (k3) => (k3 = Math.floor(k3), !isFinite(k3) || !(k3 > 0) ? null : k3 > 1 ? timeInterval((date2) => {
  date2.setTime(Math.floor(date2 / k3) * k3);
}, (date2, step) => {
  date2.setTime(+date2 + step * k3);
}, (start, end) => (end - start) / k3) : millisecond);
millisecond.range;
const durationSecond = 1e3, durationMinute = durationSecond * 60, durationHour = durationMinute * 60, durationDay = durationHour * 24, durationWeek = durationDay * 7, durationMonth = durationDay * 30, durationYear = durationDay * 365, second = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds());
}, (date2, step) => {
  date2.setTime(+date2 + step * durationSecond);
}, (start, end) => (end - start) / durationSecond, (date2) => date2.getUTCSeconds());
second.range;
const timeMinute = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start, end) => (end - start) / durationMinute, (date2) => date2.getMinutes());
timeMinute.range;
const utcMinute = timeInterval((date2) => {
  date2.setUTCSeconds(0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start, end) => (end - start) / durationMinute, (date2) => date2.getUTCMinutes());
utcMinute.range;
const timeHour = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond - date2.getMinutes() * durationMinute);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start, end) => (end - start) / durationHour, (date2) => date2.getHours());
timeHour.range;
const utcHour = timeInterval((date2) => {
  date2.setUTCMinutes(0, 0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start, end) => (end - start) / durationHour, (date2) => date2.getUTCHours());
utcHour.range;
const timeDay = timeInterval(
  (date2) => date2.setHours(0, 0, 0, 0),
  (date2, step) => date2.setDate(date2.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  (date2) => date2.getDate() - 1
);
timeDay.range;
const utcDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start, end) => (end - start) / durationDay, (date2) => date2.getUTCDate() - 1);
utcDay.range;
const unixDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start, end) => (end - start) / durationDay, (date2) => Math.floor(date2 / durationDay));
unixDay.range;
function timeWeekday(i2) {
  return timeInterval((date2) => {
    date2.setDate(date2.getDate() - (date2.getDay() + 7 - i2) % 7), date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setDate(date2.getDate() + step * 7);
  }, (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek);
}
__name(timeWeekday, "timeWeekday");
const timeSunday = timeWeekday(0), timeMonday = timeWeekday(1), timeTuesday = timeWeekday(2), timeWednesday = timeWeekday(3), timeThursday = timeWeekday(4), timeFriday = timeWeekday(5), timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(i2) {
  return timeInterval((date2) => {
    date2.setUTCDate(date2.getUTCDate() - (date2.getUTCDay() + 7 - i2) % 7), date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCDate(date2.getUTCDate() + step * 7);
  }, (start, end) => (end - start) / durationWeek);
}
__name(utcWeekday, "utcWeekday");
const utcSunday = utcWeekday(0), utcMonday = utcWeekday(1), utcTuesday = utcWeekday(2), utcWednesday = utcWeekday(3), utcThursday = utcWeekday(4), utcFriday = utcWeekday(5), utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;
const timeMonth = timeInterval((date2) => {
  date2.setDate(1), date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setMonth(date2.getMonth() + step);
}, (start, end) => end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12, (date2) => date2.getMonth());
timeMonth.range;
const utcMonth = timeInterval((date2) => {
  date2.setUTCDate(1), date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCMonth(date2.getUTCMonth() + step);
}, (start, end) => end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12, (date2) => date2.getUTCMonth());
utcMonth.range;
const timeYear = timeInterval((date2) => {
  date2.setMonth(0, 1), date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setFullYear(date2.getFullYear() + step);
}, (start, end) => end.getFullYear() - start.getFullYear(), (date2) => date2.getFullYear());
timeYear.every = (k3) => !isFinite(k3 = Math.floor(k3)) || !(k3 > 0) ? null : timeInterval((date2) => {
  date2.setFullYear(Math.floor(date2.getFullYear() / k3) * k3), date2.setMonth(0, 1), date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setFullYear(date2.getFullYear() + step * k3);
});
timeYear.range;
const utcYear = timeInterval((date2) => {
  date2.setUTCMonth(0, 1), date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCFullYear(date2.getUTCFullYear() + step);
}, (start, end) => end.getUTCFullYear() - start.getUTCFullYear(), (date2) => date2.getUTCFullYear());
utcYear.every = (k3) => !isFinite(k3 = Math.floor(k3)) || !(k3 > 0) ? null : timeInterval((date2) => {
  date2.setUTCFullYear(Math.floor(date2.getUTCFullYear() / k3) * k3), date2.setUTCMonth(0, 1), date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCFullYear(date2.getUTCFullYear() + step * k3);
});
utcYear.range;
function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [
    [second, 1, durationSecond],
    [second, 5, 5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute, 1, durationMinute],
    [minute, 5, 5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [hour, 1, durationHour],
    [hour, 3, 3 * durationHour],
    [hour, 6, 6 * durationHour],
    [hour, 12, 12 * durationHour],
    [day, 1, durationDay],
    [day, 2, 2 * durationDay],
    [week, 1, durationWeek],
    [month, 1, durationMonth],
    [month, 3, 3 * durationMonth],
    [year, 1, durationYear]
  ];
  function ticks2(start, stop, count) {
    const reverse3 = stop < start;
    reverse3 && ([start, stop] = [stop, start]);
    const interval = count && typeof count.range == "function" ? count : tickInterval(start, stop, count), ticks3 = interval ? interval.range(start, +stop + 1) : [];
    return reverse3 ? ticks3.reverse() : ticks3;
  }
  __name(ticks2, "ticks");
  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count, i2 = bisector(([, , step2]) => step2).right(tickIntervals, target);
    if (i2 === tickIntervals.length)
      return year.every(tickStep(start / durationYear, stop / durationYear, count));
    if (i2 === 0)
      return millisecond.every(Math.max(tickStep(start, stop, count), 1));
    const [t3, step] = tickIntervals[target / tickIntervals[i2 - 1][2] < tickIntervals[i2][2] / target ? i2 - 1 : i2];
    return t3.every(step);
  }
  return __name(tickInterval, "tickInterval"), [ticks2, tickInterval];
}
__name(ticker, "ticker");
const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute), [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
function localDate(d3) {
  if (0 <= d3.y && d3.y < 100) {
    var date2 = new Date(-1, d3.m, d3.d, d3.H, d3.M, d3.S, d3.L);
    return date2.setFullYear(d3.y), date2;
  }
  return new Date(d3.y, d3.m, d3.d, d3.H, d3.M, d3.S, d3.L);
}
__name(localDate, "localDate");
function utcDate(d3) {
  if (0 <= d3.y && d3.y < 100) {
    var date2 = new Date(Date.UTC(-1, d3.m, d3.d, d3.H, d3.M, d3.S, d3.L));
    return date2.setUTCFullYear(d3.y), date2;
  }
  return new Date(Date.UTC(d3.y, d3.m, d3.d, d3.H, d3.M, d3.S, d3.L));
}
__name(utcDate, "utcDate");
function newDate(y4, m3, d3) {
  return { y: y4, m: m3, d: d3, H: 0, M: 0, S: 0, L: 0 };
}
__name(newDate, "newDate");
function formatLocale(locale2) {
  var locale_dateTime = locale2.dateTime, locale_date = locale2.date, locale_time = locale2.time, locale_periods = locale2.periods, locale_weekdays = locale2.days, locale_shortWeekdays = locale2.shortDays, locale_months = locale2.months, locale_shortMonths = locale2.shortMonths, periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths), formats = {
    a: formatShortWeekday,
    A: formatWeekday,
    b: formatShortMonth,
    B: formatMonth,
    c: null,
    d: formatDayOfMonth,
    e: formatDayOfMonth,
    f: formatMicroseconds,
    g: formatYearISO,
    G: formatFullYearISO,
    H: formatHour24,
    I: formatHour12,
    j: formatDayOfYear,
    L: formatMilliseconds,
    m: formatMonthNumber,
    M: formatMinutes,
    p: formatPeriod,
    q: formatQuarter,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatSeconds,
    u: formatWeekdayNumberMonday,
    U: formatWeekNumberSunday,
    V: formatWeekNumberISO,
    w: formatWeekdayNumberSunday,
    W: formatWeekNumberMonday,
    x: null,
    X: null,
    y: formatYear,
    Y: formatFullYear,
    Z: formatZone,
    "%": formatLiteralPercent
  }, utcFormats = {
    a: formatUTCShortWeekday,
    A: formatUTCWeekday,
    b: formatUTCShortMonth,
    B: formatUTCMonth,
    c: null,
    d: formatUTCDayOfMonth,
    e: formatUTCDayOfMonth,
    f: formatUTCMicroseconds,
    g: formatUTCYearISO,
    G: formatUTCFullYearISO,
    H: formatUTCHour24,
    I: formatUTCHour12,
    j: formatUTCDayOfYear,
    L: formatUTCMilliseconds,
    m: formatUTCMonthNumber,
    M: formatUTCMinutes,
    p: formatUTCPeriod,
    q: formatUTCQuarter,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatUTCSeconds,
    u: formatUTCWeekdayNumberMonday,
    U: formatUTCWeekNumberSunday,
    V: formatUTCWeekNumberISO,
    w: formatUTCWeekdayNumberSunday,
    W: formatUTCWeekNumberMonday,
    x: null,
    X: null,
    y: formatUTCYear,
    Y: formatUTCFullYear,
    Z: formatUTCZone,
    "%": formatLiteralPercent
  }, parses = {
    a: parseShortWeekday,
    A: parseWeekday,
    b: parseShortMonth,
    B: parseMonth,
    c: parseLocaleDateTime,
    d: parseDayOfMonth,
    e: parseDayOfMonth,
    f: parseMicroseconds,
    g: parseYear,
    G: parseFullYear,
    H: parseHour24,
    I: parseHour24,
    j: parseDayOfYear,
    L: parseMilliseconds,
    m: parseMonthNumber,
    M: parseMinutes,
    p: parsePeriod,
    q: parseQuarter,
    Q: parseUnixTimestamp,
    s: parseUnixTimestampSeconds,
    S: parseSeconds,
    u: parseWeekdayNumberMonday,
    U: parseWeekNumberSunday,
    V: parseWeekNumberISO,
    w: parseWeekdayNumberSunday,
    W: parseWeekNumberMonday,
    x: parseLocaleDate,
    X: parseLocaleTime,
    y: parseYear,
    Y: parseFullYear,
    Z: parseZone,
    "%": parseLiteralPercent
  };
  formats.x = newFormat(locale_date, formats), formats.X = newFormat(locale_time, formats), formats.c = newFormat(locale_dateTime, formats), utcFormats.x = newFormat(locale_date, utcFormats), utcFormats.X = newFormat(locale_time, utcFormats), utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats2) {
    return function(date2) {
      var string2 = [], i2 = -1, j = 0, n = specifier.length, c3, pad2, format2;
      for (date2 instanceof Date || (date2 = /* @__PURE__ */ new Date(+date2)); ++i2 < n; )
        specifier.charCodeAt(i2) === 37 && (string2.push(specifier.slice(j, i2)), (pad2 = pads[c3 = specifier.charAt(++i2)]) != null ? c3 = specifier.charAt(++i2) : pad2 = c3 === "e" ? " " : "0", (format2 = formats2[c3]) && (c3 = format2(date2, pad2)), string2.push(c3), j = i2 + 1);
      return string2.push(specifier.slice(j, i2)), string2.join("");
    };
  }
  __name(newFormat, "newFormat");
  function newParse(specifier, Z) {
    return function(string2) {
      var d3 = newDate(1900, void 0, 1), i2 = parseSpecifier(d3, specifier, string2 += "", 0), week, day;
      if (i2 != string2.length)
        return null;
      if ("Q" in d3)
        return new Date(d3.Q);
      if ("s" in d3)
        return new Date(d3.s * 1e3 + ("L" in d3 ? d3.L : 0));
      if (Z && !("Z" in d3) && (d3.Z = 0), "p" in d3 && (d3.H = d3.H % 12 + d3.p * 12), d3.m === void 0 && (d3.m = "q" in d3 ? d3.q : 0), "V" in d3) {
        if (d3.V < 1 || d3.V > 53)
          return null;
        "w" in d3 || (d3.w = 1), "Z" in d3 ? (week = utcDate(newDate(d3.y, 0, 1)), day = week.getUTCDay(), week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week), week = utcDay.offset(week, (d3.V - 1) * 7), d3.y = week.getUTCFullYear(), d3.m = week.getUTCMonth(), d3.d = week.getUTCDate() + (d3.w + 6) % 7) : (week = localDate(newDate(d3.y, 0, 1)), day = week.getDay(), week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week), week = timeDay.offset(week, (d3.V - 1) * 7), d3.y = week.getFullYear(), d3.m = week.getMonth(), d3.d = week.getDate() + (d3.w + 6) % 7);
      } else
        ("W" in d3 || "U" in d3) && ("w" in d3 || (d3.w = "u" in d3 ? d3.u % 7 : "W" in d3 ? 1 : 0), day = "Z" in d3 ? utcDate(newDate(d3.y, 0, 1)).getUTCDay() : localDate(newDate(d3.y, 0, 1)).getDay(), d3.m = 0, d3.d = "W" in d3 ? (d3.w + 6) % 7 + d3.W * 7 - (day + 5) % 7 : d3.w + d3.U * 7 - (day + 6) % 7);
      return "Z" in d3 ? (d3.H += d3.Z / 100 | 0, d3.M += d3.Z % 100, utcDate(d3)) : localDate(d3);
    };
  }
  __name(newParse, "newParse");
  function parseSpecifier(d3, specifier, string2, j) {
    for (var i2 = 0, n = specifier.length, m3 = string2.length, c3, parse2; i2 < n; ) {
      if (j >= m3)
        return -1;
      if (c3 = specifier.charCodeAt(i2++), c3 === 37) {
        if (c3 = specifier.charAt(i2++), parse2 = parses[c3 in pads ? specifier.charAt(i2++) : c3], !parse2 || (j = parse2(d3, string2, j)) < 0)
          return -1;
      } else if (c3 != string2.charCodeAt(j++))
        return -1;
    }
    return j;
  }
  __name(parseSpecifier, "parseSpecifier");
  function parsePeriod(d3, string2, i2) {
    var n = periodRe.exec(string2.slice(i2));
    return n ? (d3.p = periodLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  __name(parsePeriod, "parsePeriod");
  function parseShortWeekday(d3, string2, i2) {
    var n = shortWeekdayRe.exec(string2.slice(i2));
    return n ? (d3.w = shortWeekdayLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  __name(parseShortWeekday, "parseShortWeekday");
  function parseWeekday(d3, string2, i2) {
    var n = weekdayRe.exec(string2.slice(i2));
    return n ? (d3.w = weekdayLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  __name(parseWeekday, "parseWeekday");
  function parseShortMonth(d3, string2, i2) {
    var n = shortMonthRe.exec(string2.slice(i2));
    return n ? (d3.m = shortMonthLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  __name(parseShortMonth, "parseShortMonth");
  function parseMonth(d3, string2, i2) {
    var n = monthRe.exec(string2.slice(i2));
    return n ? (d3.m = monthLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  __name(parseMonth, "parseMonth");
  function parseLocaleDateTime(d3, string2, i2) {
    return parseSpecifier(d3, locale_dateTime, string2, i2);
  }
  __name(parseLocaleDateTime, "parseLocaleDateTime");
  function parseLocaleDate(d3, string2, i2) {
    return parseSpecifier(d3, locale_date, string2, i2);
  }
  __name(parseLocaleDate, "parseLocaleDate");
  function parseLocaleTime(d3, string2, i2) {
    return parseSpecifier(d3, locale_time, string2, i2);
  }
  __name(parseLocaleTime, "parseLocaleTime");
  function formatShortWeekday(d3) {
    return locale_shortWeekdays[d3.getDay()];
  }
  __name(formatShortWeekday, "formatShortWeekday");
  function formatWeekday(d3) {
    return locale_weekdays[d3.getDay()];
  }
  __name(formatWeekday, "formatWeekday");
  function formatShortMonth(d3) {
    return locale_shortMonths[d3.getMonth()];
  }
  __name(formatShortMonth, "formatShortMonth");
  function formatMonth(d3) {
    return locale_months[d3.getMonth()];
  }
  __name(formatMonth, "formatMonth");
  function formatPeriod(d3) {
    return locale_periods[+(d3.getHours() >= 12)];
  }
  __name(formatPeriod, "formatPeriod");
  function formatQuarter(d3) {
    return 1 + ~~(d3.getMonth() / 3);
  }
  __name(formatQuarter, "formatQuarter");
  function formatUTCShortWeekday(d3) {
    return locale_shortWeekdays[d3.getUTCDay()];
  }
  __name(formatUTCShortWeekday, "formatUTCShortWeekday");
  function formatUTCWeekday(d3) {
    return locale_weekdays[d3.getUTCDay()];
  }
  __name(formatUTCWeekday, "formatUTCWeekday");
  function formatUTCShortMonth(d3) {
    return locale_shortMonths[d3.getUTCMonth()];
  }
  __name(formatUTCShortMonth, "formatUTCShortMonth");
  function formatUTCMonth(d3) {
    return locale_months[d3.getUTCMonth()];
  }
  __name(formatUTCMonth, "formatUTCMonth");
  function formatUTCPeriod(d3) {
    return locale_periods[+(d3.getUTCHours() >= 12)];
  }
  __name(formatUTCPeriod, "formatUTCPeriod");
  function formatUTCQuarter(d3) {
    return 1 + ~~(d3.getUTCMonth() / 3);
  }
  return __name(formatUTCQuarter, "formatUTCQuarter"), {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      return f.toString = function() {
        return specifier;
      }, f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", !1);
      return p.toString = function() {
        return specifier;
      }, p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      return f.toString = function() {
        return specifier;
      }, f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", !0);
      return p.toString = function() {
        return specifier;
      }, p;
    }
  };
}
__name(formatLocale, "formatLocale");
var pads = { "-": "", _: " ", 0: "0" }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill2, width2) {
  var sign2 = value < 0 ? "-" : "", string2 = (sign2 ? -value : value) + "", length = string2.length;
  return sign2 + (length < width2 ? new Array(width2 - length + 1).join(fill2) + string2 : string2);
}
__name(pad, "pad");
function requote(s4) {
  return s4.replace(requoteRe, "\\$&");
}
__name(requote, "requote");
function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
__name(formatRe, "formatRe");
function formatLookup(names) {
  return new Map(names.map((name2, i2) => [name2.toLowerCase(), i2]));
}
__name(formatLookup, "formatLookup");
function parseWeekdayNumberSunday(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 1));
  return n ? (d3.w = +n[0], i2 + n[0].length) : -1;
}
__name(parseWeekdayNumberSunday, "parseWeekdayNumberSunday");
function parseWeekdayNumberMonday(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 1));
  return n ? (d3.u = +n[0], i2 + n[0].length) : -1;
}
__name(parseWeekdayNumberMonday, "parseWeekdayNumberMonday");
function parseWeekNumberSunday(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.U = +n[0], i2 + n[0].length) : -1;
}
__name(parseWeekNumberSunday, "parseWeekNumberSunday");
function parseWeekNumberISO(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.V = +n[0], i2 + n[0].length) : -1;
}
__name(parseWeekNumberISO, "parseWeekNumberISO");
function parseWeekNumberMonday(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.W = +n[0], i2 + n[0].length) : -1;
}
__name(parseWeekNumberMonday, "parseWeekNumberMonday");
function parseFullYear(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 4));
  return n ? (d3.y = +n[0], i2 + n[0].length) : -1;
}
__name(parseFullYear, "parseFullYear");
function parseYear(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), i2 + n[0].length) : -1;
}
__name(parseYear, "parseYear");
function parseZone(d3, string2, i2) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string2.slice(i2, i2 + 6));
  return n ? (d3.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i2 + n[0].length) : -1;
}
__name(parseZone, "parseZone");
function parseQuarter(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 1));
  return n ? (d3.q = n[0] * 3 - 3, i2 + n[0].length) : -1;
}
__name(parseQuarter, "parseQuarter");
function parseMonthNumber(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.m = n[0] - 1, i2 + n[0].length) : -1;
}
__name(parseMonthNumber, "parseMonthNumber");
function parseDayOfMonth(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.d = +n[0], i2 + n[0].length) : -1;
}
__name(parseDayOfMonth, "parseDayOfMonth");
function parseDayOfYear(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 3));
  return n ? (d3.m = 0, d3.d = +n[0], i2 + n[0].length) : -1;
}
__name(parseDayOfYear, "parseDayOfYear");
function parseHour24(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.H = +n[0], i2 + n[0].length) : -1;
}
__name(parseHour24, "parseHour24");
function parseMinutes(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.M = +n[0], i2 + n[0].length) : -1;
}
__name(parseMinutes, "parseMinutes");
function parseSeconds(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.S = +n[0], i2 + n[0].length) : -1;
}
__name(parseSeconds, "parseSeconds");
function parseMilliseconds(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 3));
  return n ? (d3.L = +n[0], i2 + n[0].length) : -1;
}
__name(parseMilliseconds, "parseMilliseconds");
function parseMicroseconds(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 6));
  return n ? (d3.L = Math.floor(n[0] / 1e3), i2 + n[0].length) : -1;
}
__name(parseMicroseconds, "parseMicroseconds");
function parseLiteralPercent(d3, string2, i2) {
  var n = percentRe.exec(string2.slice(i2, i2 + 1));
  return n ? i2 + n[0].length : -1;
}
__name(parseLiteralPercent, "parseLiteralPercent");
function parseUnixTimestamp(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2));
  return n ? (d3.Q = +n[0], i2 + n[0].length) : -1;
}
__name(parseUnixTimestamp, "parseUnixTimestamp");
function parseUnixTimestampSeconds(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2));
  return n ? (d3.s = +n[0], i2 + n[0].length) : -1;
}
__name(parseUnixTimestampSeconds, "parseUnixTimestampSeconds");
function formatDayOfMonth(d3, p) {
  return pad(d3.getDate(), p, 2);
}
__name(formatDayOfMonth, "formatDayOfMonth");
function formatHour24(d3, p) {
  return pad(d3.getHours(), p, 2);
}
__name(formatHour24, "formatHour24");
function formatHour12(d3, p) {
  return pad(d3.getHours() % 12 || 12, p, 2);
}
__name(formatHour12, "formatHour12");
function formatDayOfYear(d3, p) {
  return pad(1 + timeDay.count(timeYear(d3), d3), p, 3);
}
__name(formatDayOfYear, "formatDayOfYear");
function formatMilliseconds(d3, p) {
  return pad(d3.getMilliseconds(), p, 3);
}
__name(formatMilliseconds, "formatMilliseconds");
function formatMicroseconds(d3, p) {
  return formatMilliseconds(d3, p) + "000";
}
__name(formatMicroseconds, "formatMicroseconds");
function formatMonthNumber(d3, p) {
  return pad(d3.getMonth() + 1, p, 2);
}
__name(formatMonthNumber, "formatMonthNumber");
function formatMinutes(d3, p) {
  return pad(d3.getMinutes(), p, 2);
}
__name(formatMinutes, "formatMinutes");
function formatSeconds(d3, p) {
  return pad(d3.getSeconds(), p, 2);
}
__name(formatSeconds, "formatSeconds");
function formatWeekdayNumberMonday(d3) {
  var day = d3.getDay();
  return day === 0 ? 7 : day;
}
__name(formatWeekdayNumberMonday, "formatWeekdayNumberMonday");
function formatWeekNumberSunday(d3, p) {
  return pad(timeSunday.count(timeYear(d3) - 1, d3), p, 2);
}
__name(formatWeekNumberSunday, "formatWeekNumberSunday");
function dISO(d3) {
  var day = d3.getDay();
  return day >= 4 || day === 0 ? timeThursday(d3) : timeThursday.ceil(d3);
}
__name(dISO, "dISO");
function formatWeekNumberISO(d3, p) {
  return d3 = dISO(d3), pad(timeThursday.count(timeYear(d3), d3) + (timeYear(d3).getDay() === 4), p, 2);
}
__name(formatWeekNumberISO, "formatWeekNumberISO");
function formatWeekdayNumberSunday(d3) {
  return d3.getDay();
}
__name(formatWeekdayNumberSunday, "formatWeekdayNumberSunday");
function formatWeekNumberMonday(d3, p) {
  return pad(timeMonday.count(timeYear(d3) - 1, d3), p, 2);
}
__name(formatWeekNumberMonday, "formatWeekNumberMonday");
function formatYear(d3, p) {
  return pad(d3.getFullYear() % 100, p, 2);
}
__name(formatYear, "formatYear");
function formatYearISO(d3, p) {
  return d3 = dISO(d3), pad(d3.getFullYear() % 100, p, 2);
}
__name(formatYearISO, "formatYearISO");
function formatFullYear(d3, p) {
  return pad(d3.getFullYear() % 1e4, p, 4);
}
__name(formatFullYear, "formatFullYear");
function formatFullYearISO(d3, p) {
  var day = d3.getDay();
  return d3 = day >= 4 || day === 0 ? timeThursday(d3) : timeThursday.ceil(d3), pad(d3.getFullYear() % 1e4, p, 4);
}
__name(formatFullYearISO, "formatFullYearISO");
function formatZone(d3) {
  var z2 = d3.getTimezoneOffset();
  return (z2 > 0 ? "-" : (z2 *= -1, "+")) + pad(z2 / 60 | 0, "0", 2) + pad(z2 % 60, "0", 2);
}
__name(formatZone, "formatZone");
function formatUTCDayOfMonth(d3, p) {
  return pad(d3.getUTCDate(), p, 2);
}
__name(formatUTCDayOfMonth, "formatUTCDayOfMonth");
function formatUTCHour24(d3, p) {
  return pad(d3.getUTCHours(), p, 2);
}
__name(formatUTCHour24, "formatUTCHour24");
function formatUTCHour12(d3, p) {
  return pad(d3.getUTCHours() % 12 || 12, p, 2);
}
__name(formatUTCHour12, "formatUTCHour12");
function formatUTCDayOfYear(d3, p) {
  return pad(1 + utcDay.count(utcYear(d3), d3), p, 3);
}
__name(formatUTCDayOfYear, "formatUTCDayOfYear");
function formatUTCMilliseconds(d3, p) {
  return pad(d3.getUTCMilliseconds(), p, 3);
}
__name(formatUTCMilliseconds, "formatUTCMilliseconds");
function formatUTCMicroseconds(d3, p) {
  return formatUTCMilliseconds(d3, p) + "000";
}
__name(formatUTCMicroseconds, "formatUTCMicroseconds");
function formatUTCMonthNumber(d3, p) {
  return pad(d3.getUTCMonth() + 1, p, 2);
}
__name(formatUTCMonthNumber, "formatUTCMonthNumber");
function formatUTCMinutes(d3, p) {
  return pad(d3.getUTCMinutes(), p, 2);
}
__name(formatUTCMinutes, "formatUTCMinutes");
function formatUTCSeconds(d3, p) {
  return pad(d3.getUTCSeconds(), p, 2);
}
__name(formatUTCSeconds, "formatUTCSeconds");
function formatUTCWeekdayNumberMonday(d3) {
  var dow = d3.getUTCDay();
  return dow === 0 ? 7 : dow;
}
__name(formatUTCWeekdayNumberMonday, "formatUTCWeekdayNumberMonday");
function formatUTCWeekNumberSunday(d3, p) {
  return pad(utcSunday.count(utcYear(d3) - 1, d3), p, 2);
}
__name(formatUTCWeekNumberSunday, "formatUTCWeekNumberSunday");
function UTCdISO(d3) {
  var day = d3.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday(d3) : utcThursday.ceil(d3);
}
__name(UTCdISO, "UTCdISO");
function formatUTCWeekNumberISO(d3, p) {
  return d3 = UTCdISO(d3), pad(utcThursday.count(utcYear(d3), d3) + (utcYear(d3).getUTCDay() === 4), p, 2);
}
__name(formatUTCWeekNumberISO, "formatUTCWeekNumberISO");
function formatUTCWeekdayNumberSunday(d3) {
  return d3.getUTCDay();
}
__name(formatUTCWeekdayNumberSunday, "formatUTCWeekdayNumberSunday");
function formatUTCWeekNumberMonday(d3, p) {
  return pad(utcMonday.count(utcYear(d3) - 1, d3), p, 2);
}
__name(formatUTCWeekNumberMonday, "formatUTCWeekNumberMonday");
function formatUTCYear(d3, p) {
  return pad(d3.getUTCFullYear() % 100, p, 2);
}
__name(formatUTCYear, "formatUTCYear");
function formatUTCYearISO(d3, p) {
  return d3 = UTCdISO(d3), pad(d3.getUTCFullYear() % 100, p, 2);
}
__name(formatUTCYearISO, "formatUTCYearISO");
function formatUTCFullYear(d3, p) {
  return pad(d3.getUTCFullYear() % 1e4, p, 4);
}
__name(formatUTCFullYear, "formatUTCFullYear");
function formatUTCFullYearISO(d3, p) {
  var day = d3.getUTCDay();
  return d3 = day >= 4 || day === 0 ? utcThursday(d3) : utcThursday.ceil(d3), pad(d3.getUTCFullYear() % 1e4, p, 4);
}
__name(formatUTCFullYearISO, "formatUTCFullYearISO");
function formatUTCZone() {
  return "+0000";
}
__name(formatUTCZone, "formatUTCZone");
function formatLiteralPercent() {
  return "%";
}
__name(formatLiteralPercent, "formatLiteralPercent");
function formatUnixTimestamp(d3) {
  return +d3;
}
__name(formatUnixTimestamp, "formatUnixTimestamp");
function formatUnixTimestampSeconds(d3) {
  return Math.floor(+d3 / 1e3);
}
__name(formatUnixTimestampSeconds, "formatUnixTimestampSeconds");
var locale, timeFormat, utcFormat;
defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale(definition2) {
  return locale = formatLocale(definition2), timeFormat = locale.format, locale.parse, utcFormat = locale.utcFormat, locale.utcParse, locale;
}
__name(defaultLocale, "defaultLocale");
function date(t3) {
  return new Date(t3);
}
__name(date, "date");
function number(t3) {
  return t3 instanceof Date ? +t3 : +/* @__PURE__ */ new Date(+t3);
}
__name(number, "number");
function calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2) {
  var scale2 = continuous(), invert = scale2.invert, domain = scale2.domain, formatMillisecond = format2(".%L"), formatSecond = format2(":%S"), formatMinute = format2("%I:%M"), formatHour = format2("%I %p"), formatDay = format2("%a %d"), formatWeek = format2("%b %d"), formatMonth = format2("%B"), formatYear2 = format2("%Y");
  function tickFormat2(date2) {
    return (second2(date2) < date2 ? formatMillisecond : minute(date2) < date2 ? formatSecond : hour(date2) < date2 ? formatMinute : day(date2) < date2 ? formatHour : month(date2) < date2 ? week(date2) < date2 ? formatDay : formatWeek : year(date2) < date2 ? formatMonth : formatYear2)(date2);
  }
  return __name(tickFormat2, "tickFormat"), scale2.invert = function(y4) {
    return new Date(invert(y4));
  }, scale2.domain = function(_) {
    return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
  }, scale2.ticks = function(interval) {
    var d3 = domain();
    return ticks2(d3[0], d3[d3.length - 1], interval ?? 10);
  }, scale2.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat2 : format2(specifier);
  }, scale2.nice = function(interval) {
    var d3 = domain();
    return (!interval || typeof interval.range != "function") && (interval = tickInterval(d3[0], d3[d3.length - 1], interval ?? 10)), interval ? domain(nice(d3, interval)) : scale2;
  }, scale2.copy = function() {
    return copy$1(scale2, calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2));
  }, scale2;
}
__name(calendar, "calendar");
function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
__name(time, "time");
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
__name(utcTime, "utcTime");
function transformer$1() {
  var x0 = 0, x1 = 1, t02, t12, k10, transform2, interpolator = identity$6, clamp2 = !1, unknown;
  function scale2(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown : interpolator(k10 === 0 ? 0.5 : (x3 = (transform2(x3) - t02) * k10, clamp2 ? Math.max(0, Math.min(1, x3)) : x3));
  }
  __name(scale2, "scale"), scale2.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, t02 = transform2(x0 = +x0), t12 = transform2(x1 = +x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale2) : [x0, x1];
  }, scale2.clamp = function(_) {
    return arguments.length ? (clamp2 = !!_, scale2) : clamp2;
  }, scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  function range3(interpolate2) {
    return function(_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate2(r0, r1), scale2) : [interpolator(0), interpolator(1)];
    };
  }
  return __name(range3, "range"), scale2.range = range3(interpolate), scale2.rangeRound = range3(interpolateRound), scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  }, function(t3) {
    return transform2 = t3, t02 = t3(x0), t12 = t3(x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale2;
  };
}
__name(transformer$1, "transformer$1");
function copy(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
__name(copy, "copy");
function sequential() {
  var scale2 = linearish(transformer$1()(identity$6));
  return scale2.copy = function() {
    return copy(scale2, sequential());
  }, initInterpolator.apply(scale2, arguments);
}
__name(sequential, "sequential");
function sequentialLog() {
  var scale2 = loggish(transformer$1()).domain([1, 10]);
  return scale2.copy = function() {
    return copy(scale2, sequentialLog()).base(scale2.base());
  }, initInterpolator.apply(scale2, arguments);
}
__name(sequentialLog, "sequentialLog");
function sequentialSymlog() {
  var scale2 = symlogish(transformer$1());
  return scale2.copy = function() {
    return copy(scale2, sequentialSymlog()).constant(scale2.constant());
  }, initInterpolator.apply(scale2, arguments);
}
__name(sequentialSymlog, "sequentialSymlog");
function sequentialPow() {
  var scale2 = powish(transformer$1());
  return scale2.copy = function() {
    return copy(scale2, sequentialPow()).exponent(scale2.exponent());
  }, initInterpolator.apply(scale2, arguments);
}
__name(sequentialPow, "sequentialPow");
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
__name(sequentialSqrt, "sequentialSqrt");
function sequentialQuantile() {
  var domain = [], interpolator = identity$6;
  function scale2(x3) {
    if (x3 != null && !isNaN(x3 = +x3))
      return interpolator((bisect(domain, x3, 1) - 1) / (domain.length - 1));
  }
  return __name(scale2, "scale"), scale2.domain = function(_) {
    if (!arguments.length)
      return domain.slice();
    domain = [];
    for (let d3 of _)
      d3 != null && !isNaN(d3 = +d3) && domain.push(d3);
    return domain.sort(ascending), scale2;
  }, scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  }, scale2.range = function() {
    return domain.map((d3, i2) => interpolator(i2 / (domain.length - 1)));
  }, scale2.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (_, i2) => quantile$1(domain, i2 / n));
  }, scale2.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  }, initInterpolator.apply(scale2, arguments);
}
__name(sequentialQuantile, "sequentialQuantile");
function transformer() {
  var x0 = 0, x1 = 0.5, x22 = 1, s4 = 1, t02, t12, t22, k10, k21, interpolator = identity$6, transform2, clamp2 = !1, unknown;
  function scale2(x3) {
    return isNaN(x3 = +x3) ? unknown : (x3 = 0.5 + ((x3 = +transform2(x3)) - t12) * (s4 * x3 < s4 * t12 ? k10 : k21), interpolator(clamp2 ? Math.max(0, Math.min(1, x3)) : x3));
  }
  __name(scale2, "scale"), scale2.domain = function(_) {
    return arguments.length ? ([x0, x1, x22] = _, t02 = transform2(x0 = +x0), t12 = transform2(x1 = +x1), t22 = transform2(x22 = +x22), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s4 = t12 < t02 ? -1 : 1, scale2) : [x0, x1, x22];
  }, scale2.clamp = function(_) {
    return arguments.length ? (clamp2 = !!_, scale2) : clamp2;
  }, scale2.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale2) : interpolator;
  };
  function range3(interpolate2) {
    return function(_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate2, [r0, r1, r2]), scale2) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  return __name(range3, "range"), scale2.range = range3(interpolate), scale2.rangeRound = range3(interpolateRound), scale2.unknown = function(_) {
    return arguments.length ? (unknown = _, scale2) : unknown;
  }, function(t3) {
    return transform2 = t3, t02 = t3(x0), t12 = t3(x1), t22 = t3(x22), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s4 = t12 < t02 ? -1 : 1, scale2;
  };
}
__name(transformer, "transformer");
function diverging() {
  var scale2 = linearish(transformer()(identity$6));
  return scale2.copy = function() {
    return copy(scale2, diverging());
  }, initInterpolator.apply(scale2, arguments);
}
__name(diverging, "diverging");
function divergingLog() {
  var scale2 = loggish(transformer()).domain([0.1, 1, 10]);
  return scale2.copy = function() {
    return copy(scale2, divergingLog()).base(scale2.base());
  }, initInterpolator.apply(scale2, arguments);
}
__name(divergingLog, "divergingLog");
function divergingSymlog() {
  var scale2 = symlogish(transformer());
  return scale2.copy = function() {
    return copy(scale2, divergingSymlog()).constant(scale2.constant());
  }, initInterpolator.apply(scale2, arguments);
}
__name(divergingSymlog, "divergingSymlog");
function divergingPow() {
  var scale2 = powish(transformer());
  return scale2.copy = function() {
    return copy(scale2, divergingPow()).exponent(scale2.exponent());
  }, initInterpolator.apply(scale2, arguments);
}
__name(divergingPow, "divergingPow");
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
__name(divergingSqrt, "divergingSqrt");
const d3Scales = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: band,
  scaleDiverging: diverging,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  scaleIdentity: identity$4,
  scaleImplicit: implicit,
  scaleLinear: linear,
  scaleLog: log,
  scaleOrdinal: ordinal,
  scalePoint: point,
  scalePow: pow,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleRadial: radial,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialQuantile: sequentialQuantile,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSqrt: sqrt,
  scaleSymlog: symlog,
  scaleThreshold: threshold,
  scaleTime: time,
  scaleUtc: utcTime,
  tickFormat
}, Symbol.toStringTag, { value: "Module" }));
var isSymbol = isSymbol_1;
function baseExtremum$4(array2, iteratee, comparator2) {
  for (var index2 = -1, length = array2.length; ++index2 < length; ) {
    var value = array2[index2], current = iteratee(value);
    if (current != null && (computed === void 0 ? current === current && !isSymbol(current) : comparator2(current, computed)))
      var computed = current, result2 = value;
  }
  return result2;
}
__name(baseExtremum$4, "baseExtremum$4");
var _baseExtremum = baseExtremum$4;
function baseGt$2(value, other) {
  return value > other;
}
__name(baseGt$2, "baseGt$2");
var _baseGt = baseGt$2, baseExtremum$3 = _baseExtremum, baseGt$1 = _baseGt, identity$3 = identity_1;
function max(array2) {
  return array2 && array2.length ? baseExtremum$3(array2, identity$3, baseGt$1) : void 0;
}
__name(max, "max");
var max_1 = max;
const max$1 = /* @__PURE__ */ getDefaultExportFromCjs(max_1);
function baseLt$2(value, other) {
  return value < other;
}
__name(baseLt$2, "baseLt$2");
var _baseLt = baseLt$2, baseExtremum$2 = _baseExtremum, baseLt$1 = _baseLt, identity$2 = identity_1;
function min(array2) {
  return array2 && array2.length ? baseExtremum$2(array2, identity$2, baseLt$1) : void 0;
}
__name(min, "min");
var min_1 = min;
const min$1 = /* @__PURE__ */ getDefaultExportFromCjs(min_1);
var arrayMap = _arrayMap, baseIteratee$5 = _baseIteratee, baseMap = _baseMap, isArray$3 = isArray_1;
function map$2(collection, iteratee) {
  var func2 = isArray$3(collection) ? arrayMap : baseMap;
  return func2(collection, baseIteratee$5(iteratee));
}
__name(map$2, "map$2");
var map_1 = map$2, baseFlatten = _baseFlatten, map$1 = map_1;
function flatMap(collection, iteratee) {
  return baseFlatten(map$1(collection, iteratee), 1);
}
__name(flatMap, "flatMap");
var flatMap_1 = flatMap;
const flatMap$1 = /* @__PURE__ */ getDefaultExportFromCjs(flatMap_1);
var baseIsEqual = _baseIsEqual;
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
__name(isEqual, "isEqual");
var isEqual_1 = isEqual;
const isEqual$1 = /* @__PURE__ */ getDefaultExportFromCjs(isEqual_1);
var MAX_DIGITS = 1e9, defaults = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Decimal, external = !0, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), P = {};
P.absoluteValue = P.abs = function() {
  var x3 = new this.constructor(this);
  return x3.s && (x3.s = 1), x3;
};
P.comparedTo = P.cmp = function(y4) {
  var i2, j, xdL, ydL, x3 = this;
  if (y4 = new x3.constructor(y4), x3.s !== y4.s)
    return x3.s || -y4.s;
  if (x3.e !== y4.e)
    return x3.e > y4.e ^ x3.s < 0 ? 1 : -1;
  for (xdL = x3.d.length, ydL = y4.d.length, i2 = 0, j = xdL < ydL ? xdL : ydL; i2 < j; ++i2)
    if (x3.d[i2] !== y4.d[i2])
      return x3.d[i2] > y4.d[i2] ^ x3.s < 0 ? 1 : -1;
  return xdL === ydL ? 0 : xdL > ydL ^ x3.s < 0 ? 1 : -1;
};
P.decimalPlaces = P.dp = function() {
  var x3 = this, w2 = x3.d.length - 1, dp = (w2 - x3.e) * LOG_BASE;
  if (w2 = x3.d[w2], w2)
    for (; w2 % 10 == 0; w2 /= 10)
      dp--;
  return dp < 0 ? 0 : dp;
};
P.dividedBy = P.div = function(y4) {
  return divide(this, new this.constructor(y4));
};
P.dividedToIntegerBy = P.idiv = function(y4) {
  var x3 = this, Ctor = x3.constructor;
  return round(divide(x3, new Ctor(y4), 0, 1), Ctor.precision);
};
P.equals = P.eq = function(y4) {
  return !this.cmp(y4);
};
P.exponent = function() {
  return getBase10Exponent(this);
};
P.greaterThan = P.gt = function(y4) {
  return this.cmp(y4) > 0;
};
P.greaterThanOrEqualTo = P.gte = function(y4) {
  return this.cmp(y4) >= 0;
};
P.isInteger = P.isint = function() {
  return this.e > this.d.length - 2;
};
P.isNegative = P.isneg = function() {
  return this.s < 0;
};
P.isPositive = P.ispos = function() {
  return this.s > 0;
};
P.isZero = function() {
  return this.s === 0;
};
P.lessThan = P.lt = function(y4) {
  return this.cmp(y4) < 0;
};
P.lessThanOrEqualTo = P.lte = function(y4) {
  return this.cmp(y4) < 1;
};
P.logarithm = P.log = function(base) {
  var r2, x3 = this, Ctor = x3.constructor, pr = Ctor.precision, wpr = pr + 5;
  if (base === void 0)
    base = new Ctor(10);
  else if (base = new Ctor(base), base.s < 1 || base.eq(ONE))
    throw Error(decimalError + "NaN");
  if (x3.s < 1)
    throw Error(decimalError + (x3.s ? "NaN" : "-Infinity"));
  return x3.eq(ONE) ? new Ctor(0) : (external = !1, r2 = divide(ln(x3, wpr), ln(base, wpr), wpr), external = !0, round(r2, pr));
};
P.minus = P.sub = function(y4) {
  var x3 = this;
  return y4 = new x3.constructor(y4), x3.s == y4.s ? subtract(x3, y4) : add(x3, (y4.s = -y4.s, y4));
};
P.modulo = P.mod = function(y4) {
  var q2, x3 = this, Ctor = x3.constructor, pr = Ctor.precision;
  if (y4 = new Ctor(y4), !y4.s)
    throw Error(decimalError + "NaN");
  return x3.s ? (external = !1, q2 = divide(x3, y4, 0, 1).times(y4), external = !0, x3.minus(q2)) : round(new Ctor(x3), pr);
};
P.naturalExponential = P.exp = function() {
  return exp(this);
};
P.naturalLogarithm = P.ln = function() {
  return ln(this);
};
P.negated = P.neg = function() {
  var x3 = new this.constructor(this);
  return x3.s = -x3.s || 0, x3;
};
P.plus = P.add = function(y4) {
  var x3 = this;
  return y4 = new x3.constructor(y4), x3.s == y4.s ? add(x3, y4) : subtract(x3, (y4.s = -y4.s, y4));
};
P.precision = P.sd = function(z2) {
  var e3, sd, w2, x3 = this;
  if (z2 !== void 0 && z2 !== !!z2 && z2 !== 1 && z2 !== 0)
    throw Error(invalidArgument + z2);
  if (e3 = getBase10Exponent(x3) + 1, w2 = x3.d.length - 1, sd = w2 * LOG_BASE + 1, w2 = x3.d[w2], w2) {
    for (; w2 % 10 == 0; w2 /= 10)
      sd--;
    for (w2 = x3.d[0]; w2 >= 10; w2 /= 10)
      sd++;
  }
  return z2 && e3 > sd ? e3 : sd;
};
P.squareRoot = P.sqrt = function() {
  var e3, n, pr, r2, s4, t3, wpr, x3 = this, Ctor = x3.constructor;
  if (x3.s < 1) {
    if (!x3.s)
      return new Ctor(0);
    throw Error(decimalError + "NaN");
  }
  for (e3 = getBase10Exponent(x3), external = !1, s4 = Math.sqrt(+x3), s4 == 0 || s4 == 1 / 0 ? (n = digitsToString(x3.d), (n.length + e3) % 2 == 0 && (n += "0"), s4 = Math.sqrt(n), e3 = mathfloor((e3 + 1) / 2) - (e3 < 0 || e3 % 2), s4 == 1 / 0 ? n = "5e" + e3 : (n = s4.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + e3), r2 = new Ctor(n)) : r2 = new Ctor(s4.toString()), pr = Ctor.precision, s4 = wpr = pr + 3; ; )
    if (t3 = r2, r2 = t3.plus(divide(x3, t3, wpr + 2)).times(0.5), digitsToString(t3.d).slice(0, wpr) === (n = digitsToString(r2.d)).slice(0, wpr)) {
      if (n = n.slice(wpr - 3, wpr + 1), s4 == wpr && n == "4999") {
        if (round(t3, pr + 1, 0), t3.times(t3).eq(x3)) {
          r2 = t3;
          break;
        }
      } else if (n != "9999")
        break;
      wpr += 4;
    }
  return external = !0, round(r2, pr);
};
P.times = P.mul = function(y4) {
  var carry, e3, i2, k3, r2, rL, t3, xdL, ydL, x3 = this, Ctor = x3.constructor, xd = x3.d, yd = (y4 = new Ctor(y4)).d;
  if (!x3.s || !y4.s)
    return new Ctor(0);
  for (y4.s *= x3.s, e3 = x3.e + y4.e, xdL = xd.length, ydL = yd.length, xdL < ydL && (r2 = xd, xd = yd, yd = r2, rL = xdL, xdL = ydL, ydL = rL), r2 = [], rL = xdL + ydL, i2 = rL; i2--; )
    r2.push(0);
  for (i2 = ydL; --i2 >= 0; ) {
    for (carry = 0, k3 = xdL + i2; k3 > i2; )
      t3 = r2[k3] + yd[i2] * xd[k3 - i2 - 1] + carry, r2[k3--] = t3 % BASE | 0, carry = t3 / BASE | 0;
    r2[k3] = (r2[k3] + carry) % BASE | 0;
  }
  for (; !r2[--rL]; )
    r2.pop();
  return carry ? ++e3 : r2.shift(), y4.d = r2, y4.e = e3, external ? round(y4, Ctor.precision) : y4;
};
P.toDecimalPlaces = P.todp = function(dp, rm) {
  var x3 = this, Ctor = x3.constructor;
  return x3 = new Ctor(x3), dp === void 0 ? x3 : (checkInt32(dp, 0, MAX_DIGITS), rm === void 0 ? rm = Ctor.rounding : checkInt32(rm, 0, 8), round(x3, dp + getBase10Exponent(x3) + 1, rm));
};
P.toExponential = function(dp, rm) {
  var str, x3 = this, Ctor = x3.constructor;
  return dp === void 0 ? str = toString(x3, !0) : (checkInt32(dp, 0, MAX_DIGITS), rm === void 0 ? rm = Ctor.rounding : checkInt32(rm, 0, 8), x3 = round(new Ctor(x3), dp + 1, rm), str = toString(x3, !0, dp + 1)), str;
};
P.toFixed = function(dp, rm) {
  var str, y4, x3 = this, Ctor = x3.constructor;
  return dp === void 0 ? toString(x3) : (checkInt32(dp, 0, MAX_DIGITS), rm === void 0 ? rm = Ctor.rounding : checkInt32(rm, 0, 8), y4 = round(new Ctor(x3), dp + getBase10Exponent(x3) + 1, rm), str = toString(y4.abs(), !1, dp + getBase10Exponent(y4) + 1), x3.isneg() && !x3.isZero() ? "-" + str : str);
};
P.toInteger = P.toint = function() {
  var x3 = this, Ctor = x3.constructor;
  return round(new Ctor(x3), getBase10Exponent(x3) + 1, Ctor.rounding);
};
P.toNumber = function() {
  return +this;
};
P.toPower = P.pow = function(y4) {
  var e3, k3, pr, r2, sign2, yIsInt, x3 = this, Ctor = x3.constructor, guard = 12, yn = +(y4 = new Ctor(y4));
  if (!y4.s)
    return new Ctor(ONE);
  if (x3 = new Ctor(x3), !x3.s) {
    if (y4.s < 1)
      throw Error(decimalError + "Infinity");
    return x3;
  }
  if (x3.eq(ONE))
    return x3;
  if (pr = Ctor.precision, y4.eq(ONE))
    return round(x3, pr);
  if (e3 = y4.e, k3 = y4.d.length - 1, yIsInt = e3 >= k3, sign2 = x3.s, yIsInt) {
    if ((k3 = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
      for (r2 = new Ctor(ONE), e3 = Math.ceil(pr / LOG_BASE + 4), external = !1; k3 % 2 && (r2 = r2.times(x3), truncate(r2.d, e3)), k3 = mathfloor(k3 / 2), k3 !== 0; )
        x3 = x3.times(x3), truncate(x3.d, e3);
      return external = !0, y4.s < 0 ? new Ctor(ONE).div(r2) : round(r2, pr);
    }
  } else if (sign2 < 0)
    throw Error(decimalError + "NaN");
  return sign2 = sign2 < 0 && y4.d[Math.max(e3, k3)] & 1 ? -1 : 1, x3.s = 1, external = !1, r2 = y4.times(ln(x3, pr + guard)), external = !0, r2 = exp(r2), r2.s = sign2, r2;
};
P.toPrecision = function(sd, rm) {
  var e3, str, x3 = this, Ctor = x3.constructor;
  return sd === void 0 ? (e3 = getBase10Exponent(x3), str = toString(x3, e3 <= Ctor.toExpNeg || e3 >= Ctor.toExpPos)) : (checkInt32(sd, 1, MAX_DIGITS), rm === void 0 ? rm = Ctor.rounding : checkInt32(rm, 0, 8), x3 = round(new Ctor(x3), sd, rm), e3 = getBase10Exponent(x3), str = toString(x3, sd <= e3 || e3 <= Ctor.toExpNeg, sd)), str;
};
P.toSignificantDigits = P.tosd = function(sd, rm) {
  var x3 = this, Ctor = x3.constructor;
  return sd === void 0 ? (sd = Ctor.precision, rm = Ctor.rounding) : (checkInt32(sd, 1, MAX_DIGITS), rm === void 0 ? rm = Ctor.rounding : checkInt32(rm, 0, 8)), round(new Ctor(x3), sd, rm);
};
P.toString = P.valueOf = P.val = P.toJSON = P[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var x3 = this, e3 = getBase10Exponent(x3), Ctor = x3.constructor;
  return toString(x3, e3 <= Ctor.toExpNeg || e3 >= Ctor.toExpPos);
};
function add(x3, y4) {
  var carry, d3, e3, i2, k3, len, xd, yd, Ctor = x3.constructor, pr = Ctor.precision;
  if (!x3.s || !y4.s)
    return y4.s || (y4 = new Ctor(x3)), external ? round(y4, pr) : y4;
  if (xd = x3.d, yd = y4.d, k3 = x3.e, e3 = y4.e, xd = xd.slice(), i2 = k3 - e3, i2) {
    for (i2 < 0 ? (d3 = xd, i2 = -i2, len = yd.length) : (d3 = yd, e3 = k3, len = xd.length), k3 = Math.ceil(pr / LOG_BASE), len = k3 > len ? k3 + 1 : len + 1, i2 > len && (i2 = len, d3.length = 1), d3.reverse(); i2--; )
      d3.push(0);
    d3.reverse();
  }
  for (len = xd.length, i2 = yd.length, len - i2 < 0 && (i2 = len, d3 = yd, yd = xd, xd = d3), carry = 0; i2; )
    carry = (xd[--i2] = xd[i2] + yd[i2] + carry) / BASE | 0, xd[i2] %= BASE;
  for (carry && (xd.unshift(carry), ++e3), len = xd.length; xd[--len] == 0; )
    xd.pop();
  return y4.d = xd, y4.e = e3, external ? round(y4, pr) : y4;
}
__name(add, "add");
function checkInt32(i2, min2, max2) {
  if (i2 !== ~~i2 || i2 < min2 || i2 > max2)
    throw Error(invalidArgument + i2);
}
__name(checkInt32, "checkInt32");
function digitsToString(d3) {
  var i2, k3, ws, indexOfLastWord = d3.length - 1, str = "", w2 = d3[0];
  if (indexOfLastWord > 0) {
    for (str += w2, i2 = 1; i2 < indexOfLastWord; i2++)
      ws = d3[i2] + "", k3 = LOG_BASE - ws.length, k3 && (str += getZeroString(k3)), str += ws;
    w2 = d3[i2], ws = w2 + "", k3 = LOG_BASE - ws.length, k3 && (str += getZeroString(k3));
  } else if (w2 === 0)
    return "0";
  for (; w2 % 10 === 0; )
    w2 /= 10;
  return str + w2;
}
__name(digitsToString, "digitsToString");
var divide = function() {
  function multiplyInteger(x3, k3) {
    var temp, carry = 0, i2 = x3.length;
    for (x3 = x3.slice(); i2--; )
      temp = x3[i2] * k3 + carry, x3[i2] = temp % BASE | 0, carry = temp / BASE | 0;
    return carry && x3.unshift(carry), x3;
  }
  __name(multiplyInteger, "multiplyInteger");
  function compare2(a4, b2, aL, bL) {
    var i2, r2;
    if (aL != bL)
      r2 = aL > bL ? 1 : -1;
    else
      for (i2 = r2 = 0; i2 < aL; i2++)
        if (a4[i2] != b2[i2]) {
          r2 = a4[i2] > b2[i2] ? 1 : -1;
          break;
        }
    return r2;
  }
  __name(compare2, "compare");
  function subtract2(a4, b2, aL) {
    for (var i2 = 0; aL--; )
      a4[aL] -= i2, i2 = a4[aL] < b2[aL] ? 1 : 0, a4[aL] = i2 * BASE + a4[aL] - b2[aL];
    for (; !a4[0] && a4.length > 1; )
      a4.shift();
  }
  return __name(subtract2, "subtract"), function(x3, y4, pr, dp) {
    var cmp2, e3, i2, k3, prod, prodL, q2, qd, rem, remL, rem0, sd, t3, xi, xL, yd0, yL, yz, Ctor = x3.constructor, sign2 = x3.s == y4.s ? 1 : -1, xd = x3.d, yd = y4.d;
    if (!x3.s)
      return new Ctor(x3);
    if (!y4.s)
      throw Error(decimalError + "Division by zero");
    for (e3 = x3.e - y4.e, yL = yd.length, xL = xd.length, q2 = new Ctor(sign2), qd = q2.d = [], i2 = 0; yd[i2] == (xd[i2] || 0); )
      ++i2;
    if (yd[i2] > (xd[i2] || 0) && --e3, pr == null ? sd = pr = Ctor.precision : dp ? sd = pr + (getBase10Exponent(x3) - getBase10Exponent(y4)) + 1 : sd = pr, sd < 0)
      return new Ctor(0);
    if (sd = sd / LOG_BASE + 2 | 0, i2 = 0, yL == 1)
      for (k3 = 0, yd = yd[0], sd++; (i2 < xL || k3) && sd--; i2++)
        t3 = k3 * BASE + (xd[i2] || 0), qd[i2] = t3 / yd | 0, k3 = t3 % yd | 0;
    else {
      for (k3 = BASE / (yd[0] + 1) | 0, k3 > 1 && (yd = multiplyInteger(yd, k3), xd = multiplyInteger(xd, k3), yL = yd.length, xL = xd.length), xi = yL, rem = xd.slice(0, yL), remL = rem.length; remL < yL; )
        rem[remL++] = 0;
      yz = yd.slice(), yz.unshift(0), yd0 = yd[0], yd[1] >= BASE / 2 && ++yd0;
      do
        k3 = 0, cmp2 = compare2(yd, rem, yL, remL), cmp2 < 0 ? (rem0 = rem[0], yL != remL && (rem0 = rem0 * BASE + (rem[1] || 0)), k3 = rem0 / yd0 | 0, k3 > 1 ? (k3 >= BASE && (k3 = BASE - 1), prod = multiplyInteger(yd, k3), prodL = prod.length, remL = rem.length, cmp2 = compare2(prod, rem, prodL, remL), cmp2 == 1 && (k3--, subtract2(prod, yL < prodL ? yz : yd, prodL))) : (k3 == 0 && (cmp2 = k3 = 1), prod = yd.slice()), prodL = prod.length, prodL < remL && prod.unshift(0), subtract2(rem, prod, remL), cmp2 == -1 && (remL = rem.length, cmp2 = compare2(yd, rem, yL, remL), cmp2 < 1 && (k3++, subtract2(rem, yL < remL ? yz : yd, remL))), remL = rem.length) : cmp2 === 0 && (k3++, rem = [0]), qd[i2++] = k3, cmp2 && rem[0] ? rem[remL++] = xd[xi] || 0 : (rem = [xd[xi]], remL = 1);
      while ((xi++ < xL || rem[0] !== void 0) && sd--);
    }
    return qd[0] || qd.shift(), q2.e = e3, round(q2, dp ? pr + getBase10Exponent(q2) + 1 : pr);
  };
}();
function exp(x3, sd) {
  var denominator, guard, pow2, sum, t3, wpr, i2 = 0, k3 = 0, Ctor = x3.constructor, pr = Ctor.precision;
  if (getBase10Exponent(x3) > 16)
    throw Error(exponentOutOfRange + getBase10Exponent(x3));
  if (!x3.s)
    return new Ctor(ONE);
  for (sd == null ? (external = !1, wpr = pr) : wpr = sd, t3 = new Ctor(0.03125); x3.abs().gte(0.1); )
    x3 = x3.times(t3), k3 += 5;
  for (guard = Math.log(mathpow(2, k3)) / Math.LN10 * 2 + 5 | 0, wpr += guard, denominator = pow2 = sum = new Ctor(ONE), Ctor.precision = wpr; ; ) {
    if (pow2 = round(pow2.times(x3), wpr), denominator = denominator.times(++i2), t3 = sum.plus(divide(pow2, denominator, wpr)), digitsToString(t3.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
      for (; k3--; )
        sum = round(sum.times(sum), wpr);
      return Ctor.precision = pr, sd == null ? (external = !0, round(sum, pr)) : sum;
    }
    sum = t3;
  }
}
__name(exp, "exp");
function getBase10Exponent(x3) {
  for (var e3 = x3.e * LOG_BASE, w2 = x3.d[0]; w2 >= 10; w2 /= 10)
    e3++;
  return e3;
}
__name(getBase10Exponent, "getBase10Exponent");
function getLn10(Ctor, sd, pr) {
  if (sd > Ctor.LN10.sd())
    throw external = !0, pr && (Ctor.precision = pr), Error(decimalError + "LN10 precision limit exceeded");
  return round(new Ctor(Ctor.LN10), sd);
}
__name(getLn10, "getLn10");
function getZeroString(k3) {
  for (var zs = ""; k3--; )
    zs += "0";
  return zs;
}
__name(getZeroString, "getZeroString");
function ln(y4, sd) {
  var c3, c0, denominator, e3, numerator, sum, t3, wpr, x22, n = 1, guard = 10, x3 = y4, xd = x3.d, Ctor = x3.constructor, pr = Ctor.precision;
  if (x3.s < 1)
    throw Error(decimalError + (x3.s ? "NaN" : "-Infinity"));
  if (x3.eq(ONE))
    return new Ctor(0);
  if (sd == null ? (external = !1, wpr = pr) : wpr = sd, x3.eq(10))
    return sd == null && (external = !0), getLn10(Ctor, wpr);
  if (wpr += guard, Ctor.precision = wpr, c3 = digitsToString(xd), c0 = c3.charAt(0), e3 = getBase10Exponent(x3), Math.abs(e3) < 15e14) {
    for (; c0 < 7 && c0 != 1 || c0 == 1 && c3.charAt(1) > 3; )
      x3 = x3.times(y4), c3 = digitsToString(x3.d), c0 = c3.charAt(0), n++;
    e3 = getBase10Exponent(x3), c0 > 1 ? (x3 = new Ctor("0." + c3), e3++) : x3 = new Ctor(c0 + "." + c3.slice(1));
  } else
    return t3 = getLn10(Ctor, wpr + 2, pr).times(e3 + ""), x3 = ln(new Ctor(c0 + "." + c3.slice(1)), wpr - guard).plus(t3), Ctor.precision = pr, sd == null ? (external = !0, round(x3, pr)) : x3;
  for (sum = numerator = x3 = divide(x3.minus(ONE), x3.plus(ONE), wpr), x22 = round(x3.times(x3), wpr), denominator = 3; ; ) {
    if (numerator = round(numerator.times(x22), wpr), t3 = sum.plus(divide(numerator, new Ctor(denominator), wpr)), digitsToString(t3.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr))
      return sum = sum.times(2), e3 !== 0 && (sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e3 + ""))), sum = divide(sum, new Ctor(n), wpr), Ctor.precision = pr, sd == null ? (external = !0, round(sum, pr)) : sum;
    sum = t3, denominator += 2;
  }
}
__name(ln, "ln");
function parseDecimal(x3, str) {
  var e3, i2, len;
  for ((e3 = str.indexOf(".")) > -1 && (str = str.replace(".", "")), (i2 = str.search(/e/i)) > 0 ? (e3 < 0 && (e3 = i2), e3 += +str.slice(i2 + 1), str = str.substring(0, i2)) : e3 < 0 && (e3 = str.length), i2 = 0; str.charCodeAt(i2) === 48; )
    ++i2;
  for (len = str.length; str.charCodeAt(len - 1) === 48; )
    --len;
  if (str = str.slice(i2, len), str) {
    if (len -= i2, e3 = e3 - i2 - 1, x3.e = mathfloor(e3 / LOG_BASE), x3.d = [], i2 = (e3 + 1) % LOG_BASE, e3 < 0 && (i2 += LOG_BASE), i2 < len) {
      for (i2 && x3.d.push(+str.slice(0, i2)), len -= LOG_BASE; i2 < len; )
        x3.d.push(+str.slice(i2, i2 += LOG_BASE));
      str = str.slice(i2), i2 = LOG_BASE - str.length;
    } else
      i2 -= len;
    for (; i2--; )
      str += "0";
    if (x3.d.push(+str), external && (x3.e > MAX_E || x3.e < -MAX_E))
      throw Error(exponentOutOfRange + e3);
  } else
    x3.s = 0, x3.e = 0, x3.d = [0];
  return x3;
}
__name(parseDecimal, "parseDecimal");
function round(x3, sd, rm) {
  var i2, j, k3, n, rd, doRound, w2, xdi, xd = x3.d;
  for (n = 1, k3 = xd[0]; k3 >= 10; k3 /= 10)
    n++;
  if (i2 = sd - n, i2 < 0)
    i2 += LOG_BASE, j = sd, w2 = xd[xdi = 0];
  else {
    if (xdi = Math.ceil((i2 + 1) / LOG_BASE), k3 = xd.length, xdi >= k3)
      return x3;
    for (w2 = k3 = xd[xdi], n = 1; k3 >= 10; k3 /= 10)
      n++;
    i2 %= LOG_BASE, j = i2 - LOG_BASE + n;
  }
  if (rm !== void 0 && (k3 = mathpow(10, n - j - 1), rd = w2 / k3 % 10 | 0, doRound = sd < 0 || xd[xdi + 1] !== void 0 || w2 % k3, doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x3.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (i2 > 0 ? j > 0 ? w2 / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x3.s < 0 ? 8 : 7))), sd < 1 || !xd[0])
    return doRound ? (k3 = getBase10Exponent(x3), xd.length = 1, sd = sd - k3 - 1, xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE), x3.e = mathfloor(-sd / LOG_BASE) || 0) : (xd.length = 1, xd[0] = x3.e = x3.s = 0), x3;
  if (i2 == 0 ? (xd.length = xdi, k3 = 1, xdi--) : (xd.length = xdi + 1, k3 = mathpow(10, LOG_BASE - i2), xd[xdi] = j > 0 ? (w2 / mathpow(10, n - j) % mathpow(10, j) | 0) * k3 : 0), doRound)
    for (; ; )
      if (xdi == 0) {
        (xd[0] += k3) == BASE && (xd[0] = 1, ++x3.e);
        break;
      } else {
        if (xd[xdi] += k3, xd[xdi] != BASE)
          break;
        xd[xdi--] = 0, k3 = 1;
      }
  for (i2 = xd.length; xd[--i2] === 0; )
    xd.pop();
  if (external && (x3.e > MAX_E || x3.e < -MAX_E))
    throw Error(exponentOutOfRange + getBase10Exponent(x3));
  return x3;
}
__name(round, "round");
function subtract(x3, y4) {
  var d3, e3, i2, j, k3, len, xd, xe, xLTy, yd, Ctor = x3.constructor, pr = Ctor.precision;
  if (!x3.s || !y4.s)
    return y4.s ? y4.s = -y4.s : y4 = new Ctor(x3), external ? round(y4, pr) : y4;
  if (xd = x3.d, yd = y4.d, e3 = y4.e, xe = x3.e, xd = xd.slice(), k3 = xe - e3, k3) {
    for (xLTy = k3 < 0, xLTy ? (d3 = xd, k3 = -k3, len = yd.length) : (d3 = yd, e3 = xe, len = xd.length), i2 = Math.max(Math.ceil(pr / LOG_BASE), len) + 2, k3 > i2 && (k3 = i2, d3.length = 1), d3.reverse(), i2 = k3; i2--; )
      d3.push(0);
    d3.reverse();
  } else {
    for (i2 = xd.length, len = yd.length, xLTy = i2 < len, xLTy && (len = i2), i2 = 0; i2 < len; i2++)
      if (xd[i2] != yd[i2]) {
        xLTy = xd[i2] < yd[i2];
        break;
      }
    k3 = 0;
  }
  for (xLTy && (d3 = xd, xd = yd, yd = d3, y4.s = -y4.s), len = xd.length, i2 = yd.length - len; i2 > 0; --i2)
    xd[len++] = 0;
  for (i2 = yd.length; i2 > k3; ) {
    if (xd[--i2] < yd[i2]) {
      for (j = i2; j && xd[--j] === 0; )
        xd[j] = BASE - 1;
      --xd[j], xd[i2] += BASE;
    }
    xd[i2] -= yd[i2];
  }
  for (; xd[--len] === 0; )
    xd.pop();
  for (; xd[0] === 0; xd.shift())
    --e3;
  return xd[0] ? (y4.d = xd, y4.e = e3, external ? round(y4, pr) : y4) : new Ctor(0);
}
__name(subtract, "subtract");
function toString(x3, isExp, sd) {
  var k3, e3 = getBase10Exponent(x3), str = digitsToString(x3.d), len = str.length;
  return isExp ? (sd && (k3 = sd - len) > 0 ? str = str.charAt(0) + "." + str.slice(1) + getZeroString(k3) : len > 1 && (str = str.charAt(0) + "." + str.slice(1)), str = str + (e3 < 0 ? "e" : "e+") + e3) : e3 < 0 ? (str = "0." + getZeroString(-e3 - 1) + str, sd && (k3 = sd - len) > 0 && (str += getZeroString(k3))) : e3 >= len ? (str += getZeroString(e3 + 1 - len), sd && (k3 = sd - e3 - 1) > 0 && (str = str + "." + getZeroString(k3))) : ((k3 = e3 + 1) < len && (str = str.slice(0, k3) + "." + str.slice(k3)), sd && (k3 = sd - len) > 0 && (e3 + 1 === len && (str += "."), str += getZeroString(k3))), x3.s < 0 ? "-" + str : str;
}
__name(toString, "toString");
function truncate(arr, len) {
  if (arr.length > len)
    return arr.length = len, !0;
}
__name(truncate, "truncate");
function clone(obj2) {
  var i2, p, ps;
  function Decimal2(value) {
    var x3 = this;
    if (!(x3 instanceof Decimal2))
      return new Decimal2(value);
    if (x3.constructor = Decimal2, value instanceof Decimal2) {
      x3.s = value.s, x3.e = value.e, x3.d = (value = value.d) ? value.slice() : value;
      return;
    }
    if (typeof value == "number") {
      if (value * 0 !== 0)
        throw Error(invalidArgument + value);
      if (value > 0)
        x3.s = 1;
      else if (value < 0)
        value = -value, x3.s = -1;
      else {
        x3.s = 0, x3.e = 0, x3.d = [0];
        return;
      }
      if (value === ~~value && value < 1e7) {
        x3.e = 0, x3.d = [value];
        return;
      }
      return parseDecimal(x3, value.toString());
    } else if (typeof value != "string")
      throw Error(invalidArgument + value);
    if (value.charCodeAt(0) === 45 ? (value = value.slice(1), x3.s = -1) : x3.s = 1, isDecimal.test(value))
      parseDecimal(x3, value);
    else
      throw Error(invalidArgument + value);
  }
  if (__name(Decimal2, "Decimal"), Decimal2.prototype = P, Decimal2.ROUND_UP = 0, Decimal2.ROUND_DOWN = 1, Decimal2.ROUND_CEIL = 2, Decimal2.ROUND_FLOOR = 3, Decimal2.ROUND_HALF_UP = 4, Decimal2.ROUND_HALF_DOWN = 5, Decimal2.ROUND_HALF_EVEN = 6, Decimal2.ROUND_HALF_CEIL = 7, Decimal2.ROUND_HALF_FLOOR = 8, Decimal2.clone = clone, Decimal2.config = Decimal2.set = config, obj2 === void 0 && (obj2 = {}), obj2)
    for (ps = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], i2 = 0; i2 < ps.length; )
      obj2.hasOwnProperty(p = ps[i2++]) || (obj2[p] = this[p]);
  return Decimal2.config(obj2), Decimal2;
}
__name(clone, "clone");
function config(obj2) {
  if (!obj2 || typeof obj2 != "object")
    throw Error(decimalError + "Object expected");
  var i2, p, v, ps = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (i2 = 0; i2 < ps.length; i2 += 3)
    if ((v = obj2[p = ps[i2]]) !== void 0)
      if (mathfloor(v) === v && v >= ps[i2 + 1] && v <= ps[i2 + 2])
        this[p] = v;
      else
        throw Error(invalidArgument + p + ": " + v);
  if ((v = obj2[p = "LN10"]) !== void 0)
    if (v == Math.LN10)
      this[p] = new this(v);
    else
      throw Error(invalidArgument + p + ": " + v);
  return this;
}
__name(config, "config");
var Decimal = clone(defaults);
ONE = new Decimal(1);
const Decimal$1 = Decimal;
function _toConsumableArray$a(arr) {
  return _arrayWithoutHoles$a(arr) || _iterableToArray$b(arr) || _unsupportedIterableToArray$g(arr) || _nonIterableSpread$a();
}
__name(_toConsumableArray$a, "_toConsumableArray$a");
function _nonIterableSpread$a() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$a, "_nonIterableSpread$a");
function _unsupportedIterableToArray$g(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$g(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$g(o, minLen);
  }
}
__name(_unsupportedIterableToArray$g, "_unsupportedIterableToArray$g");
function _iterableToArray$b(iter) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(iter))
    return Array.from(iter);
}
__name(_iterableToArray$b, "_iterableToArray$b");
function _arrayWithoutHoles$a(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$g(arr);
}
__name(_arrayWithoutHoles$a, "_arrayWithoutHoles$a");
function _arrayLikeToArray$g(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$g, "_arrayLikeToArray$g");
var identity$1 = /* @__PURE__ */ __name(function(i2) {
  return i2;
}, "identity"), PLACE_HOLDER = {
  "@@functional/placeholder": !0
}, isPlaceHolder = /* @__PURE__ */ __name(function(val) {
  return val === PLACE_HOLDER;
}, "isPlaceHolder"), curry0 = /* @__PURE__ */ __name(function(fn) {
  return /* @__PURE__ */ __name(function _curried() {
    return arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? void 0 : arguments[0]) ? _curried : fn.apply(void 0, arguments);
  }, "_curried");
}, "curry0"), curryN = /* @__PURE__ */ __name(function curryN2(n, fn) {
  return n === 1 ? fn : curry0(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
      args[_key] = arguments[_key];
    var argsLength = args.filter(function(arg) {
      return arg !== PLACE_HOLDER;
    }).length;
    return argsLength >= n ? fn.apply(void 0, args) : curryN2(n - argsLength, curry0(function() {
      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)
        restArgs[_key2] = arguments[_key2];
      var newArgs = args.map(function(arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });
      return fn.apply(void 0, _toConsumableArray$a(newArgs).concat(restArgs));
    }));
  });
}, "curryN"), curry = /* @__PURE__ */ __name(function(fn) {
  return curryN(fn.length, fn);
}, "curry"), range$2 = /* @__PURE__ */ __name(function(begin, end) {
  for (var arr = [], i2 = begin; i2 < end; ++i2)
    arr[i2 - begin] = i2;
  return arr;
}, "range"), map = curry(function(fn, arr) {
  return Array.isArray(arr) ? arr.map(fn) : Object.keys(arr).map(function(key) {
    return arr[key];
  }).map(fn);
}), compose = /* @__PURE__ */ __name(function() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)
    args[_key3] = arguments[_key3];
  if (!args.length)
    return identity$1;
  var fns = args.reverse(), firstFn = fns[0], tailsFn = fns.slice(1);
  return function() {
    return tailsFn.reduce(function(res, fn) {
      return fn(res);
    }, firstFn.apply(void 0, arguments));
  };
}, "compose"), reverse = /* @__PURE__ */ __name(function(arr) {
  return Array.isArray(arr) ? arr.reverse() : arr.split("").reverse.join("");
}, "reverse"), memoize = /* @__PURE__ */ __name(function(fn) {
  var lastArgs = null, lastResult2 = null;
  return function() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)
      args[_key4] = arguments[_key4];
    return lastArgs && args.every(function(val, i2) {
      return val === lastArgs[i2];
    }) || (lastArgs = args, lastResult2 = fn.apply(void 0, args)), lastResult2;
  };
}, "memoize");
function getDigitCount(value) {
  var result2;
  return value === 0 ? result2 = 1 : result2 = Math.floor(new Decimal$1(value).abs().log(10).toNumber()) + 1, result2;
}
__name(getDigitCount, "getDigitCount");
function rangeStep(start, end, step) {
  for (var num2 = new Decimal$1(start), i2 = 0, result2 = []; num2.lt(end) && i2 < 1e5; )
    result2.push(num2.toNumber()), num2 = num2.add(step), i2++;
  return result2;
}
__name(rangeStep, "rangeStep");
var interpolateNumber2 = curry(function(a4, b2, t3) {
  var newA = +a4, newB = +b2;
  return newA + t3 * (newB - newA);
}), uninterpolateNumber = curry(function(a4, b2, x3) {
  var diff = b2 - +a4;
  return diff = diff || 1 / 0, (x3 - a4) / diff;
}), uninterpolateTruncation = curry(function(a4, b2, x3) {
  var diff = b2 - +a4;
  return diff = diff || 1 / 0, Math.max(0, Math.min(1, (x3 - a4) / diff));
});
const Arithmetic = {
  rangeStep,
  getDigitCount,
  interpolateNumber: interpolateNumber2,
  uninterpolateNumber,
  uninterpolateTruncation
};
function _toConsumableArray$9(arr) {
  return _arrayWithoutHoles$9(arr) || _iterableToArray$a(arr) || _unsupportedIterableToArray$f(arr) || _nonIterableSpread$9();
}
__name(_toConsumableArray$9, "_toConsumableArray$9");
function _nonIterableSpread$9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$9, "_nonIterableSpread$9");
function _iterableToArray$a(iter) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(iter))
    return Array.from(iter);
}
__name(_iterableToArray$a, "_iterableToArray$a");
function _arrayWithoutHoles$9(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$f(arr);
}
__name(_arrayWithoutHoles$9, "_arrayWithoutHoles$9");
function _slicedToArray$8(arr, i2) {
  return _arrayWithHoles$9(arr) || _iterableToArrayLimit$8(arr, i2) || _unsupportedIterableToArray$f(arr, i2) || _nonIterableRest$9();
}
__name(_slicedToArray$8, "_slicedToArray$8");
function _nonIterableRest$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$9, "_nonIterableRest$9");
function _unsupportedIterableToArray$f(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$f(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$f(o, minLen);
  }
}
__name(_unsupportedIterableToArray$f, "_unsupportedIterableToArray$f");
function _arrayLikeToArray$f(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$f, "_arrayLikeToArray$f");
function _iterableToArrayLimit$8(arr, i2) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(arr)))) {
    var _arr = [], _n = !0, _d = !1, _e = void 0;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i2 && _arr.length === i2)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
__name(_iterableToArrayLimit$8, "_iterableToArrayLimit$8");
function _arrayWithHoles$9(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$9, "_arrayWithHoles$9");
function getValidInterval(_ref) {
  var _ref2 = _slicedToArray$8(_ref, 2), min2 = _ref2[0], max2 = _ref2[1], validMin = min2, validMax = max2;
  return min2 > max2 && (validMin = max2, validMax = min2), [validMin, validMax];
}
__name(getValidInterval, "getValidInterval");
function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep.lte(0))
    return new Decimal$1(0);
  var digitCount = Arithmetic.getDigitCount(roughStep.toNumber()), digitCountValue = new Decimal$1(10).pow(digitCount), stepRatio = roughStep.div(digitCountValue), stepRatioScale = digitCount !== 1 ? 0.05 : 0.1, amendStepRatio = new Decimal$1(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale), formatStep = amendStepRatio.mul(digitCountValue);
  return allowDecimals ? formatStep : new Decimal$1(Math.ceil(formatStep));
}
__name(getFormatStep, "getFormatStep");
function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var step = 1, middle = new Decimal$1(value);
  if (!middle.isint() && allowDecimals) {
    var absVal = Math.abs(value);
    absVal < 1 ? (step = new Decimal$1(10).pow(Arithmetic.getDigitCount(value) - 1), middle = new Decimal$1(Math.floor(middle.div(step).toNumber())).mul(step)) : absVal > 1 && (middle = new Decimal$1(Math.floor(value)));
  } else
    value === 0 ? middle = new Decimal$1(Math.floor((tickCount - 1) / 2)) : allowDecimals || (middle = new Decimal$1(Math.floor(value)));
  var middleIndex = Math.floor((tickCount - 1) / 2), fn = compose(map(function(n) {
    return middle.add(new Decimal$1(n - middleIndex).mul(step)).toNumber();
  }), range$2);
  return fn(0, tickCount);
}
__name(getTickOfSingleValue, "getTickOfSingleValue");
function calculateStep(min2, max2, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((max2 - min2) / (tickCount - 1)))
    return {
      step: new Decimal$1(0),
      tickMin: new Decimal$1(0),
      tickMax: new Decimal$1(0)
    };
  var step = getFormatStep(new Decimal$1(max2).sub(min2).div(tickCount - 1), allowDecimals, correctionFactor), middle;
  min2 <= 0 && max2 >= 0 ? middle = new Decimal$1(0) : (middle = new Decimal$1(min2).add(max2).div(2), middle = middle.sub(new Decimal$1(middle).mod(step)));
  var belowCount = Math.ceil(middle.sub(min2).div(step).toNumber()), upCount = Math.ceil(new Decimal$1(max2).sub(middle).div(step).toNumber()), scaleCount = belowCount + upCount + 1;
  return scaleCount > tickCount ? calculateStep(min2, max2, tickCount, allowDecimals, correctionFactor + 1) : (scaleCount < tickCount && (upCount = max2 > 0 ? upCount + (tickCount - scaleCount) : upCount, belowCount = max2 > 0 ? belowCount : belowCount + (tickCount - scaleCount)), {
    step,
    tickMin: middle.sub(new Decimal$1(belowCount).mul(step)),
    tickMax: middle.add(new Decimal$1(upCount).mul(step))
  });
}
__name(calculateStep, "calculateStep");
function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray$8(_ref3, 2), min2 = _ref4[0], max2 = _ref4[1], tickCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, allowDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, count = Math.max(tickCount, 2), _getValidInterval = getValidInterval([min2, max2]), _getValidInterval2 = _slicedToArray$8(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
  if (cormin === -1 / 0 || cormax === 1 / 0) {
    var _values = cormax === 1 / 0 ? [cormin].concat(_toConsumableArray$9(range$2(0, tickCount - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(_toConsumableArray$9(range$2(0, tickCount - 1).map(function() {
      return -1 / 0;
    })), [cormax]);
    return min2 > max2 ? reverse(_values) : _values;
  }
  if (cormin === cormax)
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax, values = Arithmetic.rangeStep(tickMin, tickMax.add(new Decimal$1(0.1).mul(step)), step);
  return min2 > max2 ? reverse(values) : values;
}
__name(getNiceTickValuesFn, "getNiceTickValuesFn");
function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray$8(_ref7, 2), min2 = _ref8[0], max2 = _ref8[1], allowDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, _getValidInterval5 = getValidInterval([min2, max2]), _getValidInterval6 = _slicedToArray$8(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
  if (cormin === -1 / 0 || cormax === 1 / 0)
    return [min2, max2];
  if (cormin === cormax)
    return [cormin];
  var count = Math.max(tickCount, 2), step = getFormatStep(new Decimal$1(cormax).sub(cormin).div(count - 1), allowDecimals, 0), values = [].concat(_toConsumableArray$9(Arithmetic.rangeStep(new Decimal$1(cormin), new Decimal$1(cormax).sub(new Decimal$1(0.99).mul(step)), step)), [cormax]);
  return min2 > max2 ? reverse(values) : values;
}
__name(getTickValuesFixedDomainFn, "getTickValuesFixedDomainFn");
var getNiceTickValues = memoize(getNiceTickValuesFn), getTickValuesFixedDomain = memoize(getTickValuesFixedDomainFn), isProduction = process.env.NODE_ENV === "production", prefix = "Invariant failed";
function invariant(condition, message) {
  if (!condition) {
    if (isProduction)
      throw new Error(prefix);
    var provided = typeof message == "function" ? message() : message, value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
  }
}
__name(invariant, "invariant");
var _excluded$8 = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function _extends$h() {
  return _extends$h = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$h.apply(this, arguments);
}
__name(_extends$h, "_extends$h");
function _slicedToArray$7(arr, i2) {
  return _arrayWithHoles$8(arr) || _iterableToArrayLimit$7(arr, i2) || _unsupportedIterableToArray$e(arr, i2) || _nonIterableRest$8();
}
__name(_slicedToArray$7, "_slicedToArray$7");
function _nonIterableRest$8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$8, "_nonIterableRest$8");
function _unsupportedIterableToArray$e(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$e(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$e(o, minLen);
  }
}
__name(_unsupportedIterableToArray$e, "_unsupportedIterableToArray$e");
function _arrayLikeToArray$e(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$e, "_arrayLikeToArray$e");
function _iterableToArrayLimit$7(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$7, "_iterableToArrayLimit$7");
function _arrayWithHoles$8(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$8, "_arrayWithHoles$8");
function _objectWithoutProperties$8(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$8(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$8, "_objectWithoutProperties$8");
function _objectWithoutPropertiesLoose$8(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$8, "_objectWithoutPropertiesLoose$8");
function ErrorBar(props) {
  var offset = props.offset, layout2 = props.layout, width2 = props.width, dataKey = props.dataKey, data2 = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = _objectWithoutProperties$8(props, _excluded$8), svgProps = filterProps(others, !1);
  props.direction === "x" && xAxis.type !== "number" && (process.env.NODE_ENV !== "production" ? invariant(!1, 'ErrorBar requires Axis type property to be "number".') : invariant(!1));
  var errorBars = data2.map(function(entry) {
    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x3 = _dataPointFormatter.x, y4 = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
    if (!errorVal)
      return null;
    var lineCoordinates = [], lowBound, highBound;
    if (Array.isArray(errorVal)) {
      var _errorVal = _slicedToArray$7(errorVal, 2);
      lowBound = _errorVal[0], highBound = _errorVal[1];
    } else
      lowBound = highBound = errorVal;
    if (layout2 === "vertical") {
      var scale2 = xAxis.scale, yMid = y4 + offset, yMin = yMid + width2, yMax = yMid - width2, xMin = scale2(value - lowBound), xMax = scale2(value + highBound);
      lineCoordinates.push({
        x1: xMax,
        y1: yMin,
        x2: xMax,
        y2: yMax
      }), lineCoordinates.push({
        x1: xMin,
        y1: yMid,
        x2: xMax,
        y2: yMid
      }), lineCoordinates.push({
        x1: xMin,
        y1: yMin,
        x2: xMin,
        y2: yMax
      });
    } else if (layout2 === "horizontal") {
      var _scale = yAxis.scale, xMid = x3 + offset, _xMin = xMid - width2, _xMax = xMid + width2, _yMin = _scale(value - lowBound), _yMax = _scale(value + highBound);
      lineCoordinates.push({
        x1: _xMin,
        y1: _yMax,
        x2: _xMax,
        y2: _yMax
      }), lineCoordinates.push({
        x1: xMid,
        y1: _yMin,
        x2: xMid,
        y2: _yMax
      }), lineCoordinates.push({
        x1: _xMin,
        y1: _yMin,
        x2: _xMax,
        y2: _yMin
      });
    }
    return /* @__PURE__ */ React__default.createElement(Layer, _extends$h({
      className: "recharts-errorBar",
      key: "bar-".concat(lineCoordinates.map(function(c3) {
        return "".concat(c3.x1, "-").concat(c3.x2, "-").concat(c3.y1, "-").concat(c3.y2);
      }))
    }, svgProps), lineCoordinates.map(function(coordinates) {
      return /* @__PURE__ */ React__default.createElement("line", _extends$h({}, coordinates, {
        key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
      }));
    }));
  });
  return /* @__PURE__ */ React__default.createElement(Layer, {
    className: "recharts-errorBars"
  }, errorBars);
}
__name(ErrorBar, "ErrorBar");
ErrorBar.defaultProps = {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
};
ErrorBar.displayName = "ErrorBar";
function _typeof$r(o) {
  "@babel/helpers - typeof";
  return _typeof$r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$r(o);
}
__name(_typeof$r, "_typeof$r");
function ownKeys$o(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$o, "ownKeys$o");
function _objectSpread$o(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$o(Object(t3), !0).forEach(function(r3) {
      _defineProperty$p(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$o(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$o, "_objectSpread$o");
function _defineProperty$p(obj2, key, value) {
  return key = _toPropertyKey$p(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$p, "_defineProperty$p");
function _toPropertyKey$p(t3) {
  var i2 = _toPrimitive$p(t3, "string");
  return _typeof$r(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$p, "_toPropertyKey$p");
function _toPrimitive$p(t3, r2) {
  if (_typeof$r(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$r(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$p, "_toPrimitive$p");
var getLegendProps = /* @__PURE__ */ __name(function(_ref) {
  var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent, legendItem = findChildByType(children, Legend);
  if (!legendItem)
    return null;
  var legendData;
  return legendItem.props && legendItem.props.payload ? legendData = legendItem.props && legendItem.props.payload : legendContent === "children" ? legendData = (formattedGraphicalItems || []).reduce(function(result2, _ref2) {
    var item = _ref2.item, props = _ref2.props, data2 = props.sectors || props.data || [];
    return result2.concat(data2.map(function(entry) {
      return {
        type: legendItem.props.iconType || item.props.legendType,
        value: entry.name,
        color: entry.fill,
        payload: entry
      };
    }));
  }, []) : legendData = (formattedGraphicalItems || []).map(function(_ref3) {
    var item = _ref3.item, _item$props = item.props, dataKey = _item$props.dataKey, name2 = _item$props.name, legendType = _item$props.legendType, hide = _item$props.hide;
    return {
      inactive: hide,
      dataKey,
      type: legendItem.props.iconType || legendType || "square",
      color: getMainColorOfGraphicItem(item),
      value: name2 || dataKey,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: item.props
    };
  }), _objectSpread$o(_objectSpread$o(_objectSpread$o({}, legendItem.props), Legend.getWithHeight(legendItem, legendWidth)), {}, {
    payload: legendData,
    item: legendItem
  });
}, "getLegendProps");
function _typeof$q(o) {
  "@babel/helpers - typeof";
  return _typeof$q = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$q(o);
}
__name(_typeof$q, "_typeof$q");
function ownKeys$n(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$n, "ownKeys$n");
function _objectSpread$n(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$n(Object(t3), !0).forEach(function(r3) {
      _defineProperty$o(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$n(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$n, "_objectSpread$n");
function _defineProperty$o(obj2, key, value) {
  return key = _toPropertyKey$o(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$o, "_defineProperty$o");
function _toPropertyKey$o(t3) {
  var i2 = _toPrimitive$o(t3, "string");
  return _typeof$q(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$o, "_toPropertyKey$o");
function _toPrimitive$o(t3, r2) {
  if (_typeof$q(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$q(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$o, "_toPrimitive$o");
function _toConsumableArray$8(arr) {
  return _arrayWithoutHoles$8(arr) || _iterableToArray$9(arr) || _unsupportedIterableToArray$d(arr) || _nonIterableSpread$8();
}
__name(_toConsumableArray$8, "_toConsumableArray$8");
function _nonIterableSpread$8() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$8, "_nonIterableSpread$8");
function _unsupportedIterableToArray$d(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$d(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$d(o, minLen);
  }
}
__name(_unsupportedIterableToArray$d, "_unsupportedIterableToArray$d");
function _iterableToArray$9(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$9, "_iterableToArray$9");
function _arrayWithoutHoles$8(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$d(arr);
}
__name(_arrayWithoutHoles$8, "_arrayWithoutHoles$8");
function _arrayLikeToArray$d(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$d, "_arrayLikeToArray$d");
function getValueByDataKey(obj2, dataKey, defaultValue) {
  return isNil$1(obj2) || isNil$1(dataKey) ? defaultValue : isNumOrStr(dataKey) ? get$2(obj2, dataKey, defaultValue) : isFunction$3(dataKey) ? dataKey(obj2) : defaultValue;
}
__name(getValueByDataKey, "getValueByDataKey");
function getDomainOfDataByKey(data2, key, type, filterNil) {
  var flattenData = flatMap$1(data2, function(entry) {
    return getValueByDataKey(entry, key);
  });
  if (type === "number") {
    var domain = flattenData.filter(function(entry) {
      return isNumber(entry) || parseFloat(entry);
    });
    return domain.length ? [min$1(domain), max$1(domain)] : [1 / 0, -1 / 0];
  }
  var validateData = filterNil ? flattenData.filter(function(entry) {
    return !isNil$1(entry);
  }) : flattenData;
  return validateData.map(function(entry) {
    return isNumOrStr(entry) || entry instanceof Date ? entry : "";
  });
}
__name(getDomainOfDataByKey, "getDomainOfDataByKey");
var calculateActiveTickIndex = /* @__PURE__ */ __name(function(coordinate) {
  var _ticks$length, ticks2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], unsortedTicks = arguments.length > 2 ? arguments[2] : void 0, axis = arguments.length > 3 ? arguments[3] : void 0, index2 = -1, len = (_ticks$length = ticks2 == null ? void 0 : ticks2.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
  if (len <= 1)
    return 0;
  if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6)
    for (var range3 = axis.range, i2 = 0; i2 < len; i2++) {
      var before = i2 > 0 ? unsortedTicks[i2 - 1].coordinate : unsortedTicks[len - 1].coordinate, cur = unsortedTicks[i2].coordinate, after = i2 >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i2 + 1].coordinate, sameDirectionCoord = void 0;
      if (mathSign(cur - before) !== mathSign(after - cur)) {
        var diffInterval = [];
        if (mathSign(after - cur) === mathSign(range3[1] - range3[0])) {
          sameDirectionCoord = after;
          var curInRange = cur + range3[1] - range3[0];
          diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2), diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
        } else {
          sameDirectionCoord = before;
          var afterInRange = after + range3[1] - range3[0];
          diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2), diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
        }
        var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
        if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
          index2 = unsortedTicks[i2].index;
          break;
        }
      } else {
        var minValue = Math.min(before, after), maxValue = Math.max(before, after);
        if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
          index2 = unsortedTicks[i2].index;
          break;
        }
      }
    }
  else
    for (var _i = 0; _i < len; _i++)
      if (_i === 0 && coordinate <= (ticks2[_i].coordinate + ticks2[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks2[_i].coordinate + ticks2[_i - 1].coordinate) / 2 && coordinate <= (ticks2[_i].coordinate + ticks2[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks2[_i].coordinate + ticks2[_i - 1].coordinate) / 2) {
        index2 = ticks2[_i].index;
        break;
      }
  return index2;
}, "calculateActiveTickIndex"), getMainColorOfGraphicItem = /* @__PURE__ */ __name(function(item) {
  var _ref = item, displayName = _ref.type.displayName, _item$props = item.props, stroke2 = _item$props.stroke, fill2 = _item$props.fill, result2;
  switch (displayName) {
    case "Line":
      result2 = stroke2;
      break;
    case "Area":
    case "Radar":
      result2 = stroke2 && stroke2 !== "none" ? stroke2 : fill2;
      break;
    default:
      result2 = fill2;
      break;
  }
  return result2;
}, "getMainColorOfGraphicItem"), getBarSizeList = /* @__PURE__ */ __name(function(_ref2) {
  var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
  if (!stackGroups)
    return {};
  for (var result2 = {}, numericAxisIds = Object.keys(stackGroups), i2 = 0, len = numericAxisIds.length; i2 < len; i2++)
    for (var sgs = stackGroups[numericAxisIds[i2]].stackGroups, stackIds = Object.keys(sgs), j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId, barItems = items.filter(function(item) {
        return getDisplayName(item.type).indexOf("Bar") >= 0;
      });
      if (barItems && barItems.length) {
        var selfSize = barItems[0].props.barSize, cateId = barItems[0].props[cateAxisId];
        result2[cateId] || (result2[cateId] = []);
        var barSize = isNil$1(selfSize) ? globalSize : selfSize;
        result2[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: isNil$1(barSize) ? void 0 : getPercentValue(barSize, totalSize, 0)
        });
      }
    }
  return result2;
}, "getBarSizeList"), getBarPosition = /* @__PURE__ */ __name(function(_ref3) {
  var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize, len = sizeList.length;
  if (len < 1)
    return null;
  var realBarGap = getPercentValue(barGap, bandSize, 0, !0), result2, initialValue = [];
  if (sizeList[0].barSize === +sizeList[0].barSize) {
    var useFull = !1, fullBarSize = bandSize / len, sum = sizeList.reduce(function(res, entry) {
      return res + entry.barSize || 0;
    }, 0);
    sum += (len - 1) * realBarGap, sum >= bandSize && (sum -= (len - 1) * realBarGap, realBarGap = 0), sum >= bandSize && fullBarSize > 0 && (useFull = !0, fullBarSize *= 0.9, sum = len * fullBarSize);
    var offset = (bandSize - sum) / 2 >> 0, prev = {
      offset: offset - realBarGap,
      size: 0
    };
    result2 = sizeList.reduce(function(res, entry) {
      var newPosition = {
        item: entry.item,
        position: {
          offset: prev.offset + prev.size + realBarGap,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: useFull ? fullBarSize : entry.barSize
        }
      }, newRes = [].concat(_toConsumableArray$8(res), [newPosition]);
      return prev = newRes[newRes.length - 1].position, entry.stackList && entry.stackList.length && entry.stackList.forEach(function(item) {
        newRes.push({
          item,
          position: prev
        });
      }), newRes;
    }, initialValue);
  } else {
    var _offset = getPercentValue(barCategoryGap, bandSize, 0, !0);
    bandSize - 2 * _offset - (len - 1) * realBarGap <= 0 && (realBarGap = 0);
    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
    originalSize > 1 && (originalSize >>= 0);
    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
    result2 = sizeList.reduce(function(res, entry, i2) {
      var newRes = [].concat(_toConsumableArray$8(res), [{
        item: entry.item,
        position: {
          offset: _offset + (originalSize + realBarGap) * i2 + (originalSize - size) / 2,
          size
        }
      }]);
      return entry.stackList && entry.stackList.length && entry.stackList.forEach(function(item) {
        newRes.push({
          item,
          position: newRes[newRes.length - 1].position
        });
      }), newRes;
    }, initialValue);
  }
  return result2;
}, "getBarPosition"), appendOffsetOfLegend = /* @__PURE__ */ __name(function(offset, _unused, props, legendBox) {
  var children = props.children, width2 = props.width, margin2 = props.margin, legendWidth = width2 - (margin2.left || 0) - (margin2.right || 0), legendProps = getLegendProps({
    children,
    legendWidth
  });
  if (legendProps) {
    var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height, align = legendProps.align, verticalAlign2 = legendProps.verticalAlign, layout2 = legendProps.layout;
    if ((layout2 === "vertical" || layout2 === "horizontal" && verticalAlign2 === "middle") && align !== "center" && isNumber(offset[align]))
      return _objectSpread$n(_objectSpread$n({}, offset), {}, _defineProperty$o({}, align, offset[align] + (boxWidth || 0)));
    if ((layout2 === "horizontal" || layout2 === "vertical" && align === "center") && verticalAlign2 !== "middle" && isNumber(offset[verticalAlign2]))
      return _objectSpread$n(_objectSpread$n({}, offset), {}, _defineProperty$o({}, verticalAlign2, offset[verticalAlign2] + (boxHeight || 0)));
  }
  return offset;
}, "appendOffsetOfLegend"), isErrorBarRelevantForAxis = /* @__PURE__ */ __name(function(layout2, axisType, direction) {
  return isNil$1(axisType) ? !0 : layout2 === "horizontal" ? axisType === "yAxis" : layout2 === "vertical" || direction === "x" ? axisType === "xAxis" : direction === "y" ? axisType === "yAxis" : !0;
}, "isErrorBarRelevantForAxis"), getDomainOfErrorBars = /* @__PURE__ */ __name(function(data2, item, dataKey, layout2, axisType) {
  var children = item.props.children, errorBars = findAllByType(children, ErrorBar).filter(function(errorBarChild) {
    return isErrorBarRelevantForAxis(layout2, axisType, errorBarChild.props.direction);
  });
  if (errorBars && errorBars.length) {
    var keys2 = errorBars.map(function(errorBarChild) {
      return errorBarChild.props.dataKey;
    });
    return data2.reduce(function(result2, entry) {
      var entryValue = getValueByDataKey(entry, dataKey);
      if (isNil$1(entryValue))
        return result2;
      var mainValue = Array.isArray(entryValue) ? [min$1(entryValue), max$1(entryValue)] : [entryValue, entryValue], errorDomain = keys2.reduce(function(prevErrorArr, k3) {
        var errorValue = getValueByDataKey(entry, k3, 0), lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue), upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(errorDomain[0], result2[0]), Math.max(errorDomain[1], result2[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, "getDomainOfErrorBars"), parseErrorBarsOfAxis = /* @__PURE__ */ __name(function(data2, items, dataKey, axisType, layout2) {
  var domains = items.map(function(item) {
    return getDomainOfErrorBars(data2, item, dataKey, layout2, axisType);
  }).filter(function(entry) {
    return !isNil$1(entry);
  });
  return domains && domains.length ? domains.reduce(function(result2, entry) {
    return [Math.min(result2[0], entry[0]), Math.max(result2[1], entry[1])];
  }, [1 / 0, -1 / 0]) : null;
}, "parseErrorBarsOfAxis"), getDomainOfItemsWithSameAxis = /* @__PURE__ */ __name(function(data2, items, type, layout2, filterNil) {
  var domains = items.map(function(item) {
    var dataKey = item.props.dataKey;
    return type === "number" && dataKey && getDomainOfErrorBars(data2, item, dataKey, layout2) || getDomainOfDataByKey(data2, dataKey, type, filterNil);
  });
  if (type === "number")
    return domains.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(result2, entry) {
        return [Math.min(result2[0], entry[0]), Math.max(result2[1], entry[1])];
      },
      [1 / 0, -1 / 0]
    );
  var tag = {};
  return domains.reduce(function(result2, entry) {
    for (var i2 = 0, len = entry.length; i2 < len; i2++)
      tag[entry[i2]] || (tag[entry[i2]] = !0, result2.push(entry[i2]));
    return result2;
  }, []);
}, "getDomainOfItemsWithSameAxis"), isCategoricalAxis = /* @__PURE__ */ __name(function(layout2, axisType) {
  return layout2 === "horizontal" && axisType === "xAxis" || layout2 === "vertical" && axisType === "yAxis" || layout2 === "centric" && axisType === "angleAxis" || layout2 === "radial" && axisType === "radiusAxis";
}, "isCategoricalAxis"), getTicksOfAxis = /* @__PURE__ */ __name(function(axis, isGrid, isAll) {
  if (!axis)
    return null;
  var scale2 = axis.scale, duplicateDomain = axis.duplicateDomain, type = axis.type, range3 = axis.range, offsetForBand = axis.realScaleType === "scaleBand" ? scale2.bandwidth() / 2 : 2, offset = (isGrid || isAll) && type === "category" && scale2.bandwidth ? scale2.bandwidth() / offsetForBand : 0;
  if (offset = axis.axisType === "angleAxis" && (range3 == null ? void 0 : range3.length) >= 2 ? mathSign(range3[0] - range3[1]) * 2 * offset : offset, isGrid && (axis.ticks || axis.niceTicks)) {
    var result2 = (axis.ticks || axis.niceTicks).map(function(entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: scale2(scaleContent) + offset,
        value: entry,
        offset
      };
    });
    return result2.filter(function(row2) {
      return !isNan(row2.coordinate);
    });
  }
  return axis.isCategorical && axis.categoricalDomain ? axis.categoricalDomain.map(function(entry, index2) {
    return {
      coordinate: scale2(entry) + offset,
      value: entry,
      index: index2,
      offset
    };
  }) : scale2.ticks && !isAll ? scale2.ticks(axis.tickCount).map(function(entry) {
    return {
      coordinate: scale2(entry) + offset,
      value: entry,
      offset
    };
  }) : scale2.domain().map(function(entry, index2) {
    return {
      coordinate: scale2(entry) + offset,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index2,
      offset
    };
  });
}, "getTicksOfAxis"), handlerWeakMap = /* @__PURE__ */ new WeakMap(), combineEventHandlers = /* @__PURE__ */ __name(function(defaultHandler, childHandler) {
  if (typeof childHandler != "function")
    return defaultHandler;
  handlerWeakMap.has(defaultHandler) || handlerWeakMap.set(defaultHandler, /* @__PURE__ */ new WeakMap());
  var childWeakMap = handlerWeakMap.get(defaultHandler);
  if (childWeakMap.has(childHandler))
    return childWeakMap.get(childHandler);
  var combineHandler = /* @__PURE__ */ __name(function() {
    defaultHandler.apply(void 0, arguments), childHandler.apply(void 0, arguments);
  }, "combineHandler");
  return childWeakMap.set(childHandler, combineHandler), combineHandler;
}, "combineEventHandlers"), parseScale = /* @__PURE__ */ __name(function(axis, chartType, hasBar) {
  var scale2 = axis.scale, type = axis.type, layout2 = axis.layout, axisType = axis.axisType;
  if (scale2 === "auto")
    return layout2 === "radial" && axisType === "radiusAxis" ? {
      scale: band(),
      realScaleType: "band"
    } : layout2 === "radial" && axisType === "angleAxis" ? {
      scale: linear(),
      realScaleType: "linear"
    } : type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar) ? {
      scale: point(),
      realScaleType: "point"
    } : type === "category" ? {
      scale: band(),
      realScaleType: "band"
    } : {
      scale: linear(),
      realScaleType: "linear"
    };
  if (isString$1(scale2)) {
    var name2 = "scale".concat(upperFirst$1(scale2));
    return {
      scale: (d3Scales[name2] || point)(),
      realScaleType: d3Scales[name2] ? name2 : "point"
    };
  }
  return isFunction$3(scale2) ? {
    scale: scale2
  } : {
    scale: point(),
    realScaleType: "point"
  };
}, "parseScale"), EPS = 1e-4, checkDomainOfScale = /* @__PURE__ */ __name(function(scale2) {
  var domain = scale2.domain();
  if (!(!domain || domain.length <= 2)) {
    var len = domain.length, range3 = scale2.range(), minValue = Math.min(range3[0], range3[1]) - EPS, maxValue = Math.max(range3[0], range3[1]) + EPS, first = scale2(domain[0]), last2 = scale2(domain[len - 1]);
    (first < minValue || first > maxValue || last2 < minValue || last2 > maxValue) && scale2.domain([domain[0], domain[len - 1]]);
  }
}, "checkDomainOfScale"), offsetSign = /* @__PURE__ */ __name(function(series) {
  var n = series.length;
  if (!(n <= 0))
    for (var j = 0, m3 = series[0].length; j < m3; ++j)
      for (var positive = 0, negative2 = 0, i2 = 0; i2 < n; ++i2) {
        var value = isNan(series[i2][j][1]) ? series[i2][j][0] : series[i2][j][1];
        value >= 0 ? (series[i2][j][0] = positive, series[i2][j][1] = positive + value, positive = series[i2][j][1]) : (series[i2][j][0] = negative2, series[i2][j][1] = negative2 + value, negative2 = series[i2][j][1]);
      }
}, "offsetSign"), offsetPositive = /* @__PURE__ */ __name(function(series) {
  var n = series.length;
  if (!(n <= 0))
    for (var j = 0, m3 = series[0].length; j < m3; ++j)
      for (var positive = 0, i2 = 0; i2 < n; ++i2) {
        var value = isNan(series[i2][j][1]) ? series[i2][j][0] : series[i2][j][1];
        value >= 0 ? (series[i2][j][0] = positive, series[i2][j][1] = positive + value, positive = series[i2][j][1]) : (series[i2][j][0] = 0, series[i2][j][1] = 0);
      }
}, "offsetPositive"), STACK_OFFSET_MAP = {
  sign: offsetSign,
  // @ts-expect-error definitelytyped types are incorrect
  expand: stackOffsetExpand,
  // @ts-expect-error definitelytyped types are incorrect
  none: stackOffsetNone,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: stackOffsetSilhouette,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: stackOffsetWiggle,
  positive: offsetPositive
}, getStackedData = /* @__PURE__ */ __name(function(data2, stackItems, offsetType) {
  var dataKeys = stackItems.map(function(item) {
    return item.props.dataKey;
  }), offsetAccessor = STACK_OFFSET_MAP[offsetType], stack = shapeStack().keys(dataKeys).value(function(d3, key) {
    return +getValueByDataKey(d3, key, 0);
  }).order(stackOrderNone).offset(offsetAccessor);
  return stack(data2);
}, "getStackedData"), getStackGroupsByAxisId = /* @__PURE__ */ __name(function(data2, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
  if (!data2)
    return null;
  var items = reverseStackOrder ? _items.reverse() : _items, parentStackGroupsInitialValue = {}, stackGroups = items.reduce(function(result2, item) {
    var _item$props2 = item.props, stackId = _item$props2.stackId, hide = _item$props2.hide;
    if (hide)
      return result2;
    var axisId = item.props[numericAxisId], parentGroup = result2[axisId] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (isNumOrStr(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId,
        cateAxisId,
        items: []
      };
      childGroup.items.push(item), parentGroup.hasStack = !0, parentGroup.stackGroups[stackId] = childGroup;
    } else
      parentGroup.stackGroups[uniqueId("_stackId_")] = {
        numericAxisId,
        cateAxisId,
        items: [item]
      };
    return _objectSpread$n(_objectSpread$n({}, result2), {}, _defineProperty$o({}, axisId, parentGroup));
  }, parentStackGroupsInitialValue), axisStackGroupsInitialValue = {};
  return Object.keys(stackGroups).reduce(function(result2, axisId) {
    var group = stackGroups[axisId];
    if (group.hasStack) {
      var stackGroupsInitialValue = {};
      group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
        var g = group.stackGroups[stackId];
        return _objectSpread$n(_objectSpread$n({}, res), {}, _defineProperty$o({}, stackId, {
          numericAxisId,
          cateAxisId,
          items: g.items,
          stackedData: getStackedData(data2, g.items, offsetType)
        }));
      }, stackGroupsInitialValue);
    }
    return _objectSpread$n(_objectSpread$n({}, result2), {}, _defineProperty$o({}, axisId, group));
  }, axisStackGroupsInitialValue);
}, "getStackGroupsByAxisId"), getTicksOfScale = /* @__PURE__ */ __name(function(scale2, opts) {
  var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals, scaleType = realScaleType || opts.scale;
  if (scaleType !== "auto" && scaleType !== "linear")
    return null;
  if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
    var domain = scale2.domain();
    if (!domain.length)
      return null;
    var tickValues = getNiceTickValues(domain, tickCount, allowDecimals);
    return scale2.domain([min$1(tickValues), max$1(tickValues)]), {
      niceTicks: tickValues
    };
  }
  if (tickCount && type === "number") {
    var _domain = scale2.domain(), _tickValues = getTickValuesFixedDomain(_domain, tickCount, allowDecimals);
    return {
      niceTicks: _tickValues
    };
  }
  return null;
}, "getTicksOfScale"), getStackedDataOfItem = /* @__PURE__ */ __name(function(item, stackGroups) {
  var stackId = item.props.stackId;
  if (isNumOrStr(stackId)) {
    var group = stackGroups[stackId];
    if (group) {
      var itemIndex = group.items.indexOf(item);
      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }
  return null;
}, "getStackedDataOfItem"), getDomainOfSingle = /* @__PURE__ */ __name(function(data2) {
  return data2.reduce(function(result2, entry) {
    return [min$1(entry.concat([result2[0]]).filter(isNumber)), max$1(entry.concat([result2[1]]).filter(isNumber))];
  }, [1 / 0, -1 / 0]);
}, "getDomainOfSingle"), getDomainOfStackGroups = /* @__PURE__ */ __name(function(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function(result2, stackId) {
    var group = stackGroups[stackId], stackedData = group.stackedData, domain = stackedData.reduce(function(res, entry) {
      var s4 = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
      return [Math.min(res[0], s4[0]), Math.max(res[1], s4[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(domain[0], result2[0]), Math.max(domain[1], result2[1])];
  }, [1 / 0, -1 / 0]).map(function(result2) {
    return result2 === 1 / 0 || result2 === -1 / 0 ? 0 : result2;
  });
}, "getDomainOfStackGroups"), MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, parseSpecifiedDomain = /* @__PURE__ */ __name(function(specifiedDomain, dataDomain, allowDataOverflow) {
  if (isFunction$3(specifiedDomain))
    return specifiedDomain(dataDomain, allowDataOverflow);
  if (!Array.isArray(specifiedDomain))
    return dataDomain;
  var domain = [];
  if (isNumber(specifiedDomain[0]))
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
    domain[0] = dataDomain[0] - value;
  } else
    isFunction$3(specifiedDomain[0]) ? domain[0] = specifiedDomain[0](dataDomain[0]) : domain[0] = dataDomain[0];
  if (isNumber(specifiedDomain[1]))
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
    domain[1] = dataDomain[1] + _value;
  } else
    isFunction$3(specifiedDomain[1]) ? domain[1] = specifiedDomain[1](dataDomain[1]) : domain[1] = dataDomain[1];
  return domain;
}, "parseSpecifiedDomain"), getBandSizeOfAxis = /* @__PURE__ */ __name(function(axis, ticks2, isBar) {
  if (axis && axis.scale && axis.scale.bandwidth) {
    var bandWidth = axis.scale.bandwidth();
    if (!isBar || bandWidth > 0)
      return bandWidth;
  }
  if (axis && ticks2 && ticks2.length >= 2) {
    for (var orderedTicks = sortBy$1(ticks2, function(o) {
      return o.coordinate;
    }), bandSize = 1 / 0, i2 = 1, len = orderedTicks.length; i2 < len; i2++) {
      var cur = orderedTicks[i2], prev = orderedTicks[i2 - 1];
      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }
    return bandSize === 1 / 0 ? 0 : bandSize;
  }
  return isBar ? void 0 : 0;
}, "getBandSizeOfAxis"), parseDomainOfCategoryAxis = /* @__PURE__ */ __name(function(specifiedDomain, calculatedDomain, axisChild) {
  return !specifiedDomain || !specifiedDomain.length || isEqual$1(specifiedDomain, get$2(axisChild, "type.defaultProps.domain")) ? calculatedDomain : specifiedDomain;
}, "parseDomainOfCategoryAxis"), getTooltipItem = /* @__PURE__ */ __name(function(graphicalItem, payload) {
  var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name2 = _graphicalItem$props.name, unit2 = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType, hide = _graphicalItem$props.hide;
  return _objectSpread$n(_objectSpread$n({}, filterProps(graphicalItem, !1)), {}, {
    dataKey,
    unit: unit2,
    formatter,
    name: name2 || dataKey,
    color: getMainColorOfGraphicItem(graphicalItem),
    value: getValueByDataKey(payload, dataKey),
    type: tooltipType,
    payload,
    chartType,
    hide
  });
}, "getTooltipItem");
function _typeof$p(o) {
  "@babel/helpers - typeof";
  return _typeof$p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$p(o);
}
__name(_typeof$p, "_typeof$p");
function ownKeys$m(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$m, "ownKeys$m");
function _objectSpread$m(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$m(Object(t3), !0).forEach(function(r3) {
      _defineProperty$n(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$m(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$m, "_objectSpread$m");
function _defineProperty$n(obj2, key, value) {
  return key = _toPropertyKey$n(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$n, "_defineProperty$n");
function _toPropertyKey$n(t3) {
  var i2 = _toPrimitive$n(t3, "string");
  return _typeof$p(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$n, "_toPropertyKey$n");
function _toPrimitive$n(t3, r2) {
  if (_typeof$p(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$p(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$n, "_toPrimitive$n");
function _slicedToArray$6(arr, i2) {
  return _arrayWithHoles$7(arr) || _iterableToArrayLimit$6(arr, i2) || _unsupportedIterableToArray$c(arr, i2) || _nonIterableRest$7();
}
__name(_slicedToArray$6, "_slicedToArray$6");
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$7, "_nonIterableRest$7");
function _unsupportedIterableToArray$c(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$c(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$c(o, minLen);
  }
}
__name(_unsupportedIterableToArray$c, "_unsupportedIterableToArray$c");
function _arrayLikeToArray$c(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$c, "_arrayLikeToArray$c");
function _iterableToArrayLimit$6(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$6, "_iterableToArrayLimit$6");
function _arrayWithHoles$7(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$7, "_arrayWithHoles$7");
var RADIAN$1 = Math.PI / 180, radianToDegree = /* @__PURE__ */ __name(function(angleInRadian) {
  return angleInRadian * 180 / Math.PI;
}, "radianToDegree"), polarToCartesian = /* @__PURE__ */ __name(function(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN$1 * angle) * radius,
    y: cy + Math.sin(-RADIAN$1 * angle) * radius
  };
}, "polarToCartesian"), getMaxRadius = /* @__PURE__ */ __name(function(width2, height2) {
  var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(width2 - (offset.left || 0) - (offset.right || 0)), Math.abs(height2 - (offset.top || 0) - (offset.bottom || 0))) / 2;
}, "getMaxRadius"), formatAxisMap = /* @__PURE__ */ __name(function(props, axisMap, offset, axisType, chartName) {
  var width2 = props.width, height2 = props.height, startAngle = props.startAngle, endAngle = props.endAngle, cx = getPercentValue(props.cx, width2, width2 / 2), cy = getPercentValue(props.cy, height2, height2 / 2), maxRadius = getMaxRadius(width2, height2, offset), innerRadius = getPercentValue(props.innerRadius, maxRadius, 0), outerRadius = getPercentValue(props.outerRadius, maxRadius, maxRadius * 0.8), ids = Object.keys(axisMap);
  return ids.reduce(function(result2, id2) {
    var axis = axisMap[id2], domain = axis.domain, reversed = axis.reversed, range3;
    if (isNil$1(axis.range))
      axisType === "angleAxis" ? range3 = [startAngle, endAngle] : axisType === "radiusAxis" && (range3 = [innerRadius, outerRadius]), reversed && (range3 = [range3[1], range3[0]]);
    else {
      range3 = axis.range;
      var _range = range3, _range2 = _slicedToArray$6(_range, 2);
      startAngle = _range2[0], endAngle = _range2[1];
    }
    var _parseScale = parseScale(axis, chartName), realScaleType = _parseScale.realScaleType, scale2 = _parseScale.scale;
    scale2.domain(domain).range(range3), checkDomainOfScale(scale2);
    var ticks2 = getTicksOfScale(scale2, _objectSpread$m(_objectSpread$m({}, axis), {}, {
      realScaleType
    })), finalAxis = _objectSpread$m(_objectSpread$m(_objectSpread$m({}, axis), ticks2), {}, {
      range: range3,
      radius: outerRadius,
      realScaleType,
      scale: scale2,
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle
    });
    return _objectSpread$m(_objectSpread$m({}, result2), {}, _defineProperty$n({}, id2, finalAxis));
  }, {});
}, "formatAxisMap"), distanceBetweenPoints = /* @__PURE__ */ __name(function(point2, anotherPoint) {
  var x1 = point2.x, y1 = point2.y, x22 = anotherPoint.x, y22 = anotherPoint.y;
  return Math.sqrt(Math.pow(x1 - x22, 2) + Math.pow(y1 - y22, 2));
}, "distanceBetweenPoints"), getAngleOfPoint = /* @__PURE__ */ __name(function(_ref, _ref2) {
  var x3 = _ref.x, y4 = _ref.y, cx = _ref2.cx, cy = _ref2.cy, radius = distanceBetweenPoints({
    x: x3,
    y: y4
  }, {
    x: cx,
    y: cy
  });
  if (radius <= 0)
    return {
      radius
    };
  var cos2 = (x3 - cx) / radius, angleInRadian = Math.acos(cos2);
  return y4 > cy && (angleInRadian = 2 * Math.PI - angleInRadian), {
    radius,
    angle: radianToDegree(angleInRadian),
    angleInRadian
  };
}, "getAngleOfPoint"), formatAngleOfSector = /* @__PURE__ */ __name(function(_ref3) {
  var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle, startCnt = Math.floor(startAngle / 360), endCnt = Math.floor(endAngle / 360), min2 = Math.min(startCnt, endCnt);
  return {
    startAngle: startAngle - min2 * 360,
    endAngle: endAngle - min2 * 360
  };
}, "formatAngleOfSector"), reverseFormatAngleOfSetor = /* @__PURE__ */ __name(function(angle, _ref4) {
  var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle, startCnt = Math.floor(startAngle / 360), endCnt = Math.floor(endAngle / 360), min2 = Math.min(startCnt, endCnt);
  return angle + min2 * 360;
}, "reverseFormatAngleOfSetor"), inRangeOfSector = /* @__PURE__ */ __name(function(_ref5, sector) {
  var x3 = _ref5.x, y4 = _ref5.y, _getAngleOfPoint = getAngleOfPoint({
    x: x3,
    y: y4
  }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle, innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
  if (radius < innerRadius || radius > outerRadius)
    return !1;
  if (radius === 0)
    return !0;
  var _formatAngleOfSector = formatAngleOfSector(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle, formatAngle = angle, inRange;
  if (startAngle <= endAngle) {
    for (; formatAngle > endAngle; )
      formatAngle -= 360;
    for (; formatAngle < startAngle; )
      formatAngle += 360;
    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
  } else {
    for (; formatAngle > startAngle; )
      formatAngle -= 360;
    for (; formatAngle < endAngle; )
      formatAngle += 360;
    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
  }
  return inRange ? _objectSpread$m(_objectSpread$m({}, sector), {}, {
    radius,
    angle: reverseFormatAngleOfSetor(formatAngle, sector)
  }) : null;
}, "inRangeOfSector"), getTickClassName = /* @__PURE__ */ __name(function(tick) {
  return !/* @__PURE__ */ isValidElement(tick) && !isFunction$3(tick) && typeof tick != "boolean" ? tick.className : "";
}, "getTickClassName");
function _typeof$o(o) {
  "@babel/helpers - typeof";
  return _typeof$o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$o(o);
}
__name(_typeof$o, "_typeof$o");
var _excluded$7 = ["offset"];
function _toConsumableArray$7(arr) {
  return _arrayWithoutHoles$7(arr) || _iterableToArray$8(arr) || _unsupportedIterableToArray$b(arr) || _nonIterableSpread$7();
}
__name(_toConsumableArray$7, "_toConsumableArray$7");
function _nonIterableSpread$7() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$7, "_nonIterableSpread$7");
function _unsupportedIterableToArray$b(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$b(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$b(o, minLen);
  }
}
__name(_unsupportedIterableToArray$b, "_unsupportedIterableToArray$b");
function _iterableToArray$8(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$8, "_iterableToArray$8");
function _arrayWithoutHoles$7(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$b(arr);
}
__name(_arrayWithoutHoles$7, "_arrayWithoutHoles$7");
function _arrayLikeToArray$b(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$b, "_arrayLikeToArray$b");
function _objectWithoutProperties$7(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$7(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$7, "_objectWithoutProperties$7");
function _objectWithoutPropertiesLoose$7(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$7, "_objectWithoutPropertiesLoose$7");
function ownKeys$l(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$l, "ownKeys$l");
function _objectSpread$l(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$l(Object(t3), !0).forEach(function(r3) {
      _defineProperty$m(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$l(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$l, "_objectSpread$l");
function _defineProperty$m(obj2, key, value) {
  return key = _toPropertyKey$m(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$m, "_defineProperty$m");
function _toPropertyKey$m(t3) {
  var i2 = _toPrimitive$m(t3, "string");
  return _typeof$o(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$m, "_toPropertyKey$m");
function _toPrimitive$m(t3, r2) {
  if (_typeof$o(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$o(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$m, "_toPrimitive$m");
function _extends$g() {
  return _extends$g = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$g.apply(this, arguments);
}
__name(_extends$g, "_extends$g");
var getLabel = /* @__PURE__ */ __name(function(props) {
  var value = props.value, formatter = props.formatter, label = isNil$1(props.children) ? value : props.children;
  return isFunction$3(formatter) ? formatter(label) : label;
}, "getLabel"), getDeltaAngle$1 = /* @__PURE__ */ __name(function(startAngle, endAngle) {
  var sign2 = mathSign(endAngle - startAngle), deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign2 * deltaAngle;
}, "getDeltaAngle"), renderRadialLabel = /* @__PURE__ */ __name(function(labelProps, label, attrs) {
  var position2 = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className, _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise, radius = (innerRadius + outerRadius) / 2, deltaAngle = getDeltaAngle$1(startAngle, endAngle), sign2 = deltaAngle >= 0 ? 1 : -1, labelAngle, direction;
  position2 === "insideStart" ? (labelAngle = startAngle + sign2 * offset, direction = clockWise) : position2 === "insideEnd" ? (labelAngle = endAngle - sign2 * offset, direction = !clockWise) : position2 === "end" && (labelAngle = endAngle + sign2 * offset, direction = clockWise), direction = deltaAngle <= 0 ? direction : !direction;
  var startPoint = polarToCartesian(cx, cy, radius, labelAngle), endPoint = polarToCartesian(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359), path = "M".concat(startPoint.x, ",").concat(startPoint.y, `
    A`).concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, `,
    `).concat(endPoint.x, ",").concat(endPoint.y), id2 = isNil$1(labelProps.id) ? uniqueId("recharts-radial-line-") : labelProps.id;
  return /* @__PURE__ */ React__default.createElement("text", _extends$g({}, attrs, {
    dominantBaseline: "central",
    className: clsx("recharts-radial-bar-label", className)
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("path", {
    id: id2,
    d: path
  })), /* @__PURE__ */ React__default.createElement("textPath", {
    xlinkHref: "#".concat(id2)
  }, label));
}, "renderRadialLabel"), getAttrsOfPolarLabel = /* @__PURE__ */ __name(function(props) {
  var viewBox = props.viewBox, offset = props.offset, position2 = props.position, _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle, midAngle = (startAngle + endAngle) / 2;
  if (position2 === "outside") {
    var _polarToCartesian = polarToCartesian(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
    return {
      x: _x,
      y: _y,
      textAnchor: _x >= cx ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (position2 === "center")
    return {
      x: cx,
      y: cy,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (position2 === "centerTop")
    return {
      x: cx,
      y: cy,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (position2 === "centerBottom")
    return {
      x: cx,
      y: cy,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var r2 = (innerRadius + outerRadius) / 2, _polarToCartesian2 = polarToCartesian(cx, cy, r2, midAngle), x3 = _polarToCartesian2.x, y4 = _polarToCartesian2.y;
  return {
    x: x3,
    y: y4,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, "getAttrsOfPolarLabel"), getAttrsOfCartesianLabel = /* @__PURE__ */ __name(function(props) {
  var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position2 = props.position, _ref3 = viewBox, x3 = _ref3.x, y4 = _ref3.y, width2 = _ref3.width, height2 = _ref3.height, verticalSign = height2 >= 0 ? 1 : -1, verticalOffset = verticalSign * offset, verticalEnd = verticalSign > 0 ? "end" : "start", verticalStart = verticalSign > 0 ? "start" : "end", horizontalSign = width2 >= 0 ? 1 : -1, horizontalOffset = horizontalSign * offset, horizontalEnd = horizontalSign > 0 ? "end" : "start", horizontalStart = horizontalSign > 0 ? "start" : "end";
  if (position2 === "top") {
    var attrs = {
      x: x3 + width2 / 2,
      y: y4 - verticalSign * offset,
      textAnchor: "middle",
      verticalAnchor: verticalEnd
    };
    return _objectSpread$l(_objectSpread$l({}, attrs), parentViewBox ? {
      height: Math.max(y4 - parentViewBox.y, 0),
      width: width2
    } : {});
  }
  if (position2 === "bottom") {
    var _attrs = {
      x: x3 + width2 / 2,
      y: y4 + height2 + verticalOffset,
      textAnchor: "middle",
      verticalAnchor: verticalStart
    };
    return _objectSpread$l(_objectSpread$l({}, _attrs), parentViewBox ? {
      height: Math.max(parentViewBox.y + parentViewBox.height - (y4 + height2), 0),
      width: width2
    } : {});
  }
  if (position2 === "left") {
    var _attrs2 = {
      x: x3 - horizontalOffset,
      y: y4 + height2 / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: "middle"
    };
    return _objectSpread$l(_objectSpread$l({}, _attrs2), parentViewBox ? {
      width: Math.max(_attrs2.x - parentViewBox.x, 0),
      height: height2
    } : {});
  }
  if (position2 === "right") {
    var _attrs3 = {
      x: x3 + width2 + horizontalOffset,
      y: y4 + height2 / 2,
      textAnchor: horizontalStart,
      verticalAnchor: "middle"
    };
    return _objectSpread$l(_objectSpread$l({}, _attrs3), parentViewBox ? {
      width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
      height: height2
    } : {});
  }
  var sizeAttrs = parentViewBox ? {
    width: width2,
    height: height2
  } : {};
  return position2 === "insideLeft" ? _objectSpread$l({
    x: x3 + horizontalOffset,
    y: y4 + height2 / 2,
    textAnchor: horizontalStart,
    verticalAnchor: "middle"
  }, sizeAttrs) : position2 === "insideRight" ? _objectSpread$l({
    x: x3 + width2 - horizontalOffset,
    y: y4 + height2 / 2,
    textAnchor: horizontalEnd,
    verticalAnchor: "middle"
  }, sizeAttrs) : position2 === "insideTop" ? _objectSpread$l({
    x: x3 + width2 / 2,
    y: y4 + verticalOffset,
    textAnchor: "middle",
    verticalAnchor: verticalStart
  }, sizeAttrs) : position2 === "insideBottom" ? _objectSpread$l({
    x: x3 + width2 / 2,
    y: y4 + height2 - verticalOffset,
    textAnchor: "middle",
    verticalAnchor: verticalEnd
  }, sizeAttrs) : position2 === "insideTopLeft" ? _objectSpread$l({
    x: x3 + horizontalOffset,
    y: y4 + verticalOffset,
    textAnchor: horizontalStart,
    verticalAnchor: verticalStart
  }, sizeAttrs) : position2 === "insideTopRight" ? _objectSpread$l({
    x: x3 + width2 - horizontalOffset,
    y: y4 + verticalOffset,
    textAnchor: horizontalEnd,
    verticalAnchor: verticalStart
  }, sizeAttrs) : position2 === "insideBottomLeft" ? _objectSpread$l({
    x: x3 + horizontalOffset,
    y: y4 + height2 - verticalOffset,
    textAnchor: horizontalStart,
    verticalAnchor: verticalEnd
  }, sizeAttrs) : position2 === "insideBottomRight" ? _objectSpread$l({
    x: x3 + width2 - horizontalOffset,
    y: y4 + height2 - verticalOffset,
    textAnchor: horizontalEnd,
    verticalAnchor: verticalEnd
  }, sizeAttrs) : isObject$8(position2) && (isNumber(position2.x) || isPercent(position2.x)) && (isNumber(position2.y) || isPercent(position2.y)) ? _objectSpread$l({
    x: x3 + getPercentValue(position2.x, width2),
    y: y4 + getPercentValue(position2.y, height2),
    textAnchor: "end",
    verticalAnchor: "end"
  }, sizeAttrs) : _objectSpread$l({
    x: x3 + width2 / 2,
    y: y4 + height2 / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, sizeAttrs);
}, "getAttrsOfCartesianLabel"), isPolar = /* @__PURE__ */ __name(function(viewBox) {
  return "cx" in viewBox && isNumber(viewBox.cx);
}, "isPolar");
function Label(_ref4) {
  var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = _objectWithoutProperties$7(_ref4, _excluded$7), props = _objectSpread$l({
    offset
  }, restProps), viewBox = props.viewBox, position2 = props.position, value = props.value, children = props.children, content2 = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
  if (!viewBox || isNil$1(value) && isNil$1(children) && !/* @__PURE__ */ isValidElement(content2) && !isFunction$3(content2))
    return null;
  if (/* @__PURE__ */ isValidElement(content2))
    return /* @__PURE__ */ cloneElement(content2, props);
  var label;
  if (isFunction$3(content2)) {
    if (label = /* @__PURE__ */ createElement(content2, props), /* @__PURE__ */ isValidElement(label))
      return label;
  } else
    label = getLabel(props);
  var isPolarLabel = isPolar(viewBox), attrs = filterProps(props, !0);
  if (isPolarLabel && (position2 === "insideStart" || position2 === "insideEnd" || position2 === "end"))
    return renderRadialLabel(props, label, attrs);
  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
  return /* @__PURE__ */ React__default.createElement(Text, _extends$g({
    className: clsx("recharts-label", className)
  }, attrs, positionAttrs, {
    breakAll: textBreakAll
  }), label);
}
__name(Label, "Label");
Label.displayName = "Label";
var parseViewBox = /* @__PURE__ */ __name(function(props) {
  var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r2 = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x3 = props.x, y4 = props.y, top2 = props.top, left2 = props.left, width2 = props.width, height2 = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
  if (labelViewBox)
    return labelViewBox;
  if (isNumber(width2) && isNumber(height2)) {
    if (isNumber(x3) && isNumber(y4))
      return {
        x: x3,
        y: y4,
        width: width2,
        height: height2
      };
    if (isNumber(top2) && isNumber(left2))
      return {
        x: top2,
        y: left2,
        width: width2,
        height: height2
      };
  }
  return isNumber(x3) && isNumber(y4) ? {
    x: x3,
    y: y4,
    width: 0,
    height: 0
  } : isNumber(cx) && isNumber(cy) ? {
    cx,
    cy,
    startAngle: startAngle || angle || 0,
    endAngle: endAngle || angle || 0,
    innerRadius: innerRadius || 0,
    outerRadius: outerRadius || radius || r2 || 0,
    clockWise
  } : props.viewBox ? props.viewBox : {};
}, "parseViewBox"), parseLabel = /* @__PURE__ */ __name(function(label, viewBox) {
  return label ? label === !0 ? /* @__PURE__ */ React__default.createElement(Label, {
    key: "label-implicit",
    viewBox
  }) : isNumOrStr(label) ? /* @__PURE__ */ React__default.createElement(Label, {
    key: "label-implicit",
    viewBox,
    value: label
  }) : /* @__PURE__ */ isValidElement(label) ? label.type === Label ? /* @__PURE__ */ cloneElement(label, {
    key: "label-implicit",
    viewBox
  }) : /* @__PURE__ */ React__default.createElement(Label, {
    key: "label-implicit",
    content: label,
    viewBox
  }) : isFunction$3(label) ? /* @__PURE__ */ React__default.createElement(Label, {
    key: "label-implicit",
    content: label,
    viewBox
  }) : isObject$8(label) ? /* @__PURE__ */ React__default.createElement(Label, _extends$g({
    viewBox
  }, label, {
    key: "label-implicit"
  })) : null : null;
}, "parseLabel"), renderCallByParent$1 = /* @__PURE__ */ __name(function(parentProps, viewBox) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label)
    return null;
  var children = parentProps.children, parentViewBox = parseViewBox(parentProps), explicitChildren = findAllByType(children, Label).map(function(child, index2) {
    return /* @__PURE__ */ cloneElement(child, {
      viewBox: viewBox || parentViewBox,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(index2)
    });
  });
  if (!checkPropsLabel)
    return explicitChildren;
  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
  return [implicitLabel].concat(_toConsumableArray$7(explicitChildren));
}, "renderCallByParent");
Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent$1;
function last(array2) {
  var length = array2 == null ? 0 : array2.length;
  return length ? array2[length - 1] : void 0;
}
__name(last, "last");
var last_1 = last;
const last$1 = /* @__PURE__ */ getDefaultExportFromCjs(last_1);
function _typeof$n(o) {
  "@babel/helpers - typeof";
  return _typeof$n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$n(o);
}
__name(_typeof$n, "_typeof$n");
var _excluded$6 = ["valueAccessor"], _excluded2$2 = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function _toConsumableArray$6(arr) {
  return _arrayWithoutHoles$6(arr) || _iterableToArray$7(arr) || _unsupportedIterableToArray$a(arr) || _nonIterableSpread$6();
}
__name(_toConsumableArray$6, "_toConsumableArray$6");
function _nonIterableSpread$6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$6, "_nonIterableSpread$6");
function _unsupportedIterableToArray$a(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$a(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$a(o, minLen);
  }
}
__name(_unsupportedIterableToArray$a, "_unsupportedIterableToArray$a");
function _iterableToArray$7(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$7, "_iterableToArray$7");
function _arrayWithoutHoles$6(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$a(arr);
}
__name(_arrayWithoutHoles$6, "_arrayWithoutHoles$6");
function _arrayLikeToArray$a(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$a, "_arrayLikeToArray$a");
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$f.apply(this, arguments);
}
__name(_extends$f, "_extends$f");
function ownKeys$k(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$k, "ownKeys$k");
function _objectSpread$k(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$k(Object(t3), !0).forEach(function(r3) {
      _defineProperty$l(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$k(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$k, "_objectSpread$k");
function _defineProperty$l(obj2, key, value) {
  return key = _toPropertyKey$l(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$l, "_defineProperty$l");
function _toPropertyKey$l(t3) {
  var i2 = _toPrimitive$l(t3, "string");
  return _typeof$n(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$l, "_toPropertyKey$l");
function _toPrimitive$l(t3, r2) {
  if (_typeof$n(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$n(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$l, "_toPrimitive$l");
function _objectWithoutProperties$6(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$6(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$6, "_objectWithoutProperties$6");
function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$6, "_objectWithoutPropertiesLoose$6");
var defaultAccessor = /* @__PURE__ */ __name(function(entry) {
  return Array.isArray(entry.value) ? last$1(entry.value) : entry.value;
}, "defaultAccessor");
function LabelList(_ref) {
  var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? defaultAccessor : _ref$valueAccessor, restProps = _objectWithoutProperties$6(_ref, _excluded$6), data2 = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id2 = restProps.id, textBreakAll = restProps.textBreakAll, others = _objectWithoutProperties$6(restProps, _excluded2$2);
  return !data2 || !data2.length ? null : /* @__PURE__ */ React__default.createElement(Layer, {
    className: "recharts-label-list"
  }, data2.map(function(entry, index2) {
    var value = isNil$1(dataKey) ? valueAccessor(entry, index2) : getValueByDataKey(entry && entry.payload, dataKey), idProps = isNil$1(id2) ? {} : {
      id: "".concat(id2, "-").concat(index2)
    };
    return /* @__PURE__ */ React__default.createElement(Label, _extends$f({}, filterProps(entry, !0), others, idProps, {
      parentViewBox: entry.parentViewBox,
      value,
      textBreakAll,
      viewBox: Label.parseViewBox(isNil$1(clockWise) ? entry : _objectSpread$k(_objectSpread$k({}, entry), {}, {
        clockWise
      })),
      key: "label-".concat(index2),
      index: index2
    }));
  }));
}
__name(LabelList, "LabelList");
LabelList.displayName = "LabelList";
function parseLabelList(label, data2) {
  return label ? label === !0 ? /* @__PURE__ */ React__default.createElement(LabelList, {
    key: "labelList-implicit",
    data: data2
  }) : /* @__PURE__ */ React__default.isValidElement(label) || isFunction$3(label) ? /* @__PURE__ */ React__default.createElement(LabelList, {
    key: "labelList-implicit",
    data: data2,
    content: label
  }) : isObject$8(label) ? /* @__PURE__ */ React__default.createElement(LabelList, _extends$f({
    data: data2
  }, label, {
    key: "labelList-implicit"
  })) : null : null;
}
__name(parseLabelList, "parseLabelList");
function renderCallByParent2(parentProps, data2) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label)
    return null;
  var children = parentProps.children, explicitChildren = findAllByType(children, LabelList).map(function(child, index2) {
    return /* @__PURE__ */ cloneElement(child, {
      data: data2,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(index2)
    });
  });
  if (!checkPropsLabel)
    return explicitChildren;
  var implicitLabelList = parseLabelList(parentProps.label, data2);
  return [implicitLabelList].concat(_toConsumableArray$6(explicitChildren));
}
__name(renderCallByParent2, "renderCallByParent");
LabelList.renderCallByParent = renderCallByParent2;
function _typeof$m(o) {
  "@babel/helpers - typeof";
  return _typeof$m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$m(o);
}
__name(_typeof$m, "_typeof$m");
function _extends$e() {
  return _extends$e = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$e.apply(this, arguments);
}
__name(_extends$e, "_extends$e");
function ownKeys$j(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$j, "ownKeys$j");
function _objectSpread$j(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$j(Object(t3), !0).forEach(function(r3) {
      _defineProperty$k(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$j(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$j, "_objectSpread$j");
function _defineProperty$k(obj2, key, value) {
  return key = _toPropertyKey$k(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$k, "_defineProperty$k");
function _toPropertyKey$k(t3) {
  var i2 = _toPrimitive$k(t3, "string");
  return _typeof$m(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$k, "_toPropertyKey$k");
function _toPrimitive$k(t3, r2) {
  if (_typeof$m(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$m(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$k, "_toPrimitive$k");
var getDeltaAngle2 = /* @__PURE__ */ __name(function(startAngle, endAngle) {
  var sign2 = mathSign(endAngle - startAngle), deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
  return sign2 * deltaAngle;
}, "getDeltaAngle"), getTangentCircle = /* @__PURE__ */ __name(function(_ref) {
  var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign2 = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal, centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius, theta = Math.asin(cornerRadius / centerRadius) / RADIAN$1, centerAngle = cornerIsExternal ? angle : angle + sign2 * theta, center = polarToCartesian(cx, cy, centerRadius, centerAngle), circleTangency = polarToCartesian(cx, cy, radius, centerAngle), lineTangencyAngle = cornerIsExternal ? angle - sign2 * theta : angle, lineTangency = polarToCartesian(cx, cy, centerRadius * Math.cos(theta * RADIAN$1), lineTangencyAngle);
  return {
    center,
    circleTangency,
    lineTangency,
    theta
  };
}, "getTangentCircle"), getSectorPath = /* @__PURE__ */ __name(function(_ref2) {
  var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle, angle = getDeltaAngle2(startAngle, endAngle), tempEndAngle = startAngle + angle, outerStartPoint = polarToCartesian(cx, cy, outerRadius, startAngle), outerEndPoint = polarToCartesian(cx, cy, outerRadius, tempEndAngle), path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, `
    A `).concat(outerRadius, ",").concat(outerRadius, `,0,
    `).concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), `,
    `).concat(outerEndPoint.x, ",").concat(outerEndPoint.y, `
  `);
  if (innerRadius > 0) {
    var innerStartPoint = polarToCartesian(cx, cy, innerRadius, startAngle), innerEndPoint = polarToCartesian(cx, cy, innerRadius, tempEndAngle);
    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, `
            A `).concat(innerRadius, ",").concat(innerRadius, `,0,
            `).concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), `,
            `).concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
  } else
    path += "L ".concat(cx, ",").concat(cy, " Z");
  return path;
}, "getSectorPath"), getSectorWithCorner = /* @__PURE__ */ __name(function(_ref3) {
  var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle, sign2 = mathSign(endAngle - startAngle), _getTangentCircle = getTangentCircle({
    cx,
    cy,
    radius: outerRadius,
    angle: startAngle,
    sign: sign2,
    cornerRadius,
    cornerIsExternal
  }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta, _getTangentCircle2 = getTangentCircle({
    cx,
    cy,
    radius: outerRadius,
    angle: endAngle,
    sign: -sign2,
    cornerRadius,
    cornerIsExternal
  }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta, outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
  if (outerArcAngle < 0)
    return forceCornerRadius ? "M ".concat(solt.x, ",").concat(solt.y, `
        a`).concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, `,0
        a`).concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, `,0
      `) : getSectorPath({
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle
    });
  var path = "M ".concat(solt.x, ",").concat(solt.y, `
    A`).concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(soct.x, ",").concat(soct.y, `
    A`).concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign2 < 0), ",").concat(eoct.x, ",").concat(eoct.y, `
    A`).concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(eolt.x, ",").concat(eolt.y, `
  `);
  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
      cx,
      cy,
      radius: innerRadius,
      angle: startAngle,
      sign: sign2,
      isExternal: !0,
      cornerRadius,
      cornerIsExternal
    }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta, _getTangentCircle4 = getTangentCircle({
      cx,
      cy,
      radius: innerRadius,
      angle: endAngle,
      sign: -sign2,
      isExternal: !0,
      cornerRadius,
      cornerIsExternal
    }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta, innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
    if (innerArcAngle < 0 && cornerRadius === 0)
      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
    path += "L".concat(eilt.x, ",").concat(eilt.y, `
      A`).concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(eict.x, ",").concat(eict.y, `
      A`).concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign2 > 0), ",").concat(sict.x, ",").concat(sict.y, `
      A`).concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign2 < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
  } else
    path += "L".concat(cx, ",").concat(cy, "Z");
  return path;
}, "getSectorWithCorner"), defaultProps$2 = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, Sector = /* @__PURE__ */ __name(function(sectorProps) {
  var props = _objectSpread$j(_objectSpread$j({}, defaultProps$2), sectorProps), cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
  if (outerRadius < innerRadius || startAngle === endAngle)
    return null;
  var layerClass = clsx("recharts-sector", className), deltaRadius = outerRadius - innerRadius, cr = getPercentValue(cornerRadius, deltaRadius, 0, !0), path;
  return cr > 0 && Math.abs(startAngle - endAngle) < 360 ? path = getSectorWithCorner({
    cx,
    cy,
    innerRadius,
    outerRadius,
    cornerRadius: Math.min(cr, deltaRadius / 2),
    forceCornerRadius,
    cornerIsExternal,
    startAngle,
    endAngle
  }) : path = getSectorPath({
    cx,
    cy,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle
  }), /* @__PURE__ */ React__default.createElement("path", _extends$e({}, filterProps(props, !0), {
    className: layerClass,
    d: path,
    role: "img"
  }));
}, "Sector");
function _typeof$l(o) {
  "@babel/helpers - typeof";
  return _typeof$l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$l(o);
}
__name(_typeof$l, "_typeof$l");
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$d.apply(this, arguments);
}
__name(_extends$d, "_extends$d");
function ownKeys$i(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$i, "ownKeys$i");
function _objectSpread$i(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$i(Object(t3), !0).forEach(function(r3) {
      _defineProperty$j(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$i(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$i, "_objectSpread$i");
function _defineProperty$j(obj2, key, value) {
  return key = _toPropertyKey$j(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$j, "_defineProperty$j");
function _toPropertyKey$j(t3) {
  var i2 = _toPrimitive$j(t3, "string");
  return _typeof$l(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$j, "_toPropertyKey$j");
function _toPrimitive$j(t3, r2) {
  if (_typeof$l(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$l(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$j, "_toPrimitive$j");
var CURVE_FACTORIES = {
  curveBasisClosed,
  curveBasisOpen,
  curveBasis,
  curveBumpX: bumpX,
  curveBumpY: bumpY,
  curveLinearClosed,
  curveLinear,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural,
  curveStep,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore
}, defined = /* @__PURE__ */ __name(function(p) {
  return p.x === +p.x && p.y === +p.y;
}, "defined"), getX = /* @__PURE__ */ __name(function(p) {
  return p.x;
}, "getX"), getY = /* @__PURE__ */ __name(function(p) {
  return p.y;
}, "getY"), getCurveFactory = /* @__PURE__ */ __name(function(type, layout2) {
  if (isFunction$3(type))
    return type;
  var name2 = "curve".concat(upperFirst$1(type));
  return (name2 === "curveMonotone" || name2 === "curveBump") && layout2 ? CURVE_FACTORIES["".concat(name2).concat(layout2 === "vertical" ? "Y" : "X")] : CURVE_FACTORIES[name2] || curveLinear;
}, "getCurveFactory"), getPath$1 = /* @__PURE__ */ __name(function(_ref) {
  var _ref$type = _ref.type, type = _ref$type === void 0 ? "linear" : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout2 = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? !1 : _ref$connectNulls, curveFactory = getCurveFactory(type, layout2), formatPoints = connectNulls ? points.filter(function(entry) {
    return defined(entry);
  }) : points, lineFunction;
  if (Array.isArray(baseLine)) {
    var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
      return defined(base);
    }) : baseLine, areaPoints = formatPoints.map(function(entry, index2) {
      return _objectSpread$i(_objectSpread$i({}, entry), {}, {
        base: formatBaseLine[index2]
      });
    });
    return layout2 === "vertical" ? lineFunction = shapeArea().y(getY).x1(getX).x0(function(d3) {
      return d3.base.x;
    }) : lineFunction = shapeArea().x(getX).y1(getY).y0(function(d3) {
      return d3.base.y;
    }), lineFunction.defined(defined).curve(curveFactory), lineFunction(areaPoints);
  }
  return layout2 === "vertical" && isNumber(baseLine) ? lineFunction = shapeArea().y(getY).x1(getX).x0(baseLine) : isNumber(baseLine) ? lineFunction = shapeArea().x(getX).y1(getY).y0(baseLine) : lineFunction = shapeLine().x(getX).y(getY), lineFunction.defined(defined).curve(curveFactory), lineFunction(formatPoints);
}, "getPath"), Curve = /* @__PURE__ */ __name(function(props) {
  var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
  if ((!points || !points.length) && !path)
    return null;
  var realPath = points && points.length ? getPath$1(props) : path;
  return /* @__PURE__ */ React__default.createElement("path", _extends$d({}, filterProps(props, !1), adaptEventHandlers(props), {
    className: clsx("recharts-curve", className),
    d: realPath,
    ref: pathRef
  }));
}, "Curve"), getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function combineComparators(comparatorA, comparatorB) {
  return /* @__PURE__ */ __name(function(a4, b2, state) {
    return comparatorA(a4, b2, state) && comparatorB(a4, b2, state);
  }, "isEqual");
}
__name(combineComparators, "combineComparators");
function createIsCircular(areItemsEqual) {
  return /* @__PURE__ */ __name(function(a4, b2, state) {
    if (!a4 || !b2 || typeof a4 != "object" || typeof b2 != "object")
      return areItemsEqual(a4, b2, state);
    var cache2 = state.cache, cachedA = cache2.get(a4), cachedB = cache2.get(b2);
    if (cachedA && cachedB)
      return cachedA === b2 && cachedB === a4;
    cache2.set(a4, b2), cache2.set(b2, a4);
    var result2 = areItemsEqual(a4, b2, state);
    return cache2.delete(a4), cache2.delete(b2), result2;
  }, "isCircular");
}
__name(createIsCircular, "createIsCircular");
function getStrictProperties(object2) {
  return getOwnPropertyNames(object2).concat(getOwnPropertySymbols(object2));
}
__name(getStrictProperties, "getStrictProperties");
var hasOwn = Object.hasOwn || function(object2, property2) {
  return hasOwnProperty$1.call(object2, property2);
};
function sameValueZeroEqual(a4, b2) {
  return a4 === b2 || !a4 && !b2 && a4 !== a4 && b2 !== b2;
}
__name(sameValueZeroEqual, "sameValueZeroEqual");
var PREACT_VNODE = "__v", PREACT_OWNER = "__o", REACT_OWNER = "_owner", getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
function areArraysEqual(a4, b2, state) {
  var index2 = a4.length;
  if (b2.length !== index2)
    return !1;
  for (; index2-- > 0; )
    if (!state.equals(a4[index2], b2[index2], index2, index2, a4, b2, state))
      return !1;
  return !0;
}
__name(areArraysEqual, "areArraysEqual");
function areDatesEqual(a4, b2) {
  return sameValueZeroEqual(a4.getTime(), b2.getTime());
}
__name(areDatesEqual, "areDatesEqual");
function areErrorsEqual(a4, b2) {
  return a4.name === b2.name && a4.message === b2.message && a4.cause === b2.cause && a4.stack === b2.stack;
}
__name(areErrorsEqual, "areErrorsEqual");
function areFunctionsEqual(a4, b2) {
  return a4 === b2;
}
__name(areFunctionsEqual, "areFunctionsEqual");
function areMapsEqual(a4, b2, state) {
  var size = a4.size;
  if (size !== b2.size)
    return !1;
  if (!size)
    return !0;
  for (var matchedIndices = new Array(size), aIterable = a4.entries(), aResult, bResult, index2 = 0; (aResult = aIterable.next()) && !aResult.done; ) {
    for (var bIterable = b2.entries(), hasMatch = !1, matchIndex = 0; (bResult = bIterable.next()) && !bResult.done; ) {
      if (matchedIndices[matchIndex]) {
        matchIndex++;
        continue;
      }
      var aEntry = aResult.value, bEntry = bResult.value;
      if (state.equals(aEntry[0], bEntry[0], index2, matchIndex, a4, b2, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a4, b2, state)) {
        hasMatch = matchedIndices[matchIndex] = !0;
        break;
      }
      matchIndex++;
    }
    if (!hasMatch)
      return !1;
    index2++;
  }
  return !0;
}
__name(areMapsEqual, "areMapsEqual");
var areNumbersEqual = sameValueZeroEqual;
function areObjectsEqual(a4, b2, state) {
  var properties = keys(a4), index2 = properties.length;
  if (keys(b2).length !== index2)
    return !1;
  for (; index2-- > 0; )
    if (!isPropertyEqual(a4, b2, state, properties[index2]))
      return !1;
  return !0;
}
__name(areObjectsEqual, "areObjectsEqual");
function areObjectsEqualStrict(a4, b2, state) {
  var properties = getStrictProperties(a4), index2 = properties.length;
  if (getStrictProperties(b2).length !== index2)
    return !1;
  for (var property2, descriptorA, descriptorB; index2-- > 0; )
    if (property2 = properties[index2], !isPropertyEqual(a4, b2, state, property2) || (descriptorA = getOwnPropertyDescriptor(a4, property2), descriptorB = getOwnPropertyDescriptor(b2, property2), (descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)))
      return !1;
  return !0;
}
__name(areObjectsEqualStrict, "areObjectsEqualStrict");
function arePrimitiveWrappersEqual(a4, b2) {
  return sameValueZeroEqual(a4.valueOf(), b2.valueOf());
}
__name(arePrimitiveWrappersEqual, "arePrimitiveWrappersEqual");
function areRegExpsEqual(a4, b2) {
  return a4.source === b2.source && a4.flags === b2.flags;
}
__name(areRegExpsEqual, "areRegExpsEqual");
function areSetsEqual(a4, b2, state) {
  var size = a4.size;
  if (size !== b2.size)
    return !1;
  if (!size)
    return !0;
  for (var matchedIndices = new Array(size), aIterable = a4.values(), aResult, bResult; (aResult = aIterable.next()) && !aResult.done; ) {
    for (var bIterable = b2.values(), hasMatch = !1, matchIndex = 0; (bResult = bIterable.next()) && !bResult.done; ) {
      if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a4, b2, state)) {
        hasMatch = matchedIndices[matchIndex] = !0;
        break;
      }
      matchIndex++;
    }
    if (!hasMatch)
      return !1;
  }
  return !0;
}
__name(areSetsEqual, "areSetsEqual");
function areTypedArraysEqual(a4, b2) {
  var index2 = a4.length;
  if (b2.length !== index2)
    return !1;
  for (; index2-- > 0; )
    if (a4[index2] !== b2[index2])
      return !1;
  return !0;
}
__name(areTypedArraysEqual, "areTypedArraysEqual");
function areUrlsEqual(a4, b2) {
  return a4.hostname === b2.hostname && a4.pathname === b2.pathname && a4.protocol === b2.protocol && a4.port === b2.port && a4.hash === b2.hash && a4.username === b2.username && a4.password === b2.password;
}
__name(areUrlsEqual, "areUrlsEqual");
function isPropertyEqual(a4, b2, state, property2) {
  return (property2 === REACT_OWNER || property2 === PREACT_OWNER || property2 === PREACT_VNODE) && (a4.$$typeof || b2.$$typeof) ? !0 : hasOwn(b2, property2) && state.equals(a4[property2], b2[property2], property2, property2, a4, b2, state);
}
__name(isPropertyEqual, "isPropertyEqual");
var ARGUMENTS_TAG = "[object Arguments]", BOOLEAN_TAG = "[object Boolean]", DATE_TAG = "[object Date]", ERROR_TAG = "[object Error]", MAP_TAG = "[object Map]", NUMBER_TAG = "[object Number]", OBJECT_TAG = "[object Object]", REG_EXP_TAG = "[object RegExp]", SET_TAG = "[object Set]", STRING_TAG = "[object String]", URL_TAG = "[object URL]", isArray$2 = Array.isArray, isTypedArray = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, assign = Object.assign, getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
function createEqualityComparator(_a3) {
  var areArraysEqual2 = _a3.areArraysEqual, areDatesEqual2 = _a3.areDatesEqual, areErrorsEqual2 = _a3.areErrorsEqual, areFunctionsEqual2 = _a3.areFunctionsEqual, areMapsEqual2 = _a3.areMapsEqual, areNumbersEqual2 = _a3.areNumbersEqual, areObjectsEqual2 = _a3.areObjectsEqual, arePrimitiveWrappersEqual2 = _a3.arePrimitiveWrappersEqual, areRegExpsEqual2 = _a3.areRegExpsEqual, areSetsEqual2 = _a3.areSetsEqual, areTypedArraysEqual2 = _a3.areTypedArraysEqual, areUrlsEqual2 = _a3.areUrlsEqual;
  return /* @__PURE__ */ __name(function(a4, b2, state) {
    if (a4 === b2)
      return !0;
    if (a4 == null || b2 == null)
      return !1;
    var type = typeof a4;
    if (type !== typeof b2)
      return !1;
    if (type !== "object")
      return type === "number" ? areNumbersEqual2(a4, b2, state) : type === "function" ? areFunctionsEqual2(a4, b2, state) : !1;
    var constructor = a4.constructor;
    if (constructor !== b2.constructor)
      return !1;
    if (constructor === Object)
      return areObjectsEqual2(a4, b2, state);
    if (isArray$2(a4))
      return areArraysEqual2(a4, b2, state);
    if (isTypedArray != null && isTypedArray(a4))
      return areTypedArraysEqual2(a4, b2, state);
    if (constructor === Date)
      return areDatesEqual2(a4, b2, state);
    if (constructor === RegExp)
      return areRegExpsEqual2(a4, b2, state);
    if (constructor === Map)
      return areMapsEqual2(a4, b2, state);
    if (constructor === Set)
      return areSetsEqual2(a4, b2, state);
    var tag = getTag(a4);
    return tag === DATE_TAG ? areDatesEqual2(a4, b2, state) : tag === REG_EXP_TAG ? areRegExpsEqual2(a4, b2, state) : tag === MAP_TAG ? areMapsEqual2(a4, b2, state) : tag === SET_TAG ? areSetsEqual2(a4, b2, state) : tag === OBJECT_TAG ? typeof a4.then != "function" && typeof b2.then != "function" && areObjectsEqual2(a4, b2, state) : tag === URL_TAG ? areUrlsEqual2(a4, b2, state) : tag === ERROR_TAG ? areErrorsEqual2(a4, b2, state) : tag === ARGUMENTS_TAG ? areObjectsEqual2(a4, b2, state) : tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG ? arePrimitiveWrappersEqual2(a4, b2, state) : !1;
  }, "comparator");
}
__name(createEqualityComparator, "createEqualityComparator");
function createEqualityComparatorConfig(_a3) {
  var circular = _a3.circular, createCustomConfig = _a3.createCustomConfig, strict = _a3.strict, config2 = {
    areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
    areDatesEqual,
    areErrorsEqual,
    areFunctionsEqual,
    areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
    areNumbersEqual,
    areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
    arePrimitiveWrappersEqual,
    areRegExpsEqual,
    areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
    areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
    areUrlsEqual
  };
  if (createCustomConfig && (config2 = assign({}, config2, createCustomConfig(config2))), circular) {
    var areArraysEqual$1 = createIsCircular(config2.areArraysEqual), areMapsEqual$1 = createIsCircular(config2.areMapsEqual), areObjectsEqual$1 = createIsCircular(config2.areObjectsEqual), areSetsEqual$1 = createIsCircular(config2.areSetsEqual);
    config2 = assign({}, config2, {
      areArraysEqual: areArraysEqual$1,
      areMapsEqual: areMapsEqual$1,
      areObjectsEqual: areObjectsEqual$1,
      areSetsEqual: areSetsEqual$1
    });
  }
  return config2;
}
__name(createEqualityComparatorConfig, "createEqualityComparatorConfig");
function createInternalEqualityComparator(compare2) {
  return function(a4, b2, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
    return compare2(a4, b2, state);
  };
}
__name(createInternalEqualityComparator, "createInternalEqualityComparator");
function createIsEqual(_a3) {
  var circular = _a3.circular, comparator2 = _a3.comparator, createState2 = _a3.createState, equals = _a3.equals, strict = _a3.strict;
  if (createState2)
    return /* @__PURE__ */ __name(function(a4, b2) {
      var _a4 = createState2(), _b = _a4.cache, cache2 = _b === void 0 ? circular ? /* @__PURE__ */ new WeakMap() : void 0 : _b, meta = _a4.meta;
      return comparator2(a4, b2, {
        cache: cache2,
        equals,
        meta,
        strict
      });
    }, "isEqual");
  if (circular)
    return /* @__PURE__ */ __name(function(a4, b2) {
      return comparator2(a4, b2, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals,
        meta: void 0,
        strict
      });
    }, "isEqual");
  var state = {
    cache: void 0,
    equals,
    meta: void 0,
    strict
  };
  return /* @__PURE__ */ __name(function(a4, b2) {
    return comparator2(a4, b2, state);
  }, "isEqual");
}
__name(createIsEqual, "createIsEqual");
var deepEqual = createCustomEqual();
createCustomEqual({ strict: !0 });
createCustomEqual({ circular: !0 });
createCustomEqual({
  circular: !0,
  strict: !0
});
createCustomEqual({
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  strict: !0,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  circular: !0,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  circular: !0,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  },
  strict: !0
});
function createCustomEqual(options) {
  options === void 0 && (options = {});
  var _a3 = options.circular, circular = _a3 === void 0 ? !1 : _a3, createCustomInternalComparator = options.createInternalComparator, createState2 = options.createState, _b = options.strict, strict = _b === void 0 ? !1 : _b, config2 = createEqualityComparatorConfig(options), comparator2 = createEqualityComparator(config2), equals = createCustomInternalComparator ? createCustomInternalComparator(comparator2) : createInternalEqualityComparator(comparator2);
  return createIsEqual({ circular, comparator: comparator2, createState: createState2, equals, strict });
}
__name(createCustomEqual, "createCustomEqual");
function safeRequestAnimationFrame(callback) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(callback);
}
__name(safeRequestAnimationFrame, "safeRequestAnimationFrame");
function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, currTime = -1, shouldUpdate = /* @__PURE__ */ __name(function shouldUpdate2(now2) {
    currTime < 0 && (currTime = now2), now2 - currTime > timeout ? (callback(now2), currTime = -1) : safeRequestAnimationFrame(shouldUpdate2);
  }, "shouldUpdate");
  requestAnimationFrame(shouldUpdate);
}
__name(setRafTimeout, "setRafTimeout");
function _typeof$k(o) {
  "@babel/helpers - typeof";
  return _typeof$k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$k(o);
}
__name(_typeof$k, "_typeof$k");
function _toArray(arr) {
  return _arrayWithHoles$6(arr) || _iterableToArray$6(arr) || _unsupportedIterableToArray$9(arr) || _nonIterableRest$6();
}
__name(_toArray, "_toArray");
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$6, "_nonIterableRest$6");
function _unsupportedIterableToArray$9(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$9(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$9(o, minLen);
  }
}
__name(_unsupportedIterableToArray$9, "_unsupportedIterableToArray$9");
function _arrayLikeToArray$9(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$9, "_arrayLikeToArray$9");
function _iterableToArray$6(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$6, "_iterableToArray$6");
function _arrayWithHoles$6(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$6, "_arrayWithHoles$6");
function createAnimateManager() {
  var currStyle = {}, handleChange = /* @__PURE__ */ __name(function() {
    return null;
  }, "handleChange"), shouldStop = !1, setStyle = /* @__PURE__ */ __name(function setStyle2(_style) {
    if (!shouldStop) {
      if (Array.isArray(_style)) {
        if (!_style.length)
          return;
        var styles = _style, _styles = _toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
        if (typeof curr == "number") {
          setRafTimeout(setStyle2.bind(null, restStyles), curr);
          return;
        }
        setStyle2(curr), setRafTimeout(setStyle2.bind(null, restStyles));
        return;
      }
      _typeof$k(_style) === "object" && (currStyle = _style, handleChange(currStyle)), typeof _style == "function" && _style();
    }
  }, "setStyle");
  return {
    stop: /* @__PURE__ */ __name(function() {
      shouldStop = !0;
    }, "stop"),
    start: /* @__PURE__ */ __name(function(style2) {
      shouldStop = !1, setStyle(style2);
    }, "start"),
    subscribe: /* @__PURE__ */ __name(function(_handleChange) {
      return handleChange = _handleChange, function() {
        handleChange = /* @__PURE__ */ __name(function() {
          return null;
        }, "handleChange");
      };
    }, "subscribe")
  };
}
__name(createAnimateManager, "createAnimateManager");
function _typeof$j(o) {
  "@babel/helpers - typeof";
  return _typeof$j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$j(o);
}
__name(_typeof$j, "_typeof$j");
function ownKeys$h(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$h, "ownKeys$h");
function _objectSpread$h(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$h(Object(t3), !0).forEach(function(r3) {
      _defineProperty$i(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$h(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$h, "_objectSpread$h");
function _defineProperty$i(obj2, key, value) {
  return key = _toPropertyKey$i(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$i, "_defineProperty$i");
function _toPropertyKey$i(arg) {
  var key = _toPrimitive$i(arg, "string");
  return _typeof$j(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$i, "_toPropertyKey$i");
function _toPrimitive$i(input, hint) {
  if (_typeof$j(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$j(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
__name(_toPrimitive$i, "_toPrimitive$i");
var getIntersectionKeys = /* @__PURE__ */ __name(function(preObj, nextObj) {
  return [Object.keys(preObj), Object.keys(nextObj)].reduce(function(a4, b2) {
    return a4.filter(function(c3) {
      return b2.includes(c3);
    });
  });
}, "getIntersectionKeys"), identity2 = /* @__PURE__ */ __name(function(param) {
  return param;
}, "identity"), getDashCase = /* @__PURE__ */ __name(function(name2) {
  return name2.replace(/([A-Z])/g, function(v) {
    return "-".concat(v.toLowerCase());
  });
}, "getDashCase"), mapObject = /* @__PURE__ */ __name(function(fn, obj2) {
  return Object.keys(obj2).reduce(function(res, key) {
    return _objectSpread$h(_objectSpread$h({}, res), {}, _defineProperty$i({}, key, fn(key, obj2[key])));
  }, {});
}, "mapObject"), getTransitionVal = /* @__PURE__ */ __name(function(props, duration, easing) {
  return props.map(function(prop) {
    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
  }).join(",");
}, "getTransitionVal"), isDev = process.env.NODE_ENV !== "production", warn2 = /* @__PURE__ */ __name(function(condition, format2, a4, b2, c3, d3, e3, f) {
  if (isDev && typeof console < "u" && console.warn && (format2 === void 0 && console.warn("LogUtils requires an error message argument"), !condition))
    if (format2 === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var args = [a4, b2, c3, d3, e3, f], argIndex = 0;
      console.warn(format2.replace(/%s/g, function() {
        return args[argIndex++];
      }));
    }
}, "warn");
function _slicedToArray$5(arr, i2) {
  return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i2) || _unsupportedIterableToArray$8(arr, i2) || _nonIterableRest$5();
}
__name(_slicedToArray$5, "_slicedToArray$5");
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$5, "_nonIterableRest$5");
function _iterableToArrayLimit$5(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$5, "_iterableToArrayLimit$5");
function _arrayWithHoles$5(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$5, "_arrayWithHoles$5");
function _toConsumableArray$5(arr) {
  return _arrayWithoutHoles$5(arr) || _iterableToArray$5(arr) || _unsupportedIterableToArray$8(arr) || _nonIterableSpread$5();
}
__name(_toConsumableArray$5, "_toConsumableArray$5");
function _nonIterableSpread$5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$5, "_nonIterableSpread$5");
function _unsupportedIterableToArray$8(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$8(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$8(o, minLen);
  }
}
__name(_unsupportedIterableToArray$8, "_unsupportedIterableToArray$8");
function _iterableToArray$5(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$5, "_iterableToArray$5");
function _arrayWithoutHoles$5(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$8(arr);
}
__name(_arrayWithoutHoles$5, "_arrayWithoutHoles$5");
function _arrayLikeToArray$8(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$8, "_arrayLikeToArray$8");
var ACCURACY = 1e-4, cubicBezierFactor = /* @__PURE__ */ __name(function(c1, c22) {
  return [0, 3 * c1, 3 * c22 - 6 * c1, 3 * c1 - 3 * c22 + 1];
}, "cubicBezierFactor"), multyTime = /* @__PURE__ */ __name(function(params, t3) {
  return params.map(function(param, i2) {
    return param * Math.pow(t3, i2);
  }).reduce(function(pre, curr) {
    return pre + curr;
  });
}, "multyTime"), cubicBezier = /* @__PURE__ */ __name(function(c1, c22) {
  return function(t3) {
    var params = cubicBezierFactor(c1, c22);
    return multyTime(params, t3);
  };
}, "cubicBezier"), derivativeCubicBezier = /* @__PURE__ */ __name(function(c1, c22) {
  return function(t3) {
    var params = cubicBezierFactor(c1, c22), newParams = [].concat(_toConsumableArray$5(params.map(function(param, i2) {
      return param * i2;
    }).slice(1)), [0]);
    return multyTime(newParams, t3);
  };
}, "derivativeCubicBezier"), configBezier = /* @__PURE__ */ __name(function() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)
    args[_key] = arguments[_key];
  var x1 = args[0], y1 = args[1], x22 = args[2], y22 = args[3];
  if (args.length === 1)
    switch (args[0]) {
      case "linear":
        x1 = 0, y1 = 0, x22 = 1, y22 = 1;
        break;
      case "ease":
        x1 = 0.25, y1 = 0.1, x22 = 0.25, y22 = 1;
        break;
      case "ease-in":
        x1 = 0.42, y1 = 0, x22 = 1, y22 = 1;
        break;
      case "ease-out":
        x1 = 0.42, y1 = 0, x22 = 0.58, y22 = 1;
        break;
      case "ease-in-out":
        x1 = 0, y1 = 0, x22 = 0.58, y22 = 1;
        break;
      default: {
        var easing = args[0].split("(");
        if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
          var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x3) {
            return parseFloat(x3);
          }), _easing$1$split$0$spl2 = _slicedToArray$5(_easing$1$split$0$spl, 4);
          x1 = _easing$1$split$0$spl2[0], y1 = _easing$1$split$0$spl2[1], x22 = _easing$1$split$0$spl2[2], y22 = _easing$1$split$0$spl2[3];
        } else
          warn2(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
      }
    }
  warn2([x1, x22, y1, y22].every(function(num2) {
    return typeof num2 == "number" && num2 >= 0 && num2 <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
  var curveX = cubicBezier(x1, x22), curveY = cubicBezier(y1, y22), derCurveX = derivativeCubicBezier(x1, x22), rangeValue = /* @__PURE__ */ __name(function(value) {
    return value > 1 ? 1 : value < 0 ? 0 : value;
  }, "rangeValue"), bezier = /* @__PURE__ */ __name(function(_t) {
    for (var t3 = _t > 1 ? 1 : _t, x3 = t3, i2 = 0; i2 < 8; ++i2) {
      var evalT = curveX(x3) - t3, derVal = derCurveX(x3);
      if (Math.abs(evalT - t3) < ACCURACY || derVal < ACCURACY)
        return curveY(x3);
      x3 = rangeValue(x3 - evalT / derVal);
    }
    return curveY(x3);
  }, "bezier");
  return bezier.isStepper = !1, bezier;
}, "configBezier"), configSpring = /* @__PURE__ */ __name(function() {
  var config2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _config$stiff = config2.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config2.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config2.dt, dt = _config$dt === void 0 ? 17 : _config$dt, stepper = /* @__PURE__ */ __name(function(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff, FDamping = currV * damping, newV = currV + (FSpring - FDamping) * dt / 1e3, newX = currV * dt / 1e3 + currX;
    return Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY ? [destX, 0] : [newX, newV];
  }, "stepper");
  return stepper.isStepper = !0, stepper.dt = dt, stepper;
}, "configSpring"), configEasing = /* @__PURE__ */ __name(function() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)
    args[_key2] = arguments[_key2];
  var easing = args[0];
  if (typeof easing == "string")
    switch (easing) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return configBezier(easing);
      case "spring":
        return configSpring();
      default:
        if (easing.split("(")[0] === "cubic-bezier")
          return configBezier(easing);
        warn2(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
  return typeof easing == "function" ? easing : (warn2(!1, "[configEasing]: first argument type should be function or string, instead received %s", args), null);
}, "configEasing");
function _typeof$i(o) {
  "@babel/helpers - typeof";
  return _typeof$i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$i(o);
}
__name(_typeof$i, "_typeof$i");
function _toConsumableArray$4(arr) {
  return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$7(arr) || _nonIterableSpread$4();
}
__name(_toConsumableArray$4, "_toConsumableArray$4");
function _nonIterableSpread$4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$4, "_nonIterableSpread$4");
function _iterableToArray$4(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$4, "_iterableToArray$4");
function _arrayWithoutHoles$4(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$7(arr);
}
__name(_arrayWithoutHoles$4, "_arrayWithoutHoles$4");
function ownKeys$g(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$g, "ownKeys$g");
function _objectSpread$g(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$g(Object(t3), !0).forEach(function(r3) {
      _defineProperty$h(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$g(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$g, "_objectSpread$g");
function _defineProperty$h(obj2, key, value) {
  return key = _toPropertyKey$h(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$h, "_defineProperty$h");
function _toPropertyKey$h(arg) {
  var key = _toPrimitive$h(arg, "string");
  return _typeof$i(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$h, "_toPropertyKey$h");
function _toPrimitive$h(input, hint) {
  if (_typeof$i(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$i(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
__name(_toPrimitive$h, "_toPrimitive$h");
function _slicedToArray$4(arr, i2) {
  return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i2) || _unsupportedIterableToArray$7(arr, i2) || _nonIterableRest$4();
}
__name(_slicedToArray$4, "_slicedToArray$4");
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$4, "_nonIterableRest$4");
function _unsupportedIterableToArray$7(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$7(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$7(o, minLen);
  }
}
__name(_unsupportedIterableToArray$7, "_unsupportedIterableToArray$7");
function _arrayLikeToArray$7(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$7, "_arrayLikeToArray$7");
function _iterableToArrayLimit$4(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$4, "_iterableToArrayLimit$4");
function _arrayWithHoles$4(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$4, "_arrayWithHoles$4");
var alpha = /* @__PURE__ */ __name(function(begin, end, k3) {
  return begin + (end - begin) * k3;
}, "alpha"), needContinue = /* @__PURE__ */ __name(function(_ref) {
  var from = _ref.from, to = _ref.to;
  return from !== to;
}, "needContinue"), calStepperVals = /* @__PURE__ */ __name(function calStepperVals2(easing, preVals, steps2) {
  var nextStepVals = mapObject(function(key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity), _easing2 = _slicedToArray$4(_easing, 2), newX = _easing2[0], newV = _easing2[1];
      return _objectSpread$g(_objectSpread$g({}, val), {}, {
        from: newX,
        velocity: newV
      });
    }
    return val;
  }, preVals);
  return steps2 < 1 ? mapObject(function(key, val) {
    return needContinue(val) ? _objectSpread$g(_objectSpread$g({}, val), {}, {
      velocity: alpha(val.velocity, nextStepVals[key].velocity, steps2),
      from: alpha(val.from, nextStepVals[key].from, steps2)
    }) : val;
  }, preVals) : calStepperVals2(easing, nextStepVals, steps2 - 1);
}, "calStepperVals");
const configUpdate = /* @__PURE__ */ __name(function(from, to, easing, duration, render) {
  var interKeys = getIntersectionKeys(from, to), timingStyle = interKeys.reduce(function(res, key) {
    return _objectSpread$g(_objectSpread$g({}, res), {}, _defineProperty$h({}, key, [from[key], to[key]]));
  }, {}), stepperStyle = interKeys.reduce(function(res, key) {
    return _objectSpread$g(_objectSpread$g({}, res), {}, _defineProperty$h({}, key, {
      from: from[key],
      velocity: 0,
      to: to[key]
    }));
  }, {}), cafId = -1, preTime, beginTime, update3 = /* @__PURE__ */ __name(function() {
    return null;
  }, "update"), getCurrStyle = /* @__PURE__ */ __name(function() {
    return mapObject(function(key, val) {
      return val.from;
    }, stepperStyle);
  }, "getCurrStyle"), shouldStopAnimation = /* @__PURE__ */ __name(function() {
    return !Object.values(stepperStyle).filter(needContinue).length;
  }, "shouldStopAnimation"), stepperUpdate = /* @__PURE__ */ __name(function(now2) {
    preTime || (preTime = now2);
    var deltaTime = now2 - preTime, steps2 = deltaTime / easing.dt;
    stepperStyle = calStepperVals(easing, stepperStyle, steps2), render(_objectSpread$g(_objectSpread$g(_objectSpread$g({}, from), to), getCurrStyle())), preTime = now2, shouldStopAnimation() || (cafId = requestAnimationFrame(update3));
  }, "stepperUpdate"), timingUpdate = /* @__PURE__ */ __name(function(now2) {
    beginTime || (beginTime = now2);
    var t3 = (now2 - beginTime) / duration, currStyle = mapObject(function(key, val) {
      return alpha.apply(void 0, _toConsumableArray$4(val).concat([easing(t3)]));
    }, timingStyle);
    if (render(_objectSpread$g(_objectSpread$g(_objectSpread$g({}, from), to), currStyle)), t3 < 1)
      cafId = requestAnimationFrame(update3);
    else {
      var finalStyle = mapObject(function(key, val) {
        return alpha.apply(void 0, _toConsumableArray$4(val).concat([easing(1)]));
      }, timingStyle);
      render(_objectSpread$g(_objectSpread$g(_objectSpread$g({}, from), to), finalStyle));
    }
  }, "timingUpdate");
  return update3 = easing.isStepper ? stepperUpdate : timingUpdate, function() {
    return requestAnimationFrame(update3), function() {
      cancelAnimationFrame(cafId);
    };
  };
}, "configUpdate");
function _typeof$h(o) {
  "@babel/helpers - typeof";
  return _typeof$h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$h(o);
}
__name(_typeof$h, "_typeof$h");
var _excluded$5 = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function _objectWithoutProperties$5(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$5(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$5, "_objectWithoutProperties$5");
function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$5, "_objectWithoutPropertiesLoose$5");
function _toConsumableArray$3(arr) {
  return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$6(arr) || _nonIterableSpread$3();
}
__name(_toConsumableArray$3, "_toConsumableArray$3");
function _nonIterableSpread$3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$3, "_nonIterableSpread$3");
function _unsupportedIterableToArray$6(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$6(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$6(o, minLen);
  }
}
__name(_unsupportedIterableToArray$6, "_unsupportedIterableToArray$6");
function _iterableToArray$3(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$3, "_iterableToArray$3");
function _arrayWithoutHoles$3(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$6(arr);
}
__name(_arrayWithoutHoles$3, "_arrayWithoutHoles$3");
function _arrayLikeToArray$6(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$6, "_arrayLikeToArray$6");
function ownKeys$f(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$f, "ownKeys$f");
function _objectSpread$f(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$f(Object(t3), !0).forEach(function(r3) {
      _defineProperty$g(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$f(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$f, "_objectSpread$f");
function _defineProperty$g(obj2, key, value) {
  return key = _toPropertyKey$g(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$g, "_defineProperty$g");
function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$7, "_classCallCheck$7");
function _defineProperties$7(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$g(descriptor.key), descriptor);
  }
}
__name(_defineProperties$7, "_defineProperties$7");
function _createClass$7(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$7(Constructor.prototype, protoProps), staticProps && _defineProperties$7(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$7, "_createClass$7");
function _toPropertyKey$g(arg) {
  var key = _toPrimitive$g(arg, "string");
  return _typeof$h(key) === "symbol" ? key : String(key);
}
__name(_toPropertyKey$g, "_toPropertyKey$g");
function _toPrimitive$g(input, hint) {
  if (_typeof$h(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$h(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
__name(_toPrimitive$g, "_toPrimitive$g");
function _inherits$5(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$5(subClass, superClass);
}
__name(_inherits$5, "_inherits$5");
function _setPrototypeOf$5(o, p) {
  return _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$5(o, p);
}
__name(_setPrototypeOf$5, "_setPrototypeOf$5");
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
  return /* @__PURE__ */ __name(function() {
    var Super = _getPrototypeOf$5(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$5(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else
      result2 = Super.apply(this, arguments);
    return _possibleConstructorReturn$5(this, result2);
  }, "_createSuperInternal");
}
__name(_createSuper, "_createSuper");
function _possibleConstructorReturn$5(self2, call) {
  if (call && (_typeof$h(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$5(self2);
}
__name(_possibleConstructorReturn$5, "_possibleConstructorReturn$5");
function _assertThisInitialized$5(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$5, "_assertThisInitialized$5");
function _isNativeReflectConstruct$5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
__name(_isNativeReflectConstruct$5, "_isNativeReflectConstruct$5");
function _getPrototypeOf$5(o) {
  return _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$5(o);
}
__name(_getPrototypeOf$5, "_getPrototypeOf$5");
var Animate = /* @__PURE__ */ function(_PureComponent) {
  _inherits$5(Animate2, _PureComponent);
  var _super = _createSuper(Animate2);
  function Animate2(props, context) {
    var _this;
    _classCallCheck$7(this, Animate2), _this = _super.call(this, props, context);
    var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps2 = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
    if (_this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized$5(_this)), _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized$5(_this)), !isActive || duration <= 0)
      return _this.state = {
        style: {}
      }, typeof children == "function" && (_this.state = {
        style: to
      }), _possibleConstructorReturn$5(_this);
    if (steps2 && steps2.length)
      _this.state = {
        style: steps2[0].style
      };
    else if (from) {
      if (typeof children == "function")
        return _this.state = {
          style: from
        }, _possibleConstructorReturn$5(_this);
      _this.state = {
        style: attributeName ? _defineProperty$g({}, attributeName, from) : from
      };
    } else
      _this.state = {
        style: {}
      };
    return _this;
  }
  return __name(Animate2, "Animate"), _createClass$7(Animate2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function() {
      var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
      this.mounted = !0, !(!isActive || !canBegin) && this.runAnimation(this.props);
    }, "componentDidMount")
  }, {
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function(prevProps) {
      var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from, style2 = this.state.style;
      if (canBegin) {
        if (!isActive) {
          var newState = {
            style: attributeName ? _defineProperty$g({}, attributeName, to) : to
          };
          this.state && style2 && (attributeName && style2[attributeName] !== to || !attributeName && style2 !== to) && this.setState(newState);
          return;
        }
        if (!(deepEqual(prevProps.to, to) && prevProps.canBegin && prevProps.isActive)) {
          var isTriggered = !prevProps.canBegin || !prevProps.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
          if (this.state && style2) {
            var _newState = {
              style: attributeName ? _defineProperty$g({}, attributeName, from) : from
            };
            (attributeName && style2[attributeName] !== from || !attributeName && style2 !== from) && this.setState(_newState);
          }
          this.runAnimation(_objectSpread$f(_objectSpread$f({}, this.props), {}, {
            from,
            begin: 0
          }));
        }
      }
    }, "componentDidUpdate")
  }, {
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function() {
      this.mounted = !1;
      var onAnimationEnd2 = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), onAnimationEnd2 && onAnimationEnd2();
    }, "componentWillUnmount")
  }, {
    key: "handleStyleChange",
    value: /* @__PURE__ */ __name(function(style2) {
      this.changeStyle(style2);
    }, "handleStyleChange")
  }, {
    key: "changeStyle",
    value: /* @__PURE__ */ __name(function(style2) {
      this.mounted && this.setState({
        style: style2
      });
    }, "changeStyle")
  }, {
    key: "runJSAnimation",
    value: /* @__PURE__ */ __name(function(props) {
      var _this2 = this, from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd2 = props.onAnimationEnd, onAnimationStart2 = props.onAnimationStart, startAnimation = configUpdate(from, to, configEasing(easing), duration, this.changeStyle), finalStartAnimation = /* @__PURE__ */ __name(function() {
        _this2.stopJSAnimation = startAnimation();
      }, "finalStartAnimation");
      this.manager.start([onAnimationStart2, begin, finalStartAnimation, duration, onAnimationEnd2]);
    }, "runJSAnimation")
  }, {
    key: "runStepAnimation",
    value: /* @__PURE__ */ __name(function(props) {
      var _this3 = this, steps2 = props.steps, begin = props.begin, onAnimationStart2 = props.onAnimationStart, _steps$ = steps2[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration, addStyle = /* @__PURE__ */ __name(function(sequence, nextItem, index2) {
        if (index2 === 0)
          return sequence;
        var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style2 = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd2 = nextItem.onAnimationEnd, preItem = index2 > 0 ? steps2[index2 - 1] : nextItem, properties = nextProperties || Object.keys(style2);
        if (typeof easing == "function" || easing === "spring")
          return [].concat(_toConsumableArray$3(sequence), [_this3.runJSAnimation.bind(_this3, {
            from: preItem.style,
            to: style2,
            duration,
            easing
          }), duration]);
        var transition2 = getTransitionVal(properties, duration, easing), newStyle = _objectSpread$f(_objectSpread$f(_objectSpread$f({}, preItem.style), style2), {}, {
          transition: transition2
        });
        return [].concat(_toConsumableArray$3(sequence), [newStyle, duration, onAnimationEnd2]).filter(identity2);
      }, "addStyle");
      return this.manager.start([onAnimationStart2].concat(_toConsumableArray$3(steps2.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
    }, "runStepAnimation")
  }, {
    key: "runAnimation",
    value: /* @__PURE__ */ __name(function(props) {
      this.manager || (this.manager = createAnimateManager());
      var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart2 = props.onAnimationStart, onAnimationEnd2 = props.onAnimationEnd, steps2 = props.steps, children = props.children, manager = this.manager;
      if (this.unSubscribe = manager.subscribe(this.handleStyleChange), typeof easing == "function" || typeof children == "function" || easing === "spring") {
        this.runJSAnimation(props);
        return;
      }
      if (steps2.length > 1) {
        this.runStepAnimation(props);
        return;
      }
      var to = attributeName ? _defineProperty$g({}, attributeName, propsTo) : propsTo, transition2 = getTransitionVal(Object.keys(to), duration, easing);
      manager.start([onAnimationStart2, begin, _objectSpread$f(_objectSpread$f({}, to), {}, {
        transition: transition2
      }), duration, onAnimationEnd2]);
    }, "runAnimation")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this$props4 = this.props, children = _this$props4.children;
      _this$props4.begin;
      var duration = _this$props4.duration;
      _this$props4.attributeName, _this$props4.easing;
      var isActive = _this$props4.isActive;
      _this$props4.steps, _this$props4.from, _this$props4.to, _this$props4.canBegin, _this$props4.onAnimationEnd, _this$props4.shouldReAnimate, _this$props4.onAnimationReStart;
      var others = _objectWithoutProperties$5(_this$props4, _excluded$5), count = Children.count(children), stateStyle = this.state.style;
      if (typeof children == "function")
        return children(stateStyle);
      if (!isActive || count === 0 || duration <= 0)
        return children;
      var cloneContainer = /* @__PURE__ */ __name(function(container2) {
        var _container$props = container2.props, _container$props$styl = _container$props.style, style2 = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className, res = /* @__PURE__ */ cloneElement(container2, _objectSpread$f(_objectSpread$f({}, others), {}, {
          style: _objectSpread$f(_objectSpread$f({}, style2), stateStyle),
          className
        }));
        return res;
      }, "cloneContainer");
      return count === 1 ? cloneContainer(Children.only(children)) : /* @__PURE__ */ React__default.createElement("div", null, Children.map(children, function(child) {
        return cloneContainer(child);
      }));
    }, "render")
  }]), Animate2;
}(PureComponent);
Animate.displayName = "Animate";
Animate.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: /* @__PURE__ */ __name(function() {
  }, "onAnimationEnd"),
  onAnimationStart: /* @__PURE__ */ __name(function() {
  }, "onAnimationStart")
};
Animate.propTypes = {
  from: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  attributeName: PropTypes.string,
  // animation duration
  duration: PropTypes.number,
  begin: PropTypes.number,
  easing: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  steps: PropTypes.arrayOf(PropTypes.shape({
    duration: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
    easing: PropTypes.oneOfType([PropTypes.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), PropTypes.func]),
    // transition css properties(dash case), optional
    properties: PropTypes.arrayOf("string"),
    onAnimationEnd: PropTypes.func
  })),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isActive: PropTypes.bool,
  canBegin: PropTypes.bool,
  onAnimationEnd: PropTypes.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: PropTypes.bool,
  onAnimationStart: PropTypes.func,
  onAnimationReStart: PropTypes.func
};
const Animate$1 = Animate;
function _typeof$g(o) {
  "@babel/helpers - typeof";
  return _typeof$g = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$g(o);
}
__name(_typeof$g, "_typeof$g");
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$c.apply(this, arguments);
}
__name(_extends$c, "_extends$c");
function _slicedToArray$3(arr, i2) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i2) || _unsupportedIterableToArray$5(arr, i2) || _nonIterableRest$3();
}
__name(_slicedToArray$3, "_slicedToArray$3");
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$3, "_nonIterableRest$3");
function _unsupportedIterableToArray$5(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$5(o, minLen);
  }
}
__name(_unsupportedIterableToArray$5, "_unsupportedIterableToArray$5");
function _arrayLikeToArray$5(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$5, "_arrayLikeToArray$5");
function _iterableToArrayLimit$3(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$3, "_iterableToArrayLimit$3");
function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$3, "_arrayWithHoles$3");
function ownKeys$e(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$e, "ownKeys$e");
function _objectSpread$e(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$e(Object(t3), !0).forEach(function(r3) {
      _defineProperty$f(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$e(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$e, "_objectSpread$e");
function _defineProperty$f(obj2, key, value) {
  return key = _toPropertyKey$f(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$f, "_defineProperty$f");
function _toPropertyKey$f(t3) {
  var i2 = _toPrimitive$f(t3, "string");
  return _typeof$g(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$f, "_toPropertyKey$f");
function _toPrimitive$f(t3, r2) {
  if (_typeof$g(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$g(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$f, "_toPrimitive$f");
var getRectanglePath = /* @__PURE__ */ __name(function(x3, y4, width2, height2, radius) {
  var maxRadius = Math.min(Math.abs(width2) / 2, Math.abs(height2) / 2), ySign = height2 >= 0 ? 1 : -1, xSign = width2 >= 0 ? 1 : -1, clockWise = height2 >= 0 && width2 >= 0 || height2 < 0 && width2 < 0 ? 1 : 0, path;
  if (maxRadius > 0 && radius instanceof Array) {
    for (var newRadius = [0, 0, 0, 0], i2 = 0, len = 4; i2 < len; i2++)
      newRadius[i2] = radius[i2] > maxRadius ? maxRadius : radius[i2];
    path = "M".concat(x3, ",").concat(y4 + ySign * newRadius[0]), newRadius[0] > 0 && (path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x3 + xSign * newRadius[0], ",").concat(y4)), path += "L ".concat(x3 + width2 - xSign * newRadius[1], ",").concat(y4), newRadius[1] > 0 && (path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, `,
        `).concat(x3 + width2, ",").concat(y4 + ySign * newRadius[1])), path += "L ".concat(x3 + width2, ",").concat(y4 + height2 - ySign * newRadius[2]), newRadius[2] > 0 && (path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, `,
        `).concat(x3 + width2 - xSign * newRadius[2], ",").concat(y4 + height2)), path += "L ".concat(x3 + xSign * newRadius[3], ",").concat(y4 + height2), newRadius[3] > 0 && (path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, `,
        `).concat(x3, ",").concat(y4 + height2 - ySign * newRadius[3])), path += "Z";
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);
    path = "M ".concat(x3, ",").concat(y4 + ySign * _newRadius, `
            A `).concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x3 + xSign * _newRadius, ",").concat(y4, `
            L `).concat(x3 + width2 - xSign * _newRadius, ",").concat(y4, `
            A `).concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x3 + width2, ",").concat(y4 + ySign * _newRadius, `
            L `).concat(x3 + width2, ",").concat(y4 + height2 - ySign * _newRadius, `
            A `).concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x3 + width2 - xSign * _newRadius, ",").concat(y4 + height2, `
            L `).concat(x3 + xSign * _newRadius, ",").concat(y4 + height2, `
            A `).concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x3, ",").concat(y4 + height2 - ySign * _newRadius, " Z");
  } else
    path = "M ".concat(x3, ",").concat(y4, " h ").concat(width2, " v ").concat(height2, " h ").concat(-width2, " Z");
  return path;
}, "getRectanglePath"), isInRectangle = /* @__PURE__ */ __name(function(point2, rect) {
  if (!point2 || !rect)
    return !1;
  var px2 = point2.x, py2 = point2.y, x3 = rect.x, y4 = rect.y, width2 = rect.width, height2 = rect.height;
  if (Math.abs(width2) > 0 && Math.abs(height2) > 0) {
    var minX = Math.min(x3, x3 + width2), maxX = Math.max(x3, x3 + width2), minY = Math.min(y4, y4 + height2), maxY = Math.max(y4, y4 + height2);
    return px2 >= minX && px2 <= maxX && py2 >= minY && py2 <= maxY;
  }
  return !1;
}, "isInRectangle"), defaultProps$1 = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Rectangle = /* @__PURE__ */ __name(function(rectangleProps) {
  var props = _objectSpread$e(_objectSpread$e({}, defaultProps$1), rectangleProps), pathRef = useRef(), _useState = useState(-1), _useState2 = _slicedToArray$3(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
  useEffect(function() {
    if (pathRef.current && pathRef.current.getTotalLength)
      try {
        var pathTotalLength = pathRef.current.getTotalLength();
        pathTotalLength && setTotalLength(pathTotalLength);
      } catch {
      }
  }, []);
  var x3 = props.x, y4 = props.y, width2 = props.width, height2 = props.height, radius = props.radius, className = props.className, animationEasing = props.animationEasing, animationDuration2 = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
  if (x3 !== +x3 || y4 !== +y4 || width2 !== +width2 || height2 !== +height2 || width2 === 0 || height2 === 0)
    return null;
  var layerClass = clsx("recharts-rectangle", className);
  return isUpdateAnimationActive ? /* @__PURE__ */ React__default.createElement(Animate$1, {
    canBegin: totalLength > 0,
    from: {
      width: width2,
      height: height2,
      x: x3,
      y: y4
    },
    to: {
      width: width2,
      height: height2,
      x: x3,
      y: y4
    },
    duration: animationDuration2,
    animationEasing,
    isActive: isUpdateAnimationActive
  }, function(_ref) {
    var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
    return /* @__PURE__ */ React__default.createElement(Animate$1, {
      canBegin: totalLength > 0,
      from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
      to: "".concat(totalLength, "px 0px"),
      attributeName: "strokeDasharray",
      begin: animationBegin,
      duration: animationDuration2,
      isActive: isAnimationActive,
      easing: animationEasing
    }, /* @__PURE__ */ React__default.createElement("path", _extends$c({}, filterProps(props, !0), {
      className: layerClass,
      d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
      ref: pathRef
    })));
  }) : /* @__PURE__ */ React__default.createElement("path", _extends$c({}, filterProps(props, !0), {
    className: layerClass,
    d: getRectanglePath(x3, y4, width2, height2, radius)
  }));
}, "Rectangle"), _excluded$4 = ["points", "className", "baseLinePoints", "connectNulls"];
function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$b.apply(this, arguments);
}
__name(_extends$b, "_extends$b");
function _objectWithoutProperties$4(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$4(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$4, "_objectWithoutProperties$4");
function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$4, "_objectWithoutPropertiesLoose$4");
function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread$2();
}
__name(_toConsumableArray$2, "_toConsumableArray$2");
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$2, "_nonIterableSpread$2");
function _unsupportedIterableToArray$4(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$4(o, minLen);
  }
}
__name(_unsupportedIterableToArray$4, "_unsupportedIterableToArray$4");
function _iterableToArray$2(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$2, "_iterableToArray$2");
function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$4(arr);
}
__name(_arrayWithoutHoles$2, "_arrayWithoutHoles$2");
function _arrayLikeToArray$4(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$4, "_arrayLikeToArray$4");
var isValidatePoint = /* @__PURE__ */ __name(function(point2) {
  return point2 && point2.x === +point2.x && point2.y === +point2.y;
}, "isValidatePoint"), getParsedPoints = /* @__PURE__ */ __name(function() {
  var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], segmentPoints = [[]];
  return points.forEach(function(entry) {
    isValidatePoint(entry) ? segmentPoints[segmentPoints.length - 1].push(entry) : segmentPoints[segmentPoints.length - 1].length > 0 && segmentPoints.push([]);
  }), isValidatePoint(points[0]) && segmentPoints[segmentPoints.length - 1].push(points[0]), segmentPoints[segmentPoints.length - 1].length <= 0 && (segmentPoints = segmentPoints.slice(0, -1)), segmentPoints;
}, "getParsedPoints"), getSinglePolygonPath = /* @__PURE__ */ __name(function(points, connectNulls) {
  var segmentPoints = getParsedPoints(points);
  connectNulls && (segmentPoints = [segmentPoints.reduce(function(res, segPoints) {
    return [].concat(_toConsumableArray$2(res), _toConsumableArray$2(segPoints));
  }, [])]);
  var polygonPath = segmentPoints.map(function(segPoints) {
    return segPoints.reduce(function(path, point2, index2) {
      return "".concat(path).concat(index2 === 0 ? "M" : "L").concat(point2.x, ",").concat(point2.y);
    }, "");
  }).join("");
  return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
}, "getSinglePolygonPath"), getRanglePath = /* @__PURE__ */ __name(function(points, baseLinePoints, connectNulls) {
  var outerPath = getSinglePolygonPath(points, connectNulls);
  return "".concat(outerPath.slice(-1) === "Z" ? outerPath.slice(0, -1) : outerPath, "L").concat(getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
}, "getRanglePath"), Polygon = /* @__PURE__ */ __name(function(props) {
  var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = _objectWithoutProperties$4(props, _excluded$4);
  if (!points || !points.length)
    return null;
  var layerClass = clsx("recharts-polygon", className);
  if (baseLinePoints && baseLinePoints.length) {
    var hasStroke = others.stroke && others.stroke !== "none", rangePath = getRanglePath(points, baseLinePoints, connectNulls);
    return /* @__PURE__ */ React__default.createElement("g", {
      className: layerClass
    }, /* @__PURE__ */ React__default.createElement("path", _extends$b({}, filterProps(others, !0), {
      fill: rangePath.slice(-1) === "Z" ? others.fill : "none",
      stroke: "none",
      d: rangePath
    })), hasStroke ? /* @__PURE__ */ React__default.createElement("path", _extends$b({}, filterProps(others, !0), {
      fill: "none",
      d: getSinglePolygonPath(points, connectNulls)
    })) : null, hasStroke ? /* @__PURE__ */ React__default.createElement("path", _extends$b({}, filterProps(others, !0), {
      fill: "none",
      d: getSinglePolygonPath(baseLinePoints, connectNulls)
    })) : null);
  }
  var singlePath = getSinglePolygonPath(points, connectNulls);
  return /* @__PURE__ */ React__default.createElement("path", _extends$b({}, filterProps(others, !0), {
    fill: singlePath.slice(-1) === "Z" ? others.fill : "none",
    className: layerClass,
    d: singlePath
  }));
}, "Polygon");
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$a.apply(this, arguments);
}
__name(_extends$a, "_extends$a");
var Dot = /* @__PURE__ */ __name(function(props) {
  var cx = props.cx, cy = props.cy, r2 = props.r, className = props.className, layerClass = clsx("recharts-dot", className);
  return cx === +cx && cy === +cy && r2 === +r2 ? /* @__PURE__ */ React__default.createElement("circle", _extends$a({}, filterProps(props, !1), adaptEventHandlers(props), {
    className: layerClass,
    cx,
    cy,
    r: r2
  })) : null;
}, "Dot");
function _typeof$f(o) {
  "@babel/helpers - typeof";
  return _typeof$f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$f(o);
}
__name(_typeof$f, "_typeof$f");
var _excluded$3 = ["x", "y", "top", "left", "width", "height", "className"];
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$9.apply(this, arguments);
}
__name(_extends$9, "_extends$9");
function ownKeys$d(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$d, "ownKeys$d");
function _objectSpread$d(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$d(Object(t3), !0).forEach(function(r3) {
      _defineProperty$e(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$d(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$d, "_objectSpread$d");
function _defineProperty$e(obj2, key, value) {
  return key = _toPropertyKey$e(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$e, "_defineProperty$e");
function _toPropertyKey$e(t3) {
  var i2 = _toPrimitive$e(t3, "string");
  return _typeof$f(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$e, "_toPropertyKey$e");
function _toPrimitive$e(t3, r2) {
  if (_typeof$f(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$f(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$e, "_toPrimitive$e");
function _objectWithoutProperties$3(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$3, "_objectWithoutProperties$3");
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$3, "_objectWithoutPropertiesLoose$3");
var getPath2 = /* @__PURE__ */ __name(function(x3, y4, width2, height2, top2, left2) {
  return "M".concat(x3, ",").concat(top2, "v").concat(height2, "M").concat(left2, ",").concat(y4, "h").concat(width2);
}, "getPath"), Cross = /* @__PURE__ */ __name(function(_ref) {
  var _ref$x = _ref.x, x3 = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y4 = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top2 = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left2 = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width2 = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height2 = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = _objectWithoutProperties$3(_ref, _excluded$3), props = _objectSpread$d({
    x: x3,
    y: y4,
    top: top2,
    left: left2,
    width: width2,
    height: height2
  }, rest);
  return !isNumber(x3) || !isNumber(y4) || !isNumber(width2) || !isNumber(height2) || !isNumber(top2) || !isNumber(left2) ? null : /* @__PURE__ */ React__default.createElement("path", _extends$9({}, filterProps(props, !0), {
    className: clsx("recharts-cross", className),
    d: getPath2(x3, y4, width2, height2, top2, left2)
  }));
}, "Cross"), baseExtremum$1 = _baseExtremum, baseGt = _baseGt, baseIteratee$4 = _baseIteratee;
function maxBy(array2, iteratee) {
  return array2 && array2.length ? baseExtremum$1(array2, baseIteratee$4(iteratee), baseGt) : void 0;
}
__name(maxBy, "maxBy");
var maxBy_1 = maxBy;
const maxBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(maxBy_1);
var baseExtremum = _baseExtremum, baseIteratee$3 = _baseIteratee, baseLt = _baseLt;
function minBy(array2, iteratee) {
  return array2 && array2.length ? baseExtremum(array2, baseIteratee$3(iteratee), baseLt) : void 0;
}
__name(minBy, "minBy");
var minBy_1 = minBy;
const minBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(minBy_1);
var _excluded$2 = ["cx", "cy", "angle", "ticks", "axisLine"], _excluded2$1 = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function _typeof$e(o) {
  "@babel/helpers - typeof";
  return _typeof$e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$e(o);
}
__name(_typeof$e, "_typeof$e");
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$8.apply(this, arguments);
}
__name(_extends$8, "_extends$8");
function ownKeys$c(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$c, "ownKeys$c");
function _objectSpread$c(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$c(Object(t3), !0).forEach(function(r3) {
      _defineProperty$d(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$c(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$c, "_objectSpread$c");
function _objectWithoutProperties$2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$2, "_objectWithoutProperties$2");
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$2, "_objectWithoutPropertiesLoose$2");
function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$6, "_classCallCheck$6");
function _defineProperties$6(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$d(descriptor.key), descriptor);
  }
}
__name(_defineProperties$6, "_defineProperties$6");
function _createClass$6(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$6(Constructor.prototype, protoProps), staticProps && _defineProperties$6(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$6, "_createClass$6");
function _callSuper$4(t3, o, e3) {
  return o = _getPrototypeOf$4(o), _possibleConstructorReturn$4(t3, _isNativeReflectConstruct$4() ? Reflect.construct(o, e3 || [], _getPrototypeOf$4(t3).constructor) : o.apply(t3, e3));
}
__name(_callSuper$4, "_callSuper$4");
function _possibleConstructorReturn$4(self2, call) {
  if (call && (_typeof$e(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$4(self2);
}
__name(_possibleConstructorReturn$4, "_possibleConstructorReturn$4");
function _assertThisInitialized$4(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$4, "_assertThisInitialized$4");
function _isNativeReflectConstruct$4() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$4 = /* @__PURE__ */ __name(function() {
    return !!t3;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct$4, "_isNativeReflectConstruct$4");
function _getPrototypeOf$4(o) {
  return _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$4(o);
}
__name(_getPrototypeOf$4, "_getPrototypeOf$4");
function _inherits$4(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$4(subClass, superClass);
}
__name(_inherits$4, "_inherits$4");
function _setPrototypeOf$4(o, p) {
  return _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$4(o, p);
}
__name(_setPrototypeOf$4, "_setPrototypeOf$4");
function _defineProperty$d(obj2, key, value) {
  return key = _toPropertyKey$d(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$d, "_defineProperty$d");
function _toPropertyKey$d(t3) {
  var i2 = _toPrimitive$d(t3, "string");
  return _typeof$e(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$d, "_toPropertyKey$d");
function _toPrimitive$d(t3, r2) {
  if (_typeof$e(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$e(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$d, "_toPrimitive$d");
var PolarRadiusAxis = /* @__PURE__ */ function(_PureComponent) {
  _inherits$4(PolarRadiusAxis2, _PureComponent);
  function PolarRadiusAxis2() {
    return _classCallCheck$6(this, PolarRadiusAxis2), _callSuper$4(this, PolarRadiusAxis2, arguments);
  }
  return __name(PolarRadiusAxis2, "PolarRadiusAxis"), _createClass$6(PolarRadiusAxis2, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      /* @__PURE__ */ __name(function(_ref) {
        var coordinate = _ref.coordinate, _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
        return polarToCartesian(cx, cy, coordinate, angle);
      }, "getTickValueCoord")
    )
  }, {
    key: "getTickTextAnchor",
    value: /* @__PURE__ */ __name(function() {
      var orientation = this.props.orientation, textAnchor;
      switch (orientation) {
        case "left":
          textAnchor = "end";
          break;
        case "right":
          textAnchor = "start";
          break;
        default:
          textAnchor = "middle";
          break;
      }
      return textAnchor;
    }, "getTickTextAnchor")
  }, {
    key: "getViewBox",
    value: /* @__PURE__ */ __name(function() {
      var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks2 = _this$props2.ticks, maxRadiusTick = maxBy$1(ticks2, function(entry) {
        return entry.coordinate || 0;
      }), minRadiusTick = minBy$1(ticks2, function(entry) {
        return entry.coordinate || 0;
      });
      return {
        cx,
        cy,
        startAngle: angle,
        endAngle: angle,
        innerRadius: minRadiusTick.coordinate || 0,
        outerRadius: maxRadiusTick.coordinate || 0
      };
    }, "getViewBox")
  }, {
    key: "renderAxisLine",
    value: /* @__PURE__ */ __name(function() {
      var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks2 = _this$props3.ticks, axisLine = _this$props3.axisLine, others = _objectWithoutProperties$2(_this$props3, _excluded$2), extent = ticks2.reduce(function(result2, entry) {
        return [Math.min(result2[0], entry.coordinate), Math.max(result2[1], entry.coordinate)];
      }, [1 / 0, -1 / 0]), point0 = polarToCartesian(cx, cy, extent[0], angle), point1 = polarToCartesian(cx, cy, extent[1], angle), props = _objectSpread$c(_objectSpread$c(_objectSpread$c({}, filterProps(others, !1)), {}, {
        fill: "none"
      }, filterProps(axisLine, !1)), {}, {
        x1: point0.x,
        y1: point0.y,
        x2: point1.x,
        y2: point1.y
      });
      return /* @__PURE__ */ React__default.createElement("line", _extends$8({
        className: "recharts-polar-radius-axis-line"
      }, props));
    }, "renderAxisLine")
  }, {
    key: "renderTicks",
    value: /* @__PURE__ */ __name(function() {
      var _this = this, _this$props4 = this.props, ticks2 = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke2 = _this$props4.stroke, others = _objectWithoutProperties$2(_this$props4, _excluded2$1), textAnchor = this.getTickTextAnchor(), axisProps = filterProps(others, !1), customTickProps = filterProps(tick, !1), items = ticks2.map(function(entry, i2) {
        var coord = _this.getTickValueCoord(entry), tickProps = _objectSpread$c(_objectSpread$c(_objectSpread$c(_objectSpread$c({
          textAnchor,
          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
        }, axisProps), {}, {
          stroke: "none",
          fill: stroke2
        }, customTickProps), {}, {
          index: i2
        }, coord), {}, {
          payload: entry
        });
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$8({
          className: clsx("recharts-polar-radius-axis-tick", getTickClassName(tick)),
          key: "tick-".concat(entry.coordinate)
        }, adaptEventsOfChild(_this.props, entry, i2)), PolarRadiusAxis2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i2) : entry.value));
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-polar-radius-axis-ticks"
      }, items);
    }, "renderTicks")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this$props5 = this.props, ticks2 = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
      return !ticks2 || !ticks2.length ? null : /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-polar-radius-axis", this.props.className)
      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), Label.renderCallByParent(this.props, this.getViewBox()));
    }, "render")
  }], [{
    key: "renderTickItem",
    value: /* @__PURE__ */ __name(function(option, props, value) {
      var tickItem;
      return /* @__PURE__ */ React__default.isValidElement(option) ? tickItem = /* @__PURE__ */ React__default.cloneElement(option, props) : isFunction$3(option) ? tickItem = option(props) : tickItem = /* @__PURE__ */ React__default.createElement(Text, _extends$8({}, props, {
        className: "recharts-polar-radius-axis-tick-value"
      }), value), tickItem;
    }, "renderTickItem")
  }]), PolarRadiusAxis2;
}(PureComponent);
_defineProperty$d(PolarRadiusAxis, "displayName", "PolarRadiusAxis");
_defineProperty$d(PolarRadiusAxis, "axisType", "radiusAxis");
_defineProperty$d(PolarRadiusAxis, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function _typeof$d(o) {
  "@babel/helpers - typeof";
  return _typeof$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$d(o);
}
__name(_typeof$d, "_typeof$d");
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$7.apply(this, arguments);
}
__name(_extends$7, "_extends$7");
function ownKeys$b(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$b, "ownKeys$b");
function _objectSpread$b(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$b(Object(t3), !0).forEach(function(r3) {
      _defineProperty$c(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$b(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$b, "_objectSpread$b");
function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$5, "_classCallCheck$5");
function _defineProperties$5(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$c(descriptor.key), descriptor);
  }
}
__name(_defineProperties$5, "_defineProperties$5");
function _createClass$5(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$5(Constructor.prototype, protoProps), staticProps && _defineProperties$5(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$5, "_createClass$5");
function _callSuper$3(t3, o, e3) {
  return o = _getPrototypeOf$3(o), _possibleConstructorReturn$3(t3, _isNativeReflectConstruct$3() ? Reflect.construct(o, e3 || [], _getPrototypeOf$3(t3).constructor) : o.apply(t3, e3));
}
__name(_callSuper$3, "_callSuper$3");
function _possibleConstructorReturn$3(self2, call) {
  if (call && (_typeof$d(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$3(self2);
}
__name(_possibleConstructorReturn$3, "_possibleConstructorReturn$3");
function _assertThisInitialized$3(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$3, "_assertThisInitialized$3");
function _isNativeReflectConstruct$3() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$3 = /* @__PURE__ */ __name(function() {
    return !!t3;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct$3, "_isNativeReflectConstruct$3");
function _getPrototypeOf$3(o) {
  return _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$3(o);
}
__name(_getPrototypeOf$3, "_getPrototypeOf$3");
function _inherits$3(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$3(subClass, superClass);
}
__name(_inherits$3, "_inherits$3");
function _setPrototypeOf$3(o, p) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$3(o, p);
}
__name(_setPrototypeOf$3, "_setPrototypeOf$3");
function _defineProperty$c(obj2, key, value) {
  return key = _toPropertyKey$c(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$c, "_defineProperty$c");
function _toPropertyKey$c(t3) {
  var i2 = _toPrimitive$c(t3, "string");
  return _typeof$d(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$c, "_toPropertyKey$c");
function _toPrimitive$c(t3, r2) {
  if (_typeof$d(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$d(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$c, "_toPrimitive$c");
var RADIAN = Math.PI / 180, eps = 1e-5, PolarAngleAxis = /* @__PURE__ */ function(_PureComponent) {
  _inherits$3(PolarAngleAxis2, _PureComponent);
  function PolarAngleAxis2() {
    return _classCallCheck$5(this, PolarAngleAxis2), _callSuper$3(this, PolarAngleAxis2, arguments);
  }
  return __name(PolarAngleAxis2, "PolarAngleAxis"), _createClass$5(PolarAngleAxis2, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      /* @__PURE__ */ __name(function(data2) {
        var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize, tickLineSize = tickSize || 8, p1 = polarToCartesian(cx, cy, radius, data2.coordinate), p2 = polarToCartesian(cx, cy, radius + (orientation === "inner" ? -1 : 1) * tickLineSize, data2.coordinate);
        return {
          x1: p1.x,
          y1: p1.y,
          x2: p2.x,
          y2: p2.y
        };
      }, "getTickLineCoord")
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: /* @__PURE__ */ __name(function(data2) {
      var orientation = this.props.orientation, cos2 = Math.cos(-data2.coordinate * RADIAN), textAnchor;
      return cos2 > eps ? textAnchor = orientation === "outer" ? "start" : "end" : cos2 < -eps ? textAnchor = orientation === "outer" ? "end" : "start" : textAnchor = "middle", textAnchor;
    }, "getTickTextAnchor")
  }, {
    key: "renderAxisLine",
    value: /* @__PURE__ */ __name(function() {
      var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType, props = _objectSpread$b(_objectSpread$b({}, filterProps(this.props, !1)), {}, {
        fill: "none"
      }, filterProps(axisLine, !1));
      if (axisLineType === "circle")
        return /* @__PURE__ */ React__default.createElement(Dot, _extends$7({
          className: "recharts-polar-angle-axis-line"
        }, props, {
          cx,
          cy,
          r: radius
        }));
      var ticks2 = this.props.ticks, points = ticks2.map(function(entry) {
        return polarToCartesian(cx, cy, radius, entry.coordinate);
      });
      return /* @__PURE__ */ React__default.createElement(Polygon, _extends$7({
        className: "recharts-polar-angle-axis-line"
      }, props, {
        points
      }));
    }, "renderAxisLine")
  }, {
    key: "renderTicks",
    value: /* @__PURE__ */ __name(function() {
      var _this = this, _this$props3 = this.props, ticks2 = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke2 = _this$props3.stroke, axisProps = filterProps(this.props, !1), customTickProps = filterProps(tick, !1), tickLineProps = _objectSpread$b(_objectSpread$b({}, axisProps), {}, {
        fill: "none"
      }, filterProps(tickLine, !1)), items = ticks2.map(function(entry, i2) {
        var lineCoord = _this.getTickLineCoord(entry), textAnchor = _this.getTickTextAnchor(entry), tickProps = _objectSpread$b(_objectSpread$b(_objectSpread$b({
          textAnchor
        }, axisProps), {}, {
          stroke: "none",
          fill: stroke2
        }, customTickProps), {}, {
          index: i2,
          payload: entry,
          x: lineCoord.x2,
          y: lineCoord.y2
        });
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$7({
          className: clsx("recharts-polar-angle-axis-tick", getTickClassName(tick)),
          key: "tick-".concat(entry.coordinate)
        }, adaptEventsOfChild(_this.props, entry, i2)), tickLine && /* @__PURE__ */ React__default.createElement("line", _extends$7({
          className: "recharts-polar-angle-axis-tick-line"
        }, tickLineProps, lineCoord)), tick && PolarAngleAxis2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i2) : entry.value));
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-polar-angle-axis-ticks"
      }, items);
    }, "renderTicks")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this$props4 = this.props, ticks2 = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
      return radius <= 0 || !ticks2 || !ticks2.length ? null : /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-polar-angle-axis", this.props.className)
      }, axisLine && this.renderAxisLine(), this.renderTicks());
    }, "render")
  }], [{
    key: "renderTickItem",
    value: /* @__PURE__ */ __name(function(option, props, value) {
      var tickItem;
      return /* @__PURE__ */ React__default.isValidElement(option) ? tickItem = /* @__PURE__ */ React__default.cloneElement(option, props) : isFunction$3(option) ? tickItem = option(props) : tickItem = /* @__PURE__ */ React__default.createElement(Text, _extends$7({}, props, {
        className: "recharts-polar-angle-axis-tick-value"
      }), value), tickItem;
    }, "renderTickItem")
  }]), PolarAngleAxis2;
}(PureComponent);
_defineProperty$c(PolarAngleAxis, "displayName", "PolarAngleAxis");
_defineProperty$c(PolarAngleAxis, "axisType", "angleAxis");
_defineProperty$c(PolarAngleAxis, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var overArg = _overArg, getPrototype$1 = overArg(Object.getPrototypeOf, Object), _getPrototype = getPrototype$1, baseGetTag$1 = _baseGetTag, getPrototype = _getPrototype, isObjectLike$1 = isObjectLike_1, objectTag = "[object Object]", funcProto = Function.prototype, objectProto = Object.prototype, funcToString = funcProto.toString, hasOwnProperty = objectProto.hasOwnProperty, objectCtorString = funcToString.call(Object);
function isPlainObject2(value) {
  if (!isObjectLike$1(value) || baseGetTag$1(value) != objectTag)
    return !1;
  var proto = getPrototype(value);
  if (proto === null)
    return !0;
  var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
__name(isPlainObject2, "isPlainObject");
var isPlainObject_1 = isPlainObject2;
const isPlainObject$1 = /* @__PURE__ */ getDefaultExportFromCjs(isPlainObject_1);
var baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1, boolTag = "[object Boolean]";
function isBoolean(value) {
  return value === !0 || value === !1 || isObjectLike(value) && baseGetTag(value) == boolTag;
}
__name(isBoolean, "isBoolean");
var isBoolean_1 = isBoolean;
const isBoolean$1 = /* @__PURE__ */ getDefaultExportFromCjs(isBoolean_1);
function _typeof$c(o) {
  "@babel/helpers - typeof";
  return _typeof$c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$c(o);
}
__name(_typeof$c, "_typeof$c");
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$6.apply(this, arguments);
}
__name(_extends$6, "_extends$6");
function _slicedToArray$2(arr, i2) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i2) || _unsupportedIterableToArray$3(arr, i2) || _nonIterableRest$2();
}
__name(_slicedToArray$2, "_slicedToArray$2");
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$2, "_nonIterableRest$2");
function _unsupportedIterableToArray$3(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$3(o, minLen);
  }
}
__name(_unsupportedIterableToArray$3, "_unsupportedIterableToArray$3");
function _arrayLikeToArray$3(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$3, "_arrayLikeToArray$3");
function _iterableToArrayLimit$2(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$2, "_iterableToArrayLimit$2");
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$2, "_arrayWithHoles$2");
function ownKeys$a(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$a, "ownKeys$a");
function _objectSpread$a(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$a(Object(t3), !0).forEach(function(r3) {
      _defineProperty$b(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$a(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$a, "_objectSpread$a");
function _defineProperty$b(obj2, key, value) {
  return key = _toPropertyKey$b(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$b, "_defineProperty$b");
function _toPropertyKey$b(t3) {
  var i2 = _toPrimitive$b(t3, "string");
  return _typeof$c(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$b, "_toPropertyKey$b");
function _toPrimitive$b(t3, r2) {
  if (_typeof$c(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$c(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$b, "_toPrimitive$b");
var getTrapezoidPath = /* @__PURE__ */ __name(function(x3, y4, upperWidth, lowerWidth, height2) {
  var widthGap = upperWidth - lowerWidth, path;
  return path = "M ".concat(x3, ",").concat(y4), path += "L ".concat(x3 + upperWidth, ",").concat(y4), path += "L ".concat(x3 + upperWidth - widthGap / 2, ",").concat(y4 + height2), path += "L ".concat(x3 + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y4 + height2), path += "L ".concat(x3, ",").concat(y4, " Z"), path;
}, "getTrapezoidPath"), defaultProps = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Trapezoid = /* @__PURE__ */ __name(function(props) {
  var trapezoidProps = _objectSpread$a(_objectSpread$a({}, defaultProps), props), pathRef = useRef(), _useState = useState(-1), _useState2 = _slicedToArray$2(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
  useEffect(function() {
    if (pathRef.current && pathRef.current.getTotalLength)
      try {
        var pathTotalLength = pathRef.current.getTotalLength();
        pathTotalLength && setTotalLength(pathTotalLength);
      } catch {
      }
  }, []);
  var x3 = trapezoidProps.x, y4 = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height2 = trapezoidProps.height, className = trapezoidProps.className, animationEasing = trapezoidProps.animationEasing, animationDuration2 = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
  if (x3 !== +x3 || y4 !== +y4 || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height2 !== +height2 || upperWidth === 0 && lowerWidth === 0 || height2 === 0)
    return null;
  var layerClass = clsx("recharts-trapezoid", className);
  return isUpdateAnimationActive ? /* @__PURE__ */ React__default.createElement(Animate$1, {
    canBegin: totalLength > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: height2,
      x: x3,
      y: y4
    },
    to: {
      upperWidth,
      lowerWidth,
      height: height2,
      x: x3,
      y: y4
    },
    duration: animationDuration2,
    animationEasing,
    isActive: isUpdateAnimationActive
  }, function(_ref) {
    var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
    return /* @__PURE__ */ React__default.createElement(Animate$1, {
      canBegin: totalLength > 0,
      from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
      to: "".concat(totalLength, "px 0px"),
      attributeName: "strokeDasharray",
      begin: animationBegin,
      duration: animationDuration2,
      easing: animationEasing
    }, /* @__PURE__ */ React__default.createElement("path", _extends$6({}, filterProps(trapezoidProps, !0), {
      className: layerClass,
      d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
      ref: pathRef
    })));
  }) : /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement("path", _extends$6({}, filterProps(trapezoidProps, !0), {
    className: layerClass,
    d: getTrapezoidPath(x3, y4, upperWidth, lowerWidth, height2)
  })));
}, "Trapezoid"), _excluded$1 = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function _typeof$b(o) {
  "@babel/helpers - typeof";
  return _typeof$b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$b(o);
}
__name(_typeof$b, "_typeof$b");
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties$1, "_objectWithoutProperties$1");
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose$1, "_objectWithoutPropertiesLoose$1");
function ownKeys$9(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$9, "ownKeys$9");
function _objectSpread$9(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$9(Object(t3), !0).forEach(function(r3) {
      _defineProperty$a(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$9(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$9, "_objectSpread$9");
function _defineProperty$a(obj2, key, value) {
  return key = _toPropertyKey$a(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$a, "_defineProperty$a");
function _toPropertyKey$a(t3) {
  var i2 = _toPrimitive$a(t3, "string");
  return _typeof$b(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$a, "_toPropertyKey$a");
function _toPrimitive$a(t3, r2) {
  if (_typeof$b(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$b(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$a, "_toPrimitive$a");
function defaultPropTransformer(option, props) {
  return _objectSpread$9(_objectSpread$9({}, props), option);
}
__name(defaultPropTransformer, "defaultPropTransformer");
function isSymbolsProps(shapeType, _elementProps) {
  return shapeType === "symbols";
}
__name(isSymbolsProps, "isSymbolsProps");
function ShapeSelector(_ref) {
  var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
  switch (shapeType) {
    case "rectangle":
      return /* @__PURE__ */ React__default.createElement(Rectangle, elementProps);
    case "trapezoid":
      return /* @__PURE__ */ React__default.createElement(Trapezoid, elementProps);
    case "sector":
      return /* @__PURE__ */ React__default.createElement(Sector, elementProps);
    case "symbols":
      if (isSymbolsProps(shapeType))
        return /* @__PURE__ */ React__default.createElement(Symbols, elementProps);
      break;
    default:
      return null;
  }
}
__name(ShapeSelector, "ShapeSelector");
function getPropsFromShapeOption(option) {
  return /* @__PURE__ */ isValidElement(option) ? option.props : option;
}
__name(getPropsFromShapeOption, "getPropsFromShapeOption");
function Shape(_ref2) {
  var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? "recharts-active-shape" : _ref2$activeClassName, isActive = _ref2.isActive, props = _objectWithoutProperties$1(_ref2, _excluded$1), shape;
  if (/* @__PURE__ */ isValidElement(option))
    shape = /* @__PURE__ */ cloneElement(option, _objectSpread$9(_objectSpread$9({}, props), getPropsFromShapeOption(option)));
  else if (isFunction$3(option))
    shape = option(props);
  else if (isPlainObject$1(option) && !isBoolean$1(option)) {
    var nextProps = propTransformer(option, props);
    shape = /* @__PURE__ */ React__default.createElement(ShapeSelector, {
      shapeType,
      elementProps: nextProps
    });
  } else {
    var elementProps = props;
    shape = /* @__PURE__ */ React__default.createElement(ShapeSelector, {
      shapeType,
      elementProps
    });
  }
  return isActive ? /* @__PURE__ */ React__default.createElement(Layer, {
    className: activeClassName
  }, shape) : shape;
}
__name(Shape, "Shape");
function isFunnel(graphicalItem, _item) {
  return _item != null && "trapezoids" in graphicalItem.props;
}
__name(isFunnel, "isFunnel");
function isPie(graphicalItem, _item) {
  return _item != null && "sectors" in graphicalItem.props;
}
__name(isPie, "isPie");
function isScatter(graphicalItem, _item) {
  return _item != null && "points" in graphicalItem.props;
}
__name(isScatter, "isScatter");
function compareFunnel(shapeData, activeTooltipItem) {
  var _activeTooltipItem$la, _activeTooltipItem$la2, xMatches = shapeData.x === (activeTooltipItem == null || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x, yMatches = shapeData.y === (activeTooltipItem == null || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
  return xMatches && yMatches;
}
__name(compareFunnel, "compareFunnel");
function comparePie(shapeData, activeTooltipItem) {
  var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle, endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
  return startAngleMatches && endAngleMatches;
}
__name(comparePie, "comparePie");
function compareScatter(shapeData, activeTooltipItem) {
  var xMatches = shapeData.x === activeTooltipItem.x, yMatches = shapeData.y === activeTooltipItem.y, zMatches = shapeData.z === activeTooltipItem.z;
  return xMatches && yMatches && zMatches;
}
__name(compareScatter, "compareScatter");
function getComparisonFn(graphicalItem, activeItem) {
  var comparison;
  return isFunnel(graphicalItem, activeItem) ? comparison = compareFunnel : isPie(graphicalItem, activeItem) ? comparison = comparePie : isScatter(graphicalItem, activeItem) && (comparison = compareScatter), comparison;
}
__name(getComparisonFn, "getComparisonFn");
function getShapeDataKey(graphicalItem, activeItem) {
  var shapeKey;
  return isFunnel(graphicalItem, activeItem) ? shapeKey = "trapezoids" : isPie(graphicalItem, activeItem) ? shapeKey = "sectors" : isScatter(graphicalItem, activeItem) && (shapeKey = "points"), shapeKey;
}
__name(getShapeDataKey, "getShapeDataKey");
function getActiveShapeTooltipPayload(graphicalItem, activeItem) {
  if (isFunnel(graphicalItem, activeItem)) {
    var _activeItem$tooltipPa;
    return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
  }
  if (isPie(graphicalItem, activeItem)) {
    var _activeItem$tooltipPa2;
    return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
  }
  return isScatter(graphicalItem, activeItem) ? activeItem.payload : {};
}
__name(getActiveShapeTooltipPayload, "getActiveShapeTooltipPayload");
function getActiveShapeIndexForTooltip(_ref3) {
  var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData, shapeKey = getShapeDataKey(graphicalItem, activeTooltipItem), tooltipPayload = getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem), activeItemMatches = itemData.filter(function(datum, dataIndex) {
    var valuesMatch = isEqual$1(tooltipPayload, datum), mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
      var comparison = getComparisonFn(graphicalItem, activeTooltipItem);
      return comparison(shapeData, activeTooltipItem);
    }), indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]), coordinatesMatch = dataIndex === indexOfMouseCoordinates;
    return valuesMatch && coordinatesMatch;
  }), activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
  return activeIndex;
}
__name(getActiveShapeIndexForTooltip, "getActiveShapeIndexForTooltip");
var _Pie;
function _typeof$a(o) {
  "@babel/helpers - typeof";
  return _typeof$a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$a(o);
}
__name(_typeof$a, "_typeof$a");
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$5.apply(this, arguments);
}
__name(_extends$5, "_extends$5");
function ownKeys$8(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$8, "ownKeys$8");
function _objectSpread$8(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$8(Object(t3), !0).forEach(function(r3) {
      _defineProperty$9(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$8(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$8, "_objectSpread$8");
function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$4, "_classCallCheck$4");
function _defineProperties$4(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$9(descriptor.key), descriptor);
  }
}
__name(_defineProperties$4, "_defineProperties$4");
function _createClass$4(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$4(Constructor.prototype, protoProps), staticProps && _defineProperties$4(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$4, "_createClass$4");
function _callSuper$2(t3, o, e3) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t3, _isNativeReflectConstruct$2() ? Reflect.construct(o, e3 || [], _getPrototypeOf$2(t3).constructor) : o.apply(t3, e3));
}
__name(_callSuper$2, "_callSuper$2");
function _possibleConstructorReturn$2(self2, call) {
  if (call && (_typeof$a(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(self2);
}
__name(_possibleConstructorReturn$2, "_possibleConstructorReturn$2");
function _isNativeReflectConstruct$2() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$2 = /* @__PURE__ */ __name(function() {
    return !!t3;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct$2, "_isNativeReflectConstruct$2");
function _getPrototypeOf$2(o) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$2(o);
}
__name(_getPrototypeOf$2, "_getPrototypeOf$2");
function _assertThisInitialized$2(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$2, "_assertThisInitialized$2");
function _inherits$2(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$2(subClass, superClass);
}
__name(_inherits$2, "_inherits$2");
function _setPrototypeOf$2(o, p) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$2(o, p);
}
__name(_setPrototypeOf$2, "_setPrototypeOf$2");
function _defineProperty$9(obj2, key, value) {
  return key = _toPropertyKey$9(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$9, "_defineProperty$9");
function _toPropertyKey$9(t3) {
  var i2 = _toPrimitive$9(t3, "string");
  return _typeof$a(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$9, "_toPropertyKey$9");
function _toPrimitive$9(t3, r2) {
  if (_typeof$a(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$a(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$9, "_toPrimitive$9");
var Pie = /* @__PURE__ */ function(_PureComponent) {
  _inherits$2(Pie2, _PureComponent);
  function Pie2(props) {
    var _this;
    return _classCallCheck$4(this, Pie2), _this = _callSuper$2(this, Pie2, [props]), _defineProperty$9(_assertThisInitialized$2(_this), "pieRef", null), _defineProperty$9(_assertThisInitialized$2(_this), "sectorRefs", []), _defineProperty$9(_assertThisInitialized$2(_this), "id", uniqueId("recharts-pie-")), _defineProperty$9(_assertThisInitialized$2(_this), "handleAnimationEnd", function() {
      var onAnimationEnd2 = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: !0
      }), isFunction$3(onAnimationEnd2) && onAnimationEnd2();
    }), _defineProperty$9(_assertThisInitialized$2(_this), "handleAnimationStart", function() {
      var onAnimationStart2 = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: !1
      }), isFunction$3(onAnimationStart2) && onAnimationStart2();
    }), _this.state = {
      isAnimationFinished: !props.isAnimationActive,
      prevIsAnimationActive: props.isAnimationActive,
      prevAnimationId: props.animationId,
      sectorToFocus: 0
    }, _this;
  }
  return __name(Pie2, "Pie"), _createClass$4(Pie2, [{
    key: "isActiveIndex",
    value: /* @__PURE__ */ __name(function(i2) {
      var activeIndex = this.props.activeIndex;
      return Array.isArray(activeIndex) ? activeIndex.indexOf(i2) !== -1 : i2 === activeIndex;
    }, "isActiveIndex")
  }, {
    key: "hasActiveIndex",
    value: /* @__PURE__ */ __name(function() {
      var activeIndex = this.props.activeIndex;
      return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
    }, "hasActiveIndex")
  }, {
    key: "renderLabels",
    value: /* @__PURE__ */ __name(function(sectors) {
      var isAnimationActive = this.props.isAnimationActive;
      if (isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey, pieProps = filterProps(this.props, !1), customLabelProps = filterProps(label, !1), customLabelLineProps = filterProps(labelLine, !1), offsetRadius = label && label.offsetRadius || 20, labels = sectors.map(function(entry, i2) {
        var midAngle = (entry.startAngle + entry.endAngle) / 2, endPoint = polarToCartesian(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle), labelProps = _objectSpread$8(_objectSpread$8(_objectSpread$8(_objectSpread$8({}, pieProps), entry), {}, {
          stroke: "none"
        }, customLabelProps), {}, {
          index: i2,
          textAnchor: Pie2.getTextAnchor(endPoint.x, entry.cx)
        }, endPoint), lineProps = _objectSpread$8(_objectSpread$8(_objectSpread$8(_objectSpread$8({}, pieProps), entry), {}, {
          fill: "none",
          stroke: entry.fill
        }, customLabelLineProps), {}, {
          index: i2,
          points: [polarToCartesian(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint],
          key: "line"
        }), realDataKey = dataKey;
        return isNil$1(dataKey) && isNil$1(valueKey) ? realDataKey = "value" : isNil$1(dataKey) && (realDataKey = valueKey), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ React__default.createElement(Layer, {
          key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i2)
        }, labelLine && Pie2.renderLabelLineItem(labelLine, lineProps), Pie2.renderLabelItem(label, labelProps, getValueByDataKey(entry, realDataKey)));
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-pie-labels"
      }, labels);
    }, "renderLabels")
  }, {
    key: "renderSectorsStatically",
    value: /* @__PURE__ */ __name(function(sectors) {
      var _this2 = this, _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
      return sectors.map(function(entry, i2) {
        if ((entry == null ? void 0 : entry.startAngle) === 0 && (entry == null ? void 0 : entry.endAngle) === 0 && sectors.length !== 1)
          return null;
        var isActive = _this2.isActiveIndex(i2), inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null, sectorOptions = isActive ? activeShape : inactiveShape, sectorProps = _objectSpread$8(_objectSpread$8({}, entry), {}, {
          stroke: blendStroke ? entry.fill : entry.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$5({
          ref: /* @__PURE__ */ __name(function(_ref) {
            _ref && !_this2.sectorRefs.includes(_ref) && _this2.sectorRefs.push(_ref);
          }, "ref"),
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, adaptEventsOfChild(_this2.props, entry, i2), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(entry == null ? void 0 : entry.startAngle, "-").concat(entry == null ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i2)
        }), /* @__PURE__ */ React__default.createElement(Shape, _extends$5({
          option: sectorOptions,
          isActive,
          shapeType: "sector"
        }, sectorProps)));
      });
    }, "renderSectorsStatically")
  }, {
    key: "renderSectorsWithAnimation",
    value: /* @__PURE__ */ __name(function() {
      var _this3 = this, _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration2 = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId, _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
      return /* @__PURE__ */ React__default.createElement(Animate$1, {
        begin: animationBegin,
        duration: animationDuration2,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(_ref2) {
        var t3 = _ref2.t, stepData = [], first = sectors && sectors[0], curAngle = first.startAngle;
        return sectors.forEach(function(entry, index2) {
          var prev = prevSectors && prevSectors[index2], paddingAngle = index2 > 0 ? get$2(entry, "paddingAngle", 0) : 0;
          if (prev) {
            var angleIp = interpolateNumber$2(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle), latest = _objectSpread$8(_objectSpread$8({}, entry), {}, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + angleIp(t3) + paddingAngle
            });
            stepData.push(latest), curAngle = latest.endAngle;
          } else {
            var endAngle = entry.endAngle, startAngle = entry.startAngle, interpolatorAngle = interpolateNumber$2(0, endAngle - startAngle), deltaAngle = interpolatorAngle(t3), _latest = _objectSpread$8(_objectSpread$8({}, entry), {}, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + deltaAngle + paddingAngle
            });
            stepData.push(_latest), curAngle = _latest.endAngle;
          }
        }), /* @__PURE__ */ React__default.createElement(Layer, null, _this3.renderSectorsStatically(stepData));
      });
    }, "renderSectorsWithAnimation")
  }, {
    key: "attachKeyboardHandlers",
    value: /* @__PURE__ */ __name(function(pieRef) {
      var _this4 = this;
      pieRef.onkeydown = function(e3) {
        if (!e3.altKey)
          switch (e3.key) {
            case "ArrowLeft": {
              var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
              _this4.sectorRefs[next].focus(), _this4.setState({
                sectorToFocus: next
              });
              break;
            }
            case "ArrowRight": {
              var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
              _this4.sectorRefs[_next].focus(), _this4.setState({
                sectorToFocus: _next
              });
              break;
            }
            case "Escape": {
              _this4.sectorRefs[_this4.state.sectorToFocus].blur(), _this4.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }, "attachKeyboardHandlers")
  }, {
    key: "renderSectors",
    value: /* @__PURE__ */ __name(function() {
      var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive, prevSectors = this.state.prevSectors;
      return isAnimationActive && sectors && sectors.length && (!prevSectors || !isEqual$1(prevSectors, sectors)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(sectors);
    }, "renderSectors")
  }, {
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }, "componentDidMount")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this5 = this, _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive, isAnimationFinished = this.state.isAnimationFinished;
      if (hide || !sectors || !sectors.length || !isNumber(cx) || !isNumber(cy) || !isNumber(innerRadius) || !isNumber(outerRadius))
        return null;
      var layerClass = clsx("recharts-pie", className);
      return /* @__PURE__ */ React__default.createElement(Layer, {
        tabIndex: this.props.rootTabIndex,
        className: layerClass,
        ref: /* @__PURE__ */ __name(function(_ref3) {
          _this5.pieRef = _ref3;
        }, "ref")
      }, this.renderSectors(), label && this.renderLabels(sectors), Label.renderCallByParent(this.props, null, !1), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, sectors, !1));
    }, "render")
  }], [{
    key: "getDerivedStateFromProps",
    value: /* @__PURE__ */ __name(function(nextProps, prevState) {
      return prevState.prevIsAnimationActive !== nextProps.isAnimationActive ? {
        prevIsAnimationActive: nextProps.isAnimationActive,
        prevAnimationId: nextProps.animationId,
        curSectors: nextProps.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId ? {
        prevAnimationId: nextProps.animationId,
        curSectors: nextProps.sectors,
        prevSectors: prevState.curSectors,
        isAnimationFinished: !0
      } : nextProps.sectors !== prevState.curSectors ? {
        curSectors: nextProps.sectors,
        isAnimationFinished: !0
      } : null;
    }, "getDerivedStateFromProps")
  }, {
    key: "getTextAnchor",
    value: /* @__PURE__ */ __name(function(x3, cx) {
      return x3 > cx ? "start" : x3 < cx ? "end" : "middle";
    }, "getTextAnchor")
  }, {
    key: "renderLabelLineItem",
    value: /* @__PURE__ */ __name(function(option, props) {
      if (/* @__PURE__ */ React__default.isValidElement(option))
        return /* @__PURE__ */ React__default.cloneElement(option, props);
      if (isFunction$3(option))
        return option(props);
      var className = clsx("recharts-pie-label-line", typeof option != "boolean" ? option.className : "");
      return /* @__PURE__ */ React__default.createElement(Curve, _extends$5({}, props, {
        type: "linear",
        className
      }));
    }, "renderLabelLineItem")
  }, {
    key: "renderLabelItem",
    value: /* @__PURE__ */ __name(function(option, props, value) {
      if (/* @__PURE__ */ React__default.isValidElement(option))
        return /* @__PURE__ */ React__default.cloneElement(option, props);
      var label = value;
      if (isFunction$3(option) && (label = option(props), /* @__PURE__ */ React__default.isValidElement(label)))
        return label;
      var className = clsx("recharts-pie-label-text", typeof option != "boolean" && !isFunction$3(option) ? option.className : "");
      return /* @__PURE__ */ React__default.createElement(Text, _extends$5({}, props, {
        alignmentBaseline: "middle",
        className
      }), label);
    }, "renderLabelItem")
  }]), Pie2;
}(PureComponent);
_Pie = Pie;
_defineProperty$9(Pie, "displayName", "Pie");
_defineProperty$9(Pie, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !Global.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
_defineProperty$9(Pie, "parseDeltaAngle", function(startAngle, endAngle) {
  var sign2 = mathSign(endAngle - startAngle), deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign2 * deltaAngle;
});
_defineProperty$9(Pie, "getRealPieData", function(item) {
  var _item$props = item.props, data2 = _item$props.data, children = _item$props.children, presentationProps = filterProps(item.props, !1), cells = findAllByType(children, Cell);
  return data2 && data2.length ? data2.map(function(entry, index2) {
    return _objectSpread$8(_objectSpread$8(_objectSpread$8({
      payload: entry
    }, presentationProps), entry), cells && cells[index2] && cells[index2].props);
  }) : cells && cells.length ? cells.map(function(cell) {
    return _objectSpread$8(_objectSpread$8({}, presentationProps), cell.props);
  }) : [];
});
_defineProperty$9(Pie, "parseCoordinateOfPie", function(item, offset) {
  var top2 = offset.top, left2 = offset.left, width2 = offset.width, height2 = offset.height, maxPieRadius = getMaxRadius(width2, height2), cx = left2 + getPercentValue(item.props.cx, width2, width2 / 2), cy = top2 + getPercentValue(item.props.cy, height2, height2 / 2), innerRadius = getPercentValue(item.props.innerRadius, maxPieRadius, 0), outerRadius = getPercentValue(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8), maxRadius = item.props.maxRadius || Math.sqrt(width2 * width2 + height2 * height2) / 2;
  return {
    cx,
    cy,
    innerRadius,
    outerRadius,
    maxRadius
  };
});
_defineProperty$9(Pie, "getComposedData", function(_ref4) {
  var item = _ref4.item, offset = _ref4.offset, pieData = _Pie.getRealPieData(item);
  if (!pieData || !pieData.length)
    return null;
  var _item$props2 = item.props, cornerRadius = _item$props2.cornerRadius, startAngle = _item$props2.startAngle, endAngle = _item$props2.endAngle, paddingAngle = _item$props2.paddingAngle, dataKey = _item$props2.dataKey, nameKey = _item$props2.nameKey, valueKey = _item$props2.valueKey, tooltipType = _item$props2.tooltipType, minAngle = Math.abs(item.props.minAngle), coordinate = _Pie.parseCoordinateOfPie(item, offset), deltaAngle = _Pie.parseDeltaAngle(startAngle, endAngle), absDeltaAngle = Math.abs(deltaAngle), realDataKey = dataKey;
  isNil$1(dataKey) && isNil$1(valueKey) ? (warn$1(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), realDataKey = "value") : isNil$1(dataKey) && (warn$1(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), realDataKey = valueKey);
  var notZeroItemCount = pieData.filter(function(entry) {
    return getValueByDataKey(entry, realDataKey, 0) !== 0;
  }).length, totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle, realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle, sum = pieData.reduce(function(result2, entry) {
    var val = getValueByDataKey(entry, realDataKey, 0);
    return result2 + (isNumber(val) ? val : 0);
  }, 0), sectors;
  if (sum > 0) {
    var prev;
    sectors = pieData.map(function(entry, i2) {
      var val = getValueByDataKey(entry, realDataKey, 0), name2 = getValueByDataKey(entry, nameKey, i2), percent2 = (isNumber(val) ? val : 0) / sum, tempStartAngle;
      i2 ? tempStartAngle = prev.endAngle + mathSign(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0) : tempStartAngle = startAngle;
      var tempEndAngle = tempStartAngle + mathSign(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent2 * realTotalAngle), midAngle = (tempStartAngle + tempEndAngle) / 2, middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2, tooltipPayload = [{
        name: name2,
        value: val,
        payload: entry,
        dataKey: realDataKey,
        type: tooltipType
      }], tooltipPosition = polarToCartesian(coordinate.cx, coordinate.cy, middleRadius, midAngle);
      return prev = _objectSpread$8(_objectSpread$8(_objectSpread$8({
        percent: percent2,
        cornerRadius,
        name: name2,
        tooltipPayload,
        midAngle,
        middleRadius,
        tooltipPosition
      }, entry), coordinate), {}, {
        value: getValueByDataKey(entry, realDataKey),
        startAngle: tempStartAngle,
        endAngle: tempEndAngle,
        payload: entry,
        paddingAngle: mathSign(deltaAngle) * paddingAngle
      }), prev;
    });
  }
  return _objectSpread$8(_objectSpread$8({}, coordinate), {}, {
    sectors,
    data: pieData
  });
});
var nativeCeil = Math.ceil, nativeMax = Math.max;
function baseRange$1(start, end, step, fromRight) {
  for (var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array(length); length--; )
    result2[fromRight ? length : ++index2] = start, start += step;
  return result2;
}
__name(baseRange$1, "baseRange$1");
var _baseRange = baseRange$1, toNumber = toNumber_1, INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$1(value) {
  if (!value)
    return value === 0 ? value : 0;
  if (value = toNumber(value), value === INFINITY || value === -INFINITY) {
    var sign2 = value < 0 ? -1 : 1;
    return sign2 * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
__name(toFinite$1, "toFinite$1");
var toFinite_1 = toFinite$1, baseRange = _baseRange, isIterateeCall$2 = _isIterateeCall, toFinite = toFinite_1;
function createRange$1(fromRight) {
  return function(start, end, step) {
    return step && typeof step != "number" && isIterateeCall$2(start, end, step) && (end = step = void 0), start = toFinite(start), end === void 0 ? (end = start, start = 0) : end = toFinite(end), step = step === void 0 ? start < end ? 1 : -1 : toFinite(step), baseRange(start, end, step, fromRight);
  };
}
__name(createRange$1, "createRange$1");
var _createRange = createRange$1, createRange = _createRange, range2 = createRange(), range_1 = range2;
const range$1 = /* @__PURE__ */ getDefaultExportFromCjs(range_1);
function _typeof$9(o) {
  "@babel/helpers - typeof";
  return _typeof$9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$9(o);
}
__name(_typeof$9, "_typeof$9");
function ownKeys$7(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$7, "ownKeys$7");
function _objectSpread$7(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$7(Object(t3), !0).forEach(function(r3) {
      _defineProperty$8(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$7(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$7, "_objectSpread$7");
function _defineProperty$8(obj2, key, value) {
  return key = _toPropertyKey$8(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$8, "_defineProperty$8");
function _toPropertyKey$8(t3) {
  var i2 = _toPrimitive$8(t3, "string");
  return _typeof$9(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$8, "_toPropertyKey$8");
function _toPrimitive$8(t3, r2) {
  if (_typeof$9(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$9(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$8, "_toPrimitive$8");
var PREFIX_LIST = ["Webkit", "Moz", "O", "ms"], generatePrefixStyle = /* @__PURE__ */ __name(function(name2, value) {
  if (!name2)
    return null;
  var camelName = name2.replace(/(\w)/, function(v) {
    return v.toUpperCase();
  }), result2 = PREFIX_LIST.reduce(function(res, entry) {
    return _objectSpread$7(_objectSpread$7({}, res), {}, _defineProperty$8({}, entry + camelName, value));
  }, {});
  return result2[name2] = value, result2;
}, "generatePrefixStyle");
function _typeof$8(o) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$8(o);
}
__name(_typeof$8, "_typeof$8");
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$4.apply(this, arguments);
}
__name(_extends$4, "_extends$4");
function ownKeys$6(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$6, "ownKeys$6");
function _objectSpread$6(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$6(Object(t3), !0).forEach(function(r3) {
      _defineProperty$7(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$6(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$6, "_objectSpread$6");
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$3, "_classCallCheck$3");
function _defineProperties$3(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$7(descriptor.key), descriptor);
  }
}
__name(_defineProperties$3, "_defineProperties$3");
function _createClass$3(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$3(Constructor.prototype, protoProps), staticProps && _defineProperties$3(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$3, "_createClass$3");
function _callSuper$1(t3, o, e3) {
  return o = _getPrototypeOf$1(o), _possibleConstructorReturn$1(t3, _isNativeReflectConstruct$1() ? Reflect.construct(o, e3 || [], _getPrototypeOf$1(t3).constructor) : o.apply(t3, e3));
}
__name(_callSuper$1, "_callSuper$1");
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof$8(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(self2);
}
__name(_possibleConstructorReturn$1, "_possibleConstructorReturn$1");
function _isNativeReflectConstruct$1() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$1 = /* @__PURE__ */ __name(function() {
    return !!t3;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct$1, "_isNativeReflectConstruct$1");
function _getPrototypeOf$1(o) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf$1(o);
}
__name(_getPrototypeOf$1, "_getPrototypeOf$1");
function _assertThisInitialized$1(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized$1, "_assertThisInitialized$1");
function _inherits$1(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf$1(subClass, superClass);
}
__name(_inherits$1, "_inherits$1");
function _setPrototypeOf$1(o, p) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf$1(o, p);
}
__name(_setPrototypeOf$1, "_setPrototypeOf$1");
function _defineProperty$7(obj2, key, value) {
  return key = _toPropertyKey$7(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$7, "_defineProperty$7");
function _toPropertyKey$7(t3) {
  var i2 = _toPrimitive$7(t3, "string");
  return _typeof$8(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$7, "_toPropertyKey$7");
function _toPrimitive$7(t3, r2) {
  if (_typeof$8(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$8(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$7, "_toPrimitive$7");
var createScale = /* @__PURE__ */ __name(function(_ref) {
  var data2 = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x3 = _ref.x, width2 = _ref.width, travellerWidth = _ref.travellerWidth;
  if (!data2 || !data2.length)
    return {};
  var len = data2.length, scale2 = point().domain(range$1(0, len)).range([x3, x3 + width2 - travellerWidth]), scaleValues = scale2.domain().map(function(entry) {
    return scale2(entry);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: scale2(startIndex),
    endX: scale2(endIndex),
    scale: scale2,
    scaleValues
  };
}, "createScale"), isTouch = /* @__PURE__ */ __name(function(e3) {
  return e3.changedTouches && !!e3.changedTouches.length;
}, "isTouch"), Brush = /* @__PURE__ */ function(_PureComponent) {
  _inherits$1(Brush2, _PureComponent);
  function Brush2(props) {
    var _this;
    return _classCallCheck$3(this, Brush2), _this = _callSuper$1(this, Brush2, [props]), _defineProperty$7(_assertThisInitialized$1(_this), "handleDrag", function(e3) {
      _this.leaveTimer && (clearTimeout(_this.leaveTimer), _this.leaveTimer = null), _this.state.isTravellerMoving ? _this.handleTravellerMove(e3) : _this.state.isSlideMoving && _this.handleSlideDrag(e3);
    }), _defineProperty$7(_assertThisInitialized$1(_this), "handleTouchMove", function(e3) {
      e3.changedTouches != null && e3.changedTouches.length > 0 && _this.handleDrag(e3.changedTouches[0]);
    }), _defineProperty$7(_assertThisInitialized$1(_this), "handleDragEnd", function() {
      _this.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
        onDragEnd == null || onDragEnd({
          endIndex,
          startIndex
        });
      }), _this.detachDragEndListener();
    }), _defineProperty$7(_assertThisInitialized$1(_this), "handleLeaveWrapper", function() {
      (_this.state.isTravellerMoving || _this.state.isSlideMoving) && (_this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut));
    }), _defineProperty$7(_assertThisInitialized$1(_this), "handleEnterSlideOrTraveller", function() {
      _this.setState({
        isTextActive: !0
      });
    }), _defineProperty$7(_assertThisInitialized$1(_this), "handleLeaveSlideOrTraveller", function() {
      _this.setState({
        isTextActive: !1
      });
    }), _defineProperty$7(_assertThisInitialized$1(_this), "handleSlideDragStart", function(e3) {
      var event = isTouch(e3) ? e3.changedTouches[0] : e3;
      _this.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: event.pageX
      }), _this.attachDragEndListener();
    }), _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized$1(_this), "startX"),
      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized$1(_this), "endX")
    }, _this.state = {}, _this;
  }
  return __name(Brush2, "Brush"), _createClass$3(Brush2, [{
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }, "componentWillUnmount")
  }, {
    key: "getIndex",
    value: /* @__PURE__ */ __name(function(_ref2) {
      var startX = _ref2.startX, endX = _ref2.endX, scaleValues = this.state.scaleValues, _this$props2 = this.props, gap2 = _this$props2.gap, data2 = _this$props2.data, lastIndex = data2.length - 1, min2 = Math.min(startX, endX), max2 = Math.max(startX, endX), minIndex = Brush2.getIndexInRange(scaleValues, min2), maxIndex = Brush2.getIndexInRange(scaleValues, max2);
      return {
        startIndex: minIndex - minIndex % gap2,
        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap2
      };
    }, "getIndex")
  }, {
    key: "getTextOfTick",
    value: /* @__PURE__ */ __name(function(index2) {
      var _this$props3 = this.props, data2 = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey, text2 = getValueByDataKey(data2[index2], dataKey, index2);
      return isFunction$3(tickFormatter) ? tickFormatter(text2, index2) : text2;
    }, "getTextOfTick")
  }, {
    key: "attachDragEndListener",
    value: /* @__PURE__ */ __name(function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }, "attachDragEndListener")
  }, {
    key: "detachDragEndListener",
    value: /* @__PURE__ */ __name(function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }, "detachDragEndListener")
  }, {
    key: "handleSlideDrag",
    value: /* @__PURE__ */ __name(function(e3) {
      var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX, _this$props4 = this.props, x3 = _this$props4.x, width2 = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange5 = _this$props4.onChange, delta = e3.pageX - slideMoveStartX;
      delta > 0 ? delta = Math.min(delta, x3 + width2 - travellerWidth - endX, x3 + width2 - travellerWidth - startX) : delta < 0 && (delta = Math.max(delta, x3 - startX, x3 - endX));
      var newIndex = this.getIndex({
        startX: startX + delta,
        endX: endX + delta
      });
      (newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange5 && onChange5(newIndex), this.setState({
        startX: startX + delta,
        endX: endX + delta,
        slideMoveStartX: e3.pageX
      });
    }, "handleSlideDrag")
  }, {
    key: "handleTravellerDragStart",
    value: /* @__PURE__ */ __name(function(id2, e3) {
      var event = isTouch(e3) ? e3.changedTouches[0] : e3;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: id2,
        brushMoveStartX: event.pageX
      }), this.attachDragEndListener();
    }, "handleTravellerDragStart")
  }, {
    key: "handleTravellerMove",
    value: /* @__PURE__ */ __name(function(e3) {
      var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX, prevValue = this.state[movingTravellerId], _this$props5 = this.props, x3 = _this$props5.x, width2 = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange5 = _this$props5.onChange, gap2 = _this$props5.gap, data2 = _this$props5.data, params = {
        startX: this.state.startX,
        endX: this.state.endX
      }, delta = e3.pageX - brushMoveStartX;
      delta > 0 ? delta = Math.min(delta, x3 + width2 - travellerWidth - prevValue) : delta < 0 && (delta = Math.max(delta, x3 - prevValue)), params[movingTravellerId] = prevValue + delta;
      var newIndex = this.getIndex(params), startIndex = newIndex.startIndex, endIndex = newIndex.endIndex, isFullGap = /* @__PURE__ */ __name(function() {
        var lastIndex = data2.length - 1;
        return movingTravellerId === "startX" && (endX > startX ? startIndex % gap2 === 0 : endIndex % gap2 === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap2 === 0 : startIndex % gap2 === 0) || endX > startX && endIndex === lastIndex;
      }, "isFullGap");
      this.setState(_defineProperty$7(_defineProperty$7({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e3.pageX), function() {
        onChange5 && isFullGap() && onChange5(newIndex);
      });
    }, "handleTravellerMove")
  }, {
    key: "handleTravellerMoveKeyboard",
    value: /* @__PURE__ */ __name(function(direction, id2) {
      var _this2 = this, _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX, currentScaleValue = this.state[id2], currentIndex = scaleValues.indexOf(currentScaleValue);
      if (currentIndex !== -1) {
        var newIndex = currentIndex + direction;
        if (!(newIndex === -1 || newIndex >= scaleValues.length)) {
          var newScaleValue = scaleValues[newIndex];
          id2 === "startX" && newScaleValue >= endX || id2 === "endX" && newScaleValue <= startX || this.setState(_defineProperty$7({}, id2, newScaleValue), function() {
            _this2.props.onChange(_this2.getIndex({
              startX: _this2.state.startX,
              endX: _this2.state.endX
            }));
          });
        }
      }
    }, "handleTravellerMoveKeyboard")
  }, {
    key: "renderBackground",
    value: /* @__PURE__ */ __name(function() {
      var _this$props6 = this.props, x3 = _this$props6.x, y4 = _this$props6.y, width2 = _this$props6.width, height2 = _this$props6.height, fill2 = _this$props6.fill, stroke2 = _this$props6.stroke;
      return /* @__PURE__ */ React__default.createElement("rect", {
        stroke: stroke2,
        fill: fill2,
        x: x3,
        y: y4,
        width: width2,
        height: height2
      });
    }, "renderBackground")
  }, {
    key: "renderPanorama",
    value: /* @__PURE__ */ __name(function() {
      var _this$props7 = this.props, x3 = _this$props7.x, y4 = _this$props7.y, width2 = _this$props7.width, height2 = _this$props7.height, data2 = _this$props7.data, children = _this$props7.children, padding2 = _this$props7.padding, chartElement = Children.only(children);
      return chartElement ? /* @__PURE__ */ React__default.cloneElement(chartElement, {
        x: x3,
        y: y4,
        width: width2,
        height: height2,
        margin: padding2,
        compact: !0,
        data: data2
      }) : null;
    }, "renderPanorama")
  }, {
    key: "renderTravellerLayer",
    value: /* @__PURE__ */ __name(function(travellerX, id2) {
      var _this3 = this, _this$props8 = this.props, y4 = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height2 = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data2 = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex, x3 = Math.max(travellerX, this.props.x), travellerProps = _objectSpread$6(_objectSpread$6({}, filterProps(this.props, !1)), {}, {
        x: x3,
        y: y4,
        width: travellerWidth,
        height: height2
      }), ariaLabelBrush = ariaLabel || "Min value: ".concat(data2[startIndex].name, ", Max value: ").concat(data2[endIndex].name);
      return /* @__PURE__ */ React__default.createElement(Layer, {
        tabIndex: 0,
        role: "slider",
        "aria-label": ariaLabelBrush,
        "aria-valuenow": travellerX,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[id2],
        onTouchStart: this.travellerDragStartHandlers[id2],
        onKeyDown: /* @__PURE__ */ __name(function(e3) {
          ["ArrowLeft", "ArrowRight"].includes(e3.key) && (e3.preventDefault(), e3.stopPropagation(), _this3.handleTravellerMoveKeyboard(e3.key === "ArrowRight" ? 1 : -1, id2));
        }, "onKeyDown"),
        onFocus: /* @__PURE__ */ __name(function() {
          _this3.setState({
            isTravellerFocused: !0
          });
        }, "onFocus"),
        onBlur: /* @__PURE__ */ __name(function() {
          _this3.setState({
            isTravellerFocused: !1
          });
        }, "onBlur"),
        style: {
          cursor: "col-resize"
        }
      }, Brush2.renderTraveller(traveller, travellerProps));
    }, "renderTravellerLayer")
  }, {
    key: "renderSlide",
    value: /* @__PURE__ */ __name(function(startX, endX) {
      var _this$props9 = this.props, y4 = _this$props9.y, height2 = _this$props9.height, stroke2 = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth, x3 = Math.min(startX, endX) + travellerWidth, width2 = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
      return /* @__PURE__ */ React__default.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: stroke2,
        fillOpacity: 0.2,
        x: x3,
        y: y4,
        width: width2,
        height: height2
      });
    }, "renderSlide")
  }, {
    key: "renderText",
    value: /* @__PURE__ */ __name(function() {
      var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y4 = _this$props10.y, height2 = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke2 = _this$props10.stroke, _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX, offset = 5, attrs = {
        pointerEvents: "none",
        fill: stroke2
      };
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ React__default.createElement(Text, _extends$4({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(startX, endX) - offset,
        y: y4 + height2 / 2
      }, attrs), this.getTextOfTick(startIndex)), /* @__PURE__ */ React__default.createElement(Text, _extends$4({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(startX, endX) + travellerWidth + offset,
        y: y4 + height2 / 2
      }, attrs), this.getTextOfTick(endIndex)));
    }, "renderText")
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function() {
      var _this$props11 = this.props, data2 = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x3 = _this$props11.x, y4 = _this$props11.y, width2 = _this$props11.width, height2 = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText, _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
      if (!data2 || !data2.length || !isNumber(x3) || !isNumber(y4) || !isNumber(width2) || !isNumber(height2) || width2 <= 0 || height2 <= 0)
        return null;
      var layerClass = clsx("recharts-brush", className), isPanoramic = React__default.Children.count(children) === 1, style2 = generatePrefixStyle("userSelect", "none");
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: layerClass,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: style2
      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
    }, "render")
  }], [{
    key: "renderDefaultTraveller",
    value: /* @__PURE__ */ __name(function(props) {
      var x3 = props.x, y4 = props.y, width2 = props.width, height2 = props.height, stroke2 = props.stroke, lineY = Math.floor(y4 + height2 / 2) - 1;
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("rect", {
        x: x3,
        y: y4,
        width: width2,
        height: height2,
        fill: stroke2,
        stroke: "none"
      }), /* @__PURE__ */ React__default.createElement("line", {
        x1: x3 + 1,
        y1: lineY,
        x2: x3 + width2 - 1,
        y2: lineY,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ React__default.createElement("line", {
        x1: x3 + 1,
        y1: lineY + 2,
        x2: x3 + width2 - 1,
        y2: lineY + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }, "renderDefaultTraveller")
  }, {
    key: "renderTraveller",
    value: /* @__PURE__ */ __name(function(option, props) {
      var rectangle;
      return /* @__PURE__ */ React__default.isValidElement(option) ? rectangle = /* @__PURE__ */ React__default.cloneElement(option, props) : isFunction$3(option) ? rectangle = option(props) : rectangle = Brush2.renderDefaultTraveller(props), rectangle;
    }, "renderTraveller")
  }, {
    key: "getDerivedStateFromProps",
    value: /* @__PURE__ */ __name(function(nextProps, prevState) {
      var data2 = nextProps.data, width2 = nextProps.width, x3 = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
      if (data2 !== prevState.prevData || updateId !== prevState.prevUpdateId)
        return _objectSpread$6({
          prevData: data2,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x3,
          prevWidth: width2
        }, data2 && data2.length ? createScale({
          data: data2,
          width: width2,
          x: x3,
          travellerWidth,
          startIndex,
          endIndex
        }) : {
          scale: null,
          scaleValues: null
        });
      if (prevState.scale && (width2 !== prevState.prevWidth || x3 !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
        prevState.scale.range([x3, x3 + width2 - travellerWidth]);
        var scaleValues = prevState.scale.domain().map(function(entry) {
          return prevState.scale(entry);
        });
        return {
          prevData: data2,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x3,
          prevWidth: width2,
          startX: prevState.scale(nextProps.startIndex),
          endX: prevState.scale(nextProps.endIndex),
          scaleValues
        };
      }
      return null;
    }, "getDerivedStateFromProps")
  }, {
    key: "getIndexInRange",
    value: /* @__PURE__ */ __name(function(valueRange, x3) {
      for (var len = valueRange.length, start = 0, end = len - 1; end - start > 1; ) {
        var middle = Math.floor((start + end) / 2);
        valueRange[middle] > x3 ? end = middle : start = middle;
      }
      return x3 >= valueRange[end] ? end : start;
    }, "getIndexInRange")
  }]), Brush2;
}(PureComponent);
_defineProperty$7(Brush, "displayName", "Brush");
_defineProperty$7(Brush, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var baseEach$1 = _baseEach;
function baseSome$1(collection, predicate) {
  var result2;
  return baseEach$1(collection, function(value, index2, collection2) {
    return result2 = predicate(value, index2, collection2), !result2;
  }), !!result2;
}
__name(baseSome$1, "baseSome$1");
var _baseSome = baseSome$1, arraySome = _arraySome, baseIteratee$2 = _baseIteratee, baseSome = _baseSome, isArray$1 = isArray_1, isIterateeCall$1 = _isIterateeCall;
function some(collection, predicate, guard) {
  var func2 = isArray$1(collection) ? arraySome : baseSome;
  return guard && isIterateeCall$1(collection, predicate, guard) && (predicate = void 0), func2(collection, baseIteratee$2(predicate));
}
__name(some, "some");
var some_1 = some;
const some$1 = /* @__PURE__ */ getDefaultExportFromCjs(some_1);
var ifOverflowMatches = /* @__PURE__ */ __name(function(props, value) {
  var alwaysShow = props.alwaysShow, ifOverflow = props.ifOverflow;
  return alwaysShow && (ifOverflow = "extendDomain"), ifOverflow === value;
}, "ifOverflowMatches"), defineProperty = _defineProperty$w;
function baseAssignValue$1(object2, key, value) {
  key == "__proto__" && defineProperty ? defineProperty(object2, key, {
    configurable: !0,
    enumerable: !0,
    value,
    writable: !0
  }) : object2[key] = value;
}
__name(baseAssignValue$1, "baseAssignValue$1");
var _baseAssignValue = baseAssignValue$1, baseAssignValue = _baseAssignValue, baseForOwn = _baseForOwn, baseIteratee$1 = _baseIteratee;
function mapValues(object2, iteratee) {
  var result2 = {};
  return iteratee = baseIteratee$1(iteratee), baseForOwn(object2, function(value, key, object3) {
    baseAssignValue(result2, key, iteratee(value, key, object3));
  }), result2;
}
__name(mapValues, "mapValues");
var mapValues_1 = mapValues;
const mapValues$1 = /* @__PURE__ */ getDefaultExportFromCjs(mapValues_1);
function arrayEvery$1(array2, predicate) {
  for (var index2 = -1, length = array2 == null ? 0 : array2.length; ++index2 < length; )
    if (!predicate(array2[index2], index2, array2))
      return !1;
  return !0;
}
__name(arrayEvery$1, "arrayEvery$1");
var _arrayEvery = arrayEvery$1, baseEach = _baseEach;
function baseEvery$1(collection, predicate) {
  var result2 = !0;
  return baseEach(collection, function(value, index2, collection2) {
    return result2 = !!predicate(value, index2, collection2), result2;
  }), result2;
}
__name(baseEvery$1, "baseEvery$1");
var _baseEvery = baseEvery$1, arrayEvery = _arrayEvery, baseEvery = _baseEvery, baseIteratee = _baseIteratee, isArray2 = isArray_1, isIterateeCall = _isIterateeCall;
function every(collection, predicate, guard) {
  var func2 = isArray2(collection) ? arrayEvery : baseEvery;
  return guard && isIterateeCall(collection, predicate, guard) && (predicate = void 0), func2(collection, baseIteratee(predicate));
}
__name(every, "every");
var every_1 = every;
const every$1 = /* @__PURE__ */ getDefaultExportFromCjs(every_1);
function _typeof$7(o) {
  "@babel/helpers - typeof";
  return _typeof$7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$7(o);
}
__name(_typeof$7, "_typeof$7");
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$2, "_classCallCheck$2");
function _defineProperties$2(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$6(descriptor.key), descriptor);
  }
}
__name(_defineProperties$2, "_defineProperties$2");
function _createClass$2(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$2(Constructor.prototype, protoProps), staticProps && _defineProperties$2(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$2, "_createClass$2");
function ownKeys$5(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$5, "ownKeys$5");
function _objectSpread$5(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$5(Object(t3), !0).forEach(function(r3) {
      _defineProperty$6(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$5(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$5, "_objectSpread$5");
function _defineProperty$6(obj2, key, value) {
  return key = _toPropertyKey$6(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$6, "_defineProperty$6");
function _toPropertyKey$6(t3) {
  var i2 = _toPrimitive$6(t3, "string");
  return _typeof$7(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$6, "_toPropertyKey$6");
function _toPrimitive$6(t3, r2) {
  if (_typeof$7(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$7(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$6, "_toPrimitive$6");
var rectWithPoints = /* @__PURE__ */ __name(function(_ref, _ref2) {
  var x1 = _ref.x, y1 = _ref.y, x22 = _ref2.x, y22 = _ref2.y;
  return {
    x: Math.min(x1, x22),
    y: Math.min(y1, y22),
    width: Math.abs(x22 - x1),
    height: Math.abs(y22 - y1)
  };
}, "rectWithPoints"), rectWithCoords = /* @__PURE__ */ __name(function(_ref3) {
  var x1 = _ref3.x1, y1 = _ref3.y1, x22 = _ref3.x2, y22 = _ref3.y2;
  return rectWithPoints({
    x: x1,
    y: y1
  }, {
    x: x22,
    y: y22
  });
}, "rectWithCoords"), ScaleHelper = /* @__PURE__ */ function() {
  function ScaleHelper2(scale2) {
    _classCallCheck$2(this, ScaleHelper2), this.scale = scale2;
  }
  return __name(ScaleHelper2, "ScaleHelper"), _createClass$2(ScaleHelper2, [{
    key: "domain",
    get: /* @__PURE__ */ __name(function() {
      return this.scale.domain;
    }, "get")
  }, {
    key: "range",
    get: /* @__PURE__ */ __name(function() {
      return this.scale.range;
    }, "get")
  }, {
    key: "rangeMin",
    get: /* @__PURE__ */ __name(function() {
      return this.range()[0];
    }, "get")
  }, {
    key: "rangeMax",
    get: /* @__PURE__ */ __name(function() {
      return this.range()[1];
    }, "get")
  }, {
    key: "bandwidth",
    get: /* @__PURE__ */ __name(function() {
      return this.scale.bandwidth;
    }, "get")
  }, {
    key: "apply",
    value: /* @__PURE__ */ __name(function(value) {
      var _ref4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, bandAware = _ref4.bandAware, position2 = _ref4.position;
      if (value !== void 0) {
        if (position2)
          switch (position2) {
            case "start":
              return this.scale(value);
            case "middle": {
              var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(value) + offset;
            }
            case "end": {
              var _offset = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(value) + _offset;
            }
            default:
              return this.scale(value);
          }
        if (bandAware) {
          var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(value) + _offset2;
        }
        return this.scale(value);
      }
    }, "apply")
  }, {
    key: "isInRange",
    value: /* @__PURE__ */ __name(function(value) {
      var range3 = this.range(), first = range3[0], last2 = range3[range3.length - 1];
      return first <= last2 ? value >= first && value <= last2 : value >= last2 && value <= first;
    }, "isInRange")
  }], [{
    key: "create",
    value: /* @__PURE__ */ __name(function(obj2) {
      return new ScaleHelper2(obj2);
    }, "create")
  }]), ScaleHelper2;
}();
_defineProperty$6(ScaleHelper, "EPS", 1e-4);
var createLabeledScales = /* @__PURE__ */ __name(function(options) {
  var scales = Object.keys(options).reduce(function(res, key) {
    return _objectSpread$5(_objectSpread$5({}, res), {}, _defineProperty$6({}, key, ScaleHelper.create(options[key])));
  }, {});
  return _objectSpread$5(_objectSpread$5({}, scales), {}, {
    apply: /* @__PURE__ */ __name(function(coord) {
      var _ref5 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, bandAware = _ref5.bandAware, position2 = _ref5.position;
      return mapValues$1(coord, function(value, label) {
        return scales[label].apply(value, {
          bandAware,
          position: position2
        });
      });
    }, "apply"),
    isInRange: /* @__PURE__ */ __name(function(coord) {
      return every$1(coord, function(value, label) {
        return scales[label].isInRange(value);
      });
    }, "isInRange")
  });
}, "createLabeledScales"), calculateViewBox = memoize$3(function(offset) {
  return {
    x: offset.left,
    y: offset.top,
    width: offset.width,
    height: offset.height
  };
}, function(offset) {
  return ["l", offset.left, "t", offset.top, "w", offset.width, "h", offset.height].join("");
});
function _typeof$6(o) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$6(o);
}
__name(_typeof$6, "_typeof$6");
var XAxisContext = /* @__PURE__ */ createContext(void 0), YAxisContext = /* @__PURE__ */ createContext(void 0), ViewBoxContext = /* @__PURE__ */ createContext(void 0), OffsetContext = /* @__PURE__ */ createContext({}), ClipPathIdContext = /* @__PURE__ */ createContext(void 0), ChartHeightContext = /* @__PURE__ */ createContext(0), ChartWidthContext = /* @__PURE__ */ createContext(0), ChartLayoutContextProvider = /* @__PURE__ */ __name(function(props) {
  var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width2 = props.width, height2 = props.height, viewBox = calculateViewBox(offset);
  return /* @__PURE__ */ React__default.createElement(XAxisContext.Provider, {
    value: xAxisMap
  }, /* @__PURE__ */ React__default.createElement(YAxisContext.Provider, {
    value: yAxisMap
  }, /* @__PURE__ */ React__default.createElement(OffsetContext.Provider, {
    value: offset
  }, /* @__PURE__ */ React__default.createElement(ViewBoxContext.Provider, {
    value: viewBox
  }, /* @__PURE__ */ React__default.createElement(ClipPathIdContext.Provider, {
    value: clipPathId
  }, /* @__PURE__ */ React__default.createElement(ChartHeightContext.Provider, {
    value: height2
  }, /* @__PURE__ */ React__default.createElement(ChartWidthContext.Provider, {
    value: width2
  }, children)))))));
}, "ChartLayoutContextProvider"), useClipPathId = /* @__PURE__ */ __name(function() {
  return useContext(ClipPathIdContext);
}, "useClipPathId");
function getKeysForDebug(object2) {
  var keys2 = Object.keys(object2);
  return keys2.length === 0 ? "There are no available ids." : "Available ids are: ".concat(keys2, ".");
}
__name(getKeysForDebug, "getKeysForDebug");
var useXAxisOrThrow = /* @__PURE__ */ __name(function(xAxisId) {
  var xAxisMap = useContext(XAxisContext);
  xAxisMap == null && (process.env.NODE_ENV !== "production" ? invariant(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : invariant(!1));
  var xAxis = xAxisMap[xAxisId];
  return xAxis == null && (process.env.NODE_ENV !== "production" ? invariant(!1, 'Could not find xAxis by id "'.concat(xAxisId, '" [').concat(_typeof$6(xAxisId), "]. ").concat(getKeysForDebug(xAxisMap))) : invariant(!1)), xAxis;
}, "useXAxisOrThrow"), useYAxisOrThrow = /* @__PURE__ */ __name(function(yAxisId) {
  var yAxisMap = useContext(YAxisContext);
  yAxisMap == null && (process.env.NODE_ENV !== "production" ? invariant(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : invariant(!1));
  var yAxis = yAxisMap[yAxisId];
  return yAxis == null && (process.env.NODE_ENV !== "production" ? invariant(!1, 'Could not find yAxis by id "'.concat(yAxisId, '" [').concat(_typeof$6(yAxisId), "]. ").concat(getKeysForDebug(yAxisMap))) : invariant(!1)), yAxis;
}, "useYAxisOrThrow"), useViewBox = /* @__PURE__ */ __name(function() {
  var viewBox = useContext(ViewBoxContext);
  return viewBox;
}, "useViewBox");
function _typeof$5(o) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$5(o);
}
__name(_typeof$5, "_typeof$5");
function ownKeys$4(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$4, "ownKeys$4");
function _objectSpread$4(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$4(Object(t3), !0).forEach(function(r3) {
      _defineProperty$5(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$4(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$4, "_objectSpread$4");
function _defineProperty$5(obj2, key, value) {
  return key = _toPropertyKey$5(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$5, "_defineProperty$5");
function _toPropertyKey$5(t3) {
  var i2 = _toPrimitive$5(t3, "string");
  return _typeof$5(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$5, "_toPropertyKey$5");
function _toPrimitive$5(t3, r2) {
  if (_typeof$5(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$5(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$5, "_toPrimitive$5");
function _slicedToArray$1(arr, i2) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i2) || _unsupportedIterableToArray$2(arr, i2) || _nonIterableRest$1();
}
__name(_slicedToArray$1, "_slicedToArray$1");
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest$1, "_nonIterableRest$1");
function _unsupportedIterableToArray$2(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$2(o, minLen);
  }
}
__name(_unsupportedIterableToArray$2, "_unsupportedIterableToArray$2");
function _arrayLikeToArray$2(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$2, "_arrayLikeToArray$2");
function _iterableToArrayLimit$1(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit$1, "_iterableToArrayLimit$1");
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles$1, "_arrayWithHoles$1");
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$3.apply(this, arguments);
}
__name(_extends$3, "_extends$3");
var renderLine = /* @__PURE__ */ __name(function(option, props) {
  var line;
  return /* @__PURE__ */ React__default.isValidElement(option) ? line = /* @__PURE__ */ React__default.cloneElement(option, props) : isFunction$3(option) ? line = option(props) : line = /* @__PURE__ */ React__default.createElement("line", _extends$3({}, props, {
    className: "recharts-reference-line-line"
  })), line;
}, "renderLine"), getEndPoints = /* @__PURE__ */ __name(function(scales, isFixedX, isFixedY, isSegment, viewBox, position2, xAxisOrientation, yAxisOrientation, props) {
  var x3 = viewBox.x, y4 = viewBox.y, width2 = viewBox.width, height2 = viewBox.height;
  if (isFixedY) {
    var yCoord = props.y, coord = scales.y.apply(yCoord, {
      position: position2
    });
    if (ifOverflowMatches(props, "discard") && !scales.y.isInRange(coord))
      return null;
    var points = [{
      x: x3 + width2,
      y: coord
    }, {
      x: x3,
      y: coord
    }];
    return yAxisOrientation === "left" ? points.reverse() : points;
  }
  if (isFixedX) {
    var xCoord = props.x, _coord = scales.x.apply(xCoord, {
      position: position2
    });
    if (ifOverflowMatches(props, "discard") && !scales.x.isInRange(_coord))
      return null;
    var _points = [{
      x: _coord,
      y: y4 + height2
    }, {
      x: _coord,
      y: y4
    }];
    return xAxisOrientation === "top" ? _points.reverse() : _points;
  }
  if (isSegment) {
    var segment = props.segment, _points2 = segment.map(function(p) {
      return scales.apply(p, {
        position: position2
      });
    });
    return ifOverflowMatches(props, "discard") && some$1(_points2, function(p) {
      return !scales.isInRange(p);
    }) ? null : _points2;
  }
  return null;
}, "getEndPoints");
function ReferenceLine(props) {
  var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = useClipPathId(), xAxis = useXAxisOrThrow(xAxisId), yAxis = useYAxisOrThrow(yAxisId), viewBox = useViewBox();
  if (!clipPathId || !viewBox)
    return null;
  warn$1(alwaysShow === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  }), isX = isNumOrStr(fixedX), isY = isNumOrStr(fixedY), isSegment = segment && segment.length === 2, endPoints = getEndPoints(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
  if (!endPoints)
    return null;
  var _endPoints = _slicedToArray$1(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x22 = _endPoints$2.x, y22 = _endPoints$2.y, clipPath = ifOverflowMatches(props, "hidden") ? "url(#".concat(clipPathId, ")") : void 0, lineProps = _objectSpread$4(_objectSpread$4({
    clipPath
  }, filterProps(props, !0)), {}, {
    x1,
    y1,
    x2: x22,
    y2: y22
  });
  return /* @__PURE__ */ React__default.createElement(Layer, {
    className: clsx("recharts-reference-line", className)
  }, renderLine(shape, lineProps), Label.renderCallByParent(props, rectWithCoords({
    x1,
    y1,
    x2: x22,
    y2: y22
  })));
}
__name(ReferenceLine, "ReferenceLine");
ReferenceLine.displayName = "ReferenceLine";
ReferenceLine.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
};
function _typeof$4(o) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$4(o);
}
__name(_typeof$4, "_typeof$4");
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$2.apply(this, arguments);
}
__name(_extends$2, "_extends$2");
function ownKeys$3(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$3, "ownKeys$3");
function _objectSpread$3(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$3(Object(t3), !0).forEach(function(r3) {
      _defineProperty$4(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$3(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$3, "_objectSpread$3");
function _defineProperty$4(obj2, key, value) {
  return key = _toPropertyKey$4(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$4, "_defineProperty$4");
function _toPropertyKey$4(t3) {
  var i2 = _toPrimitive$4(t3, "string");
  return _typeof$4(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$4, "_toPropertyKey$4");
function _toPrimitive$4(t3, r2) {
  if (_typeof$4(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$4(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$4, "_toPrimitive$4");
var getCoordinate = /* @__PURE__ */ __name(function(props) {
  var x3 = props.x, y4 = props.y, xAxis = props.xAxis, yAxis = props.yAxis, scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  }), result2 = scales.apply({
    x: x3,
    y: y4
  }, {
    bandAware: !0
  });
  return ifOverflowMatches(props, "discard") && !scales.isInRange(result2) ? null : result2;
}, "getCoordinate");
function ReferenceDot(props) {
  var x3 = props.x, y4 = props.y, r2 = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId, isX = isNumOrStr(x3), isY = isNumOrStr(y4);
  if (warn$1(alwaysShow === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !isX || !isY)
    return null;
  var coordinate = getCoordinate(props);
  if (!coordinate)
    return null;
  var cx = coordinate.x, cy = coordinate.y, shape = props.shape, className = props.className, clipPath = ifOverflowMatches(props, "hidden") ? "url(#".concat(clipPathId, ")") : void 0, dotProps = _objectSpread$3(_objectSpread$3({
    clipPath
  }, filterProps(props, !0)), {}, {
    cx,
    cy
  });
  return /* @__PURE__ */ React__default.createElement(Layer, {
    className: clsx("recharts-reference-dot", className)
  }, ReferenceDot.renderDot(shape, dotProps), Label.renderCallByParent(props, {
    x: cx - r2,
    y: cy - r2,
    width: 2 * r2,
    height: 2 * r2
  }));
}
__name(ReferenceDot, "ReferenceDot");
ReferenceDot.displayName = "ReferenceDot";
ReferenceDot.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
};
ReferenceDot.renderDot = function(option, props) {
  var dot;
  return /* @__PURE__ */ React__default.isValidElement(option) ? dot = /* @__PURE__ */ React__default.cloneElement(option, props) : isFunction$3(option) ? dot = option(props) : dot = /* @__PURE__ */ React__default.createElement(Dot, _extends$2({}, props, {
    cx: props.cx,
    cy: props.cy,
    className: "recharts-reference-dot-dot"
  })), dot;
};
function _typeof$3(o) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$3(o);
}
__name(_typeof$3, "_typeof$3");
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$1.apply(this, arguments);
}
__name(_extends$1, "_extends$1");
function ownKeys$2(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$2, "ownKeys$2");
function _objectSpread$2(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$2(Object(t3), !0).forEach(function(r3) {
      _defineProperty$3(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$2(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$2, "_objectSpread$2");
function _defineProperty$3(obj2, key, value) {
  return key = _toPropertyKey$3(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$3, "_defineProperty$3");
function _toPropertyKey$3(t3) {
  var i2 = _toPrimitive$3(t3, "string");
  return _typeof$3(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$3, "_toPropertyKey$3");
function _toPrimitive$3(t3, r2) {
  if (_typeof$3(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$3(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$3, "_toPrimitive$3");
var getRect = /* @__PURE__ */ __name(function(hasX1, hasX2, hasY1, hasY2, props) {
  var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
  if (!xAxis || !yAxis)
    return null;
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  }), p1 = {
    x: hasX1 ? scales.x.apply(xValue1, {
      position: "start"
    }) : scales.x.rangeMin,
    y: hasY1 ? scales.y.apply(yValue1, {
      position: "start"
    }) : scales.y.rangeMin
  }, p2 = {
    x: hasX2 ? scales.x.apply(xValue2, {
      position: "end"
    }) : scales.x.rangeMax,
    y: hasY2 ? scales.y.apply(yValue2, {
      position: "end"
    }) : scales.y.rangeMax
  };
  return ifOverflowMatches(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2)) ? null : rectWithPoints(p1, p2);
}, "getRect");
function ReferenceArea(props) {
  var x1 = props.x1, x22 = props.x2, y1 = props.y1, y22 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
  warn$1(alwaysShow === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var hasX1 = isNumOrStr(x1), hasX2 = isNumOrStr(x22), hasY1 = isNumOrStr(y1), hasY2 = isNumOrStr(y22), shape = props.shape;
  if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape)
    return null;
  var rect = getRect(hasX1, hasX2, hasY1, hasY2, props);
  if (!rect && !shape)
    return null;
  var clipPath = ifOverflowMatches(props, "hidden") ? "url(#".concat(clipPathId, ")") : void 0;
  return /* @__PURE__ */ React__default.createElement(Layer, {
    className: clsx("recharts-reference-area", className)
  }, ReferenceArea.renderRect(shape, _objectSpread$2(_objectSpread$2({
    clipPath
  }, filterProps(props, !0)), rect)), Label.renderCallByParent(props, rect));
}
__name(ReferenceArea, "ReferenceArea");
ReferenceArea.displayName = "ReferenceArea";
ReferenceArea.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
};
ReferenceArea.renderRect = function(option, props) {
  var rect;
  return /* @__PURE__ */ React__default.isValidElement(option) ? rect = /* @__PURE__ */ React__default.cloneElement(option, props) : isFunction$3(option) ? rect = option(props) : rect = /* @__PURE__ */ React__default.createElement(Rectangle, _extends$1({}, props, {
    className: "recharts-reference-area-rect"
  })), rect;
};
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
__name(_toConsumableArray$1, "_toConsumableArray$1");
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread$1, "_nonIterableSpread$1");
function _unsupportedIterableToArray$1(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray$1(o, minLen);
  }
}
__name(_unsupportedIterableToArray$1, "_unsupportedIterableToArray$1");
function _iterableToArray$1(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray$1, "_iterableToArray$1");
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$1(arr);
}
__name(_arrayWithoutHoles$1, "_arrayWithoutHoles$1");
function _arrayLikeToArray$1(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray$1, "_arrayLikeToArray$1");
var detectReferenceElementsDomain = /* @__PURE__ */ __name(function(children, domain, axisId, axisType, specifiedTicks) {
  var lines = findAllByType(children, ReferenceLine), dots = findAllByType(children, ReferenceDot), elements = [].concat(_toConsumableArray$1(lines), _toConsumableArray$1(dots)), areas = findAllByType(children, ReferenceArea), idKey = "".concat(axisType, "Id"), valueKey = axisType[0], finalDomain = domain;
  if (elements.length && (finalDomain = elements.reduce(function(result2, el) {
    if (el.props[idKey] === axisId && ifOverflowMatches(el.props, "extendDomain") && isNumber(el.props[valueKey])) {
      var value = el.props[valueKey];
      return [Math.min(result2[0], value), Math.max(result2[1], value)];
    }
    return result2;
  }, finalDomain)), areas.length) {
    var key1 = "".concat(valueKey, "1"), key2 = "".concat(valueKey, "2");
    finalDomain = areas.reduce(function(result2, el) {
      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, "extendDomain") && isNumber(el.props[key1]) && isNumber(el.props[key2])) {
        var value1 = el.props[key1], value2 = el.props[key2];
        return [Math.min(result2[0], value1, value2), Math.max(result2[1], value1, value2)];
      }
      return result2;
    }, finalDomain);
  }
  return specifiedTicks && specifiedTicks.length && (finalDomain = specifiedTicks.reduce(function(result2, tick) {
    return isNumber(tick) ? [Math.min(result2[0], tick), Math.max(result2[1], tick)] : result2;
  }, finalDomain)), finalDomain;
}, "detectReferenceElementsDomain"), eventemitter3 = { exports: {} };
(function(module2) {
  var has2 = Object.prototype.hasOwnProperty, prefix2 = "~";
  function Events() {
  }
  __name(Events, "Events"), Object.create && (Events.prototype = /* @__PURE__ */ Object.create(null), new Events().__proto__ || (prefix2 = !1));
  function EE(fn, context, once) {
    this.fn = fn, this.context = context, this.once = once || !1;
  }
  __name(EE, "EE");
  function addListener(emitter, event, fn, context, once) {
    if (typeof fn != "function")
      throw new TypeError("The listener must be a function");
    var listener = new EE(fn, context || emitter, once), evt = prefix2 ? prefix2 + event : event;
    return emitter._events[evt] ? emitter._events[evt].fn ? emitter._events[evt] = [emitter._events[evt], listener] : emitter._events[evt].push(listener) : (emitter._events[evt] = listener, emitter._eventsCount++), emitter;
  }
  __name(addListener, "addListener");
  function clearEvent(emitter, evt) {
    --emitter._eventsCount === 0 ? emitter._events = new Events() : delete emitter._events[evt];
  }
  __name(clearEvent, "clearEvent");
  function EventEmitter2() {
    this._events = new Events(), this._eventsCount = 0;
  }
  __name(EventEmitter2, "EventEmitter"), EventEmitter2.prototype.eventNames = /* @__PURE__ */ __name(function() {
    var names = [], events, name2;
    if (this._eventsCount === 0)
      return names;
    for (name2 in events = this._events)
      has2.call(events, name2) && names.push(prefix2 ? name2.slice(1) : name2);
    return Object.getOwnPropertySymbols ? names.concat(Object.getOwnPropertySymbols(events)) : names;
  }, "eventNames"), EventEmitter2.prototype.listeners = /* @__PURE__ */ __name(function(event) {
    var evt = prefix2 ? prefix2 + event : event, handlers2 = this._events[evt];
    if (!handlers2)
      return [];
    if (handlers2.fn)
      return [handlers2.fn];
    for (var i2 = 0, l = handlers2.length, ee = new Array(l); i2 < l; i2++)
      ee[i2] = handlers2[i2].fn;
    return ee;
  }, "listeners"), EventEmitter2.prototype.listenerCount = /* @__PURE__ */ __name(function(event) {
    var evt = prefix2 ? prefix2 + event : event, listeners = this._events[evt];
    return listeners ? listeners.fn ? 1 : listeners.length : 0;
  }, "listenerCount"), EventEmitter2.prototype.emit = /* @__PURE__ */ __name(function(event, a1, a22, a32, a4, a5) {
    var evt = prefix2 ? prefix2 + event : event;
    if (!this._events[evt])
      return !1;
    var listeners = this._events[evt], len = arguments.length, args, i2;
    if (listeners.fn) {
      switch (listeners.once && this.removeListener(event, listeners.fn, void 0, !0), len) {
        case 1:
          return listeners.fn.call(listeners.context), !0;
        case 2:
          return listeners.fn.call(listeners.context, a1), !0;
        case 3:
          return listeners.fn.call(listeners.context, a1, a22), !0;
        case 4:
          return listeners.fn.call(listeners.context, a1, a22, a32), !0;
        case 5:
          return listeners.fn.call(listeners.context, a1, a22, a32, a4), !0;
        case 6:
          return listeners.fn.call(listeners.context, a1, a22, a32, a4, a5), !0;
      }
      for (i2 = 1, args = new Array(len - 1); i2 < len; i2++)
        args[i2 - 1] = arguments[i2];
      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length, j;
      for (i2 = 0; i2 < length; i2++)
        switch (listeners[i2].once && this.removeListener(event, listeners[i2].fn, void 0, !0), len) {
          case 1:
            listeners[i2].fn.call(listeners[i2].context);
            break;
          case 2:
            listeners[i2].fn.call(listeners[i2].context, a1);
            break;
          case 3:
            listeners[i2].fn.call(listeners[i2].context, a1, a22);
            break;
          case 4:
            listeners[i2].fn.call(listeners[i2].context, a1, a22, a32);
            break;
          default:
            if (!args)
              for (j = 1, args = new Array(len - 1); j < len; j++)
                args[j - 1] = arguments[j];
            listeners[i2].fn.apply(listeners[i2].context, args);
        }
    }
    return !0;
  }, "emit"), EventEmitter2.prototype.on = /* @__PURE__ */ __name(function(event, fn, context) {
    return addListener(this, event, fn, context, !1);
  }, "on"), EventEmitter2.prototype.once = /* @__PURE__ */ __name(function(event, fn, context) {
    return addListener(this, event, fn, context, !0);
  }, "once"), EventEmitter2.prototype.removeListener = /* @__PURE__ */ __name(function(event, fn, context, once) {
    var evt = prefix2 ? prefix2 + event : event;
    if (!this._events[evt])
      return this;
    if (!fn)
      return clearEvent(this, evt), this;
    var listeners = this._events[evt];
    if (listeners.fn)
      listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context) && clearEvent(this, evt);
    else {
      for (var i2 = 0, events = [], length = listeners.length; i2 < length; i2++)
        (listeners[i2].fn !== fn || once && !listeners[i2].once || context && listeners[i2].context !== context) && events.push(listeners[i2]);
      events.length ? this._events[evt] = events.length === 1 ? events[0] : events : clearEvent(this, evt);
    }
    return this;
  }, "removeListener"), EventEmitter2.prototype.removeAllListeners = /* @__PURE__ */ __name(function(event) {
    var evt;
    return event ? (evt = prefix2 ? prefix2 + event : event, this._events[evt] && clearEvent(this, evt)) : (this._events = new Events(), this._eventsCount = 0), this;
  }, "removeAllListeners"), EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener, EventEmitter2.prototype.addListener = EventEmitter2.prototype.on, EventEmitter2.prefixed = prefix2, EventEmitter2.EventEmitter = EventEmitter2, module2.exports = EventEmitter2;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
var eventCenter = new EventEmitter(), SYNC_EVENT = "recharts.syncMouseEvents";
function _typeof$2(o) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$2(o);
}
__name(_typeof$2, "_typeof$2");
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck$1, "_classCallCheck$1");
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor);
  }
}
__name(_defineProperties$1, "_defineProperties$1");
function _createClass$1(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties$1(Constructor.prototype, protoProps), staticProps && _defineProperties$1(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass$1, "_createClass$1");
function _defineProperty$2(obj2, key, value) {
  return key = _toPropertyKey$2(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$2, "_defineProperty$2");
function _toPropertyKey$2(t3) {
  var i2 = _toPrimitive$2(t3, "string");
  return _typeof$2(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$2, "_toPropertyKey$2");
function _toPrimitive$2(t3, r2) {
  if (_typeof$2(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$2(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$2, "_toPrimitive$2");
var AccessibilityManager = /* @__PURE__ */ function() {
  function AccessibilityManager2() {
    _classCallCheck$1(this, AccessibilityManager2), _defineProperty$2(this, "activeIndex", 0), _defineProperty$2(this, "coordinateList", []), _defineProperty$2(this, "layout", "horizontal");
  }
  return __name(AccessibilityManager2, "AccessibilityManager"), _createClass$1(AccessibilityManager2, [{
    key: "setDetails",
    value: /* @__PURE__ */ __name(function(_ref) {
      var _ref2, _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container2 = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout2 = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
      this.coordinateList = (_ref2 = coordinateList ?? this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [], this.container = container2 ?? this.container, this.layout = layout2 ?? this.layout, this.offset = offset ?? this.offset, this.mouseHandlerCallback = mouseHandlerCallback ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }, "setDetails")
  }, {
    key: "focus",
    value: /* @__PURE__ */ __name(function() {
      this.spoofMouse();
    }, "focus")
  }, {
    key: "keyboardEvent",
    value: /* @__PURE__ */ __name(function(e3) {
      if (this.coordinateList.length !== 0)
        switch (e3.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }, "keyboardEvent")
  }, {
    key: "setIndex",
    value: /* @__PURE__ */ __name(function(newIndex) {
      this.activeIndex = newIndex;
    }, "setIndex")
  }, {
    key: "spoofMouse",
    value: /* @__PURE__ */ __name(function() {
      var _window, _window2;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var _this$container$getBo = this.container.getBoundingClientRect(), x3 = _this$container$getBo.x, y4 = _this$container$getBo.y, height2 = _this$container$getBo.height, coordinate = this.coordinateList[this.activeIndex].coordinate, scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0, scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0, pageX = x3 + coordinate + scrollOffsetX, pageY = y4 + this.offset.top + height2 / 2 + scrollOffsetY;
        this.mouseHandlerCallback({
          pageX,
          pageY
        });
      }
    }, "spoofMouse")
  }]), AccessibilityManager2;
}();
function isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
  if (axisType === "number" && allowDataOverflow === !0 && Array.isArray(domain)) {
    var domainStart = domain == null ? void 0 : domain[0], domainEnd = domain == null ? void 0 : domain[1];
    if (domainStart && domainEnd && isNumber(domainStart) && isNumber(domainEnd))
      return !0;
  }
  return !1;
}
__name(isDomainSpecifiedByUser, "isDomainSpecifiedByUser");
function getCursorRectangle(layout2, activeCoordinate, offset, tooltipAxisBandSize) {
  var halfSize = tooltipAxisBandSize / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: layout2 === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
    y: layout2 === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
    width: layout2 === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
    height: layout2 === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
  };
}
__name(getCursorRectangle, "getCursorRectangle");
function getRadialCursorPoints(activeCoordinate) {
  var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle, startPoint = polarToCartesian(cx, cy, radius, startAngle), endPoint = polarToCartesian(cx, cy, radius, endAngle);
  return {
    points: [startPoint, endPoint],
    cx,
    cy,
    radius,
    startAngle,
    endAngle
  };
}
__name(getRadialCursorPoints, "getRadialCursorPoints");
function getCursorPoints(layout2, activeCoordinate, offset) {
  var x1, y1, x22, y22;
  if (layout2 === "horizontal")
    x1 = activeCoordinate.x, x22 = x1, y1 = offset.top, y22 = offset.top + offset.height;
  else if (layout2 === "vertical")
    y1 = activeCoordinate.y, y22 = y1, x1 = offset.left, x22 = offset.left + offset.width;
  else if (activeCoordinate.cx != null && activeCoordinate.cy != null)
    if (layout2 === "centric") {
      var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle, innerPoint = polarToCartesian(cx, cy, innerRadius, angle), outerPoint = polarToCartesian(cx, cy, outerRadius, angle);
      x1 = innerPoint.x, y1 = innerPoint.y, x22 = outerPoint.x, y22 = outerPoint.y;
    } else
      return getRadialCursorPoints(activeCoordinate);
  return [{
    x: x1,
    y: y1
  }, {
    x: x22,
    y: y22
  }];
}
__name(getCursorPoints, "getCursorPoints");
function _typeof$1(o) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$1(o);
}
__name(_typeof$1, "_typeof$1");
function ownKeys$1(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys$1, "ownKeys$1");
function _objectSpread$1(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys$1(Object(t3), !0).forEach(function(r3) {
      _defineProperty$1(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread$1, "_objectSpread$1");
function _defineProperty$1(obj2, key, value) {
  return key = _toPropertyKey$1(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty$1, "_defineProperty$1");
function _toPropertyKey$1(t3) {
  var i2 = _toPrimitive$1(t3, "string");
  return _typeof$1(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey$1, "_toPropertyKey$1");
function _toPrimitive$1(t3, r2) {
  if (_typeof$1(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof$1(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive$1, "_toPrimitive$1");
function Cursor(props) {
  var element2 = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout2 = props.layout, chartName = props.chartName;
  if (!element2 || !element2.props.cursor || !isActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis")
    return null;
  var restProps, cursorComp = Curve;
  if (chartName === "ScatterChart")
    restProps = activeCoordinate, cursorComp = Cross;
  else if (chartName === "BarChart")
    restProps = getCursorRectangle(layout2, activeCoordinate, offset, tooltipAxisBandSize), cursorComp = Rectangle;
  else if (layout2 === "radial") {
    var _getRadialCursorPoint = getRadialCursorPoints(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
    restProps = {
      cx,
      cy,
      startAngle,
      endAngle,
      innerRadius: radius,
      outerRadius: radius
    }, cursorComp = Sector;
  } else
    restProps = {
      points: getCursorPoints(layout2, activeCoordinate, offset)
    }, cursorComp = Curve;
  var cursorProps = _objectSpread$1(_objectSpread$1(_objectSpread$1(_objectSpread$1({
    stroke: "#ccc",
    pointerEvents: "none"
  }, offset), restProps), filterProps(element2.props.cursor, !1)), {}, {
    payload: activePayload,
    payloadIndex: activeTooltipIndex,
    className: clsx("recharts-tooltip-cursor", element2.props.cursor.className)
  });
  return /* @__PURE__ */ isValidElement(element2.props.cursor) ? /* @__PURE__ */ cloneElement(element2.props.cursor, cursorProps) : /* @__PURE__ */ createElement(cursorComp, cursorProps);
}
__name(Cursor, "Cursor");
var _excluded = ["item"], _excluded2 = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
__name(_extends, "_extends");
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableRest, "_nonIterableRest");
function _iterableToArrayLimit(r2, l) {
  var t3 = r2 == null ? null : typeof Symbol < "u" && r2[Symbol.iterator] || r2["@@iterator"];
  if (t3 != null) {
    var e3, n, i2, u2, a4 = [], f = !0, o = !1;
    try {
      if (i2 = (t3 = t3.call(r2)).next, l === 0) {
        if (Object(t3) !== t3)
          return;
        f = !1;
      } else
        for (; !(f = (e3 = i2.call(t3)).done) && (a4.push(e3.value), a4.length !== l); f = !0)
          ;
    } catch (r3) {
      o = !0, n = r3;
    } finally {
      try {
        if (!f && t3.return != null && (u2 = t3.return(), Object(u2) !== u2))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a4;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
__name(_arrayWithHoles, "_arrayWithHoles");
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded), key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++)
      key = sourceSymbolKeys[i2], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++)
    key = sourceKeys[i2], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
__name(_createClass, "_createClass");
function _callSuper(t3, o, e3) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t3, _isNativeReflectConstruct() ? Reflect.construct(o, e3 || [], _getPrototypeOf(t3).constructor) : o.apply(t3, e3));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call == "function"))
    return call;
  if (call !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(self2);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _isNativeReflectConstruct() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function() {
    return !!t3;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(o) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  }, "_getPrototypeOf"), _getPrototypeOf(o);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _assertThisInitialized(self2) {
  if (self2 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self2;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _inherits(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: !0, configurable: !0 } }), Object.defineProperty(subClass, "prototype", { writable: !1 }), superClass && _setPrototypeOf(subClass, superClass);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : /* @__PURE__ */ __name(function(o2, p2) {
    return o2.__proto__ = p2, o2;
  }, "_setPrototypeOf"), _setPrototypeOf(o, p);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _unsupportedIterableToArray(o, minLen) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set")
      return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray(o, minLen);
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _iterableToArray(iter) {
  if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _arrayLikeToArray(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function ownKeys(e3, r2) {
  var t3 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t3.push.apply(t3, o);
  }
  return t3;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = arguments[r2] != null ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t3), !0).forEach(function(r3) {
      _defineProperty(e3, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t3)) : ownKeys(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e3;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(obj2, key, value) {
  return key = _toPropertyKey(key), key in obj2 ? Object.defineProperty(obj2, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj2[key] = value, obj2;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t3) {
  var i2 = _toPrimitive(t3, "string");
  return _typeof(i2) == "symbol" ? i2 : String(i2);
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t3, r2) {
  if (_typeof(t3) != "object" || !t3)
    return t3;
  var e3 = t3[Symbol.toPrimitive];
  if (e3 !== void 0) {
    var i2 = e3.call(t3, r2 || "default");
    if (_typeof(i2) != "object")
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r2 === "string" ? String : Number)(t3);
}
__name(_toPrimitive, "_toPrimitive");
var ORIENT_MAP = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, FULL_WIDTH_AND_HEIGHT = {
  width: "100%",
  height: "100%"
}, originCoordinate = {
  x: 0,
  y: 0
};
function renderAsIs(element2) {
  return element2;
}
__name(renderAsIs, "renderAsIs");
var calculateTooltipPos = /* @__PURE__ */ __name(function(rangeObj, layout2) {
  return layout2 === "horizontal" ? rangeObj.x : layout2 === "vertical" ? rangeObj.y : layout2 === "centric" ? rangeObj.angle : rangeObj.radius;
}, "calculateTooltipPos"), getActiveCoordinate = /* @__PURE__ */ __name(function(layout2, tooltipTicks, activeIndex, rangeObj) {
  var entry = tooltipTicks.find(function(tick) {
    return tick && tick.index === activeIndex;
  });
  if (entry) {
    if (layout2 === "horizontal")
      return {
        x: entry.coordinate,
        y: rangeObj.y
      };
    if (layout2 === "vertical")
      return {
        x: rangeObj.x,
        y: entry.coordinate
      };
    if (layout2 === "centric") {
      var _angle = entry.coordinate, _radius = rangeObj.radius;
      return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
        angle: _angle,
        radius: _radius
      });
    }
    var radius = entry.coordinate, angle = rangeObj.angle;
    return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
      angle,
      radius
    });
  }
  return originCoordinate;
}, "getActiveCoordinate"), getDisplayedData = /* @__PURE__ */ __name(function(data2, _ref) {
  var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex, itemsData = (graphicalItems ?? []).reduce(function(result2, child) {
    var itemData = child.props.data;
    return itemData && itemData.length ? [].concat(_toConsumableArray(result2), _toConsumableArray(itemData)) : result2;
  }, []);
  return itemsData.length > 0 ? itemsData : data2 && data2.length && isNumber(dataStartIndex) && isNumber(dataEndIndex) ? data2.slice(dataStartIndex, dataEndIndex + 1) : [];
}, "getDisplayedData");
function getDefaultDomainByAxisType(axisType) {
  return axisType === "number" ? [0, "auto"] : void 0;
}
__name(getDefaultDomainByAxisType, "getDefaultDomainByAxisType");
var getTooltipContent = /* @__PURE__ */ __name(function(state, chartData, activeIndex, activeLabel) {
  var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis, displayedData = getDisplayedData(chartData, state);
  return activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length ? null : graphicalItems.reduce(function(result2, child) {
    var _child$props$data, data2 = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
    data2 && state.dataStartIndex + state.dataEndIndex !== 0 && (data2 = data2.slice(state.dataStartIndex, state.dataEndIndex + 1));
    var payload;
    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
      var entries = data2 === void 0 ? displayedData : data2;
      payload = findEntryInArray(entries, tooltipAxis.dataKey, activeLabel);
    } else
      payload = data2 && data2[activeIndex] || displayedData[activeIndex];
    return payload ? [].concat(_toConsumableArray(result2), [getTooltipItem(child, payload)]) : result2;
  }, []);
}, "getTooltipContent"), getTooltipData = /* @__PURE__ */ __name(function(state, chartData, layout2, rangeObj) {
  var rangeData = rangeObj || {
    x: state.chartX,
    y: state.chartY
  }, pos = calculateTooltipPos(rangeData, layout2), ticks2 = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks, activeIndex = calculateActiveTickIndex(pos, ticks2, tooltipTicks, axis);
  if (activeIndex >= 0 && tooltipTicks) {
    var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value, activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel), activeCoordinate = getActiveCoordinate(layout2, ticks2, activeIndex, rangeData);
    return {
      activeTooltipIndex: activeIndex,
      activeLabel,
      activePayload,
      activeCoordinate
    };
  }
  return null;
}, "getTooltipData"), getAxisMapByAxes = /* @__PURE__ */ __name(function(props, _ref2) {
  var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex, layout2 = props.layout, children = props.children, stackOffset = props.stackOffset, isCategorical = isCategoricalAxis(layout2, axisType);
  return axes.reduce(function(result2, child) {
    var _child$props$domain2, _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale2 = _child$props.scale, ticks2 = _child$props.ticks, includeHidden = _child$props.includeHidden, axisId = child.props[axisIdKey];
    if (result2[axisId])
      return result2;
    var displayedData = getDisplayedData(props.data, {
      graphicalItems: graphicalItems.filter(function(item) {
        return item.props[axisIdKey] === axisId;
      }),
      dataStartIndex,
      dataEndIndex
    }), len = displayedData.length, domain, duplicateDomain, categoricalDomain;
    isDomainSpecifiedByUser(child.props.domain, allowDataOverflow, type) && (domain = parseSpecifiedDomain(child.props.domain, null, allowDataOverflow), isCategorical && (type === "number" || scale2 !== "auto") && (categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, "category")));
    var defaultDomain = getDefaultDomainByAxisType(type);
    if (!domain || domain.length === 0) {
      var _child$props$domain, childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
      if (dataKey) {
        if (domain = getDomainOfDataByKey(displayedData, dataKey, type), type === "category" && isCategorical) {
          var duplicate = hasDuplicate(domain);
          allowDuplicatedCategory && duplicate ? (duplicateDomain = domain, domain = range$1(0, len)) : allowDuplicatedCategory || (domain = parseDomainOfCategoryAxis(childDomain, domain, child).reduce(function(finalDomain, entry) {
            return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
          }, []));
        } else if (type === "category")
          allowDuplicatedCategory ? domain = domain.filter(function(entry) {
            return entry !== "" && !isNil$1(entry);
          }) : domain = parseDomainOfCategoryAxis(childDomain, domain, child).reduce(function(finalDomain, entry) {
            return finalDomain.indexOf(entry) >= 0 || entry === "" || isNil$1(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
          }, []);
        else if (type === "number") {
          var errorBarsDomain = parseErrorBarsOfAxis(displayedData, graphicalItems.filter(function(item) {
            return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
          }), dataKey, axisType, layout2);
          errorBarsDomain && (domain = errorBarsDomain);
        }
        isCategorical && (type === "number" || scale2 !== "auto") && (categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, "category"));
      } else
        isCategorical ? domain = range$1(0, len) : stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number" ? domain = stackOffset === "expand" ? [0, 1] : getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex) : domain = getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function(item) {
          return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
        }), type, layout2, !0);
      if (type === "number")
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType, ticks2), childDomain && (domain = parseSpecifiedDomain(childDomain, domain, allowDataOverflow));
      else if (type === "category" && childDomain) {
        var axisDomain = childDomain, isDomainValid = domain.every(function(entry) {
          return axisDomain.indexOf(entry) >= 0;
        });
        isDomainValid && (domain = axisDomain);
      }
    }
    return _objectSpread(_objectSpread({}, result2), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({}, child.props), {}, {
      axisType,
      domain,
      categoricalDomain,
      duplicateDomain,
      originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
      isCategorical,
      layout: layout2
    })));
  }, {});
}, "getAxisMapByAxes"), getAxisMapByItems = /* @__PURE__ */ __name(function(props, _ref3) {
  var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex, layout2 = props.layout, children = props.children, displayedData = getDisplayedData(props.data, {
    graphicalItems,
    dataStartIndex,
    dataEndIndex
  }), len = displayedData.length, isCategorical = isCategoricalAxis(layout2, axisType), index2 = -1;
  return graphicalItems.reduce(function(result2, child) {
    var axisId = child.props[axisIdKey], originalDomain = getDefaultDomainByAxisType("number");
    if (!result2[axisId]) {
      index2++;
      var domain;
      return isCategorical ? domain = range$1(0, len) : stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack ? (domain = getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex), domain = detectReferenceElementsDomain(children, domain, axisId, axisType)) : (domain = parseSpecifiedDomain(originalDomain, getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function(item) {
        return item.props[axisIdKey] === axisId && !item.props.hide;
      }), "number", layout2), Axis.defaultProps.allowDataOverflow), domain = detectReferenceElementsDomain(children, domain, axisId, axisType)), _objectSpread(_objectSpread({}, result2), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({
        axisType
      }, Axis.defaultProps), {}, {
        hide: !0,
        orientation: get$2(ORIENT_MAP, "".concat(axisType, ".").concat(index2 % 2), null),
        domain,
        originalDomain,
        isCategorical,
        layout: layout2
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return result2;
  }, {});
}, "getAxisMapByItems"), getAxisMap = /* @__PURE__ */ __name(function(props, _ref4) {
  var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex, children = props.children, axisIdKey = "".concat(axisType, "Id"), axes = findAllByType(children, AxisComp), axisMap = {};
  return axes && axes.length ? axisMap = getAxisMapByAxes(props, {
    axes,
    graphicalItems,
    axisType,
    axisIdKey,
    stackGroups,
    dataStartIndex,
    dataEndIndex
  }) : graphicalItems && graphicalItems.length && (axisMap = getAxisMapByItems(props, {
    Axis: AxisComp,
    graphicalItems,
    axisType,
    axisIdKey,
    stackGroups,
    dataStartIndex,
    dataEndIndex
  })), axisMap;
}, "getAxisMap"), tooltipTicksGenerator = /* @__PURE__ */ __name(function(axisMap) {
  var axis = getAnyElementOfObject(axisMap), tooltipTicks = getTicksOfAxis(axis, !1, !0);
  return {
    tooltipTicks,
    orderedTooltipTicks: sortBy$1(tooltipTicks, function(o) {
      return o.coordinate;
    }),
    tooltipAxis: axis,
    tooltipAxisBandSize: getBandSizeOfAxis(axis, tooltipTicks)
  };
}, "tooltipTicksGenerator"), createDefaultState = /* @__PURE__ */ __name(function(props) {
  var children = props.children, defaultShowTooltip = props.defaultShowTooltip, brushItem = findChildByType(children, Brush), startIndex = 0, endIndex = 0;
  return props.data && props.data.length !== 0 && (endIndex = props.data.length - 1), brushItem && brushItem.props && (brushItem.props.startIndex >= 0 && (startIndex = brushItem.props.startIndex), brushItem.props.endIndex >= 0 && (endIndex = brushItem.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: startIndex,
    dataEndIndex: endIndex,
    activeTooltipIndex: -1,
    isTooltipActive: !!defaultShowTooltip
  };
}, "createDefaultState"), hasGraphicalBarItem = /* @__PURE__ */ __name(function(graphicalItems) {
  return !graphicalItems || !graphicalItems.length ? !1 : graphicalItems.some(function(item) {
    var name2 = getDisplayName(item && item.type);
    return name2 && name2.indexOf("Bar") >= 0;
  });
}, "hasGraphicalBarItem"), getAxisNameByLayout = /* @__PURE__ */ __name(function(layout2) {
  return layout2 === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : layout2 === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : layout2 === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, "getAxisNameByLayout"), calculateOffset = /* @__PURE__ */ __name(function(_ref5, prevLegendBBox) {
  var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap, width2 = props.width, height2 = props.height, children = props.children, margin2 = props.margin || {}, brushItem = findChildByType(children, Brush), legendItem = findChildByType(children, Legend), offsetH = Object.keys(yAxisMap).reduce(function(result2, id2) {
    var entry = yAxisMap[id2], orientation = entry.orientation;
    return !entry.mirror && !entry.hide ? _objectSpread(_objectSpread({}, result2), {}, _defineProperty({}, orientation, result2[orientation] + entry.width)) : result2;
  }, {
    left: margin2.left || 0,
    right: margin2.right || 0
  }), offsetV = Object.keys(xAxisMap).reduce(function(result2, id2) {
    var entry = xAxisMap[id2], orientation = entry.orientation;
    return !entry.mirror && !entry.hide ? _objectSpread(_objectSpread({}, result2), {}, _defineProperty({}, orientation, get$2(result2, "".concat(orientation)) + entry.height)) : result2;
  }, {
    top: margin2.top || 0,
    bottom: margin2.bottom || 0
  }), offset = _objectSpread(_objectSpread({}, offsetV), offsetH), brushBottom = offset.bottom;
  brushItem && (offset.bottom += brushItem.props.height || Brush.defaultProps.height), legendItem && prevLegendBBox && (offset = appendOffsetOfLegend(offset, graphicalItems, props, prevLegendBBox));
  var offsetWidth = width2 - offset.left - offset.right, offsetHeight = height2 - offset.top - offset.bottom;
  return _objectSpread(_objectSpread({
    brushBottom
  }, offset), {}, {
    // never return negative values for height and width
    width: Math.max(offsetWidth, 0),
    height: Math.max(offsetHeight, 0)
  });
}, "calculateOffset"), getCartesianAxisSize = /* @__PURE__ */ __name(function(axisObj, axisName) {
  if (axisName === "xAxis")
    return axisObj[axisName].width;
  if (axisName === "yAxis")
    return axisObj[axisName].height;
}, "getCartesianAxisSize"), generateCategoricalChart = /* @__PURE__ */ __name(function(_ref6) {
  var _CategoricalChartWrapper, chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? ["axis"] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap3 = _ref6.formatAxisMap, defaultProps2 = _ref6.defaultProps, getFormatItems = /* @__PURE__ */ __name(function(props, currentState) {
    var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex, barSize = props.barSize, layout2 = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize, _getAxisNameByLayout = getAxisNameByLayout(layout2), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName, hasBar = hasGraphicalBarItem(graphicalItems), formattedItems = [];
    return graphicalItems.forEach(function(item, index2) {
      var displayedData = getDisplayedData(props.data, {
        graphicalItems: [item],
        dataStartIndex,
        dataEndIndex
      }), _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize, numericAxisId = item.props["".concat(numericAxisName, "Id")], cateAxisId = item.props["".concat(cateAxisName, "Id")], axisObjInitialValue = {}, axisObj = axisComponents.reduce(function(result2, entry) {
        var _item$type$displayNam, _item$type, axisMap = currentState["".concat(entry.axisType, "Map")], id2 = item.props["".concat(entry.axisType, "Id")];
        axisMap && axisMap[id2] || entry.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? invariant(!1, "Specifying a(n) ".concat(entry.axisType, "Id requires a corresponding ").concat(
          entry.axisType,
          "Id on the targeted graphical component "
        ).concat((_item$type$displayNam = item == null || (_item$type = item.type) === null || _item$type === void 0 ? void 0 : _item$type.displayName) !== null && _item$type$displayNam !== void 0 ? _item$type$displayNam : "")) : invariant(!1));
        var axis = axisMap[id2];
        return _objectSpread(_objectSpread({}, result2), {}, _defineProperty(_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), getTicksOfAxis(axis)));
      }, axisObjInitialValue), cateAxis = axisObj[cateAxisName], cateTicks = axisObj["".concat(cateAxisName, "Ticks")], stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && getStackedDataOfItem(item, stackGroups[numericAxisId].stackGroups), itemIsBar = getDisplayName(item.type).indexOf("Bar") >= 0, bandSize = getBandSizeOfAxis(cateAxis, cateTicks), barPosition = [], sizeList = hasBar && getBarSizeList({
        barSize,
        stackGroups,
        totalSize: getCartesianAxisSize(axisObj, cateAxisName)
      });
      if (itemIsBar) {
        var _ref7, _getBandSizeOfAxis, maxBarSize = isNil$1(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize, barBandSize = (_ref7 = (_getBandSizeOfAxis = getBandSizeOfAxis(cateAxis, cateTicks, !0)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
        barPosition = getBarPosition({
          barGap,
          barCategoryGap,
          bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
          sizeList: sizeList[cateAxisId],
          maxBarSize
        }), barBandSize !== bandSize && (barPosition = barPosition.map(function(pos) {
          return _objectSpread(_objectSpread({}, pos), {}, {
            position: _objectSpread(_objectSpread({}, pos.position), {}, {
              offset: pos.position.offset - barBandSize / 2
            })
          });
        }));
      }
      var composedFn = item && item.type && item.type.getComposedData;
      composedFn && formattedItems.push({
        props: _objectSpread(_objectSpread({}, composedFn(_objectSpread(_objectSpread({}, axisObj), {}, {
          displayedData,
          props,
          dataKey,
          item,
          bandSize,
          barPosition,
          offset,
          stackedData,
          layout: layout2,
          dataStartIndex,
          dataEndIndex
        }))), {}, _defineProperty(_defineProperty(_defineProperty({
          key: item.key || "item-".concat(index2)
        }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
        childIndex: parseChildIndex(item, props.children),
        item
      });
    }), formattedItems;
  }, "getFormatItems"), updateStateOfAxisMapsOffsetAndStackGroups = /* @__PURE__ */ __name(function(_ref8, prevState) {
    var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
    if (!validateWidthHeight({
      props
    }))
      return null;
    var children = props.children, layout2 = props.layout, stackOffset = props.stackOffset, data2 = props.data, reverseStackOrder = props.reverseStackOrder, _getAxisNameByLayout2 = getAxisNameByLayout(layout2), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName, graphicalItems = findAllByType(children, GraphicalChild), stackGroups = getStackGroupsByAxisId(data2, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder), axisObj = axisComponents.reduce(function(result2, entry) {
      var name2 = "".concat(entry.axisType, "Map");
      return _objectSpread(_objectSpread({}, result2), {}, _defineProperty({}, name2, getAxisMap(props, _objectSpread(_objectSpread({}, entry), {}, {
        graphicalItems,
        stackGroups: entry.axisType === numericAxisName && stackGroups,
        dataStartIndex,
        dataEndIndex
      }))));
    }, {}), offset = calculateOffset(_objectSpread(_objectSpread({}, axisObj), {}, {
      props,
      graphicalItems
    }), prevState == null ? void 0 : prevState.legendBBox);
    Object.keys(axisObj).forEach(function(key) {
      axisObj[key] = formatAxisMap3(props, axisObj[key], offset, key.replace("Map", ""), chartName);
    });
    var cateAxisMap = axisObj["".concat(cateAxisName, "Map")], ticksObj = tooltipTicksGenerator(cateAxisMap), formattedGraphicalItems = getFormatItems(props, _objectSpread(_objectSpread({}, axisObj), {}, {
      dataStartIndex,
      dataEndIndex,
      updateId,
      graphicalItems,
      stackGroups,
      offset
    }));
    return _objectSpread(_objectSpread({
      formattedGraphicalItems,
      graphicalItems,
      offset,
      stackGroups
    }, ticksObj), axisObj);
  }, "updateStateOfAxisMapsOffsetAndStackGroups");
  return _CategoricalChartWrapper = /* @__PURE__ */ function(_Component) {
    _inherits(CategoricalChartWrapper, _Component);
    function CategoricalChartWrapper(_props) {
      var _props$id, _props$throttleDelay, _this;
      return _classCallCheck(this, CategoricalChartWrapper), _this = _callSuper(this, CategoricalChartWrapper, [_props]), _defineProperty(_assertThisInitialized(_this), "eventEmitterSymbol", Symbol("rechartsEventEmitter")), _defineProperty(_assertThisInitialized(_this), "accessibilityManager", new AccessibilityManager()), _defineProperty(_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
        if (box) {
          var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
          _this.setState(_objectSpread({
            legendBBox: box
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex,
            dataEndIndex,
            updateId
          }, _objectSpread(_objectSpread({}, _this.state), {}, {
            legendBBox: box
          }))));
        }
      }), _defineProperty(_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, data2, emitter) {
        if (_this.props.syncId === cId) {
          if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod != "function")
            return;
          _this.applySyncEvent(data2);
        }
      }), _defineProperty(_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
        var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
          var updateId = _this.state.updateId;
          _this.setState(function() {
            return _objectSpread({
              dataStartIndex: startIndex,
              dataEndIndex: endIndex
            }, updateStateOfAxisMapsOffsetAndStackGroups({
              props: _this.props,
              dataStartIndex: startIndex,
              dataEndIndex: endIndex,
              updateId
            }, _this.state));
          }), _this.triggerSyncEvent({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          });
        }
      }), _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function(e3) {
        var mouse = _this.getMouseInfo(e3);
        if (mouse) {
          var _nextState = _objectSpread(_objectSpread({}, mouse), {}, {
            isTooltipActive: !0
          });
          _this.setState(_nextState), _this.triggerSyncEvent(_nextState);
          var onMouseEnter = _this.props.onMouseEnter;
          isFunction$3(onMouseEnter) && onMouseEnter(_nextState, e3);
        }
      }), _defineProperty(_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e3) {
        var mouse = _this.getMouseInfo(e3), nextState = mouse ? _objectSpread(_objectSpread({}, mouse), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        _this.setState(nextState), _this.triggerSyncEvent(nextState);
        var onMouseMove = _this.props.onMouseMove;
        isFunction$3(onMouseMove) && onMouseMove(nextState, e3);
      }), _defineProperty(_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
        _this.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: el,
            activePayload: el.tooltipPayload,
            activeCoordinate: el.tooltipPosition || {
              x: el.cx,
              y: el.cy
            }
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "handleItemMouseLeave", function() {
        _this.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function(e3) {
        e3.persist(), _this.throttleTriggeredAfterMouseMove(e3);
      }), _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function(e3) {
        _this.throttleTriggeredAfterMouseMove.cancel();
        var nextState = {
          isTooltipActive: !1
        };
        _this.setState(nextState), _this.triggerSyncEvent(nextState);
        var onMouseLeave = _this.props.onMouseLeave;
        isFunction$3(onMouseLeave) && onMouseLeave(nextState, e3);
      }), _defineProperty(_assertThisInitialized(_this), "handleOuterEvent", function(e3) {
        var eventName = getReactEventByType(e3), event = get$2(_this.props, "".concat(eventName));
        if (eventName && isFunction$3(event)) {
          var _mouse, mouse;
          /.*touch.*/i.test(eventName) ? mouse = _this.getMouseInfo(e3.changedTouches[0]) : mouse = _this.getMouseInfo(e3), event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e3);
        }
      }), _defineProperty(_assertThisInitialized(_this), "handleClick", function(e3) {
        var mouse = _this.getMouseInfo(e3);
        if (mouse) {
          var _nextState2 = _objectSpread(_objectSpread({}, mouse), {}, {
            isTooltipActive: !0
          });
          _this.setState(_nextState2), _this.triggerSyncEvent(_nextState2);
          var onClick2 = _this.props.onClick;
          isFunction$3(onClick2) && onClick2(_nextState2, e3);
        }
      }), _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function(e3) {
        var onMouseDown = _this.props.onMouseDown;
        if (isFunction$3(onMouseDown)) {
          var _nextState3 = _this.getMouseInfo(e3);
          onMouseDown(_nextState3, e3);
        }
      }), _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function(e3) {
        var onMouseUp = _this.props.onMouseUp;
        if (isFunction$3(onMouseUp)) {
          var _nextState4 = _this.getMouseInfo(e3);
          onMouseUp(_nextState4, e3);
        }
      }), _defineProperty(_assertThisInitialized(_this), "handleTouchMove", function(e3) {
        e3.changedTouches != null && e3.changedTouches.length > 0 && _this.throttleTriggeredAfterMouseMove(e3.changedTouches[0]);
      }), _defineProperty(_assertThisInitialized(_this), "handleTouchStart", function(e3) {
        e3.changedTouches != null && e3.changedTouches.length > 0 && _this.handleMouseDown(e3.changedTouches[0]);
      }), _defineProperty(_assertThisInitialized(_this), "handleTouchEnd", function(e3) {
        e3.changedTouches != null && e3.changedTouches.length > 0 && _this.handleMouseUp(e3.changedTouches[0]);
      }), _defineProperty(_assertThisInitialized(_this), "triggerSyncEvent", function(data2) {
        _this.props.syncId !== void 0 && eventCenter.emit(SYNC_EVENT, _this.props.syncId, data2, _this.eventEmitterSymbol);
      }), _defineProperty(_assertThisInitialized(_this), "applySyncEvent", function(data2) {
        var _this$props = _this.props, layout2 = _this$props.layout, syncMethod = _this$props.syncMethod, updateId = _this.state.updateId, dataStartIndex = data2.dataStartIndex, dataEndIndex = data2.dataEndIndex;
        if (data2.dataStartIndex !== void 0 || data2.dataEndIndex !== void 0)
          _this.setState(_objectSpread({
            dataStartIndex,
            dataEndIndex
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex,
            dataEndIndex,
            updateId
          }, _this.state)));
        else if (data2.activeTooltipIndex !== void 0) {
          var chartX = data2.chartX, chartY = data2.chartY, activeTooltipIndex = data2.activeTooltipIndex, _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
          if (!offset)
            return;
          if (typeof syncMethod == "function")
            activeTooltipIndex = syncMethod(tooltipTicks, data2);
          else if (syncMethod === "value") {
            activeTooltipIndex = -1;
            for (var i2 = 0; i2 < tooltipTicks.length; i2++)
              if (tooltipTicks[i2].value === data2.activeLabel) {
                activeTooltipIndex = i2;
                break;
              }
          }
          var viewBox = _objectSpread(_objectSpread({}, offset), {}, {
            x: offset.left,
            y: offset.top
          }), validateChartX = Math.min(chartX, viewBox.x + viewBox.width), validateChartY = Math.min(chartY, viewBox.y + viewBox.height), activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value, activePayload = getTooltipContent(_this.state, _this.props.data, activeTooltipIndex), activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
            x: layout2 === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
            y: layout2 === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
          } : originCoordinate;
          _this.setState(_objectSpread(_objectSpread({}, data2), {}, {
            activeLabel,
            activeCoordinate,
            activePayload,
            activeTooltipIndex
          }));
        } else
          _this.setState(data2);
      }), _defineProperty(_assertThisInitialized(_this), "renderCursor", function(element2) {
        var _element$props$active, _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize, tooltipEventType = _this.getTooltipEventType(), isActive = (_element$props$active = element2.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive, layout2 = _this.props.layout, key = element2.key || "_recharts-cursor";
        return /* @__PURE__ */ React__default.createElement(Cursor, {
          key,
          activeCoordinate,
          activePayload,
          activeTooltipIndex,
          chartName,
          element: element2,
          isActive,
          layout: layout2,
          offset,
          tooltipAxisBandSize,
          tooltipEventType
        });
      }), _defineProperty(_assertThisInitialized(_this), "renderPolarAxis", function(element2, displayName, index2) {
        var axisType = get$2(element2, "type.axisType"), axisMap = get$2(_this.state, "".concat(axisType, "Map")), axisOption = axisMap && axisMap[element2.props["".concat(axisType, "Id")]];
        return /* @__PURE__ */ cloneElement(element2, _objectSpread(_objectSpread({}, axisOption), {}, {
          className: clsx(axisType, axisOption.className),
          key: element2.key || "".concat(displayName, "-").concat(index2),
          ticks: getTicksOfAxis(axisOption, !0)
        }));
      }), _defineProperty(_assertThisInitialized(_this), "renderPolarGrid", function(element2) {
        var _element$props = element2.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius, _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap, radiusAxis = getAnyElementOfObject(radiusAxisMap), angleAxis = getAnyElementOfObject(angleAxisMap), cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
        return /* @__PURE__ */ cloneElement(element2, {
          polarAngles: Array.isArray(polarAngles) ? polarAngles : getTicksOfAxis(angleAxis, !0).map(function(entry) {
            return entry.coordinate;
          }),
          polarRadius: Array.isArray(polarRadius) ? polarRadius : getTicksOfAxis(radiusAxis, !0).map(function(entry) {
            return entry.coordinate;
          }),
          cx,
          cy,
          innerRadius,
          outerRadius,
          key: element2.key || "polar-grid",
          radialLines
        });
      }), _defineProperty(_assertThisInitialized(_this), "renderLegend", function() {
        var formattedGraphicalItems = _this.state.formattedGraphicalItems, _this$props2 = _this.props, children = _this$props2.children, width2 = _this$props2.width, height2 = _this$props2.height, margin2 = _this.props.margin || {}, legendWidth = width2 - (margin2.left || 0) - (margin2.right || 0), props = getLegendProps({
          children,
          formattedGraphicalItems,
          legendWidth,
          legendContent
        });
        if (!props)
          return null;
        var item = props.item, otherProps = _objectWithoutProperties(props, _excluded);
        return /* @__PURE__ */ cloneElement(item, _objectSpread(_objectSpread({}, otherProps), {}, {
          chartWidth: width2,
          chartHeight: height2,
          margin: margin2,
          onBBoxUpdate: _this.handleLegendBBoxUpdate
        }));
      }), _defineProperty(_assertThisInitialized(_this), "renderTooltip", function() {
        var _tooltipItem$props$ac, _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer, tooltipItem = findChildByType(children, Tooltip);
        if (!tooltipItem)
          return null;
        var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset, isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
        return /* @__PURE__ */ cloneElement(tooltipItem, {
          viewBox: _objectSpread(_objectSpread({}, offset), {}, {
            x: offset.left,
            y: offset.top
          }),
          active: isActive,
          label: activeLabel,
          payload: isActive ? activePayload : [],
          coordinate: activeCoordinate,
          accessibilityLayer
        });
      }), _defineProperty(_assertThisInitialized(_this), "renderBrush", function(element2) {
        var _this$props4 = _this.props, margin2 = _this$props4.margin, data2 = _this$props4.data, _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
        return /* @__PURE__ */ cloneElement(element2, {
          key: element2.key || "_recharts-brush",
          onChange: combineEventHandlers(_this.handleBrushChange, element2.props.onChange),
          data: data2,
          x: isNumber(element2.props.x) ? element2.props.x : offset.left,
          y: isNumber(element2.props.y) ? element2.props.y : offset.top + offset.height + offset.brushBottom - (margin2.bottom || 0),
          width: isNumber(element2.props.width) ? element2.props.width : offset.width,
          startIndex: dataStartIndex,
          endIndex: dataEndIndex,
          updateId: "brush-".concat(updateId)
        });
      }), _defineProperty(_assertThisInitialized(_this), "renderReferenceElement", function(element2, displayName, index2) {
        if (!element2)
          return null;
        var _assertThisInitialize = _assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId, _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset, _element$props2 = element2.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
        return /* @__PURE__ */ cloneElement(element2, {
          key: element2.key || "".concat(displayName, "-").concat(index2),
          xAxis: xAxisMap[xAxisId],
          yAxis: yAxisMap[yAxisId],
          viewBox: {
            x: offset.left,
            y: offset.top,
            width: offset.width,
            height: offset.height
          },
          clipPathId
        });
      }), _defineProperty(_assertThisInitialized(_this), "renderActivePoints", function(_ref10) {
        var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange, result2 = [], key = item.props.key, _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey, dotProps = _objectSpread(_objectSpread({
          index: childIndex,
          dataKey,
          cx: activePoint.x,
          cy: activePoint.y,
          r: 4,
          fill: getMainColorOfGraphicItem(item.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: activePoint.payload,
          value: activePoint.value,
          key: "".concat(key, "-activePoint-").concat(childIndex)
        }, filterProps(activeDot, !1)), adaptEventHandlers(activeDot));
        return result2.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps)), basePoint ? result2.push(CategoricalChartWrapper.renderActiveDot(activeDot, _objectSpread(_objectSpread({}, dotProps), {}, {
          cx: basePoint.x,
          cy: basePoint.y,
          key: "".concat(key, "-basePoint-").concat(childIndex)
        }))) : isRange && result2.push(null), result2;
      }), _defineProperty(_assertThisInitialized(_this), "renderGraphicChild", function(element2, displayName, index2) {
        var item = _this.filterFormatItem(element2, displayName, index2);
        if (!item)
          return null;
        var tooltipEventType = _this.getTooltipEventType(), _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel, children = _this.props.children, tooltipItem = findChildByType(children, Tooltip), _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine, _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide, activeBar = _item$item$props2.activeBar, activeShape = _item$item$props2.activeShape, hasActive = !!(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape)), itemEvents = {};
        tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click" ? itemEvents = {
          onClick: combineEventHandlers(_this.handleItemMouseEnter, element2.props.onClick)
        } : tooltipEventType !== "axis" && (itemEvents = {
          onMouseLeave: combineEventHandlers(_this.handleItemMouseLeave, element2.props.onMouseLeave),
          onMouseEnter: combineEventHandlers(_this.handleItemMouseEnter, element2.props.onMouseEnter)
        });
        var graphicalItem = /* @__PURE__ */ cloneElement(element2, _objectSpread(_objectSpread({}, item.props), itemEvents));
        function findWithPayload(entry) {
          return typeof tooltipAxis.dataKey == "function" ? tooltipAxis.dataKey(entry.payload) : null;
        }
        if (__name(findWithPayload, "findWithPayload"), hasActive)
          if (activeTooltipIndex >= 0) {
            var activePoint, basePoint;
            if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
              var specifiedKey = typeof tooltipAxis.dataKey == "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
              activePoint = findEntryInArray(points, specifiedKey, activeLabel), basePoint = isRange && baseLine && findEntryInArray(baseLine, specifiedKey, activeLabel);
            } else
              activePoint = points == null ? void 0 : points[activeTooltipIndex], basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
            if (activeShape || activeBar) {
              var activeIndex = element2.props.activeIndex !== void 0 ? element2.props.activeIndex : activeTooltipIndex;
              return [/* @__PURE__ */ cloneElement(element2, _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                activeIndex
              })), null, null];
            }
            if (!isNil$1(activePoint))
              return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
                item,
                activePoint,
                basePoint,
                childIndex: activeTooltipIndex,
                isRange
              })));
          } else {
            var _this$getItemByXY, _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
              graphicalItem
            }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element2 : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex, elementProps = _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
              activeIndex: childIndex
            });
            return [/* @__PURE__ */ cloneElement(xyItem, elementProps), null, null];
          }
        return isRange ? [graphicalItem, null, null] : [graphicalItem, null];
      }), _defineProperty(_assertThisInitialized(_this), "renderCustomized", function(element2, displayName, index2) {
        return /* @__PURE__ */ cloneElement(element2, _objectSpread(_objectSpread({
          key: "recharts-customized-".concat(index2)
        }, _this.props), _this.state));
      }), _defineProperty(_assertThisInitialized(_this), "renderMap", {
        CartesianGrid: {
          handler: renderAsIs,
          once: !0
        },
        ReferenceArea: {
          handler: _this.renderReferenceElement
        },
        ReferenceLine: {
          handler: renderAsIs
        },
        ReferenceDot: {
          handler: _this.renderReferenceElement
        },
        XAxis: {
          handler: renderAsIs
        },
        YAxis: {
          handler: renderAsIs
        },
        Brush: {
          handler: _this.renderBrush,
          once: !0
        },
        Bar: {
          handler: _this.renderGraphicChild
        },
        Line: {
          handler: _this.renderGraphicChild
        },
        Area: {
          handler: _this.renderGraphicChild
        },
        Radar: {
          handler: _this.renderGraphicChild
        },
        RadialBar: {
          handler: _this.renderGraphicChild
        },
        Scatter: {
          handler: _this.renderGraphicChild
        },
        Pie: {
          handler: _this.renderGraphicChild
        },
        Funnel: {
          handler: _this.renderGraphicChild
        },
        Tooltip: {
          handler: _this.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: _this.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: _this.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: _this.renderPolarAxis
        },
        Customized: {
          handler: _this.renderCustomized
        }
      }), _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : uniqueId("recharts"), "-clip"), _this.throttleTriggeredAfterMouseMove = throttle$1(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1e3 / 60), _this.state = {}, _this;
    }
    return __name(CategoricalChartWrapper, "CategoricalChartWrapper"), _createClass(CategoricalChartWrapper, [{
      key: "componentDidMount",
      value: /* @__PURE__ */ __name(function() {
        var _this$props$margin$le, _this$props$margin$to;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }, "componentDidMount")
    }, {
      key: "displayDefaultTooltip",
      value: /* @__PURE__ */ __name(function() {
        var _this$props5 = this.props, children = _this$props5.children, data2 = _this$props5.data, height2 = _this$props5.height, layout2 = _this$props5.layout, tooltipElem = findChildByType(children, Tooltip);
        if (tooltipElem) {
          var defaultIndex = tooltipElem.props.defaultIndex;
          if (!(typeof defaultIndex != "number" || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length)) {
            var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value, activePayload = getTooltipContent(this.state, data2, defaultIndex, activeLabel), independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate, dependentAxisCoord = (this.state.offset.top + height2) / 2, isHorizontal = layout2 === "horizontal", activeCoordinate = isHorizontal ? {
              x: independentAxisCoord,
              y: dependentAxisCoord
            } : {
              y: independentAxisCoord,
              x: dependentAxisCoord
            }, scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
              var item = _ref12.item;
              return item.type.name === "Scatter";
            });
            scatterPlotElement && (activeCoordinate = _objectSpread(_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition), activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload);
            var nextState = {
              activeTooltipIndex: defaultIndex,
              isTooltipActive: !0,
              activeLabel,
              activePayload,
              activeCoordinate
            };
            this.setState(nextState), this.renderCursor(tooltipElem), this.accessibilityManager.setIndex(defaultIndex);
          }
        }
      }, "displayDefaultTooltip")
    }, {
      key: "getSnapshotBeforeUpdate",
      value: /* @__PURE__ */ __name(function(prevProps, prevState) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== prevState.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== prevProps.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== prevProps.margin) {
          var _this$props$margin$le2, _this$props$margin$to2;
          this.accessibilityManager.setDetails({
            offset: {
              left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
              top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
            }
          });
        }
        return null;
      }, "getSnapshotBeforeUpdate")
    }, {
      key: "componentDidUpdate",
      value: /* @__PURE__ */ __name(function(prevProps) {
        isChildrenEqual([findChildByType(prevProps.children, Tooltip)], [findChildByType(this.props.children, Tooltip)]) || this.displayDefaultTooltip();
      }, "componentDidUpdate")
    }, {
      key: "componentWillUnmount",
      value: /* @__PURE__ */ __name(function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }, "componentWillUnmount")
    }, {
      key: "getTooltipEventType",
      value: /* @__PURE__ */ __name(function() {
        var tooltipItem = findChildByType(this.props.children, Tooltip);
        if (tooltipItem && typeof tooltipItem.props.shared == "boolean") {
          var eventType = tooltipItem.props.shared ? "axis" : "item";
          return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
        }
        return defaultTooltipEventType;
      }, "getTooltipEventType")
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: /* @__PURE__ */ __name(function(event) {
        if (!this.container)
          return null;
        var element2 = this.container, boundingRect = element2.getBoundingClientRect(), containerOffset = getOffset(boundingRect), e3 = {
          chartX: Math.round(event.pageX - containerOffset.left),
          chartY: Math.round(event.pageY - containerOffset.top)
        }, scale2 = boundingRect.width / element2.offsetWidth || 1, rangeObj = this.inRange(e3.chartX, e3.chartY, scale2);
        if (!rangeObj)
          return null;
        var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap, tooltipEventType = this.getTooltipEventType();
        if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
          var xScale = getAnyElementOfObject(xAxisMap).scale, yScale = getAnyElementOfObject(yAxisMap).scale, xValue = xScale && xScale.invert ? xScale.invert(e3.chartX) : null, yValue = yScale && yScale.invert ? yScale.invert(e3.chartY) : null;
          return _objectSpread(_objectSpread({}, e3), {}, {
            xValue,
            yValue
          });
        }
        var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
        return toolTipData ? _objectSpread(_objectSpread({}, e3), toolTipData) : null;
      }, "getMouseInfo")
    }, {
      key: "inRange",
      value: /* @__PURE__ */ __name(function(x3, y4) {
        var scale2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, layout2 = this.props.layout, scaledX = x3 / scale2, scaledY = y4 / scale2;
        if (layout2 === "horizontal" || layout2 === "vertical") {
          var offset = this.state.offset, isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
          return isInRange ? {
            x: scaledX,
            y: scaledY
          } : null;
        }
        var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
        if (angleAxisMap && radiusAxisMap) {
          var angleAxis = getAnyElementOfObject(angleAxisMap);
          return inRangeOfSector({
            x: scaledX,
            y: scaledY
          }, angleAxis);
        }
        return null;
      }, "inRange")
    }, {
      key: "parseEventsOfWrapper",
      value: /* @__PURE__ */ __name(function() {
        var children = this.props.children, tooltipEventType = this.getTooltipEventType(), tooltipItem = findChildByType(children, Tooltip), tooltipEvents = {};
        tooltipItem && tooltipEventType === "axis" && (tooltipItem.props.trigger === "click" ? tooltipEvents = {
          onClick: this.handleClick
        } : tooltipEvents = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        });
        var outerEvents = adaptEventHandlers(this.props, this.handleOuterEvent);
        return _objectSpread(_objectSpread({}, outerEvents), tooltipEvents);
      }, "parseEventsOfWrapper")
    }, {
      key: "addListener",
      value: /* @__PURE__ */ __name(function() {
        eventCenter.on(SYNC_EVENT, this.handleReceiveSyncEvent);
      }, "addListener")
    }, {
      key: "removeListener",
      value: /* @__PURE__ */ __name(function() {
        eventCenter.removeListener(SYNC_EVENT, this.handleReceiveSyncEvent);
      }, "removeListener")
    }, {
      key: "filterFormatItem",
      value: /* @__PURE__ */ __name(function(item, displayName, childIndex) {
        for (var formattedGraphicalItems = this.state.formattedGraphicalItems, i2 = 0, len = formattedGraphicalItems.length; i2 < len; i2++) {
          var entry = formattedGraphicalItems[i2];
          if (entry.item === item || entry.props.key === item.key || displayName === getDisplayName(entry.item.type) && childIndex === entry.childIndex)
            return entry;
        }
        return null;
      }, "filterFormatItem")
    }, {
      key: "renderClipPath",
      value: /* @__PURE__ */ __name(function() {
        var clipPathId = this.clipPathId, _this$state$offset = this.state.offset, left2 = _this$state$offset.left, top2 = _this$state$offset.top, height2 = _this$state$offset.height, width2 = _this$state$offset.width;
        return /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", {
          id: clipPathId
        }, /* @__PURE__ */ React__default.createElement("rect", {
          x: left2,
          y: top2,
          height: height2,
          width: width2
        })));
      }, "renderClipPath")
    }, {
      key: "getXScales",
      value: /* @__PURE__ */ __name(function() {
        var xAxisMap = this.state.xAxisMap;
        return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
          var _ref14 = _slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
          return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
        }, {}) : null;
      }, "getXScales")
    }, {
      key: "getYScales",
      value: /* @__PURE__ */ __name(function() {
        var yAxisMap = this.state.yAxisMap;
        return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
          var _ref16 = _slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
          return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
        }, {}) : null;
      }, "getYScales")
    }, {
      key: "getXScaleByAxisId",
      value: /* @__PURE__ */ __name(function(axisId) {
        var _this$state$xAxisMap;
        return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
      }, "getXScaleByAxisId")
    }, {
      key: "getYScaleByAxisId",
      value: /* @__PURE__ */ __name(function(axisId) {
        var _this$state$yAxisMap;
        return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
      }, "getYScaleByAxisId")
    }, {
      key: "getItemByXY",
      value: /* @__PURE__ */ __name(function(chartXY) {
        var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
        if (formattedGraphicalItems && formattedGraphicalItems.length)
          for (var i2 = 0, len = formattedGraphicalItems.length; i2 < len; i2++) {
            var graphicalItem = formattedGraphicalItems[i2], props = graphicalItem.props, item = graphicalItem.item, itemDisplayName = getDisplayName(item.type);
            if (itemDisplayName === "Bar") {
              var activeBarItem = (props.data || []).find(function(entry) {
                return isInRectangle(chartXY, entry);
              });
              if (activeBarItem)
                return {
                  graphicalItem,
                  payload: activeBarItem
                };
            } else if (itemDisplayName === "RadialBar") {
              var _activeBarItem = (props.data || []).find(function(entry) {
                return inRangeOfSector(chartXY, entry);
              });
              if (_activeBarItem)
                return {
                  graphicalItem,
                  payload: _activeBarItem
                };
            } else if (isFunnel(graphicalItem, activeItem) || isPie(graphicalItem, activeItem) || isScatter(graphicalItem, activeItem)) {
              var activeIndex = getActiveShapeIndexForTooltip({
                graphicalItem,
                activeTooltipItem: activeItem,
                itemData: item.props.data
              }), childIndex = item.props.activeIndex === void 0 ? activeIndex : item.props.activeIndex;
              return {
                graphicalItem: _objectSpread(_objectSpread({}, graphicalItem), {}, {
                  childIndex
                }),
                payload: isScatter(graphicalItem, activeItem) ? item.props.data[activeIndex] : graphicalItem.props.data[activeIndex]
              };
            }
          }
        return null;
      }, "getItemByXY")
    }, {
      key: "render",
      value: /* @__PURE__ */ __name(function() {
        var _this2 = this;
        if (!validateWidthHeight(this))
          return null;
        var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width2 = _this$props6.width, height2 = _this$props6.height, style2 = _this$props6.style, compact2 = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = _objectWithoutProperties(_this$props6, _excluded2), attrs = filterProps(others, !1);
        if (compact2)
          return /* @__PURE__ */ React__default.createElement(ChartLayoutContextProvider, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ React__default.createElement(Surface, _extends({}, attrs, {
            width: width2,
            height: height2,
            title,
            desc
          }), this.renderClipPath(), renderByOrder(children, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var _this$props$tabIndex, _this$props$role;
          attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0, attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : "application", attrs.onKeyDown = function(e3) {
            _this2.accessibilityManager.keyboardEvent(e3);
          }, attrs.onFocus = function() {
            _this2.accessibilityManager.focus();
          };
        }
        var events = this.parseEventsOfWrapper();
        return /* @__PURE__ */ React__default.createElement(ChartLayoutContextProvider, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ React__default.createElement("div", _extends({
          className: clsx("recharts-wrapper", className),
          style: _objectSpread({
            position: "relative",
            cursor: "default",
            width: width2,
            height: height2
          }, style2)
        }, events, {
          ref: /* @__PURE__ */ __name(function(node2) {
            _this2.container = node2;
          }, "ref")
        }), /* @__PURE__ */ React__default.createElement(Surface, _extends({}, attrs, {
          width: width2,
          height: height2,
          title,
          desc,
          style: FULL_WIDTH_AND_HEIGHT
        }), this.renderClipPath(), renderByOrder(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }, "render")
    }]), CategoricalChartWrapper;
  }(Component), _defineProperty(_CategoricalChartWrapper, "displayName", chartName), _defineProperty(_CategoricalChartWrapper, "defaultProps", _objectSpread({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, defaultProps2)), _defineProperty(_CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
    var dataKey = nextProps.dataKey, data2 = nextProps.data, children = nextProps.children, width2 = nextProps.width, height2 = nextProps.height, layout2 = nextProps.layout, stackOffset = nextProps.stackOffset, margin2 = nextProps.margin, dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
    if (prevState.updateId === void 0) {
      var defaultState = createDefaultState(nextProps);
      return _objectSpread(_objectSpread(_objectSpread({}, defaultState), {}, {
        updateId: 0
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
        props: nextProps
      }, defaultState), {}, {
        updateId: 0
      }), prevState)), {}, {
        prevDataKey: dataKey,
        prevData: data2,
        prevWidth: width2,
        prevHeight: height2,
        prevLayout: layout2,
        prevStackOffset: stackOffset,
        prevMargin: margin2,
        prevChildren: children
      });
    }
    if (dataKey !== prevState.prevDataKey || data2 !== prevState.prevData || width2 !== prevState.prevWidth || height2 !== prevState.prevHeight || layout2 !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !shallowEqual(margin2, prevState.prevMargin)) {
      var _defaultState = createDefaultState(nextProps), keepFromPrevState = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: prevState.chartX,
        chartY: prevState.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: prevState.isTooltipActive
      }, updatesToState = _objectSpread(_objectSpread({}, getTooltipData(prevState, data2, layout2)), {}, {
        updateId: prevState.updateId + 1
      }), newState = _objectSpread(_objectSpread(_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
      return _objectSpread(_objectSpread(_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
        props: nextProps
      }, newState), prevState)), {}, {
        prevDataKey: dataKey,
        prevData: data2,
        prevWidth: width2,
        prevHeight: height2,
        prevLayout: layout2,
        prevStackOffset: stackOffset,
        prevMargin: margin2,
        prevChildren: children
      });
    }
    if (!isChildrenEqual(children, prevState.prevChildren)) {
      var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2, brush = findChildByType(children, Brush), startIndex = brush && (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex, endIndex = brush && (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex, hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex, hasGlobalData = !isNil$1(data2), newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
      return _objectSpread(_objectSpread({
        updateId: newUpdateId
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
        props: nextProps
      }, prevState), {}, {
        updateId: newUpdateId,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex
      }), prevState)), {}, {
        prevChildren: children,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex
      });
    }
    return null;
  }), _defineProperty(_CategoricalChartWrapper, "renderActiveDot", function(option, props) {
    var dot;
    return /* @__PURE__ */ isValidElement(option) ? dot = /* @__PURE__ */ cloneElement(option, props) : isFunction$3(option) ? dot = option(props) : dot = /* @__PURE__ */ React__default.createElement(Dot, props), /* @__PURE__ */ React__default.createElement(Layer, {
      className: "recharts-active-dot",
      key: props.key
    }, dot);
  }), _CategoricalChartWrapper;
}, "generateCategoricalChart"), PieChart$1 = generateCategoricalChart({
  chartName: "PieChart",
  GraphicalChild: Pie,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: PolarAngleAxis
  }, {
    axisType: "radiusAxis",
    AxisComp: PolarRadiusAxis
  }],
  formatAxisMap,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
});
const CenteredContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
`;
function PieChart({
  "data-test": dataTest = "pie-chart",
  children,
  data: data2,
  minAngle = 10,
  onHover,
  onUnhover,
  onLegendHover,
  onLegendUnhover,
  radius = 60,
  ringWidth = 6,
  showLegend,
  ...boxProps
}) {
  const [activeIndex, setActiveIndex] = useState(), emptyColor = useColor("secondary-100"), onPieEnter = /* @__PURE__ */ __name((_, index2) => {
    setActiveIndex(index2), onHover == null || onHover(index2);
  }, "onPieEnter"), onPieLeave = /* @__PURE__ */ __name(() => {
    setActiveIndex(void 0), onUnhover == null || onUnhover();
  }, "onPieLeave"), onLegendEnter = /* @__PURE__ */ __name((index2) => {
    setActiveIndex(index2), onLegendHover == null || onLegendHover(index2);
  }, "onLegendEnter"), onLegendLeave = /* @__PURE__ */ __name(() => {
    setActiveIndex(void 0), onLegendUnhover == null || onLegendUnhover();
  }, "onLegendLeave"), innerRadius = radius - ringWidth * 2, cx = showLegend ? radius : "50%", isTotalZero = data2.reduce((acc, d3) => acc + d3.value, 0) === 0;
  return /* @__PURE__ */ jsxs(Box, { "data-test": dataTest, position: "relative", ...boxProps, children: [
    children && /* @__PURE__ */ jsx(CenteredContainer, { children }),
    /* @__PURE__ */ jsx(
      ResponsiveContainer,
      {
        minHeight: radius * 2,
        minWidth: radius * 2,
        width: "100%",
        children: /* @__PURE__ */ jsxs(PieChart$1, { children: [
          showLegend && !isTotalZero && /* @__PURE__ */ jsx(
            Legend,
            {
              align: "right",
              content: /* @__PURE__ */ jsx(
                PieChartLegend,
                {
                  onHover: onLegendEnter,
                  onUnhover: onLegendLeave
                }
              ),
              layout: "vertical",
              verticalAlign: "middle"
            }
          ),
          /* @__PURE__ */ jsx(
            Pie,
            {
              minAngle,
              startAngle: 90,
              endAngle: -270,
              data: isTotalZero ? [{ label: "", value: 1 }] : data2,
              cx,
              cy: "50%",
              outerRadius: radius,
              innerRadius,
              paddingAngle: 4,
              onMouseEnter: onPieEnter,
              onMouseLeave: onPieLeave,
              isAnimationActive: !0,
              dataKey: "value",
              nameKey: "label",
              style: { outline: "none" },
              children: isTotalZero ? /* @__PURE__ */ jsx(
                Cell,
                {
                  "data-test": "pie-chart-cell-empty",
                  fill: emptyColor
                },
                "cell-empty"
              ) : data2.map((d3, index2) => /* @__PURE__ */ jsx(
                Cell,
                {
                  "data-test": `pie-chart-cell-${d3.value}`,
                  fill: index2 === activeIndex ? data2[index2].hoverFill : data2[index2].fill
                },
                `cell-${d3.value}`
              ))
            }
          )
        ] })
      }
    )
  ] });
}
__name(PieChart, "PieChart");
function PieChartLegend({
  "data-test": dataTest = "pie-chart-legend",
  onHover,
  onUnhover,
  payload
}) {
  const onMouseEnter = /* @__PURE__ */ __name((index2) => {
    onHover == null || onHover(index2);
  }, "onMouseEnter"), onMouseLeave = /* @__PURE__ */ __name(() => {
    onUnhover == null || onUnhover();
  }, "onMouseLeave");
  return payload ? /* @__PURE__ */ jsx(Flex, { as: "ul", "data-test": dataTest, flexDirection: "column", p: 0, children: payload.map((item, index2) => /* @__PURE__ */ jsxs(
    Flex,
    {
      alignItems: "center",
      as: "li",
      gap: "xxs",
      mb: "xxs",
      onMouseEnter: () => onMouseEnter(index2),
      onMouseLeave,
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            backgroundColor: item.color,
            borderRadius: "full",
            h: "14px",
            w: "14px"
          }
        ),
        /* @__PURE__ */ jsx(Typography, { color: "text-base", variant: "bodyMediumS", children: item.payload.label }),
        /* @__PURE__ */ jsx(Count, { size: "small", value: item.payload.value })
      ]
    },
    item.value
  )) }) : null;
}
__name(PieChartLegend, "PieChartLegend");
function ProgressChart({
  "data-test": dataTest,
  children,
  fill: fill2,
  radius = 60,
  ringWidth = 5,
  value,
  ...boxProps
}) {
  const defaultColor = useColor("primary-500"), emptyColor = useColor("secondary-100");
  if (value > 100 || value < 0)
    throw new Error("The provided value needs to be between 0 and 100");
  const data2 = [
    { value, fill: fill2 || defaultColor },
    { value: 100 - value, fill: emptyColor }
  ], innerRadius = radius - ringWidth * 2;
  return /* @__PURE__ */ jsxs(Box, { "data-test": dataTest, position: "relative", ...boxProps, children: [
    /* @__PURE__ */ jsx(
      ResponsiveContainer,
      {
        minHeight: radius * 2,
        minWidth: radius * 2,
        width: "100%",
        children: /* @__PURE__ */ jsx(PieChart$1, { children: /* @__PURE__ */ jsx(
          Pie,
          {
            startAngle: 90,
            endAngle: -270,
            data: data2,
            cx: "50%",
            cy: "50%",
            outerRadius: radius,
            innerRadius,
            paddingAngle: 4,
            dataKey: "value",
            nameKey: "label",
            style: { outline: "none" }
          }
        ) })
      }
    ),
    children && /* @__PURE__ */ jsx(CenteredContainer, { children })
  ] });
}
__name(ProgressChart, "ProgressChart");
const RadioBoxGroupContext = createContext(void 0);
function RadioBoxGroup({
  "data-test": dataTest = "radio-box-group",
  children,
  defaultValue,
  onChange: onChange5,
  size = "small",
  ...spacerProps
}) {
  const [checkedValue, setCheckedValue] = useState(), contextValue = useMemo(
    () => ({ checkedValue: checkedValue ?? defaultValue, size }),
    [checkedValue, defaultValue, size]
  ), handleChange = useCallback(
    (value) => {
      setCheckedValue(value), onChange5 == null || onChange5(value);
    },
    [onChange5]
  );
  return /* @__PURE__ */ jsx(RadioBoxGroupContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx(
    RadioGroup,
    {
      ...spacerProps,
      defaultValue,
      onChange: handleChange,
      value: checkedValue,
      "data-test": dataTest,
      children
    }
  ) });
}
__name(RadioBoxGroup, "RadioBoxGroup");
function getRadioBoxStyles(checked) {
  const styles = {
    backgroundColor: "surface-interactive-default",
    borderColor: "graphic-interactive-default",
    borderRadius: "sm",
    borderStyle: "solid",
    borderWidth: 1,
    padding: "s"
  };
  return checked ? {
    ...styles,
    backgroundColor: "surface-interactive-default-active",
    borderColor: "graphic-interactive-primary"
  } : styles;
}
__name(getRadioBoxStyles, "getRadioBoxStyles");
function RadioBox({
  description,
  disabled = !1,
  label,
  value,
  "data-test": dataTest = "radio-box"
}) {
  const context = useContext(RadioBoxGroupContext);
  if (!context)
    throw new Error("RadioBox should be used inside RadioBoxGroup");
  const checked = context.checkedValue === value;
  return /* @__PURE__ */ jsx(Box, { ...getRadioBoxStyles(checked), children: /* @__PURE__ */ jsxs(
    Radio,
    {
      value,
      size: context.size,
      disabled,
      "data-test": `${dataTest}-${value}`,
      children: [
        /* @__PURE__ */ jsx(RadioLabel, { children: label }),
        description && /* @__PURE__ */ jsx(RadioDescription, { children: description })
      ]
    }
  ) });
}
__name(RadioBox, "RadioBox");
const CustomLink = styled(Link$2)`
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  gap: ${getSpace("xxxs")};
  font-weight: 400;
`;
function RadioRow({
  value,
  title,
  description,
  content: content2,
  disabled = !1,
  learnMoreLink,
  learnMoreText,
  "data-test": dataTest
}) {
  return /* @__PURE__ */ jsxs(
    Grid,
    {
      display: "inline-grid",
      columnGap: { _: "s" },
      padding: "s",
      pb: "xs",
      alignItems: "center",
      gridAutoFlow: "column",
      rowGap: "xxs",
      gridTemplateColumns: "max-content auto",
      w: "100%",
      position: "relative",
      "data-test": dataTest,
      children: [
        learnMoreText && learnMoreLink && /* @__PURE__ */ jsxs(CustomLink, { href: learnMoreLink, target: "_blank", children: [
          learnMoreText,
          /* @__PURE__ */ jsx(ExternalOutlined, { size: 18 })
        ] }),
        /* @__PURE__ */ jsx(Box, { gridRow: 1, children: /* @__PURE__ */ jsx(
          Radio,
          {
            value,
            disabled,
            "data-test": `${dataTest}-radio`
          }
        ) }),
        /* @__PURE__ */ jsx(Box, { gridRow: 1, children: /* @__PURE__ */ jsx(Typography, { children: title }) }),
        /* @__PURE__ */ jsx(Box, { gridRow: 2, children: /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", color: "neutral-400", children: description }) }),
        content2 && /* @__PURE__ */ jsx(Box, { gridRow: 3, mt: "xxs", children: content2 })
      ]
    }
  );
}
__name(RadioRow, "RadioRow");
function RadioRows({
  value,
  children,
  onChange: onChange5,
  "data-test": dataTest,
  renderHeader
}) {
  return /* @__PURE__ */ jsx(
    RadioGroup,
    {
      value,
      onChange: onChange5,
      w: "100%",
      itemsSized: "evenly-sized",
      "data-test": dataTest,
      children: /* @__PURE__ */ jsx(List, { hasScroll: !1, w: "100%", renderHeader, children })
    }
  );
}
__name(RadioRows, "RadioRows");
function RelativeDay({ date: date2, locale: locale2, ...restProps }) {
  return /* @__PURE__ */ jsx(Typography, { ...restProps, children: getRelativeDate(date2, locale2) });
}
__name(RelativeDay, "RelativeDay");
function getRoleColor(roleName) {
  switch (roleName) {
    case ROLE_NAME.OWNER:
      return "green";
    case ROLE_NAME.ADMIN:
      return "pink";
    case ROLE_NAME.SUPERVISOR:
      return "blue";
    case ROLE_NAME.AGENT:
      return "yellow";
    default:
      return null;
  }
}
__name(getRoleColor, "getRoleColor");
function RolesTags({ rolesNames, lang = "en" }) {
  if (!rolesNames.length)
    return null;
  const tags = [...rolesNames].sort((roleNameA, roleNameB) => {
    const rankA = ROLE_ORDER[roleNameA] || 0, rankB = ROLE_ORDER[roleNameB] || 0;
    return rankA - rankB;
  }).map((roleName) => {
    const color2 = getRoleColor(roleName);
    if (!(!color2 || !Object.values(ROLE_NAME).includes(roleName)))
      return /* @__PURE__ */ jsx(Tag, { variant: color2, size: "small", children: translations[lang][roleName] }, roleName);
  }).filter(isDefined$1);
  return tags.length ? /* @__PURE__ */ jsx(Spacer, { "data-test": "roles-tags", direction: "horizontal", space: "xxxs", children: tags }) : null;
}
__name(RolesTags, "RolesTags");
function RelativeDayTime({
  date: date2,
  locale: locale2,
  ...restProps
}) {
  return /* @__PURE__ */ jsxs(Typography, { ...restProps, children: [
    /* @__PURE__ */ jsx(
      RelativeDay,
      {
        date: date2,
        locale: locale2,
        ...restProps,
        display: "inline"
      }
    ),
    " - ",
    /* @__PURE__ */ jsx(Time, { date: date2, locale: locale2, ...restProps, display: "inline" })
  ] });
}
__name(RelativeDayTime, "RelativeDayTime");
function RouteAccess({
  resource,
  action = PERMISSIONS_ACTIONS.READ,
  children,
  onClick: onClick2,
  messageTitle,
  messageSubtitle,
  messageButtonText,
  className
}) {
  const { checkAccess } = usePermissions(), resources = Array.isArray(resource) ? resource : [resource];
  return resources.every((r2) => checkAccess(action, r2)) ? /* @__PURE__ */ jsx(Resource, { name: resources[0], children: children || /* @__PURE__ */ jsx(Outlet, {}) }) : /* @__PURE__ */ jsx(
    RestrictedAccessScreen,
    {
      title: messageTitle,
      subtitle: messageSubtitle,
      buttonText: messageButtonText,
      onClick: onClick2,
      h: "100%",
      className
    }
  );
}
__name(RouteAccess, "RouteAccess");
function SearchMenuItem({
  searchStr,
  onSelected,
  width: width2,
  texts: texts2
}) {
  const [hovering, setHovering] = useState(!1), onMouseEnter = useCallback(() => {
    setHovering(!0);
  }, []), onMouseLeave = useCallback(() => {
    setHovering(!1);
  }, []), onClick2 = useCallback(() => {
    onSelected(searchStr);
  }, [onSelected, searchStr]);
  return /* @__PURE__ */ jsx(Box, { onMouseEnter, onMouseLeave, children: /* @__PURE__ */ jsxs(MenuItem, { onClick: onClick2, itemKey: searchStr, children: [
    /* @__PURE__ */ jsxs(Spacer, { space: "xs", direction: "horizontal", alignItems: "center", children: [
      /* @__PURE__ */ jsx(HistoryOutlined, {}),
      /* @__PURE__ */ jsx(Typography, { maxWidth: width2, ellipsis: !0, children: searchStr })
    ] }),
    /* @__PURE__ */ jsx(MenuItemSuffix, { children: hovering && /* @__PURE__ */ jsx(Box, { color: "neutral-700", children: texts2.goToPageButton }) })
  ] }) });
}
__name(SearchMenuItem, "SearchMenuItem");
const MenuHeader = styled(Grid)`
  align-items: center;
  padding: ${getSpace$1("xs")} ${getSpace$1("s")};
  grid-template-columns: auto min-content;
`, MenuTitle = styled(Typography).attrs(() => {
  "headingLightM";
})`
  color: ${getColor$2("neutral-400")};
  text-transform: uppercase;
`, LinkButton = styled(Button$1).attrs(() => ({
  mode: "link"
}))`
  &,
  &:hover,
  &:focus {
    color: ${getColor$2("text-base")};
  }
`, MotionBox = styled(
  motion.ul
)`
  position: fixed;
  z-index: 1001;
  top: ${({ top: top2 }) => top2}px;
  left: ${({ left: left2 }) => left2}px;
  width: ${({ width: width2 }) => width2}px;
  min-width: fit-content;
  height: max-content;
  padding: ${getSpace$1("xs")} 0;
  border-radius: ${getRadii("xs")};
  margin-top: ${getSpace$1("xxs")};
  background: ${getColor$2("neutral-0")};
  overflow-x: hidden;
  box-shadow: ${getShadow(5)};
`, AnimationVariants = {
  enter: {
    y: 0,
    opacity: 1
  },
  exit: {
    y: -10,
    opacity: 0
  }
}, RecentSearch = React__default.memo(
  forwardRef(
    ({ width: width2, top: top2, left: left2, open, recentSearches, onSelected, onClear, texts: texts2 }, ref) => {
      const menuItems = useMemo(
        () => recentSearches.map((searchStr) => /* @__PURE__ */ jsx(
          SearchMenuItem,
          {
            width: width2,
            searchStr,
            onSelected,
            texts: { goToPageButton: texts2.goToPageButton }
          },
          searchStr
        )),
        [onSelected, recentSearches, texts2.goToPageButton, width2]
      );
      return /* @__PURE__ */ jsx(AnimatePresence, { children: open && recentSearches.length > 0 && /* @__PURE__ */ jsx(Overlay, { children: /* @__PURE__ */ jsx("div", { ref, tabIndex: 0, "data-test": "recent-search-menu", children: /* @__PURE__ */ jsxs(
        MotionBox,
        {
          initial: "exit",
          animate: "enter",
          exit: "exit",
          width: width2,
          top: top2,
          left: left2,
          variants: AnimationVariants,
          children: [
            /* @__PURE__ */ jsxs(MenuHeader, { children: [
              /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(MenuTitle, { children: texts2.menuTitle }) }),
              /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
                LinkButton,
                {
                  "data-test": "clear-history-button",
                  size: "xSmall",
                  onClick: onClear,
                  children: texts2.clearButton
                }
              ) })
            ] }),
            /* @__PURE__ */ jsx(Menu, { w: "100%", children: menuItems })
          ]
        }
      ) }) }) });
    }
  )
);
function SearchBar({
  w: w2 = "100%",
  name: name2,
  placeholder,
  onSearch: onSearch2,
  onClear = /* @__PURE__ */ __name(() => onSearch2(""), "onClear"),
  debounceTimeout = 800,
  value,
  size = "regular",
  "data-test": dataTest = "search-bar",
  texts: texts2
}) {
  const [searchVal, setSearchVal] = useState(value || "");
  useEffect(() => {
    setSearchVal(value || "");
  }, [value]);
  const [menuShown, setMenuShown] = useState(!1), openMenu = useCallback(() => setMenuShown(!0), []), closeMenu = useCallback(() => setMenuShown(!1), []), inputRef = useRef(null), menuRef = useRef(null);
  useCloseOnScroll({
    eleRef: inputRef,
    innerScrollRef: menuRef,
    open: menuShown,
    onClose: closeMenu
  });
  const { boundingRect: inputPos, updateLayoutPosition } = useLayoutPosition(inputRef), menuPos = useMemo(() => inputPos ? {
    width: inputPos.width,
    top: inputPos.bottom,
    left: inputPos.left
  } : {
    width: 0,
    top: 0,
    left: 0
  }, [inputPos]);
  useEffect(() => {
    menuShown && updateLayoutPosition();
  }, [menuShown, updateLayoutPosition]);
  const debounceSearch = useMemo(
    () => debounce$2(onSearch2, debounceTimeout),
    [debounceTimeout, onSearch2]
  ), cancelSearch = useCallback(() => {
    setSearchVal(""), debounceSearch.cancel(), onClear(), closeMenu();
  }, [debounceSearch, onClear, closeMenu]), handleClear = useMemo(
    () => searchVal ? cancelSearch : void 0,
    [cancelSearch, searchVal]
  ), handleSearch = useCallback(
    (event) => {
      const search3 = event.target.value;
      closeMenu(), search3 ? (setSearchVal(search3), debounceSearch(search3)) : cancelSearch();
    },
    [cancelSearch, debounceSearch, closeMenu]
  ), handleMenuBlur = useCallback(
    (e3) => {
      if (menuRef.current && menuRef.current.contains(e3.relatedTarget)) {
        e3.target.focus();
        return;
      }
      closeMenu();
    },
    [closeMenu]
  ), { recentSearches, clearAllSearch, addSearch } = useSearchHistory({
    search: searchVal,
    name: name2
  }), startImmediateSearch = useCallback(
    (searchStr) => {
      debounceSearch.cancel(), onSearch2(searchStr);
    },
    [debounceSearch, onSearch2]
  ), handleSubmit = useCallback(() => {
    var _a3;
    addSearch(searchVal), (_a3 = inputRef.current) == null || _a3.blur(), startImmediateSearch(searchVal);
  }, [addSearch, searchVal, startImmediateSearch]), handleKeyDown = useCallback(
    (event) => {
      event.key === "Escape" && closeMenu(), event.key === "Enter" && handleSubmit();
    },
    [closeMenu, handleSubmit]
  ), onRecentSearchSelected = useCallback(
    (searchStr) => {
      setSearchVal(searchStr), startImmediateSearch(searchStr), menuShown && closeMenu();
    },
    [closeMenu, menuShown, startImmediateSearch]
  );
  return useEffect(
    () => () => {
      debounceSearch.cancel();
    },
    [debounceSearch]
  ), /* @__PURE__ */ jsxs(Box, { "data-test": `${dataTest}-wrapper`, w: w2, children: [
    /* @__PURE__ */ jsx(
      TextInput,
      {
        ref: inputRef,
        value: searchVal,
        name: name2,
        placeholder,
        icon: SearchOutlined,
        size,
        onChange: handleSearch,
        onClear: handleClear,
        "data-test": dataTest,
        onFocus: openMenu,
        onBlur: handleMenuBlur,
        onKeyDown: handleKeyDown,
        autoComplete: "off"
      }
    ),
    /* @__PURE__ */ jsx(
      RecentSearch,
      {
        ref: menuRef,
        open: menuShown,
        recentSearches,
        onSelected: onRecentSearchSelected,
        onClear: clearAllSearch,
        texts: texts2,
        ...menuPos
      }
    )
  ] });
}
__name(SearchBar, "SearchBar");
const RESULTS_OPTION_KEY = "RESULTS_OPTION_KEY", SELECTED_OPTION_KEY = "SELECTED_OPTION_KEY", SelectGlobalStyle = createGlobalStyle`
  [data-test="${({ dataTest }) => dataTest}-content"] > div:first-child,
  [data-test="select-dropdown-container"] > div:first-child {
    padding: 10px 10px 0 10px;
  }

  [data-test="${({ dataTest }) => dataTest}-content"] > div:first-child > div,
  [data-test="select-dropdown-container"] > div:first-child > div {
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    overflow: hidden;
  }

  [data-test="${({ dataTest }) => dataTest}-content"] > div:first-child > div:focus-within,
  [data-test="select-dropdown-container"] > div:first-child > div:focus-within {
    border: 1px solid black;
  }

  [data-test="select-search-input"] {
    border-bottom: none !important;
    box-shadow: none !important;
  }

  /* results option */
  div[data-test="select-option-item-${SELECTED_OPTION_KEY}"],
  div[data-test="select-option-item-${RESULTS_OPTION_KEY}"] {
    height: 30px;
    pointer-events: none;
  }

  /* results option checkbox */
  div[data-test="select-option-item-${SELECTED_OPTION_KEY}"] > div:first-child,
  div[data-test="select-option-item-${RESULTS_OPTION_KEY}"] > div:first-child {
    display: none;
  }
`;
function Select(props) {
  const { "data-test": dataTest } = props;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SelectGlobalStyle, { dataTest }),
    /* @__PURE__ */ jsx(Select$1, { ...props })
  ] });
}
__name(Select, "Select");
const ClearIconButton = styled(IconButton)`
  position: absolute;
  z-index: 1;
  right: 0px;
`, CustomTrigger$1 = forwardRef((props, ref) => {
  const { getPlaceholder, onClear, ...rest } = props, selectedKeys = useSelect().selectedKeys, hasValue = selectedKeys.length > 0, label = getPlaceholder(selectedKeys.length), handleClear = useCallback(
    (e3) => {
      e3.preventDefault(), onClear();
    },
    [onClear]
  );
  return /* @__PURE__ */ jsx(
    Flex,
    {
      w: "100%",
      borderRadius: "8px",
      border: "1px solid",
      borderColor: "neutral-200",
      p: "xs",
      cursor: "pointer",
      alignItems: "center",
      ref,
      backgroundColor: hasValue ? "#507988" : "neutral-0",
      color: hasValue ? "neutral-0" : "neutral-1000",
      ...rest,
      children: /* @__PURE__ */ jsx(
        Flex,
        {
          flex: "1",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
          children: /* @__PURE__ */ jsxs(Gap, { flex: "1", alignItems: "center", gap: "xs", children: [
            /* @__PURE__ */ jsx(
              Icon,
              {
                component: SearchOutlined,
                color: hasValue ? "neutral-0" : "secondary-500",
                size: 22
              }
            ),
            /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children: label }),
            hasValue && /* @__PURE__ */ jsx(
              ClearIconButton,
              {
                "data-test": "trigger-clear",
                onClick: handleClear,
                size: 28,
                component: CloseCircleFilled,
                color: "neutral-0",
                discColor: "transparent"
              }
            )
          ] })
        }
      )
    }
  );
});
function SearchMultiSelect({
  options,
  placeholder = "Select items",
  renderOption: renderOption2,
  onSearch: onSearch2,
  total,
  onChange: onChange5,
  getPlaceholder
}) {
  const [loading, setLoading] = useState(!1), [selectedKeys, setSelectedKeys] = useState([]), storedOptions = useRef(options), resultsOption = useRef({
    label: RESULTS_OPTION_KEY,
    value: RESULTS_OPTION_KEY
  }), selectedOption = useRef({
    label: SELECTED_OPTION_KEY,
    value: SELECTED_OPTION_KEY
  }), selectedOptions = useMemo(
    () => storedOptions.current.filter((o) => selectedKeys.includes(o.value)),
    [selectedKeys]
  ), innerOptions = useMemo(
    () => [
      ...selectedOptions.length ? [selectedOption.current] : [],
      ...selectedOptions,
      resultsOption.current,
      ...options.filter(
        (o) => !selectedOptions.map((_o) => _o.value).includes(o.value)
      )
    ],
    [options, selectedOptions]
  ), search3 = useCallback(
    async (q2) => {
      setLoading(!0);
      const query = q2.trim().toLowerCase(), res = await onSearch2(query, options);
      return setLoading(!1), q2.length ? (storedOptions.current = removeDuplicatesByProperties(
        [...storedOptions.current, ...res],
        ["value"]
      ), [resultsOption.current, ...res]) : innerOptions;
    },
    [innerOptions, onSearch2, options]
  ), _renderOption = useCallback(
    (option) => option.value === SELECTED_OPTION_KEY || option.value === RESULTS_OPTION_KEY ? /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsxs(Typography, { variant: "bodyRegularS", color: "neutral-700", children: [
      option.value === SELECTED_OPTION_KEY && `${selectedOptions.length} selected`,
      option.value === RESULTS_OPTION_KEY && `${total} results`
    ] }) }) : renderOption2(option),
    [renderOption2, selectedOptions.length, total]
  ), handleChange = useCallback(
    (values) => {
      setSelectedKeys(values), onChange5(values);
    },
    [onChange5]
  ), handleClear = useCallback(() => {
    setSelectedKeys([]), onChange5([]);
  }, [onChange5]);
  return /* @__PURE__ */ jsx(
    Select,
    {
      selectionMode: "multiple",
      placeholder,
      options: innerOptions,
      searchOptions: search3,
      loading,
      searchable: !0,
      selectedKeys,
      onSelectionChange: handleChange,
      renderOption: _renderOption,
      trigger: /* @__PURE__ */ jsx(CustomTrigger$1, { onClear: handleClear, getPlaceholder }),
      takeTriggerWidth: !1
    }
  );
}
__name(SearchMultiSelect, "SearchMultiSelect");
function SearchMultiLinesSelect({
  lines,
  total,
  onSearch: onSearch2,
  onChange: onChange5
}) {
  const options = useMemo(
    () => lines.map((line) => ({
      label: line.name,
      data: line,
      value: line.id
    })),
    [lines]
  ), renderOption2 = useCallback((option) => {
    const {
      data: { name: name2, number: number2, countryCode }
    } = option;
    return /* @__PURE__ */ jsxs(Flex, { alignItems: "center", flex: "1", w: "360px", children: [
      /* @__PURE__ */ jsxs(Gap, { gap: "xxs", alignItems: "center", pl: "xxs", children: [
        /* @__PURE__ */ jsx(FlagIcon, { countryCode }),
        /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children: name2 })
      ] }),
      /* @__PURE__ */ jsx(Typography, { ml: "auto", variant: "bodyRegularS", color: "neutral-700", children: number2 })
    ] });
  }, []), handleSearch = useCallback(
    async (q2) => (await onSearch2(q2, options)).map((line) => ({
      label: line.name,
      data: line,
      value: line.id
    })),
    [onSearch2, options]
  );
  return /* @__PURE__ */ jsx(
    SearchMultiSelect,
    {
      options,
      getPlaceholder: (numberOfSelected) => numberOfSelected ? `${numberOfSelected} numbers` : "Search lines",
      renderOption: renderOption2,
      onSearch: handleSearch,
      total,
      onChange: onChange5
    }
  );
}
__name(SearchMultiLinesSelect, "SearchMultiLinesSelect");
function SearchMultiUsersSelect({
  users,
  total,
  onSearch: onSearch2,
  onChange: onChange5
}) {
  const options = useMemo(
    () => users.map((user) => ({
      label: user.name,
      data: user,
      value: user.id
    })),
    [users]
  ), renderOption2 = /* @__PURE__ */ __name((option) => {
    const {
      data: { name: name2, image: image2 }
    } = option;
    return /* @__PURE__ */ jsx(Flex, { alignItems: "center", flex: "1", w: "360px", children: /* @__PURE__ */ jsxs(Gap, { gap: "xxs", alignItems: "center", pl: "xxs", children: [
      /* @__PURE__ */ jsx(
        Avatar,
        {
          "data-test": "page-header-avatar",
          src: image2,
          initials: getInitials(name2),
          size: "regular"
        }
      ),
      /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children: name2 })
    ] }) });
  }, "renderOption"), handleSearch = useCallback(
    async (q2) => (await onSearch2(q2, options)).map((line) => ({
      label: line.name,
      data: line,
      value: line.id
    })),
    [onSearch2, options]
  );
  return /* @__PURE__ */ jsx(
    SearchMultiSelect,
    {
      options,
      getPlaceholder: (numberOfSelected) => numberOfSelected ? `${numberOfSelected} users` : "Search users",
      renderOption: renderOption2,
      onSearch: handleSearch,
      total,
      onChange: onChange5
    }
  );
}
__name(SearchMultiUsersSelect, "SearchMultiUsersSelect");
function SearchMultiTeamsSelect({
  teams,
  total,
  onSearch: onSearch2,
  onChange: onChange5
}) {
  const options = useMemo(
    () => teams.map((team) => ({
      label: team.name,
      data: team,
      value: team.id
    })),
    [teams]
  ), renderOption2 = /* @__PURE__ */ __name((option) => {
    const {
      data: { name: name2, emoji }
    } = option;
    return /* @__PURE__ */ jsx(Flex, { alignItems: "center", flex: "1", w: "360px", children: /* @__PURE__ */ jsxs(Gap, { gap: "xxs", alignItems: "center", pl: "xxs", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children: emoji }),
      /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children: name2 })
    ] }) });
  }, "renderOption"), handleSearch = useCallback(
    async (q2) => (await onSearch2(q2, options)).map((team) => ({
      label: team.name,
      data: team,
      value: team.id
    })),
    [onSearch2, options]
  );
  return /* @__PURE__ */ jsx(
    SearchMultiSelect,
    {
      options,
      getPlaceholder: (numberOfSelected) => numberOfSelected ? `${numberOfSelected} teams` : "Search teams",
      renderOption: renderOption2,
      onSearch: handleSearch,
      total,
      onChange: onChange5
    }
  );
}
__name(SearchMultiTeamsSelect, "SearchMultiTeamsSelect");
const CustomTrigger = forwardRef((props, ref) => {
  const { placeholder } = props;
  return /* @__PURE__ */ jsx(
    Flex,
    {
      w: "100%",
      borderRadius: "8px",
      border: "1px solid",
      borderColor: "neutral-200",
      p: "xs",
      cursor: "pointer",
      alignItems: "center",
      ref,
      backgroundColor: "neutral-0",
      ...props,
      children: /* @__PURE__ */ jsxs(Gap, { flex: "1", alignItems: "center", gap: "xs", children: [
        /* @__PURE__ */ jsx(Icon, { component: SearchOutlined, color: "secondary-500", size: 22 }),
        /* @__PURE__ */ jsx(Gap, { alignItems: "center", gap: "xxxs", children: /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children: placeholder }) })
      ] })
    }
  );
});
function SearchSelect({
  options,
  renderOption: renderOption2,
  "data-test": dataTest = "search-select",
  placeholder = "Search",
  getPlaceholder,
  onChange: onChange5,
  onSearch: onSearch2,
  loadingText
}) {
  const [loading, setLoading] = useState(!1), [selectedKeys, setSelectedKeys] = useState([]), storedOptions = useRef(options), selectedOption = useMemo(
    () => storedOptions.current.find((o) => o.value === selectedKeys[0]),
    [selectedKeys]
  ), searchOptions = useCallback(
    async (q2) => {
      if (!q2.length)
        return options;
      setLoading(!0);
      const query = q2.trim().toLowerCase(), newOptions = await onSearch2(query, options);
      return storedOptions.current = removeDuplicatesByProperties(
        [...storedOptions.current, ...newOptions],
        ["value"]
      ), setLoading(!1), newOptions;
    },
    [onSearch2, options]
  ), handleSelectionChange = useCallback(
    (selectedIds) => {
      setSelectedKeys(selectedIds);
      const newOption = storedOptions.current.find(
        (o) => o.value === selectedIds[0]
      );
      if (!newOption)
        throw new Error("Selected option not found");
      onChange5(newOption);
    },
    [onChange5]
  );
  return /* @__PURE__ */ jsx(
    Select,
    {
      "data-test": dataTest,
      placeholder,
      options,
      searchOptions,
      loading,
      loadingText,
      searchable: !0,
      selectedKeys,
      renderOption: renderOption2,
      onSelectionChange: handleSelectionChange,
      trigger: /* @__PURE__ */ jsx(CustomTrigger, { placeholder: getPlaceholder(selectedOption) })
    }
  );
}
__name(SearchSelect, "SearchSelect");
function SearchLinesSelect({
  lines,
  onChange: onChange5,
  onSearch: onSearch2,
  getPlaceholder = /* @__PURE__ */ __name((selectedOption) => (selectedOption == null ? void 0 : selectedOption.data.name) || "Search lines", "getPlaceholder")
}) {
  const options = useMemo(
    () => lines.map((line) => ({
      label: line.name,
      value: line.id,
      data: line
    })),
    [lines]
  ), searchOptions = useCallback(
    async (query) => (await onSearch2(query, options)).map((line) => ({
      label: line.name,
      value: line.id,
      data: line
    })),
    [onSearch2, options]
  ), renderOption2 = useCallback((option) => {
    const {
      data: { name: name2, number: number2, countryCode }
    } = option;
    return /* @__PURE__ */ jsx(Flex, { alignItems: "center", flex: "1", w: "360px", children: /* @__PURE__ */ jsxs(Gap, { gap: "xxs", alignItems: "center", children: [
      /* @__PURE__ */ jsx(FlagIcon, { countryCode }),
      /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children: name2 }),
      /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", color: "neutral-600", fontSize: 12, children: number2 })
    ] }) });
  }, []);
  return /* @__PURE__ */ jsx(
    SearchSelect,
    {
      "data-test": "search-lines-select",
      getPlaceholder,
      options,
      onSearch: searchOptions,
      onChange: onChange5,
      renderOption: renderOption2
    }
  );
}
__name(SearchLinesSelect, "SearchLinesSelect");
function SearchUsersSelect({
  users,
  onChange: onChange5,
  onSearch: onSearch2,
  getPlaceholder = /* @__PURE__ */ __name((selectedOption) => (selectedOption == null ? void 0 : selectedOption.data.name) || "Search users", "getPlaceholder"),
  loadingText
}) {
  const options = useMemo(
    () => users.map((user) => ({
      label: user.name,
      value: user.id,
      data: user
    })),
    [users]
  ), searchOptions = useCallback(
    async (query) => (await onSearch2(query, options)).map((user) => ({
      label: user.name,
      value: user.id,
      data: user
    })),
    [onSearch2, options]
  ), renderOption2 = useCallback((option) => {
    const {
      data: { name: name2, image: image2, email }
    } = option;
    return /* @__PURE__ */ jsx(Flex, { alignItems: "center", flex: "1", w: "360px", children: /* @__PURE__ */ jsxs(Gap, { gap: "xxs", alignItems: "center", children: [
      /* @__PURE__ */ jsx(Avatar, { src: image2, initials: getInitials(name2), size: "regular" }),
      /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", children: name2 }),
      /* @__PURE__ */ jsx(Typography, { variant: "bodyRegularS", color: "neutral-600", fontSize: 12, children: email })
    ] }) });
  }, []);
  return /* @__PURE__ */ jsx(
    SearchSelect,
    {
      "data-test": "search-users-select",
      getPlaceholder,
      options,
      onSearch: searchOptions,
      onChange: onChange5,
      renderOption: renderOption2,
      loadingText
    }
  );
}
__name(SearchUsersSelect, "SearchUsersSelect");
function SkeletonText({
  "data-test": dataTest = "skeleton-text",
  quantity = 3
}) {
  const getLineWidth = useCallback(
    (index2) => `${index2 === quantity - 1 ? Math.floor(Math.random() * 60) + 15 : 100}%`,
    [quantity]
  );
  return quantity < 1 ? null : /* @__PURE__ */ jsx(
    RenderMultiple,
    {
      gap: "xxxs",
      w: "100%",
      direction: "vertical",
      quantity,
      "data-test": dataTest,
      children: (index2) => /* @__PURE__ */ jsx(
        Skeleton,
        {
          h: 14,
          w: getLineWidth(index2),
          "data-test": `${dataTest}-line-${index2}`
        }
      )
    }
  );
}
__name(SkeletonText, "SkeletonText");
function SkeletonNote({
  "data-test": dataTest = "skeleton-note",
  quantity = 2
}) {
  return /* @__PURE__ */ jsxs(Spacer, { direction: "vertical", gap: "xxs", w: "100%", "data-test": dataTest, children: [
    /* @__PURE__ */ jsxs(Flex, { alignItems: "center", justifyContent: "space-between", gap: "xxxs", children: [
      /* @__PURE__ */ jsxs(Spacer, { gap: "xxxs", alignItems: "center", children: [
        /* @__PURE__ */ jsx(Skeleton, { h: 24, shape: "squircle", w: 24 }),
        /* @__PURE__ */ jsx(Skeleton, { w: 80, h: 14 })
      ] }),
      /* @__PURE__ */ jsx(Skeleton, { w: 100, h: 14 })
    ] }),
    /* @__PURE__ */ jsx(SkeletonText, { quantity })
  ] });
}
__name(SkeletonNote, "SkeletonNote");
function SkeletonTags({
  quantity = 3,
  gap: gap2 = "xxs",
  "data-test": dataTest = "skeleton-tag",
  ...skeletonProps
}) {
  return /* @__PURE__ */ jsx(RenderMultiple, { quantity, gap: gap2, flexWrap: "wrap", children: (index2) => /* @__PURE__ */ jsx(
    Skeleton,
    {
      w: 80,
      h: 18,
      "data-test": `${dataTest}-${index2}`,
      ...skeletonProps
    },
    index2
  ) });
}
__name(SkeletonTags, "SkeletonTags");
function StartTime({ date: date2, locale: locale2, ...restProps }) {
  const isDateToday = isToday(date2);
  return /* @__PURE__ */ jsxs(Gap, { flexDirection: "column", gap: 0, children: [
    /* @__PURE__ */ jsx(Time, { date: date2, variant: "bodyMediumS", locale: locale2, ...restProps }),
    !isDateToday && /* @__PURE__ */ jsx(
      RelativeDay,
      {
        date: date2,
        color: "text-secondary",
        variant: "supportingMediumS",
        locale: locale2
      }
    )
  ] });
}
__name(StartTime, "StartTime");
function TagBeautified({
  color: color2,
  children,
  size = "small",
  "data-test": dataTest = "tag-beautified"
}) {
  const { textColor } = useLuminance({
    color: color2,
    threshold: THRESHOLD
  }), possibleTagColors = [
    useColor("secondary-800"),
    useColor("informative-500"),
    useColor("informative-600"),
    useColor("warning-500"),
    useColor("critical-300"),
    useColor("critical-500"),
    useColor("critical-700"),
    useColor("primary-300"),
    useColor("primary-600"),
    useColor("decorative1-300"),
    useColor("decorative2-700"),
    useColor("informative-100")
  ].filter(isDefined$1), { color: backgroundColor2 } = getClosestColor(color2, possibleTagColors);
  return /* @__PURE__ */ jsx(
    Tag,
    {
      "data-test": dataTest,
      bg: backgroundColor2,
      color: textColor,
      size,
      children
    }
  );
}
__name(TagBeautified, "TagBeautified");
const THRESHOLD = 0.3;
function ColorChip({
  color: color2,
  active = !1,
  "data-test": dataTest
}) {
  return /* @__PURE__ */ jsx(
    Box,
    {
      "data-test": dataTest,
      borderRadius: "50%",
      w: 20,
      h: 20,
      border: "4px solid",
      borderColor: color2,
      backgroundColor: active ? "transparent" : color2
    }
  );
}
__name(ColorChip, "ColorChip");
const FlexContainer = styled(Flex)`
  border: 1px solid ${getColor$2("neutral-200")};
  &:hover {
    border: 1px solid ${getColor$2("neutral-300")};
  }
`, TagColorPickerTrigger = forwardRef(({ value, onClick: onClick2, dataTest, disabled }, ref) => /* @__PURE__ */ jsxs(
  FlexContainer,
  {
    alignItems: "center",
    justifyContent: "center",
    h: "48px",
    px: "xs",
    gap: "xxxs",
    borderRadius: "8px",
    cursor: disabled ? "not-allowed" : "pointer",
    backgroundColor: disabled ? "neutral-100" : "white",
    ref,
    onClick: disabled ? void 0 : onClick2,
    "data-test": dataTest,
    children: [
      /* @__PURE__ */ jsx(
        ColorChip,
        {
          "data-test": `${dataTest}-input-color-chip`,
          color: value || "neutral-200"
        }
      ),
      /* @__PURE__ */ jsx(Box, { ml: "xxxs", children: /* @__PURE__ */ jsx(ChevronDownOutlined, {}) })
    ]
  }
)), TAGS_COLORS = [
  "#003D4C",
  "#BB2100",
  "#F92C00",
  "#0662B5",
  "#008f6c",
  "#29C8FF",
  "#B285D1",
  "#FCBB26",
  "#FF9D88",
  "#FF854C",
  "#ACCCF3",
  "#48A0FF",
  "#65D289"
], OPTIONS = TAGS_COLORS.map((c3) => ({ label: c3, value: c3 })), renderOption = /* @__PURE__ */ __name((option, selectedValue) => /* @__PURE__ */ jsx(
  ColorChip,
  {
    "data-test": `color-chip-${option.value}`,
    color: option.value,
    active: selectedValue === (option == null ? void 0 : option.value)
  }
), "renderOption");
function TagColorPicker({
  onChange: onChange5,
  value,
  dataTest = "tag-color-picker",
  disabled = !1
}) {
  return /* @__PURE__ */ jsx(
    Select$1,
    {
      options: OPTIONS,
      renderOption: (option) => renderOption(option, value),
      trigger: /* @__PURE__ */ jsx(
        TagColorPickerTrigger,
        {
          value,
          dataTest,
          disabled
        }
      ),
      selectedKeys: value ? [value] : [],
      onSelectionChange: /* @__PURE__ */ __name((newValues) => {
        onChange5(newValues[0]);
      }, "handleChange")
    }
  );
}
__name(TagColorPicker, "TagColorPicker");
function TooltipContent$1({ items }) {
  return /* @__PURE__ */ jsx(Box, { maxW: 250, children: items.map((item, index2) => /* @__PURE__ */ jsxs(Typography, { color: "neutral-0", maxW: 235, ellipsis: !0, children: [
    item,
    index2 !== items.length - 1 && ","
  ] }, index2)) });
}
__name(TooltipContent$1, "TooltipContent$1");
function TagStack({
  items,
  mode = "outline",
  size = "small",
  variant = "lightSecondary",
  maxVisibleTags = 5,
  "data-test": dataTest = "tag-stack",
  ...tagProps
}) {
  const stack = useMemo(
    () => items.slice(maxVisibleTags),
    [items, maxVisibleTags]
  ), tags = useMemo(
    () => items.slice(0, maxVisibleTags),
    [items, maxVisibleTags]
  );
  return /* @__PURE__ */ jsx(
    ConditionalTooltip,
    {
      visible: !!stack.length,
      content: /* @__PURE__ */ jsx(TooltipContent$1, { items: stack }),
      align: "end",
      "data-test": `${dataTest}-tooltip`,
      children: /* @__PURE__ */ jsxs(
        Spacer,
        {
          space: "xxxs",
          alignItems: "center",
          "data-test": dataTest,
          flexWrap: "wrap",
          children: [
            tags.map((tag, index2) => /* @__PURE__ */ jsx(
              Tag,
              {
                size,
                mode,
                variant,
                ...tagProps,
                children: tag
              },
              index2
            )),
            stack.length && /* @__PURE__ */ jsx(Tag, { size: "xSmall", variant: "grey", children: /* @__PURE__ */ jsxs(Typography, { color: "text-contrast-dark", variant: "supportingMediumS", children: [
              "+",
              stack.length
            ] }) })
          ]
        }
      )
    }
  );
}
__name(TagStack, "TagStack");
const TileContext = createContext(
  {}
), useTileContextProvider = /* @__PURE__ */ __name(() => useContext(TileContext), "useTileContextProvider");
function TileProvider({ children, disabled }) {
  const ref = useRef(null), hovering = useHover(ref), value = useMemo(() => ({ disabled, hovering }), [disabled, hovering]);
  return /* @__PURE__ */ jsx(TileContext.Provider, { value, children: cloneElement(children, { ref }) });
}
__name(TileProvider, "TileProvider");
function Tile({
  "data-test": dataTest = "tile",
  children,
  disabled = !1,
  minWidth: minWidth2 = 144,
  ...flexProps
}) {
  return /* @__PURE__ */ jsx(TileProvider, { disabled, children: /* @__PURE__ */ jsx(
    Flex,
    {
      backgroundColor: "surface-default",
      border: "1px solid",
      borderColor: "graphic-default",
      borderRadius: "sm",
      "data-test": dataTest,
      flexDirection: "column",
      minWidth: minWidth2,
      position: "relative",
      px: "xxs",
      py: "xxs",
      ...flexProps,
      children
    }
  ) });
}
__name(Tile, "Tile");
function TileActions({
  "data-test": dataTest = "tile-actions",
  children
}) {
  return /* @__PURE__ */ jsx(
    Flex,
    {
      alignItems: "center",
      "data-test": dataTest,
      position: "absolute",
      right: "8px",
      top: "8px",
      children
    }
  );
}
__name(TileActions, "TileActions");
function TileBody({
  "data-test": dataTest = "tile-body",
  children,
  ...flexProps
}) {
  return /* @__PURE__ */ jsx(Flex, { alignItems: "center", "data-test": dataTest, gap: "xxxs", ...flexProps, children });
}
__name(TileBody, "TileBody");
var TREND = /* @__PURE__ */ ((TREND2) => (TREND2.NEGATIVE = "NEGATIVE", TREND2.NEUTRAL = "NEUTRAL", TREND2.POSITIVE = "POSITIVE", TREND2))(TREND || {});
function renderIcon(type) {
  switch (type) {
    case TREND.NEGATIVE:
      return /* @__PURE__ */ jsx(ArrowDownFilled, { color: "graphic-critical-strong", size: 12 });
    case TREND.POSITIVE:
      return /* @__PURE__ */ jsx(ArrowUpFilled, { color: "graphic-success-strong", size: 12 });
    case TREND.NEUTRAL:
    default:
      return /* @__PURE__ */ jsx(MinusOutlined, { color: "graphic-neutral", size: 12 });
  }
}
__name(renderIcon, "renderIcon");
function Trend({
  "data-test": dataTest = "trend",
  tooltipContent,
  trend,
  value
}) {
  const hasValue = value !== void 0;
  return /* @__PURE__ */ jsx(
    ConditionalTooltip,
    {
      "data-test": `${dataTest}-tooltip`,
      content: tooltipContent,
      visible: tooltipContent !== void 0,
      children: /* @__PURE__ */ jsxs(Flex, { alignItems: "center", "data-test": dataTest, gap: "xxxs", children: [
        renderIcon(trend),
        hasValue && /* @__PURE__ */ jsx(Typography, { color: "text-secondary", variant: "supportingRegularS", children: value })
      ] })
    }
  );
}
__name(Trend, "Trend");
function TileExtra({
  "data-test": dataTest = "tile-extra",
  secondaryText,
  trend,
  ...trendProps
}) {
  const { disabled } = useTileContextProvider();
  return /* @__PURE__ */ jsxs(Flex, { alignItems: "center", "data-test": dataTest, children: [
    trend && /* @__PURE__ */ jsx(Trend, { "data-test": `${dataTest}-trend`, trend, ...trendProps }),
    secondaryText && /* @__PURE__ */ jsx(
      Typography,
      {
        color: disabled ? "text-disabled" : "text-interactive-neutral",
        ml: trend ? "xs" : "xxs",
        variant: "supportingRegularS",
        children: secondaryText
      }
    )
  ] });
}
__name(TileExtra, "TileExtra");
const typographyVariant = {
  small: "supportingMediumXS",
  regular: "supportingMediumXS",
  large: "supportingRegularS"
};
function TileHeader({
  "data-test": dataTest = "tile-header",
  label,
  size = "regular",
  tooltipTexts,
  ...flexProps
}) {
  const [tooltipVisible, setTooltipVisible] = useState(!1), { hovering } = useTileContextProvider(), tooltipTitle = (tooltipTexts == null ? void 0 : tooltipTexts.help) ?? (tooltipTexts == null ? void 0 : tooltipTexts.info), shouldDisplayTooltip = tooltipTitle && hovering || tooltipVisible, icon = tooltipTexts != null && tooltipTexts.help ? QuestionFilled : InformationOutlined, tooltipProps = {
    ...typeof tooltipTitle == "string" ? { title: tooltipTitle } : { content: tooltipTitle }
  };
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      alignItems: "center",
      alignSelf: "flex-start",
      "data-test": dataTest,
      ...flexProps,
      children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            color: "text-interactive-neutral",
            variant: typographyVariant[size],
            children: label
          }
        ),
        shouldDisplayTooltip && /* @__PURE__ */ jsx(
          Tooltip$1,
          {
            mouseLeaveDelay: 300,
            onVisibilityChange: setTooltipVisible,
            visible: tooltipVisible,
            ...tooltipProps,
            children: /* @__PURE__ */ jsx(
              Icon,
              {
                color: "icon-default",
                component: icon,
                "data-test": "tile-header-tooltip-trigger",
                ml: "xxxs",
                size: 12
              }
            )
          }
        )
      ]
    }
  );
}
__name(TileHeader, "TileHeader");
const typographyPrimaryStyle$1 = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "32px", fontWeight: "700", fontSize: "24px" },
  large: { lineHeight: "32px", fontWeight: "700", fontSize: "32px" }
}, typographySecondaryStyle$1 = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "18px", fontWeight: "500", fontSize: "16px" },
  large: { lineHeight: "18px", fontWeight: "500", fontSize: "16px" }
};
function TileDuration({
  "data-test": dataTest = "tile-duration",
  size = "regular",
  value
}) {
  const splittedDurationText = getSplittedText(formatSecondsToDuration(value));
  return splittedDurationText ? /* @__PURE__ */ jsxs(Flex, { alignItems: "baseline", "data-test": dataTest, display: "flex", children: [
    /* @__PURE__ */ jsx(Typography, { color: "inherit", ...typographyPrimaryStyle$1[size], children: splittedDurationText[0] }),
    /* @__PURE__ */ jsx(Typography, { color: "inherit", ...typographySecondaryStyle$1[size], children: splittedDurationText[1] })
  ] }) : null;
}
__name(TileDuration, "TileDuration");
const typographyPrimaryStyle = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "32px", fontWeight: "700", fontSize: "24px" },
  large: { lineHeight: "32px", fontWeight: "700", fontSize: "32px" }
}, typographySecondaryStyle = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "18px", fontWeight: "700", fontSize: "18px" },
  large: { lineHeight: "18px", fontWeight: "700", fontSize: "24px" }
}, typographyTertiaryStyle = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "18px", fontWeight: "500", fontSize: "16px" },
  large: { lineHeight: "18px", fontWeight: "500", fontSize: "16px" }
};
function TileNumber({
  "data-test": dataTest = "tile-number",
  locale: locale2 = "en-US",
  size = "regular",
  suffix,
  value
}) {
  const splittedNumberText = getSplittedText(
    formatLocalizedNumber(value, locale2)
  );
  return splittedNumberText ? /* @__PURE__ */ jsxs(Flex, { alignItems: "baseline", "data-test": dataTest, display: "flex", children: [
    /* @__PURE__ */ jsx(Typography, { color: "inherit", ...typographyPrimaryStyle[size], children: splittedNumberText[0] }),
    splittedNumberText[1] !== void 0 && /* @__PURE__ */ jsx(Typography, { color: "inherit", ...typographySecondaryStyle[size], children: splittedNumberText[1] }),
    suffix !== void 0 && /* @__PURE__ */ jsx(Typography, { color: "inherit", ...typographyTertiaryStyle[size], children: suffix })
  ] }) : null;
}
__name(TileNumber, "TileNumber");
const typographyStyle = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "32px", fontWeight: "500", fontSize: "16px" },
  large: { lineHeight: "32px", fontWeight: "300", fontSize: "32px" }
};
function TileText({
  "data-test": dataTest = "tile-text",
  size = "regular",
  value
}) {
  return /* @__PURE__ */ jsx(Typography, { color: "inherit", "data-test": dataTest, ...typographyStyle[size], children: value });
}
__name(TileText, "TileText");
var TILE_VALUE = /* @__PURE__ */ ((TILE_VALUE2) => (TILE_VALUE2.DURATION = "DURATION", TILE_VALUE2.NUMBER = "NUMBER", TILE_VALUE2.TEXT = "TEXT", TILE_VALUE2))(TILE_VALUE || {});
const StyledButton = styled(Button$1)`
  background-color: transparent;
  border: 0;
  color: ${getColor$2("text-interactive-secondary")};
  flex-direction: column;
  gap: 0;
  height: unset;
  min-width: auto;
  padding: 0;

  ${({ active, disabled, readOnly }) => disabled ? css`
          color: ${getColor$2("text-disabled")};
          cursor: not-allowed;
        ` : !readOnly && css`
          color: ${getColor$2(
  active ? "text-interactive-primary-active" : "text-interactive-secondary"
)};

          &:hover {
            background-color: transparent;
            color: ${getColor$2("text-interactive-primary")};

            ::after {
              background: ${getColor$2("text-interactive-primary")};
            }
          }

          &:focus,
          &:active {
            background-color: transparent;
            color: ${getColor$2("text-interactive-primary-active")};

            ::after {
              background: ${getColor$2("text-interactive-primary-active")};
            }
          }
        `}

  ${({ active, readOnly }) => !readOnly && css`
      ::after {
        background: ${active ? getColor$2("text-interactive-primary-active") : css`repeating-linear-gradient(
            to right,
            ${getColor$2("text-interactive-secondary")},
            ${getColor$2("text-interactive-secondary")} 2px,
            transparent 2px,
            transparent 4px
            )
          center/100% 2px no-repeat`};
        bottom: 0;
        content: "";
        height: 1px;
        position: absolute;
        width: 100%;
    `}
`, loadingSizes = {
  small: "22px",
  regular: "24px",
  large: "24px"
};
function renderValue(type, value, valueProps) {
  if (value === void 0)
    return /* @__PURE__ */ jsx(TileText, { value: "_ _", ...valueProps });
  switch (type) {
    case TILE_VALUE.DURATION:
      return /* @__PURE__ */ jsx(
        TileDuration,
        {
          value,
          ...valueProps
        }
      );
    case TILE_VALUE.NUMBER:
      return /* @__PURE__ */ jsx(TileNumber, { value, ...valueProps });
    case TILE_VALUE.TEXT:
    default:
      return /* @__PURE__ */ jsx(TileText, { value, ...valueProps });
  }
}
__name(renderValue, "renderValue");
function TileValue({
  "data-test": dataTest = "tile-value",
  active = !1,
  loading,
  onClick: onClick2,
  type = TILE_VALUE.NUMBER,
  value,
  ...valueProps
}) {
  const { disabled } = useTileContextProvider(), isInteractive = !!onClick2;
  if (loading) {
    const size = valueProps.size ?? "regular";
    return /* @__PURE__ */ jsx(
      Flex,
      {
        alignItems: "center",
        "data-test": `${dataTest}-loading`,
        h: "32px",
        justifyContent: "center",
        children: /* @__PURE__ */ jsx(Icon, { component: SpinnerOutlined, size: loadingSizes[size], spin: !0 })
      }
    );
  }
  return /* @__PURE__ */ jsx(
    StyledButton,
    {
      active,
      "data-test": dataTest,
      disabled,
      onClick: onClick2,
      readOnly: !isInteractive,
      type: "button",
      children: renderValue(type, value, valueProps)
    }
  );
}
__name(TileValue, "TileValue");
const StyledFlex$1 = styled(Flex)`
  top: 50%;
  transform: translateY(-50%);
`;
function TileLegend({
  "data-test": dataTest = "tile-legend",
  detailedValue,
  label,
  loading,
  onClick: onClick2,
  value
}) {
  const handleClick = /* @__PURE__ */ __name(() => {
    onClick2 == null || onClick2({ label, value });
  }, "handleClick");
  return /* @__PURE__ */ jsx(
    Flex,
    {
      alignSelf: "center",
      "data-test": dataTest,
      flexDirection: "column",
      ml: detailedValue ? "xxs" : "l",
      position: "relative",
      w: "100%",
      children: /* @__PURE__ */ jsx(
        StyledFlex$1,
        {
          alignItems: "flex-start",
          flexDirection: "column",
          position: "absolute",
          w: "100%",
          children: detailedValue ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsxs(Flex, { alignItems: "center", justifyContent: "space-between", w: "100%", children: [
              /* @__PURE__ */ jsx(
                TileValue,
                {
                  loading,
                  onClick: handleClick,
                  size: "small",
                  type: TILE_VALUE.TEXT,
                  value: label
                }
              ),
              /* @__PURE__ */ jsx(Typography, { variant: "supportingSemiboldS", children: value })
            ] }),
            /* @__PURE__ */ jsx(Flex, { as: "ul", flexDirection: "column", mt: 0.5, p: 0, w: "100%", children: detailedValue.map((val, index2) => /* @__PURE__ */ jsxs(
              Flex,
              {
                as: "li",
                justifyContent: "space-between",
                mt: 0.5,
                children: [
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      color: "text-secondary",
                      variant: "supportingRegularXS",
                      children: val.label
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      color: "text-secondary",
                      variant: "supportingRegularXS",
                      children: val.value
                    }
                  )
                ]
              },
              index2
            )) })
          ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              TileValue,
              {
                loading,
                onClick: handleClick,
                size: "large",
                value
              }
            ),
            /* @__PURE__ */ jsx(TileHeader, { label, my: "xxxs", size: "large" })
          ] })
        }
      )
    }
  );
}
__name(TileLegend, "TileLegend");
const StyledFlex = styled(Flex)`
  & > div {
    border: 0;
  }
`;
function TileList({
  "data-test": dataTest = "tile-list",
  children,
  ...flexProps
}) {
  return /* @__PURE__ */ jsx(
    StyledFlex,
    {
      alignItems: "center",
      backgroundColor: "surface-default",
      border: "1px solid",
      borderColor: "graphic-default",
      borderRadius: "sm",
      "data-test": dataTest,
      justifyContent: "space-between",
      ...flexProps,
      children
    }
  );
}
__name(TileList, "TileList");
const TIME_SLOTS_LIMIT_IN_MINUTES = 1440, createTimeSlots = /* @__PURE__ */ __name((optionInterval) => {
  const timeSlots = [];
  for (let hour = 0; hour <= 24; hour += 1)
    for (let minute = 0; minute < 60 && !(hour * 60 + minute > TIME_SLOTS_LIMIT_IN_MINUTES); minute += optionInterval) {
      const paddedHour = hour.toString().padStart(2, "0"), paddedMinute = minute.toString().padStart(2, "0"), time2 = `${paddedHour}:${paddedMinute}`, timeValue = `${paddedHour}:${paddedMinute}:00.000`;
      timeSlots.push({ label: time2, value: timeValue });
    }
  return timeSlots;
}, "createTimeSlots"), getStartingTime = /* @__PURE__ */ __name((interval, excludeStartingTime) => {
  if (!excludeStartingTime)
    return "00:00";
  const [startingHours, startingMinutes] = excludeStartingTime.split(":"), startingInMinutes = parseInt(startingHours) * 60 + parseInt(startingMinutes), minutesFromNearerInterval = startingInMinutes % interval, nextIntervalInMinutes = startingInMinutes - minutesFromNearerInterval + interval, hours = Math.floor(nextIntervalInMinutes / 60), minutes = Math.floor(nextIntervalInMinutes % 60);
  return `${hours}:${minutes}`;
}, "getStartingTime"), filterOptions = /* @__PURE__ */ __name((timingOptions, optionInterval, endingTime, excludeStartingTime) => {
  const [endingHour, endingMinutes] = endingTime.split(":").map(Number), [startingHour, startingMinutes] = getStartingTime(
    optionInterval,
    excludeStartingTime
  ).split(":").map(Number), endingTimeInMinutes = endingHour * 60 + endingMinutes, startingTimeInMinutes = startingHour * 60 + startingMinutes;
  return timingOptions.filter((timingOption) => {
    const [optionHours, optionMinutes] = timingOption.value.split(":").map(Number), optionInMinutes = optionHours * 60 + optionMinutes;
    return optionInMinutes >= startingTimeInMinutes && optionInMinutes <= endingTimeInMinutes;
  });
}, "filterOptions"), OPTION_KEYS = ["ZERO", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX"], isResetCursorPositionValid = /* @__PURE__ */ __name((position2) => [0, 1, 3, 4, 5].includes(position2), "isResetCursorPositionValid"), resetDigit = /* @__PURE__ */ __name((hours, minutes, cursorPosition) => {
  const resetOptionsMap = {
    ZERO: `0${hours}:${minutes}`,
    ONE: `${hours}0:${minutes}`,
    THREE: `${hours}:0${minutes}`,
    FOUR: `${hours}:${minutes}0`
  }, key = OPTION_KEYS[cursorPosition];
  return resetOptionsMap[key];
}, "resetDigit"), isUpdateCursorPositionValid = /* @__PURE__ */ __name((position2) => [1, 2, 3, 4, 5, 6].includes(position2), "isUpdateCursorPositionValid"), updateDigit = /* @__PURE__ */ __name((hours, minutes, position2) => {
  const updateOptionsMap = {
    ONE: `${hours[0]}${hours[2]}:${minutes}`,
    TWO: `${hours.slice(0, 2)}:${minutes}`,
    THREE: `${hours.slice(0, 2)}:${hours[2]}${minutes[1]}`,
    FOUR: `${hours}:${minutes[0]}${minutes[2]}`,
    FIVE: `${hours}:${minutes.slice(0, 2)}`,
    SIX: `${hours}:${minutes.slice(0, 2)}`
  }, key = OPTION_KEYS[position2];
  return updateOptionsMap[key];
}, "updateDigit"), getHourAndMinutes = /* @__PURE__ */ __name((time2, cursorPosition) => {
  const [newHours, newMinutes] = time2.split(":");
  return newMinutes ? (newHours.length === 1 || newMinutes.length === 1) && isResetCursorPositionValid(cursorPosition) ? resetDigit(newHours, newMinutes, cursorPosition) : (newHours.length === 3 || newMinutes.length === 3) && isUpdateCursorPositionValid(cursorPosition) ? updateDigit(newHours, newMinutes, cursorPosition) : time2 : `${time2.slice(0, 1)}0:${time2.slice(2)}`;
}, "getHourAndMinutes"), getCursorPosition = /* @__PURE__ */ __name((previousPosition, newPosition) => {
  if (!previousPosition || !newPosition)
    return newPosition;
  const direction = newPosition - previousPosition;
  return newPosition === 2 && direction > 0 ? newPosition + 1 : newPosition === 2 && direction < 0 ? newPosition - 1 : newPosition === 3 && direction > 0 ? newPosition + 1 : newPosition;
}, "getCursorPosition"), validateTimes = /* @__PURE__ */ __name((time2, endingTime) => {
  const [endingHours, endingMinutes] = endingTime.split(":").map(Number), endingTimeInMinutes = endingHours * 60 + endingMinutes, [hours, minutes] = time2.split(":").map(Number), selectedTimeInMinutes = hours * 60 + minutes;
  return !(!/^(?:[01]\d|2[0-3]):[0-5]\d|24:00$/.test(time2) || selectedTimeInMinutes > endingTimeInMinutes);
}, "validateTimes"), StyledTimeInput = styled(TextInput)`
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  &::-webkit-clear-button {
    -webkit-appearance: none;
  }
  &::-webkit-calendar-picker-indicator {
    display: none;
  }
  &::-webkit-datetime-edit-hour-field,
  &::-webkit-datetime-edit-minute-field {
    &:focus,
    &:hover {
      cursor: text;
    }
    &:focus {
      background-color: ${({ theme }) => theme.colors["surface-interactive-secondary-ghost-active"]};
      padding: 1px 3px;
      border-radius: 4px;
    }
  }
  &,
  &::-webkit-datetime-edit-hour-field:focus,
  &::-webkit-datetime-edit-minute-field:focus {
    color: ${({ theme }) => theme.colors["text-base"]};
  }
`, CustomDropdownButton = styled(DropdownButton)`
  justify-content: space-between;
  border: 1px solid;
  border-color: ${({ hasError }) => hasError ? getColor$2("graphic-interactive-critical") : getColor$2("graphic-interactive-default")};
  color: ${getColor$2("text-base")};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  background-color: ${({ disabled }) => disabled ? getColor$2("surface-disabled") : getColor$2("surface-default")};
  pointer-events: ${({ disabled }) => disabled ? "none" : "auto"};
  width: 100%;

  &:hover {
    background-color: ${getColor$2("surface-default")};
    border-color: ${({ hasError }) => hasError ? getColor$2("graphic-interactive-critical-hover") : getColor$2("graphic-interactive-default-hover")};
  }

  &:focus,
  &:focus-within {
    background-color: ${getColor$2("surface-default")};
    border-color: ${({ hasError }) => hasError ? getColor$2("text-interactive-critical-active") : getColor$2(
  "graphic-interactive-default-active"
)}; // this is due to graphic-interactive-critical-active being bugged
  }

  > div {
    border: none;
    background-color: transparent;
    padding: 0;
  }
`, HOUR_PICKER_DATA_TEST = {
  MAIN: "time-picker",
  DROPDOWN: "dropdown",
  ITEM: "item",
  MENU: "menu"
};
function TimePicker({
  "data-test": dataTest = HOUR_PICKER_DATA_TEST.MAIN,
  value,
  onInputChange,
  onSelectChange,
  onRowDisable,
  error = !1,
  minWidth: minWidth2 = "105px",
  maxHeight: maxHeight2 = "250px",
  excludeStartingTime,
  endingTime = "23:59",
  disabled = !1,
  ariaLabel,
  optionInterval = 30,
  noOptionsLabel
}) {
  const selectedTime = useMemo(() => value.slice(0, 5), [value]), inputRef = useRef(null), [cursorPosition, setCursorPosition] = useState(null), timingOptions = useMemo(
    () => createTimeSlots(optionInterval),
    [optionInterval]
  ), filteredOptions = useMemo(
    () => filterOptions(
      timingOptions,
      optionInterval,
      endingTime,
      excludeStartingTime
    ),
    [timingOptions, optionInterval, excludeStartingTime, endingTime]
  ), handleInputChange = /* @__PURE__ */ __name((event) => {
    event.preventDefault();
    const { value: time2, selectionStart } = event.target, newTime = getHourAndMinutes(time2, selectionStart), isTimeValid = validateTimes(newTime, endingTime), newCursorPosition = getCursorPosition(cursorPosition, selectionStart);
    setCursorPosition(newCursorPosition), isTimeValid && onInputChange(`${newTime}:00.000`);
  }, "handleInputChange"), handleSelect = /* @__PURE__ */ __name((event) => {
    setCursorPosition(event.target.selectionStart);
  }, "handleSelect");
  return useLayoutEffect(() => {
    inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
  }, [cursorPosition]), /* @__PURE__ */ jsx(Box, { minWidth: minWidth2, w: "100%", children: /* @__PURE__ */ jsx(
    Dropdown,
    {
      align: "end",
      trigger: /* @__PURE__ */ jsx(
        CustomDropdownButton,
        {
          "data-test": `${dataTest}-${HOUR_PICKER_DATA_TEST.DROPDOWN}`,
          mode: "outline",
          variant: "secondary",
          hasError: error,
          disabled,
          "aria-label": ariaLabel,
          children: /* @__PURE__ */ jsx(
            StyledTimeInput,
            {
              ref: inputRef,
              "data-test": dataTest,
              value: selectedTime,
              onChange: handleInputChange,
              onSelect: handleSelect
            }
          )
        }
      ),
      children: /* @__PURE__ */ jsx(
        Menu,
        {
          "data-test": `${dataTest}-${HOUR_PICKER_DATA_TEST.MENU}`,
          overflowY: "scroll",
          maxH: maxHeight2,
          children: filteredOptions.length > 0 ? filteredOptions.map((option) => /* @__PURE__ */ jsx(
            MenuItem,
            {
              "data-test": `${dataTest}-${HOUR_PICKER_DATA_TEST.ITEM}-${option.value}`,
              onClick: () => onSelectChange(option.value),
              disabled: (onRowDisable == null ? void 0 : onRowDisable(option.value)) ?? !1,
              children: option.label
            },
            option.value
          )) : /* @__PURE__ */ jsx(Box, { pl: "xs", pr: "xs", children: /* @__PURE__ */ jsx(Typography, { variant: "supportingRegularS", children: noOptionsLabel }) })
        }
      )
    }
  ) });
}
__name(TimePicker, "TimePicker");
function TooltipContent({ items }) {
  return /* @__PURE__ */ jsx(Box, { maxW: 250, children: items.map((item, index2) => /* @__PURE__ */ jsxs(
    Typography,
    {
      color: "neutral-0",
      maxW: 235,
      ellipsis: !0,
      children: [
        item,
        index2 !== items.length - 1 && ","
      ]
    },
    index2
  )) });
}
__name(TooltipContent, "TooltipContent");
function TypographyStack({
  items: [first, ...stack],
  hasTooltip = !0,
  "data-test": dataTest = "typography-stack",
  ...typographyProps
}) {
  return /* @__PURE__ */ jsx(
    ConditionalTooltip,
    {
      visible: hasTooltip && !!stack.length,
      content: /* @__PURE__ */ jsx(TooltipContent, { items: stack }),
      "data-test": `${dataTest}-tooltip`,
      children: /* @__PURE__ */ jsxs(Flex, { "data-test": dataTest, gap: "xxxs", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "bodySemiboldS", ...typographyProps, ellipsis: !0, children: first }),
        stack.length > 0 && /* @__PURE__ */ jsxs(Typography, { color: "text-placeholder", children: [
          "+",
          stack.length
        ] })
      ] })
    }
  );
}
__name(TypographyStack, "TypographyStack");
const UserContext = createContext({
  names: [],
  number: void 0,
  disabled: !1,
  hasClick: !1,
  setNames: (
    /* istanbul ignore next */
    () => {
    }
  )
});
function UserName({
  names,
  children: name2,
  ...restProps
}) {
  const { setNames, disabled, hasClick } = useContext(UserContext);
  if (useEffect(() => {
    names ? setNames(names) : Array.isArray(name2) ? setNames([name2.join("")]) : name2 && setNames([name2]);
  }, [setNames, names, name2]), names)
    return /* @__PURE__ */ jsx(TypographyStack, { hasTooltip: !1, items: names, ...restProps });
  let color2 = "text-base";
  return disabled ? color2 = "text-secondary" : hasClick && (color2 = "text-interactive-secondary"), /* @__PURE__ */ jsx(Typography, { variant: "bodySemiboldS", color: color2, ...restProps, children: name2 });
}
__name(UserName, "UserName");
function UserAvatar({ children }) {
  const { names, disabled } = useContext(UserContext), initials = useMemo(() => {
    if (!names.length)
      return "";
    const [firstName, lastName] = names[0].split(" ");
    return getInitials(firstName, lastName);
  }, [names]);
  return /* @__PURE__ */ jsx(
    Avatar,
    {
      "data-test": "user-avatar",
      initials,
      src: children,
      size: "small",
      disabled,
      variant: "default"
    }
  );
}
__name(UserAvatar, "UserAvatar");
function User({
  "data-test": dataTest = "user",
  children,
  disabled = !1,
  number: number2,
  countryCode,
  hasTooltip = !0,
  tooltipSecondary,
  ...restProps
}) {
  const [names, setNames] = useState([]), isString2 = typeof children == "string", hasClick = !!restProps.onClick, value = useMemo(
    () => ({
      names,
      setNames,
      number: number2,
      disabled,
      hasClick,
      countryCode
    }),
    [countryCode, disabled, hasClick, names, number2]
  );
  function getTooltip() {
    let primary;
    return !hasTooltip || (number2 ? primary = /* @__PURE__ */ jsx(NumberFormatted, { value: number2, countryCode }) : names.length === 1 ? [primary] = names : names.length > 1 && (primary = names.slice(1).join(", ")), !primary) ? null : /* @__PURE__ */ jsx(TooltipContent$2, { rows: [[primary, tooltipSecondary]] });
  }
  __name(getTooltip, "getTooltip");
  const tooltip = getTooltip();
  return /* @__PURE__ */ jsx(UserContext.Provider, { value, children: /* @__PURE__ */ jsx(
    ConditionalTooltip,
    {
      visible: !!tooltip,
      content: tooltip,
      align: "center",
      side: "top",
      sideOffset: 4,
      mouseEnterDelay: 0,
      mouseLeaveDelay: 100,
      children: /* @__PURE__ */ jsx(
        Flex,
        {
          alignItems: "center",
          cursor: hasClick ? "pointer" : "default",
          "data-test": dataTest,
          gap: "xxxs",
          ...restProps,
          children: isString2 ? /* @__PURE__ */ jsx(UserName, { children }) : children
        }
      )
    }
  ) });
}
__name(User, "User");
function UserNumber({ children, ...typographyProps }) {
  const { countryCode, hasClick, disabled } = useContext(UserContext);
  let color2 = "text-base";
  return disabled ? color2 = "text-secondary" : hasClick && (color2 = "text-interactive-secondary"), /* @__PURE__ */ jsx(
    NumberFormatted,
    {
      "data-test": "user-number",
      value: children,
      countryCode,
      color: color2,
      variant: "bodyMediumS",
      ...typographyProps
    }
  );
}
__name(UserNumber, "UserNumber");
function UserCount({
  size,
  "data-test": dataTest = "user-count-tag"
}) {
  const hasNoUsers = size === 0;
  return /* @__PURE__ */ jsx(
    Tag,
    {
      variant: "red",
      mode: "fill",
      bg: hasNoUsers ? void 0 : "transparent",
      color: hasNoUsers ? void 0 : "neutrall-700",
      "data-test": dataTest,
      children: /* @__PURE__ */ jsxs(Spacer, { space: "xxxs", alignItems: "center", children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            "data-test": `${dataTest}-icon`,
            component: UserOutlined,
            size: 16
          }
        ),
        /* @__PURE__ */ jsx(Typography, { children: size.toString() })
      ] })
    }
  );
}
__name(UserCount, "UserCount");
function UserStatusIcon({ status }) {
  let color2 = "informative-500";
  switch (status) {
    case LiveMonitoringUserStatus.IN_CALL:
      return /* @__PURE__ */ jsx(CallStatusIcon, { status: LiveMonitoringCallStatus.IN_CALL, size: 24 });
    case LiveMonitoringUserStatus.RINGING:
      return /* @__PURE__ */ jsx(CallStatusIcon, { status: LiveMonitoringCallStatus.RINGING, size: 24 });
    case LiveMonitoringUserStatus.AFTER_CALL_WORK:
      color2 = "informative-300";
      break;
    case LiveMonitoringUserStatus.AVAILABLE:
    case LiveMonitoringUserStatus.ON_MOBILE:
      color2 = "primary-500";
      break;
    case LiveMonitoringUserStatus.OFFLINE:
      color2 = "neutral-200";
      break;
    default:
      color2 = "critical-500";
      break;
  }
  return /* @__PURE__ */ jsx(Flex, { w: 24, justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ jsx(Box, { w: 6, h: 6, backgroundColor: color2, borderRadius: "50%" }) });
}
__name(UserStatusIcon, "UserStatusIcon");
function UserStatusTooltipContent({
  text: text2
}) {
  return /* @__PURE__ */ jsx(Box, { "data-test": "user-status-tooltip", children: /* @__PURE__ */ jsx(Typography, { children: text2 }) });
}
__name(UserStatusTooltipContent, "UserStatusTooltipContent");
function UserStatus({ status, duration, texts: texts2 }) {
  return /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      content: /* @__PURE__ */ jsx(UserStatusTooltipContent, { text: texts2.tooltip }),
      sideOffset: 2,
      children: /* @__PURE__ */ jsxs(Spacer, { space: "xxs", alignItems: "center", "data-test": "user-status", children: [
        /* @__PURE__ */ jsx(UserStatusIcon, { status }),
        /* @__PURE__ */ jsxs(Gap, { flexDirection: "column", space: 0, children: [
          /* @__PURE__ */ jsx(Typography, { color: "text-base", variant: "bodyMediumS", children: texts2.title }),
          /* @__PURE__ */ jsx(
            LiveDuration,
            {
              color: "neutral-400",
              variant: "supportingMediumS",
              seconds: duration,
              children: texts2.duration
            }
          )
        ] })
      ] })
    }
  );
}
__name(UserStatus, "UserStatus");
const withAccess = /* @__PURE__ */ __name((WrappedComponent, hasAccessProps) => /* @__PURE__ */ __name(function(origProps) {
  return /* @__PURE__ */ jsx(HasAccess, { ...hasAccessProps, children: /* @__PURE__ */ jsx(WrappedComponent, { ...origProps }) });
}, "WithAccessWrapper"), "withAccess"), withResource = /* @__PURE__ */ __name((WrappedComponent, resourceProps) => /* @__PURE__ */ __name(function(origProps) {
  return /* @__PURE__ */ jsx(Resource, { ...resourceProps, children: /* @__PURE__ */ jsx(WrappedComponent, { ...origProps }) });
}, "WithResourceWrapper"), "withResource");
function LanguageSelect({
  value,
  w: w2 = "200px",
  maxW = "200px",
  languages,
  texts: texts2 = {
    item: "language",
    items: "languages",
    result: "result",
    results: "results"
  },
  "data-test": dataTest = "language-select",
  ...rest
}) {
  const [searchOptions, setSearchOptions] = useState(void 0), options = useMemo(() => (languages && languages.length > 0 ? languages : LANGUAGES.map((l) => l.languageCode)).map((code2) => {
    const label = getLabelFromLanguage(code2), countryCode = getCountryCodeFromLanguage(code2);
    return !label || !countryCode ? void 0 : {
      value: code2,
      label,
      countryCode
    };
  }).filter(isDefined$1), [languages]), handleSearch = useCallback(
    (query) => {
      if (query === "") {
        setSearchOptions(void 0);
        return;
      }
      const results = options.filter(
        (option) => option.label.toLowerCase().includes(query.toLowerCase())
      );
      setSearchOptions(results);
    },
    [options]
  ), renderItemPrefix = useCallback(
    (option) => /* @__PURE__ */ jsx(FlagIcon, { countryCode: option.countryCode, size: 20, mr: "xxs" }),
    []
  ), renderTriggerPrefix = useCallback(
    (option) => /* @__PURE__ */ jsx(FlagIcon, { countryCode: option.countryCode, size: 24, mr: "xxs" }),
    []
  ), renderTriggerLabel = useCallback(
    (selectedOptions) => {
      const selectedOption = selectedOptions[0];
      if (!selectedOption)
        return "";
      const label = getLabelFromLanguage(selectedOption.value);
      return label || selectedOption.value;
    },
    []
  );
  return /* @__PURE__ */ jsx(
    MultiSearchSelect,
    {
      selectionMode: "single",
      triggerStyle: "select",
      options: searchOptions || options,
      isSearch: !!searchOptions,
      renderItemPrefix,
      renderTriggerLabel,
      renderTriggerPrefix,
      texts: texts2,
      w: w2,
      maxW,
      onSearch: handleSearch,
      debounceDuration: 0,
      selectedKeys: value ? [value] : [],
      "data-test": dataTest,
      ...rest
    }
  );
}
__name(LanguageSelect, "LanguageSelect");
function Language({
  size = 20,
  languageCode,
  children,
  gap: gap2 = 2,
  ...typographyProps
}) {
  const countryCode = getCountryCodeFromLanguage(languageCode), label = children ?? getLabelFromLanguage(languageCode);
  return /* @__PURE__ */ jsxs(Flex, { alignItems: "center", gap: gap2, children: [
    countryCode && /* @__PURE__ */ jsx(FlagIcon, { size, countryCode }),
    /* @__PURE__ */ jsx(Typography, { ...typographyProps, children: label })
  ] });
}
__name(Language, "Language");
const StyledAvatar = styled(Avatar$1)`
  background-color: icon-primary;
`, iconSize = {
  small: 16,
  regular: 22,
  large: 33,
  xLarge: 44
};
function VirtualAgentAvatar({
  "data-test": dataTest = "virtual-agent-avatar",
  size = "regular",
  ...avatarProps
}) {
  return /* @__PURE__ */ jsx(StyledAvatar, { "data-test": dataTest, size, ...avatarProps, children: /* @__PURE__ */ jsx(VirtualAgentFilled, { color: "surface-default", size: iconSize[size] }) });
}
__name(VirtualAgentAvatar, "VirtualAgentAvatar");
function VirtualAgentTag({
  "data-test": dataTest = "virtual-agent-tag",
  name: name2
}) {
  return /* @__PURE__ */ jsxs(Tag, { "data-test": dataTest, variant: "green", children: [
    /* @__PURE__ */ jsx(VirtualAgentFilled, { size: 16 }),
    /* @__PURE__ */ jsx(TagLabel, { children: name2 })
  ] });
}
__name(VirtualAgentTag, "VirtualAgentTag");
export {
  ACCOUNT_PLAN_CANCEL_ROUTE,
  ACCOUNT_PLAN_PURCHASE_ROUTE,
  ACCOUNT_ROUTE,
  ACCOUNT_ROUTE_TAB,
  ACCOUNT_TABS,
  ACTIVITY_FEED_ROUTE,
  ADDONS_DETAIL_ROUTE,
  ANALYTICS_ROUTE,
  ANALYTICS_ROUTE_TAB,
  AUTHORIZATION_ERROR_CODES,
  AUTH_STRATEGY,
  AVAILABILITY_FILTER_VALUES,
  AVAILABLE_BROADCAST_CHANNELS,
  AccordionSection,
  AddButton,
  AiPromotionalBanner,
  AnimatedButton,
  AnimatedSaveContainer,
  AtomicError,
  Availability,
  AvailabilitySelect,
  Avatar,
  BACKEND_ERRORS_TRANSLATION_KEYS,
  BACKEND_VALIDATION_ERRORS_TRANSLATION_KEYS,
  BACKEND_VALIDATION_KEY_MAPPER,
  BROWSER_CHROME_ALLOWED_VERSIONS,
  BROWSER_EDGE_ALLOWED_VERSIONS,
  BROWSER_FIREFOX_ALLOWED_VERSIONS,
  BROWSER_IE_ALLOWED_VERSIONS,
  BROWSER_OPERA_ALLOWED_VERSIONS,
  BROWSER_SAFARI_ALLOWED_VERSIONS,
  CALENDAR_BROADCAST_EVENTS,
  CALLS_CHILD_ROUTE,
  CALLS_ROUTE,
  CHECK_HEALTH,
  COMPANY_ROUTE,
  CONFIRM_INVITATION_ROUTE,
  CONFIRM_USER_CREATION_ROUTE,
  CURRENCIES,
  CURRENCIES_SYMBOLS,
  CallDirection,
  CallStatus,
  CallStatusDuration,
  CallStatusIcon,
  CallStatusText,
  CallStatusTooltipContent,
  Chevron,
  ClientException,
  ComingSoonScreen,
  ConditionalTooltip,
  ConfirmationModal,
  CopyToClipboardButton,
  CopyToClipboardText,
  Count,
  Country,
  CountryMultiSearchSelect,
  CountryPrefixSearchSelect,
  CustomCallStatus,
  DAYS_IN_WEEK,
  DAY_IN_MILLISECONDS,
  DEFAULT_CURRENCY,
  DEFAULT_GUTTER,
  DOWNLOAD_APP_ROUTE,
  DateSelect,
  DateSelectMenu,
  Day,
  DayOfWeek,
  DayTime,
  DaysPicker,
  DrawerSection,
  DrawerSectionBody,
  DrawerSectionHeader,
  DropdownIconWrapper,
  Dropzone,
  DropzoneTextElement,
  Duration,
  EMOJI_SIZES,
  ERROR_TYPES,
  ERROR_TYPES_DEFAULT_MESSAGES,
  EditableInput,
  EditableSelect,
  EditableTextarea,
  Emoji2 as Emoji,
  EmojiAvatar,
  EmojiPicker,
  EmptyStateView,
  ErrorBoundary,
  ExpandableAudioPlayer,
  FF_FORM_ERROR,
  FORGOT_PASSWORD_ROUTE,
  FORM_ACTIONS,
  FRONTEND_VALIDATION_ERRORS_MAPPER_OF_DESCRIPTIVE_ERROR_TO_KEY_NAME,
  FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS,
  FileInput,
  FilterTrigger,
  FilterTriggerBase,
  FormField,
  FormWizard,
  FormWizardContext,
  GATEWAY_TIMEOUT_ERROR_CODES,
  GRAPHQL_ERROR_INTERNAL_API_NOT_FOUND,
  GRAPHQL_ERROR_INVALID_DATA,
  GRAPHQL_ERROR_NON_EXISTENT_RESOURCE,
  Gap,
  GatewayTimeoutError,
  GraphQuery,
  GridItem,
  GridLayout,
  HOME_ROUTE,
  HOUR_PICKER_DATA_TEST,
  HTTPS_URL_PREFIX,
  HasAccess,
  HttpError,
  IDENTITY_PROVIDERS,
  INTEGRATIONS_ROUTE,
  INTEGRATIONS_ROUTE_TAB,
  INTEGRATION_AUTHORIZE,
  INTEGRATION_AUTHORIZE_SUCCESS,
  INTEGRATION_CHILD_ROUTES,
  INTEGRATION_FULL_ROUTES,
  IconWrapper,
  ImageUploader,
  InfoPopup,
  InfoPopupContent,
  InfoPopupTrigger,
  InlineForm,
  InlineFormButtons,
  InvalidError,
  LANGUAGES,
  LEGACY_TIMEZONES,
  LICENSE_NAME,
  LIMITATION_ERROR_CODES,
  LINE_BROADCAST_EVENTS,
  LINE_TYPE_VALUES,
  LIST_VIEW_PARAMS,
  LIVE_MONITORING_ENTERPRISE_PLANS,
  LOGIN_ROUTE,
  LOGIN_SSO_ROUTE,
  LOGIN_SUB_PASSWORD_ROUTE,
  LOGIN_SUB_SSO_ROUTE,
  Language,
  LanguageSelect,
  Line,
  LineContext,
  LineFlag,
  LineStatus,
  LineSubtitle,
  LineTitle,
  Link,
  List,
  ListItem,
  ListItemActions,
  ListPaginated,
  LiveDuration,
  LiveMonitoringCallDirection,
  LiveMonitoringCallStatus,
  LiveMonitoringUserStatus,
  LoadMoreStrategy,
  LoadMoreTable,
  Loader,
  Loading,
  LoadingButton,
  MATCH_HTML_ELEMENTS,
  MATCH_NON_DIGITS_REGEX,
  MAX_PICTURE_SIZE,
  MAX_UPLOD_IMAGE_SIZE,
  MarkdownContent,
  MarkdownNote,
  MessageScreen,
  MiniAudioPlayer,
  ModalCard,
  ModalForm,
  MotionBox$1 as MotionBox,
  MultiInlineSearchSelect,
  MultiSearchSelect,
  MultiSelect,
  MultiSelectContent,
  MultiSelectInput,
  MultiSelectItem,
  MultiSelectLoader,
  MultiSelectResults,
  NETWORK_ERROR_MSGS,
  NOT_FOUND_ERROR_CODES,
  NUMBERS_ROUTE,
  NUMBERS_ROUTE_TAB_ACTIVE,
  NUMBERS_ROUTE_TAB_UNVERIFIED,
  NUMBER_DETAIL_ROUTE,
  NUMBER_DETAIL_ROUTE_TAB,
  NUMBER_PROOF_OF_ID_ROUTE,
  NUMBER_PURCHASE_ROUTE,
  NUMBER_PURCHASE_ROUTE_AT_IVR_CREATION,
  NUMBER_PURCHASE_ROUTE_AT_IVR_EDITION,
  NavigationBlockerContext,
  NavigationBlockerDialog,
  NavigationBlockerProvider,
  NetworkError,
  NoDataScreen,
  NoSupportScreen,
  NotFoundError,
  NotFoundScreen,
  Note,
  NumberBox,
  NumberFormatted,
  NumberInput,
  ONBOARDING_ROUTE,
  OptimisticProgressBar,
  Overlay,
  PERMISSIONS_ACTIONS,
  PERMISSIONS_MODAL_LS_KEY,
  PERSIST_SEARCH_PARAMS_KEY,
  PROGRESS_ACTION_TYPE,
  PUBLIC_ROUTES,
  PageHeader,
  PageHeaderLink,
  Paper,
  PaperForm,
  PercentageTag,
  PermissionsContext,
  PermissionsProvider,
  PersistedSearchParams,
  PhoneInput,
  PieChart,
  PieChartLegend,
  ProgressBar,
  ProgressChart,
  RESET_PASSWORD_ROUTE,
  RESOURCE,
  RESULTS_OPTION_KEY,
  ROLE_NAME,
  ROLE_ORDER,
  RadioBox,
  RadioBoxGroup,
  RadioBoxGroupContext,
  RadioRow,
  RadioRows,
  RelativeDay,
  RelativeDayTime,
  RenderMultiple,
  Resource,
  ResourceContext,
  RestrictedAccessScreen,
  RolesTags,
  RouteAccess,
  SANDBOX_SSO,
  SELECTED_OPTION_KEY,
  STATS_CHILD_ROUTE,
  STATS_ROUTE,
  STATS_ROUTE_TAB,
  STRIP_COUNTRY_FROM_LANGUAGE,
  SUCCESS_FEEDBACK_MESSAGES,
  SaveBar,
  SaveBarContainerContext,
  SaveBarProvider,
  SaveButton,
  SaveButtonStatus,
  ScrollContainer,
  SearchBar,
  SearchLinesSelect,
  SearchMultiLinesSelect,
  SearchMultiSelect,
  SearchMultiTeamsSelect,
  SearchMultiUsersSelect,
  SearchSelect,
  SearchUsersSelect,
  Select,
  SelectField,
  SelectTrigger,
  SelectTriggerBase,
  ShadowScrollContainer,
  ShadowScrollContainerInner,
  SingleSearchSelect,
  SkeletonNote,
  SkeletonTags,
  SkeletonText,
  StartTime,
  StyledFlex,
  StyledFlexTrigger,
  StyledSaveBar,
  StyledSpacer,
  TEAMS_ROUTE,
  TEAM_BROADCAST_EVENTS,
  TEAM_DETAIL_ROUTE,
  TEST_ROUTE,
  THRESHOLD,
  TILE_VALUE,
  TIMEZONES,
  TOAST_DEFAULT_DISMISS_IN_MILLISECONDS,
  TREND,
  TRIAL_PLANS,
  Tab,
  TagBeautified,
  TagColorPicker,
  TagStack,
  Tile,
  TileActions,
  TileBody,
  TileExtra,
  TileHeader,
  TileLegend,
  TileList,
  TileValue,
  Time,
  TimePicker,
  TimeSelect,
  TimeSlotContainer,
  TimeSlotField,
  TimeSlotsField,
  TimeSlotsForm,
  TimezoneSelect,
  TooManyRequestsError,
  TooltipContent$2 as TooltipContent,
  Trend,
  TypographyStack,
  UNAUTHORIZED_ROUTE,
  USERS_ROUTE,
  USER_BROADCAST_EVENTS,
  USER_DETAIL_ROUTE,
  USER_DETAIL_ROUTE_TAB,
  UnauthorizedError,
  UnderlinedExternalLink,
  UnderlinedLink,
  UnknownError,
  UnknownErrorScreen,
  User,
  UserAvatar,
  UserCount,
  UserName,
  UserNumber,
  UserStatus,
  UserStatusTooltipContent,
  VALIDATE_EMAIL_REGEX,
  VALIDATE_NUMBERS_ONLY_REGEX,
  VALIDATE_PASSWORD_LENGTH_REGEX,
  VALIDATE_PASSWORD_STRENGTH_REGEX,
  VALIDATE_PERCENTAGE_ONLY_REGEX,
  VALIDATE_URL_FORMAT_REGEX,
  VALIDATION_ERROR_CODES,
  VIRTUAL_AGENT_BROADCAST_EVENTS,
  ValidationError,
  VirtualAgentAvatar,
  VirtualAgentTag,
  ZENDESK_SSO,
  allRoutes,
  areSearchParamsEqual,
  browserMapper,
  browserTimezones,
  calcColorDistance,
  canDeleteUser,
  capitalizeFirstLetter,
  checkIsCompanyInTrial,
  checkIsLiveMonitoringEnabled,
  checkIsLiveMonitoringEnterprisePlan,
  checkIsLiveMonitoringPlusEnabled,
  checkLicenseExpression,
  checkUserHasLicense,
  classicFormat,
  computeThemeVariantFromInitials,
  convertSecondsToMinSecNotation,
  convertToSeconds,
  copyURLSearchParamsWithoutKeys,
  countriesCurrenciesMapping,
  countriesPrefix,
  countriesStates,
  countryISOMapping,
  currencyValueWithSymbol,
  dashboardTheme,
  dayOfMonthFormat,
  decodeToken,
  delay$1 as delay,
  deleteResource,
  determineBrowserSupport,
  doRequest,
  downloadPdfFile,
  fileToBase64,
  formatInternationalNumber,
  formatLocalizedCurrency,
  formatLocalizedNumber,
  formatObjectToSearchParams,
  formatSearchParamsToObject,
  formatSecondsToDuration,
  formatToE164,
  forwardRefWithGenericType,
  generateEmptyArray,
  generateRandomUUID,
  generateUniqId,
  getBrowser,
  getClosestColor,
  getCommonPayload,
  getCountryCodeFromLanguage,
  getCountryISO3,
  getCurrencyByCountryCode,
  getCurrencySymbol,
  getDaysDifference,
  getDerivedEmoji,
  getEmoji,
  getErrorKey,
  getErrorTranslation,
  getFile,
  getFlagName,
  getFormattedTimezoneOffset,
  getFullName,
  getInitials,
  getKeysWithDifferentValues,
  getKeysWithSameValues,
  getLabelFromLanguage,
  getLocalizedTime,
  getMidnightDate,
  getMinutesDifference,
  getNextOS,
  getOperatingSystem,
  getPeriodOfDay,
  getRadioBoxStyles,
  getRelativeDate,
  getResource,
  getResourceFromPath,
  getRoleColor,
  getRouteFromPath,
  getRtf,
  getSavingStatus,
  getScrollableParent,
  getSearchParamsSize,
  getSplittedText,
  getTimezones,
  getTrackSettingsProperties,
  getTranslatedCountryName,
  getValidationErrors,
  getValidationErrorsTranslations,
  graphqlErrorHasErrorMessage,
  handleApolloError,
  hasErrorCode,
  hasRole,
  hexToRgb,
  isAnyFieldDifferent,
  isBrowserAccepted,
  isDefined$1 as isDefined,
  isGraphQLError,
  isNetworkError,
  isObject$e as isObject,
  isOnlyAgent,
  isTruthy,
  isValidUrl,
  localizedRTFMap,
  loggingLink,
  longDate,
  longFormat,
  makeTextField,
  mapActions,
  matchPartialText,
  mergeBaseUrlWithEndpoints,
  mergeSearchParams,
  monthFormat,
  monthYearFormat,
  navigation,
  normalizeNumber,
  parseResponse,
  parseRoles,
  parseToken,
  pipeValidators,
  postFormData,
  postNormalizedResource,
  postResource,
  prettifyTimezoneName,
  removeDuplicateForwardSlashesFromUrl,
  removeDuplicatesByProperties,
  removeEmptyEntriesFromObject,
  removeFieldsFromObjectRecursively,
  replace$1 as replace,
  reverseOrderDirection,
  routeReplacer,
  safeJSONParse,
  saveAnimationVariants,
  shortDate,
  shortMonthFormat,
  sortAscending,
  sortAscendingBy,
  stringContainsHtmlTags,
  toBoolean,
  toFixedNumber,
  toLower,
  toNumber$4 as toNumber,
  toStringArray,
  toUpper,
  toUpperStringArray,
  translations,
  trimWhiteSpaces,
  trimWithEllipsis,
  typedMemo,
  useBeforeUnload,
  useBlocker,
  useBroadcastChannel,
  useCancellableLazyQuery,
  useCloseOnScroll,
  useCombinedRefs,
  useCopyToClipboard$1 as useCopyToClipboard,
  useElapsedTime,
  useFormWizard,
  useFromRoute,
  useGraphLazyQuery,
  useGraphMutation,
  useGraphQuery,
  useGraphQueryPaginated,
  useHasAccess,
  useImperativeQuery,
  useInfiniteLoader,
  useIntersection,
  useLayoutPosition,
  useListViewFilters,
  useLoadMore,
  useLuminance,
  useMeasureElement,
  useMutableRef,
  useNavigateToAddonPage,
  useNavigateWithParamsReplace,
  useNavigationBlocker,
  usePageVisibility,
  usePermissions,
  usePersistedSearchParams,
  useQueryParams,
  useResizeObserver,
  useResource,
  useSearchHistory,
  useStateDelay,
  useThrottledCallback,
  useToast,
  useToggle,
  useTrackAddonSubscriptionFunnel,
  useTrackLicenseManagementFunnel,
  validateAlreadyExists,
  validateConfirmedPassword,
  validateEmail,
  validateMaxLength,
  validateMaxValue,
  validateMinValue,
  validateNumberName,
  validateNumberOnly,
  validatePasswordLength,
  validatePasswordStrength,
  validatePercentage,
  validatePhoneNumberFormat,
  validatePictureFormat,
  validatePictureSize,
  validateRequired,
  validateUniquePhoneNumber,
  validateUrlFormat,
  withAccess,
  withResource
};
